{
    "songs": [
        {
            "songId": "君の知らない物語",
            "category": "POPS＆アニメ",
            "title": "君の知らない物語",
            "artist": "supercell「化物語」",
            "bpm": 181,
            "imageName": "b9d06643b0f9db1f154aad251470631bb688d1b5fb36566738d2c1f3cd488566",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 53,
                        "hold": 18,
                        "slide": 4,
                        "touch": 6,
                        "break": 3,
                        "total": 84
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 10181,
                    "releaseDate": "2020-07-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 163,
                        "hold": 18,
                        "slide": 15,
                        "touch": 9,
                        "break": 4,
                        "total": 209
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 10181,
                    "releaseDate": "2020-07-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 31,
                        "slide": 10,
                        "touch": 22,
                        "break": 5,
                        "total": 258
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 10181,
                    "releaseDate": "2020-07-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 18,
                        "slide": 78,
                        "touch": 29,
                        "break": 14,
                        "total": 372
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 10181,
                    "releaseDate": "2020-07-30"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 47,
                        "hold": 18,
                        "slide": 2,
                        "touch": null,
                        "break": 3,
                        "total": 70
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 181,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 13,
                        "slide": 11,
                        "touch": null,
                        "break": 9,
                        "total": 184
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 181,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 29,
                        "slide": 21,
                        "touch": null,
                        "break": 4,
                        "total": 251
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 181,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 187,
                        "hold": 17,
                        "slide": 61,
                        "touch": null,
                        "break": 10,
                        "total": 275
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 181,
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Our Fighting",
            "category": "ゲーム＆バラエティ",
            "title": "Our Fighting",
            "artist": "クーナ(CV 喜多村英梨)「PHANTASY STAR ONLINE 2」",
            "bpm": 165,
            "imageName": "14781baf4201173e1c8ddf380c97e3894327ee2e0f89ac054398294f0ab26af6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 13,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 203
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 293,
                    "releaseDate": "2015-06-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 18,
                        "slide": 12,
                        "touch": null,
                        "break": 10,
                        "total": 335
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 293,
                    "releaseDate": "2015-06-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 374,
                        "hold": 31,
                        "slide": 58,
                        "touch": null,
                        "break": 9,
                        "total": 472
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 293,
                    "releaseDate": "2015-06-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 511,
                        "hold": 31,
                        "slide": 73,
                        "touch": null,
                        "break": 24,
                        "total": 639
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 293,
                    "multiverInternalLevelValue": {
                        "FESTiVAL PLUS": 12.5
                    },
                    "releaseDate": "2015-06-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "1/3の純情な感情",
            "category": "POPS＆アニメ",
            "title": "1/3の純情な感情",
            "artist": "SIAM SHADE [covered by 湯毛]",
            "bpm": 152,
            "imageName": "59d6e4bc6052f1c398d9c50aced4c4e581679ce101baeea7ea9babeb73316363",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 150,
                        "hold": 3,
                        "slide": 3,
                        "touch": null,
                        "break": 4,
                        "total": 160
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 356,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 208,
                        "hold": 2,
                        "slide": 9,
                        "touch": null,
                        "break": 2,
                        "total": 221
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 356,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 249,
                        "hold": 46,
                        "slide": 25,
                        "touch": null,
                        "break": 23,
                        "total": 343
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 356,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 340,
                        "hold": 65,
                        "slide": 46,
                        "touch": null,
                        "break": 16,
                        "total": 467
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 356,
                    "releaseDate": "2015-07-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "毒占欲",
            "category": "niconico＆ボーカロイド",
            "title": "毒占欲",
            "artist": "DECO*27",
            "bpm": 117,
            "imageName": "da7ddc4bc051b9aff57134c4acd62e92253ad139c56d3c6b388610eaef47c67f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 116,
                        "hold": 3,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 127
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-11-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 16,
                        "slide": 9,
                        "touch": null,
                        "break": 4,
                        "total": 316
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-11-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 310,
                        "hold": 42,
                        "slide": 27,
                        "touch": null,
                        "break": 11,
                        "total": 390
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-11-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 502,
                        "hold": 46,
                        "slide": 58,
                        "touch": null,
                        "break": 11,
                        "total": 617
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "multiverInternalLevelValue": {
                        "Splash": 13.2,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.6,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2014-11-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "おじゃま虫",
            "category": "niconico＆ボーカロイド",
            "title": "おじゃま虫",
            "artist": "DECO*27",
            "bpm": 143,
            "imageName": "7da15ccc9f45c6bc5f8a5503659143e58c678d3f06829c8fa2e14018d401b3ab",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 2,
                        "slide": 4,
                        "touch": null,
                        "break": 3,
                        "total": 136
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 436,
                    "releaseDate": "2015-09-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 304,
                        "hold": 24,
                        "slide": 12,
                        "touch": null,
                        "break": 12,
                        "total": 352
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 436,
                    "releaseDate": "2015-09-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 323,
                        "hold": 32,
                        "slide": 25,
                        "touch": null,
                        "break": 9,
                        "total": 389
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 436,
                    "releaseDate": "2015-09-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 563,
                        "hold": 34,
                        "slide": 77,
                        "touch": null,
                        "break": 15,
                        "total": 689
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 436,
                    "releaseDate": "2015-09-17"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "はじめまして地球人さん",
            "category": "niconico＆ボーカロイド",
            "title": "はじめまして地球人さん",
            "artist": "ピノキオピー",
            "bpm": 175,
            "imageName": "1ecfd9045a7dff32c12daf3d72f4dd8440b1d631c1fcfaf5dadd046c7036c33b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 13,
                        "slide": 3,
                        "touch": null,
                        "break": 4,
                        "total": 147
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 440,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 201,
                        "hold": 13,
                        "slide": 19,
                        "touch": null,
                        "break": 6,
                        "total": 239
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 440,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 289,
                        "hold": 45,
                        "slide": 20,
                        "touch": null,
                        "break": 8,
                        "total": 362
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 440,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 461,
                        "hold": 11,
                        "slide": 46,
                        "touch": null,
                        "break": 14,
                        "total": 532
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 440,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "Splash": 12.4
                    },
                    "releaseDate": "2015-07-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ヒビカセ",
            "category": "niconico＆ボーカロイド",
            "title": "ヒビカセ",
            "artist": "GigaReol",
            "bpm": 140,
            "imageName": "ada5f54797b26f08a3de25d17a38530bd93bd1a05ada7ac6198736c8c984e372",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 11,
                        "slide": 4,
                        "touch": null,
                        "break": 10,
                        "total": 214
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 510,
                    "releaseDate": "2018-08-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 386,
                        "hold": 15,
                        "slide": 6,
                        "touch": null,
                        "break": 13,
                        "total": 420
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 510,
                    "releaseDate": "2018-08-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 381,
                        "hold": 43,
                        "slide": 54,
                        "touch": null,
                        "break": 12,
                        "total": 490
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 510,
                    "releaseDate": "2018-08-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 615,
                        "hold": 67,
                        "slide": 71,
                        "touch": null,
                        "break": 14,
                        "total": 767
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 510,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "Splash": 12.6,
                        "UNiVERSE PLUS": 13.1
                    },
                    "releaseDate": "2018-08-09"
                }
            ],
            "searchAcronyms": [
                "hibikase",
                "Hibikase",
                "no title",
                "匕匕力",
                "匕匕力七",
                "匕匕力也",
                "比力也",
                "比比力也",
                "让其响彻"
            ]
        },
        {
            "songId": "ブリキノダンス",
            "category": "niconico＆ボーカロイド",
            "title": "ブリキノダンス",
            "artist": "日向電工",
            "bpm": 172,
            "imageName": "9fdb91e2e4187c4c5172afafcd13380ccd608158107119b75aba926dccf0c3f1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 202,
                        "hold": 12,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 228
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 525,
                    "releaseDate": "2018-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 418,
                        "hold": 25,
                        "slide": 6,
                        "touch": null,
                        "break": 11,
                        "total": 460
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 525,
                    "releaseDate": "2018-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 480,
                        "hold": 53,
                        "slide": 22,
                        "touch": null,
                        "break": 20,
                        "total": 575
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 525,
                    "releaseDate": "2018-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 625,
                        "hold": 5,
                        "slide": 116,
                        "touch": null,
                        "break": 6,
                        "total": 752
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 525,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "CiRCLE": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2018-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 763,
                        "hold": 32,
                        "slide": 93,
                        "touch": null,
                        "break": 12,
                        "total": 900
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 525,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2018-08-07"
                }
            ],
            "searchAcronyms": [
                "BURIKI NO DANCE"
            ]
        },
        {
            "songId": "ファッとして桃源郷",
            "category": "POPS＆アニメ",
            "title": "ファッとして桃源郷",
            "artist": "新庄かなえ(CV:三森すずこ)「てーきゅう」",
            "bpm": 160,
            "imageName": "2bb4572de6d12e415fe1eb226ff599f01148a42b9a11a0bc67aba7462f3c0eaf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 15,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 190
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 10,
                        "slide": 16,
                        "touch": null,
                        "break": 9,
                        "total": 286
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 28,
                        "slide": 39,
                        "touch": null,
                        "break": 16,
                        "total": 405
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 452,
                        "hold": 34,
                        "slide": 98,
                        "touch": null,
                        "break": 47,
                        "total": 631
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "multiverInternalLevelValue": {
                        "Splash": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2016-12-15"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Paradisus-Paradoxum",
            "category": "POPS＆アニメ",
            "title": "Paradisus-Paradoxum",
            "artist": "MYTH & ROID「Re：ゼロから始める異世界生活」",
            "bpm": 201,
            "imageName": "f3b658d66bdc7d80a66f8f80a6050eed345025ff5912aa80c20e3bd20c9e8ef5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 79,
                        "hold": 9,
                        "slide": 4,
                        "touch": 9,
                        "break": 2,
                        "total": 103
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 10615,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 134,
                        "hold": 16,
                        "slide": 5,
                        "touch": 26,
                        "break": 2,
                        "total": 183
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 10615,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 235,
                        "hold": 33,
                        "slide": 33,
                        "touch": 10,
                        "break": 14,
                        "total": 325
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 10615,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 320,
                        "hold": 20,
                        "slide": 100,
                        "touch": 40,
                        "break": 20,
                        "total": 500
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 10615,
                    "multiverInternalLevelValue": {
                        "Splash": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 121,
                        "hold": 11,
                        "slide": 4,
                        "touch": null,
                        "break": 9,
                        "total": 145
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 615,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 27,
                        "slide": 9,
                        "touch": null,
                        "break": 10,
                        "total": 234
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 615,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 27,
                        "slide": 33,
                        "touch": null,
                        "break": 6,
                        "total": 320
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 615,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 381,
                        "hold": 16,
                        "slide": 113,
                        "touch": null,
                        "break": 12,
                        "total": 522
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 615,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 13.2,
                        "Splash": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.4
                    },
                    "releaseDate": "2017-06-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "名探偵連続殺人事件",
            "category": "niconico＆ボーカロイド",
            "title": "名探偵連続殺人事件",
            "artist": "てにをは",
            "bpm": 140,
            "imageName": "0646d0658a7ec5c7fe560fdf19d386475b71a31129af0cdd506b7f400b19599c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 187,
                        "hold": 9,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 208
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-11-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 33,
                        "slide": 16,
                        "touch": null,
                        "break": 17,
                        "total": 322
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-11-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 269,
                        "hold": 98,
                        "slide": 51,
                        "touch": null,
                        "break": 25,
                        "total": 443
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-11-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 500,
                        "hold": 75,
                        "slide": 67,
                        "touch": null,
                        "break": 30,
                        "total": 672
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-11-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "あ・え・い・う・え・お・あお!!",
            "category": "POPS＆アニメ",
            "title": "あ・え・い・う・え・お・あお!!",
            "artist": "劇団ひととせ「ひなこのーと」",
            "bpm": 145,
            "imageName": "a752596dc1a29e8b1db400a2e46680840b69d744c1c1162ec855beb3a327d67f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 116,
                        "hold": 14,
                        "slide": 2,
                        "touch": null,
                        "break": 6,
                        "total": 138
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 669,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 193,
                        "hold": 40,
                        "slide": 17,
                        "touch": null,
                        "break": 13,
                        "total": 263
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 669,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 50,
                        "slide": 22,
                        "touch": null,
                        "break": 11,
                        "total": 370
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 669,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 418,
                        "hold": 38,
                        "slide": 53,
                        "touch": null,
                        "break": 31,
                        "total": 540
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 669,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "FESTiVAL": 12.9,
                        "Splash": 12.4,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2017-12-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "This game",
            "category": "POPS＆アニメ",
            "title": "This game",
            "artist": "鈴木このみ「ノーゲーム・ノーライフ」",
            "bpm": 147,
            "imageName": "1bd402fbbe7abb7cbc1df497d5f5e516a1834d4a65b18fcf2917ad9eb0cd8bf7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 100,
                        "hold": 8,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 116
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 678,
                    "releaseDate": "2018-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 8,
                        "slide": 14,
                        "touch": null,
                        "break": 4,
                        "total": 188
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 678,
                    "releaseDate": "2018-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 35,
                        "slide": 53,
                        "touch": null,
                        "break": 19,
                        "total": 346
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 678,
                    "releaseDate": "2018-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 346,
                        "hold": 53,
                        "slide": 69,
                        "touch": null,
                        "break": 60,
                        "total": 528
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 678,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.4
                    },
                    "releaseDate": "2018-01-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Los! Los! Los!",
            "category": "POPS＆アニメ",
            "title": "Los! Los! Los!",
            "artist": "ターニャ・デグレチャフ(CV.悠木碧)「幼女戦記」",
            "bpm": 240,
            "imageName": "9ea8644506f34a8016fb30f21f1792f3e01702a6d57fb2687e121e4885a41d5a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 89,
                        "hold": 10,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 107
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 679,
                    "releaseDate": "2018-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 17,
                        "slide": 10,
                        "touch": null,
                        "break": 4,
                        "total": 265
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 679,
                    "releaseDate": "2018-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 41,
                        "slide": 18,
                        "touch": null,
                        "break": 15,
                        "total": 361
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 679,
                    "releaseDate": "2018-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 353,
                        "hold": 50,
                        "slide": 60,
                        "touch": null,
                        "break": 10,
                        "total": 473
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 679,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 12.6,
                        "FESTiVAL PLUS": 12.6,
                        "Splash": 12.1,
                        "UNiVERSE PLUS": 12.6
                    },
                    "releaseDate": "2018-01-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ガヴリールドロップキック",
            "category": "POPS＆アニメ",
            "title": "ガヴリールドロップキック",
            "artist": "ガヴリール（富田美憂），ヴィーネ（大西沙織），サターニャ（大空直美），ラフィエル（花澤香菜）「ガヴリールドロップアウト」",
            "bpm": 168,
            "imageName": "adb8d47f179554035b059d29001dc52f2827cf9d21125645125339325693b90c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 112,
                        "hold": 6,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 126
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 697,
                    "releaseDate": "2018-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 155,
                        "hold": 29,
                        "slide": 13,
                        "touch": null,
                        "break": 15,
                        "total": 212
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 697,
                    "releaseDate": "2018-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 40,
                        "slide": 11,
                        "touch": null,
                        "break": 11,
                        "total": 312
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 697,
                    "releaseDate": "2018-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 54,
                        "slide": 71,
                        "touch": null,
                        "break": 29,
                        "total": 447
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 697,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2018-04-17"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "アンチクロックワイズ",
            "category": "POPS＆アニメ",
            "title": "アンチクロックワイズ",
            "artist": "After the Rain（そらる×まふまふ）",
            "bpm": 186,
            "imageName": "13291edc8d4a8fe904456a1e171eac0d3f1fc66dd2f2b5b5b555623db04e1e09",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 140,
                        "hold": 10,
                        "slide": 7,
                        "touch": null,
                        "break": 2,
                        "total": 159
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 743,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 221,
                        "hold": 9,
                        "slide": 15,
                        "touch": null,
                        "break": 2,
                        "total": 247
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 743,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 30,
                        "slide": 24,
                        "touch": null,
                        "break": 8,
                        "total": 291
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 743,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 13,
                        "slide": 68,
                        "touch": null,
                        "break": 13,
                        "total": 387
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 743,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 377,
                        "hold": 17,
                        "slide": 82,
                        "touch": null,
                        "break": 19,
                        "total": 495
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 743,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "Splash": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2018-06-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "SHINY DAYS",
            "category": "POPS＆アニメ",
            "title": "SHINY DAYS",
            "artist": "亜咲花",
            "bpm": 110,
            "imageName": "846c4d40997355f0c747e53cf280f07838f9af921473606c52529b3bb6e8bf1a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 86,
                        "hold": 7,
                        "slide": 2,
                        "touch": null,
                        "break": 3,
                        "total": 98
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 787,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 177,
                        "hold": 18,
                        "slide": 11,
                        "touch": null,
                        "break": 6,
                        "total": 212
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 787,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 17,
                        "slide": 17,
                        "touch": null,
                        "break": 5,
                        "total": 215
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 787,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 10,
                        "slide": 59,
                        "touch": null,
                        "break": 3,
                        "total": 359
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 787,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 12.6,
                        "FESTiVAL PLUS": 12.6,
                        "Splash": 12.1
                    },
                    "releaseDate": "2018-12-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "only my railgun",
            "category": "POPS＆アニメ",
            "title": "only my railgun",
            "artist": "fripSide",
            "bpm": 143,
            "imageName": "4540b88cf6d1249c8341d34526b270bf4bd1ad74f5a92e581eea3de71401d2db",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 10,
                        "slide": 2,
                        "touch": null,
                        "break": 4,
                        "total": 154
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 790,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 220,
                        "hold": 19,
                        "slide": 7,
                        "touch": null,
                        "break": 6,
                        "total": 252
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 790,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 249,
                        "hold": 44,
                        "slide": 34,
                        "touch": null,
                        "break": 20,
                        "total": 347
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 790,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 12,
                        "slide": 91,
                        "touch": null,
                        "break": 4,
                        "total": 459
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 790,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 465,
                        "hold": 3,
                        "slide": 62,
                        "touch": null,
                        "break": 22,
                        "total": 552
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 790,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 12.6
                    },
                    "releaseDate": "2018-12-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "お気に召すまま",
            "category": "niconico＆ボーカロイド",
            "title": "お気に召すまま",
            "artist": "Eve",
            "bpm": 143,
            "imageName": "f0a9b3e8efce30e0ec6440c2db530d95b840ee30515b0c72067f409d13074981",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 7,
                        "slide": 8,
                        "touch": null,
                        "break": 3,
                        "total": 215
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 831,
                    "releaseDate": "2019-04-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 23,
                        "slide": 9,
                        "touch": null,
                        "break": 5,
                        "total": 393
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 831,
                    "releaseDate": "2019-04-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 386,
                        "hold": 69,
                        "slide": 32,
                        "touch": null,
                        "break": 10,
                        "total": 497
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 831,
                    "releaseDate": "2019-04-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 512,
                        "hold": 33,
                        "slide": 129,
                        "touch": null,
                        "break": 5,
                        "total": 679
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 831,
                    "releaseDate": "2019-04-26"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 612,
                        "hold": 23,
                        "slide": 144,
                        "touch": null,
                        "break": 4,
                        "total": 783
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 831,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "Splash": 12.5,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2019-04-26"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "徒花ネクロマンシー",
            "category": "POPS＆アニメ",
            "title": "徒花ネクロマンシー",
            "artist": "フランシュシュ",
            "bpm": 172,
            "imageName": "082a66b182549091a5a17a6378ac3f908c416bc6f6d93f1a6077a85dfe556ddc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 73,
                        "hold": 17,
                        "slide": 2,
                        "touch": 6,
                        "break": 2,
                        "total": 100
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-10-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 181,
                        "hold": 12,
                        "slide": 8,
                        "touch": 12,
                        "break": 5,
                        "total": 218
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-10-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 26,
                        "slide": 45,
                        "touch": 22,
                        "break": 18,
                        "total": 362
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-10-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 44,
                        "slide": 68,
                        "touch": 33,
                        "break": 15,
                        "total": 455
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-10-04"
                }
            ],
            "searchAcronyms": [
                "Adabana Necromancy"
            ]
        },
        {
            "songId": "目覚めRETURNER",
            "category": "POPS＆アニメ",
            "title": "目覚めRETURNER",
            "artist": "フランシュシュ",
            "bpm": 145,
            "imageName": "2d23e18b8ecec4bd4bf10b1a1100ce245739384ea2d5735c9c3021c811e00324",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 11,
                        "slide": 2,
                        "touch": 10,
                        "break": 10,
                        "total": 171
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-10-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 224,
                        "hold": 24,
                        "slide": 6,
                        "touch": 8,
                        "break": 14,
                        "total": 276
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-10-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 50,
                        "slide": 16,
                        "touch": 21,
                        "break": 12,
                        "total": 363
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-10-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 65,
                        "slide": 81,
                        "touch": 38,
                        "break": 10,
                        "total": 550
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-10-04"
                }
            ],
            "searchAcronyms": [
                "Mezame Returner"
            ]
        },
        {
            "songId": "青空のラプソディ",
            "category": "POPS＆アニメ",
            "title": "青空のラプソディ",
            "artist": "fhána",
            "bpm": 135,
            "imageName": "523aa6c22e7039d8cd1dafb7d5b56577f018577aec3e4c708059195141aefd9c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 55,
                        "hold": 9,
                        "slide": 2,
                        "touch": 11,
                        "break": 3,
                        "total": 80
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 140,
                        "hold": 5,
                        "slide": 7,
                        "touch": 21,
                        "break": 6,
                        "total": 179
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 245,
                        "hold": 47,
                        "slide": 22,
                        "touch": 16,
                        "break": 6,
                        "total": 336
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 23,
                        "slide": 44,
                        "touch": 45,
                        "break": 18,
                        "total": 481
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ラブ・ドラマティック feat. 伊原六花",
            "category": "POPS＆アニメ",
            "title": "ラブ・ドラマティック feat. 伊原六花",
            "artist": "鈴木雅之",
            "bpm": 129,
            "imageName": "799f4f4213ba2c2640ae0a41b74eab665d620ce047235e8c0cdb02d36d1b5bd6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 51,
                        "hold": 18,
                        "slide": 4,
                        "touch": 10,
                        "break": 3,
                        "total": 86
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 12,
                        "slide": 3,
                        "touch": 15,
                        "break": 2,
                        "total": 169
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 208,
                        "hold": 23,
                        "slide": 53,
                        "touch": 12,
                        "break": 6,
                        "total": 302
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 23,
                        "slide": 68,
                        "touch": 10,
                        "break": 16,
                        "total": 347
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "異世界かるてっと",
            "category": "POPS＆アニメ",
            "title": "異世界かるてっと",
            "artist": "アインズ(日野聡)、カズマ(福島潤)、スバル(小林裕介)、ターニャ(悠木碧)",
            "bpm": 148,
            "imageName": "29484ff426e218eaca1dd55bcf46a0156565bacaa8511ed7d51cc5ab2b298e60",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 63,
                        "hold": 8,
                        "slide": 3,
                        "touch": 11,
                        "break": 11,
                        "total": 96
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 123,
                        "hold": 10,
                        "slide": 3,
                        "touch": 29,
                        "break": 16,
                        "total": 181
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 25,
                        "slide": 22,
                        "touch": 9,
                        "break": 7,
                        "total": 355
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 32,
                        "slide": 73,
                        "touch": 32,
                        "break": 19,
                        "total": 462
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": [
                "Isekai Quartet"
            ]
        },
        {
            "songId": "いつかいい感じにアレしよう",
            "category": "POPS＆アニメ",
            "title": "いつかいい感じにアレしよう",
            "artist": "カクとイムラ(CV：松本慶祐)",
            "bpm": 144,
            "imageName": "6571194c327dc15b4388fc8fe67102b0ef5d6bbdb1be0807d0e5473496b268fe",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 113,
                        "hold": 17,
                        "slide": 9,
                        "touch": 12,
                        "break": 3,
                        "total": 154
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11118,
                    "releaseDate": "2020-07-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 12,
                        "slide": 22,
                        "touch": 20,
                        "break": 10,
                        "total": 269
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11118,
                    "releaseDate": "2020-07-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 78,
                        "slide": 26,
                        "touch": 9,
                        "break": 17,
                        "total": 481
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11118,
                    "releaseDate": "2020-07-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 451,
                        "hold": 122,
                        "slide": 43,
                        "touch": 143,
                        "break": 10,
                        "total": 769
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11118,
                    "multiverInternalLevelValue": {
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 12.9,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2020-07-17"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "オトモダチフィルム",
            "category": "POPS＆アニメ",
            "title": "オトモダチフィルム",
            "artist": "オーイシマサヨシ",
            "bpm": 158,
            "imageName": "ad61e1031f785f1861b7c9e985e793282e808d711db35b55faa2f3bc991ef6e7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 81,
                        "hold": 7,
                        "slide": 2,
                        "touch": 10,
                        "break": 2,
                        "total": 102
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-07-31"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 155,
                        "hold": 16,
                        "slide": 6,
                        "touch": 11,
                        "break": 14,
                        "total": 202
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-07-31"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 268,
                        "hold": 14,
                        "slide": 12,
                        "touch": 11,
                        "break": 18,
                        "total": 323
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-07-31"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 34,
                        "slide": 20,
                        "touch": 88,
                        "break": 4,
                        "total": 377
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-07-31"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "六厘歌",
            "category": "POPS＆アニメ",
            "title": "六厘歌",
            "artist": "六厘舎",
            "bpm": 140,
            "imageName": "a78c4bd60c4e893093c6a576ed11865348d5d7ac1d4ca7ac0dbb9c952c42d362",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 96,
                        "hold": 14,
                        "slide": 4,
                        "touch": 10,
                        "break": 8,
                        "total": 132
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11144,
                    "releaseDate": "2020-06-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 6,
                        "slide": 8,
                        "touch": 13,
                        "break": 6,
                        "total": 242
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11144,
                    "releaseDate": "2020-06-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 244,
                        "hold": 24,
                        "slide": 32,
                        "touch": 87,
                        "break": 6,
                        "total": 393
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11144,
                    "releaseDate": "2020-06-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 96,
                        "hold": 75,
                        "slide": 154,
                        "touch": 16,
                        "break": 130,
                        "total": 471
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11144,
                    "releaseDate": "2020-06-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "馬と鹿",
            "category": "POPS＆アニメ",
            "title": "馬と鹿",
            "artist": "米津玄師",
            "bpm": 91,
            "imageName": "66f84deb504ffef5d3c3e91bcad289d71ad86ad3ae687e80eccc41302fbebb0f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 43,
                        "hold": 5,
                        "slide": 2,
                        "touch": 8,
                        "break": 2,
                        "total": 60
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 81,
                        "hold": 17,
                        "slide": 3,
                        "touch": 10,
                        "break": 4,
                        "total": 115
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 122,
                        "hold": 40,
                        "slide": 14,
                        "touch": 16,
                        "break": 4,
                        "total": 196
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 181,
                        "hold": 15,
                        "slide": 40,
                        "touch": 20,
                        "break": 19,
                        "total": 275
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ノーポイッ!",
            "category": "POPS＆アニメ",
            "title": "ノーポイッ!",
            "artist": "Petit Rabbit's",
            "bpm": 158,
            "imageName": "6b8af1be057649016007ed05386a846bfd4ac6f0a341512d03611cf327968a59",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 69,
                        "hold": 6,
                        "slide": 2,
                        "touch": 7,
                        "break": 1,
                        "total": 85
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11178,
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 149,
                        "hold": 17,
                        "slide": 5,
                        "touch": 15,
                        "break": 2,
                        "total": 188
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11178,
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 34,
                        "slide": 17,
                        "touch": 47,
                        "break": 16,
                        "total": 346
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11178,
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 329,
                        "hold": 38,
                        "slide": 66,
                        "touch": 23,
                        "break": 28,
                        "total": 484
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11178,
                    "releaseDate": "2020-09-17"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "町かどタンジェント",
            "category": "POPS＆アニメ",
            "title": "町かどタンジェント",
            "artist": "shami momo（吉田優子・千代田桃）／CV：小原好美・鬼頭明里",
            "bpm": 165,
            "imageName": "ee6e84711efc00ce528b570ad56b1fc4c024da33dda7d12a31eae5521a2a1cda",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 59,
                        "hold": 10,
                        "slide": 1,
                        "touch": 9,
                        "break": 2,
                        "total": 81
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11179,
                    "multiverInternalLevelValue": {
                        "Splash": 2
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 173,
                        "hold": 16,
                        "slide": 6,
                        "touch": 16,
                        "break": 4,
                        "total": 215
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11179,
                    "multiverInternalLevelValue": {
                        "Splash": 6.5
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 21,
                        "slide": 20,
                        "touch": 20,
                        "break": 15,
                        "total": 339
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11179,
                    "multiverInternalLevelValue": {
                        "Splash": 8.8
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 16,
                        "slide": 56,
                        "touch": 17,
                        "break": 15,
                        "total": 399
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11179,
                    "multiverInternalLevelValue": {
                        "Splash": 11.8
                    },
                    "releaseDate": "2020-09-17"
                }
            ],
            "searchAcronyms": [
                "Machikado Tangent",
                "Town corner tangent"
            ]
        },
        {
            "songId": "紅蓮華",
            "category": "POPS＆アニメ",
            "title": "紅蓮華",
            "artist": "LiSA",
            "bpm": 135,
            "imageName": "c7dbd8037378aa175cb703319f286100fe9a7602924a8947dd875ef8e28a0080",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 126,
                        "hold": 10,
                        "slide": 5,
                        "touch": 9,
                        "break": 12,
                        "total": 162
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11180,
                    "multiverInternalLevelValue": {
                        "Splash": 3
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 159,
                        "hold": 28,
                        "slide": 18,
                        "touch": 10,
                        "break": 5,
                        "total": 220
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11180,
                    "multiverInternalLevelValue": {
                        "Splash": 6.2
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 42,
                        "slide": 25,
                        "touch": 48,
                        "break": 12,
                        "total": 476
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11180,
                    "multiverInternalLevelValue": {
                        "Splash": 9
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 361,
                        "hold": 84,
                        "slide": 53,
                        "touch": 36,
                        "break": 26,
                        "total": 560
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11180,
                    "multiverInternalLevelValue": {
                        "Splash": 11.5
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 430,
                        "hold": 112,
                        "slide": 99,
                        "touch": 43,
                        "break": 23,
                        "total": 707
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11180,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 13,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2020-09-17"
                }
            ],
            "searchAcronyms": [
                "Demon Slayer",
                "Gurenge"
            ]
        },
        {
            "songId": "MIRACLE RUSH",
            "category": "POPS＆アニメ",
            "title": "MIRACLE RUSH",
            "artist": "StylipS",
            "bpm": 168,
            "imageName": "70f0870a00be2aa45f109b5371953380965ff76cffb43aeb94877aad94064ad7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 82,
                        "hold": 13,
                        "slide": 1,
                        "touch": 9,
                        "break": 2,
                        "total": 107
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11182,
                    "multiverInternalLevelValue": {
                        "Splash": 3
                    },
                    "releaseDate": "2020-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 158,
                        "hold": 14,
                        "slide": 9,
                        "touch": 8,
                        "break": 2,
                        "total": 191
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11182,
                    "multiverInternalLevelValue": {
                        "Splash": 6.2
                    },
                    "releaseDate": "2020-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 45,
                        "slide": 24,
                        "touch": 18,
                        "break": 20,
                        "total": 340
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11182,
                    "multiverInternalLevelValue": {
                        "Splash": 9.5
                    },
                    "releaseDate": "2020-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "譜面男子学院 中堅 小鳥 遊",
                    "noteCounts": {
                        "tap": 339,
                        "hold": 26,
                        "slide": 58,
                        "touch": 42,
                        "break": 29,
                        "total": 494
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11182,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 12,
                        "Splash": 12
                    },
                    "releaseDate": "2020-10-30"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Pretender",
            "category": "POPS＆アニメ",
            "title": "Pretender",
            "artist": "Official髭男dism",
            "bpm": 92,
            "imageName": "3dbeef01382b6c489ef6a95344364e5edded06df93af8c226acd637aa700945e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 91,
                        "hold": 10,
                        "slide": 5,
                        "touch": 8,
                        "break": 6,
                        "total": 120
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11217,
                    "multiverInternalLevelValue": {
                        "Splash": 2
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 166,
                        "hold": 29,
                        "slide": 7,
                        "touch": 13,
                        "break": 4,
                        "total": 219
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11217,
                    "multiverInternalLevelValue": {
                        "Splash": 5.8
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 321,
                        "hold": 37,
                        "slide": 15,
                        "touch": 5,
                        "break": 21,
                        "total": 399
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11217,
                    "multiverInternalLevelValue": {
                        "Splash": 8.5
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 404,
                        "hold": 34,
                        "slide": 52,
                        "touch": 5,
                        "break": 7,
                        "total": 502
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11217,
                    "multiverInternalLevelValue": {
                        "Splash": 12.4
                    },
                    "releaseDate": "2020-09-17"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "インフェルノ",
            "category": "POPS＆アニメ",
            "title": "インフェルノ",
            "artist": "Mrs. GREEN APPLE",
            "bpm": 185,
            "imageName": "97bab70fdeab7364a26c6589ca430dc636dab879b18376808788221420632d98",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 77,
                        "hold": 3,
                        "slide": 2,
                        "touch": 3,
                        "break": 4,
                        "total": 89
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11250,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 22,
                        "slide": 8,
                        "touch": 10,
                        "break": 3,
                        "total": 219
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11250,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 219,
                        "hold": 38,
                        "slide": 54,
                        "touch": 18,
                        "break": 28,
                        "total": 357
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11250,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 34,
                        "slide": 85,
                        "touch": 13,
                        "break": 32,
                        "total": 442
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11250,
                    "multiverInternalLevelValue": {
                        "Splash PLUS": 11.7
                    },
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 348,
                        "hold": 16,
                        "slide": 80,
                        "touch": 35,
                        "break": 8,
                        "total": 487
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11250,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": [
                "Inferno"
            ]
        },
        {
            "songId": "冬のこもりうた",
            "category": "POPS＆アニメ",
            "title": "冬のこもりうた",
            "artist": "原田知世",
            "bpm": 118,
            "imageName": "bc98e401f81480b0b0a16a29e87d750080b7accc2b275468fd6517125d31ff70",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 50,
                        "hold": 5,
                        "slide": 4,
                        "touch": 5,
                        "break": 1,
                        "total": 65
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11251,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 62,
                        "hold": 20,
                        "slide": 10,
                        "touch": 30,
                        "break": 2,
                        "total": 124
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11251,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 92,
                        "hold": 55,
                        "slide": 25,
                        "touch": 24,
                        "break": 1,
                        "total": 197
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11251,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 21,
                        "slide": 38,
                        "touch": 29,
                        "break": 2,
                        "total": 252
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11251,
                    "multiverInternalLevelValue": {
                        "Splash PLUS": 10.7
                    },
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 35,
                        "slide": 62,
                        "touch": 51,
                        "break": 3,
                        "total": 388
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11251,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "God knows...",
            "category": "POPS＆アニメ",
            "title": "God knows...",
            "artist": "涼宮ハルヒ（CV.平野 綾） TVアニメ「涼宮ハルヒの憂鬱」",
            "bpm": 150,
            "imageName": "208810e9ec2930ac0220cdb922d19ff46b4e1e5f5d700e9c13f285e874738a11",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 155,
                        "hold": 9,
                        "slide": 8,
                        "touch": 8,
                        "break": 4,
                        "total": 184
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11252,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 243,
                        "hold": 24,
                        "slide": 11,
                        "touch": 15,
                        "break": 7,
                        "total": 300
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11252,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 296,
                        "hold": 84,
                        "slide": 63,
                        "touch": 26,
                        "break": 17,
                        "total": 486
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11252,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 511,
                        "hold": 47,
                        "slide": 90,
                        "touch": 42,
                        "break": 29,
                        "total": 719
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11252,
                    "multiverInternalLevelValue": {
                        "Splash PLUS": 11.7
                    },
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 582,
                        "hold": 86,
                        "slide": 87,
                        "touch": 39,
                        "break": 37,
                        "total": 831
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11252,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "秒針を噛む",
            "category": "POPS＆アニメ",
            "title": "秒針を噛む",
            "artist": "ずっと真夜中でいいのに。",
            "bpm": 130,
            "imageName": "53d9ed764346266c0f44fa899d1a25e800b0ec7aaff30e0d4959f79fcb798e6b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 124,
                        "hold": 7,
                        "slide": 5,
                        "touch": 11,
                        "break": 2,
                        "total": 149
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11254,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 16,
                        "slide": 13,
                        "touch": 15,
                        "break": 6,
                        "total": 300
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11254,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 27,
                        "slide": 42,
                        "touch": 21,
                        "break": 14,
                        "total": 426
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11254,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 476,
                        "hold": 54,
                        "slide": 73,
                        "touch": 18,
                        "break": 20,
                        "total": 641
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11254,
                    "multiverInternalLevelValue": {
                        "Splash PLUS": 11
                    },
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 556,
                        "hold": 49,
                        "slide": 101,
                        "touch": 59,
                        "break": 13,
                        "total": 778
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11254,
                    "multiverInternalLevelValue": {
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "乙女のルートはひとつじゃない！",
            "category": "POPS＆アニメ",
            "title": "乙女のルートはひとつじゃない！",
            "artist": "angela",
            "bpm": 192,
            "imageName": "34f51d3f03af2f4db1f3af6b66d1b1c729aea2f49ee7d7a421386a98dbc98f55",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 68,
                        "hold": 9,
                        "slide": 2,
                        "touch": 4,
                        "break": 2,
                        "total": 85
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11256,
                    "releaseDate": "2021-07-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 166,
                        "hold": 26,
                        "slide": 16,
                        "touch": 9,
                        "break": 5,
                        "total": 222
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11256,
                    "releaseDate": "2021-07-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 217,
                        "hold": 17,
                        "slide": 46,
                        "touch": 22,
                        "break": 24,
                        "total": 326
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11256,
                    "releaseDate": "2021-07-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 341,
                        "hold": 35,
                        "slide": 91,
                        "touch": 13,
                        "break": 27,
                        "total": 507
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11256,
                    "multiverInternalLevelValue": {
                        "Splash PLUS": 12.5
                    },
                    "releaseDate": "2021-07-09"
                }
            ],
            "searchAcronyms": [
                "Otome no Route wa Hitotsu Janai!"
            ]
        },
        {
            "songId": "ビックカメラのテーマソング",
            "category": "POPS＆アニメ",
            "title": "ビックカメラのテーマソング",
            "artist": "ビックカメラ",
            "bpm": 160,
            "imageName": "24aaaf7e688bcab024d69df3ea1483cd3eecc1dc6b5adf15b5306a615122be8e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 90,
                        "hold": 6,
                        "slide": 3,
                        "touch": 17,
                        "break": 18,
                        "total": 134
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11257,
                    "releaseDate": "2021-07-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 224,
                        "hold": 25,
                        "slide": 11,
                        "touch": 28,
                        "break": 22,
                        "total": 310
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11257,
                    "releaseDate": "2021-07-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 68,
                        "slide": 18,
                        "touch": 26,
                        "break": 22,
                        "total": 357
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11257,
                    "releaseDate": "2021-07-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 248,
                        "hold": 92,
                        "slide": 79,
                        "touch": 176,
                        "break": 82,
                        "total": 677
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11257,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2021-07-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Shiny Smily Story",
            "category": "POPS＆アニメ",
            "title": "Shiny Smily Story",
            "artist": "hololive IDOL PROJECT",
            "bpm": 168,
            "imageName": "5f76a70a99ddb9d6787e12e71b0d02aad252bb0fa1ba601c6ba0382d7dad9d51",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 65,
                        "hold": 7,
                        "slide": 4,
                        "touch": 7,
                        "break": 2,
                        "total": 85
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11259,
                    "releaseDate": "2021-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 150,
                        "hold": 21,
                        "slide": 16,
                        "touch": 12,
                        "break": 4,
                        "total": 203
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11259,
                    "releaseDate": "2021-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 19,
                        "slide": 36,
                        "touch": 25,
                        "break": 10,
                        "total": 408
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11259,
                    "releaseDate": "2021-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "ものくろっく",
                    "noteCounts": {
                        "tap": 327,
                        "hold": 36,
                        "slide": 64,
                        "touch": 51,
                        "break": 21,
                        "total": 499
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11259,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "Splash PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2021-08-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "夜に駆ける",
            "category": "POPS＆アニメ",
            "title": "夜に駆ける",
            "artist": "YOASOBI",
            "bpm": 130,
            "imageName": "b2a0b6da4ca4dd4431756312658e0936f4c764ce5e7efb24f3f6bc9f64c0344a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 95,
                        "hold": 6,
                        "slide": 8,
                        "touch": 9,
                        "break": 2,
                        "total": 120
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11321,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 15,
                        "slide": 15,
                        "touch": 8,
                        "break": 5,
                        "total": 323
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11321,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 303,
                        "hold": 62,
                        "slide": 36,
                        "touch": 43,
                        "break": 20,
                        "total": 464
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11321,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 512,
                        "hold": 51,
                        "slide": 88,
                        "touch": 20,
                        "break": 13,
                        "total": 684
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11321,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 11.2
                    },
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 632,
                        "hold": 61,
                        "slide": 87,
                        "touch": 27,
                        "break": 17,
                        "total": 824
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11321,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2021-09-15"
                }
            ],
            "searchAcronyms": [
                "Into the Night",
                "Race into the night",
                "Racing into the night",
                "YOASOBI",
                "Yoru ni Kakeru",
                "入夜狂飙",
                "向夜晚奔去",
                "向天堂奔去",
                "向晚",
                "向晚爬",
                "夜驱",
                "晚上跑"
            ]
        },
        {
            "songId": "うっせぇわ",
            "category": "POPS＆アニメ",
            "title": "うっせぇわ",
            "artist": "Ado",
            "bpm": 178,
            "imageName": "0ca650a74183bf7d8b70927390de3751a962ff68b3aebf4122bf23ff7fdc0a62",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 89,
                        "hold": 17,
                        "slide": 4,
                        "touch": 17,
                        "break": 6,
                        "total": 133
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11322,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 28,
                        "slide": 19,
                        "touch": 6,
                        "break": 17,
                        "total": 342
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11322,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 320,
                        "hold": 56,
                        "slide": 40,
                        "touch": 68,
                        "break": 26,
                        "total": 510
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11322,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 537,
                        "hold": 40,
                        "slide": 115,
                        "touch": 36,
                        "break": 19,
                        "total": 747
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11322,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 11.7
                    },
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "あまくちジンジャー＠やべー新人",
                    "noteCounts": {
                        "tap": 438,
                        "hold": 60,
                        "slide": 115,
                        "touch": 102,
                        "break": 76,
                        "total": 791
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11322,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2021-09-15"
                }
            ],
            "searchAcronyms": [
                "Be quiet",
                "Shut up",
                "Ussewa",
                "吵死了",
                "好你妈吵",
                "无路赛",
                "烦死了"
            ]
        },
        {
            "songId": "Shooting Stars",
            "category": "POPS＆アニメ",
            "title": "Shooting Stars",
            "artist": "クレシェンドブルー [最上静香 (CV.田所あずさ)、北上麗花 (CV.平山笑美)、北沢志保 (CV.雨宮 天)、野々原 茜 (CV.小笠原早紀)、箱崎星梨花 (CV.麻倉もも)]",
            "bpm": 150,
            "imageName": "27dff3421c84ed12eaa134c8e6a594a7871443f2875d5d19ae3d2105e0ee678c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 69,
                        "hold": 12,
                        "slide": 4,
                        "touch": 8,
                        "break": 2,
                        "total": 95
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11323,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 21,
                        "slide": 22,
                        "touch": 7,
                        "break": 8,
                        "total": 263
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11323,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 216,
                        "hold": 59,
                        "slide": 37,
                        "touch": 18,
                        "break": 6,
                        "total": 336
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11323,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 8
                    },
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 481,
                        "hold": 49,
                        "slide": 81,
                        "touch": 5,
                        "break": 26,
                        "total": 642
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11323,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 12.5,
                        "UNiVERSE": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2021-09-16"
                }
            ],
            "searchAcronyms": [
                "🐍⭐",
                "流星"
            ]
        },
        {
            "songId": "MOON NIGHTのせいにして",
            "category": "POPS＆アニメ",
            "title": "MOON NIGHTのせいにして",
            "artist": "DRAMATIC STARS [天道 輝 (CV.仲村宗悟), 桜庭 薫 (CV.内田雄馬), 柏木 翼 (CV.八代 拓)]",
            "bpm": 141,
            "imageName": "05d949db77b564ac537cb460c5e8c94d6761b28595610987194d7763dd535391",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 76,
                        "hold": 9,
                        "slide": 3,
                        "touch": 8,
                        "break": 1,
                        "total": 97
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11324,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 211,
                        "hold": 16,
                        "slide": 6,
                        "touch": 21,
                        "break": 14,
                        "total": 268
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11324,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 242,
                        "hold": 53,
                        "slide": 25,
                        "touch": 14,
                        "break": 12,
                        "total": 346
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11324,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 406,
                        "hold": 47,
                        "slide": 95,
                        "touch": 14,
                        "break": 6,
                        "total": 568
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11324,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 12.2
                    },
                    "releaseDate": "2021-09-16"
                }
            ],
            "searchAcronyms": [
                "moonnight",
                "月光",
                "月夜",
                "月锅"
            ]
        },
        {
            "songId": "泥の分際で私だけの大切を奪おうだなんて",
            "category": "POPS＆アニメ",
            "title": "泥の分際で私だけの大切を奪おうだなんて",
            "artist": "ツユ",
            "bpm": 225,
            "imageName": "594e0a2b69ed1a799b48def7650deb0340d7a2db4f6e9705a533199e27a785af",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 101,
                        "hold": 7,
                        "slide": 2,
                        "touch": 6,
                        "break": 5,
                        "total": 121
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11347,
                    "releaseDate": "2021-11-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 279,
                        "hold": 37,
                        "slide": 19,
                        "touch": 13,
                        "break": 7,
                        "total": 355
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11347,
                    "releaseDate": "2021-11-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 482,
                        "hold": 32,
                        "slide": 36,
                        "touch": 3,
                        "break": 37,
                        "total": 590
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11347,
                    "releaseDate": "2021-11-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 522,
                        "hold": 76,
                        "slide": 137,
                        "touch": 52,
                        "break": 37,
                        "total": 824
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11347,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "FESTiVAL": 13.6,
                        "FESTiVAL PLUS": 13.7,
                        "UNiVERSE": 13.4,
                        "UNiVERSE PLUS": 13.4
                    },
                    "releaseDate": "2021-11-26"
                }
            ],
            "searchAcronyms": [
                "being low as dirt",
                "Being low as dirt, taking what's important from me",
                "dorono",
                "low as dirt",
                "伤不起",
                "你个辣鸡还跟我抢男人",
                "八个绝赞叫四声",
                "区区小三竟敢抢老娘女人",
                "区区泥土竟然也想夺走属于我的宝物",
                "区区烂泥",
                "区区烂泥却妄想夺去只属于我的宝物",
                "区区穿心也想夺走属于我的AP",
                "区区绝赞也妄想夺走我的鸟加",
                "大醋坛子",
                "就凭泥土竟然也想夺走专属我的宝物",
                "就凭泥土竟然也想夺走属于我的宝物",
                "我",
                "抢男人",
                "果咩纳塞",
                "果咩那塞",
                "泥",
                "泥分",
                "泥分大切",
                "泥分祭",
                "泥分际私大切夺",
                "泥切",
                "泥土",
                "泥抢啥",
                "泥歌",
                "泥铲",
                "烂泥",
                "狗莓拿塞",
                "痛失吾爱举目破败",
                "穿心の分際で私だけの鸟加を奪おうだなんて",
                "臭屌丝还想抢老娘男人",
                "蛐蛐泥土",
                "蛐蛐烂泥",
                "黑化能天使"
            ]
        },
        {
            "songId": "VOLTAGE",
            "category": "POPS＆アニメ",
            "title": "VOLTAGE",
            "artist": "Rain Drops",
            "bpm": 194,
            "imageName": "18301b12ae737bbc0dd8ae9452dec58f473017849f5f64d158307918f9ef5c9e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 6,
                        "slide": 4,
                        "touch": 7,
                        "break": 2,
                        "total": 215
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11348,
                    "releaseDate": "2021-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 370,
                        "hold": 18,
                        "slide": 11,
                        "touch": 13,
                        "break": 2,
                        "total": 414
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11348,
                    "releaseDate": "2021-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 481,
                        "hold": 72,
                        "slide": 42,
                        "touch": 31,
                        "break": 19,
                        "total": 645
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11348,
                    "releaseDate": "2021-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 573,
                        "hold": 70,
                        "slide": 161,
                        "touch": 23,
                        "break": 15,
                        "total": 842
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11348,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2021-12-24"
                }
            ],
            "searchAcronyms": [
                "电压"
            ]
        },
        {
            "songId": "Seize The Day",
            "category": "POPS＆アニメ",
            "title": "Seize The Day",
            "artist": "亜咲花",
            "bpm": 122,
            "imageName": "468d09b7b43350e638f09d00751ad1b6a0c58a33e18bd0af74988a12f458e78a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 30,
                        "hold": 5,
                        "slide": 2,
                        "touch": 5,
                        "break": 1,
                        "total": 43
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11352,
                    "releaseDate": "2022-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 112,
                        "hold": 10,
                        "slide": 10,
                        "touch": 26,
                        "break": 6,
                        "total": 164
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11352,
                    "releaseDate": "2022-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 185,
                        "hold": 24,
                        "slide": 12,
                        "touch": 13,
                        "break": 4,
                        "total": 238
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11352,
                    "releaseDate": "2022-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 40,
                        "slide": 38,
                        "touch": 37,
                        "break": 15,
                        "total": 377
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11352,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 11.8
                    },
                    "releaseDate": "2022-01-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "veil",
            "category": "POPS＆アニメ",
            "title": "veil",
            "artist": "須田景凪",
            "bpm": 150,
            "imageName": "f0f8bcecc9ea868736346832c293db7bd7af4e45e09d5bb7f1224a9c784e2628",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 98,
                        "hold": 2,
                        "slide": 5,
                        "touch": 20,
                        "break": 2,
                        "total": 127
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11367,
                    "releaseDate": "2021-11-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 20,
                        "slide": 13,
                        "touch": 21,
                        "break": 8,
                        "total": 248
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11367,
                    "releaseDate": "2021-11-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 35,
                        "slide": 24,
                        "touch": 30,
                        "break": 13,
                        "total": 364
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11367,
                    "releaseDate": "2021-11-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 66,
                        "slide": 116,
                        "touch": 22,
                        "break": 20,
                        "total": 576
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11367,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "UNiVERSE": 12.2
                    },
                    "releaseDate": "2021-11-26"
                }
            ],
            "searchAcronyms": [
                "🍎",
                "🍎👈",
                "炎炎消防队",
                "苹果",
                "苹果酱"
            ]
        },
        {
            "songId": "さんさーら！",
            "category": "ゲーム＆バラエティ",
            "title": "さんさーら！",
            "artist": "ARuFa",
            "bpm": 140,
            "imageName": "c715bdf82bdc997edf4b76336473b129ae18a422e5522c831d3c8681e3c5aba5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 120,
                        "hold": 13,
                        "slide": 4,
                        "touch": 8,
                        "break": 3,
                        "total": 148
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11370,
                    "releaseDate": "2021-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 269,
                        "hold": 16,
                        "slide": 15,
                        "touch": 20,
                        "break": 4,
                        "total": 324
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11370,
                    "releaseDate": "2021-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 286,
                        "hold": 107,
                        "slide": 15,
                        "touch": 9,
                        "break": 13,
                        "total": 430
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11370,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 8.8
                    },
                    "releaseDate": "2021-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 519,
                        "hold": 47,
                        "slide": 107,
                        "touch": 52,
                        "break": 68,
                        "total": 793
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11370,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 12.9
                    },
                    "releaseDate": "2021-09-22"
                }
            ],
            "searchAcronyms": [
                "arufa",
                "samsara",
                "Samsara",
                "哈比下",
                "本社爆破"
            ]
        },
        {
            "songId": "テリトリーバトル",
            "category": "オンゲキ＆CHUNITHM",
            "title": "テリトリーバトル",
            "artist": "ツユ",
            "bpm": 140,
            "imageName": "5faa9b9ab9e41faff2b5dd9d0e72cbdce1b75feab983484b2b6df6d6b8edfe95",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 170,
                        "hold": 5,
                        "slide": 3,
                        "touch": 16,
                        "break": 15,
                        "total": 209
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11396,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 21,
                        "slide": 16,
                        "touch": 11,
                        "break": 10,
                        "total": 316
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11396,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 427,
                        "hold": 50,
                        "slide": 43,
                        "touch": 10,
                        "break": 12,
                        "total": 542
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11396,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 10
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "アミノハバキリ",
                    "noteCounts": {
                        "tap": 671,
                        "hold": 36,
                        "slide": 98,
                        "touch": 37,
                        "break": 26,
                        "total": 868
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11396,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.6,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.5,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2022-03-24"
                }
            ],
            "searchAcronyms": [
                "👿👿",
                "0419",
                "mtf",
                "territory battle",
                "Territory Battle",
                "二次元鼓动",
                "伪娘",
                "可爱男娘加我",
                "团长我徒弟呢",
                "坎二四",
                "小伪娘",
                "小圣诞",
                "小男娘",
                "把我妈妈还给我",
                "把我的家人还给我",
                "木桶饭",
                "猫抓板",
                "男娘",
                "超威蓝猫",
                "返せ!返せ!👿👿",
                "领土战争",
                "领土战役"
            ]
        },
        {
            "songId": "愛のシュプリーム！",
            "category": "POPS＆アニメ",
            "title": "愛のシュプリーム！",
            "artist": "fhána",
            "bpm": 135,
            "imageName": "8875333b89b4185f012b494bc6df160358464b8c27caddecdeff71847cbb43b5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 50,
                        "hold": 5,
                        "slide": 3,
                        "touch": 6,
                        "break": 1,
                        "total": 65
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11406,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 158,
                        "hold": 20,
                        "slide": 4,
                        "touch": 9,
                        "break": 4,
                        "total": 195
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11406,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 56,
                        "slide": 8,
                        "touch": 28,
                        "break": 5,
                        "total": 324
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11406,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 8
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 372,
                        "hold": 18,
                        "slide": 63,
                        "touch": 45,
                        "break": 35,
                        "total": 533
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11406,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.6,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2022-03-24"
                }
            ],
            "searchAcronyms": [
                "Ai no Supreme",
                "Love Supreme"
            ]
        },
        {
            "songId": "くらべられっ子",
            "category": "POPS＆アニメ",
            "title": "くらべられっ子",
            "artist": "ツユ",
            "bpm": 194,
            "imageName": "18d5d1e7a5bdaf9e7e27240941d5e6b0946cbd3791bdecdc2921fcbe56dee081",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 81,
                        "hold": 18,
                        "slide": 3,
                        "touch": 6,
                        "break": 2,
                        "total": 110
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11407,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 27,
                        "slide": 20,
                        "touch": 16,
                        "break": 3,
                        "total": 307
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11407,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.8,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 269,
                        "hold": 53,
                        "slide": 20,
                        "touch": 16,
                        "break": 21,
                        "total": 379
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11407,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 9.8
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11.5,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 376,
                        "hold": 43,
                        "slide": 85,
                        "touch": 12,
                        "break": 11,
                        "total": 527
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11407,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 11.5
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 416,
                        "hold": 64,
                        "slide": 116,
                        "touch": 17,
                        "break": 15,
                        "total": 628
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11407,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "BUDDiES PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2022-03-24"
                }
            ],
            "searchAcronyms": [
                "😭",
                "ABCDEFG",
                "Compared Child",
                "Kuraberarekko",
                "我",
                "日本字子",
                "林涅",
                "比较子",
                "比较孩",
                "被比较的孩子"
            ]
        },
        {
            "songId": "あの世行きのバスに乗ってさらば。",
            "category": "POPS＆アニメ",
            "title": "あの世行きのバスに乗ってさらば。",
            "artist": "ツユ",
            "bpm": 240,
            "imageName": "17101da795b7c3b28ee6ec16fc6e814c3ee6970014c9ba3e7312400e74d0b51b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 84,
                        "hold": 16,
                        "slide": 7,
                        "touch": 8,
                        "break": 5,
                        "total": 120
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11408,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 37,
                        "slide": 12,
                        "touch": 32,
                        "break": 11,
                        "total": 332
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11408,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 380,
                        "hold": 41,
                        "slide": 24,
                        "touch": 13,
                        "break": 28,
                        "total": 486
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11408,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 11
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 462,
                        "hold": 63,
                        "slide": 71,
                        "touch": 38,
                        "break": 64,
                        "total": 698
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11408,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2022-03-24"
                }
            ],
            "searchAcronyms": [
                "😵🙏",
                "760",
                "bus",
                "I'm getting on the bus to the other world, see ya!",
                "世行",
                "世行乘",
                "乘上前往彼世的巴士以告别",
                "公交车创死我",
                "坐上前往彼世的巴士",
                "坐上前往彼岸的巴士永别了",
                "巴士",
                "巴士酱",
                "开放姐",
                "彼世公交",
                "彼世公交车",
                "彼世巴士",
                "彼岸巴士",
                "晓美焰",
                "曉美焰"
            ]
        },
        {
            "songId": "うまぴょい伝説",
            "category": "POPS＆アニメ",
            "title": "うまぴょい伝説",
            "artist": "スペシャルウィーク （CV.和氣あず未）、サイレンススズカ （CV.高野麻里佳）、トウカイテイオー （CV.Machico）",
            "bpm": 170,
            "imageName": "ecf121e744baa20ca011b31fc77f7c8d5d65162974345ca670c0e88e2dbad6bc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 167,
                        "hold": 14,
                        "slide": 3,
                        "touch": 24,
                        "break": 16,
                        "total": 224
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11409,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 17,
                        "slide": 19,
                        "touch": 9,
                        "break": 13,
                        "total": 288
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11409,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 8.7,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 85,
                        "slide": 15,
                        "touch": 35,
                        "break": 21,
                        "total": 448
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11409,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 8.7
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 353,
                        "hold": 65,
                        "slide": 61,
                        "touch": 35,
                        "break": 46,
                        "total": 560
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11409,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 11
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 515,
                        "hold": 58,
                        "slide": 138,
                        "touch": 26,
                        "break": 93,
                        "total": 830
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11409,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "UNiVERSE PLUS": 13.5
                    },
                    "releaseDate": "2022-03-24"
                }
            ],
            "searchAcronyms": [
                "Uma musume",
                "Umapyoi",
                "Umapyoi Densetsu"
            ]
        },
        {
            "songId": "YONA YONA DANCE",
            "category": "POPS＆アニメ",
            "title": "YONA YONA DANCE",
            "artist": "和田アキ子",
            "bpm": 145,
            "imageName": "beed9f22295ac1835fd14d516e7aae169fef697e6d124aacb09bfed0d768b587",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 72,
                        "hold": 8,
                        "slide": 7,
                        "touch": 8,
                        "break": 3,
                        "total": 98
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11450,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 260,
                        "hold": 26,
                        "slide": 9,
                        "touch": 11,
                        "break": 12,
                        "total": 318
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11450,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 93,
                        "slide": 23,
                        "touch": 96,
                        "break": 12,
                        "total": 504
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11450,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 9
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 404,
                        "hold": 67,
                        "slide": 116,
                        "touch": 53,
                        "break": 27,
                        "total": 667
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11450,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2022-03-24"
                }
            ],
            "searchAcronyms": [
                "yona",
                "yyd",
                "不跳舞就亏了",
                "晚上晚上跳舞"
            ]
        },
        {
            "songId": "Photon Melodies",
            "category": "POPS＆アニメ",
            "title": "Photon Melodies",
            "artist": "Photon Maiden",
            "bpm": 128,
            "imageName": "ef00e2517aaf9ce9ae0640c146896ab30ca6aa0b1fe93acd2499ebde516af759",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 106,
                        "hold": 8,
                        "slide": 3,
                        "touch": 0,
                        "break": 3,
                        "total": 120
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11420,
                    "releaseDate": "2022-04-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 116,
                        "hold": 16,
                        "slide": 14,
                        "touch": 27,
                        "break": 10,
                        "total": 183
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11420,
                    "releaseDate": "2022-04-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 222,
                        "hold": 86,
                        "slide": 23,
                        "touch": 18,
                        "break": 12,
                        "total": 361
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11420,
                    "releaseDate": "2022-04-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 359,
                        "hold": 26,
                        "slide": 121,
                        "touch": 54,
                        "break": 15,
                        "total": 575
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11420,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2022-04-15"
                }
            ],
            "searchAcronyms": [
                "pm",
                "光子旋律"
            ]
        },
        {
            "songId": "吾輩よ猫であれ",
            "category": "POPS＆アニメ",
            "title": "吾輩よ猫であれ",
            "artist": "Lyrical Lily",
            "bpm": 136,
            "imageName": "c4830cd3590e4b00dbf6d3e0851b1685547e5785c17e1ea8635104f198b0d5ac",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 7,
                        "slide": 3,
                        "touch": 7,
                        "break": 1,
                        "total": 121
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11421,
                    "releaseDate": "2022-04-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 23,
                        "slide": 10,
                        "touch": 25,
                        "break": 4,
                        "total": 231
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11421,
                    "releaseDate": "2022-04-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 72,
                        "slide": 22,
                        "touch": 25,
                        "break": 6,
                        "total": 348
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11421,
                    "releaseDate": "2022-04-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 377,
                        "hold": 56,
                        "slide": 90,
                        "touch": 27,
                        "break": 8,
                        "total": 558
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11421,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 12.2,
                        "UNiVERSE PLUS": 12
                    },
                    "releaseDate": "2022-04-15"
                }
            ],
            "searchAcronyms": [
                "吾辈",
                "吾辈是猫",
                "吾辈猫",
                "我是猫",
                "萨卡班甲鱼"
            ]
        },
        {
            "songId": "PON PON PON",
            "category": "POPS＆アニメ",
            "title": "PON PON PON",
            "artist": "きゃりーぱみゅぱみゅ［PV］",
            "bpm": 128,
            "imageName": "6a4489d7d298b9b6c5bd54f4e13d6118f293e2f900da979c3750ecd549b62665",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 213,
                        "hold": 1,
                        "slide": 3,
                        "touch": null,
                        "break": 3,
                        "total": 220
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 6,
                        "slide": 9,
                        "touch": null,
                        "break": 4,
                        "total": 276
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 309,
                        "hold": 13,
                        "slide": 8,
                        "touch": null,
                        "break": 10,
                        "total": 340
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 343,
                        "hold": 27,
                        "slide": 21,
                        "touch": null,
                        "break": 20,
                        "total": 411
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Choo Choo TRAIN",
            "category": "POPS＆アニメ",
            "title": "Choo Choo TRAIN",
            "artist": "EXILE［PV］",
            "bpm": 115,
            "imageName": "afc15c0732441c1b0903777a157db2698b32914a43b9a69f5f3496b1caf93e90",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 107,
                        "hold": 18,
                        "slide": 12,
                        "touch": null,
                        "break": 3,
                        "total": 140
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 17,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 172
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 33,
                        "slide": 38,
                        "touch": null,
                        "break": 10,
                        "total": 358
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 270,
                        "hold": 57,
                        "slide": 66,
                        "touch": null,
                        "break": 44,
                        "total": 437
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "VICTORY",
            "category": "POPS＆アニメ",
            "title": "VICTORY",
            "artist": "EXILE",
            "bpm": 130,
            "imageName": "2162e8236ac166e0e092b96f4495aa6f1f1fdc56c0ae82ede3e7912f312d2555",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 53,
                        "hold": 7,
                        "slide": 10,
                        "touch": null,
                        "break": 3,
                        "total": 73
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-06-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 225,
                        "hold": 9,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 246
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-06-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 60,
                        "slide": 15,
                        "touch": null,
                        "break": 6,
                        "total": 223
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-06-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 34,
                        "slide": 30,
                        "touch": null,
                        "break": 20,
                        "total": 338
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-06-17"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ヘビーローテーション",
            "category": "POPS＆アニメ",
            "title": "ヘビーローテーション",
            "artist": "AKB48［PV］",
            "bpm": 178,
            "imageName": "99899cf0a1fbc644e9a4a208b178802f0257c869a3be763b8b847e0826ba7d28",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 132,
                        "hold": 14,
                        "slide": 5,
                        "touch": null,
                        "break": 3,
                        "total": 154
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 22,
                        "slide": 5,
                        "touch": null,
                        "break": 3,
                        "total": 259
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 301,
                        "hold": 40,
                        "slide": 8,
                        "touch": null,
                        "break": 7,
                        "total": 356
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 383,
                        "hold": 20,
                        "slide": 38,
                        "touch": null,
                        "break": 6,
                        "total": 447
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Everyday、カチューシャ",
            "category": "POPS＆アニメ",
            "title": "Everyday、カチューシャ",
            "artist": "AKB48［PV］",
            "bpm": 172,
            "imageName": "24cae3519a8ede77d077c1ecbdb402eac264fee6deae8a5f0b32d476303d40d0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 185,
                        "hold": 14,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 206
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 217,
                        "hold": 47,
                        "slide": 12,
                        "touch": null,
                        "break": 2,
                        "total": 278
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 453,
                        "hold": 14,
                        "slide": 20,
                        "touch": null,
                        "break": 4,
                        "total": 491
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 368,
                        "hold": 56,
                        "slide": 79,
                        "touch": null,
                        "break": 12,
                        "total": 515
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Chu Chu",
            "category": "POPS＆アニメ",
            "title": "Chu Chu",
            "artist": "moumoon［PV］",
            "bpm": 98,
            "imageName": "a66fe32dc723bea748969aee9d69835dfaaa83daf3b443d7625241df0010425b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 167,
                        "hold": 3,
                        "slide": 3,
                        "touch": null,
                        "break": 3,
                        "total": 176
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 224,
                        "hold": 4,
                        "slide": 5,
                        "touch": null,
                        "break": 5,
                        "total": 238
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 16,
                        "slide": 6,
                        "touch": null,
                        "break": 1,
                        "total": 280
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 444,
                        "hold": 8,
                        "slide": 4,
                        "touch": null,
                        "break": 15,
                        "total": 471
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "New World",
            "category": "POPS＆アニメ",
            "title": "New World",
            "artist": "w-inds.［PV］",
            "bpm": 127,
            "imageName": "052e2f90b49e27d2ad1ca3c8e39fed8fbf33d7207a5fad4f93b98d47c85edb50",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 155,
                        "hold": 12,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 173
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 20,
                        "slide": 5,
                        "touch": null,
                        "break": 10,
                        "total": 223
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 222,
                        "hold": 26,
                        "slide": 17,
                        "touch": null,
                        "break": 17,
                        "total": 282
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 58,
                        "slide": 21,
                        "touch": null,
                        "break": 13,
                        "total": 369
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "CAN'T GET BACK",
            "category": "POPS＆アニメ",
            "title": "CAN'T GET BACK",
            "artist": "w-inds.［PV］",
            "bpm": 140,
            "imageName": "a99c7075b0d50aa1597b2836178e3b0710630502e9f163841fbfc10e6be7b780",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 3,
                        "slide": 3,
                        "touch": null,
                        "break": 2,
                        "total": 117
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 139,
                        "hold": 13,
                        "slide": 4,
                        "touch": null,
                        "break": 3,
                        "total": 159
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 168,
                        "hold": 35,
                        "slide": 21,
                        "touch": null,
                        "break": 2,
                        "total": 226
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 235,
                        "hold": 17,
                        "slide": 20,
                        "touch": null,
                        "break": 10,
                        "total": 282
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "愛を止めないで",
            "category": "POPS＆アニメ",
            "title": "愛を止めないで",
            "artist": "倖田來未［PV］",
            "bpm": 83,
            "imageName": "4831c63f89a1f76bbb2fbdf925dce56f4831bd7bb06fb408150c6a315ec99e2b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 73,
                        "hold": 15,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 94
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 132,
                        "hold": 45,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 183
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 152,
                        "hold": 25,
                        "slide": 20,
                        "touch": null,
                        "break": 4,
                        "total": 201
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 161,
                        "hold": 15,
                        "slide": 46,
                        "touch": null,
                        "break": 12,
                        "total": 234
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "LOVE ＆ JOY",
            "category": "POPS＆アニメ",
            "title": "LOVE ＆ JOY",
            "artist": "木村 由姫［cover］",
            "bpm": 173,
            "imageName": "8b5f6a1971b8351c043074e51865297c55aad6320778890808079e8cd646f872",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 0,
                        "slide": 4,
                        "touch": null,
                        "break": 3,
                        "total": 183
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 226,
                        "hold": 8,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 246
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 41,
                        "slide": 13,
                        "touch": null,
                        "break": 5,
                        "total": 292
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 329,
                        "hold": 16,
                        "slide": 33,
                        "touch": null,
                        "break": 23,
                        "total": 401
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "じょいふる",
            "category": "POPS＆アニメ",
            "title": "じょいふる",
            "artist": "いきものがかり［cover］",
            "bpm": 159,
            "imageName": "4588ebf67b9d728991f9afab9101d4c3b3d7d688be30a330305e487bada8d76f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 155,
                        "hold": 3,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 165
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 265,
                        "hold": 10,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 285
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 22,
                        "slide": 17,
                        "touch": null,
                        "break": 4,
                        "total": 293
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 343,
                        "hold": 18,
                        "slide": 25,
                        "touch": null,
                        "break": 28,
                        "total": 414
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "アイデンティティ",
            "category": "POPS＆アニメ",
            "title": "アイデンティティ",
            "artist": "サカナクション［cover］",
            "bpm": 140,
            "imageName": "5228029fa7b89dd4e595389d3fe8a6e6d7c6dd6037f9890087727bbeddb930f1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 165,
                        "hold": 7,
                        "slide": 2,
                        "touch": null,
                        "break": 2,
                        "total": 176
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 198,
                        "hold": 22,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 226
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 22,
                        "slide": 22,
                        "touch": null,
                        "break": 6,
                        "total": 240
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 29,
                        "slide": 32,
                        "touch": null,
                        "break": 5,
                        "total": 361
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Garden",
            "category": "POPS＆アニメ",
            "title": "Garden",
            "artist": "May J.［cover］",
            "bpm": 99,
            "imageName": "6067d18d9b5d647eb870f37f388b7cd3ccf3a3deb0f19176561d8012464fbc69",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 93,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 103
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 4,
                        "slide": 6,
                        "touch": null,
                        "break": 1,
                        "total": 157
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 210,
                        "hold": 28,
                        "slide": 12,
                        "touch": null,
                        "break": 8,
                        "total": 258
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 29,
                        "slide": 24,
                        "touch": null,
                        "break": 17,
                        "total": 284
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "つけまつける",
            "category": "POPS＆アニメ",
            "title": "つけまつける",
            "artist": "きゃりーぱみゅぱみゅ［PV］",
            "bpm": 145,
            "imageName": "8cafaedc167f21a3d2e633584fc227d9f0bc2e2992d9ab8aba4e088ac1764cdc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 66,
                        "hold": 14,
                        "slide": 3,
                        "touch": null,
                        "break": 6,
                        "total": 89
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 40,
                        "slide": 4,
                        "touch": null,
                        "break": 7,
                        "total": 245
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 216,
                        "hold": 58,
                        "slide": 1,
                        "touch": null,
                        "break": 1,
                        "total": 276
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 43,
                        "slide": 31,
                        "touch": null,
                        "break": 7,
                        "total": 338
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "CANDY CANDY",
            "category": "POPS＆アニメ",
            "title": "CANDY CANDY",
            "artist": "きゃりーぱみゅぱみゅ［PV］",
            "bpm": 130,
            "imageName": "8e91ef2751d784fb4aacc8be91fa9dc5839a37f1afc2079c89763557bec2fde3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 94,
                        "hold": 21,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 124
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 191,
                        "hold": 30,
                        "slide": 4,
                        "touch": null,
                        "break": 12,
                        "total": 237
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 236,
                        "hold": 47,
                        "slide": 3,
                        "touch": null,
                        "break": 2,
                        "total": 288
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 215,
                        "hold": 44,
                        "slide": 43,
                        "touch": null,
                        "break": 11,
                        "total": 313
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "SPELL MAGIC",
            "category": "POPS＆アニメ",
            "title": "SPELL MAGIC",
            "artist": "Acid Black Cherry［PV］",
            "bpm": 180,
            "imageName": "68fbf121cbfb92aa3920f2b14a610bfbd5fe23ebd9460cc6d99ec3c9e0728f3b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 147,
                        "hold": 19,
                        "slide": 10,
                        "touch": null,
                        "break": 5,
                        "total": 181
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 222,
                        "hold": 34,
                        "slide": 15,
                        "touch": null,
                        "break": 8,
                        "total": 279
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 310,
                        "hold": 62,
                        "slide": 32,
                        "touch": null,
                        "break": 23,
                        "total": 427
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 386,
                        "hold": 67,
                        "slide": 24,
                        "touch": null,
                        "break": 37,
                        "total": 514
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ニブンノイチ",
            "category": "POPS＆アニメ",
            "title": "ニブンノイチ",
            "artist": "BACK-ON［cover］",
            "bpm": 125,
            "imageName": "412a8857cb93da36f48915af6508b2be59c5f91f359db83cb8365beb6e4e2b8a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 96,
                        "hold": 3,
                        "slide": 2,
                        "touch": null,
                        "break": 4,
                        "total": 105
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 193,
                        "hold": 3,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 206
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 238,
                        "hold": 13,
                        "slide": 22,
                        "touch": null,
                        "break": 4,
                        "total": 277
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 30,
                        "slide": 33,
                        "touch": null,
                        "break": 18,
                        "total": 387
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "サラバ、愛しき悲しみたちよ",
            "category": "POPS＆アニメ",
            "title": "サラバ、愛しき悲しみたちよ",
            "artist": "ももいろクローバーZ［PV］",
            "bpm": 168,
            "imageName": "ea7dcd6045ec8af5446fdd2771dd9822771394689a260ac11121396155fcdb3c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 8,
                        "slide": 3,
                        "touch": null,
                        "break": 6,
                        "total": 145
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 19,
                        "slide": 5,
                        "touch": null,
                        "break": 10,
                        "total": 285
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 52,
                        "slide": 31,
                        "touch": null,
                        "break": 37,
                        "total": 374
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 334,
                        "hold": 66,
                        "slide": 55,
                        "touch": null,
                        "break": 22,
                        "total": 477
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "女々しくて",
            "category": "POPS＆アニメ",
            "title": "女々しくて",
            "artist": "ゴールデンボンバー［PV］",
            "bpm": 143,
            "imageName": "f15d1a105410fb45100142d89dbb07288eed6f2d8860dc28e2a4f2b36d92d3fb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 104,
                        "hold": 9,
                        "slide": 0,
                        "touch": null,
                        "break": 4,
                        "total": 117
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 18,
                        "slide": 9,
                        "touch": null,
                        "break": 8,
                        "total": 235
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 17,
                        "slide": 21,
                        "touch": null,
                        "break": 8,
                        "total": 313
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 381,
                        "hold": 12,
                        "slide": 63,
                        "touch": null,
                        "break": 10,
                        "total": 466
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "LOVEドッきゅん♥",
            "category": "POPS＆アニメ",
            "title": "LOVEドッきゅん♥",
            "artist": "club prince［cover］",
            "bpm": 149,
            "imageName": "77c4447ac88278611f80eb57972ce63295f73f93c2bfff5c17a4212749a59cbd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 99,
                        "hold": 13,
                        "slide": 5,
                        "touch": null,
                        "break": 17,
                        "total": 134
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 261,
                        "hold": 16,
                        "slide": 5,
                        "touch": null,
                        "break": 16,
                        "total": 298
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 48,
                        "slide": 21,
                        "touch": null,
                        "break": 40,
                        "total": 381
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 363,
                        "hold": 55,
                        "slide": 24,
                        "touch": null,
                        "break": 45,
                        "total": 487
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "GO!!!",
            "category": "POPS＆アニメ",
            "title": "GO!!!",
            "artist": "FLOW「NARUTO」［cover］",
            "bpm": 134,
            "imageName": "0226f237a5ceb33a96e34119a12779925b0e78e94041744cd7a05bbe3688f22d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 15,
                        "slide": 11,
                        "touch": null,
                        "break": 7,
                        "total": 138
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 170,
                        "hold": 25,
                        "slide": 9,
                        "touch": null,
                        "break": 8,
                        "total": 212
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 37,
                        "slide": 19,
                        "touch": null,
                        "break": 21,
                        "total": 354
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 381,
                        "hold": 30,
                        "slide": 49,
                        "touch": null,
                        "break": 33,
                        "total": 493
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "カルマ",
            "category": "POPS＆アニメ",
            "title": "カルマ",
            "artist": "BUMP OF CHICKEN［cover］",
            "bpm": 195,
            "imageName": "5483ca284c350bf63865b80206f6b4d561d55ba7e049bb44b1287fbb0512f2af",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 83,
                        "hold": 16,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 107
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 99,
                        "hold": 40,
                        "slide": 9,
                        "touch": null,
                        "break": 3,
                        "total": 151
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "maimai",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 54,
                        "slide": 9,
                        "touch": null,
                        "break": 5,
                        "total": 315
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 289,
                        "hold": 14,
                        "slide": 57,
                        "touch": null,
                        "break": 16,
                        "total": 376
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "リライト",
            "category": "POPS＆アニメ",
            "title": "リライト",
            "artist": "ASIAN KANG-FU GENERATION［cover］",
            "bpm": 179,
            "imageName": "31e506fe4b3489feb28d548c3d60e242979d8e6540baf69070a3a298abde914e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 100,
                        "hold": 20,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 129
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 34,
                        "slide": 4,
                        "touch": null,
                        "break": 10,
                        "total": 242
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 358,
                        "hold": 18,
                        "slide": 11,
                        "touch": null,
                        "break": 13,
                        "total": 400
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 413,
                        "hold": 47,
                        "slide": 23,
                        "touch": null,
                        "break": 8,
                        "total": 491
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "READY STEADY GO",
            "category": "POPS＆アニメ",
            "title": "READY STEADY GO",
            "artist": "L'Arc~en~Ciel［cover］",
            "bpm": 144,
            "imageName": "a2bbbbbb2044e1cde1180c267f55e5d22dff1bffb2b0ed3bb3801fb422be7357",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 72,
                        "hold": 17,
                        "slide": 5,
                        "touch": null,
                        "break": 1,
                        "total": 95
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 122,
                        "hold": 26,
                        "slide": 4,
                        "touch": null,
                        "break": 7,
                        "total": 159
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 43,
                        "slide": 18,
                        "touch": null,
                        "break": 7,
                        "total": 344
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 66,
                        "slide": 16,
                        "touch": null,
                        "break": 13,
                        "total": 401
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Butter-Fly",
            "category": "POPS＆アニメ",
            "title": "Butter-Fly",
            "artist": "和田光司［cover］",
            "bpm": 165,
            "imageName": "baa1fe6f11a7a17eef3246a537f95a47be223556fa0132a3cb1d801f10381151",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 99,
                        "hold": 12,
                        "slide": 7,
                        "touch": null,
                        "break": 3,
                        "total": 121
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 119,
                        "hold": 22,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 151
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 177,
                        "hold": 90,
                        "slide": 7,
                        "touch": null,
                        "break": 17,
                        "total": 291
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "合作だよ",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 40,
                        "slide": 73,
                        "touch": null,
                        "break": 14,
                        "total": 367
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "創聖のアクエリオン",
            "category": "POPS＆アニメ",
            "title": "創聖のアクエリオン",
            "artist": "AKINO［cover］",
            "bpm": 151,
            "imageName": "6c71ebec5d6f36446496ceab3dab0f06aeb941c95774f5c53fdfd1aee488d470",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 54,
                        "hold": 12,
                        "slide": 3,
                        "touch": null,
                        "break": 4,
                        "total": 73
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 112,
                        "hold": 30,
                        "slide": 17,
                        "touch": null,
                        "break": 4,
                        "total": 163
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 211,
                        "hold": 11,
                        "slide": 24,
                        "touch": null,
                        "break": 7,
                        "total": 253
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 13,
                        "slide": 109,
                        "touch": null,
                        "break": 5,
                        "total": 341
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "残酷な天使のテーゼ",
            "category": "POPS＆アニメ",
            "title": "残酷な天使のテーゼ",
            "artist": "高橋洋子［cover］",
            "bpm": 128,
            "imageName": "a9a9cdc4a1fccfa54d6af0be5324dfab29c7f9aaaebd6c7dd8167df45abf30c5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 64,
                        "hold": 10,
                        "slide": 3,
                        "touch": null,
                        "break": 7,
                        "total": 84
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 123,
                        "hold": 21,
                        "slide": 6,
                        "touch": null,
                        "break": 10,
                        "total": 160
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 161,
                        "hold": 15,
                        "slide": 21,
                        "touch": null,
                        "break": 6,
                        "total": 203
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 266,
                        "hold": 34,
                        "slide": 13,
                        "touch": null,
                        "break": 29,
                        "total": 342
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": [
                "A Cruel Angel's Thesis",
                "Cruel Angel's Thesis",
                "Evangelion"
            ]
        },
        {
            "songId": "galaxias!",
            "category": "niconico＆ボーカロイド",
            "title": "galaxias!",
            "artist": "galaxias!［PV］",
            "bpm": 123,
            "imageName": "c245f218e35b4ab929234828923682bf4d73800c1a24ee2be01169485cf5344a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 88,
                        "hold": 9,
                        "slide": 7,
                        "touch": null,
                        "break": 4,
                        "total": 108
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 18,
                        "slide": 9,
                        "touch": null,
                        "break": 17,
                        "total": 190
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 226,
                        "hold": 20,
                        "slide": 31,
                        "touch": null,
                        "break": 3,
                        "total": 280
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 204,
                        "hold": 37,
                        "slide": 76,
                        "touch": null,
                        "break": 23,
                        "total": 340
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Tachyon",
            "category": "POPS＆アニメ",
            "title": "Tachyon",
            "artist": "mamenoi (MANYO＆やなぎなぎ)",
            "bpm": 176,
            "imageName": "c286dde93b460d9cfc5b9e8f82c622daedf066d9ef05c41ca704d4bc20b96c1d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 91,
                        "hold": 12,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 109
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 159,
                        "hold": 19,
                        "slide": 42,
                        "touch": null,
                        "break": 13,
                        "total": 233
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 20,
                        "slide": 48,
                        "touch": null,
                        "break": 16,
                        "total": 318
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 39,
                        "slide": 131,
                        "touch": null,
                        "break": 6,
                        "total": 406
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-07-17"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "リクライム",
            "category": "POPS＆アニメ",
            "title": "リクライム",
            "artist": "ROOKiEZ is PUNK’D 「弱虫ペダル」[アニメPV]",
            "bpm": 188,
            "imageName": "5c841373fbc4ea17f2a5850f3cc60a4dc1dad9a15c426979495a04ada7fe9792",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 97,
                        "hold": 2,
                        "slide": 4,
                        "touch": null,
                        "break": 7,
                        "total": 110
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 180,
                        "hold": 5,
                        "slide": 13,
                        "touch": null,
                        "break": 10,
                        "total": 208
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 266,
                        "hold": 5,
                        "slide": 42,
                        "touch": null,
                        "break": 9,
                        "total": 322
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 398,
                        "hold": 0,
                        "slide": 54,
                        "touch": null,
                        "break": 16,
                        "total": 468
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "恋のヒメヒメぺったんこ",
            "category": "POPS＆アニメ",
            "title": "恋のヒメヒメぺったんこ",
            "artist": "姫野湖鳥（CV 田村ゆかり）「弱虫ペダル」",
            "bpm": 178,
            "imageName": "627cf4d75d4d1601272f2a126daec5d782e5306a5f74bc810a385701a22a8e8b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 81,
                        "hold": 19,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 106
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 195,
                        "hold": 14,
                        "slide": 17,
                        "touch": null,
                        "break": 14,
                        "total": 240
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 29,
                        "slide": 10,
                        "touch": null,
                        "break": 23,
                        "total": 320
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 16,
                        "slide": 114,
                        "touch": null,
                        "break": 22,
                        "total": 384
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-03-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "サブリナ",
            "category": "POPS＆アニメ",
            "title": "サブリナ",
            "artist": "家入レオ［PV］",
            "bpm": 136,
            "imageName": "43df68d4da7fa5f8866f589cf6a8821fe3fa0d8bbcd7652b7dc9e0bd6a937f98",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 100,
                        "hold": 32,
                        "slide": 1,
                        "touch": null,
                        "break": 5,
                        "total": 138
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 40,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 255
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 88,
                        "slide": 22,
                        "touch": null,
                        "break": 4,
                        "total": 323
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 268,
                        "hold": 67,
                        "slide": 95,
                        "touch": null,
                        "break": 6,
                        "total": 436
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "RPG",
            "category": "POPS＆アニメ",
            "title": "RPG",
            "artist": "SEKAI NO OWARI",
            "bpm": 135,
            "imageName": "8028a8fbdfba8fcd80db2304f124f5fbc6efd645faa1cda38dffc1768cb5cac9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 88,
                        "hold": 11,
                        "slide": 2,
                        "touch": null,
                        "break": 5,
                        "total": 106
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 22,
                        "slide": 8,
                        "touch": null,
                        "break": 7,
                        "total": 191
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 19,
                        "slide": 10,
                        "touch": null,
                        "break": 4,
                        "total": 323
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 224,
                        "hold": 0,
                        "slide": 99,
                        "touch": null,
                        "break": 7,
                        "total": 330
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "GO MY WAY!!",
            "category": "ゲーム＆バラエティ",
            "title": "GO MY WAY!!",
            "artist": "ナムコエンジェル「アイドルマスター」",
            "bpm": 180,
            "imageName": "8901f1235693ab75e9508904143ab6a404c16e3e705c20d4ebc7126c82484937",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 83,
                        "hold": 22,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 112
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 5,
                        "slide": 29,
                        "touch": null,
                        "break": 3,
                        "total": 206
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 28,
                        "slide": 41,
                        "touch": null,
                        "break": 13,
                        "total": 315
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 469,
                        "hold": 10,
                        "slide": 90,
                        "touch": null,
                        "break": 8,
                        "total": 577
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "THE IDOLM@STER 2nd-mix",
            "category": "ゲーム＆バラエティ",
            "title": "THE IDOLM@STER 2nd-mix",
            "artist": "ナムコエンジェル「アイドルマスター」",
            "bpm": 168,
            "imageName": "a0530a5906f846613eb2d40b6b3786c22c5739d6d6c1d6b8c207eec7d7ca11d7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 129,
                        "hold": 10,
                        "slide": 9,
                        "touch": null,
                        "break": 2,
                        "total": 150
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 332,
                        "hold": 12,
                        "slide": 15,
                        "touch": null,
                        "break": 5,
                        "total": 364
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 473,
                        "hold": 6,
                        "slide": 24,
                        "touch": null,
                        "break": 86,
                        "total": 589
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 407,
                        "hold": 20,
                        "slide": 85,
                        "touch": null,
                        "break": 8,
                        "total": 520
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "The world is all one !!",
            "category": "ゲーム＆バラエティ",
            "title": "The world is all one !!",
            "artist": "ナムコエンジェル「アイドルマスター」",
            "bpm": 167,
            "imageName": "736ad5fd57949f8ce59d7896250ca997c17745105a6ffe5a40b2beabb4f71784",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 92,
                        "hold": 19,
                        "slide": 7,
                        "touch": null,
                        "break": 3,
                        "total": 121
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 150,
                        "hold": 10,
                        "slide": 15,
                        "touch": null,
                        "break": 6,
                        "total": 181
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "maimai",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 6,
                        "slide": 43,
                        "touch": null,
                        "break": 13,
                        "total": 337
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 26,
                        "slide": 60,
                        "touch": null,
                        "break": 19,
                        "total": 449
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Get Off of My Way",
            "category": "POPS＆アニメ",
            "title": "Get Off of My Way",
            "artist": "MAN WITH A MISSION［PV］",
            "bpm": 135,
            "imageName": "ecf349ef6249e7b0da4bf37cfad29c20ce5288097f59b6b372722c8a0e70615c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 10,
                        "slide": 6,
                        "touch": null,
                        "break": 6,
                        "total": 198
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 225,
                        "hold": 27,
                        "slide": 11,
                        "touch": null,
                        "break": 7,
                        "total": 270
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 465,
                        "hold": 21,
                        "slide": 8,
                        "touch": null,
                        "break": 18,
                        "total": 512
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 645,
                        "hold": 0,
                        "slide": 24,
                        "touch": null,
                        "break": 9,
                        "total": 678
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2012-12-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "おいでよ！妖精の森",
            "category": "POPS＆アニメ",
            "title": "おいでよ！妖精の森",
            "artist": "「gdgd妖精s」",
            "bpm": 220,
            "imageName": "91283dcae02b87b356a90b56cd77c147014d290c995c6a1f16395945f4229efe",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 12,
                        "slide": 5,
                        "touch": null,
                        "break": 5,
                        "total": 149
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 18,
                        "slide": 12,
                        "touch": null,
                        "break": 2,
                        "total": 271
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 324,
                        "hold": 29,
                        "slide": 15,
                        "touch": null,
                        "break": 12,
                        "total": 380
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 417,
                        "hold": 8,
                        "slide": 105,
                        "touch": null,
                        "break": 52,
                        "total": 582
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "みかんのうた",
            "category": "POPS＆アニメ",
            "title": "みかんのうた",
            "artist": "SEX MACHINEGUNS［cover］",
            "bpm": 288,
            "imageName": "b47b85320c136011ef53157f9b8e90bbe77d4a6530ffb21ce28150b827094bb7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 143,
                        "hold": 18,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 169
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 327,
                        "hold": 4,
                        "slide": 7,
                        "touch": null,
                        "break": 16,
                        "total": 354
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 387,
                        "hold": 24,
                        "slide": 16,
                        "touch": null,
                        "break": 76,
                        "total": 503
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 571,
                        "hold": 4,
                        "slide": 106,
                        "touch": null,
                        "break": 68,
                        "total": 749
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ファミリーパーティー",
            "category": "POPS＆アニメ",
            "title": "ファミリーパーティー",
            "artist": "きゃりーぱみゅぱみゅ［PV］",
            "bpm": 142,
            "imageName": "e72bbfe0ed3fa30bd70189787cea4f005a68682cc7612ec8fee62a43b288f2d9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 13,
                        "slide": 3,
                        "touch": null,
                        "break": 5,
                        "total": 156
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 27,
                        "slide": 8,
                        "touch": null,
                        "break": 1,
                        "total": 266
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 29,
                        "slide": 14,
                        "touch": null,
                        "break": 5,
                        "total": 247
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 371,
                        "hold": 13,
                        "slide": 68,
                        "touch": null,
                        "break": 8,
                        "total": 460
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "恋愛サーキュレーション",
            "category": "POPS＆アニメ",
            "title": "恋愛サーキュレーション",
            "artist": "「化物語」［cover］",
            "bpm": 120,
            "imageName": "faccea64b481927b0054b7cbb32cc5833aece4dd583be21394ce78a47ad0a9a2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 8,
                        "slide": 2,
                        "touch": null,
                        "break": 2,
                        "total": 154
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 149,
                        "hold": 24,
                        "slide": 7,
                        "touch": null,
                        "break": 4,
                        "total": 184
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 28,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 234
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 26,
                        "slide": 10,
                        "touch": null,
                        "break": 13,
                        "total": 324
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Can Do",
            "category": "POPS＆アニメ",
            "title": "Can Do",
            "artist": "GRANRODEO[PV]",
            "bpm": 200,
            "imageName": "07efedcb40d494ac2678b09bbc4cc4ac7269630feb58157fb1f549871084ce21",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 6,
                        "slide": 3,
                        "touch": null,
                        "break": 7,
                        "total": 151
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-04-16"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 9,
                        "slide": 5,
                        "touch": null,
                        "break": 12,
                        "total": 299
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-04-16"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 368,
                        "hold": 14,
                        "slide": 19,
                        "touch": null,
                        "break": 22,
                        "total": 423
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-04-16"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 446,
                        "hold": 37,
                        "slide": 64,
                        "touch": null,
                        "break": 34,
                        "total": 581
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-04-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "The Other self",
            "category": "POPS＆アニメ",
            "title": "The Other self",
            "artist": "GRANRODEO[PV]",
            "bpm": 150,
            "imageName": "b46c67495a1bc7ce34e79c9e44f568abf0330c5b39866c6c7fdf6be68d5c4f75",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 100,
                        "hold": 8,
                        "slide": 2,
                        "touch": null,
                        "break": 2,
                        "total": 112
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-10-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 224,
                        "hold": 6,
                        "slide": 15,
                        "touch": null,
                        "break": 8,
                        "total": 253
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-10-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 63,
                        "slide": 16,
                        "touch": null,
                        "break": 16,
                        "total": 380
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-10-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 33,
                        "slide": 51,
                        "touch": null,
                        "break": 31,
                        "total": 490
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-10-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "カノン",
            "category": "POPS＆アニメ",
            "title": "カノン",
            "artist": "宮野真守[PV]",
            "bpm": 208,
            "imageName": "17af36e875f826b6ed3324db841a59b28635fe427e1470d973d8740c46a9edb5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 4,
                        "slide": 2,
                        "touch": null,
                        "break": 6,
                        "total": 149
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-10-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 14,
                        "slide": 16,
                        "touch": null,
                        "break": 7,
                        "total": 294
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-10-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 31,
                        "slide": 32,
                        "touch": null,
                        "break": 10,
                        "total": 408
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-10-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 426,
                        "hold": 22,
                        "slide": 69,
                        "touch": null,
                        "break": 8,
                        "total": 525
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-10-08"
                }
            ],
            "searchAcronyms": [
                "Kanon"
            ]
        },
        {
            "songId": "オルフェ",
            "category": "POPS＆アニメ",
            "title": "オルフェ",
            "artist": "宮野真守[PV]",
            "bpm": 184,
            "imageName": "daca194ccb993634e9ca138343bd8aade456ff9927ffb3b951e08522bbe17b5c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 17,
                        "slide": 7,
                        "touch": null,
                        "break": 5,
                        "total": 138
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-04-16"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 24,
                        "slide": 16,
                        "touch": null,
                        "break": 4,
                        "total": 302
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-04-16"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 319,
                        "hold": 50,
                        "slide": 15,
                        "touch": null,
                        "break": 18,
                        "total": 402
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-04-16"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 36,
                        "slide": 77,
                        "touch": null,
                        "break": 9,
                        "total": 427
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-04-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ヘタリアン☆ジェット",
            "category": "POPS＆アニメ",
            "title": "ヘタリアン☆ジェット",
            "artist": "イタリア (CV.浪川大輔)「ヘタリア The World Twinkle」",
            "bpm": 132,
            "imageName": "41de1791235ef0205cef10d642b9cd195bbe0c985f5b49a745061fa12650c3cc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 136,
                        "hold": 10,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 158
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-10-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 159,
                        "hold": 6,
                        "slide": 19,
                        "touch": null,
                        "break": 6,
                        "total": 190
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-10-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 289,
                        "hold": 26,
                        "slide": 36,
                        "touch": null,
                        "break": 20,
                        "total": 371
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-10-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 60,
                        "slide": 59,
                        "touch": null,
                        "break": 4,
                        "total": 364
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-10-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ココロオドル",
            "category": "POPS＆アニメ",
            "title": "ココロオドル",
            "artist": "nobodyknows+［cover］",
            "bpm": 226,
            "imageName": "0997c6bd146923bd4a0422d506b22f0a191a4ecf53a44c23f202a468494ace92",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 159,
                        "hold": 5,
                        "slide": 2,
                        "touch": null,
                        "break": 5,
                        "total": 171
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 316,
                        "hold": 4,
                        "slide": 12,
                        "touch": null,
                        "break": 8,
                        "total": 340
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 246,
                        "hold": 78,
                        "slide": 30,
                        "touch": null,
                        "break": 69,
                        "total": 423
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 463,
                        "hold": 9,
                        "slide": 110,
                        "touch": null,
                        "break": 100,
                        "total": 682
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-07-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "naraku within",
            "category": "POPS＆アニメ",
            "title": "naraku within",
            "artist": "藤澤健至（Team-MAX）「ニンジャスレイヤー」",
            "bpm": 130,
            "imageName": "32699e67c9934f2d7ec44e3c35f736646dd77286bc4367c654672b9aac5396e9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 150
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 294,
                        "hold": 16,
                        "slide": 16,
                        "touch": null,
                        "break": 8,
                        "total": 334
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 40,
                        "slide": 14,
                        "touch": null,
                        "break": 8,
                        "total": 426
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 421,
                        "hold": 31,
                        "slide": 64,
                        "touch": null,
                        "break": 30,
                        "total": 546
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-12-04"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ほとんど違法行為",
            "category": "POPS＆アニメ",
            "title": "ほとんど違法行為",
            "artist": "ネコネコカワイイ「ニンジャスレイヤー」",
            "bpm": 128,
            "imageName": "12ca696704114f46b0e556a3eeff66dc83410fd0dbfe55478d0880814f5695cb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 111,
                        "hold": 6,
                        "slide": 3,
                        "touch": null,
                        "break": 5,
                        "total": 125
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 327,
                        "hold": 8,
                        "slide": 5,
                        "touch": null,
                        "break": 6,
                        "total": 346
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 259,
                        "hold": 23,
                        "slide": 57,
                        "touch": null,
                        "break": 12,
                        "total": 351
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 27,
                        "slide": 56,
                        "touch": null,
                        "break": 19,
                        "total": 424
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "releaseDate": "2014-12-04"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "シリウス",
            "category": "POPS＆アニメ",
            "title": "シリウス",
            "artist": "藍井エイル「キルラキル」[アニメPV]",
            "bpm": 176,
            "imageName": "29d3603cd030b111e21a648ca2b1755b72188841a82a3780e5f5ad7970db0ee3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 111,
                        "hold": 6,
                        "slide": 5,
                        "touch": null,
                        "break": 4,
                        "total": 126
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 13,
                        "slide": 18,
                        "touch": null,
                        "break": 6,
                        "total": 212
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 298,
                        "hold": 20,
                        "slide": 26,
                        "touch": null,
                        "break": 9,
                        "total": 353
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 331,
                        "hold": 18,
                        "slide": 43,
                        "touch": null,
                        "break": 11,
                        "total": 403
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "青春はNon-Stop！",
            "category": "POPS＆アニメ",
            "title": "青春はNon-Stop！",
            "artist": "プラズマジカ「SHOW BY ROCK!!」",
            "bpm": 172,
            "imageName": "0469e9bc070bd80d31ee358e08eee9dc159eced9886d7dd863dd8146c233d49b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 9,
                        "slide": 1,
                        "touch": null,
                        "break": 6,
                        "total": 154
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-03-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 19,
                        "slide": 10,
                        "touch": null,
                        "break": 18,
                        "total": 280
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-03-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 321,
                        "hold": 28,
                        "slide": 28,
                        "touch": null,
                        "break": 24,
                        "total": 401
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-03-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 499,
                        "hold": 32,
                        "slide": 75,
                        "touch": null,
                        "break": 39,
                        "total": 645
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-03-03"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Falling Roses",
            "category": "POPS＆アニメ",
            "title": "Falling Roses",
            "artist": "シンガンクリムゾンズ「SHOW BY ROCK!!」",
            "bpm": 200,
            "imageName": "1ca4d73a2416b4c2dde2b8a4f81cd40ce1fd081fdf3883fa9d9b4cb766ca0d1d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 136,
                        "hold": 5,
                        "slide": 6,
                        "touch": null,
                        "break": 3,
                        "total": 150
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-03-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 283,
                        "hold": 14,
                        "slide": 15,
                        "touch": null,
                        "break": 12,
                        "total": 324
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-03-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 323,
                        "hold": 57,
                        "slide": 38,
                        "touch": null,
                        "break": 4,
                        "total": 422
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-03-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 484,
                        "hold": 20,
                        "slide": 53,
                        "touch": null,
                        "break": 35,
                        "total": 592
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-03-03"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ようかい体操第一",
            "category": "POPS＆アニメ",
            "title": "ようかい体操第一",
            "artist": "Dream5「妖怪ウォッチ」",
            "bpm": 125,
            "imageName": "e0bf3fe7b34029502fcb5daefca0e4d72a4dbb6e9ade114804d849aeb0617e2a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 64,
                        "hold": 14,
                        "slide": 2,
                        "touch": null,
                        "break": 3,
                        "total": 83
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-08-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 12,
                        "slide": 8,
                        "touch": null,
                        "break": 2,
                        "total": 194
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-08-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 207,
                        "hold": 29,
                        "slide": 4,
                        "touch": null,
                        "break": 6,
                        "total": 246
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-08-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 211,
                        "hold": 19,
                        "slide": 55,
                        "touch": null,
                        "break": 8,
                        "total": 293
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-08-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ゲラゲラポーのうた",
            "category": "POPS＆アニメ",
            "title": "ゲラゲラポーのうた",
            "artist": "キング・クリームソーダ「妖怪ウォッチ」",
            "bpm": 120,
            "imageName": "1f2081a48f767e69ad1b6878bba0915cb542ca3163e5a12e532a373783e749ad",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 102,
                        "hold": 10,
                        "slide": 2,
                        "touch": null,
                        "break": 6,
                        "total": 120
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 12,
                        "slide": 3,
                        "touch": null,
                        "break": 4,
                        "total": 181
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 177,
                        "hold": 24,
                        "slide": 5,
                        "touch": null,
                        "break": 28,
                        "total": 234
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 27,
                        "slide": 57,
                        "touch": null,
                        "break": 10,
                        "total": 369
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Scatman (Ski Ba Bop Ba Dop Bop)",
            "category": "POPS＆アニメ",
            "title": "Scatman (Ski Ba Bop Ba Dop Bop)",
            "artist": "Scatman John",
            "bpm": 136,
            "imageName": "050e68d0e471e7ddf06b992428a56513e60648f3e00a3ad0aa48c7948c1c643c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 4,
                        "slide": 2,
                        "touch": null,
                        "break": 4,
                        "total": 164
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-10-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 10,
                        "slide": 6,
                        "touch": null,
                        "break": 8,
                        "total": 212
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-10-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 380,
                        "hold": 52,
                        "slide": 16,
                        "touch": null,
                        "break": 23,
                        "total": 471
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-10-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 572,
                        "hold": 25,
                        "slide": 48,
                        "touch": null,
                        "break": 20,
                        "total": 665
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-10-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "でんでんぱっしょん",
            "category": "POPS＆アニメ",
            "title": "でんでんぱっしょん",
            "artist": "でんぱ組.inc",
            "bpm": 186,
            "imageName": "1c2bb9adffb4fd5ce305ea01399962803adaccac949a0cd5d1152f2bf5f10eba",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 88,
                        "hold": 19,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 115
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 260,
                        "hold": 8,
                        "slide": 4,
                        "touch": null,
                        "break": 8,
                        "total": 280
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 265,
                        "hold": 18,
                        "slide": 47,
                        "touch": null,
                        "break": 10,
                        "total": 340
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 38,
                        "slide": 71,
                        "touch": null,
                        "break": 37,
                        "total": 488
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Dragon Night",
            "category": "POPS＆アニメ",
            "title": "Dragon Night",
            "artist": "SEKAI NO OWARI",
            "bpm": 124,
            "imageName": "4e70c1292ef54fca06293cee764b465c7924ea211c98b775eee603e710792c3b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 147,
                        "hold": 3,
                        "slide": 5,
                        "touch": null,
                        "break": 1,
                        "total": 156
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 11,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 281
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 260,
                        "hold": 14,
                        "slide": 34,
                        "touch": null,
                        "break": 15,
                        "total": 323
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 459,
                        "hold": 104,
                        "slide": 29,
                        "touch": null,
                        "break": 17,
                        "total": 609
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Luminize",
            "category": "POPS＆アニメ",
            "title": "Luminize",
            "artist": "fripSide「フューチャーカード バディファイト ハンドレッド」",
            "bpm": 140,
            "imageName": "1f01b6e9996e0c03fb24548ed03fbad3768cf01d7654e9da7b74adb027008d97",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 118,
                        "hold": 8,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 134
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-01-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 204,
                        "hold": 11,
                        "slide": 13,
                        "touch": null,
                        "break": 10,
                        "total": 238
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-01-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 201,
                        "hold": 34,
                        "slide": 24,
                        "touch": null,
                        "break": 22,
                        "total": 281
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-01-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 30,
                        "slide": 26,
                        "touch": null,
                        "break": 29,
                        "total": 421
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-01-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "秘密の扉から会いにきて",
            "category": "POPS＆アニメ",
            "title": "秘密の扉から会いにきて",
            "artist": "田村ゆかり「のうりん」",
            "bpm": 184,
            "imageName": "d11f762012ecf84b9b2f83cf4b899f39338362ab0c1a648d4a2a054f8092ec83",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 91,
                        "hold": 14,
                        "slide": 5,
                        "touch": null,
                        "break": 4,
                        "total": 114
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-01-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 210,
                        "hold": 16,
                        "slide": 3,
                        "touch": null,
                        "break": 11,
                        "total": 240
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-01-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 10,
                        "slide": 18,
                        "touch": null,
                        "break": 29,
                        "total": 347
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-01-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 265,
                        "hold": 42,
                        "slide": 120,
                        "touch": null,
                        "break": 21,
                        "total": 448
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-01-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Touch Tap Baby",
            "category": "POPS＆アニメ",
            "title": "Touch Tap Baby",
            "artist": "ハッカドール",
            "bpm": 162,
            "imageName": "08e844d6e8db2ce0910298ad20bdff1e6623be4f810b1c85176b366b84254fac",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 5,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 115
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 253,
                        "hold": 9,
                        "slide": 14,
                        "touch": null,
                        "break": 6,
                        "total": 282
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 28,
                        "slide": 26,
                        "touch": null,
                        "break": 18,
                        "total": 329
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 326,
                        "hold": 14,
                        "slide": 43,
                        "touch": null,
                        "break": 20,
                        "total": 403
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "イチズレシピ",
            "category": "POPS＆アニメ",
            "title": "イチズレシピ",
            "artist": "アイドルカレッジ「俺がお嬢様学校に「庶民サンプル」としてゲッツされた件」",
            "bpm": 170,
            "imageName": "840e9f6e7db510d1c884263af90bd8d8bb59afe9a90ba3c79dc993c0e232a5bc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 131,
                        "hold": 9,
                        "slide": 4,
                        "touch": null,
                        "break": 6,
                        "total": 150
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-07-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 14,
                        "slide": 9,
                        "touch": null,
                        "break": 8,
                        "total": 265
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-07-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 268,
                        "hold": 55,
                        "slide": 23,
                        "touch": null,
                        "break": 9,
                        "total": 355
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-07-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 24,
                        "slide": 90,
                        "touch": null,
                        "break": 32,
                        "total": 503
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-07-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ふ・れ・ん・ど・し・た・い",
            "category": "POPS＆アニメ",
            "title": "ふ・れ・ん・ど・し・た・い",
            "artist": "学園生活部「がっこうぐらし！」",
            "bpm": 148,
            "imageName": "ff17f4c123b4407923cd73ae323baf787da3110fe8263b260257d200945b5c48",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 10,
                        "slide": 2,
                        "touch": null,
                        "break": 8,
                        "total": 174
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-07-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 32,
                        "slide": 14,
                        "touch": null,
                        "break": 5,
                        "total": 240
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-07-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 245,
                        "hold": 60,
                        "slide": 16,
                        "touch": null,
                        "break": 18,
                        "total": 339
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-07-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 418,
                        "hold": 6,
                        "slide": 50,
                        "touch": null,
                        "break": 22,
                        "total": 496
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-07-14"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 393,
                        "hold": 5,
                        "slide": 89,
                        "touch": null,
                        "break": 23,
                        "total": 510
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-07-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "未来(ソラ)の歌",
            "category": "POPS＆アニメ",
            "title": "未来(ソラ)の歌",
            "artist": "Questy「ポッピンQ」",
            "bpm": 153,
            "imageName": "fbe6f6108d7c6984bb4abfc10c4233d979bf833e7f9fef8736f5283827eeed65",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 4,
                        "slide": 9,
                        "touch": null,
                        "break": 6,
                        "total": 156
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-11-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 208,
                        "hold": 15,
                        "slide": 12,
                        "touch": null,
                        "break": 12,
                        "total": 247
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-11-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 253,
                        "hold": 33,
                        "slide": 32,
                        "touch": null,
                        "break": 8,
                        "total": 326
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-11-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 384,
                        "hold": 27,
                        "slide": 81,
                        "touch": null,
                        "break": 26,
                        "total": 518
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-11-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ひみつをちょーだい",
            "category": "niconico＆ボーカロイド",
            "title": "ひみつをちょーだい",
            "artist": "アルスマグナ",
            "bpm": 160,
            "imageName": "edacaf22f4f2b878e1451eaee8747c918ce3fe38578408b3de44293424270965",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 97,
                        "hold": 33,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 138
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 24,
                        "slide": 3,
                        "touch": null,
                        "break": 3,
                        "total": 262
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 28,
                        "slide": 26,
                        "touch": null,
                        "break": 12,
                        "total": 372
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 42,
                        "slide": 65,
                        "touch": null,
                        "break": 24,
                        "total": 423
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "夏にキスしていいですか？",
            "category": "niconico＆ボーカロイド",
            "title": "夏にキスしていいですか？",
            "artist": "アルスマグナ",
            "bpm": 160,
            "imageName": "eb0c54b3d2a26bf5fb82001a489bc605fac8bab5b99c085278c2db1453be67a3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 274,
                        "hold": 8,
                        "slide": 10,
                        "touch": null,
                        "break": 3,
                        "total": 295
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 24,
                        "slide": 16,
                        "touch": null,
                        "break": 6,
                        "total": 357
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 435,
                        "hold": 29,
                        "slide": 44,
                        "touch": null,
                        "break": 16,
                        "total": 524
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 438,
                        "hold": 59,
                        "slide": 130,
                        "touch": null,
                        "break": 18,
                        "total": 645
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "PERFECT HUMAN",
            "category": "POPS＆アニメ",
            "title": "PERFECT HUMAN",
            "artist": "RADIO FISH",
            "bpm": 128,
            "imageName": "35aee2223a46174858a31bc4acb6444ba6d1b03d0acde7fadb64e246c5ad928e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 123,
                        "hold": 8,
                        "slide": 2,
                        "touch": null,
                        "break": 5,
                        "total": 138
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 164,
                        "hold": 32,
                        "slide": 8,
                        "touch": null,
                        "break": 12,
                        "total": 216
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "畳返し",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 95,
                        "slide": 8,
                        "touch": null,
                        "break": 16,
                        "total": 331
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 397,
                        "hold": 58,
                        "slide": 30,
                        "touch": null,
                        "break": 38,
                        "total": 523
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2016-12-15"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "SUSHI食べたい feat.ソイソース",
            "category": "POPS＆アニメ",
            "title": "SUSHI食べたい feat.ソイソース",
            "artist": "ORANGE RANGE",
            "bpm": 135,
            "imageName": "a2fcdbd7be3416cbefddfec907405abcb131d4ea97782a8c0785ff2a2b934c85",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 191,
                        "hold": 10,
                        "slide": 4,
                        "touch": null,
                        "break": 6,
                        "total": 211
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-03-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 304,
                        "hold": 28,
                        "slide": 18,
                        "touch": null,
                        "break": 8,
                        "total": 358
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-03-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 265,
                        "hold": 149,
                        "slide": 38,
                        "touch": null,
                        "break": 11,
                        "total": 463
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-03-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 551,
                        "hold": 72,
                        "slide": 92,
                        "touch": null,
                        "break": 19,
                        "total": 734
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-03-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "7 Girls War",
            "category": "POPS＆アニメ",
            "title": "7 Girls War",
            "artist": "Wake Up, Girls！",
            "bpm": 180,
            "imageName": "0325339789a0168d9e50ae830a883685bcf7dbc712e2b870a0b0539536d22394",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 114,
                        "hold": 12,
                        "slide": 6,
                        "touch": null,
                        "break": 5,
                        "total": 137
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-03-23"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 222,
                        "hold": 22,
                        "slide": 23,
                        "touch": null,
                        "break": 4,
                        "total": 271
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-03-23"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 27,
                        "slide": 36,
                        "touch": null,
                        "break": 10,
                        "total": 365
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-03-23"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 35,
                        "slide": 58,
                        "touch": null,
                        "break": 20,
                        "total": 395
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-03-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Jumping!!",
            "category": "POPS＆アニメ",
            "title": "Jumping!!",
            "artist": "Rhodanthe*",
            "bpm": 175,
            "imageName": "3ce4bb0f522925acb974fc69a6ffbf696fe72ad3a25e2a27d4475ab68b54d998",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 10,
                        "slide": 3,
                        "touch": null,
                        "break": 8,
                        "total": 148
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-03-23"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 12,
                        "slide": 8,
                        "touch": null,
                        "break": 10,
                        "total": 312
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-03-23"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 42,
                        "slide": 18,
                        "touch": null,
                        "break": 19,
                        "total": 363
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-03-23"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 18,
                        "slide": 80,
                        "touch": null,
                        "break": 8,
                        "total": 451
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-03-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ゆりゆららららゆるゆり大事件",
            "category": "POPS＆アニメ",
            "title": "ゆりゆららららゆるゆり大事件",
            "artist": "七森中☆ごらく部「ゆるゆり」",
            "bpm": 175,
            "imageName": "4d36bbf2625402598871193af79581a13b026a769d5e786e402f181bf6e2d672",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 122,
                        "hold": 17,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 148
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 235,
                        "hold": 7,
                        "slide": 20,
                        "touch": null,
                        "break": 6,
                        "total": 268
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 296,
                        "hold": 31,
                        "slide": 27,
                        "touch": null,
                        "break": 11,
                        "total": 365
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 9,
                        "slide": 93,
                        "touch": null,
                        "break": 30,
                        "total": 470
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2016-12-15"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "いぇす！ゆゆゆ☆ゆるゆり♪♪",
            "category": "POPS＆アニメ",
            "title": "いぇす！ゆゆゆ☆ゆるゆり♪♪",
            "artist": "七森中☆ごらく部「ゆるゆり♪♪」",
            "bpm": 182,
            "imageName": "b0513d487e272e2875f84266ef215e6499011fcfd4825541e3b1179b49c907d2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 14,
                        "slide": 2,
                        "touch": null,
                        "break": 5,
                        "total": 162
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-01-10"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 266,
                        "hold": 14,
                        "slide": 10,
                        "touch": null,
                        "break": 6,
                        "total": 296
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-01-10"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "如月 ゆかり",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 26,
                        "slide": 30,
                        "touch": null,
                        "break": 20,
                        "total": 394
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-01-10"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 24,
                        "slide": 102,
                        "touch": null,
                        "break": 49,
                        "total": 539
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-01-10"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ちょちょちょ！ゆるゆり☆かぷりっちょ！！！",
            "category": "POPS＆アニメ",
            "title": "ちょちょちょ！ゆるゆり☆かぷりっちょ！！！",
            "artist": "七森中☆ごらく部「ゆるゆり さん☆ハイ！」",
            "bpm": 190,
            "imageName": "3790e0b1443055da659bf7225b548de38accf569c3628d825b93566ba0f715f0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 8,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 157
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-01-10"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 279,
                        "hold": 11,
                        "slide": 13,
                        "touch": null,
                        "break": 6,
                        "total": 309
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-01-10"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 340,
                        "hold": 37,
                        "slide": 20,
                        "touch": null,
                        "break": 25,
                        "total": 422
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-01-10"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 424,
                        "hold": 8,
                        "slide": 100,
                        "touch": null,
                        "break": 43,
                        "total": 575
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-01-10"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "H-A-J-I-M-A-R-I-U-T-A-!!",
            "category": "ゲーム＆バラエティ",
            "title": "H-A-J-I-M-A-R-I-U-T-A-!!",
            "artist": "777☆SISTERS",
            "bpm": 140,
            "imageName": "3be72487792ba508642b30300d47dabaa732ebb94b7512ae8809e9e4dad388f4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 133,
                        "hold": 5,
                        "slide": 4,
                        "touch": null,
                        "break": 8,
                        "total": 150
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-04-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 12,
                        "slide": 17,
                        "touch": null,
                        "break": 7,
                        "total": 266
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-04-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 46,
                        "slide": 53,
                        "touch": null,
                        "break": 8,
                        "total": 369
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-04-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 422,
                        "hold": 18,
                        "slide": 109,
                        "touch": null,
                        "break": 38,
                        "total": 587
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-04-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Star☆Glitter",
            "category": "ゲーム＆バラエティ",
            "title": "Star☆Glitter",
            "artist": "セブンスシスターズ",
            "bpm": 171,
            "imageName": "8f25304981c1da882ce6fba709b2c95f10780050e90914679a6c4d83caa1c058",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 130,
                        "hold": 20,
                        "slide": 6,
                        "touch": null,
                        "break": 8,
                        "total": 164
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-04-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 266,
                        "hold": 22,
                        "slide": 19,
                        "touch": null,
                        "break": 5,
                        "total": 312
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-04-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 31,
                        "slide": 36,
                        "touch": null,
                        "break": 7,
                        "total": 423
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-04-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 462,
                        "hold": 16,
                        "slide": 109,
                        "touch": null,
                        "break": 18,
                        "total": 605
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "releaseDate": "2017-04-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "紅蓮の弓矢",
            "category": "POPS＆アニメ",
            "title": "紅蓮の弓矢",
            "artist": "Linked Horizon 「進撃の巨人」[アニメPV]",
            "bpm": 180,
            "imageName": "36fca6fc47309a005c4a4cc81928695b95c32f0e491355caebb7e3e32d33d4af",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 155,
                        "hold": 10,
                        "slide": 4,
                        "touch": null,
                        "break": 6,
                        "total": 175
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 336,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 18,
                        "slide": 11,
                        "touch": null,
                        "break": 14,
                        "total": 280
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 336,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 314,
                        "hold": 30,
                        "slide": 77,
                        "touch": null,
                        "break": 5,
                        "total": 426
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 336,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 325,
                        "hold": 21,
                        "slide": 74,
                        "touch": null,
                        "break": 31,
                        "total": 451
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 336,
                    "version": "GreeN PLUS",
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "SAKURAスキップ",
            "category": "POPS＆アニメ",
            "title": "SAKURAスキップ",
            "artist": "fourfolium 「NEW GAME!」",
            "bpm": 165,
            "imageName": "42a438ff59c50f6f6830dd6c8df5c4846e0dfe0a4635be0c30e85fbfe7f0f328",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 116,
                        "hold": 7,
                        "slide": 6,
                        "touch": null,
                        "break": 6,
                        "total": 135
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 609,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 224,
                        "hold": 14,
                        "slide": 9,
                        "touch": null,
                        "break": 4,
                        "total": 251
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 609,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 35,
                        "slide": 29,
                        "touch": null,
                        "break": 18,
                        "total": 338
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 609,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 347,
                        "hold": 10,
                        "slide": 103,
                        "touch": null,
                        "break": 32,
                        "total": 492
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 609,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-06-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Now Loading!!!!",
            "category": "POPS＆アニメ",
            "title": "Now Loading!!!!",
            "artist": "fourfolium 「NEW GAME!」",
            "bpm": 193,
            "imageName": "3be2a96c45a9774adba0c50e924ff7fbc1fc913bfa5e1239e9c110f7df4280ff",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 120,
                        "hold": 11,
                        "slide": 5,
                        "touch": null,
                        "break": 4,
                        "total": 140
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 653,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 208,
                        "hold": 25,
                        "slide": 14,
                        "touch": null,
                        "break": 3,
                        "total": 250
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 653,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 259,
                        "hold": 41,
                        "slide": 37,
                        "touch": null,
                        "break": 12,
                        "total": 349
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 653,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 326,
                        "hold": 21,
                        "slide": 106,
                        "touch": null,
                        "break": 8,
                        "total": 461
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 653,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-07-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ホシトハナ",
            "category": "POPS＆アニメ",
            "title": "ホシトハナ",
            "artist": "讃州中学勇者部 「結城友奈は勇者である」",
            "bpm": 158,
            "imageName": "eeae835646dafffa0cef076faaaf75d5dba14eb99818682b4378cff0a1a60de3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 76,
                        "hold": 11,
                        "slide": 2,
                        "touch": null,
                        "break": 6,
                        "total": 95
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 645,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-11-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 25,
                        "slide": 17,
                        "touch": null,
                        "break": 2,
                        "total": 181
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 645,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-11-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 191,
                        "hold": 19,
                        "slide": 30,
                        "touch": null,
                        "break": 8,
                        "total": 248
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 645,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-11-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 245,
                        "hold": 45,
                        "slide": 49,
                        "touch": null,
                        "break": 12,
                        "total": 351
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 645,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-11-09"
                }
            ],
            "searchAcronyms": [
                "Hoshi to Hana"
            ]
        },
        {
            "songId": "Stand Up!!!!",
            "category": "POPS＆アニメ",
            "title": "Stand Up!!!!",
            "artist": "鈴木結愛(CV:西 明日香)/佐藤陽菜(CV:明坂聡美)/高橋 葵(CV:荻野可鈴)/田中心春(CV:大橋彩香)/「てさぐれ！部活もの」 [アニメPV]",
            "bpm": 185,
            "imageName": "3f3f70e6f6e775c124be78d60ab9e37b627cb9dd6fd4b7bc745a2f4c90a0c93a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 11,
                        "slide": 15,
                        "touch": null,
                        "break": 7,
                        "total": 158
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 371,
                    "version": "ORANGE",
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 6,
                        "slide": 8,
                        "touch": null,
                        "break": 18,
                        "total": 266
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 371,
                    "version": "ORANGE",
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 314,
                        "hold": 18,
                        "slide": 42,
                        "touch": null,
                        "break": 26,
                        "total": 400
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 371,
                    "version": "ORANGE",
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 327,
                        "hold": 10,
                        "slide": 151,
                        "touch": null,
                        "break": 39,
                        "total": 527
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 371,
                    "version": "ORANGE",
                    "releaseDate": "2014-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ヤバい○○",
            "category": "POPS＆アニメ",
            "title": "ヤバい○○",
            "artist": "上坂すみれ",
            "bpm": 133,
            "imageName": "876bce52bf6b46a2a3ce058d0acd752e7c4fdadc83ca4fa7b762b2f7c573c76e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 124,
                        "hold": 4,
                        "slide": 9,
                        "touch": null,
                        "break": 8,
                        "total": 145
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 718,
                    "version": "MiLK",
                    "releaseDate": "2018-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 21,
                        "slide": 19,
                        "touch": null,
                        "break": 8,
                        "total": 237
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 718,
                    "version": "MiLK",
                    "releaseDate": "2018-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 34,
                        "slide": 53,
                        "touch": null,
                        "break": 31,
                        "total": 402
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 718,
                    "version": "MiLK",
                    "releaseDate": "2018-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 389,
                        "hold": 28,
                        "slide": 71,
                        "touch": null,
                        "break": 88,
                        "total": 576
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 718,
                    "version": "MiLK",
                    "releaseDate": "2018-02-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Pursuing My True Self",
            "category": "ゲーム＆バラエティ",
            "title": "Pursuing My True Self",
            "artist": "目黒 將司",
            "bpm": 119,
            "imageName": "769d4060428e8d1d632c8b4dc242d83d554f8fca4e920e368dc242b6e15276a0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 187,
                        "hold": 4,
                        "slide": 3,
                        "touch": null,
                        "break": 3,
                        "total": 197
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 441,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-08-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 354,
                        "hold": 8,
                        "slide": 18,
                        "touch": null,
                        "break": 12,
                        "total": 392
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 441,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-08-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 380,
                        "hold": 33,
                        "slide": 48,
                        "touch": null,
                        "break": 14,
                        "total": 475
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 441,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-08-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 547,
                        "hold": 40,
                        "slide": 92,
                        "touch": null,
                        "break": 6,
                        "total": 685
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 441,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-08-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Signs Of Love (“Never More” ver.)",
            "category": "ゲーム＆バラエティ",
            "title": "Signs Of Love (“Never More” ver.)",
            "artist": "目黒 将司",
            "bpm": 109,
            "imageName": "ff10b8dbb7bc1ae587fc4c280abf5983d1cb5d59b7e85d4addbd4b53b0eecf9e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 12,
                        "slide": 5,
                        "touch": null,
                        "break": 4,
                        "total": 159
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 442,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-08-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 29,
                        "slide": 6,
                        "touch": null,
                        "break": 6,
                        "total": 379
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 442,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-08-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 483,
                        "hold": 46,
                        "slide": 23,
                        "touch": null,
                        "break": 15,
                        "total": 567
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 442,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-08-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 567,
                        "hold": 31,
                        "slide": 35,
                        "touch": null,
                        "break": 23,
                        "total": 656
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 442,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-08-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "specialist (“Never More” ver.)",
            "category": "ゲーム＆バラエティ",
            "title": "specialist (“Never More” ver.)",
            "artist": "目黒 將司",
            "bpm": 128,
            "imageName": "ff38ab7354a7161f56c5670d5085fc851273ede8c2b4b4e6be15cccd3e5f3657",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 164,
                        "hold": 1,
                        "slide": 9,
                        "touch": null,
                        "break": 2,
                        "total": 176
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 443,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-08-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 29,
                        "slide": 22,
                        "touch": null,
                        "break": 1,
                        "total": 337
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 443,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-08-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 37,
                        "slide": 46,
                        "touch": null,
                        "break": 15,
                        "total": 500
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 443,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-08-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 473,
                        "hold": 63,
                        "slide": 67,
                        "touch": null,
                        "break": 8,
                        "total": 611
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 443,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-08-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Time To Make History (AKIRA YAMAOKA Remix)",
            "category": "ゲーム＆バラエティ",
            "title": "Time To Make History (AKIRA YAMAOKA Remix)",
            "artist": "目黒 將司 Remixed by 山岡 晃",
            "bpm": 190,
            "imageName": "b9d6987414c4ba0d1c2d89f32aaf6353091bcfa5c1368710668e701b53b16368",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 198,
                        "hold": 6,
                        "slide": 3,
                        "touch": null,
                        "break": 6,
                        "total": 213
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 444,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-08-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 32,
                        "slide": 15,
                        "touch": null,
                        "break": 6,
                        "total": 402
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 444,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-08-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 416,
                        "hold": 50,
                        "slide": 44,
                        "touch": null,
                        "break": 8,
                        "total": 518
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 444,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-08-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 667,
                        "hold": 31,
                        "slide": 142,
                        "touch": null,
                        "break": 4,
                        "total": 844
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 444,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-08-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "CALL HEAVEN!!",
            "category": "ゲーム＆バラエティ",
            "title": "CALL HEAVEN!!",
            "artist": "夢色キャスト",
            "bpm": 123,
            "imageName": "8bcf6e61a1e437503f18dbba444f8d2dc61cbcbb2113106371b863b516a5d9cf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 134,
                        "hold": 6,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 152
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 661,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 219,
                        "hold": 24,
                        "slide": 11,
                        "touch": null,
                        "break": 10,
                        "total": 264
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 661,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 242,
                        "hold": 55,
                        "slide": 61,
                        "touch": null,
                        "break": 14,
                        "total": 372
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 661,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 35,
                        "slide": 82,
                        "touch": null,
                        "break": 42,
                        "total": 481
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 661,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-09-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Sunshine world tour",
            "category": "ゲーム＆バラエティ",
            "title": "Sunshine world tour",
            "artist": "夢色キャスト",
            "bpm": 140,
            "imageName": "5bc7230fc5f71ec883fc881e88c6342f5be3a67f8bb7acd948ea313f3679c59d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 8,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 158
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 662,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 22,
                        "slide": 14,
                        "touch": null,
                        "break": 8,
                        "total": 256
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 662,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 312,
                        "hold": 43,
                        "slide": 41,
                        "touch": null,
                        "break": 10,
                        "total": 406
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 662,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 474,
                        "hold": 8,
                        "slide": 81,
                        "touch": null,
                        "break": 38,
                        "total": 601
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "internalId": 662,
                    "version": "MURASAKi PLUS",
                    "releaseDate": "2017-09-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "POP TEAM EPIC",
            "category": "POPS＆アニメ",
            "title": "POP TEAM EPIC",
            "artist": "上坂すみれ「ポプテピピック」",
            "bpm": 142,
            "imageName": "0b8ac38b37eeae60118d1d0eb600816d9d15c4bea88b660567c511f3cdd4c1e5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 68,
                        "hold": 7,
                        "slide": 3,
                        "touch": 8,
                        "break": 2,
                        "total": 88
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 124,
                        "hold": 18,
                        "slide": 7,
                        "touch": 16,
                        "break": 9,
                        "total": 174
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 144,
                        "hold": 42,
                        "slide": 28,
                        "touch": 80,
                        "break": 6,
                        "total": 300
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 168,
                        "hold": 37,
                        "slide": 58,
                        "touch": 222,
                        "break": 13,
                        "total": 498
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "multiverInternalLevelValue": {
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 112,
                        "hold": 4,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 123
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 11,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 224
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 228,
                        "hold": 60,
                        "slide": 19,
                        "touch": null,
                        "break": 7,
                        "total": 314
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 15,
                        "slide": 93,
                        "touch": null,
                        "break": 8,
                        "total": 383
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 480,
                        "hold": 37,
                        "slide": 89,
                        "touch": null,
                        "break": 24,
                        "total": 630
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "multiverInternalLevelValue": {
                        "Splash": 13.7,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2018-06-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "全力☆Summer!",
            "category": "POPS＆アニメ",
            "title": "全力☆Summer!",
            "artist": "angela「アホガール」",
            "bpm": 158,
            "imageName": "41b168c44066f1b33535d12d72800530fe5dcffc58db81d85792894e111c4152",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 24,
                        "slide": 9,
                        "touch": null,
                        "break": 2,
                        "total": 197
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 47,
                        "slide": 11,
                        "touch": null,
                        "break": 27,
                        "total": 341
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 409,
                        "hold": 57,
                        "slide": 17,
                        "touch": null,
                        "break": 4,
                        "total": 487
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 429,
                        "hold": 39,
                        "slide": 106,
                        "touch": null,
                        "break": 8,
                        "total": 582
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 425,
                        "hold": 22,
                        "slide": 131,
                        "touch": null,
                        "break": 85,
                        "total": 663
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "multiverInternalLevelValue": {
                        "Splash": 12
                    },
                    "releaseDate": "2018-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Arrival of Tears",
            "category": "POPS＆アニメ",
            "title": "Arrival of Tears",
            "artist": "彩音",
            "bpm": 200,
            "imageName": "7f44be998599d737bf73033c9c00138e99bb78fdfef9606ba8fc75dce82be750",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 122,
                        "hold": 6,
                        "slide": 7,
                        "touch": null,
                        "break": 2,
                        "total": 137
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 34,
                        "slide": 6,
                        "touch": null,
                        "break": 6,
                        "total": 293
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 332,
                        "hold": 33,
                        "slide": 44,
                        "touch": null,
                        "break": 31,
                        "total": 440
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 494,
                        "hold": 33,
                        "slide": 122,
                        "touch": null,
                        "break": 54,
                        "total": 703
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "multiverInternalLevelValue": {
                        "Splash": 12.7,
                        "maimaiでらっくす PLUS": 12.4
                    },
                    "releaseDate": "2018-09-04"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "にめんせい☆ウラオモテライフ！",
            "category": "POPS＆アニメ",
            "title": "にめんせい☆ウラオモテライフ！",
            "artist": "土間うまる（田中あいみ）「乾物妹！うまるちゃんR」",
            "bpm": 170,
            "imageName": "16012683b7c4758c5a70fc6a8e796034c44ae5a04d6600f409f14fcc51911563",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 98,
                        "hold": 4,
                        "slide": 5,
                        "touch": null,
                        "break": 6,
                        "total": 113
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-07-24"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 25,
                        "slide": 23,
                        "touch": null,
                        "break": 20,
                        "total": 271
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-07-24"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 255,
                        "hold": 48,
                        "slide": 30,
                        "touch": null,
                        "break": 45,
                        "total": 378
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-07-24"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 362,
                        "hold": 23,
                        "slide": 69,
                        "touch": null,
                        "break": 26,
                        "total": 480
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-07-24"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 324,
                        "hold": 38,
                        "slide": 72,
                        "touch": null,
                        "break": 59,
                        "total": 493
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-07-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "うまるん体操",
            "category": "POPS＆アニメ",
            "title": "うまるん体操",
            "artist": "妹Ｓ「乾物妹！うまるちゃんR」",
            "bpm": 170,
            "imageName": "13559cb816f01762e111ede3b22bc2ce2333e54766061ee072b05bc771b1f9dc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 108,
                        "hold": 8,
                        "slide": 5,
                        "touch": null,
                        "break": 3,
                        "total": 124
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 22,
                        "slide": 9,
                        "touch": null,
                        "break": 7,
                        "total": 234
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 42,
                        "slide": 9,
                        "touch": null,
                        "break": 12,
                        "total": 335
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 302,
                        "hold": 19,
                        "slide": 88,
                        "touch": null,
                        "break": 12,
                        "total": 421
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 7,
                        "slide": 116,
                        "touch": null,
                        "break": 25,
                        "total": 375
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "multiverInternalLevelValue": {
                        "Splash": 12.2
                    },
                    "releaseDate": "2018-06-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "夏祭り",
            "category": "POPS＆アニメ",
            "title": "夏祭り",
            "artist": "Jitterin' Jinn [covered by ろん]",
            "bpm": 141,
            "imageName": "2c22c37826b995607a181f87d9a079186e3e14b2883b8051be6af762e1eef36f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 136,
                        "hold": 5,
                        "slide": 10,
                        "touch": null,
                        "break": 2,
                        "total": 153
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-08-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 249,
                        "hold": 13,
                        "slide": 4,
                        "touch": null,
                        "break": 8,
                        "total": 274
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-08-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "如月 ゆかり",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 6,
                        "slide": 26,
                        "touch": null,
                        "break": 26,
                        "total": 433
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-08-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 517,
                        "hold": 30,
                        "slide": 59,
                        "touch": null,
                        "break": 20,
                        "total": 626
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-08-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "SAVIOR OF SONG",
            "category": "POPS＆アニメ",
            "title": "SAVIOR OF SONG",
            "artist": "ナノ feat.MY FIRST STORY",
            "bpm": 192,
            "imageName": "f41cac39eeda33f1bce1f167429d9238a5c55d82d9a54f895f579dbb98a5edb0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 115,
                        "hold": 4,
                        "slide": 2,
                        "touch": null,
                        "break": 4,
                        "total": 125
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-10-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 8,
                        "slide": 10,
                        "touch": null,
                        "break": 2,
                        "total": 259
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-10-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 291,
                        "hold": 20,
                        "slide": 23,
                        "touch": null,
                        "break": 5,
                        "total": 339
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-10-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 472,
                        "hold": 2,
                        "slide": 109,
                        "touch": null,
                        "break": 7,
                        "total": 590
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "multiverInternalLevelValue": {
                        "Splash": 13.1,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2015-10-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "かくしん的☆めたまるふぉ～ぜっ！",
            "category": "POPS＆アニメ",
            "title": "かくしん的☆めたまるふぉ～ぜっ！",
            "artist": "土間うまる [CV.田中あいみ]「乾物妹！うまるちゃん」",
            "bpm": 139,
            "imageName": "2186763113591920cea92409e166c4c447ac57bdd9e2f390086cdc317bf3ec08",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 81,
                        "hold": 8,
                        "slide": 2,
                        "touch": 4,
                        "break": 5,
                        "total": 100
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 152,
                        "hold": 19,
                        "slide": 4,
                        "touch": 11,
                        "break": 14,
                        "total": 200
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 17,
                        "slide": 20,
                        "touch": 40,
                        "break": 14,
                        "total": 300
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 371,
                        "hold": 23,
                        "slide": 33,
                        "touch": 42,
                        "break": 34,
                        "total": 503
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 104,
                        "hold": 12,
                        "slide": 2,
                        "touch": null,
                        "break": 1,
                        "total": 119
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 202,
                        "hold": 16,
                        "slide": 3,
                        "touch": null,
                        "break": 9,
                        "total": 230
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 28,
                        "slide": 28,
                        "touch": null,
                        "break": 19,
                        "total": 332
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 426,
                        "hold": 10,
                        "slide": 37,
                        "touch": null,
                        "break": 44,
                        "total": 517
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 374,
                        "hold": 24,
                        "slide": 84,
                        "touch": null,
                        "break": 73,
                        "total": 555
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "multiverInternalLevelValue": {
                        "Splash": 12.7,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2015-12-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Deep in Abyss",
            "category": "POPS＆アニメ",
            "title": "Deep in Abyss",
            "artist": "リコ（CV：富田美憂）、レグ（CV：伊瀬茉莉也）",
            "bpm": 135,
            "imageName": "086b46a03f19b5c0cff628cdb6633d85d5149a927d13acacf649b7e77afd8c50",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 93,
                        "hold": 12,
                        "slide": 8,
                        "touch": null,
                        "break": 5,
                        "total": 118
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "releaseDate": "2019-03-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 6,
                        "slide": 12,
                        "touch": null,
                        "break": 2,
                        "total": 192
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "releaseDate": "2019-03-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 40,
                        "slide": 27,
                        "touch": null,
                        "break": 6,
                        "total": 296
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "releaseDate": "2019-03-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 310,
                        "hold": 44,
                        "slide": 55,
                        "touch": null,
                        "break": 25,
                        "total": 434
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "multiverInternalLevelValue": {
                        "Splash": 12.3
                    },
                    "releaseDate": "2019-03-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "NOISY LOVE POWER☆",
            "category": "POPS＆アニメ",
            "title": "NOISY LOVE POWER☆",
            "artist": "大橋彩香",
            "bpm": 140,
            "imageName": "92ff400b27c2b3f8c1b4942e9fe44b2a9c473a631ec74c8cc9619963881bee89",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 1,
                        "total": 155
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 11,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 228
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 340,
                        "hold": 22,
                        "slide": 24,
                        "touch": null,
                        "break": 13,
                        "total": 399
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 30,
                        "slide": 63,
                        "touch": null,
                        "break": 6,
                        "total": 455
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 561,
                        "hold": 12,
                        "slide": 96,
                        "touch": null,
                        "break": 12,
                        "total": 681
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "multiverInternalLevelValue": {
                        "Splash": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2018-12-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "極上スマイル",
            "category": "POPS＆アニメ",
            "title": "極上スマイル",
            "artist": "Wake Up, Girls！",
            "bpm": 143,
            "imageName": "ec8cde872e2ff1873a54f8fea43b4135983a2623f730b3814cc553da434e18b7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 112,
                        "hold": 8,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 128
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-01-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 201,
                        "hold": 12,
                        "slide": 7,
                        "touch": null,
                        "break": 12,
                        "total": 232
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-01-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 19,
                        "slide": 8,
                        "touch": null,
                        "break": 27,
                        "total": 293
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-01-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 17,
                        "slide": 73,
                        "touch": null,
                        "break": 35,
                        "total": 372
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-01-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "甲賀忍法帖",
            "category": "POPS＆アニメ",
            "title": "甲賀忍法帖",
            "artist": "陰陽座",
            "bpm": 178,
            "imageName": "75fca5775aaa94056f8d086a2414106d16713a65a593691a7fabf792c8c12bf5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 124,
                        "hold": 4,
                        "slide": 9,
                        "touch": null,
                        "break": 8,
                        "total": 145
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-11-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 21,
                        "slide": 19,
                        "touch": null,
                        "break": 8,
                        "total": 237
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-11-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 34,
                        "slide": 53,
                        "touch": null,
                        "break": 31,
                        "total": 402
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-11-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 389,
                        "hold": 28,
                        "slide": 71,
                        "touch": null,
                        "break": 88,
                        "total": 576
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-11-06"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 490,
                        "hold": 48,
                        "slide": 112,
                        "touch": null,
                        "break": 18,
                        "total": 668
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "multiverInternalLevelValue": {
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "maimaiでらっくす PLUS": 11.9
                    },
                    "releaseDate": "2018-11-06"
                }
            ],
            "searchAcronyms": [
                "Koga Shinobu Hojo",
                "Kouga Ninpouchou",
                "The Jouga Ninja Scrolls"
            ]
        },
        {
            "songId": "Ievan Polkka",
            "category": "niconico＆ボーカロイド",
            "title": "Ievan Polkka",
            "artist": "Otomania feat. 初音ミク",
            "bpm": 119,
            "imageName": "49e0fc37f3f543338eda0c08a6a3fe31b0a7ea3d0fbdf2991984b27c0f24a93c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 208,
                        "hold": 10,
                        "slide": 2,
                        "touch": null,
                        "break": 6,
                        "total": 226
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-08-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 312,
                        "hold": 29,
                        "slide": 4,
                        "touch": null,
                        "break": 29,
                        "total": 374
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-08-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "合作だよ",
                    "noteCounts": {
                        "tap": 112,
                        "hold": 197,
                        "slide": 1,
                        "touch": null,
                        "break": 39,
                        "total": 349
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "releaseDate": "2018-08-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 666,
                        "hold": 66,
                        "slide": 31,
                        "touch": null,
                        "break": 39,
                        "total": 802
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "multiverInternalLevelValue": {
                        "Splash": 13.1,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2018-08-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "LOSER",
            "category": "POPS＆アニメ",
            "title": "LOSER",
            "artist": "米津玄師",
            "bpm": 121,
            "imageName": "fb245f7fb7460e6acf58e1643288619754fa90faa52c4f43d3d9e2b4ad4568c5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 96,
                        "hold": 11,
                        "slide": 4,
                        "touch": 12,
                        "break": 4,
                        "total": 127
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 217,
                        "hold": 25,
                        "slide": 16,
                        "touch": 13,
                        "break": 12,
                        "total": 283
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 66,
                        "slide": 26,
                        "touch": 14,
                        "break": 23,
                        "total": 465
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 515,
                        "hold": 67,
                        "slide": 59,
                        "touch": 58,
                        "break": 6,
                        "total": 705
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "U.S.A.",
            "category": "POPS＆アニメ",
            "title": "U.S.A.",
            "artist": "DA PUMP",
            "bpm": 139,
            "imageName": "17297aadd9c99c5ec4f1146c0a96c98659fc311366115284e1477b38a63feee1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 111,
                        "hold": 15,
                        "slide": 2,
                        "touch": 15,
                        "break": 4,
                        "total": 147
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 26,
                        "slide": 12,
                        "touch": 14,
                        "break": 16,
                        "total": 291
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 313,
                        "hold": 80,
                        "slide": 53,
                        "touch": 21,
                        "break": 8,
                        "total": 475
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 53,
                        "slide": 54,
                        "touch": 124,
                        "break": 7,
                        "total": 574
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 554,
                        "hold": 56,
                        "slide": 68,
                        "touch": 59,
                        "break": 24,
                        "total": 761
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "multiverInternalLevelValue": {
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "新宝島",
            "category": "POPS＆アニメ",
            "title": "新宝島",
            "artist": "サカナクション",
            "bpm": 158,
            "imageName": "359188f171201c125b03dbb5364bae74a1c59e0d7973e04fb0a8609d35bb37bc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 96,
                        "hold": 7,
                        "slide": 1,
                        "touch": 8,
                        "break": 2,
                        "total": 114
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 27,
                        "slide": 6,
                        "touch": 13,
                        "break": 16,
                        "total": 256
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 45,
                        "slide": 14,
                        "touch": 39,
                        "break": 3,
                        "total": 398
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Moon Strix",
                    "noteCounts": {
                        "tap": 307,
                        "hold": 42,
                        "slide": 81,
                        "touch": 61,
                        "break": 6,
                        "total": 497
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "未完成人",
            "category": "POPS＆アニメ",
            "title": "未完成人",
            "artist": "ンダホ&ぺけたん from Fischer's",
            "bpm": 148,
            "imageName": "37febc89df97acb56418272990d06d88169f8e354f02f1d21fd4559b25e888df",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 129,
                        "hold": 8,
                        "slide": 4,
                        "touch": 8,
                        "break": 5,
                        "total": 154
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 22,
                        "slide": 7,
                        "touch": 14,
                        "break": 18,
                        "total": 273
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 265,
                        "hold": 24,
                        "slide": 37,
                        "touch": 32,
                        "break": 11,
                        "total": 369
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 469,
                        "hold": 37,
                        "slide": 113,
                        "touch": 33,
                        "break": 7,
                        "total": 659
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "シュガーソングとビターステップ",
            "category": "POPS＆アニメ",
            "title": "シュガーソングとビターステップ",
            "artist": "UNISON SQUARE GARDEN",
            "bpm": 132,
            "imageName": "e686474eeecc9a630808252c237e6d0a3f9aa82d359f24be9feb3cf4d1de9a0c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 140,
                        "hold": 8,
                        "slide": 3,
                        "touch": 10,
                        "break": 5,
                        "total": 166
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 217,
                        "hold": 27,
                        "slide": 8,
                        "touch": 13,
                        "break": 17,
                        "total": 282
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 37,
                        "slide": 13,
                        "touch": 48,
                        "break": 14,
                        "total": 454
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 454,
                        "hold": 20,
                        "slide": 79,
                        "touch": 128,
                        "break": 17,
                        "total": 698
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 210,
                        "hold": 3,
                        "slide": 4,
                        "touch": null,
                        "break": 7,
                        "total": 224
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 288,
                        "hold": 46,
                        "slide": 8,
                        "touch": null,
                        "break": 10,
                        "total": 352
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 449,
                        "hold": 43,
                        "slide": 40,
                        "touch": null,
                        "break": 22,
                        "total": 554
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 771,
                        "hold": 28,
                        "slide": 67,
                        "touch": null,
                        "break": 21,
                        "total": 887
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "multiverInternalLevelValue": {
                        "Splash PLUS": 12.9,
                        "maimaiでらっくす PLUS": 12.2
                    },
                    "releaseDate": "2016-06-30"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Daydream café",
            "category": "POPS＆アニメ",
            "title": "Daydream café",
            "artist": "Petit Rabbit's「ご注文はうさぎですか？」",
            "bpm": 150,
            "imageName": "593678777397e75152cf3e6caacdebb84900b39ae9ed798b1e0f9f0e549ea68c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 66,
                        "hold": 11,
                        "slide": 4,
                        "touch": 12,
                        "break": 4,
                        "total": 97
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 160,
                        "hold": 4,
                        "slide": 7,
                        "touch": 8,
                        "break": 4,
                        "total": 183
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 204,
                        "hold": 53,
                        "slide": 10,
                        "touch": 13,
                        "break": 9,
                        "total": 289
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 46,
                        "slide": 41,
                        "touch": 53,
                        "break": 26,
                        "total": 458
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 99,
                        "hold": 11,
                        "slide": 6,
                        "touch": null,
                        "break": 6,
                        "total": 122
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 244,
                        "hold": 14,
                        "slide": 13,
                        "touch": null,
                        "break": 2,
                        "total": 273
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 259,
                        "hold": 46,
                        "slide": 24,
                        "touch": null,
                        "break": 4,
                        "total": 333
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 399,
                        "hold": 22,
                        "slide": 76,
                        "touch": null,
                        "break": 28,
                        "total": 525
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-06-30"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "コネクト",
            "category": "POPS＆アニメ",
            "title": "コネクト",
            "artist": "ClariS「魔法少女まどか☆マギカ」",
            "bpm": 175,
            "imageName": "28c1089c07007d53a79c7c1e41d3fb427cadc5798d1d8cbfd5e0a50e12c40e6d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 69,
                        "hold": 11,
                        "slide": 3,
                        "touch": 16,
                        "break": 4,
                        "total": 103
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 18,
                        "slide": 11,
                        "touch": 14,
                        "break": 2,
                        "total": 229
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 226,
                        "hold": 29,
                        "slide": 20,
                        "touch": 37,
                        "break": 8,
                        "total": 320
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 46,
                        "slide": 68,
                        "touch": 5,
                        "break": 5,
                        "total": 409
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 367,
                        "hold": 21,
                        "slide": 128,
                        "touch": 33,
                        "break": 3,
                        "total": 552
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "multiverInternalLevelValue": {
                        "Splash": 12.8,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 139,
                        "hold": 12,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 157
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 177,
                        "hold": 26,
                        "slide": 17,
                        "touch": null,
                        "break": 2,
                        "total": 222
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "maimai TEAM",
                    "noteCounts": {
                        "tap": 274,
                        "hold": 18,
                        "slide": 15,
                        "touch": null,
                        "break": 6,
                        "total": 313
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 211,
                        "hold": 25,
                        "slide": 95,
                        "touch": null,
                        "break": 3,
                        "total": 334
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "multiverInternalLevelValue": {
                        "Splash": 11.3
                    },
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "The Gong of Knockout",
            "category": "POPS＆アニメ",
            "title": "The Gong of Knockout",
            "artist": "Fear, and Loathing in Las Vegas",
            "bpm": 180,
            "imageName": "93d3265ae86bb14f8cc4b23eead9a19eda6a1fb649f2d71be625b71ca92aeb0c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 77,
                        "hold": 7,
                        "slide": 2,
                        "touch": 6,
                        "break": 7,
                        "total": 99
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-09-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 11,
                        "slide": 10,
                        "touch": 13,
                        "break": 10,
                        "total": 238
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-09-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 220,
                        "hold": 50,
                        "slide": 42,
                        "touch": 105,
                        "break": 11,
                        "total": 428
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-09-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 493,
                        "hold": 51,
                        "slide": 48,
                        "touch": 93,
                        "break": 23,
                        "total": 708
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "multiverInternalLevelValue": {
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2019-09-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Clattanoia",
            "category": "POPS＆アニメ",
            "title": "Clattanoia",
            "artist": "OxT",
            "bpm": 190,
            "imageName": "8d7a3b10f9800740f6770a19ece12c211629ec96c32873be6172569c6a0a7747",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 76,
                        "hold": 9,
                        "slide": 7,
                        "touch": 7,
                        "break": 2,
                        "total": 101
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-09-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 180,
                        "hold": 23,
                        "slide": 11,
                        "touch": 6,
                        "break": 8,
                        "total": 228
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-09-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 33,
                        "slide": 14,
                        "touch": 59,
                        "break": 13,
                        "total": 377
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-09-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 355,
                        "hold": 17,
                        "slide": 96,
                        "touch": 76,
                        "break": 18,
                        "total": 562
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-09-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "UNION",
            "category": "POPS＆アニメ",
            "title": "UNION",
            "artist": "OxT",
            "bpm": 178,
            "imageName": "e3cee2873a8368b24b92ec128a9d66025ee9fc8928fe5028307e9180362ec2f5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 74,
                        "hold": 6,
                        "slide": 3,
                        "touch": 6,
                        "break": 5,
                        "total": 94
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 193,
                        "hold": 11,
                        "slide": 6,
                        "touch": 10,
                        "break": 12,
                        "total": 232
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 25,
                        "slide": 16,
                        "touch": 35,
                        "break": 10,
                        "total": 336
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 308,
                        "hold": 15,
                        "slide": 74,
                        "touch": 48,
                        "break": 6,
                        "total": 451
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "東奔西走行進曲",
            "category": "POPS＆アニメ",
            "title": "東奔西走行進曲",
            "artist": "BLACK STARS（ブラック指令・ペガッサ星人・シルバーブルーメ・ノーバ）",
            "bpm": 165,
            "imageName": "893cf575c2f107be07e46e02aa0cc8f2229256cb0ece6fa52c29f2aff9218b95",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 21,
                        "slide": 6,
                        "touch": 14,
                        "break": 8,
                        "total": 194
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 10,
                        "slide": 24,
                        "touch": 32,
                        "break": 18,
                        "total": 311
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 325,
                        "hold": 43,
                        "slide": 49,
                        "touch": 67,
                        "break": 39,
                        "total": 523
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 69,
                        "slide": 80,
                        "touch": 83,
                        "break": 15,
                        "total": 649
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 12.7
                    },
                    "releaseDate": "2019-12-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Soul-ride ON!",
            "category": "POPS＆アニメ",
            "title": "Soul-ride ON!",
            "artist": "アギラ・キングジョー・ガッツ星人（CV：飯田裡穂・三森すずこ・松田利冴）",
            "bpm": 146,
            "imageName": "68e570c74a1b0ec2a66bb8f208a0f0b4dcb81bf8b959c2812bf8dc0e74da304f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 73,
                        "hold": 16,
                        "slide": 3,
                        "touch": 8,
                        "break": 2,
                        "total": 102
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 144,
                        "hold": 16,
                        "slide": 17,
                        "touch": 19,
                        "break": 6,
                        "total": 202
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 31,
                        "slide": 19,
                        "touch": 58,
                        "break": 32,
                        "total": 354
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 82,
                        "slide": 35,
                        "touch": 46,
                        "break": 31,
                        "total": 452
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-12-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "乗ってけ！ジャパリビート",
            "category": "POPS＆アニメ",
            "title": "乗ってけ！ジャパリビート",
            "artist": "どうぶつビスケッツ×PPP「けものフレンズ２」",
            "bpm": 134,
            "imageName": "987ca92d1109199ac0cf455aa6d0c17119b2ffa78ad2bbed33dc463691d80fe0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 76,
                        "hold": 8,
                        "slide": 4,
                        "touch": 4,
                        "break": 3,
                        "total": 95
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 158,
                        "hold": 16,
                        "slide": 1,
                        "touch": 6,
                        "break": 13,
                        "total": 194
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 28,
                        "slide": 24,
                        "touch": 44,
                        "break": 12,
                        "total": 292
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 36,
                        "slide": 29,
                        "touch": 46,
                        "break": 19,
                        "total": 460
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "フレ！フレ！ベストフレンズ",
            "category": "POPS＆アニメ",
            "title": "フレ！フレ！ベストフレンズ",
            "artist": "どうぶつビスケッツ×PPP「けものフレンズ」",
            "bpm": 166,
            "imageName": "e547dd6983eb2bb0d01f4b95a5fe0d4b8fe5d1d656b9d2af271e06f0a03be152",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 73,
                        "hold": 7,
                        "slide": 2,
                        "touch": 8,
                        "break": 5,
                        "total": 95
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 17,
                        "slide": 3,
                        "touch": 8,
                        "break": 19,
                        "total": 237
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 213,
                        "hold": 29,
                        "slide": 11,
                        "touch": 24,
                        "break": 15,
                        "total": 292
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 339,
                        "hold": 31,
                        "slide": 68,
                        "touch": 24,
                        "break": 12,
                        "total": 474
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "POPPY PAPPY DAY",
            "category": "POPS＆アニメ",
            "title": "POPPY PAPPY DAY",
            "artist": "ポプ子(CV:五十嵐裕美)＆ピピ美(CV:松嵜麗)",
            "bpm": 157,
            "imageName": "cc653af29eedfbae742d898470ae0100f54e9573eb898c2c7b86c588039a446f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 119,
                        "hold": 15,
                        "slide": 5,
                        "touch": 9,
                        "break": 5,
                        "total": 153
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-09-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 24,
                        "slide": 11,
                        "touch": 14,
                        "break": 16,
                        "total": 292
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-09-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 65,
                        "slide": 53,
                        "touch": 32,
                        "break": 14,
                        "total": 418
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-09-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 372,
                        "hold": 49,
                        "slide": 91,
                        "touch": 32,
                        "break": 15,
                        "total": 559
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-09-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "アウトサイダー",
            "category": "niconico＆ボーカロイド",
            "title": "アウトサイダー",
            "artist": "Eve",
            "bpm": 172,
            "imageName": "8f9183bc2ab28b1d0540ba73aa9f47dfed995de3a3f8f2663c716e13d7450a84",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 114,
                        "hold": 16,
                        "slide": 3,
                        "touch": 6,
                        "break": 11,
                        "total": 150
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 279,
                        "hold": 19,
                        "slide": 12,
                        "touch": 20,
                        "break": 6,
                        "total": 336
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 59,
                        "slide": 22,
                        "touch": 42,
                        "break": 12,
                        "total": 486
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 523,
                        "hold": 9,
                        "slide": 128,
                        "touch": 127,
                        "break": 7,
                        "total": 794
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "multiverInternalLevelValue": {
                        "Splash": 12.6,
                        "Splash PLUS": 12.7
                    },
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "絵の上手かった友達",
            "category": "niconico＆ボーカロイド",
            "title": "絵の上手かった友達",
            "artist": "ピノキオピー",
            "bpm": 128,
            "imageName": "7548bc33c01e25cb334a573a0a7f1f75cf1e0236903024f30b569046639d28c7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 8,
                        "slide": 11,
                        "touch": null,
                        "break": 6,
                        "total": 150
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 34,
                        "slide": 14,
                        "touch": null,
                        "break": 6,
                        "total": 349
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 383,
                        "hold": 22,
                        "slide": 40,
                        "touch": null,
                        "break": 9,
                        "total": 454
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "releaseDate": "2016-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 576,
                        "hold": 12,
                        "slide": 82,
                        "touch": null,
                        "break": 6,
                        "total": 676
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "multiverInternalLevelValue": {
                        "Splash": 12.4
                    },
                    "releaseDate": "2016-04-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ワンダーラスト",
            "category": "niconico＆ボーカロイド",
            "title": "ワンダーラスト",
            "artist": "sasakure.UK",
            "bpm": 230,
            "imageName": "7d0e18b56e5baff542c949d2b2ec95bcc53839efdeeb022f5c1c4dbd6c71bdae",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 22,
                        "slide": 3,
                        "touch": null,
                        "break": 4,
                        "total": 157
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "releaseDate": "2019-06-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 24,
                        "slide": 19,
                        "touch": null,
                        "break": 13,
                        "total": 290
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "releaseDate": "2019-06-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 471,
                        "hold": 121,
                        "slide": 70,
                        "touch": null,
                        "break": 10,
                        "total": 672
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "releaseDate": "2019-06-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 597,
                        "hold": 73,
                        "slide": 101,
                        "touch": null,
                        "break": 16,
                        "total": 787
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "multiverInternalLevelValue": {
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2019-06-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Mr. Wonderland",
            "category": "niconico＆ボーカロイド",
            "title": "Mr. Wonderland",
            "artist": "sasakure.UK",
            "bpm": 140,
            "imageName": "4798aa8e75b12672a70f0267466eb6fdb4476798fbfee94595654c63de3398db",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 14,
                        "slide": 16,
                        "touch": null,
                        "break": 4,
                        "total": 210
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-07-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 46,
                        "slide": 18,
                        "touch": null,
                        "break": 5,
                        "total": 278
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-07-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 62,
                        "slide": 56,
                        "touch": null,
                        "break": 17,
                        "total": 472
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "releaseDate": "2016-07-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 586,
                        "hold": 61,
                        "slide": 89,
                        "touch": null,
                        "break": 4,
                        "total": 740
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "multiverInternalLevelValue": {
                        "Splash": 13.2,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2016-07-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ジャガーノート",
            "category": "niconico＆ボーカロイド",
            "title": "ジャガーノート",
            "artist": "夏代孝明 feat. 初音ミク",
            "bpm": 190,
            "imageName": "94552bed046225520c7517e80ef94919774ee396bc596c01c8dfac344bb8cca2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 90,
                        "hold": 16,
                        "slide": 7,
                        "touch": 13,
                        "break": 4,
                        "total": 130
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 18,
                        "slide": 14,
                        "touch": 10,
                        "break": 10,
                        "total": 289
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 64,
                        "slide": 28,
                        "touch": 57,
                        "break": 10,
                        "total": 396
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 489,
                        "hold": 19,
                        "slide": 107,
                        "touch": 77,
                        "break": 17,
                        "total": 709
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "multiverInternalLevelValue": {
                        "Splash": 12.4
                    },
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "アリサのテーマ",
            "category": "ゲーム＆バラエティ",
            "title": "アリサのテーマ",
            "artist": "池頼広",
            "bpm": 130,
            "imageName": "72c54611a0d9cd83e83fb3dc902416f3d751cbdec0828afb07b3fcfa47093f59",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 14,
                        "slide": 2,
                        "touch": null,
                        "break": 6,
                        "total": 225
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "releaseDate": "2019-04-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 55,
                        "slide": 8,
                        "touch": null,
                        "break": 12,
                        "total": 353
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "releaseDate": "2019-04-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 52,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 417
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "releaseDate": "2019-04-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 0,
                        "slide": 229,
                        "touch": null,
                        "break": 3,
                        "total": 461
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "multiverInternalLevelValue": {
                        "Splash": 13.2,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "maimaiでらっくす PLUS": 13.1
                    },
                    "releaseDate": "2019-04-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "全世界共通リズム感テスト",
            "category": "maimai",
            "title": "全世界共通リズム感テスト",
            "artist": "☆リズムに合わせてボタンを叩き達成率を競うゲームです☆",
            "bpm": 120,
            "imageName": "692ae385226bd2ff2c7134b8593c195ef5d4294194c672eb33ce97394ec882ef",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 48,
                        "hold": 0,
                        "slide": 0,
                        "touch": null,
                        "break": 17,
                        "total": 65
                    },
                    "regions": {
                        "jp": false,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "Splash"
                        }
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-04-01"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 96,
                        "hold": 0,
                        "slide": 0,
                        "touch": null,
                        "break": 33,
                        "total": 129
                    },
                    "regions": {
                        "jp": false,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "Splash"
                        }
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-04-01"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 0,
                        "hold": 0,
                        "slide": 0,
                        "touch": null,
                        "break": 129,
                        "total": 129
                    },
                    "regions": {
                        "jp": false,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "Splash"
                        }
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-04-01"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "(無し)",
                    "noteCounts": {
                        "tap": 0,
                        "hold": 0,
                        "slide": 0,
                        "touch": null,
                        "break": 129,
                        "total": 129
                    },
                    "regions": {
                        "jp": false,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "Splash"
                        }
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "releaseDate": "2015-04-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "オントロジー",
            "category": "POPS＆アニメ",
            "title": "オントロジー",
            "artist": "Rain Drops",
            "bpm": 192,
            "imageName": "90ad22d33eb9076ca52ca03db83985a87cdb1852d535e4e22432715946296598",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 4,
                        "slide": 6,
                        "touch": 15,
                        "break": 3,
                        "total": 131
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11430,
                    "releaseDate": "2022-06-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 329,
                        "hold": 15,
                        "slide": 13,
                        "touch": 15,
                        "break": 10,
                        "total": 382
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11430,
                    "releaseDate": "2022-06-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 449,
                        "hold": 39,
                        "slide": 24,
                        "touch": 16,
                        "break": 14,
                        "total": 542
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11430,
                    "releaseDate": "2022-06-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 479,
                        "hold": 30,
                        "slide": 149,
                        "touch": 20,
                        "break": 24,
                        "total": 702
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11430,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2022-06-10"
                }
            ],
            "searchAcronyms": [
                "ontology",
                "本体论"
            ]
        },
        {
            "songId": "剣を抜け！GCCX MAX",
            "category": "POPS＆アニメ",
            "title": "剣を抜け！GCCX MAX",
            "artist": "メッセメッセクラブ",
            "bpm": 96,
            "imageName": "251243f31824edf461bd9a43d7d455f383f046d4828ef94c3b7257f916ffe59d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 143,
                        "hold": 5,
                        "slide": 5,
                        "touch": 9,
                        "break": 8,
                        "total": 170
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11431,
                    "releaseDate": "2022-06-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 181,
                        "hold": 20,
                        "slide": 8,
                        "touch": 66,
                        "break": 16,
                        "total": 291
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11431,
                    "releaseDate": "2022-06-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 114,
                        "slide": 44,
                        "touch": 17,
                        "break": 32,
                        "total": 425
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11431,
                    "releaseDate": "2022-06-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 359,
                        "hold": 96,
                        "slide": 101,
                        "touch": 168,
                        "break": 64,
                        "total": 788
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11431,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 12.9,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2022-06-10"
                }
            ],
            "searchAcronyms": [
                "gccx",
                "GCCX",
                "剑拔",
                "剑拔弩张",
                "拔剑"
            ]
        },
        {
            "songId": "アノーイング！さんさんウィーク！",
            "category": "POPS＆アニメ",
            "title": "アノーイング！さんさんウィーク！",
            "artist": "五十嵐双葉（ＣＶ：楠木ともり）、桜井桃子（ＣＶ：早見沙織）、黒部夏美（ＣＶ：青山玲菜）、月城モナ（ＣＶ：古賀葵）",
            "bpm": 140,
            "imageName": "e4eb57417ff552c26817607319384f753ad9f016cadc0e30536c01ffdc4b2519",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 71,
                        "hold": 1,
                        "slide": 3,
                        "touch": 6,
                        "break": 3,
                        "total": 84
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11480,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 132,
                        "hold": 10,
                        "slide": 9,
                        "touch": 11,
                        "break": 12,
                        "total": 174
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11480,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 13,
                        "slide": 11,
                        "touch": 24,
                        "break": 10,
                        "total": 331
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11480,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 373,
                        "hold": 42,
                        "slide": 28,
                        "touch": 72,
                        "break": 33,
                        "total": 548
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11480,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "残響散歌",
            "category": "POPS＆アニメ",
            "title": "残響散歌",
            "artist": "Aimer",
            "bpm": 171,
            "imageName": "7eabfcb8b374db41cccec3a7c57d529d736d6f799886c0a83c6b9706e96de0e2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 117,
                        "hold": 12,
                        "slide": 4,
                        "touch": 22,
                        "break": 7,
                        "total": 162
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11484,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 17,
                        "slide": 7,
                        "touch": 46,
                        "break": 8,
                        "total": 373
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11484,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.7,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 370,
                        "hold": 57,
                        "slide": 50,
                        "touch": 32,
                        "break": 38,
                        "total": 547
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11484,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 9.7
                    },
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 657,
                        "hold": 38,
                        "slide": 199,
                        "touch": 22,
                        "break": 23,
                        "total": 939
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11484,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": [
                "残响",
                "残响散歌"
            ]
        },
        {
            "songId": "アマカミサマ",
            "category": "POPS＆アニメ",
            "title": "アマカミサマ",
            "artist": "名取さな",
            "bpm": 174,
            "imageName": "48e9ea2d8dd51520cece8ce764bd9dfb0c8c38528d31741a7271caa69e8d419b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 118,
                        "hold": 11,
                        "slide": 3,
                        "touch": 8,
                        "break": 2,
                        "total": 142
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11497,
                    "releaseDate": "2022-11-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 252,
                        "hold": 31,
                        "slide": 11,
                        "touch": 26,
                        "break": 6,
                        "total": 326
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11497,
                    "releaseDate": "2022-11-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 42,
                        "slide": 26,
                        "touch": 6,
                        "break": 10,
                        "total": 429
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11497,
                    "releaseDate": "2022-11-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "アマリリスせんせえ",
                    "noteCounts": {
                        "tap": 390,
                        "hold": 70,
                        "slide": 79,
                        "touch": 145,
                        "break": 17,
                        "total": 701
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11497,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2022-11-04"
                }
            ],
            "searchAcronyms": [
                "Amakamisama",
                "天神",
                "天神大人",
                "阿妈卡密萨马"
            ]
        },
        {
            "songId": "アンダーキッズ",
            "category": "POPS＆アニメ",
            "title": "アンダーキッズ",
            "artist": "ツユ",
            "bpm": 225,
            "imageName": "5790cc5e8b00a81150ad8f5a3a68b749bafc7a07a658947f02ed7207bbda714f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 11,
                        "slide": 5,
                        "touch": 30,
                        "break": 14,
                        "total": 249
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11635,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 9,
                        "slide": 6,
                        "touch": 22,
                        "break": 6,
                        "total": 349
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11635,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.8,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 499,
                        "hold": 103,
                        "slide": 28,
                        "touch": 13,
                        "break": 46,
                        "total": 689
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11635,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 10.8
                    },
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 597,
                        "hold": 77,
                        "slide": 174,
                        "touch": 74,
                        "break": 64,
                        "total": 986
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11635,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4
                    },
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": [
                "Under Kids"
            ]
        },
        {
            "songId": "[協]ぽっぴっぽー",
            "category": "宴会場",
            "title": "[協]ぽっぴっぽー",
            "artist": "",
            "bpm": null,
            "imageName": "634532beae7f19f2ec22f4923713bdb234c44584d43d20df283b6d8756b79392",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【協】",
                    "level": "13+?",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100259,
                    "version": "BUDDiES",
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[協]ポップミュージックは僕のもの",
            "category": "宴会場",
            "title": "[協]ポップミュージックは僕のもの",
            "artist": "ONIGAWARA",
            "bpm": null,
            "imageName": "0cee7f2b4d14bb1024304250d8c93040d147d5c0f4893751f9911e9a493b6def",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【協】",
                    "level": "12+?",
                    "internalLevelValue": 12.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 110579,
                    "version": "BUDDiES",
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[光]BREaK! BREaK! BREaK!",
            "category": "宴会場",
            "title": "[光]BREaK! BREaK! BREaK!",
            "artist": "HiTECH NINJA vs Cranky",
            "bpm": null,
            "imageName": "4f9500cbc714e859a617ed06238916752a145271132d6199e7c0053b5b7b4146",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【光】",
                    "level": "14+?",
                    "internalLevelValue": 14.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "BUDDiES",
                    "releaseDate": "2023-10-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[蔵]Aegleseeker",
            "category": "宴会場",
            "title": "[蔵]Aegleseeker",
            "artist": "Silentroom vs Frums",
            "bpm": null,
            "imageName": "0fee1f54c5613514d93e215e37a737be3fffb1e47fd04bbd4ca562595eddc4e3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【蔵】",
                    "level": "14+?",
                    "internalLevelValue": 14.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111516,
                    "version": "BUDDiES",
                    "releaseDate": "2023-10-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[蔵]In Chaos",
            "category": "宴会場",
            "title": "[蔵]In Chaos",
            "artist": "Hiro「Crackin’DJ」",
            "bpm": null,
            "imageName": "704d8f68917a041a526b8055b669145d7a28289a84da0b2ad03b4543fd83d7b8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【蔵】",
                    "level": "14+?",
                    "internalLevelValue": 14.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100022,
                    "version": "BUDDiES",
                    "releaseDate": "2023-12-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[右]The wheel to the right",
            "category": "宴会場",
            "title": "[右]The wheel to the right",
            "artist": "Sampling Masters MEGA",
            "bpm": null,
            "imageName": "c9e62a59fdba62e3da399823c1a62812b974e234e1c9fdac39657ca326961c6d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【右】",
                    "level": "14+?",
                    "internalLevelValue": 14.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 110606,
                    "version": "BUDDiES",
                    "releaseDate": "2024-02-29"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[逆]KING is BACK!!",
            "category": "宴会場",
            "title": "[逆]KING is BACK!!",
            "artist": "A-One",
            "bpm": null,
            "imageName": "0f087e8a12b2b86936761f54c7175018f915854aeb0c50365aa578a1f19e1db6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【逆】",
                    "level": "13+?",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": false,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 110631,
                    "version": "BUDDiES",
                    "releaseDate": "2024-02-29"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "True Love Song",
            "category": "maimai",
            "title": "True Love Song",
            "artist": "Kai/クラシック「G線上のアリア」",
            "bpm": 150,
            "imageName": "d260d1c2d49551b5b024cfbe61db63143400e59d729ee4c7a02baffc374dddb0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 63,
                        "hold": 23,
                        "slide": 8,
                        "touch": null,
                        "break": 2,
                        "total": 96
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 8,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 85,
                        "hold": 27,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 122
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 8,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 110,
                        "hold": 56,
                        "slide": 9,
                        "touch": null,
                        "break": 2,
                        "total": 177
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 8,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 14,
                        "slide": 19,
                        "touch": null,
                        "break": 6,
                        "total": 302
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 8,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "小管弦乐",
                "真情歌",
                "真爱",
                "真爱歌",
                "糖糖"
            ]
        },
        {
            "songId": "Color My World",
            "category": "maimai",
            "title": "Color My World",
            "artist": "GOSH/クラシック「悲愴」",
            "bpm": 94,
            "imageName": "6ea75769d59b055bd605a5e44f0b41221dd58254a6d70f86de0ceb18f1bca7d7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 73,
                        "hold": 1,
                        "slide": 19,
                        "touch": null,
                        "break": 2,
                        "total": 95
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 9,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 89,
                        "hold": 39,
                        "slide": 8,
                        "touch": null,
                        "break": 7,
                        "total": 143
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 9,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 5,
                        "slide": 31,
                        "touch": null,
                        "break": 8,
                        "total": 153
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 9,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 148,
                        "hold": 13,
                        "slide": 49,
                        "touch": null,
                        "break": 3,
                        "total": 213
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 9,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "cmw",
                "悲怆"
            ]
        },
        {
            "songId": "Future",
            "category": "POPS＆アニメ",
            "title": "Future",
            "artist": "★STAR GUiTAR [cover]",
            "bpm": 130,
            "imageName": "9db5b25cd3c87a04a8dda3eb7c720f676447b1cc809141007544f461633c25fa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 183,
                        "hold": 0,
                        "slide": 3,
                        "touch": null,
                        "break": 2,
                        "total": 188
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 17,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 178,
                        "hold": 16,
                        "slide": 12,
                        "touch": null,
                        "break": 4,
                        "total": 210
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 17,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "maimai TEAM",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 12,
                        "slide": 5,
                        "touch": null,
                        "break": 3,
                        "total": 304
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 17,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 226,
                        "hold": 18,
                        "slide": 33,
                        "touch": null,
                        "break": 9,
                        "total": 286
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 17,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 238,
                        "hold": 4,
                        "slide": 128,
                        "touch": null,
                        "break": 126,
                        "total": 496
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 17,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.2,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2015-08-12"
                }
            ],
            "searchAcronyms": [
                "ftr",
                "未来",
                "错位歌"
            ]
        },
        {
            "songId": "Love You",
            "category": "POPS＆アニメ",
            "title": "Love You",
            "artist": "Q;indivi [cover]",
            "bpm": 135,
            "imageName": "96141297a26510f6cd1f1eaac1cda7f6be8180c8aa6b633c5b0816603ea1e138",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 91,
                        "hold": 33,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 130
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 18,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 150,
                        "hold": 23,
                        "slide": 21,
                        "touch": null,
                        "break": 4,
                        "total": 198
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 18,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 104,
                        "hold": 61,
                        "slide": 16,
                        "touch": null,
                        "break": 3,
                        "total": 184
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 18,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 91,
                        "hold": 51,
                        "slide": 51,
                        "touch": null,
                        "break": 5,
                        "total": 198
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 18,
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "爱你"
            ]
        },
        {
            "songId": "In Chaos",
            "category": "ゲーム＆バラエティ",
            "title": "In Chaos",
            "artist": "Hiro「Crackin’DJ」",
            "bpm": 140,
            "imageName": "704d8f68917a041a526b8055b669145d7a28289a84da0b2ad03b4543fd83d7b8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 2,
                        "slide": 4,
                        "touch": null,
                        "break": 1,
                        "total": 142
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 22,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 10,
                        "slide": 8,
                        "touch": null,
                        "break": 3,
                        "total": 221
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 22,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 320,
                        "hold": 1,
                        "slide": 3,
                        "touch": null,
                        "break": 2,
                        "total": 326
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 22,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 328,
                        "hold": 28,
                        "slide": 17,
                        "touch": null,
                        "break": 7,
                        "total": 380
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 22,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 768,
                        "hold": 0,
                        "slide": 97,
                        "touch": null,
                        "break": 15,
                        "total": 880
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 22,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "FESTiVAL": 14.8,
                        "FESTiVAL PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8,
                        "Splash": 14.8,
                        "Splash PLUS": 14.8,
                        "UNiVERSE": 14.8,
                        "UNiVERSE PLUS": 14.8,
                        "maimaiでらっくす PLUS": 14.9
                    },
                    "releaseDate": "2017-12-04"
                }
            ],
            "searchAcronyms": [
                "💩",
                "别急14",
                "印钞",
                "在超市",
                "有害的音乐",
                "硬超市",
                "硬超死",
                "超市",
                "超市入口",
                "超市里",
                "超市里谱",
                "这是有害的音乐",
                "银潮湿",
                "阴超室",
                "阴超市",
                "阴间超市",
                "马叫"
            ]
        },
        {
            "songId": "Crush On You",
            "category": "ゲーム＆バラエティ",
            "title": "Crush On You",
            "artist": "福山光晴「Crackin’DJ」",
            "bpm": 125,
            "imageName": "bc8c817cf11c771a7ef1415b2aa19ed08bef28a39759d9a3f8c217f53acc0aeb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 114,
                        "hold": 8,
                        "slide": 3,
                        "touch": null,
                        "break": 1,
                        "total": 126
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 23,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 139,
                        "hold": 26,
                        "slide": 2,
                        "touch": null,
                        "break": 1,
                        "total": 168
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 23,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 182,
                        "hold": 34,
                        "slide": 2,
                        "touch": null,
                        "break": 5,
                        "total": 223
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 23,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 201,
                        "hold": 31,
                        "slide": 39,
                        "touch": null,
                        "break": 6,
                        "total": 277
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 23,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 341,
                        "hold": 89,
                        "slide": 109,
                        "touch": null,
                        "break": 16,
                        "total": 555
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 23,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2017-12-04"
                }
            ],
            "searchAcronyms": [
                "cou",
                "coy",
                "冲你身上",
                "创似拟",
                "创死你",
                "小黑子",
                "撞死你",
                "暗恋你",
                "木有芭蕾",
                "蔡徐坤",
                "虫儿飞",
                "鸡你太美"
            ]
        },
        {
            "songId": "Sun Dance",
            "category": "ゲーム＆バラエティ",
            "title": "Sun Dance",
            "artist": "Hiro「Crackin’DJ」",
            "bpm": 102,
            "imageName": "30589386357db48bec3d2a26e314cb60a19a0ce09266d79e5f0a60a3cdbdaaa7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 100,
                        "hold": 3,
                        "slide": 1,
                        "touch": null,
                        "break": 2,
                        "total": 106
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 24,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 10,
                        "slide": 1,
                        "touch": null,
                        "break": 4,
                        "total": 190
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 24,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 201,
                        "hold": 16,
                        "slide": 5,
                        "touch": null,
                        "break": 3,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 24,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 11,
                        "slide": 16,
                        "touch": null,
                        "break": 11,
                        "total": 316
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 24,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 381,
                        "hold": 72,
                        "slide": 29,
                        "touch": null,
                        "break": 53,
                        "total": 535
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 24,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2017-12-04"
                }
            ],
            "searchAcronyms": [
                "sd",
                "太阳舞",
                "孙舞",
                "日舞",
                "日跳舞",
                "阳舞"
            ]
        },
        {
            "songId": "Sweets×Sweets",
            "category": "maimai",
            "title": "Sweets×Sweets",
            "artist": "Team-D",
            "bpm": 132,
            "imageName": "83319c642ca7e10b04661e176ff14e46209632dcb760d76460df2cd89dd3afff",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 7,
                        "slide": 5,
                        "touch": null,
                        "break": 4,
                        "total": 151
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 25,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 195,
                        "hold": 16,
                        "slide": 10,
                        "touch": null,
                        "break": 2,
                        "total": 223
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 25,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 181,
                        "hold": 35,
                        "slide": 20,
                        "touch": null,
                        "break": 2,
                        "total": 238
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 25,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "maimai TEAM",
                    "noteCounts": {
                        "tap": 343,
                        "hold": 23,
                        "slide": 12,
                        "touch": null,
                        "break": 9,
                        "total": 387
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 25,
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "甜²",
                "甜甜",
                "甜蜜蜜",
                "阳光彩虹小白马"
            ]
        },
        {
            "songId": "Love or Lies",
            "category": "POPS＆アニメ",
            "title": "Love or Lies",
            "artist": "capsule [cover]",
            "bpm": 128,
            "imageName": "50c2f66b48da1206b0b4fb7b9edbbf4a1de7a8076d2287d2c84b4461c5159ca4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 91,
                        "hold": 6,
                        "slide": 5,
                        "touch": null,
                        "break": 3,
                        "total": 105
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 27,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 165,
                        "hold": 6,
                        "slide": 9,
                        "touch": null,
                        "break": 10,
                        "total": 190
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 27,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 208,
                        "hold": 43,
                        "slide": 6,
                        "touch": null,
                        "break": 6,
                        "total": 263
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 27,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 279,
                        "hold": 38,
                        "slide": 21,
                        "touch": null,
                        "break": 15,
                        "total": 353
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 27,
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "lol",
                "LOL",
                "爱或谎"
            ]
        },
        {
            "songId": "ネコ日和。",
            "category": "maimai",
            "title": "ネコ日和。",
            "artist": "Kai/能登有沙",
            "bpm": 171,
            "imageName": "4de607204098ec4d30eee2651ea5a0e6b470fcd3553c582cc0d9b6dbbff3e8e8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 97,
                        "hold": 11,
                        "slide": 6,
                        "touch": 4,
                        "break": 8,
                        "total": 126
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 10030,
                    "releaseDate": "2025-04-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 12,
                        "slide": 6,
                        "touch": 28,
                        "break": 10,
                        "total": 218
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 10030,
                    "releaseDate": "2025-04-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 216,
                        "hold": 38,
                        "slide": 14,
                        "touch": 21,
                        "break": 30,
                        "total": 319
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 10030,
                    "releaseDate": "2025-04-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 417,
                        "hold": 8,
                        "slide": 91,
                        "touch": 41,
                        "break": 74,
                        "total": 631
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 10030,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2025-04-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 4,
                        "slide": 7,
                        "touch": null,
                        "break": 4,
                        "total": 177
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 30,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 210,
                        "hold": 23,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 241
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 30,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 259,
                        "hold": 4,
                        "slide": 10,
                        "touch": null,
                        "break": 8,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 30,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 283,
                        "hold": 36,
                        "slide": 11,
                        "touch": null,
                        "break": 16,
                        "total": 346
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 30,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "大臣日和",
                "猫咪日和",
                "猫天气",
                "猫日和"
            ]
        },
        {
            "songId": "虹と太陽",
            "category": "maimai",
            "title": "虹と太陽",
            "artist": "GOSH/manami",
            "bpm": 146,
            "imageName": "138aa9cfe97bdecb628ec24d4bedd54c0009ff4851f70bbc6b0dc6cee6a71d99",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 118,
                        "hold": 8,
                        "slide": 7,
                        "touch": null,
                        "break": 2,
                        "total": 135
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 31,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 20,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 31,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 255,
                        "hold": 9,
                        "slide": 14,
                        "touch": null,
                        "break": 2,
                        "total": 280
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 31,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 23,
                        "slide": 12,
                        "touch": null,
                        "break": 16,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 31,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "☀",
                "太阳",
                "彩虹太阳",
                "虹太阳"
            ]
        },
        {
            "songId": "炭★坑★節",
            "category": "maimai",
            "title": "炭★坑★節",
            "artist": "Kai/光吉猛修",
            "bpm": 112,
            "imageName": "3160b304b03f9849fd5b437c84a2b2befea98cc74bd67a40cf4d6a2f3d0880cf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 153,
                        "hold": 2,
                        "slide": 3,
                        "touch": null,
                        "break": 6,
                        "total": 164
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 35,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 1,
                        "slide": 12,
                        "touch": null,
                        "break": 6,
                        "total": 222
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 35,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 341,
                        "hold": 14,
                        "slide": 11,
                        "touch": null,
                        "break": 4,
                        "total": 370
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 35,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 13,
                        "slide": 22,
                        "touch": null,
                        "break": 6,
                        "total": 356
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 35,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13.1,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 12.1
                    },
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "最新热歌慢摇",
                "炭坑节",
                "粪坑节"
            ]
        },
        {
            "songId": "NIGHT OF FIRE",
            "category": "POPS＆アニメ",
            "title": "NIGHT OF FIRE",
            "artist": "NIKO [cover]",
            "bpm": 155,
            "imageName": "d44968b214d617f0cda2e0fcd09a4dbeb6e5ee5a5ca85260ca0067f40ad9b5e4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 118,
                        "hold": 26,
                        "slide": 2,
                        "touch": null,
                        "break": 3,
                        "total": 149
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 38,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 156,
                        "hold": 43,
                        "slide": 5,
                        "touch": null,
                        "break": 10,
                        "total": 214
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 38,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 46,
                        "slide": 11,
                        "touch": null,
                        "break": 3,
                        "total": 249
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 38,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "maimai TEAM",
                    "noteCounts": {
                        "tap": 298,
                        "hold": 35,
                        "slide": 10,
                        "touch": null,
                        "break": 13,
                        "total": 356
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 38,
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "nof",
                "卧槽",
                "夜火",
                "头文字d",
                "奶头发炎",
                "男同fire",
                "目害",
                "逮虾户",
                "闪瞎你眼"
            ]
        },
        {
            "songId": "come again",
            "category": "POPS＆アニメ",
            "title": "come again",
            "artist": "m-flo [cover]",
            "bpm": 130,
            "imageName": "aec5f7ca603c8e8f9b10727beb4b8788f40db9ee6135d81d3ab51f328530663f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 95,
                        "hold": 6,
                        "slide": 3,
                        "touch": null,
                        "break": 1,
                        "total": 105
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 40,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 88,
                        "hold": 21,
                        "slide": 7,
                        "touch": null,
                        "break": 2,
                        "total": 118
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 40,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 139,
                        "hold": 55,
                        "slide": 14,
                        "touch": null,
                        "break": 2,
                        "total": 210
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 40,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 45,
                        "slide": 17,
                        "touch": null,
                        "break": 3,
                        "total": 264
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 40,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "cum again",
                "再冲一次",
                "再来",
                "再来一遍",
                "舞立方踩在脚下"
            ]
        },
        {
            "songId": "jelly",
            "category": "POPS＆アニメ",
            "title": "jelly",
            "artist": "capsule [cover]",
            "bpm": 128,
            "imageName": "6afdbb97043881ed642025b5bd1b0c4f7e0d016de68a75914c40b277af78600a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 97,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 3,
                        "total": 108
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 42,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 119,
                        "hold": 29,
                        "slide": 4,
                        "touch": null,
                        "break": 10,
                        "total": 162
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 42,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 50,
                        "slide": 11,
                        "touch": null,
                        "break": 6,
                        "total": 256
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 42,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 17,
                        "slide": 21,
                        "touch": null,
                        "break": 3,
                        "total": 346
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 42,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM PLUS": 12.4,
                        "UNiVERSE PLUS": 12.4
                    },
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "果冻"
            ]
        },
        {
            "songId": "ハッピーシンセサイザ",
            "category": "niconico＆ボーカロイド",
            "title": "ハッピーシンセサイザ",
            "artist": "EasyPop",
            "bpm": 127,
            "imageName": "d50b183c7ecec41cb3b77c7200775af5265159e635e492cb2c29c5998a594100",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 2,
                        "slide": 2,
                        "touch": 7,
                        "break": 5,
                        "total": 119
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 10044,
                    "releaseDate": "2024-03-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 150,
                        "hold": 4,
                        "slide": 4,
                        "touch": 7,
                        "break": 8,
                        "total": 173
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 10044,
                    "releaseDate": "2024-03-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 24,
                        "slide": 26,
                        "touch": 12,
                        "break": 12,
                        "total": 250
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 10044,
                    "releaseDate": "2024-03-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 376,
                        "hold": 38,
                        "slide": 46,
                        "touch": 23,
                        "break": 25,
                        "total": 508
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 10044,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2024-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 108,
                        "hold": 2,
                        "slide": 1,
                        "touch": null,
                        "break": 3,
                        "total": 114
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 44,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 18,
                        "slide": 6,
                        "touch": null,
                        "break": 8,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 44,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 27,
                        "slide": 9,
                        "touch": null,
                        "break": 4,
                        "total": 280
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 44,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 236,
                        "hold": 27,
                        "slide": 30,
                        "touch": null,
                        "break": 4,
                        "total": 297
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 44,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ルカルカ★ナイトフィーバー",
            "category": "niconico＆ボーカロイド",
            "title": "ルカルカ★ナイトフィーバー",
            "artist": "samfree",
            "bpm": 160,
            "imageName": "60d9a30b081742b5608982a916db02b6e29af4262a215f41df2f587d12be9e30",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 0,
                        "slide": 7,
                        "touch": null,
                        "break": 2,
                        "total": 114
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 46,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 213,
                        "hold": 7,
                        "slide": 3,
                        "touch": null,
                        "break": 7,
                        "total": 230
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 46,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 50,
                        "slide": 5,
                        "touch": null,
                        "break": 6,
                        "total": 260
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 46,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 319,
                        "hold": 34,
                        "slide": 14,
                        "touch": null,
                        "break": 14,
                        "total": 381
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 46,
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "luka",
                "rukaruka",
                "和谐你全家",
                "夜里发烧",
                "河蟹你全家",
                "绿坝娘",
                "露卡露卡"
            ]
        },
        {
            "songId": "源平大戦絵巻テーマソング",
            "category": "ゲーム＆バラエティ",
            "title": "源平大戦絵巻テーマソング",
            "artist": "新小田夢童 ＆ キラ★ロッソ",
            "bpm": 190,
            "imageName": "f3cd18713b04f55c21016495100937bec0b7220b30387bd3782390757812c037",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 11,
                        "slide": 12,
                        "touch": null,
                        "break": 2,
                        "total": 152
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 47,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 178,
                        "hold": 29,
                        "slide": 5,
                        "touch": null,
                        "break": 19,
                        "total": 231
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 47,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 312,
                        "hold": 12,
                        "slide": 20,
                        "touch": null,
                        "break": 32,
                        "total": 376
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 47,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 325,
                        "hold": 32,
                        "slide": 50,
                        "touch": null,
                        "break": 21,
                        "total": 428
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 47,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "舞舞10年ズ（チャンとはっぴー）",
                    "noteCounts": {
                        "tap": 512,
                        "hold": 16,
                        "slide": 144,
                        "touch": null,
                        "break": 50,
                        "total": 722
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 47,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL": 14.4,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6,
                        "UNiVERSE PLUS": 14.4
                    },
                    "releaseDate": "2022-07-10"
                }
            ],
            "searchAcronyms": [
                "op",
                "op大战汉奸",
                "op大战罕见",
                "原批",
                "原批大战罕见",
                "叩大战东雪莲",
                "有灯大战没灯",
                "淳平大战德川",
                "源平",
                "源平1",
                "源平大战",
                "源平大战绘卷",
                "臀p大战mai批"
            ]
        },
        {
            "songId": "美しく燃える森",
            "category": "POPS＆アニメ",
            "title": "美しく燃える森",
            "artist": "東京スカパラダイスオーケストラ [cover]",
            "bpm": 140,
            "imageName": "b03cb398a552446f204ccd3d16b0f9fa52eb9f90bae5070c90f102bf215ca9ef",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 120,
                        "hold": 8,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 134
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 53,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 177,
                        "hold": 15,
                        "slide": 6,
                        "touch": null,
                        "break": 1,
                        "total": 199
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 53,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 179,
                        "hold": 39,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 230
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 53,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "畳返し",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 21,
                        "slide": 1,
                        "touch": null,
                        "break": 4,
                        "total": 375
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 53,
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "美燃森"
            ]
        },
        {
            "songId": "ウッーウッーウマウマ(ﾟ∀ﾟ)",
            "category": "POPS＆アニメ",
            "title": "ウッーウッーウマウマ(ﾟ∀ﾟ)",
            "artist": "Caramell/Caramelldansen [cover]",
            "bpm": 164,
            "imageName": "7dfcc54368f3e0dcbc30dc8e394802817ea61dba8c7a9f0583697c903d02ea4e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 222,
                        "hold": 2,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 230
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 56,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 314,
                        "hold": 6,
                        "slide": 12,
                        "touch": null,
                        "break": 2,
                        "total": 334
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 56,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 413,
                        "hold": 0,
                        "slide": 5,
                        "touch": null,
                        "break": 8,
                        "total": 426
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 56,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 514,
                        "hold": 1,
                        "slide": 11,
                        "touch": null,
                        "break": 16,
                        "total": 542
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 56,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.7,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 11.8
                    },
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "(ﾟ∀ﾟ)",
                "呜哇呜哇",
                "扭秧歌",
                "扭腰",
                "扭腰歌",
                "跳舞歌"
            ]
        },
        {
            "songId": "Beat Of Mind",
            "category": "ゲーム＆バラエティ",
            "title": "Beat Of Mind",
            "artist": "Hiro「Crackin’DJ」",
            "bpm": 140,
            "imageName": "96246c9fe1f280ed589042129b57eca5b1523781f61de4100f338cc91f015e2f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 181,
                        "hold": 9,
                        "slide": 4,
                        "touch": null,
                        "break": 3,
                        "total": 197
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 61,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 14,
                        "slide": 6,
                        "touch": null,
                        "break": 8,
                        "total": 286
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 61,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 27,
                        "slide": 19,
                        "touch": null,
                        "break": 4,
                        "total": 402
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 61,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 94,
                        "slide": 12,
                        "touch": null,
                        "break": 15,
                        "total": 351
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 61,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 595,
                        "hold": 42,
                        "slide": 129,
                        "touch": null,
                        "break": 11,
                        "total": 777
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 61,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14.2,
                        "FESTiVAL PLUS": 14.2,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "Splash": 14,
                        "Splash PLUS": 14.2,
                        "UNiVERSE": 14.2,
                        "UNiVERSE PLUS": 14.2,
                        "maimaiでらっくす PLUS": 14.5
                    },
                    "releaseDate": "2017-12-04"
                }
            ],
            "searchAcronyms": [
                "bom",
                "nmb的mai",
                "你妈逼",
                "你麻痹的mai",
                "心跳",
                "打脑阔",
                "红鼻子男",
                "给你脑袋来一拳"
            ]
        },
        {
            "songId": "檄！帝国華撃団(改)",
            "category": "ゲーム＆バラエティ",
            "title": "檄！帝国華撃団(改)",
            "artist": "「サクラ大戦」",
            "bpm": 144,
            "imageName": "4ef943793b1609d2c9aced860620edb312b49f713d2953197f6f67b466b5bf42",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 14,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 125
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 62,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 21,
                        "slide": 13,
                        "touch": null,
                        "break": 27,
                        "total": 203
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 62,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 25,
                        "slide": 43,
                        "touch": null,
                        "break": 12,
                        "total": 205
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 62,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 36,
                        "slide": 45,
                        "touch": null,
                        "break": 8,
                        "total": 235
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 62,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 329,
                        "hold": 31,
                        "slide": 69,
                        "touch": null,
                        "break": 44,
                        "total": 473
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 62,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.1,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2016-08-10"
                }
            ],
            "searchAcronyms": [
                "帝国华击团",
                "帝国滑稽团",
                "樱花大战",
                "樱花大战2",
                "滑稽团"
            ]
        },
        {
            "songId": "メランコリック",
            "category": "niconico＆ボーカロイド",
            "title": "メランコリック",
            "artist": "Junky",
            "bpm": 140,
            "imageName": "ffb83983cbc71593a52fd24b382843c1238844a5c7810d3445b624fad114e58f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 26,
                        "slide": 10,
                        "touch": null,
                        "break": 2,
                        "total": 192
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 63,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 9,
                        "slide": 10,
                        "touch": null,
                        "break": 3,
                        "total": 197
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 63,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "maimai TEAM",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 44,
                        "slide": 19,
                        "touch": null,
                        "break": 8,
                        "total": 274
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 63,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "maimai TEAM",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 52,
                        "slide": 26,
                        "touch": null,
                        "break": 4,
                        "total": 323
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 63,
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "melancholic",
                "忧郁的心情"
            ]
        },
        {
            "songId": "教えて!! 魔法のLyric",
            "category": "niconico＆ボーカロイド",
            "title": "教えて!! 魔法のLyric",
            "artist": "ちょむP <advanced mix>",
            "bpm": 180,
            "imageName": "1b03943a61f4c1998a251cab2d3fe974976f2f24fdd2b73da67ce08ebb13e9ed",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 177,
                        "hold": 19,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 210
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 64,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 33,
                        "slide": 8,
                        "touch": null,
                        "break": 3,
                        "total": 253
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 64,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "maimai TEAM",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 60,
                        "slide": 11,
                        "touch": null,
                        "break": 4,
                        "total": 326
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 64,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "maimai TEAM",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 24,
                        "slide": 7,
                        "touch": null,
                        "break": 36,
                        "total": 424
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 64,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "教",
                "教我魔法",
                "教教",
                "教魔法"
            ]
        },
        {
            "songId": "ZIGG-ZAGG",
            "category": "niconico＆ボーカロイド",
            "title": "ZIGG-ZAGG",
            "artist": "Junky",
            "bpm": 138,
            "imageName": "5acaf37d4fc31eeb79a687994ab28c42174ea636ef025d3327c56c9bd73b4f50",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 192,
                        "hold": 20,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 222
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 65,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 155,
                        "hold": 20,
                        "slide": 6,
                        "touch": null,
                        "break": 8,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 65,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "maimai TEAM",
                    "noteCounts": {
                        "tap": 235,
                        "hold": 31,
                        "slide": 18,
                        "touch": null,
                        "break": 7,
                        "total": 291
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 65,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "maimai TEAM",
                    "noteCounts": {
                        "tap": 265,
                        "hold": 29,
                        "slide": 33,
                        "touch": null,
                        "break": 4,
                        "total": 331
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 65,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 208,
                        "hold": 28,
                        "slide": 116,
                        "touch": null,
                        "break": 6,
                        "total": 358
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 65,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2017-07-10"
                }
            ],
            "searchAcronyms": [
                "zigg",
                "几个咋个"
            ]
        },
        {
            "songId": "ワールズエンド・ダンスホール",
            "category": "niconico＆ボーカロイド",
            "title": "ワールズエンド・ダンスホール",
            "artist": "wowaka",
            "bpm": 171,
            "imageName": "e6b8aa404daa7510f325bb5e5ec931f3350b7cc20451ad9540c4b7ef05e1ef81",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 17,
                        "slide": 14,
                        "touch": null,
                        "break": 2,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 66,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 32,
                        "slide": 10,
                        "touch": null,
                        "break": 4,
                        "total": 258
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 66,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 27,
                        "slide": 17,
                        "touch": null,
                        "break": 4,
                        "total": 328
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 66,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 416,
                        "hold": 0,
                        "slide": 20,
                        "touch": null,
                        "break": 28,
                        "total": 464
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 66,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM": 12.9,
                        "PRiSM PLUS": 13,
                        "Splash": 12.3,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 461,
                        "hold": 62,
                        "slide": 100,
                        "touch": null,
                        "break": 13,
                        "total": 636
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 66,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2015-08-12"
                }
            ],
            "searchAcronyms": [
                "WORLD'S END DANCE HALL",
                "世末舞厅",
                "世终舞厅",
                "双关门",
                "末世舞厅",
                "舞厅"
            ]
        },
        {
            "songId": "パンダヒーロー",
            "category": "niconico＆ボーカロイド",
            "title": "パンダヒーロー",
            "artist": "ハチ",
            "bpm": 190,
            "imageName": "f60328914aaafa072e3611d051edf4d18560e9019f71630a28bd063c5e981694",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 6,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 67,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 49,
                        "slide": 5,
                        "touch": null,
                        "break": 9,
                        "total": 205
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 67,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "maimai TEAM",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 52,
                        "slide": 13,
                        "touch": null,
                        "break": 4,
                        "total": 278
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 67,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 91,
                        "slide": 17,
                        "touch": null,
                        "break": 13,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 67,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL": 12.4,
                        "PRiSM PLUS": 12.4,
                        "UNiVERSE PLUS": 12.4
                    },
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "panda hero",
                "会员制餐厅",
                "熊猫英雄"
            ]
        },
        {
            "songId": "オレンジの夏",
            "category": "maimai",
            "title": "オレンジの夏",
            "artist": "Hiro/タクマロ",
            "bpm": 132,
            "imageName": "74d6f9350a8cf42d8f09355e56abd76da6dc94edd708e2aec0b8182fb359bd80",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 15,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 179
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 68,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 49,
                        "slide": 7,
                        "touch": null,
                        "break": 1,
                        "total": 211
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 68,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 221,
                        "hold": 31,
                        "slide": 16,
                        "touch": null,
                        "break": 7,
                        "total": 275
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 68,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 33,
                        "slide": 29,
                        "touch": null,
                        "break": 16,
                        "total": 371
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 68,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "🎞️",
                "夏",
                "女人骑自行车",
                "橙色夏天",
                "橙色的夏天",
                "洋车的",
                "自行车",
                "菊次郎的夏天"
            ]
        },
        {
            "songId": "BaBan!! －甘い罠－",
            "category": "maimai",
            "title": "BaBan!! －甘い罠－",
            "artist": "Hiro/永江理奈",
            "bpm": 161,
            "imageName": "7d364631c640d66e04a9b489904eda870016e1b7fbca1c010f608d3a786b8b4b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 7,
                        "slide": 4,
                        "touch": null,
                        "break": 3,
                        "total": 200
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 69,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 45,
                        "slide": 5,
                        "touch": null,
                        "break": 4,
                        "total": 288
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 69,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 236,
                        "hold": 75,
                        "slide": 18,
                        "touch": null,
                        "break": 4,
                        "total": 333
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 69,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.3,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.3,
                        "UNiVERSE PLUS": 12.3
                    },
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "maimai TEAM",
                    "noteCounts": {
                        "tap": 381,
                        "hold": 48,
                        "slide": 20,
                        "touch": null,
                        "break": 8,
                        "total": 457
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 69,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "baban",
                "八班",
                "甘民",
                "甜蜜陷阱"
            ]
        },
        {
            "songId": "ジングルベル",
            "category": "maimai",
            "title": "ジングルベル",
            "artist": "SEGA Sound Unit [H.]",
            "bpm": 100,
            "imageName": "671128a0c103a5de70afc3d6a4eeb123d3afb4d79ef092de0022bba4543efd68",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 144,
                        "hold": 12,
                        "slide": 3,
                        "touch": 6,
                        "break": 10,
                        "total": 175
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10070,
                    "releaseDate": "2022-12-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 242,
                        "hold": 9,
                        "slide": 6,
                        "touch": 23,
                        "break": 4,
                        "total": 284
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10070,
                    "releaseDate": "2022-12-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 266,
                        "hold": 36,
                        "slide": 21,
                        "touch": 27,
                        "break": 77,
                        "total": 427
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10070,
                    "releaseDate": "2022-12-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "舞舞10年ズ ～ファイナル～",
                    "noteCounts": {
                        "tap": 377,
                        "hold": 99,
                        "slide": 26,
                        "touch": 302,
                        "break": 125,
                        "total": 929
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10070,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL": 14.7,
                        "FESTiVAL PLUS": 14.7,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6
                    },
                    "releaseDate": "2022-12-22"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 139,
                        "hold": 13,
                        "slide": 2,
                        "touch": null,
                        "break": 3,
                        "total": 157
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 70,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 149,
                        "hold": 26,
                        "slide": 5,
                        "touch": null,
                        "break": 5,
                        "total": 185
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 70,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 18,
                        "slide": 18,
                        "touch": null,
                        "break": 14,
                        "total": 332
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 70,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 564,
                        "hold": 27,
                        "slide": 37,
                        "touch": null,
                        "break": 20,
                        "total": 648
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 70,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14,
                        "FESTiVAL PLUS": 14.3,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "Splash": 14,
                        "Splash PLUS": 14,
                        "UNiVERSE": 14,
                        "UNiVERSE PLUS": 14,
                        "maimaiでらっくす PLUS": 14.4
                    },
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 450,
                        "hold": 63,
                        "slide": 124,
                        "touch": null,
                        "break": 100,
                        "total": 737
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 70,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14,
                        "FESTiVAL PLUS": 14.2,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "Splash": 14,
                        "Splash PLUS": 14,
                        "UNiVERSE": 14,
                        "UNiVERSE PLUS": 14,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2018-12-24"
                }
            ],
            "searchAcronyms": [
                "🎄",
                "dxjb",
                "dx圣诞",
                "dx圣诞歌",
                "jb",
                "jingle bell",
                "Jingle Bell",
                "Jingle Bells",
                "剩蛋歌",
                "圣诞",
                "圣诞树",
                "圣诞歌",
                "标准圣诞",
                "金勾八",
                "铃儿响叮当",
                "鬼歌",
                "鸡公煲"
            ]
        },
        {
            "songId": "マトリョシカ",
            "category": "niconico＆ボーカロイド",
            "title": "マトリョシカ",
            "artist": "ハチ",
            "bpm": 205,
            "imageName": "c6b7879f31eeb8fcb8792c3b8de5c4d6e65dc6ccc8fc41c4aab9f73ec8dcd576",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 191,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 3,
                        "total": 202
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 71,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 10,
                        "slide": 11,
                        "touch": null,
                        "break": 12,
                        "total": 229
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 71,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "maimai TEAM",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 35,
                        "slide": 11,
                        "touch": null,
                        "break": 13,
                        "total": 356
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 71,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 422,
                        "hold": 7,
                        "slide": 17,
                        "touch": null,
                        "break": 8,
                        "total": 454
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 71,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 395,
                        "hold": 26,
                        "slide": 127,
                        "touch": null,
                        "break": 23,
                        "total": 571
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 71,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2015-05-13"
                }
            ],
            "searchAcronyms": [
                "😋🤗",
                "MATRYOSHKA",
                "俄罗斯套娃",
                "套娃"
            ]
        },
        {
            "songId": "メグメグ☆ファイアーエンドレスナイト",
            "category": "niconico＆ボーカロイド",
            "title": "メグメグ☆ファイアーエンドレスナイト",
            "artist": "samfree",
            "bpm": 162,
            "imageName": "74435d5e5118d95b7b691383d2f4e3cb55a9581822b15e1849b24537e9d22c9b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 147,
                        "hold": 12,
                        "slide": 3,
                        "touch": null,
                        "break": 3,
                        "total": 165
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 73,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 12,
                        "slide": 12,
                        "touch": null,
                        "break": 4,
                        "total": 258
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 73,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "maimai TEAM",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 34,
                        "slide": 18,
                        "touch": null,
                        "break": 9,
                        "total": 288
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 73,
                    "releaseDate": "2012-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "maimai TEAM",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 21,
                        "slide": 15,
                        "touch": null,
                        "break": 7,
                        "total": 381
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 73,
                    "releaseDate": "2012-07-11"
                }
            ],
            "searchAcronyms": [
                "megu",
                "火柴人大战"
            ]
        },
        {
            "songId": "きみのためなら死ねる",
            "category": "ゲーム＆バラエティ",
            "title": "きみのためなら死ねる",
            "artist": "スーパーラバーズ「きみのためなら死ねる」",
            "bpm": 147,
            "imageName": "979c58233cb3095331444872ee907cd8aadbee4810a6ed9c74b5099bbd531716",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 132,
                        "hold": 8,
                        "slide": 4,
                        "touch": null,
                        "break": 8,
                        "total": 152
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 76,
                    "releaseDate": "2012-09-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 31,
                        "slide": 5,
                        "touch": null,
                        "break": 9,
                        "total": 220
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 76,
                    "releaseDate": "2012-09-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 30,
                        "slide": 23,
                        "touch": null,
                        "break": 11,
                        "total": 439
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 76,
                    "releaseDate": "2012-09-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 438,
                        "hold": 56,
                        "slide": 12,
                        "touch": null,
                        "break": 11,
                        "total": 517
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 76,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash": 12
                    },
                    "releaseDate": "2012-09-13"
                }
            ],
            "searchAcronyms": [
                "为了你而死",
                "为你而死",
                "失败的man",
                "死"
            ]
        },
        {
            "songId": "怪盗Rのテーマ",
            "category": "ゲーム＆バラエティ",
            "title": "怪盗Rのテーマ",
            "artist": "大谷智哉「リズム怪盗R 皇帝ナポレオンの遺産」",
            "bpm": 147,
            "imageName": "7408bb9187adab91641af8200bc56f409efa311c1c177acb5073c2e9f7d4a94c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 136,
                        "hold": 11,
                        "slide": 4,
                        "touch": 13,
                        "break": 5,
                        "total": 169
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 226,
                        "hold": 12,
                        "slide": 8,
                        "touch": 26,
                        "break": 6,
                        "total": 278
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 281,
                        "hold": 65,
                        "slide": 46,
                        "touch": 9,
                        "break": 40,
                        "total": 441
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 423,
                        "hold": 67,
                        "slide": 85,
                        "touch": 33,
                        "break": 39,
                        "total": 647
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2
                    },
                    "releaseDate": "2025-10-15"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 14,
                        "slide": 10,
                        "touch": null,
                        "break": 6,
                        "total": 165
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 77,
                    "releaseDate": "2012-09-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 140,
                        "hold": 53,
                        "slide": 6,
                        "touch": null,
                        "break": 9,
                        "total": 208
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 77,
                    "releaseDate": "2012-09-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 74,
                        "slide": 13,
                        "touch": null,
                        "break": 7,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 77,
                    "releaseDate": "2012-09-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 366,
                        "hold": 59,
                        "slide": 37,
                        "touch": null,
                        "break": 12,
                        "total": 474
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 77,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2012-09-13"
                }
            ],
            "searchAcronyms": [
                "怪盗",
                "怪盗r",
                "怪盗R",
                "怪盗r的影之诗",
                "节奏怪盗"
            ]
        },
        {
            "songId": "マリアをはげませ",
            "category": "ゲーム＆バラエティ",
            "title": "マリアをはげませ",
            "artist": "大谷智哉「リズム怪盗R 皇帝ナポレオンの遺産」",
            "bpm": 131,
            "imageName": "c04f73eef0cfada07d538b6147b5c4233b4958cdbea53dfd56bea2d08163d8c6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 14,
                        "slide": 7,
                        "touch": null,
                        "break": 4,
                        "total": 134
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 78,
                    "releaseDate": "2012-09-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 217,
                        "hold": 16,
                        "slide": 7,
                        "touch": null,
                        "break": 3,
                        "total": 243
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 78,
                    "releaseDate": "2012-09-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 41,
                        "slide": 16,
                        "touch": null,
                        "break": 12,
                        "total": 331
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 78,
                    "releaseDate": "2012-09-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 368,
                        "hold": 43,
                        "slide": 33,
                        "touch": null,
                        "break": 8,
                        "total": 452
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 78,
                    "releaseDate": "2012-09-13"
                }
            ],
            "searchAcronyms": [
                "玛利亚"
            ]
        },
        {
            "songId": "SHOW TIME",
            "category": "ゲーム＆バラエティ",
            "title": "SHOW TIME",
            "artist": "幡谷尚史「リズム怪盗R 皇帝ナポレオンの遺産」",
            "bpm": 120,
            "imageName": "d0154320d9112a682d478f39f31d1b32bdcd5fa12b1407a82ab53083ade222a8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 97,
                        "hold": 5,
                        "slide": 9,
                        "touch": null,
                        "break": 9,
                        "total": 120
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 79,
                    "releaseDate": "2012-09-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 11,
                        "slide": 14,
                        "touch": null,
                        "break": 9,
                        "total": 171
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 79,
                    "releaseDate": "2012-09-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 170,
                        "hold": 34,
                        "slide": 7,
                        "touch": null,
                        "break": 5,
                        "total": 216
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 79,
                    "releaseDate": "2012-09-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 213,
                        "hold": 38,
                        "slide": 27,
                        "touch": null,
                        "break": 13,
                        "total": 291
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 79,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash": 12
                    },
                    "releaseDate": "2012-09-13"
                }
            ],
            "searchAcronyms": [
                "怪盗基德"
            ]
        },
        {
            "songId": "JACKY [Remix]",
            "category": "ゲーム＆バラエティ",
            "title": "JACKY [Remix]",
            "artist": "「バーチャファイター」",
            "bpm": 135,
            "imageName": "27b9c248df629f9c5e10ae772fea7bfe7777feda9f03fed0ea1e17dcb7f358e6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 107,
                        "hold": 5,
                        "slide": 3,
                        "touch": null,
                        "break": 4,
                        "total": 119
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 85,
                    "releaseDate": "2012-09-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 12,
                        "slide": 12,
                        "touch": null,
                        "break": 9,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 85,
                    "releaseDate": "2012-09-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 270,
                        "hold": 26,
                        "slide": 8,
                        "touch": null,
                        "break": 14,
                        "total": 318
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 85,
                    "releaseDate": "2012-09-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 298,
                        "hold": 3,
                        "slide": 73,
                        "touch": null,
                        "break": 12,
                        "total": 386
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 85,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2012-09-13"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 424,
                        "hold": 17,
                        "slide": 59,
                        "touch": null,
                        "break": 46,
                        "total": 546
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 85,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "UNiVERSE PLUS": 13.5
                    },
                    "releaseDate": "2020-10-22"
                }
            ],
            "searchAcronyms": [
                "jacky",
                "vr战士",
                "成龙",
                "舞萌往事"
            ]
        },
        {
            "songId": "天国と地獄",
            "category": "ゲーム＆バラエティ",
            "title": "天国と地獄",
            "artist": "スーパーラバーズ「赤ちゃんはどこからくるの？」",
            "bpm": 175,
            "imageName": "9edfc466a9b478c21c14cb8758059cdfe0ba88bcb47fccd314f7841a16d2024f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 21,
                        "slide": 12,
                        "touch": null,
                        "break": 4,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 75,
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 242,
                        "hold": 16,
                        "slide": 18,
                        "touch": null,
                        "break": 11,
                        "total": 287
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 75,
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 398,
                        "hold": 12,
                        "slide": 4,
                        "touch": null,
                        "break": 128,
                        "total": 542
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 75,
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 530,
                        "hold": 12,
                        "slide": 50,
                        "touch": null,
                        "break": 15,
                        "total": 607
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 75,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.4
                    },
                    "releaseDate": "2012-11-07"
                }
            ],
            "searchAcronyms": [
                "为你而生",
                "地狱中的奥菲欧",
                "天国与地狱",
                "天国地狱",
                "康康舞曲",
                "绝赞128",
                "菠菜进行曲"
            ]
        },
        {
            "songId": "City Escape: Act1",
            "category": "ゲーム＆バラエティ",
            "title": "City Escape: Act1",
            "artist": "Cash Cash「ソニック ジェネレーションズ」",
            "bpm": 130,
            "imageName": "066460b949fdf510358e5e654f5949fda4b01596a97a1d6efa0d24af96990ee2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 133,
                        "hold": 9,
                        "slide": 7,
                        "touch": null,
                        "break": 6,
                        "total": 155
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 80,
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 181,
                        "hold": 8,
                        "slide": 10,
                        "touch": null,
                        "break": 11,
                        "total": 210
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 80,
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 246,
                        "hold": 63,
                        "slide": 12,
                        "touch": null,
                        "break": 10,
                        "total": 331
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 80,
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 438,
                        "hold": 10,
                        "slide": 35,
                        "touch": null,
                        "break": 29,
                        "total": 512
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 80,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 428,
                        "hold": 8,
                        "slide": 129,
                        "touch": null,
                        "break": 24,
                        "total": 589
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 80,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2016-08-10"
                }
            ],
            "searchAcronyms": [
                "act1",
                "刺猬头跑酷",
                "索1"
            ]
        },
        {
            "songId": "Rooftop Run: Act1",
            "category": "ゲーム＆バラエティ",
            "title": "Rooftop Run: Act1",
            "artist": "大谷智哉「ソニック ジェネレーションズ」",
            "bpm": 152,
            "imageName": "443feff2b656fb8d71d2561ae3946223e2fc66c7176360f58b3d7d35f7d0120c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 126,
                        "hold": 17,
                        "slide": 0,
                        "touch": null,
                        "break": 3,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 81,
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 225,
                        "hold": 30,
                        "slide": 2,
                        "touch": null,
                        "break": 6,
                        "total": 263
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 81,
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 86,
                        "slide": 11,
                        "touch": null,
                        "break": 2,
                        "total": 384
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 81,
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 348,
                        "hold": 81,
                        "slide": 21,
                        "touch": null,
                        "break": 7,
                        "total": 457
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 81,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.4,
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL PLUS": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 414,
                        "hold": 116,
                        "slide": 78,
                        "touch": null,
                        "break": 15,
                        "total": 623
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 81,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2016-09-21"
                }
            ],
            "searchAcronyms": [
                "屋顶跑路：动作1",
                "索2",
                "逃离屋顶"
            ]
        },
        {
            "songId": "Reach For The Stars",
            "category": "ゲーム＆バラエティ",
            "title": "Reach For The Stars",
            "artist": "大谷智哉, Jean Paul Makhlouf of Cash Cash「ソニック カラーズ」",
            "bpm": 203,
            "imageName": "92fa2c16e9e454eac925e00f203fb3f4c78ce41c707fc05884d9617f132a0d49",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 68,
                        "hold": 21,
                        "slide": 7,
                        "touch": null,
                        "break": 1,
                        "total": 97
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 82,
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 20,
                        "slide": 5,
                        "touch": null,
                        "break": 13,
                        "total": 241
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 82,
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 274,
                        "hold": 61,
                        "slide": 26,
                        "touch": null,
                        "break": 34,
                        "total": 395
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 82,
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 456,
                        "hold": 29,
                        "slide": 50,
                        "touch": null,
                        "break": 14,
                        "total": 549
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 82,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.6,
                        "Splash PLUS": 13.6,
                        "UNiVERSE": 13.6,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2012-11-07"
                }
            ],
            "searchAcronyms": [
                "一拳超人",
                "摘星",
                "立直为了星",
                "索3",
                "索尼克缤纷色彩",
                "给你🐴来一拳",
                "追星"
            ]
        },
        {
            "songId": "Urban Crusher [Remix]",
            "category": "ゲーム＆バラエティ",
            "title": "Urban Crusher [Remix]",
            "artist": "「BORDER BREAK」",
            "bpm": 155,
            "imageName": "9ddf6ef386f382c50f80f822b6b646c623152622a2d3febd510082a26d695fa5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 104,
                        "hold": 14,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 130
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 83,
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 260,
                        "hold": 15,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 283
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 83,
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 390,
                        "hold": 33,
                        "slide": 10,
                        "touch": null,
                        "break": 13,
                        "total": 446
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 83,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.2
                    },
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 396,
                        "hold": 46,
                        "slide": 25,
                        "touch": null,
                        "break": 9,
                        "total": 476
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 83,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.2
                    },
                    "releaseDate": "2012-11-07"
                }
            ],
            "searchAcronyms": [
                "uc",
                "urbancrusher",
                "汽车人",
                "波尔布特",
                "泰坦陨落",
                "高达"
            ]
        },
        {
            "songId": "Catch The Future",
            "category": "ゲーム＆バラエティ",
            "title": "Catch The Future",
            "artist": "「BORDER BREAK UNION」メインテーマ",
            "bpm": 210,
            "imageName": "2a66a29cbcb6498ea3fac86ca035985ea4572f16c7fa476b688982069c840769",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 9,
                        "slide": 3,
                        "touch": null,
                        "break": 4,
                        "total": 141
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 84,
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 216,
                        "hold": 20,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 243
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 84,
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 216,
                        "hold": 27,
                        "slide": 34,
                        "touch": null,
                        "break": 10,
                        "total": 287
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 84,
                    "releaseDate": "2012-11-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 28,
                        "slide": 66,
                        "touch": null,
                        "break": 2,
                        "total": 391
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai",
                    "internalId": 84,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.3
                    },
                    "releaseDate": "2012-11-07"
                }
            ],
            "searchAcronyms": [
                "抓住未来",
                "洋葱"
            ]
        },
        {
            "songId": "おちゃめ機能",
            "category": "niconico＆ボーカロイド",
            "title": "おちゃめ機能",
            "artist": "ゴジマジP",
            "bpm": 150,
            "imageName": "8063bec48407182b0e1bc47ecea09d8b5484edd3fa602c872eae7aa70eabf57c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 107,
                        "hold": 7,
                        "slide": 3,
                        "touch": null,
                        "break": 11,
                        "total": 128
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 101,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 236,
                        "hold": 20,
                        "slide": 10,
                        "touch": null,
                        "break": 10,
                        "total": 276
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 101,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 55,
                        "slide": 13,
                        "touch": null,
                        "break": 9,
                        "total": 277
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 101,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 443,
                        "hold": 19,
                        "slide": 9,
                        "touch": null,
                        "break": 28,
                        "total": 499
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 101,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.4,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12
                    },
                    "releaseDate": "2012-12-13"
                }
            ],
            "searchAcronyms": [
                "ochamekinou",
                "五月病",
                "天真浪漫机能",
                "天真烂漫机能",
                "机能"
            ]
        },
        {
            "songId": "ダンシング☆サムライ",
            "category": "niconico＆ボーカロイド",
            "title": "ダンシング☆サムライ",
            "artist": "mathru(かにみそP)",
            "bpm": 142,
            "imageName": "2b39236b3227a69e8fb30b8388db240daed14754d00782b6c7bbc8d38f82c573",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 131,
                        "hold": 0,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 139
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 102,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 248,
                        "hold": 36,
                        "slide": 12,
                        "touch": null,
                        "break": 21,
                        "total": 317
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 102,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 238,
                        "hold": 73,
                        "slide": 59,
                        "touch": null,
                        "break": 17,
                        "total": 387
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 102,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 495,
                        "hold": 24,
                        "slide": 36,
                        "touch": null,
                        "break": 9,
                        "total": 564
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 102,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.1
                    },
                    "releaseDate": "2012-12-13"
                }
            ],
            "searchAcronyms": [
                "🍆",
                "🍆🗻",
                "dancing samurai",
                "富士山茄子",
                "茄子先生",
                "茄子哥",
                "茄子山",
                "茄子武士",
                "跳舞武士"
            ]
        },
        {
            "songId": "BAD∞END∞NIGHT",
            "category": "niconico＆ボーカロイド",
            "title": "BAD∞END∞NIGHT",
            "artist": "ひとしずくP・やま△",
            "bpm": 204,
            "imageName": "5e773dbef94ce6e9b693d0ffb44690fe941d372aec9b4dbf78d7005c7b695bf5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 8,
                        "slide": 4,
                        "touch": 12,
                        "break": 9,
                        "total": 179
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 12,
                        "slide": 6,
                        "touch": 13,
                        "break": 12,
                        "total": 272
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 45,
                        "slide": 33,
                        "touch": 9,
                        "break": 72,
                        "total": 421
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "メロンポップ",
                    "noteCounts": {
                        "tap": 411,
                        "hold": 45,
                        "slide": 111,
                        "touch": 15,
                        "break": 36,
                        "total": 618
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5
                    },
                    "releaseDate": "2025-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 95,
                        "hold": 20,
                        "slide": 7,
                        "touch": null,
                        "break": 5,
                        "total": 127
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 106,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 286,
                        "hold": 10,
                        "slide": 2,
                        "touch": null,
                        "break": 16,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 106,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 50,
                        "slide": 22,
                        "touch": null,
                        "break": 5,
                        "total": 335
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 106,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 381,
                        "hold": 21,
                        "slide": 61,
                        "touch": null,
                        "break": 33,
                        "total": 496
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 106,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.6,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5,
                        "Splash": 12.8,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.2
                    },
                    "releaseDate": "2012-12-13"
                }
            ],
            "searchAcronyms": [
                "∞",
                "♾️",
                "bad end night",
                "badendnight",
                "坏结夜",
                "鬼畜公馆"
            ]
        },
        {
            "songId": "ロミオとシンデレラ",
            "category": "niconico＆ボーカロイド",
            "title": "ロミオとシンデレラ",
            "artist": "doriko",
            "bpm": 170,
            "imageName": "47b264f1192714755bbdf8f07049f27d06c866b685c413bf2ff911bac070d248",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 7,
                        "slide": 5,
                        "touch": null,
                        "break": 6,
                        "total": 143
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 107,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 166,
                        "hold": 48,
                        "slide": 4,
                        "touch": null,
                        "break": 8,
                        "total": 226
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 107,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 24,
                        "slide": 57,
                        "touch": null,
                        "break": 16,
                        "total": 273
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 107,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 390,
                        "hold": 35,
                        "slide": 16,
                        "touch": null,
                        "break": 9,
                        "total": 450
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 107,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 522,
                        "hold": 29,
                        "slide": 56,
                        "touch": null,
                        "break": 17,
                        "total": 624
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 107,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2016-09-07"
                }
            ],
            "searchAcronyms": [
                "Romeo and Cinderella",
                "灰姑娘",
                "罗密欧",
                "罗密欧与辛德瑞拉",
                "罗密欧和辛德瑞拉",
                "罗密欧辛德瑞拉",
                "辛德瑞拉"
            ]
        },
        {
            "songId": "Sweetiex2",
            "category": "niconico＆ボーカロイド",
            "title": "Sweetiex2",
            "artist": "Dixie Flatline",
            "bpm": 125,
            "imageName": "b22e0cea89a26c98e711c9293772cb3518bf139378c94f8643167074501bbf69",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 101,
                        "hold": 12,
                        "slide": 4,
                        "touch": null,
                        "break": 6,
                        "total": 123
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 108,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 19,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 223
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 108,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 31,
                        "slide": 12,
                        "touch": null,
                        "break": 8,
                        "total": 315
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 108,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 228,
                        "hold": 26,
                        "slide": 47,
                        "touch": null,
                        "break": 7,
                        "total": 308
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 108,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2012-12-13"
                }
            ],
            "searchAcronyms": [
                "教室"
            ]
        },
        {
            "songId": "腐れ外道とチョコレゐト",
            "category": "niconico＆ボーカロイド",
            "title": "腐れ外道とチョコレゐト",
            "artist": "ピノキオP",
            "bpm": 260,
            "imageName": "339031bc12f64f9d07602b85624645c8a850835c2de3f94f25a7712637b240b5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 180,
                        "hold": 23,
                        "slide": 2,
                        "touch": null,
                        "break": 1,
                        "total": 206
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 109,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 35,
                        "slide": 9,
                        "touch": null,
                        "break": 6,
                        "total": 334
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 109,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 416,
                        "hold": 54,
                        "slide": 3,
                        "touch": null,
                        "break": 12,
                        "total": 485
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 109,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 435,
                        "hold": 92,
                        "slide": 62,
                        "touch": null,
                        "break": 9,
                        "total": 598
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 109,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2012-12-13"
                }
            ],
            "searchAcronyms": [
                "🍫",
                "kusare gedou",
                "Kusare gedou to chocolate",
                "外道",
                "巧克力",
                "异端",
                "腐外道",
                "该死的异端及巧克力"
            ]
        },
        {
            "songId": "スイートマジック",
            "category": "niconico＆ボーカロイド",
            "title": "スイートマジック",
            "artist": "ろん×Junky",
            "bpm": 123,
            "imageName": "31f2fe5a9d47549648e15d46435abc418c450e0af529f70ed4127ed2eae7616d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 5,
                        "slide": 3,
                        "touch": null,
                        "break": 7,
                        "total": 161
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 121,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 170,
                        "hold": 32,
                        "slide": 10,
                        "touch": null,
                        "break": 16,
                        "total": 228
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 121,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 21,
                        "slide": 33,
                        "touch": null,
                        "break": 20,
                        "total": 389
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 121,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 303,
                        "hold": 43,
                        "slide": 39,
                        "touch": null,
                        "break": 29,
                        "total": 414
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 121,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL PLUS": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2012-12-13"
                }
            ],
            "searchAcronyms": [
                "sm",
                "sweet magic",
                "Sweet Magic",
                "sweetmagic",
                "swmg",
                "甜甜魔法",
                "甜蜜魔法"
            ]
        },
        {
            "songId": "ゴーゴー幽霊船",
            "category": "niconico＆ボーカロイド",
            "title": "ゴーゴー幽霊船",
            "artist": "米津玄師",
            "bpm": 180,
            "imageName": "271f40408574f8a63e9d0e172e47154cbd56acd9678ddc127becec270a5d9df0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 102,
                        "hold": 9,
                        "slide": 4,
                        "touch": 7,
                        "break": 2,
                        "total": 124
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 10122,
                    "releaseDate": "2025-03-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 210,
                        "hold": 16,
                        "slide": 4,
                        "touch": 28,
                        "break": 6,
                        "total": 264
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 10122,
                    "releaseDate": "2025-03-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 334,
                        "hold": 45,
                        "slide": 33,
                        "touch": 5,
                        "break": 15,
                        "total": 432
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 10122,
                    "releaseDate": "2025-03-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 309,
                        "hold": 41,
                        "slide": 101,
                        "touch": 72,
                        "break": 20,
                        "total": 543
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 10122,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2025-03-12"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 16,
                        "slide": 1,
                        "touch": null,
                        "break": 4,
                        "total": 124
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 122,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 53,
                        "slide": 1,
                        "touch": null,
                        "break": 9,
                        "total": 286
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 122,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 61,
                        "slide": 40,
                        "touch": null,
                        "break": 8,
                        "total": 348
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 122,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 270,
                        "hold": 94,
                        "slide": 18,
                        "touch": null,
                        "break": 19,
                        "total": 401
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 122,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "Splash": 12
                    },
                    "releaseDate": "2012-12-13"
                }
            ],
            "searchAcronyms": [
                "Go Go Yureisen",
                "gogo幽灵船",
                "幽灵船"
            ]
        },
        {
            "songId": "千本桜",
            "category": "niconico＆ボーカロイド",
            "title": "千本桜",
            "artist": "黒うさP",
            "bpm": 154,
            "imageName": "0595504e2f501a9f7d96d26e8f151bc0eb3a96375b6d404545c993039b6d0437",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 0,
                        "slide": 2,
                        "touch": 17,
                        "break": 2,
                        "total": 162
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10125,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 5,
                        "slide": 6,
                        "touch": 11,
                        "break": 4,
                        "total": 267
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10125,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 301,
                        "hold": 47,
                        "slide": 47,
                        "touch": 46,
                        "break": 4,
                        "total": 445
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10125,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 528,
                        "hold": 32,
                        "slide": 70,
                        "touch": 25,
                        "break": 11,
                        "total": 666
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10125,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 144,
                        "hold": 6,
                        "slide": 5,
                        "touch": null,
                        "break": 4,
                        "total": 159
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 125,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 34,
                        "slide": 1,
                        "touch": null,
                        "break": 11,
                        "total": 277
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 125,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 235,
                        "hold": 64,
                        "slide": 17,
                        "touch": null,
                        "break": 20,
                        "total": 336
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 125,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 556,
                        "hold": 27,
                        "slide": 45,
                        "touch": null,
                        "break": 9,
                        "total": 637
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 125,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 13.2
                    },
                    "releaseDate": "2012-12-13"
                }
            ],
            "searchAcronyms": [
                "Senbon Zakura",
                "Thousand Cherry Blossoms",
                "Thousands of Cherry Trees"
            ]
        },
        {
            "songId": "We Gonna Party",
            "category": "maimai",
            "title": "We Gonna Party",
            "artist": "Cranky",
            "bpm": 159,
            "imageName": "63aead98b75dd354ee47e387d3c05632bb6a877bd72bcd8fd5a544a304c42df3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 104,
                        "hold": 24,
                        "slide": 7,
                        "touch": null,
                        "break": 7,
                        "total": 142
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 133,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 160,
                        "hold": 24,
                        "slide": 2,
                        "touch": null,
                        "break": 6,
                        "total": 192
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 133,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 324,
                        "hold": 15,
                        "slide": 22,
                        "touch": null,
                        "break": 14,
                        "total": 375
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 133,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 373,
                        "hold": 5,
                        "slide": 51,
                        "touch": null,
                        "break": 16,
                        "total": 445
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 133,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "FESTiVAL": 13.6,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.3,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.6,
                        "maimaiでらっくす PLUS": 12.6
                    },
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 487,
                        "hold": 25,
                        "slide": 57,
                        "touch": null,
                        "break": 39,
                        "total": 608
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 133,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.9,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.9,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2020-10-22"
                }
            ],
            "searchAcronyms": [
                "wgp",
                "咱想开派对",
                "我们即将排队",
                "我们去派对",
                "我们去银趴",
                "我们要派对",
                "铁塔",
                "银趴"
            ]
        },
        {
            "songId": "Streak",
            "category": "maimai",
            "title": "Streak",
            "artist": "ARM(IOSYS)",
            "bpm": 150,
            "imageName": "78bc29372f74edae35a14c5238329cca7ea5794380e85cad53a8578e9699de81",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 91,
                        "hold": 16,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 119
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 136,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 118,
                        "hold": 16,
                        "slide": 12,
                        "touch": null,
                        "break": 10,
                        "total": 156
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 136,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 283,
                        "hold": 7,
                        "slide": 9,
                        "touch": null,
                        "break": 2,
                        "total": 301
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 136,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 222,
                        "hold": 35,
                        "slide": 71,
                        "touch": null,
                        "break": 4,
                        "total": 332
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 136,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "FESTiVAL": 13.4,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.6
                    },
                    "releaseDate": "2012-12-13"
                }
            ],
            "searchAcronyms": [
                "拆房子",
                "牛排",
                "米奇妙妙屋",
                "米奇粑粑屋",
                "绿庙",
                "绿房",
                "翠楼屋"
            ]
        },
        {
            "songId": "Lionheart",
            "category": "maimai",
            "title": "Lionheart",
            "artist": "Masayoshi Minoshima",
            "bpm": 132,
            "imageName": "cf293cb06b62e496e30a1bb86f51414217aaea580f25cb5f5613b88e3514a5a2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 108,
                        "hold": 15,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 129
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 138,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 159,
                        "hold": 14,
                        "slide": 5,
                        "touch": null,
                        "break": 4,
                        "total": 182
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 138,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 248,
                        "hold": 22,
                        "slide": 14,
                        "touch": null,
                        "break": 11,
                        "total": 295
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 138,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 383,
                        "hold": 4,
                        "slide": 61,
                        "touch": null,
                        "break": 16,
                        "total": 464
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 138,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.4
                    },
                    "releaseDate": "2012-12-13"
                }
            ],
            "searchAcronyms": [
                "狮子心",
                "狮心",
                "节奏大师",
                "莱因哈特"
            ]
        },
        {
            "songId": "Acceleration",
            "category": "maimai",
            "title": "Acceleration",
            "artist": "REDALiCE",
            "bpm": 180,
            "imageName": "4b001babbfb130b0c3cab2c9da9c17b0ff392e55a7f284a520a64afd8067c721",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 166,
                        "hold": 9,
                        "slide": 6,
                        "touch": null,
                        "break": 7,
                        "total": 188
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 139,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 193,
                        "hold": 25,
                        "slide": 2,
                        "touch": null,
                        "break": 5,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 139,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 361,
                        "hold": 20,
                        "slide": 19,
                        "touch": null,
                        "break": 6,
                        "total": 406
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 139,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 421,
                        "hold": 8,
                        "slide": 28,
                        "touch": null,
                        "break": 7,
                        "total": 464
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 139,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.4
                    },
                    "releaseDate": "2012-12-13"
                }
            ],
            "searchAcronyms": [
                "加速",
                "加速器",
                "转圈金曲"
            ]
        },
        {
            "songId": "Sprintrances",
            "category": "maimai",
            "title": "Sprintrances",
            "artist": "Taishi",
            "bpm": 178,
            "imageName": "e87c803219037e5827d8ef1681dfed5f6826a1aec07fe59ade6e436fa4754b7f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 10,
                        "slide": 2,
                        "touch": null,
                        "break": 1,
                        "total": 118
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 140,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 187,
                        "hold": 18,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 212
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 140,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 180,
                        "hold": 42,
                        "slide": 10,
                        "touch": null,
                        "break": 9,
                        "total": 241
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 140,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 44,
                        "slide": 47,
                        "touch": null,
                        "break": 5,
                        "total": 353
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 140,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.2
                    },
                    "releaseDate": "2012-12-13"
                }
            ],
            "searchAcronyms": [
                "一块五",
                "冰山"
            ]
        },
        {
            "songId": "air's gravity",
            "category": "maimai",
            "title": "air's gravity",
            "artist": "zts",
            "bpm": 137,
            "imageName": "f98f5bb4e77467d7aec5c83dfced609f3196aae094436549b8a77fc884c748a9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 114,
                        "hold": 7,
                        "slide": 3,
                        "touch": null,
                        "break": 6,
                        "total": 130
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 144,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 165,
                        "hold": 31,
                        "slide": 2,
                        "touch": null,
                        "break": 6,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 144,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 198,
                        "hold": 32,
                        "slide": 11,
                        "touch": null,
                        "break": 6,
                        "total": 247
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 144,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 363,
                        "hold": 18,
                        "slide": 1,
                        "touch": null,
                        "break": 15,
                        "total": 397
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 144,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.6
                    },
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 418,
                        "hold": 20,
                        "slide": 39,
                        "touch": null,
                        "break": 15,
                        "total": 492
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 144,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.5
                    },
                    "releaseDate": "2020-10-22"
                }
            ],
            "searchAcronyms": [
                "空气重力"
            ]
        },
        {
            "songId": "Starlight Disco",
            "category": "maimai",
            "title": "Starlight Disco",
            "artist": "loos feat. Meramipop",
            "bpm": 128,
            "imageName": "5cac06f3f503d46dfc9796813c5ceb6180b7c694e0f8b3c2c535bc456911afca",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 78,
                        "hold": 1,
                        "slide": 5,
                        "touch": 22,
                        "break": 1,
                        "total": 107
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 10145,
                    "releaseDate": "2022-06-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 113,
                        "hold": 15,
                        "slide": 7,
                        "touch": 13,
                        "break": 2,
                        "total": 150
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 10145,
                    "releaseDate": "2022-06-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Starlight Disco Festa",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 49,
                        "slide": 33,
                        "touch": 56,
                        "break": 4,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 10145,
                    "releaseDate": "2022-06-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Starlight Disco Festa",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 21,
                        "slide": 64,
                        "touch": 20,
                        "break": 10,
                        "total": 430
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 10145,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 13.4,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2022-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 59,
                        "hold": 6,
                        "slide": 7,
                        "touch": null,
                        "break": 4,
                        "total": 76
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 145,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 8,
                        "slide": 16,
                        "touch": null,
                        "break": 8,
                        "total": 159
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 145,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 66,
                        "slide": 32,
                        "touch": null,
                        "break": 4,
                        "total": 230
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 145,
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 87,
                        "slide": 40,
                        "touch": null,
                        "break": 1,
                        "total": 279
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 145,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2012-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 261,
                        "hold": 38,
                        "slide": 87,
                        "touch": null,
                        "break": 3,
                        "total": 389
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 145,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12
                    },
                    "releaseDate": "2015-05-13"
                }
            ],
            "searchAcronyms": [
                "dx星光",
                "星光",
                "星光迪斯科",
                "标星光"
            ]
        },
        {
            "songId": "犬日和。",
            "category": "maimai",
            "title": "犬日和。",
            "artist": "RYOHEI KOHNO/森綾香",
            "bpm": 138,
            "imageName": "52c79fdcfdae1061f168f7c9c38bba354378a2cda343e287a4b02eb9f9cb8b70",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 7,
                        "total": 150
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 118,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 179,
                        "hold": 14,
                        "slide": 3,
                        "touch": null,
                        "break": 26,
                        "total": 222
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 118,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 302,
                        "hold": 8,
                        "slide": 4,
                        "touch": null,
                        "break": 23,
                        "total": 337
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 118,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 26,
                        "slide": 8,
                        "touch": null,
                        "break": 23,
                        "total": 413
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 118,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2013-01-17"
                }
            ],
            "searchAcronyms": [
                "哈皮",
                "山里灵活的狗",
                "炫狗",
                "犬日和",
                "狗天气",
                "狗日和",
                "狗日子",
                "狗日的"
            ]
        },
        {
            "songId": "デコボコ体操第二",
            "category": "ゲーム＆バラエティ",
            "title": "デコボコ体操第二",
            "artist": "光吉猛修＆体操隊",
            "bpm": 140,
            "imageName": "66f5ba5c5ae15bd02e31db4fb58bf21f506c5b69c4b4822a22e948970ef9e021",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 77,
                        "hold": 1,
                        "slide": 10,
                        "touch": null,
                        "break": 3,
                        "total": 91
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 120,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 89,
                        "hold": 19,
                        "slide": 12,
                        "touch": null,
                        "break": 6,
                        "total": 126
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 120,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 34,
                        "slide": 49,
                        "touch": null,
                        "break": 6,
                        "total": 194
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 120,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 0,
                        "slide": 64,
                        "touch": null,
                        "break": 10,
                        "total": 268
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 120,
                    "releaseDate": "2013-01-17"
                }
            ],
            "searchAcronyms": [
                "体操",
                "体操第二",
                "凹凸"
            ]
        },
        {
            "songId": "御旗のもとに",
            "category": "ゲーム＆バラエティ",
            "title": "御旗のもとに",
            "artist": "「サクラ大戦」",
            "bpm": 147,
            "imageName": "9795a902007c611c8928130ec01681a69056e1704bb28412fd0a44a2a217fcd7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 75,
                        "hold": 9,
                        "slide": 4,
                        "touch": 8,
                        "break": 5,
                        "total": 101
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 10128,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 21,
                        "slide": 4,
                        "touch": 30,
                        "break": 4,
                        "total": 235
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 10128,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 185,
                        "hold": 66,
                        "slide": 25,
                        "touch": 9,
                        "break": 25,
                        "total": 310
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 10128,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 324,
                        "hold": 31,
                        "slide": 74,
                        "touch": 43,
                        "break": 32,
                        "total": 504
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 10128,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 49,
                        "hold": 25,
                        "slide": 6,
                        "touch": null,
                        "break": 1,
                        "total": 81
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 128,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 62,
                        "hold": 37,
                        "slide": 22,
                        "touch": null,
                        "break": 2,
                        "total": 123
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 128,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.1,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 95,
                        "hold": 59,
                        "slide": 37,
                        "touch": null,
                        "break": 3,
                        "total": 194
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 128,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.1,
                        "CiRCLE": 12.1,
                        "CiRCLE PLUS": 12.1,
                        "PRiSM PLUS": 12.1
                    },
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 80,
                        "slide": 32,
                        "touch": null,
                        "break": 5,
                        "total": 346
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 128,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12
                    },
                    "releaseDate": "2013-01-17"
                }
            ],
            "searchAcronyms": [
                "Mihata no motoni",
                "御旗"
            ]
        },
        {
            "songId": "DO RORO DERODERO ON DO RORO",
            "category": "ゲーム＆バラエティ",
            "title": "DO RORO DERODERO ON DO RORO",
            "artist": "怒髪天「百鬼大戦絵巻」",
            "bpm": 190,
            "imageName": "d6204756386649b1209afbf2bdd2d88e736a852c720106f4cc36ccba0de07cea",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 14,
                        "slide": 2,
                        "touch": null,
                        "break": 6,
                        "total": 164
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 154,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 271,
                        "hold": 26,
                        "slide": 7,
                        "touch": null,
                        "break": 7,
                        "total": 311
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 154,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 401,
                        "hold": 33,
                        "slide": 15,
                        "touch": null,
                        "break": 8,
                        "total": 457
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 154,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 411,
                        "hold": 54,
                        "slide": 33,
                        "touch": null,
                        "break": 17,
                        "total": 515
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 154,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.4,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2013-01-17"
                }
            ],
            "searchAcronyms": [
                "原批大战罕见2",
                "多罗罗",
                "源平2",
                "百鬼",
                "百鬼大战绘卷",
                "百鬼大战罕见",
                "迪罗迪罗"
            ]
        },
        {
            "songId": "Natural Flow",
            "category": "ゲーム＆バラエティ",
            "title": "Natural Flow",
            "artist": "KENTARO「Crackin’DJ」",
            "bpm": 100,
            "imageName": "4ec9033c7c3cf289aa09cf139bef5a164529b6ae015df4f81bd26b533d3f4143",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 5,
                        "slide": 3,
                        "touch": null,
                        "break": 3,
                        "total": 114
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 157,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 23,
                        "slide": 8,
                        "touch": null,
                        "break": 5,
                        "total": 198
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 157,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 58,
                        "slide": 21,
                        "touch": null,
                        "break": 5,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 157,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 104,
                        "hold": 28,
                        "slide": 47,
                        "touch": null,
                        "break": 26,
                        "total": 205
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 157,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2013-01-17"
                }
            ],
            "searchAcronyms": [
                "自然流"
            ]
        },
        {
            "songId": "maimaiちゃんのテーマ",
            "category": "maimai",
            "title": "maimaiちゃんのテーマ",
            "artist": "YMCK",
            "bpm": 136,
            "imageName": "069610f960e14cd531ff0cc73bad21db9f42e6ea9efac97605754d4c360c1a43",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 15,
                        "slide": 6,
                        "touch": null,
                        "break": 3,
                        "total": 129
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 159,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 31,
                        "slide": 3,
                        "touch": null,
                        "break": 9,
                        "total": 184
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 159,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 42,
                        "slide": 11,
                        "touch": null,
                        "break": 15,
                        "total": 243
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 159,
                    "releaseDate": "2013-01-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 328,
                        "hold": 29,
                        "slide": 31,
                        "touch": null,
                        "break": 10,
                        "total": 398
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 159,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2013-01-17"
                }
            ],
            "searchAcronyms": [
                "maimai酱",
                "舞萌酱"
            ]
        },
        {
            "songId": "Quartet Theme [Reborn]",
            "category": "ゲーム＆バラエティ",
            "title": "Quartet Theme [Reborn]",
            "artist": "COSIO(ZUNTATA/TAITO)「カルテット」",
            "bpm": 137,
            "imageName": "db439e208d560b96a42be17cfdcb2a297febd8006c90f9288ab61907a850ea83",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 98,
                        "hold": 12,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 119
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 110,
                    "releaseDate": "2013-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 43,
                        "slide": 4,
                        "touch": null,
                        "break": 13,
                        "total": 265
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 110,
                    "releaseDate": "2013-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 174,
                        "hold": 44,
                        "slide": 69,
                        "touch": null,
                        "break": 3,
                        "total": 290
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 110,
                    "releaseDate": "2013-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 370,
                        "hold": 96,
                        "slide": 35,
                        "touch": null,
                        "break": 1,
                        "total": 502
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 110,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2013-02-20"
                }
            ],
            "searchAcronyms": [
                "quartet",
                "十面埋伏",
                "四重奏",
                "手枪人",
                "生死四人组"
            ]
        },
        {
            "songId": "Sky High [Reborn]",
            "category": "ゲーム＆バラエティ",
            "title": "Sky High [Reborn]",
            "artist": "大久保 博(BNGI)「デイトナ USA」",
            "bpm": 144,
            "imageName": "181fcc8be0d54e0c4ec0c2165541c79d6781c8fae9f3f79fe08954227ff2641c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 123,
                        "hold": 2,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 135
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 111,
                    "releaseDate": "2013-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 19,
                        "slide": 6,
                        "touch": null,
                        "break": 9,
                        "total": 285
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 111,
                    "releaseDate": "2013-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 244,
                        "hold": 79,
                        "slide": 15,
                        "touch": null,
                        "break": 2,
                        "total": 340
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 111,
                    "releaseDate": "2013-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 316,
                        "hold": 73,
                        "slide": 36,
                        "touch": null,
                        "break": 3,
                        "total": 428
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 111,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2013-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 475,
                        "hold": 43,
                        "slide": 64,
                        "touch": null,
                        "break": 29,
                        "total": 611
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 111,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2020-10-29"
                }
            ],
            "searchAcronyms": [
                "天空高",
                "天高"
            ]
        },
        {
            "songId": "Like the Wind [Reborn]",
            "category": "ゲーム＆バラエティ",
            "title": "Like the Wind [Reborn]",
            "artist": "sampling masters MEGA「パワードリフト」",
            "bpm": 200,
            "imageName": "f634659eb49988bbecd6d8a7238aa2c685fe62e95da591ac9b7738baa1e1d21d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 11,
                        "slide": 8,
                        "touch": null,
                        "break": 11,
                        "total": 206
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 112,
                    "releaseDate": "2013-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 320,
                        "hold": 20,
                        "slide": 4,
                        "touch": null,
                        "break": 18,
                        "total": 362
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 112,
                    "releaseDate": "2013-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 475,
                        "hold": 22,
                        "slide": 15,
                        "touch": null,
                        "break": 27,
                        "total": 539
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 112,
                    "releaseDate": "2013-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 535,
                        "hold": 20,
                        "slide": 70,
                        "touch": null,
                        "break": 54,
                        "total": 679
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 112,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2013-02-20"
                }
            ],
            "searchAcronyms": [
                "Like The Wind",
                "一块钱",
                "像风一样",
                "像风一样复兴的",
                "动力甩尾",
                "怎么样 好玩吧 被这精彩的场面震撼到了吧",
                "被这精彩的场面震撼到了吧",
                "野兽先辈"
            ]
        },
        {
            "songId": "YA･DA･YO [Reborn]",
            "category": "ゲーム＆バラエティ",
            "title": "YA･DA･YO [Reborn]",
            "artist": "古代 祐三「ファンタジーゾーン」",
            "bpm": 105,
            "imageName": "a00c56267b034320a5efb84d8de5dd35711146bb980c0ee3005e614810399e52",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 88,
                        "hold": 10,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 106
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 113,
                    "releaseDate": "2013-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 225,
                        "hold": 6,
                        "slide": 11,
                        "touch": null,
                        "break": 4,
                        "total": 246
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 113,
                    "releaseDate": "2013-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 515,
                        "hold": 1,
                        "slide": 8,
                        "touch": null,
                        "break": 10,
                        "total": 534
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 113,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2013-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 473,
                        "hold": 16,
                        "slide": 10,
                        "touch": null,
                        "break": 14,
                        "total": 513
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 113,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.2
                    },
                    "releaseDate": "2013-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "Safata.Hz",
                    "noteCounts": {
                        "tap": 512,
                        "hold": 48,
                        "slide": 54,
                        "touch": null,
                        "break": 52,
                        "total": 666
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4
                    },
                    "releaseDate": "2025-11-19"
                }
            ],
            "searchAcronyms": [
                "yadayo",
                "不要嘛",
                "亚达哟",
                "六个喇叭",
                "幻想地带"
            ]
        },
        {
            "songId": "Space Harrier Main Theme [Reborn]",
            "category": "ゲーム＆バラエティ",
            "title": "Space Harrier Main Theme [Reborn]",
            "artist": "佐野 信義「スペースハリアー」",
            "bpm": 125,
            "imageName": "efbffc987a0fa536acb35e1d5f5e1081e861933a87f7ebac68edbd471fbb2266",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 148,
                        "hold": 4,
                        "slide": 9,
                        "touch": null,
                        "break": 5,
                        "total": 166
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 114,
                    "releaseDate": "2013-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 24,
                        "slide": 10,
                        "touch": null,
                        "break": 1,
                        "total": 186
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 114,
                    "releaseDate": "2013-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 47,
                        "hold": 147,
                        "slide": 7,
                        "touch": null,
                        "break": 7,
                        "total": 208
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 114,
                    "releaseDate": "2013-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 421,
                        "hold": 23,
                        "slide": 6,
                        "touch": null,
                        "break": 14,
                        "total": 464
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 114,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash": 13.2,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2013-02-20"
                }
            ],
            "searchAcronyms": [
                "太空",
                "太空哈利",
                "太空哈姆",
                "太空蛤蜊"
            ]
        },
        {
            "songId": "Tell Your World",
            "category": "niconico＆ボーカロイド",
            "title": "Tell Your World",
            "artist": "livetune",
            "bpm": 150,
            "imageName": "b55c974246dfc856eecb99194ab43362e19622dbe0bf40fc7735ec5aa6e97e0a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 113,
                        "hold": 13,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 138
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 100,
                    "releaseDate": "2013-03-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 159,
                        "hold": 36,
                        "slide": 17,
                        "touch": null,
                        "break": 13,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 100,
                    "releaseDate": "2013-03-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "譜面-100号とはっぴー",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 53,
                        "slide": 47,
                        "touch": null,
                        "break": 3,
                        "total": 335
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 100,
                    "releaseDate": "2013-03-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 260,
                        "hold": 79,
                        "slide": 29,
                        "touch": null,
                        "break": 16,
                        "total": 384
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 100,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2013-03-07"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 365,
                        "hold": 35,
                        "slide": 69,
                        "touch": null,
                        "break": 4,
                        "total": 473
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 100,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 11.8
                    },
                    "releaseDate": "2016-09-07"
                }
            ],
            "searchAcronyms": [
                "tyw",
                "告诉你的世界"
            ]
        },
        {
            "songId": "FEEL ALIVE",
            "category": "maimai",
            "title": "FEEL ALIVE",
            "artist": "ELEMENTAS feat. NAGISA",
            "bpm": 162,
            "imageName": "92e15c9b48b43a3c9c00b66c22cf05a78aff56932022d49bc26b2de4538d4c11",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 106,
                        "hold": 5,
                        "slide": 9,
                        "touch": null,
                        "break": 9,
                        "total": 129
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 130,
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 211,
                        "hold": 20,
                        "slide": 8,
                        "touch": null,
                        "break": 8,
                        "total": 247
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 130,
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.1,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 279,
                        "hold": 31,
                        "slide": 12,
                        "touch": null,
                        "break": 8,
                        "total": 330
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 130,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.1,
                        "CiRCLE PLUS": 12.1,
                        "PRiSM PLUS": 12.1
                    },
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 29,
                        "slide": 36,
                        "touch": null,
                        "break": 29,
                        "total": 469
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 130,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2013-03-14"
                }
            ],
            "searchAcronyms": [
                "女人赛跑",
                "小蜜蜂",
                "感觉死",
                "感觉活",
                "感觉活着"
            ]
        },
        {
            "songId": "Link",
            "category": "maimai",
            "title": "Link",
            "artist": "Clean Tears feat. Youna",
            "bpm": 132,
            "imageName": "721639140a9430475770fe5ba130c76e0298bc5bfa86db1fd5e624a4ed1f7af2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 110,
                        "hold": 5,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 124
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 19,
                        "slide": 7,
                        "touch": null,
                        "break": 3,
                        "total": 174
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 253,
                        "hold": 31,
                        "slide": 23,
                        "touch": null,
                        "break": 7,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 208,
                        "hold": 14,
                        "slide": 73,
                        "touch": null,
                        "break": 13,
                        "total": 308
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 29,
                        "slide": 84,
                        "touch": null,
                        "break": 40,
                        "total": 475
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 131,
                    "releaseDate": "2023-11-23"
                }
            ],
            "searchAcronyms": [
                "林克",
                "链接"
            ]
        },
        {
            "songId": "Night Fly",
            "category": "maimai",
            "title": "Night Fly",
            "artist": "発熱巫女～ず",
            "bpm": 127,
            "imageName": "2e93a7a7baa461817b0b0b50687f9c16b4c0e30c684484fe345bac32ed254bb9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 63,
                        "hold": 6,
                        "slide": 3,
                        "touch": null,
                        "break": 3,
                        "total": 75
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 134,
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 66,
                        "hold": 49,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 122
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 134,
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 167,
                        "hold": 39,
                        "slide": 9,
                        "touch": null,
                        "break": 9,
                        "total": 224
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 134,
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 180,
                        "hold": 30,
                        "slide": 67,
                        "touch": null,
                        "break": 9,
                        "total": 286
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 134,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 11.7
                    },
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Moon Strix",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 23,
                        "slide": 57,
                        "touch": null,
                        "break": 15,
                        "total": 387
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 134,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4
                    },
                    "releaseDate": "2020-10-29"
                }
            ],
            "searchAcronyms": [
                "🐳",
                "万象区",
                "万象汇",
                "发热金曲",
                "夜飞",
                "晚上飞",
                "蓝鲸"
            ]
        },
        {
            "songId": "Feel My Fire",
            "category": "maimai",
            "title": "Feel My Fire",
            "artist": "発熱巫女～ず",
            "bpm": 123,
            "imageName": "b89b4d976d770427dd35b369e9b5e35cc92a78023473a70a9c078472aace787f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 72,
                        "hold": 9,
                        "slide": 4,
                        "touch": null,
                        "break": 3,
                        "total": 88
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 135,
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 161,
                        "hold": 22,
                        "slide": 16,
                        "touch": null,
                        "break": 8,
                        "total": 207
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 135,
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 112,
                        "hold": 58,
                        "slide": 28,
                        "touch": null,
                        "break": 11,
                        "total": 209
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 135,
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 34,
                        "slide": 54,
                        "touch": null,
                        "break": 3,
                        "total": 309
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 135,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.1
                    },
                    "releaseDate": "2013-03-14"
                }
            ],
            "searchAcronyms": [
                "fmf",
                "感受我的火",
                "感受我的烧",
                "感觉我烧",
                "爱如火"
            ]
        },
        {
            "songId": "Spin me harder",
            "category": "maimai",
            "title": "Spin me harder",
            "artist": "D.watt(IOSYS)feat. Asana",
            "bpm": 130,
            "imageName": "42de1924b739ed1bb50eeb67a5d2b551c621237623d5f9327281cefc5a549c6b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 95,
                        "hold": 15,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 117
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 137,
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 13,
                        "slide": 12,
                        "touch": null,
                        "break": 4,
                        "total": 154
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 137,
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 11,
                        "slide": 56,
                        "touch": null,
                        "break": 8,
                        "total": 264
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 137,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "PRiSM PLUS": 12.2
                    },
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 236,
                        "hold": 58,
                        "slide": 39,
                        "touch": null,
                        "break": 4,
                        "total": 337
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 137,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.4
                    },
                    "releaseDate": "2013-03-14"
                }
            ],
            "searchAcronyms": [
                "🦋",
                "更努力转我",
                "更大力转我",
                "更难的旋转",
                "用力转我",
                "电蝴蝶",
                "蓝蝴蝶",
                "蝴蝶",
                "转我更猛些"
            ]
        },
        {
            "songId": "Fragrance",
            "category": "maimai",
            "title": "Fragrance",
            "artist": "Tsukasa(Arte Refact)",
            "bpm": 180,
            "imageName": "0ecab941e218b4f8828451af340524a74fb786e9f65d2122eafcec15cc658db4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 76,
                        "hold": 7,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 91
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 143,
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 96,
                        "hold": 37,
                        "slide": 7,
                        "touch": null,
                        "break": 2,
                        "total": 142
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 143,
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 50,
                        "slide": 12,
                        "touch": null,
                        "break": 2,
                        "total": 294
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 143,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.1
                    },
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 651,
                        "hold": 0,
                        "slide": 2,
                        "touch": null,
                        "break": 2,
                        "total": 655
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 143,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14.2,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "Splash": 14.2,
                        "Splash PLUS": 14.2,
                        "UNiVERSE": 14.2,
                        "UNiVERSE PLUS": 14.2,
                        "maimaiでらっくす PLUS": 14.2
                    },
                    "releaseDate": "2013-03-14"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 441,
                        "hold": 19,
                        "slide": 192,
                        "touch": null,
                        "break": 3,
                        "total": 655
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 143,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.6,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6,
                        "Splash": 14.5,
                        "Splash PLUS": 14.5,
                        "UNiVERSE": 14.5,
                        "UNiVERSE PLUS": 14.5,
                        "maimaiでらっくす PLUS": 14.7
                    },
                    "releaseDate": "2018-07-23"
                }
            ],
            "searchAcronyms": [
                "大楼",
                "斜塔",
                "白楼开花",
                "白香芋",
                "芳香",
                "香水",
                "香香"
            ]
        },
        {
            "songId": "39",
            "category": "niconico＆ボーカロイド",
            "title": "39",
            "artist": "sasakure.UK x DECO*27",
            "bpm": 175,
            "imageName": "96fe9aecc727c724e55b133102918468d465f5862cd6c312ccb45e6e78ccdf84",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 62,
                        "hold": 16,
                        "slide": 2,
                        "touch": 11,
                        "break": 2,
                        "total": 93
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10146,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 136,
                        "hold": 14,
                        "slide": 11,
                        "touch": 28,
                        "break": 9,
                        "total": 198
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10146,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 201,
                        "hold": 97,
                        "slide": 19,
                        "touch": 63,
                        "break": 10,
                        "total": 390
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10146,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 35,
                        "slide": 78,
                        "touch": 104,
                        "break": 33,
                        "total": 602
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10146,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 86,
                        "hold": 31,
                        "slide": 5,
                        "touch": null,
                        "break": 4,
                        "total": 126
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 146,
                    "releaseDate": "2013-03-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 159,
                        "hold": 45,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 218
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 146,
                    "releaseDate": "2013-03-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 78,
                        "slide": 15,
                        "touch": null,
                        "break": 8,
                        "total": 297
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 146,
                    "releaseDate": "2013-03-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 374,
                        "hold": 55,
                        "slide": 40,
                        "touch": null,
                        "break": 43,
                        "total": 512
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 146,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2013-03-18"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 380,
                        "hold": 66,
                        "slide": 90,
                        "touch": null,
                        "break": 39,
                        "total": 575
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 146,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2019-07-04"
                }
            ],
            "searchAcronyms": [
                "dx39",
                "初音未来",
                "机厅几爷",
                "标39",
                "标准39",
                "谢谢"
            ]
        },
        {
            "songId": "炎歌 -ほむらうた-",
            "category": "maimai",
            "title": "炎歌 -ほむらうた-",
            "artist": "Hiro/森山愛子",
            "bpm": 108,
            "imageName": "48490550ecd0a9d6e3f5b2b87f35a9aea62fda70061a1e77513f009319d87d4a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 11,
                        "slide": 4,
                        "touch": 7,
                        "break": 1,
                        "total": 132
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 10117,
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 155,
                        "hold": 14,
                        "slide": 6,
                        "touch": 17,
                        "break": 3,
                        "total": 195
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 10117,
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 208,
                        "hold": 34,
                        "slide": 42,
                        "touch": 40,
                        "break": 15,
                        "total": 339
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 10117,
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 372,
                        "hold": 43,
                        "slide": 74,
                        "touch": 22,
                        "break": 16,
                        "total": 527
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 10117,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM": 13,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 12,
                        "slide": 6,
                        "touch": null,
                        "break": 5,
                        "total": 132
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 117,
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 33,
                        "slide": 11,
                        "touch": null,
                        "break": 5,
                        "total": 238
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 117,
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 25,
                        "slide": 33,
                        "touch": null,
                        "break": 6,
                        "total": 409
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 117,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 33,
                        "slide": 94,
                        "touch": null,
                        "break": 5,
                        "total": 389
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 117,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.1,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2013-04-23"
                }
            ],
            "searchAcronyms": [
                "凤凰传奇",
                "广场舞",
                "炎歌",
                "阉割"
            ]
        },
        {
            "songId": "ソーラン☆節",
            "category": "maimai",
            "title": "ソーラン☆節",
            "artist": "光吉猛修",
            "bpm": 145,
            "imageName": "966e0e4f300d94adb6de78341f15899ae004750acb47b517e78d38016c1627c1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 106,
                        "hold": 9,
                        "slide": 10,
                        "touch": null,
                        "break": 8,
                        "total": 133
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 119,
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 160,
                        "hold": 23,
                        "slide": 6,
                        "touch": null,
                        "break": 16,
                        "total": 205
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 119,
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 43,
                        "slide": 39,
                        "touch": null,
                        "break": 20,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 119,
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 314,
                        "hold": 34,
                        "slide": 46,
                        "touch": null,
                        "break": 20,
                        "total": 414
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 119,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12
                    },
                    "releaseDate": "2013-04-23"
                }
            ],
            "searchAcronyms": [
                "嗦拉面",
                "拉面",
                "索兰节"
            ]
        },
        {
            "songId": "地上の戦士",
            "category": "ゲーム＆バラエティ",
            "title": "地上の戦士",
            "artist": "「サクラ大戦」",
            "bpm": 130,
            "imageName": "08eba97db7870a2028186d193560fc5f420ea679354656555c26bf72b282b860",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 62,
                        "hold": 20,
                        "slide": 7,
                        "touch": null,
                        "break": 4,
                        "total": 93
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 147,
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 99,
                        "hold": 45,
                        "slide": 7,
                        "touch": null,
                        "break": 14,
                        "total": 165
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 147,
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 113,
                        "hold": 72,
                        "slide": 16,
                        "touch": null,
                        "break": 12,
                        "total": 213
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 147,
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 28,
                        "slide": 46,
                        "touch": null,
                        "break": 14,
                        "total": 345
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 147,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12
                    },
                    "releaseDate": "2013-04-23"
                }
            ],
            "searchAcronyms": [
                "地上",
                "地上的战士",
                "樱花大战5"
            ]
        },
        {
            "songId": "超絶！Superlative",
            "category": "ゲーム＆バラエティ",
            "title": "超絶！Superlative",
            "artist": "Keitarou Hanada「戦国大戦」",
            "bpm": 200,
            "imageName": "2b52eec7053f6904e81d02f0e9c66e20796c11eff6e6ec0b3be75c94db0b702a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 82,
                        "hold": 22,
                        "slide": 6,
                        "touch": null,
                        "break": 5,
                        "total": 115
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 152,
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 64,
                        "slide": 7,
                        "touch": null,
                        "break": 4,
                        "total": 217
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 152,
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 268,
                        "hold": 68,
                        "slide": 16,
                        "touch": null,
                        "break": 11,
                        "total": 363
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 152,
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 312,
                        "hold": 39,
                        "slide": 73,
                        "touch": null,
                        "break": 24,
                        "total": 448
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 152,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2013-04-23"
                }
            ],
            "searchAcronyms": [
                "超绝"
            ]
        },
        {
            "songId": "采配の刻 Power of order",
            "category": "ゲーム＆バラエティ",
            "title": "采配の刻 Power of order",
            "artist": "Keitarou Hanada「戦国大戦」",
            "bpm": 185,
            "imageName": "7e87e645312bdea88449cc7e522f4d758d1d6a60782343a51530c5a1638a7809",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 91,
                        "hold": 24,
                        "slide": 7,
                        "touch": null,
                        "break": 4,
                        "total": 126
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 153,
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 147,
                        "hold": 33,
                        "slide": 15,
                        "touch": null,
                        "break": 10,
                        "total": 205
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 153,
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 72,
                        "slide": 34,
                        "touch": null,
                        "break": 23,
                        "total": 459
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 153,
                    "releaseDate": "2013-04-23"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 326,
                        "hold": 67,
                        "slide": 95,
                        "touch": null,
                        "break": 24,
                        "total": 512
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 153,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2013-04-23"
                }
            ],
            "searchAcronyms": [
                "采配之刻"
            ]
        },
        {
            "songId": "Endless World",
            "category": "maimai",
            "title": "Endless World",
            "artist": "RYOHEI KOHNO/保立美和子",
            "bpm": 142,
            "imageName": "614515ccea1dd429509601c7afbf8af200dfbbd4a5db4319663f9d52d173f1a0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 83,
                        "hold": 16,
                        "slide": 5,
                        "touch": null,
                        "break": 6,
                        "total": 110
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 58,
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 122,
                        "hold": 38,
                        "slide": 9,
                        "touch": null,
                        "break": 6,
                        "total": 175
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 58,
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 219,
                        "hold": 89,
                        "slide": 30,
                        "touch": null,
                        "break": 3,
                        "total": 341
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 58,
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 57,
                        "slide": 75,
                        "touch": null,
                        "break": 12,
                        "total": 398
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 58,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 383,
                        "hold": 49,
                        "slide": 86,
                        "touch": null,
                        "break": 22,
                        "total": 540
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 58,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2019-06-20"
                }
            ],
            "searchAcronyms": [
                "💄",
                "ew",
                "口红",
                "无尽世界"
            ]
        },
        {
            "songId": "ぴぴぱぷぅ！",
            "category": "maimai",
            "title": "ぴぴぱぷぅ！",
            "artist": "Hiro/小山あかり",
            "bpm": 147,
            "imageName": "982f850880ef6849cf9b29e023475a292ebce7a1423ee5ba2b40866bda9a451a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 9,
                        "slide": 6,
                        "touch": null,
                        "break": 5,
                        "total": 123
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 116,
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 249,
                        "hold": 42,
                        "slide": 24,
                        "touch": null,
                        "break": 8,
                        "total": 323
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 116,
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 59,
                        "slide": 37,
                        "touch": null,
                        "break": 19,
                        "total": 388
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 116,
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 366,
                        "hold": 68,
                        "slide": 59,
                        "touch": null,
                        "break": 7,
                        "total": 500
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 116,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2013-05-09"
                }
            ],
            "searchAcronyms": [
                "噼噼啪噗",
                "比巴卜"
            ]
        },
        {
            "songId": "Turn around",
            "category": "maimai",
            "title": "Turn around",
            "artist": "Clean Tears",
            "bpm": 156,
            "imageName": "9ec4f4c9f393819464174ef06c9cc30e628dfad0aeb59c311d990a4e2acf5fa9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 132,
                        "hold": 8,
                        "slide": 2,
                        "touch": null,
                        "break": 3,
                        "total": 145
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 132,
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 167,
                        "hold": 16,
                        "slide": 8,
                        "touch": null,
                        "break": 3,
                        "total": 194
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 132,
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 361,
                        "hold": 26,
                        "slide": 11,
                        "touch": null,
                        "break": 4,
                        "total": 402
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 132,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.1,
                        "UNiVERSE PLUS": 13.1
                    },
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 26,
                        "slide": 55,
                        "touch": null,
                        "break": 8,
                        "total": 445
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 132,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.1,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 12.6
                    },
                    "releaseDate": "2013-05-09"
                }
            ],
            "searchAcronyms": [
                "ta",
                "转弯"
            ]
        },
        {
            "songId": "Nerverakes",
            "category": "maimai",
            "title": "Nerverakes",
            "artist": "Taishi",
            "bpm": 140,
            "imageName": "c3542fc22bf60cc32880e3c4d72f93d02b4315e04a0a5feceeedb17c2ef4d431",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 100,
                        "hold": 16,
                        "slide": 3,
                        "touch": null,
                        "break": 3,
                        "total": 122
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 141,
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 124,
                        "hold": 36,
                        "slide": 7,
                        "touch": null,
                        "break": 6,
                        "total": 173
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 141,
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 219,
                        "hold": 31,
                        "slide": 15,
                        "touch": null,
                        "break": 7,
                        "total": 272
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 141,
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 515,
                        "hold": 22,
                        "slide": 12,
                        "touch": null,
                        "break": 11,
                        "total": 560
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 141,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.6
                    },
                    "releaseDate": "2013-05-09"
                }
            ],
            "searchAcronyms": [
                "2",
                "两块钱",
                "二块钱",
                "地球仪"
            ]
        },
        {
            "songId": "Black Out",
            "category": "maimai",
            "title": "Black Out",
            "artist": "Tsukasa(Arte Refact)",
            "bpm": 142,
            "imageName": "62bfdba50f6c794eef1cab40b73b65311fe59967dbee75fb9b932621aa8ce2d1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 100,
                        "hold": 2,
                        "slide": 2,
                        "touch": null,
                        "break": 4,
                        "total": 108
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 142,
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 23,
                        "slide": 3,
                        "touch": null,
                        "break": 6,
                        "total": 183
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 142,
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 32,
                        "slide": 2,
                        "touch": null,
                        "break": 10,
                        "total": 322
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 142,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "Splash": 12
                    },
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 43,
                        "slide": 37,
                        "touch": null,
                        "break": 28,
                        "total": 339
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 142,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12
                    },
                    "releaseDate": "2013-05-09"
                }
            ],
            "searchAcronyms": [
                "晕倒",
                "黑出",
                "黜"
            ]
        },
        {
            "songId": "泣き虫O'clock",
            "category": "maimai",
            "title": "泣き虫O'clock",
            "artist": "Hiro/友香",
            "bpm": 152,
            "imageName": "f3a495b8dcce85736a7486b6e13868e53e6dab82cf27ce5d64601abe2bfc2ba0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 132,
                        "hold": 5,
                        "slide": 6,
                        "touch": null,
                        "break": 5,
                        "total": 148
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 155,
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 67,
                        "slide": 14,
                        "touch": null,
                        "break": 9,
                        "total": 280
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 155,
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 77,
                        "slide": 27,
                        "touch": null,
                        "break": 4,
                        "total": 358
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 155,
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 324,
                        "hold": 58,
                        "slide": 77,
                        "touch": null,
                        "break": 10,
                        "total": 469
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 155,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2013-05-09"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 527,
                        "hold": 42,
                        "slide": 85,
                        "touch": null,
                        "break": 20,
                        "total": 674
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimai PLUS",
                    "internalId": 155,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2020-10-29"
                }
            ],
            "searchAcronyms": [
                "泣虫",
                "爱哭鬼"
            ]
        },
        {
            "songId": "脳漿炸裂ガール",
            "category": "niconico＆ボーカロイド",
            "title": "脳漿炸裂ガール",
            "artist": "れるりり",
            "bpm": 155,
            "imageName": "5db6d9816b387ecc6b30bef27ec0787619b54ec01af68b7c02931edeed4aee63",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 116,
                        "hold": 0,
                        "slide": 4,
                        "touch": 15,
                        "break": 2,
                        "total": 137
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10191,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 220,
                        "hold": 19,
                        "slide": 5,
                        "touch": 8,
                        "break": 4,
                        "total": 256
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10191,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 303,
                        "hold": 33,
                        "slide": 51,
                        "touch": 23,
                        "break": 18,
                        "total": 428
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10191,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 455,
                        "hold": 47,
                        "slide": 50,
                        "touch": 110,
                        "break": 3,
                        "total": 665
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10191,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 94,
                        "hold": 26,
                        "slide": 7,
                        "touch": null,
                        "break": 3,
                        "total": 130
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 191,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 6,
                        "slide": 11,
                        "touch": null,
                        "break": 4,
                        "total": 297
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 191,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "譜面-100号とはっぴー",
                    "noteCounts": {
                        "tap": 367,
                        "hold": 30,
                        "slide": 34,
                        "touch": null,
                        "break": 17,
                        "total": 448
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 191,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 600,
                        "hold": 31,
                        "slide": 33,
                        "touch": null,
                        "break": 14,
                        "total": 678
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 191,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": [
                "🤯👧",
                "Brain Fluid Explosion Girl",
                "dx肯尼迪",
                "dx脑浆",
                "dx脑浆炸裂",
                "nou shou sakuretsu girl",
                "noushou",
                "力一儿",
                "吸溜",
                "标准脑浆",
                "标脑",
                "标脑浆",
                "肯尼迪",
                "脑浆",
                "脑浆炸裂",
                "脑浆炸裂力一儿",
                "脑浆炸裂女孩",
                "脑浆炸裂少女",
                "脑浆炸裂谱",
                "脑瘫",
                "脑瘫炸裂",
                "脑裂",
                "麦当劳1+1"
            ]
        },
        {
            "songId": "カゲロウデイズ",
            "category": "niconico＆ボーカロイド",
            "title": "カゲロウデイズ",
            "artist": "じん",
            "bpm": 200,
            "imageName": "a12e92a73087d0568a87563ae78945099febd1f5dd6c8bf2fcddb7e85bb9ed8a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 120,
                        "hold": 12,
                        "slide": 5,
                        "touch": null,
                        "break": 10,
                        "total": 147
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 198,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 96,
                        "hold": 32,
                        "slide": 18,
                        "touch": null,
                        "break": 4,
                        "total": 150
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 198,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 304,
                        "hold": 78,
                        "slide": 18,
                        "touch": null,
                        "break": 5,
                        "total": 405
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 198,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 380,
                        "hold": 70,
                        "slide": 30,
                        "touch": null,
                        "break": 21,
                        "total": 501
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 198,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 688,
                        "hold": 8,
                        "slide": 169,
                        "touch": null,
                        "break": 11,
                        "total": 876
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 198,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2018-06-04"
                }
            ],
            "searchAcronyms": [
                "Kagerou Days",
                "Kagerou Daze",
                "车祸",
                "车祸曲",
                "车祸歌",
                "阳炎",
                "阳炎眩乱"
            ]
        },
        {
            "songId": "チルノのパーフェクトさんすう教室",
            "category": "東方Project",
            "title": "チルノのパーフェクトさんすう教室",
            "artist": "ARM＋夕野ヨシミ(IOSYS)feat. miko",
            "bpm": 175,
            "imageName": "d76db1f6abc2d604ebb0139eda2e78582c59eb30de85eac0295b29fdaf8def9f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 147,
                        "hold": 9,
                        "slide": 4,
                        "touch": 6,
                        "break": 2,
                        "total": 168
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 12,
                        "slide": 4,
                        "touch": 11,
                        "break": 6,
                        "total": 295
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 122,
                        "slide": 19,
                        "touch": 26,
                        "break": 9,
                        "total": 362
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "まぐランド",
                    "noteCounts": {
                        "tap": 457,
                        "hold": 43,
                        "slide": 107,
                        "touch": 49,
                        "break": 37,
                        "total": 693
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13
                    },
                    "releaseDate": "2025-09-17"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 84,
                        "hold": 30,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 122
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 199,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 27,
                        "slide": 18,
                        "touch": null,
                        "break": 5,
                        "total": 207
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 199,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 248,
                        "hold": 86,
                        "slide": 26,
                        "touch": null,
                        "break": 4,
                        "total": 364
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 199,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 74,
                        "slide": 29,
                        "touch": null,
                        "break": 21,
                        "total": 526
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 199,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.4
                    },
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": [
                "⑨",
                "⑨章算数",
                "baka",
                "Cirno",
                "Cirno's Perfect Math Class",
                "琪露诺的完美算数教室",
                "琪露诺的完美算术教室",
                "算数教室",
                "算术教室"
            ]
        },
        {
            "songId": "Bad Apple!! feat.nomico",
            "category": "東方Project",
            "title": "Bad Apple!! feat.nomico",
            "artist": "Masayoshi Minoshima",
            "bpm": 138,
            "imageName": "5ad1c3494ec97be53f527bdf1a6c9141881c16555c63391f0730bafa00f1202e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 7,
                        "slide": 4,
                        "touch": null,
                        "break": 7,
                        "total": 145
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 200,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 245,
                        "hold": 5,
                        "slide": 4,
                        "touch": null,
                        "break": 11,
                        "total": 265
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 200,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 376,
                        "hold": 47,
                        "slide": 17,
                        "touch": null,
                        "break": 8,
                        "total": 448
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 200,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 453,
                        "hold": 67,
                        "slide": 34,
                        "touch": null,
                        "break": 36,
                        "total": 590
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 200,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack vs 某S氏",
                    "noteCounts": {
                        "tap": 515,
                        "hold": 34,
                        "slide": 114,
                        "touch": null,
                        "break": 35,
                        "total": 698
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 200,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash PLUS": 12.8
                    },
                    "releaseDate": "2015-03-18"
                }
            ],
            "searchAcronyms": [
                "Bad Apple",
                "bad apple!! feat nomico",
                "badapple",
                "BDAP",
                "iPhone",
                "坏苹果",
                "烂苹果",
                "黑白苹果",
                "黑苹果"
            ]
        },
        {
            "songId": "Grip & Break down !!",
            "category": "東方Project",
            "title": "Grip & Break down !!",
            "artist": "SOUND HOLIC feat. Nana Takahashi",
            "bpm": 160,
            "imageName": "254e17bb3ce7287c1b5303f854d415773b6d3cbd5cbb6626d4cafc21fd91c0d7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 170,
                        "hold": 19,
                        "slide": 3,
                        "touch": 7,
                        "break": 25,
                        "total": 224
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 10202,
                    "releaseDate": "2022-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 14,
                        "slide": 21,
                        "touch": 27,
                        "break": 16,
                        "total": 353
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 10202,
                    "releaseDate": "2022-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9.5,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 403,
                        "hold": 42,
                        "slide": 39,
                        "touch": 31,
                        "break": 41,
                        "total": 556
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 10202,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 9.5
                    },
                    "releaseDate": "2022-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 615,
                        "hold": 30,
                        "slide": 116,
                        "touch": 105,
                        "break": 57,
                        "total": 923
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 10202,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "UNiVERSE PLUS": 13.5
                    },
                    "releaseDate": "2022-03-23"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 155,
                        "hold": 14,
                        "slide": 2,
                        "touch": null,
                        "break": 3,
                        "total": 174
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 202,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 300,
                        "hold": 28,
                        "slide": 11,
                        "touch": null,
                        "break": 5,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 202,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 16,
                        "slide": 22,
                        "touch": null,
                        "break": 8,
                        "total": 421
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 202,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 563,
                        "hold": 41,
                        "slide": 88,
                        "touch": null,
                        "break": 26,
                        "total": 718
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 202,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.5
                    },
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": [
                "gbd",
                "grip",
                "Grip &amp; Break down !!",
                "Grip and Break Down",
                "发光绝赞",
                "红魔馆内战",
                "红魔馆爆炸",
                "绝赞落"
            ]
        },
        {
            "songId": "ナイト・オブ・ナイツ",
            "category": "東方Project",
            "title": "ナイト・オブ・ナイツ",
            "artist": "ビートまりお(COOL＆CREATE)",
            "bpm": 180,
            "imageName": "a9ecc1e80667056bc5cbb75e81923782746a5a83aaef06242b2a1770c35c1e63",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 9,
                        "slide": 4,
                        "touch": 6,
                        "break": 10,
                        "total": 174
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 10204,
                    "releaseDate": "2023-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 11,
                        "slide": 8,
                        "touch": 28,
                        "break": 8,
                        "total": 331
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 10204,
                    "releaseDate": "2023-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 393,
                        "hold": 43,
                        "slide": 18,
                        "touch": 36,
                        "break": 58,
                        "total": 548
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 10204,
                    "releaseDate": "2023-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 487,
                        "hold": 28,
                        "slide": 137,
                        "touch": 27,
                        "break": 29,
                        "total": 708
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 10204,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2023-06-07"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 120,
                        "hold": 9,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 135
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 204,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 291,
                        "hold": 11,
                        "slide": 10,
                        "touch": null,
                        "break": 12,
                        "total": 324
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 204,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 488,
                        "hold": 16,
                        "slide": 14,
                        "touch": null,
                        "break": 45,
                        "total": 563
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 204,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 596,
                        "hold": 13,
                        "slide": 10,
                        "touch": null,
                        "break": 56,
                        "total": 675
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 204,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.5,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3
                    },
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 893,
                        "hold": 26,
                        "slide": 44,
                        "touch": null,
                        "break": 38,
                        "total": 1001
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 204,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "Splash": 14.3,
                        "UNiVERSE PLUS": 14.3,
                        "maimaiでらっくす PLUS": 14.3
                    },
                    "releaseDate": "2016-05-25"
                }
            ],
            "searchAcronyms": [
                "Knight of Nights",
                "kon",
                "night of knights",
                "Night of Knights",
                "Night of Knights / Knight of Nights",
                "nok",
                "st夜骑",
                "写到心里去了",
                "原版夜骑",
                "夜骑",
                "夜骑士",
                "暴走のpad长",
                "标准夜骑",
                "标夜骑",
                "电线杆",
                "音乐小子1",
                "骑士之夜"
            ]
        },
        {
            "songId": "時空を超えて久しぶり！",
            "category": "ゲーム＆バラエティ",
            "title": "時空を超えて久しぶり！",
            "artist": "アルル(CV 園崎未恵)「ぷよぷよ」",
            "bpm": 145,
            "imageName": "c33c06b1a4364ba020541962dce358aae3036d8b865aeb40c9ec1b18e849112c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 60,
                        "hold": 15,
                        "slide": 9,
                        "touch": null,
                        "break": 4,
                        "total": 88
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 207,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 165,
                        "hold": 21,
                        "slide": 17,
                        "touch": null,
                        "break": 12,
                        "total": 215
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 207,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 182,
                        "hold": 28,
                        "slide": 51,
                        "touch": null,
                        "break": 6,
                        "total": 267
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 207,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 333,
                        "hold": 40,
                        "slide": 49,
                        "touch": null,
                        "break": 9,
                        "total": 431
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 207,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.2
                    },
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": [
                "3d弹珠",
                "3d弹球",
                "3D弹球",
                "puyopuyo",
                "噗呦噗呦",
                "噗哟噗哟"
            ]
        },
        {
            "songId": "Her Dream Is To Be A Fantastic Sorceress",
            "category": "ゲーム＆バラエティ",
            "title": "Her Dream Is To Be A Fantastic Sorceress",
            "artist": "アミティ(CV 菊池志穂)「ぷよぷよ」",
            "bpm": 170,
            "imageName": "1d1cdb05a1991a8f0b889ffbac0f02cdd06692d9c63878ed3276e682496c9932",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 42,
                        "hold": 16,
                        "slide": 2,
                        "touch": null,
                        "break": 2,
                        "total": 62
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 208,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 90,
                        "hold": 26,
                        "slide": 9,
                        "touch": null,
                        "break": 10,
                        "total": 135
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 208,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 73,
                        "slide": 39,
                        "touch": null,
                        "break": 4,
                        "total": 267
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 208,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 88,
                        "hold": 112,
                        "slide": 28,
                        "touch": null,
                        "break": 7,
                        "total": 235
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 208,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": [
                "噗哟噗哟",
                "她的梦想是成为一名出色的女巫"
            ]
        },
        {
            "songId": "神室雪月花",
            "category": "ゲーム＆バラエティ",
            "title": "神室雪月花",
            "artist": "桐生 一馬「龍が如く」",
            "bpm": 86,
            "imageName": "6da7b6adbb45ad35b26a321d2c4f81023bc5c54986f5c0c50a4b1faf5ae92103",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 58,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 1,
                        "total": 67
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 212,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 73,
                        "hold": 22,
                        "slide": 7,
                        "touch": null,
                        "break": 6,
                        "total": 108
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 212,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "譜面-100号とはっぴー",
                    "noteCounts": {
                        "tap": 74,
                        "hold": 21,
                        "slide": 27,
                        "touch": null,
                        "break": 1,
                        "total": 123
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 212,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "PRiSM PLUS": 12.2,
                        "UNiVERSE PLUS": 12.2
                    },
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 160,
                        "hold": 21,
                        "slide": 36,
                        "touch": null,
                        "break": 19,
                        "total": 236
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 212,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12
                    },
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": [
                "别急4",
                "如龙",
                "雪月花"
            ]
        },
        {
            "songId": "KONNANじゃないっ！",
            "category": "ゲーム＆バラエティ",
            "title": "KONNANじゃないっ！",
            "artist": "澤村 遥「龍が如く５ 夢、叶えし者」",
            "bpm": 155,
            "imageName": "c7acfdc94fa8e13debd275c268d635be95f782d4628e1c4c062f21c122e9f4fb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 4,
                        "slide": 13,
                        "touch": null,
                        "break": 4,
                        "total": 130
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 213,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 171,
                        "hold": 16,
                        "slide": 11,
                        "touch": null,
                        "break": 18,
                        "total": 216
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 213,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 245,
                        "hold": 33,
                        "slide": 17,
                        "touch": null,
                        "break": 19,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 213,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 370,
                        "hold": 33,
                        "slide": 69,
                        "touch": null,
                        "break": 20,
                        "total": 492
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 213,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.6
                    },
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": [
                "konnan",
                "不恐男",
                "不该是这样",
                "二逼",
                "如龙5",
                "柯南",
                "泽村遥"
            ]
        },
        {
            "songId": "awake",
            "category": "ゲーム＆バラエティ",
            "title": "awake",
            "artist": "下田麻美「Shining・Force CROSS ELYSION」",
            "bpm": 170,
            "imageName": "aeae22dd98f05f5e7d39d778d7c1d8759a1ae30e1ccef76fa81895231cc98fee",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 75,
                        "hold": 14,
                        "slide": 4,
                        "touch": null,
                        "break": 3,
                        "total": 96
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 214,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 92,
                        "hold": 34,
                        "slide": 9,
                        "touch": null,
                        "break": 10,
                        "total": 145
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 214,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 163,
                        "hold": 36,
                        "slide": 16,
                        "touch": null,
                        "break": 10,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 214,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 29,
                        "slide": 65,
                        "touch": null,
                        "break": 13,
                        "total": 391
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 214,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": [
                "起了",
                "醒了"
            ]
        },
        {
            "songId": "Terminal Storm",
            "category": "ゲーム＆バラエティ",
            "title": "Terminal Storm",
            "artist": "三草康二郎「CODE OF JOKER」",
            "bpm": 160,
            "imageName": "6d05e4cf69a2360247cf97a1ee145cb761c494a46590ecb2791027baef7a77ce",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 73,
                        "hold": 12,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 93
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 218,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 33,
                        "slide": 6,
                        "touch": null,
                        "break": 5,
                        "total": 171
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 218,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 308,
                        "hold": 54,
                        "slide": 23,
                        "touch": null,
                        "break": 5,
                        "total": 390
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 218,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 28,
                        "slide": 48,
                        "touch": null,
                        "break": 32,
                        "total": 483
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 218,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.4
                    },
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": [
                "终端风暴",
                "麻花"
            ]
        },
        {
            "songId": "記憶、記録",
            "category": "maimai",
            "title": "記憶、記録",
            "artist": "LOPIT(SEGA)",
            "bpm": 185,
            "imageName": "3cce017c2fed74309256a3b3f13e4788a383736d28d5112a90178f4ad2b8abb3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 88,
                        "hold": 23,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 123
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 219,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 381,
                        "hold": 37,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 427
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 219,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 412,
                        "hold": 26,
                        "slide": 23,
                        "touch": null,
                        "break": 12,
                        "total": 473
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 219,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 461,
                        "hold": 27,
                        "slide": 76,
                        "touch": null,
                        "break": 87,
                        "total": 651
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 219,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 567,
                        "hold": 20,
                        "slide": 66,
                        "touch": null,
                        "break": 99,
                        "total": 752
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 219,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3
                    },
                    "releaseDate": "2022-07-21"
                }
            ],
            "searchAcronyms": [
                "lopit",
                "恐怖谷",
                "爆裂鼓手",
                "记忆纪录",
                "记忆记录",
                "鸡鸡已撸"
            ]
        },
        {
            "songId": "Blew Moon",
            "category": "maimai",
            "title": "Blew Moon",
            "artist": "t+pazolite",
            "bpm": 180,
            "imageName": "55ece3e707cadb58e30892406281c6c64f414c9f8ed9e989d0eb461fd460d9bf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 165,
                        "hold": 30,
                        "slide": 4,
                        "touch": null,
                        "break": 9,
                        "total": 208
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 226,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 450,
                        "hold": 17,
                        "slide": 8,
                        "touch": null,
                        "break": 10,
                        "total": 485
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 226,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 386,
                        "hold": 79,
                        "slide": 15,
                        "touch": null,
                        "break": 15,
                        "total": 495
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 226,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 459,
                        "hold": 50,
                        "slide": 39,
                        "touch": null,
                        "break": 60,
                        "total": 608
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 226,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.2
                    },
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 593,
                        "hold": 47,
                        "slide": 122,
                        "touch": null,
                        "break": 25,
                        "total": 787
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 226,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2016-07-27"
                }
            ],
            "searchAcronyms": [
                "blew shit",
                "吹屎",
                "吹月",
                "吹月亮",
                "答辩",
                "蓝月亮"
            ]
        },
        {
            "songId": "Pixel Voyage",
            "category": "maimai",
            "title": "Pixel Voyage",
            "artist": "YMCK",
            "bpm": 170,
            "imageName": "9e4fd66f6af1f0cbbacac360c0f6201b2c12bcaf7d0f00e88490ccf39e631bab",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 86,
                        "hold": 23,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 118
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 237,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 7,
                        "slide": 19,
                        "touch": null,
                        "break": 2,
                        "total": 217
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 237,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 204,
                        "hold": 66,
                        "slide": 17,
                        "touch": null,
                        "break": 7,
                        "total": 294
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 237,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 321,
                        "hold": 88,
                        "slide": 57,
                        "touch": null,
                        "break": 19,
                        "total": 485
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 237,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": [
                "像素旅行",
                "小飞机"
            ]
        },
        {
            "songId": "Get Happy",
            "category": "maimai",
            "title": "Get Happy",
            "artist": "Jimmy Weckl",
            "bpm": 150,
            "imageName": "6d30c646e48d4d0a38194b254c0c8b38f4176e936f01fa9231fc8681048a4745",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 118,
                        "hold": 34,
                        "slide": 3,
                        "touch": null,
                        "break": 7,
                        "total": 162
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 238,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 2,
                        "slide": 16,
                        "touch": null,
                        "break": 15,
                        "total": 272
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 238,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 487,
                        "hold": 33,
                        "slide": 25,
                        "touch": null,
                        "break": 2,
                        "total": 547
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 238,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "ニャインとはっぴー",
                    "noteCounts": {
                        "tap": 533,
                        "hold": 45,
                        "slide": 60,
                        "touch": null,
                        "break": 42,
                        "total": 680
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 238,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.2,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": [
                "得乐",
                "得到开心",
                "爽了",
                "给他哈皮",
                "给爽"
            ]
        },
        {
            "songId": "Beat of getting entangled",
            "category": "maimai",
            "title": "Beat of getting entangled",
            "artist": "Shoichiro Hirata",
            "bpm": 140,
            "imageName": "613f42e31298545c27f2ac9ba3f81d877a13401c03f7ea1fc2faf5c7cbe1bb5d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 115,
                        "hold": 15,
                        "slide": 10,
                        "touch": null,
                        "break": 6,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 240,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 323,
                        "hold": 34,
                        "slide": 7,
                        "touch": null,
                        "break": 10,
                        "total": 374
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 240,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 109,
                        "slide": 19,
                        "touch": null,
                        "break": 13,
                        "total": 490
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 240,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 413,
                        "hold": 81,
                        "slide": 43,
                        "touch": null,
                        "break": 49,
                        "total": 586
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 240,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.2
                    },
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 692,
                        "hold": 58,
                        "slide": 79,
                        "touch": null,
                        "break": 28,
                        "total": 857
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 240,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "Splash": 14.5,
                        "Splash PLUS": 14.5,
                        "UNiVERSE": 14.5,
                        "UNiVERSE PLUS": 14.5
                    },
                    "releaseDate": "2020-10-22"
                }
            ],
            "searchAcronyms": [
                "❓",
                "boge",
                "一坨蓝",
                "别急13",
                "胡来的处男",
                "胡辣汤"
            ]
        },
        {
            "songId": "Cosmic Train",
            "category": "maimai",
            "title": "Cosmic Train",
            "artist": "Shoichiro Hirata feat.SUIMI",
            "bpm": 140,
            "imageName": "40fb0b98c947c7dca81e1b187f310de2e504e4f2c81be62868095e045febaad8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 98,
                        "hold": 10,
                        "slide": 9,
                        "touch": null,
                        "break": 3,
                        "total": 120
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 241,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 0,
                        "slide": 16,
                        "touch": null,
                        "break": 2,
                        "total": 217
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 241,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 283,
                        "hold": 38,
                        "slide": 30,
                        "touch": null,
                        "break": 11,
                        "total": 362
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 241,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 91,
                        "slide": 117,
                        "touch": null,
                        "break": 9,
                        "total": 417
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 241,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": [
                "ct",
                "green主题曲",
                "反恐精英",
                "地铁",
                "宇宙列车",
                "小星穹铁道",
                "星穹列车",
                "星空列车"
            ]
        },
        {
            "songId": "maiム・maiム feat.週刊少年マガジン",
            "category": "maimai",
            "title": "maiム・maiム feat.週刊少年マガジン",
            "artist": "にしもと先生、タクマ、どんちゃん「ちょっと盛りました。」",
            "bpm": 140,
            "imageName": "75e132d671165b5e8d94ee14b48bdf3956f8e132289ff59c958b4bfe3c8dabf2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 98,
                        "hold": 18,
                        "slide": 18,
                        "touch": null,
                        "break": 4,
                        "total": 138
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 246,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 29,
                        "slide": 12,
                        "touch": null,
                        "break": 23,
                        "total": 326
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 246,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 446,
                        "hold": 34,
                        "slide": 29,
                        "touch": null,
                        "break": 53,
                        "total": 562
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 246,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 497,
                        "hold": 12,
                        "slide": 103,
                        "touch": null,
                        "break": 72,
                        "total": 684
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 246,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": [
                "三个臭逼",
                "功夫",
                "周刊少年",
                "啦啦啦啦啦"
            ]
        },
        {
            "songId": "Backyun! －悪い女－",
            "category": "maimai",
            "title": "Backyun! －悪い女－",
            "artist": "青木千紘/愛海",
            "bpm": 140,
            "imageName": "77f2e4984751719dd7494540bf2b1fa137693c2687fff96e126a642a1279cd41",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 106,
                        "hold": 9,
                        "slide": 5,
                        "touch": null,
                        "break": 5,
                        "total": 125
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 248,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 222,
                        "hold": 3,
                        "slide": 10,
                        "touch": null,
                        "break": 26,
                        "total": 261
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 248,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 35,
                        "slide": 40,
                        "touch": null,
                        "break": 4,
                        "total": 357
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 248,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 35,
                        "slide": 41,
                        "touch": null,
                        "break": 26,
                        "total": 451
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 248,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.1
                    },
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 396,
                        "hold": 42,
                        "slide": 90,
                        "touch": null,
                        "break": 31,
                        "total": 559
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 248,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 13.3
                    },
                    "releaseDate": "2020-10-29"
                }
            ],
            "searchAcronyms": [
                "坏女人",
                "恶之女",
                "恶女",
                "我异域了"
            ]
        },
        {
            "songId": "みんなのマイマイマー",
            "category": "maimai",
            "title": "みんなのマイマイマー",
            "artist": "ビートまりお(COOL＆CREATE)+ ARM(IOSYS)",
            "bpm": 175,
            "imageName": "18560c2ad305d9902685da1ce88dbc2391b9115bcc25609ff4062127d050f90a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 22,
                        "slide": 2,
                        "touch": null,
                        "break": 11,
                        "total": 144
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 252,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 350,
                        "hold": 3,
                        "slide": 14,
                        "touch": null,
                        "break": 13,
                        "total": 380
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 252,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 314,
                        "hold": 56,
                        "slide": 45,
                        "touch": null,
                        "break": 21,
                        "total": 436
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 252,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 438,
                        "hold": 59,
                        "slide": 30,
                        "touch": null,
                        "break": 98,
                        "total": 625
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 252,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "みんなでマイマイマー",
                    "noteCounts": {
                        "tap": 458,
                        "hold": 28,
                        "slide": 164,
                        "touch": null,
                        "break": 100,
                        "total": 750
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 252,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2022-09-21"
                }
            ],
            "searchAcronyms": [
                "🍥",
                "maimai",
                "大家的maimai",
                "大家的maimai人",
                "大家的maimai吗"
            ]
        },
        {
            "songId": "円舞曲、君に",
            "category": "ゲーム＆バラエティ",
            "title": "円舞曲、君に",
            "artist": "「サクラ大戦奏組」",
            "bpm": 128,
            "imageName": "168e075c9b1ca8ed8743d9771c65db378b867041359e56d916a8b806b654a6ce",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 77,
                        "hold": 21,
                        "slide": 2,
                        "touch": null,
                        "break": 4,
                        "total": 104
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 253,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 83,
                        "hold": 35,
                        "slide": 7,
                        "touch": null,
                        "break": 7,
                        "total": 132
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 253,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 179,
                        "hold": 58,
                        "slide": 21,
                        "touch": null,
                        "break": 14,
                        "total": 272
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 253,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 47,
                        "slide": 48,
                        "touch": null,
                        "break": 6,
                        "total": 394
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 253,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.7,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12
                    },
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": [
                "圆舞曲",
                "舞曲"
            ]
        },
        {
            "songId": "Burning Hearts ～炎のANGEL～",
            "category": "ゲーム＆バラエティ",
            "title": "Burning Hearts ～炎のANGEL～",
            "artist": "幡谷尚史 Arranged by SEGA Sound Unit [H.]「バーニングレンジャー」",
            "bpm": 155,
            "imageName": "8a9850fb0d203e3a48695fbd5a982f100eac063cb9ceed83d269788d22d30c9d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 98,
                        "hold": 17,
                        "slide": 7,
                        "touch": null,
                        "break": 7,
                        "total": 129
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 255,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 24,
                        "slide": 30,
                        "touch": null,
                        "break": 6,
                        "total": 249
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 255,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 53,
                        "slide": 17,
                        "touch": null,
                        "break": 31,
                        "total": 290
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 255,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 309,
                        "hold": 53,
                        "slide": 19,
                        "touch": null,
                        "break": 26,
                        "total": 407
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 255,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 372,
                        "hold": 37,
                        "slide": 98,
                        "touch": null,
                        "break": 50,
                        "total": 557
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 255,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2017-10-02"
                }
            ],
            "searchAcronyms": [
                "Angels with Burning Hearts",
                "br",
                "Burning Angel",
                "Burning Hearts",
                "炎天使",
                "烧心"
            ]
        },
        {
            "songId": "いーあるふぁんくらぶ",
            "category": "niconico＆ボーカロイド",
            "title": "いーあるふぁんくらぶ",
            "artist": "みきとP",
            "bpm": 145,
            "imageName": "67fef67add6efb7153ee69ebb05595155ca7efdeac9c55c490a102c719f70deb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 2,
                        "slide": 5,
                        "touch": 15,
                        "break": 2,
                        "total": 127
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10256,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 14,
                        "slide": 19,
                        "touch": 26,
                        "break": 8,
                        "total": 267
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10256,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 50,
                        "slide": 6,
                        "touch": 36,
                        "break": 8,
                        "total": 323
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10256,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 32,
                        "slide": 40,
                        "touch": 108,
                        "break": 4,
                        "total": 533
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10256,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 84,
                        "hold": 16,
                        "slide": 14,
                        "touch": null,
                        "break": 6,
                        "total": 120
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 256,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 44,
                        "slide": 11,
                        "touch": null,
                        "break": 12,
                        "total": 264
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 256,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 33,
                        "slide": 36,
                        "touch": null,
                        "break": 11,
                        "total": 255
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 256,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 348,
                        "hold": 39,
                        "slide": 33,
                        "touch": null,
                        "break": 28,
                        "total": 448
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 256,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "PRiSM PLUS": 12.2
                    },
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 500,
                        "hold": 13,
                        "slide": 104,
                        "touch": null,
                        "break": 45,
                        "total": 662
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 256,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.1
                    },
                    "releaseDate": "2016-04-06"
                }
            ],
            "searchAcronyms": [
                "1 2 Fanclub",
                "12",
                "12fan",
                "12fanclub",
                "dx王力宏",
                "fanclub",
                "iarufanclub",
                "一二俱乐部",
                "中日友好歌",
                "周杰伦",
                "熊猫头",
                "王力宏"
            ]
        },
        {
            "songId": "Ignite Infinity",
            "category": "ゲーム＆バラエティ",
            "title": "Ignite Infinity",
            "artist": "「PHANTASY STAR PORTABLE2 ∞」",
            "bpm": 160,
            "imageName": "0bd0d8d3acb380d675017b05e1b210749ad9d51b7d9add77ef92288335cc3740",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 81,
                        "hold": 5,
                        "slide": 5,
                        "touch": null,
                        "break": 6,
                        "total": 97
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 267,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 116,
                        "hold": 45,
                        "slide": 8,
                        "touch": null,
                        "break": 5,
                        "total": 174
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 267,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 174,
                        "hold": 49,
                        "slide": 76,
                        "touch": null,
                        "break": 2,
                        "total": 301
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 267,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 55,
                        "slide": 43,
                        "touch": null,
                        "break": 6,
                        "total": 335
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 267,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "Splash": 12
                    },
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": [
                "psp2"
            ]
        },
        {
            "songId": "トルコ行進曲 - オワタ＼(^o^)／",
            "category": "niconico＆ボーカロイド",
            "title": "トルコ行進曲 - オワタ＼(^o^)／",
            "artist": "オワタP",
            "bpm": 120,
            "imageName": "c33d84a130ea2ff3aaf9b14922bf54a21e8171018a139f3fd317ad048c48d2de",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 107,
                        "hold": 11,
                        "slide": 5,
                        "touch": null,
                        "break": 3,
                        "total": 126
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 268,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 174,
                        "hold": 31,
                        "slide": 6,
                        "touch": null,
                        "break": 14,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 268,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 30,
                        "slide": 9,
                        "touch": null,
                        "break": 22,
                        "total": 413
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 268,
                    "releaseDate": "2013-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 539,
                        "hold": 21,
                        "slide": 17,
                        "touch": null,
                        "break": 32,
                        "total": 609
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 268,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.3,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.6,
                        "maimaiでらっくす PLUS": 13.1
                    },
                    "releaseDate": "2013-07-11"
                }
            ],
            "searchAcronyms": [
                "\\（^o^)／",
                "🇹🇷",
                "关我屁事进行曲",
                "土耳其",
                "土耳其进行曲",
                "完蛋了"
            ]
        },
        {
            "songId": "ココロスキャンのうた",
            "category": "ゲーム＆バラエティ",
            "title": "ココロスキャンのうた",
            "artist": "ササキトモコ「音声感情測定器ココロスキャン」",
            "bpm": 203,
            "imageName": "5de725e4304c78e884515827e1cf4fceb7e39f697d1c217210f60b14e66ff622",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 113,
                        "hold": 22,
                        "slide": 4,
                        "touch": null,
                        "break": 3,
                        "total": 142
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 209,
                    "releaseDate": "2013-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 207,
                        "hold": 21,
                        "slide": 12,
                        "touch": null,
                        "break": 7,
                        "total": 247
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 209,
                    "releaseDate": "2013-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 371,
                        "hold": 53,
                        "slide": 22,
                        "touch": null,
                        "break": 22,
                        "total": 468
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 209,
                    "releaseDate": "2013-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 510,
                        "hold": 56,
                        "slide": 42,
                        "touch": null,
                        "break": 16,
                        "total": 624
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 209,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13.1
                    },
                    "releaseDate": "2013-08-07"
                }
            ],
            "searchAcronyms": [
                "少林捂裆功",
                "心灵扫描歌",
                "捂裆歌",
                "捂裆男",
                "武当派",
                "白色小人摸几把",
                "裸男"
            ]
        },
        {
            "songId": "Mysterious Destiny",
            "category": "ゲーム＆バラエティ",
            "title": "Mysterious Destiny",
            "artist": "「BAYONETTA(ベヨネッタ)」",
            "bpm": 140,
            "imageName": "3c73352ee284527ef1d951748b126f2ab95090c2a2583631a4814f44f77ef631",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 86,
                        "hold": 24,
                        "slide": 2,
                        "touch": null,
                        "break": 3,
                        "total": 115
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 216,
                    "releaseDate": "2013-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 193,
                        "hold": 21,
                        "slide": 10,
                        "touch": null,
                        "break": 6,
                        "total": 230
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 216,
                    "releaseDate": "2013-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 61,
                        "slide": 50,
                        "touch": null,
                        "break": 6,
                        "total": 454
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 216,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2013-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 185,
                        "hold": 0,
                        "slide": 185,
                        "touch": null,
                        "break": 2,
                        "total": 372
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 216,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.6
                    },
                    "releaseDate": "2013-08-07"
                }
            ],
            "searchAcronyms": [
                "md",
                "微信",
                "猎天使魔女",
                "神秘命运",
                "贝姐"
            ]
        },
        {
            "songId": "Riders Of The Light",
            "category": "ゲーム＆バラエティ",
            "title": "Riders Of The Light",
            "artist": "「BAYONETTA(ベヨネッタ)」",
            "bpm": 143,
            "imageName": "fe949b999557bdd25d2afe75966eef1450b90b663c35a5743aa94f329231e163",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 84,
                        "hold": 6,
                        "slide": 8,
                        "touch": null,
                        "break": 9,
                        "total": 107
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 217,
                    "releaseDate": "2013-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 22,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 242
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 217,
                    "releaseDate": "2013-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 77,
                        "slide": 28,
                        "touch": null,
                        "break": 2,
                        "total": 383
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 217,
                    "releaseDate": "2013-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 75,
                        "slide": 45,
                        "touch": null,
                        "break": 24,
                        "total": 428
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 217,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "Splash": 12
                    },
                    "releaseDate": "2013-08-07"
                }
            ],
            "searchAcronyms": [
                "光之骑士",
                "光骑"
            ]
        },
        {
            "songId": "Save This World νMIX",
            "category": "ゲーム＆バラエティ",
            "title": "Save This World νMIX",
            "artist": "「PHANTASY STAR PORTABLE」",
            "bpm": 143,
            "imageName": "a2dbf03f162b61fc642c285674f9e40172d28ba03294ca8a30746ec97e37b21f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 90,
                        "hold": 23,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 123
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 265,
                    "releaseDate": "2013-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 84,
                        "hold": 85,
                        "slide": 25,
                        "touch": null,
                        "break": 2,
                        "total": 196
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 265,
                    "releaseDate": "2013-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 31,
                        "slide": 44,
                        "touch": null,
                        "break": 6,
                        "total": 361
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 265,
                    "releaseDate": "2013-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 60,
                        "slide": 89,
                        "touch": null,
                        "break": 3,
                        "total": 348
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 265,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.7,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.2
                    },
                    "releaseDate": "2013-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 395,
                        "hold": 34,
                        "slide": 161,
                        "touch": null,
                        "break": 6,
                        "total": 596
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 265,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.5,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3
                    },
                    "releaseDate": "2016-11-02"
                }
            ],
            "searchAcronyms": [
                "psp",
                "拯救世界",
                "救世",
                "梦幻之星携带版"
            ]
        },
        {
            "songId": "Living Universe",
            "category": "ゲーム＆バラエティ",
            "title": "Living Universe",
            "artist": "「PHANTASY STAR PORTABLE2」",
            "bpm": 155,
            "imageName": "90f3e9fe89dacf36397bbb883b78a1f372ec8454507f2afeaa48e7834583f01b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 56,
                        "hold": 9,
                        "slide": 3,
                        "touch": null,
                        "break": 6,
                        "total": 74
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 266,
                    "releaseDate": "2013-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 24,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 169
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 266,
                    "releaseDate": "2013-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ニャイン",
                    "noteCounts": {
                        "tap": 116,
                        "hold": 45,
                        "slide": 19,
                        "touch": null,
                        "break": 12,
                        "total": 192
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 266,
                    "releaseDate": "2013-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 150,
                        "hold": 45,
                        "slide": 37,
                        "touch": null,
                        "break": 7,
                        "total": 239
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 266,
                    "releaseDate": "2013-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 24,
                        "slide": 73,
                        "touch": null,
                        "break": 23,
                        "total": 495
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 266,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "Splash": 12.1
                    },
                    "releaseDate": "2016-11-02"
                }
            ],
            "searchAcronyms": [
                "psp2",
                "活在宇宙"
            ]
        },
        {
            "songId": "イアイア★ナイトオブデザイア",
            "category": "niconico＆ボーカロイド",
            "title": "イアイア★ナイトオブデザイア",
            "artist": "samfree",
            "bpm": 162,
            "imageName": "067c1d71e34e7ed04aa7d965f719d77f6c3ff910a58c81a709bd22cc915b0c55",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 98,
                        "hold": 2,
                        "slide": 10,
                        "touch": null,
                        "break": 8,
                        "total": 118
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 186,
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 185,
                        "hold": 16,
                        "slide": 16,
                        "touch": null,
                        "break": 13,
                        "total": 230
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 186,
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 165,
                        "hold": 43,
                        "slide": 25,
                        "touch": null,
                        "break": 14,
                        "total": 247
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 186,
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 202,
                        "hold": 70,
                        "slide": 60,
                        "touch": null,
                        "break": 15,
                        "total": 347
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 186,
                    "releaseDate": "2013-09-05"
                }
            ],
            "searchAcronyms": [
                "IAIA",
                "IA是我老婆",
                "yiayia"
            ]
        },
        {
            "songId": "魔理沙は大変なものを盗んでいきました",
            "category": "東方Project",
            "title": "魔理沙は大変なものを盗んでいきました",
            "artist": "ARM＋夕野ヨシミ(IOSYS)feat. 藤咲かりん",
            "bpm": 170,
            "imageName": "0c7e1c973cb55bf315c4a7effa2a938640b73ef4c9c8252893cd9a5b8a3cfc4d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 143,
                        "hold": 8,
                        "slide": 4,
                        "touch": 8,
                        "break": 6,
                        "total": 169
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 12,
                        "slide": 7,
                        "touch": 11,
                        "break": 4,
                        "total": 291
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 62,
                        "slide": 33,
                        "touch": 22,
                        "break": 27,
                        "total": 441
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 461,
                        "hold": 92,
                        "slide": 104,
                        "touch": 78,
                        "break": 39,
                        "total": 774
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 13.6
                    },
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 5,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 201,
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 5,
                        "slide": 12,
                        "touch": null,
                        "break": 16,
                        "total": 283
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 201,
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 71,
                        "slide": 27,
                        "touch": null,
                        "break": 6,
                        "total": 331
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 201,
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 459,
                        "hold": 46,
                        "slide": 67,
                        "touch": null,
                        "break": 12,
                        "total": 584
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 201,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2013-09-05"
                }
            ],
            "searchAcronyms": [
                "123",
                "123123",
                "123123晚自习晚自习一起上",
                "Marisa Stole the Precious Thing",
                "大盗魔理沙",
                "魔理沙",
                "魔理沙偷大便",
                "魔理沙偷大变",
                "魔理沙偷走了重要的东西",
                "魔理沙大便盗",
                "魔理沙大变态",
                "魔理沙大变盗",
                "魔理沙痴",
                "魔理沙盗大变"
            ]
        },
        {
            "songId": "Help me, ERINNNNNN!!（Band ver.）",
            "category": "東方Project",
            "title": "Help me, ERINNNNNN!!（Band ver.）",
            "artist": "ビートまりお(COOL＆CREATE)",
            "bpm": 183,
            "imageName": "0bfba30a9ad204ff1851361b96b1455289c9bdb69218964ed9c35271f052d6f6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 180,
                        "hold": 25,
                        "slide": 7,
                        "touch": null,
                        "break": 6,
                        "total": 218
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 203,
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 201,
                        "hold": 20,
                        "slide": 18,
                        "touch": null,
                        "break": 2,
                        "total": 241
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 203,
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 61,
                        "slide": 60,
                        "touch": null,
                        "break": 15,
                        "total": 412
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 203,
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 383,
                        "hold": 43,
                        "slide": 107,
                        "touch": null,
                        "break": 6,
                        "total": 539
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 203,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2013-09-05"
                }
            ],
            "searchAcronyms": [
                "erin",
                "help me, erinnnnnn!!",
                "帮帮我，肯德基爷爷！",
                "帮我",
                "救我",
                "救救我"
            ]
        },
        {
            "songId": "夜咄ディセイブ",
            "category": "niconico＆ボーカロイド",
            "title": "夜咄ディセイブ",
            "artist": "じん",
            "bpm": 260,
            "imageName": "f0389e8a8e26f1212732799df00318035ec45456863d646f0d26615186c70ff8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 114,
                        "hold": 21,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 147
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 223,
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 228,
                        "hold": 35,
                        "slide": 7,
                        "touch": null,
                        "break": 6,
                        "total": 276
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 223,
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 65,
                        "slide": 17,
                        "touch": null,
                        "break": 18,
                        "total": 436
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 223,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 462,
                        "hold": 23,
                        "slide": 136,
                        "touch": null,
                        "break": 14,
                        "total": 635
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 223,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.4,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2013-09-05"
                }
            ],
            "searchAcronyms": [
                "kano角色歌",
                "Yobanashi",
                "Yobanashi Deceive",
                "夜出",
                "夜咄",
                "夜咄deceive",
                "夜谈欺骗"
            ]
        },
        {
            "songId": "ウサテイ",
            "category": "東方Project",
            "title": "ウサテイ",
            "artist": "あまね＋ビートまりお(COOL＆CREATE)",
            "bpm": 190,
            "imageName": "d556845c5bbf03fce7dd41ef7f69d32459ccd237e4c23f980b28675ac675d283",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 8,
                        "slide": 4,
                        "touch": null,
                        "break": 10,
                        "total": 159
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 224,
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 224,
                        "hold": 28,
                        "slide": 12,
                        "touch": null,
                        "break": 5,
                        "total": 269
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 224,
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 406,
                        "hold": 42,
                        "slide": 7,
                        "touch": null,
                        "break": 10,
                        "total": 465
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 224,
                    "releaseDate": "2013-09-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 549,
                        "hold": 16,
                        "slide": 65,
                        "touch": null,
                        "break": 16,
                        "total": 646
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 224,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.6,
                        "Splash PLUS": 13.6,
                        "UNiVERSE": 13.6,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2013-09-05"
                }
            ],
            "searchAcronyms": [
                "🐇",
                "USATEI",
                "乌撒",
                "兔子",
                "兔子快跑",
                "兔子跑",
                "因幡帝",
                "小老帝",
                "帝帝跑跑跑"
            ]
        },
        {
            "songId": "LUCIA",
            "category": "maimai",
            "title": "LUCIA",
            "artist": "SHIKI",
            "bpm": 154,
            "imageName": "19d16af1ba064a549f785dbd6d4c4a45c851159c480e588d30cd057cf3118e03",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 123,
                        "hold": 9,
                        "slide": 7,
                        "touch": null,
                        "break": 3,
                        "total": 142
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 260,
                    "releaseDate": "2013-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 177,
                        "hold": 22,
                        "slide": 11,
                        "touch": null,
                        "break": 9,
                        "total": 219
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 260,
                    "releaseDate": "2013-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 269,
                        "hold": 82,
                        "slide": 44,
                        "touch": null,
                        "break": 15,
                        "total": 410
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 260,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.3,
                        "CiRCLE PLUS": 12.3,
                        "PRiSM PLUS": 12.3
                    },
                    "releaseDate": "2013-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 416,
                        "hold": 24,
                        "slide": 77,
                        "touch": null,
                        "break": 17,
                        "total": 534
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 260,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.1,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2013-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 572,
                        "hold": 44,
                        "slide": 49,
                        "touch": null,
                        "break": 33,
                        "total": 698
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 260,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.4,
                        "Splash PLUS": 13.4,
                        "UNiVERSE": 13.4,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2020-10-22"
                }
            ],
            "searchAcronyms": [
                "卢锡安",
                "圣枪游侠",
                "露西亚",
                "露西娅"
            ]
        },
        {
            "songId": "Death Scythe",
            "category": "maimai",
            "title": "Death Scythe",
            "artist": "SHIKI",
            "bpm": 182,
            "imageName": "8cccf9898f16f827eb0c419df0982b13b1b1a2846d38d45b89f2e3ec0c0198d2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 21,
                        "slide": 11,
                        "touch": null,
                        "break": 8,
                        "total": 182
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 261,
                    "releaseDate": "2013-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 22,
                        "slide": 9,
                        "touch": null,
                        "break": 20,
                        "total": 282
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 261,
                    "releaseDate": "2013-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.1,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 493,
                        "hold": 15,
                        "slide": 22,
                        "touch": null,
                        "break": 16,
                        "total": 546
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 261,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.1,
                        "CiRCLE PLUS": 12.1,
                        "PRiSM PLUS": 12.1
                    },
                    "releaseDate": "2013-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 630,
                        "hold": 16,
                        "slide": 101,
                        "touch": null,
                        "break": 16,
                        "total": 763
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 261,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2013-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 811,
                        "hold": 32,
                        "slide": 89,
                        "touch": null,
                        "break": 44,
                        "total": 976
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 261,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14.2,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "Splash": 14.2,
                        "Splash PLUS": 14.2,
                        "UNiVERSE": 14.2,
                        "UNiVERSE PLUS": 14.2
                    },
                    "releaseDate": "2020-11-04"
                }
            ],
            "searchAcronyms": [
                "死亡镰刀",
                "死镰",
                "死镰1"
            ]
        },
        {
            "songId": "BREAK YOU!!",
            "category": "maimai",
            "title": "BREAK YOU!!",
            "artist": "A-One",
            "bpm": 167,
            "imageName": "ab50eeb5b02ec236596ce4bdaf720c510670cddeb50746aac1543d8dfb49eb21",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 187,
                        "hold": 3,
                        "slide": 7,
                        "touch": null,
                        "break": 12,
                        "total": 209
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 262,
                    "releaseDate": "2013-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 36,
                        "slide": 12,
                        "touch": null,
                        "break": 9,
                        "total": 219
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 262,
                    "releaseDate": "2013-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 414,
                        "hold": 43,
                        "slide": 57,
                        "touch": null,
                        "break": 29,
                        "total": 543
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 262,
                    "releaseDate": "2013-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 588,
                        "hold": 42,
                        "slide": 108,
                        "touch": null,
                        "break": 34,
                        "total": 772
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 262,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.4,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2013-09-19"
                }
            ],
            "searchAcronyms": [
                "breakyou",
                "炸你",
                "破坏你",
                "碎了你",
                "绝赞你"
            ]
        },
        {
            "songId": "JUMPIN' JUMPIN'",
            "category": "maimai",
            "title": "JUMPIN' JUMPIN'",
            "artist": "SOUND HOLIC feat. Nana Takahashi",
            "bpm": 163,
            "imageName": "a931ea71bf25b5ba292c84b5b8693f03ee5459186986d655c8c893500c25922d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 108,
                        "hold": 18,
                        "slide": 8,
                        "touch": null,
                        "break": 5,
                        "total": 139
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 263,
                    "releaseDate": "2013-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 31,
                        "slide": 24,
                        "touch": null,
                        "break": 13,
                        "total": 295
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 263,
                    "releaseDate": "2013-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 291,
                        "hold": 68,
                        "slide": 58,
                        "touch": null,
                        "break": 20,
                        "total": 437
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 263,
                    "releaseDate": "2013-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 433,
                        "hold": 29,
                        "slide": 93,
                        "touch": null,
                        "break": 36,
                        "total": 591
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 263,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.3
                    },
                    "releaseDate": "2013-09-19"
                }
            ],
            "searchAcronyms": [
                "jj",
                "sh金曲",
                "跳跳"
            ]
        },
        {
            "songId": "L'épilogue",
            "category": "maimai",
            "title": "L'épilogue",
            "artist": "SOUND HOLIC feat. Nana Takahashi",
            "bpm": 145,
            "imageName": "d79ac9dca42e4b4bd7c9d9043618c436e39239f487f064f28023950422698d64",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 134,
                        "hold": 20,
                        "slide": 14,
                        "touch": null,
                        "break": 4,
                        "total": 172
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 264,
                    "releaseDate": "2013-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 19,
                        "slide": 24,
                        "touch": null,
                        "break": 16,
                        "total": 334
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 264,
                    "releaseDate": "2013-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 366,
                        "hold": 52,
                        "slide": 49,
                        "touch": null,
                        "break": 14,
                        "total": 481
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 264,
                    "releaseDate": "2013-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 654,
                        "hold": 31,
                        "slide": 60,
                        "touch": null,
                        "break": 18,
                        "total": 763
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 264,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2013-09-19"
                }
            ],
            "searchAcronyms": [
                "Lepilogue",
                "后记",
                "法文歌"
            ]
        },
        {
            "songId": "ローリンガール",
            "category": "niconico＆ボーカロイド",
            "title": "ローリンガール",
            "artist": "wowaka",
            "bpm": 195,
            "imageName": "bb00ba8a7e6d87964c79781a42a37a1da79022c6a2ae37144c76573b2e5eaf90",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 9,
                        "slide": 4,
                        "touch": 6,
                        "break": 4,
                        "total": 199
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-31"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 274,
                        "hold": 12,
                        "slide": 6,
                        "touch": 26,
                        "break": 4,
                        "total": 322
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-31"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 388,
                        "hold": 65,
                        "slide": 44,
                        "touch": 0,
                        "break": 23,
                        "total": 520
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-31"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 463,
                        "hold": 49,
                        "slide": 109,
                        "touch": 32,
                        "break": 35,
                        "total": 688
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2025-07-31"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 104,
                        "hold": 10,
                        "slide": 8,
                        "touch": null,
                        "break": 5,
                        "total": 127
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 187,
                    "releaseDate": "2013-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 20,
                        "slide": 20,
                        "touch": null,
                        "break": 8,
                        "total": 242
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 187,
                    "releaseDate": "2013-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 193,
                        "hold": 20,
                        "slide": 74,
                        "touch": null,
                        "break": 2,
                        "total": 289
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 187,
                    "releaseDate": "2013-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 378,
                        "hold": 76,
                        "slide": 79,
                        "touch": null,
                        "break": 10,
                        "total": 543
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 187,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2013-10-03"
                }
            ],
            "searchAcronyms": [
                "roiling giri",
                "Rollin'Girl",
                "rolling girl",
                "Rolling Girl",
                "头皮屑",
                "滚女",
                "翻滚少女"
            ]
        },
        {
            "songId": "放課後ストライド",
            "category": "niconico＆ボーカロイド",
            "title": "放課後ストライド",
            "artist": "Last Note.",
            "bpm": 225,
            "imageName": "5455253842fab480af1f53504c81929fa85a64e8b5e050e7cb62998bee7d0af5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 23,
                        "slide": 13,
                        "touch": null,
                        "break": 6,
                        "total": 183
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 194,
                    "releaseDate": "2013-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 266,
                        "hold": 38,
                        "slide": 10,
                        "touch": null,
                        "break": 21,
                        "total": 335
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 194,
                    "releaseDate": "2013-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 443,
                        "hold": 39,
                        "slide": 21,
                        "touch": null,
                        "break": 54,
                        "total": 557
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 194,
                    "releaseDate": "2013-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 429,
                        "hold": 28,
                        "slide": 205,
                        "touch": null,
                        "break": 46,
                        "total": 708
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 194,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2013-10-03"
                }
            ],
            "searchAcronyms": [
                "Houkago Stride",
                "放课后",
                "放课后冲"
            ]
        },
        {
            "songId": "全人類ノ非想天則",
            "category": "東方Project",
            "title": "全人類ノ非想天則",
            "artist": "SOUND HOLIC feat. 匠眞",
            "bpm": 168,
            "imageName": "92bf1e569716924f65df69d9c1166e677f6fc7bb0a852eaa4239974280988e5c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 22,
                        "slide": 5,
                        "touch": null,
                        "break": 5,
                        "total": 160
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 205,
                    "releaseDate": "2013-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 36,
                        "slide": 12,
                        "touch": null,
                        "break": 21,
                        "total": 255
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 205,
                    "releaseDate": "2013-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 268,
                        "hold": 25,
                        "slide": 38,
                        "touch": null,
                        "break": 67,
                        "total": 398
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 205,
                    "releaseDate": "2013-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 421,
                        "hold": 48,
                        "slide": 58,
                        "touch": null,
                        "break": 59,
                        "total": 586
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 205,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2013-10-03"
                }
            ],
            "searchAcronyms": [
                "Zen-Jinrui no Hisoutensoku",
                "全人类",
                "全人类的非想天则",
                "绯想天",
                "非想天则",
                "非想天則",
                "高达"
            ]
        },
        {
            "songId": "しゅわスパ大作戦☆",
            "category": "東方Project",
            "title": "しゅわスパ大作戦☆",
            "artist": "SOUND HOLIC feat. Nana Takahashi",
            "bpm": 140,
            "imageName": "d93a14827483d85307c067519383d23aaca5c2efd544dd0486d485ae52609299",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 115,
                        "hold": 28,
                        "slide": 14,
                        "touch": null,
                        "break": 9,
                        "total": 166
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 206,
                    "releaseDate": "2013-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 191,
                        "hold": 36,
                        "slide": 18,
                        "touch": null,
                        "break": 19,
                        "total": 264
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 206,
                    "releaseDate": "2013-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 271,
                        "hold": 40,
                        "slide": 51,
                        "touch": null,
                        "break": 6,
                        "total": 368
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 206,
                    "releaseDate": "2013-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 391,
                        "hold": 54,
                        "slide": 81,
                        "touch": null,
                        "break": 27,
                        "total": 553
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 206,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.1,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2013-10-03"
                }
            ],
            "searchAcronyms": [
                "ShuwaSupa Daisakusen",
                "ymn",
                "下药神曲",
                "修哇",
                "修哇大作战",
                "大作战",
                "对他使用炎拳吧",
                "炎拳",
                "野兽妹"
            ]
        },
        {
            "songId": "Garakuta Doll Play",
            "category": "maimai",
            "title": "Garakuta Doll Play",
            "artist": "t+pazolite",
            "bpm": 256,
            "imageName": "2fd925d0bc0256851e1c4c80354c792af803f98e057c95972873b5dd352b6a8f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 21,
                        "slide": 12,
                        "touch": null,
                        "break": 4,
                        "total": 246
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 227,
                    "releaseDate": "2013-10-24"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 20,
                        "slide": 3,
                        "touch": null,
                        "break": 39,
                        "total": 392
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 227,
                    "releaseDate": "2013-10-24"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 613,
                        "hold": 60,
                        "slide": 36,
                        "touch": null,
                        "break": 31,
                        "total": 740
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 227,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.1,
                        "Splash": 12.6,
                        "UNiVERSE PLUS": 13.1
                    },
                    "releaseDate": "2013-10-24"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 718,
                        "hold": 6,
                        "slide": 134,
                        "touch": null,
                        "break": 19,
                        "total": 877
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 227,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14.2,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "Splash": 14.2,
                        "Splash PLUS": 14.2,
                        "UNiVERSE": 14.2,
                        "UNiVERSE PLUS": 14.2,
                        "maimaiでらっくす PLUS": 14.2
                    },
                    "releaseDate": "2013-10-24"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 792,
                        "hold": 35,
                        "slide": 154,
                        "touch": null,
                        "break": 29,
                        "total": 1010
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 227,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "FESTiVAL": 14.8,
                        "FESTiVAL PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8,
                        "Splash": 14.9,
                        "Splash PLUS": 14.8,
                        "UNiVERSE": 14.8,
                        "UNiVERSE PLUS": 14.8,
                        "maimaiでらっくす PLUS": 14.8
                    },
                    "releaseDate": "2018-09-17"
                }
            ],
            "searchAcronyms": [
                "🃏",
                "garakuta",
                "garakuta doll",
                "gdp",
                "GDP",
                "joker",
                "tpz教你耍牌",
                "zhy137",
                "国内生产总值",
                "小丑",
                "性感小丑在线发牌",
                "我",
                "扑克牌",
                "旮旯哭他多普雷",
                "果丹皮",
                "潮音",
                "炸批队长",
                "管理",
                "轨道炮",
                "金盆",
                "鬼牌",
                "鸡滴屁"
            ]
        },
        {
            "songId": "System “Z”",
            "category": "maimai",
            "title": "System “Z”",
            "artist": "Jimmy Weckl",
            "bpm": 147,
            "imageName": "8b3292764265e4742752625340e8a72348dc3ef4e99894e6a360ecd27969398c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 101,
                        "hold": 23,
                        "slide": 16,
                        "touch": null,
                        "break": 2,
                        "total": 142
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 239,
                    "releaseDate": "2013-10-24"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 204,
                        "hold": 22,
                        "slide": 17,
                        "touch": null,
                        "break": 6,
                        "total": 249
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 239,
                    "releaseDate": "2013-10-24"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 447,
                        "hold": 23,
                        "slide": 30,
                        "touch": null,
                        "break": 7,
                        "total": 507
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 239,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2013-10-24"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "譜面-100号とはっぴー",
                    "noteCounts": {
                        "tap": 626,
                        "hold": 17,
                        "slide": 128,
                        "touch": null,
                        "break": 6,
                        "total": 777
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 239,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "Splash": 14.2,
                        "Splash PLUS": 14.3,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.3,
                        "maimaiでらっくす PLUS": 14
                    },
                    "releaseDate": "2013-10-24"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 603,
                        "hold": 15,
                        "slide": 130,
                        "touch": null,
                        "break": 5,
                        "total": 753
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 239,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14,
                        "FESTiVAL PLUS": 14,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.9,
                        "Splash PLUS": 14,
                        "UNiVERSE": 14,
                        "UNiVERSE PLUS": 14
                    },
                    "releaseDate": "2020-11-04"
                }
            ],
            "searchAcronyms": [
                "🥗",
                "z",
                "沙拉",
                "系统z",
                "系统贼",
                "蔬菜沙拉"
            ]
        },
        {
            "songId": "＊ハロー、プラネット。",
            "category": "niconico＆ボーカロイド",
            "title": "＊ハロー、プラネット。",
            "artist": "sasakure.UK",
            "bpm": 150,
            "imageName": "53ab14b55b0e6e0c9166580d511ae98ac89970f7e3e626287055dca288af8985",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 87,
                        "hold": 9,
                        "slide": 4,
                        "touch": 8,
                        "break": 5,
                        "total": 113
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10185,
                    "releaseDate": "2023-12-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 18,
                        "slide": 9,
                        "touch": 11,
                        "break": 8,
                        "total": 260
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10185,
                    "releaseDate": "2023-12-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 224,
                        "hold": 15,
                        "slide": 50,
                        "touch": 47,
                        "break": 13,
                        "total": 349
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10185,
                    "releaseDate": "2023-12-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 303,
                        "hold": 43,
                        "slide": 88,
                        "touch": 88,
                        "break": 16,
                        "total": 538
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10185,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-12-08"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 83,
                        "hold": 8,
                        "slide": 6,
                        "touch": null,
                        "break": 6,
                        "total": 103
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 185,
                    "releaseDate": "2013-11-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 16,
                        "slide": 13,
                        "touch": null,
                        "break": 8,
                        "total": 174
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 185,
                    "releaseDate": "2013-11-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 70,
                        "slide": 14,
                        "touch": null,
                        "break": 5,
                        "total": 336
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 185,
                    "releaseDate": "2013-11-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 467,
                        "hold": 31,
                        "slide": 48,
                        "touch": null,
                        "break": 15,
                        "total": 561
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 185,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.1
                    },
                    "releaseDate": "2013-11-14"
                }
            ],
            "searchAcronyms": [
                "*Hello, Planet."
            ]
        },
        {
            "songId": "セガサターン起動音[H.][Remix]",
            "category": "ゲーム＆バラエティ",
            "title": "セガサターン起動音[H.][Remix]",
            "artist": "Hiro",
            "bpm": 148,
            "imageName": "6b2e3ec675ea2e40be0eda7605df74079b548cfaa68964e2727756f49426f2c0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 42,
                        "hold": 10,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 60
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 220,
                    "releaseDate": "2013-11-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 10,
                        "slide": 10,
                        "touch": null,
                        "break": 9,
                        "total": 166
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 220,
                    "releaseDate": "2013-11-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 192,
                        "hold": 37,
                        "slide": 14,
                        "touch": null,
                        "break": 13,
                        "total": 256
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 220,
                    "releaseDate": "2013-11-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 271,
                        "hold": 4,
                        "slide": 72,
                        "touch": null,
                        "break": 21,
                        "total": 368
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 220,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2013-11-14"
                }
            ],
            "searchAcronyms": [
                "sbga",
                "Sega Saturn",
                "Sega Saturn Startup Sound",
                "SEGASATURN Startup Sound[H.][Remix]",
                "ss",
                "世嘉土星",
                "世嘉土星启动音",
                "启动音",
                "土星",
                "大b圈",
                "起动音"
            ]
        },
        {
            "songId": "ぽっぴっぽー",
            "category": "niconico＆ボーカロイド",
            "title": "ぽっぴっぽー",
            "artist": "",
            "bpm": 150,
            "imageName": "634532beae7f19f2ec22f4923713bdb234c44584d43d20df283b6d8756b79392",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 3,
                        "slide": 2,
                        "touch": null,
                        "break": 2,
                        "total": 116
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 259,
                    "releaseDate": "2013-11-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 2,
                        "slide": 14,
                        "touch": null,
                        "break": 18,
                        "total": 268
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 259,
                    "releaseDate": "2013-11-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 52,
                        "slide": 17,
                        "touch": null,
                        "break": 8,
                        "total": 362
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 259,
                    "releaseDate": "2013-11-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 430,
                        "hold": 36,
                        "slide": 37,
                        "touch": null,
                        "break": 4,
                        "total": 507
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 259,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.7,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 13.3
                    },
                    "releaseDate": "2013-11-14"
                }
            ],
            "searchAcronyms": [
                "popipo",
                "波比波",
                "菜蔬汁",
                "蔬菜歌",
                "蔬菜汁"
            ]
        },
        {
            "songId": "裏表ラバーズ",
            "category": "niconico＆ボーカロイド",
            "title": "裏表ラバーズ",
            "artist": "wowaka",
            "bpm": 159,
            "imageName": "7aa9c75f5920b176f038c4f45c6a6459ff97ed25b761865b02460f4bbb024b9c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 5,
                        "slide": 5,
                        "touch": null,
                        "break": 5,
                        "total": 199
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 269,
                    "releaseDate": "2013-11-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 228,
                        "hold": 18,
                        "slide": 25,
                        "touch": null,
                        "break": 9,
                        "total": 280
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 269,
                    "releaseDate": "2013-11-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 443,
                        "hold": 10,
                        "slide": 9,
                        "touch": null,
                        "break": 42,
                        "total": 504
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 269,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL": 12.6,
                        "FESTiVAL PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "UNiVERSE PLUS": 12.6
                    },
                    "releaseDate": "2013-11-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 556,
                        "hold": 2,
                        "slide": 82,
                        "touch": null,
                        "break": 11,
                        "total": 651
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 269,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.1
                    },
                    "releaseDate": "2013-11-14"
                }
            ],
            "searchAcronyms": [
                "Uraomote Lovers",
                "李彪情人",
                "里表",
                "里表中单",
                "里表情人"
            ]
        },
        {
            "songId": "DADDY MULK -Groove remix-",
            "category": "ゲーム＆バラエティ",
            "title": "DADDY MULK -Groove remix-",
            "artist": "Performed by SEGA Sound Unit [H.]",
            "bpm": 154,
            "imageName": "43d48de24ed6d95c7b3f8458b267f23a842d8922d9e83965d3c0d438ff84461a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 98,
                        "hold": 17,
                        "slide": 7,
                        "touch": null,
                        "break": 7,
                        "total": 129
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 115,
                    "releaseDate": "2013-12-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 13,
                        "slide": 12,
                        "touch": null,
                        "break": 12,
                        "total": 310
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 115,
                    "releaseDate": "2013-12-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "ニャインとはっぴー",
                    "noteCounts": {
                        "tap": 400,
                        "hold": 34,
                        "slide": 10,
                        "touch": null,
                        "break": 2,
                        "total": 446
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 115,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2013-12-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 739,
                        "hold": 6,
                        "slide": 38,
                        "touch": null,
                        "break": 2,
                        "total": 785
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 115,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.3
                    },
                    "releaseDate": "2013-12-05"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "ものくロシェ",
                    "noteCounts": {
                        "tap": 798,
                        "hold": 22,
                        "slide": 71,
                        "touch": null,
                        "break": 10,
                        "total": 901
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 115,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.3,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2020-10-22"
                }
            ],
            "searchAcronyms": [
                "大爹奶",
                "大爹马克",
                "忍者战士",
                "爸爸奶",
                "爹地奶",
                "爹奶",
                "爹爹奶",
                "黑屏猜你妈妈"
            ]
        },
        {
            "songId": "弱虫モンブラン",
            "category": "niconico＆ボーカロイド",
            "title": "弱虫モンブラン",
            "artist": "DECO*27",
            "bpm": 120,
            "imageName": "29d81fa1ba93a45d319cfb1930b4f4ccfb26bcb71e5c494281966387bf0a9214",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 94,
                        "hold": 24,
                        "slide": 3,
                        "touch": null,
                        "break": 1,
                        "total": 122
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 189,
                    "releaseDate": "2014-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 6,
                        "slide": 12,
                        "touch": null,
                        "break": 4,
                        "total": 206
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 189,
                    "releaseDate": "2014-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 38,
                        "slide": 23,
                        "touch": null,
                        "break": 3,
                        "total": 267
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 189,
                    "releaseDate": "2014-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 12,
                        "slide": 94,
                        "touch": null,
                        "break": 3,
                        "total": 466
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 189,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.1,
                        "UNiVERSE PLUS": 12.6
                    },
                    "releaseDate": "2014-01-09"
                }
            ],
            "searchAcronyms": [
                "iidx",
                "弱虫",
                "弱鸡",
                "强虫蒙布朗",
                "我回来了",
                "我玩的是盗版",
                "换手练习歌",
                "胆小鬼",
                "胆小鬼蒙布朗",
                "若虫",
                "错位教科书"
            ]
        },
        {
            "songId": "セツナトリップ",
            "category": "niconico＆ボーカロイド",
            "title": "セツナトリップ",
            "artist": "Last Note.",
            "bpm": 145,
            "imageName": "8252b5e69d925fb961c0dd77ccadcd73fa11007164fd5f196814fe592fdca816",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 88,
                        "hold": 8,
                        "slide": 4,
                        "touch": 8,
                        "break": 6,
                        "total": 114
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 10193,
                    "releaseDate": "2022-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 208,
                        "hold": 16,
                        "slide": 12,
                        "touch": 43,
                        "break": 7,
                        "total": 286
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 10193,
                    "releaseDate": "2022-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.8,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 381,
                        "hold": 59,
                        "slide": 27,
                        "touch": 32,
                        "break": 11,
                        "total": 510
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 10193,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 10.8
                    },
                    "releaseDate": "2022-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 634,
                        "hold": 24,
                        "slide": 52,
                        "touch": 35,
                        "break": 51,
                        "total": 796
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 10193,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2022-03-23"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 118,
                        "hold": 15,
                        "slide": 12,
                        "touch": null,
                        "break": 12,
                        "total": 157
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 193,
                    "releaseDate": "2014-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 204,
                        "hold": 14,
                        "slide": 11,
                        "touch": null,
                        "break": 6,
                        "total": 235
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 193,
                    "releaseDate": "2014-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 347,
                        "hold": 48,
                        "slide": 47,
                        "touch": null,
                        "break": 18,
                        "total": 460
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 193,
                    "releaseDate": "2014-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 563,
                        "hold": 23,
                        "slide": 54,
                        "touch": null,
                        "break": 33,
                        "total": 673
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 193,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2014-01-09"
                }
            ],
            "searchAcronyms": [
                "dx刹那旅程",
                "DX刹那旅行",
                "Setsuna Trip",
                "刹那",
                "刹那旅程",
                "刹那旅行",
                "标准刹那旅程"
            ]
        },
        {
            "songId": "Nyan Cat EX",
            "category": "niconico＆ボーカロイド",
            "title": "Nyan Cat EX",
            "artist": "daniwell",
            "bpm": 150,
            "imageName": "9ecabd5ae2be239dbb9c20291e5f3e7106aa91416761aabddc3ae20bf0f02fab",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 2,
                        "slide": 2,
                        "touch": null,
                        "break": 12,
                        "total": 153
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 258,
                    "releaseDate": "2014-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 0,
                        "slide": 13,
                        "touch": null,
                        "break": 19,
                        "total": 273
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 258,
                    "releaseDate": "2014-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "maimai TEAM",
                    "noteCounts": {
                        "tap": 485,
                        "hold": 0,
                        "slide": 4,
                        "touch": null,
                        "break": 3,
                        "total": 492
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 258,
                    "releaseDate": "2014-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 630,
                        "hold": 0,
                        "slide": 40,
                        "touch": null,
                        "break": 40,
                        "total": 710
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 258,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2014-01-09"
                }
            ],
            "searchAcronyms": [
                "🌈🐱",
                "nya",
                "彩虹猫"
            ]
        },
        {
            "songId": "I ♥",
            "category": "niconico＆ボーカロイド",
            "title": "I ♥",
            "artist": "Junky",
            "bpm": 132,
            "imageName": "2e800307a5efc1e200a4299a9c636e100a224eeed67d0bfb93885c889dccc063",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 5,
                        "slide": 2,
                        "touch": null,
                        "break": 8,
                        "total": 140
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 184,
                    "releaseDate": "2014-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 11,
                        "slide": 29,
                        "touch": null,
                        "break": 5,
                        "total": 248
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 184,
                    "releaseDate": "2014-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 22,
                        "slide": 42,
                        "touch": null,
                        "break": 18,
                        "total": 313
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 184,
                    "releaseDate": "2014-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "maimai TEAM",
                    "noteCounts": {
                        "tap": 427,
                        "hold": 29,
                        "slide": 39,
                        "touch": null,
                        "break": 14,
                        "total": 509
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 184,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2014-01-23"
                }
            ],
            "searchAcronyms": [
                "ilove",
                "我爱"
            ]
        },
        {
            "songId": "天ノ弱",
            "category": "niconico＆ボーカロイド",
            "title": "天ノ弱",
            "artist": "164",
            "bpm": 200,
            "imageName": "bf2a05de323d8a8fce0f89299a352dae3924e313d4d88f6f7272f2a36b36a30f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 97,
                        "hold": 12,
                        "slide": 4,
                        "touch": 4,
                        "break": 6,
                        "total": 123
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 10188,
                    "releaseDate": "2021-01-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 261,
                        "hold": 22,
                        "slide": 7,
                        "touch": 29,
                        "break": 5,
                        "total": 324
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 10188,
                    "releaseDate": "2021-01-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 374,
                        "hold": 45,
                        "slide": 41,
                        "touch": 34,
                        "break": 23,
                        "total": 517
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 10188,
                    "releaseDate": "2021-01-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 444,
                        "hold": 63,
                        "slide": 118,
                        "touch": 28,
                        "break": 22,
                        "total": 675
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 10188,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2021-01-20"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 133,
                        "hold": 10,
                        "slide": 7,
                        "touch": null,
                        "break": 8,
                        "total": 158
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 188,
                    "releaseDate": "2014-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 216,
                        "hold": 28,
                        "slide": 18,
                        "touch": null,
                        "break": 16,
                        "total": 278
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 188,
                    "releaseDate": "2014-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 110,
                        "slide": 24,
                        "touch": null,
                        "break": 6,
                        "total": 417
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 188,
                    "releaseDate": "2014-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "mai-Starとはっぴー",
                    "noteCounts": {
                        "tap": 397,
                        "hold": 38,
                        "slide": 137,
                        "touch": null,
                        "break": 16,
                        "total": 588
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 188,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.9,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2014-01-23"
                }
            ],
            "searchAcronyms": [
                "amanojaku",
                "dx天之弱",
                "dx天弱",
                "天之弱",
                "天弱",
                "标准天之弱"
            ]
        },
        {
            "songId": "モザイクロール",
            "category": "niconico＆ボーカロイド",
            "title": "モザイクロール",
            "artist": "DECO*27",
            "bpm": 130,
            "imageName": "6b27ce8cb64fc9075e1032dd6f309c292c7876ac1e2ff95261f86d5c73856343",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 104,
                        "hold": 11,
                        "slide": 4,
                        "touch": 6,
                        "break": 4,
                        "total": 129
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10190,
                    "releaseDate": "2022-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 314,
                        "hold": 13,
                        "slide": 7,
                        "touch": 27,
                        "break": 4,
                        "total": 365
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10190,
                    "releaseDate": "2022-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 362,
                        "hold": 32,
                        "slide": 34,
                        "touch": 3,
                        "break": 31,
                        "total": 462
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10190,
                    "releaseDate": "2022-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 524,
                        "hold": 47,
                        "slide": 77,
                        "touch": 11,
                        "break": 67,
                        "total": 726
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10190,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "BUDDiES PLUS": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2022-09-14"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 107,
                        "hold": 12,
                        "slide": 11,
                        "touch": null,
                        "break": 4,
                        "total": 134
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 190,
                    "releaseDate": "2014-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 12,
                        "slide": 10,
                        "touch": null,
                        "break": 8,
                        "total": 267
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 190,
                    "releaseDate": "2014-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 53,
                        "slide": 34,
                        "touch": null,
                        "break": 9,
                        "total": 452
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 190,
                    "releaseDate": "2014-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 553,
                        "hold": 12,
                        "slide": 78,
                        "touch": null,
                        "break": 7,
                        "total": 650
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN",
                    "internalId": 190,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2014-01-23"
                }
            ],
            "searchAcronyms": [
                "dx马赛克卷",
                "mosaic roll",
                "Mozaik Role",
                "标准马赛克卷",
                "马赛克卷"
            ]
        },
        {
            "songId": "sweet little sister",
            "category": "東方Project",
            "title": "sweet little sister",
            "artist": "Silver Forest",
            "bpm": 168,
            "imageName": "626fd78ef3155e61ecf5d3519983146d6fd4f57b07cdc7000ec969629c8216f0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 180,
                        "hold": 11,
                        "slide": 2,
                        "touch": 7,
                        "break": 4,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 10225,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 16,
                        "slide": 13,
                        "touch": 13,
                        "break": 3,
                        "total": 309
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 10225,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 390,
                        "hold": 27,
                        "slide": 27,
                        "touch": 13,
                        "break": 17,
                        "total": 474
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 10225,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 520,
                        "hold": 29,
                        "slide": 141,
                        "touch": 21,
                        "break": 66,
                        "total": 777
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 10225,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 163,
                        "hold": 5,
                        "slide": 5,
                        "touch": null,
                        "break": 7,
                        "total": 180
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 225,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 29,
                        "slide": 9,
                        "touch": null,
                        "break": 9,
                        "total": 310
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 225,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 43,
                        "slide": 61,
                        "touch": null,
                        "break": 14,
                        "total": 433
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 225,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 451,
                        "hold": 41,
                        "slide": 95,
                        "touch": null,
                        "break": 30,
                        "total": 617
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 225,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.1
                    },
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": [
                "小甜妹",
                "甜二妹",
                "甜小姐姐"
            ]
        },
        {
            "songId": "ぐるぐるWASH！コインランドリー・ディスコ",
            "category": "maimai",
            "title": "ぐるぐるWASH！コインランドリー・ディスコ",
            "artist": "D.watt(IOSYS)feat.ちよこ",
            "bpm": 132,
            "imageName": "28fc845b5a03f5db27ec131dbfe3c30c8940cd6d6b1a220a218d6fc9d029e154",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 5,
                        "slide": 1,
                        "touch": null,
                        "break": 4,
                        "total": 148
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 229,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 144,
                        "hold": 29,
                        "slide": 22,
                        "touch": null,
                        "break": 7,
                        "total": 202
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 229,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 12,
                        "slide": 59,
                        "touch": null,
                        "break": 11,
                        "total": 309
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 229,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 21,
                        "slide": 116,
                        "touch": null,
                        "break": 28,
                        "total": 383
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 229,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": [
                "suomi",
                "咕噜咕噜",
                "咕噜咕噜wash",
                "屏幕清洁工",
                "洗衣房",
                "洗衣机",
                "滚筒洗衣机"
            ]
        },
        {
            "songId": "Monochrome Rainbow",
            "category": "maimai",
            "title": "Monochrome Rainbow",
            "artist": "Sta",
            "bpm": 182,
            "imageName": "9582406e3036d38c9785bdbe844322617fea3a410d9c7d5401485b4cf17b63e4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 121,
                        "hold": 7,
                        "slide": 6,
                        "touch": 7,
                        "break": 4,
                        "total": 145
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 10251,
                    "releaseDate": "2023-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 220,
                        "hold": 24,
                        "slide": 6,
                        "touch": 28,
                        "break": 6,
                        "total": 284
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 10251,
                    "releaseDate": "2023-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 61,
                        "slide": 25,
                        "touch": 14,
                        "break": 15,
                        "total": 421
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 10251,
                    "releaseDate": "2023-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 455,
                        "hold": 44,
                        "slide": 77,
                        "touch": 66,
                        "break": 16,
                        "total": 658
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 10251,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2023-06-07"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 87,
                        "hold": 10,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 103
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 251,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 244,
                        "hold": 11,
                        "slide": 7,
                        "touch": null,
                        "break": 6,
                        "total": 268
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 251,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 329,
                        "hold": 18,
                        "slide": 33,
                        "touch": null,
                        "break": 6,
                        "total": 386
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 251,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 396,
                        "hold": 12,
                        "slide": 76,
                        "touch": null,
                        "break": 16,
                        "total": 500
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 251,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "Splash": 12.1
                    },
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": [
                "😎",
                "单色彩虹",
                "黑白彩虹",
                "黑白格"
            ]
        },
        {
            "songId": "お嫁にしなさいっ！",
            "category": "東方Project",
            "title": "お嫁にしなさいっ！",
            "artist": "ARM＋夕野ヨシミ(IOSYS)",
            "bpm": 180,
            "imageName": "6ea0650f3bb2a06554520e053c505b6d4fa25bafa92eedb09d62d0f18af95a54",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 102,
                        "hold": 23,
                        "slide": 3,
                        "touch": null,
                        "break": 4,
                        "total": 132
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 298,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 24,
                        "slide": 5,
                        "touch": null,
                        "break": 8,
                        "total": 266
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 298,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 27,
                        "slide": 17,
                        "touch": null,
                        "break": 31,
                        "total": 386
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 298,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 422,
                        "hold": 17,
                        "slide": 70,
                        "touch": null,
                        "break": 25,
                        "total": 534
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 298,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.1,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": [
                "Oyome ni Shinasai!",
                "东方花嫁",
                "东方萃翠酒醉",
                "女同7",
                "婚礼",
                "婚礼进行曲",
                "结婚"
            ]
        },
        {
            "songId": "最速最高シャッターガール",
            "category": "東方Project",
            "title": "最速最高シャッターガール",
            "artist": "ビートまりお(COOL＆CREATE)",
            "bpm": 160,
            "imageName": "1fb26f542695ac432624f23b8695a8642792ae43ecd2d611362eaea1ab97cfc1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 106,
                        "hold": 11,
                        "slide": 11,
                        "touch": null,
                        "break": 6,
                        "total": 134
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 320,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 210,
                        "hold": 19,
                        "slide": 12,
                        "touch": null,
                        "break": 7,
                        "total": 248
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 320,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 76,
                        "slide": 37,
                        "touch": null,
                        "break": 8,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 320,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 504,
                        "hold": 22,
                        "slide": 49,
                        "touch": null,
                        "break": 16,
                        "total": 591
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 320,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "Splash": 12.1
                    },
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": [
                "最速最高",
                "文文"
            ]
        },
        {
            "songId": "林檎華憐歌",
            "category": "niconico＆ボーカロイド",
            "title": "林檎華憐歌",
            "artist": "ビートまりお母(尾崎順子)",
            "bpm": 144,
            "imageName": "ef79b4523d74b6c66095bc1da2a3731dac61d22ab586cc2685aedf27fbec908a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 168,
                        "hold": 10,
                        "slide": 1,
                        "touch": null,
                        "break": 2,
                        "total": 181
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 322,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 17,
                        "slide": 21,
                        "touch": null,
                        "break": 10,
                        "total": 275
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 322,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 21,
                        "slide": 49,
                        "touch": null,
                        "break": 35,
                        "total": 462
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 322,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 636,
                        "hold": 27,
                        "slide": 50,
                        "touch": null,
                        "break": 6,
                        "total": 719
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 322,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": [
                "大妈唱歌",
                "拜拜",
                "拜拜拜拜",
                "林檎",
                "苹果歌"
            ]
        },
        {
            "songId": "YATTA!",
            "category": "POPS＆アニメ",
            "title": "YATTA!",
            "artist": "はっぱ隊 [cover]",
            "bpm": 133,
            "imageName": "d4f3469d03a490d7692b0c9aa6ad611e13bbb8e0bd72db3419a4819a0713374b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 104,
                        "hold": 6,
                        "slide": 1,
                        "touch": null,
                        "break": 7,
                        "total": 118
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 323,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 178,
                        "hold": 36,
                        "slide": 5,
                        "touch": null,
                        "break": 4,
                        "total": 223
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 323,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 57,
                        "slide": 15,
                        "touch": null,
                        "break": 22,
                        "total": 323
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 323,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 22,
                        "slide": 100,
                        "touch": null,
                        "break": 4,
                        "total": 402
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 323,
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": [
                "🥕",
                "yatta",
                "好耶！",
                "胡萝卜"
            ]
        },
        {
            "songId": "Windy Hill -Zone 1",
            "category": "ゲーム＆バラエティ",
            "title": "Windy Hill -Zone 1",
            "artist": "大谷智哉「ソニック ロストワールド」",
            "bpm": 194,
            "imageName": "c2e3a9a931e338555b3c1b0e71c3dc48a906d0203ecc16591d23d4a9dbd93661",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 156,
                        "hold": 11,
                        "slide": 5,
                        "touch": null,
                        "break": 5,
                        "total": 177
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 325,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 308,
                        "hold": 11,
                        "slide": 14,
                        "touch": null,
                        "break": 9,
                        "total": 342
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 325,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 433,
                        "hold": 38,
                        "slide": 16,
                        "touch": null,
                        "break": 14,
                        "total": 501
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 325,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 682,
                        "hold": 21,
                        "slide": 25,
                        "touch": null,
                        "break": 13,
                        "total": 741
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 325,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.2
                    },
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": [
                "小追星",
                "疯狂小糖",
                "索4",
                "索尼克失落的世界",
                "追星上位"
            ]
        },
        {
            "songId": "コトバ・カラフル",
            "category": "ゲーム＆バラエティ",
            "title": "コトバ・カラフル",
            "artist": "うたよめ575＜正岡小豆(大坪由佳)小林抹茶(大橋彩香)＞",
            "bpm": 169,
            "imageName": "255c4a9ff236762bf36777f380df88869b77937fb4b1dcf947af52d7d43658c2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 70,
                        "hold": 6,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 84
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 326,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 144,
                        "hold": 11,
                        "slide": 9,
                        "touch": null,
                        "break": 6,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 326,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 17,
                        "slide": 9,
                        "touch": null,
                        "break": 15,
                        "total": 275
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 326,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 459,
                        "hold": 3,
                        "slide": 53,
                        "touch": null,
                        "break": 60,
                        "total": 575
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 326,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.3,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12
                    },
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": [
                "575",
                "双押姐妹花",
                "多彩言语",
                "女同",
                "女同歌",
                "女同贴贴",
                "歌组575"
            ]
        },
        {
            "songId": "アゲアゲアゲイン",
            "category": "niconico＆ボーカロイド",
            "title": "アゲアゲアゲイン",
            "artist": "Mitchie M",
            "bpm": 175,
            "imageName": "ce90177122e2e1646f4afcc8c1a3e9cdbbbb7a00c2f47de353d9a5e5a1e8d744",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 94,
                        "hold": 8,
                        "slide": 4,
                        "touch": null,
                        "break": 3,
                        "total": 109
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 332,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 213,
                        "hold": 24,
                        "slide": 3,
                        "touch": null,
                        "break": 8,
                        "total": 248
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 332,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 22,
                        "slide": 21,
                        "touch": null,
                        "break": 8,
                        "total": 260
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 332,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 299,
                        "hold": 19,
                        "slide": 73,
                        "touch": null,
                        "break": 14,
                        "total": 405
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 332,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash": 12
                    },
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "鼓動",
            "category": "ゲーム＆バラエティ",
            "title": "鼓動",
            "artist": "青木 千紘「龍が如く 維新！」",
            "bpm": 121,
            "imageName": "f611ac05f65f3def55ed58db0247d9b111fdb6446811d7e8a4a82f27aeb23c63",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 2,
                        "slide": 8,
                        "touch": null,
                        "break": 3,
                        "total": 122
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 337,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 208,
                        "hold": 11,
                        "slide": 8,
                        "touch": null,
                        "break": 10,
                        "total": 237
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 337,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 359,
                        "hold": 0,
                        "slide": 2,
                        "touch": null,
                        "break": 18,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 337,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 317,
                        "hold": 27,
                        "slide": 75,
                        "touch": null,
                        "break": 17,
                        "total": 436
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 337,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": [
                "如龙3",
                "如龙维新",
                "鼓动"
            ]
        },
        {
            "songId": "DRAGONLADY",
            "category": "ゲーム＆バラエティ",
            "title": "DRAGONLADY",
            "artist": "Nankumo/CUBE3",
            "bpm": 150,
            "imageName": "5313e97db836afe9ecf552f93337cfc45fcbeb4509fbc64d6e66011454d50a33",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 7,
                        "slide": 2,
                        "touch": null,
                        "break": 10,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 339,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 20,
                        "slide": 24,
                        "touch": null,
                        "break": 12,
                        "total": 303
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 339,
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 2,
                        "slide": 95,
                        "touch": null,
                        "break": 27,
                        "total": 391
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 339,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2014-02-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 609,
                        "hold": 0,
                        "slide": 19,
                        "touch": null,
                        "break": 14,
                        "total": 642
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 339,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.6
                    },
                    "releaseDate": "2014-02-26"
                }
            ],
            "searchAcronyms": [
                "ub",
                "你舍得打破这份宁静吗",
                "喇叭",
                "尼美舒利",
                "纵连女士",
                "舍得",
                "龙女",
                "龙女士",
                "龙玉涛"
            ]
        },
        {
            "songId": "SPiCa",
            "category": "niconico＆ボーカロイド",
            "title": "SPiCa",
            "artist": "とくP",
            "bpm": 162,
            "imageName": "809360fa5b26670861ce182ab6a5f45ad4e7c940f0693ec36f0b42f79a4603fd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 147,
                        "hold": 6,
                        "slide": 7,
                        "touch": null,
                        "break": 6,
                        "total": 166
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 192,
                    "releaseDate": "2014-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 253,
                        "hold": 20,
                        "slide": 18,
                        "touch": null,
                        "break": 11,
                        "total": 302
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 192,
                    "releaseDate": "2014-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 52,
                        "slide": 52,
                        "touch": null,
                        "break": 7,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 192,
                    "releaseDate": "2014-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 320,
                        "hold": 10,
                        "slide": 129,
                        "touch": null,
                        "break": 14,
                        "total": 473
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 192,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.3,
                        "UNiVERSE": 12.3,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2014-03-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "magician's operation",
            "category": "niconico＆ボーカロイド",
            "title": "magician's operation",
            "artist": "EZFG",
            "bpm": 125,
            "imageName": "65bf62db4b996a6cf4ec8c5a06cc5abf8bcaf2e22dd6484d7ef1864b9011343f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 107,
                        "hold": 4,
                        "slide": 5,
                        "touch": null,
                        "break": 5,
                        "total": 121
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 285,
                    "releaseDate": "2014-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 28,
                        "slide": 9,
                        "touch": null,
                        "break": 7,
                        "total": 190
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 285,
                    "releaseDate": "2014-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 317,
                        "hold": 58,
                        "slide": 5,
                        "touch": null,
                        "break": 5,
                        "total": 385
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 285,
                    "releaseDate": "2014-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 443,
                        "hold": 31,
                        "slide": 77,
                        "touch": null,
                        "break": 6,
                        "total": 557
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 285,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2014-03-20"
                }
            ],
            "searchAcronyms": [
                "魔术手",
                "魔法师手术",
                "魔法手指",
                "黑屏"
            ]
        },
        {
            "songId": "M.S.S.Planet",
            "category": "niconico＆ボーカロイド",
            "title": "M.S.S.Planet",
            "artist": "M.S.S Project",
            "bpm": 145,
            "imageName": "05fbb403c069cd7e3379618ee954161a9e45171e7d1dc6480407f7aa27221065",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 102,
                        "hold": 2,
                        "slide": 4,
                        "touch": 8,
                        "break": 10,
                        "total": 126
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10316,
                    "releaseDate": "2022-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 260,
                        "hold": 9,
                        "slide": 15,
                        "touch": 11,
                        "break": 13,
                        "total": 308
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10316,
                    "releaseDate": "2022-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.7,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 33,
                        "slide": 40,
                        "touch": 24,
                        "break": 39,
                        "total": 429
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10316,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 9.7
                    },
                    "releaseDate": "2022-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 442,
                        "hold": 13,
                        "slide": 122,
                        "touch": 86,
                        "break": 37,
                        "total": 700
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10316,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2022-09-14"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 117,
                        "hold": 12,
                        "slide": 4,
                        "touch": null,
                        "break": 11,
                        "total": 144
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 316,
                    "releaseDate": "2014-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 221,
                        "hold": 23,
                        "slide": 23,
                        "touch": null,
                        "break": 12,
                        "total": 279
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 316,
                    "releaseDate": "2014-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 67,
                        "slide": 34,
                        "touch": null,
                        "break": 41,
                        "total": 398
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 316,
                    "releaseDate": "2014-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 403,
                        "hold": 20,
                        "slide": 93,
                        "touch": null,
                        "break": 36,
                        "total": 552
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 316,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "Splash": 12.1
                    },
                    "releaseDate": "2014-03-20"
                }
            ],
            "searchAcronyms": [
                "dxmss",
                "mss",
                "MSS",
                "妈杀杀星球",
                "我是地球"
            ]
        },
        {
            "songId": "二息歩行",
            "category": "niconico＆ボーカロイド",
            "title": "二息歩行",
            "artist": "DECO*27",
            "bpm": 180,
            "imageName": "7c2da73247d4bfd6043821752a985891f5dc06a7cbeab41ea15bc448ca0a287b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 15,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 124
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 341,
                    "releaseDate": "2014-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 13,
                        "slide": 17,
                        "touch": null,
                        "break": 8,
                        "total": 265
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 341,
                    "releaseDate": "2014-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 332,
                        "hold": 5,
                        "slide": 48,
                        "touch": null,
                        "break": 15,
                        "total": 400
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 341,
                    "releaseDate": "2014-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 40,
                        "slide": 92,
                        "touch": null,
                        "break": 8,
                        "total": 542
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 341,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.2
                    },
                    "releaseDate": "2014-03-20"
                }
            ],
            "searchAcronyms": [
                "二息步行",
                "二息电摇",
                "儿媳不行",
                "电摇嘲讽"
            ]
        },
        {
            "songId": "かせげ！ジャリンコヒーロー",
            "category": "ゲーム＆バラエティ",
            "title": "かせげ！ジャリンコヒーロー",
            "artist": "角田信朗「ヒーローバンク」",
            "bpm": 186,
            "imageName": "ead5f04270259f3ca24172615f3bac8f42bee2b73578d3871e571492b47a3136",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 102,
                        "hold": 7,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 121
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 329,
                    "releaseDate": "2014-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 25,
                        "slide": 8,
                        "touch": null,
                        "break": 14,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 329,
                    "releaseDate": "2014-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 6,
                        "slide": 33,
                        "touch": null,
                        "break": 59,
                        "total": 328
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 329,
                    "releaseDate": "2014-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 30,
                        "slide": 50,
                        "touch": null,
                        "break": 25,
                        "total": 416
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 329,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2014-04-07"
                }
            ],
            "searchAcronyms": [
                "哈姆",
                "哈姆？",
                "英雄银行"
            ]
        },
        {
            "songId": "キズナの物語",
            "category": "ゲーム＆バラエティ",
            "title": "キズナの物語",
            "artist": "Trefle「チェインクロニクル」",
            "bpm": 128,
            "imageName": "60db60ab1e402e6b29422f313da4bce788bc65e11babc74e5d91507c7e4fd4e9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 93,
                        "hold": 17,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 119
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 330,
                    "releaseDate": "2014-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 147,
                        "hold": 14,
                        "slide": 30,
                        "touch": null,
                        "break": 12,
                        "total": 203
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 330,
                    "releaseDate": "2014-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 20,
                        "slide": 27,
                        "touch": null,
                        "break": 12,
                        "total": 271
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 330,
                    "releaseDate": "2014-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 10,
                        "slide": 140,
                        "touch": null,
                        "break": 10,
                        "total": 356
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 330,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2014-04-07"
                }
            ],
            "searchAcronyms": [
                "物语",
                "羁绊物语",
                "羁绊的故事",
                "羁绊的物语",
                "锁链战记"
            ]
        },
        {
            "songId": "CYCLES",
            "category": "maimai",
            "title": "CYCLES",
            "artist": "Masayoshi Minoshima feat. 綾倉盟",
            "bpm": 135,
            "imageName": "7ef3e95cf5ded39ef44c85433c98452ae592fe49e58fe716756493adb1a2f9cb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 143,
                        "hold": 31,
                        "slide": 10,
                        "touch": null,
                        "break": 3,
                        "total": 187
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 230,
                    "releaseDate": "2014-04-10"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 244,
                        "hold": 32,
                        "slide": 15,
                        "touch": null,
                        "break": 8,
                        "total": 299
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 230,
                    "releaseDate": "2014-04-10"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 19,
                        "slide": 97,
                        "touch": null,
                        "break": 20,
                        "total": 366
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 230,
                    "releaseDate": "2014-04-10"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 252,
                        "hold": 8,
                        "slide": 217,
                        "touch": null,
                        "break": 19,
                        "total": 496
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 230,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2014-04-10"
                }
            ],
            "searchAcronyms": [
                "🐎🐸🦌",
                "🐴🐸🦌",
                "cyc",
                "cycle",
                "吗哇路",
                "圆",
                "挖马路",
                "轮回",
                "马哇路",
                "马挖路",
                "马洼路",
                "马瓦路",
                "马瓦鲁"
            ]
        },
        {
            "songId": "Heartbeats",
            "category": "maimai",
            "title": "Heartbeats",
            "artist": "RAMM feat. 若井友希",
            "bpm": 170,
            "imageName": "272d353f54cfa310ae2d43895b0e2d7a77094a0ed73a63cc0c6ef7374df09f21",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 24,
                        "slide": 5,
                        "touch": null,
                        "break": 4,
                        "total": 158
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 231,
                    "releaseDate": "2014-04-10"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 253,
                        "hold": 15,
                        "slide": 30,
                        "touch": null,
                        "break": 13,
                        "total": 311
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 231,
                    "releaseDate": "2014-04-10"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 22,
                        "slide": 62,
                        "touch": null,
                        "break": 6,
                        "total": 420
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 231,
                    "releaseDate": "2014-04-10"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 412,
                        "hold": 29,
                        "slide": 61,
                        "touch": null,
                        "break": 30,
                        "total": 532
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 231,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2014-04-10"
                }
            ],
            "searchAcronyms": [
                "小红金曲",
                "心跳"
            ]
        },
        {
            "songId": "Life Feels Good",
            "category": "maimai",
            "title": "Life Feels Good",
            "artist": "Cranky",
            "bpm": 180,
            "imageName": "a3a709eef205b9c1490de68b24389b6d4fad07b55ad8c4ae335a60a55a4f1fe7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 158,
                        "hold": 10,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 177
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 232,
                    "releaseDate": "2014-04-10"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 288,
                        "hold": 23,
                        "slide": 18,
                        "touch": null,
                        "break": 17,
                        "total": 346
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 232,
                    "releaseDate": "2014-04-10"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 466,
                        "hold": 29,
                        "slide": 31,
                        "touch": null,
                        "break": 36,
                        "total": 562
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 232,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2014-04-10"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 594,
                        "hold": 17,
                        "slide": 72,
                        "touch": null,
                        "break": 10,
                        "total": 693
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 232,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2014-04-10"
                }
            ],
            "searchAcronyms": [
                "lfg",
                "好日子",
                "感觉很好",
                "生活感觉好",
                "生活真美好"
            ]
        },
        {
            "songId": "MYTHOS",
            "category": "maimai",
            "title": "MYTHOS",
            "artist": "Cranky feat. まらしぃ ＆ てっぺい先生",
            "bpm": 158,
            "imageName": "d1759073b8ff47cbb1ac00b7a3fb4d0c7c06fcc338671a19362fdcd00510bd1d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 116,
                        "hold": 12,
                        "slide": 15,
                        "touch": null,
                        "break": 9,
                        "total": 152
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 233,
                    "releaseDate": "2014-04-10"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 225,
                        "hold": 19,
                        "slide": 12,
                        "touch": null,
                        "break": 13,
                        "total": 269
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 233,
                    "releaseDate": "2014-04-10"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "Jack vs 譜面-100号",
                    "noteCounts": {
                        "tap": 354,
                        "hold": 14,
                        "slide": 60,
                        "touch": null,
                        "break": 34,
                        "total": 462
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 233,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "PRiSM PLUS": 12.2
                    },
                    "releaseDate": "2014-04-10"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 633,
                        "hold": 6,
                        "slide": 80,
                        "touch": null,
                        "break": 16,
                        "total": 735
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 233,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "Splash": 14.1,
                        "Splash PLUS": 14.1,
                        "UNiVERSE": 14.1,
                        "UNiVERSE PLUS": 14.1,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2014-04-10"
                }
            ],
            "searchAcronyms": [
                "🎻",
                "小提琴"
            ]
        },
        {
            "songId": "End of Twilight",
            "category": "maimai",
            "title": "End of Twilight",
            "artist": "ALiCE'S EMOTiON feat. Ayumi Nomiya",
            "bpm": 180,
            "imageName": "c13b522885cd74cf8f0d7682ddd7a1a9e51c5b1e162c2c5504055c890d9043be",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 155,
                        "hold": 11,
                        "slide": 5,
                        "touch": null,
                        "break": 6,
                        "total": 177
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 234,
                    "releaseDate": "2014-04-10"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 19,
                        "slide": 25,
                        "touch": null,
                        "break": 13,
                        "total": 290
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 234,
                    "releaseDate": "2014-04-10"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 385,
                        "hold": 43,
                        "slide": 43,
                        "touch": null,
                        "break": 19,
                        "total": 490
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 234,
                    "releaseDate": "2014-04-10"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 458,
                        "hold": 33,
                        "slide": 83,
                        "touch": null,
                        "break": 10,
                        "total": 584
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 234,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2014-04-10"
                }
            ],
            "searchAcronyms": [
                "🌃",
                "夜之城",
                "摩天楼",
                "暮光终结"
            ]
        },
        {
            "songId": "ファンタジーゾーン OPA-OPA! -GMT remix-",
            "category": "ゲーム＆バラエティ",
            "title": "ファンタジーゾーン OPA-OPA! -GMT remix-",
            "artist": "Hiro(SEGA)「ファンタジーゾーン」",
            "bpm": 142,
            "imageName": "06514c41bdd855cfcfbe8526748c0eca1dfbfa723f5dbbe7a9ff59c442bd1932",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 130,
                        "hold": 21,
                        "slide": 2,
                        "touch": null,
                        "break": 7,
                        "total": 160
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 342,
                    "releaseDate": "2014-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 48,
                        "slide": 10,
                        "touch": null,
                        "break": 11,
                        "total": 238
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 342,
                    "releaseDate": "2014-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 371,
                        "hold": 51,
                        "slide": 22,
                        "touch": null,
                        "break": 11,
                        "total": 455
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 342,
                    "releaseDate": "2014-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 473,
                        "hold": 38,
                        "slide": 44,
                        "touch": null,
                        "break": 31,
                        "total": 586
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 342,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2014-04-17"
                }
            ],
            "searchAcronyms": [
                "opa",
                "幻想空间",
                "🈸🌞🌝",
                "申日月"
            ]
        },
        {
            "songId": "電車で電車でGO!GO!GO!GC! -GMT remix-",
            "category": "ゲーム＆バラエティ",
            "title": "電車で電車でGO!GO!GO!GC! -GMT remix-",
            "artist": "COSIO(ZUNTATA/TAITO)/沢城千春「電車でGO!」",
            "bpm": 134,
            "imageName": "4ba6ddc8e5e6198a3c3bb76aa2828a708a948c87e5f2786954827844af32173d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 164,
                        "hold": 4,
                        "slide": 2,
                        "touch": null,
                        "break": 8,
                        "total": 178
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 343,
                    "releaseDate": "2014-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 178,
                        "hold": 9,
                        "slide": 24,
                        "touch": null,
                        "break": 41,
                        "total": 252
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 343,
                    "releaseDate": "2014-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 18,
                        "slide": 26,
                        "touch": null,
                        "break": 35,
                        "total": 342
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 343,
                    "releaseDate": "2014-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 437,
                        "hold": 7,
                        "slide": 75,
                        "touch": null,
                        "break": 27,
                        "total": 546
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 343,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2014-04-17"
                }
            ],
            "searchAcronyms": [
                "电车",
                "电车go"
            ]
        },
        {
            "songId": "RIDGE RACER STEPS -GMT remix-",
            "category": "ゲーム＆バラエティ",
            "title": "RIDGE RACER STEPS -GMT remix-",
            "artist": "Yuji Masubuchi(BNGI)「RIDGE RACER」",
            "bpm": 240,
            "imageName": "a1795083ad9d6286966ad3fa3cfe6670b66a07713b22457a90cc9fcab2c4adf3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 136,
                        "hold": 8,
                        "slide": 15,
                        "touch": null,
                        "break": 2,
                        "total": 161
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 344,
                    "releaseDate": "2014-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 228,
                        "hold": 11,
                        "slide": 14,
                        "touch": null,
                        "break": 7,
                        "total": 260
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 344,
                    "releaseDate": "2014-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 468,
                        "hold": 19,
                        "slide": 20,
                        "touch": null,
                        "break": 4,
                        "total": 511
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 344,
                    "releaseDate": "2014-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 509,
                        "hold": 12,
                        "slide": 87,
                        "touch": null,
                        "break": 32,
                        "total": 640
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 344,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.5
                    },
                    "releaseDate": "2014-04-17"
                }
            ],
            "searchAcronyms": [
                "山脊赛车",
                "我创死你",
                "汽车总动员"
            ]
        },
        {
            "songId": "リッジでリッジでGO!GO!GO! -GMT mashup-",
            "category": "ゲーム＆バラエティ",
            "title": "リッジでリッジでGO!GO!GO! -GMT mashup-",
            "artist": "Hiro(SEGA)「RIDGE RACER」「電車でGO!」",
            "bpm": 146,
            "imageName": "e7098ba99e17f553dd843577b05d0aa47f2282a436465613c31f42f54375228b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 10,
                        "slide": 4,
                        "touch": null,
                        "break": 8,
                        "total": 168
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 345,
                    "releaseDate": "2014-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 326,
                        "hold": 16,
                        "slide": 23,
                        "touch": null,
                        "break": 7,
                        "total": 372
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 345,
                    "releaseDate": "2014-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 396,
                        "hold": 27,
                        "slide": 57,
                        "touch": null,
                        "break": 34,
                        "total": 514
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 345,
                    "releaseDate": "2014-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 536,
                        "hold": 10,
                        "slide": 28,
                        "touch": null,
                        "break": 159,
                        "total": 733
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 345,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.2,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2014-05-08"
                }
            ],
            "searchAcronyms": [
                "山脊赛车×电车go",
                "电车",
                "电车go",
                "电车gogogo"
            ]
        },
        {
            "songId": "オパ! オパ! RACER -GMT mashup-",
            "category": "ゲーム＆バラエティ",
            "title": "オパ! オパ! RACER -GMT mashup-",
            "artist": "COSIO(ZUNTATA/TAITO)「ファンタジーゾーン」「RIDGE RACER」",
            "bpm": 172,
            "imageName": "a61f50b78e2b72dc31b55554af003dacbad13504f4d7f39cb3a6bc0f7bf0330c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 17,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 162
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 346,
                    "releaseDate": "2014-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 266,
                        "hold": 6,
                        "slide": 13,
                        "touch": null,
                        "break": 14,
                        "total": 299
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 346,
                    "releaseDate": "2014-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 12,
                        "slide": 68,
                        "touch": null,
                        "break": 11,
                        "total": 378
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 346,
                    "releaseDate": "2014-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 451,
                        "hold": 37,
                        "slide": 49,
                        "touch": null,
                        "break": 21,
                        "total": 558
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 346,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.6,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.3,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.6,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2014-05-08"
                }
            ],
            "searchAcronyms": [
                "坟头对撞",
                "幻想空间×山脊赛车",
                "才八",
                "才八才八",
                "赛车"
            ]
        },
        {
            "songId": "電車で電車でOPA!OPA!OPA! -GMT mashup-",
            "category": "ゲーム＆バラエティ",
            "title": "電車で電車でOPA!OPA!OPA! -GMT mashup-",
            "artist": "Yuji Masubuchi(BNGI)「電車でGO!」「ファンタジーゾーン」",
            "bpm": 134,
            "imageName": "b7b964f36c0ef2c8a5c7081d0739f177a20a583cf8b1a3b9bc43a9b9554594c1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 131,
                        "hold": 11,
                        "slide": 3,
                        "touch": null,
                        "break": 3,
                        "total": 148
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 347,
                    "releaseDate": "2014-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 329,
                        "hold": 6,
                        "slide": 20,
                        "touch": null,
                        "break": 11,
                        "total": 366
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 347,
                    "releaseDate": "2014-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 373,
                        "hold": 46,
                        "slide": 21,
                        "touch": null,
                        "break": 31,
                        "total": 471
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 347,
                    "releaseDate": "2014-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 363,
                        "hold": 14,
                        "slide": 169,
                        "touch": null,
                        "break": 26,
                        "total": 572
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 347,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2014-05-08"
                }
            ],
            "searchAcronyms": [
                "星星电车",
                "电车",
                "电车go×幻想空间",
                "电车opa"
            ]
        },
        {
            "songId": "火炎地獄",
            "category": "maimai",
            "title": "火炎地獄",
            "artist": "山根ミチル",
            "bpm": 216,
            "imageName": "627593efd5b676fb993a7390c816b23eabdcbe32719d3f37da7230016d5ed07e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 107,
                        "hold": 7,
                        "slide": 13,
                        "touch": 10,
                        "break": 11,
                        "total": 148
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10235,
                    "releaseDate": "2022-10-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 193,
                        "hold": 16,
                        "slide": 13,
                        "touch": 12,
                        "break": 18,
                        "total": 252
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10235,
                    "releaseDate": "2022-10-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 389,
                        "hold": 63,
                        "slide": 42,
                        "touch": 22,
                        "break": 27,
                        "total": 543
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10235,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2022-10-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 17,
                        "slide": 72,
                        "touch": 309,
                        "break": 70,
                        "total": 824
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10235,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 14.1,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1
                    },
                    "releaseDate": "2022-10-06"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 81,
                        "hold": 7,
                        "slide": 12,
                        "touch": null,
                        "break": 4,
                        "total": 104
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 235,
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 10,
                        "slide": 12,
                        "touch": null,
                        "break": 10,
                        "total": 347
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 235,
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 323,
                        "hold": 51,
                        "slide": 50,
                        "touch": null,
                        "break": 18,
                        "total": 442
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 235,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.6,
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 457,
                        "hold": 26,
                        "slide": 140,
                        "touch": null,
                        "break": 62,
                        "total": 685
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 235,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2014-05-15"
                }
            ],
            "searchAcronyms": [
                "dx地狱",
                "dx火炎",
                "dx火炎地狱",
                "dx火焰地狱",
                "怪兽",
                "打怪兽",
                "标准火炎",
                "火炎",
                "火炎地狱",
                "绝赞地狱"
            ]
        },
        {
            "songId": "患部で止まってすぐ溶ける～狂気の優曇華院",
            "category": "東方Project",
            "title": "患部で止まってすぐ溶ける～狂気の優曇華院",
            "artist": "ARM＋夕野ヨシミ(IOSYS)feat. miko",
            "bpm": 200,
            "imageName": "6ce9a003708523012465f71db11d1db4d0c3ee5bf61d97bced3b751627b713b7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 77,
                        "hold": 9,
                        "slide": 2,
                        "touch": 10,
                        "break": 5,
                        "total": 103
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10301,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 12,
                        "slide": 12,
                        "touch": 27,
                        "break": 11,
                        "total": 309
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10301,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 291,
                        "hold": 92,
                        "slide": 4,
                        "touch": 167,
                        "break": 6,
                        "total": 560
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10301,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 436,
                        "hold": 29,
                        "slide": 107,
                        "touch": 113,
                        "break": 10,
                        "total": 695
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10301,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13.3
                    },
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 9,
                        "slide": 4,
                        "touch": null,
                        "break": 3,
                        "total": 144
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 301,
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 2,
                        "slide": 18,
                        "touch": null,
                        "break": 11,
                        "total": 326
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 301,
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 439,
                        "hold": 50,
                        "slide": 27,
                        "touch": null,
                        "break": 13,
                        "total": 529
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 301,
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 594,
                        "hold": 23,
                        "slide": 110,
                        "touch": null,
                        "break": 25,
                        "total": 752
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 301,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.4,
                        "Splash PLUS": 13.4,
                        "UNiVERSE": 13.4,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 712,
                        "hold": 21,
                        "slide": 94,
                        "touch": null,
                        "break": 77,
                        "total": 904
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 301,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 14,
                        "FESTiVAL PLUS": 14,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 14,
                        "Splash PLUS": 14,
                        "UNiVERSE": 14,
                        "UNiVERSE PLUS": 14,
                        "maimaiでらっくす PLUS": 14.2
                    },
                    "releaseDate": "2016-10-05"
                }
            ],
            "searchAcronyms": [
                "dx患部",
                "Kanbu",
                "Kanbu de Tomatte Sugu Tokeru",
                "overdrive",
                "Overdrive",
                "优云华院",
                "兔子药",
                "座药",
                "患部",
                "标患部",
                "狂气的优昙华院",
                "肛塞"
            ]
        },
        {
            "songId": "神々の祈り",
            "category": "東方Project",
            "title": "神々の祈り",
            "artist": "舞風-MAIKAZE/沙紗飛鳥",
            "bpm": 130,
            "imageName": "4db6fb1d6536fa627ec4242236b51e6313dd4428ac4c6398eddea3e3b523c04d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 99,
                        "hold": 6,
                        "slide": 6,
                        "touch": null,
                        "break": 1,
                        "total": 112
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 309,
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 168,
                        "hold": 22,
                        "slide": 14,
                        "touch": null,
                        "break": 6,
                        "total": 210
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 309,
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 133,
                        "hold": 52,
                        "slide": 30,
                        "touch": null,
                        "break": 3,
                        "total": 218
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 309,
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 58,
                        "slide": 61,
                        "touch": null,
                        "break": 6,
                        "total": 422
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 309,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.1
                    },
                    "releaseDate": "2014-05-15"
                }
            ],
            "searchAcronyms": [
                "神明的祈祷",
                "神祈"
            ]
        },
        {
            "songId": "エピクロスの虹はもう見えない",
            "category": "東方Project",
            "title": "エピクロスの虹はもう見えない",
            "artist": "SYNC.ART'S feat. 美里",
            "bpm": 155,
            "imageName": "b6c233eeb475de71247d4b4a1e82b08eb2a3e1f3dad673320751e58392111ea0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 96,
                        "hold": 7,
                        "slide": 6,
                        "touch": null,
                        "break": 3,
                        "total": 112
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 310,
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 17,
                        "slide": 13,
                        "touch": null,
                        "break": 9,
                        "total": 176
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 310,
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 39,
                        "slide": 26,
                        "touch": null,
                        "break": 15,
                        "total": 264
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 310,
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 26,
                        "slide": 72,
                        "touch": null,
                        "break": 9,
                        "total": 464
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 310,
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 204,
                        "hold": 130,
                        "slide": 94,
                        "touch": null,
                        "break": 16,
                        "total": 444
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 310,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.5
                    },
                    "releaseDate": "2015-11-11"
                }
            ],
            "searchAcronyms": [
                "Epikouros no niji wa mou mienai",
                "再见不到伊壁鸠鲁的彩虹",
                "圣母",
                "虹见"
            ]
        },
        {
            "songId": "言ノ葉カルマ",
            "category": "maimai",
            "title": "言ノ葉カルマ",
            "artist": "そらる・ろん×れるりり",
            "bpm": 150,
            "imageName": "193698da846e485c888088b26666520ceec3fa9917f965b7325c4fdbc9285ba9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 10,
                        "slide": 3,
                        "touch": null,
                        "break": 9,
                        "total": 179
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 328,
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 226,
                        "hold": 15,
                        "slide": 22,
                        "touch": null,
                        "break": 15,
                        "total": 278
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 328,
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 496,
                        "hold": 27,
                        "slide": 26,
                        "touch": null,
                        "break": 17,
                        "total": 566
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 328,
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 633,
                        "hold": 20,
                        "slide": 105,
                        "touch": null,
                        "break": 34,
                        "total": 792
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 328,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.5
                    },
                    "releaseDate": "2014-05-15"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 627,
                        "hold": 44,
                        "slide": 92,
                        "touch": null,
                        "break": 12,
                        "total": 775
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 328,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2024-03-07"
                }
            ],
            "searchAcronyms": [
                "kotonoha karma",
                "soraru",
                "因果",
                "言叶",
                "言叶业"
            ]
        },
        {
            "songId": "タカハせ！名人マン",
            "category": "maimai",
            "title": "タカハせ！名人マン",
            "artist": "ビートまりお + ARM feat. 高橋名人",
            "bpm": 150,
            "imageName": "7f2bea0c2b68b18f6574712137af566081777a16371cd7ae2de3240912d48ed7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 17,
                        "slide": 6,
                        "touch": null,
                        "break": 7,
                        "total": 133
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 327,
                    "releaseDate": "2014-05-23"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 17,
                        "slide": 9,
                        "touch": null,
                        "break": 17,
                        "total": 290
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 327,
                    "releaseDate": "2014-05-23"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 281,
                        "hold": 47,
                        "slide": 27,
                        "touch": null,
                        "break": 28,
                        "total": 383
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 327,
                    "releaseDate": "2014-05-23"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 437,
                        "hold": 64,
                        "slide": 48,
                        "touch": null,
                        "break": 22,
                        "total": 571
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 327,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5,
                        "Splash": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13.1
                    },
                    "releaseDate": "2014-05-23"
                }
            ],
            "searchAcronyms": [
                "😉",
                "たかはし",
                "光头16连",
                "名人",
                "四号键质检员",
                "奔跑吧！高桥名人侠",
                "高桥",
                "高桥名人"
            ]
        },
        {
            "songId": "Outlaw's Lullaby",
            "category": "ゲーム＆バラエティ",
            "title": "Outlaw's Lullaby",
            "artist": "「龍が如く２」",
            "bpm": 145,
            "imageName": "b03825621f1d4d2d2c5d773a358fae9b380309dd02e680e428e9a3447bb1e6a1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 95,
                        "hold": 12,
                        "slide": 7,
                        "touch": null,
                        "break": 2,
                        "total": 116
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 270,
                    "releaseDate": "2014-06-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 283,
                        "hold": 13,
                        "slide": 10,
                        "touch": null,
                        "break": 4,
                        "total": 310
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 270,
                    "releaseDate": "2014-06-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 321,
                        "hold": 46,
                        "slide": 18,
                        "touch": null,
                        "break": 9,
                        "total": 394
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 270,
                    "releaseDate": "2014-06-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 546,
                        "hold": 64,
                        "slide": 42,
                        "touch": null,
                        "break": 42,
                        "total": 694
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 270,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2014-06-17"
                }
            ],
            "searchAcronyms": [
                "ol",
                "outlaw",
                "史蒂夫抽烈焰棒",
                "史蒂夫抽烟",
                "如龙",
                "如龙2",
                "王源"
            ]
        },
        {
            "songId": "Brand-new Japanesque",
            "category": "ゲーム＆バラエティ",
            "title": "Brand-new Japanesque",
            "artist": "「龍が如く 見参！」",
            "bpm": 135,
            "imageName": "36c560de952f634371af8805a4205b86325561052d1d528084730eb02733e721",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 88,
                        "hold": 6,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 100
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 271,
                    "releaseDate": "2014-06-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 8,
                        "slide": 7,
                        "touch": null,
                        "break": 10,
                        "total": 288
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 271,
                    "releaseDate": "2014-06-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 187,
                        "hold": 58,
                        "slide": 19,
                        "touch": null,
                        "break": 20,
                        "total": 284
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 271,
                    "releaseDate": "2014-06-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 372,
                        "hold": 47,
                        "slide": 43,
                        "touch": null,
                        "break": 8,
                        "total": 470
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 271,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2014-06-17"
                }
            ],
            "searchAcronyms": [
                "全新日本人",
                "如龙0",
                "如龙见参"
            ]
        },
        {
            "songId": "レッツゴー!陰陽師",
            "category": "ゲーム＆バラエティ",
            "title": "レッツゴー!陰陽師",
            "artist": "「新豪血寺一族 -煩悩解放-」",
            "bpm": 150,
            "imageName": "3ab0a277cc0f6bbd35cc4d5a11fa1f7fc5e2d0577c61470449a653258d44dd5b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 78,
                        "hold": 8,
                        "slide": 1,
                        "touch": null,
                        "break": 5,
                        "total": 92
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 278,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 27,
                        "slide": 14,
                        "touch": null,
                        "break": 5,
                        "total": 302
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 278,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 31,
                        "slide": 31,
                        "touch": null,
                        "break": 14,
                        "total": 332
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 278,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 435,
                        "hold": 22,
                        "slide": 126,
                        "touch": null,
                        "break": 15,
                        "total": 598
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 278,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.1
                    },
                    "releaseDate": "2014-07-17"
                }
            ],
            "searchAcronyms": [
                "Let'go!阴阳师",
                "Let's go! Onmyoji",
                "Onmyoji",
                "恶灵退散！恶灵退散！恶灵退散！",
                "挑眉",
                "朱元璋",
                "老登挑眉",
                "阴阳师"
            ]
        },
        {
            "songId": "からくりピエロ",
            "category": "niconico＆ボーカロイド",
            "title": "からくりピエロ",
            "artist": "40mP",
            "bpm": 102,
            "imageName": "a48fd5796466b29761c12fc7990d4d5684d523c474194f21154c9a6eca57abcd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 107,
                        "hold": 0,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 114
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 282,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 10,
                        "slide": 16,
                        "touch": null,
                        "break": 5,
                        "total": 193
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 282,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 30,
                        "slide": 43,
                        "touch": null,
                        "break": 8,
                        "total": 335
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 282,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 332,
                        "hold": 28,
                        "slide": 42,
                        "touch": null,
                        "break": 27,
                        "total": 429
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 282,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.6,
                        "Splash": 12,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 485,
                        "hold": 10,
                        "slide": 62,
                        "touch": null,
                        "break": 10,
                        "total": 567
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 282,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.3
                    },
                    "releaseDate": "2016-09-07"
                }
            ],
            "searchAcronyms": [
                "🤡",
                "Karakuri Pierrot",
                "小丑",
                "我",
                "活动小丑"
            ]
        },
        {
            "songId": "リリリリ★バーニングナイト",
            "category": "niconico＆ボーカロイド",
            "title": "リリリリ★バーニングナイト",
            "artist": "samfree",
            "bpm": 165,
            "imageName": "48666bf9704e4c4777b51c432c7d1fb384d58bc21cef4b1f534b8ebe813027ba",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 171,
                        "hold": 3,
                        "slide": 14,
                        "touch": null,
                        "break": 4,
                        "total": 192
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 290,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 265,
                        "hold": 25,
                        "slide": 20,
                        "touch": null,
                        "break": 18,
                        "total": 328
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 290,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 286,
                        "hold": 27,
                        "slide": 43,
                        "touch": null,
                        "break": 23,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 290,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 61,
                        "slide": 30,
                        "touch": null,
                        "break": 21,
                        "total": 464
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 290,
                    "releaseDate": "2014-07-17"
                }
            ],
            "searchAcronyms": [
                "lily",
                "lilylily",
                "lilylily★burningnight",
                "lilylilyburningnight",
                "哔哩哔哩拿命来",
                "美女躺着",
                "酒吧",
                "酒吧跳舞"
            ]
        },
        {
            "songId": "POP STAR",
            "category": "POPS＆アニメ",
            "title": "POP STAR",
            "artist": "平井堅 [cover]",
            "bpm": 140,
            "imageName": "77890b1417311f0da31ff621aae8516dbef2cc001b5b0f280f057e516de5ab94",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 118,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 6,
                        "total": 132
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 305,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 10,
                        "slide": 8,
                        "touch": null,
                        "break": 3,
                        "total": 260
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 305,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 195,
                        "hold": 25,
                        "slide": 47,
                        "touch": null,
                        "break": 19,
                        "total": 286
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 305,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 341,
                        "hold": 38,
                        "slide": 60,
                        "touch": null,
                        "break": 11,
                        "total": 450
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 305,
                    "releaseDate": "2014-07-17"
                }
            ],
            "searchAcronyms": [
                "匡威"
            ]
        },
        {
            "songId": "待チ人ハ来ズ。",
            "category": "東方Project",
            "title": "待チ人ハ来ズ。",
            "artist": "豚乙女",
            "bpm": 160,
            "imageName": "84dcc861c13d240838a8da052a7b8dfa993b989ae06b6bf52d0f81bf537e86c3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 15,
                        "slide": 7,
                        "touch": null,
                        "break": 5,
                        "total": 132
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 313,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 204,
                        "hold": 32,
                        "slide": 30,
                        "touch": null,
                        "break": 9,
                        "total": 275
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 313,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 243,
                        "hold": 68,
                        "slide": 25,
                        "touch": null,
                        "break": 10,
                        "total": 346
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 313,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 544,
                        "hold": 44,
                        "slide": 84,
                        "touch": null,
                        "break": 21,
                        "total": 693
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 313,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2014-07-17"
                }
            ],
            "searchAcronyms": [
                "machibitohakozu",
                "东方旋转木马",
                "小伞",
                "待人未至",
                "待人来",
                "旋转木马",
                "等人",
                "等的人没有来"
            ]
        },
        {
            "songId": "幻想のサテライト",
            "category": "東方Project",
            "title": "幻想のサテライト",
            "artist": "豚乙女",
            "bpm": 230,
            "imageName": "306f56cd0dfbf01698b1a082043fd78ef1e4a5c1541c6c9b206f878bb541fb31",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 120,
                        "hold": 14,
                        "slide": 4,
                        "touch": 12,
                        "break": 6,
                        "total": 156
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10319,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 24,
                        "slide": 10,
                        "touch": 10,
                        "break": 14,
                        "total": 270
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10319,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 313,
                        "hold": 38,
                        "slide": 32,
                        "touch": 35,
                        "break": 8,
                        "total": 426
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10319,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 395,
                        "hold": 55,
                        "slide": 85,
                        "touch": 188,
                        "break": 5,
                        "total": 728
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10319,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.6,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.6,
                        "FESTiVAL PLUS": 13.6,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5,
                        "Splash": 13.6,
                        "Splash PLUS": 13.6,
                        "UNiVERSE": 13.6,
                        "UNiVERSE PLUS": 13.6,
                        "maimaiでらっくす PLUS": 13.6
                    },
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 13,
                        "slide": 5,
                        "touch": null,
                        "break": 11,
                        "total": 157
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 319,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 6,
                        "slide": 7,
                        "touch": null,
                        "break": 4,
                        "total": 368
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 319,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 386,
                        "hold": 36,
                        "slide": 23,
                        "touch": null,
                        "break": 36,
                        "total": 481
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 319,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 621,
                        "hold": 41,
                        "slide": 169,
                        "touch": null,
                        "break": 19,
                        "total": 850
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 319,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2014-07-17"
                }
            ],
            "searchAcronyms": [
                "dx幻想卫星",
                "Gensou",
                "Gensou no Satelite",
                "gensounosateraito",
                "homo",
                "Satelite",
                "卫星",
                "幻想卫星",
                "幻想的卫星",
                "标幻想卫星"
            ]
        },
        {
            "songId": "バラライカ",
            "category": "POPS＆アニメ",
            "title": "バラライカ",
            "artist": "Performed by 光吉猛修",
            "bpm": 140,
            "imageName": "b9952586b72b32ca308972a8e9c0ebc3ce4cb78151abf1f1a625d842ea2670f9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 130,
                        "hold": 2,
                        "slide": 1,
                        "touch": null,
                        "break": 6,
                        "total": 139
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 321,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 0,
                        "slide": 11,
                        "touch": null,
                        "break": 20,
                        "total": 265
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 321,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 289,
                        "hold": 8,
                        "slide": 21,
                        "touch": null,
                        "break": 43,
                        "total": 361
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 321,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 312,
                        "hold": 14,
                        "slide": 80,
                        "touch": null,
                        "break": 74,
                        "total": 480
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 321,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2014-07-17"
                }
            ],
            "searchAcronyms": [
                "亚拉那一卡",
                "空手",
                "空手道"
            ]
        },
        {
            "songId": "Jack-the-Ripper◆",
            "category": "ゲーム＆バラエティ",
            "title": "Jack-the-Ripper◆",
            "artist": "sasakure.UK",
            "bpm": 210,
            "imageName": "aa61d49f63dc0ed90cd36cc73e28979a8660449e4f97bf57e696bc0804e2b8e7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 25,
                        "slide": 5,
                        "touch": null,
                        "break": 10,
                        "total": 191
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 324,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 436,
                        "hold": 7,
                        "slide": 10,
                        "touch": null,
                        "break": 14,
                        "total": 467
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 324,
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 451,
                        "hold": 88,
                        "slide": 44,
                        "touch": null,
                        "break": 27,
                        "total": 610
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 324,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "PRiSM PLUS": 12.2,
                        "UNiVERSE PLUS": 12.2
                    },
                    "releaseDate": "2014-07-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 741,
                        "hold": 85,
                        "slide": 94,
                        "touch": null,
                        "break": 13,
                        "total": 933
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 324,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2014-07-17"
                }
            ],
            "searchAcronyms": [
                "jack the ripper",
                "jtr",
                "ripper",
                "开膛手",
                "开膛手杰克",
                "杰克开膛手",
                "杰克日批",
                "杰哥",
                "杰哥日批",
                "杰哥雷普"
            ]
        },
        {
            "songId": "Danza zandA",
            "category": "maimai",
            "title": "Danza zandA",
            "artist": "福山光晴",
            "bpm": 129,
            "imageName": "9e81073f5e4c10a6829fb233a40457fe71324caf782dff16d9b0127b694db396",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 16,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 150
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 247,
                    "releaseDate": "2014-08-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 202,
                        "hold": 23,
                        "slide": 13,
                        "touch": null,
                        "break": 3,
                        "total": 241
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 247,
                    "releaseDate": "2014-08-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 29,
                        "slide": 32,
                        "touch": null,
                        "break": 10,
                        "total": 406
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 247,
                    "releaseDate": "2014-08-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 530,
                        "hold": 23,
                        "slide": 58,
                        "touch": null,
                        "break": 27,
                        "total": 638
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 247,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash PLUS": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.5
                    },
                    "releaseDate": "2014-08-22"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 438,
                        "hold": 50,
                        "slide": 73,
                        "touch": null,
                        "break": 54,
                        "total": 615
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 247,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2019-06-20"
                }
            ],
            "searchAcronyms": [
                "万达",
                "小号歌",
                "砸蛋",
                "蛋砸",
                "蛋砸砸蛋"
            ]
        },
        {
            "songId": "Live & Learn",
            "category": "ゲーム＆バラエティ",
            "title": "Live & Learn",
            "artist": "Crush 40「ソニックアドベンチャー2」",
            "bpm": 172,
            "imageName": "56a34c16b15acb0963e7bcd0c6d26bdb527afc44d9498efcea2d460b82186450",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 98,
                        "hold": 18,
                        "slide": 6,
                        "touch": null,
                        "break": 6,
                        "total": 128
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 254,
                    "releaseDate": "2014-08-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 19,
                        "slide": 18,
                        "touch": null,
                        "break": 6,
                        "total": 255
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 254,
                    "releaseDate": "2014-08-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 327,
                        "hold": 51,
                        "slide": 44,
                        "touch": null,
                        "break": 21,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 254,
                    "releaseDate": "2014-08-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 484,
                        "hold": 39,
                        "slide": 62,
                        "touch": null,
                        "break": 75,
                        "total": 660
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 254,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2014-08-22"
                }
            ],
            "searchAcronyms": [
                "sa2",
                "开心超人",
                "索尼克大冒险2"
            ]
        },
        {
            "songId": "Endless, Sleepless Night",
            "category": "東方Project",
            "title": "Endless, Sleepless Night",
            "artist": "samfree feat.(V)・∀・(V)かにぱん。(A-ONE)",
            "bpm": 165,
            "imageName": "75ec41ef5bc161710b96c982fb3b1feb99be6d38871dcd12c0ba3a223f1287c7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 9,
                        "slide": 4,
                        "touch": 8,
                        "break": 8,
                        "total": 186
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 10303,
                    "releaseDate": "2025-07-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 17,
                        "slide": 6,
                        "touch": 27,
                        "break": 4,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 10303,
                    "releaseDate": "2025-07-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 333,
                        "hold": 35,
                        "slide": 37,
                        "touch": 20,
                        "break": 25,
                        "total": 450
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 10303,
                    "releaseDate": "2025-07-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 557,
                        "hold": 34,
                        "slide": 95,
                        "touch": 13,
                        "break": 33,
                        "total": 732
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 10303,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2025-07-03"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 8,
                        "slide": 3,
                        "touch": null,
                        "break": 6,
                        "total": 163
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 303,
                    "releaseDate": "2014-08-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 28,
                        "slide": 21,
                        "touch": null,
                        "break": 11,
                        "total": 323
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 303,
                    "releaseDate": "2014-08-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 57,
                        "slide": 40,
                        "touch": null,
                        "break": 18,
                        "total": 464
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 303,
                    "releaseDate": "2014-08-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 549,
                        "hold": 25,
                        "slide": 91,
                        "touch": null,
                        "break": 19,
                        "total": 684
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 303,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2014-08-22"
                }
            ],
            "searchAcronyms": [
                "不眠之夜",
                "不眠夜",
                "东方不眠夜",
                "无尽不眠夜",
                "漫漫长眠夜",
                "灵梦1"
            ]
        },
        {
            "songId": "Back 2 Back",
            "category": "ゲーム＆バラエティ",
            "title": "Back 2 Back",
            "artist": "長沼英樹「ソニック ラッシュ」",
            "bpm": 150,
            "imageName": "7b557446bdcf05653bf809b175a3e3df558fd6f30c7af96827f175c912c9d526",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 210,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 223
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 308,
                    "releaseDate": "2014-08-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 164,
                        "hold": 10,
                        "slide": 12,
                        "touch": null,
                        "break": 28,
                        "total": 214
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 308,
                    "releaseDate": "2014-08-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 0,
                        "slide": 83,
                        "touch": null,
                        "break": 14,
                        "total": 435
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 308,
                    "releaseDate": "2014-08-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 0,
                        "slide": 189,
                        "touch": null,
                        "break": 2,
                        "total": 381
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 308,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.9,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.1,
                        "Splash PLUS": 13.6,
                        "UNiVERSE": 13.6,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2014-08-22"
                }
            ],
            "searchAcronyms": [
                "b2b",
                "B2B",
                "b歌",
                "你画我猜",
                "回2回",
                "回二回",
                "逼俩逼"
            ]
        },
        {
            "songId": "シアワセうさぎ",
            "category": "東方Project",
            "title": "シアワセうさぎ",
            "artist": "あまね＋ビートまりお(COOL＆CREATE)",
            "bpm": 140,
            "imageName": "bc0fefeac9ced4d894d8f3b2226d478ce2e03214979c6c54b09d837de8b00de7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 122,
                        "hold": 17,
                        "slide": 2,
                        "touch": null,
                        "break": 5,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 311,
                    "releaseDate": "2014-08-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 13,
                        "slide": 14,
                        "touch": null,
                        "break": 13,
                        "total": 258
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 311,
                    "releaseDate": "2014-08-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 40,
                        "slide": 23,
                        "touch": null,
                        "break": 5,
                        "total": 291
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 311,
                    "releaseDate": "2014-08-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 343,
                        "hold": 41,
                        "slide": 44,
                        "touch": null,
                        "break": 7,
                        "total": 435
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 311,
                    "releaseDate": "2014-08-22"
                }
            ],
            "searchAcronyms": [
                "Shiawase Usagi",
                "幸福兔"
            ]
        },
        {
            "songId": "むかしむかしのきょうのぼく",
            "category": "niconico＆ボーカロイド",
            "title": "むかしむかしのきょうのぼく",
            "artist": "DECO*27",
            "bpm": 130,
            "imageName": "39563d0363185ada571201e94f126cf4f16ccd3b5efa33fb995d6c5cefccb831",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 12,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 160
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 284,
                    "releaseDate": "2014-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 9,
                        "slide": 8,
                        "touch": null,
                        "break": 9,
                        "total": 256
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 284,
                    "releaseDate": "2014-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 379,
                        "hold": 30,
                        "slide": 27,
                        "touch": null,
                        "break": 7,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 284,
                    "releaseDate": "2014-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 394,
                        "hold": 39,
                        "slide": 75,
                        "touch": null,
                        "break": 8,
                        "total": 516
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 284,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2014-09-04"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ハロ／ハワユ",
            "category": "niconico＆ボーカロイド",
            "title": "ハロ／ハワユ",
            "artist": "ナノウ",
            "bpm": 95,
            "imageName": "c5030b06cf769d19a65ab148c10c80ded4128aa1667a4e9ca1335e1e56ab6e49",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 3,
                        "slide": 1,
                        "touch": null,
                        "break": 2,
                        "total": 115
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 291,
                    "releaseDate": "2014-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 149,
                        "hold": 21,
                        "slide": 5,
                        "touch": null,
                        "break": 5,
                        "total": 180
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 291,
                    "releaseDate": "2014-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 177,
                        "hold": 50,
                        "slide": 15,
                        "touch": null,
                        "break": 4,
                        "total": 246
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 291,
                    "releaseDate": "2014-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 416,
                        "hold": 32,
                        "slide": 35,
                        "touch": null,
                        "break": 9,
                        "total": 492
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 291,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2014-09-04"
                }
            ],
            "searchAcronyms": [
                "hello",
                "hello how are you",
                "hello，how are you",
                "hello/howareyou",
                "你好",
                "八口",
                "被踩:ハロ/ハワユ"
            ]
        },
        {
            "songId": "深海少女",
            "category": "niconico＆ボーカロイド",
            "title": "深海少女",
            "artist": "ゆうゆ",
            "bpm": 137,
            "imageName": "d3fb09cbe6884344505bb54de035bdf76d915f46f9bdcd131eee15ac8815ba5f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 92,
                        "hold": 16,
                        "slide": 4,
                        "touch": 12,
                        "break": 1,
                        "total": 125
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 10315,
                    "releaseDate": "2023-03-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 23,
                        "slide": 10,
                        "touch": 24,
                        "break": 12,
                        "total": 268
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 10315,
                    "releaseDate": "2023-03-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "佑",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 50,
                        "slide": 26,
                        "touch": 18,
                        "break": 21,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 10315,
                    "releaseDate": "2023-03-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 530,
                        "hold": 38,
                        "slide": 92,
                        "touch": 31,
                        "break": 23,
                        "total": 714
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 10315,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2023-03-22"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 12,
                        "slide": 3,
                        "touch": null,
                        "break": 5,
                        "total": 145
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 315,
                    "releaseDate": "2014-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 33,
                        "slide": 25,
                        "touch": null,
                        "break": 12,
                        "total": 221
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 315,
                    "releaseDate": "2014-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 131,
                        "hold": 107,
                        "slide": 28,
                        "touch": null,
                        "break": 10,
                        "total": 276
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 315,
                    "releaseDate": "2014-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 424,
                        "hold": 46,
                        "slide": 99,
                        "touch": null,
                        "break": 8,
                        "total": 577
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "GreeN PLUS",
                    "internalId": 315,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2014-09-04"
                }
            ],
            "searchAcronyms": [
                "Deep-Sea Girl",
                "Shinkai Shoujo",
                "深海和少女相比",
                "深海邵壮",
                "深海魔男",
                "贵州和广西相比"
            ]
        },
        {
            "songId": "ダブルラリアット",
            "category": "niconico＆ボーカロイド",
            "title": "ダブルラリアット",
            "artist": "アゴアニキ",
            "bpm": 138,
            "imageName": "7d0c91c09383d4edc9a9af1c9a5f4247ce7121879a3b10230d92f73f22c7776d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 130,
                        "hold": 19,
                        "slide": 2,
                        "touch": null,
                        "break": 4,
                        "total": 155
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 281,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 161,
                        "hold": 20,
                        "slide": 11,
                        "touch": null,
                        "break": 5,
                        "total": 197
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 281,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 52,
                        "slide": 42,
                        "touch": null,
                        "break": 8,
                        "total": 277
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 281,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 324,
                        "hold": 17,
                        "slide": 110,
                        "touch": null,
                        "break": 16,
                        "total": 467
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 281,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2014-09-18"
                }
            ],
            "searchAcronyms": [
                "Double Lariat"
            ]
        },
        {
            "songId": "緋色のDance",
            "category": "東方Project",
            "title": "緋色のDance",
            "artist": "岸田教団＆THE明星ロケッツ",
            "bpm": 155,
            "imageName": "510ad44afb07924d922208c1c719cbb71f8ea52d029ab4886c5c700efbf24a1b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 107,
                        "hold": 16,
                        "slide": 4,
                        "touch": null,
                        "break": 8,
                        "total": 135
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 295,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 249,
                        "hold": 0,
                        "slide": 15,
                        "touch": null,
                        "break": 10,
                        "total": 274
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 295,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 358,
                        "hold": 32,
                        "slide": 17,
                        "touch": null,
                        "break": 10,
                        "total": 417
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 295,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 522,
                        "hold": 6,
                        "slide": 58,
                        "touch": null,
                        "break": 12,
                        "total": 598
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 295,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.5
                    },
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 0,
                        "slide": 229,
                        "touch": null,
                        "break": 26,
                        "total": 484
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 295,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.1
                    },
                    "releaseDate": "2015-11-11"
                }
            ],
            "searchAcronyms": [
                "Hiiro no DANCE",
                "绯色",
                "绯色dance",
                "绯色之舞"
            ]
        },
        {
            "songId": "明星ロケット",
            "category": "東方Project",
            "title": "明星ロケット",
            "artist": "岸田教団＆THE明星ロケッツ",
            "bpm": 163,
            "imageName": "b8b2e30dbb424f87f84fa05a46c55630a0ca07afeece88d385ce88830e1ced87",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 102,
                        "hold": 10,
                        "slide": 4,
                        "touch": null,
                        "break": 6,
                        "total": 122
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 296,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 224,
                        "hold": 22,
                        "slide": 17,
                        "touch": null,
                        "break": 7,
                        "total": 270
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 296,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 47,
                        "slide": 19,
                        "touch": null,
                        "break": 4,
                        "total": 293
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 296,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 13,
                        "slide": 76,
                        "touch": null,
                        "break": 10,
                        "total": 396
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 296,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 17,
                        "slide": 108,
                        "touch": null,
                        "break": 12,
                        "total": 512
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 296,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2016-02-03"
                }
            ],
            "searchAcronyms": [
                "Akeboshi Rocket",
                "幻想事变",
                "明星",
                "明星火箭"
            ]
        },
        {
            "songId": "MIRROR of MAGIC",
            "category": "maimai",
            "title": "MIRROR of MAGIC",
            "artist": "Shoichiro Hirata feat.SUIMI",
            "bpm": 135,
            "imageName": "0500229a1fba056cab4d4a872b4ac8f734812e3ebc2b3c5a978c9502dff579d6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 191,
                        "hold": 5,
                        "slide": 1,
                        "touch": null,
                        "break": 5,
                        "total": 202
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 351,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 302,
                        "hold": 20,
                        "slide": 14,
                        "touch": null,
                        "break": 8,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 351,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 291,
                        "hold": 36,
                        "slide": 61,
                        "touch": null,
                        "break": 14,
                        "total": 402
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 351,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 406,
                        "hold": 52,
                        "slide": 82,
                        "touch": null,
                        "break": 12,
                        "total": 552
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 351,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.1
                    },
                    "releaseDate": "2014-09-18"
                }
            ],
            "searchAcronyms": [
                "mom",
                "镜子魔法",
                "镜魔",
                "魔镜"
            ]
        },
        {
            "songId": "One Step Ahead",
            "category": "niconico＆ボーカロイド",
            "title": "One Step Ahead",
            "artist": "伊東歌詞太郎",
            "bpm": 186,
            "imageName": "ab58f0aeda05de549daeb0c56c58c5ad654edfeb57ef6e85ebde349ccd232dc9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 155,
                        "hold": 17,
                        "slide": 4,
                        "touch": 16,
                        "break": 4,
                        "total": 196
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 10375,
                    "releaseDate": "2024-09-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 21,
                        "slide": 6,
                        "touch": 25,
                        "break": 2,
                        "total": 285
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 10375,
                    "releaseDate": "2024-09-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 390,
                        "hold": 25,
                        "slide": 26,
                        "touch": 15,
                        "break": 29,
                        "total": 485
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 10375,
                    "releaseDate": "2024-09-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 415,
                        "hold": 54,
                        "slide": 121,
                        "touch": 16,
                        "break": 48,
                        "total": 654
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 10375,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2024-09-11"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 211,
                        "hold": 4,
                        "slide": 11,
                        "touch": null,
                        "break": 2,
                        "total": 228
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 375,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 235,
                        "hold": 25,
                        "slide": 9,
                        "touch": null,
                        "break": 6,
                        "total": 275
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 375,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 55,
                        "slide": 21,
                        "touch": null,
                        "break": 14,
                        "total": 401
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 375,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 333,
                        "hold": 52,
                        "slide": 91,
                        "touch": null,
                        "break": 15,
                        "total": 491
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 375,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2014-09-18"
                }
            ],
            "searchAcronyms": [
                "一步个头",
                "一步向前",
                "向前一步"
            ]
        },
        {
            "songId": "B.B.K.K.B.K.K.",
            "category": "ゲーム＆バラエティ",
            "title": "B.B.K.K.B.K.K.",
            "artist": "nora2r",
            "bpm": 170,
            "imageName": "81badfa10e1f7e5c4722b5429e591676d37e99e123abfe66490a08ab8d324909",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 4,
                        "slide": 1,
                        "touch": null,
                        "break": 6,
                        "total": 258
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 381,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 456,
                        "hold": 13,
                        "slide": 24,
                        "touch": null,
                        "break": 9,
                        "total": 502
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 381,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 581,
                        "hold": 26,
                        "slide": 61,
                        "touch": null,
                        "break": 8,
                        "total": 676
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 381,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 767,
                        "hold": 12,
                        "slide": 116,
                        "touch": null,
                        "break": 9,
                        "total": 904
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 381,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2014-09-18"
                }
            ],
            "searchAcronyms": [
                "↑↓",
                "bass kick",
                "bbk",
                "bbkk",
                "bbkkbkk",
                "bk",
                "s.s.b.b.s.b.b",
                "ssbbsbb",
                "小bk的",
                "汉堡王"
            ]
        },
        {
            "songId": "おこちゃま戦争",
            "category": "niconico＆ボーカロイド",
            "title": "おこちゃま戦争",
            "artist": "ギガ/れをる",
            "bpm": 175,
            "imageName": "6ef17fd248e72340fc80e000f37b38ee0048aef5482a4de101c2cd9af87509e9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 198,
                        "hold": 24,
                        "slide": 3,
                        "touch": null,
                        "break": 7,
                        "total": 232
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 382,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 7,
                        "slide": 10,
                        "touch": null,
                        "break": 14,
                        "total": 376
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 382,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 58,
                        "slide": 28,
                        "touch": null,
                        "break": 14,
                        "total": 449
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 382,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 658,
                        "hold": 27,
                        "slide": 40,
                        "touch": null,
                        "break": 15,
                        "total": 740
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 382,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash PLUS": 12.9,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2014-09-18"
                }
            ],
            "searchAcronyms": [
                "Okochama Sensou",
                "Okocyama Sensou",
                "孩子气战争",
                "孩子气的战争",
                "战争"
            ]
        },
        {
            "songId": "Link (2)",
            "category": "niconico＆ボーカロイド",
            "title": "Link",
            "artist": "Circle of friends(天月-あまつき-・un:c・伊東歌詞太郎・コニー・はしやん)",
            "bpm": 198,
            "imageName": "39fe3f0024f36553ce39b4c030a727f1b523d7f14ce2672fc81f587075e805e7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 269,
                        "hold": 4,
                        "slide": 2,
                        "touch": null,
                        "break": 3,
                        "total": 278
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 383,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 26,
                        "slide": 17,
                        "touch": null,
                        "break": 12,
                        "total": 337
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 383,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 367,
                        "hold": 28,
                        "slide": 22,
                        "touch": null,
                        "break": 8,
                        "total": 425
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 383,
                    "releaseDate": "2014-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 485,
                        "hold": 57,
                        "slide": 60,
                        "touch": null,
                        "break": 11,
                        "total": 613
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 383,
                    "releaseDate": "2014-09-18"
                }
            ],
            "searchAcronyms": [
                "cof",
                "朋友圈"
            ]
        },
        {
            "songId": "Dreampainter",
            "category": "maimai",
            "title": "Dreampainter",
            "artist": "Sta feat.tigerlily and DOT96",
            "bpm": 136,
            "imageName": "b8ef1498af130d1cd7b64954eb7e3baef14076f7f7df0b79f4c5caddfe4c8112",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 106,
                        "hold": 9,
                        "slide": 6,
                        "touch": null,
                        "break": 3,
                        "total": 124
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 228,
                    "releaseDate": "2014-10-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 24,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 316
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 228,
                    "releaseDate": "2014-10-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 71,
                        "slide": 24,
                        "touch": null,
                        "break": 8,
                        "total": 353
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 228,
                    "releaseDate": "2014-10-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 29,
                        "slide": 99,
                        "touch": null,
                        "break": 5,
                        "total": 469
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 228,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.2
                    },
                    "releaseDate": "2014-10-09"
                }
            ],
            "searchAcronyms": [
                "🎩",
                "sta金曲",
                "梦境绘画者"
            ]
        },
        {
            "songId": "The Great Journey",
            "category": "ゲーム＆バラエティ",
            "title": "The Great Journey",
            "artist": "光吉猛修「ホルカ・トルカ」",
            "bpm": 135,
            "imageName": "38f8f48ee156cea6674bd5af9ff7410401a8ac36412ed4d235adbd61ab270d7c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 160,
                        "hold": 10,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 184
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 297,
                    "releaseDate": "2014-10-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 16,
                        "slide": 9,
                        "touch": null,
                        "break": 3,
                        "total": 255
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 297,
                    "releaseDate": "2014-10-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 248,
                        "hold": 57,
                        "slide": 25,
                        "touch": null,
                        "break": 11,
                        "total": 341
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 297,
                    "releaseDate": "2014-10-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 417,
                        "hold": 51,
                        "slide": 33,
                        "touch": null,
                        "break": 19,
                        "total": 520
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 297,
                    "releaseDate": "2014-10-09"
                }
            ],
            "searchAcronyms": [
                "大冒险",
                "好旅行",
                "黄金矿工"
            ]
        },
        {
            "songId": "きたさいたま2000",
            "category": "ゲーム＆バラエティ",
            "title": "きたさいたま2000",
            "artist": "LindaAI-CUE(BNGI)「太鼓の達人」より",
            "bpm": 222,
            "imageName": "8f925c357cf40d1b17b9c3d6b195f50f97f66ed7a793d8117fd71a38a147487c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 187,
                        "hold": 4,
                        "slide": 2,
                        "touch": null,
                        "break": 6,
                        "total": 199
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 388,
                    "releaseDate": "2014-10-29"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 31,
                        "slide": 20,
                        "touch": null,
                        "break": 18,
                        "total": 278
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 388,
                    "releaseDate": "2014-10-29"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 593,
                        "hold": 8,
                        "slide": 23,
                        "touch": null,
                        "break": 13,
                        "total": 637
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 388,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2014-10-29"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "譜面-100号とはっぴー",
                    "noteCounts": {
                        "tap": 697,
                        "hold": 27,
                        "slide": 89,
                        "touch": null,
                        "break": 27,
                        "total": 840
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 388,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14.2,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "Splash": 14.2,
                        "Splash PLUS": 14.2,
                        "UNiVERSE": 14.2,
                        "UNiVERSE PLUS": 14.2,
                        "maimaiでらっくす PLUS": 14.2
                    },
                    "releaseDate": "2014-10-29"
                }
            ],
            "searchAcronyms": [
                "😁😁😁😁😁",
                "2000",
                "kita",
                "下北泽2000",
                "中年社畜的怒吼",
                "五个🐷🐷拉屎",
                "五个傻逼",
                "五兄弟",
                "五大阴兵",
                "光污染小人",
                "全网最帅五兄弟",
                "北埼玉",
                "北埼玉2000",
                "北琦玉",
                "北琦玉2000",
                "史",
                "塞他妈",
                "太鼓2000",
                "屎",
                "过北脱新"
            ]
        },
        {
            "songId": "FLOWER",
            "category": "ゲーム＆バラエティ",
            "title": "FLOWER",
            "artist": "DJ YOSHITAKA「jubeat」より",
            "bpm": 173,
            "imageName": "da91c79222faa000bc23e5f2d1f02fbf2627981b3ef559164bcefe609e9c0a35",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 18,
                        "slide": 2,
                        "touch": null,
                        "break": 2,
                        "total": 212
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 389,
                    "releaseDate": "2014-10-29"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 248,
                        "hold": 24,
                        "slide": 17,
                        "touch": null,
                        "break": 8,
                        "total": 297
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 389,
                    "releaseDate": "2014-10-29"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 510,
                        "hold": 34,
                        "slide": 23,
                        "touch": null,
                        "break": 6,
                        "total": 573
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 389,
                    "releaseDate": "2014-10-29"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 648,
                        "hold": 56,
                        "slide": 78,
                        "touch": null,
                        "break": 30,
                        "total": 812
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 389,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2014-10-29"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 771,
                        "hold": 91,
                        "slide": 55,
                        "touch": null,
                        "break": 44,
                        "total": 961
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 389,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "UNiVERSE PLUS": 14.3
                    },
                    "releaseDate": "2022-07-28"
                }
            ],
            "searchAcronyms": [
                "扶老二",
                "花",
                "花神"
            ]
        },
        {
            "songId": "Got more raves？",
            "category": "ゲーム＆バラエティ",
            "title": "Got more raves？",
            "artist": "E.G.G.「グルーヴコースター」より",
            "bpm": 266,
            "imageName": "a2549bd0afcfd0c262823acd96912fdb2887dfc172e90c6649fc9b65742fb7e1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 20,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 390,
                    "releaseDate": "2014-10-29"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 16,
                        "slide": 11,
                        "touch": null,
                        "break": 6,
                        "total": 363
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 390,
                    "releaseDate": "2014-10-29"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 412,
                        "hold": 71,
                        "slide": 9,
                        "touch": null,
                        "break": 10,
                        "total": 502
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 390,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2014-10-29"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 762,
                        "hold": 25,
                        "slide": 81,
                        "touch": null,
                        "break": 34,
                        "total": 902
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 390,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "Splash": 14,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2014-10-29"
                }
            ],
            "searchAcronyms": [
                "gmr",
                "郭沫若",
                "雷神"
            ]
        },
        {
            "songId": "shake it!",
            "category": "niconico＆ボーカロイド",
            "title": "shake it!",
            "artist": "emon",
            "bpm": 130,
            "imageName": "0962b2d79a9cf7381e206d6ca1e0808a473d3f2e866c34a6a7389dea5ca608b2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 1,
                        "slide": 3,
                        "touch": null,
                        "break": 2,
                        "total": 152
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 353,
                    "releaseDate": "2014-11-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 16,
                        "slide": 5,
                        "touch": null,
                        "break": 10,
                        "total": 258
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 353,
                    "releaseDate": "2014-11-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 300,
                        "hold": 44,
                        "slide": 20,
                        "touch": null,
                        "break": 10,
                        "total": 374
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 353,
                    "releaseDate": "2014-11-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 355,
                        "hold": 69,
                        "slide": 48,
                        "touch": null,
                        "break": 25,
                        "total": 497
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 353,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2014-11-13"
                }
            ],
            "searchAcronyms": [
                "shake it",
                "摇它",
                "狗zhai子",
                "骑自行车的男人",
                "骑车"
            ]
        },
        {
            "songId": "BETTER CHOICE",
            "category": "maimai",
            "title": "BETTER CHOICE",
            "artist": "Jimmy Weckl feat.高貴みな",
            "bpm": 130,
            "imageName": "121cc60b6e34cbadcbf4b374385a746be409a4fdda8b9057384c08534efd63df",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 107,
                        "hold": 11,
                        "slide": 4,
                        "touch": null,
                        "break": 6,
                        "total": 128
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 362,
                    "releaseDate": "2014-11-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 320,
                        "hold": 10,
                        "slide": 15,
                        "touch": null,
                        "break": 2,
                        "total": 347
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 362,
                    "releaseDate": "2014-11-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 291,
                        "hold": 42,
                        "slide": 28,
                        "touch": null,
                        "break": 9,
                        "total": 370
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 362,
                    "releaseDate": "2014-11-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 456,
                        "hold": 38,
                        "slide": 42,
                        "touch": null,
                        "break": 14,
                        "total": 550
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 362,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.4
                    },
                    "releaseDate": "2014-11-13"
                }
            ],
            "searchAcronyms": [
                "👄",
                "更好的选择",
                "更好选择",
                "烈焰红唇"
            ]
        },
        {
            "songId": "VERTeX",
            "category": "maimai",
            "title": "VERTeX",
            "artist": "Hiro「maimai」より",
            "bpm": 237,
            "imageName": "78a076f279af1be59ce85508cfff1397ac66cd4139b9189481d7dbe852baf1a6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 4,
                        "slide": 5,
                        "touch": null,
                        "break": 4,
                        "total": 197
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 384,
                    "releaseDate": "2014-11-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 6,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 321
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 384,
                    "releaseDate": "2014-11-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 433,
                        "hold": 46,
                        "slide": 26,
                        "touch": null,
                        "break": 22,
                        "total": 527
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 384,
                    "releaseDate": "2014-11-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 725,
                        "hold": 36,
                        "slide": 119,
                        "touch": null,
                        "break": 8,
                        "total": 888
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 384,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.6,
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "FESTiVAL": 14.4,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7,
                        "Splash": 14.4,
                        "Splash PLUS": 14.4,
                        "UNiVERSE": 14.4,
                        "UNiVERSE PLUS": 14.4,
                        "maimaiでらっくす PLUS": 14.5
                    },
                    "releaseDate": "2014-11-26"
                }
            ],
            "searchAcronyms": [
                "🌊",
                "水神",
                "芙卡洛斯",
                "芙宁娜"
            ]
        },
        {
            "songId": "Ignis Danse",
            "category": "ゲーム＆バラエティ",
            "title": "Ignis Danse",
            "artist": "Yuji Masubuchi「太鼓の達人」より",
            "bpm": 246,
            "imageName": "eee51f837da9a38075824a55c9b213f5f6902dd5092b581a41b97edecb12bb23",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 8,
                        "slide": 8,
                        "touch": null,
                        "break": 3,
                        "total": 144
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 385,
                    "releaseDate": "2014-11-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 265,
                        "hold": 14,
                        "slide": 17,
                        "touch": null,
                        "break": 17,
                        "total": 313
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 385,
                    "releaseDate": "2014-11-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 538,
                        "hold": 64,
                        "slide": 10,
                        "touch": null,
                        "break": 31,
                        "total": 643
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 385,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "Splash": 12
                    },
                    "releaseDate": "2014-11-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 779,
                        "hold": 17,
                        "slide": 104,
                        "touch": null,
                        "break": 99,
                        "total": 999
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 385,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.6,
                        "BUDDiES PLUS": 14.6,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.4,
                        "FESTiVAL PLUS": 14.6,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "Splash": 14.4,
                        "Splash PLUS": 14.4,
                        "UNiVERSE": 14.4,
                        "UNiVERSE PLUS": 14.4,
                        "maimaiでらっくす PLUS": 14.3
                    },
                    "releaseDate": "2014-11-26"
                }
            ],
            "searchAcronyms": [
                "一个妮子",
                "一起去吃烤肉吧",
                "卫宫士郎",
                "火神",
                "火神大我",
                "班尼特",
                "红孩儿",
                "跳高"
            ]
        },
        {
            "songId": "Scars of FAUNA",
            "category": "ゲーム＆バラエティ",
            "title": "Scars of FAUNA",
            "artist": "猫叉Master「jubeat」より",
            "bpm": 165,
            "imageName": "bee31a79c003ae96f6c27d123b1127a68c3ab7de7f077347ac7d06bead473eec",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 6,
                        "total": 152
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 386,
                    "releaseDate": "2014-11-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 341,
                        "hold": 25,
                        "slide": 9,
                        "touch": null,
                        "break": 7,
                        "total": 382
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 386,
                    "releaseDate": "2014-11-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 341,
                        "hold": 55,
                        "slide": 29,
                        "touch": null,
                        "break": 19,
                        "total": 444
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 386,
                    "releaseDate": "2014-11-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 655,
                        "hold": 21,
                        "slide": 92,
                        "touch": null,
                        "break": 9,
                        "total": 777
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 386,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2014-11-26"
                }
            ],
            "searchAcronyms": [
                "土神"
            ]
        },
        {
            "songId": "FUJIN Rumble",
            "category": "ゲーム＆バラエティ",
            "title": "FUJIN Rumble",
            "artist": "COSIO(ZUNTATA)「グルーヴコースター」より",
            "bpm": 192,
            "imageName": "004479a6ef2fec8718f8c1ce3e5785c29b687862128baa216d446ce9e05023b6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 17,
                        "slide": 12,
                        "touch": null,
                        "break": 8,
                        "total": 191
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 387,
                    "releaseDate": "2014-11-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 308,
                        "hold": 10,
                        "slide": 13,
                        "touch": null,
                        "break": 13,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 387,
                    "releaseDate": "2014-11-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 413,
                        "hold": 24,
                        "slide": 65,
                        "touch": null,
                        "break": 7,
                        "total": 509
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 387,
                    "releaseDate": "2014-11-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 982,
                        "hold": 3,
                        "slide": 5,
                        "touch": null,
                        "break": 10,
                        "total": 1000
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 387,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "Splash": 14.5,
                        "Splash PLUS": 14.5,
                        "UNiVERSE": 14.5,
                        "UNiVERSE PLUS": 14.5,
                        "maimaiでらっくす PLUS": 14.3
                    },
                    "releaseDate": "2014-11-26"
                }
            ],
            "searchAcronyms": [
                "先天太乙神风诀",
                "福晋软贝",
                "附近maimai",
                "风神"
            ]
        },
        {
            "songId": "アンハッピーリフレイン",
            "category": "niconico＆ボーカロイド",
            "title": "アンハッピーリフレイン",
            "artist": "wowaka",
            "bpm": 205,
            "imageName": "8858c6ff4c22ef44ce537a582d70a84c89690a5716030d865a276f73d2a1ec11",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 2,
                        "slide": 3,
                        "touch": null,
                        "break": 3,
                        "total": 177
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 374,
                    "releaseDate": "2014-12-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 15,
                        "slide": 7,
                        "touch": null,
                        "break": 8,
                        "total": 325
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 374,
                    "releaseDate": "2014-12-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 447,
                        "hold": 32,
                        "slide": 48,
                        "touch": null,
                        "break": 22,
                        "total": 549
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 374,
                    "releaseDate": "2014-12-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 615,
                        "hold": 10,
                        "slide": 113,
                        "touch": null,
                        "break": 18,
                        "total": 756
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 374,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2014-12-18"
                }
            ],
            "searchAcronyms": [
                "💗",
                "unhappy",
                "unhappy refrain",
                "Unhappy Refrain",
                "不高兴的副歌",
                "副歌"
            ]
        },
        {
            "songId": "planet dancer",
            "category": "maimai",
            "title": "planet dancer",
            "artist": "樽木栄一郎",
            "bpm": 127,
            "imageName": "42ac815fadea204d439c093c3d93bca84dcb65b67c8cf0880faf54ba72a4f34b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 114,
                        "hold": 8,
                        "slide": 6,
                        "touch": null,
                        "break": 6,
                        "total": 134
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 378,
                    "releaseDate": "2014-12-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 298,
                        "hold": 26,
                        "slide": 10,
                        "touch": null,
                        "break": 2,
                        "total": 336
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 378,
                    "releaseDate": "2014-12-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "rioNとはっぴー",
                    "noteCounts": {
                        "tap": 298,
                        "hold": 65,
                        "slide": 40,
                        "touch": null,
                        "break": 17,
                        "total": 420
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 378,
                    "releaseDate": "2014-12-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 384,
                        "hold": 0,
                        "slide": 157,
                        "touch": null,
                        "break": 8,
                        "total": 549
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 378,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 11.9
                    },
                    "releaseDate": "2014-12-18"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 595,
                        "hold": 87,
                        "slide": 37,
                        "touch": null,
                        "break": 13,
                        "total": 732
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 378,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.7,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5
                    },
                    "releaseDate": "2020-11-04"
                }
            ],
            "searchAcronyms": [
                "pd",
                "拉屎拉不出来",
                "星球舞者",
                "爸爸拉粑粑",
                "男人坐椅子",
                "行星舞者"
            ]
        },
        {
            "songId": "Cosmic Magic Shooter",
            "category": "東方Project",
            "title": "Cosmic Magic Shooter",
            "artist": "SOUND HOLIC feat. Nana Takahashi",
            "bpm": 163,
            "imageName": "a2e565783ee29117555705719d6eb8e66065b23dc5a0604430641fbe13bfaecd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 119,
                        "hold": 11,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 138
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 314,
                    "releaseDate": "2015-01-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 253,
                        "hold": 9,
                        "slide": 22,
                        "touch": null,
                        "break": 8,
                        "total": 292
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 314,
                    "releaseDate": "2015-01-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 325,
                        "hold": 70,
                        "slide": 22,
                        "touch": null,
                        "break": 11,
                        "total": 428
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 314,
                    "releaseDate": "2015-01-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 585,
                        "hold": 23,
                        "slide": 134,
                        "touch": null,
                        "break": 21,
                        "total": 763
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 314,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.6,
                        "Splash PLUS": 13.6,
                        "UNiVERSE": 13.6,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.1
                    },
                    "releaseDate": "2015-01-08"
                }
            ],
            "searchAcronyms": [
                "cms",
                "宇宙魔术射手",
                "魔弹射手",
                "魔术射手",
                "魔法射手"
            ]
        },
        {
            "songId": "ピーマンたべたら",
            "category": "maimai",
            "title": "ピーマンたべたら",
            "artist": "カタオカツグミ",
            "bpm": 178,
            "imageName": "767f49f8e49afc2d5d9dad0a60f8b78c36dad6bcc7d1c081426770764bae97ec",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 14,
                        "slide": 3,
                        "touch": null,
                        "break": 5,
                        "total": 149
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 349,
                    "releaseDate": "2015-01-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 10,
                        "slide": 12,
                        "touch": null,
                        "break": 10,
                        "total": 241
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 349,
                    "releaseDate": "2015-01-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 443,
                        "hold": 12,
                        "slide": 46,
                        "touch": null,
                        "break": 5,
                        "total": 506
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 349,
                    "releaseDate": "2015-01-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 521,
                        "hold": 5,
                        "slide": 88,
                        "touch": null,
                        "break": 77,
                        "total": 691
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 349,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13.1
                    },
                    "releaseDate": "2015-01-08"
                }
            ],
            "searchAcronyms": [
                "🫑",
                "吃了青椒的话",
                "柿子椒",
                "青椒",
                "青椒歌"
            ]
        },
        {
            "songId": "究極焼肉レストラン！お燐の地獄亭！",
            "category": "東方Project",
            "title": "究極焼肉レストラン！お燐の地獄亭！",
            "artist": "ARM＋夕野ヨシミ(IOSYS)feat. 藤枝あかね",
            "bpm": 185,
            "imageName": "7491ca8d3ce173ea6e3273c72fd8838ea4329c7063ee7b04038c7d9e01b8ce96",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 7,
                        "slide": 3,
                        "touch": null,
                        "break": 3,
                        "total": 148
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 352,
                    "releaseDate": "2015-01-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 2,
                        "slide": 13,
                        "touch": null,
                        "break": 10,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 352,
                    "releaseDate": "2015-01-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 302,
                        "hold": 21,
                        "slide": 22,
                        "touch": null,
                        "break": 34,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 352,
                    "releaseDate": "2015-01-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 346,
                        "hold": 29,
                        "slide": 61,
                        "touch": null,
                        "break": 23,
                        "total": 459
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 352,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12
                    },
                    "releaseDate": "2015-01-08"
                }
            ],
            "searchAcronyms": [
                "Yakiniku Restaurant",
                "Yakiniku Restaurant! Orin’s Jigokutei!",
                "烤肉",
                "究极烧肉"
            ]
        },
        {
            "songId": "Heart Beats",
            "category": "niconico＆ボーカロイド",
            "title": "Heart Beats",
            "artist": "向日葵×emon(Tes.)",
            "bpm": 128,
            "imageName": "f4557aafd2e3ac70edfd812b95bcace641513e84aebd83ad2c56ccc90a2628b9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 166,
                        "hold": 5,
                        "slide": 2,
                        "touch": null,
                        "break": 7,
                        "total": 180
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 331,
                    "releaseDate": "2015-02-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 303,
                        "hold": 18,
                        "slide": 12,
                        "touch": null,
                        "break": 10,
                        "total": 343
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 331,
                    "releaseDate": "2015-02-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 328,
                        "hold": 46,
                        "slide": 30,
                        "touch": null,
                        "break": 12,
                        "total": 416
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 331,
                    "releaseDate": "2015-02-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 562,
                        "hold": 48,
                        "slide": 61,
                        "touch": null,
                        "break": 21,
                        "total": 692
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 331,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2015-02-05"
                }
            ],
            "searchAcronyms": [
                "喝茶",
                "心跳",
                "铅笔画"
            ]
        },
        {
            "songId": "oboro",
            "category": "maimai",
            "title": "oboro",
            "artist": "ヒゲドライバー",
            "bpm": 175,
            "imageName": "11a38c8290dead83ab1af5a375072247108af71880dbaff7b5b85626690e2583",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 132,
                        "hold": 13,
                        "slide": 4,
                        "touch": 8,
                        "break": 3,
                        "total": 160
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10366,
                    "releaseDate": "2023-10-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 14,
                        "slide": 8,
                        "touch": 30,
                        "break": 6,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10366,
                    "releaseDate": "2023-10-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 40,
                        "slide": 41,
                        "touch": 27,
                        "break": 42,
                        "total": 408
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10366,
                    "releaseDate": "2023-10-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 429,
                        "hold": 43,
                        "slide": 67,
                        "touch": 78,
                        "break": 47,
                        "total": 664
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10366,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-10-05"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 204,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 6,
                        "total": 218
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 366,
                    "releaseDate": "2015-02-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 8,
                        "slide": 15,
                        "touch": null,
                        "break": 3,
                        "total": 370
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 366,
                    "releaseDate": "2015-02-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 379,
                        "hold": 54,
                        "slide": 64,
                        "touch": null,
                        "break": 8,
                        "total": 505
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 366,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "FESTiVAL": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2015-02-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 505,
                        "hold": 39,
                        "slide": 77,
                        "touch": null,
                        "break": 15,
                        "total": 636
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 366,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.4,
                        "Splash PLUS": 13.4,
                        "UNiVERSE": 13.4,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2015-02-05"
                }
            ],
            "searchAcronyms": [
                "🌠",
                "小火焰",
                "小火球",
                "小火苗",
                "我吉吉在燃燒",
                "我的吉吉在燃烧",
                "火球",
                "超新星燃烧"
            ]
        },
        {
            "songId": "Dragoon",
            "category": "maimai",
            "title": "Dragoon",
            "artist": "Shandy kubota",
            "bpm": 175,
            "imageName": "434dc1342db00b19ce5963c43f1c8234b0bb77d20bf951978a79089cb2b28e97",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 129,
                        "hold": 10,
                        "slide": 4,
                        "touch": 16,
                        "break": 7,
                        "total": 166
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 10367,
                    "releaseDate": "2025-06-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 252,
                        "hold": 16,
                        "slide": 10,
                        "touch": 28,
                        "break": 2,
                        "total": 308
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 10367,
                    "releaseDate": "2025-06-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 43,
                        "slide": 54,
                        "touch": 36,
                        "break": 29,
                        "total": 492
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 10367,
                    "releaseDate": "2025-06-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 482,
                        "hold": 43,
                        "slide": 108,
                        "touch": 48,
                        "break": 26,
                        "total": 707
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 10367,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2025-06-05"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 129,
                        "hold": 9,
                        "slide": 6,
                        "touch": null,
                        "break": 7,
                        "total": 151
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 367,
                    "releaseDate": "2015-02-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 21,
                        "slide": 18,
                        "touch": null,
                        "break": 9,
                        "total": 359
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 367,
                    "releaseDate": "2015-02-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 412,
                        "hold": 44,
                        "slide": 49,
                        "touch": null,
                        "break": 7,
                        "total": 512
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 367,
                    "releaseDate": "2015-02-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 470,
                        "hold": 76,
                        "slide": 86,
                        "touch": null,
                        "break": 18,
                        "total": 650
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 367,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2015-02-05"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 594,
                        "hold": 93,
                        "slide": 122,
                        "touch": null,
                        "break": 9,
                        "total": 818
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 367,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "Splash": 14.2,
                        "Splash PLUS": 14.3,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.5
                    },
                    "releaseDate": "2020-11-04"
                }
            ],
            "searchAcronyms": [
                "🐉",
                "🐲",
                "多拉贡",
                "绝味鸭头",
                "绝味鸭脖",
                "鸭头",
                "麻辣鸭头",
                "龙",
                "龙骑士"
            ]
        },
        {
            "songId": "不毛！",
            "category": "niconico＆ボーカロイド",
            "title": "不毛！",
            "artist": "ぽてんしゃる0",
            "bpm": 200,
            "imageName": "bac1c14ed08bd58e09f84d46787f25df2b9db069a69a5ca38f2e4c94f3d4b554",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 131,
                        "hold": 3,
                        "slide": 5,
                        "touch": null,
                        "break": 5,
                        "total": 144
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 399,
                    "releaseDate": "2015-02-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 324,
                        "hold": 8,
                        "slide": 10,
                        "touch": null,
                        "break": 2,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 399,
                    "releaseDate": "2015-02-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 383,
                        "hold": 35,
                        "slide": 49,
                        "touch": null,
                        "break": 20,
                        "total": 487
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 399,
                    "releaseDate": "2015-02-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 502,
                        "hold": 28,
                        "slide": 158,
                        "touch": null,
                        "break": 22,
                        "total": 710
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 399,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2015-02-05"
                }
            ],
            "searchAcronyms": [
                "不毛",
                "木毛"
            ]
        },
        {
            "songId": "おても☆Yan",
            "category": "maimai",
            "title": "おても☆Yan",
            "artist": "光吉猛修",
            "bpm": 90,
            "imageName": "1e6dab68bca4ebefe3daa8536fac6923b9be01a456df36916aac6a818a701df3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 8,
                        "slide": 7,
                        "touch": null,
                        "break": 5,
                        "total": 125
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 244,
                    "releaseDate": "2015-02-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 252,
                        "hold": 8,
                        "slide": 12,
                        "touch": null,
                        "break": 11,
                        "total": 283
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 244,
                    "releaseDate": "2015-02-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 301,
                        "hold": 50,
                        "slide": 10,
                        "touch": null,
                        "break": 13,
                        "total": 374
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 244,
                    "releaseDate": "2015-02-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 429,
                        "hold": 58,
                        "slide": 13,
                        "touch": null,
                        "break": 29,
                        "total": 529
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 244,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2015-02-19"
                }
            ],
            "searchAcronyms": [
                "😃",
                "😃👍",
                "yan",
                "山歌",
                "日本民歌",
                "烟",
                "阿铁摸呀",
                "阿铁摸鸭",
                "陕北民歌"
            ]
        },
        {
            "songId": "Caliburne ～Story of the Legendary sword～",
            "category": "maimai",
            "title": "Caliburne ～Story of the Legendary sword～",
            "artist": "Project Grimoire",
            "bpm": 190,
            "imageName": "9b5077aa1296855dd87961ca3e8b5d3e2508725c56c2f6a7cf93b8b2ab50f45b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 173,
                        "hold": 30,
                        "slide": 8,
                        "touch": null,
                        "break": 5,
                        "total": 216
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 379,
                    "releaseDate": "2015-03-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 426,
                        "hold": 25,
                        "slide": 42,
                        "touch": null,
                        "break": 8,
                        "total": 501
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 379,
                    "releaseDate": "2015-03-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Jack vs mai-Star",
                    "noteCounts": {
                        "tap": 533,
                        "hold": 35,
                        "slide": 93,
                        "touch": null,
                        "break": 19,
                        "total": 680
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 379,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2015-03-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 734,
                        "hold": 10,
                        "slide": 208,
                        "touch": null,
                        "break": 4,
                        "total": 956
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE",
                    "internalId": 379,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.2,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "Splash": 14.2,
                        "Splash PLUS": 14.2,
                        "UNiVERSE": 14.2,
                        "UNiVERSE PLUS": 14.2,
                        "maimaiでらっくす PLUS": 14.1
                    },
                    "releaseDate": "2015-03-05"
                }
            ],
            "searchAcronyms": [
                "cali",
                "caliburne",
                "咖喱棒",
                "圣剑",
                "圣剑1",
                "我老婆",
                "生煎",
                "生煎1",
                "石中剑",
                "福瑞",
                "福瑞1"
            ]
        },
        {
            "songId": "ナミダと流星",
            "category": "maimai",
            "title": "ナミダと流星",
            "artist": "芳川よしの",
            "bpm": 190,
            "imageName": "1c2d499cad0fd85dafd4ab9731859c48e5bc36f382806ead0a1fd1d1fd9201d3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 15,
                        "slide": 3,
                        "touch": 7,
                        "break": 3,
                        "total": 197
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10242,
                    "releaseDate": "2023-11-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 216,
                        "hold": 34,
                        "slide": 9,
                        "touch": 22,
                        "break": 4,
                        "total": 285
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10242,
                    "releaseDate": "2023-11-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 59,
                        "slide": 44,
                        "touch": 9,
                        "break": 34,
                        "total": 495
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10242,
                    "releaseDate": "2023-11-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 475,
                        "hold": 39,
                        "slide": 126,
                        "touch": 18,
                        "break": 20,
                        "total": 678
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10242,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2023-11-23"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 121,
                        "hold": 11,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 139
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 242,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 279,
                        "hold": 26,
                        "slide": 13,
                        "touch": null,
                        "break": 8,
                        "total": 326
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 242,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 346,
                        "hold": 43,
                        "slide": 36,
                        "touch": null,
                        "break": 4,
                        "total": 429
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 242,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 312,
                        "hold": 50,
                        "slide": 150,
                        "touch": null,
                        "break": 5,
                        "total": 517
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 242,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2015-03-19"
                }
            ],
            "searchAcronyms": [
                "泪与流星",
                "流星",
                "眼泪与流星",
                "眼泪流星"
            ]
        },
        {
            "songId": "みくみくにしてあげる♪【してやんよ】",
            "category": "niconico＆ボーカロイド",
            "title": "みくみくにしてあげる♪【してやんよ】",
            "artist": "ika",
            "bpm": 160,
            "imageName": "111d326fcfa996655613e7891c393ff560b0632a92df86009af4c6f9cec14e11",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 114,
                        "hold": 10,
                        "slide": 7,
                        "touch": null,
                        "break": 3,
                        "total": 134
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 289,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 255,
                        "hold": 16,
                        "slide": 10,
                        "touch": null,
                        "break": 6,
                        "total": 287
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 289,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 286,
                        "hold": 29,
                        "slide": 27,
                        "touch": null,
                        "break": 12,
                        "total": 354
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 289,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 26,
                        "slide": 67,
                        "touch": null,
                        "break": 14,
                        "total": 471
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 289,
                    "releaseDate": "2015-03-19"
                }
            ],
            "searchAcronyms": [
                "📉",
                "I'll Miku-Miku You♪ (For Reals)",
                "党歌",
                "把你mikumiku掉",
                "狗·眼·①·瞎",
                "飞龙"
            ]
        },
        {
            "songId": "ロストワンの号哭",
            "category": "niconico＆ボーカロイド",
            "title": "ロストワンの号哭",
            "artist": "Neru",
            "bpm": 162,
            "imageName": "c299f1dea4115d6106b5e5b4433be3506680c727f029b0e10706af1311ba4a83",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 8,
                        "slide": 4,
                        "touch": null,
                        "break": 7,
                        "total": 215
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 299,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 11,
                        "slide": 18,
                        "touch": null,
                        "break": 12,
                        "total": 371
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 299,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 419,
                        "hold": 78,
                        "slide": 38,
                        "touch": null,
                        "break": 10,
                        "total": 545
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 299,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 828,
                        "hold": 26,
                        "slide": 68,
                        "touch": null,
                        "break": 24,
                        "total": 946
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 299,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 12.6
                    },
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 723,
                        "hold": 50,
                        "slide": 162,
                        "touch": null,
                        "break": 11,
                        "total": 946
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 299,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14.2,
                        "FESTiVAL PLUS": 14.2,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "Splash": 14.2,
                        "Splash PLUS": 14.2,
                        "UNiVERSE": 14.2,
                        "UNiVERSE PLUS": 14.2,
                        "maimaiでらっくす PLUS": 14
                    },
                    "releaseDate": "2015-03-19"
                }
            ],
            "searchAcronyms": [
                "kappa",
                "Lost one",
                "lost one 的号哭",
                "Lost one's weeping",
                "Lost ones",
                "The Lamentations of the Lost Ones",
                "号哭",
                "失去1的号哭",
                "没有1我要哭了",
                "破防"
            ]
        },
        {
            "songId": "ケロ⑨destiny",
            "category": "東方Project",
            "title": "ケロ⑨destiny",
            "artist": "Silver Forest",
            "bpm": 172,
            "imageName": "df475670114e33aebf19ece077fe72ecaf4b5c54a03b128452b3dcf41efc5f6b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 8,
                        "slide": 5,
                        "touch": 9,
                        "break": 5,
                        "total": 178
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10302,
                    "releaseDate": "2023-02-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 35,
                        "slide": 13,
                        "touch": 16,
                        "break": 7,
                        "total": 255
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10302,
                    "releaseDate": "2023-02-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 252,
                        "hold": 97,
                        "slide": 22,
                        "touch": 15,
                        "break": 44,
                        "total": 430
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10302,
                    "releaseDate": "2023-02-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Redarrow",
                    "noteCounts": {
                        "tap": 431,
                        "hold": 58,
                        "slide": 78,
                        "touch": 54,
                        "break": 70,
                        "total": 691
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10302,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2023-02-02"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 170,
                        "hold": 7,
                        "slide": 1,
                        "touch": null,
                        "break": 4,
                        "total": 182
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 302,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 187,
                        "hold": 10,
                        "slide": 10,
                        "touch": null,
                        "break": 6,
                        "total": 213
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 302,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 226,
                        "hold": 144,
                        "slide": 18,
                        "touch": null,
                        "break": 36,
                        "total": 424
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 302,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 458,
                        "hold": 70,
                        "slide": 62,
                        "touch": null,
                        "break": 32,
                        "total": 622
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 302,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2015-03-19"
                }
            ],
            "searchAcronyms": [
                "9",
                "⑨",
                "kero",
                "KERO⑨destiny"
            ]
        },
        {
            "songId": "ってゐ！ ～えいえんてゐVer～",
            "category": "東方Project",
            "title": "ってゐ！ ～えいえんてゐVer～",
            "artist": "石鹸屋",
            "bpm": 156,
            "imageName": "6ee7966752b4a2f673b26a5e7126864908f462c1fcc8070a48cadc2e20881315",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 131,
                        "hold": 9,
                        "slide": 8,
                        "touch": null,
                        "break": 3,
                        "total": 151
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 312,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 228,
                        "hold": 10,
                        "slide": 12,
                        "touch": null,
                        "break": 6,
                        "total": 256
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 312,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 387,
                        "hold": 12,
                        "slide": 42,
                        "touch": null,
                        "break": 17,
                        "total": 458
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 312,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 457,
                        "hold": 3,
                        "slide": 146,
                        "touch": null,
                        "break": 10,
                        "total": 616
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 312,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash": 12
                    },
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 654,
                        "hold": 0,
                        "slide": 187,
                        "touch": null,
                        "break": 12,
                        "total": 853
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 312,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.1
                    },
                    "releaseDate": "2016-10-05"
                }
            ],
            "searchAcronyms": [
                "屁股",
                "帝帝",
                "翘屁股",
                "翘臀"
            ]
        },
        {
            "songId": "L9",
            "category": "ゲーム＆バラエティ",
            "title": "L9",
            "artist": "paraoka",
            "bpm": 256,
            "imageName": "a29d70671cd6afc11eb58cf5b0a9b6d133c660d45d91f675773d055f84a156ef",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 2,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 186
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 376,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 26,
                        "slide": 14,
                        "touch": null,
                        "break": 5,
                        "total": 381
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 376,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Revo@LC vs Jack",
                    "noteCounts": {
                        "tap": 506,
                        "hold": 21,
                        "slide": 33,
                        "touch": null,
                        "break": 7,
                        "total": 567
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 376,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 676,
                        "hold": 36,
                        "slide": 114,
                        "touch": null,
                        "break": 9,
                        "total": 835
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 376,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.2,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.6,
                        "maimaiでらっくす PLUS": 13.1
                    },
                    "releaseDate": "2015-03-19"
                }
            ],
            "searchAcronyms": [
                "绿9",
                "轴交互"
            ]
        },
        {
            "songId": "赤心性：カマトト荒療治",
            "category": "niconico＆ボーカロイド",
            "title": "赤心性：カマトト荒療治",
            "artist": "スズム",
            "bpm": 205,
            "imageName": "0bfa7e224af0bf38068a39c9337e04352bca34554213cf9622bf8527c302ee37",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 191,
                        "hold": 2,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 200
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 401,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 422,
                        "hold": 8,
                        "slide": 6,
                        "touch": null,
                        "break": 6,
                        "total": 442
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 401,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 423,
                        "hold": 35,
                        "slide": 55,
                        "touch": null,
                        "break": 48,
                        "total": 561
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 401,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 593,
                        "hold": 14,
                        "slide": 177,
                        "touch": null,
                        "break": 48,
                        "total": 832
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 401,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.3,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.6,
                        "maimaiでらっくす PLUS": 13.3
                    },
                    "releaseDate": "2015-03-19"
                }
            ],
            "searchAcronyms": [
                "赤心性"
            ]
        },
        {
            "songId": "響縁",
            "category": "東方Project",
            "title": "響縁",
            "artist": "豚乙女",
            "bpm": 180,
            "imageName": "544e61d614cdde6bc181b1320c9dc74a538a0a0208b709b5f7fd3435dab1a14e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 93,
                        "hold": 6,
                        "slide": 2,
                        "touch": 16,
                        "break": 1,
                        "total": 118
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10404,
                    "releaseDate": "2022-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 15,
                        "slide": 6,
                        "touch": 27,
                        "break": 22,
                        "total": 302
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10404,
                    "releaseDate": "2022-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10.5,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 428,
                        "hold": 22,
                        "slide": 20,
                        "touch": 28,
                        "break": 21,
                        "total": 519
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10404,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 10.5
                    },
                    "releaseDate": "2022-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 547,
                        "hold": 44,
                        "slide": 88,
                        "touch": 12,
                        "break": 16,
                        "total": 707
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10404,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2022-09-14"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 164,
                        "hold": 12,
                        "slide": 1,
                        "touch": null,
                        "break": 4,
                        "total": 181
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 404,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 6,
                        "slide": 11,
                        "touch": null,
                        "break": 6,
                        "total": 305
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 404,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 362,
                        "hold": 39,
                        "slide": 27,
                        "touch": null,
                        "break": 14,
                        "total": 442
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 404,
                    "releaseDate": "2015-03-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 507,
                        "hold": 20,
                        "slide": 125,
                        "touch": null,
                        "break": 22,
                        "total": 674
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 404,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 13,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.1
                    },
                    "releaseDate": "2015-03-19"
                }
            ],
            "searchAcronyms": [
                "dx响缘",
                "响缘",
                "梦花火2",
                "響绿",
                "響緣"
            ]
        },
        {
            "songId": "悪戯",
            "category": "maimai",
            "title": "悪戯",
            "artist": "ろん×田中秀和(MONACA)",
            "bpm": 140,
            "imageName": "2b9920555b3a0964008087c35f78af6a773859a0d1ded8c3206e9b01aed80408",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 191,
                        "hold": 5,
                        "slide": 6,
                        "touch": null,
                        "break": 5,
                        "total": 207
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 403,
                    "releaseDate": "2015-04-16"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 25,
                        "slide": 19,
                        "touch": null,
                        "break": 23,
                        "total": 294
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 403,
                    "releaseDate": "2015-04-16"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 385,
                        "hold": 37,
                        "slide": 15,
                        "touch": null,
                        "break": 17,
                        "total": 454
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 403,
                    "releaseDate": "2015-04-16"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 557,
                        "hold": 62,
                        "slide": 69,
                        "touch": null,
                        "break": 26,
                        "total": 714
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 403,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2015-04-16"
                }
            ],
            "searchAcronyms": [
                "Itazura",
                "恶习",
                "恶戏"
            ]
        },
        {
            "songId": "welcome to maimai!! with マイマイマー",
            "category": "maimai",
            "title": "welcome to maimai!! with マイマイマー",
            "artist": "Hiro feat.越田Rute隆人&ビートまりお",
            "bpm": 163,
            "imageName": "2cda85e9d2a096b971cf648240f6feec9df2ca226a9c9521f4b249874f45dabb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 11,
                        "slide": 10,
                        "touch": null,
                        "break": 11,
                        "total": 207
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 418,
                    "releaseDate": "2015-04-16"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 350,
                        "hold": 36,
                        "slide": 22,
                        "touch": null,
                        "break": 16,
                        "total": 424
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 418,
                    "releaseDate": "2015-04-16"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 300,
                        "hold": 65,
                        "slide": 33,
                        "touch": null,
                        "break": 80,
                        "total": 478
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 418,
                    "releaseDate": "2015-04-16"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 417,
                        "hold": 71,
                        "slide": 104,
                        "touch": null,
                        "break": 52,
                        "total": 644
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 418,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.3
                    },
                    "releaseDate": "2015-04-16"
                }
            ],
            "searchAcronyms": [
                "go! go! 575",
                "maimai",
                "欢迎来到舞萌的世界"
            ]
        },
        {
            "songId": "クローバー♣クラブ",
            "category": "niconico＆ボーカロイド",
            "title": "クローバー♣クラブ",
            "artist": "ゆうゆ",
            "bpm": 150,
            "imageName": "b3688b6d393b3e0f5a11f38667811d8936cbecd03cdcabd13d6e85dd14a3d3a0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 123,
                        "hold": 22,
                        "slide": 7,
                        "touch": null,
                        "break": 3,
                        "total": 155
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 408,
                    "releaseDate": "2015-05-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 291,
                        "hold": 5,
                        "slide": 23,
                        "touch": null,
                        "break": 5,
                        "total": 324
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 408,
                    "releaseDate": "2015-05-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 31,
                        "slide": 39,
                        "touch": null,
                        "break": 7,
                        "total": 429
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 408,
                    "releaseDate": "2015-05-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 380,
                        "hold": 23,
                        "slide": 146,
                        "touch": null,
                        "break": 20,
                        "total": 569
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 408,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2015-05-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "妄想税",
            "category": "niconico＆ボーカロイド",
            "title": "妄想税",
            "artist": "DECO*27",
            "bpm": 134,
            "imageName": "e4b53ba139111410d252b84faed0f2499939ee21570fe42a2a17847ef0825ac3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 174,
                        "hold": 11,
                        "slide": 2,
                        "touch": null,
                        "break": 4,
                        "total": 191
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 409,
                    "releaseDate": "2015-05-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 21,
                        "slide": 13,
                        "touch": null,
                        "break": 4,
                        "total": 296
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 409,
                    "releaseDate": "2015-05-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 399,
                        "hold": 51,
                        "slide": 12,
                        "touch": null,
                        "break": 14,
                        "total": 476
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 409,
                    "releaseDate": "2015-05-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 49,
                        "slide": 63,
                        "touch": null,
                        "break": 13,
                        "total": 527
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 409,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2015-05-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ウミユリ海底譚",
            "category": "niconico＆ボーカロイド",
            "title": "ウミユリ海底譚",
            "artist": "n-buna",
            "bpm": 120,
            "imageName": "e05e2a6fc30cd26f1b87310732062c03fdcc3900808695594d4b7d1c625c7315",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 164,
                        "hold": 6,
                        "slide": 2,
                        "touch": null,
                        "break": 8,
                        "total": 180
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 417,
                    "releaseDate": "2015-05-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 34,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 380
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 417,
                    "releaseDate": "2015-05-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 386,
                        "hold": 39,
                        "slide": 22,
                        "touch": null,
                        "break": 16,
                        "total": 463
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 417,
                    "releaseDate": "2015-05-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 648,
                        "hold": 21,
                        "slide": 76,
                        "touch": null,
                        "break": 14,
                        "total": 759
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 417,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2015-05-14"
                }
            ],
            "searchAcronyms": [
                "Umiyuri",
                "Umiyuri Kaiteitan",
                "你学不会",
                "初音未来跳海",
                "初音跳海",
                "别惦记你那逼海底谭了",
                "我应该打",
                "海带汤",
                "海底捞",
                "海底谭",
                "海百合",
                "海百合海底谭",
                "海脑瘫",
                "舞萌老玩家",
                "谭"
            ]
        },
        {
            "songId": "若い力 -SEGA HARD GIRLS MIX-",
            "category": "POPS＆アニメ",
            "title": "若い力 -SEGA HARD GIRLS MIX-",
            "artist": "SC-3000(シーさん)/CV.相沢 舞、SG-1000(せん)/CV.芹澤 優、SG-1000Ⅱ(せんつー)/CV.大空直美、ゲームギア(ムギ)/CV.田中美海、ロボピッチャ(ぴっちゃん)/CV.もものはるな「Hi☆sCoool! セハガール」 [アニメPV]",
            "bpm": 162,
            "imageName": "4caa7dd131a96f83080da61ff5374ea74e6398708aa413173ea2b99f6355a3af",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 19,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 178
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 414,
                    "releaseDate": "2015-06-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 10,
                        "slide": 16,
                        "touch": null,
                        "break": 3,
                        "total": 340
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 414,
                    "releaseDate": "2015-06-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 41,
                        "slide": 53,
                        "touch": null,
                        "break": 25,
                        "total": 383
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 414,
                    "releaseDate": "2015-06-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 538,
                        "hold": 10,
                        "slide": 116,
                        "touch": null,
                        "break": 31,
                        "total": 695
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 414,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2015-06-04"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 0,
                        "slide": 197,
                        "touch": null,
                        "break": 22,
                        "total": 495
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 414,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2016-09-21"
                }
            ],
            "searchAcronyms": [
                "SBGA",
                "sega",
                "WAKAICHIKARA -SEGA HARD GIRLS MIX-",
                "世嘉女孩",
                "世嘉少女",
                "世嘉社歌",
                "年轻的力量",
                "若以力",
                "若力"
            ]
        },
        {
            "songId": "Oshama Scramble!",
            "category": "maimai",
            "title": "Oshama Scramble!",
            "artist": "t+pazolite",
            "bpm": 190,
            "imageName": "bc7cd87b2a854f63049f834d7ecd9733724424188dc1dae53b33234c70d585b1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 110,
                        "hold": 7,
                        "slide": 12,
                        "touch": 35,
                        "break": 5,
                        "total": 169
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10363,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 317,
                        "hold": 29,
                        "slide": 10,
                        "touch": 35,
                        "break": 17,
                        "total": 408
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10363,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 56,
                        "slide": 54,
                        "touch": 193,
                        "break": 5,
                        "total": 555
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10363,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 747,
                        "hold": 21,
                        "slide": 52,
                        "touch": 81,
                        "break": 99,
                        "total": 1000
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10363,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "FESTiVAL": 13.6,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash": 13.6,
                        "Splash PLUS": 13.6,
                        "UNiVERSE": 13.6,
                        "UNiVERSE PLUS": 13.6,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 238,
                        "hold": 8,
                        "slide": 4,
                        "touch": null,
                        "break": 9,
                        "total": 259
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 363,
                    "releaseDate": "2015-06-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 438,
                        "hold": 23,
                        "slide": 9,
                        "touch": null,
                        "break": 16,
                        "total": 486
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 363,
                    "releaseDate": "2015-06-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 299,
                        "hold": 79,
                        "slide": 116,
                        "touch": null,
                        "break": 100,
                        "total": 594
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 363,
                    "releaseDate": "2015-06-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 944,
                        "hold": 0,
                        "slide": 68,
                        "touch": null,
                        "break": 99,
                        "total": 1111
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 363,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "Splash": 14.2,
                        "Splash PLUS": 14.5,
                        "UNiVERSE": 14.5,
                        "UNiVERSE PLUS": 14.5,
                        "maimaiでらっくす PLUS": 14
                    },
                    "releaseDate": "2015-06-25"
                }
            ],
            "searchAcronyms": [
                "🥛",
                "dx奶",
                "dx奶猫",
                "dx牛奶",
                "oshama",
                "o杀妈",
                "丰胸奶",
                "俩老婆",
                "哦啥马上吃让明白了",
                "哦杀妈",
                "喝奶",
                "大臣与左大臣",
                "奶猫",
                "巧克力与香子兰",
                "标奶",
                "标牛奶",
                "热辣大飞机",
                "牛乳",
                "牛奶",
                "牛奶猫"
            ]
        },
        {
            "songId": "D✪N’T  ST✪P  R✪CKIN’",
            "category": "maimai",
            "title": "D✪N’T  ST✪P  R✪CKIN’",
            "artist": "EB(aka EarBreaker)",
            "bpm": 140,
            "imageName": "febe1e8d14f388a41b39debf1430f5e45d9596cedb01b08442d678b617af8937",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 11,
                        "slide": 6,
                        "touch": null,
                        "break": 6,
                        "total": 223
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 364,
                    "releaseDate": "2015-06-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 31,
                        "slide": 8,
                        "touch": null,
                        "break": 9,
                        "total": 405
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 364,
                    "releaseDate": "2015-06-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 396,
                        "hold": 80,
                        "slide": 52,
                        "touch": null,
                        "break": 15,
                        "total": 543
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 364,
                    "releaseDate": "2015-06-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 611,
                        "hold": 29,
                        "slide": 143,
                        "touch": null,
                        "break": 19,
                        "total": 802
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 364,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2015-06-25"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 482,
                        "hold": 24,
                        "slide": 116,
                        "touch": null,
                        "break": 47,
                        "total": 669
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 364,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.5
                    },
                    "releaseDate": "2020-11-04"
                }
            ],
            "searchAcronyms": [
                "⭐⭐⭐",
                "🤖",
                "dont stop rockin",
                "dsr",
                "小机器人",
                "恐怖g7人",
                "机器人",
                "机器人射出飞盘"
            ]
        },
        {
            "songId": "ガラテアの螺旋",
            "category": "maimai",
            "title": "ガラテアの螺旋",
            "artist": "sasakure.UK",
            "bpm": 200,
            "imageName": "07e161bff23fbc8b4ac37d85ce3865d1e291ed0258b7646ab7ef128b86efee30",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 6,
                        "slide": 1,
                        "touch": null,
                        "break": 4,
                        "total": 197
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 365,
                    "releaseDate": "2015-06-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 261,
                        "hold": 32,
                        "slide": 10,
                        "touch": null,
                        "break": 4,
                        "total": 307
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 365,
                    "releaseDate": "2015-06-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 493,
                        "hold": 17,
                        "slide": 46,
                        "touch": null,
                        "break": 5,
                        "total": 561
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 365,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2015-06-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 747,
                        "hold": 27,
                        "slide": 75,
                        "touch": null,
                        "break": 10,
                        "total": 859
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 365,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.6,
                        "BUDDiES PLUS": 14.6,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL": 14.6,
                        "FESTiVAL PLUS": 14.6,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6,
                        "Splash": 14.6,
                        "Splash PLUS": 14.6,
                        "UNiVERSE": 14.6,
                        "UNiVERSE PLUS": 14.5,
                        "maimaiでらっくす PLUS": 14.5
                    },
                    "releaseDate": "2015-06-25"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 676,
                        "hold": 120,
                        "slide": 93,
                        "touch": null,
                        "break": 10,
                        "total": 899
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 365,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "FESTiVAL": 14.7,
                        "FESTiVAL PLUS": 14.7,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7,
                        "Splash": 14.9,
                        "Splash PLUS": 14.8,
                        "UNiVERSE": 14.8,
                        "UNiVERSE PLUS": 14.7,
                        "maimaiでらっくす PLUS": 14.8
                    },
                    "releaseDate": "2018-10-15"
                }
            ],
            "searchAcronyms": [
                "🌀",
                "ガラテアのにゃんこ",
                "伽拉",
                "伽拉泰亚的螺旋",
                "白洛轩",
                "螺旋"
            ]
        },
        {
            "songId": "東方スイーツ！～鬼畜姉妹と受難メイド～",
            "category": "東方Project",
            "title": "東方スイーツ！～鬼畜姉妹と受難メイド～",
            "artist": "Innocent Keyと小宮真央、ココ、樹詩音",
            "bpm": 179,
            "imageName": "facd78302d19d544a93398f41ed3b69b4c21004c5e63c3b55c7c2f9aa48ba32b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 160,
                        "hold": 12,
                        "slide": 3,
                        "touch": null,
                        "break": 5,
                        "total": 180
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 318,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 235,
                        "hold": 22,
                        "slide": 12,
                        "touch": null,
                        "break": 2,
                        "total": 271
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 318,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 296,
                        "hold": 33,
                        "slide": 57,
                        "touch": null,
                        "break": 12,
                        "total": 398
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 318,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 406,
                        "hold": 30,
                        "slide": 103,
                        "touch": null,
                        "break": 13,
                        "total": 552
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 318,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2015-07-16"
                }
            ],
            "searchAcronyms": [
                "东方受难",
                "咲夜哭哭",
                "鬼畜姐妹"
            ]
        },
        {
            "songId": "キャプテン・ムラサのケツアンカー",
            "category": "東方Project",
            "title": "キャプテン・ムラサのケツアンカー",
            "artist": "ARM＋夕野ヨシミ(IOSYS)feat.山本椛",
            "bpm": 190,
            "imageName": "be88c07ea5cab76599858245a9a0a066feaf16426a7e31428c84ee5ce08dc0c2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 10,
                        "slide": 2,
                        "touch": null,
                        "break": 7,
                        "total": 164
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 413,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 14,
                        "slide": 9,
                        "touch": null,
                        "break": 4,
                        "total": 236
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 413,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 30,
                        "slide": 37,
                        "touch": null,
                        "break": 19,
                        "total": 361
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 413,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 430,
                        "hold": 16,
                        "slide": 93,
                        "touch": null,
                        "break": 34,
                        "total": 573
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 413,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2015-07-16"
                }
            ],
            "searchAcronyms": [
                "Captain Murasa",
                "Captain Murasa's Ketsu Anchor",
                "村纱水蜜",
                "船长"
            ]
        },
        {
            "songId": "どうしてこうなった",
            "category": "niconico＆ボーカロイド",
            "title": "どうしてこうなった",
            "artist": "うどんゲルゲ",
            "bpm": 180,
            "imageName": "418316e45ea9f154b4cef928b46e756d49db9f0d23c1d4d881b8e5d0cb8cca9f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 244,
                        "hold": 2,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 254
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 380,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 327,
                        "hold": 4,
                        "slide": 15,
                        "touch": null,
                        "break": 4,
                        "total": 350
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 380,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 457,
                        "hold": 15,
                        "slide": 49,
                        "touch": null,
                        "break": 75,
                        "total": 596
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 380,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 735,
                        "hold": 70,
                        "slide": 84,
                        "touch": null,
                        "break": 45,
                        "total": 934
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 380,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2015-07-16"
                }
            ],
            "searchAcronyms": [
                "为什么会变成这样",
                "为什么会变成这样呢",
                "怎么回事呢",
                "怎么这样",
                "白板",
                "跳舞狗"
            ]
        },
        {
            "songId": "どういうことなの！？",
            "category": "niconico＆ボーカロイド",
            "title": "どういうことなの！？",
            "artist": "くちばしP",
            "bpm": 175,
            "imageName": "24d9989474573c31202f33de648e5fcdf5205e06d60e12de7c786c9adaf882f7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 178,
                        "hold": 6,
                        "slide": 1,
                        "touch": null,
                        "break": 5,
                        "total": 190
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 410,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 45,
                        "slide": 19,
                        "touch": null,
                        "break": 12,
                        "total": 307
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 410,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 417,
                        "hold": 24,
                        "slide": 39,
                        "touch": null,
                        "break": 9,
                        "total": 489
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 410,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 452,
                        "hold": 65,
                        "slide": 69,
                        "touch": null,
                        "break": 8,
                        "total": 594
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 410,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2015-07-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Change Our MIRAI！",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Change Our MIRAI！",
            "artist": "イロドリミドリ「CHUNITHM」",
            "bpm": 256,
            "imageName": "b168827de9656eb70fbd8aa18215795abb0843ccb930ab3b070187bef50eb23e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 32,
                        "slide": 6,
                        "touch": 16,
                        "break": 2,
                        "total": 194
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10420,
                    "releaseDate": "2019-11-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 219,
                        "hold": 56,
                        "slide": 16,
                        "touch": 27,
                        "break": 4,
                        "total": 322
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10420,
                    "releaseDate": "2019-11-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 77,
                        "slide": 39,
                        "touch": 84,
                        "break": 59,
                        "total": 539
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10420,
                    "releaseDate": "2019-11-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 575,
                        "hold": 83,
                        "slide": 101,
                        "touch": 41,
                        "break": 27,
                        "total": 827
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10420,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2019-11-14"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 15,
                        "slide": 9,
                        "touch": null,
                        "break": 9,
                        "total": 174
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 420,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 40,
                        "slide": 21,
                        "touch": null,
                        "break": 10,
                        "total": 348
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 420,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 445,
                        "hold": 90,
                        "slide": 55,
                        "touch": null,
                        "break": 28,
                        "total": 618
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 420,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 640,
                        "hold": 59,
                        "slide": 114,
                        "touch": null,
                        "break": 33,
                        "total": 846
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 420,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.7,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.2
                    },
                    "releaseDate": "2015-07-16"
                }
            ],
            "searchAcronyms": [
                "com",
                "dx五对奶子",
                "不含月铃姐妹",
                "五个女人",
                "五对奶子",
                "五对柰子",
                "四大一小",
                "小心彩绿",
                "改变未来"
            ]
        },
        {
            "songId": "六兆年と一夜物語",
            "category": "niconico＆ボーカロイド",
            "title": "六兆年と一夜物語",
            "artist": "kemu",
            "bpm": 186,
            "imageName": "94d3b047ff4ae39cc5706dacb45f55191cbc73e8b639e77605212e00b06f5885",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 129,
                        "hold": 6,
                        "slide": 4,
                        "touch": 4,
                        "break": 7,
                        "total": 150
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10288,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 23,
                        "slide": 8,
                        "touch": 4,
                        "break": 16,
                        "total": 288
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10288,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 260,
                        "hold": 24,
                        "slide": 11,
                        "touch": 29,
                        "break": 30,
                        "total": 354
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10288,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "うさぎランドリー",
                    "noteCounts": {
                        "tap": 554,
                        "hold": 25,
                        "slide": 47,
                        "touch": 57,
                        "break": 21,
                        "total": 704
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10288,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.3,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 13.3
                    },
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 2,
                        "slide": 7,
                        "touch": null,
                        "break": 5,
                        "total": 160
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 288,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 291,
                        "hold": 8,
                        "slide": 5,
                        "touch": null,
                        "break": 10,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 288,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 317,
                        "hold": 22,
                        "slide": 31,
                        "touch": null,
                        "break": 29,
                        "total": 399
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 288,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 660,
                        "hold": 6,
                        "slide": 69,
                        "touch": null,
                        "break": 13,
                        "total": 748
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 288,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2015-07-16"
                }
            ],
            "searchAcronyms": [
                "6000000000000年",
                "6m",
                "dx六兆年",
                "dx希腊奶",
                "Rokuchou nen",
                "six trillion",
                "Six trillion nights",
                "Six Trillion Years and Overnight Story",
                "六兆年",
                "六兆年零一夜物语",
                "安慕希",
                "希腊奶",
                "标六兆年"
            ]
        },
        {
            "songId": "Sweet Devil",
            "category": "niconico＆ボーカロイド",
            "title": "Sweet Devil",
            "artist": "八王子P",
            "bpm": 132,
            "imageName": "9c3a5ff21a9fb49b0833359d98f5ca950ba2e0c0bc7e2a856b157a075565504a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 156,
                        "hold": 2,
                        "slide": 2,
                        "touch": null,
                        "break": 3,
                        "total": 163
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 300,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 12,
                        "slide": 9,
                        "touch": null,
                        "break": 6,
                        "total": 268
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 300,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 37,
                        "slide": 37,
                        "touch": null,
                        "break": 12,
                        "total": 391
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 300,
                    "releaseDate": "2015-07-16"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 434,
                        "hold": 59,
                        "slide": 63,
                        "touch": null,
                        "break": 43,
                        "total": 599
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 300,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2015-07-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "デッドレッドガールズ",
            "category": "niconico＆ボーカロイド",
            "title": "デッドレッドガールズ",
            "artist": "MARUDARUMA",
            "bpm": 230,
            "imageName": "363b9edbb567946a0fa5023f59d3c9abfe2a013a6958584d09967ad533304cbe",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 181,
                        "hold": 4,
                        "slide": 2,
                        "touch": null,
                        "break": 8,
                        "total": 195
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 400,
                    "releaseDate": "2015-09-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 348,
                        "hold": 18,
                        "slide": 24,
                        "touch": null,
                        "break": 14,
                        "total": 404
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 400,
                    "releaseDate": "2015-09-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 558,
                        "hold": 44,
                        "slide": 20,
                        "touch": null,
                        "break": 14,
                        "total": 636
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 400,
                    "releaseDate": "2015-09-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 744,
                        "hold": 22,
                        "slide": 136,
                        "touch": null,
                        "break": 15,
                        "total": 917
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 400,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2015-09-17"
                }
            ],
            "searchAcronyms": [
                "死红女",
                "荒野大镖妹"
            ]
        },
        {
            "songId": "ストリーミングハート",
            "category": "niconico＆ボーカロイド",
            "title": "ストリーミングハート",
            "artist": "DECO*27",
            "bpm": 210,
            "imageName": "cba6fcd465d18c3f67c7613aa73f23a30006ff13a043533fb7cc8d1f6d6c1302",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 10,
                        "slide": 3,
                        "touch": null,
                        "break": 3,
                        "total": 173
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 419,
                    "releaseDate": "2015-09-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 225,
                        "hold": 33,
                        "slide": 21,
                        "touch": null,
                        "break": 14,
                        "total": 293
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 419,
                    "releaseDate": "2015-09-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 400,
                        "hold": 71,
                        "slide": 24,
                        "touch": null,
                        "break": 22,
                        "total": 517
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 419,
                    "releaseDate": "2015-09-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 594,
                        "hold": 45,
                        "slide": 93,
                        "touch": null,
                        "break": 10,
                        "total": 742
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 419,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2015-09-17"
                }
            ],
            "searchAcronyms": [
                "Streaming Heart",
                "嘉然",
                "嘉然比心",
                "流心"
            ]
        },
        {
            "songId": "LANCE",
            "category": "maimai",
            "title": "LANCE",
            "artist": "Ras",
            "bpm": 156,
            "imageName": "8a47022d9af07e6802eb1791d8be43e690ce1cbbaeb8a1866aec525815fdc32b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 168,
                        "hold": 11,
                        "slide": 4,
                        "touch": 6,
                        "break": 5,
                        "total": 194
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 10422,
                    "releaseDate": "2024-10-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 15,
                        "slide": 6,
                        "touch": 26,
                        "break": 8,
                        "total": 345
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 10422,
                    "releaseDate": "2024-10-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 373,
                        "hold": 56,
                        "slide": 38,
                        "touch": 18,
                        "break": 17,
                        "total": 502
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 10422,
                    "releaseDate": "2024-10-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 644,
                        "hold": 54,
                        "slide": 67,
                        "touch": 42,
                        "break": 53,
                        "total": 860
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 10422,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2024-10-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 198,
                        "hold": 8,
                        "slide": 2,
                        "touch": null,
                        "break": 4,
                        "total": 212
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 422,
                    "releaseDate": "2015-09-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 24,
                        "slide": 17,
                        "touch": null,
                        "break": 16,
                        "total": 354
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 422,
                    "releaseDate": "2015-09-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 485,
                        "hold": 44,
                        "slide": 51,
                        "touch": null,
                        "break": 9,
                        "total": 589
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 422,
                    "releaseDate": "2015-09-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 704,
                        "hold": 28,
                        "slide": 109,
                        "touch": null,
                        "break": 14,
                        "total": 855
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 422,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.6,
                        "Splash PLUS": 13.6,
                        "UNiVERSE": 13.6,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2015-09-17"
                }
            ],
            "searchAcronyms": [
                "兰斯",
                "兰瑟",
                "懒死",
                "烂死",
                "缆车",
                "蓝枪"
            ]
        },
        {
            "songId": "Aiolos",
            "category": "maimai",
            "title": "Aiolos",
            "artist": "xi",
            "bpm": 205,
            "imageName": "1a95069d603925739cbd7d014ba13f582771713ce0158701493b43f0dab4f860",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 6,
                        "slide": 9,
                        "touch": null,
                        "break": 10,
                        "total": 298
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 421,
                    "releaseDate": "2015-10-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 348,
                        "hold": 22,
                        "slide": 22,
                        "touch": null,
                        "break": 10,
                        "total": 402
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 421,
                    "releaseDate": "2015-10-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 638,
                        "hold": 23,
                        "slide": 48,
                        "touch": null,
                        "break": 18,
                        "total": 727
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 421,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2015-10-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 989,
                        "hold": 20,
                        "slide": 61,
                        "touch": null,
                        "break": 30,
                        "total": 1100
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 421,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.4,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "Splash": 14.4,
                        "Splash PLUS": 14.4,
                        "UNiVERSE": 14.4,
                        "UNiVERSE PLUS": 14.4,
                        "maimaiでらっくす PLUS": 14
                    },
                    "releaseDate": "2015-10-15"
                }
            ],
            "searchAcronyms": [
                "aio",
                "a打头的风神",
                "肉包",
                "艾俄洛斯",
                "艾欧洛斯",
                "阿米诺斯"
            ]
        },
        {
            "songId": "Yet Another ”drizzly rain”",
            "category": "東方Project",
            "title": "Yet Another ”drizzly rain”",
            "artist": "myu314 feat.あまね(COOL&CREATE)",
            "bpm": 175,
            "imageName": "52275bc3808bf91a86e95ab2519b85c11c9832604ffda2cd085f08e93daeea1a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 134,
                        "hold": 4,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 152
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 437,
                    "releaseDate": "2015-11-12"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 286,
                        "hold": 16,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 437,
                    "releaseDate": "2015-11-12"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 348,
                        "hold": 25,
                        "slide": 43,
                        "touch": null,
                        "break": 20,
                        "total": 436
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 437,
                    "releaseDate": "2015-11-12"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 467,
                        "hold": 35,
                        "slide": 72,
                        "touch": null,
                        "break": 23,
                        "total": 597
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 437,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2015-11-12"
                }
            ],
            "searchAcronyms": [
                "姆Q",
                "帕秋莉"
            ]
        },
        {
            "songId": "四次元跳躍機関",
            "category": "東方Project",
            "title": "四次元跳躍機関",
            "artist": "koutaq",
            "bpm": 135,
            "imageName": "ba4c15c6a4d3a074fb1186b64a6e8189d2500f0880d46c29a6f63771dd50d680",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 117,
                        "hold": 14,
                        "slide": 1,
                        "touch": null,
                        "break": 5,
                        "total": 137
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 438,
                    "releaseDate": "2015-11-12"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 207,
                        "hold": 18,
                        "slide": 17,
                        "touch": null,
                        "break": 5,
                        "total": 247
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 438,
                    "releaseDate": "2015-11-12"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 307,
                        "hold": 27,
                        "slide": 37,
                        "touch": null,
                        "break": 8,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 438,
                    "releaseDate": "2015-11-12"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 537,
                        "hold": 38,
                        "slide": 43,
                        "touch": null,
                        "break": 18,
                        "total": 636
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 438,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2015-11-12"
                }
            ],
            "searchAcronyms": [
                "Four-Dimensional Warp Device",
                "冰风",
                "四次元",
                "四次元跳跃机关",
                "大小姐",
                "机关",
                "跳楼机"
            ]
        },
        {
            "songId": "最終鬼畜妹・一部声",
            "category": "東方Project",
            "title": "最終鬼畜妹・一部声",
            "artist": "ビートまりお",
            "bpm": 200,
            "imageName": "88136cbcde228b8ab26f82b3387a5beb3120581f26f9e22bd203d2a71cefc872",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 210,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 16,
                        "total": 234
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 439,
                    "releaseDate": "2015-11-12"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 409,
                        "hold": 32,
                        "slide": 37,
                        "touch": null,
                        "break": 21,
                        "total": 499
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 439,
                    "releaseDate": "2015-11-12"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 551,
                        "hold": 79,
                        "slide": 17,
                        "touch": null,
                        "break": 4,
                        "total": 651
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 439,
                    "releaseDate": "2015-11-12"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 598,
                        "hold": 37,
                        "slide": 164,
                        "touch": null,
                        "break": 42,
                        "total": 841
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 439,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2015-11-12"
                }
            ],
            "searchAcronyms": [
                "Saishuu kichiku imouto ichibu koe",
                "一部声",
                "易卜生",
                "月儿子青春版",
                "月女儿",
                "蓝蓝路",
                "鬼叫",
                "鬼畜妹",
                "鬼畜妹一部声"
            ]
        },
        {
            "songId": "Axeria",
            "category": "maimai",
            "title": "Axeria",
            "artist": "AcuticNotes",
            "bpm": 193,
            "imageName": "43a86d80f379804a7c04a39f5c08fafe16c3e915767f04d1abac59ccab556dda",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 3,
                        "slide": 9,
                        "touch": null,
                        "break": 3,
                        "total": 233
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 348,
                    "releaseDate": "2015-11-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 29,
                        "slide": 12,
                        "touch": null,
                        "break": 6,
                        "total": 323
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 348,
                    "releaseDate": "2015-11-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 453,
                        "hold": 60,
                        "slide": 56,
                        "touch": null,
                        "break": 6,
                        "total": 575
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 348,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2015-11-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 700,
                        "hold": 53,
                        "slide": 133,
                        "touch": null,
                        "break": 2,
                        "total": 888
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "ORANGE PLUS",
                    "internalId": 348,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "Splash": 14.5,
                        "Splash PLUS": 14.5,
                        "UNiVERSE": 14.5,
                        "UNiVERSE PLUS": 14.5,
                        "maimaiでらっくす PLUS": 14.5
                    },
                    "releaseDate": "2015-11-26"
                }
            ],
            "searchAcronyms": [
                "ax"
            ]
        },
        {
            "songId": "初音ミクの消失",
            "category": "niconico＆ボーカロイド",
            "title": "初音ミクの消失",
            "artist": "cosMo＠暴走P",
            "bpm": 240,
            "imageName": "4ea26f737916ec69c73e22628452904ea0a619835a21211b4f03bd17bef56e14",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 8,
                        "slide": 3,
                        "touch": 7,
                        "break": 7,
                        "total": 257
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10411,
                    "releaseDate": "2023-09-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 324,
                        "hold": 13,
                        "slide": 10,
                        "touch": 26,
                        "break": 2,
                        "total": 375
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10411,
                    "releaseDate": "2023-09-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 506,
                        "hold": 56,
                        "slide": 33,
                        "touch": 32,
                        "break": 13,
                        "total": 640
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10411,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12,
                        "BUDDiES PLUS": 12,
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2023-09-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 828,
                        "hold": 50,
                        "slide": 102,
                        "touch": 20,
                        "break": 39,
                        "total": 1039
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10411,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5
                    },
                    "releaseDate": "2023-09-13"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 243,
                        "hold": 5,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 257
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 411,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 376,
                        "hold": 53,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 411,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 503,
                        "hold": 60,
                        "slide": 43,
                        "touch": null,
                        "break": 27,
                        "total": 633
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 411,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 784,
                        "hold": 34,
                        "slide": 104,
                        "touch": null,
                        "break": 39,
                        "total": 961
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 411,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2015-12-09"
                }
            ],
            "searchAcronyms": [
                "?",
                "？",
                "disappearance",
                "The Disappearance of Hatsune Miku",
                "初音未来的消失",
                "初音没有来",
                "消失"
            ]
        },
        {
            "songId": "+♂",
            "category": "niconico＆ボーカロイド",
            "title": "+♂",
            "artist": "ギガ/れをる　ダンス　アルスマグナ",
            "bpm": 180,
            "imageName": "742e816d2b983f9b0f4a66c0091b1d40e742b4a6bc35f085e23d09db4a7dca5b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 246,
                        "hold": 8,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 260
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 447,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 406,
                        "hold": 16,
                        "slide": 5,
                        "touch": null,
                        "break": 12,
                        "total": 439
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 447,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 446,
                        "hold": 51,
                        "slide": 31,
                        "touch": null,
                        "break": 8,
                        "total": 536
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 447,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 606,
                        "hold": 26,
                        "slide": 144,
                        "touch": null,
                        "break": 38,
                        "total": 814
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 447,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4
                    },
                    "releaseDate": "2015-12-09"
                }
            ],
            "searchAcronyms": [
                "+男",
                "Plus男子",
                "加男",
                "嘉然",
                "憋憋憋憋",
                "正男"
            ]
        },
        {
            "songId": "Counselor",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Counselor",
            "artist": "DECO*27 feat.echo",
            "bpm": 135,
            "imageName": "fdaebd0cc5d56b95c3e646638f7635f73d6b19ba3bb7b9e244c9dde973e2a1ed",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 8,
                        "slide": 6,
                        "touch": null,
                        "break": 3,
                        "total": 207
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 455,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 27,
                        "slide": 27,
                        "touch": null,
                        "break": 12,
                        "total": 353
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 455,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 53,
                        "slide": 42,
                        "touch": null,
                        "break": 44,
                        "total": 488
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 455,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 526,
                        "hold": 69,
                        "slide": 88,
                        "touch": null,
                        "break": 37,
                        "total": 720
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 455,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2015-12-09"
                }
            ],
            "searchAcronyms": [
                "小护士",
                "律师"
            ]
        },
        {
            "songId": "言ノ葉遊戯",
            "category": "maimai",
            "title": "言ノ葉遊戯",
            "artist": "S!N・高橋菜々×ひとしずく・やま△",
            "bpm": 164,
            "imageName": "4f6266c8e26446504e088514e04ccc97c59c94583f1ce06a09f140fe07534f18",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 86,
                        "hold": 10,
                        "slide": 9,
                        "touch": null,
                        "break": 6,
                        "total": 111
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 457,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 18,
                        "slide": 17,
                        "touch": null,
                        "break": 10,
                        "total": 276
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 457,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 346,
                        "hold": 0,
                        "slide": 61,
                        "touch": null,
                        "break": 18,
                        "total": 425
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 457,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 392,
                        "hold": 0,
                        "slide": 149,
                        "touch": null,
                        "break": 29,
                        "total": 570
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 457,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.2
                    },
                    "releaseDate": "2015-12-09"
                }
            ],
            "searchAcronyms": [
                "KOTONOHA Yu-Gi",
                "文字游戏",
                "游戏",
                "言叶游戏"
            ]
        },
        {
            "songId": "りばーぶ",
            "category": "maimai",
            "title": "りばーぶ",
            "artist": "高橋菜々×岡部啓一(MONACA)",
            "bpm": 120,
            "imageName": "4262834d54612738639e8b04e3974502bcf2495598421c9a0eade3bb95b4dedc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 100,
                        "hold": 15,
                        "slide": 8,
                        "touch": null,
                        "break": 2,
                        "total": 125
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 458,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 16,
                        "slide": 14,
                        "touch": null,
                        "break": 8,
                        "total": 269
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 458,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 28,
                        "slide": 46,
                        "touch": null,
                        "break": 20,
                        "total": 288
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 458,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 353,
                        "hold": 6,
                        "slide": 98,
                        "touch": null,
                        "break": 13,
                        "total": 470
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 458,
                    "releaseDate": "2015-12-09"
                }
            ],
            "searchAcronyms": [
                "reverb",
                "Reverb",
                "两个人喝茶"
            ]
        },
        {
            "songId": "幾四音-Ixion-",
            "category": "オンゲキ＆CHUNITHM",
            "title": "幾四音-Ixion-",
            "artist": "M.S.S Project",
            "bpm": 210,
            "imageName": "23c873a51e133f91d254a3186d0892a9ae2f14637c8c7659d4a0ddd046224514",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 8,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 249
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 459,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 59,
                        "slide": 21,
                        "touch": null,
                        "break": 10,
                        "total": 368
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 459,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 465,
                        "hold": 54,
                        "slide": 43,
                        "touch": null,
                        "break": 23,
                        "total": 585
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 459,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 548,
                        "hold": 51,
                        "slide": 136,
                        "touch": null,
                        "break": 59,
                        "total": 794
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 459,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.1
                    },
                    "releaseDate": "2015-12-09"
                }
            ],
            "searchAcronyms": [
                "IKUSHION -Ixion-",
                "Ixion",
                "几四音",
                "急死银",
                "第四爱"
            ]
        },
        {
            "songId": "HIMITSUスパーク",
            "category": "POPS＆アニメ",
            "title": "HIMITSUスパーク",
            "artist": "カラスは真っ白",
            "bpm": 156,
            "imageName": "07907a8f7f5365d7f18d15b4a3c5a0d27bf00244bb1a0a4e0836fc96aaef9e97",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 166,
                        "hold": 15,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 188
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 480,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 24,
                        "slide": 21,
                        "touch": null,
                        "break": 4,
                        "total": 322
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 480,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 441,
                        "hold": 25,
                        "slide": 42,
                        "touch": null,
                        "break": 9,
                        "total": 517
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 480,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 532,
                        "hold": 50,
                        "slide": 79,
                        "touch": null,
                        "break": 7,
                        "total": 668
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 480,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2015-12-09"
                }
            ],
            "searchAcronyms": [
                "秘密"
            ]
        },
        {
            "songId": "Party 4U ”holy nite mix”",
            "category": "ゲーム＆バラエティ",
            "title": "Party 4U ”holy nite mix”",
            "artist": "Cranky",
            "bpm": 159,
            "imageName": "4ded45a82df2db941d71e620e968bd3d3d278ef9e367fa83a5c80ecbcc0d6aab",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 6,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 153
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 482,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 20,
                        "slide": 4,
                        "touch": null,
                        "break": 12,
                        "total": 266
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 482,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 401,
                        "hold": 0,
                        "slide": 44,
                        "touch": null,
                        "break": 25,
                        "total": 470
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 482,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 571,
                        "hold": 14,
                        "slide": 82,
                        "touch": null,
                        "break": 28,
                        "total": 695
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 482,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.3
                    },
                    "releaseDate": "2015-12-09"
                }
            ],
            "searchAcronyms": [
                "4u",
                "p4u",
                "派对4你"
            ]
        },
        {
            "songId": "物凄い勢いでけーねが物凄いうた",
            "category": "東方Project",
            "title": "物凄い勢いでけーねが物凄いうた",
            "artist": "Halozy",
            "bpm": 180,
            "imageName": "af903603ea9b0d777ee9a26ef59fa649339d70f1903343bac7376400e95dc589",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 6,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 149
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 360,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 20,
                        "slide": 28,
                        "touch": null,
                        "break": 22,
                        "total": 321
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 360,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 27,
                        "slide": 54,
                        "touch": null,
                        "break": 27,
                        "total": 388
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 360,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 452,
                        "hold": 30,
                        "slide": 84,
                        "touch": null,
                        "break": 33,
                        "total": 599
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 360,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.4,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2015-12-09"
                }
            ],
            "searchAcronyms": [
                "Monosugoi Ikioide Ke-ne",
                "三倍Ice☆Cream",
                "以惊人的气势发出了惊人的声音",
                "慧音",
                "物凄",
                "白泽球",
                "罪"
            ]
        },
        {
            "songId": "すろぉもぉしょん",
            "category": "niconico＆ボーカロイド",
            "title": "すろぉもぉしょん",
            "artist": "ピノキオピー",
            "bpm": 160,
            "imageName": "ff23c0bb15fdc58c99ffd7f47900da383b8b6ecd192149155281605a0376b5b1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 143,
                        "hold": 19,
                        "slide": 12,
                        "touch": null,
                        "break": 2,
                        "total": 176
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 449,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 325,
                        "hold": 12,
                        "slide": 19,
                        "touch": null,
                        "break": 7,
                        "total": 363
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 449,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 35,
                        "slide": 22,
                        "touch": null,
                        "break": 14,
                        "total": 473
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 449,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 689,
                        "hold": 8,
                        "slide": 62,
                        "touch": null,
                        "break": 29,
                        "total": 788
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 449,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.1
                    },
                    "releaseDate": "2015-12-09"
                }
            ],
            "searchAcronyms": [
                "SLoWMoTIoN"
            ]
        },
        {
            "songId": "閃鋼のブリューナク",
            "category": "オンゲキ＆CHUNITHM",
            "title": "閃鋼のブリューナク",
            "artist": "sasakure.UK",
            "bpm": 140,
            "imageName": "5158919509df472813ea0697fb5efafe5edb5e8768550a12a5d7d139fa95ad36",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 161,
                        "hold": 7,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 178
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 460,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 67,
                        "slide": 9,
                        "touch": null,
                        "break": 12,
                        "total": 372
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 460,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 475,
                        "hold": 48,
                        "slide": 42,
                        "touch": null,
                        "break": 8,
                        "total": 573
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 460,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 915,
                        "hold": 23,
                        "slide": 52,
                        "touch": null,
                        "break": 11,
                        "total": 1001
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 460,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2015-12-09"
                }
            ],
            "searchAcronyms": [
                "brionac",
                "Brionac of Steel-flash",
                "Senko no Brionac",
                "Senko no Buryunaku",
                "senkou",
                "闪钢"
            ]
        },
        {
            "songId": "アージェントシンメトリー",
            "category": "maimai",
            "title": "アージェントシンメトリー",
            "artist": "Sta feat.b",
            "bpm": 172,
            "imageName": "d99b7e652a1319ee945edc1a8f64b4c2e549afa95237d7dd0a3d5ddf47a78611",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 10,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 208
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 472,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 20,
                        "slide": 9,
                        "touch": null,
                        "break": 7,
                        "total": 342
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 472,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 423,
                        "hold": 35,
                        "slide": 25,
                        "touch": null,
                        "break": 17,
                        "total": 500
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 472,
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 629,
                        "hold": 12,
                        "slide": 101,
                        "touch": null,
                        "break": 4,
                        "total": 746
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 472,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.5,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2015-12-09"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 751,
                        "hold": 115,
                        "slide": 67,
                        "touch": null,
                        "break": 23,
                        "total": 956
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 472,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.8,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2020-11-04"
                }
            ],
            "searchAcronyms": [
                "argent symmetry",
                "Argent Symmetry",
                "pink op",
                "sta",
                "桃代主题曲",
                "白银",
                "白银对称",
                "白银对称性",
                "科目二",
                "银对称",
                "银对称性",
                "银色对称"
            ]
        },
        {
            "songId": "LOL -lots of laugh-",
            "category": "niconico＆ボーカロイド",
            "title": "LOL -lots of laugh-",
            "artist": "KeN/エンドケイプ",
            "bpm": 138,
            "imageName": "6ab9bc89007156e777d46036044a6c5061a614c69f87021b2297f49c9d0c211e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 178,
                        "hold": 6,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 194
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 407,
                    "releaseDate": "2016-01-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 304,
                        "hold": 10,
                        "slide": 16,
                        "touch": null,
                        "break": 3,
                        "total": 333
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 407,
                    "releaseDate": "2016-01-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 53,
                        "slide": 67,
                        "touch": null,
                        "break": 5,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 407,
                    "releaseDate": "2016-01-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 428,
                        "hold": 24,
                        "slide": 130,
                        "touch": null,
                        "break": 7,
                        "total": 589
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 407,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2016-01-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "イノコリ先生",
            "category": "niconico＆ボーカロイド",
            "title": "イノコリ先生",
            "artist": "HoneyWorks",
            "bpm": 162,
            "imageName": "eaed6a23a3408ca0f8550d927a24286e47ba934d59289f041bc87b0ba9b783a2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 10,
                        "slide": 5,
                        "touch": null,
                        "break": 5,
                        "total": 162
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 412,
                    "releaseDate": "2016-01-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 316,
                        "hold": 15,
                        "slide": 18,
                        "touch": null,
                        "break": 9,
                        "total": 358
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 412,
                    "releaseDate": "2016-01-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 92,
                        "slide": 48,
                        "touch": null,
                        "break": 17,
                        "total": 495
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 412,
                    "releaseDate": "2016-01-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 656,
                        "hold": 41,
                        "slide": 91,
                        "touch": null,
                        "break": 19,
                        "total": 807
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 412,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.1
                    },
                    "releaseDate": "2016-01-21"
                }
            ],
            "searchAcronyms": [
                "先生",
                "男同",
                "男同互瞪",
                "男同老师",
                "留堂老师"
            ]
        },
        {
            "songId": "厨病激発ボーイ",
            "category": "niconico＆ボーカロイド",
            "title": "厨病激発ボーイ",
            "artist": "れるりり",
            "bpm": 190,
            "imageName": "e6493d74d00298e7b6ead2856792bce029c1f1974e1203294ba924ef0ce23a26",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 10,
                        "slide": 2,
                        "touch": null,
                        "break": 9,
                        "total": 251
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 477,
                    "releaseDate": "2019-03-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 38,
                        "slide": 11,
                        "touch": null,
                        "break": 23,
                        "total": 417
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 477,
                    "releaseDate": "2019-03-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 395,
                        "hold": 32,
                        "slide": 85,
                        "touch": null,
                        "break": 21,
                        "total": 533
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 477,
                    "releaseDate": "2019-03-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 725,
                        "hold": 25,
                        "slide": 162,
                        "touch": null,
                        "break": 16,
                        "total": 928
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 477,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.3
                    },
                    "releaseDate": "2019-03-08"
                }
            ],
            "searchAcronyms": [
                "Young disease outburst Boy"
            ]
        },
        {
            "songId": "Revive The Rave",
            "category": "maimai",
            "title": "Revive The Rave",
            "artist": "void(Mournfinale)",
            "bpm": 165,
            "imageName": "e2ca2f1853a16d4ab25d67784af8692e0737d8b0af5f15fad4f9edc17f779489",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 294,
                        "hold": 12,
                        "slide": 2,
                        "touch": null,
                        "break": 2,
                        "total": 310
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 464,
                    "releaseDate": "2016-01-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 327,
                        "hold": 35,
                        "slide": 19,
                        "touch": null,
                        "break": 22,
                        "total": 403
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 464,
                    "releaseDate": "2016-01-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 519,
                        "hold": 46,
                        "slide": 42,
                        "touch": null,
                        "break": 24,
                        "total": 631
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 464,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2016-01-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 790,
                        "hold": 55,
                        "slide": 43,
                        "touch": null,
                        "break": 70,
                        "total": 958
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 464,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2016-01-21"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 646,
                        "hold": 105,
                        "slide": 61,
                        "touch": null,
                        "break": 100,
                        "total": 912
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 464,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "UNiVERSE PLUS": 14.4
                    },
                    "releaseDate": "2022-08-04"
                }
            ],
            "searchAcronyms": [
                "rtr",
                "一个绝赞叫一声",
                "润体乳"
            ]
        },
        {
            "songId": "YU-MU",
            "category": "東方Project",
            "title": "YU-MU",
            "artist": "岸田教団＆THE明星ロケッツ",
            "bpm": 160,
            "imageName": "b4acb61bb84f9c176d5a96dc6044bded5d711696f73283113a41fd981681a890",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 110,
                        "hold": 6,
                        "slide": 9,
                        "touch": null,
                        "break": 2,
                        "total": 127
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 359,
                    "releaseDate": "2016-02-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 47,
                        "slide": 7,
                        "touch": null,
                        "break": 10,
                        "total": 282
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 359,
                    "releaseDate": "2016-02-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 54,
                        "slide": 24,
                        "touch": null,
                        "break": 14,
                        "total": 414
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 359,
                    "releaseDate": "2016-02-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 439,
                        "hold": 36,
                        "slide": 91,
                        "touch": null,
                        "break": 10,
                        "total": 576
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 359,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2016-02-04"
                }
            ],
            "searchAcronyms": [
                "yumu",
                "榆木"
            ]
        },
        {
            "songId": "フラグメンツ -T.V. maimai edit-",
            "category": "東方Project",
            "title": "フラグメンツ -T.V. maimai edit-",
            "artist": "発熱巫女～ず",
            "bpm": 160,
            "imageName": "96f061d1e0ba54259469b0b8543bb701d6e1a421938cf307b3ec7c4c294ebb67",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 129,
                        "hold": 12,
                        "slide": 12,
                        "touch": null,
                        "break": 5,
                        "total": 158
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 434,
                    "releaseDate": "2016-02-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 12,
                        "slide": 12,
                        "touch": null,
                        "break": 2,
                        "total": 337
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 434,
                    "releaseDate": "2016-02-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 407,
                        "hold": 30,
                        "slide": 46,
                        "touch": null,
                        "break": 2,
                        "total": 485
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 434,
                    "releaseDate": "2016-02-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 56,
                        "slide": 122,
                        "touch": null,
                        "break": 18,
                        "total": 598
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 434,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2016-02-04"
                }
            ],
            "searchAcronyms": [
                "fragments",
                "maimai edit",
                "tv",
                "东方穿心莲"
            ]
        },
        {
            "songId": "願いを呼ぶ季節",
            "category": "東方Project",
            "title": "願いを呼ぶ季節",
            "artist": "舞風-MAIKAZE/時音-TOKINE",
            "bpm": 170,
            "imageName": "921072644f139726ca33fa87c77c55c1494424469bd9d9deae8e238c1e8d7793",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 6,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 118
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 435,
                    "releaseDate": "2016-02-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 215,
                        "hold": 8,
                        "slide": 20,
                        "touch": null,
                        "break": 11,
                        "total": 254
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 435,
                    "releaseDate": "2016-02-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 243,
                        "hold": 37,
                        "slide": 31,
                        "touch": null,
                        "break": 6,
                        "total": 317
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 435,
                    "releaseDate": "2016-02-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 38,
                        "slide": 42,
                        "touch": null,
                        "break": 3,
                        "total": 447
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 435,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2016-02-04"
                }
            ],
            "searchAcronyms": [
                "呼唤愿望的季节",
                "季节",
                "愿呼季节",
                "梦想夏乡",
                "梦想夏乡主题曲",
                "红蓝"
            ]
        },
        {
            "songId": "囲い無き世は一期の月影",
            "category": "東方Project",
            "title": "囲い無き世は一期の月影",
            "artist": "豚乙女",
            "bpm": 172,
            "imageName": "d0ddd244f91a162d30ed546275c3fe1192269e8ef4109d8452a0f50786bcd6ae",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 10,
                        "slide": 7,
                        "touch": null,
                        "break": 5,
                        "total": 212
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 483,
                    "releaseDate": "2016-02-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 16,
                        "slide": 20,
                        "touch": null,
                        "break": 12,
                        "total": 338
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 483,
                    "releaseDate": "2016-02-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 348,
                        "hold": 48,
                        "slide": 56,
                        "touch": null,
                        "break": 7,
                        "total": 459
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 483,
                    "releaseDate": "2016-02-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 613,
                        "hold": 16,
                        "slide": 72,
                        "touch": null,
                        "break": 17,
                        "total": 718
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 483,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2016-02-04"
                }
            ],
            "searchAcronyms": [
                "月影"
            ]
        },
        {
            "songId": "After Burner",
            "category": "ゲーム＆バラエティ",
            "title": "After Burner",
            "artist": "東京アクティブNEETs",
            "bpm": 155,
            "imageName": "4c46116639080c309c580897225c2ae39b65d314f80b628f26c770a1afd041f5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 211,
                        "hold": 4,
                        "slide": 12,
                        "touch": null,
                        "break": 8,
                        "total": 235
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 454,
                    "releaseDate": "2016-02-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 384,
                        "hold": 30,
                        "slide": 7,
                        "touch": null,
                        "break": 10,
                        "total": 431
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 454,
                    "releaseDate": "2016-02-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 343,
                        "hold": 23,
                        "slide": 79,
                        "touch": null,
                        "break": 43,
                        "total": 488
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 454,
                    "releaseDate": "2016-02-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 774,
                        "hold": 27,
                        "slide": 78,
                        "touch": null,
                        "break": 36,
                        "total": 915
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 454,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.6,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.1,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.6,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2016-02-18"
                }
            ],
            "searchAcronyms": [
                "ab",
                "东京热",
                "冲破火网",
                "后烧"
            ]
        },
        {
            "songId": "7thSense",
            "category": "maimai",
            "title": "7thSense",
            "artist": "削除",
            "bpm": 150,
            "imageName": "4f7d9ec836d61addbbc5a26c8a3f03e17fd91ad5c06711981dc54b1e04b2e932",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 206,
                        "hold": 25,
                        "slide": 12,
                        "touch": null,
                        "break": 4,
                        "total": 247
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 462,
                    "releaseDate": "2016-02-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 348,
                        "hold": 30,
                        "slide": 17,
                        "touch": null,
                        "break": 9,
                        "total": 404
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 462,
                    "releaseDate": "2016-02-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 403,
                        "hold": 59,
                        "slide": 27,
                        "touch": null,
                        "break": 26,
                        "total": 515
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 462,
                    "releaseDate": "2016-02-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 640,
                        "hold": 46,
                        "slide": 96,
                        "touch": null,
                        "break": 77,
                        "total": 859
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 462,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "Splash": 14.3,
                        "Splash PLUS": 14.3,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.3,
                        "maimaiでらっくす PLUS": 14.2
                    },
                    "releaseDate": "2016-02-18"
                }
            ],
            "searchAcronyms": [
                "7",
                "7s",
                "7th",
                "7感",
                "七感",
                "七拍子",
                "旗杆",
                "第七感"
            ]
        },
        {
            "songId": "ラブリー☆えんじぇる!!",
            "category": "POPS＆アニメ",
            "title": "ラブリー☆えんじぇる!!",
            "artist": "あべにゅうぷろじぇくと feat.佐倉紗織&井上みゆ「パチスロ快盗天使ツインエンジェル」",
            "bpm": 173,
            "imageName": "a47a10919823e9af17d5fe7b64a3c18de859eca6f12fcb683a036a0c4297546d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 130,
                        "hold": 5,
                        "slide": 7,
                        "touch": null,
                        "break": 3,
                        "total": 145
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 468,
                    "releaseDate": "2016-03-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 14,
                        "slide": 6,
                        "touch": null,
                        "break": 6,
                        "total": 260
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 468,
                    "releaseDate": "2016-03-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 310,
                        "hold": 37,
                        "slide": 12,
                        "touch": null,
                        "break": 23,
                        "total": 382
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 468,
                    "releaseDate": "2016-03-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 360,
                        "hold": 43,
                        "slide": 66,
                        "touch": null,
                        "break": 32,
                        "total": 501
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 468,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash": 12,
                        "UNiVERSE": 12
                    },
                    "releaseDate": "2016-03-03"
                }
            ],
            "searchAcronyms": [
                "Lovely☆Angel!!",
                "可爱天使"
            ]
        },
        {
            "songId": "オモイヨシノ",
            "category": "ゲーム＆バラエティ",
            "title": "オモイヨシノ",
            "artist": "loos feat. 柊莉杏",
            "bpm": 168,
            "imageName": "4084ee4029d058e6b26b1bb41ea652dbdb94df7ddcd84b25360b798b6e7fe72a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 156,
                        "hold": 14,
                        "slide": 6,
                        "touch": null,
                        "break": 6,
                        "total": 182
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 471,
                    "releaseDate": "2016-03-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 17,
                        "slide": 18,
                        "touch": null,
                        "break": 31,
                        "total": 372
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 471,
                    "releaseDate": "2016-03-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 438,
                        "hold": 39,
                        "slide": 33,
                        "touch": null,
                        "break": 24,
                        "total": 534
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 471,
                    "releaseDate": "2016-03-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 497,
                        "hold": 56,
                        "slide": 110,
                        "touch": null,
                        "break": 12,
                        "total": 675
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 471,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.1
                    },
                    "releaseDate": "2016-03-03"
                }
            ],
            "searchAcronyms": [
                "Omoiyoshino",
                "恋咏樱"
            ]
        },
        {
            "songId": "GEMINI -M-",
            "category": "maimai",
            "title": "GEMINI -M-",
            "artist": "Tatsh",
            "bpm": 180,
            "imageName": "e125941c23ef90e2fe5c615834b23f9ecb8208387d1715c6a56e483db4c92392",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 18,
                        "slide": 11,
                        "touch": null,
                        "break": 24,
                        "total": 292
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 446,
                    "releaseDate": "2016-03-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 379,
                        "hold": 21,
                        "slide": 15,
                        "touch": null,
                        "break": 10,
                        "total": 425
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 446,
                    "releaseDate": "2016-03-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 586,
                        "hold": 32,
                        "slide": 37,
                        "touch": null,
                        "break": 8,
                        "total": 663
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 446,
                    "releaseDate": "2016-03-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 898,
                        "hold": 54,
                        "slide": 102,
                        "touch": null,
                        "break": 22,
                        "total": 1076
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 446,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.9,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2016-03-17"
                }
            ],
            "searchAcronyms": [
                "双子座",
                "双子星",
                "戈米尼"
            ]
        },
        {
            "songId": "ありふれたせかいせいふく",
            "category": "niconico＆ボーカロイド",
            "title": "ありふれたせかいせいふく",
            "artist": "ピノキオピー",
            "bpm": 150,
            "imageName": "68219fbdc43a451f4158731c132251bcc685e4c6f896532d8d704c37ee8371ac",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 187,
                        "hold": 11,
                        "slide": 8,
                        "touch": null,
                        "break": 7,
                        "total": 213
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 448,
                    "releaseDate": "2016-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 300,
                        "hold": 19,
                        "slide": 19,
                        "touch": null,
                        "break": 10,
                        "total": 348
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 448,
                    "releaseDate": "2016-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 45,
                        "slide": 23,
                        "touch": null,
                        "break": 11,
                        "total": 436
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 448,
                    "releaseDate": "2016-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 732,
                        "hold": 61,
                        "slide": 79,
                        "touch": null,
                        "break": 20,
                        "total": 892
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 448,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2016-04-07"
                }
            ],
            "searchAcronyms": [
                "Arifureta sekai seifuku",
                "世界征服",
                "初音围巾",
                "司空见惯的世界征服",
                "红围巾"
            ]
        },
        {
            "songId": "頓珍漢の宴",
            "category": "niconico＆ボーカロイド",
            "title": "頓珍漢の宴",
            "artist": "ピノキオピー",
            "bpm": 145,
            "imageName": "b5d67aee408d3a8f421d491f2871b213f7b84eaa64dcfcabc6642762924568ca",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 7,
                        "slide": 11,
                        "touch": null,
                        "break": 5,
                        "total": 252
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 451,
                    "releaseDate": "2016-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 390,
                        "hold": 36,
                        "slide": 10,
                        "touch": null,
                        "break": 8,
                        "total": 444
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 451,
                    "releaseDate": "2016-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 570,
                        "hold": 43,
                        "slide": 16,
                        "touch": null,
                        "break": 12,
                        "total": 641
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 451,
                    "releaseDate": "2016-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 843,
                        "hold": 25,
                        "slide": 92,
                        "touch": null,
                        "break": 27,
                        "total": 987
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 451,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.3
                    },
                    "releaseDate": "2016-04-07"
                }
            ],
            "searchAcronyms": [
                "🥓",
                "🙏",
                "tonchinkan",
                "Tonchinkan no en",
                "初音上菜",
                "吃饭",
                "大嘴花",
                "希望人没事",
                "汉尼拔之宴",
                "珍顿汉",
                "蹲着喊耶",
                "顿珍汉",
                "顿珍汉之宴",
                "顿珍汉吃席",
                "顿珍汉宴",
                "顿震撼",
                "食雪汉"
            ]
        },
        {
            "songId": "Garden Of The Dragon",
            "category": "ゲーム＆バラエティ",
            "title": "Garden Of The Dragon",
            "artist": "Kai「Wonderland Wars」",
            "bpm": 120,
            "imageName": "468401e0ee975705cb431bed0d1f0253e8583418e8eea2dbede4ea6f7799f865",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 95,
                        "hold": 10,
                        "slide": 2,
                        "touch": null,
                        "break": 4,
                        "total": 111
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 453,
                    "releaseDate": "2016-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 215,
                        "hold": 32,
                        "slide": 22,
                        "touch": null,
                        "break": 12,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 453,
                    "releaseDate": "2016-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 433,
                        "hold": 36,
                        "slide": 48,
                        "touch": null,
                        "break": 8,
                        "total": 525
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 453,
                    "releaseDate": "2016-04-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 531,
                        "hold": 11,
                        "slide": 67,
                        "touch": null,
                        "break": 67,
                        "total": 676
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 453,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.5,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2016-04-07"
                }
            ],
            "searchAcronyms": [
                "04年广告",
                "花园龙",
                "龙花园"
            ]
        },
        {
            "songId": "FEEL the BEATS",
            "category": "maimai",
            "title": "FEEL the BEATS",
            "artist": "A-One",
            "bpm": 166,
            "imageName": "4c83c01ddbf984a40384de389efb6a311e3ba9433aed8eb353d3cd785ba52f46",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 222,
                        "hold": 11,
                        "slide": 8,
                        "touch": null,
                        "break": 2,
                        "total": 243
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 463,
                    "releaseDate": "2016-04-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 466,
                        "hold": 10,
                        "slide": 13,
                        "touch": null,
                        "break": 6,
                        "total": 495
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 463,
                    "releaseDate": "2016-04-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 414,
                        "hold": 80,
                        "slide": 44,
                        "touch": null,
                        "break": 10,
                        "total": 548
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 463,
                    "releaseDate": "2016-04-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 789,
                        "hold": 30,
                        "slide": 87,
                        "touch": null,
                        "break": 25,
                        "total": 931
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 463,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2016-04-21"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 740,
                        "hold": 71,
                        "slide": 101,
                        "touch": null,
                        "break": 88,
                        "total": 1000
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 463,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.7,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2020-11-04"
                }
            ],
            "searchAcronyms": [
                "fb",
                "ftb",
                "感受节拍"
            ]
        },
        {
            "songId": "スリップフリップ",
            "category": "maimai",
            "title": "スリップフリップ",
            "artist": "tilt-six feat.串伊トモミ",
            "bpm": 143,
            "imageName": "ea39e8dc284a484ec2d10c5ed214c6d65c224794a9bfa9a3d20500a8573ebf31",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 10,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 200
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 465,
                    "releaseDate": "2016-04-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 384,
                        "hold": 8,
                        "slide": 33,
                        "touch": null,
                        "break": 11,
                        "total": 436
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 465,
                    "releaseDate": "2016-04-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 50,
                        "slide": 61,
                        "touch": null,
                        "break": 13,
                        "total": 476
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 465,
                    "releaseDate": "2016-04-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 537,
                        "hold": 40,
                        "slide": 235,
                        "touch": null,
                        "break": 20,
                        "total": 832
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 465,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.2
                    },
                    "releaseDate": "2016-04-21"
                }
            ],
            "searchAcronyms": [
                "010",
                "slipflip",
                "不二家",
                "大脸妹",
                "耳机女",
                "耳机娘"
            ]
        },
        {
            "songId": "橙の幻想郷音頭",
            "category": "東方Project",
            "title": "橙の幻想郷音頭",
            "artist": "発熱巫女～ず",
            "bpm": 136,
            "imageName": "807f65a993a27a8878fa845153de8e69d57db3178825c53fc5140820750c97fc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 195,
                        "hold": 4,
                        "slide": 1,
                        "touch": null,
                        "break": 6,
                        "total": 206
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 424,
                    "releaseDate": "2016-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 182,
                        "hold": 16,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 206
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 424,
                    "releaseDate": "2016-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 348,
                        "hold": 23,
                        "slide": 71,
                        "touch": null,
                        "break": 35,
                        "total": 477
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 424,
                    "releaseDate": "2016-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 456,
                        "hold": 7,
                        "slide": 75,
                        "touch": null,
                        "break": 26,
                        "total": 564
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 424,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.2
                    },
                    "releaseDate": "2016-05-12"
                }
            ],
            "searchAcronyms": [
                "🐱",
                "Chen No Gensoukyo Ondo",
                "幻想乡音头",
                "橙",
                "橙之幻想乡",
                "橙的幻想乡音头",
                "橙舞",
                "橙音头",
                "欢乐斗地主",
                "音头"
            ]
        },
        {
            "songId": "東方妖々夢 ～the maximum moving about～",
            "category": "東方Project",
            "title": "東方妖々夢 ～the maximum moving about～",
            "artist": "石鹸屋",
            "bpm": 196,
            "imageName": "1e17f41b087fc41a0798ce1e4d550b0c28b087144514fe197a0820e29b8cc2f1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 307,
                        "hold": 10,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 329
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 425,
                    "releaseDate": "2016-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 445,
                        "hold": 15,
                        "slide": 17,
                        "touch": null,
                        "break": 6,
                        "total": 483
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 425,
                    "releaseDate": "2016-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 526,
                        "hold": 30,
                        "slide": 47,
                        "touch": null,
                        "break": 8,
                        "total": 611
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 425,
                    "releaseDate": "2016-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "rioNとはっぴー",
                    "noteCounts": {
                        "tap": 558,
                        "hold": 45,
                        "slide": 167,
                        "touch": null,
                        "break": 10,
                        "total": 780
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 425,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2016-05-12"
                }
            ],
            "searchAcronyms": [
                "the maximum moving about",
                "toho yoyomu -the maximum moving about-",
                "东方不可拘束",
                "东方妖妖梦",
                "妖妖梦",
                "车万不可拘束"
            ]
        },
        {
            "songId": "蒼空に舞え、墨染の桜",
            "category": "東方Project",
            "title": "蒼空に舞え、墨染の桜",
            "artist": "Silver Forest",
            "bpm": 150,
            "imageName": "ab407ad38be8d1a02db414f372906012d5dd5deabfef178d5c585198d9e97a06",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 180,
                        "hold": 29,
                        "slide": 2,
                        "touch": null,
                        "break": 4,
                        "total": 215
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 426,
                    "releaseDate": "2016-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 30,
                        "slide": 9,
                        "touch": null,
                        "break": 4,
                        "total": 349
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 426,
                    "releaseDate": "2016-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 377,
                        "hold": 78,
                        "slide": 54,
                        "touch": null,
                        "break": 8,
                        "total": 517
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 426,
                    "releaseDate": "2016-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 459,
                        "hold": 47,
                        "slide": 182,
                        "touch": null,
                        "break": 10,
                        "total": 698
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 426,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2016-05-12"
                }
            ],
            "searchAcronyms": [
                "Soranimae Sumizomenosakura",
                "妖梦",
                "苍空",
                "苍空舞",
                "苍空飞舞墨染之樱",
                "墨染",
                "墨染樱"
            ]
        },
        {
            "songId": "少女幻葬戦慄曲 ～ Necro Fantasia",
            "category": "東方Project",
            "title": "少女幻葬戦慄曲 ～ Necro Fantasia",
            "artist": "どぶウサギ",
            "bpm": 182,
            "imageName": "f3f6a7fe649c6a02cafb1b05d7c38fd4f16b16dee54dae4ad7e9e3ae6bf7378b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 17,
                        "slide": 10,
                        "touch": null,
                        "break": 4,
                        "total": 268
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 427,
                    "releaseDate": "2016-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 378,
                        "hold": 32,
                        "slide": 5,
                        "touch": null,
                        "break": 3,
                        "total": 418
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 427,
                    "releaseDate": "2016-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "畳返し",
                    "noteCounts": {
                        "tap": 361,
                        "hold": 78,
                        "slide": 30,
                        "touch": null,
                        "break": 7,
                        "total": 476
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 427,
                    "releaseDate": "2016-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 798,
                        "hold": 18,
                        "slide": 137,
                        "touch": null,
                        "break": 25,
                        "total": 978
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 427,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.6,
                        "UNiVERSE": 13.6,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2016-05-12"
                }
            ],
            "searchAcronyms": [
                "少女幻葬",
                "死灵幻想曲"
            ]
        },
        {
            "songId": "Jimang Shot",
            "category": "東方Project",
            "title": "Jimang Shot",
            "artist": "じまんぐ",
            "bpm": 164,
            "imageName": "a29b2f7911b30e67c96773155dbbd8c41c8acbeab9ceda54b6ea7ac3c28a0c77",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 204,
                        "hold": 18,
                        "slide": 10,
                        "touch": null,
                        "break": 6,
                        "total": 238
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 466,
                    "releaseDate": "2016-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 353,
                        "hold": 10,
                        "slide": 7,
                        "touch": null,
                        "break": 8,
                        "total": 378
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 466,
                    "releaseDate": "2016-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 378,
                        "hold": 48,
                        "slide": 56,
                        "touch": null,
                        "break": 16,
                        "total": 498
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 466,
                    "releaseDate": "2016-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 504,
                        "hold": 44,
                        "slide": 149,
                        "touch": null,
                        "break": 13,
                        "total": 710
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 466,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2016-05-12"
                }
            ],
            "searchAcronyms": [
                "2015",
                "囧仙",
                "大叔唱歌",
                "急忙射",
                "报纸歌"
            ]
        },
        {
            "songId": "Glorious Crown",
            "category": "maimai",
            "title": "Glorious Crown",
            "artist": "xi",
            "bpm": 225,
            "imageName": "86732af137675c3d9cb03d1f28434cd35acbfaa50b3bb91fb3e7ad1e2ce76dbc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 317,
                        "hold": 8,
                        "slide": 12,
                        "touch": null,
                        "break": 7,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 456,
                    "releaseDate": "2016-05-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 572,
                        "hold": 14,
                        "slide": 19,
                        "touch": null,
                        "break": 12,
                        "total": 617
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 456,
                    "releaseDate": "2016-05-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 642,
                        "hold": 33,
                        "slide": 65,
                        "touch": null,
                        "break": 37,
                        "total": 777
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 456,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2016-05-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "チャン@DP皆伝 vs Jack",
                    "noteCounts": {
                        "tap": 989,
                        "hold": 18,
                        "slide": 89,
                        "touch": null,
                        "break": 54,
                        "total": 1150
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK",
                    "internalId": 456,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "FESTiVAL": 14.8,
                        "FESTiVAL PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8,
                        "Splash": 14.8,
                        "Splash PLUS": 14.8,
                        "UNiVERSE": 14.8,
                        "UNiVERSE PLUS": 14.8,
                        "maimaiでらっくす PLUS": 14.6
                    },
                    "releaseDate": "2016-05-26"
                }
            ],
            "searchAcronyms": [
                "👑",
                "fd2",
                "gc",
                "王冠",
                "皇冠",
                "荣耀的皇冠"
            ]
        },
        {
            "songId": "無敵We are one!!",
            "category": "オンゲキ＆CHUNITHM",
            "title": "無敵We are one!!",
            "artist": "イロドリミドリ「CHUNITHM」",
            "bpm": 190,
            "imageName": "630d5eede5367697d5f6511f4088214ef50ef62336574b3f8abbe5e02a6ea026",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 207,
                        "hold": 14,
                        "slide": 7,
                        "touch": null,
                        "break": 6,
                        "total": 234
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 461,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 412,
                        "hold": 20,
                        "slide": 22,
                        "touch": null,
                        "break": 11,
                        "total": 465
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 461,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 428,
                        "hold": 40,
                        "slide": 50,
                        "touch": null,
                        "break": 26,
                        "total": 544
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 461,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 721,
                        "hold": 45,
                        "slide": 143,
                        "touch": null,
                        "break": 29,
                        "total": 938
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 461,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2016-06-30"
                }
            ],
            "searchAcronyms": [
                "muteki",
                "MUTEKI We are one!!",
                "We are one",
                "我们是1",
                "我们是一",
                "我们是无敌1",
                "无敌",
                "无敌we are one",
                "无敌我们是1",
                "无敌我们是一"
            ]
        },
        {
            "songId": "儚きもの人間",
            "category": "東方Project",
            "title": "儚きもの人間",
            "artist": "豚乙女",
            "bpm": 180,
            "imageName": "42e326217db314ce230ae2374b89d868fe61ece119eecfb6f712c709b87f07db",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 139,
                        "hold": 14,
                        "slide": 12,
                        "touch": null,
                        "break": 2,
                        "total": 167
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 467,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 64,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 387
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 467,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 441,
                        "hold": 38,
                        "slide": 41,
                        "touch": null,
                        "break": 16,
                        "total": 536
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 467,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 736,
                        "hold": 26,
                        "slide": 119,
                        "touch": null,
                        "break": 21,
                        "total": 902
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 467,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.8,
                        "Splash PLUS": 13.6,
                        "UNiVERSE": 13.6,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2016-06-30"
                }
            ],
            "searchAcronyms": [
                "Hakanakimono Ningen",
                "少女炼狱",
                "梦人间"
            ]
        },
        {
            "songId": "キミノヨゾラ哨戒班",
            "category": "niconico＆ボーカロイド",
            "title": "キミノヨゾラ哨戒班",
            "artist": "Orangestar",
            "bpm": 185,
            "imageName": "c1f198cb5598fe55d226750e4c1759d64a502bd499a8e418d1da4fb0416be4b7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 171,
                        "hold": 12,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 195
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 507,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 325,
                        "hold": 16,
                        "slide": 11,
                        "touch": null,
                        "break": 1,
                        "total": 353
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 507,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 418,
                        "hold": 34,
                        "slide": 51,
                        "touch": null,
                        "break": 29,
                        "total": 532
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 507,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 603,
                        "hold": 27,
                        "slide": 96,
                        "touch": null,
                        "break": 15,
                        "total": 741
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 507,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2016-06-30"
                }
            ],
            "searchAcronyms": [
                "你的夜空哨戒班",
                "哨戒班",
                "烧鸡班"
            ]
        },
        {
            "songId": "恋愛裁判",
            "category": "niconico＆ボーカロイド",
            "title": "恋愛裁判",
            "artist": "40mP",
            "bpm": 134,
            "imageName": "1c571d729acf820e3e8cd0b8d933fe39446f30f1dda075b54b4f8f06b10ba994",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 147,
                        "hold": 8,
                        "slide": 7,
                        "touch": null,
                        "break": 3,
                        "total": 165
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 508,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 266,
                        "hold": 21,
                        "slide": 9,
                        "touch": null,
                        "break": 8,
                        "total": 304
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 508,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "畳返しとはっぴー",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 109,
                        "slide": 45,
                        "touch": null,
                        "break": 21,
                        "total": 393
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 508,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "しろいろとはっぴー",
                    "noteCounts": {
                        "tap": 472,
                        "hold": 65,
                        "slide": 69,
                        "touch": null,
                        "break": 26,
                        "total": 632
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 508,
                    "releaseDate": "2016-06-30"
                }
            ],
            "searchAcronyms": [
                "Love Trial",
                "а╣░ш╡цеп",
                "初音大小姐想和我告白高智商天才的头脑对决",
                "她",
                "恋爱审判",
                "恋爱裁判",
                "有罪",
                "朝你大胯捏一把",
                "逆转裁判"
            ]
        },
        {
            "songId": "METATRON",
            "category": "ゲーム＆バラエティ",
            "title": "METATRON",
            "artist": "SHIKI",
            "bpm": 190,
            "imageName": "e9f57c0d3a782935794eda4f7bf216d8b2a3973b2b0fbc4717da1522c0dfe462",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 15,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 224
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 542,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 420,
                        "hold": 12,
                        "slide": 15,
                        "touch": null,
                        "break": 11,
                        "total": 458
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 542,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 508,
                        "hold": 27,
                        "slide": 40,
                        "touch": null,
                        "break": 18,
                        "total": 593
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 542,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 807,
                        "hold": 20,
                        "slide": 82,
                        "touch": null,
                        "break": 16,
                        "total": 925
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 542,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2016-06-30"
                }
            ],
            "searchAcronyms": [
                "元创",
                "梅塔特隆",
                "死镰2",
                "死镰二",
                "钟楼"
            ]
        },
        {
            "songId": "fake!fake!",
            "category": "POPS＆アニメ",
            "title": "fake!fake!",
            "artist": "カラスは真っ白",
            "bpm": 156,
            "imageName": "cadbf3fe341cc4808f5a36027816584731a7e2d07360fdead91c4b05ae16a5d0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 159,
                        "hold": 5,
                        "slide": 6,
                        "touch": null,
                        "break": 3,
                        "total": 173
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 497,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 274,
                        "hold": 29,
                        "slide": 21,
                        "touch": null,
                        "break": 8,
                        "total": 332
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 497,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 358,
                        "hold": 62,
                        "slide": 41,
                        "touch": null,
                        "break": 13,
                        "total": 474
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 497,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 639,
                        "hold": 28,
                        "slide": 77,
                        "touch": null,
                        "break": 12,
                        "total": 756
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 497,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2016-06-30"
                }
            ],
            "searchAcronyms": [
                "fake",
                "fakefake",
                "万物皆虚",
                "假！假！",
                "假的假的",
                "弹簧",
                "彩虹圈",
                "骗子"
            ]
        },
        {
            "songId": "Invitation",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Invitation",
            "artist": "れるりり feat.ろん",
            "bpm": 147,
            "imageName": "1924dfbd61f7898c60e1a639cf636c948fad2009ff5cda6bec7b5a56be62b834",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 155,
                        "hold": 12,
                        "slide": 9,
                        "touch": null,
                        "break": 6,
                        "total": 182
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 528,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 8,
                        "slide": 19,
                        "touch": null,
                        "break": 6,
                        "total": 390
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 528,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 491,
                        "hold": 29,
                        "slide": 39,
                        "touch": null,
                        "break": 9,
                        "total": 568
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 528,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 720,
                        "hold": 21,
                        "slide": 68,
                        "touch": null,
                        "break": 25,
                        "total": 834
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 528,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13,
                        "Splash": 12.6,
                        "UNiVERSE PLUS": 13.1
                    },
                    "releaseDate": "2016-06-30"
                }
            ],
            "searchAcronyms": [
                "！？",
                "邀请"
            ]
        },
        {
            "songId": "月に叢雲華に風",
            "category": "東方Project",
            "title": "月に叢雲華に風",
            "artist": "幽閉サテライト(Produce:嵯峨飛鳥 Arranged:Iceon)",
            "bpm": 160,
            "imageName": "02990ac0368e32ddc26cf24e1789bc1c0f39639bfceb8aa9d8e8e407773a2b32",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 55,
                        "hold": 7,
                        "slide": 2,
                        "touch": 6,
                        "break": 2,
                        "total": 72
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10536,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 148,
                        "hold": 13,
                        "slide": 12,
                        "touch": 10,
                        "break": 8,
                        "total": 191
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10536,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 46,
                        "slide": 22,
                        "touch": 12,
                        "break": 12,
                        "total": 280
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10536,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 245,
                        "hold": 42,
                        "slide": 45,
                        "touch": 93,
                        "break": 8,
                        "total": 433
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10536,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.6,
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL": 12.6,
                        "FESTiVAL PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "UNiVERSE PLUS": 12.6
                    },
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 9,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 119
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 536,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 208,
                        "hold": 20,
                        "slide": 10,
                        "touch": null,
                        "break": 2,
                        "total": 240
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 536,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 300,
                        "hold": 18,
                        "slide": 25,
                        "touch": null,
                        "break": 7,
                        "total": 350
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 536,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "mai-Star",
                    "noteCounts": {
                        "tap": 319,
                        "hold": 71,
                        "slide": 64,
                        "touch": null,
                        "break": 11,
                        "total": 465
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 536,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.2
                    },
                    "releaseDate": "2016-06-30"
                }
            ],
            "searchAcronyms": [
                "Tsuki Ni Murakumo Hana Ni Kaze",
                "丛云伴月",
                "丛云华",
                "小五",
                "摇摆阳",
                "月丛云",
                "月丛云华风",
                "月云华风",
                "月从云华风",
                "月映从云花语风",
                "月遇丛云花遇风",
                "月风",
                "闲云遮月清风袭花"
            ]
        },
        {
            "songId": "connecting with you",
            "category": "maimai",
            "title": "connecting with you",
            "artist": "Takahiro Eguchi feat. 三澤秋",
            "bpm": 155,
            "imageName": "11578edbcebea8d46a1c93ebc13c09201591569f27711be37150fafc0755fe9d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 8,
                        "slide": 8,
                        "touch": null,
                        "break": 3,
                        "total": 188
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 529,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 22,
                        "slide": 32,
                        "touch": null,
                        "break": 8,
                        "total": 404
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 529,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 543,
                        "hold": 25,
                        "slide": 61,
                        "touch": null,
                        "break": 3,
                        "total": 632
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 529,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 702,
                        "hold": 32,
                        "slide": 98,
                        "touch": null,
                        "break": 18,
                        "total": 850
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 529,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2016-06-30"
                }
            ],
            "searchAcronyms": [
                "pink挑战",
                "与你连接",
                "连接你"
            ]
        },
        {
            "songId": "高気圧ねこロック",
            "category": "maimai",
            "title": "高気圧ねこロック",
            "artist": "小野隊長とJimmy親分",
            "bpm": 260,
            "imageName": "29b7be1d79205ce0f078235664bb25b1608f64f88f173995987aed956dc45864",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 10,
                        "slide": 10,
                        "touch": null,
                        "break": 11,
                        "total": 231
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 530,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 45,
                        "slide": 23,
                        "touch": null,
                        "break": 18,
                        "total": 424
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 530,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 404,
                        "hold": 79,
                        "slide": 70,
                        "touch": null,
                        "break": 45,
                        "total": 598
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 530,
                    "releaseDate": "2016-06-30"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 743,
                        "hold": 34,
                        "slide": 105,
                        "touch": null,
                        "break": 24,
                        "total": 906
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 530,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.6,
                        "Splash PLUS": 13.6,
                        "UNiVERSE": 13.6,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2016-06-30"
                }
            ],
            "searchAcronyms": [
                "anticyclone",
                "Anticyclone Cat Rock",
                "Koukiatsu Neko Rock",
                "Koukiatsu Rock",
                "高气压",
                "高气压猫",
                "高气压猫摇滚",
                "高气压猫猫头",
                "高血压",
                "高血压流汗黄豆"
            ]
        },
        {
            "songId": "パーフェクト生命",
            "category": "niconico＆ボーカロイド",
            "title": "パーフェクト生命",
            "artist": "ナユタン星人",
            "bpm": 200,
            "imageName": "a990633a58e1c73db8eef051aeca1469d2fccdca100019dfc29da357a623e326",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 14,
                        "slide": 8,
                        "touch": null,
                        "break": 14,
                        "total": 313
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 511,
                    "releaseDate": "2016-07-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 424,
                        "hold": 24,
                        "slide": 5,
                        "touch": null,
                        "break": 10,
                        "total": 463
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 511,
                    "releaseDate": "2016-07-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 467,
                        "hold": 74,
                        "slide": 45,
                        "touch": null,
                        "break": 20,
                        "total": 606
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 511,
                    "releaseDate": "2016-07-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 730,
                        "hold": 11,
                        "slide": 151,
                        "touch": null,
                        "break": 25,
                        "total": 917
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 511,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2016-07-14"
                }
            ],
            "searchAcronyms": [
                "Perfect Life",
                "完美生命",
                "生命"
            ]
        },
        {
            "songId": "Infantoon Fantasy",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Infantoon Fantasy",
            "artist": "t+pazolite",
            "bpm": 185,
            "imageName": "16f4b6e85bc402950c794060204267492c7b1cc271cd46ef71f38c8e82288a4e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 270,
                        "hold": 20,
                        "slide": 10,
                        "touch": null,
                        "break": 8,
                        "total": 308
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 490,
                    "releaseDate": "2016-07-28"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 40,
                        "slide": 31,
                        "touch": null,
                        "break": 12,
                        "total": 418
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 490,
                    "releaseDate": "2016-07-28"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 511,
                        "hold": 33,
                        "slide": 83,
                        "touch": null,
                        "break": 8,
                        "total": 635
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 490,
                    "releaseDate": "2016-07-28"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 840,
                        "hold": 25,
                        "slide": 128,
                        "touch": null,
                        "break": 46,
                        "total": 1039
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 490,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.3
                    },
                    "releaseDate": "2016-07-28"
                }
            ],
            "searchAcronyms": [
                "🖕",
                "if",
                "两茄子",
                "中指机器人",
                "竖中指",
                "竖中指机器人",
                "舞萌打卡活动"
            ]
        },
        {
            "songId": "洗脳",
            "category": "maimai",
            "title": "洗脳",
            "artist": "ゆりん・柿チョコ×Neru",
            "bpm": 125,
            "imageName": "42a34325108104e045ba061d4d478a16d1a8cdc6ba77ed89bd679d4ca6e19af5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 170,
                        "hold": 20,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 200
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 532,
                    "releaseDate": "2016-07-28"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 236,
                        "hold": 26,
                        "slide": 22,
                        "touch": null,
                        "break": 4,
                        "total": 288
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 532,
                    "releaseDate": "2016-07-28"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 372,
                        "hold": 33,
                        "slide": 48,
                        "touch": null,
                        "break": 8,
                        "total": 461
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 532,
                    "releaseDate": "2016-07-28"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 516,
                        "hold": 47,
                        "slide": 72,
                        "touch": null,
                        "break": 9,
                        "total": 644
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 532,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2016-07-28"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 653,
                        "hold": 63,
                        "slide": 52,
                        "touch": null,
                        "break": 9,
                        "total": 777
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 532,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.4,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2016-07-28"
                }
            ],
            "searchAcronyms": [
                "Sennou",
                "拖鞋",
                "洗脑"
            ]
        },
        {
            "songId": "Contrapasso -paradiso-",
            "category": "maimai",
            "title": "Contrapasso -paradiso-",
            "artist": "t+pazolite",
            "bpm": 243,
            "imageName": "727ef246ec32c604d22d9358f358194ddfd8dc44f87de2e77bcaee8e7db96448",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 266,
                        "hold": 12,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 287
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 431,
                    "releaseDate": "2016-07-28"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 436,
                        "hold": 16,
                        "slide": 32,
                        "touch": null,
                        "break": 9,
                        "total": 493
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 431,
                    "releaseDate": "2016-07-28"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 665,
                        "hold": 26,
                        "slide": 48,
                        "touch": null,
                        "break": 12,
                        "total": 751
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 431,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 13.1
                    },
                    "releaseDate": "2016-07-28"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 776,
                        "hold": 24,
                        "slide": 209,
                        "touch": null,
                        "break": 15,
                        "total": 1024
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 431,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "Splash": 14.4,
                        "Splash PLUS": 14.4,
                        "UNiVERSE": 14.4,
                        "UNiVERSE PLUS": 14.4,
                        "maimaiでらっくす PLUS": 14.4
                    },
                    "releaseDate": "2016-07-28"
                }
            ],
            "searchAcronyms": [
                "⚙️",
                "⚙",
                "cp",
                "ctps",
                "天堂",
                "天堂齿轮",
                "齿轮",
                "齿轮天堂"
            ]
        },
        {
            "songId": "東京リアルワールド",
            "category": "niconico＆ボーカロイド",
            "title": "東京リアルワールド",
            "artist": "out of service",
            "bpm": 150,
            "imageName": "e4b6e1ffcd5cee99aee5862ac11b23dca12a022d931a10ec100b93804af3123a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 17,
                        "slide": 6,
                        "touch": null,
                        "break": 8,
                        "total": 227
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 517,
                    "releaseDate": "2016-08-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 320,
                        "hold": 16,
                        "slide": 17,
                        "touch": null,
                        "break": 16,
                        "total": 369
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 517,
                    "releaseDate": "2016-08-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 396,
                        "hold": 22,
                        "slide": 41,
                        "touch": null,
                        "break": 13,
                        "total": 472
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 517,
                    "releaseDate": "2016-08-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 476,
                        "hold": 27,
                        "slide": 122,
                        "touch": null,
                        "break": 16,
                        "total": 641
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 517,
                    "releaseDate": "2016-08-11"
                }
            ],
            "searchAcronyms": [
                "🗼",
                "东京",
                "东京real world",
                "东京塔",
                "东京现充世界",
                "东京现实世界",
                "东京铁塔",
                "塔"
            ]
        },
        {
            "songId": "しんでしまうとはなさけない！",
            "category": "niconico＆ボーカロイド",
            "title": "しんでしまうとはなさけない！",
            "artist": "ワンダフル☆オポチュニティ！",
            "bpm": 174,
            "imageName": "cae2b0063a3975f8d39984a18425cd1a9f8387f648e3fa8d579a509a983a8da4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 9,
                        "total": 247
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 523,
                    "releaseDate": "2016-08-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 12,
                        "slide": 13,
                        "touch": null,
                        "break": 6,
                        "total": 342
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 523,
                    "releaseDate": "2016-08-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 416,
                        "hold": 33,
                        "slide": 51,
                        "touch": null,
                        "break": 26,
                        "total": 526
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 523,
                    "releaseDate": "2016-08-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 588,
                        "hold": 68,
                        "slide": 70,
                        "touch": null,
                        "break": 28,
                        "total": 754
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 523,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.4,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2016-08-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Jumble Rumble",
            "category": "maimai",
            "title": "Jumble Rumble",
            "artist": "INNOCENT NOIZE",
            "bpm": 185,
            "imageName": "3d1dd1b634ddf49d00640eb849746896c9b3dc38954b3aa0e90cf6840f194a1d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 274,
                        "hold": 8,
                        "slide": 8,
                        "touch": null,
                        "break": 5,
                        "total": 295
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 492,
                    "releaseDate": "2016-08-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 415,
                        "hold": 21,
                        "slide": 13,
                        "touch": null,
                        "break": 8,
                        "total": 457
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 492,
                    "releaseDate": "2016-08-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 595,
                        "hold": 22,
                        "slide": 70,
                        "touch": null,
                        "break": 15,
                        "total": 702
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 492,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2016-08-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 949,
                        "hold": 9,
                        "slide": 90,
                        "touch": null,
                        "break": 33,
                        "total": 1081
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 492,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2016-08-25"
                }
            ],
            "searchAcronyms": [
                "dj猫",
                "dj鼠",
                "jr",
                "几把",
                "几把乱报",
                "几把乱爆",
                "几把乱蹦",
                "小豆泽心羽",
                "打碟猫",
                "早苗叠",
                "猫打碟",
                "猫猫打碟",
                "魔法猫咪"
            ]
        },
        {
            "songId": "Hand in Hand",
            "category": "niconico＆ボーカロイド",
            "title": "Hand in Hand",
            "artist": "livetune",
            "bpm": 128,
            "imageName": "44d678f9502dae022c55a853ab90f0f5ccd8e8c0083a37347c2208fc71845a29",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 18,
                        "slide": 1,
                        "touch": null,
                        "break": 4,
                        "total": 169
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 524,
                    "releaseDate": "2016-08-31"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 13,
                        "slide": 2,
                        "touch": null,
                        "break": 6,
                        "total": 260
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 524,
                    "releaseDate": "2016-08-31"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 20,
                        "slide": 44,
                        "touch": null,
                        "break": 11,
                        "total": 411
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 524,
                    "releaseDate": "2016-08-31"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 441,
                        "hold": 21,
                        "slide": 110,
                        "touch": null,
                        "break": 18,
                        "total": 590
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 524,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.3
                    },
                    "releaseDate": "2016-08-31"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "クノイチでも恋がしたい",
            "category": "niconico＆ボーカロイド",
            "title": "クノイチでも恋がしたい",
            "artist": "みきとP",
            "bpm": 185,
            "imageName": "e53898b3182d230dfc8195f30da81bc7855493e43f7f1f37efe67f126fbff7b3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 225,
                        "hold": 21,
                        "slide": 10,
                        "touch": null,
                        "break": 10,
                        "total": 266
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 515,
                    "releaseDate": "2016-09-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 331,
                        "hold": 10,
                        "slide": 15,
                        "touch": null,
                        "break": 7,
                        "total": 363
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 515,
                    "releaseDate": "2016-09-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "如月 ゆかり",
                    "noteCounts": {
                        "tap": 536,
                        "hold": 32,
                        "slide": 34,
                        "touch": null,
                        "break": 24,
                        "total": 626
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 515,
                    "releaseDate": "2016-09-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 678,
                        "hold": 9,
                        "slide": 148,
                        "touch": null,
                        "break": 20,
                        "total": 855
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 515,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2016-09-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Barbed Eye",
            "category": "maimai",
            "title": "Barbed Eye",
            "artist": "柿チョコ×みきとP",
            "bpm": 135,
            "imageName": "c9ac7c388d5f1fdf7ec68dbd71c0b5bcd64f04d6b4aeb033788d06984ed682c2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 21,
                        "slide": 6,
                        "touch": null,
                        "break": 3,
                        "total": 233
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 533,
                    "releaseDate": "2016-09-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 281,
                        "hold": 20,
                        "slide": 20,
                        "touch": null,
                        "break": 10,
                        "total": 331
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 533,
                    "releaseDate": "2016-09-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 367,
                        "hold": 68,
                        "slide": 68,
                        "touch": null,
                        "break": 14,
                        "total": 517
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 533,
                    "releaseDate": "2016-09-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 671,
                        "hold": 42,
                        "slide": 70,
                        "touch": null,
                        "break": 24,
                        "total": 807
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 533,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2016-09-08"
                }
            ],
            "searchAcronyms": [
                "坏眼",
                "狗谷爱"
            ]
        },
        {
            "songId": "セハガガガンバッちゃう！！",
            "category": "POPS＆アニメ",
            "title": "セハガガガンバッちゃう！！",
            "artist": "Hi☆sCoool! セハガール",
            "bpm": 202,
            "imageName": "6f828d0113564efb3e48789ba30e8ad4eea338f2b6c9a34ef5398953455b2b6c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 198,
                        "hold": 29,
                        "slide": 8,
                        "touch": null,
                        "break": 9,
                        "total": 244
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 506,
                    "releaseDate": "2016-09-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 15,
                        "slide": 16,
                        "touch": null,
                        "break": 17,
                        "total": 378
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 506,
                    "releaseDate": "2016-09-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 452,
                        "hold": 32,
                        "slide": 43,
                        "touch": null,
                        "break": 80,
                        "total": 607
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 506,
                    "releaseDate": "2016-09-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 412,
                        "hold": 12,
                        "slide": 222,
                        "touch": null,
                        "break": 89,
                        "total": 735
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 506,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2016-09-22"
                }
            ],
            "searchAcronyms": [
                "SEHA GA GA GANBATCHAU",
                "世嘉硬件女孩"
            ]
        },
        {
            "songId": "brilliant better",
            "category": "オンゲキ＆CHUNITHM",
            "title": "brilliant better",
            "artist": "御形 アリシアナ(CV:福原 綾香)",
            "bpm": 172,
            "imageName": "9e1ac449a1b26d19405f1b4894ceaf819755d2bf3a55848db15a70de8f76d7f6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 12,
                        "slide": 8,
                        "touch": null,
                        "break": 9,
                        "total": 228
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 526,
                    "releaseDate": "2016-09-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 12,
                        "slide": 13,
                        "touch": null,
                        "break": 6,
                        "total": 395
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 526,
                    "releaseDate": "2016-09-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 486,
                        "hold": 46,
                        "slide": 52,
                        "touch": null,
                        "break": 11,
                        "total": 595
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 526,
                    "releaseDate": "2016-09-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 616,
                        "hold": 21,
                        "slide": 167,
                        "touch": null,
                        "break": 36,
                        "total": 840
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 526,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2016-09-22"
                }
            ],
            "searchAcronyms": [
                "bb",
                "更精彩",
                "黄色吉他"
            ]
        },
        {
            "songId": "Hyper Active",
            "category": "maimai",
            "title": "Hyper Active",
            "artist": "HiTECH NINJA",
            "bpm": 160,
            "imageName": "20bc969e64d51f333c633d4f0adb2424ea051609b33aef771432b53bffa4a70e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 25,
                        "slide": 11,
                        "touch": null,
                        "break": 6,
                        "total": 292
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 495,
                    "releaseDate": "2016-09-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 392,
                        "hold": 32,
                        "slide": 13,
                        "touch": null,
                        "break": 8,
                        "total": 445
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 495,
                    "releaseDate": "2016-09-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 442,
                        "hold": 150,
                        "slide": 54,
                        "touch": null,
                        "break": 14,
                        "total": 660
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 495,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2016-09-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 859,
                        "hold": 78,
                        "slide": 105,
                        "touch": null,
                        "break": 22,
                        "total": 1064
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 495,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2016-09-22"
                }
            ],
            "searchAcronyms": [
                "卡车",
                "小黄车",
                "撞大运",
                "擎天柱",
                "泥头车",
                "黄卡车"
            ]
        },
        {
            "songId": "No Routine",
            "category": "東方Project",
            "title": "No Routine",
            "artist": "A-One",
            "bpm": 163,
            "imageName": "6d42bc365ac41119acbe4d4c5d451f120e5843378a025d57101423076262ab32",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 198,
                        "hold": 30,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 236
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 537,
                    "releaseDate": "2016-10-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 303,
                        "hold": 14,
                        "slide": 14,
                        "touch": null,
                        "break": 8,
                        "total": 339
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 537,
                    "releaseDate": "2016-10-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 334,
                        "hold": 44,
                        "slide": 80,
                        "touch": null,
                        "break": 10,
                        "total": 468
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 537,
                    "releaseDate": "2016-10-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 756,
                        "hold": 12,
                        "slide": 59,
                        "touch": null,
                        "break": 26,
                        "total": 853
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 537,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2016-10-06"
                }
            ],
            "searchAcronyms": [
                "三梦奇缘",
                "东方龙",
                "没有日常",
                "绿色女人",
                "龙女"
            ]
        },
        {
            "songId": "ひれ伏せ愚民どもっ！",
            "category": "東方Project",
            "title": "ひれ伏せ愚民どもっ！",
            "artist": "ARM＋夕野ヨシミ (IOSYS) feat.miko",
            "bpm": 180,
            "imageName": "011f3a9209934d38943b5ab5be8a8053bdd878d57743ed89ce5a3678ed9c9b38",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 12,
                        "slide": 8,
                        "touch": null,
                        "break": 2,
                        "total": 219
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 538,
                    "releaseDate": "2016-10-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 291,
                        "hold": 21,
                        "slide": 38,
                        "touch": null,
                        "break": 8,
                        "total": 358
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 538,
                    "releaseDate": "2016-10-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 483,
                        "hold": 20,
                        "slide": 29,
                        "touch": null,
                        "break": 10,
                        "total": 542
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 538,
                    "releaseDate": "2016-10-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 552,
                        "hold": 18,
                        "slide": 176,
                        "touch": null,
                        "break": 34,
                        "total": 780
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 538,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2016-10-06"
                }
            ],
            "searchAcronyms": [
                "Hirefuse Gumin-domo!",
                "佩恩",
                "愚民"
            ]
        },
        {
            "songId": "エテルニタス・ルドロジー",
            "category": "東方Project",
            "title": "エテルニタス・ルドロジー",
            "artist": "IRON ATTACK!",
            "bpm": 178,
            "imageName": "f98296c9b7b7d2bb2f2404af959e7fc004baa9f94e51c04ad91847780d77688f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 215,
                        "hold": 9,
                        "slide": 10,
                        "touch": null,
                        "break": 6,
                        "total": 240
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 539,
                    "releaseDate": "2016-10-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 24,
                        "slide": 10,
                        "touch": null,
                        "break": 4,
                        "total": 390
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 539,
                    "releaseDate": "2016-10-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 427,
                        "hold": 59,
                        "slide": 40,
                        "touch": null,
                        "break": 8,
                        "total": 534
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 539,
                    "releaseDate": "2016-10-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 660,
                        "hold": 42,
                        "slide": 110,
                        "touch": null,
                        "break": 16,
                        "total": 828
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 539,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.4,
                        "Splash PLUS": 13.4,
                        "UNiVERSE": 13.4,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.2
                    },
                    "releaseDate": "2016-10-06"
                }
            ],
            "searchAcronyms": [
                "~AETERNITAS LUDOLOGY~",
                "eternitas ludology",
                "东方鼓动",
                "八云紫"
            ]
        },
        {
            "songId": "Nitrous Fury",
            "category": "maimai",
            "title": "Nitrous Fury",
            "artist": "Jun Senoue",
            "bpm": 144,
            "imageName": "ef0ae9eec38afca70964cbab7edbd9c18281cd1c98dbe32cc7f105a46df54cac",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 148,
                        "hold": 42,
                        "slide": 4,
                        "touch": null,
                        "break": 7,
                        "total": 201
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 534,
                    "releaseDate": "2016-10-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 309,
                        "hold": 24,
                        "slide": 7,
                        "touch": null,
                        "break": 6,
                        "total": 346
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 534,
                    "releaseDate": "2016-10-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 462,
                        "hold": 42,
                        "slide": 42,
                        "touch": null,
                        "break": 7,
                        "total": 553
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 534,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2016-10-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 739,
                        "hold": 6,
                        "slide": 2,
                        "touch": null,
                        "break": 5,
                        "total": 752
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 534,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2016-10-14"
                }
            ],
            "searchAcronyms": [
                "nf",
                "你创死福瑞",
                "你戳死福瑞",
                "你臭死福瑞",
                "架子鼓",
                "氮气狂怒",
                "氮气福瑞"
            ]
        },
        {
            "songId": "CITRUS MONSTER",
            "category": "maimai",
            "title": "CITRUS MONSTER",
            "artist": "D-Cee",
            "bpm": 220,
            "imageName": "e0d4065eac9bda002310933ad04e3378e141fda3ddf5fd70f1d2a0b8f694d9b4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 281,
                        "hold": 18,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 308
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 494,
                    "releaseDate": "2016-10-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 394,
                        "hold": 25,
                        "slide": 9,
                        "touch": null,
                        "break": 4,
                        "total": 432
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 494,
                    "releaseDate": "2016-10-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 499,
                        "hold": 73,
                        "slide": 52,
                        "touch": null,
                        "break": 24,
                        "total": 648
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 494,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2016-10-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 817,
                        "hold": 48,
                        "slide": 122,
                        "touch": null,
                        "break": 45,
                        "total": 1032
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 494,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "Splash": 14.5,
                        "Splash PLUS": 14.5,
                        "UNiVERSE": 14.5,
                        "UNiVERSE PLUS": 14.5,
                        "maimaiでらっくす PLUS": 14.3
                    },
                    "releaseDate": "2016-10-20"
                }
            ],
            "searchAcronyms": [
                "🍊",
                "citrus",
                "cm",
                "橘子怪兽"
            ]
        },
        {
            "songId": "ハート・ビート",
            "category": "オンゲキ＆CHUNITHM",
            "title": "ハート・ビート",
            "artist": "明坂 芹菜(CV:新田 恵海)",
            "bpm": 212,
            "imageName": "14e99ce9db764916c1fbba21caf99af74bbd2dedf1722fba2cfa936148130d99",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 269,
                        "hold": 23,
                        "slide": 2,
                        "touch": null,
                        "break": 4,
                        "total": 298
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 527,
                    "releaseDate": "2016-11-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 377,
                        "hold": 24,
                        "slide": 26,
                        "touch": null,
                        "break": 15,
                        "total": 442
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 527,
                    "releaseDate": "2016-11-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 577,
                        "hold": 57,
                        "slide": 51,
                        "touch": null,
                        "break": 14,
                        "total": 699
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 527,
                    "releaseDate": "2016-11-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 613,
                        "hold": 36,
                        "slide": 148,
                        "touch": null,
                        "break": 21,
                        "total": 818
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 527,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2016-11-04"
                }
            ],
            "searchAcronyms": [
                "heart beat",
                "heart・beat",
                "serina",
                "心跳",
                "心跳2"
            ]
        },
        {
            "songId": "終わりなき物語",
            "category": "ゲーム＆バラエティ",
            "title": "終わりなき物語",
            "artist": "クーナ(CV 喜多村英梨)「PHANTASY STAR ONLINE 2」",
            "bpm": 150,
            "imageName": "5f8b8fc4f833cac2358cc20f8ede151e261ea8f0d91d28f8ce81fd71ef9f1408",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 18,
                        "slide": 3,
                        "touch": null,
                        "break": 5,
                        "total": 201
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 543,
                    "releaseDate": "2016-11-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 23,
                        "slide": 10,
                        "touch": null,
                        "break": 14,
                        "total": 325
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 543,
                    "releaseDate": "2016-11-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 279,
                        "hold": 49,
                        "slide": 46,
                        "touch": null,
                        "break": 29,
                        "total": 403
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 543,
                    "releaseDate": "2016-11-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 394,
                        "hold": 63,
                        "slide": 114,
                        "touch": null,
                        "break": 13,
                        "total": 584
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 543,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.2,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2016-11-04"
                }
            ],
            "searchAcronyms": [
                "OWARINAKIMONOGATARI",
                "无尽物语",
                "物语",
                "终物语"
            ]
        },
        {
            "songId": "やめろ！聴くな！",
            "category": "niconico＆ボーカロイド",
            "title": "やめろ！聴くな！",
            "artist": "SLAVE.V-V-R",
            "bpm": 160,
            "imageName": "5c446f06edefde13e67fccee055b751f449873e12f4261403c2d5092d1ad07ad",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 14,
                        "slide": 6,
                        "touch": null,
                        "break": 8,
                        "total": 259
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 518,
                    "releaseDate": "2016-11-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 403,
                        "hold": 23,
                        "slide": 17,
                        "touch": null,
                        "break": 6,
                        "total": 449
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 518,
                    "releaseDate": "2016-11-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 373,
                        "hold": 70,
                        "slide": 51,
                        "touch": null,
                        "break": 40,
                        "total": 534
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 518,
                    "releaseDate": "2016-11-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 492,
                        "hold": 87,
                        "slide": 159,
                        "touch": null,
                        "break": 15,
                        "total": 753
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 518,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2016-11-17"
                }
            ],
            "searchAcronyms": [
                "やめろ",
                "别听",
                "听"
            ]
        },
        {
            "songId": "木彫り鯰と右肩ゾンビ",
            "category": "niconico＆ボーカロイド",
            "title": "木彫り鯰と右肩ゾンビ",
            "artist": "hanzo/赤飯歌唱Ver",
            "bpm": 150,
            "imageName": "c8b46d34b0494c2a2a1d5cf4aef8a3241078f35b7d5af9d512dfe8d099cfcb64",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 13,
                        "slide": 11,
                        "touch": null,
                        "break": 11,
                        "total": 298
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 520,
                    "releaseDate": "2016-11-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 14,
                        "slide": 28,
                        "touch": null,
                        "break": 8,
                        "total": 414
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 520,
                    "releaseDate": "2016-11-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 447,
                        "hold": 34,
                        "slide": 52,
                        "touch": null,
                        "break": 11,
                        "total": 544
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 520,
                    "releaseDate": "2016-11-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 710,
                        "hold": 68,
                        "slide": 113,
                        "touch": null,
                        "break": 34,
                        "total": 925
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 520,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.3,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash": 12.9,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2016-11-17"
                }
            ],
            "searchAcronyms": [
                "Kiborinamazu to Migikatazonbi",
                "僵尸",
                "右肩",
                "右肩僵尸",
                "木彫",
                "木雕",
                "木雕鲇鱼",
                "木雕鲶鱼",
                "木鲶鱼",
                "肩周炎",
                "鲷鱼烧"
            ]
        },
        {
            "songId": "ECHO",
            "category": "niconico＆ボーカロイド",
            "title": "ECHO",
            "artist": "CIRCRUSH",
            "bpm": 140,
            "imageName": "bb4bb392d15881d0df1cdb85b9749fcfe2af091d008b1c2afdd6f89b84ea52bc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 10,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 163
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 521,
                    "releaseDate": "2016-11-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 363,
                        "hold": 21,
                        "slide": 40,
                        "touch": null,
                        "break": 2,
                        "total": 426
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 521,
                    "releaseDate": "2016-11-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 421,
                        "hold": 30,
                        "slide": 79,
                        "touch": null,
                        "break": 5,
                        "total": 535
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 521,
                    "releaseDate": "2016-11-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 607,
                        "hold": 30,
                        "slide": 125,
                        "touch": null,
                        "break": 6,
                        "total": 768
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 521,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 13.3
                    },
                    "releaseDate": "2016-11-17"
                }
            ],
            "searchAcronyms": [
                "一口",
                "回声",
                "恶臭",
                "电视头"
            ]
        },
        {
            "songId": "AMAZING MIGHTYYYY!!!!",
            "category": "maimai",
            "title": "AMAZING MIGHTYYYY!!!!",
            "artist": "WAiKURO",
            "bpm": 185,
            "imageName": "de160cdc21de9c124db1c597dbfd8719d1365e2013e70d4a70132d15b3b845c0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 347,
                        "hold": 10,
                        "slide": 8,
                        "touch": null,
                        "break": 9,
                        "total": 374
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 496,
                    "releaseDate": "2016-11-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 496,
                        "hold": 60,
                        "slide": 12,
                        "touch": null,
                        "break": 8,
                        "total": 576
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 496,
                    "releaseDate": "2016-11-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 781,
                        "hold": 36,
                        "slide": 71,
                        "touch": null,
                        "break": 12,
                        "total": 900
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 496,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.6,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.6,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2016-11-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "ぴちネコ vs Jack",
                    "noteCounts": {
                        "tap": 865,
                        "hold": 69,
                        "slide": 151,
                        "touch": null,
                        "break": 41,
                        "total": 1126
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 496,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "FESTiVAL": 14.7,
                        "FESTiVAL PLUS": 14.7,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7,
                        "Splash": 14.7,
                        "Splash PLUS": 14.7,
                        "UNiVERSE": 14.7,
                        "UNiVERSE PLUS": 14.7,
                        "maimaiでらっくす PLUS": 14.6
                    },
                    "releaseDate": "2016-11-17"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 874,
                        "hold": 65,
                        "slide": 162,
                        "touch": null,
                        "break": 38,
                        "total": 1139
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 496,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "Splash": 14.5,
                        "Splash PLUS": 14.5,
                        "UNiVERSE": 14.5,
                        "UNiVERSE PLUS": 14.5,
                        "maimaiでらっくす PLUS": 14.5
                    },
                    "releaseDate": "2018-08-20"
                }
            ],
            "searchAcronyms": [
                "！！！！",
                "am",
                "amazing mighty",
                "amemai",
                "amz",
                "mighty",
                "不可思议的大概概概概",
                "你收个p",
                "啊卖金麦提",
                "屁股发芽",
                "惊异全能",
                "我的妹妹是男的",
                "阿米娅"
            ]
        },
        {
            "songId": "Prophesy One",
            "category": "maimai",
            "title": "Prophesy One",
            "artist": "vox2（小野秀幸）",
            "bpm": 120,
            "imageName": "8e37cad533ffc4b85c31f2b4f5ec651ac1648aef768ec24d28c7a76fe822f574",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 259,
                        "hold": 35,
                        "slide": 6,
                        "touch": null,
                        "break": 7,
                        "total": 307
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 531,
                    "releaseDate": "2016-11-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 399,
                        "hold": 53,
                        "slide": 22,
                        "touch": null,
                        "break": 8,
                        "total": 482
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 531,
                    "releaseDate": "2016-11-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 569,
                        "hold": 27,
                        "slide": 79,
                        "touch": null,
                        "break": 11,
                        "total": 686
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 531,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL PLUS": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2016-11-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 843,
                        "hold": 57,
                        "slide": 162,
                        "touch": null,
                        "break": 6,
                        "total": 1068
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PiNK PLUS",
                    "internalId": 531,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.6,
                        "BUDDiES PLUS": 14.6,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6,
                        "Splash": 14.5,
                        "Splash PLUS": 14.5,
                        "UNiVERSE": 14.5,
                        "UNiVERSE PLUS": 14.5,
                        "maimaiでらっくす PLUS": 14.6
                    },
                    "releaseDate": "2016-11-17"
                }
            ],
            "searchAcronyms": [
                "p1",
                "预言1",
                "预言一"
            ]
        },
        {
            "songId": "ゴーストルール",
            "category": "niconico＆ボーカロイド",
            "title": "ゴーストルール",
            "artist": "DECO*27",
            "bpm": 210,
            "imageName": "5bf267afb9745b2ff03ca85df125bb7ec8ddd8c3736912ab77b4917f13fac740",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 99,
                        "hold": 12,
                        "slide": 2,
                        "touch": 14,
                        "break": 3,
                        "total": 130
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 10552,
                    "releaseDate": "2021-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 36,
                        "slide": 18,
                        "touch": 9,
                        "break": 8,
                        "total": 311
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 10552,
                    "releaseDate": "2021-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 314,
                        "hold": 75,
                        "slide": 15,
                        "touch": 51,
                        "break": 53,
                        "total": 508
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 10552,
                    "releaseDate": "2021-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 444,
                        "hold": 75,
                        "slide": 106,
                        "touch": 30,
                        "break": 18,
                        "total": 673
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 10552,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "UNiVERSE": 12.9
                    },
                    "releaseDate": "2021-09-15"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 9,
                        "slide": 10,
                        "touch": null,
                        "break": 4,
                        "total": 223
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 552,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 53,
                        "slide": 26,
                        "touch": null,
                        "break": 8,
                        "total": 384
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 552,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "畳返し",
                    "noteCounts": {
                        "tap": 428,
                        "hold": 70,
                        "slide": 12,
                        "touch": null,
                        "break": 21,
                        "total": 531
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 552,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "しろいろ",
                    "noteCounts": {
                        "tap": 501,
                        "hold": 36,
                        "slide": 138,
                        "touch": null,
                        "break": 14,
                        "total": 689
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 552,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.5,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2016-12-15"
                }
            ],
            "searchAcronyms": [
                "👻",
                "dx幽灵法则",
                "ghost rule",
                "Ghost Rule",
                "小吹爆",
                "幽灵",
                "幽灵法则",
                "露露小姐"
            ]
        },
        {
            "songId": "Last Brave ～ Go to zero",
            "category": "ゲーム＆バラエティ",
            "title": "Last Brave ～ Go to zero",
            "artist": "MECHANiCAL PANDA「BORDER BREAK」",
            "bpm": 132,
            "imageName": "cd235919e56726f19aa8b3f0c83c0edec7aed98486d3d947908184d36e48466c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 225,
                        "hold": 15,
                        "slide": 2,
                        "touch": null,
                        "break": 5,
                        "total": 247
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 557,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 367,
                        "hold": 24,
                        "slide": 12,
                        "touch": null,
                        "break": 8,
                        "total": 411
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 557,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 442,
                        "hold": 58,
                        "slide": 55,
                        "touch": null,
                        "break": 30,
                        "total": 585
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 557,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 668,
                        "hold": 45,
                        "slide": 106,
                        "touch": null,
                        "break": 22,
                        "total": 841
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 557,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.3
                    },
                    "releaseDate": "2016-12-15"
                }
            ],
            "searchAcronyms": [
                "BT",
                "最后勇敢变成0",
                "勇敢变成0",
                "去做0",
                "去找0",
                "变成0",
                "我们去做0",
                "机甲",
                "走向0"
            ]
        },
        {
            "songId": "STAIRWAY TO GENERATION",
            "category": "ゲーム＆バラエティ",
            "title": "STAIRWAY TO GENERATION",
            "artist": "Yosh(Survive Said The Prophet)",
            "bpm": 150,
            "imageName": "963308835202e74e2daf0f60366fe6ff13307eeaca062d4e2d834a396b9f3bb9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 14,
                        "slide": 8,
                        "touch": null,
                        "break": 2,
                        "total": 218
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 558,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 30,
                        "slide": 18,
                        "touch": null,
                        "break": 6,
                        "total": 317
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 558,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 341,
                        "hold": 38,
                        "slide": 64,
                        "touch": null,
                        "break": 14,
                        "total": 457
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 558,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 511,
                        "hold": 129,
                        "slide": 23,
                        "touch": null,
                        "break": 21,
                        "total": 684
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 558,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2016-12-15"
                }
            ],
            "searchAcronyms": [
                "stairway",
                "一片绿",
                "八块钱"
            ]
        },
        {
            "songId": "空威張りビヘイビア",
            "category": "maimai",
            "title": "空威張りビヘイビア",
            "artist": "un:c・ろん×じーざすP",
            "bpm": 186,
            "imageName": "743519e4d801361ee4e84a4641943211d1a2d880e071a87520812b4c7e4f57ce",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 245,
                        "hold": 20,
                        "slide": 7,
                        "touch": null,
                        "break": 3,
                        "total": 275
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 559,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 24,
                        "slide": 19,
                        "touch": null,
                        "break": 14,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 559,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 445,
                        "hold": 54,
                        "slide": 50,
                        "touch": null,
                        "break": 24,
                        "total": 573
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 559,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Revo@LC vs Jack",
                    "noteCounts": {
                        "tap": 693,
                        "hold": 25,
                        "slide": 149,
                        "touch": null,
                        "break": 20,
                        "total": 887
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 559,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.5,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13.2
                    },
                    "releaseDate": "2016-12-15"
                }
            ],
            "searchAcronyms": [
                "brash behavior",
                "空威张"
            ]
        },
        {
            "songId": "回レ！雪月花",
            "category": "POPS＆アニメ",
            "title": "回レ！雪月花",
            "artist": "歌組雪月花 夜々(原田ひとみ)/いろり(茅野愛衣)/小紫(小倉唯)「機巧少女は傷つかない」",
            "bpm": 160,
            "imageName": "25d65b9003eb69c0fba381379163178fa372fae1c3dc1e24c18bd557cd2e1766",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 99,
                        "hold": 2,
                        "slide": 2,
                        "touch": 11,
                        "break": 2,
                        "total": 116
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10560,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 168,
                        "hold": 28,
                        "slide": 3,
                        "touch": 21,
                        "break": 10,
                        "total": 230
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10560,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 24,
                        "slide": 30,
                        "touch": 16,
                        "break": 10,
                        "total": 364
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10560,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 452,
                        "hold": 27,
                        "slide": 36,
                        "touch": 128,
                        "break": 7,
                        "total": 650
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10560,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 6,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 169
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 560,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 20,
                        "slide": 7,
                        "touch": null,
                        "break": 12,
                        "total": 271
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 560,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 316,
                        "hold": 24,
                        "slide": 34,
                        "touch": null,
                        "break": 12,
                        "total": 386
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 560,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 555,
                        "hold": 30,
                        "slide": 41,
                        "touch": null,
                        "break": 39,
                        "total": 665
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 560,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2016-12-15"
                }
            ],
            "searchAcronyms": [
                "maware",
                "Maware! setsugetsuka"
            ]
        },
        {
            "songId": "taboo tears you up",
            "category": "東方Project",
            "title": "taboo tears you up",
            "artist": "REDALiCE (HARDCORE TANO*C)",
            "bpm": 180,
            "imageName": "2fe8d728170449954eda9c3fd693da304173b13f98f9f863971f41a5a3fa1fb9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 98,
                        "hold": 20,
                        "slide": 4,
                        "touch": 16,
                        "break": 4,
                        "total": 142
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 10602,
                    "releaseDate": "2021-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 294,
                        "hold": 17,
                        "slide": 23,
                        "touch": 28,
                        "break": 11,
                        "total": 373
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 10602,
                    "releaseDate": "2021-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 378,
                        "hold": 62,
                        "slide": 28,
                        "touch": 26,
                        "break": 7,
                        "total": 501
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 10602,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 10.8
                    },
                    "releaseDate": "2021-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 651,
                        "hold": 106,
                        "slide": 95,
                        "touch": 52,
                        "break": 33,
                        "total": 937
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 10602,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2021-09-15"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 25,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 273
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 602,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 23,
                        "slide": 13,
                        "touch": null,
                        "break": 13,
                        "total": 367
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 602,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 420,
                        "hold": 50,
                        "slide": 55,
                        "touch": null,
                        "break": 20,
                        "total": 545
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 602,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "如月 ゆかり",
                    "noteCounts": {
                        "tap": 719,
                        "hold": 44,
                        "slide": 137,
                        "touch": null,
                        "break": 37,
                        "total": 937
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 602,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12
                    },
                    "releaseDate": "2016-12-15"
                }
            ],
            "searchAcronyms": [
                "dx淘宝",
                "dx禁忌将你撕裂",
                "taboo",
                "三倍icecream",
                "淘宝",
                "滔搏",
                "禁忌将你撕裂"
            ]
        },
        {
            "songId": "夜明けまであと３秒",
            "category": "ゲーム＆バラエティ",
            "title": "夜明けまであと３秒",
            "artist": "BNSI（Taku Inoue）「シンクロニカ」より",
            "bpm": 182,
            "imageName": "c4e9659c35af5808206655cdb71440ac24bc419d7e7246240ff3b1405dc67f52",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 260,
                        "hold": 10,
                        "slide": 7,
                        "touch": null,
                        "break": 2,
                        "total": 279
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 556,
                    "releaseDate": "2016-12-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 453,
                        "hold": 38,
                        "slide": 11,
                        "touch": null,
                        "break": 11,
                        "total": 513
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 556,
                    "releaseDate": "2016-12-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 399,
                        "hold": 101,
                        "slide": 33,
                        "touch": null,
                        "break": 22,
                        "total": 555
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 556,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.1,
                        "Splash": 12.6,
                        "UNiVERSE PLUS": 13.1
                    },
                    "releaseDate": "2016-12-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 733,
                        "hold": 123,
                        "slide": 81,
                        "touch": null,
                        "break": 25,
                        "total": 962
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 556,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2016-12-05"
                }
            ],
            "searchAcronyms": [
                "3秒",
                "三秒",
                "夜明",
                "夜明3秒",
                "夜明三秒",
                "天亮的前三秒",
                "失明前三秒",
                "距离黎明还有三秒",
                "黎明的前三秒"
            ]
        },
        {
            "songId": "色は匂へど散りぬるを",
            "category": "東方Project",
            "title": "色は匂へど散りぬるを",
            "artist": "幽閉サテライト(Produce:嵯峨飛鳥 Arranged:Iceon)",
            "bpm": 138,
            "imageName": "abc25cad0f616e69af4a28ce49403566b107fc76de7c894c4b45232d42fa6e03",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 10,
                        "slide": 6,
                        "touch": 7,
                        "break": 4,
                        "total": 154
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10535,
                    "releaseDate": "2023-11-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 178,
                        "hold": 14,
                        "slide": 10,
                        "touch": 24,
                        "break": 2,
                        "total": 228
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10535,
                    "releaseDate": "2023-11-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 54,
                        "slide": 32,
                        "touch": 16,
                        "break": 23,
                        "total": 311
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10535,
                    "releaseDate": "2023-11-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 36,
                        "slide": 75,
                        "touch": 42,
                        "break": 15,
                        "total": 426
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 10535,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2023-11-23"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 22,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 535,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 14,
                        "slide": 26,
                        "touch": null,
                        "break": 4,
                        "total": 284
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 535,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 206,
                        "hold": 39,
                        "slide": 60,
                        "touch": null,
                        "break": 16,
                        "total": 321
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 535,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 448,
                        "hold": 13,
                        "slide": 105,
                        "touch": null,
                        "break": 7,
                        "total": 573
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 535,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2016-12-15"
                }
            ],
            "searchAcronyms": [
                "Iro Ha Nioedo Chirinuruwo",
                "三个老婆",
                "伊洛瓦",
                "老年人活动中心",
                "色散",
                "花开艳丽终散落",
                "花朵艳丽终会散落"
            ]
        },
        {
            "songId": "すーぱーぬこになりたい",
            "category": "niconico＆ボーカロイド",
            "title": "すーぱーぬこになりたい",
            "artist": "まふまふ",
            "bpm": 194,
            "imageName": "eb4dcf93be89ee33f8018f5ef5a568ce7c80c8057b79de8784e47a6e70e32a77",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 248,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 9,
                        "total": 265
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 598,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 8,
                        "slide": 17,
                        "touch": null,
                        "break": 16,
                        "total": 392
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 598,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 37,
                        "slide": 80,
                        "touch": null,
                        "break": 35,
                        "total": 516
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 598,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 721,
                        "hold": 23,
                        "slide": 117,
                        "touch": null,
                        "break": 36,
                        "total": 897
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 598,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.3,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.6,
                        "maimaiでらっくす PLUS": 13.2
                    },
                    "releaseDate": "2016-12-15"
                }
            ],
            "searchAcronyms": [
                "nuko",
                "变成猫",
                "变超猫",
                "想变成猫",
                "想变猫",
                "想要变成超级猫",
                "想要成为super nuko",
                "想要成为超级猫猫",
                "我想变成猫咪",
                "猫猫",
                "粉猫",
                "超猫"
            ]
        },
        {
            "songId": "いっしそう電☆舞舞神拳！",
            "category": "maimai",
            "title": "いっしそう電☆舞舞神拳！",
            "artist": "さつき が てんこもり feat. YURiCa/花たん",
            "bpm": 185,
            "imageName": "afaf4972933c63f967b237593015babb344fba7c57817d0cef4182a514530df0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 308,
                        "hold": 4,
                        "slide": 6,
                        "touch": null,
                        "break": 8,
                        "total": 326
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 561,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 444,
                        "hold": 18,
                        "slide": 10,
                        "touch": null,
                        "break": 12,
                        "total": 484
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 561,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 539,
                        "hold": 28,
                        "slide": 66,
                        "touch": null,
                        "break": 15,
                        "total": 648
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 561,
                    "releaseDate": "2016-12-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 582,
                        "hold": 27,
                        "slide": 217,
                        "touch": null,
                        "break": 42,
                        "total": 868
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 561,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.1,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2016-12-15"
                }
            ],
            "searchAcronyms": [
                "114514",
                "maimai神拳",
                "一子相传",
                "紫代主题曲",
                "给你一拳",
                "舞舞神拳"
            ]
        },
        {
            "songId": "ゆっくりしていってね！！！",
            "category": "niconico＆ボーカロイド",
            "title": "ゆっくりしていってね！！！",
            "artist": "今日犬",
            "bpm": 221,
            "imageName": "2ee2a7e1a97bd704c53d7a33d86b307fdd470c4284f7e400f9d7b318815e9f92",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 160,
                        "hold": 16,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 184
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 519,
                    "releaseDate": "2017-01-24"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 358,
                        "hold": 28,
                        "slide": 19,
                        "touch": null,
                        "break": 3,
                        "total": 408
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 519,
                    "releaseDate": "2017-01-24"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 437,
                        "hold": 105,
                        "slide": 30,
                        "touch": null,
                        "break": 8,
                        "total": 580
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 519,
                    "releaseDate": "2017-01-24"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 675,
                        "hold": 22,
                        "slide": 80,
                        "touch": null,
                        "break": 20,
                        "total": 797
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 519,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2017-01-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "チュルリラ・チュルリラ・ダッダッダ！",
            "category": "niconico＆ボーカロイド",
            "title": "チュルリラ・チュルリラ・ダッダッダ！",
            "artist": "和田たけあき(くらげP)",
            "bpm": 220,
            "imageName": "5aa1833eff0b847b073299b5a07cf2ba18d942949ef42fbe58980cbbae95160b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 16,
                        "slide": 2,
                        "touch": null,
                        "break": 7,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 553,
                    "releaseDate": "2017-01-24"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 450,
                        "hold": 10,
                        "slide": 3,
                        "touch": null,
                        "break": 12,
                        "total": 475
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 553,
                    "releaseDate": "2017-01-24"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 478,
                        "hold": 74,
                        "slide": 15,
                        "touch": null,
                        "break": 13,
                        "total": 580
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 553,
                    "releaseDate": "2017-01-24"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 610,
                        "hold": 36,
                        "slide": 169,
                        "touch": null,
                        "break": 25,
                        "total": 840
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 553,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2017-01-24"
                }
            ],
            "searchAcronyms": [
                "chururira",
                "Chururira • Chururira • Daddadda!",
                "ddd",
                "jk结月缘",
                "告密老师",
                "告状",
                "告老师",
                "哒哒哒",
                "啾噜哩啦",
                "啾噜哩啦·啾噜哩啦·哒哒哒",
                "啾噜哩啦啾噜哩啦哒哒哒",
                "打小报告",
                "暗杀教室",
                "秋露里拉",
                "结月缘杀人"
            ]
        },
        {
            "songId": "生きてるおばけは生きている",
            "category": "niconico＆ボーカロイド",
            "title": "生きてるおばけは生きている",
            "artist": "鬱P feat.flower",
            "bpm": 140,
            "imageName": "3f2a691a8e7c19a9b700dfd43f4741607b6f1da6f8e71f0d5d429a944de4fa1c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 152,
                        "hold": 30,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 190
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 565,
                    "releaseDate": "2017-01-24"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 294,
                        "hold": 12,
                        "slide": 26,
                        "touch": null,
                        "break": 6,
                        "total": 338
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 565,
                    "releaseDate": "2017-01-24"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 97,
                        "slide": 48,
                        "touch": null,
                        "break": 18,
                        "total": 507
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 565,
                    "releaseDate": "2017-01-24"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 689,
                        "hold": 64,
                        "slide": 60,
                        "touch": null,
                        "break": 16,
                        "total": 829
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 565,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2017-01-24"
                }
            ],
            "searchAcronyms": [
                "坟头蹦迪",
                "欧巴给",
                "活着的怪物会一直活着",
                "生生"
            ]
        },
        {
            "songId": "踊れオーケストラ",
            "category": "niconico＆ボーカロイド",
            "title": "踊れオーケストラ",
            "artist": "YASUHIRO(康寛)",
            "bpm": 180,
            "imageName": "9d6c5dc962e97eba4d04c59f87e5be27cfc030e93f1409eb87dc5fe6fe55d7d7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 198,
                        "hold": 11,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 218
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 599,
                    "releaseDate": "2017-01-24"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 348,
                        "hold": 16,
                        "slide": 10,
                        "touch": null,
                        "break": 8,
                        "total": 382
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 599,
                    "releaseDate": "2017-01-24"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 377,
                        "hold": 18,
                        "slide": 61,
                        "touch": null,
                        "break": 7,
                        "total": 463
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 599,
                    "releaseDate": "2017-01-24"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 490,
                        "hold": 19,
                        "slide": 134,
                        "touch": null,
                        "break": 14,
                        "total": 657
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 599,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2017-01-24"
                }
            ],
            "searchAcronyms": [
                "踊",
                "随管弦乐起舞"
            ]
        },
        {
            "songId": "Our Wrenally",
            "category": "maimai",
            "title": "Our Wrenally",
            "artist": "t+pazolite",
            "bpm": 105,
            "imageName": "2929c99b7452b49d13dfdfc10039d58958bd0b5d8a6ba753bf58d63cdc0727bb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 45,
                        "slide": 4,
                        "touch": null,
                        "break": 10,
                        "total": 277
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 571,
                    "releaseDate": "2017-01-24"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 413,
                        "hold": 24,
                        "slide": 31,
                        "touch": null,
                        "break": 20,
                        "total": 488
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 571,
                    "releaseDate": "2017-01-24"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 457,
                        "hold": 150,
                        "slide": 44,
                        "touch": null,
                        "break": 9,
                        "total": 660
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 571,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2017-01-24"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "原田ひろゆき",
                    "noteCounts": {
                        "tap": 868,
                        "hold": 23,
                        "slide": 99,
                        "touch": null,
                        "break": 9,
                        "total": 999
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 571,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "FESTiVAL": 14.8,
                        "FESTiVAL PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8,
                        "Splash": 14.8,
                        "Splash PLUS": 14.8,
                        "UNiVERSE": 14.8,
                        "UNiVERSE PLUS": 14.8,
                        "maimaiでらっくす PLUS": 14.8
                    },
                    "releaseDate": "2017-01-24"
                }
            ],
            "searchAcronyms": [
                "ow",
                "临兵斗者皆阵列在前",
                "别急9",
                "别急加强版",
                "夏祭",
                "夏祭2",
                "夏祭re:master",
                "守望先锋",
                "急急国王",
                "恐怖奶奶",
                "我们的万人阿里路亚",
                "我把你妈妈抓走",
                "火女孩",
                "白夏祭",
                "里夏祭",
                "高数",
                "高等数学",
                "魔法夏祭",
                "魔法阿妈",
                "魔法阿嫲",
                "魔法阿嬷"
            ]
        },
        {
            "songId": "フォルテシモBELL",
            "category": "オンゲキ＆CHUNITHM",
            "title": "フォルテシモBELL",
            "artist": "天王洲 なずな(CV:山本 彩乃)",
            "bpm": 121,
            "imageName": "16665be4499d98fb1ab68cc4312c81fd59ef73d0031b4ac7faaa4d32120dc9ec",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 153,
                        "hold": 9,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 546,
                    "releaseDate": "2017-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 14,
                        "slide": 20,
                        "touch": null,
                        "break": 8,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 546,
                    "releaseDate": "2017-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 323,
                        "hold": 58,
                        "slide": 41,
                        "touch": null,
                        "break": 18,
                        "total": 440
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 546,
                    "releaseDate": "2017-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 468,
                        "hold": 20,
                        "slide": 92,
                        "touch": null,
                        "break": 15,
                        "total": 595
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 546,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2017-02-07"
                }
            ],
            "searchAcronyms": [
                "bell",
                "fortissimo bell",
                "FORTISSIMO BELL"
            ]
        },
        {
            "songId": "conflict",
            "category": "ゲーム＆バラエティ",
            "title": "conflict",
            "artist": "siromaru + cranky",
            "bpm": 160,
            "imageName": "ad00d95b400d16ac7bdd65b7ab4772051bbd0e4bcd6f4738ab1434901aac6347",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 76,
                        "hold": 9,
                        "slide": 5,
                        "touch": 22,
                        "break": 6,
                        "total": 118
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10593,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 317,
                        "hold": 33,
                        "slide": 3,
                        "touch": 19,
                        "break": 2,
                        "total": 374
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10593,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 42,
                        "slide": 70,
                        "touch": 99,
                        "break": 18,
                        "total": 571
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10593,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 583,
                        "hold": 58,
                        "slide": 65,
                        "touch": 175,
                        "break": 19,
                        "total": 900
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10593,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM PLUS": 13.5,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 27,
                        "slide": 13,
                        "touch": null,
                        "break": 6,
                        "total": 192
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 593,
                    "releaseDate": "2017-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 353,
                        "hold": 36,
                        "slide": 18,
                        "touch": null,
                        "break": 9,
                        "total": 416
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 593,
                    "releaseDate": "2017-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 532,
                        "hold": 86,
                        "slide": 73,
                        "touch": null,
                        "break": 15,
                        "total": 706
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 593,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2017-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 758,
                        "hold": 56,
                        "slide": 125,
                        "touch": null,
                        "break": 9,
                        "total": 948
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 593,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14.1,
                        "FESTiVAL PLUS": 14.1,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "Splash": 14.1,
                        "Splash PLUS": 14.1,
                        "UNiVERSE": 14.1,
                        "UNiVERSE PLUS": 14.1,
                        "maimaiでらっくす PLUS": 14
                    },
                    "releaseDate": "2017-02-07"
                }
            ],
            "searchAcronyms": [
                "🚌",
                "bus",
                "dx公交车",
                "公交车",
                "冲突",
                "标准公交车"
            ]
        },
        {
            "songId": "DETARAME ROCK&ROLL THEORY",
            "category": "オンゲキ＆CHUNITHM",
            "title": "DETARAME ROCK&ROLL THEORY",
            "artist": "箱部 なる(CV:M・A・O)",
            "bpm": 140,
            "imageName": "04508ef78d4330becb15d7ec4bf4d3d54fad1cd32a9f42ce983337f398f84b30",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 204,
                        "hold": 8,
                        "slide": 2,
                        "touch": null,
                        "break": 3,
                        "total": 217
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 548,
                    "releaseDate": "2017-02-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 369,
                        "hold": 23,
                        "slide": 18,
                        "touch": null,
                        "break": 18,
                        "total": 428
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 548,
                    "releaseDate": "2017-02-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 459,
                        "hold": 117,
                        "slide": 15,
                        "touch": null,
                        "break": 28,
                        "total": 619
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 548,
                    "releaseDate": "2017-02-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 600,
                        "hold": 46,
                        "slide": 145,
                        "touch": null,
                        "break": 22,
                        "total": 813
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 548,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2017-02-14"
                }
            ],
            "searchAcronyms": [
                "8787",
                "detarame",
                "DRRT",
                "drt",
                "摇滚理论"
            ]
        },
        {
            "songId": "Sakura Fubuki",
            "category": "ゲーム＆バラエティ",
            "title": "Sakura Fubuki",
            "artist": "Street",
            "bpm": 175,
            "imageName": "778e01f4f6233d669f2da94360474f4b872132162cfbbf1ae94777c328c394ef",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 158,
                        "hold": 6,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 174
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 592,
                    "releaseDate": "2017-02-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 6,
                        "slide": 20,
                        "touch": null,
                        "break": 8,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 592,
                    "releaseDate": "2017-02-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 58,
                        "slide": 35,
                        "touch": null,
                        "break": 6,
                        "total": 333
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 592,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "FESTiVAL": 12.2,
                        "PRiSM PLUS": 12.2
                    },
                    "releaseDate": "2017-02-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 559,
                        "hold": 54,
                        "slide": 53,
                        "touch": null,
                        "break": 12,
                        "total": 678
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 592,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2017-02-14"
                }
            ],
            "searchAcronyms": [
                "🌸💨❄️",
                "fbk",
                "sakura",
                "吹雪",
                "樱吹屎",
                "樱吹雪",
                "白上吹雪"
            ]
        },
        {
            "songId": "私の中の幻想的世界観及びその顕現を想起させたある現実での出来事に関する一考察",
            "category": "オンゲキ＆CHUNITHM",
            "title": "私の中の幻想的世界観及びその顕現を想起させたある現実での出来事に関する一考察",
            "artist": "小仏 凪(CV:佐倉 薫)",
            "bpm": 175,
            "imageName": "e5ccdae230e0bb3d4616d0b25823eab00a7f5caf70c71438be13a1ffb56d4de6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 217,
                        "hold": 43,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 268
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 547,
                    "releaseDate": "2017-02-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 30,
                        "slide": 8,
                        "touch": null,
                        "break": 12,
                        "total": 406
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 547,
                    "releaseDate": "2017-02-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Moon Strix",
                    "noteCounts": {
                        "tap": 362,
                        "hold": 69,
                        "slide": 48,
                        "touch": null,
                        "break": 12,
                        "total": 491
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 547,
                    "releaseDate": "2017-02-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 685,
                        "hold": 66,
                        "slide": 70,
                        "touch": null,
                        "break": 23,
                        "total": 844
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 547,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.5
                    },
                    "releaseDate": "2017-02-21"
                }
            ],
            "searchAcronyms": [
                "A consideration of the fantastic world view in me and the events in a certain reality that reminded me of its manifestation",
                "long",
                "long song",
                "一考察",
                "世界观",
                "关于我内心对歌名长度的困惑及让我想要在抽象画中用同样的字数将其写出的一次考察",
                "关于让我想起幻想的世界观及其显现的现实事件的一项考察",
                "名字太长",
                "名字太长的歌",
                "名字很长",
                "名字很长的歌",
                "名字超长",
                "对我对虚幻世界的看法和现实中唤起其表现的事件的思考",
                "小仏凪",
                "小佛凪",
                "幻想的世界观",
                "总之名字很长的歌",
                "考察",
                "轻小说"
            ]
        },
        {
            "songId": "GOODMEN",
            "category": "ゲーム＆バラエティ",
            "title": "GOODMEN",
            "artist": "EBIMAYO",
            "bpm": 175,
            "imageName": "0f441bfce3a25c457e63df65e0a4e87016a6df2b2dc0bf026971a51c285a44ff",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 12,
                        "slide": 8,
                        "touch": null,
                        "break": 13,
                        "total": 274
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 555,
                    "releaseDate": "2017-02-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 389,
                        "hold": 12,
                        "slide": 33,
                        "touch": null,
                        "break": 4,
                        "total": 438
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 555,
                    "releaseDate": "2017-02-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 442,
                        "hold": 67,
                        "slide": 53,
                        "touch": null,
                        "break": 10,
                        "total": 572
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 555,
                    "releaseDate": "2017-02-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 646,
                        "hold": 78,
                        "slide": 136,
                        "touch": null,
                        "break": 15,
                        "total": 875
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 555,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2017-02-21"
                }
            ],
            "searchAcronyms": [
                "👍",
                "👍🏻",
                "好人",
                "好汉歌",
                "好男人",
                "曾小贤",
                "群友",
                "良民",
                "良面",
                "良麵"
            ]
        },
        {
            "songId": "ドキドキDREAM!!!",
            "category": "オンゲキ＆CHUNITHM",
            "title": "ドキドキDREAM!!!",
            "artist": "イロドリミドリ「CHUNITHM」",
            "bpm": 210,
            "imageName": "d17f735ad5d0fd67dfadb97e3d9fd4ad8eafb0b582ab98ec5783ebdf64385469",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 249,
                        "hold": 20,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 283
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 578,
                    "releaseDate": "2017-02-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 73,
                        "slide": 17,
                        "touch": null,
                        "break": 16,
                        "total": 458
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 578,
                    "releaseDate": "2017-02-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 515,
                        "hold": 72,
                        "slide": 54,
                        "touch": null,
                        "break": 17,
                        "total": 658
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 578,
                    "releaseDate": "2017-02-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Moon Strix",
                    "noteCounts": {
                        "tap": 679,
                        "hold": 72,
                        "slide": 88,
                        "touch": null,
                        "break": 40,
                        "total": 879
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 578,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2017-02-21"
                }
            ],
            "searchAcronyms": [
                "dokidoki",
                "DOKIDOKI DREAM!!!",
                "五对柰子"
            ]
        },
        {
            "songId": "Selector",
            "category": "maimai",
            "title": "Selector",
            "artist": "Aliesrite* (Ym1024 feat. lamie*)",
            "bpm": 148,
            "imageName": "b80121a0a33e3c2b646be318f812a9c2c9bc7dbae022bb9ce9650ad60fb9a129",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 9,
                        "slide": 3,
                        "touch": 15,
                        "break": 14,
                        "total": 187
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 10574,
                    "releaseDate": "2023-07-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 20,
                        "slide": 6,
                        "touch": 18,
                        "break": 7,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 10574,
                    "releaseDate": "2023-07-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 57,
                        "slide": 74,
                        "touch": 8,
                        "break": 20,
                        "total": 431
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 10574,
                    "releaseDate": "2023-07-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "ボコ太",
                    "noteCounts": {
                        "tap": 652,
                        "hold": 77,
                        "slide": 12,
                        "touch": 41,
                        "break": 44,
                        "total": 826
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 10574,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2023-07-20"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 183,
                        "hold": 26,
                        "slide": 4,
                        "touch": null,
                        "break": 8,
                        "total": 221
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 574,
                    "releaseDate": "2017-02-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 252,
                        "hold": 58,
                        "slide": 18,
                        "touch": null,
                        "break": 6,
                        "total": 334
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 574,
                    "releaseDate": "2017-02-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 313,
                        "hold": 82,
                        "slide": 72,
                        "touch": null,
                        "break": 11,
                        "total": 478
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 574,
                    "releaseDate": "2017-02-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 426,
                        "hold": 6,
                        "slide": 245,
                        "touch": null,
                        "break": 41,
                        "total": 718
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 574,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.1
                    },
                    "releaseDate": "2017-02-21"
                }
            ],
            "searchAcronyms": [
                "🧚‍♂️",
                "specter",
                "你与我的工口世界",
                "爸爸的雷达",
                "绿女人",
                "绿色女人",
                "选择器",
                "马哇路加强版",
                "马挖路plus"
            ]
        },
        {
            "songId": "HERA",
            "category": "maimai",
            "title": "HERA",
            "artist": "ルゼ",
            "bpm": 185,
            "imageName": "c8f70548b764a923f9c07b0457d87a286170a5be6d3a2c524de6723e0d0e9561",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 10,
                        "slide": 14,
                        "touch": null,
                        "break": 6,
                        "total": 312
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 567,
                    "releaseDate": "2017-02-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 476,
                        "hold": 19,
                        "slide": 20,
                        "touch": null,
                        "break": 12,
                        "total": 527
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 567,
                    "releaseDate": "2017-02-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 577,
                        "hold": 45,
                        "slide": 74,
                        "touch": null,
                        "break": 26,
                        "total": 722
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 567,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2017-02-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 761,
                        "hold": 81,
                        "slide": 106,
                        "touch": null,
                        "break": 83,
                        "total": 1031
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 567,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.2,
                        "FESTiVAL PLUS": 14.2,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "Splash": 14.2,
                        "Splash PLUS": 14.2,
                        "UNiVERSE": 14.2,
                        "UNiVERSE PLUS": 14.2,
                        "maimaiでらっくす PLUS": 14.4
                    },
                    "releaseDate": "2017-02-21"
                }
            ],
            "searchAcronyms": [
                "🦊",
                "b三狼",
                "一号键质检员",
                "七匹狼",
                "古希腊掌管纵连的神",
                "大逼纵",
                "狐狸",
                "狐狸模拟器",
                "芝士雪豹",
                "赫拉",
                "轻松莫放纵",
                "黑拉"
            ]
        },
        {
            "songId": "分からない",
            "category": "maimai",
            "title": "分からない",
            "artist": "ろん×黒魔",
            "bpm": 200,
            "imageName": "22068525fa26aebd0028c805f4c0419aaa881e380a7a6a181aeec2c9849e3f5d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 14,
                        "slide": 9,
                        "touch": null,
                        "break": 8,
                        "total": 177
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 568,
                    "releaseDate": "2017-03-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 266,
                        "hold": 57,
                        "slide": 23,
                        "touch": null,
                        "break": 3,
                        "total": 349
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 568,
                    "releaseDate": "2017-03-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "如月 ゆかり",
                    "noteCounts": {
                        "tap": 410,
                        "hold": 53,
                        "slide": 40,
                        "touch": null,
                        "break": 11,
                        "total": 514
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 568,
                    "releaseDate": "2017-03-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 809,
                        "hold": 25,
                        "slide": 79,
                        "touch": null,
                        "break": 40,
                        "total": 953
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 568,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2017-03-09"
                }
            ],
            "searchAcronyms": [
                "😵",
                "Wakaranai",
                "不知道",
                "优秀答案",
                "优质解答",
                "发生什么事了",
                "吾伐晓得",
                "哇卡拉奶",
                "哇嘎啦乃",
                "我不到啊",
                "我不知道",
                "我哪知道",
                "我怎么知道",
                "暂时不能给你明确的答复",
                "这"
            ]
        },
        {
            "songId": "ポップミュージックは僕のもの",
            "category": "POPS＆アニメ",
            "title": "ポップミュージックは僕のもの",
            "artist": "ONIGAWARA",
            "bpm": 135,
            "imageName": "0cee7f2b4d14bb1024304250d8c93040d147d5c0f4893751f9911e9a493b6def",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 115,
                        "hold": 26,
                        "slide": 7,
                        "touch": null,
                        "break": 4,
                        "total": 152
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 579,
                    "releaseDate": "2017-03-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 22,
                        "slide": 19,
                        "touch": null,
                        "break": 7,
                        "total": 383
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 579,
                    "releaseDate": "2017-03-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 47,
                        "slide": 29,
                        "touch": null,
                        "break": 16,
                        "total": 364
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 579,
                    "releaseDate": "2017-03-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 368,
                        "hold": 159,
                        "slide": 33,
                        "touch": null,
                        "break": 1,
                        "total": 561
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 579,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2017-03-09"
                }
            ],
            "searchAcronyms": [
                "南通",
                "流行音乐是我的东西",
                "男同",
                "男同歌",
                "男童歌",
                "超市里莎莎",
                "镜子"
            ]
        },
        {
            "songId": "きらっせ☆ウッド村ファーム",
            "category": "POPS＆アニメ",
            "title": "きらっせ☆ウッド村ファーム",
            "artist": "uno(IOSYS) feat.miko",
            "bpm": 190,
            "imageName": "e6434c20bcdb67c095ff1027293fd3461e227e9d8c86e2d67f45565784520b31",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 268,
                        "hold": 2,
                        "slide": 10,
                        "touch": null,
                        "break": 6,
                        "total": 286
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 601,
                    "releaseDate": "2017-03-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 411,
                        "hold": 31,
                        "slide": 12,
                        "touch": null,
                        "break": 4,
                        "total": 458
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 601,
                    "releaseDate": "2017-03-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 446,
                        "hold": 33,
                        "slide": 68,
                        "touch": null,
                        "break": 22,
                        "total": 569
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 601,
                    "releaseDate": "2017-03-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 418,
                        "hold": 38,
                        "slide": 185,
                        "touch": null,
                        "break": 54,
                        "total": 695
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 601,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.1,
                        "UNiVERSE PLUS": 12.6
                    },
                    "releaseDate": "2017-03-09"
                }
            ],
            "searchAcronyms": [
                "はっぴー酱下乡扶贫",
                "妖精村",
                "木村农场",
                "銚子县"
            ]
        },
        {
            "songId": "その群青が愛しかったようだった",
            "category": "オンゲキ＆CHUNITHM",
            "title": "その群青が愛しかったようだった",
            "artist": "n-buna feat.ヤギヌマカナ",
            "bpm": 220,
            "imageName": "e904d647a974c89fddfdd13177b4fa1d81eff392b1482ddfd7c3d3be26b97d34",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 206,
                        "hold": 7,
                        "slide": 4,
                        "touch": null,
                        "break": 8,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 603,
                    "releaseDate": "2017-03-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 384,
                        "hold": 15,
                        "slide": 26,
                        "touch": null,
                        "break": 7,
                        "total": 432
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 603,
                    "releaseDate": "2017-03-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 505,
                        "hold": 23,
                        "slide": 64,
                        "touch": null,
                        "break": 14,
                        "total": 606
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 603,
                    "releaseDate": "2017-03-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 550,
                        "hold": 38,
                        "slide": 115,
                        "touch": null,
                        "break": 14,
                        "total": 717
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 603,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.2,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2017-03-09"
                }
            ],
            "searchAcronyms": [
                "It seemed that the ultramarine was loved",
                "Sono gunjo",
                "Sono Gunjo ga Itoshikattayouda",
                "群青",
                "群青爱"
            ]
        },
        {
            "songId": "Imitation:Loud Lounge",
            "category": "maimai",
            "title": "Imitation:Loud Lounge",
            "artist": "Ino(chronoize)",
            "bpm": 145,
            "imageName": "511b0960d8beb31a453574fc3e4d5db67693ed688e82ef42605dbd7a690f9854",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 114,
                        "hold": 10,
                        "slide": 4,
                        "touch": 14,
                        "break": 2,
                        "total": 144
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 10493,
                    "releaseDate": "2025-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 12,
                        "slide": 6,
                        "touch": 26,
                        "break": 3,
                        "total": 270
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 10493,
                    "releaseDate": "2025-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 343,
                        "hold": 67,
                        "slide": 68,
                        "touch": 17,
                        "break": 10,
                        "total": 505
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 10493,
                    "releaseDate": "2025-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 522,
                        "hold": 65,
                        "slide": 52,
                        "touch": 51,
                        "break": 35,
                        "total": 725
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 10493,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2025-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 173,
                        "hold": 6,
                        "slide": 10,
                        "touch": null,
                        "break": 5,
                        "total": 194
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 493,
                    "releaseDate": "2017-03-28"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 288,
                        "hold": 12,
                        "slide": 19,
                        "touch": null,
                        "break": 4,
                        "total": 323
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 493,
                    "releaseDate": "2017-03-28"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 417,
                        "hold": 58,
                        "slide": 81,
                        "touch": null,
                        "break": 5,
                        "total": 561
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 493,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2017-03-28"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 468,
                        "hold": 60,
                        "slide": 96,
                        "touch": null,
                        "break": 13,
                        "total": 637
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 493,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2017-03-28"
                }
            ],
            "searchAcronyms": [
                "丘丘人",
                "呀哈哈",
                "奇面族",
                "面具",
                "面具娃娃"
            ]
        },
        {
            "songId": "Lividi",
            "category": "maimai",
            "title": "Lividi",
            "artist": "Feryquitous",
            "bpm": 191,
            "imageName": "22884dde4e0926f82aec00942aca61b134bd7c3894eadedcbf1ac9636de5328f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 11,
                        "slide": 6,
                        "touch": null,
                        "break": 7,
                        "total": 218
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 488,
                    "releaseDate": "2017-03-28"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 373,
                        "hold": 32,
                        "slide": 30,
                        "touch": null,
                        "break": 8,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 488,
                    "releaseDate": "2017-03-28"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 481,
                        "hold": 62,
                        "slide": 74,
                        "touch": null,
                        "break": 12,
                        "total": 629
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 488,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2017-03-28"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "Moon Strix",
                    "noteCounts": {
                        "tap": 822,
                        "hold": 52,
                        "slide": 101,
                        "touch": null,
                        "break": 8,
                        "total": 983
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 488,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 14,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "Splash": 14,
                        "Splash PLUS": 14,
                        "UNiVERSE": 14,
                        "UNiVERSE PLUS": 14,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2017-03-28"
                }
            ],
            "searchAcronyms": [
                "呼哇",
                "执念",
                "李云迪",
                "李伟迪",
                "李汶谛",
                "李维迪"
            ]
        },
        {
            "songId": "だんだん早くなる",
            "category": "niconico＆ボーカロイド",
            "title": "だんだん早くなる",
            "artist": "40mP",
            "bpm": 160,
            "imageName": "999f4d9a792b4032a87a9bc50b4dee75ecc391342210ff9c1c4f9f59e18f62d0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 3,
                        "slide": 2,
                        "touch": null,
                        "break": 5,
                        "total": 209
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 513,
                    "releaseDate": "2017-04-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 377,
                        "hold": 12,
                        "slide": 21,
                        "touch": null,
                        "break": 10,
                        "total": 420
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 513,
                    "releaseDate": "2017-04-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 64,
                        "slide": 36,
                        "touch": null,
                        "break": 6,
                        "total": 401
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 513,
                    "releaseDate": "2017-04-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 371,
                        "hold": 85,
                        "slide": 79,
                        "touch": null,
                        "break": 17,
                        "total": 552
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 513,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2017-04-18"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 406,
                        "hold": 6,
                        "slide": 125,
                        "touch": null,
                        "break": 15,
                        "total": 552
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 513,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.2
                    },
                    "releaseDate": "2018-01-08"
                }
            ],
            "searchAcronyms": [
                "dandan hayaku naru",
                "Getting Faster and Faster",
                "专注轻机枪",
                "别急8",
                "动力小子",
                "哈压库",
                "当当哈呀库那路",
                "渐变快",
                "渐渐加快",
                "渐渐加速",
                "渐渐变快",
                "渐渐变急",
                "秃老头",
                "蛋蛋",
                "蛋蛋加速",
                "蛋蛋变快",
                "蛋蛋歌",
                "走路歌",
                "越战越勇",
                "越来越快",
                "跑男",
                "逐渐加快",
                "逐渐加速",
                "逐渐变快"
            ]
        },
        {
            "songId": "ココロ",
            "category": "niconico＆ボーカロイド",
            "title": "ココロ",
            "artist": "トラボルタ",
            "bpm": 140,
            "imageName": "6f37ebaa1b7ff851dc10b86438b5502810d5865332c60fbf3dcb513bae0e983f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 178,
                        "hold": 15,
                        "slide": 5,
                        "touch": null,
                        "break": 8,
                        "total": 206
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 516,
                    "releaseDate": "2017-04-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 38,
                        "slide": 19,
                        "touch": null,
                        "break": 6,
                        "total": 327
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 516,
                    "releaseDate": "2017-04-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 58,
                        "slide": 58,
                        "touch": null,
                        "break": 5,
                        "total": 416
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 516,
                    "releaseDate": "2017-04-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 366,
                        "hold": 48,
                        "slide": 142,
                        "touch": null,
                        "break": 10,
                        "total": 566
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 516,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2017-04-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "吉原ラメント",
            "category": "niconico＆ボーカロイド",
            "title": "吉原ラメント",
            "artist": "亜沙",
            "bpm": 191,
            "imageName": "0f609ba4b3a69856338afdc1f612e6c363a4a5928f2b8238ba0a383aceb99175",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 182,
                        "hold": 18,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 210
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 580,
                    "releaseDate": "2017-04-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 333,
                        "hold": 32,
                        "slide": 26,
                        "touch": null,
                        "break": 7,
                        "total": 398
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 580,
                    "releaseDate": "2017-04-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 474,
                        "hold": 42,
                        "slide": 49,
                        "touch": null,
                        "break": 14,
                        "total": 579
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 580,
                    "releaseDate": "2017-04-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 614,
                        "hold": 10,
                        "slide": 194,
                        "touch": null,
                        "break": 31,
                        "total": 849
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 580,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2017-04-18"
                }
            ],
            "searchAcronyms": [
                "yoshiwara lament",
                "YOSHIWARALAMENTO",
                "吉原",
                "吉原哀歌",
                "吉原拉面",
                "吉原泼妇"
            ]
        },
        {
            "songId": "ねぇ、壊れタ人形ハ何処へ棄テらレるノ？",
            "category": "maimai",
            "title": "ねぇ、壊れタ人形ハ何処へ棄テらレるノ？",
            "artist": "cosMo＠暴走P",
            "bpm": 188,
            "imageName": "cbe42455075460ba27ef54231732903147d12b0ba82a9bee6de8520a23686393",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 8,
                        "slide": 5,
                        "touch": null,
                        "break": 9,
                        "total": 273
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 581,
                    "releaseDate": "2017-04-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 393,
                        "hold": 51,
                        "slide": 17,
                        "touch": null,
                        "break": 9,
                        "total": 470
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 581,
                    "releaseDate": "2017-04-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 675,
                        "hold": 29,
                        "slide": 28,
                        "touch": null,
                        "break": 16,
                        "total": 748
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 581,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "Splash": 12.5,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2017-04-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 900,
                        "hold": 56,
                        "slide": 74,
                        "touch": null,
                        "break": 13,
                        "total": 1043
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 581,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "Splash": 14.5,
                        "Splash PLUS": 14.5,
                        "UNiVERSE": 14.5,
                        "UNiVERSE PLUS": 14.5,
                        "maimaiでらっくす PLUS": 14.4
                    },
                    "releaseDate": "2017-04-18"
                }
            ],
            "searchAcronyms": [
                "doll wandering",
                "Doll wAndeRing iN tHe NighTmARe",
                "Ne Kowaretaningyoha Dokohe Suterareruno",
                "人形",
                "坏人",
                "坏人偶",
                "坏人形",
                "暴走p我好喜欢你"
            ]
        },
        {
            "songId": "The wheel to the right",
            "category": "オンゲキ＆CHUNITHM",
            "title": "The wheel to the right",
            "artist": "Sampling Masters MEGA",
            "bpm": 200,
            "imageName": "c9e62a59fdba62e3da399823c1a62812b974e234e1c9fdac39657ca326961c6d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 354,
                        "hold": 7,
                        "slide": 6,
                        "touch": null,
                        "break": 25,
                        "total": 392
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 606,
                    "releaseDate": "2017-04-27"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 443,
                        "hold": 75,
                        "slide": 31,
                        "touch": null,
                        "break": 13,
                        "total": 562
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 606,
                    "releaseDate": "2017-04-27"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 547,
                        "hold": 125,
                        "slide": 156,
                        "touch": null,
                        "break": 44,
                        "total": 872
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 606,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2017-04-27"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 590,
                        "hold": 21,
                        "slide": 176,
                        "touch": null,
                        "break": 200,
                        "total": 987
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 606,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2017-04-27"
                }
            ],
            "searchAcronyms": [
                "DJ-MEGA",
                "一块钱2",
                "三块钱",
                "光头强",
                "印度人",
                "右轮",
                "我要杀了你们所有人",
                "欢乐喜锯人",
                "电锯",
                "电锯人",
                "轮子右拧",
                "这谱谁写的",
                "难听"
            ]
        },
        {
            "songId": "四月の雨",
            "category": "maimai",
            "title": "四月の雨",
            "artist": "cubesato",
            "bpm": 79,
            "imageName": "675a0c902ebd49793b64e40d6d8dd730358c7ee60611814b77662caa2c08166d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 120,
                        "hold": 12,
                        "slide": 10,
                        "touch": null,
                        "break": 6,
                        "total": 148
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 573,
                    "releaseDate": "2017-04-27"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 204,
                        "hold": 32,
                        "slide": 22,
                        "touch": null,
                        "break": 4,
                        "total": 262
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 573,
                    "releaseDate": "2017-04-27"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 289,
                        "hold": 33,
                        "slide": 59,
                        "touch": null,
                        "break": 4,
                        "total": 385
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 573,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2017-04-27"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 432,
                        "hold": 32,
                        "slide": 166,
                        "touch": null,
                        "break": 4,
                        "total": 634
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 573,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2017-04-27"
                }
            ],
            "searchAcronyms": [
                "114514月的臭雨",
                "April Showers",
                "下北泽的雨",
                "伞",
                "别急",
                "别急1",
                "四月的💩",
                "四月的shi",
                "四月的别急",
                "四月的屎",
                "四月的急",
                "四月的粪",
                "四月的雨",
                "四月答辩",
                "四月雨",
                "我为你撑一把伞",
                "星星出来就划掉"
            ]
        },
        {
            "songId": "Scream out! -maimai SONIC WASHER Edit-",
            "category": "東方Project",
            "title": "Scream out! -maimai SONIC WASHER Edit-",
            "artist": "A-One",
            "bpm": 174,
            "imageName": "2cf5178ee150b695a370e9b2f3c3e517e22abfcc5781e3b84ed9c788d07623b7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 132,
                        "hold": 9,
                        "slide": 4,
                        "touch": 8,
                        "break": 11,
                        "total": 164
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10572,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 26,
                        "slide": 17,
                        "touch": 10,
                        "break": 30,
                        "total": 420
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10572,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 326,
                        "hold": 67,
                        "slide": 66,
                        "touch": 59,
                        "break": 28,
                        "total": 546
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10572,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 654,
                        "hold": 73,
                        "slide": 102,
                        "touch": 120,
                        "break": 42,
                        "total": 991
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10572,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.6,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.6,
                        "FESTiVAL PLUS": 13.6,
                        "PRiSM PLUS": 13.5,
                        "Splash": 13.6,
                        "Splash PLUS": 13.6,
                        "UNiVERSE": 13.6,
                        "UNiVERSE PLUS": 13.6,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 222,
                        "hold": 32,
                        "slide": 4,
                        "touch": null,
                        "break": 17,
                        "total": 275
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 572,
                    "releaseDate": "2017-05-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 453,
                        "hold": 44,
                        "slide": 24,
                        "touch": null,
                        "break": 14,
                        "total": 535
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 572,
                    "releaseDate": "2017-05-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 560,
                        "hold": 118,
                        "slide": 84,
                        "touch": null,
                        "break": 15,
                        "total": 777
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 572,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "BUDDiES PLUS": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2017-05-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 845,
                        "hold": 64,
                        "slide": 131,
                        "touch": null,
                        "break": 49,
                        "total": 1089
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 572,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2017-05-11"
                }
            ],
            "searchAcronyms": [
                "dx赞不绝口",
                "dx青蛙子",
                "喊出来",
                "美国紫妈",
                "诹访子",
                "赞不绝口",
                "青蛙子"
            ]
        },
        {
            "songId": "幽闇に目醒めしは",
            "category": "東方Project",
            "title": "幽闇に目醒めしは",
            "artist": "セブンスヘブンMAXION",
            "bpm": 120,
            "imageName": "6d3938627b660424f62790f46990ae83b6c33b85110f99d154c27acb0e976474",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 148,
                        "hold": 9,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 171
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 582,
                    "releaseDate": "2017-05-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 206,
                        "hold": 21,
                        "slide": 14,
                        "touch": null,
                        "break": 6,
                        "total": 247
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 582,
                    "releaseDate": "2017-05-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 238,
                        "hold": 33,
                        "slide": 41,
                        "touch": null,
                        "break": 1,
                        "total": 313
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 582,
                    "releaseDate": "2017-05-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 48,
                        "slide": 106,
                        "touch": null,
                        "break": 10,
                        "total": 506
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 582,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.6
                    },
                    "releaseDate": "2017-05-11"
                }
            ],
            "searchAcronyms": [
                "Anything which was awakened to phantom-dusk",
                "东方四个女人躺草地",
                "幽暗",
                "幽暗目醒",
                "幽目",
                "躺草坪"
            ]
        },
        {
            "songId": "Starlight Vision",
            "category": "東方Project",
            "title": "Starlight Vision",
            "artist": "矢鴇つかさ feat. 三澤秋",
            "bpm": 180,
            "imageName": "b991773ef6695dde51e9b9d4372cc1ffeb0afd1dcc1c028b8a849c2274b49fb3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 115,
                        "hold": 8,
                        "slide": 9,
                        "touch": null,
                        "break": 2,
                        "total": 134
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 583,
                    "releaseDate": "2017-05-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 245,
                        "hold": 35,
                        "slide": 14,
                        "touch": null,
                        "break": 4,
                        "total": 298
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 583,
                    "releaseDate": "2017-05-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 30,
                        "slide": 38,
                        "touch": null,
                        "break": 30,
                        "total": 455
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 583,
                    "releaseDate": "2017-05-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 466,
                        "hold": 50,
                        "slide": 81,
                        "touch": null,
                        "break": 11,
                        "total": 608
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 583,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.2
                    },
                    "releaseDate": "2017-05-11"
                }
            ],
            "searchAcronyms": [
                "🌸",
                "星光视觉",
                "樱花灵梦"
            ]
        },
        {
            "songId": "Club Ibuki in Break All",
            "category": "東方Project",
            "title": "Club Ibuki in Break All",
            "artist": "void＋夕野ヨシミ (IOSYS) feat.藤原鞠菜",
            "bpm": 175,
            "imageName": "d3867397e9923cd2f91007cf9e34bded36b3ff2b61fc241df9377f525dc7e646",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 170,
                        "hold": 6,
                        "slide": 6,
                        "touch": null,
                        "break": 6,
                        "total": 188
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 584,
                    "releaseDate": "2017-05-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 25,
                        "slide": 11,
                        "touch": null,
                        "break": 12,
                        "total": 277
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 584,
                    "releaseDate": "2017-05-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 283,
                        "hold": 32,
                        "slide": 91,
                        "touch": null,
                        "break": 29,
                        "total": 435
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 584,
                    "releaseDate": "2017-05-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 37,
                        "slide": 95,
                        "touch": null,
                        "break": 166,
                        "total": 673
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 584,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2017-05-11"
                }
            ],
            "searchAcronyms": [
                "club ibuki",
                "ibuki",
                "东方年柄年中",
                "全是大逼绝赞",
                "全是绝赞",
                "绝赞俱乐部",
                "萃香跳舞",
                "西瓜跳舞"
            ]
        },
        {
            "songId": "Phantasm Brigade",
            "category": "東方Project",
            "title": "Phantasm Brigade",
            "artist": "Silver Forest",
            "bpm": 168,
            "imageName": "746a5f9fafd373c04e37761e88d0cf225e66f16d508c2b0be7c475d0d6896273",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 13,
                        "slide": 7,
                        "touch": null,
                        "break": 3,
                        "total": 213
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 585,
                    "releaseDate": "2017-05-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 324,
                        "hold": 46,
                        "slide": 22,
                        "touch": null,
                        "break": 6,
                        "total": 398
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 585,
                    "releaseDate": "2017-05-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 64,
                        "slide": 83,
                        "touch": null,
                        "break": 17,
                        "total": 509
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 585,
                    "releaseDate": "2017-05-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 721,
                        "hold": 4,
                        "slide": 133,
                        "touch": null,
                        "break": 33,
                        "total": 891
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 585,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2017-05-11"
                }
            ],
            "searchAcronyms": [
                "pb"
            ]
        },
        {
            "songId": "天火明命",
            "category": "maimai",
            "title": "天火明命",
            "artist": "削除",
            "bpm": 155,
            "imageName": "bfbaeaaa1ed5e2ec4fdfafb0861db7424b831d6f6afe420c648d218277ce3286",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 9,
                        "slide": 10,
                        "touch": null,
                        "break": 4,
                        "total": 226
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 566,
                    "releaseDate": "2017-05-23"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 301,
                        "hold": 57,
                        "slide": 60,
                        "touch": null,
                        "break": 12,
                        "total": 430
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 566,
                    "releaseDate": "2017-05-23"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 535,
                        "hold": 36,
                        "slide": 109,
                        "touch": null,
                        "break": 34,
                        "total": 714
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 566,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2017-05-23"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 778,
                        "hold": 49,
                        "slide": 106,
                        "touch": null,
                        "break": 30,
                        "total": 963
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 566,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2017-05-23"
                }
            ],
            "searchAcronyms": [
                "Amenohoakari",
                "tenkameimei",
                "天火",
                "天火没命"
            ]
        },
        {
            "songId": "Panopticon",
            "category": "maimai",
            "title": "Panopticon",
            "artist": "cybermiso",
            "bpm": 110,
            "imageName": "2c34e6ecd46d18ba5b392a7c4030623f02c55611a8aea37ac5f80c96be12232c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 187,
                        "hold": 18,
                        "slide": 3,
                        "touch": null,
                        "break": 9,
                        "total": 217
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 589,
                    "releaseDate": "2017-05-23"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 48,
                        "slide": 46,
                        "touch": null,
                        "break": 10,
                        "total": 401
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 589,
                    "releaseDate": "2017-05-23"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 76,
                        "slide": 71,
                        "touch": null,
                        "break": 10,
                        "total": 514
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 589,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2017-05-23"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 650,
                        "hold": 52,
                        "slide": 140,
                        "touch": null,
                        "break": 58,
                        "total": 900
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 589,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.2,
                        "FESTiVAL PLUS": 14.2,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "Splash": 14.1,
                        "Splash PLUS": 14.1,
                        "UNiVERSE": 14.1,
                        "UNiVERSE PLUS": 14.1,
                        "maimaiでらっくす PLUS": 14.4
                    },
                    "releaseDate": "2017-05-23"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 708,
                        "hold": 75,
                        "slide": 110,
                        "touch": null,
                        "break": 16,
                        "total": 909
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 589,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.1,
                        "BUDDiES PLUS": 14.1,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.1,
                        "FESTiVAL PLUS": 14.1,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "Splash": 14.1,
                        "Splash PLUS": 14.1,
                        "UNiVERSE": 14.1,
                        "UNiVERSE PLUS": 14.1,
                        "maimaiでらっくす PLUS": 14.1
                    },
                    "releaseDate": "2018-06-20"
                }
            ],
            "searchAcronyms": [
                "mai当牢",
                "上学",
                "上班",
                "不要再申请没有用的学校别名了 不会通过的",
                "保全派驻",
                "别急12",
                "办公室",
                "圆形监狱",
                "坐牢",
                "大学",
                "大牢",
                "学校",
                "机厅",
                "来坐大牢",
                "牢",
                "牢大",
                "监狱",
                "高中"
            ]
        },
        {
            "songId": "炉心融解",
            "category": "niconico＆ボーカロイド",
            "title": "炉心融解",
            "artist": "iroha(sasaki)／kuma(alfred)",
            "bpm": 165,
            "imageName": "fd5a0f96c9520623cad8b717bdab88a9ac89262e7d6ebf49bf7ee04a3510b839",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 113,
                        "hold": 14,
                        "slide": 5,
                        "touch": null,
                        "break": 4,
                        "total": 136
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 280,
                    "releaseDate": "2017-06-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 183,
                        "hold": 8,
                        "slide": 36,
                        "touch": null,
                        "break": 6,
                        "total": 233
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 280,
                    "releaseDate": "2017-06-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 243,
                        "hold": 25,
                        "slide": 49,
                        "touch": null,
                        "break": 7,
                        "total": 324
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 280,
                    "releaseDate": "2017-06-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 44,
                        "slide": 75,
                        "touch": null,
                        "break": 19,
                        "total": 416
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 280,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2017-06-06"
                }
            ],
            "searchAcronyms": [
                "Meltdown",
                "Roshin Yukai"
            ]
        },
        {
            "songId": "ネトゲ廃人シュプレヒコール",
            "category": "niconico＆ボーカロイド",
            "title": "ネトゲ廃人シュプレヒコール",
            "artist": "さつき が てんこもり",
            "bpm": 175,
            "imageName": "59ac54ef98c277b803622b61f071c84ec22c4b385bba189b951ee4c41528c9d0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 259,
                        "hold": 12,
                        "slide": 4,
                        "touch": null,
                        "break": 7,
                        "total": 282
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 283,
                    "releaseDate": "2017-06-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 325,
                        "hold": 46,
                        "slide": 25,
                        "touch": null,
                        "break": 10,
                        "total": 406
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 283,
                    "releaseDate": "2017-06-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 468,
                        "hold": 65,
                        "slide": 39,
                        "touch": null,
                        "break": 17,
                        "total": 589
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 283,
                    "releaseDate": "2017-06-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 688,
                        "hold": 65,
                        "slide": 102,
                        "touch": null,
                        "break": 33,
                        "total": 888
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 283,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13.2
                    },
                    "releaseDate": "2017-06-06"
                }
            ],
            "searchAcronyms": [
                "😉",
                "Net game",
                "Netoge",
                "The MMORPG Addict's Anthem",
                "废人",
                "我",
                "网游废人",
                "网游废人的呐喊",
                "网络废人"
            ]
        },
        {
            "songId": "Just Be Friends",
            "category": "niconico＆ボーカロイド",
            "title": "Just Be Friends",
            "artist": "Dixie Flatline",
            "bpm": 128,
            "imageName": "c27f4df7fe8a39980817a9b56ab667600648fc29b48c7b4804e7608fae731d10",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 183,
                        "hold": 6,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 199
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 509,
                    "releaseDate": "2017-06-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 317,
                        "hold": 42,
                        "slide": 18,
                        "touch": null,
                        "break": 6,
                        "total": 383
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 509,
                    "releaseDate": "2017-06-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 50,
                        "slide": 60,
                        "touch": null,
                        "break": 2,
                        "total": 454
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 509,
                    "releaseDate": "2017-06-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 652,
                        "hold": 45,
                        "slide": 107,
                        "touch": null,
                        "break": 8,
                        "total": 812
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 509,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2017-06-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "StargazeR",
            "category": "niconico＆ボーカロイド",
            "title": "StargazeR",
            "artist": "骨盤P",
            "bpm": 195,
            "imageName": "a3e54e78c74c6372cd7b011cc716cbee6e9b06cfc19d708c5755d1565488536f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 167,
                        "hold": 16,
                        "slide": 5,
                        "touch": null,
                        "break": 3,
                        "total": 191
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 512,
                    "releaseDate": "2017-06-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 27,
                        "slide": 20,
                        "touch": null,
                        "break": 4,
                        "total": 305
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 512,
                    "releaseDate": "2017-06-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 58,
                        "slide": 64,
                        "touch": null,
                        "break": 6,
                        "total": 415
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 512,
                    "releaseDate": "2017-06-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Moon Strix",
                    "noteCounts": {
                        "tap": 394,
                        "hold": 56,
                        "slide": 125,
                        "touch": null,
                        "break": 12,
                        "total": 587
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi",
                    "internalId": 512,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2017-06-06"
                }
            ],
            "searchAcronyms": [
                "空条承太郎",
                "虎哥",
                "观星者"
            ]
        },
        {
            "songId": "華鳥風月",
            "category": "東方Project",
            "title": "華鳥風月",
            "artist": "幽閉サテライト(Produce:嵯峨飛鳥 Arranged:Iceon)",
            "bpm": 123,
            "imageName": "a221fb6471069dbc6df399c821a56c1907b01f74ad095510907dde3af2e8cdbf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 10,
                        "slide": 7,
                        "touch": null,
                        "break": 4,
                        "total": 126
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 541,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 18,
                        "slide": 20,
                        "touch": null,
                        "break": 7,
                        "total": 233
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 541,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 44,
                        "slide": 34,
                        "touch": null,
                        "break": 8,
                        "total": 320
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 541,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 477,
                        "hold": 37,
                        "slide": 95,
                        "touch": null,
                        "break": 18,
                        "total": 627
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 541,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.3,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2017-06-22"
                }
            ],
            "searchAcronyms": [
                "Kachoufugetsu",
                "かちょうふうげつ",
                "华鸟风月",
                "四季",
                "四季映姬",
                "花鸟市场",
                "花鸟风月"
            ]
        },
        {
            "songId": "リンカーネイション",
            "category": "niconico＆ボーカロイド",
            "title": "リンカーネイション",
            "artist": "kemu",
            "bpm": 185,
            "imageName": "cd0b08fc94f8e3a9a191cfc987ed0256f911e4c1d9f4b14e09f0ae2a20bca7bb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 163,
                        "hold": 17,
                        "slide": 7,
                        "touch": null,
                        "break": 8,
                        "total": 195
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 610,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 18,
                        "slide": 9,
                        "touch": null,
                        "break": 6,
                        "total": 338
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 610,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 489,
                        "hold": 32,
                        "slide": 24,
                        "touch": null,
                        "break": 24,
                        "total": 569
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 610,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 722,
                        "hold": 23,
                        "slide": 79,
                        "touch": null,
                        "break": 37,
                        "total": 861
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 610,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2017-06-22"
                }
            ],
            "searchAcronyms": [
                "lexburner",
                "LexBurner",
                "reincarnation",
                "灵魂转生",
                "烈火战神",
                "轮回转生"
            ]
        },
        {
            "songId": "宿題が終わらないっ！",
            "category": "東方Project",
            "title": "宿題が終わらないっ！",
            "artist": "Innocent Keyと梨本悠里、JUNCA、小宮真央、樹詩音、大瀬良あい",
            "bpm": 180,
            "imageName": "3b3824c5e4876834bfc90ac8a951f3f75fbc1bcd5d84eb5b37818e10bee5ccb0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 8,
                        "slide": 10,
                        "touch": null,
                        "break": 6,
                        "total": 181
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 611,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 222,
                        "hold": 22,
                        "slide": 28,
                        "touch": null,
                        "break": 9,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 611,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 304,
                        "hold": 54,
                        "slide": 38,
                        "touch": null,
                        "break": 20,
                        "total": 416
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 611,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "如月 ゆかり",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 68,
                        "slide": 124,
                        "touch": null,
                        "break": 43,
                        "total": 599
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 611,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.4,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2017-06-22"
                }
            ],
            "searchAcronyms": [
                "-Connect-少女与触手编织出的爱",
                "不写作业",
                "作业还没做完",
                "吱吱",
                "宿题",
                "宿题终",
                "触手"
            ]
        },
        {
            "songId": "GO BACK 2 YOUR RAVE",
            "category": "ゲーム＆バラエティ",
            "title": "GO BACK 2 YOUR RAVE",
            "artist": "nora2r",
            "bpm": 170,
            "imageName": "e2d3ee7ab115dc6247c936db254f07807fd1c4e526079e0330e5a7ab1828ba59",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 228,
                        "hold": 4,
                        "slide": 11,
                        "touch": null,
                        "break": 10,
                        "total": 253
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 612,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 268,
                        "hold": 59,
                        "slide": 19,
                        "touch": null,
                        "break": 9,
                        "total": 355
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 612,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.3,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 459,
                        "hold": 16,
                        "slide": 94,
                        "touch": null,
                        "break": 22,
                        "total": 591
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 612,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.3,
                        "CiRCLE": 12.3,
                        "CiRCLE PLUS": 12.3,
                        "PRiSM PLUS": 12.3
                    },
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 814,
                        "hold": 51,
                        "slide": 101,
                        "touch": null,
                        "break": 33,
                        "total": 999
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 612,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2017-06-22"
                }
            ],
            "searchAcronyms": [
                "gb2",
                "gb2yr",
                "业界骚然",
                "回去你的2rave"
            ]
        },
        {
            "songId": "天国と地獄 -言ノ葉リンネ-",
            "category": "maimai",
            "title": "天国と地獄 -言ノ葉リンネ-",
            "artist": "伊東歌詞太郎・ろん×れるりり",
            "bpm": 138,
            "imageName": "94d80c978503ad732fa1ea55c44a939b54085acac20d9f6f40e1551a88bc4766",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 136,
                        "hold": 22,
                        "slide": 4,
                        "touch": null,
                        "break": 8,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 613,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 38,
                        "slide": 25,
                        "touch": null,
                        "break": 5,
                        "total": 307
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 613,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 286,
                        "hold": 51,
                        "slide": 92,
                        "touch": null,
                        "break": 14,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 613,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Moon Strix",
                    "noteCounts": {
                        "tap": 600,
                        "hold": 65,
                        "slide": 59,
                        "touch": null,
                        "break": 24,
                        "total": 748
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 613,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2017-06-22"
                }
            ],
            "searchAcronyms": [
                "tengokutojigokukotonoharinne",
                "天国与地狱",
                "天国地狱"
            ]
        },
        {
            "songId": "夢花火",
            "category": "maimai",
            "title": "夢花火",
            "artist": "豚乙女",
            "bpm": 186,
            "imageName": "cd58a695d42474503515c2fd51040058446b658b577394021acb5e3a61c6013c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 6,
                        "slide": 5,
                        "touch": null,
                        "break": 11,
                        "total": 302
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 614,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 374,
                        "hold": 19,
                        "slide": 25,
                        "touch": null,
                        "break": 22,
                        "total": 440
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 614,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 487,
                        "hold": 36,
                        "slide": 92,
                        "touch": null,
                        "break": 19,
                        "total": 634
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 614,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 708,
                        "hold": 25,
                        "slide": 133,
                        "touch": null,
                        "break": 77,
                        "total": 943
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 614,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.6,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2017-06-22"
                }
            ],
            "searchAcronyms": [
                "u咩哈那比",
                "YumeHANABI",
                "乙姬角色歌",
                "最难主题曲",
                "梦花火",
                "马栏山",
                "马老三"
            ]
        },
        {
            "songId": "前前前世",
            "category": "POPS＆アニメ",
            "title": "前前前世",
            "artist": "RADWIMPS",
            "bpm": 190,
            "imageName": "033d2af90f374492c8bc54f704ee0b417af9a3adc17558c122277d09ba3015fd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 9,
                        "slide": 5,
                        "touch": null,
                        "break": 6,
                        "total": 162
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 853,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 248,
                        "hold": 5,
                        "slide": 19,
                        "touch": null,
                        "break": 4,
                        "total": 276
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 853,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 384,
                        "hold": 30,
                        "slide": 37,
                        "touch": null,
                        "break": 14,
                        "total": 465
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 853,
                    "releaseDate": "2017-06-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 540,
                        "hold": 19,
                        "slide": 120,
                        "touch": null,
                        "break": 18,
                        "total": 697
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 853,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9
                    },
                    "releaseDate": "2017-06-22"
                }
            ],
            "searchAcronyms": [
                "Your Name",
                "Zenzenzense",
                "上上上辈子",
                "你的名字",
                "推荐乐曲排行榜"
            ]
        },
        {
            "songId": "オトヒメモリー☆ウタゲーション",
            "category": "maimai",
            "title": "オトヒメモリー☆ウタゲーション",
            "artist": "Junky feat. 乙姫(CV:浅川悠)",
            "bpm": 140,
            "imageName": "220fea88947567c7f0a13c58fa479f838c4c66f6c37ad420e9188e2aab425aa1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 18,
                        "slide": 6,
                        "touch": null,
                        "break": 3,
                        "total": 226
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 617,
                    "releaseDate": "2017-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 286,
                        "hold": 20,
                        "slide": 25,
                        "touch": null,
                        "break": 14,
                        "total": 345
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 617,
                    "releaseDate": "2017-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 394,
                        "hold": 40,
                        "slide": 70,
                        "touch": null,
                        "break": 24,
                        "total": 528
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 617,
                    "releaseDate": "2017-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 492,
                        "hold": 59,
                        "slide": 115,
                        "touch": null,
                        "break": 37,
                        "total": 703
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 617,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.4,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2017-07-11"
                }
            ],
            "searchAcronyms": [
                "乙姫",
                "乙姬"
            ]
        },
        {
            "songId": "ラブチーノ",
            "category": "niconico＆ボーカロイド",
            "title": "ラブチーノ",
            "artist": "Junky",
            "bpm": 126,
            "imageName": "621552771b34a6bea82a781d0c89b9ff646928248e4ebfac568522d5a55fefde",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 14,
                        "slide": 5,
                        "touch": null,
                        "break": 5,
                        "total": 162
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 618,
                    "releaseDate": "2017-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 178,
                        "hold": 41,
                        "slide": 28,
                        "touch": null,
                        "break": 8,
                        "total": 255
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 618,
                    "releaseDate": "2017-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 302,
                        "hold": 41,
                        "slide": 25,
                        "touch": null,
                        "break": 15,
                        "total": 383
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 618,
                    "releaseDate": "2017-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 56,
                        "slide": 86,
                        "touch": null,
                        "break": 14,
                        "total": 467
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 618,
                    "releaseDate": "2017-07-11"
                }
            ],
            "searchAcronyms": [
                "love",
                "love cino"
            ]
        },
        {
            "songId": "ヘルシーエンド",
            "category": "niconico＆ボーカロイド",
            "title": "ヘルシーエンド",
            "artist": "椎名もた (ぽわぽわP)",
            "bpm": 150,
            "imageName": "b764e1b5355895cf8947767941d454ad0c7ac5fd399da0e03138dfbfd78dea0b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 116,
                        "hold": 14,
                        "slide": 10,
                        "touch": null,
                        "break": 2,
                        "total": 142
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 514,
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 16,
                        "slide": 23,
                        "touch": null,
                        "break": 4,
                        "total": 333
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 514,
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 84,
                        "slide": 45,
                        "touch": null,
                        "break": 4,
                        "total": 370
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 514,
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 116,
                        "slide": 95,
                        "touch": null,
                        "break": 4,
                        "total": 553
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 514,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.5,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2017-07-25"
                }
            ],
            "searchAcronyms": [
                "healthy end",
                "maimai你摸",
                "健康结局"
            ]
        },
        {
            "songId": "東京レトロ",
            "category": "niconico＆ボーカロイド",
            "title": "東京レトロ",
            "artist": "すこっぷ",
            "bpm": 126,
            "imageName": "63772d1a95938fafe29343e820dcf4369ce8262a4820fb7c8e06feaaaaaac478",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 6,
                        "slide": 6,
                        "touch": null,
                        "break": 6,
                        "total": 145
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 620,
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 15,
                        "slide": 15,
                        "touch": null,
                        "break": 8,
                        "total": 228
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 620,
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 173,
                        "hold": 53,
                        "slide": 45,
                        "touch": null,
                        "break": 9,
                        "total": 280
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 620,
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 331,
                        "hold": 38,
                        "slide": 90,
                        "touch": null,
                        "break": 11,
                        "total": 470
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 620,
                    "releaseDate": "2017-07-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ARROW",
            "category": "niconico＆ボーカロイド",
            "title": "ARROW",
            "artist": "niki",
            "bpm": 131,
            "imageName": "f3638e1b9b5c2a53ed6e332d1750ee75c411b7fc40b3ec8816cd642acd6b8185",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 13,
                        "slide": 6,
                        "touch": null,
                        "break": 3,
                        "total": 159
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 621,
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 26,
                        "slide": 21,
                        "touch": null,
                        "break": 12,
                        "total": 300
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 621,
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.1,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 385,
                        "hold": 74,
                        "slide": 44,
                        "touch": null,
                        "break": 15,
                        "total": 518
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 621,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.1,
                        "CiRCLE PLUS": 12.1,
                        "FESTiVAL": 12.1,
                        "PRiSM PLUS": 12.1,
                        "UNiVERSE PLUS": 12.1
                    },
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 466,
                        "hold": 123,
                        "slide": 56,
                        "touch": null,
                        "break": 12,
                        "total": 657
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 621,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2017-07-25"
                }
            ],
            "searchAcronyms": [
                "🏹",
                "箭",
                "箭头"
            ]
        },
        {
            "songId": "バッド・ダンス・ホール",
            "category": "niconico＆ボーカロイド",
            "title": "バッド・ダンス・ホール",
            "artist": "ぱなまん/カラスヤサボウ",
            "bpm": 152,
            "imageName": "3e9c7cfb8d8589318c6f676411f03659eaec5057eb3cfa3aaae391b290fae1c8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 129,
                        "hold": 12,
                        "slide": 5,
                        "touch": 8,
                        "break": 7,
                        "total": 161
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 260,
                        "hold": 12,
                        "slide": 6,
                        "touch": 11,
                        "break": 9,
                        "total": 298
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 75,
                        "slide": 30,
                        "touch": 9,
                        "break": 41,
                        "total": 493
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 577,
                        "hold": 53,
                        "slide": 120,
                        "touch": 65,
                        "break": 66,
                        "total": 881
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 173,
                        "hold": 4,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 622,
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 28,
                        "slide": 30,
                        "touch": null,
                        "break": 9,
                        "total": 304
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 622,
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 97,
                        "slide": 55,
                        "touch": null,
                        "break": 18,
                        "total": 512
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 622,
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 613,
                        "hold": 44,
                        "slide": 116,
                        "touch": null,
                        "break": 24,
                        "total": 797
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 622,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2017-07-25"
                }
            ],
            "searchAcronyms": [
                "bdh",
                "团长",
                "坏舞厅",
                "奥尔加"
            ]
        },
        {
            "songId": "ちがう!!!",
            "category": "niconico＆ボーカロイド",
            "title": "ちがう!!!",
            "artist": "カルロス袴田(サイゼP)",
            "bpm": 181,
            "imageName": "1e34fe7f2311e1ed4881e31bd3b82e04e4f2f2ff7d76dda1f4bf1145e04878ea",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 8,
                        "slide": 5,
                        "touch": null,
                        "break": 9,
                        "total": 255
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 663,
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 286,
                        "hold": 72,
                        "slide": 7,
                        "touch": null,
                        "break": 6,
                        "total": 371
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 663,
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 431,
                        "hold": 27,
                        "slide": 31,
                        "touch": null,
                        "break": 26,
                        "total": 515
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 663,
                    "releaseDate": "2017-07-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 553,
                        "hold": 16,
                        "slide": 151,
                        "touch": null,
                        "break": 70,
                        "total": 790
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 663,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 13.2
                    },
                    "releaseDate": "2017-07-25"
                }
            ],
            "searchAcronyms": [
                "CHIGAU!!!"
            ]
        },
        {
            "songId": "KISS CANDY FLAVOR",
            "category": "ゲーム＆バラエティ",
            "title": "KISS CANDY FLAVOR",
            "artist": "カラフル・サウンズ・ポート",
            "bpm": 146,
            "imageName": "82e980bbb3a437baa6563ce5f0ab79954bf17e4e2e8755d3b043d35c6ea2b808",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 6,
                        "slide": 6,
                        "touch": null,
                        "break": 7,
                        "total": 203
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 624,
                    "releaseDate": "2017-08-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 274,
                        "hold": 22,
                        "slide": 13,
                        "touch": null,
                        "break": 14,
                        "total": 323
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 624,
                    "releaseDate": "2017-08-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 397,
                        "hold": 61,
                        "slide": 30,
                        "touch": null,
                        "break": 33,
                        "total": 521
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 624,
                    "releaseDate": "2017-08-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Moon Strix",
                    "noteCounts": {
                        "tap": 558,
                        "hold": 39,
                        "slide": 119,
                        "touch": null,
                        "break": 14,
                        "total": 730
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 624,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2017-08-03"
                }
            ],
            "searchAcronyms": [
                "kcf",
                "亲亲砍弟佐料",
                "亲甜滴",
                "亲糖口味",
                "小女孩福瑞",
                "小红帽",
                "糖的味道",
                "糖糖"
            ]
        },
        {
            "songId": "Maxi",
            "category": "ゲーム＆バラエティ",
            "title": "Maxi",
            "artist": "Nizikawa",
            "bpm": 180,
            "imageName": "76f8bc84113ca9030f130898565d15440a952bef9297dfd99eae9ad6b769ed0e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 160,
                        "hold": 12,
                        "slide": 8,
                        "touch": 14,
                        "break": 8,
                        "total": 202
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10625,
                    "releaseDate": "2017-08-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 11,
                        "slide": 3,
                        "touch": 25,
                        "break": 16,
                        "total": 366
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10625,
                    "releaseDate": "2017-08-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 397,
                        "hold": 57,
                        "slide": 29,
                        "touch": 32,
                        "break": 29,
                        "total": 544
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10625,
                    "releaseDate": "2017-08-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 521,
                        "hold": 46,
                        "slide": 77,
                        "touch": 145,
                        "break": 118,
                        "total": 907
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 10625,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2017-08-03"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 206,
                        "hold": 4,
                        "slide": 9,
                        "touch": null,
                        "break": 9,
                        "total": 228
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 625,
                    "releaseDate": "2017-08-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 323,
                        "hold": 37,
                        "slide": 18,
                        "touch": null,
                        "break": 16,
                        "total": 394
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 625,
                    "releaseDate": "2017-08-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 436,
                        "hold": 39,
                        "slide": 70,
                        "touch": null,
                        "break": 22,
                        "total": 567
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 625,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2017-08-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 707,
                        "hold": 57,
                        "slide": 79,
                        "touch": null,
                        "break": 71,
                        "total": 914
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 625,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2017-08-03"
                }
            ],
            "searchAcronyms": [
                "🐴😁",
                "max!",
                "嘻嘻马",
                "马克西",
                "马戏",
                "马西"
            ]
        },
        {
            "songId": "人里に下ったアタイがいつの間にか社畜になっていた件",
            "category": "ゲーム＆バラエティ",
            "title": "人里に下ったアタイがいつの間にか社畜になっていた件",
            "artist": "ねこみりん + nora2r feat. 小宮真央",
            "bpm": 180,
            "imageName": "7b368fde79d0ae63b5ddfeafc21f101c9fc57eec698a5f66a1c65f535f6e177c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 4,
                        "slide": 6,
                        "touch": null,
                        "break": 5,
                        "total": 271
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 658,
                    "releaseDate": "2017-08-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 49,
                        "slide": 31,
                        "touch": null,
                        "break": 39,
                        "total": 441
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 658,
                    "releaseDate": "2017-08-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 544,
                        "hold": 33,
                        "slide": 77,
                        "touch": null,
                        "break": 73,
                        "total": 727
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 658,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2017-08-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 667,
                        "hold": 76,
                        "slide": 94,
                        "touch": null,
                        "break": 76,
                        "total": 913
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 658,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2017-08-03"
                }
            ],
            "searchAcronyms": [
                "996",
                "no no working",
                "人里",
                "人里社畜",
                "社畜"
            ]
        },
        {
            "songId": "相思創愛",
            "category": "maimai",
            "title": "相思創愛",
            "artist": "伊東歌詞太郎・ろん×まらしぃ",
            "bpm": 195,
            "imageName": "92e0b08f1e22b9811dd005551b5c3f989876581efc70f3874930ce09e6fd9ba3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 6,
                        "slide": 13,
                        "touch": null,
                        "break": 5,
                        "total": 223
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 626,
                    "releaseDate": "2017-08-24"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 320,
                        "hold": 38,
                        "slide": 31,
                        "touch": null,
                        "break": 15,
                        "total": 404
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 626,
                    "releaseDate": "2017-08-24"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 387,
                        "hold": 41,
                        "slide": 49,
                        "touch": null,
                        "break": 30,
                        "total": 507
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 626,
                    "releaseDate": "2017-08-24"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 655,
                        "hold": 22,
                        "slide": 126,
                        "touch": null,
                        "break": 26,
                        "total": 829
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 626,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM PLUS": 13.5,
                        "Splash": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2017-08-24"
                }
            ],
            "searchAcronyms": [
                "soushisouai",
                "创创子",
                "想创死你",
                "相思",
                "相思创爱",
                "相思創爱",
                "相爱创思"
            ]
        },
        {
            "songId": "心象蜃気楼",
            "category": "オンゲキ＆CHUNITHM",
            "title": "心象蜃気楼",
            "artist": "Orangestar",
            "bpm": 190,
            "imageName": "070cd1137a0359e8ac4290de511d758028877b0489b88473953a0451001790cc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 7,
                        "slide": 7,
                        "touch": null,
                        "break": 4,
                        "total": 251
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 627,
                    "releaseDate": "2017-08-24"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 24,
                        "slide": 24,
                        "touch": null,
                        "break": 6,
                        "total": 398
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 627,
                    "releaseDate": "2017-08-24"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 404,
                        "hold": 64,
                        "slide": 60,
                        "touch": null,
                        "break": 8,
                        "total": 536
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 627,
                    "releaseDate": "2017-08-24"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 513,
                        "hold": 62,
                        "slide": 201,
                        "touch": null,
                        "break": 10,
                        "total": 786
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 627,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2017-08-24"
                }
            ],
            "searchAcronyms": [
                "Imagined Mirage",
                "Shinsyo Shinkiro",
                "心像楼",
                "心绮楼",
                "心象",
                "心象晦气楼",
                "心象晨气楼",
                "心象楼",
                "心象蜃气楼"
            ]
        },
        {
            "songId": "光線チューニング",
            "category": "オンゲキ＆CHUNITHM",
            "title": "光線チューニング",
            "artist": "ナユタン星人",
            "bpm": 190,
            "imageName": "4d755dc94480e5fbd3552501a05e987df8a4f895467073deff27c560153deefc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 296,
                        "hold": 4,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 628,
                    "releaseDate": "2017-08-24"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 346,
                        "hold": 44,
                        "slide": 37,
                        "touch": null,
                        "break": 12,
                        "total": 439
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 628,
                    "releaseDate": "2017-08-24"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Moon Strix",
                    "noteCounts": {
                        "tap": 458,
                        "hold": 48,
                        "slide": 94,
                        "touch": null,
                        "break": 17,
                        "total": 617
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 628,
                    "releaseDate": "2017-08-24"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 576,
                        "hold": 123,
                        "slide": 186,
                        "touch": null,
                        "break": 48,
                        "total": 933
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 628,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "FESTiVAL": 13.5,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.1,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2017-08-24"
                }
            ],
            "searchAcronyms": [
                "Ray Tuning",
                "Rays Tuning",
                "中二节奏",
                "光线",
                "光线turning"
            ]
        },
        {
            "songId": "Limit Break",
            "category": "maimai",
            "title": "Limit Break",
            "artist": "DiGiTAL WiNG",
            "bpm": 153,
            "imageName": "baee04ac2fdec7f1907f43fe2cdc3487ae51466b7586c62587e2d82251d761a8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 217,
                        "hold": 8,
                        "slide": 4,
                        "touch": null,
                        "break": 7,
                        "total": 236
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 629,
                    "releaseDate": "2017-09-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 18,
                        "slide": 28,
                        "touch": null,
                        "break": 26,
                        "total": 365
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 629,
                    "releaseDate": "2017-09-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 53,
                        "slide": 117,
                        "touch": null,
                        "break": 39,
                        "total": 463
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 629,
                    "releaseDate": "2017-09-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 589,
                        "hold": 21,
                        "slide": 95,
                        "touch": null,
                        "break": 50,
                        "total": 755
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 629,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2017-09-07"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 639,
                        "hold": 46,
                        "slide": 75,
                        "touch": null,
                        "break": 65,
                        "total": 825
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 629,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2022-08-11"
                }
            ],
            "searchAcronyms": [
                "lb",
                "三角符文",
                "界限打击",
                "限制绝赞",
                "限界突破",
                "黄金大三角"
            ]
        },
        {
            "songId": "曖昧mind",
            "category": "maimai",
            "title": "曖昧mind",
            "artist": "Halozy",
            "bpm": 135,
            "imageName": "9e87c20199610ea4efe53050c1982feb0abd951f0ed1ee95a37bfb35301b6035",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 10,
                        "slide": 7,
                        "touch": null,
                        "break": 8,
                        "total": 214
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 630,
                    "releaseDate": "2017-09-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 51,
                        "slide": 25,
                        "touch": null,
                        "break": 13,
                        "total": 320
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 630,
                    "releaseDate": "2017-09-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 289,
                        "hold": 46,
                        "slide": 108,
                        "touch": null,
                        "break": 26,
                        "total": 469
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 630,
                    "releaseDate": "2017-09-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 540,
                        "hold": 54,
                        "slide": 96,
                        "touch": null,
                        "break": 19,
                        "total": 709
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 630,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.5
                    },
                    "releaseDate": "2017-09-07"
                }
            ],
            "searchAcronyms": [
                "哮喘",
                "暧昧",
                "暧昧mind",
                "爱maimai"
            ]
        },
        {
            "songId": "KING is BACK!!",
            "category": "maimai",
            "title": "KING is BACK!!",
            "artist": "A-One",
            "bpm": 176,
            "imageName": "0f087e8a12b2b86936761f54c7175018f915854aeb0c50365aa578a1f19e1db6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 12,
                        "slide": 2,
                        "touch": null,
                        "break": 8,
                        "total": 254
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 631,
                    "releaseDate": "2017-09-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 298,
                        "hold": 50,
                        "slide": 26,
                        "touch": null,
                        "break": 12,
                        "total": 386
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 631,
                    "releaseDate": "2017-09-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 391,
                        "hold": 33,
                        "slide": 56,
                        "touch": null,
                        "break": 44,
                        "total": 524
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 631,
                    "releaseDate": "2017-09-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 786,
                        "hold": 22,
                        "slide": 136,
                        "touch": null,
                        "break": 111,
                        "total": 1055
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 631,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.9,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2017-09-07"
                }
            ],
            "searchAcronyms": [
                "kib",
                "king is back",
                "Kobe is back",
                "KOBE is BACK!!",
                "你回来了",
                "王回来了",
                "王归",
                "王是背",
                "王者归来",
                "群友回来了",
                "金十段"
            ]
        },
        {
            "songId": "Ultranova",
            "category": "maimai",
            "title": "Ultranova",
            "artist": "A4paper",
            "bpm": 156,
            "imageName": "2968bde714dd5de5a8c0a0caaa22128006abf51ddc7ed72df7214481123094db",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 164,
                        "hold": 4,
                        "slide": 7,
                        "touch": null,
                        "break": 8,
                        "total": 183
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 632,
                    "releaseDate": "2017-09-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 261,
                        "hold": 29,
                        "slide": 13,
                        "touch": null,
                        "break": 9,
                        "total": 312
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 632,
                    "releaseDate": "2017-09-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 393,
                        "hold": 63,
                        "slide": 48,
                        "touch": null,
                        "break": 20,
                        "total": 524
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 632,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2017-09-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 768,
                        "hold": 38,
                        "slide": 56,
                        "touch": null,
                        "break": 33,
                        "total": 895
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 632,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 14,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2017-09-07"
                }
            ],
            "searchAcronyms": [
                "🏍️",
                "a4纸",
                "摩托车",
                "超新星"
            ]
        },
        {
            "songId": "GET!! 夢&DREAM",
            "category": "POPS＆アニメ",
            "title": "GET!! 夢&DREAM",
            "artist": "加賀美 祥「学園ハンサム」",
            "bpm": 150,
            "imageName": "c2291d6ede7877f25744e4aabfaf7fd9d0a42e14cf073991c371074bb22e7b66",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 117,
                        "hold": 16,
                        "slide": 7,
                        "touch": null,
                        "break": 2,
                        "total": 142
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 634,
                    "releaseDate": "2017-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 182,
                        "hold": 31,
                        "slide": 31,
                        "touch": null,
                        "break": 6,
                        "total": 250
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 634,
                    "releaseDate": "2017-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 34,
                        "slide": 49,
                        "touch": null,
                        "break": 6,
                        "total": 371
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 634,
                    "releaseDate": "2017-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 108,
                        "hold": 155,
                        "slide": 117,
                        "touch": null,
                        "break": 27,
                        "total": 407
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 634,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2017-09-19"
                }
            ],
            "searchAcronyms": [
                "getdream",
                "get梦",
                "下巴戳死人学园",
                "取得梦和梦",
                "学园handsome",
                "梦",
                "获得梦和梦"
            ]
        },
        {
            "songId": "真・ハンサム体操でズンドコホイ",
            "category": "POPS＆アニメ",
            "title": "真・ハンサム体操でズンドコホイ",
            "artist": "10Re;「学園ハンサム」",
            "bpm": 140,
            "imageName": "1df46849b7f4c5ed3cf4a3ba6514f18d2b2bedd3313f511ec6fcec8187bac0e5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 121,
                        "hold": 10,
                        "slide": 13,
                        "touch": null,
                        "break": 2,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 654,
                    "releaseDate": "2017-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 123,
                        "hold": 87,
                        "slide": 13,
                        "touch": null,
                        "break": 2,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 654,
                    "releaseDate": "2017-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 174,
                        "hold": 110,
                        "slide": 20,
                        "touch": null,
                        "break": 14,
                        "total": 318
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 654,
                    "releaseDate": "2017-09-19"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 296,
                        "hold": 92,
                        "slide": 89,
                        "touch": null,
                        "break": 23,
                        "total": 500
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 654,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.2
                    },
                    "releaseDate": "2017-09-19"
                }
            ],
            "searchAcronyms": [
                "体操",
                "学园handsome",
                "学园帅哥",
                "帅哥体操",
                "深海男同",
                "真体操"
            ]
        },
        {
            "songId": "Moon of Noon",
            "category": "maimai",
            "title": "Moon of Noon",
            "artist": "Sampling Masters MEGA",
            "bpm": 200,
            "imageName": "51323f3bc8073d991fca4bb8c78c21eaff445cd57d7e2971d8112820fe93656e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 265,
                        "hold": 14,
                        "slide": 7,
                        "touch": null,
                        "break": 11,
                        "total": 297
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 664,
                    "releaseDate": "2017-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 50,
                        "slide": 28,
                        "touch": null,
                        "break": 9,
                        "total": 423
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 664,
                    "releaseDate": "2017-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "Moon Strix",
                    "noteCounts": {
                        "tap": 470,
                        "hold": 104,
                        "slide": 90,
                        "touch": null,
                        "break": 26,
                        "total": 690
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 664,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "BUDDiES PLUS": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.1,
                        "UNiVERSE PLUS": 13.1
                    },
                    "releaseDate": "2017-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 653,
                        "hold": 99,
                        "slide": 156,
                        "touch": null,
                        "break": 16,
                        "total": 924
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 664,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "Splash": 14.3,
                        "Splash PLUS": 14.4,
                        "UNiVERSE": 14.4,
                        "UNiVERSE PLUS": 14.4,
                        "maimaiでらっくす PLUS": 14.4
                    },
                    "releaseDate": "2017-10-03"
                }
            ],
            "searchAcronyms": [
                "一块钱3",
                "五块钱",
                "农具做瑜伽",
                "午月",
                "印度人2",
                "星星入门",
                "月儿子",
                "月孙子",
                "牢大",
                "牢大打坐",
                "牢大硅胶",
                "牢大鬼叫",
                "科比坐禅",
                "科比跳舞",
                "科比鬼叫"
            ]
        },
        {
            "songId": "デスパレイト",
            "category": "maimai",
            "title": "デスパレイト",
            "artist": "owl＊tree",
            "bpm": 145,
            "imageName": "03afcaa9e2e703a275a519a4fd68b3f8f55348738692c1f65a77a7341fe0c3df",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 166,
                        "hold": 5,
                        "slide": 9,
                        "touch": null,
                        "break": 9,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 666,
                    "releaseDate": "2017-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 202,
                        "hold": 38,
                        "slide": 23,
                        "touch": null,
                        "break": 18,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 666,
                    "releaseDate": "2017-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 43,
                        "slide": 80,
                        "touch": null,
                        "break": 19,
                        "total": 478
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 666,
                    "releaseDate": "2017-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 512,
                        "hold": 44,
                        "slide": 113,
                        "touch": null,
                        "break": 16,
                        "total": 685
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 666,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.6,
                        "Splash PLUS": 13.6,
                        "UNiVERSE": 13.6,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2017-10-03"
                }
            ],
            "searchAcronyms": [
                "desperate",
                "Desperate",
                "绝望"
            ]
        },
        {
            "songId": "Starlight Dance Floor",
            "category": "東方Project",
            "title": "Starlight Dance Floor",
            "artist": "発熱巫女～ず",
            "bpm": 128,
            "imageName": "de6c6aaeca75f2bd683567174cbac048868ed5f7b64d818ac45dcde10fad0c47",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 122,
                        "hold": 4,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 134
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 639,
                    "releaseDate": "2017-10-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 28,
                        "slide": 19,
                        "touch": null,
                        "break": 5,
                        "total": 306
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 639,
                    "releaseDate": "2017-10-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 75,
                        "slide": 16,
                        "touch": null,
                        "break": 4,
                        "total": 324
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 639,
                    "releaseDate": "2017-10-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "ものくろっく",
                    "noteCounts": {
                        "tap": 383,
                        "hold": 18,
                        "slide": 109,
                        "touch": null,
                        "break": 20,
                        "total": 530
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 639,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2017-10-17"
                }
            ],
            "searchAcronyms": [
                "发热错位金曲",
                "夜店魔理沙",
                "大姐姐魔理沙",
                "星光舞厅",
                "星光舞池"
            ]
        },
        {
            "songId": "妖精村の月誕祭 ～Lunate Elf",
            "category": "東方Project",
            "title": "妖精村の月誕祭 ～Lunate Elf",
            "artist": "どぶウサギ",
            "bpm": 132,
            "imageName": "0134f41446d1a0ca8635944d8d0d175eb1fdba3352625adfca34494f5e001a9a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 120,
                        "hold": 10,
                        "slide": 4,
                        "touch": null,
                        "break": 3,
                        "total": 137
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 640,
                    "releaseDate": "2017-10-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 160,
                        "hold": 27,
                        "slide": 18,
                        "touch": null,
                        "break": 4,
                        "total": 209
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 640,
                    "releaseDate": "2017-10-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 246,
                        "hold": 34,
                        "slide": 35,
                        "touch": null,
                        "break": 5,
                        "total": 320
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 640,
                    "releaseDate": "2017-10-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 474,
                        "hold": 38,
                        "slide": 74,
                        "touch": null,
                        "break": 20,
                        "total": 606
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 640,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12
                    },
                    "releaseDate": "2017-10-17"
                }
            ],
            "searchAcronyms": [
                "大妖精",
                "妖精村"
            ]
        },
        {
            "songId": "オーディエンスを沸かす程度の能力 feat.タイツォン",
            "category": "東方Project",
            "title": "オーディエンスを沸かす程度の能力 feat.タイツォン",
            "artist": "D.watt(IOSYS)＋らっぷびと",
            "bpm": 216,
            "imageName": "e8668f97c5c3784afc6e620cfdb59beb42e78bc466e81ec94d833d510eb59a09",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 126,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 6,
                        "total": 140
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 657,
                    "releaseDate": "2017-10-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 215,
                        "hold": 47,
                        "slide": 10,
                        "touch": null,
                        "break": 11,
                        "total": 283
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 657,
                    "releaseDate": "2017-10-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 48,
                        "slide": 21,
                        "touch": null,
                        "break": 14,
                        "total": 405
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 657,
                    "releaseDate": "2017-10-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 520,
                        "hold": 15,
                        "slide": 139,
                        "touch": null,
                        "break": 34,
                        "total": 708
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 657,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 12.5
                    },
                    "releaseDate": "2017-10-17"
                }
            ],
            "searchAcronyms": [
                "东方月灯笼",
                "沸",
                "沸程度能力",
                "沸能力",
                "沸腾",
                "沸腾程度"
            ]
        },
        {
            "songId": "チルノのパーフェクトさんすう教室　⑨周年バージョン",
            "category": "東方Project",
            "title": "チルノのパーフェクトさんすう教室　⑨周年バージョン",
            "artist": "IOSYSと愉快な⑨周年フレンズ",
            "bpm": 175,
            "imageName": "61c84f4879373df02ac859b6a4cf851584423efaa85aaae9ba4c6271c7ff1357",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 90,
                        "hold": 39,
                        "slide": 4,
                        "touch": 6,
                        "break": 7,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10665,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 220,
                        "hold": 26,
                        "slide": 6,
                        "touch": 11,
                        "break": 26,
                        "total": 289
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10665,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 341,
                        "hold": 63,
                        "slide": 27,
                        "touch": 38,
                        "break": 10,
                        "total": 479
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10665,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 483,
                        "hold": 53,
                        "slide": 60,
                        "touch": 102,
                        "break": 42,
                        "total": 740
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10665,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 8,
                        "slide": 3,
                        "touch": null,
                        "break": 9,
                        "total": 238
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 665,
                    "releaseDate": "2017-10-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 50,
                        "slide": 24,
                        "touch": null,
                        "break": 9,
                        "total": 330
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 665,
                    "releaseDate": "2017-10-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 71,
                        "slide": 120,
                        "touch": null,
                        "break": 99,
                        "total": 530
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 665,
                    "releaseDate": "2017-10-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 519,
                        "hold": 63,
                        "slide": 90,
                        "touch": null,
                        "break": 99,
                        "total": 771
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 665,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2017-10-17"
                }
            ],
            "searchAcronyms": [
                "⑨",
                "99",
                "9周年",
                "9周年教室",
                "9周年算数教室",
                "baka",
                "cirno ⑨",
                "Cirno 9",
                "Cirno Anniversary",
                "cirno's Perfect Math Class 9 ver",
                "Cirno's Perfect Math Class ⑨ver",
                "dxbaka",
                "九周年",
                "机厅几卡",
                "笨蛋教室"
            ]
        },
        {
            "songId": "My Dearest Song",
            "category": "オンゲキ＆CHUNITHM",
            "title": "My Dearest Song",
            "artist": "月鈴 白奈(CV:高野 麻里佳)",
            "bpm": 145,
            "imageName": "32e66e3e520c83b9f8545716cc8c5112b7f967e9e10aca62b79c47f14c0406ee",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 163,
                        "hold": 16,
                        "slide": 9,
                        "touch": null,
                        "break": 5,
                        "total": 193
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 648,
                    "releaseDate": "2017-10-31"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 95,
                        "slide": 17,
                        "touch": null,
                        "break": 10,
                        "total": 331
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 648,
                    "releaseDate": "2017-10-31"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 334,
                        "hold": 49,
                        "slide": 77,
                        "touch": null,
                        "break": 15,
                        "total": 475
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 648,
                    "releaseDate": "2017-10-31"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 610,
                        "hold": 46,
                        "slide": 132,
                        "touch": null,
                        "break": 14,
                        "total": 802
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 648,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2017-10-31"
                }
            ],
            "searchAcronyms": [
                "大提琴",
                "女人拉提琴",
                "我最亲爱的乐曲",
                "我爱歌",
                "生日歌"
            ]
        },
        {
            "songId": "猛進ソリストライフ！",
            "category": "オンゲキ＆CHUNITHM",
            "title": "猛進ソリストライフ！",
            "artist": "月鈴 那知(CV:今村 彩夏)",
            "bpm": 189,
            "imageName": "0214bb121ddbd94c2d6bcda32e0e2c6f52deaf214487233608f87f528b257cbe",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 144,
                        "hold": 85,
                        "slide": 9,
                        "touch": null,
                        "break": 14,
                        "total": 252
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 649,
                    "releaseDate": "2017-10-31"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 32,
                        "slide": 20,
                        "touch": null,
                        "break": 3,
                        "total": 419
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 649,
                    "releaseDate": "2017-10-31"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 469,
                        "hold": 100,
                        "slide": 57,
                        "touch": null,
                        "break": 8,
                        "total": 634
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 649,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2017-10-31"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 625,
                        "hold": 78,
                        "slide": 118,
                        "touch": null,
                        "break": 35,
                        "total": 856
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 649,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "FESTiVAL": 13.9,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.6,
                        "Splash PLUS": 13.6,
                        "UNiVERSE": 13.6,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2017-10-31"
                }
            ],
            "searchAcronyms": [
                "Mo-shin Soliste Life!",
                "soliste",
                "小提琴",
                "猛进"
            ]
        },
        {
            "songId": "幸せになれる隠しコマンドがあるらしい",
            "category": "niconico＆ボーカロイド",
            "title": "幸せになれる隠しコマンドがあるらしい",
            "artist": "うたたP",
            "bpm": 142,
            "imageName": "1d3bfd6d62074f9ccb90f60d69ae6a54d712b0a2f81bf86559a579ba9d31aa95",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 4,
                        "slide": 2,
                        "touch": null,
                        "break": 14,
                        "total": 276
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 432,
                    "releaseDate": "2017-11-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 346,
                        "hold": 80,
                        "slide": 10,
                        "touch": null,
                        "break": 14,
                        "total": 450
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 432,
                    "releaseDate": "2017-11-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 388,
                        "hold": 81,
                        "slide": 59,
                        "touch": null,
                        "break": 10,
                        "total": 538
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 432,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.2
                    },
                    "releaseDate": "2017-11-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 621,
                        "hold": 37,
                        "slide": 175,
                        "touch": null,
                        "break": 17,
                        "total": 850
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 432,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 14,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2017-11-21"
                }
            ],
            "searchAcronyms": [
                "→↓↑→→↓→→↑↑↓↓←→←→",
                "😅",
                "It Seems Like There's A Secret Command To Becoming Happy",
                "shiawase",
                "Shiawase ni Nareru Kakushi Command ga Arurashii",
                "There's Supposed to Be a Cheat Code for Happiness",
                "むちゃぶり",
                "不玩了",
                "似乎有着能够蹭死我的隐藏配置",
                "差不多得了",
                "幸福指令",
                "幸隐",
                "性性性",
                "性瘾",
                "视力检测",
                "结月流汗",
                "结月缘",
                "结月缘黑丝兔女郎"
            ]
        },
        {
            "songId": "白ゆき",
            "category": "niconico＆ボーカロイド",
            "title": "白ゆき",
            "artist": "n-buna",
            "bpm": 210,
            "imageName": "063e0f1d33191801b0def65151cb2935e2123baee6faf2934c34fda94781b290",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 6,
                        "slide": 8,
                        "touch": null,
                        "break": 3,
                        "total": 171
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 587,
                    "releaseDate": "2017-11-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 18,
                        "slide": 8,
                        "touch": null,
                        "break": 5,
                        "total": 323
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 587,
                    "releaseDate": "2017-11-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 373,
                        "hold": 54,
                        "slide": 19,
                        "touch": null,
                        "break": 2,
                        "total": 448
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 587,
                    "releaseDate": "2017-11-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 532,
                        "hold": 55,
                        "slide": 114,
                        "touch": null,
                        "break": 18,
                        "total": 719
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 587,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2017-11-21"
                }
            ],
            "searchAcronyms": [
                "Shirayuki",
                "拿鸽鸡鸣",
                "白雪",
                "白雪歌送武判官归京"
            ]
        },
        {
            "songId": "エイリアンエイリアン",
            "category": "niconico＆ボーカロイド",
            "title": "エイリアンエイリアン",
            "artist": "ナユタン星人",
            "bpm": 152,
            "imageName": "bf5347b1525625b4bbaae20bd9c4d6f8a86904e4b00b22859209fccfe446eb4d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 4,
                        "slide": 6,
                        "touch": null,
                        "break": 9,
                        "total": 215
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 647,
                    "releaseDate": "2017-11-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 41,
                        "slide": 6,
                        "touch": null,
                        "break": 8,
                        "total": 328
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 647,
                    "releaseDate": "2017-11-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 61,
                        "slide": 52,
                        "touch": null,
                        "break": 30,
                        "total": 480
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 647,
                    "releaseDate": "2017-11-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 563,
                        "hold": 38,
                        "slide": 110,
                        "touch": null,
                        "break": 45,
                        "total": 756
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 647,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.3,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2017-11-21"
                }
            ],
            "searchAcronyms": [
                "👽",
                "alien",
                "Alien Alien",
                "外星人",
                "外星人外星人",
                "奥利奥利安",
                "奥利安奥利安",
                "河南人",
                "河南人我就是河南人",
                "群友",
                "阿里安"
            ]
        },
        {
            "songId": "フラジール",
            "category": "niconico＆ボーカロイド",
            "title": "フラジール",
            "artist": "ぬゆり",
            "bpm": 127,
            "imageName": "a31147a0c3331dd8c4a87a46bc15b5ee61cfb88658688d90aa1bf3aa03597231",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 161,
                        "hold": 14,
                        "slide": 6,
                        "touch": null,
                        "break": 7,
                        "total": 188
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 655,
                    "releaseDate": "2017-11-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 46,
                        "slide": 20,
                        "touch": null,
                        "break": 3,
                        "total": 283
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 655,
                    "releaseDate": "2017-11-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 296,
                        "hold": 41,
                        "slide": 57,
                        "touch": null,
                        "break": 4,
                        "total": 398
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 655,
                    "releaseDate": "2017-11-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 557,
                        "hold": 53,
                        "slide": 46,
                        "touch": null,
                        "break": 8,
                        "total": 664
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 655,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2017-11-21"
                }
            ],
            "searchAcronyms": [
                "fragile",
                "易碎",
                "易碎品",
                "脆弱"
            ]
        },
        {
            "songId": "日本の米は世界一",
            "category": "POPS＆アニメ",
            "title": "日本の米は世界一",
            "artist": "打首獄門同好会",
            "bpm": 138,
            "imageName": "b826b798c9ec68585cad33bbf3da1b71548b14e758ea13c05daff73b6bbf02fe",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 161,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 173
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 636,
                    "releaseDate": "2017-12-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 201,
                        "hold": 14,
                        "slide": 9,
                        "touch": null,
                        "break": 62,
                        "total": 286
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 636,
                    "releaseDate": "2017-12-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 367,
                        "hold": 28,
                        "slide": 14,
                        "touch": null,
                        "break": 54,
                        "total": 463
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 636,
                    "releaseDate": "2017-12-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 390,
                        "hold": 56,
                        "slide": 110,
                        "touch": null,
                        "break": 150,
                        "total": 706
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 636,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.2
                    },
                    "releaseDate": "2017-12-05"
                }
            ],
            "searchAcronyms": [
                "🌾",
                "kib青春版",
                "日本大米世界第一",
                "日本米",
                "日本米世界一",
                "日本绝赞世界第一",
                "水稻",
                "水稻滞销帮帮我们"
            ]
        },
        {
            "songId": "ないせんのうた",
            "category": "niconico＆ボーカロイド",
            "title": "ないせんのうた",
            "artist": "ナイセン - momoco-",
            "bpm": 184,
            "imageName": "81d9e2b313ea38f41afbba47c59425dcc120e06fe570a2c228a21a9f50cce6eb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 12,
                        "slide": 7,
                        "touch": null,
                        "break": 5,
                        "total": 247
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 637,
                    "releaseDate": "2017-12-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 11,
                        "slide": 23,
                        "touch": null,
                        "break": 46,
                        "total": 410
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 637,
                    "releaseDate": "2017-12-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 358,
                        "hold": 88,
                        "slide": 54,
                        "touch": null,
                        "break": 50,
                        "total": 550
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 637,
                    "releaseDate": "2017-12-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 563,
                        "hold": 19,
                        "slide": 149,
                        "touch": null,
                        "break": 94,
                        "total": 825
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 637,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2017-12-05"
                }
            ],
            "searchAcronyms": [
                "内线",
                "内线云1",
                "再见im外星人",
                "好他妈烦",
                "好你妈烦",
                "打电话",
                "没歌",
                "这个地球是一秒都待不下去了"
            ]
        },
        {
            "songId": "Calamity Fortune",
            "category": "東方Project",
            "title": "Calamity Fortune",
            "artist": "LeaF",
            "bpm": 200,
            "imageName": "84e1340f3193eeef9dd152ebc9ed324e4c23471a9608653bca5f7cbd76665e3f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 143,
                        "hold": 15,
                        "slide": 6,
                        "touch": 18,
                        "break": 4,
                        "total": 186
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10641,
                    "releaseDate": "2019-10-31"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 327,
                        "hold": 21,
                        "slide": 20,
                        "touch": 21,
                        "break": 24,
                        "total": 413
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10641,
                    "releaseDate": "2019-10-31"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 316,
                        "hold": 64,
                        "slide": 52,
                        "touch": 108,
                        "break": 18,
                        "total": 558
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10641,
                    "releaseDate": "2019-10-31"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 622,
                        "hold": 98,
                        "slide": 73,
                        "touch": 123,
                        "break": 19,
                        "total": 935
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10641,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2019-10-31"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 283,
                        "hold": 8,
                        "slide": 20,
                        "touch": null,
                        "break": 12,
                        "total": 323
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 641,
                    "releaseDate": "2017-12-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 321,
                        "hold": 47,
                        "slide": 27,
                        "touch": null,
                        "break": 12,
                        "total": 407
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 641,
                    "releaseDate": "2017-12-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 363,
                        "hold": 58,
                        "slide": 163,
                        "touch": null,
                        "break": 24,
                        "total": 608
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 641,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2017-12-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 978,
                        "hold": 24,
                        "slide": 115,
                        "touch": null,
                        "break": 25,
                        "total": 1142
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 641,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14.1,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "Splash": 14.1,
                        "Splash PLUS": 14.1,
                        "UNiVERSE": 14.1,
                        "UNiVERSE PLUS": 14.1,
                        "maimaiでらっくす PLUS": 14.1
                    },
                    "releaseDate": "2017-12-05"
                }
            ],
            "searchAcronyms": [
                "cf",
                "CF",
                "dxcf",
                "leaf教你画星星",
                "卡拉米提佛纯",
                "早苗教你画星星",
                "标cf",
                "标准cf",
                "灾厄命运",
                "穿越火线"
            ]
        },
        {
            "songId": "ユビキリ",
            "category": "maimai",
            "title": "ユビキリ",
            "artist": "山根ミチル",
            "bpm": 174,
            "imageName": "29bb579bd41ef66304a02fe92707894ff47ff3ae7a4cb1328e3084b732a60344",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 2,
                        "slide": 3,
                        "touch": null,
                        "break": 9,
                        "total": 176
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 236,
                    "releaseDate": "2017-08-10"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 294,
                        "hold": 38,
                        "slide": 26,
                        "touch": null,
                        "break": 10,
                        "total": 368
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 236,
                    "releaseDate": "2017-08-10"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 376,
                        "hold": 55,
                        "slide": 88,
                        "touch": null,
                        "break": 10,
                        "total": 529
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 236,
                    "releaseDate": "2017-08-10"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "原田ひろゆき",
                    "noteCounts": {
                        "tap": 396,
                        "hold": 13,
                        "slide": 195,
                        "touch": null,
                        "break": 38,
                        "total": 642
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MURASAKi PLUS",
                    "internalId": 236,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2017-08-10"
                }
            ],
            "searchAcronyms": [
                "勾指起誓",
                "拉勾勾",
                "舞萌爱情故事"
            ]
        },
        {
            "songId": "泡沫、哀のまほろば",
            "category": "東方Project",
            "title": "泡沫、哀のまほろば",
            "artist": "幽閉サテライト(Produce:嵯峨飛鳥 Arranged:Iceon)",
            "bpm": 155,
            "imageName": "3d917d963325e23bd1ba39c4b0d3512cf8938e724ba65084a8f78ca9f32368f9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 126,
                        "hold": 4,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 140
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 540,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 152,
                        "hold": 24,
                        "slide": 27,
                        "touch": null,
                        "break": 8,
                        "total": 211
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 540,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 195,
                        "hold": 32,
                        "slide": 40,
                        "touch": null,
                        "break": 3,
                        "total": 270
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 540,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 51,
                        "slide": 71,
                        "touch": null,
                        "break": 13,
                        "total": 392
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 540,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2017-12-14"
                }
            ],
            "searchAcronyms": [
                "Utakata, Ai No Mahoroba",
                "妹红泡水",
                "泡沫",
                "泡沫哀"
            ]
        },
        {
            "songId": "ようこそジャパリパークへ",
            "category": "POPS＆アニメ",
            "title": "ようこそジャパリパークへ",
            "artist": "どうぶつビスケッツ×PPP「けものフレンズ」",
            "bpm": 170,
            "imageName": "1ade3d00cd5b7c2066b0538ae03935f01929b5b146f91cf780f22d6328c894a2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 110,
                        "hold": 1,
                        "slide": 3,
                        "touch": 14,
                        "break": 1,
                        "total": 129
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10668,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 13,
                        "slide": 5,
                        "touch": 9,
                        "break": 7,
                        "total": 284
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10668,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 299,
                        "hold": 17,
                        "slide": 15,
                        "touch": 17,
                        "break": 12,
                        "total": 360
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10668,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 29,
                        "slide": 75,
                        "touch": 45,
                        "break": 7,
                        "total": 507
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10668,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 6,
                        "slide": 4,
                        "touch": null,
                        "break": 6,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 668,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 24,
                        "slide": 13,
                        "touch": null,
                        "break": 16,
                        "total": 282
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 668,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 33,
                        "slide": 47,
                        "touch": null,
                        "break": 27,
                        "total": 391
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 668,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 371,
                        "hold": 21,
                        "slide": 79,
                        "touch": null,
                        "break": 41,
                        "total": 512
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 668,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash": 12
                    },
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 24,
                        "slide": 109,
                        "touch": null,
                        "break": 30,
                        "total": 505
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 668,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.4,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2018-12-24"
                }
            ],
            "searchAcronyms": [
                "Welcome to Japari Park",
                "Youkoso Jyapariparkhe"
            ]
        },
        {
            "songId": "MilK",
            "category": "ゲーム＆バラエティ",
            "title": "MilK",
            "artist": "モリモリあつし",
            "bpm": 150,
            "imageName": "74bb2329ef26c43658d24797d05f41e3907a5ad281831712ab265d655bb21656",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 6,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 191
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 672,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 25,
                        "slide": 7,
                        "touch": null,
                        "break": 12,
                        "total": 334
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 672,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "rioN",
                    "noteCounts": {
                        "tap": 333,
                        "hold": 125,
                        "slide": 53,
                        "touch": null,
                        "break": 40,
                        "total": 551
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 672,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.6,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 424,
                        "hold": 76,
                        "slide": 83,
                        "touch": null,
                        "break": 53,
                        "total": 636
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 672,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.1
                    },
                    "releaseDate": "2017-12-14"
                }
            ],
            "searchAcronyms": [
                "牛奶",
                "白色液体"
            ]
        },
        {
            "songId": "咲キ誇レ常世ノ華",
            "category": "maimai",
            "title": "咲キ誇レ常世ノ華",
            "artist": "Sou×マチゲリータ",
            "bpm": 170,
            "imageName": "8864669ddd0915831181e9f661307e1197e66ce0a2e00d11aeb6f55503eb609f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 183,
                        "hold": 5,
                        "slide": 8,
                        "touch": null,
                        "break": 8,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 673,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 36,
                        "slide": 6,
                        "touch": null,
                        "break": 13,
                        "total": 370
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 673,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 450,
                        "hold": 42,
                        "slide": 36,
                        "touch": null,
                        "break": 9,
                        "total": 537
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 673,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 579,
                        "hold": 42,
                        "slide": 155,
                        "touch": null,
                        "break": 28,
                        "total": 804
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 673,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM PLUS": 13.5,
                        "Splash": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13.2
                    },
                    "releaseDate": "2017-12-14"
                }
            ],
            "searchAcronyms": [
                "Sakihokore Tokoyo No Hana",
                "常世",
                "常世之华",
                "常世华",
                "永远盛开在世上的灿烂花"
            ]
        },
        {
            "songId": "Magical Flavor",
            "category": "maimai",
            "title": "Magical Flavor",
            "artist": "DECO*27 feat.Tia",
            "bpm": 98,
            "imageName": "77d031de5abea739be889a395a75d56d2ed0b8d53d089eb72e7852a8d44c2eb3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 139,
                        "hold": 9,
                        "slide": 3,
                        "touch": 20,
                        "break": 3,
                        "total": 174
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-25"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 13,
                        "slide": 4,
                        "touch": 12,
                        "break": 6,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-25"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 39,
                        "slide": 10,
                        "touch": 14,
                        "break": 19,
                        "total": 446
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-25"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "きょむりん",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 56,
                        "slide": 55,
                        "touch": 41,
                        "break": 20,
                        "total": 547
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2
                    },
                    "releaseDate": "2025-09-25"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 149,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 159
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 674,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 207,
                        "hold": 40,
                        "slide": 16,
                        "touch": null,
                        "break": 6,
                        "total": 269
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 674,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 41,
                        "slide": 26,
                        "touch": null,
                        "break": 7,
                        "total": 426
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 674,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 477,
                        "hold": 27,
                        "slide": 75,
                        "touch": null,
                        "break": 14,
                        "total": 593
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 674,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.4
                    },
                    "releaseDate": "2017-12-14"
                }
            ],
            "searchAcronyms": [
                "mf",
                "milk+op",
                "唐氏味道",
                "魔法味道",
                "魔法风味"
            ]
        },
        {
            "songId": "REVIVER オルタンシア・サーガ -蒼の騎士団- オリジナルVer.",
            "category": "POPS＆アニメ",
            "title": "REVIVER オルタンシア・サーガ -蒼の騎士団- オリジナルVer.",
            "artist": "MY FIRST STORY",
            "bpm": 200,
            "imageName": "29de3d8bf370e25b4c907817b7b7c732c6c4bd0f3e28203987711d429c5fa09f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 152,
                        "hold": 3,
                        "slide": 7,
                        "touch": null,
                        "break": 3,
                        "total": 165
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 710,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 7,
                        "slide": 7,
                        "touch": null,
                        "break": 8,
                        "total": 286
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 710,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 372,
                        "hold": 48,
                        "slide": 39,
                        "touch": null,
                        "break": 8,
                        "total": 467
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 710,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 467,
                        "hold": 30,
                        "slide": 122,
                        "touch": null,
                        "break": 13,
                        "total": 632
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 710,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.5
                    },
                    "releaseDate": "2017-12-14"
                }
            ],
            "searchAcronyms": [
                "REVIVER",
                "伝説のオルタンシアの蒼の騎士団！",
                "你妈",
                "歌名很长的那首",
                "苍之骑士团",
                "迪拉熊骂人",
                "骑士团"
            ]
        },
        {
            "songId": "拝啓ドッペルゲンガー",
            "category": "niconico＆ボーカロイド",
            "title": "拝啓ドッペルゲンガー",
            "artist": "kemu",
            "bpm": 181,
            "imageName": "00aa762ec9cbf5285c39c61917c5a48cc7285d8af825f6ea837e968f94c86c48",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 12,
                        "slide": 9,
                        "touch": null,
                        "break": 5,
                        "total": 256
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 711,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 448,
                        "hold": 36,
                        "slide": 10,
                        "touch": null,
                        "break": 11,
                        "total": 505
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 711,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 481,
                        "hold": 94,
                        "slide": 51,
                        "touch": null,
                        "break": 21,
                        "total": 647
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 711,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.6,
                        "BUDDiES PLUS": 12.6,
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL": 12.6,
                        "FESTiVAL PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "UNiVERSE PLUS": 12.6
                    },
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 835,
                        "hold": 48,
                        "slide": 124,
                        "touch": null,
                        "break": 63,
                        "total": 1070
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 711,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.4,
                        "Splash PLUS": 13.4,
                        "UNiVERSE": 13.4,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2017-12-14"
                }
            ],
            "searchAcronyms": [
                "DEAR DOPPELGANGER",
                "分身",
                "影分身十字斩",
                "我裂开来",
                "拜启",
                "敬启",
                "敬启我的分身"
            ]
        },
        {
            "songId": "砂の惑星 feat. HATSUNE MIKU",
            "category": "niconico＆ボーカロイド",
            "title": "砂の惑星 feat. HATSUNE MIKU",
            "artist": "ハチ",
            "bpm": 95,
            "imageName": "00565c25d42a006972ca6c93da8f2817ab9a845d48dfb4454a4817fed8256a07",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 116,
                        "hold": 12,
                        "slide": 2,
                        "touch": null,
                        "break": 4,
                        "total": 134
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 725,
                    "releaseDate": "2017-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 143,
                        "hold": 47,
                        "slide": 20,
                        "touch": null,
                        "break": 10,
                        "total": 220
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 725,
                    "releaseDate": "2017-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 380,
                        "hold": 63,
                        "slide": 36,
                        "touch": null,
                        "break": 2,
                        "total": 481
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 725,
                    "releaseDate": "2017-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 582,
                        "hold": 54,
                        "slide": 75,
                        "touch": null,
                        "break": 8,
                        "total": 719
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 725,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.6
                    },
                    "releaseDate": "2017-12-04"
                }
            ],
            "searchAcronyms": [
                "dune",
                "DUNE feat. Hatsune Miku",
                "傻子火星",
                "傻屌惑星",
                "最速殿堂",
                "别急18",
                "山东卫星",
                "杀马惑星",
                "沙之惑星",
                "沙之行星",
                "沙口惑星",
                "沙星",
                "沙比惑星",
                "砂の惑星",
                "砂之惑星",
                "砂之行星",
                "砂惑",
                "砂星",
                "砂比惑星"
            ]
        },
        {
            "songId": "アンノウン・マザーグース",
            "category": "niconico＆ボーカロイド",
            "title": "アンノウン・マザーグース",
            "artist": "wowaka",
            "bpm": 222,
            "imageName": "11133ec5da889c8a868859fe34044fa29c45ada046daf0874b79acffd0e8accf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 18,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 167
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 726,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 48,
                        "slide": 9,
                        "touch": null,
                        "break": 6,
                        "total": 326
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 726,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 66,
                        "slide": 56,
                        "touch": null,
                        "break": 9,
                        "total": 483
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 726,
                    "releaseDate": "2017-12-14"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 566,
                        "hold": 83,
                        "slide": 65,
                        "touch": null,
                        "break": 18,
                        "total": 732
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 726,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2017-12-14"
                }
            ],
            "searchAcronyms": [
                "unknown mother goose",
                "Unknown Mother-Goose",
                "不为人知的鹅妈妈童谣",
                "仁王盾",
                "妈妈鹅",
                "鹅妈妈"
            ]
        },
        {
            "songId": "Bang Babang Bang!!!",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Bang Babang Bang!!!",
            "artist": "御形 アリシアナ(CV:福原 綾香)",
            "bpm": 200,
            "imageName": "d0e923c83bd2830e62959b91d7b5c4f96339ffe9ddc9209bfbf8ac1042b9bd35",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 4,
                        "slide": 9,
                        "touch": null,
                        "break": 5,
                        "total": 208
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 721,
                    "releaseDate": "2017-12-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 29,
                        "slide": 15,
                        "touch": null,
                        "break": 26,
                        "total": 343
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 721,
                    "releaseDate": "2017-12-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 453,
                        "hold": 48,
                        "slide": 27,
                        "touch": null,
                        "break": 62,
                        "total": 590
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 721,
                    "releaseDate": "2017-12-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 565,
                        "hold": 35,
                        "slide": 112,
                        "touch": null,
                        "break": 44,
                        "total": 756
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 721,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2017-12-26"
                }
            ],
            "searchAcronyms": [
                "bbb",
                "BBB",
                "bbbb",
                "大柰子",
                "大胸",
                "太大了",
                "太大了我都看晕了",
                "邦邦",
                "邦邦邦",
                "邦邦邦邦"
            ]
        },
        {
            "songId": "Tic Tac DREAMIN’",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Tic Tac DREAMIN’",
            "artist": "天王洲 なずな(CV:山本 彩乃)",
            "bpm": 125,
            "imageName": "be052276c428bf738b8c7d2d2774b4d335f054b8727acc66f84e1def55d90696",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 5,
                        "slide": 11,
                        "touch": null,
                        "break": 2,
                        "total": 169
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 722,
                    "releaseDate": "2017-12-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 19,
                        "slide": 21,
                        "touch": null,
                        "break": 3,
                        "total": 284
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 722,
                    "releaseDate": "2017-12-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 252,
                        "hold": 40,
                        "slide": 41,
                        "touch": null,
                        "break": 7,
                        "total": 340
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 722,
                    "releaseDate": "2017-12-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.1,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 380,
                        "hold": 46,
                        "slide": 86,
                        "touch": null,
                        "break": 20,
                        "total": 532
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 722,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.1,
                        "CiRCLE PLUS": 12.1,
                        "FESTiVAL": 12.1,
                        "PRiSM PLUS": 12.1
                    },
                    "releaseDate": "2017-12-26"
                }
            ],
            "searchAcronyms": [
                "⏰",
                "睡衣",
                "粉毛睡衣"
            ]
        },
        {
            "songId": "SPICY SWINGY STYLE",
            "category": "オンゲキ＆CHUNITHM",
            "title": "SPICY SWINGY STYLE",
            "artist": "明坂 芹菜(CV:新田 恵海)",
            "bpm": 242,
            "imageName": "12eddbaad9e4c59d5d76d9c20b7e6d501cbe9c5531f7857b67fd0f5f58fbbab4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 165,
                        "hold": 5,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 180
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 723,
                    "releaseDate": "2017-12-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 303,
                        "hold": 21,
                        "slide": 5,
                        "touch": null,
                        "break": 9,
                        "total": 338
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 723,
                    "releaseDate": "2017-12-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 407,
                        "hold": 20,
                        "slide": 65,
                        "touch": null,
                        "break": 16,
                        "total": 508
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 723,
                    "releaseDate": "2017-12-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 547,
                        "hold": 44,
                        "slide": 47,
                        "touch": null,
                        "break": 22,
                        "total": 660
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 723,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.4
                    },
                    "releaseDate": "2017-12-26"
                }
            ],
            "searchAcronyms": [
                "sss",
                "SSS"
            ]
        },
        {
            "songId": "白い雪のプリンセスは",
            "category": "niconico＆ボーカロイド",
            "title": "白い雪のプリンセスは",
            "artist": "のぼる↑",
            "bpm": 200,
            "imageName": "44be0f71fa5e9455ed9de3abe0aac78fac997ea889b1f65af2a4de122fb12aef",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 238,
                        "hold": 5,
                        "slide": 9,
                        "touch": null,
                        "break": 2,
                        "total": 254
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 675,
                    "releaseDate": "2018-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 329,
                        "hold": 12,
                        "slide": 15,
                        "touch": null,
                        "break": 3,
                        "total": 359
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 675,
                    "releaseDate": "2018-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 501,
                        "hold": 60,
                        "slide": 28,
                        "touch": null,
                        "break": 16,
                        "total": 605
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 675,
                    "releaseDate": "2018-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 504,
                        "hold": 39,
                        "slide": 137,
                        "touch": null,
                        "break": 41,
                        "total": 721
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 675,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.4,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2018-01-09"
                }
            ],
            "searchAcronyms": [
                "The Snow White Princess is"
            ]
        },
        {
            "songId": "好き！雪！本気マジック",
            "category": "niconico＆ボーカロイド",
            "title": "好き！雪！本気マジック",
            "artist": "Mitchie M",
            "bpm": 167,
            "imageName": "ae4c9cec39f45186da46ce510f5b715a5dc75a512cd5a236316a41987d045e0d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 8,
                        "slide": 9,
                        "touch": null,
                        "break": 2,
                        "total": 205
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 676,
                    "releaseDate": "2018-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 21,
                        "slide": 21,
                        "touch": null,
                        "break": 4,
                        "total": 395
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 676,
                    "releaseDate": "2018-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 416,
                        "hold": 65,
                        "slide": 31,
                        "touch": null,
                        "break": 12,
                        "total": 524
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 676,
                    "releaseDate": "2018-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 494,
                        "hold": 53,
                        "slide": 122,
                        "touch": null,
                        "break": 17,
                        "total": 686
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 676,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2018-01-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "スターナイトスノウ",
            "category": "niconico＆ボーカロイド",
            "title": "スターナイトスノウ",
            "artist": "n-buna × Orangestar",
            "bpm": 180,
            "imageName": "800078919f30c83e0bd5f3551b7ed46356aeb7aab2ebc73df07d1be4b954f763",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 204,
                        "hold": 4,
                        "slide": 10,
                        "touch": null,
                        "break": 6,
                        "total": 224
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 677,
                    "releaseDate": "2018-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 7,
                        "slide": 14,
                        "touch": null,
                        "break": 4,
                        "total": 381
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 677,
                    "releaseDate": "2018-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 404,
                        "hold": 54,
                        "slide": 12,
                        "touch": null,
                        "break": 5,
                        "total": 475
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 677,
                    "releaseDate": "2018-01-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 39,
                        "slide": 93,
                        "touch": null,
                        "break": 9,
                        "total": 505
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 677,
                    "releaseDate": "2018-01-09"
                }
            ],
            "searchAcronyms": [
                "Star Night Snow"
            ]
        },
        {
            "songId": "Signature",
            "category": "maimai",
            "title": "Signature",
            "artist": "Palme",
            "bpm": 128,
            "imageName": "2fe45579a999842ed12651d5f00ce07db26a893a6801c154dd10413574b8bf14",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 10,
                        "slide": 10,
                        "touch": null,
                        "break": 2,
                        "total": 184
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 681,
                    "releaseDate": "2018-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 307,
                        "hold": 19,
                        "slide": 16,
                        "touch": null,
                        "break": 14,
                        "total": 356
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 681,
                    "releaseDate": "2018-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 416,
                        "hold": 32,
                        "slide": 51,
                        "touch": null,
                        "break": 4,
                        "total": 503
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 681,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.4,
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2018-01-23"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 562,
                        "hold": 45,
                        "slide": 65,
                        "touch": null,
                        "break": 26,
                        "total": 698
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 681,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.6,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.4
                    },
                    "releaseDate": "2018-01-23"
                }
            ],
            "searchAcronyms": [
                "签名",
                "签名卡"
            ]
        },
        {
            "songId": "ドーナツホール",
            "category": "niconico＆ボーカロイド",
            "title": "ドーナツホール",
            "artist": "ハチ",
            "bpm": 252,
            "imageName": "63598e6560fb7483d47b0f177e04662847ebfa5988727f921a20f594470bd2c5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 8,
                        "slide": 8,
                        "touch": null,
                        "break": 7,
                        "total": 212
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 670,
                    "releaseDate": "2018-02-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 12,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 352
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 670,
                    "releaseDate": "2018-02-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Moon Strix",
                    "noteCounts": {
                        "tap": 425,
                        "hold": 81,
                        "slide": 38,
                        "touch": null,
                        "break": 8,
                        "total": 552
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 670,
                    "releaseDate": "2018-02-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 752,
                        "hold": 32,
                        "slide": 139,
                        "touch": null,
                        "break": 11,
                        "total": 934
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 670,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.3
                    },
                    "releaseDate": "2018-02-06"
                }
            ],
            "searchAcronyms": [
                "🍩",
                "DONUT HOLE",
                "甜圈洞",
                "甜甜圈",
                "甜甜圈洞"
            ]
        },
        {
            "songId": "人生リセットボタン",
            "category": "niconico＆ボーカロイド",
            "title": "人生リセットボタン",
            "artist": "kemu",
            "bpm": 200,
            "imageName": "5d0942d37bd163852b541ad04d1563f952794550847853a3ada8ef1955a83249",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 10,
                        "slide": 9,
                        "touch": null,
                        "break": 4,
                        "total": 252
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 682,
                    "releaseDate": "2018-02-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 371,
                        "hold": 8,
                        "slide": 7,
                        "touch": null,
                        "break": 11,
                        "total": 397
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 682,
                    "releaseDate": "2018-02-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 12.1,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 514,
                        "hold": 40,
                        "slide": 41,
                        "touch": null,
                        "break": 19,
                        "total": 614
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 682,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 12.1,
                        "UNiVERSE PLUS": 12.1
                    },
                    "releaseDate": "2018-02-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 701,
                        "hold": 48,
                        "slide": 166,
                        "touch": null,
                        "break": 52,
                        "total": 967
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 682,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2018-02-06"
                }
            ],
            "searchAcronyms": [
                "dame",
                "Life Reset Button",
                "remake",
                "人生",
                "人生reset button",
                "人生复位按钮",
                "人生重启",
                "人生重启按钮",
                "人生重启键",
                "人生重开",
                "人生重来键",
                "人生重置",
                "人生重置按钮",
                "人生重置键",
                "重开按钮"
            ]
        },
        {
            "songId": "しねばいいのに",
            "category": "niconico＆ボーカロイド",
            "title": "しねばいいのに",
            "artist": "どぶウサギ",
            "bpm": 138,
            "imageName": "88647e9eaec73091b9dc81d0fcd73ddd0083e9eb6380164d1e6ac54f2e088799",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 122,
                        "hold": 6,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 134
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 683,
                    "releaseDate": "2018-02-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 28,
                        "slide": 10,
                        "touch": null,
                        "break": 7,
                        "total": 234
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 683,
                    "releaseDate": "2018-02-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 177,
                        "hold": 27,
                        "slide": 67,
                        "touch": null,
                        "break": 21,
                        "total": 292
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 683,
                    "releaseDate": "2018-02-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 321,
                        "hold": 63,
                        "slide": 70,
                        "touch": null,
                        "break": 25,
                        "total": 479
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 683,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2018-02-06"
                }
            ],
            "searchAcronyms": [
                "不如死了算了",
                "你们怎么不去死",
                "去死死算了",
                "明明死了就好了",
                "死了一了百了",
                "死了就好",
                "死了算了",
                "洗呢吧一诺尼",
                "红烧鲤鱼",
                "红鲤鱼与绿鲤鱼",
                "西内",
                "西内吧一诺尼",
                "费玉清",
                "鲤鱼王"
            ]
        },
        {
            "songId": "もうみんなしねばいいのに",
            "category": "東方Project",
            "title": "もうみんなしねばいいのに",
            "artist": "谷屋楽",
            "bpm": 180,
            "imageName": "d4bfa83449c0580240e3bc4bd59b7c31b086a4665d4171dc005b98200c822fa8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 192,
                        "hold": 16,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 220
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 684,
                    "releaseDate": "2018-02-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 35,
                        "slide": 18,
                        "touch": null,
                        "break": 18,
                        "total": 376
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 684,
                    "releaseDate": "2018-02-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 481,
                        "hold": 27,
                        "slide": 102,
                        "touch": null,
                        "break": 36,
                        "total": 646
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 684,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2018-02-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 714,
                        "hold": 15,
                        "slide": 126,
                        "touch": null,
                        "break": 51,
                        "total": 906
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 684,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2018-02-06"
                }
            ],
            "searchAcronyms": [
                "东方难听歌",
                "全寄",
                "全灭",
                "去死吧",
                "大家一起死",
                "大家死了好",
                "大家都去死",
                "如果大家都似了就好了",
                "如果大家都趋势了就好了",
                "帕露西",
                "帕露西鬼叫",
                "很难听",
                "很难听的歌",
                "桥姬",
                "水桥帕露西",
                "要是大家都趋势就好了",
                "趋势",
                "难听",
                "难听难打",
                "骂脏话"
            ]
        },
        {
            "songId": "Excalibur ～Revived resolution～",
            "category": "maimai",
            "title": "Excalibur ～Revived resolution～",
            "artist": "Project Grimoire",
            "bpm": 200,
            "imageName": "df13eb4fceaecd5331a06f4f4635d3c39583cb9ed1b4ab2e0d51033ddc427901",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 11,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 237
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 643,
                    "releaseDate": "2018-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 45,
                        "slide": 31,
                        "touch": null,
                        "break": 15,
                        "total": 426
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 643,
                    "releaseDate": "2018-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 496,
                        "hold": 27,
                        "slide": 111,
                        "touch": null,
                        "break": 13,
                        "total": 647
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 643,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE": 12
                    },
                    "releaseDate": "2018-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 801,
                        "hold": 49,
                        "slide": 120,
                        "touch": null,
                        "break": 4,
                        "total": 974
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 643,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "FESTiVAL": 14.8,
                        "FESTiVAL PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8,
                        "Splash": 14.8,
                        "Splash PLUS": 14.8,
                        "UNiVERSE": 14.8,
                        "UNiVERSE PLUS": 14.8,
                        "maimaiでらっくす PLUS": 14.7
                    },
                    "releaseDate": "2018-02-20"
                }
            ],
            "searchAcronyms": [
                "exca",
                "excal",
                "excalibur",
                "ex咖喱棒",
                "圣剑2",
                "圣剑二",
                "生煎2",
                "福瑞2",
                "耗子传奇2"
            ]
        },
        {
            "songId": "ギリギリ最強あいまいみー！",
            "category": "POPS＆アニメ",
            "title": "ギリギリ最強あいまいみー！",
            "artist": "愛(C.V.大坪由佳) 麻衣(C.V.内田彩) ミイ(C.V.内田真礼)「あいまいみー」",
            "bpm": 185,
            "imageName": "43106332df12cde81b42e9145d0e8b45308d18b3dd22dafab988f0b643a46da5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 166,
                        "hold": 14,
                        "slide": 5,
                        "touch": null,
                        "break": 3,
                        "total": 188
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 659,
                    "releaseDate": "2018-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 249,
                        "hold": 28,
                        "slide": 10,
                        "touch": null,
                        "break": 26,
                        "total": 313
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 659,
                    "releaseDate": "2018-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 47,
                        "slide": 44,
                        "touch": null,
                        "break": 26,
                        "total": 414
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 659,
                    "releaseDate": "2018-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Revo@LC",
                    "noteCounts": {
                        "tap": 531,
                        "hold": 49,
                        "slide": 127,
                        "touch": null,
                        "break": 48,
                        "total": 755
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 659,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2018-02-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ミラクル・ショッピング",
            "category": "POPS＆アニメ",
            "title": "ミラクル・ショッピング",
            "artist": "田中マイミ",
            "bpm": 167,
            "imageName": "22182bf07d0b2e24372d989b81690a738e42d9936d141e3fca0f9cf56c69efa8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 16,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 213
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 712,
                    "releaseDate": "2018-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 20,
                        "slide": 33,
                        "touch": null,
                        "break": 16,
                        "total": 341
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 712,
                    "releaseDate": "2018-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 54,
                        "slide": 47,
                        "touch": null,
                        "break": 14,
                        "total": 450
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 712,
                    "releaseDate": "2018-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 403,
                        "hold": 25,
                        "slide": 140,
                        "touch": null,
                        "break": 73,
                        "total": 641
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 712,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2018-02-20"
                }
            ],
            "searchAcronyms": [
                "miracle shopping",
                "qq",
                "qq企鹅",
                "乱中取胜",
                "企鹅超市",
                "堂吉诃德",
                "购物"
            ]
        },
        {
            "songId": "Kinda Way",
            "category": "maimai",
            "title": "Kinda Way",
            "artist": "good-cool ft. Pete Klassen",
            "bpm": 127,
            "imageName": "50a1936228529fdeab1ce8a04b345a9047bfcaeb0e04889e432fe3cb742a5da4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 168,
                        "hold": 8,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 188
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 713,
                    "releaseDate": "2018-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 331,
                        "hold": 13,
                        "slide": 25,
                        "touch": null,
                        "break": 6,
                        "total": 375
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 713,
                    "releaseDate": "2018-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 41,
                        "slide": 57,
                        "touch": null,
                        "break": 17,
                        "total": 466
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 713,
                    "releaseDate": "2018-02-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 597,
                        "hold": 20,
                        "slide": 78,
                        "touch": null,
                        "break": 30,
                        "total": 725
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 713,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.4,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2018-02-20"
                }
            ],
            "searchAcronyms": [
                "kw",
                "健达路",
                "迷你世界"
            ]
        },
        {
            "songId": "共感覚おばけ",
            "category": "niconico＆ボーカロイド",
            "title": "共感覚おばけ",
            "artist": "ササノマリイ",
            "bpm": 184,
            "imageName": "49ffda9ef4f5c2806159c015aee2fcba24fbcce9df9aad14e81f0e4fe406438c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 8,
                        "slide": 12,
                        "touch": null,
                        "break": 3,
                        "total": 212
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 687,
                    "releaseDate": "2018-03-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 27,
                        "slide": 22,
                        "touch": null,
                        "break": 11,
                        "total": 274
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 687,
                    "releaseDate": "2018-03-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 30,
                        "slide": 47,
                        "touch": null,
                        "break": 14,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 687,
                    "releaseDate": "2018-03-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 462,
                        "hold": 51,
                        "slide": 154,
                        "touch": null,
                        "break": 15,
                        "total": 682
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 687,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.1
                    },
                    "releaseDate": "2018-03-06"
                }
            ],
            "searchAcronyms": [
                "共感怪兽",
                "共感觉"
            ]
        },
        {
            "songId": "麒麟",
            "category": "ゲーム＆バラエティ",
            "title": "麒麟",
            "artist": "sasakure.UK",
            "bpm": 220,
            "imageName": "b3835a12ab7ec04f9f4f38a383aea500459466e51b05209d550dbcce5824d971",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 245,
                        "hold": 16,
                        "slide": 8,
                        "touch": null,
                        "break": 2,
                        "total": 271
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 688,
                    "releaseDate": "2018-03-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 328,
                        "hold": 33,
                        "slide": 26,
                        "touch": null,
                        "break": 2,
                        "total": 389
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 688,
                    "releaseDate": "2018-03-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 436,
                        "hold": 63,
                        "slide": 74,
                        "touch": null,
                        "break": 9,
                        "total": 582
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 688,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2018-03-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 652,
                        "hold": 26,
                        "slide": 150,
                        "touch": null,
                        "break": 9,
                        "total": 837
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 688,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.1,
                        "BUDDiES PLUS": 14.1,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 14,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "Splash": 14,
                        "Splash PLUS": 14,
                        "UNiVERSE": 14,
                        "UNiVERSE PLUS": 14,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2018-03-06"
                }
            ],
            "searchAcronyms": [
                "🦒",
                "70",
                "kirin",
                "淇淋",
                "骑0"
            ]
        },
        {
            "songId": "Credits",
            "category": "ゲーム＆バラエティ",
            "title": "Credits",
            "artist": "Frums",
            "bpm": 179,
            "imageName": "177fc4e51b5a3c71825f8a207b56dcd85ad400ef35da941d192c1454fd18e70f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 165,
                        "hold": 8,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 181
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 689,
                    "releaseDate": "2018-03-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 69,
                        "slide": 4,
                        "touch": null,
                        "break": 6,
                        "total": 282
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 689,
                    "releaseDate": "2018-03-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 69,
                        "slide": 1,
                        "touch": null,
                        "break": 1,
                        "total": 346
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 689,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.1,
                        "UNiVERSE PLUS": 12.6
                    },
                    "releaseDate": "2018-03-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 623,
                        "hold": 72,
                        "slide": 35,
                        "touch": null,
                        "break": 3,
                        "total": 733
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 689,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6,
                        "Splash PLUS": 14.5,
                        "UNiVERSE": 14.5,
                        "UNiVERSE PLUS": 14.5
                    },
                    "releaseDate": "2018-03-06"
                }
            ],
            "searchAcronyms": [
                "corporation",
                "cre",
                "pbs",
                "xc-x",
                "信用",
                "信用卡",
                "信誉",
                "制作组",
                "可用点数",
                "学分",
                "安眠曲",
                "提供",
                "点数"
            ]
        },
        {
            "songId": "ナンセンス文学",
            "category": "niconico＆ボーカロイド",
            "title": "ナンセンス文学",
            "artist": "Eve",
            "bpm": 154,
            "imageName": "af8985b8cdb15c987199b34bed4919b06e7c114047b75aaa9fd92b21132893df",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 204,
                        "hold": 10,
                        "slide": 4,
                        "touch": null,
                        "break": 2,
                        "total": 220
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 720,
                    "releaseDate": "2018-03-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 25,
                        "slide": 18,
                        "touch": null,
                        "break": 8,
                        "total": 336
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 720,
                    "releaseDate": "2018-03-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 380,
                        "hold": 68,
                        "slide": 72,
                        "touch": null,
                        "break": 8,
                        "total": 528
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 720,
                    "releaseDate": "2018-03-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 657,
                        "hold": 69,
                        "slide": 92,
                        "touch": null,
                        "break": 10,
                        "total": 828
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 720,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2018-03-06"
                }
            ],
            "searchAcronyms": [
                "latata",
                "Nonsense Literature",
                "sb文学",
                "傻逼文学",
                "废话文学",
                "拍手文学",
                "文学",
                "无意义文学",
                "海底谭文学"
            ]
        },
        {
            "songId": "Candy Tall Woman",
            "category": "maimai",
            "title": "Candy Tall Woman",
            "artist": "naotyu- feat. 佐々木恵梨",
            "bpm": 190,
            "imageName": "280026aab401e1c4da7817746e6dfce2af268ce171afefc9f2aa1a72269c409b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 4,
                        "slide": 9,
                        "touch": null,
                        "break": 1,
                        "total": 203
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 680,
                    "releaseDate": "2018-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 11,
                        "slide": 31,
                        "touch": null,
                        "break": 13,
                        "total": 322
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 680,
                    "releaseDate": "2018-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ものくろっく",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 60,
                        "slide": 59,
                        "touch": null,
                        "break": 15,
                        "total": 485
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 680,
                    "releaseDate": "2018-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 591,
                        "hold": 43,
                        "slide": 80,
                        "touch": null,
                        "break": 27,
                        "total": 741
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 680,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.3,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.6,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2018-03-20"
                }
            ],
            "searchAcronyms": [
                "垃圾分类",
                "砍弟搞女人",
                "糖女士",
                "糖果高女士",
                "糖高女",
                "高血糖",
                "高血糖女人"
            ]
        },
        {
            "songId": "ダンスロボットダンス",
            "category": "niconico＆ボーカロイド",
            "title": "ダンスロボットダンス",
            "artist": "ナユタン星人",
            "bpm": 190,
            "imageName": "8575ed96deb401fbc1d28039322ec31090c81fa658bf14cbf7601f5252a12d95",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 148,
                        "hold": 20,
                        "slide": 4,
                        "touch": 7,
                        "break": 6,
                        "total": 185
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 10690,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2020-09-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 355,
                        "hold": 13,
                        "slide": 14,
                        "touch": 8,
                        "break": 4,
                        "total": 394
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 10690,
                    "multiverInternalLevelValue": {
                        "Splash": 7.5
                    },
                    "releaseDate": "2020-09-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 488,
                        "hold": 40,
                        "slide": 13,
                        "touch": 65,
                        "break": 8,
                        "total": 614
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 10690,
                    "multiverInternalLevelValue": {
                        "Splash": 9.2
                    },
                    "releaseDate": "2020-09-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 472,
                        "hold": 57,
                        "slide": 146,
                        "touch": 156,
                        "break": 16,
                        "total": 847
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 10690,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2020-09-30"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 333,
                        "hold": 14,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 355
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 690,
                    "releaseDate": "2018-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 456,
                        "hold": 26,
                        "slide": 15,
                        "touch": null,
                        "break": 4,
                        "total": 501
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 690,
                    "releaseDate": "2018-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 515,
                        "hold": 77,
                        "slide": 41,
                        "touch": null,
                        "break": 26,
                        "total": 659
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 690,
                    "releaseDate": "2018-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 530,
                        "hold": 15,
                        "slide": 232,
                        "touch": null,
                        "break": 49,
                        "total": 826
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 690,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.5
                    },
                    "releaseDate": "2018-03-20"
                }
            ],
            "searchAcronyms": [
                "↑↓",
                "☝😑👇",
                "👆🏻😑👇🏻",
                "👆👇",
                "dance robot dance",
                "Dance Robot Dance",
                "dancerobotdance",
                "drd",
                "我站在云林",
                "机器人舞",
                "机器人跳舞",
                "跳舞机器人",
                "跳舞机器人跳舞"
            ]
        },
        {
            "songId": "アルカリレットウセイ",
            "category": "niconico＆ボーカロイド",
            "title": "アルカリレットウセイ",
            "artist": "かいりきベア",
            "bpm": 158,
            "imageName": "a285016555ef6a5d1e26053d309c00fbf768d0290a23511f3ee994ad6c97e872",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 8,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 232
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 691,
                    "releaseDate": "2018-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 21,
                        "slide": 13,
                        "touch": null,
                        "break": 10,
                        "total": 322
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 691,
                    "releaseDate": "2018-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 368,
                        "hold": 66,
                        "slide": 19,
                        "touch": null,
                        "break": 5,
                        "total": 458
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 691,
                    "releaseDate": "2018-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 404,
                        "hold": 86,
                        "slide": 69,
                        "touch": null,
                        "break": 24,
                        "total": 583
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 691,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2018-03-20"
                }
            ],
            "searchAcronyms": [
                "alkali",
                "Alkali rettousei",
                "Arukari Rettousei",
                "碱性劣等生",
                "莉莉卡",
                "露露卡莉莉卡噜啦哩啦噜啦啦",
                "魔法少女",
                "魔法少女举大棒"
            ]
        },
        {
            "songId": "ドクハク",
            "category": "niconico＆ボーカロイド",
            "title": "ドクハク",
            "artist": "MARETU",
            "bpm": 208,
            "imageName": "0bfb91fea9a042ce7caac09e813d4cb3ed9b05544fde664049f1ba7cac689290",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 206,
                        "hold": 14,
                        "slide": 4,
                        "touch": null,
                        "break": 6,
                        "total": 230
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 692,
                    "releaseDate": "2018-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 64,
                        "slide": 24,
                        "touch": null,
                        "break": 5,
                        "total": 289
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 692,
                    "releaseDate": "2018-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 289,
                        "hold": 90,
                        "slide": 25,
                        "touch": null,
                        "break": 8,
                        "total": 412
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 692,
                    "releaseDate": "2018-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 471,
                        "hold": 76,
                        "slide": 92,
                        "touch": null,
                        "break": 2,
                        "total": 641
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 692,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.4
                    },
                    "releaseDate": "2018-03-20"
                }
            ],
            "searchAcronyms": [
                "⚰️",
                "卜夕八夕",
                "极恶",
                "棺材",
                "照相馆",
                "独白",
                "黑人抬棺"
            ]
        },
        {
            "songId": "キレキャリオン",
            "category": "niconico＆ボーカロイド",
            "title": "キレキャリオン",
            "artist": "ポリスピカデリー",
            "bpm": 170,
            "imageName": "ec6744f805b4ce83cce71fac22adb6d5c239a23344aafeaa32dec3545fd97824",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 6,
                        "slide": 8,
                        "touch": null,
                        "break": 2,
                        "total": 255
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 693,
                    "releaseDate": "2018-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 221,
                        "hold": 24,
                        "slide": 19,
                        "touch": null,
                        "break": 3,
                        "total": 267
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 693,
                    "releaseDate": "2018-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 423,
                        "hold": 42,
                        "slide": 41,
                        "touch": null,
                        "break": 2,
                        "total": 508
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 693,
                    "releaseDate": "2018-03-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "Moon Strix",
                    "noteCounts": {
                        "tap": 556,
                        "hold": 53,
                        "slide": 89,
                        "touch": null,
                        "break": 17,
                        "total": 715
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 693,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.1,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2018-03-20"
                }
            ],
            "searchAcronyms": [
                "carry on",
                "Kire Kyari On",
                "奶包",
                "小电锯",
                "电锯",
                "电锯2",
                "电锯娘"
            ]
        },
        {
            "songId": "猫祭り",
            "category": "オンゲキ＆CHUNITHM",
            "title": "猫祭り",
            "artist": "箱部 なる(CV:M・A・O)",
            "bpm": 160,
            "imageName": "0d5fe4a24865264cb07ae3950183f04d328f2ec48c7022d04042d4ef55f96a4d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 22,
                        "slide": 8,
                        "touch": null,
                        "break": 8,
                        "total": 222
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 694,
                    "releaseDate": "2018-04-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 33,
                        "slide": 9,
                        "touch": null,
                        "break": 39,
                        "total": 425
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 694,
                    "releaseDate": "2018-04-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 328,
                        "hold": 73,
                        "slide": 56,
                        "touch": null,
                        "break": 65,
                        "total": 522
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 694,
                    "releaseDate": "2018-04-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 446,
                        "hold": 45,
                        "slide": 193,
                        "touch": null,
                        "break": 101,
                        "total": 785
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 694,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2018-04-03"
                }
            ],
            "searchAcronyms": [
                "Neko Matsuri",
                "湖南省省歌",
                "猫",
                "猫寄",
                "猫抓板",
                "猫祭",
                "绝赞101",
                "野兽前辈被猫舔",
                "高清涩图"
            ]
        },
        {
            "songId": "TRUST",
            "category": "オンゲキ＆CHUNITHM",
            "title": "TRUST",
            "artist": "小仏 凪(CV:佐倉 薫)",
            "bpm": 190,
            "imageName": "682326e9af98b11b32d08c894a0ec8878287168ccd9665f0420c5926edc7aad3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 13,
                        "slide": 10,
                        "touch": null,
                        "break": 1,
                        "total": 223
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 695,
                    "releaseDate": "2018-04-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 19,
                        "slide": 15,
                        "touch": null,
                        "break": 3,
                        "total": 321
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 695,
                    "releaseDate": "2018-04-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 393,
                        "hold": 67,
                        "slide": 17,
                        "touch": null,
                        "break": 8,
                        "total": 485
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 695,
                    "releaseDate": "2018-04-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 585,
                        "hold": 31,
                        "slide": 97,
                        "touch": null,
                        "break": 16,
                        "total": 729
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 695,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.1,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.1,
                        "Splash": 12.6,
                        "UNiVERSE PLUS": 13.1
                    },
                    "releaseDate": "2018-04-03"
                }
            ],
            "searchAcronyms": [
                "信任",
                "创死他",
                "大脚丫子",
                "湿身少女翘脚吃冰糕",
                "玉足",
                "老冰棍",
                "脚歌",
                "足控"
            ]
        },
        {
            "songId": "Still",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Still",
            "artist": "イロドリミドリ「CHUNITHM」",
            "bpm": 176,
            "imageName": "509050cdeef2e7697fa9337c82b0980605a71905f46233216670a8368fd15cfa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 12,
                        "slide": 14,
                        "touch": null,
                        "break": 5,
                        "total": 236
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 696,
                    "releaseDate": "2018-04-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 301,
                        "hold": 23,
                        "slide": 17,
                        "touch": null,
                        "break": 6,
                        "total": 347
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 696,
                    "releaseDate": "2018-04-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 410,
                        "hold": 58,
                        "slide": 48,
                        "touch": null,
                        "break": 7,
                        "total": 523
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 696,
                    "releaseDate": "2018-04-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 588,
                        "hold": 43,
                        "slide": 139,
                        "touch": null,
                        "break": 23,
                        "total": 793
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 696,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2018-04-03"
                }
            ],
            "searchAcronyms": [
                "七对奈子",
                "仍然"
            ]
        },
        {
            "songId": "fantastic dreamer",
            "category": "POPS＆アニメ",
            "title": "fantastic dreamer",
            "artist": "Machico「この素晴らしい世界に祝福を！」",
            "bpm": 185,
            "imageName": "b20c9034c0791f38b60f0d6a993ada9c8d5d56f6116cd73b73bac02418238b6d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 4,
                        "slide": 3,
                        "touch": null,
                        "break": 4,
                        "total": 156
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 698,
                    "releaseDate": "2018-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 11,
                        "slide": 13,
                        "touch": null,
                        "break": 8,
                        "total": 229
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 698,
                    "releaseDate": "2018-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ミストルティン",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 37,
                        "slide": 31,
                        "touch": null,
                        "break": 15,
                        "total": 340
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 698,
                    "releaseDate": "2018-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 302,
                        "hold": 39,
                        "slide": 91,
                        "touch": null,
                        "break": 24,
                        "total": 456
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 698,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2018-04-17"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "SPILL OVER COLORS",
            "category": "maimai",
            "title": "SPILL OVER COLORS",
            "artist": "矢鴇つかさ feat. kalon.",
            "bpm": 142,
            "imageName": "f86d99f411a4c09e2cc9fb2d688597397ab42789000f351854e162e3c917e64c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 147,
                        "hold": 12,
                        "slide": 10,
                        "touch": null,
                        "break": 3,
                        "total": 172
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 704,
                    "releaseDate": "2018-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 24,
                        "slide": 23,
                        "touch": null,
                        "break": 10,
                        "total": 392
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 704,
                    "releaseDate": "2018-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 63,
                        "slide": 59,
                        "touch": null,
                        "break": 5,
                        "total": 483
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 704,
                    "releaseDate": "2018-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 648,
                        "hold": 12,
                        "slide": 160,
                        "touch": null,
                        "break": 12,
                        "total": 832
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 704,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2018-04-17"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 548,
                        "hold": 79,
                        "slide": 76,
                        "touch": null,
                        "break": 22,
                        "total": 725
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 704,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "UNiVERSE PLUS": 13.4
                    },
                    "releaseDate": "2022-08-18"
                }
            ],
            "searchAcronyms": [
                "🎨",
                "soc",
                "sunnyduck",
                "小画家",
                "小脸妹",
                "水手服小女孩画画",
                "画板",
                "调色板"
            ]
        },
        {
            "songId": "エンドマークに希望と涙を添えて",
            "category": "オンゲキ＆CHUNITHM",
            "title": "エンドマークに希望と涙を添えて",
            "artist": "cosMo＠暴走P",
            "bpm": 257,
            "imageName": "07aa6858d07c8011b0e8a5e90e04b38f97af727102708c8fc1ec96306fb74ba2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 215,
                        "hold": 19,
                        "slide": 4,
                        "touch": null,
                        "break": 6,
                        "total": 244
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 719,
                    "releaseDate": "2018-04-24"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 453,
                        "hold": 45,
                        "slide": 11,
                        "touch": null,
                        "break": 14,
                        "total": 523
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 719,
                    "releaseDate": "2018-04-24"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 577,
                        "hold": 72,
                        "slide": 49,
                        "touch": null,
                        "break": 4,
                        "total": 702
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 719,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "BUDDiES PLUS": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2018-04-24"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 898,
                        "hold": 42,
                        "slide": 137,
                        "touch": null,
                        "break": 28,
                        "total": 1105
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 719,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "Splash": 14.3,
                        "Splash PLUS": 14.3,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.3,
                        "maimaiでらっくす PLUS": 14.3
                    },
                    "releaseDate": "2018-04-24"
                }
            ],
            "searchAcronyms": [
                "End Mark ni Kibou to Namida wo soete",
                "Endmark",
                "为结局添上希望与泪水",
                "希望泪",
                "希望累",
                "梦之泪伤",
                "梦泪",
                "筋肉女神",
                "超级棒棒糖"
            ]
        },
        {
            "songId": "永遠のメロディ",
            "category": "東方Project",
            "title": "永遠のメロディ",
            "artist": "あ～るの～と（いえろ～ぜぶら）",
            "bpm": 155,
            "imageName": "328866b6fc2d420226956f9ba48644ed94a5e3e5e1a482222e2d53a990e30cc9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 17,
                        "slide": 10,
                        "touch": null,
                        "break": 8,
                        "total": 265
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 586,
                    "releaseDate": "2018-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 353,
                        "hold": 13,
                        "slide": 12,
                        "touch": null,
                        "break": 10,
                        "total": 388
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 586,
                    "releaseDate": "2018-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 48,
                        "slide": 65,
                        "touch": null,
                        "break": 17,
                        "total": 481
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 586,
                    "releaseDate": "2018-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 490,
                        "hold": 26,
                        "slide": 108,
                        "touch": null,
                        "break": 18,
                        "total": 642
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 586,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2018-05-08"
                }
            ],
            "searchAcronyms": [
                "Eternal Melody",
                "东方蓬千歌",
                "永远",
                "永远的melody",
                "永远的旋律",
                "永远的节奏"
            ]
        },
        {
            "songId": "天狗の落とし文 feat. ｙｔｒ",
            "category": "東方Project",
            "title": "天狗の落とし文 feat. ｙｔｒ",
            "artist": "魂音泉",
            "bpm": 160,
            "imageName": "43612f7c3eaf1e5b424788762f9cb29b635999434218d5fe2c9119116273f612",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 148,
                        "hold": 17,
                        "slide": 6,
                        "touch": 6,
                        "break": 9,
                        "total": 186
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 10699,
                    "releaseDate": "2024-11-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 17,
                        "slide": 8,
                        "touch": 26,
                        "break": 3,
                        "total": 341
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 10699,
                    "releaseDate": "2024-11-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 30,
                        "slide": 43,
                        "touch": 18,
                        "break": 26,
                        "total": 492
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 10699,
                    "releaseDate": "2024-11-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 546,
                        "hold": 30,
                        "slide": 91,
                        "touch": 20,
                        "break": 64,
                        "total": 751
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 10699,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2024-11-21"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 14,
                        "slide": 10,
                        "touch": null,
                        "break": 4,
                        "total": 222
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 699,
                    "releaseDate": "2018-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 33,
                        "slide": 15,
                        "touch": null,
                        "break": 10,
                        "total": 345
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 699,
                    "releaseDate": "2018-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 309,
                        "hold": 48,
                        "slide": 69,
                        "touch": null,
                        "break": 4,
                        "total": 430
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 699,
                    "releaseDate": "2018-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 480,
                        "hold": 45,
                        "slide": 128,
                        "touch": null,
                        "break": 33,
                        "total": 686
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 699,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2018-05-08"
                }
            ],
            "searchAcronyms": [
                "Tengu no Otoshibumi",
                "Tengu No Otoshibumi feat. Ytr",
                "ytr",
                "天狗",
                "天狗の落とし文",
                "天狗之落",
                "天狗的匿名信",
                "天狗的无名文书",
                "犹太人"
            ]
        },
        {
            "songId": "疾走あんさんぶる",
            "category": "東方Project",
            "title": "疾走あんさんぶる",
            "artist": "ビートまりお（COOL&CREATE）",
            "bpm": 195,
            "imageName": "7d8fec9fc105277e51093c9bb905e494508630466965c87fee74df08b4c2d961",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 243,
                        "hold": 8,
                        "slide": 8,
                        "touch": null,
                        "break": 3,
                        "total": 262
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 700,
                    "releaseDate": "2018-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 362,
                        "hold": 45,
                        "slide": 9,
                        "touch": null,
                        "break": 8,
                        "total": 424
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 700,
                    "releaseDate": "2018-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 490,
                        "hold": 72,
                        "slide": 43,
                        "touch": null,
                        "break": 8,
                        "total": 613
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 700,
                    "releaseDate": "2018-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 720,
                        "hold": 52,
                        "slide": 104,
                        "touch": null,
                        "break": 14,
                        "total": 890
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 700,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.4,
                        "Splash PLUS": 13.4,
                        "UNiVERSE": 13.4,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.3
                    },
                    "releaseDate": "2018-05-08"
                }
            ],
            "searchAcronyms": [
                "Sissou",
                "Sissou Ensemble",
                "疾走",
                "疾走乐队"
            ]
        },
        {
            "songId": "Doll Judgment",
            "category": "東方Project",
            "title": "Doll Judgment",
            "artist": "ぬるはち",
            "bpm": 230,
            "imageName": "81601a34e391f6d5613ef9a70adff5fe7ece9f18cc217cbca0fa25a684eb89dd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 12,
                        "slide": 6,
                        "touch": null,
                        "break": 5,
                        "total": 220
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 701,
                    "releaseDate": "2018-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 348,
                        "hold": 56,
                        "slide": 20,
                        "touch": null,
                        "break": 16,
                        "total": 440
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 701,
                    "releaseDate": "2018-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.1,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 508,
                        "hold": 75,
                        "slide": 37,
                        "touch": null,
                        "break": 8,
                        "total": 628
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 701,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.1,
                        "CiRCLE PLUS": 12.1,
                        "FESTiVAL": 12.1,
                        "PRiSM PLUS": 12.1,
                        "UNiVERSE PLUS": 12.1
                    },
                    "releaseDate": "2018-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 728,
                        "hold": 40,
                        "slide": 115,
                        "touch": null,
                        "break": 13,
                        "total": 896
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 701,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.3
                    },
                    "releaseDate": "2018-05-08"
                }
            ],
            "searchAcronyms": [
                "dj",
                "丁真",
                "人偶",
                "人偶审判",
                "人偶裁判",
                "人形审判",
                "人形裁判",
                "玩偶",
                "玩偶姐姐",
                "玩偶审判"
            ]
        },
        {
            "songId": "WARNING×WARNING×WARNING",
            "category": "東方Project",
            "title": "WARNING×WARNING×WARNING",
            "artist": "暁Records",
            "bpm": 172,
            "imageName": "b8bb713ae1d206441612dfe46ac9c62d306dd72deedee7066a165d6c0610f2e7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 108,
                        "hold": 17,
                        "slide": 9,
                        "touch": 17,
                        "break": 2,
                        "total": 153
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10702,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 298,
                        "hold": 33,
                        "slide": 14,
                        "touch": 11,
                        "break": 14,
                        "total": 370
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10702,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 377,
                        "hold": 40,
                        "slide": 38,
                        "touch": 92,
                        "break": 22,
                        "total": 569
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10702,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 467,
                        "hold": 22,
                        "slide": 137,
                        "touch": 105,
                        "break": 14,
                        "total": 745
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10702,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 195,
                        "hold": 27,
                        "slide": 15,
                        "touch": null,
                        "break": 4,
                        "total": 241
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 702,
                    "releaseDate": "2018-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 343,
                        "hold": 28,
                        "slide": 26,
                        "touch": null,
                        "break": 19,
                        "total": 416
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 702,
                    "releaseDate": "2018-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 385,
                        "hold": 79,
                        "slide": 79,
                        "touch": null,
                        "break": 26,
                        "total": 569
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 702,
                    "releaseDate": "2018-05-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 543,
                        "hold": 22,
                        "slide": 169,
                        "touch": null,
                        "break": 10,
                        "total": 744
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 702,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "UNiVERSE PLUS": 12.6
                    },
                    "releaseDate": "2018-05-08"
                }
            ],
            "searchAcronyms": [
                "warning",
                "www",
                "星条旗",
                "条纹过膝袜",
                "注意注意注意",
                "警告警告警告"
            ]
        },
        {
            "songId": "Justified",
            "category": "maimai",
            "title": "Justified",
            "artist": "MintJam feat.光吉猛修",
            "bpm": 185,
            "imageName": "0603e4770a7d5b959ab75452a43e49ad583c09b70582ef61dc6de36bb20dd4b5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 16,
                        "slide": 7,
                        "touch": null,
                        "break": 4,
                        "total": 211
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 642,
                    "releaseDate": "2018-05-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 378,
                        "hold": 26,
                        "slide": 22,
                        "touch": null,
                        "break": 14,
                        "total": 440
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 642,
                    "releaseDate": "2018-05-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 460,
                        "hold": 49,
                        "slide": 87,
                        "touch": null,
                        "break": 14,
                        "total": 610
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 642,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2018-05-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 658,
                        "hold": 41,
                        "slide": 131,
                        "touch": null,
                        "break": 42,
                        "total": 872
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 642,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.9,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2018-05-22"
                }
            ],
            "searchAcronyms": [
                "森林冰火人",
                "正义",
                "牌佬打架",
                "红蓝对决"
            ]
        },
        {
            "songId": "Mare Maris",
            "category": "maimai",
            "title": "Mare Maris",
            "artist": "M2U",
            "bpm": 150,
            "imageName": "46b077be53523799b24e1f47399a4a2bab0391e7080067fd0d8076ecf3cf3da8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 185,
                        "hold": 10,
                        "slide": 9,
                        "touch": null,
                        "break": 3,
                        "total": 207
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 705,
                    "releaseDate": "2018-05-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 323,
                        "hold": 39,
                        "slide": 17,
                        "touch": null,
                        "break": 10,
                        "total": 389
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 705,
                    "releaseDate": "2018-05-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 394,
                        "hold": 73,
                        "slide": 76,
                        "touch": null,
                        "break": 12,
                        "total": 555
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 705,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "BUDDiES PLUS": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2018-05-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 601,
                        "hold": 145,
                        "slide": 92,
                        "touch": null,
                        "break": 18,
                        "total": 856
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 705,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2018-05-22"
                }
            ],
            "searchAcronyms": [
                "⛵",
                "🚤",
                "stasis",
                "上海",
                "大航海",
                "妈妈死",
                "小白船",
                "小破船",
                "帆船",
                "开船",
                "海面谭",
                "白船来航",
                "船",
                "船歌",
                "贼船",
                "鸭屁股"
            ]
        },
        {
            "songId": "シャルル",
            "category": "niconico＆ボーカロイド",
            "title": "シャルル",
            "artist": "バルーン",
            "bpm": 145,
            "imageName": "efd7a01dac618984dbea6905ac274171a8872b641d3bfbe9b9a3ecc773f49f96",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 131,
                        "hold": 2,
                        "slide": 5,
                        "touch": 22,
                        "break": 2,
                        "total": 162
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10706,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 30,
                        "slide": 19,
                        "touch": 11,
                        "break": 10,
                        "total": 310
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10706,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 50,
                        "slide": 14,
                        "touch": 28,
                        "break": 8,
                        "total": 385
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10706,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 361,
                        "hold": 15,
                        "slide": 60,
                        "touch": 82,
                        "break": 6,
                        "total": 524
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10706,
                    "releaseDate": "2019-07-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 226,
                        "hold": 9,
                        "slide": 3,
                        "touch": null,
                        "break": 4,
                        "total": 242
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 706,
                    "releaseDate": "2018-06-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 269,
                        "hold": 26,
                        "slide": 18,
                        "touch": null,
                        "break": 13,
                        "total": 326
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 706,
                    "releaseDate": "2018-06-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 301,
                        "hold": 54,
                        "slide": 30,
                        "touch": null,
                        "break": 11,
                        "total": 396
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 706,
                    "releaseDate": "2018-06-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 445,
                        "hold": 36,
                        "slide": 69,
                        "touch": null,
                        "break": 39,
                        "total": 589
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 706,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.3,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2018-06-05"
                }
            ],
            "searchAcronyms": [
                "charles",
                "Charles",
                "三力儿儿",
                "夏露露",
                "查尔斯",
                "汁儿儿"
            ]
        },
        {
            "songId": "フリィダム ロリィタ",
            "category": "niconico＆ボーカロイド",
            "title": "フリィダム ロリィタ",
            "artist": "ねじ式",
            "bpm": 150,
            "imageName": "68964cda27f8b6f77e181881fa3352bb77d575719ec49ec6e63ff04a6662e248",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 13,
                        "slide": 5,
                        "touch": null,
                        "break": 6,
                        "total": 223
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 707,
                    "releaseDate": "2018-06-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 303,
                        "hold": 10,
                        "slide": 30,
                        "touch": null,
                        "break": 26,
                        "total": 369
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 707,
                    "releaseDate": "2018-06-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 294,
                        "hold": 49,
                        "slide": 58,
                        "touch": null,
                        "break": 22,
                        "total": 423
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 707,
                    "releaseDate": "2018-06-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 485,
                        "hold": 48,
                        "slide": 100,
                        "touch": null,
                        "break": 12,
                        "total": 645
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 707,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL": 12.6,
                        "PRiSM PLUS": 12.6,
                        "UNiVERSE PLUS": 12.6
                    },
                    "releaseDate": "2018-06-05"
                }
            ],
            "searchAcronyms": [
                "Freedom Lolita",
                "喂美少女嘘嘘",
                "喂饭",
                "嘘嘘",
                "沙县小吃",
                "洛丽塔",
                "自由洛丽塔",
                "自由的洛丽塔"
            ]
        },
        {
            "songId": "バレリーコ",
            "category": "niconico＆ボーカロイド",
            "title": "バレリーコ",
            "artist": "みきとP",
            "bpm": 150,
            "imageName": "89be566052d78435aadcb6e5a349678e4518d6c4a5780aa65ebc29a3953d5cf4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 204,
                        "hold": 12,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 708,
                    "releaseDate": "2018-06-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 268,
                        "hold": 42,
                        "slide": 10,
                        "touch": null,
                        "break": 15,
                        "total": 335
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 708,
                    "releaseDate": "2018-06-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 353,
                        "hold": 44,
                        "slide": 50,
                        "touch": null,
                        "break": 28,
                        "total": 475
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 708,
                    "releaseDate": "2018-06-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 483,
                        "hold": 39,
                        "slide": 108,
                        "touch": null,
                        "break": 44,
                        "total": 674
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 708,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL": 12.6,
                        "FESTiVAL PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "UNiVERSE PLUS": 12.6
                    },
                    "releaseDate": "2018-06-05"
                }
            ],
            "searchAcronyms": [
                "Ballerico",
                "Balleriko",
                "Ballerina Girl",
                "芭蕾",
                "芭蕾舞者"
            ]
        },
        {
            "songId": "アウターサイエンス",
            "category": "niconico＆ボーカロイド",
            "title": "アウターサイエンス",
            "artist": "じん",
            "bpm": 195,
            "imageName": "9dc10e274bb89d1e41ca0227733f76b19900f2acf8096a3df9ad5d458a3e4b00",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 210,
                        "hold": 6,
                        "slide": 5,
                        "touch": null,
                        "break": 5,
                        "total": 226
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 709,
                    "releaseDate": "2018-06-05"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 334,
                        "hold": 42,
                        "slide": 7,
                        "touch": null,
                        "break": 10,
                        "total": 393
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 709,
                    "releaseDate": "2018-06-05"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 544,
                        "hold": 33,
                        "slide": 54,
                        "touch": null,
                        "break": 32,
                        "total": 663
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 709,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2018-06-05"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 523,
                        "hold": 34,
                        "slide": 141,
                        "touch": null,
                        "break": 23,
                        "total": 721
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK",
                    "internalId": 709,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2018-06-05"
                }
            ],
            "searchAcronyms": [
                "outer science",
                "Outer Science",
                "次の",
                "界外科学"
            ]
        },
        {
            "songId": "妄想感傷代償連盟",
            "category": "niconico＆ボーカロイド",
            "title": "妄想感傷代償連盟",
            "artist": "DECO*27",
            "bpm": 110,
            "imageName": "4561fec2759e59cfce3da5473e34ec21cbc1ffaf41cb76a88adbd8b34c1bd7d1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 7,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 177
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 731,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 248,
                        "hold": 40,
                        "slide": 5,
                        "touch": null,
                        "break": 8,
                        "total": 301
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 731,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 44,
                        "slide": 33,
                        "touch": null,
                        "break": 7,
                        "total": 426
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 731,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 395,
                        "hold": 38,
                        "slide": 78,
                        "touch": null,
                        "break": 5,
                        "total": 516
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 731,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 593,
                        "hold": 23,
                        "slide": 102,
                        "touch": null,
                        "break": 7,
                        "total": 725
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 731,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.4
                    },
                    "releaseDate": "2018-06-21"
                }
            ],
            "searchAcronyms": [
                "dscf",
                "ghost",
                "MKDR",
                "啊咿呀咿呀",
                "妄伤",
                "妄想",
                "妄想感伤",
                "妄想感伤代偿联盟",
                "海底谭难民营",
                "盲肠大肠杆菌年龄",
                "盲肠肛肠大肠联盟",
                "盲肠肝肠大肠联盟",
                "盲肠肝脏大肠年龄",
                "联盟",
                "阿姨压一压",
                "鬼"
            ]
        },
        {
            "songId": "LOVE EAST",
            "category": "東方Project",
            "title": "LOVE EAST",
            "artist": "暁Records",
            "bpm": 168,
            "imageName": "64b9be88137e6721981ddacf6eab447e355c3e7e4581732c0f335bae671ca91b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 16,
                        "slide": 5,
                        "touch": null,
                        "break": 5,
                        "total": 223
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 732,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 35,
                        "slide": 13,
                        "touch": null,
                        "break": 9,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 732,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 341,
                        "hold": 50,
                        "slide": 47,
                        "touch": null,
                        "break": 20,
                        "total": 458
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 732,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 421,
                        "hold": 69,
                        "slide": 137,
                        "touch": null,
                        "break": 46,
                        "total": 673
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 732,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2018-06-21"
                }
            ],
            "searchAcronyms": [
                "广东",
                "爱东",
                "爱东方",
                "爱吃",
                "转转"
            ]
        },
        {
            "songId": "Fist Bump",
            "category": "ゲーム＆バラエティ",
            "title": "Fist Bump",
            "artist": "大谷智哉, Douglas Robb from Hoobastank「ソニック フォース」",
            "bpm": 217,
            "imageName": "88dbe2ff4e99e118ee1d361b64eb226675fef3cfc53ee0b2e0212ff96a84af5c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 18,
                        "slide": 5,
                        "touch": null,
                        "break": 4,
                        "total": 245
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 733,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 304,
                        "hold": 38,
                        "slide": 21,
                        "touch": null,
                        "break": 10,
                        "total": 373
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 733,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 383,
                        "hold": 49,
                        "slide": 50,
                        "touch": null,
                        "break": 5,
                        "total": 487
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 733,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 599,
                        "hold": 33,
                        "slide": 109,
                        "touch": null,
                        "break": 11,
                        "total": 752
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 733,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2018-06-21"
                }
            ],
            "searchAcronyms": [
                "索尼克力量"
            ]
        },
        {
            "songId": "ENERGY SYNERGY MATRIX",
            "category": "ゲーム＆バラエティ",
            "title": "ENERGY SYNERGY MATRIX",
            "artist": "Tanchiky",
            "bpm": 160,
            "imageName": "4e1165facbf138f26ccc64fd830162a497cc1ab672379f86c628aa6760ac43d1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 124,
                        "hold": 17,
                        "slide": 2,
                        "touch": 16,
                        "break": 5,
                        "total": 164
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10734,
                    "releaseDate": "2019-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 28,
                        "slide": 8,
                        "touch": 16,
                        "break": 25,
                        "total": 357
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10734,
                    "releaseDate": "2019-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 36,
                        "slide": 40,
                        "touch": 121,
                        "break": 50,
                        "total": 611
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10734,
                    "releaseDate": "2019-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 519,
                        "hold": 44,
                        "slide": 40,
                        "touch": 221,
                        "break": 46,
                        "total": 870
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 10734,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM PLUS": 13.5,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2019-10-03"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 202,
                        "hold": 19,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 229
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 734,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 316,
                        "hold": 22,
                        "slide": 10,
                        "touch": null,
                        "break": 55,
                        "total": 403
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 734,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 489,
                        "hold": 35,
                        "slide": 48,
                        "touch": null,
                        "break": 92,
                        "total": 664
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 734,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 661,
                        "hold": 51,
                        "slide": 80,
                        "touch": null,
                        "break": 80,
                        "total": 872
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 734,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2018-06-21"
                }
            ],
            "searchAcronyms": [
                "dxesm",
                "dxesm跑",
                "esm",
                "ESM",
                "esm跑",
                "傻吊猫",
                "傻猫出勤",
                "屙屎妹",
                "恶俗猫",
                "标ESM",
                "沙雕猫",
                "神经猫",
                "跑路猫",
                "邮政",
                "饿死猫"
            ]
        },
        {
            "songId": "Session High⤴",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Session High⤴",
            "artist": "イロドリミドリ「CHUNITHM」",
            "bpm": 200,
            "imageName": "343d67ead2e3ec099fb1198399ff8ba3aaa8d46f401bd3ba8ead026e2595b8da",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 164,
                        "hold": 9,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 182
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 735,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 211,
                        "hold": 21,
                        "slide": 14,
                        "touch": null,
                        "break": 8,
                        "total": 254
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 735,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 43,
                        "slide": 29,
                        "touch": null,
                        "break": 28,
                        "total": 377
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 735,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 390,
                        "hold": 20,
                        "slide": 79,
                        "touch": null,
                        "break": 47,
                        "total": 536
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 735,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.3,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2018-06-21"
                }
            ],
            "searchAcronyms": [
                "↑",
                "↗️",
                "⤴️",
                "⬆️"
            ]
        },
        {
            "songId": "World Vanquisher",
            "category": "オンゲキ＆CHUNITHM",
            "title": "World Vanquisher",
            "artist": "void (Mournfinale)",
            "bpm": 170,
            "imageName": "739c9134f70f49dc86e57cb52d8aaae78abdf8e4a7343bf426752651e5a05e18",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 17,
                        "slide": 6,
                        "touch": null,
                        "break": 5,
                        "total": 300
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 736,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 334,
                        "hold": 69,
                        "slide": 19,
                        "touch": null,
                        "break": 24,
                        "total": 446
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 736,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 543,
                        "hold": 71,
                        "slide": 76,
                        "touch": null,
                        "break": 32,
                        "total": 722
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 736,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 874,
                        "hold": 60,
                        "slide": 113,
                        "touch": null,
                        "break": 25,
                        "total": 1072
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 736,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "Splash": 14.3,
                        "Splash PLUS": 14.3,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.3,
                        "maimaiでらっくす PLUS": 14.3
                    },
                    "releaseDate": "2018-06-21"
                }
            ],
            "searchAcronyms": [
                "ftr6",
                "ftr8",
                "Mother Vanquisher",
                "wv",
                "世征",
                "世界征服者",
                "中二送披萨",
                "噔噔噔噔噔",
                "威猛先生",
                "我想要一张色图",
                "我想要一顿毒打",
                "我想要挨一顿毒打",
                "我的丸求你射",
                "我的碗筷洗",
                "手感噔噔",
                "木琴征服者",
                "来点色图"
            ]
        },
        {
            "songId": "FestivaLight",
            "category": "maimai",
            "title": "FestivaLight",
            "artist": "霜月はるか",
            "bpm": 125,
            "imageName": "258614cc953c337194ba3b87cdaec01aa44cf8284547eabe04fc79dad2db97e1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 148,
                        "hold": 7,
                        "slide": 6,
                        "touch": null,
                        "break": 1,
                        "total": 162
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 737,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 26,
                        "slide": 21,
                        "touch": null,
                        "break": 11,
                        "total": 272
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 737,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 45,
                        "slide": 36,
                        "touch": null,
                        "break": 5,
                        "total": 401
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 737,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 431,
                        "hold": 42,
                        "slide": 91,
                        "touch": null,
                        "break": 28,
                        "total": 592
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 737,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.4
                    },
                    "releaseDate": "2018-06-21"
                }
            ],
            "searchAcronyms": [
                "festival light",
                "milked",
                "三小只",
                "三相之力",
                "你醒了",
                "你醒啦",
                "日服之光",
                "节日光",
                "魔法灯光夜"
            ]
        },
        {
            "songId": "Seyana. ～何でも言うことを聞いてくれるアカネチャン～",
            "category": "niconico＆ボーカロイド",
            "title": "Seyana. ～何でも言うことを聞いてくれるアカネチャン～",
            "artist": "GYARI",
            "bpm": 144,
            "imageName": "99a40805904616f17fcd478ca8b0195af5629229c54b01bc8617d344e7dbde29",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 147,
                        "hold": 16,
                        "slide": 4,
                        "touch": null,
                        "break": 3,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 781,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 18,
                        "slide": 15,
                        "touch": null,
                        "break": 5,
                        "total": 292
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 781,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Moon Strix",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 43,
                        "slide": 56,
                        "touch": null,
                        "break": 37,
                        "total": 441
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 781,
                    "releaseDate": "2018-06-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 529,
                        "hold": 36,
                        "slide": 66,
                        "touch": null,
                        "break": 37,
                        "total": 668
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 781,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.4
                    },
                    "releaseDate": "2018-06-21"
                }
            ],
            "searchAcronyms": [
                "akane",
                "seyana",
                "Seyana. ~AKANE's anything ok~",
                "sodayo",
                "不管说什么都在听着的琴叶茜酱",
                "琴叶茜",
                "说的事呢"
            ]
        },
        {
            "songId": "Brain Power",
            "category": "ゲーム＆バラエティ",
            "title": "Brain Power",
            "artist": "ノマ",
            "bpm": 170,
            "imageName": "a98509232addd4aaf91a05b23556a38856425033bf951ef3014ea3f3f2558080",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 207,
                        "hold": 10,
                        "slide": 4,
                        "touch": null,
                        "break": 7,
                        "total": 228
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 738,
                    "releaseDate": "2018-07-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 53,
                        "slide": 19,
                        "touch": null,
                        "break": 6,
                        "total": 416
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 738,
                    "releaseDate": "2018-07-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 310,
                        "hold": 54,
                        "slide": 45,
                        "touch": null,
                        "break": 48,
                        "total": 457
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 738,
                    "releaseDate": "2018-07-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 443,
                        "hold": 89,
                        "slide": 71,
                        "touch": null,
                        "break": 60,
                        "total": 663
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 738,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2018-07-03"
                }
            ],
            "searchAcronyms": [
                "bass kick",
                "bp",
                "o-oooooooooo",
                "佐助",
                "脑力"
            ]
        },
        {
            "songId": "進め！イッスン軍団 -Rebellion of the Dwarfs-",
            "category": "東方Project",
            "title": "進め！イッスン軍団 -Rebellion of the Dwarfs-",
            "artist": "dawn-system",
            "bpm": 172,
            "imageName": "ea0ab5704073db00495c5ed0e3fe2f4fd843c760dae20224ef54deff27a8615e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 192,
                        "hold": 6,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 212
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 739,
                    "releaseDate": "2018-07-03"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 49,
                        "slide": 30,
                        "touch": null,
                        "break": 4,
                        "total": 286
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 739,
                    "releaseDate": "2018-07-03"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 20,
                        "slide": 33,
                        "touch": null,
                        "break": 13,
                        "total": 417
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 739,
                    "releaseDate": "2018-07-03"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 303,
                        "hold": 193,
                        "slide": 92,
                        "touch": null,
                        "break": 8,
                        "total": 596
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 739,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2018-07-03"
                }
            ],
            "searchAcronyms": [
                "一尺军团",
                "军团",
                "前进军团",
                "小人国",
                "小小兵团",
                "小碗",
                "绣花针",
                "进军团",
                "针",
                "针妙丸",
                "针妙丸军团"
            ]
        },
        {
            "songId": "Let's Go Away",
            "category": "ゲーム＆バラエティ",
            "title": "Let's Go Away",
            "artist": "光吉猛修「デイトナ Championship USA」",
            "bpm": 240,
            "imageName": "d4c386c4a639f33f938ec62d12791a2f90b5d529ef5fb6ac9606c525140bc898",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 9,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 157
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 650,
                    "releaseDate": "2018-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 44,
                        "slide": 10,
                        "touch": null,
                        "break": 18,
                        "total": 311
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 650,
                    "releaseDate": "2018-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 398,
                        "hold": 45,
                        "slide": 31,
                        "touch": null,
                        "break": 6,
                        "total": 480
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 650,
                    "releaseDate": "2018-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 377,
                        "hold": 37,
                        "slide": 117,
                        "touch": null,
                        "break": 94,
                        "total": 625
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 650,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.3,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2018-07-11"
                }
            ],
            "searchAcronyms": [
                "梦游美国",
                "芜湖",
                "赛车"
            ]
        },
        {
            "songId": "Rodeo Machine",
            "category": "POPS＆アニメ",
            "title": "Rodeo Machine",
            "artist": "HALFBY",
            "bpm": 115,
            "imageName": "33103e6762f2b5604e344f6db644fac3b7bd8945dd639aebf220a30fd0adcd25",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 98,
                        "hold": 16,
                        "slide": 5,
                        "touch": null,
                        "break": 4,
                        "total": 123
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 753,
                    "releaseDate": "2018-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 252,
                        "hold": 18,
                        "slide": 15,
                        "touch": null,
                        "break": 20,
                        "total": 305
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 753,
                    "releaseDate": "2018-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 316,
                        "hold": 59,
                        "slide": 42,
                        "touch": null,
                        "break": 44,
                        "total": 461
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 753,
                    "releaseDate": "2018-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 0,
                        "slide": 215,
                        "touch": null,
                        "break": 16,
                        "total": 428
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 753,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2018-07-11"
                }
            ],
            "searchAcronyms": [
                "广播",
                "欧内的手",
                "绿手",
                "绿手手",
                "绿皮星星歌",
                "马"
            ]
        },
        {
            "songId": "Conquista Ciela",
            "category": "ゲーム＆バラエティ",
            "title": "Conquista Ciela",
            "artist": "光吉猛修「バーチャロン」",
            "bpm": 140,
            "imageName": "11723731e485e6d016a9346a1f5d54196cf08150bf069e3c3a813b88f6955340",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 16,
                        "slide": 5,
                        "touch": null,
                        "break": 3,
                        "total": 200
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 778,
                    "releaseDate": "2018-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 39,
                        "slide": 28,
                        "touch": null,
                        "break": 26,
                        "total": 323
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 778,
                    "releaseDate": "2018-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 67,
                        "slide": 41,
                        "touch": null,
                        "break": 5,
                        "total": 347
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 778,
                    "releaseDate": "2018-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 420,
                        "hold": 103,
                        "slide": 85,
                        "touch": null,
                        "break": 6,
                        "total": 614
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 778,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.2
                    },
                    "releaseDate": "2018-07-11"
                }
            ],
            "searchAcronyms": [
                "cc",
                "光吉猛修",
                "头疼",
                "电脑战机",
                "男人唱歌"
            ]
        },
        {
            "songId": "keep hopping",
            "category": "maimai",
            "title": "keep hopping",
            "artist": "kamome sano",
            "bpm": 155,
            "imageName": "7842f355a9ea71f2e273821920eb0670b4af4c535837a8e9a797d2f76c8bccaa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 221,
                        "hold": 8,
                        "slide": 7,
                        "touch": null,
                        "break": 6,
                        "total": 242
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 745,
                    "releaseDate": "2018-07-24"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 55,
                        "slide": 10,
                        "touch": null,
                        "break": 22,
                        "total": 369
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 745,
                    "releaseDate": "2018-07-24"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 416,
                        "hold": 48,
                        "slide": 60,
                        "touch": null,
                        "break": 36,
                        "total": 560
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 745,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.6,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2018-07-24"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 699,
                        "hold": 80,
                        "slide": 66,
                        "touch": null,
                        "break": 43,
                        "total": 888
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 745,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.6
                    },
                    "releaseDate": "2018-07-24"
                }
            ],
            "searchAcronyms": [
                "kamome sano",
                "kh",
                "一直跳",
                "一起摇摆",
                "保持火拼"
            ]
        },
        {
            "songId": "larva",
            "category": "maimai",
            "title": "larva",
            "artist": "ガリガリさむし",
            "bpm": 202,
            "imageName": "8fb917562717e828f1d59a62854c7f1ab8041d8347c3ad7fa9473e562be42db8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 11,
                        "slide": 9,
                        "touch": null,
                        "break": 10,
                        "total": 307
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 746,
                    "releaseDate": "2018-07-24"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 458,
                        "hold": 46,
                        "slide": 8,
                        "touch": null,
                        "break": 11,
                        "total": 523
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 746,
                    "releaseDate": "2018-07-24"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 650,
                        "hold": 40,
                        "slide": 54,
                        "touch": null,
                        "break": 23,
                        "total": 767
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 746,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.5,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2018-07-24"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 939,
                        "hold": 78,
                        "slide": 82,
                        "touch": null,
                        "break": 74,
                        "total": 1173
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 746,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "FESTiVAL": 14.8,
                        "FESTiVAL PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8,
                        "Splash": 14.8,
                        "Splash PLUS": 14.8,
                        "UNiVERSE": 14.8,
                        "UNiVERSE PLUS": 14.8,
                        "maimaiでらっくす PLUS": 14.8
                    },
                    "releaseDate": "2018-07-24"
                }
            ],
            "searchAcronyms": [
                "冰",
                "幼虫",
                "性教育片",
                "拉瓦",
                "源石虫",
                "爆笑虫子",
                "蜜雪冰城",
                "说的道理",
                "说的道理上长蓝的盆",
                "辣蛙"
            ]
        },
        {
            "songId": "インビジブル",
            "category": "niconico＆ボーカロイド",
            "title": "インビジブル",
            "artist": "kemu",
            "bpm": 192,
            "imageName": "3da3e1c19fb85ac0bf5bd223a671aa0d28cbea4ff1b9951101b4bfd5467660dc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 279,
                        "hold": 9,
                        "slide": 3,
                        "touch": null,
                        "break": 11,
                        "total": 302
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 741,
                    "releaseDate": "2018-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 54,
                        "slide": 6,
                        "touch": null,
                        "break": 30,
                        "total": 439
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 741,
                    "releaseDate": "2018-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 474,
                        "hold": 31,
                        "slide": 48,
                        "touch": null,
                        "break": 30,
                        "total": 583
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 741,
                    "releaseDate": "2018-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.3,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 548,
                        "hold": 15,
                        "slide": 156,
                        "touch": null,
                        "break": 11,
                        "total": 730
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 741,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.3,
                        "CiRCLE PLUS": 12.3,
                        "FESTiVAL": 12.3,
                        "FESTiVAL PLUS": 12.3,
                        "PRiSM PLUS": 12.3,
                        "UNiVERSE PLUS": 12.3
                    },
                    "releaseDate": "2018-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 752,
                        "hold": 31,
                        "slide": 102,
                        "touch": null,
                        "break": 54,
                        "total": 939
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 741,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.6
                    },
                    "releaseDate": "2018-08-07"
                }
            ],
            "searchAcronyms": [
                "invisible",
                "Invisible",
                "噜啪啪",
                "建筑工地",
                "透明人",
                "透明人间"
            ]
        },
        {
            "songId": "彗星ハネムーン",
            "category": "niconico＆ボーカロイド",
            "title": "彗星ハネムーン",
            "artist": "ナユタン星人",
            "bpm": 145,
            "imageName": "88f6151b5336d9608d5574329b699b2c7b73a9ac3b7208985a2ca810aefe1125",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 21,
                        "slide": 2,
                        "touch": null,
                        "break": 9,
                        "total": 269
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 742,
                    "releaseDate": "2018-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 355,
                        "hold": 20,
                        "slide": 16,
                        "touch": null,
                        "break": 22,
                        "total": 413
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 742,
                    "releaseDate": "2018-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 380,
                        "hold": 63,
                        "slide": 52,
                        "touch": null,
                        "break": 12,
                        "total": 507
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 742,
                    "releaseDate": "2018-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 562,
                        "hold": 37,
                        "slide": 115,
                        "touch": null,
                        "break": 28,
                        "total": 742
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 742,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2018-08-07"
                }
            ],
            "searchAcronyms": [
                "Comet Honeymoon",
                "彗星",
                "彗星蜜月"
            ]
        },
        {
            "songId": "おねがいダーリン",
            "category": "niconico＆ボーカロイド",
            "title": "おねがいダーリン",
            "artist": "ONE (song by ナナホシ管弦楽団)",
            "bpm": 180,
            "imageName": "647fdf449fe67c8ca167af1d797c4231b9119b0ff69a792c6395cf9149e66267",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 10,
                        "slide": 10,
                        "touch": null,
                        "break": 8,
                        "total": 255
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 782,
                    "releaseDate": "2018-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 329,
                        "hold": 26,
                        "slide": 13,
                        "touch": null,
                        "break": 23,
                        "total": 391
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 782,
                    "releaseDate": "2018-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 522,
                        "hold": 83,
                        "slide": 63,
                        "touch": null,
                        "break": 19,
                        "total": 687
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 782,
                    "releaseDate": "2018-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 509,
                        "hold": 45,
                        "slide": 103,
                        "touch": null,
                        "break": 32,
                        "total": 689
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 782,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.3,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2018-08-07"
                }
            ],
            "searchAcronyms": [
                "one",
                "ONE",
                "ONEgai Darlin'",
                "Onegai Darling",
                "拜托了，亲爱的",
                "拜托了darling",
                "拜托了亲爱的",
                "拜托了原神"
            ]
        },
        {
            "songId": "初音ミクの激唱",
            "category": "niconico＆ボーカロイド",
            "title": "初音ミクの激唱",
            "artist": "Storyteller",
            "bpm": 200,
            "imageName": "3d8d1dd48b27fbf3c2924e1047ad52fe2d4239d36355b823e067acf46c90578b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 252,
                        "hold": 45,
                        "slide": 9,
                        "touch": null,
                        "break": 7,
                        "total": 313
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 750,
                    "releaseDate": "2018-08-09"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 313,
                        "hold": 68,
                        "slide": 1,
                        "touch": null,
                        "break": 27,
                        "total": 409
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 750,
                    "releaseDate": "2018-08-09"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 454,
                        "hold": 87,
                        "slide": 8,
                        "touch": null,
                        "break": 14,
                        "total": 563
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 750,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL": 12.4,
                        "PRiSM PLUS": 12.4,
                        "UNiVERSE PLUS": 12.4
                    },
                    "releaseDate": "2018-08-09"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 653,
                        "hold": 72,
                        "slide": 70,
                        "touch": null,
                        "break": 39,
                        "total": 834
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 750,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.3,
                        "FESTiVAL PLUS": 14.3,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "Splash": 14.3,
                        "Splash PLUS": 14.3,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.3,
                        "maimaiでらっくす PLUS": 14.4
                    },
                    "releaseDate": "2018-08-09"
                }
            ],
            "searchAcronyms": [
                "🐔🎤",
                "Gekishou",
                "Intense Singing",
                "The Intense Singing of Hatsune Miku",
                "初音未来的激唱",
                "大葱天使",
                "姬昌",
                "机场",
                "激唱",
                "鸡场",
                "鸡肠"
            ]
        },
        {
            "songId": "えれくとりっく・えんじぇぅ",
            "category": "niconico＆ボーカロイド",
            "title": "えれくとりっく・えんじぇぅ",
            "artist": "ヤスオ",
            "bpm": 150,
            "imageName": "de0880fc754be6911647c83c36b2472cf75eccaef7817ffc776eb4789e8714b5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 191,
                        "hold": 16,
                        "slide": 3,
                        "touch": null,
                        "break": 10,
                        "total": 220
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 747,
                    "releaseDate": "2018-08-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 261,
                        "hold": 51,
                        "slide": 7,
                        "touch": null,
                        "break": 6,
                        "total": 325
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 747,
                    "releaseDate": "2018-08-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 71,
                        "slide": 17,
                        "touch": null,
                        "break": 18,
                        "total": 424
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 747,
                    "releaseDate": "2018-08-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 469,
                        "hold": 41,
                        "slide": 74,
                        "touch": null,
                        "break": 10,
                        "total": 594
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 747,
                    "releaseDate": "2018-08-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ミラクルペイント",
            "category": "niconico＆ボーカロイド",
            "title": "ミラクルペイント",
            "artist": "OSTER project",
            "bpm": 215,
            "imageName": "587d874f8309f33ff8fb9468891d5a54e73740086a3b9e29eff1f7742359de5f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 19,
                        "slide": 14,
                        "touch": null,
                        "break": 9,
                        "total": 231
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 748,
                    "releaseDate": "2018-08-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 34,
                        "slide": 9,
                        "touch": null,
                        "break": 13,
                        "total": 348
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 748,
                    "releaseDate": "2018-08-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 447,
                        "hold": 46,
                        "slide": 30,
                        "touch": null,
                        "break": 8,
                        "total": 531
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 748,
                    "releaseDate": "2018-08-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 494,
                        "hold": 64,
                        "slide": 98,
                        "touch": null,
                        "break": 15,
                        "total": 671
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 748,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.6
                    },
                    "releaseDate": "2018-08-21"
                }
            ],
            "searchAcronyms": [
                "Miracle Paint"
            ]
        },
        {
            "songId": "CYBER Sparks",
            "category": "東方Project",
            "title": "CYBER Sparks",
            "artist": "Tatsh",
            "bpm": 192,
            "imageName": "2021ad7f04b73fec086b171e61800a3cc5b1c879402283156b8e4baf6d2eb5d5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 153,
                        "hold": 17,
                        "slide": 9,
                        "touch": null,
                        "break": 2,
                        "total": 181
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 756,
                    "releaseDate": "2018-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 30,
                        "slide": 10,
                        "touch": null,
                        "break": 8,
                        "total": 325
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 756,
                    "releaseDate": "2018-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 486,
                        "hold": 48,
                        "slide": 23,
                        "touch": null,
                        "break": 4,
                        "total": 561
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 756,
                    "releaseDate": "2018-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 436,
                        "hold": 36,
                        "slide": 150,
                        "touch": null,
                        "break": 4,
                        "total": 626
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 756,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2018-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 827,
                        "hold": 8,
                        "slide": 82,
                        "touch": null,
                        "break": 28,
                        "total": 945
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 756,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2018-09-04"
                }
            ],
            "searchAcronyms": [
                "🧹",
                "cs",
                "endtime青春版",
                "反恐精英",
                "赛博火花",
                "赛博炮",
                "魔光炮",
                "魔理沙爆炸",
                "黄色嘉然"
            ]
        },
        {
            "songId": "Xevel",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Xevel",
            "artist": "Tatsh",
            "bpm": 176,
            "imageName": "aca41bbc5e8874a347207065533971a2652e9d0217e377c54eaa4d118d69d396",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 228,
                        "hold": 20,
                        "slide": 8,
                        "touch": null,
                        "break": 9,
                        "total": 265
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 757,
                    "releaseDate": "2018-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 361,
                        "hold": 30,
                        "slide": 18,
                        "touch": null,
                        "break": 20,
                        "total": 429
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 757,
                    "releaseDate": "2018-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 535,
                        "hold": 38,
                        "slide": 63,
                        "touch": null,
                        "break": 85,
                        "total": 721
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 757,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2018-09-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 938,
                        "hold": 30,
                        "slide": 110,
                        "touch": null,
                        "break": 91,
                        "total": 1169
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 757,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.2,
                        "FESTiVAL PLUS": 14.2,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "Splash": 14.1,
                        "Splash PLUS": 14.1,
                        "UNiVERSE": 14.1,
                        "UNiVERSE PLUS": 14.1,
                        "maimaiでらっくす PLUS": 14.1
                    },
                    "releaseDate": "2018-09-04"
                }
            ],
            "searchAcronyms": [
                "健身房",
                "希尔薇",
                "怎么还没结束",
                "累死人不偿命",
                "邪恶vel",
                "邪恶Vel",
                "黑白双gay"
            ]
        },
        {
            "songId": "ULTRA B+K",
            "category": "ゲーム＆バラエティ",
            "title": "ULTRA B+K",
            "artist": "nora2r",
            "bpm": 175,
            "imageName": "8e74debde6d5c2136fe4a27f36b1ca05f6533e035e909321043b8a4f5a3cd3c0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 8,
                        "slide": 2,
                        "touch": null,
                        "break": 13,
                        "total": 252
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 740,
                    "releaseDate": "2018-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 42,
                        "slide": 7,
                        "touch": null,
                        "break": 34,
                        "total": 370
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 740,
                    "releaseDate": "2018-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 403,
                        "hold": 67,
                        "slide": 57,
                        "touch": null,
                        "break": 22,
                        "total": 549
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 740,
                    "releaseDate": "2018-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 590,
                        "hold": 98,
                        "slide": 129,
                        "touch": null,
                        "break": 28,
                        "total": 845
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 740,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2018-09-18"
                }
            ],
            "searchAcronyms": [
                "b+k",
                "bk2",
                "S+B",
                "ubk",
                "超级汉堡王"
            ]
        },
        {
            "songId": "INFINITE WORLD",
            "category": "東方Project",
            "title": "INFINITE WORLD",
            "artist": "SOUND HOLIC feat. Nana Takahashi",
            "bpm": 167,
            "imageName": "32f5a0b4a34d61c7ffbd5d697ec1f33e61cd2d7f6842342fefe99693d53d2e93",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 180,
                        "hold": 9,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 199
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 758,
                    "releaseDate": "2018-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 291,
                        "hold": 17,
                        "slide": 21,
                        "touch": null,
                        "break": 24,
                        "total": 353
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 758,
                    "releaseDate": "2018-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 361,
                        "hold": 62,
                        "slide": 53,
                        "touch": null,
                        "break": 32,
                        "total": 508
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 758,
                    "releaseDate": "2018-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 488,
                        "hold": 44,
                        "slide": 98,
                        "touch": null,
                        "break": 31,
                        "total": 661
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 758,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2018-09-18"
                }
            ],
            "searchAcronyms": [
                "📷",
                "天狗拍照",
                "恶心丸",
                "无限世界"
            ]
        },
        {
            "songId": "Ragnarok",
            "category": "maimai",
            "title": "Ragnarok",
            "artist": "sky_delta",
            "bpm": 184,
            "imageName": "055474e5d50fe33a286f7e7c9b4d85f5e3f388bd7c1a6040a3fbac2b567d033d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 21,
                        "slide": 3,
                        "touch": null,
                        "break": 4,
                        "total": 278
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 760,
                    "releaseDate": "2018-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 33,
                        "slide": 25,
                        "touch": null,
                        "break": 22,
                        "total": 372
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 760,
                    "releaseDate": "2018-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 347,
                        "hold": 79,
                        "slide": 86,
                        "touch": null,
                        "break": 18,
                        "total": 530
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 760,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2018-09-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 591,
                        "hold": 106,
                        "slide": 74,
                        "touch": null,
                        "break": 55,
                        "total": 826
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 760,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.1,
                        "BUDDiES PLUS": 14.1,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 14,
                        "FESTiVAL PLUS": 14,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2018-09-18"
                }
            ],
            "searchAcronyms": [
                "诸神黄昏",
                "黄昏"
            ]
        },
        {
            "songId": "サドマミホリック",
            "category": "東方Project",
            "title": "サドマミホリック",
            "artist": "ビートまりお（COOL&CREATE）",
            "bpm": 200,
            "imageName": "a63e2a892ec28735bfa95d59f7e1a7dfc827762a5856dfe6aa953ec482e8800c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 281,
                        "hold": 14,
                        "slide": 6,
                        "touch": null,
                        "break": 7,
                        "total": 308
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 759,
                    "releaseDate": "2018-10-02"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 343,
                        "hold": 40,
                        "slide": 16,
                        "touch": null,
                        "break": 34,
                        "total": 433
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 759,
                    "releaseDate": "2018-10-02"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 429,
                        "hold": 79,
                        "slide": 48,
                        "touch": null,
                        "break": 24,
                        "total": 580
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 759,
                    "releaseDate": "2018-10-02"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 581,
                        "hold": 32,
                        "slide": 130,
                        "touch": null,
                        "break": 18,
                        "total": 761
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 759,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2018-10-02"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 767,
                        "hold": 19,
                        "slide": 146,
                        "touch": null,
                        "break": 45,
                        "total": 977
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 759,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 13.6
                    },
                    "releaseDate": "2018-10-02"
                }
            ],
            "searchAcronyms": [
                "Sadomami",
                "SadoMamiHolic",
                "撒币",
                "灵梦撒币"
            ]
        },
        {
            "songId": "みんなの",
            "category": "東方Project",
            "title": "みんなの",
            "artist": "豚乙女",
            "bpm": 190,
            "imageName": "266fcd90c409517ca7fb6142d4b2e210c2889dc7f569c3f36796db6543592525",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 28,
                        "slide": 4,
                        "touch": null,
                        "break": 9,
                        "total": 216
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 765,
                    "releaseDate": "2018-10-02"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 243,
                        "hold": 56,
                        "slide": 19,
                        "touch": null,
                        "break": 21,
                        "total": 339
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 765,
                    "releaseDate": "2018-10-02"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 312,
                        "hold": 60,
                        "slide": 23,
                        "touch": null,
                        "break": 30,
                        "total": 425
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 765,
                    "releaseDate": "2018-10-02"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 467,
                        "hold": 42,
                        "slide": 82,
                        "touch": null,
                        "break": 42,
                        "total": 633
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 765,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2018-10-02"
                }
            ],
            "searchAcronyms": [
                "兽道",
                "大家的",
                "獸道"
            ]
        },
        {
            "songId": "アマノジャクリバース feat. ｙｔｒ",
            "category": "東方Project",
            "title": "アマノジャクリバース feat. ｙｔｒ",
            "artist": "魂音泉",
            "bpm": 160,
            "imageName": "45df78b7be097196fb6dbb1c1d44b0af8ef95b2c029efd63df27ac1dafc82018",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 4,
                        "slide": 2,
                        "touch": null,
                        "break": 8,
                        "total": 219
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 766,
                    "releaseDate": "2018-10-02"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 235,
                        "hold": 47,
                        "slide": 18,
                        "touch": null,
                        "break": 18,
                        "total": 318
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 766,
                    "releaseDate": "2018-10-02"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 60,
                        "slide": 37,
                        "touch": null,
                        "break": 10,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 766,
                    "releaseDate": "2018-10-02"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "はっぴー vs Jack",
                    "noteCounts": {
                        "tap": 659,
                        "hold": 18,
                        "slide": 89,
                        "touch": null,
                        "break": 11,
                        "total": 777
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 766,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.1
                    },
                    "releaseDate": "2018-10-02"
                }
            ],
            "searchAcronyms": [
                "🚸",
                "0梦过马路",
                "ytr",
                "天邪鬼",
                "天邪鬼反转",
                "灵梦过街",
                "灵梦过马路",
                "过马路"
            ]
        },
        {
            "songId": "進捗どうですか？",
            "category": "東方Project",
            "title": "進捗どうですか？",
            "artist": "sumijun(Halozy) feat. ななひら(Confetto)",
            "bpm": 199,
            "imageName": "40858dadb448519f10f6651a4de3a597b3bb1629116a41b244db84ad0f8dd2cc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 24,
                        "slide": 2,
                        "touch": null,
                        "break": 5,
                        "total": 249
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 767,
                    "releaseDate": "2018-10-02"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 354,
                        "hold": 55,
                        "slide": 14,
                        "touch": null,
                        "break": 24,
                        "total": 447
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 767,
                    "releaseDate": "2018-10-02"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 425,
                        "hold": 78,
                        "slide": 30,
                        "touch": null,
                        "break": 13,
                        "total": 546
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 767,
                    "releaseDate": "2018-10-02"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 689,
                        "hold": 62,
                        "slide": 135,
                        "touch": null,
                        "break": 32,
                        "total": 918
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 767,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.5,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2018-10-02"
                }
            ],
            "searchAcronyms": [
                "Shinchoku Doudesuka?",
                "进展如何",
                "进度",
                "进度如何",
                "进步"
            ]
        },
        {
            "songId": "Help me, あーりん！",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Help me, あーりん！",
            "artist": "イロドリミドリ「CHUNITHM」",
            "bpm": 183,
            "imageName": "22e11904160d0a5b8745089902dfe57670a57ed235fa1b0d12355e13f2fd74d4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 195,
                        "hold": 38,
                        "slide": 5,
                        "touch": null,
                        "break": 21,
                        "total": 259
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 768,
                    "releaseDate": "2018-10-16"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 46,
                        "slide": 15,
                        "touch": null,
                        "break": 26,
                        "total": 432
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 768,
                    "releaseDate": "2018-10-16"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 347,
                        "hold": 90,
                        "slide": 69,
                        "touch": null,
                        "break": 28,
                        "total": 534
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 768,
                    "releaseDate": "2018-10-16"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 515,
                        "hold": 68,
                        "slide": 93,
                        "touch": null,
                        "break": 23,
                        "total": 699
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 768,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2018-10-16"
                }
            ],
            "searchAcronyms": [
                "erin！erin！",
                "Help me arin",
                "帮帮我",
                "帮我",
                "帮我阿李安",
                "彩绿永琳",
                "救我",
                "教我，永琳！",
                "月铃姐妹"
            ]
        },
        {
            "songId": "なるとなぎのパーフェクトロックンロール教室",
            "category": "オンゲキ＆CHUNITHM",
            "title": "なるとなぎのパーフェクトロックンロール教室",
            "artist": "イロドリミドリ「CHUNITHM」",
            "bpm": 216,
            "imageName": "548f0d6d2b3884f1b395e3486141b22717d2051faca5cd1500c88f9283811dec",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 40,
                        "slide": 8,
                        "touch": null,
                        "break": 11,
                        "total": 247
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 769,
                    "releaseDate": "2018-10-16"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 270,
                        "hold": 48,
                        "slide": 9,
                        "touch": null,
                        "break": 25,
                        "total": 352
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 769,
                    "releaseDate": "2018-10-16"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 378,
                        "hold": 63,
                        "slide": 53,
                        "touch": null,
                        "break": 36,
                        "total": 530
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 769,
                    "releaseDate": "2018-10-16"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 538,
                        "hold": 40,
                        "slide": 110,
                        "touch": null,
                        "break": 99,
                        "total": 787
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 769,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.4,
                        "Splash PLUS": 13.4,
                        "UNiVERSE": 13.4,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2018-10-16"
                }
            ],
            "searchAcronyms": [
                "⑨",
                "Naru and Nagi",
                "Naru nagi",
                "Naru to Nagi's Perfect Rock and Roll Class",
                "中二教室",
                "冒牌⑨",
                "摇滚教室",
                "琪露诺的完美算数教室",
                "箱部鸣与小佛凪的完美摇滚教室"
            ]
        },
        {
            "songId": "あねぺったん",
            "category": "オンゲキ＆CHUNITHM",
            "title": "あねぺったん",
            "artist": "月鈴姉妹（イロドリミドリ）",
            "bpm": 180,
            "imageName": "a55a15786684df3c3179a7794570c372a7cb0b9750131e9994658cb9805b69ed",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 153,
                        "hold": 79,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 240
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 770,
                    "releaseDate": "2018-10-16"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 268,
                        "hold": 69,
                        "slide": 19,
                        "touch": null,
                        "break": 32,
                        "total": 388
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 770,
                    "releaseDate": "2018-10-16"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 271,
                        "hold": 161,
                        "slide": 45,
                        "touch": null,
                        "break": 60,
                        "total": 537
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 770,
                    "releaseDate": "2018-10-16"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 478,
                        "hold": 107,
                        "slide": 118,
                        "touch": null,
                        "break": 18,
                        "total": 721
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 770,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2018-10-16"
                }
            ],
            "searchAcronyms": [
                "Ane pettan",
                "月铃姐妹",
                "醋溜便当"
            ]
        },
        {
            "songId": "We Gonna Journey",
            "category": "オンゲキ＆CHUNITHM",
            "title": "We Gonna Journey",
            "artist": "Queen P.A.L.",
            "bpm": 160,
            "imageName": "baaffa8982a6b09a4cf16e1288d3aaa5e244ae6e347ba00b0cf598e6034a81b4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 28,
                        "slide": 7,
                        "touch": null,
                        "break": 5,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 771,
                    "releaseDate": "2018-10-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 346,
                        "hold": 29,
                        "slide": 16,
                        "touch": null,
                        "break": 12,
                        "total": 403
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 771,
                    "releaseDate": "2018-10-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 435,
                        "hold": 55,
                        "slide": 62,
                        "touch": null,
                        "break": 70,
                        "total": 622
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 771,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2018-10-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 716,
                        "hold": 34,
                        "slide": 115,
                        "touch": null,
                        "break": 50,
                        "total": 915
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 771,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "CiRCLE": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2018-10-25"
                }
            ],
            "searchAcronyms": [
                "wgj",
                "我们去旅行",
                "我们要旅行"
            ]
        },
        {
            "songId": "FREEDOM DiVE (tpz Overcute Remix)",
            "category": "ゲーム＆バラエティ",
            "title": "FREEDOM DiVE (tpz Overcute Remix)",
            "artist": "t+pazolite",
            "bpm": 234,
            "imageName": "02c941820e6430fa0587589c62a97d17bd266e7c7533850767894434f54c24bd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 312,
                        "hold": 32,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 354
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 772,
                    "releaseDate": "2018-10-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 406,
                        "hold": 46,
                        "slide": 14,
                        "touch": null,
                        "break": 5,
                        "total": 471
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 772,
                    "releaseDate": "2018-10-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 509,
                        "hold": 85,
                        "slide": 39,
                        "touch": null,
                        "break": 68,
                        "total": 701
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 772,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2018-10-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 717,
                        "hold": 115,
                        "slide": 166,
                        "touch": null,
                        "break": 87,
                        "total": 1085
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 772,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 14,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2018-10-25"
                }
            ],
            "searchAcronyms": [
                "↓",
                "234.56",
                "23456",
                "fd",
                "fdfd",
                "fdmm",
                "厨邦最爱",
                "发癫",
                "科比",
                "自由戴夫",
                "自由落体"
            ]
        },
        {
            "songId": "ジンギスカン",
            "category": "POPS＆アニメ",
            "title": "ジンギスカン",
            "artist": "仁井山征弘 Feat. GREAT G and surprise",
            "bpm": 150,
            "imageName": "6ad4e902dacda13d2a76a814a809c3cb25495bc0617e60125f18d9f92cbd8704",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 133,
                        "hold": 17,
                        "slide": 9,
                        "touch": null,
                        "break": 19,
                        "total": 178
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 775,
                    "releaseDate": "2018-11-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 37,
                        "slide": 14,
                        "touch": null,
                        "break": 29,
                        "total": 356
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 775,
                    "releaseDate": "2018-11-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 54,
                        "slide": 28,
                        "touch": null,
                        "break": 64,
                        "total": 502
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 775,
                    "releaseDate": "2018-11-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 546,
                        "hold": 16,
                        "slide": 124,
                        "touch": null,
                        "break": 66,
                        "total": 752
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 775,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.6
                    },
                    "releaseDate": "2018-11-06"
                }
            ],
            "searchAcronyms": [
                "成吉思汗",
                "金金金金金"
            ]
        },
        {
            "songId": "にじよめちゃん体操第一億",
            "category": "POPS＆アニメ",
            "title": "にじよめちゃん体操第一億",
            "artist": "にじよめちゃんとZIPたん",
            "bpm": 120,
            "imageName": "fe462603c582c98d0d96527b3ef1751b1bd0eb4532fa595e1e7a468774315708",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 10,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 148
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 776,
                    "releaseDate": "2018-11-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 10,
                        "slide": 14,
                        "touch": null,
                        "break": 36,
                        "total": 188
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 776,
                    "releaseDate": "2018-11-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 183,
                        "hold": 32,
                        "slide": 27,
                        "touch": null,
                        "break": 36,
                        "total": 278
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 776,
                    "releaseDate": "2018-11-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 238,
                        "hold": 1,
                        "slide": 156,
                        "touch": null,
                        "break": 74,
                        "total": 469
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 776,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2018-11-06"
                }
            ],
            "searchAcronyms": [
                "🤤",
                "体操",
                "体操一亿",
                "体操第一亿",
                "体操第一億",
                "牵线木偶"
            ]
        },
        {
            "songId": "花と、雪と、ドラムンベース。",
            "category": "maimai",
            "title": "花と、雪と、ドラムンベース。",
            "artist": "kanone feat. せんざい",
            "bpm": 180,
            "imageName": "2b9ee0b6ea8fef773725b8ae8832cd6a8c1676669408f689b0698939d89ad81b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 171,
                        "hold": 18,
                        "slide": 6,
                        "touch": null,
                        "break": 11,
                        "total": 206
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 777,
                    "releaseDate": "2018-11-06"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 261,
                        "hold": 54,
                        "slide": 34,
                        "touch": null,
                        "break": 20,
                        "total": 369
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 777,
                    "releaseDate": "2018-11-06"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 87,
                        "slide": 67,
                        "touch": null,
                        "break": 8,
                        "total": 440
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 777,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2018-11-06"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "ぴちネコ vs Moon Strix",
                    "noteCounts": {
                        "tap": 647,
                        "hold": 71,
                        "slide": 116,
                        "touch": null,
                        "break": 42,
                        "total": 876
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 777,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "Splash": 14.2,
                        "Splash PLUS": 14.3,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.4,
                        "maimaiでらっくす PLUS": 14
                    },
                    "releaseDate": "2018-11-06"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 32,
                        "slide": 106,
                        "touch": null,
                        "break": 10,
                        "total": 398
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 777,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2018-11-19"
                }
            ],
            "searchAcronyms": [
                "🌸❄️",
                "🌸1⃣️🛞",
                "flower snow",
                "Flower, snow and Drum'n'bass.",
                "fsd",
                "fsdnb",
                "Hana to Yuki to Drumn Bass",
                "冬之花",
                "别急6",
                "四月的雪",
                "有好姐妹一起出勤吗",
                "花一轮",
                "花花花花花花一轮",
                "花雪",
                "逼三狼",
                "雪球"
            ]
        },
        {
            "songId": "このふざけた素晴らしき世界は、僕の為にある",
            "category": "niconico＆ボーカロイド",
            "title": "このふざけた素晴らしき世界は、僕の為にある",
            "artist": "n.k",
            "bpm": 152,
            "imageName": "6e36364dca433696cfb898b66d0f4fe1620b21d9965a7302dc3864312ef6dd87",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 177,
                        "hold": 13,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 199
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 761,
                    "releaseDate": "2018-11-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 30,
                        "slide": 16,
                        "touch": null,
                        "break": 10,
                        "total": 348
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 761,
                    "releaseDate": "2018-11-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 358,
                        "hold": 85,
                        "slide": 28,
                        "touch": null,
                        "break": 5,
                        "total": 476
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 761,
                    "releaseDate": "2018-11-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 637,
                        "hold": 82,
                        "slide": 60,
                        "touch": null,
                        "break": 7,
                        "total": 786
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 761,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2018-11-20"
                }
            ],
            "searchAcronyms": [
                "This Messed-Up Wonderful World Exists For Me"
            ]
        },
        {
            "songId": "このピアノでお前を8759632145回ぶん殴る",
            "category": "niconico＆ボーカロイド",
            "title": "このピアノでお前を8759632145回ぶん殴る",
            "artist": "SLAVE.V-V-R",
            "bpm": 200,
            "imageName": "32dc19b8d6f248612fe2d17fe3286ff9c41aa9b71da8fb9c6044ea1cbf99fb3a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 166,
                        "hold": 19,
                        "slide": 14,
                        "touch": null,
                        "break": 5,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 762,
                    "releaseDate": "2018-11-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 324,
                        "hold": 22,
                        "slide": 26,
                        "touch": null,
                        "break": 18,
                        "total": 390
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 762,
                    "releaseDate": "2018-11-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 567,
                        "hold": 42,
                        "slide": 24,
                        "touch": null,
                        "break": 6,
                        "total": 639
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 762,
                    "releaseDate": "2018-11-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 809,
                        "hold": 15,
                        "slide": 121,
                        "touch": null,
                        "break": 22,
                        "total": 967
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 762,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2018-11-20"
                }
            ],
            "searchAcronyms": [
                "1.14514e+12",
                "114514",
                "1145141919810",
                "1919810",
                "8759632145",
                "一堆数字",
                "我会用这架钢琴殴打你8759632145次",
                "用钢琴撅你1145141919810次",
                "钢琴",
                "钢琴打人",
                "钢琴殴打",
                "钢琴砸人"
            ]
        },
        {
            "songId": "はやくそれになりたい！",
            "category": "niconico＆ボーカロイド",
            "title": "はやくそれになりたい！",
            "artist": "キノシタ feat. 音街ウナ",
            "bpm": 185,
            "imageName": "dfb134b775937826fb18f20aeab7b401a16299503ce0adff441cc3175919d7bc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 18,
                        "slide": 6,
                        "touch": null,
                        "break": 8,
                        "total": 316
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 763,
                    "releaseDate": "2018-11-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 24,
                        "slide": 14,
                        "touch": null,
                        "break": 40,
                        "total": 453
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 763,
                    "releaseDate": "2018-11-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 419,
                        "hold": 49,
                        "slide": 55,
                        "touch": null,
                        "break": 53,
                        "total": 576
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 763,
                    "releaseDate": "2018-11-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 582,
                        "hold": 31,
                        "slide": 142,
                        "touch": null,
                        "break": 9,
                        "total": 764
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 763,
                    "releaseDate": "2018-11-20"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 508,
                        "hold": 64,
                        "slide": 143,
                        "touch": null,
                        "break": 43,
                        "total": 758
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 763,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.6
                    },
                    "releaseDate": "2018-11-20"
                }
            ],
            "searchAcronyms": [
                "😫",
                "Hayaku Soreni Naritai",
                "I wanna be it",
                "I wanna be it!",
                "想快点变成那个样子",
                "蓝瓶尖叫",
                "音街",
                "音街鳗"
            ]
        },
        {
            "songId": "フィクサー",
            "category": "niconico＆ボーカロイド",
            "title": "フィクサー",
            "artist": "ぬゆり",
            "bpm": 135,
            "imageName": "a72f872e92067eabbed8f00665d10d223c14de08eca3d80e13a9bd431c85a789",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 187,
                        "hold": 7,
                        "slide": 7,
                        "touch": null,
                        "break": 4,
                        "total": 205
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 764,
                    "releaseDate": "2018-11-20"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 26,
                        "slide": 7,
                        "touch": null,
                        "break": 8,
                        "total": 352
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 764,
                    "releaseDate": "2018-11-20"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 48,
                        "slide": 55,
                        "touch": null,
                        "break": 6,
                        "total": 431
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 764,
                    "releaseDate": "2018-11-20"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 618,
                        "hold": 51,
                        "slide": 95,
                        "touch": null,
                        "break": 8,
                        "total": 772
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 764,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.6
                    },
                    "releaseDate": "2018-11-20"
                }
            ],
            "searchAcronyms": [
                "fixer",
                "Fixer",
                "修人",
                "牛头人喝酒",
                "黑山羊",
                "黑山羊吃席"
            ]
        },
        {
            "songId": "SILENT BLUE",
            "category": "maimai",
            "title": "SILENT BLUE",
            "artist": "かねこちはる",
            "bpm": 210,
            "imageName": "22c704ba6e8cf035418f7c388db708549ec8533429d093bf535402dc25edbf63",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 168,
                        "hold": 32,
                        "slide": 12,
                        "touch": null,
                        "break": 4,
                        "total": 216
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 773,
                    "releaseDate": "2018-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 274,
                        "hold": 23,
                        "slide": 24,
                        "touch": null,
                        "break": 1,
                        "total": 322
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 773,
                    "releaseDate": "2018-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 511,
                        "hold": 80,
                        "slide": 74,
                        "touch": null,
                        "break": 27,
                        "total": 692
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 773,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2018-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 838,
                        "hold": 83,
                        "slide": 126,
                        "touch": null,
                        "break": 39,
                        "total": 1086
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 773,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "FESTiVAL": 14.8,
                        "FESTiVAL PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8,
                        "Splash": 14.8,
                        "Splash PLUS": 14.8,
                        "UNiVERSE": 14.8,
                        "UNiVERSE PLUS": 14.8,
                        "maimaiでらっくす PLUS": 14.8
                    },
                    "releaseDate": "2018-12-04"
                }
            ],
            "searchAcronyms": [
                "↓↑",
                "KohaD",
                "sb",
                "傻逼",
                "四块钱",
                "我",
                "色篮",
                "静屋他弟",
                "静蓝",
                "默蓝"
            ]
        },
        {
            "songId": "怒槌",
            "category": "オンゲキ＆CHUNITHM",
            "title": "怒槌",
            "artist": "光吉猛修",
            "bpm": 200,
            "imageName": "9b8399fb23de7511b3f89aaa56041ed4d64e535c314d4b2c324f9c0ad9506b37",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 323,
                        "hold": 51,
                        "slide": 12,
                        "touch": null,
                        "break": 14,
                        "total": 400
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 779,
                    "releaseDate": "2018-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 383,
                        "hold": 74,
                        "slide": 20,
                        "touch": null,
                        "break": 10,
                        "total": 487
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 779,
                    "releaseDate": "2018-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 606,
                        "hold": 78,
                        "slide": 93,
                        "touch": null,
                        "break": 20,
                        "total": 797
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 779,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "UNiVERSE PLUS": 13.1
                    },
                    "releaseDate": "2018-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "譜面ボーイズからの挑戦状",
                    "noteCounts": {
                        "tap": 928,
                        "hold": 55,
                        "slide": 158,
                        "touch": null,
                        "break": 47,
                        "total": 1188
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 779,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "FESTiVAL": 14.8,
                        "FESTiVAL PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8,
                        "Splash": 14.8,
                        "Splash PLUS": 14.8,
                        "UNiVERSE": 14.8,
                        "UNiVERSE PLUS": 14.8,
                        "maimaiでらっくす PLUS": 14.6
                    },
                    "releaseDate": "2018-12-04"
                }
            ],
            "searchAcronyms": [
                "😡👊",
                "😡🔨",
                "Ikazuchi",
                "Rage",
                "怒捶",
                "怒锤",
                "愤怒的锤子",
                "这谱谁写的"
            ]
        },
        {
            "songId": "My First Phone",
            "category": "オンゲキ＆CHUNITHM",
            "title": "My First Phone",
            "artist": "cubesato",
            "bpm": 114,
            "imageName": "28f238066094a65a851bd7ad48e90f6b281275b8bd72bb680eeb0afa85472b52",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 216,
                        "hold": 8,
                        "slide": 4,
                        "touch": null,
                        "break": 4,
                        "total": 232
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 786,
                    "releaseDate": "2018-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 43,
                        "slide": 13,
                        "touch": null,
                        "break": 5,
                        "total": 292
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 786,
                    "releaseDate": "2018-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 30,
                        "slide": 48,
                        "touch": null,
                        "break": 5,
                        "total": 458
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 786,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "BUDDiES PLUS": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2018-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 312,
                        "hold": 45,
                        "slide": 173,
                        "touch": null,
                        "break": 2,
                        "total": 532
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "MiLK PLUS",
                    "internalId": 786,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2018-12-04"
                }
            ],
            "searchAcronyms": [
                "👴的第一部手机",
                "mfp",
                "中二的雨",
                "别急3",
                "午夜凶铃",
                "喂喂草",
                "小灵通",
                "座机",
                "我的第一部手机",
                "手机",
                "爷の手机",
                "电话",
                "额滴圣剑"
            ]
        },
        {
            "songId": "ENJOY POLIS",
            "category": "maimai",
            "title": "ENJOY POLIS",
            "artist": "LOPIT",
            "bpm": 220,
            "imageName": "26a3933d6491026a2cbff3e2809510eca79a3dc5d60700b1449521917d539bff",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 183,
                        "hold": 15,
                        "slide": 9,
                        "touch": null,
                        "break": 5,
                        "total": 212
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 564,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 42,
                        "slide": 24,
                        "touch": null,
                        "break": 14,
                        "total": 353
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 564,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 447,
                        "hold": 51,
                        "slide": 31,
                        "touch": null,
                        "break": 2,
                        "total": 531
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 564,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 539,
                        "hold": 59,
                        "slide": 87,
                        "touch": null,
                        "break": 9,
                        "total": 694
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 564,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.4
                    },
                    "releaseDate": "2018-12-13"
                }
            ],
            "searchAcronyms": [
                "enjoypolis"
            ]
        },
        {
            "songId": "ネ！コ！",
            "category": "POPS＆アニメ",
            "title": "ネ！コ！",
            "artist": "パトリシア・オブ・エンド・黒木未知・夕莉シャチ・明日原ユウキ「ノラと皇女と野良猫ハート」",
            "bpm": 182,
            "imageName": "5e5290a24190c725e079838282b9cb28f0da20e81772e7d8c47d6f0b90ed3fd2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 12,
                        "slide": 7,
                        "touch": null,
                        "break": 6,
                        "total": 200
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 789,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 307,
                        "hold": 27,
                        "slide": 21,
                        "touch": null,
                        "break": 24,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 789,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 294,
                        "hold": 55,
                        "slide": 32,
                        "touch": null,
                        "break": 26,
                        "total": 407
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 789,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 408,
                        "hold": 40,
                        "slide": 133,
                        "touch": null,
                        "break": 39,
                        "total": 620
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 789,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 11.9
                    },
                    "releaseDate": "2018-12-13"
                }
            ],
            "searchAcronyms": [
                "1！5！",
                "ne！ko！",
                "NE!KO!",
                "neko",
                "zood",
                "ネコ",
                "流浪猫之心",
                "猫",
                "野良猫"
            ]
        },
        {
            "songId": "ロールプレイングゲーム",
            "category": "niconico＆ボーカロイド",
            "title": "ロールプレイングゲーム",
            "artist": "そらまふうらさか",
            "bpm": 162,
            "imageName": "fb2edebf58e67992d2b99ad909375acab87074f22cb8eb157081927680d85716",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 228,
                        "hold": 9,
                        "slide": 6,
                        "touch": null,
                        "break": 10,
                        "total": 253
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 791,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 314,
                        "hold": 36,
                        "slide": 4,
                        "touch": null,
                        "break": 18,
                        "total": 372
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 791,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 444,
                        "hold": 45,
                        "slide": 72,
                        "touch": null,
                        "break": 30,
                        "total": 591
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 791,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 555,
                        "hold": 12,
                        "slide": 161,
                        "touch": null,
                        "break": 26,
                        "total": 754
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 791,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL": 12.6,
                        "PRiSM PLUS": 12.6,
                        "Splash": 12.1
                    },
                    "releaseDate": "2018-12-13"
                }
            ],
            "searchAcronyms": [
                "rpg",
                "RPG",
                "日屁股"
            ]
        },
        {
            "songId": "ヒバナ",
            "category": "niconico＆ボーカロイド",
            "title": "ヒバナ",
            "artist": "DECO*27",
            "bpm": 200,
            "imageName": "517b4d1528fd2c1068b17337e83938321e0e8eec1c99d5fdb7b44cae6ac43a6e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 173,
                        "hold": 16,
                        "slide": 5,
                        "touch": null,
                        "break": 6,
                        "total": 200
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 792,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 304,
                        "hold": 31,
                        "slide": 39,
                        "touch": null,
                        "break": 31,
                        "total": 405
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 792,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 386,
                        "hold": 57,
                        "slide": 21,
                        "touch": null,
                        "break": 10,
                        "total": 474
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 792,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 483,
                        "hold": 48,
                        "slide": 138,
                        "touch": null,
                        "break": 2,
                        "total": 671
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 792,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 564,
                        "hold": 44,
                        "slide": 105,
                        "touch": null,
                        "break": 27,
                        "total": 740
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 792,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2018-12-13"
                }
            ],
            "searchAcronyms": [
                "7810",
                "fufu遇刺",
                "hibana",
                "HIBANA",
                "rechan",
                "七八十",
                "初音未来被爆头",
                "初音爆头",
                "匕八十",
                "匕八卜",
                "大狙架Miku",
                "大狙架初音",
                "火化",
                "火花",
                "爆头初音",
                "狙击fufu",
                "狙击初音",
                "狙击初音未来",
                "狙初音",
                "肯尼迪"
            ]
        },
        {
            "songId": "ロキ",
            "category": "niconico＆ボーカロイド",
            "title": "ロキ",
            "artist": "みきとP",
            "bpm": 150,
            "imageName": "f1dd2a0b18a6df05e73307ce49369cc327ce4415e9186d108cab1200e509b9a0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 15,
                        "slide": 6,
                        "touch": null,
                        "break": 7,
                        "total": 217
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 793,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 313,
                        "hold": 22,
                        "slide": 10,
                        "touch": null,
                        "break": 22,
                        "total": 367
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 793,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 355,
                        "hold": 61,
                        "slide": 63,
                        "touch": null,
                        "break": 17,
                        "total": 496
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 793,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 566,
                        "hold": 43,
                        "slide": 117,
                        "touch": null,
                        "break": 4,
                        "total": 730
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 793,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 661,
                        "hold": 57,
                        "slide": 110,
                        "touch": null,
                        "break": 11,
                        "total": 839
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 793,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2018-12-13"
                }
            ],
            "searchAcronyms": [
                "loki",
                "roki",
                "ROKI",
                "口≠",
                "口丰",
                "口干",
                "㕩"
            ]
        },
        {
            "songId": "Money Money",
            "category": "東方Project",
            "title": "Money Money",
            "artist": "暁Records",
            "bpm": 145,
            "imageName": "81c1636f47a700a396f868a45ea446269baf77c885821ad16bcb8cf0fd844b9d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 139,
                        "hold": 18,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 171
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 794,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 30,
                        "slide": 24,
                        "touch": null,
                        "break": 24,
                        "total": 350
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 794,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 72,
                        "slide": 44,
                        "touch": null,
                        "break": 14,
                        "total": 467
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 794,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 555,
                        "hold": 64,
                        "slide": 85,
                        "touch": null,
                        "break": 41,
                        "total": 745
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 794,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.2
                    },
                    "releaseDate": "2018-12-13"
                }
            ],
            "searchAcronyms": [
                "💰",
                "moneymoney",
                "m属性大爆发",
                "富哥v我50",
                "紫苑镇",
                "钱钱",
                "钱钱钱钱钱",
                "马内马内",
                "骂你骂你"
            ]
        },
        {
            "songId": "極圏",
            "category": "ゲーム＆バラエティ",
            "title": "極圏",
            "artist": "cosMo VS dj TAKA「SOUND VOLTEX」より",
            "bpm": 207,
            "imageName": "8173619680c5e0a2962f043d26fc1e17b2812b232ca080241c6aba04c1a7da2a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 192,
                        "hold": 31,
                        "slide": 6,
                        "touch": null,
                        "break": 23,
                        "total": 252
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 796,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 379,
                        "hold": 30,
                        "slide": 16,
                        "touch": null,
                        "break": 26,
                        "total": 451
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 796,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 424,
                        "hold": 86,
                        "slide": 51,
                        "touch": null,
                        "break": 20,
                        "total": 581
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 796,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 755,
                        "hold": 74,
                        "slide": 98,
                        "touch": null,
                        "break": 52,
                        "total": 979
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 796,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "Splash": 14.4,
                        "Splash PLUS": 14.4,
                        "UNiVERSE": 14.4,
                        "UNiVERSE PLUS": 14.4,
                        "maimaiでらっくす PLUS": 14.4
                    },
                    "releaseDate": "2018-12-13"
                }
            ],
            "searchAcronyms": [
                "🐔⭕️",
                "🐔⭕",
                "KYOKUKEN",
                "sdvx",
                "只因圈",
                "寄圈",
                "急圈",
                "极圈",
                "極圈",
                "鸡圈"
            ]
        },
        {
            "songId": "Scarlet Lance",
            "category": "ゲーム＆バラエティ",
            "title": "Scarlet Lance",
            "artist": "MASAKI（ZUNTATA）「グルーヴコースター3EXドリームパーティー」より",
            "bpm": 185,
            "imageName": "947ddb753cf8501b8273e2dd5dc4239130df53b8998a4a99e5fbde5e39e6c3ac",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 19,
                        "slide": 12,
                        "touch": null,
                        "break": 13,
                        "total": 285
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 797,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 39,
                        "slide": 23,
                        "touch": null,
                        "break": 17,
                        "total": 397
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 797,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 534,
                        "hold": 53,
                        "slide": 82,
                        "touch": null,
                        "break": 32,
                        "total": 701
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 797,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.4,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 875,
                        "hold": 46,
                        "slide": 70,
                        "touch": null,
                        "break": 45,
                        "total": 1036
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 797,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14.2,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "Splash": 14.1,
                        "Splash PLUS": 14.1,
                        "UNiVERSE": 14.1,
                        "UNiVERSE PLUS": 14.1,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2018-12-13"
                }
            ],
            "searchAcronyms": [
                "朗基努斯之枪",
                "火枪",
                "狗含剑",
                "狗罕见",
                "红叉",
                "红枪",
                "红色紧身裤"
            ]
        },
        {
            "songId": "セイクリッド　ルイン",
            "category": "ゲーム＆バラエティ",
            "title": "セイクリッド　ルイン",
            "artist": "Drop＆祇羽 feat. 葉月ゆら「太鼓の達人」より",
            "bpm": 186,
            "imageName": "48e568a3556295c0aa45a541e7e076e5291c03a73170d25795cabd01643cf54c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 255,
                        "hold": 40,
                        "slide": 15,
                        "touch": null,
                        "break": 7,
                        "total": 317
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 798,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 401,
                        "hold": 35,
                        "slide": 13,
                        "touch": null,
                        "break": 37,
                        "total": 486
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 798,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "LabiLabi",
                    "noteCounts": {
                        "tap": 418,
                        "hold": 34,
                        "slide": 92,
                        "touch": null,
                        "break": 50,
                        "total": 594
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 798,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.6,
                        "BUDDiES PLUS": 12.6,
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL": 12.6,
                        "FESTiVAL PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "UNiVERSE PLUS": 12.6
                    },
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 744,
                        "hold": 33,
                        "slide": 160,
                        "touch": null,
                        "break": 34,
                        "total": 971
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 798,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2018-12-13"
                }
            ],
            "searchAcronyms": [
                "Sacred Ruin",
                "圣墟",
                "圣灭",
                "太鼓达人",
                "肾虚"
            ]
        },
        {
            "songId": "TiamaT:F minor",
            "category": "オンゲキ＆CHUNITHM",
            "title": "TiamaT:F minor",
            "artist": "Team Grimoire",
            "bpm": 215,
            "imageName": "44e10fa8bd28d77c37bb556f032c6b372402c537044c0506ba4387c6017fe2b4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 12,
                        "slide": 1,
                        "touch": null,
                        "break": 6,
                        "total": 356
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 852,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 412,
                        "hold": 48,
                        "slide": 13,
                        "touch": null,
                        "break": 30,
                        "total": 503
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 852,
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 598,
                        "hold": 26,
                        "slide": 120,
                        "touch": null,
                        "break": 56,
                        "total": 800
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 852,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.1,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.1,
                        "UNiVERSE": 12.6,
                        "UNiVERSE PLUS": 13.1
                    },
                    "releaseDate": "2018-12-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "小鳥遊さん vs LabiLabi",
                    "noteCounts": {
                        "tap": 829,
                        "hold": 108,
                        "slide": 124,
                        "touch": null,
                        "break": 61,
                        "total": 1122
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 852,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.6,
                        "BUDDiES PLUS": 14.6,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL": 14.6,
                        "FESTiVAL PLUS": 14.6,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6,
                        "Splash": 14.6,
                        "Splash PLUS": 14.6,
                        "UNiVERSE": 14.6,
                        "UNiVERSE PLUS": 14.6,
                        "maimaiでらっくす PLUS": 14.5
                    },
                    "releaseDate": "2018-12-13"
                }
            ],
            "searchAcronyms": [
                "🦍",
                "m T:F",
                "mtf",
                "tf",
                "tfboys",
                "TFBoys",
                "TFBOYS",
                "Tiama T:FBOYS",
                "tiamat",
                "ttf",
                "TTF",
                "健身教练",
                "兄弟提一把",
                "分割处理旋风",
                "剃阿妈 头：发 米诺人",
                "剃阿妈头发",
                "大猩猩",
                "提",
                "提一提",
                "提亚玛特",
                "提亚马特",
                "提亚马特爱抚米诺",
                "提你妈",
                "提你妈妈",
                "提提，提提提",
                "提瓦特",
                "斑马鲱鱼",
                "泡泡玛特",
                "猩手教程",
                "猩猩歌",
                "老马啊老马唉",
                "青春修炼手册",
                "音响火山",
                "音响龙"
            ]
        },
        {
            "songId": "EVERGREEN",
            "category": "ゲーム＆バラエティ",
            "title": "EVERGREEN",
            "artist": "Cranky",
            "bpm": 145,
            "imageName": "4f04bf75c75dfe85649da6d3ee02ef226ed491fb1a0fa59e3030f11d032eb460",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 16,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 172
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 800,
                    "releaseDate": "2018-12-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 24,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 262
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 800,
                    "releaseDate": "2018-12-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 279,
                        "hold": 69,
                        "slide": 65,
                        "touch": null,
                        "break": 1,
                        "total": 414
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 800,
                    "releaseDate": "2018-12-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 525,
                        "hold": 67,
                        "slide": 37,
                        "touch": null,
                        "break": 23,
                        "total": 652
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 800,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM PLUS": 13.5,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.4
                    },
                    "releaseDate": "2018-12-25"
                }
            ],
            "searchAcronyms": [
                "eg",
                "一直绿",
                "常绿",
                "常绿树",
                "常青",
                "绿一色",
                "长春",
                "长荣",
                "青春永驻"
            ]
        },
        {
            "songId": "金の聖夜霜雪に朽ちて",
            "category": "niconico＆ボーカロイド",
            "title": "金の聖夜霜雪に朽ちて",
            "artist": "デッドボールP",
            "bpm": 185,
            "imageName": "5f69537113c275a050ec7d27660ab63ca75e96d79139dab51db944cf21a5439d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 259,
                        "hold": 14,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 283
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 801,
                    "releaseDate": "2018-12-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 391,
                        "hold": 20,
                        "slide": 15,
                        "touch": null,
                        "break": 20,
                        "total": 446
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 801,
                    "releaseDate": "2018-12-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 495,
                        "hold": 77,
                        "slide": 26,
                        "touch": null,
                        "break": 2,
                        "total": 600
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 801,
                    "releaseDate": "2018-12-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 568,
                        "hold": 70,
                        "slide": 125,
                        "touch": null,
                        "break": 17,
                        "total": 780
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 801,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4
                    },
                    "releaseDate": "2018-12-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "不思議の国のクリスマス",
            "category": "東方Project",
            "title": "不思議の国のクリスマス",
            "artist": "SOUND HOLIC feat. 3L",
            "bpm": 128,
            "imageName": "b43c2d9d9f290bd14a4d31a55ed5b1e87c0241c44586284dbe1165bbf82420c0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 161,
                        "hold": 17,
                        "slide": 9,
                        "touch": null,
                        "break": 6,
                        "total": 193
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 802,
                    "releaseDate": "2018-12-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 19,
                        "slide": 20,
                        "touch": null,
                        "break": 15,
                        "total": 283
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 802,
                    "releaseDate": "2018-12-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 37,
                        "slide": 28,
                        "touch": null,
                        "break": 37,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 802,
                    "releaseDate": "2018-12-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 340,
                        "hold": 12,
                        "slide": 153,
                        "touch": null,
                        "break": 41,
                        "total": 546
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 802,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.1
                    },
                    "releaseDate": "2018-12-25"
                }
            ],
            "searchAcronyms": [
                "不可思议",
                "不思议",
                "不思议之国",
                "不思议国",
                "反海底谭",
                "圣诞节"
            ]
        },
        {
            "songId": "Magical Sound Shower",
            "category": "niconico＆ボーカロイド",
            "title": "Magical Sound Shower",
            "artist": "HIRO/曲者P",
            "bpm": 120,
            "imageName": "be2822067f9d0c9b5b8bd4584124d598909878f38e815bb37f22fb7ec1e74489",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 20,
                        "slide": 3,
                        "touch": null,
                        "break": 4,
                        "total": 224
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 804,
                    "releaseDate": "2019-01-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 30,
                        "slide": 6,
                        "touch": null,
                        "break": 12,
                        "total": 320
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 804,
                    "releaseDate": "2019-01-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 304,
                        "hold": 48,
                        "slide": 32,
                        "touch": null,
                        "break": 39,
                        "total": 423
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 804,
                    "releaseDate": "2019-01-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 585,
                        "hold": 26,
                        "slide": 43,
                        "touch": null,
                        "break": 8,
                        "total": 662
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 804,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM PLUS": 13.4,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.6
                    },
                    "releaseDate": "2019-01-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "片想いサンバ",
            "category": "niconico＆ボーカロイド",
            "title": "片想いサンバ",
            "artist": "オワタP",
            "bpm": 150,
            "imageName": "5092f1b25556ff183e55db255ce5026f66627c025432dd21496ae61fc1c4dd43",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 4,
                        "slide": 4,
                        "touch": null,
                        "break": 8,
                        "total": 296
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 805,
                    "releaseDate": "2019-01-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 316,
                        "hold": 34,
                        "slide": 4,
                        "touch": null,
                        "break": 26,
                        "total": 380
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 805,
                    "releaseDate": "2019-01-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 361,
                        "hold": 98,
                        "slide": 48,
                        "touch": null,
                        "break": 28,
                        "total": 535
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 805,
                    "releaseDate": "2019-01-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 658,
                        "hold": 40,
                        "slide": 71,
                        "touch": null,
                        "break": 47,
                        "total": 816
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 805,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2019-01-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ナイトメア☆パーティーナイト",
            "category": "niconico＆ボーカロイド",
            "title": "ナイトメア☆パーティーナイト",
            "artist": "くちばしP",
            "bpm": 175,
            "imageName": "1ba4f318c7974d80d5a06773f3e09e4d521ad6b7b3660c70bebea8545f60438c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 22,
                        "slide": 10,
                        "touch": null,
                        "break": 9,
                        "total": 246
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 806,
                    "releaseDate": "2019-01-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 42,
                        "slide": 13,
                        "touch": null,
                        "break": 26,
                        "total": 419
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 806,
                    "releaseDate": "2019-01-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 415,
                        "hold": 75,
                        "slide": 50,
                        "touch": null,
                        "break": 20,
                        "total": 560
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 806,
                    "releaseDate": "2019-01-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 515,
                        "hold": 11,
                        "slide": 162,
                        "touch": null,
                        "break": 5,
                        "total": 693
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 806,
                    "releaseDate": "2019-01-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 468,
                        "hold": 82,
                        "slide": 97,
                        "touch": null,
                        "break": 48,
                        "total": 695
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 806,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12
                    },
                    "releaseDate": "2019-01-11"
                }
            ],
            "searchAcronyms": [
                "nightmare party night",
                "nightmarepartynight",
                "初音小摩尔",
                "初音月下舞",
                "华",
                "华月",
                "噩梦派对之夜",
                "噩梦派对夜",
                "小丑初音",
                "月下初音",
                "月初音",
                "月球miku",
                "華月"
            ]
        },
        {
            "songId": "フキゲンワルツ",
            "category": "niconico＆ボーカロイド",
            "title": "フキゲンワルツ",
            "artist": "OSTER project",
            "bpm": 210,
            "imageName": "219a26dc7ca5f9264726406035425b2048a83db2e13c4b5d42fc3aff77dac456",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 2,
                        "slide": 6,
                        "touch": null,
                        "break": 3,
                        "total": 289
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 807,
                    "releaseDate": "2019-01-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 283,
                        "hold": 19,
                        "slide": 10,
                        "touch": null,
                        "break": 6,
                        "total": 318
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 807,
                    "releaseDate": "2019-01-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 68,
                        "slide": 31,
                        "touch": null,
                        "break": 6,
                        "total": 462
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 807,
                    "releaseDate": "2019-01-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 593,
                        "hold": 64,
                        "slide": 96,
                        "touch": null,
                        "break": 23,
                        "total": 776
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 807,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.6
                    },
                    "releaseDate": "2019-01-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "結ンデ開イテ羅刹ト骸",
            "category": "niconico＆ボーカロイド",
            "title": "結ンデ開イテ羅刹ト骸",
            "artist": "ハチ",
            "bpm": 169,
            "imageName": "ee79b48df1ebd2157a857293c4429e121e274a30145b8369d293909a3ea6fb83",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 179,
                        "hold": 14,
                        "slide": 8,
                        "touch": null,
                        "break": 3,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 809,
                    "releaseDate": "2019-01-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 17,
                        "slide": 2,
                        "touch": null,
                        "break": 4,
                        "total": 341
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 809,
                    "releaseDate": "2019-01-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 77,
                        "slide": 26,
                        "touch": null,
                        "break": 8,
                        "total": 455
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 809,
                    "releaseDate": "2019-01-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 472,
                        "hold": 40,
                        "slide": 73,
                        "touch": null,
                        "break": 2,
                        "total": 587
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 809,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "FESTiVAL": 12,
                        "PRiSM PLUS": 12,
                        "UNiVERSE PLUS": 12
                    },
                    "releaseDate": "2019-01-25"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 559,
                        "hold": 16,
                        "slide": 111,
                        "touch": null,
                        "break": 11,
                        "total": 697
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 809,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2019-01-25"
                }
            ],
            "searchAcronyms": [
                "八爷",
                "分分合合的罗刹与骨骸",
                "结骸",
                "罗刹",
                "连起来又分开，罗刹与骨骸"
            ]
        },
        {
            "songId": "サウンド",
            "category": "niconico＆ボーカロイド",
            "title": "サウンド",
            "artist": "baker",
            "bpm": 160,
            "imageName": "174973f19a9d641d2e4121969740275e2031048f7d9a5d6d1f1bb7a9b8a6992a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 1,
                        "slide": 5,
                        "touch": null,
                        "break": 7,
                        "total": 222
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 810,
                    "releaseDate": "2019-01-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 260,
                        "hold": 16,
                        "slide": 12,
                        "touch": null,
                        "break": 10,
                        "total": 298
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 810,
                    "releaseDate": "2019-01-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 320,
                        "hold": 57,
                        "slide": 14,
                        "touch": null,
                        "break": 1,
                        "total": 392
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 810,
                    "releaseDate": "2019-01-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 501,
                        "hold": 21,
                        "slide": 108,
                        "touch": null,
                        "break": 12,
                        "total": 642
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 810,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2019-01-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "右肩の蝶",
            "category": "niconico＆ボーカロイド",
            "title": "右肩の蝶",
            "artist": "のりP",
            "bpm": 140,
            "imageName": "b4e5b5a4eccc244c24dfce7d77552c496189835abed230c69517ed6e7b610219",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 224,
                        "hold": 8,
                        "slide": 6,
                        "touch": null,
                        "break": 4,
                        "total": 242
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 811,
                    "releaseDate": "2019-01-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 18,
                        "slide": 12,
                        "touch": null,
                        "break": 12,
                        "total": 324
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 811,
                    "releaseDate": "2019-01-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 312,
                        "hold": 72,
                        "slide": 52,
                        "touch": null,
                        "break": 13,
                        "total": 449
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 811,
                    "releaseDate": "2019-01-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "ものくろっく",
                    "noteCounts": {
                        "tap": 545,
                        "hold": 66,
                        "slide": 130,
                        "touch": null,
                        "break": 16,
                        "total": 757
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 811,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.1,
                        "UNiVERSE PLUS": 13.1
                    },
                    "releaseDate": "2019-01-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "カラフル×メロディ",
            "category": "niconico＆ボーカロイド",
            "title": "カラフル×メロディ",
            "artist": "ちーむMOER",
            "bpm": 185,
            "imageName": "b33afbe50eede0d5aa8a0e8671b1c071b5c3f07d11bb5b1f5dec216f51837cd6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 161,
                        "hold": 8,
                        "slide": 7,
                        "touch": null,
                        "break": 8,
                        "total": 184
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 847,
                    "releaseDate": "2019-01-25"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 274,
                        "hold": 18,
                        "slide": 10,
                        "touch": null,
                        "break": 4,
                        "total": 306
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 847,
                    "releaseDate": "2019-01-25"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 34,
                        "slide": 32,
                        "touch": null,
                        "break": 26,
                        "total": 427
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 847,
                    "releaseDate": "2019-01-25"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 423,
                        "hold": 39,
                        "slide": 96,
                        "touch": null,
                        "break": 4,
                        "total": 562
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 847,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "UNiVERSE PLUS": 12.6
                    },
                    "releaseDate": "2019-01-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "L4TS:2018 (feat. あひる & KTA)",
            "category": "ゲーム＆バラエティ",
            "title": "L4TS:2018 (feat. あひる & KTA)",
            "artist": "Sprite Recordings",
            "bpm": 190,
            "imageName": "df9555db33d3cd2aa1b6242573e877e30eb8d053b5df61b467d133ff0aeefb5b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 16,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 153
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 815,
                    "releaseDate": "2019-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 211,
                        "hold": 25,
                        "slide": 18,
                        "touch": null,
                        "break": 7,
                        "total": 261
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 815,
                    "releaseDate": "2019-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 38,
                        "slide": 63,
                        "touch": null,
                        "break": 22,
                        "total": 420
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 815,
                    "releaseDate": "2019-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 391,
                        "hold": 23,
                        "slide": 124,
                        "touch": null,
                        "break": 36,
                        "total": 574
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 815,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2019-02-07"
                }
            ],
            "searchAcronyms": [
                "2018",
                "l4ts",
                "伊蕾娜",
                "小奈子伊蕾娜",
                "白毛萝莉",
                "银发女孩"
            ]
        },
        {
            "songId": "魔法少女になるしかねぇ",
            "category": "ゲーム＆バラエティ",
            "title": "魔法少女になるしかねぇ",
            "artist": "ねこみりん feat.小宮真央",
            "bpm": 165,
            "imageName": "18ebb8f8cc59cdcf4bc088353c419d9d144f29c558f635707288b3cf59f085d0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 16,
                        "slide": 4,
                        "touch": null,
                        "break": 9,
                        "total": 234
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 848,
                    "releaseDate": "2019-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 332,
                        "hold": 30,
                        "slide": 21,
                        "touch": null,
                        "break": 47,
                        "total": 430
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 848,
                    "releaseDate": "2019-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 35,
                        "slide": 73,
                        "touch": null,
                        "break": 27,
                        "total": 537
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 848,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.4,
                        "BUDDiES PLUS": 12.4,
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2019-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 712,
                        "hold": 33,
                        "slide": 124,
                        "touch": null,
                        "break": 87,
                        "total": 956
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 848,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2019-02-07"
                }
            ],
            "searchAcronyms": [
                "马猴烧酒",
                "魔法少女"
            ]
        },
        {
            "songId": "Kattobi KEIKYU Rider",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Kattobi KEIKYU Rider",
            "artist": "Sampling Masters MEGA",
            "bpm": 220,
            "imageName": "64ff93dfeb9bf01a3f86c45b695142b9c8aea1356876fe99bfc63c0a6bec172b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 26,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 304
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 849,
                    "releaseDate": "2019-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 401,
                        "hold": 81,
                        "slide": 31,
                        "touch": null,
                        "break": 24,
                        "total": 537
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 849,
                    "releaseDate": "2019-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 649,
                        "hold": 116,
                        "slide": 45,
                        "touch": null,
                        "break": 18,
                        "total": 828
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 849,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2019-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 510,
                        "hold": 85,
                        "slide": 184,
                        "touch": null,
                        "break": 65,
                        "total": 844
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 849,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "FESTiVAL": 13.9,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.6,
                        "Splash PLUS": 13.6,
                        "UNiVERSE": 13.6,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2019-02-07"
                }
            ],
            "searchAcronyms": [
                "kattobi",
                "丁丁电车",
                "丁丁车",
                "京急",
                "京急电车",
                "列车",
                "卡透批来打",
                "叮叮叮",
                "叮叮电车",
                "叮叮车",
                "收到",
                "爱上火车",
                "电车",
                "电车妹",
                "电车娘",
                "电车骑士"
            ]
        },
        {
            "songId": "B.M.S.",
            "category": "ゲーム＆バラエティ",
            "title": "B.M.S.",
            "artist": "光吉猛修の父",
            "bpm": 200,
            "imageName": "a976f30250a36aa1eaaddd1e275988dc1cb730904cebcd5e2d6eef308d466216",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 8,
                        "slide": 4,
                        "touch": null,
                        "break": 6,
                        "total": 187
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 850,
                    "releaseDate": "2019-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 255,
                        "hold": 52,
                        "slide": 15,
                        "touch": null,
                        "break": 36,
                        "total": 358
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 850,
                    "releaseDate": "2019-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 394,
                        "hold": 39,
                        "slide": 86,
                        "touch": null,
                        "break": 3,
                        "total": 522
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 850,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2019-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 687,
                        "hold": 84,
                        "slide": 51,
                        "touch": null,
                        "break": 31,
                        "total": 853
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 850,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "Splash": 14,
                        "Splash PLUS": 14,
                        "UNiVERSE": 14,
                        "UNiVERSE PLUS": 14,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2019-02-07"
                }
            ],
            "searchAcronyms": [
                "bms",
                "光吉",
                "光吉猛修他爹",
                "冰美式",
                "广九皆传攻略",
                "披萨",
                "抱猫神",
                "达美乐披萨"
            ]
        },
        {
            "songId": "クレイジークレイジーダンサーズ",
            "category": "東方Project",
            "title": "クレイジークレイジーダンサーズ",
            "artist": "ビートまりお＋あまね（COOL&CREATE）",
            "bpm": 172,
            "imageName": "0e533966d5248330c0d83a2a722e3c77e3eb44d607428fe2fe1bb53cadaad9d5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 13,
                        "slide": 5,
                        "touch": null,
                        "break": 11,
                        "total": 215
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 816,
                    "releaseDate": "2019-02-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 307,
                        "hold": 20,
                        "slide": 11,
                        "touch": null,
                        "break": 58,
                        "total": 396
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 816,
                    "releaseDate": "2019-02-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 340,
                        "hold": 62,
                        "slide": 59,
                        "touch": null,
                        "break": 49,
                        "total": 510
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 816,
                    "releaseDate": "2019-02-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 459,
                        "hold": 31,
                        "slide": 105,
                        "touch": null,
                        "break": 11,
                        "total": 606
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 816,
                    "releaseDate": "2019-02-22"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 469,
                        "hold": 27,
                        "slide": 113,
                        "touch": null,
                        "break": 185,
                        "total": 794
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 816,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 13.6
                    },
                    "releaseDate": "2019-02-22"
                }
            ],
            "searchAcronyms": [
                "185",
                "ccd",
                "二人危险炸弹",
                "女同6",
                "尬舞姐妹2",
                "疯狂疯狂跳舞"
            ]
        },
        {
            "songId": "【東方ニコカラ】秘神マターラ feat.魂音泉【IOSYS】",
            "category": "東方Project",
            "title": "【東方ニコカラ】秘神マターラ feat.魂音泉【IOSYS】",
            "artist": "ARM (IOSYS)",
            "bpm": 168,
            "imageName": "328bbbb73c655da5099724717c4d6ead480f056e22c659858faa6432767f4695",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 192,
                        "hold": 18,
                        "slide": 4,
                        "touch": null,
                        "break": 17,
                        "total": 231
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 817,
                    "releaseDate": "2019-02-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 56,
                        "slide": 12,
                        "touch": null,
                        "break": 25,
                        "total": 429
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 817,
                    "releaseDate": "2019-02-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 408,
                        "hold": 63,
                        "slide": 50,
                        "touch": null,
                        "break": 48,
                        "total": 569
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 817,
                    "releaseDate": "2019-02-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 607,
                        "hold": 26,
                        "slide": 165,
                        "touch": null,
                        "break": 53,
                        "total": 851
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 817,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2019-02-22"
                }
            ],
            "searchAcronyms": [
                "[Toho nicokara]Secret God Matara feat.TAMAONSEN[IOSYS]",
                "Secret God matara",
                "东方〇起",
                "东方勃起",
                "秘神",
                "见前"
            ]
        },
        {
            "songId": "隠然",
            "category": "東方Project",
            "title": "隠然",
            "artist": "豚乙女",
            "bpm": 210,
            "imageName": "33f19f6a7e0800620ad34ecd8531881d605371e1698d80b944eae47ea856374f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 9,
                        "slide": 12,
                        "touch": null,
                        "break": 4,
                        "total": 234
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 818,
                    "releaseDate": "2019-02-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 22,
                        "slide": 22,
                        "touch": null,
                        "break": 8,
                        "total": 416
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 818,
                    "releaseDate": "2019-02-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 475,
                        "hold": 49,
                        "slide": 29,
                        "touch": null,
                        "break": 32,
                        "total": 585
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 818,
                    "releaseDate": "2019-02-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 643,
                        "hold": 24,
                        "slide": 61,
                        "touch": null,
                        "break": 1,
                        "total": 729
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 818,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2019-02-22"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 535,
                        "hold": 78,
                        "slide": 106,
                        "touch": null,
                        "break": 15,
                        "total": 734
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 818,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2019-02-22"
                }
            ],
            "searchAcronyms": [
                "隐然"
            ]
        },
        {
            "songId": "White Traveling Girl",
            "category": "東方Project",
            "title": "White Traveling Girl",
            "artist": "A-One",
            "bpm": 154,
            "imageName": "9d2050e7395cd7ca194e135756633f1a1e52a47ef814cfeda783b9f72934c1e9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 168,
                        "hold": 15,
                        "slide": 14,
                        "touch": null,
                        "break": 6,
                        "total": 203
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 819,
                    "releaseDate": "2019-02-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 269,
                        "hold": 25,
                        "slide": 17,
                        "touch": null,
                        "break": 8,
                        "total": 319
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 819,
                    "releaseDate": "2019-02-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 418,
                        "hold": 81,
                        "slide": 24,
                        "touch": null,
                        "break": 37,
                        "total": 560
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 819,
                    "releaseDate": "2019-02-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 554,
                        "hold": 86,
                        "slide": 107,
                        "touch": null,
                        "break": 58,
                        "total": 805
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 819,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2019-02-22"
                }
            ],
            "searchAcronyms": [
                "wtg",
                "白旅女",
                "白色旅人",
                "白色旅行女孩",
                "白色旅行少女",
                "萃香",
                "西瓜fumo"
            ]
        },
        {
            "songId": "-OutsideR:RequieM-",
            "category": "オンゲキ＆CHUNITHM",
            "title": "-OutsideR:RequieM-",
            "artist": "箱部なる(CV:M・A・O)",
            "bpm": 181,
            "imageName": "37df15fcc1d88d335c97e8db50f4fd6be16663db1208f4d69567451112d8c88f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 173,
                        "hold": 21,
                        "slide": 10,
                        "touch": null,
                        "break": 7,
                        "total": 211
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 821,
                    "releaseDate": "2019-03-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 274,
                        "hold": 28,
                        "slide": 20,
                        "touch": null,
                        "break": 6,
                        "total": 328
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 821,
                    "releaseDate": "2019-03-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 421,
                        "hold": 56,
                        "slide": 40,
                        "touch": null,
                        "break": 3,
                        "total": 520
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 821,
                    "releaseDate": "2019-03-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 636,
                        "hold": 21,
                        "slide": 130,
                        "touch": null,
                        "break": 30,
                        "total": 817
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 821,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.6,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash": 13,
                        "Splash PLUS": 13.4,
                        "UNiVERSE": 13.4,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2019-03-08"
                }
            ],
            "searchAcronyms": [
                "🍜",
                "outsider",
                "吃拉面",
                "吃泡面",
                "吃面",
                "嗦拉面",
                "妹子嗦面",
                "我和我的泡面",
                "拉面",
                "泡面"
            ]
        },
        {
            "songId": "イロトリドリのメロディ",
            "category": "オンゲキ＆CHUNITHM",
            "title": "イロトリドリのメロディ",
            "artist": "小仏凪(CV:佐倉薫)",
            "bpm": 140,
            "imageName": "82545d16b6709a93d8bffd7070c9b6eb2224f3f5b7c3b37f508ea816ea97b849",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 7,
                        "slide": 11,
                        "touch": null,
                        "break": 6,
                        "total": 166
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 822,
                    "releaseDate": "2019-03-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 215,
                        "hold": 8,
                        "slide": 19,
                        "touch": null,
                        "break": 8,
                        "total": 250
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 822,
                    "releaseDate": "2019-03-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 314,
                        "hold": 40,
                        "slide": 34,
                        "touch": null,
                        "break": 18,
                        "total": 406
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 822,
                    "releaseDate": "2019-03-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 483,
                        "hold": 27,
                        "slide": 42,
                        "touch": null,
                        "break": 23,
                        "total": 575
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 822,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2019-03-08"
                }
            ],
            "searchAcronyms": [
                "Irotoridori no melody",
                "多彩旋律",
                "小仏凪",
                "彩绿之歌",
                "端茶"
            ]
        },
        {
            "songId": "奏者はただ背中と提琴で語るのみ",
            "category": "オンゲキ＆CHUNITHM",
            "title": "奏者はただ背中と提琴で語るのみ",
            "artist": "月鈴那知(CV:今村彩夏)",
            "bpm": 230,
            "imageName": "90157e3973068ace53a8152b854cb3be6ace103a474c1280a074ebe5ef2dda08",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 220,
                        "hold": 56,
                        "slide": 12,
                        "touch": null,
                        "break": 7,
                        "total": 295
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 823,
                    "releaseDate": "2019-03-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 384,
                        "hold": 27,
                        "slide": 22,
                        "touch": null,
                        "break": 1,
                        "total": 434
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 823,
                    "releaseDate": "2019-03-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.3,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 501,
                        "hold": 45,
                        "slide": 60,
                        "touch": null,
                        "break": 10,
                        "total": 616
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 823,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.3,
                        "CiRCLE PLUS": 12.3,
                        "FESTiVAL": 12.3,
                        "PRiSM PLUS": 12.3
                    },
                    "releaseDate": "2019-03-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 698,
                        "hold": 60,
                        "slide": 110,
                        "touch": null,
                        "break": 61,
                        "total": 929
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 823,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2019-03-08"
                }
            ],
            "searchAcronyms": [
                "Sosya ha tada senaka to violin de katarunomi",
                "奏者",
                "奏者背后的提琴在说话",
                "提琴",
                "月玲妹妹躺沙发",
                "美少女躺沙发"
            ]
        },
        {
            "songId": "ラブって♡ジュエリー♪えんじぇる☆ブレイク！！",
            "category": "POPS＆アニメ",
            "title": "ラブって♡ジュエリー♪えんじぇる☆ブレイク！！",
            "artist": "あべにゅうぷろじぇくと feat.天月めぐる＆如月すみれ「ツインエンジェルBREAK」",
            "bpm": 238,
            "imageName": "29db402134e2e87a3ca8ac675851e8e6f7fa05a5bfd430c8a851ba756533e32d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 124,
                        "hold": 22,
                        "slide": 4,
                        "touch": null,
                        "break": 8,
                        "total": 158
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 717,
                    "releaseDate": "2019-03-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 13,
                        "slide": 6,
                        "touch": null,
                        "break": 8,
                        "total": 285
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 717,
                    "releaseDate": "2019-03-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 44,
                        "slide": 27,
                        "touch": null,
                        "break": 36,
                        "total": 404
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 717,
                    "releaseDate": "2019-03-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 18,
                        "slide": 92,
                        "touch": null,
                        "break": 56,
                        "total": 523
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 717,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.5
                    },
                    "releaseDate": "2019-03-22"
                }
            ],
            "searchAcronyms": [
                "Love is ♡ jewelry ♪ Angel ☆ Break",
                "lovette jewelry angel break",
                "刺猬",
                "快盗天使break"
            ]
        },
        {
            "songId": "ガチャガチャきゅ～と・ふぃぎゅ@メイト",
            "category": "POPS＆アニメ",
            "title": "ガチャガチャきゅ～と・ふぃぎゅ@メイト",
            "artist": "MOSAIC.WAV",
            "bpm": 178,
            "imageName": "26257dfe483a2c8df54617746703b515da694b42f201056d08e6d067c9830d62",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 8,
                        "slide": 6,
                        "touch": null,
                        "break": 27,
                        "total": 268
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 751,
                    "releaseDate": "2019-03-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 346,
                        "hold": 10,
                        "slide": 16,
                        "touch": null,
                        "break": 16,
                        "total": 388
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 751,
                    "releaseDate": "2019-03-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 394,
                        "hold": 58,
                        "slide": 36,
                        "touch": null,
                        "break": 30,
                        "total": 518
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 751,
                    "releaseDate": "2019-03-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 433,
                        "hold": 35,
                        "slide": 112,
                        "touch": null,
                        "break": 110,
                        "total": 690
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 751,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.3
                    },
                    "releaseDate": "2019-03-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "true my heart -Lovable mix-",
            "category": "POPS＆アニメ",
            "title": "true my heart -Lovable mix-",
            "artist": "ave;new feat.佐倉紗織",
            "bpm": 135,
            "imageName": "a473aeb7cbb436ec62c0e8c24c1fc69e67274fd442bae80d06f67e4c741b81e7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 16,
                        "slide": 11,
                        "touch": null,
                        "break": 3,
                        "total": 167
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 752,
                    "releaseDate": "2019-03-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 265,
                        "hold": 13,
                        "slide": 10,
                        "touch": null,
                        "break": 4,
                        "total": 292
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 752,
                    "releaseDate": "2019-03-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 321,
                        "hold": 38,
                        "slide": 33,
                        "touch": null,
                        "break": 14,
                        "total": 406
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 752,
                    "releaseDate": "2019-03-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 332,
                        "hold": 41,
                        "slide": 87,
                        "touch": null,
                        "break": 16,
                        "total": 476
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 752,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2019-03-22"
                }
            ],
            "searchAcronyms": [
                "打电话",
                "李云龙",
                "真我心"
            ]
        },
        {
            "songId": "キミとボクのミライ",
            "category": "ゲーム＆バラエティ",
            "title": "キミとボクのミライ",
            "artist": "ジータ（CV:金元寿子）、ルリア（CV:東山奈央）、ヴィーラ（CV:今井麻美）、マリー（CV:長谷川明子）",
            "bpm": 178,
            "imageName": "5c2faa986af0c6d6c23b83be595394bd3f6acfb5974bb0789bf325ca884180f9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 132,
                        "hold": 7,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 826,
                    "releaseDate": "2019-04-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 8,
                        "slide": 17,
                        "touch": null,
                        "break": 6,
                        "total": 294
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 826,
                    "releaseDate": "2019-04-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 33,
                        "slide": 50,
                        "touch": null,
                        "break": 10,
                        "total": 378
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 826,
                    "releaseDate": "2019-04-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 414,
                        "hold": 12,
                        "slide": 87,
                        "touch": null,
                        "break": 4,
                        "total": 517
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 826,
                    "releaseDate": "2019-04-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 455,
                        "hold": 34,
                        "slide": 96,
                        "touch": null,
                        "break": 18,
                        "total": 603
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 826,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.2,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2019-04-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Lost Princess",
            "category": "ゲーム＆バラエティ",
            "title": "Lost Princess",
            "artist": "ペコリーヌ（CV：M・A・O）、コッコロ（CV：伊藤美来）、キャル（CV：立花理香）",
            "bpm": 150,
            "imageName": "53e753e4cd9917ba5e5091972e9fc4b0a5670e76792e4c1775481f75cb357591",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 87,
                        "hold": 14,
                        "slide": 6,
                        "touch": null,
                        "break": 2,
                        "total": 109
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 827,
                    "releaseDate": "2019-04-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 152,
                        "hold": 17,
                        "slide": 15,
                        "touch": null,
                        "break": 12,
                        "total": 196
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 827,
                    "releaseDate": "2019-04-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 16,
                        "slide": 40,
                        "touch": null,
                        "break": 11,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 827,
                    "releaseDate": "2019-04-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 15,
                        "slide": 75,
                        "touch": null,
                        "break": 6,
                        "total": 372
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 827,
                    "releaseDate": "2019-04-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 249,
                        "hold": 36,
                        "slide": 70,
                        "touch": null,
                        "break": 13,
                        "total": 368
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 827,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash": 12
                    },
                    "releaseDate": "2019-04-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "敗北の少年",
            "category": "niconico＆ボーカロイド",
            "title": "敗北の少年",
            "artist": "kemu",
            "bpm": 185,
            "imageName": "afa6fc852db8577efa824c5d2c176e6467ce9333641648aea765924376e66b4b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 213,
                        "hold": 23,
                        "slide": 7,
                        "touch": null,
                        "break": 8,
                        "total": 251
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 829,
                    "releaseDate": "2019-04-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 405,
                        "hold": 14,
                        "slide": 24,
                        "touch": null,
                        "break": 4,
                        "total": 447
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 829,
                    "releaseDate": "2019-04-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 544,
                        "hold": 35,
                        "slide": 40,
                        "touch": null,
                        "break": 17,
                        "total": 636
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 829,
                    "releaseDate": "2019-04-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 769,
                        "hold": 18,
                        "slide": 166,
                        "touch": null,
                        "break": 15,
                        "total": 968
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 829,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2019-04-26"
                }
            ],
            "searchAcronyms": [
                "我",
                "败北",
                "败北少年",
                "败北的少年",
                "黑丝破洞"
            ]
        },
        {
            "songId": "立ち入り禁止",
            "category": "niconico＆ボーカロイド",
            "title": "立ち入り禁止",
            "artist": "まふまふ",
            "bpm": 160,
            "imageName": "da8fdad1868d1dbb0c2f6c4aa8ed9c11d6103af0db4829c5637af56d6ab9c371",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 7,
                        "slide": 8,
                        "touch": null,
                        "break": 3,
                        "total": 215
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 830,
                    "releaseDate": "2019-04-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 23,
                        "slide": 9,
                        "touch": null,
                        "break": 5,
                        "total": 393
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 830,
                    "releaseDate": "2019-04-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 441,
                        "hold": 67,
                        "slide": 35,
                        "touch": null,
                        "break": 15,
                        "total": 558
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 830,
                    "releaseDate": "2019-04-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.1,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 635,
                        "hold": 14,
                        "slide": 109,
                        "touch": null,
                        "break": 10,
                        "total": 768
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 830,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.1,
                        "CiRCLE PLUS": 12.1,
                        "PRiSM PLUS": 12.1
                    },
                    "releaseDate": "2019-04-26"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 801,
                        "hold": 23,
                        "slide": 76,
                        "touch": null,
                        "break": 53,
                        "total": 953
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 830,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.6
                    },
                    "releaseDate": "2019-04-26"
                }
            ],
            "searchAcronyms": [
                "🚫",
                "后入禁止",
                "后入群主",
                "禁止寸止",
                "禁止进入",
                "立入禁止"
            ]
        },
        {
            "songId": "命ばっかり",
            "category": "niconico＆ボーカロイド",
            "title": "命ばっかり",
            "artist": "ぬゆり",
            "bpm": 128,
            "imageName": "4b870028a4882de5b4bca72921806fc2f7b86a2e58b45b2cbe17a2c1aac3a452",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 14,
                        "slide": 5,
                        "touch": null,
                        "break": 3,
                        "total": 167
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 832,
                    "releaseDate": "2019-04-26"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 11,
                        "slide": 5,
                        "touch": null,
                        "break": 2,
                        "total": 313
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 832,
                    "releaseDate": "2019-04-26"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 268,
                        "hold": 38,
                        "slide": 38,
                        "touch": null,
                        "break": 20,
                        "total": 364
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 832,
                    "releaseDate": "2019-04-26"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 505,
                        "hold": 54,
                        "slide": 68,
                        "touch": null,
                        "break": 4,
                        "total": 631
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 832,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.2
                    },
                    "releaseDate": "2019-04-26"
                }
            ],
            "searchAcronyms": [
                "inochi bakkari",
                "It's Just Life",
                "Nothing But Life",
                "全是命",
                "只为生命",
                "只有命",
                "命",
                "命没",
                "蓝色男人坐沙发"
            ]
        },
        {
            "songId": "Good Bye, Mr. Jack",
            "category": "ゲーム＆バラエティ",
            "title": "Good Bye, Mr. Jack",
            "artist": "sasakure.UK",
            "bpm": 180,
            "imageName": "523cf8b9f9da62a9aceb41f1fcb1b6673ecee8b3a7bab1388ef01dd8c64c41aa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 171,
                        "hold": 14,
                        "slide": 13,
                        "touch": null,
                        "break": 4,
                        "total": 202
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 836,
                    "releaseDate": "2019-05-10"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 319,
                        "hold": 56,
                        "slide": 25,
                        "touch": null,
                        "break": 4,
                        "total": 404
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 836,
                    "releaseDate": "2019-05-10"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 507,
                        "hold": 76,
                        "slide": 43,
                        "touch": null,
                        "break": 11,
                        "total": 637
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 836,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2019-05-10"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 755,
                        "hold": 92,
                        "slide": 75,
                        "touch": null,
                        "break": 11,
                        "total": 933
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 836,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2019-05-10"
                }
            ],
            "searchAcronyms": [
                "再见",
                "再见杰克",
                "再见杰哥",
                "我不打叠辣",
                "杰哥"
            ]
        },
        {
            "songId": "Altale",
            "category": "ゲーム＆バラエティ",
            "title": "Altale",
            "artist": "削除",
            "bpm": 90,
            "imageName": "60e7212f4697f9b892401a54c8dee9a55752c314a65c65552e41e5cfbc3eac57",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 126,
                        "hold": 10,
                        "slide": 7,
                        "touch": null,
                        "break": 2,
                        "total": 145
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 837,
                    "releaseDate": "2019-05-10"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 195,
                        "hold": 47,
                        "slide": 10,
                        "touch": null,
                        "break": 4,
                        "total": 256
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 837,
                    "releaseDate": "2019-05-10"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 52,
                        "slide": 24,
                        "touch": null,
                        "break": 21,
                        "total": 402
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 837,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.4,
                        "BUDDiES PLUS": 12.4,
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL": 12.4,
                        "FESTiVAL PLUS": 12.4,
                        "PRiSM PLUS": 12.4,
                        "UNiVERSE PLUS": 12.4
                    },
                    "releaseDate": "2019-05-10"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 371,
                        "hold": 7,
                        "slide": 81,
                        "touch": null,
                        "break": 28,
                        "total": 487
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 837,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.5,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2019-05-10"
                }
            ],
            "searchAcronyms": [
                "你先别急",
                "别急2",
                "削除的电线",
                "开心的小曲儿",
                "机器人",
                "机器人钓鱼",
                "漏电电线",
                "电线",
                "阿泰尔"
            ]
        },
        {
            "songId": "最終鬼畜妹フランドール・S",
            "category": "東方Project",
            "title": "最終鬼畜妹フランドール・S",
            "artist": "ビートまりお（COOL&CREATE）",
            "bpm": 200,
            "imageName": "cc99937dd0be9c2406cd598df758c1b3e01a39db61618d08467e311d3999b12a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 10,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 165
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 838,
                    "releaseDate": "2019-05-24"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 331,
                        "hold": 19,
                        "slide": 27,
                        "touch": null,
                        "break": 4,
                        "total": 381
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 838,
                    "releaseDate": "2019-05-24"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 401,
                        "hold": 89,
                        "slide": 41,
                        "touch": null,
                        "break": 30,
                        "total": 561
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 838,
                    "releaseDate": "2019-05-24"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.1,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 472,
                        "hold": 42,
                        "slide": 144,
                        "touch": null,
                        "break": 8,
                        "total": 666
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 838,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.1,
                        "CiRCLE PLUS": 12.1,
                        "PRiSM PLUS": 12.1
                    },
                    "releaseDate": "2019-05-24"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 590,
                        "hold": 87,
                        "slide": 125,
                        "touch": null,
                        "break": 51,
                        "total": 853
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 838,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.6
                    },
                    "releaseDate": "2019-05-23"
                }
            ],
            "searchAcronyms": [
                "Last Brutal Sister Flandre S",
                "二妹",
                "二小姐",
                "最终鬼畜妹",
                "蓝蓝路",
                "鬼畜妹"
            ]
        },
        {
            "songId": "ネクロファンタジア～Arr.Demetori",
            "category": "東方Project",
            "title": "ネクロファンタジア～Arr.Demetori",
            "artist": "Demetori",
            "bpm": 180,
            "imageName": "4ed1912d72cc9a58eb182f5a9fa3668db00475a34d0ba9b7b60974807e45ba77",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 164,
                        "hold": 14,
                        "slide": 9,
                        "touch": null,
                        "break": 5,
                        "total": 192
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 839,
                    "releaseDate": "2019-05-24"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 331,
                        "hold": 21,
                        "slide": 26,
                        "touch": null,
                        "break": 8,
                        "total": 386
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 839,
                    "releaseDate": "2019-05-24"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 410,
                        "hold": 66,
                        "slide": 59,
                        "touch": null,
                        "break": 54,
                        "total": 589
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 839,
                    "releaseDate": "2019-05-24"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 755,
                        "hold": 23,
                        "slide": 168,
                        "touch": null,
                        "break": 25,
                        "total": 971
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 839,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2019-05-24"
                }
            ],
            "searchAcronyms": [
                "arr",
                "demetori",
                "ネクロファンタジア",
                "亡灵幻想曲",
                "少女幻葬曲",
                "紫妈弹吉他",
                "老太婆弹吉他"
            ]
        },
        {
            "songId": "Imperishable Night 2006 (2016 Refine)",
            "category": "東方Project",
            "title": "Imperishable Night 2006 (2016 Refine)",
            "artist": "ゆうゆ / 篠螺悠那",
            "bpm": 161,
            "imageName": "fb208059efd9afa472a2470263161f67986d84cc80de1eac9f5398307a27be92",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 11,
                        "slide": 3,
                        "touch": null,
                        "break": 15,
                        "total": 226
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 840,
                    "releaseDate": "2019-05-24"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 399,
                        "hold": 36,
                        "slide": 10,
                        "touch": null,
                        "break": 3,
                        "total": 448
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 840,
                    "releaseDate": "2019-05-24"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.3,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 528,
                        "hold": 56,
                        "slide": 34,
                        "touch": null,
                        "break": 44,
                        "total": 662
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 840,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.3,
                        "CiRCLE PLUS": 12.3,
                        "PRiSM PLUS": 12.3,
                        "UNiVERSE PLUS": 12.3
                    },
                    "releaseDate": "2019-05-24"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 862,
                        "hold": 26,
                        "slide": 94,
                        "touch": null,
                        "break": 61,
                        "total": 1043
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 840,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2019-05-24"
                }
            ],
            "searchAcronyms": [
                "2006",
                "2016",
                "Imperishable Night",
                "Imperishable Night 2006",
                "永夜抄2006",
                "灵梦玩火"
            ]
        },
        {
            "songId": "終点",
            "category": "niconico＆ボーカロイド",
            "title": "終点",
            "artist": "cosMo@暴走P",
            "bpm": 222,
            "imageName": "809f56703605f42f5cf9602be8043ad44b610ebc82ba35cd8ae852d34ab74742",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 150,
                        "hold": 13,
                        "slide": 5,
                        "touch": null,
                        "break": 8,
                        "total": 176
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 841,
                    "releaseDate": "2019-06-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 17,
                        "slide": 15,
                        "touch": null,
                        "break": 8,
                        "total": 274
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 841,
                    "releaseDate": "2019-06-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 432,
                        "hold": 46,
                        "slide": 35,
                        "touch": null,
                        "break": 18,
                        "total": 531
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 841,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.4,
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL": 12.4,
                        "PRiSM PLUS": 12.4,
                        "UNiVERSE PLUS": 12.4
                    },
                    "releaseDate": "2019-06-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 553,
                        "hold": 39,
                        "slide": 79,
                        "touch": null,
                        "break": 39,
                        "total": 710
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 841,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.6,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.6
                    },
                    "releaseDate": "2019-06-07"
                }
            ],
            "searchAcronyms": [
                "b50里有",
                "终点"
            ]
        },
        {
            "songId": "WORLD'S END UMBRELLA",
            "category": "niconico＆ボーカロイド",
            "title": "WORLD'S END UMBRELLA",
            "artist": "ハチ",
            "bpm": 180,
            "imageName": "d914d64b31a7857e09fb3921c87f3a8711331baa9ac8cc6f9d73a2c4451288c3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 120,
                        "hold": 18,
                        "slide": 5,
                        "touch": null,
                        "break": 5,
                        "total": 148
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 842,
                    "releaseDate": "2019-06-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 23,
                        "slide": 13,
                        "touch": null,
                        "break": 12,
                        "total": 287
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 842,
                    "releaseDate": "2019-06-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 50,
                        "slide": 29,
                        "touch": null,
                        "break": 14,
                        "total": 445
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 842,
                    "releaseDate": "2019-06-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 387,
                        "hold": 46,
                        "slide": 75,
                        "touch": null,
                        "break": 11,
                        "total": 519
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 842,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash": 12
                    },
                    "releaseDate": "2019-06-07"
                }
            ],
            "searchAcronyms": [
                "世末伞",
                "世界终末雨伞",
                "世界结束雨伞",
                "世终雨伞"
            ]
        },
        {
            "songId": "End Time",
            "category": "ゲーム＆バラエティ",
            "title": "End Time",
            "artist": "Cres.",
            "bpm": 180,
            "imageName": "619d0165272c6dac33ce810b624e95aa3c83abbd5ef9eecc2e960812a6197498",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 1,
                        "slide": 4,
                        "touch": null,
                        "break": 5,
                        "total": 198
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 844,
                    "releaseDate": "2019-06-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 281,
                        "hold": 38,
                        "slide": 10,
                        "touch": null,
                        "break": 18,
                        "total": 347
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 844,
                    "releaseDate": "2019-06-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 475,
                        "hold": 64,
                        "slide": 34,
                        "touch": null,
                        "break": 6,
                        "total": 579
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 844,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2019-06-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 829,
                        "hold": 52,
                        "slide": 38,
                        "touch": null,
                        "break": 30,
                        "total": 949
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 844,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "FESTiVAL": 14.6,
                        "FESTiVAL PLUS": 14.7,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7,
                        "Splash": 14.6,
                        "Splash PLUS": 14.6,
                        "UNiVERSE": 14.6,
                        "UNiVERSE PLUS": 14.6,
                        "maimaiでらっくす PLUS": 14.4
                    },
                    "releaseDate": "2019-06-07"
                }
            ],
            "searchAcronyms": [
                "endtime",
                "et",
                "伊岛",
                "最后的老时",
                "嗯了么",
                "嗯得烫",
                "恩德太",
                "恩德檀木",
                "烂尾楼",
                "终焉时刻",
                "结束啦",
                "贤者时间"
            ]
        },
        {
            "songId": "QZKago Requiem",
            "category": "maimai",
            "title": "QZKago Requiem",
            "artist": "t+pazolite",
            "bpm": 257,
            "imageName": "8c0ee3f6c7b7fd3e9eb0e0e2da4e3b979f1dcda4aaeacf37f00fee46bdcc67f3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 270,
                        "hold": 12,
                        "slide": 11,
                        "touch": null,
                        "break": 13,
                        "total": 306
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 799,
                    "releaseDate": "2018-12-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 509,
                        "hold": 24,
                        "slide": 24,
                        "touch": null,
                        "break": 36,
                        "total": 593
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 799,
                    "releaseDate": "2018-12-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 580,
                        "hold": 55,
                        "slide": 64,
                        "touch": null,
                        "break": 32,
                        "total": 731
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 799,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2018-12-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 838,
                        "hold": 12,
                        "slide": 191,
                        "touch": null,
                        "break": 64,
                        "total": 1105
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 799,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "FESTiVAL": 14.8,
                        "FESTiVAL PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8,
                        "Splash": 14.7,
                        "Splash PLUS": 14.8,
                        "UNiVERSE": 14.8,
                        "UNiVERSE PLUS": 14.8,
                        "maimaiでらっくす PLUS": 14.6
                    },
                    "releaseDate": "2018-12-18"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14+",
                    "internalLevelValue": 14.9,
                    "noteDesigner": "Garakuta Scramble!",
                    "noteCounts": {
                        "tap": 861,
                        "hold": 19,
                        "slide": 211,
                        "touch": null,
                        "break": 90,
                        "total": 1181
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 799,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.9,
                        "BUDDiES PLUS": 14.9,
                        "CiRCLE": 14.9,
                        "CiRCLE PLUS": 14.9,
                        "FESTiVAL": 14.9,
                        "FESTiVAL PLUS": 14.9,
                        "PRiSM": 14.9,
                        "PRiSM PLUS": 14.9,
                        "Splash": 14.9,
                        "Splash PLUS": 14.9,
                        "UNiVERSE": 14.9,
                        "UNiVERSE PLUS": 14.9,
                        "maimaiでらっくす PLUS": 14.9
                    },
                    "releaseDate": "2019-05-09"
                }
            ],
            "searchAcronyms": [
                "《tpz重磅14.9》",
                "🍆",
                "🍆💳🐶",
                "15+",
                "gdp2",
                "qz",
                "qzingo",
                "qzk",
                "qzkago",
                "假奶害猫",
                "儿简送2",
                "全家",
                "凯尔希vs嵯峨",
                "凯尔希大战嵯峨",
                "凯尔希打嵯峨",
                "合成大舞神",
                "噎死那个羊",
                "四杀",
                "坏牛奶",
                "垃圾箱镇魂曲",
                "大臣vs左大臣",
                "大臣和左大臣",
                "大臣大战左大臣",
                "大臣左大臣互殴",
                "安魂曲",
                "对立大战光光",
                "小丑牛奶",
                "巧克力vs香子兰",
                "巧克力大战香子兰",
                "巧克力干翻了香子兰",
                "巧克力艹翻了香草",
                "平胸猫大战巨乳猫",
                "毒奶",
                "毒奶粉",
                "毒牛奶",
                "牛奶2",
                "牛奶大战",
                "猫中毒",
                "猫打架",
                "猫猫打架",
                "玲芽之旅",
                "甘茄子",
                "白咲琉璃",
                "群主库",
                "茄",
                "茄子",
                "茄子卡狗",
                "茄子猫",
                "铃芽之旅",
                "铃芽户缔",
                "镇魂曲",
                "黑猫打白猫"
            ]
        },
        {
            "songId": "Schwarzschild",
            "category": "maimai",
            "title": "Schwarzschild",
            "artist": "Tsukasa",
            "bpm": 188,
            "imageName": "fb6e02b14a9e8ff1012842c6acd7ec9be6e0765272e53364742d27b9f8d38e3c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 235,
                        "hold": 16,
                        "slide": 5,
                        "touch": null,
                        "break": 4,
                        "total": 260
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 803,
                    "releaseDate": "2019-01-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 392,
                        "hold": 33,
                        "slide": 16,
                        "touch": null,
                        "break": 2,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 803,
                    "releaseDate": "2019-01-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 392,
                        "hold": 65,
                        "slide": 81,
                        "touch": null,
                        "break": 11,
                        "total": 549
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 803,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2019-01-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "“H”ack",
                    "noteCounts": {
                        "tap": 819,
                        "hold": 28,
                        "slide": 49,
                        "touch": null,
                        "break": 2,
                        "total": 898
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 803,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14,
                        "FESTiVAL PLUS": 14,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 14,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2019-01-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14+",
                    "internalLevelValue": 14.9,
                    "noteDesigner": "“H”ack underground",
                    "noteCounts": {
                        "tap": 806,
                        "hold": 22,
                        "slide": 45,
                        "touch": null,
                        "break": 2,
                        "total": 875
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 803,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.9,
                        "BUDDiES PLUS": 14.9,
                        "CiRCLE": 14.9,
                        "CiRCLE PLUS": 14.9,
                        "FESTiVAL": 14.9,
                        "FESTiVAL PLUS": 14.9,
                        "PRiSM": 14.9,
                        "PRiSM PLUS": 14.9,
                        "Splash": 14.9,
                        "Splash PLUS": 14.9,
                        "UNiVERSE": 14.9,
                        "UNiVERSE PLUS": 14.9,
                        "maimaiでらっくす PLUS": 14.9
                    },
                    "releaseDate": "2019-05-09"
                }
            ],
            "searchAcronyms": [
                "schw",
                "S属性爆发",
                "儿简送3",
                "凯旋最爱",
                "史瓦西",
                "四川火娃",
                "四川火娃弱智齿轮队",
                "四川白娃",
                "四川香水",
                "暗黑之盾",
                "火娃",
                "长香水",
                "黑盾",
                "黑色小孩"
            ]
        },
        {
            "songId": "Alea jacta est!",
            "category": "maimai",
            "title": "Alea jacta est!",
            "artist": "BlackY fused with WAiKURO",
            "bpm": 162,
            "imageName": "cf885f0760a8e67a942c27861bc7c815f697ab81d47fe9f7f3038a3421ef99aa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 313,
                        "hold": 16,
                        "slide": 4,
                        "touch": null,
                        "break": 8,
                        "total": 341
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 812,
                    "releaseDate": "2019-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 27,
                        "slide": 35,
                        "touch": null,
                        "break": 32,
                        "total": 469
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 812,
                    "releaseDate": "2019-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 540,
                        "hold": 74,
                        "slide": 82,
                        "touch": null,
                        "break": 45,
                        "total": 741
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 812,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.5,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2019-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "“Carpe diem” ＊ HAN∀BI",
                    "noteCounts": {
                        "tap": 793,
                        "hold": 51,
                        "slide": 82,
                        "touch": null,
                        "break": 84,
                        "total": 1010
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 812,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "Splash": 14.2,
                        "Splash PLUS": 14.2,
                        "UNiVERSE": 14.2,
                        "UNiVERSE PLUS": 14.2,
                        "maimaiでらっくす PLUS": 14.1
                    },
                    "releaseDate": "2019-02-07"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "小鳥遊さん fused with Phoenix",
                    "noteCounts": {
                        "tap": 906,
                        "hold": 83,
                        "slide": 77,
                        "touch": null,
                        "break": 71,
                        "total": 1137
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 812,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "FESTiVAL": 14.8,
                        "FESTiVAL PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8,
                        "Splash": 14.9,
                        "Splash PLUS": 14.8,
                        "UNiVERSE": 14.8,
                        "UNiVERSE PLUS": 14.8,
                        "maimaiでらっくす PLUS": 14.8
                    },
                    "releaseDate": "2019-02-06"
                }
            ],
            "searchAcronyms": [
                "🤺",
                "aj",
                "aje",
                "alea",
                "内个",
                "农具打架",
                "农具纠纷",
                "击剑",
                "孤注一掷",
                "尼哥打架",
                "尼哥闹矛盾",
                "广州人",
                "打架",
                "木已成舟",
                "机厅纠纷",
                "炸蛋打架",
                "电摇嘲讽",
                "白人打架",
                "种植园纠纷",
                "种植园纷争",
                "科比肘击乔丹",
                "科比肘击牢大",
                "科比肘击詹姆斯",
                "精分神曲",
                "臀批大战mai批",
                "西海岸火并",
                "骰子已经掷下",
                "骰子已被掷下",
                "黑人击剑",
                "黑人打架",
                "黑人打胶"
            ]
        },
        {
            "songId": "FFT",
            "category": "maimai",
            "title": "FFT",
            "artist": "cybermiso",
            "bpm": 180,
            "imageName": "5c8fc242ab90ff214120f0d5927c9e64f05b92cc9db3d950a69891317bbe36f9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 215,
                        "hold": 23,
                        "slide": 14,
                        "touch": null,
                        "break": 8,
                        "total": 260
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 820,
                    "releaseDate": "2019-03-08"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 68,
                        "slide": 18,
                        "touch": null,
                        "break": 15,
                        "total": 383
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 820,
                    "releaseDate": "2019-03-08"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 143,
                        "slide": 53,
                        "touch": null,
                        "break": 22,
                        "total": 407
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 820,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12
                    },
                    "releaseDate": "2019-03-08"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "safaTAmago",
                    "noteCounts": {
                        "tap": 580,
                        "hold": 61,
                        "slide": 173,
                        "touch": null,
                        "break": 35,
                        "total": 849
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 820,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 14,
                        "FESTiVAL PLUS": 14,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 14,
                        "Splash PLUS": 14,
                        "UNiVERSE": 14,
                        "UNiVERSE PLUS": 14,
                        "maimaiでらっくす PLUS": 14
                    },
                    "releaseDate": "2019-03-08"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "JAQ",
                    "noteCounts": {
                        "tap": 711,
                        "hold": 63,
                        "slide": 155,
                        "touch": null,
                        "break": 18,
                        "total": 947
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 820,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "Splash": 14.5,
                        "Splash PLUS": 14.5,
                        "UNiVERSE": 14.5,
                        "UNiVERSE PLUS": 14.5,
                        "maimaiでらっくす PLUS": 14.5
                    },
                    "releaseDate": "2019-03-08"
                }
            ],
            "searchAcronyms": [
                "付费通",
                "傅立叶",
                "傅立叶变换",
                "傅立叶快速变换",
                "傅立叶转换",
                "傅里叶",
                "傅里叶变换",
                "发发图",
                "埃夫爱妇踢",
                "快速傅立叶变换",
                "快速傅里叶变换",
                "狒狒头",
                "狒狒踢",
                "粪粪掏",
                "芳芳痛"
            ]
        },
        {
            "songId": "雷切-RAIKIRI-",
            "category": "maimai",
            "title": "雷切-RAIKIRI-",
            "artist": "kanone",
            "bpm": 165,
            "imageName": "b08f4cf2f0154fb212a8ca33b6e7b2eb6b356f9e2762c91e9a71ead102b568bf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 13,
                        "slide": 14,
                        "touch": null,
                        "break": 17,
                        "total": 301
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 825,
                    "releaseDate": "2019-04-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 304,
                        "hold": 64,
                        "slide": 23,
                        "touch": null,
                        "break": 16,
                        "total": 407
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 825,
                    "releaseDate": "2019-04-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 496,
                        "hold": 47,
                        "slide": 73,
                        "touch": null,
                        "break": 54,
                        "total": 670
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 825,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2019-04-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 1053,
                        "hold": 13,
                        "slide": 85,
                        "touch": null,
                        "break": 39,
                        "total": 1190
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 825,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.6,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL": 14.6,
                        "FESTiVAL PLUS": 14.6,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6,
                        "Splash": 14.6,
                        "Splash PLUS": 14.6,
                        "UNiVERSE": 14.6,
                        "UNiVERSE PLUS": 14.6,
                        "maimaiでらっくす PLUS": 14.4
                    },
                    "releaseDate": "2019-04-11"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "Phoenix",
                    "noteCounts": {
                        "tap": 1007,
                        "hold": 43,
                        "slide": 71,
                        "touch": null,
                        "break": 46,
                        "total": 1167
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 825,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "FESTiVAL": 14.8,
                        "FESTiVAL PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8,
                        "Splash": 14.7,
                        "Splash PLUS": 14.8,
                        "UNiVERSE": 14.8,
                        "UNiVERSE PLUS": 14.8,
                        "maimaiでらっくす PLUS": 14.8
                    },
                    "releaseDate": "2019-05-09"
                }
            ],
            "searchAcronyms": [
                "两把刀",
                "雷切"
            ]
        },
        {
            "songId": "the EmpErroR",
            "category": "maimai",
            "title": "the EmpErroR",
            "artist": "sasakure.UK",
            "bpm": 240,
            "imageName": "1f883e9ec6a96a009ab523e14e02aad9a9ed809773f65df73ed0d10f5df26c09",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 185,
                        "hold": 17,
                        "slide": 8,
                        "touch": null,
                        "break": 3,
                        "total": 213
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 833,
                    "releaseDate": "2019-05-10"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 476,
                        "hold": 35,
                        "slide": 18,
                        "touch": null,
                        "break": 4,
                        "total": 533
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 833,
                    "releaseDate": "2019-05-10"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 657,
                        "hold": 88,
                        "slide": 48,
                        "touch": null,
                        "break": 19,
                        "total": 812
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 833,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2019-05-10"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 938,
                        "hold": 35,
                        "slide": 62,
                        "touch": null,
                        "break": 22,
                        "total": 1057
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 833,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "FESTiVAL": 14.8,
                        "FESTiVAL PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8,
                        "Splash": 14.7,
                        "Splash PLUS": 14.8,
                        "UNiVERSE": 14.8,
                        "UNiVERSE PLUS": 14.8,
                        "maimaiでらっくす PLUS": 14.5
                    },
                    "releaseDate": "2019-05-10"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "14+",
                    "internalLevelValue": 14.9,
                    "noteDesigner": "-ZONE- SaFaRi",
                    "noteCounts": {
                        "tap": 836,
                        "hold": 104,
                        "slide": 102,
                        "touch": null,
                        "break": 15,
                        "total": 1057
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 833,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.9,
                        "BUDDiES PLUS": 14.9,
                        "CiRCLE": 14.9,
                        "CiRCLE PLUS": 14.9,
                        "FESTiVAL": 14.9,
                        "FESTiVAL PLUS": 14.9,
                        "PRiSM": 14.9,
                        "PRiSM PLUS": 14.9,
                        "Splash": 14.9,
                        "Splash PLUS": 14.9,
                        "UNiVERSE": 14.9,
                        "UNiVERSE PLUS": 14.9,
                        "maimaiでらっくす PLUS": 14.9
                    },
                    "releaseDate": "2019-05-10"
                }
            ],
            "searchAcronyms": [
                "👫",
                "emp",
                "emperror",
                "俩跳棋",
                "捏捏捏捏捏",
                "电磁脉冲错误",
                "皇帝",
                "群主"
            ]
        },
        {
            "songId": "PANDORA PARADOXXX",
            "category": "maimai",
            "title": "PANDORA PARADOXXX",
            "artist": "削除",
            "bpm": 150,
            "imageName": "658fe4921a6bcfff951cbd362636a6970d5bbb1df0587ac7819dcccb962c9bd6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 29,
                        "slide": 15,
                        "touch": null,
                        "break": 6,
                        "total": 307
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 834,
                    "releaseDate": "2019-05-10"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 482,
                        "hold": 63,
                        "slide": 10,
                        "touch": null,
                        "break": 13,
                        "total": 568
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 834,
                    "releaseDate": "2019-05-10"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 613,
                        "hold": 72,
                        "slide": 121,
                        "touch": null,
                        "break": 49,
                        "total": 855
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 834,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2019-05-10"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.9,
                    "noteDesigner": "PANDORA BOXXX",
                    "noteCounts": {
                        "tap": 1017,
                        "hold": 98,
                        "slide": 117,
                        "touch": null,
                        "break": 77,
                        "total": 1309
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 834,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.9,
                        "BUDDiES PLUS": 14.9,
                        "CiRCLE": 14.9,
                        "CiRCLE PLUS": 14.9,
                        "FESTiVAL": 14.9,
                        "FESTiVAL PLUS": 14.9,
                        "PRiSM": 14.9,
                        "PRiSM PLUS": 14.9,
                        "Splash": 14.9,
                        "Splash PLUS": 14.9,
                        "UNiVERSE": 14.9,
                        "UNiVERSE PLUS": 14.9,
                        "maimaiでらっくす PLUS": 14.9
                    },
                    "releaseDate": "2019-05-10"
                },
                {
                    "type": "std",
                    "difficulty": "remaster",
                    "level": "15",
                    "internalLevelValue": 15,
                    "noteDesigner": "PANDORA PARADOXXX",
                    "noteCounts": {
                        "tap": 1165,
                        "hold": 72,
                        "slide": 90,
                        "touch": null,
                        "break": 15,
                        "total": 1342
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 834,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 15,
                        "BUDDiES PLUS": 15,
                        "CiRCLE": 15,
                        "CiRCLE PLUS": 15,
                        "FESTiVAL": 15,
                        "FESTiVAL PLUS": 15,
                        "PRiSM": 15,
                        "PRiSM PLUS": 15,
                        "Splash": 15,
                        "Splash PLUS": 15,
                        "UNiVERSE": 15,
                        "UNiVERSE PLUS": 15,
                        "maimaiでらっくす PLUS": 15
                    },
                    "releaseDate": "2019-05-10"
                }
            ],
            "searchAcronyms": [
                "😵‍💫",
                "15",
                "genshin impact",
                "pp",
                "xray",
                "xxx",
                "你游15",
                "儿简送",
                "元梦之星",
                "最水15",
                "原神",
                "噔噔",
                "大学校花",
                "很急",
                "我有抑郁症",
                "推荐乐曲排行榜",
                "新手教程",
                "有手就行",
                "潘",
                "潘你妈",
                "潘多拉",
                "潘多拉悖论",
                "潘小鬼是吧",
                "舞萌最难儿歌",
                "随个15"
            ]
        },
        {
            "songId": "Believe the Rainbow",
            "category": "maimai",
            "title": "Believe the Rainbow",
            "artist": "Shoichiro Hirata feat.Sana",
            "bpm": 133,
            "imageName": "b13a0558714e28404d2d28b2ac0610f9dccef2d83ee157f290522c05ab7be204",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 144,
                        "hold": 11,
                        "slide": 4,
                        "touch": 6,
                        "break": 3,
                        "total": 168
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 198,
                        "hold": 17,
                        "slide": 9,
                        "touch": 26,
                        "break": 4,
                        "total": 254
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 48,
                        "slide": 39,
                        "touch": 64,
                        "break": 21,
                        "total": 386
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 259,
                        "hold": 25,
                        "slide": 116,
                        "touch": 93,
                        "break": 35,
                        "total": 528
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2025-07-12"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 126,
                        "hold": 12,
                        "slide": 8,
                        "touch": null,
                        "break": 6,
                        "total": 152
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 835,
                    "releaseDate": "2019-05-10"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 26,
                        "slide": 28,
                        "touch": null,
                        "break": 11,
                        "total": 342
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 835,
                    "releaseDate": "2019-05-10"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 38,
                        "slide": 43,
                        "touch": null,
                        "break": 14,
                        "total": 370
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 835,
                    "releaseDate": "2019-05-10"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 0,
                        "slide": 242,
                        "touch": null,
                        "break": 7,
                        "total": 445
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FiNALE",
                    "internalId": 835,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 12.4
                    },
                    "releaseDate": "2019-05-10"
                }
            ],
            "searchAcronyms": [
                "🌈",
                "btr",
                "别信彩虹",
                "彩虹",
                "彩虹桥",
                "相信彩虹"
            ]
        },
        {
            "songId": "BLACK ROSE",
            "category": "maimai",
            "title": "BLACK ROSE",
            "artist": "S!N・+α/あるふぁきゅん。×ALI PROJECT",
            "bpm": 145,
            "imageName": "b1284449d73b79515745d564fb92e84b1f7f52c8e0ced93ce6c9981b030115bc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 102,
                        "hold": 10,
                        "slide": 6,
                        "touch": 22,
                        "break": 2,
                        "total": 142
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11001,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 216,
                        "hold": 21,
                        "slide": 14,
                        "touch": 38,
                        "break": 8,
                        "total": 297
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11001,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 301,
                        "hold": 47,
                        "slide": 47,
                        "touch": 46,
                        "break": 4,
                        "total": 445
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11001,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 530,
                        "hold": 39,
                        "slide": 95,
                        "touch": 43,
                        "break": 2,
                        "total": 709
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11001,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "PRiSM PLUS": 12.2
                    },
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": [
                "黑玫瑰"
            ]
        },
        {
            "songId": "Secret Sleuth",
            "category": "maimai",
            "title": "Secret Sleuth",
            "artist": "島爺×蜂屋ななし",
            "bpm": 288,
            "imageName": "41c177b334cf5c221cfae0f6a67c408e840daa5512d5c2658735905d45457551",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 84,
                        "hold": 6,
                        "slide": 4,
                        "touch": 16,
                        "break": 1,
                        "total": 111
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11002,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 185,
                        "hold": 15,
                        "slide": 10,
                        "touch": 42,
                        "break": 11,
                        "total": 263
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11002,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 389,
                        "hold": 83,
                        "slide": 32,
                        "touch": 55,
                        "break": 9,
                        "total": 568
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11002,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 492,
                        "hold": 53,
                        "slide": 83,
                        "touch": 88,
                        "break": 10,
                        "total": 726
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11002,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 13.3,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "maimaiでらっくす PLUS": 13.2
                    },
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 682,
                        "hold": 68,
                        "slide": 103,
                        "touch": 35,
                        "break": 9,
                        "total": 897
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11002,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2021-12-02"
                }
            ],
            "searchAcronyms": [
                "ss",
                "兔爷快乐歌",
                "秘密侦探",
                "言叶2"
            ]
        },
        {
            "songId": "でらっくmaimai♪てんてこまい!",
            "category": "maimai",
            "title": "でらっくmaimai♪てんてこまい!",
            "artist": "やしきん feat.でらっくま(CV:三森すずこ)",
            "bpm": 178,
            "imageName": "ec7af47bd663714e39da4fdc763f18ff78fdb3c8849fc81fd5cb8810ce15fb88",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 130,
                        "hold": 19,
                        "slide": 4,
                        "touch": 11,
                        "break": 7,
                        "total": 171
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11003,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 23,
                        "slide": 20,
                        "touch": 12,
                        "break": 9,
                        "total": 356
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11003,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 404,
                        "hold": 69,
                        "slide": 44,
                        "touch": 61,
                        "break": 10,
                        "total": 588
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11003,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 518,
                        "hold": 44,
                        "slide": 132,
                        "touch": 68,
                        "break": 10,
                        "total": 772
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11003,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.6,
                        "UNiVERSE PLUS": 12.6
                    },
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": [
                "dx主题曲",
                "三森铃子",
                "天手古舞",
                "滴蜡熊",
                "舞萌主题曲",
                "迪拉熊"
            ]
        },
        {
            "songId": "MAXRAGE",
            "category": "maimai",
            "title": "MAXRAGE",
            "artist": "EBIMAYO",
            "bpm": 222,
            "imageName": "3d63e8574fb1ce6b571cbc21bb14c980a24738e0f36e109a1fe5ac8c46b917bc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 158,
                        "hold": 8,
                        "slide": 4,
                        "touch": 13,
                        "break": 3,
                        "total": 186
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11004,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 44,
                        "slide": 8,
                        "touch": 13,
                        "break": 5,
                        "total": 363
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11004,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 527,
                        "hold": 57,
                        "slide": 19,
                        "touch": 43,
                        "break": 27,
                        "total": 673
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11004,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 650,
                        "hold": 35,
                        "slide": 107,
                        "touch": 114,
                        "break": 32,
                        "total": 938
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11004,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 731,
                        "hold": 73,
                        "slide": 79,
                        "touch": 43,
                        "break": 39,
                        "total": 965
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11004,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14.2,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.3
                    },
                    "releaseDate": "2021-12-02"
                }
            ],
            "searchAcronyms": [
                "😡",
                "交互天堂",
                "很生气",
                "急怒",
                "暴怒",
                "极怒",
                "核按钮",
                "气死绝赞落了",
                "气炸",
                "满怒",
                "绝赞交互",
                "良怒2",
                "超级生气",
                "迪卢克按按钮",
                "迪卢克按炸弹",
                "马克思润菊"
            ]
        },
        {
            "songId": "バーチャルダム　ネーション",
            "category": "maimai",
            "title": "バーチャルダム　ネーション",
            "artist": "Sampling Masters MEGA",
            "bpm": 210,
            "imageName": "4725fd0a1119bf56e0f3141058148e24bd73c8721a96cb2677786176d8f87aab",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 13,
                        "slide": 4,
                        "touch": 14,
                        "break": 3,
                        "total": 175
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11005,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 279,
                        "hold": 31,
                        "slide": 13,
                        "touch": 26,
                        "break": 2,
                        "total": 351
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11005,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 483,
                        "hold": 89,
                        "slide": 10,
                        "touch": 60,
                        "break": 11,
                        "total": 653
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11005,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 609,
                        "hold": 67,
                        "slide": 79,
                        "touch": 148,
                        "break": 6,
                        "total": 909
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11005,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash": 13.5,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 640,
                        "hold": 71,
                        "slide": 129,
                        "touch": 100,
                        "break": 44,
                        "total": 984
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11005,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.2,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "UNiVERSE": 14,
                        "UNiVERSE PLUS": 14.2
                    },
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": [
                "virtualdam nation",
                "vn",
                "印度人3",
                "印度赛车",
                "小汽车",
                "月儿子2",
                "爸日儿子",
                "虚拟赛车",
                "赛车",
                "越南"
            ]
        },
        {
            "songId": "P-qoq",
            "category": "maimai",
            "title": "P-qoq",
            "artist": "owl＊tree",
            "bpm": 175,
            "imageName": "0df90ad0ffe3ff60b7c421c0de7ec875533047bd00a265c73f7542f2bae4cf46",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 96,
                        "hold": 7,
                        "slide": 1,
                        "touch": 13,
                        "break": 2,
                        "total": 119
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11006,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 20,
                        "slide": 11,
                        "touch": 20,
                        "break": 2,
                        "total": 315
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11006,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 313,
                        "hold": 71,
                        "slide": 13,
                        "touch": 64,
                        "break": 27,
                        "total": 488
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11006,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 601,
                        "hold": 53,
                        "slide": 114,
                        "touch": 109,
                        "break": 18,
                        "total": 895
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11006,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.9,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": [
                "oppo",
                "qoq",
                "拉面火箭",
                "激光火箭",
                "灯射来红"
            ]
        },
        {
            "songId": "超常マイマイン",
            "category": "maimai",
            "title": "超常マイマイン",
            "artist": "ナユタン星人",
            "bpm": 178,
            "imageName": "11d597973944954c31c3bcaf1d1519d0ba6105aa7e1ecca08f8395782882c233",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 121,
                        "hold": 14,
                        "slide": 3,
                        "touch": 9,
                        "break": 4,
                        "total": 151
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11007,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 260,
                        "hold": 35,
                        "slide": 12,
                        "touch": 19,
                        "break": 5,
                        "total": 331
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11007,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 522,
                        "hold": 57,
                        "slide": 9,
                        "touch": 34,
                        "break": 26,
                        "total": 648
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11007,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 726,
                        "hold": 19,
                        "slide": 99,
                        "touch": 124,
                        "break": 18,
                        "total": 986
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11007,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.6,
                        "UNiVERSE PLUS": 12.6
                    },
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "ロシアンブラック",
                    "noteCounts": {
                        "tap": 663,
                        "hold": 121,
                        "slide": 110,
                        "touch": 122,
                        "break": 53,
                        "total": 1069
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11007,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2022-08-25"
                }
            ],
            "searchAcronyms": [
                "Chojo maimain",
                "Paranormal my mind",
                "咕噜咕噜",
                "大逼圈入门曲",
                "超常",
                "超常maimai"
            ]
        },
        {
            "songId": "Crazy Circle",
            "category": "maimai",
            "title": "Crazy Circle",
            "artist": "みきとP feat. FantasticYouth",
            "bpm": 145,
            "imageName": "5f4321cea5a91fcb98fd20caa789a43bf3743aebe10c536d37ae11a6e9ee6d6e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 126,
                        "hold": 5,
                        "slide": 7,
                        "touch": 9,
                        "break": 2,
                        "total": 149
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11008,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 308,
                        "hold": 3,
                        "slide": 16,
                        "touch": 36,
                        "break": 16,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11008,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 328,
                        "hold": 57,
                        "slide": 29,
                        "touch": 42,
                        "break": 7,
                        "total": 463
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11008,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 671,
                        "hold": 64,
                        "slide": 73,
                        "touch": 78,
                        "break": 24,
                        "total": 910
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11008,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "Splash": 12.6
                    },
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": [
                "ddlc",
                "多多理财",
                "疯圈",
                "黑喂狗"
            ]
        },
        {
            "songId": "STEREOSCAPE",
            "category": "maimai",
            "title": "STEREOSCAPE",
            "artist": "164 feat. めいちゃん",
            "bpm": 164,
            "imageName": "45973ad6d56a504d9077fda2a82cc865fe238b34f236f3b9fd5ece675610201b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 106,
                        "hold": 9,
                        "slide": 5,
                        "touch": 10,
                        "break": 2,
                        "total": 132
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11009,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 192,
                        "hold": 37,
                        "slide": 13,
                        "touch": 26,
                        "break": 12,
                        "total": 280
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11009,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 323,
                        "hold": 29,
                        "slide": 27,
                        "touch": 25,
                        "break": 5,
                        "total": 409
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11009,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 379,
                        "hold": 58,
                        "slide": 57,
                        "touch": 83,
                        "break": 25,
                        "total": 602
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11009,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.4,
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM PLUS": 12.4,
                        "UNiVERSE PLUS": 12.4
                    },
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 529,
                        "hold": 31,
                        "slide": 109,
                        "touch": 47,
                        "break": 17,
                        "total": 733
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11009,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2023-11-23"
                }
            ],
            "searchAcronyms": [
                "天体观测",
                "玩手机"
            ]
        },
        {
            "songId": "HOT LIMIT",
            "category": "POPS＆アニメ",
            "title": "HOT LIMIT",
            "artist": "T.M.Revolution [covered by 光吉猛修]",
            "bpm": 138,
            "imageName": "70d54a3484ad2df05527eb4f4a5c6d9be6be58395785c86a6bf9ec035921baad",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 96,
                        "hold": 2,
                        "slide": 1,
                        "touch": 9,
                        "break": 4,
                        "total": 112
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11037,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 165,
                        "hold": 17,
                        "slide": 9,
                        "touch": 13,
                        "break": 13,
                        "total": 217
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11037,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 38,
                        "slide": 16,
                        "touch": 49,
                        "break": 20,
                        "total": 323
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11037,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 432,
                        "hold": 34,
                        "slide": 30,
                        "touch": 44,
                        "break": 23,
                        "total": 563
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11037,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": [
                "🥵",
                "光吉熊",
                "太烧辣",
                "捆绑滴蜡熊",
                "火辣限制",
                "热限",
                "热限制",
                "红熊",
                "裸足",
                "阳性"
            ]
        },
        {
            "songId": "メルト",
            "category": "niconico＆ボーカロイド",
            "title": "メルト",
            "artist": "supercell",
            "bpm": 170,
            "imageName": "f3d8ecb64814e1d7783d3d0e1c2e28a470024698a34790a43f5a01a4a301f29f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 10,
                        "slide": 7,
                        "touch": 13,
                        "break": 4,
                        "total": 137
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11043,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 242,
                        "hold": 24,
                        "slide": 8,
                        "touch": 23,
                        "break": 5,
                        "total": 302
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11043,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 368,
                        "hold": 49,
                        "slide": 39,
                        "touch": 27,
                        "break": 14,
                        "total": 497
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11043,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 406,
                        "hold": 59,
                        "slide": 96,
                        "touch": 31,
                        "break": 5,
                        "total": 597
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11043,
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": [
                "melt",
                "Melt",
                "meruto",
                "x儿卜",
                "熔化",
                "简笔画",
                "融化"
            ]
        },
        {
            "songId": "メルティランドナイトメア",
            "category": "niconico＆ボーカロイド",
            "title": "メルティランドナイトメア",
            "artist": "はるまきごはん feat.初音ミク",
            "bpm": 140,
            "imageName": "05f58568b862a9425daf5a27991988eba2adfcbdc15517e4fbc1e041c3ed8680",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 85,
                        "hold": 5,
                        "slide": 7,
                        "touch": 11,
                        "break": 3,
                        "total": 111
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11044,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 18,
                        "slide": 8,
                        "touch": 24,
                        "break": 4,
                        "total": 266
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11044,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 291,
                        "hold": 52,
                        "slide": 29,
                        "touch": 39,
                        "break": 6,
                        "total": 417
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11044,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 440,
                        "hold": 20,
                        "slide": 78,
                        "touch": 32,
                        "break": 3,
                        "total": 573
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11044,
                    "multiverInternalLevelValue": {
                        "Splash": 11.9
                    },
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": [
                "melty",
                "melty land nightmare",
                "Melty Land Nightmare",
                "meltyland",
                "可爱歌",
                "小粉",
                "春卷饭",
                "梦魇"
            ]
        },
        {
            "songId": "アディショナルメモリー",
            "category": "niconico＆ボーカロイド",
            "title": "アディショナルメモリー",
            "artist": "じん",
            "bpm": 200,
            "imageName": "2b3e0493a09478f913b335fac8e66fe1a0af2b599d05e25f39924aa2fd361693",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 68,
                        "hold": 7,
                        "slide": 4,
                        "touch": 12,
                        "break": 4,
                        "total": 95
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11046,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 216,
                        "hold": 13,
                        "slide": 12,
                        "touch": 10,
                        "break": 6,
                        "total": 257
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11046,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 365,
                        "hold": 46,
                        "slide": 10,
                        "touch": 21,
                        "break": 8,
                        "total": 450
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11046,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 423,
                        "hold": 43,
                        "slide": 91,
                        "touch": 10,
                        "break": 18,
                        "total": 585
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11046,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": [
                "回忆追加",
                "额外记忆"
            ]
        },
        {
            "songId": "ナイト・オブ・ナイツ (Cranky Remix)",
            "category": "東方Project",
            "title": "ナイト・オブ・ナイツ (Cranky Remix)",
            "artist": "ビートまりお × Cranky",
            "bpm": 180,
            "imageName": "2b13512e79e755b1429e4eeaf0ec5933f13aa0ed669ee237a0d402f7d9ab018b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 124,
                        "hold": 5,
                        "slide": 6,
                        "touch": 23,
                        "break": 6,
                        "total": 164
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11048,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 265,
                        "hold": 29,
                        "slide": 14,
                        "touch": 10,
                        "break": 6,
                        "total": 324
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11048,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 386,
                        "hold": 47,
                        "slide": 27,
                        "touch": 53,
                        "break": 35,
                        "total": 548
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11048,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 571,
                        "hold": 33,
                        "slide": 50,
                        "touch": 127,
                        "break": 30,
                        "total": 811
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11048,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 13.2
                    },
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": [
                "cranky也要当夜骑",
                "dx夜骑",
                "Knight of nights cranky remix",
                "kon cranky",
                "night of knights",
                "Night of Knights cranky remix",
                "nok",
                "nok cranky",
                "nok2",
                "十六夜咲夜",
                "咲夜",
                "夜骑",
                "夜骑2",
                "夜骑remix"
            ]
        },
        {
            "songId": "Strobe♡Girl",
            "category": "niconico＆ボーカロイド",
            "title": "Strobe♡Girl",
            "artist": "colate",
            "bpm": 190,
            "imageName": "4287abf562bc1939f41285911589361dd2571ae8d514de4df58d8d0beaedbf28",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 59,
                        "hold": 11,
                        "slide": 3,
                        "touch": 16,
                        "break": 1,
                        "total": 90
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11050,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 226,
                        "hold": 7,
                        "slide": 22,
                        "touch": 23,
                        "break": 6,
                        "total": 284
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11050,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 52,
                        "slide": 16,
                        "touch": 35,
                        "break": 27,
                        "total": 381
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11050,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 408,
                        "hold": 67,
                        "slide": 68,
                        "touch": 32,
                        "break": 22,
                        "total": 597
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11050,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": [
                "闪烁少女"
            ]
        },
        {
            "songId": "イカサマライフゲイム",
            "category": "niconico＆ボーカロイド",
            "title": "イカサマライフゲイム",
            "artist": "kemu",
            "bpm": 200,
            "imageName": "2f96828daef983dac3fce9f3b592cd62f535a8b52d31b966f252e8c07ddbcd8f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 17,
                        "slide": 5,
                        "touch": 6,
                        "break": 8,
                        "total": 181
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11084,
                    "releaseDate": "2019-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 294,
                        "hold": 23,
                        "slide": 15,
                        "touch": 27,
                        "break": 13,
                        "total": 372
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11084,
                    "releaseDate": "2019-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 467,
                        "hold": 51,
                        "slide": 42,
                        "touch": 61,
                        "break": 24,
                        "total": 645
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11084,
                    "releaseDate": "2019-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 593,
                        "hold": 51,
                        "slide": 114,
                        "touch": 65,
                        "break": 31,
                        "total": 854
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11084,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2019-07-19"
                }
            ],
            "searchAcronyms": [
                "Ikasama",
                "Ikasama Life Game",
                "lifegame",
                "人生游戏",
                "作弊生存游戏",
                "虚伪人生游戏",
                "骗人的lifegame",
                "骗人的人生游戏"
            ]
        },
        {
            "songId": "STARTLINER",
            "category": "オンゲキ＆CHUNITHM",
            "title": "STARTLINER",
            "artist": "曲：kz(livetune)／歌：オンゲキシューターズ",
            "bpm": 135,
            "imageName": "c1d30d1f5563a18d8b2521a5868592f3bd1ae5d8a45e1d3b19afde189d1cb849",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 112,
                        "hold": 9,
                        "slide": 5,
                        "touch": 6,
                        "break": 5,
                        "total": 137
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11010,
                    "releaseDate": "2019-07-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 27,
                        "slide": 18,
                        "touch": 27,
                        "break": 4,
                        "total": 266
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11010,
                    "releaseDate": "2019-07-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 249,
                        "hold": 48,
                        "slide": 24,
                        "touch": 30,
                        "break": 19,
                        "total": 370
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11010,
                    "releaseDate": "2019-07-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 53,
                        "slide": 75,
                        "touch": 92,
                        "break": 8,
                        "total": 521
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11010,
                    "releaseDate": "2019-07-26"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "12",
                    "internalLevelValue": 12.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 334,
                        "hold": 33,
                        "slide": 36,
                        "touch": 131,
                        "break": 33,
                        "total": 567
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11010,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.3,
                        "CiRCLE": 12.3,
                        "CiRCLE PLUS": 12.3,
                        "PRiSM PLUS": 12.3
                    },
                    "releaseDate": "2023-11-23"
                }
            ],
            "searchAcronyms": [
                "音击"
            ]
        },
        {
            "songId": "アカリがやってきたぞっ",
            "category": "niconico＆ボーカロイド",
            "title": "アカリがやってきたぞっ",
            "artist": "GYARI",
            "bpm": 136,
            "imageName": "d304693f1697dd15b0d7c6fd50d9d7781134a7119613ce562e5096907833d1ac",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 10,
                        "slide": 3,
                        "touch": 8,
                        "break": 9,
                        "total": 175
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11073,
                    "releaseDate": "2019-07-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 252,
                        "hold": 22,
                        "slide": 14,
                        "touch": 15,
                        "break": 12,
                        "total": 315
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11073,
                    "releaseDate": "2019-07-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 347,
                        "hold": 80,
                        "slide": 59,
                        "touch": 51,
                        "break": 23,
                        "total": 560
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11073,
                    "releaseDate": "2019-07-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Moon Strix",
                    "noteCounts": {
                        "tap": 353,
                        "hold": 52,
                        "slide": 119,
                        "touch": 97,
                        "break": 11,
                        "total": 632
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11073,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 12.7,
                        "maimaiでらっくす PLUS": 12.1
                    },
                    "releaseDate": "2019-07-26"
                }
            ],
            "searchAcronyms": [
                "akari",
                "Akari",
                "Akari ga yattekitazou",
                "Akari has Arrived",
                "akari来了哦",
                "来",
                "来了",
                "来了哟",
                "来了哦",
                "绁星灯",
                "阿卡丽",
                "阿卡莉"
            ]
        },
        {
            "songId": "Jump!! Jump!! Jump!!",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Jump!! Jump!! Jump!!",
            "artist": "曲：宮崎誠／歌：オンゲキシューターズ",
            "bpm": 183,
            "imageName": "4d80c1e9b6c6b2ec1430a1c1bcba3298fcebe12c921b14c8b0df707a302db3e3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 120,
                        "hold": 15,
                        "slide": 4,
                        "touch": 14,
                        "break": 3,
                        "total": 156
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11080,
                    "releaseDate": "2019-07-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 253,
                        "hold": 43,
                        "slide": 11,
                        "touch": 17,
                        "break": 14,
                        "total": 338
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11080,
                    "releaseDate": "2019-07-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 328,
                        "hold": 64,
                        "slide": 20,
                        "touch": 62,
                        "break": 6,
                        "total": 480
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11080,
                    "releaseDate": "2019-07-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 61,
                        "slide": 90,
                        "touch": 59,
                        "break": 12,
                        "total": 574
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11080,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2019-07-26"
                }
            ],
            "searchAcronyms": [
                "jump",
                "三蹦子",
                "元气少女蹦蹦蹦",
                "跳三下",
                "跳跳跳"
            ]
        },
        {
            "songId": "Scarlet Wings",
            "category": "maimai",
            "title": "Scarlet Wings",
            "artist": "REDALiCE feat. Ayumi Nomiya",
            "bpm": 183,
            "imageName": "40e99eab964e5d02c487469a39abadad9c826c42e2cfed9c4a30edecaafa29d5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 143,
                        "hold": 15,
                        "slide": 4,
                        "touch": 14,
                        "break": 9,
                        "total": 185
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11019,
                    "releaseDate": "2019-08-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 31,
                        "slide": 14,
                        "touch": 36,
                        "break": 4,
                        "total": 362
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11019,
                    "releaseDate": "2019-08-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 369,
                        "hold": 35,
                        "slide": 31,
                        "touch": 47,
                        "break": 26,
                        "total": 508
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11019,
                    "releaseDate": "2019-08-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 511,
                        "hold": 29,
                        "slide": 93,
                        "touch": 74,
                        "break": 40,
                        "total": 747
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11019,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 12.9,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2019-08-09"
                }
            ],
            "searchAcronyms": [
                "redalice",
                "小星星2",
                "小黑姬",
                "猩红之翼",
                "红烧鸡翅",
                "红翅膀子",
                "红翼",
                "鸡翅膀",
                "鸭翅",
                "黑姬",
                "黑姬拔刀"
            ]
        },
        {
            "songId": "魔ジョ狩リ",
            "category": "maimai",
            "title": "魔ジョ狩リ",
            "artist": "Nothing But Requiem (feat.Aikapin & Chiyoko)",
            "bpm": 190,
            "imageName": "05fc46c438ae18db7f7670884ac2febad6ac4d9c053ee00255c6c643e65378cd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 140,
                        "hold": 13,
                        "slide": 5,
                        "touch": 16,
                        "break": 10,
                        "total": 184
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11021,
                    "releaseDate": "2019-08-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 17,
                        "slide": 10,
                        "touch": 40,
                        "break": 6,
                        "total": 306
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11021,
                    "releaseDate": "2019-08-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 426,
                        "hold": 34,
                        "slide": 32,
                        "touch": 54,
                        "break": 4,
                        "total": 550
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11021,
                    "releaseDate": "2019-08-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 416,
                        "hold": 69,
                        "slide": 65,
                        "touch": 102,
                        "break": 13,
                        "total": 665
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11021,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.6
                    },
                    "releaseDate": "2019-08-09"
                }
            ],
            "searchAcronyms": [
                "魔女狩猎",
                "魔狩"
            ]
        },
        {
            "songId": "TwisteD! XD",
            "category": "maimai",
            "title": "TwisteD! XD",
            "artist": "t+pazolite",
            "bpm": 200,
            "imageName": "f5fadc494a3a7d0a203fcca9d14847b45f23880f9c670060da64828ef4c92a04",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 13,
                        "slide": 4,
                        "touch": 14,
                        "break": 3,
                        "total": 162
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11022,
                    "releaseDate": "2019-08-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 41,
                        "slide": 15,
                        "touch": 16,
                        "break": 8,
                        "total": 338
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11022,
                    "releaseDate": "2019-08-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 70,
                        "slide": 32,
                        "touch": 150,
                        "break": 19,
                        "total": 616
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11022,
                    "releaseDate": "2019-08-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 594,
                        "hold": 31,
                        "slide": 63,
                        "touch": 155,
                        "break": 28,
                        "total": 871
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11022,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.7,
                        "FESTiVAL": 13.6,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.6,
                        "Splash PLUS": 13.6,
                        "UNiVERSE": 13.6,
                        "UNiVERSE PLUS": 13.6,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2019-08-09"
                }
            ],
            "searchAcronyms": [
                "td",
                "TD",
                "xd",
                "退订"
            ]
        },
        {
            "songId": "Blows Up Everything",
            "category": "maimai",
            "title": "Blows Up Everything",
            "artist": "USAO",
            "bpm": 215,
            "imageName": "87f68309e3a18c9fceb1c009583ca02243b9261acc33ce9745b9a79d5af98a86",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 10,
                        "slide": 4,
                        "touch": 13,
                        "break": 8,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11023,
                    "releaseDate": "2019-08-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 353,
                        "hold": 24,
                        "slide": 14,
                        "touch": 32,
                        "break": 23,
                        "total": 446
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11023,
                    "releaseDate": "2019-08-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 429,
                        "hold": 122,
                        "slide": 70,
                        "touch": 42,
                        "break": 66,
                        "total": 729
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11023,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 11.9
                    },
                    "releaseDate": "2019-08-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 563,
                        "hold": 17,
                        "slide": 130,
                        "touch": 276,
                        "break": 22,
                        "total": 1008
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11023,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.9,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2019-08-09"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 714,
                        "hold": 80,
                        "slide": 112,
                        "touch": 43,
                        "break": 63,
                        "total": 1012
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11023,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "Splash": 14.4,
                        "Splash PLUS": 14.2,
                        "UNiVERSE": 14.2,
                        "UNiVERSE PLUS": 14.2,
                        "maimaiでらっくす PLUS": 14.4
                    },
                    "releaseDate": "2019-09-19"
                }
            ],
            "searchAcronyms": [
                "6级白谱",
                "Asuka最爱",
                "Blows Up",
                "bue",
                "口爆",
                "口爆一切",
                "吹",
                "吹爆",
                "吹爆一切",
                "吹爆牛魔",
                "嘿嘿歌",
                "拆爆",
                "爆",
                "瞎几把吹"
            ]
        },
        {
            "songId": "METEOR",
            "category": "niconico＆ボーカロイド",
            "title": "METEOR",
            "artist": "DIVELA feat.初音ミク",
            "bpm": 170,
            "imageName": "da8dcd8ae0c0ea46aed773d9ae3b4121da885f1c758d2dd3f9863a72347a014c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 104,
                        "hold": 7,
                        "slide": 2,
                        "touch": 6,
                        "break": 6,
                        "total": 125
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11034,
                    "releaseDate": "2019-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 12,
                        "slide": 7,
                        "touch": 18,
                        "break": 14,
                        "total": 288
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11034,
                    "releaseDate": "2019-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 307,
                        "hold": 23,
                        "slide": 50,
                        "touch": 14,
                        "break": 21,
                        "total": 415
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11034,
                    "releaseDate": "2019-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 358,
                        "hold": 33,
                        "slide": 65,
                        "touch": 44,
                        "break": 44,
                        "total": 544
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11034,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL": 12.4,
                        "PRiSM PLUS": 12.4,
                        "Splash": 12.4
                    },
                    "releaseDate": "2019-08-22"
                }
            ],
            "searchAcronyms": [
                "流星"
            ]
        },
        {
            "songId": "グリーンライツ・セレナーデ",
            "category": "niconico＆ボーカロイド",
            "title": "グリーンライツ・セレナーデ",
            "artist": "Omoi feat. 初音ミク",
            "bpm": 200,
            "imageName": "2c1945d6aaee04309171041add316bef6a2a6b55317fd82f4dc48d736a4be341",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 129,
                        "hold": 6,
                        "slide": 2,
                        "touch": 4,
                        "break": 4,
                        "total": 145
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11052,
                    "releaseDate": "2019-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 324,
                        "hold": 16,
                        "slide": 6,
                        "touch": 13,
                        "break": 10,
                        "total": 369
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11052,
                    "releaseDate": "2019-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 458,
                        "hold": 49,
                        "slide": 23,
                        "touch": 42,
                        "break": 41,
                        "total": 613
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11052,
                    "releaseDate": "2019-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 568,
                        "hold": 17,
                        "slide": 137,
                        "touch": 128,
                        "break": 11,
                        "total": 861
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11052,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.6,
                        "UNiVERSE PLUS": 12.6
                    },
                    "releaseDate": "2019-08-22"
                }
            ],
            "searchAcronyms": [
                "Greenlight Serenade",
                "Greenlights Serenade",
                "绿光",
                "绿光小夜曲",
                "魔法未来2018",
                "墨芷"
            ]
        },
        {
            "songId": "だれかの心臓になれたなら",
            "category": "niconico＆ボーカロイド",
            "title": "だれかの心臓になれたなら",
            "artist": "ユリイ・カノン feat.GUMI",
            "bpm": 145,
            "imageName": "aada9430d39d265421a960cb47513e9e99ad947e8e745b006774810d4903d246",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 7,
                        "slide": 2,
                        "touch": 6,
                        "break": 5,
                        "total": 161
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11086,
                    "releaseDate": "2019-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 27,
                        "slide": 11,
                        "touch": 12,
                        "break": 8,
                        "total": 289
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11086,
                    "releaseDate": "2019-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 34,
                        "slide": 68,
                        "touch": 61,
                        "break": 11,
                        "total": 492
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11086,
                    "releaseDate": "2019-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 496,
                        "hold": 49,
                        "slide": 76,
                        "touch": 97,
                        "break": 11,
                        "total": 729
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11086,
                    "multiverInternalLevelValue": {
                        "Splash": 11.9
                    },
                    "releaseDate": "2019-08-22"
                }
            ],
            "searchAcronyms": [
                "I want to be your heart",
                "如果能成为谁的心脏",
                "安倍晋三",
                "心脏"
            ]
        },
        {
            "songId": "39みゅーじっく！",
            "category": "niconico＆ボーカロイド",
            "title": "39みゅーじっく！",
            "artist": "みきとP",
            "bpm": 130,
            "imageName": "e38501944987f18fc70539b0dc812c6a62e566fc4e12b70a9a092fc59265dbe7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 77,
                        "hold": 8,
                        "slide": 4,
                        "touch": 22,
                        "break": 7,
                        "total": 118
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11088,
                    "releaseDate": "2019-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 187,
                        "hold": 11,
                        "slide": 8,
                        "touch": 13,
                        "break": 23,
                        "total": 242
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11088,
                    "releaseDate": "2019-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 301,
                        "hold": 40,
                        "slide": 27,
                        "touch": 44,
                        "break": 21,
                        "total": 433
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11088,
                    "releaseDate": "2019-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 367,
                        "hold": 24,
                        "slide": 68,
                        "touch": 101,
                        "break": 14,
                        "total": 574
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11088,
                    "releaseDate": "2019-08-22"
                }
            ],
            "searchAcronyms": [
                "39",
                "39music",
                "39音乐"
            ]
        },
        {
            "songId": "デビル☆アイドル",
            "category": "POPS＆アニメ",
            "title": "デビル☆アイドル",
            "artist": "アイラ（CV：三森すずこ）シマ（CV:井口裕香）はな（CV:花澤香菜）",
            "bpm": 180,
            "imageName": "d21f090f6e63555e4d0e85eb7ff64e2c7a1cdb668e947bb7aede5441883babcc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 69,
                        "hold": 5,
                        "slide": 6,
                        "touch": 6,
                        "break": 6,
                        "total": 92
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11077,
                    "releaseDate": "2019-09-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 10,
                        "slide": 5,
                        "touch": 7,
                        "break": 22,
                        "total": 253
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11077,
                    "releaseDate": "2019-09-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 215,
                        "hold": 52,
                        "slide": 10,
                        "touch": 23,
                        "break": 15,
                        "total": 315
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11077,
                    "releaseDate": "2019-09-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 271,
                        "hold": 68,
                        "slide": 58,
                        "touch": 28,
                        "break": 14,
                        "total": 439
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11077,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2019-09-06"
                }
            ],
            "searchAcronyms": [
                "devil",
                "devil idol",
                "恶魔偶像",
                "飞天小女警"
            ]
        },
        {
            "songId": "デンパラダイム",
            "category": "niconico＆ボーカロイド",
            "title": "デンパラダイム",
            "artist": "lumo",
            "bpm": 220,
            "imageName": "01e9fb0d6b879513db838909dc17a10b4125b5af2d5cee7eb84b3cd20fbcee1f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 95,
                        "hold": 20,
                        "slide": 6,
                        "touch": 28,
                        "break": 4,
                        "total": 153
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11058,
                    "releaseDate": "2019-09-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 244,
                        "hold": 32,
                        "slide": 13,
                        "touch": 11,
                        "break": 16,
                        "total": 316
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11058,
                    "releaseDate": "2019-09-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 513,
                        "hold": 68,
                        "slide": 37,
                        "touch": 56,
                        "break": 30,
                        "total": 704
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11058,
                    "releaseDate": "2019-09-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 458,
                        "hold": 112,
                        "slide": 76,
                        "touch": 155,
                        "break": 11,
                        "total": 812
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11058,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13.3,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 13.3
                    },
                    "releaseDate": "2019-09-20"
                }
            ],
            "searchAcronyms": [
                "denparadigm",
                "Denparadigm",
                "传送带",
                "木棍入侵正方形他家",
                "电波",
                "电波范式"
            ]
        },
        {
            "songId": "骸骨楽団とリリア",
            "category": "niconico＆ボーカロイド",
            "title": "骸骨楽団とリリア",
            "artist": "トーマ",
            "bpm": 260,
            "imageName": "5254e254c50ba253388ae4e071415abcbd0e77dddbd016fc1a3b9341e8dc308a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 122,
                        "hold": 16,
                        "slide": 2,
                        "touch": 8,
                        "break": 4,
                        "total": 152
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11059,
                    "releaseDate": "2019-09-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 22,
                        "slide": 18,
                        "touch": 15,
                        "break": 12,
                        "total": 294
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11059,
                    "releaseDate": "2019-09-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 446,
                        "hold": 81,
                        "slide": 22,
                        "touch": 30,
                        "break": 8,
                        "total": 587
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11059,
                    "releaseDate": "2019-09-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 508,
                        "hold": 74,
                        "slide": 65,
                        "touch": 47,
                        "break": 30,
                        "total": 724
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11059,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.4,
                        "Splash PLUS": 13.4,
                        "UNiVERSE": 13.4,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2019-09-20"
                }
            ],
            "searchAcronyms": [
                "👉🏻😕👈🏻",
                "Skeleton Orchestra",
                "Skeleton Orchestra and Lilia",
                "腿子",
                "莉莉亚",
                "骸骨",
                "骸骨乐团"
            ]
        },
        {
            "songId": "星屑ユートピア",
            "category": "niconico＆ボーカロイド",
            "title": "星屑ユートピア",
            "artist": "otetsu",
            "bpm": 240,
            "imageName": "8edb740463261cd554b217d7113ff72c2264d795a8c52bca5fa2118fbab9ce9f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 144,
                        "hold": 16,
                        "slide": 1,
                        "touch": 6,
                        "break": 3,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11060,
                    "releaseDate": "2019-09-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 11,
                        "slide": 6,
                        "touch": 18,
                        "break": 4,
                        "total": 331
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11060,
                    "releaseDate": "2019-09-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 444,
                        "hold": 79,
                        "slide": 46,
                        "touch": 82,
                        "break": 10,
                        "total": 661
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11060,
                    "releaseDate": "2019-09-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "玉子豆腐",
                    "noteCounts": {
                        "tap": 563,
                        "hold": 59,
                        "slide": 69,
                        "touch": 95,
                        "break": 4,
                        "total": 790
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11060,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2019-09-20"
                }
            ],
            "searchAcronyms": [
                "Hoshikuzu Utopia",
                "Stardust Utopia",
                "星屑",
                "星屑乌托邦"
            ]
        },
        {
            "songId": "アマツキツネ",
            "category": "niconico＆ボーカロイド",
            "title": "アマツキツネ",
            "artist": "まらしぃ",
            "bpm": 190,
            "imageName": "1fe393e5cbd011bca2dbf8c1da03c8fe6277cb425fc0f61228c63c9215e342b0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 86,
                        "hold": 12,
                        "slide": 8,
                        "touch": 15,
                        "break": 4,
                        "total": 125
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11061,
                    "releaseDate": "2019-09-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 220,
                        "hold": 17,
                        "slide": 10,
                        "touch": 30,
                        "break": 12,
                        "total": 289
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11061,
                    "releaseDate": "2019-09-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 384,
                        "hold": 30,
                        "slide": 39,
                        "touch": 26,
                        "break": 10,
                        "total": 489
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11061,
                    "releaseDate": "2019-09-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 456,
                        "hold": 45,
                        "slide": 86,
                        "touch": 66,
                        "break": 8,
                        "total": 661
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11061,
                    "releaseDate": "2019-09-20"
                }
            ],
            "searchAcronyms": [
                "👍😁👍",
                "Amatsukitsune",
                "刻俄柏",
                "天狐",
                "天狗"
            ]
        },
        {
            "songId": "♡マイマイマイラブ♡",
            "category": "maimai",
            "title": "♡マイマイマイラブ♡",
            "artist": "ビートまりお",
            "bpm": 170,
            "imageName": "b35a07ccd8ea0b02a32f9ed8e440f0991fb10a9a8238e38173c4d18f3d121668",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 20,
                        "slide": 4,
                        "touch": 8,
                        "break": 9,
                        "total": 183
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11014,
                    "releaseDate": "2019-10-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 55,
                        "slide": 8,
                        "touch": 24,
                        "break": 11,
                        "total": 301
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11014,
                    "releaseDate": "2019-10-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 49,
                        "slide": 30,
                        "touch": 44,
                        "break": 52,
                        "total": 433
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11014,
                    "releaseDate": "2019-10-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 454,
                        "hold": 18,
                        "slide": 100,
                        "touch": 77,
                        "break": 36,
                        "total": 685
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11014,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2019-10-04"
                }
            ],
            "searchAcronyms": [
                "maimai love",
                "maimailove",
                "maimaimailove",
                "my my my love",
                "sega游戏宇宙一",
                "出mai我的爱",
                "爱情买卖",
                "舞萌痴",
                "章鱼歌"
            ]
        },
        {
            "songId": "一か罰",
            "category": "maimai",
            "title": "一か罰",
            "artist": "豚乙女",
            "bpm": 196,
            "imageName": "216c2fc9f766b257e708de9c320bf0b2d19882201b4286734dc6496628d0092e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 153,
                        "hold": 19,
                        "slide": 5,
                        "touch": 12,
                        "break": 4,
                        "total": 193
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11015,
                    "releaseDate": "2019-10-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 286,
                        "hold": 28,
                        "slide": 11,
                        "touch": 9,
                        "break": 6,
                        "total": 340
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11015,
                    "releaseDate": "2019-10-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 515,
                        "hold": 31,
                        "slide": 35,
                        "touch": 89,
                        "break": 18,
                        "total": 688
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11015,
                    "releaseDate": "2019-10-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 524,
                        "hold": 51,
                        "slide": 62,
                        "touch": 56,
                        "break": 35,
                        "total": 728
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11015,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2019-10-18"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 538,
                        "hold": 94,
                        "slide": 112,
                        "touch": 76,
                        "break": 108,
                        "total": 928
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11015,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14
                    },
                    "releaseDate": "2023-11-23"
                }
            ],
            "searchAcronyms": [
                "一刀罚",
                "一力罚",
                "一罚",
                "一罰"
            ]
        },
        {
            "songId": "キリキリ舞Mine",
            "category": "maimai",
            "title": "キリキリ舞Mine",
            "artist": "A-One",
            "bpm": 168,
            "imageName": "78d232b8604b81d8a568c5c3af91bdb7f9e2e53676fa190937876db79038a660",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 117,
                        "hold": 27,
                        "slide": 10,
                        "touch": 12,
                        "break": 2,
                        "total": 168
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11016,
                    "releaseDate": "2019-10-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 59,
                        "slide": 10,
                        "touch": 17,
                        "break": 5,
                        "total": 375
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11016,
                    "releaseDate": "2019-10-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 75,
                        "slide": 46,
                        "touch": 59,
                        "break": 22,
                        "total": 566
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11016,
                    "releaseDate": "2019-10-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 673,
                        "hold": 44,
                        "slide": 96,
                        "touch": 50,
                        "break": 16,
                        "total": 879
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11016,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.4,
                        "Splash PLUS": 13.4,
                        "UNiVERSE": 13.4,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2019-10-18"
                }
            ],
            "searchAcronyms": [
                "girigiri舞",
                "kirikiri",
                "舞mine"
            ]
        },
        {
            "songId": "福宿音屋魂音泉",
            "category": "maimai",
            "title": "福宿音屋魂音泉",
            "artist": "魂音泉",
            "bpm": 162,
            "imageName": "60e20241c9462fdd072408cc2b5b39c850c6f1f4073a9043f52caebc05ff836e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 133,
                        "hold": 7,
                        "slide": 6,
                        "touch": 14,
                        "break": 9,
                        "total": 169
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11017,
                    "releaseDate": "2019-10-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 249,
                        "hold": 39,
                        "slide": 11,
                        "touch": 43,
                        "break": 10,
                        "total": 352
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11017,
                    "releaseDate": "2019-10-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 397,
                        "hold": 35,
                        "slide": 32,
                        "touch": 74,
                        "break": 25,
                        "total": 563
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11017,
                    "releaseDate": "2019-10-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "7.3Hz＋Jack",
                    "noteCounts": {
                        "tap": 474,
                        "hold": 68,
                        "slide": 96,
                        "touch": 191,
                        "break": 42,
                        "total": 871
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11017,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 13,
                        "Splash": 12.9,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2019-10-18"
                }
            ],
            "searchAcronyms": [
                "Fukujuku Otoya Tamaonsen",
                "Fukuyadootoya Tamaonsen",
                "Tamaonsen",
                "敬业福",
                "福州温泉",
                "魂音泉"
            ]
        },
        {
            "songId": "Now or Never",
            "category": "maimai",
            "title": "Now or Never",
            "artist": "MintJam",
            "bpm": 202,
            "imageName": "0cb730e9fc36d1ad9b4eb83fa756b84835f3a37aa3facac4cac285c0a3294dfd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 134,
                        "hold": 16,
                        "slide": 7,
                        "touch": 6,
                        "break": 2,
                        "total": 165
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11018,
                    "releaseDate": "2019-10-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 51,
                        "slide": 16,
                        "touch": 12,
                        "break": 6,
                        "total": 335
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11018,
                    "releaseDate": "2019-10-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 415,
                        "hold": 124,
                        "slide": 25,
                        "touch": 32,
                        "break": 28,
                        "total": 624
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11018,
                    "releaseDate": "2019-10-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 724,
                        "hold": 20,
                        "slide": 153,
                        "touch": 90,
                        "break": 20,
                        "total": 1007
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11018,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2019-10-18"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 722,
                        "hold": 40,
                        "slide": 151,
                        "touch": 26,
                        "break": 65,
                        "total": 1004
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11018,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 14,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "UNiVERSE": 14,
                        "UNiVERSE PLUS": 14
                    },
                    "releaseDate": "2021-12-02"
                }
            ],
            "searchAcronyms": [
                "non",
                "yoshiki快乐歌",
                "时不我待",
                "机不可失时不再来",
                "现在或从不"
            ]
        },
        {
            "songId": "玩具狂奏曲 -終焉-",
            "category": "オンゲキ＆CHUNITHM",
            "title": "玩具狂奏曲 -終焉-",
            "artist": "きくお",
            "bpm": 130,
            "imageName": "45d0d7d76d90b621612794e7fb06a7ee80395e4d28ba1b88c6ae629a9954169c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 26,
                        "slide": 5,
                        "touch": 43,
                        "break": 4,
                        "total": 205
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11028,
                    "releaseDate": "2019-10-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 220,
                        "hold": 55,
                        "slide": 6,
                        "touch": 44,
                        "break": 4,
                        "total": 329
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11028,
                    "releaseDate": "2019-10-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 327,
                        "hold": 134,
                        "slide": 71,
                        "touch": 47,
                        "break": 35,
                        "total": 614
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11028,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13.2,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2019-10-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 660,
                        "hold": 65,
                        "slide": 78,
                        "touch": 125,
                        "break": 19,
                        "total": 947
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11028,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 14.1
                    },
                    "releaseDate": "2019-10-24"
                }
            ],
            "searchAcronyms": [
                "Gangukyousoukyoku -Shuen-",
                "Toy Frenzy",
                "Toy Frenzy -The end-",
                "Toy Madness",
                "Toy Rhapsody",
                "玩具",
                "玩具狂奏曲",
                "玩具狂揍我",
                "第五人格"
            ]
        },
        {
            "songId": "Titania",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Titania",
            "artist": "xi",
            "bpm": 212,
            "imageName": "4cdbcbcc1093bef62819793507db3757c3fd48a0c56bcfadd0baeffa1ec77f5a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 147,
                        "hold": 30,
                        "slide": 6,
                        "touch": 20,
                        "break": 8,
                        "total": 211
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11029,
                    "releaseDate": "2019-10-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 28,
                        "slide": 21,
                        "touch": 27,
                        "break": 10,
                        "total": 325
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11029,
                    "releaseDate": "2019-10-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 496,
                        "hold": 70,
                        "slide": 55,
                        "touch": 65,
                        "break": 24,
                        "total": 710
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11029,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2019-10-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 831,
                        "hold": 45,
                        "slide": 74,
                        "touch": 50,
                        "break": 31,
                        "total": 1031
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11029,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.6,
                        "BUDDiES PLUS": 14.6,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL": 14.6,
                        "FESTiVAL PLUS": 14.6,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6,
                        "Splash": 14.5,
                        "Splash PLUS": 14.5,
                        "UNiVERSE": 14.5,
                        "UNiVERSE PLUS": 14.5,
                        "maimaiでらっくす PLUS": 14.3
                    },
                    "releaseDate": "2019-10-24"
                }
            ],
            "searchAcronyms": [
                "✌",
                "✌🏻",
                "arisu=LP",
                "体坛",
                "天卫三",
                "我老婆",
                "江江",
                "江江我是有栖",
                "江江比耶",
                "泰坦尼亚",
                "缇坦妮娅",
                "蓝毛小萝莉",
                "蓝毛萝莉",
                "踢他娘"
            ]
        },
        {
            "songId": "Little \"Sister\" Bitch",
            "category": "東方Project",
            "title": "Little \"Sister\" Bitch",
            "artist": "t+pazolite",
            "bpm": 185,
            "imageName": "f940919846fc969d1872c25e4aa9790651f5ad30cc7297f8ef0648d54d747240",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 13,
                        "slide": 4,
                        "touch": 17,
                        "break": 5,
                        "total": 196
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11064,
                    "releaseDate": "2019-11-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 14,
                        "slide": 7,
                        "touch": 50,
                        "break": 20,
                        "total": 358
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11064,
                    "releaseDate": "2019-11-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 83,
                        "slide": 39,
                        "touch": 84,
                        "break": 25,
                        "total": 573
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11064,
                    "releaseDate": "2019-11-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 644,
                        "hold": 25,
                        "slide": 98,
                        "touch": 66,
                        "break": 33,
                        "total": 866
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11064,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2019-11-01"
                }
            ],
            "searchAcronyms": [
                "bitch",
                "婊子",
                "小sb",
                "小妹妹臭婊子",
                "小婊妹",
                "小婊子",
                "碧池"
            ]
        },
        {
            "songId": "Yakumo >>JOINT STRUGGLE (2019 Update)",
            "category": "東方Project",
            "title": "Yakumo >>JOINT STRUGGLE (2019 Update)",
            "artist": "くっちー (DARKSIDE APPROACH)",
            "bpm": 187,
            "imageName": "20aa55bf007f6203ec467efd6a16c7dba055e239c336de35c57bfcc75e5be1b0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 123,
                        "hold": 15,
                        "slide": 6,
                        "touch": 18,
                        "break": 2,
                        "total": 164
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11065,
                    "releaseDate": "2019-11-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 279,
                        "hold": 18,
                        "slide": 9,
                        "touch": 29,
                        "break": 20,
                        "total": 355
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11065,
                    "releaseDate": "2019-11-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 404,
                        "hold": 37,
                        "slide": 47,
                        "touch": 16,
                        "break": 10,
                        "total": 514
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11065,
                    "releaseDate": "2019-11-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 779,
                        "hold": 53,
                        "slide": 33,
                        "touch": 114,
                        "break": 50,
                        "total": 1029
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11065,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2019-11-01"
                }
            ],
            "searchAcronyms": [
                "2019",
                "yakumo",
                "Yakumo joint striggle",
                "八云",
                "八云一家",
                "八云紫",
                "压裤摸",
                "把你妈妈抓走",
                "把你麻麻抓走"
            ]
        },
        {
            "songId": "げきオコスティックファイナリアリティぷんぷんマスタースパーク",
            "category": "東方Project",
            "title": "げきオコスティックファイナリアリティぷんぷんマスタースパーク",
            "artist": "ARM (IOSYS)",
            "bpm": 200,
            "imageName": "0693e2bb17d7ebcb55f62eae8fcf9ea3a884b3907ec514117bdf1ba1e9b3b5d4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 119,
                        "hold": 10,
                        "slide": 2,
                        "touch": 10,
                        "break": 5,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11066,
                    "releaseDate": "2019-11-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 32,
                        "slide": 12,
                        "touch": 16,
                        "break": 14,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11066,
                    "releaseDate": "2019-11-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 238,
                        "hold": 74,
                        "slide": 40,
                        "touch": 16,
                        "break": 20,
                        "total": 388
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11066,
                    "releaseDate": "2019-11-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 498,
                        "hold": 55,
                        "slide": 80,
                        "touch": 9,
                        "break": 27,
                        "total": 669
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11066,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2019-11-01"
                }
            ],
            "searchAcronyms": [
                "东方名字很长",
                "东方曲名过长"
            ]
        },
        {
            "songId": "Agitation！",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Agitation！",
            "artist": "舞ヶ原高校軽音部",
            "bpm": 163,
            "imageName": "bed2a2dad8cd90c09fdd011db70a8517f4f5989433da356c8ef4aaada039664f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 118,
                        "hold": 16,
                        "slide": 10,
                        "touch": 10,
                        "break": 9,
                        "total": 163
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11024,
                    "releaseDate": "2019-11-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 174,
                        "hold": 44,
                        "slide": 13,
                        "touch": 30,
                        "break": 22,
                        "total": 283
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11024,
                    "releaseDate": "2019-11-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 42,
                        "slide": 45,
                        "touch": 39,
                        "break": 29,
                        "total": 497
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11024,
                    "releaseDate": "2019-11-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 531,
                        "hold": 40,
                        "slide": 61,
                        "touch": 21,
                        "break": 12,
                        "total": 665
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11024,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2019-11-15"
                }
            ],
            "searchAcronyms": [
                "agi",
                "吉他姐2"
            ]
        },
        {
            "songId": "管弦楽組曲 第3番 ニ長調「第2曲（G線上のアリア）」BWV.1068-2",
            "category": "オンゲキ＆CHUNITHM",
            "title": "管弦楽組曲 第3番 ニ長調「第2曲（G線上のアリア）」BWV.1068-2",
            "artist": "月鈴 那知（ヴァイオリン） 伴奏：イロドリミドリ",
            "bpm": 180,
            "imageName": "2bf5aa9435772e130a8d387c68642dd24a0af6c3f8f44cf1d2c5d706603f0304",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 99,
                        "hold": 34,
                        "slide": 16,
                        "touch": 13,
                        "break": 6,
                        "total": 168
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11025,
                    "releaseDate": "2019-11-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 43,
                        "slide": 15,
                        "touch": 21,
                        "break": 8,
                        "total": 359
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11025,
                    "releaseDate": "2019-11-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 417,
                        "hold": 65,
                        "slide": 42,
                        "touch": 30,
                        "break": 18,
                        "total": 572
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11025,
                    "releaseDate": "2019-11-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 718,
                        "hold": 58,
                        "slide": 74,
                        "touch": 44,
                        "break": 43,
                        "total": 937
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11025,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2019-11-15"
                }
            ],
            "searchAcronyms": [
                "air on g",
                "air on the g string",
                "aria on g",
                "aria on the g string",
                "g弦",
                "g弦上的咏叹调",
                "二长调",
                "妹妹拉小提琴",
                "智障交互",
                "管弦乐",
                "管弦乐组曲"
            ]
        },
        {
            "songId": "CocktaiL",
            "category": "niconico＆ボーカロイド",
            "title": "CocktaiL",
            "artist": "XYZ",
            "bpm": 128,
            "imageName": "2b474e679eb3c38b5a5f4484a91db8f6ebf388d510c1671809bee5766c97b034",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 97,
                        "hold": 11,
                        "slide": 3,
                        "touch": 8,
                        "break": 4,
                        "total": 123
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11067,
                    "releaseDate": "2019-11-29"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 20,
                        "slide": 9,
                        "touch": 11,
                        "break": 20,
                        "total": 248
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11067,
                    "releaseDate": "2019-11-29"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 183,
                        "hold": 56,
                        "slide": 33,
                        "touch": 40,
                        "break": 10,
                        "total": 322
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11067,
                    "releaseDate": "2019-11-29"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 523,
                        "hold": 44,
                        "slide": 77,
                        "touch": 15,
                        "break": 14,
                        "total": 673
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11067,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash PLUS": 12.7
                    },
                    "releaseDate": "2019-11-29"
                }
            ],
            "searchAcronyms": [
                "鸡尾酒"
            ]
        },
        {
            "songId": "太陽系デスコ",
            "category": "niconico＆ボーカロイド",
            "title": "太陽系デスコ",
            "artist": "ナユタン星人",
            "bpm": 150,
            "imageName": "5c741b9b7103837cf5c2917c3523195f9f0b9ff22a81e981b154b49645a99063",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 18,
                        "slide": 2,
                        "touch": 8,
                        "break": 5,
                        "total": 184
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11069,
                    "releaseDate": "2019-11-29"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 243,
                        "hold": 44,
                        "slide": 4,
                        "touch": 19,
                        "break": 20,
                        "total": 330
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11069,
                    "releaseDate": "2019-11-29"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 373,
                        "hold": 39,
                        "slide": 48,
                        "touch": 24,
                        "break": 16,
                        "total": 500
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11069,
                    "releaseDate": "2019-11-29"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 466,
                        "hold": 28,
                        "slide": 108,
                        "touch": 98,
                        "break": 13,
                        "total": 713
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11069,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2019-11-29"
                }
            ],
            "searchAcronyms": [
                "Solar System Disco",
                "太田顺也",
                "太阳系",
                "太阳系disco"
            ]
        },
        {
            "songId": "だからパンを焼いたんだ",
            "category": "niconico＆ボーカロイド",
            "title": "だからパンを焼いたんだ",
            "artist": "あわのあゆむ",
            "bpm": 170,
            "imageName": "8d2d1b04f99d48421f73f6bf6c1829539336a0f24774b80e93d5d06dd7c6a520",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 85,
                        "hold": 19,
                        "slide": 2,
                        "touch": 25,
                        "break": 5,
                        "total": 136
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11070,
                    "releaseDate": "2019-11-29"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 228,
                        "hold": 32,
                        "slide": 14,
                        "touch": 28,
                        "break": 8,
                        "total": 310
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11070,
                    "releaseDate": "2019-11-29"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "畳返し",
                    "noteCounts": {
                        "tap": 283,
                        "hold": 67,
                        "slide": 40,
                        "touch": 31,
                        "break": 8,
                        "total": 429
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11070,
                    "releaseDate": "2019-11-29"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 608,
                        "hold": 17,
                        "slide": 97,
                        "touch": 66,
                        "break": 13,
                        "total": 801
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11070,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2019-11-29"
                }
            ],
            "searchAcronyms": [
                "🍞",
                "初音烤面包",
                "烤面包",
                "烧",
                "烧面包",
                "白葱烤面包",
                "铜锣烧",
                "面包"
            ]
        },
        {
            "songId": "quiet room",
            "category": "niconico＆ボーカロイド",
            "title": "quiet room",
            "artist": "有機酸",
            "bpm": 93,
            "imageName": "1968da68f458df2a070ede0a40e693565c365e776c75a92deb211bc36a5bb48e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 121,
                        "hold": 5,
                        "slide": 2,
                        "touch": 18,
                        "break": 2,
                        "total": 148
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11078,
                    "releaseDate": "2019-11-29"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 132,
                        "hold": 15,
                        "slide": 9,
                        "touch": 21,
                        "break": 6,
                        "total": 183
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11078,
                    "releaseDate": "2019-11-29"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 132,
                        "hold": 23,
                        "slide": 50,
                        "touch": 46,
                        "break": 6,
                        "total": 257
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11078,
                    "releaseDate": "2019-11-29"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 324,
                        "hold": 30,
                        "slide": 92,
                        "touch": 72,
                        "break": 3,
                        "total": 521
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11078,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2019-11-29"
                }
            ],
            "searchAcronyms": [
                "qr",
                "男同2",
                "静屋"
            ]
        },
        {
            "songId": "TEmPTaTiON",
            "category": "maimai",
            "title": "TEmPTaTiON",
            "artist": "かねこちはる",
            "bpm": 160,
            "imageName": "741df965f9a59341de3aa27702e4873fc4ff9043dfba060e3b63f887894541c1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 183,
                        "hold": 39,
                        "slide": 9,
                        "touch": 18,
                        "break": 9,
                        "total": 258
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11026,
                    "releaseDate": "2019-12-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 28,
                        "slide": 14,
                        "touch": 20,
                        "break": 13,
                        "total": 368
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11026,
                    "releaseDate": "2019-12-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 475,
                        "hold": 76,
                        "slide": 49,
                        "touch": 43,
                        "break": 22,
                        "total": 665
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11026,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL": 12.6,
                        "PRiSM PLUS": 12.6,
                        "Splash": 12.6,
                        "UNiVERSE PLUS": 12.6
                    },
                    "releaseDate": "2019-12-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 799,
                        "hold": 96,
                        "slide": 43,
                        "touch": 144,
                        "break": 33,
                        "total": 1115
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11026,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "FESTiVAL": 14.7,
                        "FESTiVAL PLUS": 14.7,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7,
                        "Splash": 14.7,
                        "Splash PLUS": 14.7,
                        "UNiVERSE": 14.7,
                        "UNiVERSE PLUS": 14.7,
                        "maimaiでらっくす PLUS": 14.7
                    },
                    "releaseDate": "2019-12-13"
                }
            ],
            "searchAcronyms": [
                "mika",
                "temp",
                "他不太深",
                "奶子很小",
                "小天使",
                "小萝莉",
                "小萝莉的诱惑",
                "引诱",
                "百合咲",
                "百合咲mika",
                "百合咲低语",
                "老婆",
                "肯德基六翅桶",
                "诱惑",
                "轻语",
                "鸟加鸟加"
            ]
        },
        {
            "songId": "アポカリプスに反逆の焔を焚べろ",
            "category": "maimai",
            "title": "アポカリプスに反逆の焔を焚べろ",
            "artist": "cosMo＠暴走AlterEgo",
            "bpm": 222,
            "imageName": "11364aeccd394c4dfb26114157f8638765cd6c55ca2456db938767ef18e2c2cf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 219,
                        "hold": 39,
                        "slide": 6,
                        "touch": 40,
                        "break": 6,
                        "total": 310
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11027,
                    "releaseDate": "2019-12-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 30,
                        "slide": 14,
                        "touch": 26,
                        "break": 23,
                        "total": 386
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11027,
                    "releaseDate": "2019-12-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 545,
                        "hold": 37,
                        "slide": 34,
                        "touch": 89,
                        "break": 51,
                        "total": 756
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11027,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2019-12-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 822,
                        "hold": 54,
                        "slide": 78,
                        "touch": 106,
                        "break": 26,
                        "total": 1086
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11027,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.4,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "Splash": 14.2,
                        "Splash PLUS": 14.4,
                        "UNiVERSE": 14.4,
                        "UNiVERSE PLUS": 14.4,
                        "maimaiでらっくす PLUS": 14.5
                    },
                    "releaseDate": "2019-12-13"
                }
            ],
            "searchAcronyms": [
                "Apocalypse",
                "Apocalypse Rebellion",
                "apocalypse rebellious",
                "Apokaripusu ni Hangyaku no Hono wo Kubero",
                "Burn the flame of rebellion on the apocalypse",
                "反逆",
                "反逆焰",
                "暴走p登场曲"
            ]
        },
        {
            "songId": "サヨナラチェーンソー",
            "category": "niconico＆ボーカロイド",
            "title": "サヨナラチェーンソー",
            "artist": "くらげP",
            "bpm": 154,
            "imageName": "088bc43aa4a0ad3e3585f6cc24cc9240285b18128feea00c6642ddac6a3ce199",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 112,
                        "hold": 12,
                        "slide": 7,
                        "touch": 12,
                        "break": 9,
                        "total": 152
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11083,
                    "releaseDate": "2019-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 9,
                        "slide": 11,
                        "touch": 21,
                        "break": 8,
                        "total": 336
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11083,
                    "releaseDate": "2019-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 85,
                        "slide": 43,
                        "touch": 35,
                        "break": 14,
                        "total": 534
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11083,
                    "releaseDate": "2019-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 507,
                        "hold": 79,
                        "slide": 107,
                        "touch": 71,
                        "break": 10,
                        "total": 774
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11083,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2019-12-20"
                }
            ],
            "searchAcronyms": [
                "Sayonara Chainsaw",
                "再见电锯",
                "电锯",
                "电锯人",
                "电锯缘兔"
            ]
        },
        {
            "songId": "幾望の月",
            "category": "niconico＆ボーカロイド",
            "title": "幾望の月",
            "artist": "なきゃむりゃ",
            "bpm": 276,
            "imageName": "4f0914a823946421527b5745ebe6938ee7a32dd5508f285dd5dfe839aa4b957a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 130,
                        "hold": 26,
                        "slide": 5,
                        "touch": 5,
                        "break": 3,
                        "total": 169
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11087,
                    "releaseDate": "2019-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 294,
                        "hold": 12,
                        "slide": 12,
                        "touch": 17,
                        "break": 8,
                        "total": 343
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11087,
                    "releaseDate": "2019-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 382,
                        "hold": 63,
                        "slide": 27,
                        "touch": 56,
                        "break": 24,
                        "total": 552
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11087,
                    "releaseDate": "2019-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 610,
                        "hold": 39,
                        "slide": 37,
                        "touch": 43,
                        "break": 26,
                        "total": 755
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11087,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2019-12-20"
                }
            ],
            "searchAcronyms": [
                "Kibou no Tsuki",
                "几把之月",
                "几望",
                "几望之月",
                "几望月",
                "望月",
                "鸡王之约"
            ]
        },
        {
            "songId": "BOKUTO",
            "category": "オンゲキ＆CHUNITHM",
            "title": "BOKUTO",
            "artist": "じーざすP feat.kradness",
            "bpm": 188,
            "imageName": "6a929fec8780b9e8d062f2abdb2f25d03218d78e8a09ea773a83bf40e3825e70",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 20,
                        "slide": 8,
                        "touch": 16,
                        "break": 3,
                        "total": 175
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11030,
                    "releaseDate": "2020-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 51,
                        "slide": 7,
                        "touch": 25,
                        "break": 9,
                        "total": 342
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11030,
                    "releaseDate": "2020-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 445,
                        "hold": 83,
                        "slide": 71,
                        "touch": 18,
                        "break": 20,
                        "total": 637
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11030,
                    "releaseDate": "2020-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 690,
                        "hold": 62,
                        "slide": 107,
                        "touch": 133,
                        "break": 18,
                        "total": 1010
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11030,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.4,
                        "Splash PLUS": 13.4,
                        "UNiVERSE": 13.4,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2020-01-10"
                }
            ],
            "searchAcronyms": [
                "→↓→↓→↓→↓",
                "临兵斗者皆阵列在前",
                "剥裤头",
                "波裤头",
                "破裤头"
            ]
        },
        {
            "songId": "立川浄穢捕物帳",
            "category": "オンゲキ＆CHUNITHM",
            "title": "立川浄穢捕物帳",
            "artist": "青島探偵事務所器楽捜査部B担",
            "bpm": 210,
            "imageName": "9571787908ec769bb1f87e2a149ccf0925d308771e7e4c69e06b22e3798c29df",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 160,
                        "hold": 14,
                        "slide": 3,
                        "touch": 12,
                        "break": 7,
                        "total": 196
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11031,
                    "releaseDate": "2020-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 298,
                        "hold": 29,
                        "slide": 19,
                        "touch": 13,
                        "break": 6,
                        "total": 365
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11031,
                    "releaseDate": "2020-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 504,
                        "hold": 56,
                        "slide": 40,
                        "touch": 15,
                        "break": 13,
                        "total": 628
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11031,
                    "releaseDate": "2020-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 713,
                        "hold": 33,
                        "slide": 140,
                        "touch": 50,
                        "break": 35,
                        "total": 971
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11031,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2020-01-10"
                }
            ],
            "searchAcronyms": [
                "Tachikawa",
                "Tachikawa Jyosei Catch Book",
                "Tachikawajo Torimonocho",
                "快手极速版",
                "捕物帐",
                "有损录音",
                "立川",
                "立川净秽捕物帐",
                "青岛侦探事务所"
            ]
        },
        {
            "songId": "プナイプナイせんそう",
            "category": "ゲーム＆バラエティ",
            "title": "プナイプナイせんそう",
            "artist": "立秋 feat.ちょこ",
            "bpm": 271,
            "imageName": "c9671f945dec083299042705185a8287e4242d917bbd2ea5e8796686cb71552f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 31,
                        "slide": 2,
                        "touch": 28,
                        "break": 16,
                        "total": 223
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11075,
                    "releaseDate": "2020-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 18,
                        "slide": 14,
                        "touch": 61,
                        "break": 21,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11075,
                    "releaseDate": "2020-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 457,
                        "hold": 20,
                        "slide": 20,
                        "touch": 54,
                        "break": 33,
                        "total": 584
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11075,
                    "releaseDate": "2020-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 457,
                        "hold": 34,
                        "slide": 114,
                        "touch": 143,
                        "break": 55,
                        "total": 803
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11075,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.8,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2020-01-10"
                }
            ],
            "searchAcronyms": [
                "pnpn",
                "punai",
                "punaipunai",
                "噗奶",
                "噗奶噗奶"
            ]
        },
        {
            "songId": "Bad Apple!! feat.nomico (REDALiCE Remix)",
            "category": "東方Project",
            "title": "Bad Apple!! feat.nomico (REDALiCE Remix)",
            "artist": "Masayoshi Minoshima × REDALiCE",
            "bpm": 170,
            "imageName": "27dbd4548b0fcb75290b33c70180c246aaeca4a7395839d4f9065b8718d0b9f3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 5,
                        "slide": 2,
                        "touch": 17,
                        "break": 4,
                        "total": 155
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11049,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 226,
                        "hold": 20,
                        "slide": 11,
                        "touch": 35,
                        "break": 14,
                        "total": 306
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11049,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 360,
                        "hold": 48,
                        "slide": 20,
                        "touch": 53,
                        "break": 14,
                        "total": 495
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11049,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 404,
                        "hold": 47,
                        "slide": 155,
                        "touch": 92,
                        "break": 16,
                        "total": 714
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11049,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.6,
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": [
                "🍎",
                "Bad Apple Redalice",
                "Bad Apple Redalice Remix",
                "dx坏苹果",
                "坏苹果remix",
                "红苹果"
            ]
        },
        {
            "songId": "UniTas",
            "category": "maimai",
            "title": "UniTas",
            "artist": "Masahiro \"Godspeed\" Aoki VS Kai",
            "bpm": 205,
            "imageName": "1b6fa9cfc73a16dc267429dd150407ea4d440071edbe750711f6d6c9c05864e1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 21,
                        "slide": 14,
                        "touch": 10,
                        "break": 4,
                        "total": 238
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11093,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 329,
                        "hold": 29,
                        "slide": 22,
                        "touch": 36,
                        "break": 15,
                        "total": 431
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11093,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 586,
                        "hold": 71,
                        "slide": 63,
                        "touch": 25,
                        "break": 17,
                        "total": 762
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11093,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 887,
                        "hold": 63,
                        "slide": 116,
                        "touch": 37,
                        "break": 70,
                        "total": 1173
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11093,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "Splash": 14.3,
                        "Splash PLUS": 14.4,
                        "UNiVERSE": 14.4,
                        "UNiVERSE PLUS": 14.4,
                        "maimaiでらっくす PLUS": 14.3
                    },
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": [
                "吉他女神",
                "吉他姐",
                "吉他神",
                "有你他死",
                "电吉他"
            ]
        },
        {
            "songId": "ここからはじまるプロローグ。",
            "category": "maimai",
            "title": "ここからはじまるプロローグ。",
            "artist": "ああああ",
            "bpm": 182,
            "imageName": "9d469c6a31e846691831b2c052645e906565dc64e14df08b2879eebc8b7ee512",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 84,
                        "hold": 17,
                        "slide": 5,
                        "touch": 21,
                        "break": 4,
                        "total": 131
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11094,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 41,
                        "slide": 12,
                        "touch": 35,
                        "break": 7,
                        "total": 264
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11094,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 354,
                        "hold": 36,
                        "slide": 16,
                        "touch": 47,
                        "break": 24,
                        "total": 477
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11094,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 448,
                        "hold": 56,
                        "slide": 46,
                        "touch": 62,
                        "break": 30,
                        "total": 642
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11094,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.4,
                        "Splash PLUS": 13.4,
                        "UNiVERSE": 13.4,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": [
                "kokokara hajimaru prologue",
                "Kokokara Hajimeru Prologue",
                "prologue",
                "Prologue",
                "prologue starting",
                "The prologue that starts from here.",
                "ああああ",
                "从此开始的序章",
                "你福瑞控是吧",
                "像素福瑞",
                "兽太",
                "口口一夕",
                "圣剑0",
                "小圣剑",
                "小狐狸",
                "小生煎",
                "小福瑞",
                "序言",
                "序章",
                "松鼠",
                "狐狸剑",
                "猫圣剑",
                "由此开始的序章",
                "电动福瑞控",
                "电子福瑞",
                "福瑞举剑",
                "福瑞勇者",
                "福瑞找老婆",
                "福瑞控"
            ]
        },
        {
            "songId": "絡めトリック利己ライザー",
            "category": "maimai",
            "title": "絡めトリック利己ライザー",
            "artist": "じーざす（ワンダフル☆オポチュニティ！）feat.Kradness",
            "bpm": 150,
            "imageName": "834c5d4005099f925c057da4eb8a99c9c62c3e4ad2caefa066d29d6a75f3077f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 159,
                        "hold": 17,
                        "slide": 4,
                        "touch": 12,
                        "break": 6,
                        "total": 198
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11095,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 33,
                        "slide": 6,
                        "touch": 40,
                        "break": 16,
                        "total": 353
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11095,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 82,
                        "slide": 39,
                        "touch": 45,
                        "break": 21,
                        "total": 529
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11095,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 467,
                        "hold": 165,
                        "slide": 43,
                        "touch": 67,
                        "break": 29,
                        "total": 771
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11095,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.6
                    },
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": [
                "dx+主题曲",
                "利己",
                "华代主题曲",
                "络利己",
                "绿头人"
            ]
        },
        {
            "songId": "モ°ルモ°ル",
            "category": "maimai",
            "title": "モ°ルモ°ル",
            "artist": "sasakure.UK",
            "bpm": 176,
            "imageName": "5373c43e8e39c5daa41f09f2482c0e89d6764eb63039cb1beb4cdafc89b55da7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 10,
                        "slide": 4,
                        "touch": 22,
                        "break": 4,
                        "total": 240
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11096,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 30,
                        "slide": 22,
                        "touch": 31,
                        "break": 12,
                        "total": 390
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11096,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 553,
                        "hold": 39,
                        "slide": 15,
                        "touch": 57,
                        "break": 44,
                        "total": 708
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11096,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "PRiSM PLUS": 12.2,
                        "UNiVERSE": 12.2,
                        "UNiVERSE PLUS": 12.2
                    },
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 622,
                        "hold": 50,
                        "slide": 107,
                        "touch": 106,
                        "break": 30,
                        "total": 915
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11096,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": [
                "Modoru Modoru",
                "molmol",
                "morumoru",
                "么么",
                "毛儿",
                "毛儿毛儿",
                "毛肚儿毛肚儿",
                "蹦蹦炸弹"
            ]
        },
        {
            "songId": "ヤミツキ",
            "category": "maimai",
            "title": "ヤミツキ",
            "artist": "MARETU",
            "bpm": 208,
            "imageName": "06c31d0b896b6c668490e9a2f1dc231d50ac2f937ffb406c31322f40a9e9936d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 16,
                        "slide": 4,
                        "touch": 23,
                        "break": 11,
                        "total": 199
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11104,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 152,
                        "hold": 78,
                        "slide": 9,
                        "touch": 34,
                        "break": 4,
                        "total": 277
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11104,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 70,
                        "slide": 37,
                        "touch": 70,
                        "break": 10,
                        "total": 502
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11104,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 499,
                        "hold": 57,
                        "slide": 87,
                        "touch": 70,
                        "break": 11,
                        "total": 724
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11104,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": [
                "Yamitsuki",
                "痴迷"
            ]
        },
        {
            "songId": "ハム太郎とっとこうた",
            "category": "POPS＆アニメ",
            "title": "ハム太郎とっとこうた",
            "artist": "ハムちゃんず [covered by 光吉猛修]",
            "bpm": 140,
            "imageName": "06f4e2a34d6d59cffcb7bcaa6f07fdc51a76648f908e00594f6356f17b9b135c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 57,
                        "hold": 13,
                        "slide": 3,
                        "touch": 10,
                        "break": 3,
                        "total": 86
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11113,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 136,
                        "hold": 8,
                        "slide": 10,
                        "touch": 20,
                        "break": 4,
                        "total": 178
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11113,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 37,
                        "slide": 31,
                        "touch": 61,
                        "break": 4,
                        "total": 238
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11113,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 52,
                        "slide": 78,
                        "touch": 65,
                        "break": 5,
                        "total": 451
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11113,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 57,
                        "slide": 54,
                        "touch": 137,
                        "break": 13,
                        "total": 597
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11113,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": [
                "🐹",
                "仓鼠",
                "哈姆",
                "哈姆太郎",
                "老鼠",
                "陈睿",
                "鸭脖",
                "鸭脖太郎",
                "鼠抓板",
                "鼠鼠"
            ]
        },
        {
            "songId": "だから僕は音楽を辞めた",
            "category": "POPS＆アニメ",
            "title": "だから僕は音楽を辞めた",
            "artist": "ヨルシカ",
            "bpm": 150,
            "imageName": "6771cc1cb5d65ebef30f80e82159d4014fa24e94dce4627fe7767c78da6f67a6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 83,
                        "hold": 9,
                        "slide": 4,
                        "touch": 13,
                        "break": 3,
                        "total": 112
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11115,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 150,
                        "hold": 15,
                        "slide": 28,
                        "touch": 17,
                        "break": 6,
                        "total": 216
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11115,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 242,
                        "hold": 43,
                        "slide": 24,
                        "touch": 21,
                        "break": 5,
                        "total": 335
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11115,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 372,
                        "hold": 38,
                        "slide": 68,
                        "touch": 153,
                        "break": 12,
                        "total": 643
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "level": "12",
                            "levelValue": 12
                        }
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11115,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": [
                "Moonlight",
                "That's Why I Gave Up On Music",
                "That's Why I Quit Music",
                "エイミー",
                "于是我放弃了音乐",
                "仆音乐辞",
                "团长",
                "奥尔加",
                "所以我放弃了maimai",
                "所以我放弃了音乐",
                "所以我放弃了音游",
                "放弃音乐",
                "祥子",
                "音辞"
            ]
        },
        {
            "songId": "ビターチョコデコレーション",
            "category": "niconico＆ボーカロイド",
            "title": "ビターチョコデコレーション",
            "artist": "syudou",
            "bpm": 174,
            "imageName": "f82bf811169683eb500fa968c5b1e358716f12f66a6e0a1adfe206775bf65b7e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 126,
                        "hold": 22,
                        "slide": 4,
                        "touch": 15,
                        "break": 3,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11121,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 23,
                        "slide": 21,
                        "touch": 16,
                        "break": 10,
                        "total": 360
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11121,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 374,
                        "hold": 86,
                        "slide": 14,
                        "touch": 17,
                        "break": 8,
                        "total": 499
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11121,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 619,
                        "hold": 79,
                        "slide": 92,
                        "touch": 23,
                        "break": 16,
                        "total": 829
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11121,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": [
                "🍽️",
                "米开朗基罗",
                "苦巧",
                "苦巧克力",
                "苦巧克力装饰",
                "谁知盘中餐"
            ]
        },
        {
            "songId": "アンドロイドガール",
            "category": "niconico＆ボーカロイド",
            "title": "アンドロイドガール",
            "artist": "DECO*27",
            "bpm": 192,
            "imageName": "99c48a33d59282f82f7f9bdba32f80c797a8ea7ffdf533aa63ec780a7211df6e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 130,
                        "hold": 14,
                        "slide": 7,
                        "touch": 10,
                        "break": 2,
                        "total": 163
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11122,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 304,
                        "hold": 24,
                        "slide": 10,
                        "touch": 13,
                        "break": 8,
                        "total": 359
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11122,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 459,
                        "hold": 48,
                        "slide": 5,
                        "touch": 36,
                        "break": 22,
                        "total": 570
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11122,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 596,
                        "hold": 57,
                        "slide": 81,
                        "touch": 26,
                        "break": 25,
                        "total": 785
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11122,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9,
                        "maimaiでらっくす PLUS": 13.2
                    },
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": [
                "Android Girl",
                "仿生少女",
                "安卓女",
                "安卓女孩",
                "安卓少女",
                "琪亚娜"
            ]
        },
        {
            "songId": "スターリースカイ☆パレード",
            "category": "niconico＆ボーカロイド",
            "title": "スターリースカイ☆パレード",
            "artist": "キノシタ feat. 音街ウナ・鏡音リン",
            "bpm": 177,
            "imageName": "9e7d958b570860f837e43599bc8c317e6527f8c38663ccace83e84eb697af66e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 158,
                        "hold": 18,
                        "slide": 5,
                        "touch": 9,
                        "break": 4,
                        "total": 194
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11123,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 328,
                        "hold": 16,
                        "slide": 14,
                        "touch": 20,
                        "break": 6,
                        "total": 384
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11123,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 415,
                        "hold": 50,
                        "slide": 33,
                        "touch": 57,
                        "break": 26,
                        "total": 581
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11123,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 537,
                        "hold": 64,
                        "slide": 74,
                        "touch": 57,
                        "break": 24,
                        "total": 756
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11123,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "Splash": 12.6,
                        "UNiVERSE PLUS": 12.6
                    },
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": [
                "starryskyparade",
                "女同5",
                "星空游行"
            ]
        },
        {
            "songId": "スロウダウナー",
            "category": "niconico＆ボーカロイド",
            "title": "スロウダウナー",
            "artist": "ろくろ",
            "bpm": 194,
            "imageName": "8374c70601b1f433e04239eb7b415ec292fc6a859ea034d433cfe5bf04f96a4d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 17,
                        "slide": 7,
                        "touch": 6,
                        "break": 4,
                        "total": 162
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11124,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 18,
                        "slide": 9,
                        "touch": 26,
                        "break": 8,
                        "total": 312
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11124,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 405,
                        "hold": 44,
                        "slide": 13,
                        "touch": 26,
                        "break": 8,
                        "total": 496
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11124,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 484,
                        "hold": 82,
                        "slide": 91,
                        "touch": 36,
                        "break": 14,
                        "total": 707
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11124,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": [
                "slow downer",
                "up down",
                "上下"
            ]
        },
        {
            "songId": "ソリッド",
            "category": "東方Project",
            "title": "ソリッド",
            "artist": "豚乙女",
            "bpm": 222,
            "imageName": "e554913c240fae13ef0bb6dbb25124a4b96344218a29740361a7de057f549005",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 121,
                        "hold": 11,
                        "slide": 8,
                        "touch": 12,
                        "break": 6,
                        "total": 158
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11134,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 11,
                        "slide": 11,
                        "touch": 14,
                        "break": 6,
                        "total": 292
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11134,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 404,
                        "hold": 64,
                        "slide": 30,
                        "touch": 10,
                        "break": 5,
                        "total": 513
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11134,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 523,
                        "hold": 30,
                        "slide": 132,
                        "touch": 33,
                        "break": 30,
                        "total": 748
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11134,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": [
                "solid",
                "丰川祥子",
                "大穷比",
                "大穷逼",
                "大穷鬼",
                "大贫民",
                "我",
                "我也"
            ]
        },
        {
            "songId": "Black Lair",
            "category": "ゲーム＆バラエティ",
            "title": "Black Lair",
            "artist": "削除 feat. void (Mournfinale)",
            "bpm": 150,
            "imageName": "e11a63816955d5d27d949aa8a3363f62a46ce2462bf013451b59e8010cf475ca",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 108,
                        "hold": 17,
                        "slide": 11,
                        "touch": 39,
                        "break": 1,
                        "total": 176
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11140,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 226,
                        "hold": 27,
                        "slide": 20,
                        "touch": 30,
                        "break": 7,
                        "total": 310
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11140,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 324,
                        "hold": 102,
                        "slide": 41,
                        "touch": 70,
                        "break": 15,
                        "total": 552
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11140,
                    "releaseDate": "2020-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 582,
                        "hold": 89,
                        "slide": 67,
                        "touch": 59,
                        "break": 37,
                        "total": 834
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11140,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2020-01-23"
                }
            ],
            "searchAcronyms": [
                "bl",
                "公主斗恶龙",
                "美女翘屁股砍龙",
                "黑巢"
            ]
        },
        {
            "songId": "energy trixxx",
            "category": "ゲーム＆バラエティ",
            "title": "energy trixxx",
            "artist": "KAH",
            "bpm": 160,
            "imageName": "640edd52c7f6d621ed0a9e96710ab89b28feccc78768ec1c687175ecadbaf575",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 26,
                        "slide": 8,
                        "touch": 13,
                        "break": 13,
                        "total": 201
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11141,
                    "releaseDate": "2020-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 43,
                        "slide": 14,
                        "touch": 52,
                        "break": 9,
                        "total": 290
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11141,
                    "releaseDate": "2020-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 379,
                        "hold": 75,
                        "slide": 43,
                        "touch": 60,
                        "break": 27,
                        "total": 584
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11141,
                    "releaseDate": "2020-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 673,
                        "hold": 59,
                        "slide": 51,
                        "touch": 91,
                        "break": 44,
                        "total": 918
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11141,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2020-02-07"
                }
            ],
            "searchAcronyms": [
                "xxx",
                "美友姬",
                "美有姬",
                "能量xxx",
                "能量三角",
                "能量三角形",
                "能量叉叉",
                "马娘"
            ]
        },
        {
            "songId": "NULCTRL",
            "category": "ゲーム＆バラエティ",
            "title": "NULCTRL",
            "artist": "Silentroom",
            "bpm": 100,
            "imageName": "2bc92c2ccf0dc31b7ac23c2e846bcfce0c30445dc9157aa25b658454d4e58fd7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 114,
                        "hold": 12,
                        "slide": 2,
                        "touch": 12,
                        "break": 7,
                        "total": 147
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11142,
                    "releaseDate": "2020-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 147,
                        "hold": 54,
                        "slide": 8,
                        "touch": 26,
                        "break": 10,
                        "total": 245
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11142,
                    "releaseDate": "2020-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 158,
                        "slide": 29,
                        "touch": 19,
                        "break": 6,
                        "total": 523
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11142,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "Splash": 12.4
                    },
                    "releaseDate": "2020-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "譜面-100号とはっぴー",
                    "noteCounts": {
                        "tap": 564,
                        "hold": 72,
                        "slide": 1,
                        "touch": 248,
                        "break": 12,
                        "total": 897
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11142,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2020-02-07"
                }
            ],
            "searchAcronyms": [
                "cxk",
                "nc",
                "NTR",
                "nul",
                "一根星星",
                "努力唱跳rap篮球",
                "唱跳rap篮球",
                "无控",
                "没有唱跳rap篮球",
                "牛个戳",
                "牛啃臭",
                "红蓝",
                "脑残"
            ]
        },
        {
            "songId": "アトロポスと最果の探究者",
            "category": "ゲーム＆バラエティ",
            "title": "アトロポスと最果の探究者",
            "artist": "しーけー",
            "bpm": 230,
            "imageName": "e2b952b3da054954ef7b68b6f3306f5e2fe575ebe9da0a1c2438c714bb175b74",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 180,
                        "hold": 15,
                        "slide": 5,
                        "touch": 11,
                        "break": 5,
                        "total": 216
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11143,
                    "releaseDate": "2020-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 174,
                        "hold": 49,
                        "slide": 12,
                        "touch": 34,
                        "break": 10,
                        "total": 279
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11143,
                    "releaseDate": "2020-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 370,
                        "hold": 69,
                        "slide": 42,
                        "touch": 51,
                        "break": 43,
                        "total": 575
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11143,
                    "releaseDate": "2020-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "群青リコリス",
                    "noteCounts": {
                        "tap": 572,
                        "hold": 58,
                        "slide": 88,
                        "touch": 63,
                        "break": 32,
                        "total": 813
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11143,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.5,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2020-02-07"
                }
            ],
            "searchAcronyms": [
                "最果",
                "最果探究者",
                "大奶子伊蕾娜",
                "大奶子依蕾娜",
                "大柰子伊蕾娜",
                "大柰柰伊蕾娜",
                "探究者",
                "翠果",
                "阿特洛波斯与尽头的探究者"
            ]
        },
        {
            "songId": "Valsqotch",
            "category": "maimai",
            "title": "Valsqotch",
            "artist": "owl＊tree feat.chi＊tree",
            "bpm": 125,
            "imageName": "c1a833193d2bd766bd882de5b4b77e508d3f622bc6c1a58117a0bd4494d0d884",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 44,
                        "slide": 2,
                        "touch": 35,
                        "break": 11,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11106,
                    "releaseDate": "2020-02-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 377,
                        "hold": 35,
                        "slide": 17,
                        "touch": 24,
                        "break": 17,
                        "total": 470
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11106,
                    "releaseDate": "2020-02-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 649,
                        "hold": 55,
                        "slide": 62,
                        "touch": 50,
                        "break": 37,
                        "total": 853
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11106,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2020-02-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "jacK on Phoenix",
                    "noteCounts": {
                        "tap": 895,
                        "hold": 37,
                        "slide": 94,
                        "touch": 131,
                        "break": 37,
                        "total": 1194
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11106,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "FESTiVAL": 14.7,
                        "FESTiVAL PLUS": 14.7,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7,
                        "Splash": 14.8,
                        "Splash PLUS": 14.7,
                        "UNiVERSE": 14.7,
                        "UNiVERSE PLUS": 14.7,
                        "maimaiでらっくす PLUS": 14.8
                    },
                    "releaseDate": "2020-02-14"
                }
            ],
            "searchAcronyms": [
                "kop1",
                "valsq",
                "别急7",
                "大金熊",
                "熊大",
                "迪拜熊",
                "金库玛",
                "金熊",
                "金色滴蜡熊",
                "银币",
                "黄金滴蜡熊",
                "黄金熊"
            ]
        },
        {
            "songId": "最強 the サマータイム!!!!!",
            "category": "オンゲキ＆CHUNITHM",
            "title": "最強 the サマータイム!!!!!",
            "artist": "曲：村カワ基成／歌：オンゲキシューターズ",
            "bpm": 178,
            "imageName": "1a23ee0506c130508768314110aeaa4b795d768bfc4aa3ad7bee87a1fb38a3d1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 161,
                        "hold": 23,
                        "slide": 5,
                        "touch": 14,
                        "break": 3,
                        "total": 206
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11107,
                    "releaseDate": "2020-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 35,
                        "slide": 15,
                        "touch": 39,
                        "break": 8,
                        "total": 369
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11107,
                    "releaseDate": "2020-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 517,
                        "hold": 39,
                        "slide": 28,
                        "touch": 51,
                        "break": 25,
                        "total": 660
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11107,
                    "releaseDate": "2020-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 516,
                        "hold": 27,
                        "slide": 125,
                        "touch": 49,
                        "break": 49,
                        "total": 766
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11107,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE PLUS": 12.4
                    },
                    "releaseDate": "2020-02-20"
                }
            ],
            "searchAcronyms": [
                "saikyo the summertime",
                "saikyou the summertime",
                "最强",
                "泳装"
            ]
        },
        {
            "songId": "UTAKATA",
            "category": "オンゲキ＆CHUNITHM",
            "title": "UTAKATA",
            "artist": "曲：ゆよゆっぺ／歌：九條 楓(CV：佳村 はるか)",
            "bpm": 185,
            "imageName": "db6c619eb878fcecf9f07cb64ef3d0fc76274baecafa4486db16ba9ec04567c9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 106,
                        "hold": 29,
                        "slide": 4,
                        "touch": 20,
                        "break": 6,
                        "total": 165
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11108,
                    "releaseDate": "2020-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 38,
                        "slide": 7,
                        "touch": 14,
                        "break": 9,
                        "total": 286
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11108,
                    "releaseDate": "2020-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "KTM",
                    "noteCounts": {
                        "tap": 383,
                        "hold": 38,
                        "slide": 25,
                        "touch": 17,
                        "break": 27,
                        "total": 490
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11108,
                    "releaseDate": "2020-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 508,
                        "hold": 34,
                        "slide": 93,
                        "touch": 14,
                        "break": 31,
                        "total": 680
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11108,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2020-02-20"
                }
            ],
            "searchAcronyms": [
                "拔刀",
                "泡沫",
                "维吉尔"
            ]
        },
        {
            "songId": "タテマエと本心の大乱闘",
            "category": "オンゲキ＆CHUNITHM",
            "title": "タテマエと本心の大乱闘",
            "artist": "曲：鯨井国家／歌：藍原 椿(CV：橋本 ちなみ)",
            "bpm": 180,
            "imageName": "6fa2d07966b9dd6d680f68012766cfe257cd33cd30796c852507c7140fccfad6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 158,
                        "hold": 20,
                        "slide": 2,
                        "touch": 22,
                        "break": 11,
                        "total": 213
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11109,
                    "releaseDate": "2020-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 36,
                        "slide": 5,
                        "touch": 41,
                        "break": 10,
                        "total": 332
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11109,
                    "releaseDate": "2020-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 406,
                        "hold": 63,
                        "slide": 18,
                        "touch": 40,
                        "break": 16,
                        "total": 543
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11109,
                    "releaseDate": "2020-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 539,
                        "hold": 39,
                        "slide": 128,
                        "touch": 34,
                        "break": 35,
                        "total": 775
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11109,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2020-02-20"
                }
            ],
            "searchAcronyms": [
                "dairantou",
                "tateyama",
                "任天堂明星大乱斗",
                "场面话与真心的大乱斗",
                "大乱斗",
                "本心",
                "本心大乱斗"
            ]
        },
        {
            "songId": "クレイジー・ビート",
            "category": "niconico＆ボーカロイド",
            "title": "クレイジー・ビート",
            "artist": "さつき が てんこもり",
            "bpm": 130,
            "imageName": "e70b74a50de27cc9166ce2a6e645cfc139df101250e5f582e46d06afb930515d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 9,
                        "slide": 2,
                        "touch": 8,
                        "break": 5,
                        "total": 152
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11125,
                    "releaseDate": "2020-03-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 192,
                        "hold": 23,
                        "slide": 4,
                        "touch": 38,
                        "break": 8,
                        "total": 265
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11125,
                    "releaseDate": "2020-03-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 110,
                        "slide": 40,
                        "touch": 20,
                        "break": 16,
                        "total": 433
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11125,
                    "releaseDate": "2020-03-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 475,
                        "hold": 50,
                        "slide": 76,
                        "touch": 26,
                        "break": 25,
                        "total": 652
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11125,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.9,
                        "Splash PLUS": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2020-03-06"
                }
            ],
            "searchAcronyms": [
                "crazy beat",
                "crazy beats",
                "crazybeat",
                "crazybeats",
                "双人蹦迪",
                "狂乱节拍",
                "狂热节拍",
                "致命节奏"
            ]
        },
        {
            "songId": "バイオレンストリガー",
            "category": "niconico＆ボーカロイド",
            "title": "バイオレンストリガー",
            "artist": "八王子P",
            "bpm": 196,
            "imageName": "0393f5550bda8baae8d9ca9c6c58a91ee49fe7e3e35d7e96c04923ebcafc1179",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 28,
                        "slide": 5,
                        "touch": 16,
                        "break": 2,
                        "total": 193
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11126,
                    "releaseDate": "2020-03-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 24,
                        "slide": 13,
                        "touch": 13,
                        "break": 4,
                        "total": 316
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11126,
                    "releaseDate": "2020-03-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 80,
                        "slide": 42,
                        "touch": 17,
                        "break": 9,
                        "total": 512
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11126,
                    "releaseDate": "2020-03-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 614,
                        "hold": 38,
                        "slide": 103,
                        "touch": 33,
                        "break": 44,
                        "total": 832
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11126,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 13.3,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 13.3
                    },
                    "releaseDate": "2020-03-06"
                }
            ],
            "searchAcronyms": [
                "jerry",
                "megumegu",
                "Violence Trigger",
                "危险扳机",
                "暴力扳机",
                "暴力拆机",
                "暴力板机",
                "杰瑞",
                "陶大冲"
            ]
        },
        {
            "songId": "グラーヴェ",
            "category": "niconico＆ボーカロイド",
            "title": "グラーヴェ",
            "artist": "niki",
            "bpm": 185,
            "imageName": "a6e2ba7dea47723d788d878fdfc5ad870f38010ebd203e1c3ebb9c1746203903",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 101,
                        "hold": 15,
                        "slide": 5,
                        "touch": 6,
                        "break": 2,
                        "total": 129
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11127,
                    "releaseDate": "2020-03-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 148,
                        "hold": 29,
                        "slide": 11,
                        "touch": 39,
                        "break": 2,
                        "total": 229
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11127,
                    "releaseDate": "2020-03-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 40,
                        "slide": 38,
                        "touch": 24,
                        "break": 12,
                        "total": 452
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11127,
                    "releaseDate": "2020-03-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 500,
                        "hold": 31,
                        "slide": 93,
                        "touch": 48,
                        "break": 6,
                        "total": 678
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11127,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "maimaiでらっくす PLUS": 12.6
                    },
                    "releaseDate": "2020-03-06"
                }
            ],
            "searchAcronyms": [
                "grave",
                "Grave",
                "hello",
                "嘟嘟嘟"
            ]
        },
        {
            "songId": "KILLER B",
            "category": "niconico＆ボーカロイド",
            "title": "KILLER B",
            "artist": "梅とら",
            "bpm": 130,
            "imageName": "3d7b4a4499f4405e5412f02f88d90f6442be388d8dff541daa6a453734d98364",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 97,
                        "hold": 8,
                        "slide": 2,
                        "touch": 14,
                        "break": 7,
                        "total": 128
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11128,
                    "releaseDate": "2020-03-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 36,
                        "slide": 6,
                        "touch": 23,
                        "break": 4,
                        "total": 226
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11128,
                    "releaseDate": "2020-03-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 299,
                        "hold": 55,
                        "slide": 40,
                        "touch": 44,
                        "break": 25,
                        "total": 463
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11128,
                    "releaseDate": "2020-03-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 482,
                        "hold": 29,
                        "slide": 69,
                        "touch": 68,
                        "break": 3,
                        "total": 651
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11128,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2020-03-06"
                }
            ],
            "searchAcronyms": [
                "杀b",
                "王女"
            ]
        },
        {
            "songId": "STEEL TRANSONIC",
            "category": "maimai",
            "title": "STEEL TRANSONIC",
            "artist": "BlackY vs. WAiKURO",
            "bpm": 236,
            "imageName": "fbed0027cc902c3ee3417596d041727fc84c848e2d920c8b7a5ef61789d55374",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 7,
                        "slide": 7,
                        "touch": 9,
                        "break": 11,
                        "total": 222
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11089,
                    "releaseDate": "2020-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 310,
                        "hold": 38,
                        "slide": 17,
                        "touch": 32,
                        "break": 14,
                        "total": 411
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11089,
                    "releaseDate": "2020-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 548,
                        "hold": 88,
                        "slide": 32,
                        "touch": 3,
                        "break": 33,
                        "total": 704
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11089,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2020-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 687,
                        "hold": 97,
                        "slide": 85,
                        "touch": 77,
                        "break": 57,
                        "total": 1003
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11089,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "Splash": 14.3,
                        "Splash PLUS": 14.3,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.3,
                        "maimaiでらっくす PLUS": 14.3
                    },
                    "releaseDate": "2020-03-19"
                }
            ],
            "searchAcronyms": [
                "🐔",
                "st",
                "刚铁鸡娘",
                "机娘",
                "答辩",
                "粉毛机娘",
                "粉毛机甲",
                "红色有角三倍速",
                "超音钢",
                "钢跨音速",
                "钢铁回音",
                "钢铁机娘",
                "钢铁超音速",
                "钢铁音速",
                "钢铁鸡娘",
                "铁音速"
            ]
        },
        {
            "songId": "Flashkick",
            "category": "maimai",
            "title": "Flashkick",
            "artist": "Yooh",
            "bpm": 175,
            "imageName": "f493e5a53ee053a1b2e053bfa5b5a063b8594e63989e5b3e61315a57ecf2a6b1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 136,
                        "hold": 8,
                        "slide": 7,
                        "touch": 24,
                        "break": 4,
                        "total": 179
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11090,
                    "releaseDate": "2020-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 219,
                        "hold": 24,
                        "slide": 18,
                        "touch": 39,
                        "break": 6,
                        "total": 306
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11090,
                    "releaseDate": "2020-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 392,
                        "hold": 66,
                        "slide": 71,
                        "touch": 27,
                        "break": 23,
                        "total": 579
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11090,
                    "releaseDate": "2020-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 504,
                        "hold": 62,
                        "slide": 88,
                        "touch": 99,
                        "break": 45,
                        "total": 798
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11090,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.2,
                        "maimaiでらっくす PLUS": 13.2
                    },
                    "releaseDate": "2020-03-19"
                }
            ],
            "searchAcronyms": [
                "flash",
                "我tm一个滑铲",
                "闪击",
                "闪电旋风劈",
                "闪电旋风踢",
                "闪踢"
            ]
        },
        {
            "songId": "ブレインジャックシンドローム",
            "category": "maimai",
            "title": "ブレインジャックシンドローム",
            "artist": "かいりきベア feat.利香",
            "bpm": 204,
            "imageName": "00cb44b1a909b08b010b8f778b9798a9dcb3f800844aaacc6157832d503d8398",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 140,
                        "hold": 20,
                        "slide": 8,
                        "touch": 12,
                        "break": 4,
                        "total": 184
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11097,
                    "releaseDate": "2020-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 261,
                        "hold": 31,
                        "slide": 18,
                        "touch": 28,
                        "break": 2,
                        "total": 340
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11097,
                    "releaseDate": "2020-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 426,
                        "hold": 77,
                        "slide": 25,
                        "touch": 83,
                        "break": 26,
                        "total": 637
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11097,
                    "releaseDate": "2020-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "シチミッピー",
                    "noteCounts": {
                        "tap": 747,
                        "hold": 34,
                        "slide": 150,
                        "touch": 30,
                        "break": 57,
                        "total": 1018
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11097,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "Splash": 13.3,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 13.3
                    },
                    "releaseDate": "2020-03-19"
                }
            ],
            "searchAcronyms": [
                "Brainjack Syndrome",
                "利香",
                "吉他",
                "头脑风暴",
                "头脑风暴综合症",
                "话筒姐",
                "墨镜女",
                "墨镜女歌手"
            ]
        },
        {
            "songId": "シエルブルーマルシェ",
            "category": "maimai",
            "title": "シエルブルーマルシェ",
            "artist": "OSTER project feat. かなたん",
            "bpm": 180,
            "imageName": "0452fd70bae5acda8310cc0c6f64d451f045fe60a298dbcb4e649460c47297dc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 70,
                        "hold": 22,
                        "slide": 4,
                        "touch": 21,
                        "break": 6,
                        "total": 123
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11100,
                    "releaseDate": "2020-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 210,
                        "hold": 27,
                        "slide": 13,
                        "touch": 23,
                        "break": 2,
                        "total": 275
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11100,
                    "releaseDate": "2020-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 67,
                        "slide": 31,
                        "touch": 38,
                        "break": 7,
                        "total": 394
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11100,
                    "releaseDate": "2020-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 370,
                        "hold": 70,
                        "slide": 81,
                        "touch": 27,
                        "break": 17,
                        "total": 565
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11100,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2020-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 198,
                        "hold": 1,
                        "slide": 216,
                        "touch": 1,
                        "break": 7,
                        "total": 423
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11100,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2022-09-01"
                }
            ],
            "searchAcronyms": [
                "Ciel bleu marché",
                "dx白绯色",
                "做饭",
                "小厨娘",
                "眼镜妹",
                "青空市场"
            ]
        },
        {
            "songId": "Entrance",
            "category": "ゲーム＆バラエティ",
            "title": "Entrance",
            "artist": "Ice",
            "bpm": 180,
            "imageName": "8cddc9726734492bf5f558d2e1c9584710f132cde5c351e9817bddcc033bf1de",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 9,
                        "slide": 2,
                        "touch": 6,
                        "break": 6,
                        "total": 150
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11145,
                    "releaseDate": "2020-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 22,
                        "slide": 8,
                        "touch": 23,
                        "break": 15,
                        "total": 267
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11145,
                    "releaseDate": "2020-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 41,
                        "slide": 25,
                        "touch": 35,
                        "break": 9,
                        "total": 466
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11145,
                    "releaseDate": "2020-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 493,
                        "hold": 48,
                        "slide": 37,
                        "touch": 63,
                        "break": 42,
                        "total": 683
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11145,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.8,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7,
                        "maimaiでらっくす PLUS": 13.8
                    },
                    "releaseDate": "2020-06-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Lunar Mare",
            "category": "ゲーム＆バラエティ",
            "title": "Lunar Mare",
            "artist": "xi vs sakuzyo",
            "bpm": 165,
            "imageName": "830f35261460f435ebfc7724ced36006a78f3e018c9933d2ed0d7f2fedb16252",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 24,
                        "slide": 12,
                        "touch": 16,
                        "break": 9,
                        "total": 202
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11146,
                    "releaseDate": "2020-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 35,
                        "slide": 19,
                        "touch": 15,
                        "break": 10,
                        "total": 352
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11146,
                    "releaseDate": "2020-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 358,
                        "hold": 75,
                        "slide": 51,
                        "touch": 43,
                        "break": 23,
                        "total": 550
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11146,
                    "releaseDate": "2020-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 630,
                        "hold": 65,
                        "slide": 75,
                        "touch": 80,
                        "break": 46,
                        "total": 896
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11146,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.7,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2020-06-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Saika",
            "category": "ゲーム＆バラエティ",
            "title": "Saika",
            "artist": "Rabpit",
            "bpm": 145,
            "imageName": "bd1fcb7a6ab34fa90e21d9d838787ac8aec30a7e0a72393564fc638ebc2bdfb4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 113,
                        "hold": 9,
                        "slide": 6,
                        "touch": 6,
                        "break": 2,
                        "total": 136
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11147,
                    "releaseDate": "2020-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 167,
                        "hold": 21,
                        "slide": 4,
                        "touch": 38,
                        "break": 4,
                        "total": 234
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11147,
                    "releaseDate": "2020-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 235,
                        "hold": 36,
                        "slide": 18,
                        "touch": 40,
                        "break": 14,
                        "total": 343
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11147,
                    "releaseDate": "2020-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 332,
                        "hold": 31,
                        "slide": 62,
                        "touch": 34,
                        "break": 8,
                        "total": 467
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11147,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 12.7,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2020-06-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "CHAOS",
            "category": "ゲーム＆バラエティ",
            "title": "CHAOS",
            "artist": "Æsir",
            "bpm": 150,
            "imageName": "b75894ee0376ee63f52dfed38f6a6a5c0f07f91cf95a1651460acb47f76aff08",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 12,
                        "slide": 5,
                        "touch": 8,
                        "break": 6,
                        "total": 240
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11148,
                    "releaseDate": "2020-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 43,
                        "slide": 16,
                        "touch": 17,
                        "break": 7,
                        "total": 313
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11148,
                    "releaseDate": "2020-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 425,
                        "hold": 63,
                        "slide": 54,
                        "touch": 35,
                        "break": 13,
                        "total": 590
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11148,
                    "releaseDate": "2020-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 531,
                        "hold": 98,
                        "slide": 59,
                        "touch": 106,
                        "break": 29,
                        "total": 823
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11148,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2020-06-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Maboroshi",
            "category": "ゲーム＆バラエティ",
            "title": "Maboroshi",
            "artist": "かめりあ(EDP)",
            "bpm": 190,
            "imageName": "4c891fd1abc9b728df7a38a4c67e18e459ed87bc0bcc1f0c0fd1cd75ab2097d6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 19,
                        "slide": 6,
                        "touch": 6,
                        "break": 10,
                        "total": 229
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11149,
                    "releaseDate": "2020-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 235,
                        "hold": 50,
                        "slide": 6,
                        "touch": 23,
                        "break": 12,
                        "total": 326
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11149,
                    "releaseDate": "2020-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 347,
                        "hold": 88,
                        "slide": 32,
                        "touch": 38,
                        "break": 7,
                        "total": 512
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11149,
                    "releaseDate": "2020-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 660,
                        "hold": 61,
                        "slide": 78,
                        "touch": 126,
                        "break": 19,
                        "total": 944
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11149,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14.2,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "Splash": 14.2,
                        "Splash PLUS": 14.2,
                        "UNiVERSE": 14.2,
                        "UNiVERSE PLUS": 14.2,
                        "maimaiでらっくす PLUS": 14.2
                    },
                    "releaseDate": "2020-06-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ワードワードワード",
            "category": "maimai",
            "title": "ワードワードワード",
            "artist": "syudou",
            "bpm": 137,
            "imageName": "7acf9f57f32a3bd8fb76b90172891148b35f905ea81c329ae840bebd5380503d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 156,
                        "hold": 20,
                        "slide": 1,
                        "touch": 14,
                        "break": 4,
                        "total": 195
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11105,
                    "releaseDate": "2020-06-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 28,
                        "slide": 14,
                        "touch": 50,
                        "break": 4,
                        "total": 258
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11105,
                    "releaseDate": "2020-06-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 386,
                        "hold": 76,
                        "slide": 29,
                        "touch": 8,
                        "break": 23,
                        "total": 522
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11105,
                    "releaseDate": "2020-06-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 676,
                        "hold": 56,
                        "slide": 56,
                        "touch": 72,
                        "break": 30,
                        "total": 890
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11105,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.3,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.3,
                        "maimaiでらっくす PLUS": 13.3
                    },
                    "releaseDate": "2020-06-26"
                }
            ],
            "searchAcronyms": [
                "dx海底潭",
                "dx海底谭",
                "HudeLou",
                "touch海底潭",
                "touch海底谭",
                "word word word",
                "www",
                "二位一体",
                "哇多哇多哇多",
                "豪华海底潭"
            ]
        },
        {
            "songId": "Catch the Wave",
            "category": "niconico＆ボーカロイド",
            "title": "Catch the Wave",
            "artist": "livetune",
            "bpm": 153,
            "imageName": "4b84c8e1778b828f5a974c955fbc63b9a43fdf44588948d176f1c444b2d96468",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 24,
                        "slide": 4,
                        "touch": 6,
                        "break": 4,
                        "total": 166
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11133,
                    "releaseDate": "2020-06-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 255,
                        "hold": 22,
                        "slide": 10,
                        "touch": 30,
                        "break": 10,
                        "total": 327
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11133,
                    "releaseDate": "2020-06-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 310,
                        "hold": 79,
                        "slide": 30,
                        "touch": 60,
                        "break": 39,
                        "total": 518
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11133,
                    "releaseDate": "2020-06-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 521,
                        "hold": 94,
                        "slide": 78,
                        "touch": 44,
                        "break": 19,
                        "total": 756
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11133,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2020-06-26"
                }
            ],
            "searchAcronyms": [
                "👆🏻👌🏻",
                "10",
                "ctw",
                "你是0还是1",
                "你是1还是0",
                "我是👆🏻有👌🏻吗",
                "我是1找个0",
                "我是1有0吗",
                "抓个波",
                "抓波",
                "抓波浪",
                "抓浪"
            ]
        },
        {
            "songId": "Stardust Memories",
            "category": "maimai",
            "title": "Stardust Memories",
            "artist": "Maozon",
            "bpm": 180,
            "imageName": "ea93ec3deeec62a3e6b48e7a184b58133cf9451a6fe35a09060cde6c0af8aa66",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 87,
                        "hold": 11,
                        "slide": 10,
                        "touch": 38,
                        "break": 3,
                        "total": 149
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11091,
                    "releaseDate": "2020-07-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 155,
                        "hold": 46,
                        "slide": 22,
                        "touch": 12,
                        "break": 10,
                        "total": 245
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11091,
                    "releaseDate": "2020-07-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 300,
                        "hold": 35,
                        "slide": 40,
                        "touch": 38,
                        "break": 37,
                        "total": 450
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11091,
                    "releaseDate": "2020-07-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 437,
                        "hold": 86,
                        "slide": 74,
                        "touch": 72,
                        "break": 23,
                        "total": 692
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11091,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13,
                        "Splash": 12.8,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2020-07-03"
                }
            ],
            "searchAcronyms": [
                "🌍",
                "🌏",
                "地球",
                "星尘回忆",
                "星尘记忆"
            ]
        },
        {
            "songId": "My My My",
            "category": "maimai",
            "title": "My My My",
            "artist": "C-Show",
            "bpm": 175,
            "imageName": "84db3f16849b6037fe4f08eada5a9c4accea799fc60bd304ae067ab1f22206da",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 148,
                        "hold": 11,
                        "slide": 3,
                        "touch": 13,
                        "break": 5,
                        "total": 180
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11092,
                    "releaseDate": "2020-07-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 40,
                        "slide": 8,
                        "touch": 17,
                        "break": 5,
                        "total": 297
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11092,
                    "releaseDate": "2020-07-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 333,
                        "hold": 46,
                        "slide": 35,
                        "touch": 66,
                        "break": 27,
                        "total": 507
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11092,
                    "releaseDate": "2020-07-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 581,
                        "hold": 79,
                        "slide": 67,
                        "touch": 65,
                        "break": 24,
                        "total": 816
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11092,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2020-07-03"
                }
            ],
            "searchAcronyms": [
                "3C认证",
                "mrccc",
                "mymymy",
                "买买买",
                "我我我",
                "我的我的我的",
                "麦麦麦"
            ]
        },
        {
            "songId": "共鳴",
            "category": "maimai",
            "title": "共鳴",
            "artist": "SADA 2Futureanthem feat. ellie",
            "bpm": 174,
            "imageName": "038250c3d773e3cdbc6ac4ad7415eb8ee235e8e1cee4c7c0770ccb026bf237ed",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 13,
                        "slide": 9,
                        "touch": 15,
                        "break": 6,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11098,
                    "releaseDate": "2020-07-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 32,
                        "slide": 14,
                        "touch": 32,
                        "break": 1,
                        "total": 276
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11098,
                    "releaseDate": "2020-07-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 354,
                        "hold": 70,
                        "slide": 38,
                        "touch": 22,
                        "break": 5,
                        "total": 489
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11098,
                    "releaseDate": "2020-07-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Safata.Hz",
                    "noteCounts": {
                        "tap": 472,
                        "hold": 34,
                        "slide": 87,
                        "touch": 52,
                        "break": 24,
                        "total": 669
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11098,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13.2,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2020-07-03"
                }
            ],
            "searchAcronyms": [
                "共鸣"
            ]
        },
        {
            "songId": "Ututu",
            "category": "maimai",
            "title": "Ututu",
            "artist": "中山真斗",
            "bpm": 172,
            "imageName": "06254d223e91680ec172c0d7ce548c2e4eee383a8ec640b5ce9ce782286dcfa5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 115,
                        "hold": 9,
                        "slide": 7,
                        "touch": 18,
                        "break": 2,
                        "total": 151
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11099,
                    "releaseDate": "2020-07-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 33,
                        "slide": 12,
                        "touch": 34,
                        "break": 2,
                        "total": 311
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11099,
                    "releaseDate": "2020-07-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 291,
                        "hold": 89,
                        "slide": 26,
                        "touch": 11,
                        "break": 2,
                        "total": 419
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11099,
                    "releaseDate": "2020-07-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 49,
                        "slide": 89,
                        "touch": 123,
                        "break": 23,
                        "total": 633
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11099,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 12.9,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2020-07-03"
                }
            ],
            "searchAcronyms": [
                "胡图图"
            ]
        },
        {
            "songId": "すーぱーぬこになれんかった",
            "category": "niconico＆ボーカロイド",
            "title": "すーぱーぬこになれんかった",
            "artist": "まふまふ",
            "bpm": 190,
            "imageName": "7e6fc097080cc537590e91759ec4acdb07b563ba1f4ce95bc5201b45c7d4c196",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 173,
                        "hold": 21,
                        "slide": 4,
                        "touch": 9,
                        "break": 6,
                        "total": 213
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11129,
                    "releaseDate": "2020-07-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 30,
                        "slide": 19,
                        "touch": 14,
                        "break": 20,
                        "total": 375
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11129,
                    "releaseDate": "2020-07-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 467,
                        "hold": 23,
                        "slide": 48,
                        "touch": 38,
                        "break": 22,
                        "total": 598
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11129,
                    "releaseDate": "2020-07-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 646,
                        "hold": 41,
                        "slide": 99,
                        "touch": 48,
                        "break": 61,
                        "total": 895
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11129,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13.2,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13,
                        "maimaiでらっくす PLUS": 13
                    },
                    "releaseDate": "2020-07-17"
                }
            ],
            "searchAcronyms": [
                "变不成猫",
                "无法成为超级猫猫",
                "没变成猫猫",
                "没能成为超级猫猫",
                "猫咪",
                "蓝蓝路",
                "超猫2",
                "超级猫"
            ]
        },
        {
            "songId": "アスヘノBRAVE",
            "category": "niconico＆ボーカロイド",
            "title": "アスヘノBRAVE",
            "artist": "M.S.S Project",
            "bpm": 150,
            "imageName": "51c8369a32806b60fe409db894a9c307f53edf8f2b5c88363a7009f8c00f7d94",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 104,
                        "hold": 26,
                        "slide": 7,
                        "touch": 12,
                        "break": 6,
                        "total": 155
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11130,
                    "releaseDate": "2020-07-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 204,
                        "hold": 27,
                        "slide": 17,
                        "touch": 24,
                        "break": 16,
                        "total": 288
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11130,
                    "releaseDate": "2020-07-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 394,
                        "hold": 68,
                        "slide": 16,
                        "touch": 17,
                        "break": 12,
                        "total": 507
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11130,
                    "releaseDate": "2020-07-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 589,
                        "hold": 53,
                        "slide": 91,
                        "touch": 27,
                        "break": 14,
                        "total": 774
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11130,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2020-07-17"
                }
            ],
            "searchAcronyms": [
                "brave"
            ]
        },
        {
            "songId": "深海シティアンダーグラウンド",
            "category": "niconico＆ボーカロイド",
            "title": "深海シティアンダーグラウンド",
            "artist": "田中Ｂ",
            "bpm": 170,
            "imageName": "55eacb08bb9295c280ba626498caf23805892b9188d1890868fb97d013c98bbf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 3,
                        "slide": 5,
                        "touch": 16,
                        "break": 6,
                        "total": 187
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11131,
                    "releaseDate": "2020-07-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 19,
                        "slide": 8,
                        "touch": 13,
                        "break": 14,
                        "total": 389
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11131,
                    "releaseDate": "2020-07-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 361,
                        "hold": 48,
                        "slide": 54,
                        "touch": 10,
                        "break": 8,
                        "total": 481
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11131,
                    "releaseDate": "2020-07-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 512,
                        "hold": 39,
                        "slide": 104,
                        "touch": 55,
                        "break": 14,
                        "total": 724
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11131,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2020-07-17"
                }
            ],
            "searchAcronyms": [
                "呜哇啊啊啊",
                "深海",
                "深海undergroundcity",
                "深海地下城",
                "深海地下都市",
                "深海都市"
            ]
        },
        {
            "songId": "表裏一体",
            "category": "niconico＆ボーカロイド",
            "title": "表裏一体",
            "artist": "すりぃ",
            "bpm": 150,
            "imageName": "3817271546a58dc9207cea7f6a569f9712d9fbc44bc8235520617ea79d6924ca",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 11,
                        "slide": 2,
                        "touch": 18,
                        "break": 3,
                        "total": 188
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11132,
                    "releaseDate": "2020-07-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 259,
                        "hold": 30,
                        "slide": 16,
                        "touch": 4,
                        "break": 14,
                        "total": 323
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11132,
                    "releaseDate": "2020-07-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 59,
                        "slide": 30,
                        "touch": 58,
                        "break": 19,
                        "total": 530
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11132,
                    "releaseDate": "2020-07-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 686,
                        "hold": 55,
                        "slide": 75,
                        "touch": 71,
                        "break": 9,
                        "total": 896
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11132,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2020-07-17"
                }
            ],
            "searchAcronyms": [
                "表里",
                "表里一体"
            ]
        },
        {
            "songId": "I'm with you",
            "category": "POPS＆アニメ",
            "title": "I'm with you",
            "artist": "ラティナ(CV:高尾奏音)",
            "bpm": 181,
            "imageName": "6a19633679805c47928a70d0f0a836982474d1858c8211252b8da517f703d60a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 61,
                        "hold": 10,
                        "slide": 2,
                        "touch": 8,
                        "break": 3,
                        "total": 84
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11119,
                    "releaseDate": "2020-07-31"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 15,
                        "slide": 9,
                        "touch": 18,
                        "break": 6,
                        "total": 193
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11119,
                    "releaseDate": "2020-07-31"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 32,
                        "slide": 30,
                        "touch": 28,
                        "break": 22,
                        "total": 306
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11119,
                    "releaseDate": "2020-07-31"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 26,
                        "slide": 50,
                        "touch": 44,
                        "break": 22,
                        "total": 375
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11119,
                    "releaseDate": "2020-07-31"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "GRÄNDIR",
            "category": "maimai",
            "title": "GRÄNDIR",
            "artist": "Rigel Theatre feat. ミーウェル",
            "bpm": 170,
            "imageName": "209e8a34ad6cc1582faebe3a2a35777a91bcbadbef08aa215b84e4ac43d23c34",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 10,
                        "slide": 8,
                        "touch": 26,
                        "break": 4,
                        "total": 157
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11101,
                    "releaseDate": "2020-08-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 259,
                        "hold": 38,
                        "slide": 18,
                        "touch": 45,
                        "break": 16,
                        "total": 376
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11101,
                    "releaseDate": "2020-08-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 394,
                        "hold": 46,
                        "slide": 46,
                        "touch": 71,
                        "break": 14,
                        "total": 571
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11101,
                    "releaseDate": "2020-08-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 500,
                        "hold": 29,
                        "slide": 123,
                        "touch": 124,
                        "break": 37,
                        "total": 813
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11101,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9,
                        "maimaiでらっくす PLUS": 13.9
                    },
                    "releaseDate": "2020-08-07"
                }
            ],
            "searchAcronyms": [
                "gr",
                "grandir",
                "GRANDIR",
                "德文",
                "果然第二",
                "瓜点",
                "甘地"
            ]
        },
        {
            "songId": "封焔の135秒",
            "category": "maimai",
            "title": "封焔の135秒",
            "artist": "大国奏音",
            "bpm": 200,
            "imageName": "5651cbc4bb9d223a40c717f1216f7bad9fba13e36b7a0d1fff0510ae817e9ca5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 14,
                        "slide": 2,
                        "touch": 14,
                        "break": 4,
                        "total": 196
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11102,
                    "releaseDate": "2020-08-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 21,
                        "slide": 25,
                        "touch": 39,
                        "break": 36,
                        "total": 427
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11102,
                    "releaseDate": "2020-08-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 476,
                        "hold": 58,
                        "slide": 40,
                        "touch": 12,
                        "break": 23,
                        "total": 609
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11102,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 12.7,
                        "maimaiでらっくす PLUS": 12.7
                    },
                    "releaseDate": "2020-08-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "7.3GHz vs Phoenix",
                    "noteCounts": {
                        "tap": 786,
                        "hold": 57,
                        "slide": 81,
                        "touch": 33,
                        "break": 135,
                        "total": 1092
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11102,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "FESTiVAL": 14.8,
                        "FESTiVAL PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8,
                        "Splash": 14.8,
                        "Splash PLUS": 14.7,
                        "UNiVERSE": 14.7,
                        "UNiVERSE PLUS": 14.8,
                        "maimaiでらっくす PLUS": 14.8
                    },
                    "releaseDate": "2020-08-07"
                }
            ],
            "searchAcronyms": [
                "135",
                "135 seconds",
                "135 seconds of flame",
                "135秒",
                "Fuen no Hyakusanjugobyo",
                "亲妈死去的135秒",
                "免疫系统大战新冠",
                "大战老头",
                "封号的135分钟",
                "封烟",
                "封焰",
                "封焰135",
                "封焰的135",
                "封焰的135秒",
                "封焰的2分15秒",
                "琴柳大战赫拉格",
                "老变态烤两脚羊",
                "老头大战少女",
                "老逼登大战小仙女",
                "虎弟大战杀马特团长"
            ]
        },
        {
            "songId": "全力ハッピーライフ",
            "category": "東方Project",
            "title": "全力ハッピーライフ",
            "artist": "森羅万象",
            "bpm": 190,
            "imageName": "363d4fca15d56807afc686b8aeaa14aa9ccad51ce320427413effb2823c959e9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 20,
                        "slide": 2,
                        "touch": 20,
                        "break": 7,
                        "total": 200
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11135,
                    "releaseDate": "2020-08-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 274,
                        "hold": 30,
                        "slide": 17,
                        "touch": 26,
                        "break": 9,
                        "total": 356
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11135,
                    "releaseDate": "2020-08-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 459,
                        "hold": 45,
                        "slide": 53,
                        "touch": 41,
                        "break": 37,
                        "total": 635
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11135,
                    "releaseDate": "2020-08-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 551,
                        "hold": 30,
                        "slide": 162,
                        "touch": 25,
                        "break": 44,
                        "total": 812
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11135,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2020-08-21"
                }
            ],
            "searchAcronyms": [
                "🐰👋",
                "Full Power Happy Life",
                "Zenryoku Happy Life",
                "全力",
                "全力happylife",
                "全力哈皮",
                "全力幸福",
                "吉他女神2",
                "铃仙"
            ]
        },
        {
            "songId": "Oath Act",
            "category": "東方Project",
            "title": "Oath Act",
            "artist": "暁Records",
            "bpm": 172,
            "imageName": "52c7c74282009ac47722d3490ad237c2e6297db4fb11c0fa33a261cbb5bbe090",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 88,
                        "hold": 12,
                        "slide": 4,
                        "touch": 14,
                        "break": 6,
                        "total": 124
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11136,
                    "releaseDate": "2020-08-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 6,
                        "slide": 20,
                        "touch": 7,
                        "break": 4,
                        "total": 287
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11136,
                    "releaseDate": "2020-08-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 313,
                        "hold": 76,
                        "slide": 31,
                        "touch": 25,
                        "break": 21,
                        "total": 466
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11136,
                    "releaseDate": "2020-08-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 386,
                        "hold": 56,
                        "slide": 91,
                        "touch": 72,
                        "break": 36,
                        "total": 641
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11136,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2020-08-21"
                }
            ],
            "searchAcronyms": [
                "ocean cat",
                "宣誓行为",
                "涩涩青蛙子",
                "诹访子"
            ]
        },
        {
            "songId": "Witches night",
            "category": "東方Project",
            "title": "Witches night",
            "artist": "Liz Triangle",
            "bpm": 154,
            "imageName": "eff7d0e622dcc2369e83dc1501c2160dd2ad5c57729bd2d01fa96443911fa381",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 133,
                        "hold": 6,
                        "slide": 6,
                        "touch": 12,
                        "break": 8,
                        "total": 165
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11137,
                    "releaseDate": "2020-08-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 30,
                        "slide": 12,
                        "touch": 15,
                        "break": 5,
                        "total": 261
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11137,
                    "releaseDate": "2020-08-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 298,
                        "hold": 63,
                        "slide": 38,
                        "touch": 22,
                        "break": 23,
                        "total": 444
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11137,
                    "releaseDate": "2020-08-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 480,
                        "hold": 61,
                        "slide": 111,
                        "touch": 42,
                        "break": 5,
                        "total": 699
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11137,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.5,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2020-08-21"
                }
            ],
            "searchAcronyms": [
                "东方紫发女",
                "古明地恋",
                "恋恋",
                "魔女之夜"
            ]
        },
        {
            "songId": "Drive Your Fire",
            "category": "東方Project",
            "title": "Drive Your Fire",
            "artist": "A-One",
            "bpm": 164,
            "imageName": "59c9a9db57bf202857c79f9ff19cdac6f1c422c2109f8389e177391a236b09ed",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 121,
                        "hold": 19,
                        "slide": 4,
                        "touch": 14,
                        "break": 6,
                        "total": 164
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11138,
                    "releaseDate": "2020-08-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 14,
                        "slide": 19,
                        "touch": 27,
                        "break": 8,
                        "total": 298
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11138,
                    "releaseDate": "2020-08-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 374,
                        "hold": 71,
                        "slide": 29,
                        "touch": 36,
                        "break": 10,
                        "total": 520
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11138,
                    "releaseDate": "2020-08-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 592,
                        "hold": 51,
                        "slide": 90,
                        "touch": 32,
                        "break": 24,
                        "total": 789
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11138,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2020-08-21"
                }
            ],
            "searchAcronyms": [
                "大姨父",
                "开你的火",
                "极地大冲击",
                "红色电音"
            ]
        },
        {
            "songId": "wheel",
            "category": "東方Project",
            "title": "wheel",
            "artist": "Syrufit + HDLV",
            "bpm": 136,
            "imageName": "5bede353f5c00a7fa5601950ed0f86accd435196cb8bf9d33c975260157c418a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 96,
                        "hold": 9,
                        "slide": 4,
                        "touch": 18,
                        "break": 3,
                        "total": 130
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11139,
                    "releaseDate": "2020-08-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 7,
                        "slide": 8,
                        "touch": 16,
                        "break": 2,
                        "total": 266
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11139,
                    "releaseDate": "2020-08-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 43,
                        "slide": 60,
                        "touch": 3,
                        "break": 2,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11139,
                    "releaseDate": "2020-08-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 12,
                        "slide": 142,
                        "touch": 28,
                        "break": 15,
                        "total": 534
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11139,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2020-08-21"
                }
            ],
            "searchAcronyms": [
                "悠哇悠哇",
                "猫车",
                "轮子",
                "马挖路2"
            ]
        },
        {
            "songId": "CHOCOLATE BOMB!!!!",
            "category": "オンゲキ＆CHUNITHM",
            "title": "CHOCOLATE BOMB!!!!",
            "artist": "YUC'e",
            "bpm": 190,
            "imageName": "4060c5a39c974cef5d2294eaf1f6c8c1c36409721becfc0444f848f31eda916b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 132,
                        "hold": 3,
                        "slide": 9,
                        "touch": 22,
                        "break": 8,
                        "total": 174
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11032,
                    "releaseDate": "2020-09-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 47,
                        "slide": 5,
                        "touch": 1,
                        "break": 20,
                        "total": 363
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11032,
                    "releaseDate": "2020-09-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 316,
                        "hold": 81,
                        "slide": 28,
                        "touch": 70,
                        "break": 28,
                        "total": 523
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11032,
                    "releaseDate": "2020-09-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 502,
                        "hold": 76,
                        "slide": 64,
                        "touch": 88,
                        "break": 57,
                        "total": 787
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11032,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.6,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.5,
                        "maimaiでらっくす PLUS": 13.5
                    },
                    "releaseDate": "2020-09-04"
                }
            ],
            "searchAcronyms": [
                "巧克力炸弹",
                "巧克力爆",
                "巧克力蚌埠",
                "答辩2"
            ]
        },
        {
            "songId": "はちみつアドベンチャー",
            "category": "オンゲキ＆CHUNITHM",
            "title": "はちみつアドベンチャー",
            "artist": "Yunomi feat.nicamoq",
            "bpm": 160,
            "imageName": "12b00b1e877c7d393b67c81405baabf98c1d6ea3138eff9ae82e8de35f5470f4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 140,
                        "hold": 19,
                        "slide": 2,
                        "touch": 16,
                        "break": 4,
                        "total": 181
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11110,
                    "releaseDate": "2020-09-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 248,
                        "hold": 44,
                        "slide": 9,
                        "touch": 16,
                        "break": 14,
                        "total": 331
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11110,
                    "releaseDate": "2020-09-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 45,
                        "slide": 50,
                        "touch": 45,
                        "break": 51,
                        "total": 513
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11110,
                    "releaseDate": "2020-09-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 438,
                        "hold": 51,
                        "slide": 70,
                        "touch": 120,
                        "break": 26,
                        "total": 705
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11110,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2020-09-04"
                }
            ],
            "searchAcronyms": [
                "Hachimitsu Adventure",
                "Honey Adventure",
                "はちみ",
                "哈基米",
                "大小福瑞",
                "小孩坐大车",
                "小孩开大车",
                "熊妈妈",
                "蓝色侏儒小熊",
                "蜂蜜adventure",
                "蜂蜜冒险"
            ]
        },
        {
            "songId": "popcorn",
            "category": "オンゲキ＆CHUNITHM",
            "title": "popcorn",
            "artist": "happy machine",
            "bpm": 130,
            "imageName": "789a3a09eb75db142dbce67f68e5427308792d911e3427f344f1308f273a0b70",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 96,
                        "hold": 13,
                        "slide": 6,
                        "touch": 10,
                        "break": 5,
                        "total": 130
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11111,
                    "releaseDate": "2020-09-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 156,
                        "hold": 35,
                        "slide": 7,
                        "touch": 40,
                        "break": 2,
                        "total": 240
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11111,
                    "releaseDate": "2020-09-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 354,
                        "hold": 46,
                        "slide": 25,
                        "touch": 43,
                        "break": 15,
                        "total": 483
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11111,
                    "releaseDate": "2020-09-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 425,
                        "hold": 81,
                        "slide": 54,
                        "touch": 68,
                        "break": 24,
                        "total": 652
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11111,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "maimaiでらっくす PLUS": 12.9
                    },
                    "releaseDate": "2020-09-04"
                }
            ],
            "searchAcronyms": [
                "企鹅物流",
                "企鹅警长",
                "出警",
                "爆米花"
            ]
        },
        {
            "songId": "ウマイネームイズうまみちゃん",
            "category": "POPS＆アニメ",
            "title": "ウマイネームイズうまみちゃん",
            "artist": "UMAINA",
            "bpm": 184,
            "imageName": "8b288a5376faedca94e033c12a76ca2afafccdedadf1e304d10f22bfc12269f1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 60,
                        "hold": 11,
                        "slide": 3,
                        "touch": 12,
                        "break": 3,
                        "total": 89
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11150,
                    "releaseDate": "2020-09-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 15,
                        "slide": 13,
                        "touch": 9,
                        "break": 4,
                        "total": 241
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11150,
                    "releaseDate": "2020-09-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 47,
                        "slide": 36,
                        "touch": 21,
                        "break": 16,
                        "total": 361
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11150,
                    "releaseDate": "2020-09-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 380,
                        "hold": 14,
                        "slide": 109,
                        "touch": 22,
                        "break": 19,
                        "total": 544
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11150,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2020-09-04"
                }
            ],
            "searchAcronyms": [
                "umy",
                "哆啦a梦",
                "多啦A梦",
                "米格玛",
                "美味棒"
            ]
        },
        {
            "songId": "ぼくたちいつでも　しゅわっしゅわ！",
            "category": "maimai",
            "title": "ぼくたちいつでも　しゅわっしゅわ！",
            "artist": "ヒゲドライバー feat.らいむっくま(CV:村川梨衣) ＆ れもんっくま(CV:MoeMi)",
            "bpm": 132,
            "imageName": "f6d45e999b4948e8f45e5f4e9761200face9fb1697dd5b0991ab83663215fe33",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 158,
                        "hold": 4,
                        "slide": 3,
                        "touch": 4,
                        "break": 5,
                        "total": 174
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11152,
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 21,
                        "slide": 9,
                        "touch": 26,
                        "break": 4,
                        "total": 300
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11152,
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 371,
                        "hold": 65,
                        "slide": 34,
                        "touch": 34,
                        "break": 49,
                        "total": 553
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11152,
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 510,
                        "hold": 52,
                        "slide": 67,
                        "touch": 123,
                        "break": 14,
                        "total": 766
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11152,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "いぬっくまとボコっくま",
                    "noteCounts": {
                        "tap": 647,
                        "hold": 15,
                        "slide": 82,
                        "touch": 12,
                        "break": 8,
                        "total": 764
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11152,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2022-09-08"
                }
            ],
            "searchAcronyms": [
                "splash主题曲",
                "丸山彩",
                "休哇休哇",
                "修哇",
                "修哇修哇",
                "咻哇",
                "咻哇咻哇",
                "彩黑",
                "柠檬熊",
                "雨刮器2"
            ]
        },
        {
            "songId": "Boys O’Clock",
            "category": "maimai",
            "title": "Boys O’Clock",
            "artist": "technoplanet",
            "bpm": 262,
            "imageName": "a60311057733e03de812c07dc1998e74a248ac655b6f4d2c27962650ac82a6f2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 139,
                        "hold": 13,
                        "slide": 4,
                        "touch": 13,
                        "break": 3,
                        "total": 172
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11153,
                    "multiverInternalLevelValue": {
                        "Splash": 5
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 36,
                        "slide": 11,
                        "touch": 30,
                        "break": 8,
                        "total": 303
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11153,
                    "multiverInternalLevelValue": {
                        "Splash": 7.7
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 317,
                        "hold": 78,
                        "slide": 29,
                        "touch": 55,
                        "break": 33,
                        "total": 512
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11153,
                    "multiverInternalLevelValue": {
                        "Splash": 10.8
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 580,
                        "hold": 22,
                        "slide": 16,
                        "touch": 168,
                        "break": 25,
                        "total": 811
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11153,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13.1,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2020-09-17"
                }
            ],
            "searchAcronyms": [
                "男同时刻",
                "男同时间",
                "男同时间到",
                "男孩时间"
            ]
        },
        {
            "songId": "居並ぶ穀物と溜息まじりの運送屋",
            "category": "maimai",
            "title": "居並ぶ穀物と溜息まじりの運送屋",
            "artist": "hanzo",
            "bpm": 160,
            "imageName": "466d1ce3cf0d6a2b682b14b943e8e45d910d03c5ab4a92664548e880766fee4a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 120,
                        "hold": 18,
                        "slide": 4,
                        "touch": 18,
                        "break": 5,
                        "total": 165
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11154,
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 299,
                        "hold": 36,
                        "slide": 10,
                        "touch": 41,
                        "break": 8,
                        "total": 394
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11154,
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 394,
                        "hold": 69,
                        "slide": 35,
                        "touch": 70,
                        "break": 22,
                        "total": 590
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11154,
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 697,
                        "hold": 70,
                        "slide": 123,
                        "touch": 26,
                        "break": 34,
                        "total": 950
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11154,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2020-09-17"
                }
            ],
            "searchAcronyms": [
                "勇敢勇敢我的朋友",
                "木雕2",
                "木雕鲶鱼2",
                "老汉拉车",
                "老汉推车",
                "老爷爷",
                "老登拉车",
                "运送屋",
                "进击的骆驼祥子"
            ]
        },
        {
            "songId": "ARAIS",
            "category": "maimai",
            "title": "ARAIS",
            "artist": "千本松 仁",
            "bpm": 180,
            "imageName": "58d17025b3ec3f7597c3938f24db34d4f0d6ef0c6ae8469d8e92938fcd1e5c2c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 156,
                        "hold": 28,
                        "slide": 6,
                        "touch": 8,
                        "break": 8,
                        "total": 206
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11155,
                    "multiverInternalLevelValue": {
                        "Splash": 5
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 374,
                        "hold": 23,
                        "slide": 15,
                        "touch": 15,
                        "break": 9,
                        "total": 436
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11155,
                    "multiverInternalLevelValue": {
                        "Splash": 8.8
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 475,
                        "hold": 83,
                        "slide": 30,
                        "touch": 14,
                        "break": 34,
                        "total": 636
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11155,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12,
                        "Splash": 12
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "Sukiyaki vs Happy",
                    "noteCounts": {
                        "tap": 851,
                        "hold": 14,
                        "slide": 59,
                        "touch": 54,
                        "break": 22,
                        "total": 1000
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11155,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.4,
                        "FESTiVAL PLUS": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "Splash": 14.3,
                        "Splash PLUS": 14.3,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.4
                    },
                    "releaseDate": "2020-09-17"
                }
            ],
            "searchAcronyms": [
                "阿赖斯",
                "鸟人",
                "鸟加鸟加"
            ]
        },
        {
            "songId": "マイオドレ！舞舞タイム",
            "category": "maimai",
            "title": "マイオドレ！舞舞タイム",
            "artist": "キノシタ feat. そらみこ (ホロライブ ときのそら＆さくらみこ)",
            "bpm": 183,
            "imageName": "06a7753fdbd27301899e0b1f1c9c51d83d91f38c8531312fa80ba0bef1b4b0dd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 131,
                        "hold": 18,
                        "slide": 4,
                        "touch": 23,
                        "break": 8,
                        "total": 184
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11156,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 38,
                        "slide": 14,
                        "touch": 22,
                        "break": 11,
                        "total": 370
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11156,
                    "multiverInternalLevelValue": {
                        "Splash": 7.8
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 386,
                        "hold": 49,
                        "slide": 51,
                        "touch": 37,
                        "break": 68,
                        "total": 591
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11156,
                    "multiverInternalLevelValue": {
                        "Splash": 11
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "ものくろっく",
                    "noteCounts": {
                        "tap": 498,
                        "hold": 45,
                        "slide": 148,
                        "touch": 29,
                        "break": 28,
                        "total": 748
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11156,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2020-09-17"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "宛城、炎上！！",
            "category": "オンゲキ＆CHUNITHM",
            "title": "宛城、炎上！！",
            "artist": "Cranky feat.おもしろ三国志",
            "bpm": 175,
            "imageName": "476f1cd7be3340627c28e835d7585f0919546ab83bf0e9c23adbc514c0685f8a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 13,
                        "slide": 7,
                        "touch": 12,
                        "break": 6,
                        "total": 261
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11175,
                    "multiverInternalLevelValue": {
                        "Splash": 5
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 347,
                        "hold": 30,
                        "slide": 18,
                        "touch": 31,
                        "break": 11,
                        "total": 437
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11175,
                    "multiverInternalLevelValue": {
                        "Splash": 8.8
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 477,
                        "hold": 81,
                        "slide": 42,
                        "touch": 25,
                        "break": 100,
                        "total": 725
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11175,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash": 12.5
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 762,
                        "hold": 138,
                        "slide": 51,
                        "touch": 272,
                        "break": 44,
                        "total": 1267
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11175,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 14,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2020-09-17"
                }
            ],
            "searchAcronyms": [
                "a9",
                "enjo",
                "enjo enjo",
                "enjou",
                "enjou enjou",
                "enjyo",
                "enjyo enjyo",
                "hold2miss",
                "大宇宙",
                "安卓",
                "安卓安卓",
                "宛城",
                "宛城炎上",
                "按脚",
                "摁jio",
                "摁脚",
                "曹操盖饭",
                "炎上",
                "皮炎平",
                "美团大战饿了么"
            ]
        },
        {
            "songId": "命に嫌われている",
            "category": "niconico＆ボーカロイド",
            "title": "命に嫌われている",
            "artist": "カンザキイオリ",
            "bpm": 200,
            "imageName": "a6ab9904b762e20e581c93159b82917b3873481ab9baca1adc1d77bec5e448aa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 6,
                        "slide": 5,
                        "touch": 7,
                        "break": 3,
                        "total": 149
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11185,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 20,
                        "slide": 8,
                        "touch": 8,
                        "break": 3,
                        "total": 312
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11185,
                    "multiverInternalLevelValue": {
                        "Splash": 7
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 414,
                        "hold": 80,
                        "slide": 47,
                        "touch": 34,
                        "break": 9,
                        "total": 584
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11185,
                    "multiverInternalLevelValue": {
                        "Splash": 10.2
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 696,
                        "hold": 24,
                        "slide": 135,
                        "touch": 13,
                        "break": 21,
                        "total": 889
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11185,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8
                    },
                    "releaseDate": "2020-09-17"
                }
            ],
            "searchAcronyms": [
                "Hated By Life Itself",
                "命嫌",
                "嫌命长",
                "被生命厌恶",
                "被生命所厌恶",
                "被生命所厌恶着",
                "这你他妈都不急"
            ]
        },
        {
            "songId": "アンクローズ・ヒューマン",
            "category": "niconico＆ボーカロイド",
            "title": "アンクローズ・ヒューマン",
            "artist": "作曲：カジャ　作詞：傘村トータ　編曲：ねじ式　調声：シリア",
            "bpm": 178,
            "imageName": "4b22d5de7d4c6de28cdf618ff4d2c801f6f6574585b385b991b33720150cf15d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 144,
                        "hold": 9,
                        "slide": 5,
                        "touch": 16,
                        "break": 5,
                        "total": 179
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11186,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 299,
                        "hold": 12,
                        "slide": 8,
                        "touch": 15,
                        "break": 2,
                        "total": 336
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11186,
                    "multiverInternalLevelValue": {
                        "Splash": 7.2
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 484,
                        "hold": 68,
                        "slide": 34,
                        "touch": 45,
                        "break": 2,
                        "total": 633
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11186,
                    "multiverInternalLevelValue": {
                        "Splash": 9.8
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Safata.Hz",
                    "noteCounts": {
                        "tap": 635,
                        "hold": 52,
                        "slide": 151,
                        "touch": 25,
                        "break": 34,
                        "total": 897
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11186,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 13.1,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2020-09-17"
                }
            ],
            "searchAcronyms": [
                "daybayday",
                "unclose human",
                "unclosed human",
                "Unclosed Human",
                "unclosehuman",
                "敬爱",
                "玻璃心"
            ]
        },
        {
            "songId": "乙女解剖",
            "category": "niconico＆ボーカロイド",
            "title": "乙女解剖",
            "artist": "DECO*27",
            "bpm": 134,
            "imageName": "488eefd31cbcdc42643b9ed8044e70f7eecbffd002d9cf37ceb37945375cbc38",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 94,
                        "hold": 17,
                        "slide": 3,
                        "touch": 13,
                        "break": 8,
                        "total": 135
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11187,
                    "multiverInternalLevelValue": {
                        "Splash": 3
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 193,
                        "hold": 22,
                        "slide": 6,
                        "touch": 34,
                        "break": 4,
                        "total": 259
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11187,
                    "multiverInternalLevelValue": {
                        "Splash": 6.5
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 265,
                        "hold": 57,
                        "slide": 40,
                        "touch": 18,
                        "break": 8,
                        "total": 388
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11187,
                    "multiverInternalLevelValue": {
                        "Splash": 8.8
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 436,
                        "hold": 69,
                        "slide": 69,
                        "touch": 53,
                        "break": 26,
                        "total": 653
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11187,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2020-09-17"
                }
            ],
            "searchAcronyms": [
                "Maiden Dissection",
                "Otome Dissection",
                "Otome Kaibou",
                "乙女",
                "乙女姐婆",
                "紫璃",
                "解剖"
            ]
        },
        {
            "songId": "悪戯センセーション",
            "category": "東方Project",
            "title": "悪戯センセーション",
            "artist": "森羅万象",
            "bpm": 192,
            "imageName": "66619c6142c923312d04833b32eceafd087d019792611725c26c81129902ecc1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 161,
                        "hold": 4,
                        "slide": 2,
                        "touch": 8,
                        "break": 4,
                        "total": 179
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11199,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 19,
                        "slide": 9,
                        "touch": 13,
                        "break": 4,
                        "total": 279
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11199,
                    "multiverInternalLevelValue": {
                        "Splash": 7.7
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 72,
                        "slide": 24,
                        "touch": 30,
                        "break": 10,
                        "total": 409
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11199,
                    "multiverInternalLevelValue": {
                        "Splash": 9.8
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "ものくろっく",
                    "noteCounts": {
                        "tap": 443,
                        "hold": 40,
                        "slide": 95,
                        "touch": 30,
                        "break": 26,
                        "total": 634
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11199,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2020-09-17"
                }
            ],
            "searchAcronyms": [
                "Mischievous Sensation",
                "二小姐",
                "大妹",
                "大小姐",
                "恶戏",
                "恶戏Sensation",
                "淘气感觉"
            ]
        },
        {
            "songId": "BATTLE NO.1",
            "category": "ゲーム＆バラエティ",
            "title": "BATTLE NO.1",
            "artist": "TANO*C Sound Team",
            "bpm": 200,
            "imageName": "a413d7183f0df7df05c23d504baf27adf67fc0f4b53620093d1ef0973f9738f9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 243,
                        "hold": 18,
                        "slide": 5,
                        "touch": 18,
                        "break": 3,
                        "total": 287
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11206,
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 343,
                        "hold": 38,
                        "slide": 16,
                        "touch": 14,
                        "break": 15,
                        "total": 426
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11206,
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 497,
                        "hold": 71,
                        "slide": 51,
                        "touch": 74,
                        "break": 53,
                        "total": 746
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11206,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "FESTiVAL PLUS": 12.2,
                        "PRiSM PLUS": 12.2
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "ゲキ*チュウマイ Fumen Team",
                    "noteCounts": {
                        "tap": 762,
                        "hold": 65,
                        "slide": 103,
                        "touch": 134,
                        "break": 136,
                        "total": 1200
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11206,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "Splash PLUS": 14.4,
                        "UNiVERSE": 14.4,
                        "UNiVERSE PLUS": 14.4
                    },
                    "releaseDate": "2020-09-17"
                }
            ],
            "searchAcronyms": [
                "1",
                "13p",
                "14个老公",
                "bn1",
                "tanoc",
                "一战",
                "好多人",
                "干架第一名",
                "战地1",
                "战地一",
                "战斗，爽！",
                "战斗爽",
                "战犯合影",
                "打架第一",
                "打架第一名",
                "打胶第一名",
                "按摩",
                "第一名",
                "第一战",
                "缝合怪"
            ]
        },
        {
            "songId": "Jörqer",
            "category": "maimai",
            "title": "Jörqer",
            "artist": "owl＊tree feat.yu＊tree",
            "bpm": 98,
            "imageName": "d28d3947afff524fe34d403458d95a9fe77ffeee09923a636d98418f1018d532",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 11,
                        "slide": 3,
                        "touch": 12,
                        "break": 3,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11214,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 38,
                        "slide": 8,
                        "touch": 30,
                        "break": 6,
                        "total": 313
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11214,
                    "multiverInternalLevelValue": {
                        "Splash": 7
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 449,
                        "hold": 75,
                        "slide": 24,
                        "touch": 42,
                        "break": 19,
                        "total": 609
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11214,
                    "multiverInternalLevelValue": {
                        "Splash": 11.8
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 616,
                        "hold": 27,
                        "slide": 63,
                        "touch": 75,
                        "break": 22,
                        "total": 803
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11214,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.5
                    },
                    "releaseDate": "2020-09-17"
                }
            ],
            "searchAcronyms": [
                "joker",
                "jorqer",
                "Jorqer",
                "pvq",
                "qer",
                "别急1.5",
                "周可儿",
                "小金熊",
                "猫头鹰"
            ]
        },
        {
            "songId": "Sqlupp (Camellia's \"Sqleipd*Hiytex\" Remix)",
            "category": "maimai",
            "title": "Sqlupp (Camellia's \"Sqleipd*Hiytex\" Remix)",
            "artist": "owl＊tree Remixed by Camellia",
            "bpm": 154,
            "imageName": "2fd726ca3fa377be50907588ac592eac6fc1f0b8a300915de78e013046c7f2ac",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 33,
                        "slide": 7,
                        "touch": 18,
                        "break": 7,
                        "total": 234
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11215,
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 334,
                        "hold": 35,
                        "slide": 28,
                        "touch": 22,
                        "break": 10,
                        "total": 429
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11215,
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 527,
                        "hold": 129,
                        "slide": 43,
                        "touch": 45,
                        "break": 54,
                        "total": 798
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11215,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.2,
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "FESTiVAL": 12.2,
                        "PRiSM PLUS": 12.2
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 844,
                        "hold": 68,
                        "slide": 68,
                        "touch": 107,
                        "break": 114,
                        "total": 1201
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11215,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "Splash PLUS": 14.5,
                        "UNiVERSE": 14.5,
                        "UNiVERSE PLUS": 14.5
                    },
                    "releaseDate": "2020-09-17"
                }
            ],
            "searchAcronyms": [
                "sqlupp",
                "失去了屁屁",
                "孽蜥",
                "手速疯批",
                "色情撸屁屁",
                "色情露屁屁"
            ]
        },
        {
            "songId": "felys -final remix-",
            "category": "ゲーム＆バラエティ",
            "title": "felys -final remix-",
            "artist": "onoken",
            "bpm": 180,
            "imageName": "9c1f149b62ab6a5313a413b0e97132b04b5507d244ba6c5fd94fe3dc8f41a281",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 163,
                        "hold": 10,
                        "slide": 7,
                        "touch": 8,
                        "break": 2,
                        "total": 190
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11216,
                    "multiverInternalLevelValue": {
                        "Splash": 3
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 45,
                        "slide": 12,
                        "touch": 24,
                        "break": 7,
                        "total": 345
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11216,
                    "multiverInternalLevelValue": {
                        "Splash": 7.7
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 432,
                        "hold": 57,
                        "slide": 62,
                        "touch": 38,
                        "break": 9,
                        "total": 598
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11216,
                    "multiverInternalLevelValue": {
                        "Splash": 10.7
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 925,
                        "hold": 33,
                        "slide": 117,
                        "touch": 23,
                        "break": 13,
                        "total": 1111
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11216,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.3,
                        "FESTiVAL PLUS": 14.3,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "Splash": 14.4,
                        "Splash PLUS": 14.3,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.3
                    },
                    "releaseDate": "2020-09-17"
                }
            ],
            "searchAcronyms": [
                "fely",
                "felys",
                "凤梨酥",
                "开花歌",
                "菲利斯",
                "非礼死",
                "飞叶子",
                "飞雷神"
            ]
        },
        {
            "songId": "絶え間なく藍色",
            "category": "niconico＆ボーカロイド",
            "title": "絶え間なく藍色",
            "artist": "獅子志司",
            "bpm": 125,
            "imageName": "a373ff59ac6cbfe60f50f37ecb90d2b60adc90b8c6c3036f90ff888fde5fb369",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 78,
                        "hold": 11,
                        "slide": 5,
                        "touch": 12,
                        "break": 4,
                        "total": 110
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11188,
                    "multiverInternalLevelValue": {
                        "Splash": 3
                    },
                    "releaseDate": "2020-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 21,
                        "slide": 16,
                        "touch": 14,
                        "break": 3,
                        "total": 240
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11188,
                    "multiverInternalLevelValue": {
                        "Splash": 6.2
                    },
                    "releaseDate": "2020-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 56,
                        "slide": 15,
                        "touch": 31,
                        "break": 6,
                        "total": 371
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11188,
                    "multiverInternalLevelValue": {
                        "Splash": 8.5
                    },
                    "releaseDate": "2020-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 447,
                        "hold": 46,
                        "slide": 109,
                        "touch": 35,
                        "break": 9,
                        "total": 646
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11188,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2020-10-01"
                }
            ],
            "searchAcronyms": [
                "无尽之蓝",
                "无尽的蓝色",
                "无尽蓝色",
                "绝绝子蓝色",
                "绝蓝",
                "绝间蓝",
                "绝间蓝色",
                "蓝色"
            ]
        },
        {
            "songId": "ガランド",
            "category": "niconico＆ボーカロイド",
            "title": "ガランド",
            "artist": "ピコン",
            "bpm": 93,
            "imageName": "0ce7707f096e9e24c0d2642ae292a43554bfa57d9e521502a5e478677d6cd1c5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 99,
                        "hold": 5,
                        "slide": 3,
                        "touch": 17,
                        "break": 4,
                        "total": 128
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11189,
                    "multiverInternalLevelValue": {
                        "Splash": 2
                    },
                    "releaseDate": "2020-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 10,
                        "slide": 21,
                        "touch": 23,
                        "break": 4,
                        "total": 252
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11189,
                    "multiverInternalLevelValue": {
                        "Splash": 7
                    },
                    "releaseDate": "2020-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 50,
                        "slide": 6,
                        "touch": 63,
                        "break": 8,
                        "total": 377
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11189,
                    "multiverInternalLevelValue": {
                        "Splash": 9.9
                    },
                    "releaseDate": "2020-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 439,
                        "hold": 9,
                        "slide": 80,
                        "touch": 92,
                        "break": 5,
                        "total": 625
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11189,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9
                    },
                    "releaseDate": "2020-10-01"
                }
            ],
            "searchAcronyms": [
                "airhead",
                "garando",
                "别急3.5",
                "噬菌体",
                "摸你摸你",
                "易拉罐",
                "空气头",
                "罐头章鱼",
                "触手",
                "黑色树枝"
            ]
        },
        {
            "songId": "とりあえずアナタがいなくなるまえに",
            "category": "niconico＆ボーカロイド",
            "title": "とりあえずアナタがいなくなるまえに",
            "artist": "作詞作曲：椎名もた　編曲：KTG　映像：Yuma Saito",
            "bpm": 140,
            "imageName": "72cd8908e91b0d9a98c5e6329906f37efd5ffd65def5d8e1c58c148340302664",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 130,
                        "hold": 5,
                        "slide": 7,
                        "touch": 6,
                        "break": 3,
                        "total": 151
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11190,
                    "multiverInternalLevelValue": {
                        "Splash": 3
                    },
                    "releaseDate": "2020-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 10,
                        "slide": 8,
                        "touch": 11,
                        "break": 8,
                        "total": 237
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11190,
                    "multiverInternalLevelValue": {
                        "Splash": 6
                    },
                    "releaseDate": "2020-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 37,
                        "slide": 18,
                        "touch": 23,
                        "break": 24,
                        "total": 339
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11190,
                    "multiverInternalLevelValue": {
                        "Splash": 8.8
                    },
                    "releaseDate": "2020-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 386,
                        "hold": 32,
                        "slide": 84,
                        "touch": 36,
                        "break": 8,
                        "total": 546
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11190,
                    "multiverInternalLevelValue": {
                        "Splash": 11.9
                    },
                    "releaseDate": "2020-10-01"
                }
            ],
            "searchAcronyms": [
                "📺",
                "小电视",
                "总之在你消逝之前",
                "电视",
                "电视机"
            ]
        },
        {
            "songId": "明星ギャラクティカ",
            "category": "niconico＆ボーカロイド",
            "title": "明星ギャラクティカ",
            "artist": "ナユタン星人",
            "bpm": 154,
            "imageName": "e6f5cbcc433f532d56246d19c0217b6da9428e8625723acd152a8733491c956c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 14,
                        "slide": 8,
                        "touch": 9,
                        "break": 3,
                        "total": 203
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11191,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2020-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 18,
                        "slide": 16,
                        "touch": 9,
                        "break": 4,
                        "total": 259
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11191,
                    "multiverInternalLevelValue": {
                        "Splash": 6.5
                    },
                    "releaseDate": "2020-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 389,
                        "hold": 54,
                        "slide": 15,
                        "touch": 28,
                        "break": 12,
                        "total": 498
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11191,
                    "multiverInternalLevelValue": {
                        "Splash": 8.7
                    },
                    "releaseDate": "2020-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 409,
                        "hold": 139,
                        "slide": 48,
                        "touch": 79,
                        "break": 45,
                        "total": 720
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11191,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL": 12.4,
                        "PRiSM PLUS": 12.4,
                        "Splash": 12.4,
                        "UNiVERSE PLUS": 12.4
                    },
                    "releaseDate": "2020-10-01"
                }
            ],
            "searchAcronyms": [
                "丢人银河号",
                "方向盘",
                "明星",
                "明星卡拉狄加",
                "明星银河号",
                "超级方向盘",
                "银河号"
            ]
        },
        {
            "songId": "≠彡\"/了→",
            "category": "maimai",
            "title": "≠彡\"/了→",
            "artist": "水野健治",
            "bpm": 222,
            "imageName": "2cd36cab260aae1c5fdb71b054e92a99ecdb8c1e083bd4a0ea66632145ec6177",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 15,
                        "slide": 4,
                        "touch": 12,
                        "break": 4,
                        "total": 262
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11221,
                    "multiverInternalLevelValue": {
                        "Splash": 6
                    },
                    "releaseDate": "2020-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 403,
                        "hold": 60,
                        "slide": 16,
                        "touch": 18,
                        "break": 18,
                        "total": 515
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11221,
                    "multiverInternalLevelValue": {
                        "Splash": 9
                    },
                    "releaseDate": "2020-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 543,
                        "hold": 93,
                        "slide": 43,
                        "touch": 27,
                        "break": 14,
                        "total": 720
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11221,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7
                    },
                    "releaseDate": "2020-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "ﾚよ†ょ／∪ヽ”┠  (十,3､了ﾅﾆ",
                    "noteCounts": {
                        "tap": 779,
                        "hold": 44,
                        "slide": 71,
                        "touch": 117,
                        "break": 100,
                        "total": 1111
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11221,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.4,
                        "FESTiVAL PLUS": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "Splash": 14.4,
                        "Splash PLUS": 14.3,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.4
                    },
                    "releaseDate": "2020-10-01"
                }
            ],
            "searchAcronyms": [
                "→",
                "≠",
                "kimitour",
                "Kimitour",
                "Kimitsua",
                "キミツアー",
                "不等于三撇双引号斜杠了右箭头",
                "你爹来了",
                "你爹来了→",
                "你爹来咯",
                "你爹来喽",
                "你的旅行",
                "太空熊",
                "机密a",
                "机密A",
                "水熊",
                "火箭熊",
                "爹",
                "绝赞天堂",
                "绝赞来了",
                "绝赞来咯",
                "绝赞熊"
            ]
        },
        {
            "songId": "Aetheric Energy",
            "category": "maimai",
            "title": "Aetheric Energy",
            "artist": "aran",
            "bpm": 205,
            "imageName": "d08b65adbb5d2ee01fbe2783eb6bd532e791724d742da215412700d8ce6d5e01",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 133,
                        "hold": 7,
                        "slide": 4,
                        "touch": 18,
                        "break": 7,
                        "total": 169
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11157,
                    "multiverInternalLevelValue": {
                        "Splash": 5
                    },
                    "releaseDate": "2020-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 42,
                        "slide": 4,
                        "touch": 33,
                        "break": 8,
                        "total": 343
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11157,
                    "multiverInternalLevelValue": {
                        "Splash": 7.8
                    },
                    "releaseDate": "2020-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 371,
                        "hold": 35,
                        "slide": 41,
                        "touch": 43,
                        "break": 15,
                        "total": 505
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11157,
                    "multiverInternalLevelValue": {
                        "Splash": 11
                    },
                    "releaseDate": "2020-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 478,
                        "hold": 37,
                        "slide": 72,
                        "touch": 98,
                        "break": 46,
                        "total": 731
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11157,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.1
                    },
                    "releaseDate": "2020-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 617,
                        "hold": 54,
                        "slide": 96,
                        "touch": 17,
                        "break": 40,
                        "total": 824
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1
                    },
                    "releaseDate": "2025-11-19"
                }
            ],
            "searchAcronyms": [
                "❤",
                "ae",
                "以太能量",
                "应用工程"
            ]
        },
        {
            "songId": "Komplexe",
            "category": "maimai",
            "title": "Komplexe",
            "artist": "雄之助 feat. Sennzai",
            "bpm": 165,
            "imageName": "48e2ddff4d37ff56ee0d4d5a5ab9a93423c59cbfe69a4d71b3e884b8e1416518",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 10,
                        "slide": 3,
                        "touch": 17,
                        "break": 2,
                        "total": 137
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11158,
                    "multiverInternalLevelValue": {
                        "Splash": 3
                    },
                    "releaseDate": "2020-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 147,
                        "hold": 48,
                        "slide": 17,
                        "touch": 19,
                        "break": 2,
                        "total": 233
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11158,
                    "multiverInternalLevelValue": {
                        "Splash": 7.7
                    },
                    "releaseDate": "2020-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 317,
                        "hold": 46,
                        "slide": 48,
                        "touch": 8,
                        "break": 29,
                        "total": 448
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11158,
                    "multiverInternalLevelValue": {
                        "Splash": 11
                    },
                    "releaseDate": "2020-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 596,
                        "hold": 95,
                        "slide": 63,
                        "touch": 39,
                        "break": 19,
                        "total": 812
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11158,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2020-10-16"
                }
            ],
            "searchAcronyms": [
                "complex",
                "你要结婚了",
                "大黑姬",
                "雄氏老方",
                "黑姬",
                "黑姬唱歌"
            ]
        },
        {
            "songId": "Beautiful Future",
            "category": "maimai",
            "title": "Beautiful Future",
            "artist": "PSYQUI",
            "bpm": 172,
            "imageName": "017876244b1ac73da25bc95d5b98da617b1d95ab08f0aa3a9bb8cb93ea390998",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 9,
                        "slide": 2,
                        "touch": 6,
                        "break": 7,
                        "total": 181
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11159,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2020-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 309,
                        "hold": 33,
                        "slide": 4,
                        "touch": 33,
                        "break": 6,
                        "total": 385
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11159,
                    "multiverInternalLevelValue": {
                        "Splash": 8
                    },
                    "releaseDate": "2020-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 77,
                        "slide": 42,
                        "touch": 82,
                        "break": 6,
                        "total": 474
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11159,
                    "multiverInternalLevelValue": {
                        "Splash": 10.8
                    },
                    "releaseDate": "2020-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 601,
                        "hold": 94,
                        "slide": 76,
                        "touch": 33,
                        "break": 29,
                        "total": 833
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11159,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.8,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2020-10-16"
                }
            ],
            "searchAcronyms": [
                "大好前程",
                "无一物啊啊",
                "美丽未来",
                "美味",
                "美好未来",
                "雷炎"
            ]
        },
        {
            "songId": "Mutation",
            "category": "maimai",
            "title": "Mutation",
            "artist": "Laur",
            "bpm": 155,
            "imageName": "00f50800efab0d383829b34b46ae7e4f59942e4f6f54dadbfa8e2e0e6d67452b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 198,
                        "hold": 5,
                        "slide": 3,
                        "touch": 6,
                        "break": 9,
                        "total": 221
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11160,
                    "multiverInternalLevelValue": {
                        "Splash": 5
                    },
                    "releaseDate": "2020-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 289,
                        "hold": 29,
                        "slide": 9,
                        "touch": 35,
                        "break": 13,
                        "total": 375
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11160,
                    "multiverInternalLevelValue": {
                        "Splash": 8.5
                    },
                    "releaseDate": "2020-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 488,
                        "hold": 57,
                        "slide": 32,
                        "touch": 43,
                        "break": 27,
                        "total": 647
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11160,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2020-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 713,
                        "hold": 130,
                        "slide": 47,
                        "touch": 81,
                        "break": 20,
                        "total": 991
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11160,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 14,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash": 14.4,
                        "Splash PLUS": 14,
                        "UNiVERSE": 14,
                        "UNiVERSE PLUS": 14
                    },
                    "releaseDate": "2020-10-16"
                }
            ],
            "searchAcronyms": [
                "仁王",
                "变异",
                "变种",
                "木糖醇",
                "突变"
            ]
        },
        {
            "songId": "お願いマッスル",
            "category": "POPS＆アニメ",
            "title": "お願いマッスル",
            "artist": "紗倉ひびき（CV:ファイルーズあい）＆街雄鳴造（CV:石川界人）",
            "bpm": 132,
            "imageName": "2248ef8006870bdee6a9d26b58df224e4cdc691eedcf89b5d3d5988c10071270",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 95,
                        "hold": 3,
                        "slide": 2,
                        "touch": 6,
                        "break": 10,
                        "total": 116
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11183,
                    "multiverInternalLevelValue": {
                        "Splash": 3
                    },
                    "releaseDate": "2020-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 150,
                        "hold": 18,
                        "slide": 2,
                        "touch": 13,
                        "break": 4,
                        "total": 187
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11183,
                    "multiverInternalLevelValue": {
                        "Splash": 6
                    },
                    "releaseDate": "2020-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 13,
                        "slide": 19,
                        "touch": 76,
                        "break": 20,
                        "total": 362
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11183,
                    "multiverInternalLevelValue": {
                        "Splash": 8.9
                    },
                    "releaseDate": "2020-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 289,
                        "hold": 47,
                        "slide": 96,
                        "touch": 28,
                        "break": 50,
                        "total": 510
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11183,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "BUDDiES PLUS": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2020-10-30"
                }
            ],
            "searchAcronyms": [
                "Onegai Muscle"
            ]
        },
        {
            "songId": "絶対にチョコミントを食べるアオイチャン",
            "category": "niconico＆ボーカロイド",
            "title": "絶対にチョコミントを食べるアオイチャン",
            "artist": "GYARI",
            "bpm": 140,
            "imageName": "bcc1c34ffd46781f7594c6c7ed1ddfb06e945d7204d6a40961924e11dc474dfb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 80,
                        "hold": 13,
                        "slide": 8,
                        "touch": 25,
                        "break": 3,
                        "total": 129
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11192,
                    "multiverInternalLevelValue": {
                        "Splash": 3
                    },
                    "releaseDate": "2020-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 9,
                        "slide": 29,
                        "touch": 12,
                        "break": 12,
                        "total": 234
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11192,
                    "multiverInternalLevelValue": {
                        "Splash": 6.8
                    },
                    "releaseDate": "2020-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 70,
                        "slide": 24,
                        "touch": 12,
                        "break": 37,
                        "total": 481
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11192,
                    "multiverInternalLevelValue": {
                        "Splash": 9.8
                    },
                    "releaseDate": "2020-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 428,
                        "hold": 64,
                        "slide": 70,
                        "touch": 106,
                        "break": 44,
                        "total": 712
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11192,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2020-10-30"
                }
            ],
            "searchAcronyms": [
                "Aoi",
                "Aoi chan",
                "chocomint",
                "chocomint ice",
                "Mint choco",
                "冰淇凌",
                "冰淇淋",
                "巧克力冰淇淋",
                "必须要吃薄荷巧克力味冰淇淋的琴叶葵酱",
                "绝对",
                "绝对食",
                "薄荷巧克力冰淇淋"
            ]
        },
        {
            "songId": "デリヘル呼んだら君が来た",
            "category": "niconico＆ボーカロイド",
            "title": "デリヘル呼んだら君が来た",
            "artist": "ナナホシ管弦楽団",
            "bpm": 190,
            "imageName": "e2702fe9f78fe235f75cde50101ccbc4c45637ad0d5ac32231b7b02ec0b04cac",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 115,
                        "hold": 19,
                        "slide": 1,
                        "touch": 16,
                        "break": 7,
                        "total": 158
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11193,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2020-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 22,
                        "slide": 26,
                        "touch": 14,
                        "break": 6,
                        "total": 352
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11193,
                    "multiverInternalLevelValue": {
                        "Splash": 7.2
                    },
                    "releaseDate": "2020-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 452,
                        "hold": 75,
                        "slide": 60,
                        "touch": 36,
                        "break": 18,
                        "total": 641
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11193,
                    "multiverInternalLevelValue": {
                        "Splash": 10.5
                    },
                    "releaseDate": "2020-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 740,
                        "hold": 31,
                        "slide": 115,
                        "touch": 71,
                        "break": 39,
                        "total": 996
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11193,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.1,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2020-10-30"
                }
            ],
            "searchAcronyms": [
                "Deriheru",
                "Deriheru Yondara Kimi ga Kita",
                "When I Arranged For A Call Girl, You Appeared",
                "卡姿兰大眼睛",
                "叫了应召女郎结果来的是你",
                "呼君来",
                "粉毛"
            ]
        },
        {
            "songId": "シアトリカル・ケース",
            "category": "maimai",
            "title": "シアトリカル・ケース",
            "artist": "ユリイ・カノン feat.ウォルピスカーター&まひる",
            "bpm": 150,
            "imageName": "3e16e115174ca2e04bc72e7e65eab38ada2ab2e00c37fedba20ce27097512773",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 182,
                        "hold": 11,
                        "slide": 4,
                        "touch": 16,
                        "break": 11,
                        "total": 224
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11168,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2020-11-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 339,
                        "hold": 25,
                        "slide": 4,
                        "touch": 37,
                        "break": 8,
                        "total": 413
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11168,
                    "multiverInternalLevelValue": {
                        "Splash": 7.7
                    },
                    "releaseDate": "2020-11-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 437,
                        "hold": 90,
                        "slide": 38,
                        "touch": 27,
                        "break": 23,
                        "total": 615
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11168,
                    "multiverInternalLevelValue": {
                        "Splash": 10.8
                    },
                    "releaseDate": "2020-11-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 727,
                        "hold": 74,
                        "slide": 36,
                        "touch": 73,
                        "break": 51,
                        "total": 961
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11168,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7
                    },
                    "releaseDate": "2020-11-13"
                }
            ],
            "searchAcronyms": [
                "case",
                "tc",
                "theatrical・case",
                "侦探跳火车",
                "戏剧性案件",
                "言叶3",
                "黑玫瑰3"
            ]
        },
        {
            "songId": "c.s.q.n.",
            "category": "ゲーム＆バラエティ",
            "title": "c.s.q.n.",
            "artist": "Aoi",
            "bpm": 174,
            "imageName": "adf680c009d389a0415c97adf14149e1b989110de0a34bcdba4a6d5201613cf0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 134,
                        "hold": 26,
                        "slide": 8,
                        "touch": 6,
                        "break": 5,
                        "total": 179
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11210,
                    "multiverInternalLevelValue": {
                        "Splash": 5
                    },
                    "releaseDate": "2020-11-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 29,
                        "slide": 11,
                        "touch": 17,
                        "break": 5,
                        "total": 285
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11210,
                    "multiverInternalLevelValue": {
                        "Splash": 7.8
                    },
                    "releaseDate": "2020-11-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 396,
                        "hold": 30,
                        "slide": 28,
                        "touch": 32,
                        "break": 21,
                        "total": 507
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11210,
                    "multiverInternalLevelValue": {
                        "Splash": 11.2
                    },
                    "releaseDate": "2020-11-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "七味星人",
                    "noteCounts": {
                        "tap": 500,
                        "hold": 174,
                        "slide": 71,
                        "touch": 81,
                        "break": 26,
                        "total": 852
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11210,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2020-11-13"
                }
            ],
            "searchAcronyms": [
                "😐",
                "😑",
                "csdn",
                "csgo",
                "csqn",
                "nahc2o4",
                "NaHC2O4",
                "冲上去鸟",
                "出生青年",
                "厕所七年",
                "厕所青年",
                "吃屎去哪",
                "城市青年",
                "撤硕缺你",
                "操死亲娘",
                "测试亲娘",
                "碳酸氢钠",
                "老八",
                "草酸氢纳",
                "草酸氢钠",
                "超市倩女",
                "超市琴娘"
            ]
        },
        {
            "songId": "カラッポ・ノンフィクション",
            "category": "ゲーム＆バラエティ",
            "title": "カラッポ・ノンフィクション",
            "artist": "Ino(chronoize) feat. 柳瀬マサキ",
            "bpm": 170,
            "imageName": "daebaac4cc44a0896477e55cc9d2206f25a97d82295e92fff4208edfbde07b37",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 102,
                        "hold": 16,
                        "slide": 10,
                        "touch": 16,
                        "break": 2,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11211,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2020-11-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 170,
                        "hold": 34,
                        "slide": 13,
                        "touch": 21,
                        "break": 2,
                        "total": 240
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11211,
                    "multiverInternalLevelValue": {
                        "Splash": 7.5
                    },
                    "releaseDate": "2020-11-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 236,
                        "hold": 109,
                        "slide": 27,
                        "touch": 19,
                        "break": 11,
                        "total": 402
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11211,
                    "multiverInternalLevelValue": {
                        "Splash": 10
                    },
                    "releaseDate": "2020-11-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 631,
                        "hold": 46,
                        "slide": 96,
                        "touch": 46,
                        "break": 8,
                        "total": 827
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11211,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.2,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.3
                    },
                    "releaseDate": "2020-11-13"
                }
            ],
            "searchAcronyms": [
                "Karappo Nonfiction",
                "创世纪",
                "彩色纪实文学"
            ]
        },
        {
            "songId": "emomomo",
            "category": "ゲーム＆バラエティ",
            "title": "emomomo",
            "artist": "Ras",
            "bpm": 145,
            "imageName": "4a25666ad11f25f9928e7f1de0947105e4500a283e6cfe05a0070ea9892fd1ee",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 11,
                        "slide": 10,
                        "touch": 8,
                        "break": 4,
                        "total": 171
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11212,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2020-11-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 38,
                        "slide": 5,
                        "touch": 18,
                        "break": 6,
                        "total": 270
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11212,
                    "multiverInternalLevelValue": {
                        "Splash": 7.5
                    },
                    "releaseDate": "2020-11-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 348,
                        "hold": 36,
                        "slide": 64,
                        "touch": 33,
                        "break": 16,
                        "total": 497
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11212,
                    "multiverInternalLevelValue": {
                        "Splash": 10.7
                    },
                    "releaseDate": "2020-11-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 631,
                        "hold": 34,
                        "slide": 61,
                        "touch": 133,
                        "break": 11,
                        "total": 870
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11212,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2020-11-13"
                }
            ],
            "searchAcronyms": [
                "🤔",
                "e3mo",
                "emo",
                "恶魔摸摸",
                "网易云"
            ]
        },
        {
            "songId": "レーイレーイ",
            "category": "オンゲキ＆CHUNITHM",
            "title": "レーイレーイ",
            "artist": "かいりきベア feat.松下",
            "bpm": 188,
            "imageName": "6ee866148f7807e1b3fc7ae7089d8db121ee624bf64699e7aedef0f44a867ef0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 24,
                        "slide": 2,
                        "touch": 18,
                        "break": 3,
                        "total": 182
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11177,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2020-11-27"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 302,
                        "hold": 28,
                        "slide": 21,
                        "touch": 18,
                        "break": 12,
                        "total": 381
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11177,
                    "multiverInternalLevelValue": {
                        "Splash": 7.8
                    },
                    "releaseDate": "2020-11-27"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 447,
                        "hold": 47,
                        "slide": 48,
                        "touch": 23,
                        "break": 62,
                        "total": 627
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11177,
                    "multiverInternalLevelValue": {
                        "Splash": 10.5
                    },
                    "releaseDate": "2020-11-27"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 594,
                        "hold": 97,
                        "slide": 114,
                        "touch": 52,
                        "break": 21,
                        "total": 878
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11177,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2020-11-27"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 698,
                        "hold": 32,
                        "slide": 126,
                        "touch": 87,
                        "break": 56,
                        "total": 999
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11177,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-11-23"
                }
            ],
            "searchAcronyms": [
                "re-i re-i",
                "抓鬼",
                "潇洒哥和黑大帅"
            ]
        },
        {
            "songId": "ベノム",
            "category": "niconico＆ボーカロイド",
            "title": "ベノム",
            "artist": "かいりきベア feat.flower",
            "bpm": 152,
            "imageName": "c14ca100645872bc75806fe85a489989d90a3a388469f395f384e31ecca557be",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 124,
                        "hold": 12,
                        "slide": 6,
                        "touch": 8,
                        "break": 9,
                        "total": 159
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11194,
                    "multiverInternalLevelValue": {
                        "Splash": 3
                    },
                    "releaseDate": "2020-11-27"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 24,
                        "slide": 6,
                        "touch": 12,
                        "break": 7,
                        "total": 336
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11194,
                    "multiverInternalLevelValue": {
                        "Splash": 6.5
                    },
                    "releaseDate": "2020-11-27"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 386,
                        "hold": 80,
                        "slide": 34,
                        "touch": 53,
                        "break": 8,
                        "total": 561
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11194,
                    "multiverInternalLevelValue": {
                        "Splash": 9
                    },
                    "releaseDate": "2020-11-27"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 633,
                        "hold": 34,
                        "slide": 87,
                        "touch": 35,
                        "break": 44,
                        "total": 833
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11194,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash": 12.4
                    },
                    "releaseDate": "2020-11-27"
                }
            ],
            "searchAcronyms": [
                "🙅",
                "venom",
                "Venom",
                "朱云杰",
                "朱总",
                "猛毒",
                "达咩"
            ]
        },
        {
            "songId": "マネマネサイコトロピック",
            "category": "niconico＆ボーカロイド",
            "title": "マネマネサイコトロピック",
            "artist": "かいりきベア feat.GUMI",
            "bpm": 210,
            "imageName": "dabd6275d4e2d1692d3f8d00566020e34b1e1fc51c79c6fc066f80b8949cb1b9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 120,
                        "hold": 25,
                        "slide": 4,
                        "touch": 4,
                        "break": 3,
                        "total": 156
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11195,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2020-11-27"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 29,
                        "slide": 16,
                        "touch": 8,
                        "break": 6,
                        "total": 346
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11195,
                    "multiverInternalLevelValue": {
                        "Splash": 7.2
                    },
                    "releaseDate": "2020-11-27"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 460,
                        "hold": 35,
                        "slide": 27,
                        "touch": 38,
                        "break": 14,
                        "total": 574
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11195,
                    "multiverInternalLevelValue": {
                        "Splash": 10.7
                    },
                    "releaseDate": "2020-11-27"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 575,
                        "hold": 29,
                        "slide": 143,
                        "touch": 38,
                        "break": 58,
                        "total": 843
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11195,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.2,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2020-11-27"
                }
            ],
            "searchAcronyms": [
                "manemane",
                "manemane的精神回归",
                "两人玩手机",
                "二重身",
                "分身",
                "模仿模仿",
                "模仿模仿Psychotropic",
                "模仿模仿的精神回归",
                "精神回归",
                "马内马内"
            ]
        },
        {
            "songId": "オリフィス",
            "category": "maimai",
            "title": "オリフィス",
            "artist": "40mP feat. シャノ",
            "bpm": 200,
            "imageName": "26b0bddd939540a65a2fc44fb0b7741e95474ba86f3c26462040b726cabc0bd0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 112,
                        "hold": 14,
                        "slide": 7,
                        "touch": 6,
                        "break": 2,
                        "total": 141
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11161,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2020-12-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 35,
                        "slide": 16,
                        "touch": 17,
                        "break": 8,
                        "total": 333
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11161,
                    "multiverInternalLevelValue": {
                        "Splash": 7.8
                    },
                    "releaseDate": "2020-12-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 368,
                        "hold": 66,
                        "slide": 31,
                        "touch": 34,
                        "break": 32,
                        "total": 531
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11161,
                    "multiverInternalLevelValue": {
                        "Splash": 10.4
                    },
                    "releaseDate": "2020-12-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 581,
                        "hold": 64,
                        "slide": 101,
                        "touch": 36,
                        "break": 9,
                        "total": 791
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11161,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 12.9,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2020-12-11"
                }
            ],
            "searchAcronyms": [
                "orifice",
                "流量计",
                "画家",
                "美术生",
                "黄毛美术生"
            ]
        },
        {
            "songId": "ユメヒバナ",
            "category": "maimai",
            "title": "ユメヒバナ",
            "artist": "RD-Sounds feat.中恵光城",
            "bpm": 151,
            "imageName": "1d003203f2d19f8285dd4d6af7f72bc68ae46589b6e62486a286ccb7913f0a19",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 160,
                        "hold": 4,
                        "slide": 2,
                        "touch": 10,
                        "break": 13,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11162,
                    "multiverInternalLevelValue": {
                        "Splash": 5
                    },
                    "releaseDate": "2020-12-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 24,
                        "slide": 9,
                        "touch": 29,
                        "break": 11,
                        "total": 267
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11162,
                    "multiverInternalLevelValue": {
                        "Splash": 7
                    },
                    "releaseDate": "2020-12-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 45,
                        "slide": 40,
                        "touch": 34,
                        "break": 24,
                        "total": 449
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11162,
                    "multiverInternalLevelValue": {
                        "Splash": 10
                    },
                    "releaseDate": "2020-12-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 474,
                        "hold": 52,
                        "slide": 71,
                        "touch": 116,
                        "break": 18,
                        "total": 731
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11162,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.3,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.3
                    },
                    "releaseDate": "2020-12-11"
                }
            ],
            "searchAcronyms": [
                "掉毛小哥哥",
                "梦火花"
            ]
        },
        {
            "songId": "REAL VOICE",
            "category": "maimai",
            "title": "REAL VOICE",
            "artist": "達見 恵 featured by 佐野 宏晃",
            "bpm": 183,
            "imageName": "5c7e8c4d6a0bbb15012027b900a2ec600d523469c7a797be2eaddc2b9249caa7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 113,
                        "hold": 22,
                        "slide": 4,
                        "touch": 9,
                        "break": 4,
                        "total": 152
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11163,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2020-12-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 28,
                        "slide": 17,
                        "touch": 10,
                        "break": 4,
                        "total": 337
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11163,
                    "multiverInternalLevelValue": {
                        "Splash": 7.7
                    },
                    "releaseDate": "2020-12-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 80,
                        "slide": 38,
                        "touch": 17,
                        "break": 6,
                        "total": 543
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11163,
                    "multiverInternalLevelValue": {
                        "Splash": 10.2
                    },
                    "releaseDate": "2020-12-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 557,
                        "hold": 43,
                        "slide": 95,
                        "touch": 103,
                        "break": 12,
                        "total": 810
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11163,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2020-12-11"
                }
            ],
            "searchAcronyms": [
                "realvoice",
                "本音",
                "真唱",
                "真声音",
                "真音"
            ]
        },
        {
            "songId": "パラボラ",
            "category": "maimai",
            "title": "パラボラ",
            "artist": "*Luna feat.NORISTRY",
            "bpm": 192,
            "imageName": "7fab4aca9bac72437eb638c79723b49d5fd860d2d0806ce02648ceafa3e21268",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 17,
                        "slide": 2,
                        "touch": 12,
                        "break": 6,
                        "total": 194
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11164,
                    "releaseDate": "2020-12-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 41,
                        "slide": 18,
                        "touch": 19,
                        "break": 13,
                        "total": 397
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11164,
                    "releaseDate": "2020-12-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 474,
                        "hold": 84,
                        "slide": 40,
                        "touch": 13,
                        "break": 10,
                        "total": 621
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11164,
                    "releaseDate": "2020-12-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 680,
                        "hold": 63,
                        "slide": 125,
                        "touch": 48,
                        "break": 47,
                        "total": 963
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11164,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2020-12-11"
                }
            ],
            "searchAcronyms": [
                "parabola",
                "二次元科比",
                "体育生",
                "抛物线",
                "球男",
                "白毛体育生",
                "篮球男孩",
                "网球王子",
                "蓝毛体育生"
            ]
        },
        {
            "songId": "YURUSHITE",
            "category": "オンゲキ＆CHUNITHM",
            "title": "YURUSHITE",
            "artist": "t+pazolite",
            "bpm": 270,
            "imageName": "dff3cceaa23397597e37e9395162e77e7c30ef8fe802216119ef1d8a28003b74",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 155,
                        "hold": 18,
                        "slide": 6,
                        "touch": 14,
                        "break": 5,
                        "total": 198
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11171,
                    "multiverInternalLevelValue": {
                        "Splash": 5
                    },
                    "releaseDate": "2020-12-25"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 458,
                        "hold": 15,
                        "slide": 17,
                        "touch": 16,
                        "break": 14,
                        "total": 520
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11171,
                    "multiverInternalLevelValue": {
                        "Splash": 8.8
                    },
                    "releaseDate": "2020-12-25"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 574,
                        "hold": 51,
                        "slide": 90,
                        "touch": 32,
                        "break": 26,
                        "total": 773
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11171,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash": 12.5
                    },
                    "releaseDate": "2020-12-25"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 801,
                        "hold": 86,
                        "slide": 94,
                        "touch": 38,
                        "break": 35,
                        "total": 1054
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11171,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.4,
                        "FESTiVAL PLUS": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "Splash": 14.4,
                        "Splash PLUS": 14.4,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.3
                    },
                    "releaseDate": "2020-12-25"
                }
            ],
            "searchAcronyms": [
                "shit",
                "YURU****E",
                "二郎腿",
                "你妈个逼",
                "你是屎",
                "厕所女王",
                "原谅我",
                "回娄底",
                "大司马",
                "嬲你妈妈别",
                "我要打飞机",
                "摇了我吧",
                "摇晃的红酒杯",
                "火神青春版",
                "犹如屎",
                "红酒",
                "红酒杯",
                "萨塔妮亚",
                "萨塔妮娅",
                "逢坂茜",
                "饶了我吧"
            ]
        },
        {
            "songId": "Climax",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Climax",
            "artist": "USAO",
            "bpm": 190,
            "imageName": "53505cce8a6282ef54ae3b7e005d5f83da53bde161bd04dcc35edc393cae5522",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 15,
                        "slide": 2,
                        "touch": 4,
                        "break": 10,
                        "total": 227
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11176,
                    "multiverInternalLevelValue": {
                        "Splash": 5
                    },
                    "releaseDate": "2020-12-25"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 415,
                        "hold": 9,
                        "slide": 22,
                        "touch": 17,
                        "break": 15,
                        "total": 478
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11176,
                    "multiverInternalLevelValue": {
                        "Splash": 8.5
                    },
                    "releaseDate": "2020-12-25"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 588,
                        "hold": 88,
                        "slide": 60,
                        "touch": 49,
                        "break": 22,
                        "total": 807
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11176,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12,
                        "Splash": 12
                    },
                    "releaseDate": "2020-12-25"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 797,
                        "hold": 85,
                        "slide": 144,
                        "touch": 43,
                        "break": 70,
                        "total": 1139
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11176,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "Splash": 14.3,
                        "Splash PLUS": 14.3,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.3
                    },
                    "releaseDate": "2020-12-25"
                }
            ],
            "searchAcronyms": [
                "🐍🐳",
                "stop playing maimai",
                "别打舞萌",
                "可莉max",
                "妖艳魔男",
                "性高潮",
                "我有很多手指",
                "犀利麦克斯",
                "老公",
                "莓茶",
                "阿莱乌斯",
                "高潮",
                "魔男"
            ]
        },
        {
            "songId": "Virtual to LIVE",
            "category": "POPS＆アニメ",
            "title": "Virtual to LIVE",
            "artist": "にじさんじ",
            "bpm": 156,
            "imageName": "60420da45b59c572272c7d6ea25c4d6ed4e46e9a7ddb5f4be12bb0f93fd83263",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 106,
                        "hold": 7,
                        "slide": 2,
                        "touch": 10,
                        "break": 4,
                        "total": 129
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11184,
                    "multiverInternalLevelValue": {
                        "Splash": 3
                    },
                    "releaseDate": "2020-12-25"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 207,
                        "hold": 14,
                        "slide": 8,
                        "touch": 17,
                        "break": 2,
                        "total": 248
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11184,
                    "multiverInternalLevelValue": {
                        "Splash": 6
                    },
                    "releaseDate": "2020-12-25"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "ものくろっく",
                    "noteCounts": {
                        "tap": 219,
                        "hold": 25,
                        "slide": 44,
                        "touch": 53,
                        "break": 18,
                        "total": 359
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11184,
                    "multiverInternalLevelValue": {
                        "Splash": 8.7
                    },
                    "releaseDate": "2020-12-25"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 483,
                        "hold": 36,
                        "slide": 60,
                        "touch": 48,
                        "break": 9,
                        "total": 636
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11184,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "PRiSM PLUS": 12.2,
                        "Splash": 11.2
                    },
                    "releaseDate": "2020-12-25"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 498,
                        "hold": 15,
                        "slide": 116,
                        "touch": 15,
                        "break": 23,
                        "total": 667
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11184,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2020-12-25"
                }
            ],
            "searchAcronyms": [
                "vtl",
                "巴恰兔奶",
                "彩虹社",
                "彩虹社歌",
                "管人歌",
                "管人痴",
                "虚拟到活",
                "雨刮器"
            ]
        },
        {
            "songId": "Arty Party",
            "category": "ゲーム＆バラエティ",
            "title": "Arty Party",
            "artist": "yaseta",
            "bpm": 180,
            "imageName": "f43e1c7c591fb680fb173145ef4cd167a77a9f74e046d1c1d9784210168c37da",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 124,
                        "hold": 16,
                        "slide": 2,
                        "touch": 12,
                        "break": 3,
                        "total": 157
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11213,
                    "multiverInternalLevelValue": {
                        "Splash": 5
                    },
                    "releaseDate": "2020-12-25"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 288,
                        "hold": 36,
                        "slide": 10,
                        "touch": 14,
                        "break": 8,
                        "total": 356
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11213,
                    "multiverInternalLevelValue": {
                        "Splash": 8
                    },
                    "releaseDate": "2020-12-25"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 59,
                        "slide": 60,
                        "touch": 20,
                        "break": 31,
                        "total": 522
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11213,
                    "multiverInternalLevelValue": {
                        "Splash": 11.8
                    },
                    "releaseDate": "2020-12-25"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "しちみりこりす",
                    "noteCounts": {
                        "tap": 654,
                        "hold": 34,
                        "slide": 57,
                        "touch": 30,
                        "break": 39,
                        "total": 814
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11213,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2020-12-25"
                }
            ],
            "searchAcronyms": [
                "ap",
                "arty",
                "artyparty",
                "usao和他的狐朋狗友",
                "usao派对",
                "丁真和他的动物朋友",
                "丁真和他的动物朋友们",
                "丁真派对",
                "丁真银趴",
                "动物园",
                "动物派对",
                "动物银趴",
                "基佬派对",
                "小动物开银趴",
                "小动物淫趴",
                "小动物银啪",
                "小动物银趴",
                "小动物音趴",
                "我和我的动物朋友们",
                "狐朋狗友",
                "男同派对",
                "粉兔",
                "纵连派对",
                "银趴",
                "阿姨爬梯"
            ]
        },
        {
            "songId": "Ether Strike",
            "category": "ゲーム＆バラエティ",
            "title": "Ether Strike",
            "artist": "Akira Complex",
            "bpm": 156,
            "imageName": "b9809aa3f33064cc7373073cb2ad637609ab5b6ef24539468dac51171cd9afe1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 120,
                        "hold": 12,
                        "slide": 4,
                        "touch": 12,
                        "break": 6,
                        "total": 154
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11207,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2021-01-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 21,
                        "slide": 20,
                        "touch": 12,
                        "break": 14,
                        "total": 359
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11207,
                    "multiverInternalLevelValue": {
                        "Splash": 7.7
                    },
                    "releaseDate": "2021-01-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 121,
                        "slide": 38,
                        "touch": 26,
                        "break": 16,
                        "total": 558
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11207,
                    "multiverInternalLevelValue": {
                        "Splash": 10.8
                    },
                    "releaseDate": "2021-01-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 600,
                        "hold": 79,
                        "slide": 105,
                        "touch": 16,
                        "break": 52,
                        "total": 852
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11207,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2021-01-08"
                }
            ],
            "searchAcronyms": [
                "📢0",
                "es",
                "my guiding star",
                "乙醚罢工",
                "以太冲击",
                "以太攻击",
                "吾之指路明星",
                "白内障",
                "零光",
                "零光吹喇叭"
            ]
        },
        {
            "songId": "Cyaegha",
            "category": "ゲーム＆バラエティ",
            "title": "Cyaegha",
            "artist": "USAO",
            "bpm": 200,
            "imageName": "bcc9951877d7ec31a94d267d093f1933a62f9bfc0fd30ec4379e18d18a50c25c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 174,
                        "hold": 7,
                        "slide": 2,
                        "touch": 8,
                        "break": 8,
                        "total": 199
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11208,
                    "multiverInternalLevelValue": {
                        "Splash": 5
                    },
                    "releaseDate": "2021-01-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 312,
                        "hold": 24,
                        "slide": 14,
                        "touch": 25,
                        "break": 16,
                        "total": 391
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11208,
                    "multiverInternalLevelValue": {
                        "Splash": 7.8
                    },
                    "releaseDate": "2021-01-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 407,
                        "hold": 49,
                        "slide": 86,
                        "touch": 22,
                        "break": 24,
                        "total": 588
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11208,
                    "multiverInternalLevelValue": {
                        "Splash": 11
                    },
                    "releaseDate": "2021-01-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 706,
                        "hold": 39,
                        "slide": 119,
                        "touch": 30,
                        "break": 52,
                        "total": 946
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11208,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.5
                    },
                    "releaseDate": "2021-01-08"
                }
            ],
            "searchAcronyms": [
                "古神语",
                "咲弥",
                "咲弥削吐司",
                "完型填空",
                "完形填空",
                "完形填空答案",
                "绿魔王",
                "花绿青",
                "赛伊格亚",
                "赛洛图亚",
                "赛落图亚",
                "过不了审的曲绘"
            ]
        },
        {
            "songId": "Grievous Lady",
            "category": "ゲーム＆バラエティ",
            "title": "Grievous Lady",
            "artist": "Team Grimoire vs Laur",
            "bpm": 210,
            "imageName": "31ac770f045a51cc274a65b9f29488deba2e71acdd414fc24045ae8d34b9f736",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 170,
                        "hold": 7,
                        "slide": 2,
                        "touch": 40,
                        "break": 6,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11209,
                    "multiverInternalLevelValue": {
                        "Splash": 5
                    },
                    "releaseDate": "2021-01-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 378,
                        "hold": 14,
                        "slide": 16,
                        "touch": 24,
                        "break": 10,
                        "total": 442
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11209,
                    "multiverInternalLevelValue": {
                        "Splash": 8
                    },
                    "releaseDate": "2021-01-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 504,
                        "hold": 89,
                        "slide": 55,
                        "touch": 47,
                        "break": 17,
                        "total": 712
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11209,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12,
                        "Splash": 12,
                        "UNiVERSE": 12
                    },
                    "releaseDate": "2021-01-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "Anomaly Labyrinth",
                    "noteCounts": {
                        "tap": 726,
                        "hold": 92,
                        "slide": 85,
                        "touch": 44,
                        "break": 41,
                        "total": 988
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11209,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.1,
                        "BUDDiES PLUS": 14.1,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14.1,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "Splash": 14.4,
                        "Splash PLUS": 14.4,
                        "UNiVERSE": 14.1,
                        "UNiVERSE PLUS": 14.1
                    },
                    "releaseDate": "2021-01-08"
                }
            ],
            "searchAcronyms": [
                "gl",
                "哈哈",
                "对立",
                "对立拉窗帘",
                "对立拿窗帘闷死我",
                "病女",
                "痛苦的女士",
                "老弱病残女"
            ]
        },
        {
            "songId": "劣等上等",
            "category": "niconico＆ボーカロイド",
            "title": "劣等上等",
            "artist": "Giga / 鏡音リン・レン / Vivid BAD SQUAD「プロジェクトセカイ カラフルステージ！ feat. 初音ミク」",
            "bpm": 160,
            "imageName": "c1da5d720824e512e753c3455d794bd6c6a5723c46685af24358f4a5c23985c3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 78,
                        "hold": 9,
                        "slide": 4,
                        "touch": 4,
                        "break": 6,
                        "total": 101
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11197,
                    "releaseDate": "2021-01-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 134,
                        "hold": 10,
                        "slide": 8,
                        "touch": 33,
                        "break": 4,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11197,
                    "releaseDate": "2021-01-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 222,
                        "hold": 28,
                        "slide": 37,
                        "touch": 68,
                        "break": 14,
                        "total": 369
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11197,
                    "releaseDate": "2021-01-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 368,
                        "hold": 21,
                        "slide": 88,
                        "touch": 35,
                        "break": 36,
                        "total": 548
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11197,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.2,
                        "Splash": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2021-01-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "アスノヨゾラ哨戒班",
            "category": "niconico＆ボーカロイド",
            "title": "アスノヨゾラ哨戒班",
            "artist": "Orangestar feat.IA",
            "bpm": 185,
            "imageName": "ebba9ea84df15b489565ef8ba9ca3607e84291c032bef8502774afb91b59ea0c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 108,
                        "hold": 8,
                        "slide": 6,
                        "touch": 16,
                        "break": 4,
                        "total": 142
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11198,
                    "releaseDate": "2021-01-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 17,
                        "slide": 8,
                        "touch": 27,
                        "break": 5,
                        "total": 307
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11198,
                    "releaseDate": "2021-01-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 386,
                        "hold": 17,
                        "slide": 24,
                        "touch": 67,
                        "break": 2,
                        "total": 496
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11198,
                    "releaseDate": "2021-01-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 511,
                        "hold": 67,
                        "slide": 102,
                        "touch": 33,
                        "break": 16,
                        "total": 729
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11198,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2021-01-21"
                }
            ],
            "searchAcronyms": [
                "Asu no Yozora Shoukaihan",
                "dx哨戒班",
                "dx烧鸡班",
                "Night Sky Patrol of Tomorrow",
                "哨戒班",
                "明日的夜空哨戒班",
                "烧鸡班"
            ]
        },
        {
            "songId": "自傷無色",
            "category": "niconico＆ボーカロイド",
            "title": "自傷無色",
            "artist": "ササノマリイ / 初音ミク / 25時、ナイトコードで。「プロジェクトセカイ カラフルステージ！ feat. 初音ミク」",
            "bpm": 120,
            "imageName": "18fc104ded10a74e66a5be3ba19d2c3810cf9c585cc65eead42aa46bbd467ec8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 68,
                        "hold": 4,
                        "slide": 2,
                        "touch": 15,
                        "break": 2,
                        "total": 91
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11218,
                    "releaseDate": "2021-01-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 140,
                        "hold": 10,
                        "slide": 9,
                        "touch": 13,
                        "break": 5,
                        "total": 177
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11218,
                    "releaseDate": "2021-01-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 101,
                        "hold": 58,
                        "slide": 18,
                        "touch": 30,
                        "break": 3,
                        "total": 210
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11218,
                    "releaseDate": "2021-01-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 289,
                        "hold": 23,
                        "slide": 85,
                        "touch": 28,
                        "break": 7,
                        "total": 432
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11218,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2021-01-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "絡繰りドール",
            "category": "東方Project",
            "title": "絡繰りドール",
            "artist": "SOUND HOLIC feat. Nana Takahashi",
            "bpm": 160,
            "imageName": "510537904f4018fbe1a0ddcfa10742765b8be52c4c052333da9cda4d111c424b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 120,
                        "hold": 8,
                        "slide": 2,
                        "touch": 8,
                        "break": 5,
                        "total": 143
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11201,
                    "releaseDate": "2021-02-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 17,
                        "slide": 8,
                        "touch": 8,
                        "break": 4,
                        "total": 270
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11201,
                    "releaseDate": "2021-02-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 29,
                        "slide": 44,
                        "touch": 23,
                        "break": 10,
                        "total": 421
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11201,
                    "releaseDate": "2021-02-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 528,
                        "hold": 47,
                        "slide": 52,
                        "touch": 33,
                        "break": 38,
                        "total": 698
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11201,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2021-02-05"
                }
            ],
            "searchAcronyms": [
                "奶奶狐狸",
                "絡繰",
                "络繰",
                "络缲",
                "老太婆和九尾狐妖",
                "老奶奶与狐狸精"
            ]
        },
        {
            "songId": "物凄いヴァイブスで魔理沙が物凄いラップ",
            "category": "東方Project",
            "title": "物凄いヴァイブスで魔理沙が物凄いラップ",
            "artist": "魂音泉",
            "bpm": 173,
            "imageName": "303bfcbb5712005c15b63c84c1352490b95142a2a1e64e32d919ab297481f981",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 9,
                        "slide": 4,
                        "touch": 12,
                        "break": 4,
                        "total": 157
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11202,
                    "releaseDate": "2021-02-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 204,
                        "hold": 21,
                        "slide": 8,
                        "touch": 21,
                        "break": 5,
                        "total": 259
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11202,
                    "releaseDate": "2021-02-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 15,
                        "slide": 44,
                        "touch": 48,
                        "break": 46,
                        "total": 468
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11202,
                    "releaseDate": "2021-02-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "7.3Hz＋Jack",
                    "noteCounts": {
                        "tap": 499,
                        "hold": 60,
                        "slide": 102,
                        "touch": 71,
                        "break": 45,
                        "total": 777
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11202,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.4,
                        "Splash PLUS": 13.4,
                        "UNiVERSE": 13.4,
                        "UNiVERSE PLUS": 13.4
                    },
                    "releaseDate": "2021-02-05"
                }
            ],
            "searchAcronyms": [
                "vibes",
                "夜店魔理沙",
                "妹红吸烟",
                "妹红抽烟",
                "消声器",
                "物凄",
                "藤原妹红抽大烟",
                "魔理沙抽烟"
            ]
        },
        {
            "songId": "Sweet Requiem",
            "category": "東方Project",
            "title": "Sweet Requiem",
            "artist": "REDALiCE & aran",
            "bpm": 190,
            "imageName": "81d833fbbc1cd5e1fe4cd460e7aa1eff842a5b1e0ac8a5fedf71d3414ef4fbb7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 98,
                        "hold": 12,
                        "slide": 3,
                        "touch": 18,
                        "break": 4,
                        "total": 135
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11204,
                    "releaseDate": "2021-02-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 261,
                        "hold": 9,
                        "slide": 15,
                        "touch": 23,
                        "break": 10,
                        "total": 318
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11204,
                    "releaseDate": "2021-02-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 355,
                        "hold": 52,
                        "slide": 39,
                        "touch": 23,
                        "break": 23,
                        "total": 492
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11204,
                    "releaseDate": "2021-02-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 744,
                        "hold": 30,
                        "slide": 42,
                        "touch": 52,
                        "break": 40,
                        "total": 908
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11204,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2021-02-05"
                }
            ],
            "searchAcronyms": [
                "redandblue",
                "sr",
                "塞钱",
                "灵梦镇魂曲",
                "甜蜜安魂曲",
                "甜蜜镇魂曲",
                "红蓝灵梦",
                "镇魂曲"
            ]
        },
        {
            "songId": "Dive into The Sky ～initialized～",
            "category": "東方Project",
            "title": "Dive into The Sky ～initialized～",
            "artist": "A-One",
            "bpm": 165,
            "imageName": "2deec1bceee0a49866c5df48c1b9f81be0d127faf0a297957d8efce8ab8c5380",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 121,
                        "hold": 10,
                        "slide": 5,
                        "touch": 6,
                        "break": 5,
                        "total": 147
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11205,
                    "releaseDate": "2021-02-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 236,
                        "hold": 12,
                        "slide": 15,
                        "touch": 17,
                        "break": 4,
                        "total": 284
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11205,
                    "releaseDate": "2021-02-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 401,
                        "hold": 63,
                        "slide": 30,
                        "touch": 13,
                        "break": 22,
                        "total": 529
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11205,
                    "releaseDate": "2021-02-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 578,
                        "hold": 56,
                        "slide": 50,
                        "touch": 47,
                        "break": 39,
                        "total": 770
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11205,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8
                    },
                    "releaseDate": "2021-02-05"
                }
            ],
            "searchAcronyms": [
                "dive",
                "潜入天空",
                "风神少女"
            ]
        },
        {
            "songId": "Prismatic",
            "category": "東方Project",
            "title": "Prismatic",
            "artist": "CielArc",
            "bpm": 180,
            "imageName": "3dea8925808c5038236226a97921e56d272ab760ff0ee140e9f0c28a6080b6df",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 114,
                        "hold": 14,
                        "slide": 3,
                        "touch": 12,
                        "break": 6,
                        "total": 149
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11219,
                    "releaseDate": "2021-02-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 358,
                        "hold": 14,
                        "slide": 3,
                        "touch": 12,
                        "break": 8,
                        "total": 395
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11219,
                    "releaseDate": "2021-02-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 300,
                        "hold": 108,
                        "slide": 38,
                        "touch": 13,
                        "break": 13,
                        "total": 472
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11219,
                    "releaseDate": "2021-02-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 552,
                        "hold": 42,
                        "slide": 114,
                        "touch": 29,
                        "break": 13,
                        "total": 750
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11219,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "FESTiVAL": 12.2,
                        "PRiSM PLUS": 12.2,
                        "Splash": 12.2,
                        "UNiVERSE PLUS": 12.2
                    },
                    "releaseDate": "2021-02-05"
                }
            ],
            "searchAcronyms": [
                "🤗",
                "你先别急",
                "棱镜"
            ]
        },
        {
            "songId": "Regulus",
            "category": "maimai",
            "title": "Regulus",
            "artist": "お月さま交響曲",
            "bpm": 212,
            "imageName": "492978e5988cc3472a5c2d3335de8908561fc8c1fc061f8740ba0090712602e8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 126,
                        "hold": 22,
                        "slide": 6,
                        "touch": 19,
                        "break": 7,
                        "total": 180
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11165,
                    "releaseDate": "2021-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 346,
                        "hold": 13,
                        "slide": 37,
                        "touch": 17,
                        "break": 12,
                        "total": 425
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11165,
                    "releaseDate": "2021-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 492,
                        "hold": 43,
                        "slide": 39,
                        "touch": 45,
                        "break": 9,
                        "total": 628
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11165,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2021-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "7.3GHz",
                    "noteCounts": {
                        "tap": 764,
                        "hold": 28,
                        "slide": 99,
                        "touch": 99,
                        "break": 9,
                        "total": 999
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11165,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "FESTiVAL": 14.7,
                        "FESTiVAL PLUS": 14.7,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7,
                        "Splash": 14.7,
                        "Splash PLUS": 14.7,
                        "UNiVERSE": 14.7,
                        "UNiVERSE PLUS": 14.7
                    },
                    "releaseDate": "2021-02-20"
                }
            ],
            "searchAcronyms": [
                "一视频的萝莉哦",
                "八云蓝",
                "大奶子",
                "大扎修女",
                "大欧派姐姐",
                "天界大奶",
                "奶子很大",
                "如龙4",
                "星锑",
                "热古拉斯",
                "热咕噜",
                "热轱辘丝",
                "狮子座α",
                "白又大",
                "白法院",
                "轩辕十四",
                "雷古勒斯"
            ]
        },
        {
            "songId": "ワンダーシャッフェンの法則",
            "category": "maimai",
            "title": "ワンダーシャッフェンの法則",
            "artist": "アリスシャッハと魔法の楽団",
            "bpm": 170,
            "imageName": "8819e109bb385c47f9bd06d37b6197182757c88b415f806375f761e4f51b3df8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 126,
                        "hold": 12,
                        "slide": 6,
                        "touch": 6,
                        "break": 11,
                        "total": 161
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11166,
                    "releaseDate": "2021-02-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 15,
                        "slide": 16,
                        "touch": 16,
                        "break": 12,
                        "total": 326
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11166,
                    "releaseDate": "2021-02-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 38,
                        "slide": 70,
                        "touch": 7,
                        "break": 20,
                        "total": 425
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11166,
                    "multiverInternalLevelValue": {
                        "Splash": 10.7
                    },
                    "releaseDate": "2021-02-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 501,
                        "hold": 53,
                        "slide": 131,
                        "touch": 64,
                        "break": 16,
                        "total": 765
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11166,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "Splash": 14.1,
                        "Splash PLUS": 14.1,
                        "UNiVERSE": 14.1,
                        "UNiVERSE PLUS": 14
                    },
                    "releaseDate": "2021-02-19"
                }
            ],
            "searchAcronyms": [
                "Wander Schaffen",
                "wander schaffens law",
                "wonder schaffen",
                "Wonder Schaffen no Housoku",
                "wonder schaffens law",
                "Wunder Schaffen",
                "wunder schaffens law",
                "创造奇迹的法则",
                "小扎萝莉",
                "小萝莉法则",
                "法则",
                "炼铜法则",
                "萝莉法则",
                "萝莉鸟加鸟加"
            ]
        },
        {
            "songId": "BIRTH",
            "category": "maimai",
            "title": "BIRTH",
            "artist": "llliiillliiilll",
            "bpm": 176,
            "imageName": "66a08e0f1c413f46a55710d6d49d1597b7a3400372c88b120ab743d41eb78931",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 117,
                        "hold": 13,
                        "slide": 5,
                        "touch": 11,
                        "break": 9,
                        "total": 155
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11167,
                    "releaseDate": "2021-02-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 17,
                        "slide": 24,
                        "touch": 16,
                        "break": 10,
                        "total": 352
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11167,
                    "releaseDate": "2021-02-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 505,
                        "hold": 62,
                        "slide": 17,
                        "touch": 8,
                        "break": 9,
                        "total": 601
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11167,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2021-02-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "Safata.Hz",
                    "noteCounts": {
                        "tap": 697,
                        "hold": 40,
                        "slide": 94,
                        "touch": 19,
                        "break": 38,
                        "total": 888
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11167,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "Splash": 14.5,
                        "Splash PLUS": 14.5,
                        "UNiVERSE": 14.5,
                        "UNiVERSE PLUS": 14.5
                    },
                    "releaseDate": "2021-02-19"
                }
            ],
            "searchAcronyms": [
                "÷↑",
                "Koha-D",
                "出生",
                "初生",
                "妈妈生的",
                "我",
                "我还",
                "生日",
                "畜牲",
                "畜生",
                "诞生"
            ]
        },
        {
            "songId": "ポケットからぬりつぶせ！",
            "category": "オンゲキ＆CHUNITHM",
            "title": "ポケットからぬりつぶせ！",
            "artist": "曲：中山真斗／歌：マーチングポケッツ [日向 千夏(CV：岡咲 美保)、柏木 美亜(CV：和氣 あず未)、東雲 つむぎ(CV：和泉 風花)]",
            "bpm": 126,
            "imageName": "db88497c0fe167fb56a72128c7410975f52e7e9acc2f9a2fc6a6e70f5d4eef9d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 112,
                        "hold": 10,
                        "slide": 4,
                        "touch": 14,
                        "break": 6,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11172,
                    "releaseDate": "2021-03-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 224,
                        "hold": 19,
                        "slide": 21,
                        "touch": 30,
                        "break": 10,
                        "total": 304
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11172,
                    "releaseDate": "2021-03-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 434,
                        "hold": 57,
                        "slide": 41,
                        "touch": 41,
                        "break": 20,
                        "total": 593
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11172,
                    "releaseDate": "2021-03-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 472,
                        "hold": 68,
                        "slide": 68,
                        "touch": 140,
                        "break": 22,
                        "total": 770
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11172,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2021-03-04"
                }
            ],
            "searchAcronyms": [
                "口袋涂鸦"
            ]
        },
        {
            "songId": "トリドリ⇒モリモリ！Lovely fruits☆",
            "category": "オンゲキ＆CHUNITHM",
            "title": "トリドリ⇒モリモリ！Lovely fruits☆",
            "artist": "曲：やしきん／歌：柏木 美亜(CV：和氣 あず未)",
            "bpm": 185,
            "imageName": "2be363d201449fcfd95d45260a3520568766c1ba5d401ba67c4f7d1fb159cb65",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 152,
                        "hold": 19,
                        "slide": 7,
                        "touch": 16,
                        "break": 10,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11173,
                    "releaseDate": "2021-03-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 35,
                        "slide": 14,
                        "touch": 52,
                        "break": 10,
                        "total": 373
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11173,
                    "releaseDate": "2021-03-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 446,
                        "hold": 92,
                        "slide": 42,
                        "touch": 12,
                        "break": 23,
                        "total": 615
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11173,
                    "releaseDate": "2021-03-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 605,
                        "hold": 87,
                        "slide": 112,
                        "touch": 44,
                        "break": 36,
                        "total": 884
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11173,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2021-03-04"
                }
            ],
            "searchAcronyms": [
                "可爱水果",
                "可爱的水果",
                "合成大西瓜",
                "水果",
                "水果摊子",
                "水果歌"
            ]
        },
        {
            "songId": "Desperado Waltz",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Desperado Waltz",
            "artist": "ぺのれり",
            "bpm": 172,
            "imageName": "56093588350f227ffa29ef713230d9b53020fb433f7f9bd93276c219a593ad37",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 129,
                        "hold": 21,
                        "slide": 4,
                        "touch": 10,
                        "break": 4,
                        "total": 168
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11174,
                    "releaseDate": "2021-03-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 270,
                        "hold": 31,
                        "slide": 18,
                        "touch": 37,
                        "break": 12,
                        "total": 368
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11174,
                    "releaseDate": "2021-03-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 485,
                        "hold": 120,
                        "slide": 27,
                        "touch": 52,
                        "break": 13,
                        "total": 697
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11174,
                    "multiverInternalLevelValue": {
                        "Splash": 11.8
                    },
                    "releaseDate": "2021-03-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 809,
                        "hold": 140,
                        "slide": 42,
                        "touch": 57,
                        "break": 54,
                        "total": 1102
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11174,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14.2,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "Splash": 14.3,
                        "Splash PLUS": 14.3,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.3
                    },
                    "releaseDate": "2021-03-04"
                }
            ],
            "searchAcronyms": [
                "亡徒华尔兹",
                "华尔兹",
                "噔噔噔",
                "第三只手",
                "荷官发牌"
            ]
        },
        {
            "songId": "BREaK! BREaK! BREaK!",
            "category": "maimai",
            "title": "BREaK! BREaK! BREaK!",
            "artist": "HiTECH NINJA vs Cranky",
            "bpm": 165,
            "imageName": "4f9500cbc714e859a617ed06238916752a145271132d6199e7c0053b5b7b4146",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 10,
                        "slide": 8,
                        "touch": 0,
                        "break": 17,
                        "total": 207
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "Splash"
                        }
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11222,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 321,
                        "hold": 17,
                        "slide": 14,
                        "touch": 26,
                        "break": 36,
                        "total": 414
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "Splash"
                        }
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11222,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 513,
                        "hold": 65,
                        "slide": 42,
                        "touch": 55,
                        "break": 57,
                        "total": 732
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "Splash"
                        }
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11222,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "サファ太 vs -ZONE- SaFaRi",
                    "noteCounts": {
                        "tap": 797,
                        "hold": 76,
                        "slide": 121,
                        "touch": 62,
                        "break": 50,
                        "total": 1106
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "Splash"
                        }
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11222,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL": 14.7,
                        "FESTiVAL PLUS": 14.7,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6,
                        "Splash PLUS": 14.7,
                        "UNiVERSE": 14.7,
                        "UNiVERSE PLUS": 14.7
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": [
                "2550！2550！2550！",
                "3b",
                "bbb",
                "break",
                "break!break!break!",
                "kop2",
                "三个绝赞",
                "三绝赞",
                "不不不",
                "仨绝赞",
                "哇，全大P",
                "哔哩吧啦白",
                "哔哩啵拜",
                "哔啵吧",
                "哔啵拜",
                "哔啵掰",
                "哔波掰哔波掰",
                "啊？全小p？",
                "大b歌",
                "天赋佬我草爹",
                "天赋佬我超爹",
                "崩三",
                "崩坏三",
                "崩崩崩",
                "我超，全大P",
                "我趣全大p",
                "泉此方！泉此方！泉此方！",
                "爆！",
                "爆！爆！爆！",
                "爆爆爆",
                "碧波白碧波白",
                "绝赞³",
                "绝赞绝赞绝赞",
                "缝合怪",
                "苹果菠萝派",
                "落落落",
                "血脑屏障",
                "逼波掰"
            ]
        },
        {
            "songId": "Heavenly Blast",
            "category": "maimai",
            "title": "Heavenly Blast",
            "artist": "xi",
            "bpm": 234,
            "imageName": "9ba5a03cb42c0301391d857d90fd71214a737acd270a7364ed8496f17e732b49",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 174,
                        "hold": 19,
                        "slide": 6,
                        "touch": 6,
                        "break": 9,
                        "total": 214
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11223,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 444,
                        "hold": 15,
                        "slide": 32,
                        "touch": 22,
                        "break": 22,
                        "total": 535
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11223,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 581,
                        "hold": 49,
                        "slide": 46,
                        "touch": 49,
                        "break": 36,
                        "total": 761
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11223,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8
                    },
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "The ALiEN",
                    "noteCounts": {
                        "tap": 892,
                        "hold": 84,
                        "slide": 71,
                        "touch": 45,
                        "break": 77,
                        "total": 1169
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11223,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "FESTiVAL": 14.8,
                        "FESTiVAL PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8,
                        "Splash PLUS": 14.8,
                        "UNiVERSE": 14.8,
                        "UNiVERSE PLUS": 14.8
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": [
                "fd3",
                "hb",
                "天暴",
                "天爆",
                "皇冠2",
                "皇冠二",
                "蜜雪冰城",
                "跟你爆了"
            ]
        },
        {
            "songId": "Paradisoda",
            "category": "maimai",
            "title": "Paradisoda",
            "artist": "魂音泉",
            "bpm": 135,
            "imageName": "6b2c5cff1855f24746bd8f034633e38613947510446524c8ecc99a0e691e2e2f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 13,
                        "slide": 7,
                        "touch": 8,
                        "break": 4,
                        "total": 160
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11224,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 20,
                        "slide": 12,
                        "touch": 24,
                        "break": 12,
                        "total": 325
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11224,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 33,
                        "slide": 41,
                        "touch": 31,
                        "break": 36,
                        "total": 431
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11224,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 508,
                        "hold": 35,
                        "slide": 100,
                        "touch": 94,
                        "break": 34,
                        "total": 771
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11224,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "BUDDiES PLUS": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.1,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.1
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": [
                "soda",
                "sp+主题曲",
                "splash+主题曲",
                "splashplus主题曲",
                "侧漏",
                "天堂汽水",
                "天堂苏打",
                "快乐水",
                "泳装乙姬",
                "苏打",
                "苏打天堂"
            ]
        },
        {
            "songId": "VANTABLACK RAVER",
            "category": "maimai",
            "title": "VANTABLACK RAVER",
            "artist": "DIVELA feat.桐谷こむぎ",
            "bpm": 170,
            "imageName": "eab8c815168605af3031919a55573999fc62f345af240d67df4af90a403745ef",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 116,
                        "hold": 13,
                        "slide": 7,
                        "touch": 10,
                        "break": 2,
                        "total": 148
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11225,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 16,
                        "slide": 14,
                        "touch": 31,
                        "break": 9,
                        "total": 304
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11225,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 77,
                        "slide": 52,
                        "touch": 22,
                        "break": 12,
                        "total": 507
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11225,
                    "multiverInternalLevelValue": {
                        "Splash PLUS": 11.1
                    },
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 685,
                        "hold": 5,
                        "slide": 75,
                        "touch": 98,
                        "break": 21,
                        "total": 884
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11225,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": [
                "⚡乙姬⚡",
                "上单乙姬",
                "乙姬给你一锤",
                "吴乙凡",
                "放电乙姬",
                "狂暴乙姬",
                "电音乙姬",
                "电鳗乙姬",
                "红眼乙姬",
                "黑乙姬",
                "黑化乙姬"
            ]
        },
        {
            "songId": "時計の国のジェミニ",
            "category": "maimai",
            "title": "時計の国のジェミニ",
            "artist": "黒魔",
            "bpm": 180,
            "imageName": "9dafde5e84b0ec5d91fcab38b27dc4a711b3a7bb7b2db29a9d6565b774acaa45",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 17,
                        "slide": 4,
                        "touch": 13,
                        "break": 1,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11226,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 225,
                        "hold": 23,
                        "slide": 27,
                        "touch": 23,
                        "break": 4,
                        "total": 302
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11226,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 354,
                        "hold": 64,
                        "slide": 21,
                        "touch": 46,
                        "break": 12,
                        "total": 497
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11226,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 441,
                        "hold": 30,
                        "slide": 48,
                        "touch": 115,
                        "break": 56,
                        "total": 690
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11226,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 506,
                        "hold": 68,
                        "slide": 70,
                        "touch": 69,
                        "break": 74,
                        "total": 787
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7
                    },
                    "releaseDate": "2025-11-19"
                }
            ],
            "searchAcronyms": [
                "时之国",
                "时计",
                "时计之国",
                "时计国",
                "时针",
                "时针之国",
                "时针国",
                "时钟",
                "时钟之国",
                "时钟国",
                "石鸡锅",
                "钟表之国"
            ]
        },
        {
            "songId": "Xenovcipher",
            "category": "maimai",
            "title": "Xenovcipher",
            "artist": "Juggernaut.",
            "bpm": 210,
            "imageName": "3e10317281b4a1118df79bc5ea322ebb159a168e522b58034128fb4368ff49d9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 156,
                        "hold": 11,
                        "slide": 8,
                        "touch": 10,
                        "break": 11,
                        "total": 196
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11227,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 27,
                        "slide": 19,
                        "touch": 29,
                        "break": 8,
                        "total": 401
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11227,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 527,
                        "hold": 96,
                        "slide": 67,
                        "touch": 54,
                        "break": 28,
                        "total": 772
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11227,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 665,
                        "hold": 77,
                        "slide": 113,
                        "touch": 74,
                        "break": 53,
                        "total": 982
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11227,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "Splash PLUS": 14.3,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.3
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": [
                "冰火人",
                "异种密码",
                "挠头怪",
                "棺材板",
                "泽拉斯",
                "终极猎手",
                "远古巫灵",
                "飞升b"
            ]
        },
        {
            "songId": "おジャ魔女カーニバル!!",
            "category": "POPS＆アニメ",
            "title": "おジャ魔女カーニバル!!",
            "artist": "covered by 光吉猛修",
            "bpm": 147,
            "imageName": "4467a39fb893084fdc457086bc9cd46dd5af83b8f73faf9675acaaefdc419d79",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 10,
                        "slide": 10,
                        "touch": 8,
                        "break": 9,
                        "total": 162
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11253,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 9,
                        "slide": 12,
                        "touch": 14,
                        "break": 14,
                        "total": 282
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11253,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 274,
                        "hold": 59,
                        "slide": 9,
                        "touch": 26,
                        "break": 83,
                        "total": 451
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11253,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 499,
                        "hold": 36,
                        "slide": 88,
                        "touch": 63,
                        "break": 74,
                        "total": 760
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11253,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": [
                "你不准玩了",
                "你拆机",
                "光吉猛修",
                "光吉猛修小魔女",
                "小魔女",
                "小魔女嘉年华",
                "就你小子删我",
                "就你小子拆机",
                "就你小子拆机是吧",
                "魔女"
            ]
        },
        {
            "songId": "ネガティブ進化論",
            "category": "niconico＆ボーカロイド",
            "title": "ネガティブ進化論",
            "artist": "DECO*27",
            "bpm": 140,
            "imageName": "3a64b7f9f5bb3979e52c1ef3b3a413522c6cbc1341b1161c33a8b525a209d81e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 107,
                        "hold": 9,
                        "slide": 4,
                        "touch": 9,
                        "break": 10,
                        "total": 139
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11260,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 22,
                        "slide": 11,
                        "touch": 16,
                        "break": 9,
                        "total": 242
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11260,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 27,
                        "slide": 48,
                        "touch": 49,
                        "break": 8,
                        "total": 355
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11260,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 491,
                        "hold": 100,
                        "slide": 53,
                        "touch": 39,
                        "break": 8,
                        "total": 691
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11260,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash PLUS": 12.5,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": [
                "👎",
                "👎🏻",
                "negative",
                "弟中之弟",
                "弟中之弟进化论",
                "消极进化论",
                "达尔文",
                "进化论"
            ]
        },
        {
            "songId": "雨とペトラ",
            "category": "niconico＆ボーカロイド",
            "title": "雨とペトラ",
            "artist": "バルーン",
            "bpm": 195,
            "imageName": "86a7f088286fa75e3585f1b650bd5dd073b90f97bc4e5e2f46d37f1101503232",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 16,
                        "slide": 4,
                        "touch": 12,
                        "break": 2,
                        "total": 172
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11261,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 13,
                        "slide": 14,
                        "touch": 13,
                        "break": 7,
                        "total": 337
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11261,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 23,
                        "slide": 22,
                        "touch": 81,
                        "break": 10,
                        "total": 451
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11261,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 530,
                        "hold": 26,
                        "slide": 106,
                        "touch": 48,
                        "break": 11,
                        "total": 721
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11261,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM PLUS": 12.4,
                        "Splash PLUS": 12.2
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": [
                "☂",
                "Ame to Petra",
                "Rain and Petra",
                "伞",
                "佩特拉",
                "雨",
                "雨与佩特拉",
                "雨伞",
                "雨和佩特拉"
            ]
        },
        {
            "songId": "永遠にゲームで対戦したいキリタン",
            "category": "niconico＆ボーカロイド",
            "title": "永遠にゲームで対戦したいキリタン",
            "artist": "GYARI",
            "bpm": 126,
            "imageName": "e25dfa24a43db08536b6a0458b568fb0a2f568685168c39e1764d1d8ff96944b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 99,
                        "hold": 13,
                        "slide": 3,
                        "touch": 8,
                        "break": 1,
                        "total": 124
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11262,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 171,
                        "hold": 24,
                        "slide": 17,
                        "touch": 22,
                        "break": 5,
                        "total": 239
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11262,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 323,
                        "hold": 52,
                        "slide": 12,
                        "touch": 12,
                        "break": 43,
                        "total": 442
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11262,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 509,
                        "hold": 63,
                        "slide": 48,
                        "touch": 66,
                        "break": 43,
                        "total": 729
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11262,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": [
                "kiritan",
                "Kiritan Wants to Battle Online Forever",
                "东北切蒲英",
                "东北往事",
                "切蒲英",
                "切蒲英打电动",
                "宝〇梦",
                "对战",
                "对战游戏",
                "永远",
                "永远对战",
                "永远都想对战游戏",
                "永远都想玩对战游戏的切蒲英",
                "猫耳",
                "肝帝打不赢欧皇"
            ]
        },
        {
            "songId": "KING",
            "category": "niconico＆ボーカロイド",
            "title": "KING",
            "artist": "Kanaria",
            "bpm": 166,
            "imageName": "91efb343f04ac18cec6b91b7fb08d4bab72d8b0122897bc7b7adafd38a6a46c5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 13,
                        "slide": 3,
                        "touch": 8,
                        "break": 6,
                        "total": 133
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11263,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 242,
                        "hold": 12,
                        "slide": 11,
                        "touch": 36,
                        "break": 8,
                        "total": 309
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11263,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 382,
                        "hold": 48,
                        "slide": 34,
                        "touch": 30,
                        "break": 28,
                        "total": 522
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11263,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 572,
                        "hold": 57,
                        "slide": 86,
                        "touch": 27,
                        "break": 27,
                        "total": 769
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11263,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM": 13,
                        "PRiSM PLUS": 13,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": [
                "👑",
                "burger king",
                "你",
                "剔牙",
                "姐就是女王",
                "您",
                "无名指扣牙",
                "无名指抠牙",
                "汉堡王",
                "王",
                "霸者"
            ]
        },
        {
            "songId": "ロストワードクロニカル",
            "category": "東方Project",
            "title": "ロストワードクロニカル",
            "artist": "東方LostWord feat.いとうかなこ",
            "bpm": 184,
            "imageName": "56b307c881a0ad69a1c317a945a05e558f35eefbcebdc625147767df12889807",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 149,
                        "hold": 15,
                        "slide": 8,
                        "touch": 6,
                        "break": 4,
                        "total": 182
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11275,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 14,
                        "slide": 11,
                        "touch": 13,
                        "break": 12,
                        "total": 385
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11275,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 417,
                        "hold": 26,
                        "slide": 57,
                        "touch": 21,
                        "break": 10,
                        "total": 531
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11275,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 660,
                        "hold": 46,
                        "slide": 121,
                        "touch": 37,
                        "break": 57,
                        "total": 921
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11275,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": [
                "lost word chronicle",
                "Lost Word Chronicle",
                "Lost Word Chronicles",
                "lostword",
                "lw",
                "东方号哭",
                "东方归言录",
                "归言录",
                "牛魔酬宾"
            ]
        },
        {
            "songId": "今、誰が為のかがり火へ",
            "category": "東方Project",
            "title": "今、誰が為のかがり火へ",
            "artist": "幽閉サテライト(Produce:嵯峨飛鳥 Arranged:Iceon)",
            "bpm": 156,
            "imageName": "cdb6013bb44b9a027713eea774e22a4fa02bb5fa607ee9d0188ccccdca8f8606",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 10,
                        "slide": 5,
                        "touch": 10,
                        "break": 7,
                        "total": 167
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11276,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 261,
                        "hold": 16,
                        "slide": 12,
                        "touch": 18,
                        "break": 6,
                        "total": 313
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11276,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 24,
                        "slide": 41,
                        "touch": 42,
                        "break": 4,
                        "total": 404
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11276,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "アミノハバキリ",
                    "noteCounts": {
                        "tap": 499,
                        "hold": 45,
                        "slide": 93,
                        "touch": 20,
                        "break": 17,
                        "total": 674
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11276,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM PLUS": 12.4,
                        "Splash PLUS": 12.4
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": [
                "今",
                "今谁",
                "今谁为",
                "今谁为火",
                "现在，为了谁的篝火"
            ]
        },
        {
            "songId": "Re：End of a Dream",
            "category": "ゲーム＆バラエティ",
            "title": "Re：End of a Dream",
            "artist": "uma vs. モリモリあつし",
            "bpm": 212,
            "imageName": "6edff32d63ce43edab1eb3a8d3a78c5438250314acb4e8a6a135de7821cb8756",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 28,
                        "slide": 6,
                        "touch": 25,
                        "break": 6,
                        "total": 227
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11281,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 9,
                        "slide": 13,
                        "touch": 29,
                        "break": 20,
                        "total": 422
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11281,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 469,
                        "hold": 72,
                        "slide": 37,
                        "touch": 0,
                        "break": 51,
                        "total": 629
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11281,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "FESTiVAL": 12,
                        "FESTiVAL PLUS": 12,
                        "PRiSM PLUS": 12,
                        "UNiVERSE": 12,
                        "UNiVERSE PLUS": 12
                    },
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 707,
                        "hold": 164,
                        "slide": 60,
                        "touch": 114,
                        "break": 50,
                        "total": 1095
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11281,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.4,
                        "FESTiVAL PLUS": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "UNiVERSE PLUS": 14.4
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": [
                "re",
                "Re:End",
                "Re:end of dream",
                "reend",
                "女同4",
                "完梦",
                "幻梦",
                "我重塑你的梦",
                "梦的终点",
                "梦终",
                "梦结束",
                "终梦",
                "美女背靠背",
                "阿玛十则十"
            ]
        },
        {
            "songId": "もぺもぺ",
            "category": "ゲーム＆バラエティ",
            "title": "もぺもぺ",
            "artist": "LeaF & Optie",
            "bpm": 100,
            "imageName": "9f7c6f14667e766e8f615ed6a2e092cf0813151e374bf49c0b63cd9e1f7101f8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 82,
                        "hold": 8,
                        "slide": 3,
                        "touch": 6,
                        "break": 9,
                        "total": 108
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11282,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 159,
                        "hold": 28,
                        "slide": 11,
                        "touch": 42,
                        "break": 8,
                        "total": 248
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11282,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 34,
                        "slide": 44,
                        "touch": 24,
                        "break": 34,
                        "total": 350
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11282,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.5
                    },
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "さふぁた",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 221,
                        "slide": 40,
                        "touch": 44,
                        "break": 66,
                        "total": 676
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11282,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": [
                "mope",
                "mope mope",
                "mopemope",
                "niceboat",
                "もペもペ",
                "儿歌",
                "儿童金曲",
                "儿童鞋垫",
                "好船",
                "宝宝金曲",
                "小白船",
                "小花",
                "小花花",
                "小蓝花",
                "小鬼快乐歌",
                "恐怖小花",
                "恶心",
                "早八早八",
                "毛八",
                "毛八毛八",
                "烟火大会",
                "老八老八",
                "臀小鬼最爱",
                "草",
                "闪光弹",
                "鞋垫"
            ]
        },
        {
            "songId": "Sound Chimera",
            "category": "ゲーム＆バラエティ",
            "title": "Sound Chimera",
            "artist": "Laur",
            "bpm": 190,
            "imageName": "61f1385c88dd2b6fd53f7f9a5881915ccdaeb86b1641afdfb09182d017932978",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 10,
                        "slide": 4,
                        "touch": 4,
                        "break": 8,
                        "total": 183
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11283,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 355,
                        "hold": 21,
                        "slide": 15,
                        "touch": 12,
                        "break": 12,
                        "total": 415
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11283,
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 606,
                        "hold": 29,
                        "slide": 42,
                        "touch": 27,
                        "break": 31,
                        "total": 735
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11283,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash PLUS": 12.5,
                        "UNiVERSE": 12.5
                    },
                    "releaseDate": "2021-03-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 656,
                        "hold": 88,
                        "slide": 87,
                        "touch": 124,
                        "break": 26,
                        "total": 981
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11283,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2021-03-18"
                }
            ],
            "searchAcronyms": [
                "himera",
                "吃你妈",
                "声音奇美拉",
                "声音嵌合体",
                "天使马杀鸡",
                "奇美拉",
                "灵梦撒币plus",
                "老二玩花的",
                "骚的吃你妈"
            ]
        },
        {
            "songId": "ハジマリノピアノ",
            "category": "オンゲキ＆CHUNITHM",
            "title": "ハジマリノピアノ",
            "artist": "ゆゆうた",
            "bpm": 190,
            "imageName": "f63caaff845559b9c37f304e9f3e41515cfff3951be13ff3067783114d4e5e30",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 161,
                        "hold": 14,
                        "slide": 8,
                        "touch": 17,
                        "break": 4,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11243,
                    "releaseDate": "2021-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 20,
                        "slide": 25,
                        "touch": 28,
                        "break": 4,
                        "total": 354
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11243,
                    "releaseDate": "2021-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 360,
                        "hold": 64,
                        "slide": 60,
                        "touch": 73,
                        "break": 40,
                        "total": 597
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11243,
                    "multiverInternalLevelValue": {
                        "Splash PLUS": 10.8
                    },
                    "releaseDate": "2021-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 849,
                        "hold": 17,
                        "slide": 86,
                        "touch": 18,
                        "break": 12,
                        "total": 982
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11243,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2021-04-01"
                }
            ],
            "searchAcronyms": [
                "Hajimari no Piano",
                "yyut",
                "yyut教你扫键",
                "最初的钢琴",
                "哈吉玛丽弄钢琴",
                "钢琴"
            ]
        },
        {
            "songId": "タケモトピアノCMソング",
            "category": "POPS＆アニメ",
            "title": "タケモトピアノCMソング",
            "artist": "タケモトピアノCM",
            "bpm": 122,
            "imageName": "1fc15a3759bb19848a0f44b2d56cc27484a23ac412614edf1b1bc43eea759afd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 19,
                        "hold": 13,
                        "slide": 4,
                        "touch": 14,
                        "break": 2,
                        "total": 52
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11255,
                    "releaseDate": "2021-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 74,
                        "hold": 8,
                        "slide": 9,
                        "touch": 0,
                        "break": 17,
                        "total": 108
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11255,
                    "releaseDate": "2021-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 111,
                        "hold": 12,
                        "slide": 20,
                        "touch": 19,
                        "break": 8,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11255,
                    "multiverInternalLevelValue": {
                        "Splash PLUS": 9
                    },
                    "releaseDate": "2021-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 179,
                        "hold": 5,
                        "slide": 45,
                        "touch": 44,
                        "break": 37,
                        "total": 310
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11255,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2021-04-01"
                }
            ],
            "searchAcronyms": [
                "0120370009",
                "0800",
                "cm",
                "CM",
                "卖钢琴",
                "原谅你了小鬼",
                "广告",
                "广告歌",
                "机厅老板快乐歌",
                "猫和老鼠开头",
                "电话号码",
                "竹本钢琴",
                "超级变变变",
                "钢琴广告"
            ]
        },
        {
            "songId": "オーケー？　オーライ！",
            "category": "オンゲキ＆CHUNITHM",
            "title": "オーケー？　オーライ！",
            "artist": "五十嵐 撫子(CV:花井 美春)",
            "bpm": 150,
            "imageName": "a83a050db82a0dc7260df25d364df1e7579e0d646c57676dc74552591e788ae1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 9,
                        "slide": 5,
                        "touch": 6,
                        "break": 1,
                        "total": 172
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11239,
                    "releaseDate": "2021-04-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 26,
                        "slide": 18,
                        "touch": 8,
                        "break": 10,
                        "total": 338
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11239,
                    "releaseDate": "2021-04-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 109,
                        "slide": 24,
                        "touch": 10,
                        "break": 33,
                        "total": 498
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11239,
                    "releaseDate": "2021-04-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 540,
                        "hold": 26,
                        "slide": 139,
                        "touch": 36,
                        "break": 11,
                        "total": 752
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11239,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2021-04-09"
                }
            ],
            "searchAcronyms": [
                "？！",
                "3q",
                "ok",
                "Ok Alright",
                "Okay Alright"
            ]
        },
        {
            "songId": "サヨナラフリーウェイ",
            "category": "オンゲキ＆CHUNITHM",
            "title": "サヨナラフリーウェイ",
            "artist": "萩原 七々瀬(CV:東城 日沙子)",
            "bpm": 170,
            "imageName": "80963f75427660c85a598d8186707c00aff28d28dd04a7ffe100f71e461f8a79",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 110,
                        "hold": 11,
                        "slide": 5,
                        "touch": 6,
                        "break": 1,
                        "total": 133
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11240,
                    "releaseDate": "2021-04-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 18,
                        "slide": 13,
                        "touch": 16,
                        "break": 9,
                        "total": 288
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11240,
                    "releaseDate": "2021-04-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 249,
                        "hold": 55,
                        "slide": 32,
                        "touch": 13,
                        "break": 2,
                        "total": 351
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11240,
                    "releaseDate": "2021-04-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 407,
                        "hold": 34,
                        "slide": 70,
                        "touch": 9,
                        "break": 16,
                        "total": 536
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11240,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL": 12.6,
                        "FESTiVAL PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2021-04-09"
                }
            ],
            "searchAcronyms": [
                "Sayonara Freeway",
                "再见",
                "再见高速公路",
                "我有抑郁症",
                "抑郁症"
            ]
        },
        {
            "songId": "単一指向性オーバーブルーム",
            "category": "オンゲキ＆CHUNITHM",
            "title": "単一指向性オーバーブルーム",
            "artist": "葛城 華(CV:丸岡 和佳奈)",
            "bpm": 158,
            "imageName": "634a0c5ebc1e98f4f76be3339cf2b7d5c54d879ac8b287e6caa13940c4ec98c7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 130,
                        "hold": 24,
                        "slide": 3,
                        "touch": 9,
                        "break": 5,
                        "total": 171
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11241,
                    "releaseDate": "2021-04-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 17,
                        "slide": 13,
                        "touch": 27,
                        "break": 6,
                        "total": 358
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11241,
                    "releaseDate": "2021-04-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 68,
                        "slide": 42,
                        "touch": 74,
                        "break": 26,
                        "total": 574
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11241,
                    "releaseDate": "2021-04-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Redarrow",
                    "noteCounts": {
                        "tap": 635,
                        "hold": 95,
                        "slide": 91,
                        "touch": 44,
                        "break": 59,
                        "total": 924
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11241,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2021-04-09"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 801,
                        "hold": 45,
                        "slide": 118,
                        "touch": 93,
                        "break": 23,
                        "total": 1080
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11241,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2021-04-09"
                }
            ],
            "searchAcronyms": [
                "Overbloom",
                "Unidirectional Overbloom",
                "单一",
                "单一手癖性",
                "单一指向性",
                "单向性",
                "大额头",
                "开花"
            ]
        },
        {
            "songId": "みなえをチェック！",
            "category": "オンゲキ＆CHUNITHM",
            "title": "みなえをチェック！",
            "artist": "小野 美苗(CV:伊藤 美来)",
            "bpm": 178,
            "imageName": "b7bab1878cbdee0ae5867995965696be243fe323983d53c6ba9d82f4ee416d8a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 136,
                        "hold": 23,
                        "slide": 2,
                        "touch": 9,
                        "break": 5,
                        "total": 175
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11242,
                    "releaseDate": "2021-04-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 27,
                        "slide": 13,
                        "touch": 31,
                        "break": 8,
                        "total": 421
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11242,
                    "releaseDate": "2021-04-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 368,
                        "hold": 62,
                        "slide": 38,
                        "touch": 15,
                        "break": 32,
                        "total": 515
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11242,
                    "releaseDate": "2021-04-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 631,
                        "hold": 57,
                        "slide": 133,
                        "touch": 95,
                        "break": 22,
                        "total": 938
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11242,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2021-04-09"
                }
            ],
            "searchAcronyms": [
                "Minae wo Check",
                "口水歌",
                "指挥棒",
                "注目",
                "美苗"
            ]
        },
        {
            "songId": "CO5M1C R4ILR0AD",
            "category": "ゲーム＆バラエティ",
            "title": "CO5M1C R4ILR0AD",
            "artist": "kanone",
            "bpm": 155,
            "imageName": "bb375466af93f4c9ea79d708204eecdd7bab87ed50efb371c1793ec80338017d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 10,
                        "slide": 4,
                        "touch": 8,
                        "break": 5,
                        "total": 172
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11284,
                    "releaseDate": "2021-04-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 23,
                        "slide": 12,
                        "touch": 23,
                        "break": 14,
                        "total": 364
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11284,
                    "releaseDate": "2021-04-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 288,
                        "hold": 87,
                        "slide": 53,
                        "touch": 44,
                        "break": 12,
                        "total": 484
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11284,
                    "multiverInternalLevelValue": {
                        "Splash PLUS": 11.8
                    },
                    "releaseDate": "2021-04-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 787,
                        "hold": 58,
                        "slide": 75,
                        "touch": 35,
                        "break": 35,
                        "total": 990
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11284,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.4,
                        "FESTiVAL PLUS": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "Splash PLUS": 14.2,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.3
                    },
                    "releaseDate": "2021-04-16"
                }
            ],
            "searchAcronyms": [
                "⭐️奴",
                "514",
                "5140",
                "co5",
                "cosmic railroad",
                "railroad",
                "五氧化碳",
                "哎呀那没办法铁轨总得创似一个人那就吧你给创似吧",
                "宇宙泥头车",
                "宇宙铁路",
                "宇宙铁道",
                "我创死你",
                "星奴",
                "星怒铁道",
                "星穹轨道",
                "星穹铁道",
                "星铁",
                "水晶火车",
                "火车头",
                "磁小轨",
                "铁路",
                "银河列车",
                "银河超级快的泥头车创死你",
                "银河铁路",
                "银河铁道",
                "雷切2"
            ]
        },
        {
            "songId": "MAKE IT FUNKY NOW",
            "category": "ゲーム＆バラエティ",
            "title": "MAKE IT FUNKY NOW",
            "artist": "DOT96",
            "bpm": 146,
            "imageName": "4b11119e1ffc3bc6b15f1954da49d4df32a0355d12c44bbd162ae05f031c675f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 126,
                        "hold": 10,
                        "slide": 4,
                        "touch": 9,
                        "break": 2,
                        "total": 151
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11285,
                    "releaseDate": "2021-04-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 25,
                        "slide": 12,
                        "touch": 40,
                        "break": 8,
                        "total": 284
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11285,
                    "releaseDate": "2021-04-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 288,
                        "hold": 87,
                        "slide": 53,
                        "touch": 44,
                        "break": 12,
                        "total": 484
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11285,
                    "multiverInternalLevelValue": {
                        "Splash PLUS": 11
                    },
                    "releaseDate": "2021-04-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 453,
                        "hold": 43,
                        "slide": 118,
                        "touch": 155,
                        "break": 18,
                        "total": 787
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11285,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2021-04-16"
                }
            ],
            "searchAcronyms": [
                "🥪",
                "funky",
                "FUNKY",
                "makeitfuckynow",
                "mifn",
                "MILF",
                "sandwich",
                "三明治",
                "两面包夹培根",
                "两面包夹芝士"
            ]
        },
        {
            "songId": "Rush-More",
            "category": "ゲーム＆バラエティ",
            "title": "Rush-More",
            "artist": "litmus*",
            "bpm": 160,
            "imageName": "6375f3144869c2fe1815479e043f398d1a38695f32093d03b248abc346ec8cd4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 90,
                        "hold": 11,
                        "slide": 4,
                        "touch": 6,
                        "break": 7,
                        "total": 118
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11286,
                    "releaseDate": "2021-04-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 12,
                        "slide": 13,
                        "touch": 27,
                        "break": 14,
                        "total": 313
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11286,
                    "releaseDate": "2021-04-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 391,
                        "hold": 81,
                        "slide": 12,
                        "touch": 52,
                        "break": 16,
                        "total": 552
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11286,
                    "releaseDate": "2021-04-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 645,
                        "hold": 48,
                        "slide": 111,
                        "touch": 35,
                        "break": 18,
                        "total": 857
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11286,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM PLUS": 13.5,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.5
                    },
                    "releaseDate": "2021-04-16"
                }
            ],
            "searchAcronyms": [
                "rush",
                "rush more",
                "rushmore",
                "冲多了",
                "冲多点",
                "冲很多",
                "冲更多",
                "多冲",
                "多冲点"
            ]
        },
        {
            "songId": "ステップアンドライム",
            "category": "maimai",
            "title": "ステップアンドライム",
            "artist": "YASUHIRO(康寛)",
            "bpm": 155,
            "imageName": "83e4301a4071279e06d9e971fd751929afe571a4cd17b277e41dff974fb325c0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 16,
                        "slide": 4,
                        "touch": 17,
                        "break": 3,
                        "total": 168
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11169,
                    "releaseDate": "2021-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 23,
                        "slide": 28,
                        "touch": 17,
                        "break": 12,
                        "total": 321
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11169,
                    "releaseDate": "2021-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 368,
                        "hold": 79,
                        "slide": 33,
                        "touch": 14,
                        "break": 7,
                        "total": 501
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11169,
                    "releaseDate": "2021-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 605,
                        "hold": 83,
                        "slide": 75,
                        "touch": 57,
                        "break": 23,
                        "total": 843
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11169,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8
                    },
                    "releaseDate": "2021-04-28"
                }
            ],
            "searchAcronyms": [
                "stepandlime",
                "来来来",
                "间谍过家家"
            ]
        },
        {
            "songId": "届かない花束",
            "category": "maimai",
            "title": "届かない花束",
            "artist": "ELECTROCUTICA",
            "bpm": 180,
            "imageName": "9b90087c1a8b5d8ae097e915bddb6cfb389a8dd153e2b48477fcde650f2402c9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 23,
                        "slide": 2,
                        "touch": 10,
                        "break": 1,
                        "total": 141
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11170,
                    "releaseDate": "2021-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 198,
                        "hold": 18,
                        "slide": 21,
                        "touch": 42,
                        "break": 4,
                        "total": 283
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11170,
                    "releaseDate": "2021-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 271,
                        "hold": 97,
                        "slide": 28,
                        "touch": 9,
                        "break": 14,
                        "total": 419
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11170,
                    "releaseDate": "2021-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 421,
                        "hold": 105,
                        "slide": 100,
                        "touch": 23,
                        "break": 10,
                        "total": 659
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11170,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13.1,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2021-04-28"
                }
            ],
            "searchAcronyms": [
                "传达不到的花束",
                "届不到的花束",
                "届花束",
                "花束",
                "送不到的花束"
            ]
        },
        {
            "songId": "幽霊東京",
            "category": "niconico＆ボーカロイド",
            "title": "幽霊東京",
            "artist": "Ayase",
            "bpm": 124,
            "imageName": "ae5b4814d6177c2d9780cd2e2484ea9225ffad17b436fb7d97a69999ceff7a7d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 66,
                        "hold": 11,
                        "slide": 3,
                        "touch": 7,
                        "break": 1,
                        "total": 88
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11264,
                    "releaseDate": "2021-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 25,
                        "slide": 14,
                        "touch": 10,
                        "break": 5,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11264,
                    "releaseDate": "2021-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 325,
                        "hold": 47,
                        "slide": 25,
                        "touch": 34,
                        "break": 6,
                        "total": 437
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11264,
                    "releaseDate": "2021-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 452,
                        "hold": 68,
                        "slide": 60,
                        "touch": 78,
                        "break": 14,
                        "total": 672
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11264,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash PLUS": 12.5
                    },
                    "releaseDate": "2021-04-28"
                }
            ],
            "searchAcronyms": [
                "Ghost City Tokyo",
                "Yuurei Tokyo",
                "东京",
                "幽灵东京",
                "幽灵京东",
                "幽灵北京",
                "幽灵线东京",
                "诱0东京"
            ]
        },
        {
            "songId": "Strange Bar",
            "category": "ゲーム＆バラエティ",
            "title": "Strange Bar",
            "artist": "Laur",
            "bpm": 110,
            "imageName": "a2aa36d8a0c13327af952fcfbdaea9437efbbf62a06c7d15582b71e5d06941fb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 110,
                        "hold": 9,
                        "slide": 4,
                        "touch": 7,
                        "break": 1,
                        "total": 131
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11287,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 25,
                        "slide": 19,
                        "touch": 49,
                        "break": 10,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11287,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 378,
                        "hold": 59,
                        "slide": 46,
                        "touch": 61,
                        "break": 11,
                        "total": 555
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11287,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 677,
                        "hold": 49,
                        "slide": 104,
                        "touch": 16,
                        "break": 36,
                        "total": 882
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11287,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2021-05-14"
                }
            ],
            "searchAcronyms": [
                "sb",
                "sb2",
                "初音未来提着两个黄色老鼠头",
                "别急11",
                "大黄蜂",
                "奇怪的吧",
                "奇怪的胸罩",
                "奇怪的酒吧",
                "奇怪罩杯",
                "奇怪酒吧",
                "小金熊",
                "怪吧",
                "怪酒吧",
                "我",
                "我2",
                "我又",
                "斯特兰奇酒吧",
                "死转几把",
                "酒吧",
                "酒老二"
            ]
        },
        {
            "songId": "Big Daddy",
            "category": "ゲーム＆バラエティ",
            "title": "Big Daddy",
            "artist": "USAO",
            "bpm": 190,
            "imageName": "d0f0583d6ec949bb033534abe1bf0e7d04dfa6deb844798c28aa9d51895e61d1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 15,
                        "slide": 4,
                        "touch": 7,
                        "break": 5,
                        "total": 169
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11288,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 376,
                        "hold": 17,
                        "slide": 16,
                        "touch": 35,
                        "break": 18,
                        "total": 462
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11288,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 464,
                        "hold": 103,
                        "slide": 88,
                        "touch": 47,
                        "break": 19,
                        "total": 721
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11288,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "FESTiVAL PLUS": 12,
                        "PRiSM PLUS": 12,
                        "Splash PLUS": 12
                    },
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 677,
                        "hold": 77,
                        "slide": 144,
                        "touch": 57,
                        "break": 45,
                        "total": 1000
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11288,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2021-05-14"
                }
            ],
            "searchAcronyms": [
                "🤩",
                "🥵",
                "你",
                "你又",
                "大爸爸",
                "大爹",
                "大跌",
                "尼玛啊 好热",
                "您",
                "我推的孩子",
                "星野爱",
                "星野爱高潮",
                "机厅不开空调歌",
                "机厅好热",
                "比格大帝",
                "汤姆猫",
                "爸爸爷",
                "神木光干的",
                "群友",
                "老头发力了",
                "逼格大帝"
            ]
        },
        {
            "songId": "ベースラインやってる？笑",
            "category": "ゲーム＆バラエティ",
            "title": "ベースラインやってる？笑",
            "artist": "かめりあ feat. ななひら",
            "bpm": 128,
            "imageName": "1fbd9f7f5fccee27940fd3eef422093c826c99ba92515925a7bd8c1dbbc59ff9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 9,
                        "slide": 3,
                        "touch": 7,
                        "break": 2,
                        "total": 126
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11289,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 44,
                        "slide": 17,
                        "touch": 23,
                        "break": 10,
                        "total": 317
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11289,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 56,
                        "slide": 45,
                        "touch": 108,
                        "break": 18,
                        "total": 524
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11289,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 447,
                        "hold": 39,
                        "slide": 90,
                        "touch": 63,
                        "break": 53,
                        "total": 692
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11289,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2021-05-14"
                }
            ],
            "searchAcronyms": [
                "baseline",
                "bassbook",
                "bassline",
                "Bassline Yatteru",
                "Can I friend you on Bassbook",
                "Can I friend you on Bassbook? lol",
                "lol",
                "nanahira",
                "什么什么笑",
                "变态萝莉",
                "女流氓",
                "妹妹恰个v",
                "学妹恰个v",
                "痴女nanahira",
                "笑",
                "颜文字"
            ]
        },
        {
            "songId": "ALiVE",
            "category": "ゲーム＆バラエティ",
            "title": "ALiVE",
            "artist": "REDALiCE",
            "bpm": 170,
            "imageName": "d3061f88a4cc869eed8c907543549cf27668a61b18c197636513b984aac824ec",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 106,
                        "hold": 7,
                        "slide": 3,
                        "touch": 6,
                        "break": 2,
                        "total": 124
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11290,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 11,
                        "slide": 14,
                        "touch": 16,
                        "break": 10,
                        "total": 307
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11290,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 369,
                        "hold": 40,
                        "slide": 28,
                        "touch": 14,
                        "break": 10,
                        "total": 461
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11290,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 465,
                        "hold": 75,
                        "slide": 93,
                        "touch": 95,
                        "break": 20,
                        "total": 748
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11290,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.1
                    },
                    "releaseDate": "2021-05-14"
                }
            ],
            "searchAcronyms": [
                "嗷呜",
                "活",
                "活着"
            ]
        },
        {
            "songId": "ヒミツCULT",
            "category": "ゲーム＆バラエティ",
            "title": "ヒミツCULT",
            "artist": "t+pazolite",
            "bpm": 190,
            "imageName": "1518b215726262a51a0c9aecfc1757fa1e2c31757f3c4279b3f27d897efc4214",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 140,
                        "hold": 9,
                        "slide": 2,
                        "touch": 16,
                        "break": 4,
                        "total": 171
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11291,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 348,
                        "hold": 23,
                        "slide": 17,
                        "touch": 32,
                        "break": 14,
                        "total": 434
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11291,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 474,
                        "hold": 67,
                        "slide": 48,
                        "touch": 80,
                        "break": 14,
                        "total": 683
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11291,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 671,
                        "hold": 48,
                        "slide": 99,
                        "touch": 50,
                        "break": 45,
                        "total": 913
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11291,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2021-05-14"
                }
            ],
            "searchAcronyms": [
                "cult",
                "吹月2",
                "我们都很棒",
                "教程曲",
                "秘密信徒"
            ]
        },
        {
            "songId": "MEGATON KICK",
            "category": "ゲーム＆バラエティ",
            "title": "MEGATON KICK",
            "artist": "DJ Myosuke",
            "bpm": 200,
            "imageName": "2d1d3fa587cd1e933737465230c65bea5ee97c97f4ab4f778710801e77e6203d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 17,
                        "slide": 2,
                        "touch": 12,
                        "break": 8,
                        "total": 181
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11292,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 329,
                        "hold": 16,
                        "slide": 23,
                        "touch": 48,
                        "break": 10,
                        "total": 426
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11292,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 516,
                        "hold": 61,
                        "slide": 9,
                        "touch": 74,
                        "break": 22,
                        "total": 682
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11292,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "ロシアンブラック",
                    "noteCounts": {
                        "tap": 631,
                        "hold": 39,
                        "slide": 113,
                        "touch": 102,
                        "break": 53,
                        "total": 938
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11292,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash PLUS": 14.1,
                        "UNiVERSE": 14.1,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2021-05-14"
                }
            ],
            "searchAcronyms": [
                "kick",
                "MK",
                "兆吨",
                "大飞脚",
                "拉普兰德",
                "李宁踹开线",
                "百万吨级踢腿",
                "百万吨踢",
                "百万吨飞踢",
                "踢腿",
                "钢踢"
            ]
        },
        {
            "songId": "LOSE CONTROL",
            "category": "ゲーム＆バラエティ",
            "title": "LOSE CONTROL",
            "artist": "Massive New Krew",
            "bpm": 150,
            "imageName": "418b3350e722cb6437370b7625b4933e2884ed556bfce556d85dea0304abd07a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 4,
                        "slide": 4,
                        "touch": 8,
                        "break": 6,
                        "total": 125
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11293,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 48,
                        "slide": 11,
                        "touch": 33,
                        "break": 7,
                        "total": 274
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11293,
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 300,
                        "hold": 43,
                        "slide": 32,
                        "touch": 65,
                        "break": 54,
                        "total": 494
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11293,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM PLUS": 12.4,
                        "Splash PLUS": 12
                    },
                    "releaseDate": "2021-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 390,
                        "hold": 19,
                        "slide": 139,
                        "touch": 50,
                        "break": 17,
                        "total": 615
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11293,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash PLUS": 13.5,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.5
                    },
                    "releaseDate": "2021-05-14"
                }
            ],
            "searchAcronyms": [
                "塔露拉",
                "失去控制",
                "失控"
            ]
        },
        {
            "songId": "星めぐり、果ての君へ。",
            "category": "maimai",
            "title": "星めぐり、果ての君へ。",
            "artist": "TAKU1175 ft.駄々子",
            "bpm": 175,
            "imageName": "81565940ceca08dad9c24880a01f44decb2a266717c06625fd16ae2029f844a1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 24,
                        "slide": 11,
                        "touch": 5,
                        "break": 1,
                        "total": 179
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11228,
                    "releaseDate": "2021-05-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 249,
                        "hold": 25,
                        "slide": 35,
                        "touch": 28,
                        "break": 8,
                        "total": 345
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11228,
                    "releaseDate": "2021-05-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 373,
                        "hold": 54,
                        "slide": 55,
                        "touch": 23,
                        "break": 15,
                        "total": 520
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11228,
                    "releaseDate": "2021-05-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "隅田川華火大会",
                    "noteCounts": {
                        "tap": 506,
                        "hold": 52,
                        "slide": 80,
                        "touch": 53,
                        "break": 29,
                        "total": 720
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11228,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2021-05-28"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 640,
                        "hold": 32,
                        "slide": 94,
                        "touch": 58,
                        "break": 18,
                        "total": 842
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11228,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2022-09-14"
                }
            ],
            "searchAcronyms": [
                "🥺",
                "Hoshimeguri",
                "Hoshimeguri Hateno Kimihe",
                "星斗流转、赴你为终",
                "星果",
                "星果君",
                "星间巡游致尽头的你"
            ]
        },
        {
            "songId": "スローアライズ",
            "category": "maimai",
            "title": "スローアライズ",
            "artist": "Endorfin.",
            "bpm": 185,
            "imageName": "b93a508470a63b7ff57479d4907a093edc89e8568c36203b70503a6a1042dbe4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 95,
                        "hold": 20,
                        "slide": 4,
                        "touch": 16,
                        "break": 1,
                        "total": 136
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11229,
                    "releaseDate": "2021-05-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 173,
                        "hold": 20,
                        "slide": 22,
                        "touch": 31,
                        "break": 9,
                        "total": 255
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11229,
                    "releaseDate": "2021-05-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 310,
                        "hold": 41,
                        "slide": 39,
                        "touch": 30,
                        "break": 8,
                        "total": 428
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11229,
                    "releaseDate": "2021-05-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "群青リコリス",
                    "noteCounts": {
                        "tap": 396,
                        "hold": 38,
                        "slide": 71,
                        "touch": 43,
                        "break": 8,
                        "total": 556
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11229,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2021-05-28"
                }
            ],
            "searchAcronyms": [
                "slowarise",
                "SlowArise",
                "鲸鱼情侣"
            ]
        },
        {
            "songId": "チエルカ／エソテリカ",
            "category": "maimai",
            "title": "チエルカ／エソテリカ",
            "artist": "ツミキ × 宮下遊",
            "bpm": 205,
            "imageName": "35c25daec9ad947444b55005ee3ec1c73230357e2904b3e6194f623155c39d07",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 22,
                        "slide": 6,
                        "touch": 13,
                        "break": 6,
                        "total": 222
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11230,
                    "releaseDate": "2021-05-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 22,
                        "slide": 12,
                        "touch": 38,
                        "break": 17,
                        "total": 445
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11230,
                    "releaseDate": "2021-05-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 561,
                        "hold": 94,
                        "slide": 37,
                        "touch": 16,
                        "break": 33,
                        "total": 741
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11230,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "BUDDiES PLUS": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash PLUS": 12.7,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2021-05-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "Safata.Hz",
                    "noteCounts": {
                        "tap": 800,
                        "hold": 49,
                        "slide": 123,
                        "touch": 73,
                        "break": 73,
                        "total": 1118
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11230,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.1,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "Splash PLUS": 14.1,
                        "UNiVERSE": 14.1,
                        "UNiVERSE PLUS": 14.1
                    },
                    "releaseDate": "2021-05-28"
                }
            ],
            "searchAcronyms": [
                "4/5",
                "cerca/esoterica",
                "チエルカ/エソテリカ",
                "企鹅卢卡",
                "倒立消防员",
                "切噜卡",
                "千工儿力",
                "呐",
                "呐呐呐",
                "呐呐呐呐",
                "四个日本字五个日本字",
                "四个日本字左斜杠五个日本字",
                "四个日本字斜杠五个日本字",
                "四个日本字杠五个日本字",
                "四个日语字不会念斜杠五个日语字不会念",
                "四日本字/五个日本字",
                "宫下游",
                "小绿人",
                "工力工力",
                "捏",
                "探寻/秘密",
                "探寻秘密",
                "摔倒",
                "擦玻璃",
                "条形码",
                "消防员",
                "渊下宫",
                "铅汞",
                "黄鼠狼"
            ]
        },
        {
            "songId": "生命不詳",
            "category": "maimai",
            "title": "生命不詳",
            "artist": "蜂屋ななし",
            "bpm": 200,
            "imageName": "c7ccf9ea3d81f662f629d3d4a7390c9c3c79fb18227759230365d6339be8c6eb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 17,
                        "slide": 2,
                        "touch": 6,
                        "break": 2,
                        "total": 178
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11231,
                    "releaseDate": "2021-05-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 298,
                        "hold": 42,
                        "slide": 13,
                        "touch": 24,
                        "break": 4,
                        "total": 381
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11231,
                    "releaseDate": "2021-05-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 323,
                        "hold": 148,
                        "slide": 50,
                        "touch": 59,
                        "break": 16,
                        "total": 596
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11231,
                    "releaseDate": "2021-05-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 537,
                        "hold": 53,
                        "slide": 137,
                        "touch": 94,
                        "break": 9,
                        "total": 830
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11231,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash PLUS": 13.4,
                        "UNiVERSE": 13.4,
                        "UNiVERSE PLUS": 13.4
                    },
                    "releaseDate": "2021-05-28"
                }
            ],
            "searchAcronyms": [
                "不知死活",
                "半死不活",
                "新手还打8",
                "死不明白",
                "生命不详",
                "生母不详",
                "那你摸哪里哟"
            ]
        },
        {
            "songId": "Melody！",
            "category": "東方Project",
            "title": "Melody！",
            "artist": "あ～るの～と（いえろ～ぜぶら）",
            "bpm": 175,
            "imageName": "c0a9adb7a53af70a733c36ce49a04e8ac719014cc3c0976f8eeaa3197f7a1756",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 110,
                        "hold": 16,
                        "slide": 4,
                        "touch": 16,
                        "break": 5,
                        "total": 151
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11277,
                    "releaseDate": "2021-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 21,
                        "slide": 27,
                        "touch": 19,
                        "break": 7,
                        "total": 351
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11277,
                    "releaseDate": "2021-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 380,
                        "hold": 54,
                        "slide": 32,
                        "touch": 46,
                        "break": 12,
                        "total": 524
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11277,
                    "releaseDate": "2021-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "はっぴー respects for 某S氏",
                    "noteCounts": {
                        "tap": 544,
                        "hold": 52,
                        "slide": 91,
                        "touch": 24,
                        "break": 10,
                        "total": 721
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11277,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "PRiSM PLUS": 12.2
                    },
                    "releaseDate": "2021-06-11"
                }
            ],
            "searchAcronyms": [
                "melody",
                "东方绚彩歌",
                "旋律",
                "美乐蒂",
                "马老弟"
            ]
        },
        {
            "songId": "下克上々",
            "category": "東方Project",
            "title": "下克上々",
            "artist": "豚乙女",
            "bpm": 164,
            "imageName": "a73272388cb4d77730676acffc3c6a176a84f180571bc50676cbbfbba08bf8f9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 101,
                        "hold": 15,
                        "slide": 6,
                        "touch": 6,
                        "break": 5,
                        "total": 133
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11278,
                    "releaseDate": "2021-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 252,
                        "hold": 25,
                        "slide": 10,
                        "touch": 29,
                        "break": 12,
                        "total": 328
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11278,
                    "releaseDate": "2021-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 56,
                        "slide": 51,
                        "touch": 21,
                        "break": 6,
                        "total": 472
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11278,
                    "multiverInternalLevelValue": {
                        "Splash PLUS": 10.2
                    },
                    "releaseDate": "2021-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 632,
                        "hold": 54,
                        "slide": 79,
                        "touch": 16,
                        "break": 46,
                        "total": 827
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11278,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2021-06-11"
                }
            ],
            "searchAcronyms": [
                "0克1",
                "下克上",
                "少女炼狱2",
                "正邪",
                "田忌赛马",
                "长发疯批男"
            ]
        },
        {
            "songId": "ハウリング",
            "category": "東方Project",
            "title": "ハウリング",
            "artist": "Liz Triangle",
            "bpm": 184,
            "imageName": "8215d67ffc4edba563f2fbb6ae54012d21acd96806fc6c896670ff90fc4d0278",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 122,
                        "hold": 12,
                        "slide": 6,
                        "touch": 6,
                        "break": 5,
                        "total": 151
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11279,
                    "releaseDate": "2021-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 25,
                        "slide": 19,
                        "touch": 13,
                        "break": 5,
                        "total": 299
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11279,
                    "releaseDate": "2021-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 320,
                        "hold": 45,
                        "slide": 33,
                        "touch": 10,
                        "break": 16,
                        "total": 424
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11279,
                    "releaseDate": "2021-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 404,
                        "hold": 52,
                        "slide": 111,
                        "touch": 83,
                        "break": 34,
                        "total": 684
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11279,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13.1,
                        "Splash PLUS": 12.8
                    },
                    "releaseDate": "2021-06-11"
                }
            ],
            "searchAcronyms": [
                "howling",
                "Howling",
                "yellow",
                "黄",
                "黄灵梦"
            ]
        },
        {
            "songId": "トランスダンスアナーキー",
            "category": "東方Project",
            "title": "トランスダンスアナーキー",
            "artist": "暁Records",
            "bpm": 195,
            "imageName": "82f2645cec7155d2d670aa21970f9698b1fe035e9d86126c86f88e817d32710d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 8,
                        "slide": 4,
                        "touch": 8,
                        "break": 7,
                        "total": 215
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11280,
                    "releaseDate": "2021-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 53,
                        "slide": 13,
                        "touch": 57,
                        "break": 12,
                        "total": 402
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11280,
                    "releaseDate": "2021-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 490,
                        "hold": 37,
                        "slide": 28,
                        "touch": 48,
                        "break": 50,
                        "total": 653
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11280,
                    "multiverInternalLevelValue": {
                        "Splash PLUS": 10.8
                    },
                    "releaseDate": "2021-06-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 656,
                        "hold": 25,
                        "slide": 178,
                        "touch": 29,
                        "break": 44,
                        "total": 932
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11280,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5,
                        "Splash PLUS": 13.3,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.3
                    },
                    "releaseDate": "2021-06-11"
                }
            ],
            "searchAcronyms": [
                "trance",
                "trance dance anarchy",
                "Trance Dance Anarchy",
                "女同9",
                "尬舞姐妹"
            ]
        },
        {
            "songId": "Last Samurai",
            "category": "maimai",
            "title": "Last Samurai",
            "artist": "Street",
            "bpm": 57,
            "imageName": "2296db399affd5fc51a1a92af366bc25026f3694475c6749e49cb8050cc76677",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 126,
                        "hold": 13,
                        "slide": 4,
                        "touch": 23,
                        "break": 6,
                        "total": 172
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11236,
                    "releaseDate": "2021-06-25"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 303,
                        "hold": 14,
                        "slide": 22,
                        "touch": 38,
                        "break": 12,
                        "total": 389
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11236,
                    "releaseDate": "2021-06-25"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 36,
                        "slide": 44,
                        "touch": 6,
                        "break": 7,
                        "total": 247
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11236,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12,
                        "Splash PLUS": 12
                    },
                    "releaseDate": "2021-06-25"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 42,
                        "slide": 105,
                        "touch": 8,
                        "break": 4,
                        "total": 449
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11236,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2021-06-25"
                }
            ],
            "searchAcronyms": [
                "11月的雨",
                "dx四月雨",
                "lastsamurai",
                "last炫",
                "六月的答辩",
                "六月的雨",
                "六月的食",
                "六月雨",
                "最后武士",
                "最后的武士",
                "别急5",
                "十一月的雨",
                "年末的雨",
                "拆弹",
                "星星武士",
                "武士",
                "绝地武士",
                "黄金船"
            ]
        },
        {
            "songId": "蒼穹舞楽",
            "category": "maimai",
            "title": "蒼穹舞楽",
            "artist": "Capchii",
            "bpm": 195,
            "imageName": "c9c4eb192a7563feb328406e0d4cfce0461edea3b3acd41162c236fef85bd28f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 160,
                        "hold": 5,
                        "slide": 8,
                        "touch": 22,
                        "break": 6,
                        "total": 201
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11237,
                    "releaseDate": "2021-05-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 303,
                        "hold": 14,
                        "slide": 22,
                        "touch": 38,
                        "break": 12,
                        "total": 389
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11237,
                    "releaseDate": "2021-05-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 498,
                        "hold": 68,
                        "slide": 43,
                        "touch": 57,
                        "break": 22,
                        "total": 688
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11237,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2021-05-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 610,
                        "hold": 61,
                        "slide": 98,
                        "touch": 78,
                        "break": 31,
                        "total": 878
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11237,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "Splash PLUS": 13.9,
                        "UNiVERSE": 14,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2021-05-28"
                }
            ],
            "searchAcronyms": [
                "Soukyu Bugaku",
                "Yukyu Buraku",
                "斗破苍穹",
                "神里绫人",
                "苍穹",
                "苍穹舞乐",
                "菅穹舞乐"
            ]
        },
        {
            "songId": "AMABIE",
            "category": "maimai",
            "title": "AMABIE",
            "artist": "OSTER project",
            "bpm": 190,
            "imageName": "3e999dcebd1b2eb877944b7a312c845bcd70750e819f844e95ec1907916b8e4a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 202,
                        "hold": 4,
                        "slide": 5,
                        "touch": 8,
                        "break": 2,
                        "total": 221
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11238,
                    "releaseDate": "2021-06-25"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 328,
                        "hold": 23,
                        "slide": 25,
                        "touch": 26,
                        "break": 9,
                        "total": 411
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11238,
                    "releaseDate": "2021-06-25"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 374,
                        "hold": 44,
                        "slide": 57,
                        "touch": 77,
                        "break": 60,
                        "total": 612
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11238,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM PLUS": 12.4,
                        "Splash PLUS": 12.4
                    },
                    "releaseDate": "2021-06-25"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 748,
                        "hold": 37,
                        "slide": 59,
                        "touch": 82,
                        "break": 6,
                        "total": 932
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11238,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.6,
                        "BUDDiES PLUS": 14.6,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL": 14.6,
                        "FESTiVAL PLUS": 14.6,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6,
                        "Splash PLUS": 14.5,
                        "UNiVERSE": 14.5,
                        "UNiVERSE PLUS": 14.6
                    },
                    "releaseDate": "2021-06-25"
                }
            ],
            "searchAcronyms": [
                "abie",
                "啊妈逼",
                "啊麻痹",
                "没妈",
                "阿妈别",
                "阿妈比",
                "阿玛别"
            ]
        },
        {
            "songId": "電話革命ナイセン",
            "category": "niconico＆ボーカロイド",
            "title": "電話革命ナイセン",
            "artist": "ナイセン - momoco-",
            "bpm": 145,
            "imageName": "05a0b37c77c91e97f625c2c859744494a7ff5065cbeb5679144bc6e09ad350c5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 116,
                        "hold": 4,
                        "slide": 3,
                        "touch": 14,
                        "break": 3,
                        "total": 140
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11258,
                    "releaseDate": "2021-07-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 34,
                        "slide": 16,
                        "touch": 23,
                        "break": 10,
                        "total": 292
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11258,
                    "releaseDate": "2021-07-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 37,
                        "slide": 37,
                        "touch": 26,
                        "break": 12,
                        "total": 370
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11258,
                    "releaseDate": "2021-07-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 354,
                        "hold": 27,
                        "slide": 121,
                        "touch": 33,
                        "break": 16,
                        "total": 551
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11258,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.4,
                        "Splash PLUS": 12.5
                    },
                    "releaseDate": "2021-07-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Alice in 冷凍庫",
            "category": "niconico＆ボーカロイド",
            "title": "Alice in 冷凍庫",
            "artist": "Orangestar",
            "bpm": 176,
            "imageName": "0f88533fd24a48da6c6cd06010eb8939ec5b7ace1e50f96268690103e154dc72",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 118,
                        "hold": 6,
                        "slide": 2,
                        "touch": 6,
                        "break": 1,
                        "total": 133
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11265,
                    "releaseDate": "2021-07-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 238,
                        "hold": 19,
                        "slide": 14,
                        "touch": 10,
                        "break": 6,
                        "total": 287
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11265,
                    "releaseDate": "2021-07-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 347,
                        "hold": 54,
                        "slide": 24,
                        "touch": 14,
                        "break": 8,
                        "total": 447
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11265,
                    "multiverInternalLevelValue": {
                        "Splash PLUS": 9.8
                    },
                    "releaseDate": "2021-07-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 437,
                        "hold": 69,
                        "slide": 81,
                        "touch": 50,
                        "break": 6,
                        "total": 643
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11265,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8
                    },
                    "releaseDate": "2021-07-09"
                }
            ],
            "searchAcronyms": [
                "Alice in 冷冻库",
                "冰箱",
                "冷冻库",
                "冻死爱丽丝",
                "哦哦哦",
                "爱丽丝"
            ]
        },
        {
            "songId": "キラメキ居残り大戦争",
            "category": "ゲーム＆バラエティ",
            "title": "キラメキ居残り大戦争",
            "artist": "森羅万象",
            "bpm": 212,
            "imageName": "fdead0d8ce5c94e64723598969b4b017a122f557608c2bf1a455ab38e9dc0a37",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 136,
                        "hold": 17,
                        "slide": 2,
                        "touch": 16,
                        "break": 2,
                        "total": 173
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11266,
                    "releaseDate": "2021-07-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 270,
                        "hold": 42,
                        "slide": 24,
                        "touch": 22,
                        "break": 8,
                        "total": 366
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11266,
                    "releaseDate": "2021-07-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 434,
                        "hold": 48,
                        "slide": 29,
                        "touch": 25,
                        "break": 32,
                        "total": 568
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11266,
                    "multiverInternalLevelValue": {
                        "Splash PLUS": 10.8
                    },
                    "releaseDate": "2021-07-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 536,
                        "hold": 38,
                        "slide": 135,
                        "touch": 41,
                        "break": 48,
                        "total": 798
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11266,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2021-07-09"
                }
            ],
            "searchAcronyms": [
                "大战争",
                "女同2",
                "女同大战争",
                "女同歌",
                "居残",
                "居残大战争",
                "留校大作战"
            ]
        },
        {
            "songId": "Never Give Up!",
            "category": "maimai",
            "title": "Never Give Up!",
            "artist": "nanobii",
            "bpm": 171,
            "imageName": "434214b79b3a118088d917ffa822b682cb19b953296485ea66e69fd8817fd687",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 131,
                        "hold": 7,
                        "slide": 8,
                        "touch": 6,
                        "break": 3,
                        "total": 155
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11232,
                    "releaseDate": "2021-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 245,
                        "hold": 25,
                        "slide": 23,
                        "touch": 27,
                        "break": 7,
                        "total": 327
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11232,
                    "releaseDate": "2021-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 340,
                        "hold": 43,
                        "slide": 54,
                        "touch": 53,
                        "break": 5,
                        "total": 495
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11232,
                    "releaseDate": "2021-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "7.3連発華火",
                    "noteCounts": {
                        "tap": 485,
                        "hold": 73,
                        "slide": 112,
                        "touch": 57,
                        "break": 20,
                        "total": 747
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11232,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "Splash PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2021-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 499,
                        "hold": 84,
                        "slide": 74,
                        "touch": 85,
                        "break": 17,
                        "total": 759
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11232,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-11-23"
                }
            ],
            "searchAcronyms": [
                "nevergiveup",
                "NeverGonnaGiveYouUp",
                "ngu",
                "rickroll",
                "不给上",
                "乃8给8",
                "从不给上",
                "你被骗了",
                "永不放弃",
                "永不言弃",
                "永远不给上",
                "绝不认输"
            ]
        },
        {
            "songId": "Starry Colors",
            "category": "maimai",
            "title": "Starry Colors",
            "artist": "BlackY feat. Risa Yuzuki",
            "bpm": 177,
            "imageName": "8e971823bbb151458c778cc38efa74be319be1710457547f1f54f43cd58e2814",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 14,
                        "slide": 6,
                        "touch": 6,
                        "break": 4,
                        "total": 168
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11233,
                    "releaseDate": "2021-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 259,
                        "hold": 37,
                        "slide": 25,
                        "touch": 11,
                        "break": 6,
                        "total": 338
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11233,
                    "releaseDate": "2021-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 405,
                        "hold": 65,
                        "slide": 31,
                        "touch": 10,
                        "break": 10,
                        "total": 521
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11233,
                    "releaseDate": "2021-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 674,
                        "hold": 60,
                        "slide": 99,
                        "touch": 78,
                        "break": 19,
                        "total": 930
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11233,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 14,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "Splash PLUS": 14,
                        "UNiVERSE": 14,
                        "UNiVERSE PLUS": 14
                    },
                    "releaseDate": "2021-07-21"
                }
            ],
            "searchAcronyms": [
                "斯大林格勒",
                "星之彩",
                "星彩",
                "星色",
                "魔爪"
            ]
        },
        {
            "songId": "ほしぞらスペクタクル",
            "category": "maimai",
            "title": "ほしぞらスペクタクル",
            "artist": "奏音",
            "bpm": 200,
            "imageName": "0aad1815e3ded98572b433a214f2189c844bf9224ee6a384f7fd9d44f32b1012",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 16,
                        "slide": 12,
                        "touch": 22,
                        "break": 3,
                        "total": 210
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11234,
                    "releaseDate": "2021-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 30,
                        "slide": 45,
                        "touch": 27,
                        "break": 6,
                        "total": 426
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11234,
                    "releaseDate": "2021-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 583,
                        "hold": 59,
                        "slide": 50,
                        "touch": 60,
                        "break": 10,
                        "total": 762
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11234,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5,
                        "Splash PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2021-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 823,
                        "hold": 60,
                        "slide": 69,
                        "touch": 202,
                        "break": 25,
                        "total": 1179
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11234,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "Splash PLUS": 14.3,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.3
                    },
                    "releaseDate": "2021-07-21"
                }
            ],
            "searchAcronyms": [
                "奏音",
                "巫贼",
                "星球妹",
                "星空奇观",
                "星际奇观",
                "水母",
                "水母妹",
                "水母姐",
                "水母娘",
                "珊瑚宫心海"
            ]
        },
        {
            "songId": "ディカディズム",
            "category": "niconico＆ボーカロイド",
            "title": "ディカディズム",
            "artist": "ぬゆり",
            "bpm": 124,
            "imageName": "ad693a119f1d3f67f628120212fe856c80c5c9df9f7f7227f286199b71966214",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 115,
                        "hold": 9,
                        "slide": 6,
                        "touch": 8,
                        "break": 1,
                        "total": 139
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11267,
                    "releaseDate": "2021-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 18,
                        "slide": 11,
                        "touch": 21,
                        "break": 6,
                        "total": 286
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11267,
                    "releaseDate": "2021-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 423,
                        "hold": 77,
                        "slide": 17,
                        "touch": 14,
                        "break": 3,
                        "total": 534
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11267,
                    "releaseDate": "2021-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 663,
                        "hold": 81,
                        "slide": 53,
                        "touch": 20,
                        "break": 27,
                        "total": 844
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11267,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.2,
                        "Splash PLUS": 13.1,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.1
                    },
                    "releaseDate": "2021-08-05"
                }
            ],
            "searchAcronyms": [
                "decadism",
                "年代主义",
                "皇帝小兵",
                "皇帝排队"
            ]
        },
        {
            "songId": "猫猫的宇宙論",
            "category": "niconico＆ボーカロイド",
            "title": "猫猫的宇宙論",
            "artist": "ナユタン星人",
            "bpm": 134,
            "imageName": "8366a52cb57933e4b7caf24bc4198816a623640020dd6de7e525c242cf95e7ea",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 152,
                        "hold": 9,
                        "slide": 4,
                        "touch": 14,
                        "break": 4,
                        "total": 183
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11268,
                    "releaseDate": "2021-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 270,
                        "hold": 18,
                        "slide": 9,
                        "touch": 11,
                        "break": 10,
                        "total": 318
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11268,
                    "releaseDate": "2021-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 288,
                        "hold": 62,
                        "slide": 42,
                        "touch": 87,
                        "break": 14,
                        "total": 493
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11268,
                    "releaseDate": "2021-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 528,
                        "hold": 72,
                        "slide": 68,
                        "touch": 48,
                        "break": 22,
                        "total": 738
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11268,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7,
                        "Splash PLUS": 12.7
                    },
                    "releaseDate": "2021-08-05"
                }
            ],
            "searchAcronyms": [
                "学猫叫",
                "宇宙论",
                "猫猫宇宙论",
                "猫猫的宇宙论"
            ]
        },
        {
            "songId": "ラットが死んだnew words",
            "category": "niconico＆ボーカロイド",
            "title": "ラットが死んだnew words",
            "artist": "P.I.N.A.",
            "bpm": 146,
            "imageName": "75b00ea70ed73e4b873b2728cb048ee1ded88369d540932b1a0237ef2635fc8a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 9,
                        "slide": 5,
                        "touch": 9,
                        "break": 1,
                        "total": 129
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11269,
                    "releaseDate": "2021-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 216,
                        "hold": 17,
                        "slide": 12,
                        "touch": 27,
                        "break": 3,
                        "total": 275
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11269,
                    "releaseDate": "2021-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 245,
                        "hold": 52,
                        "slide": 42,
                        "touch": 32,
                        "break": 4,
                        "total": 375
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11269,
                    "releaseDate": "2021-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 604,
                        "hold": 36,
                        "slide": 101,
                        "touch": 34,
                        "break": 8,
                        "total": 783
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11269,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8
                    },
                    "releaseDate": "2021-08-05"
                }
            ],
            "searchAcronyms": [
                "死",
                "白老鼠死掉了",
                "硕鼠死亡",
                "硕鼠死亡newwords",
                "老鼠死掉了",
                "老鼠死掉了newwords",
                "芝麻街",
                "鼠鼠似了"
            ]
        },
        {
            "songId": "阿吽のビーツ",
            "category": "niconico＆ボーカロイド",
            "title": "阿吽のビーツ",
            "artist": "羽生まゐご",
            "bpm": 103,
            "imageName": "9163e07addcd526f5fd75506f2f114874cfbb8303b0e7e11a3a02eee481697ca",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 73,
                        "hold": 10,
                        "slide": 6,
                        "touch": 13,
                        "break": 2,
                        "total": 104
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11270,
                    "releaseDate": "2021-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 173,
                        "hold": 20,
                        "slide": 15,
                        "touch": 20,
                        "break": 8,
                        "total": 236
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11270,
                    "releaseDate": "2021-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 55,
                        "slide": 22,
                        "touch": 34,
                        "break": 11,
                        "total": 474
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11270,
                    "releaseDate": "2021-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 557,
                        "hold": 11,
                        "slide": 76,
                        "touch": 31,
                        "break": 8,
                        "total": 683
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11270,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2021-08-05"
                }
            ],
            "searchAcronyms": [
                "小灵通青春版",
                "阿吽",
                "阿吽的节奏",
                "阿哞",
                "阿哞的节奏",
                "阿牛",
                "阿牛小卖铺"
            ]
        },
        {
            "songId": "再会",
            "category": "niconico＆ボーカロイド",
            "title": "再会",
            "artist": "はるまきごはん",
            "bpm": 137,
            "imageName": "2e112e020701c88324d3d6daa1556a8402a589ba2b089f7bce746cf49ccbb02f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 77,
                        "hold": 8,
                        "slide": 6,
                        "touch": 7,
                        "break": 1,
                        "total": 99
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11271,
                    "releaseDate": "2021-08-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 211,
                        "hold": 15,
                        "slide": 17,
                        "touch": 20,
                        "break": 4,
                        "total": 267
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11271,
                    "releaseDate": "2021-08-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 30,
                        "slide": 27,
                        "touch": 42,
                        "break": 4,
                        "total": 418
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11271,
                    "releaseDate": "2021-08-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 508,
                        "hold": 25,
                        "slide": 73,
                        "touch": 22,
                        "break": 15,
                        "total": 643
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11271,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.2,
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "FESTiVAL PLUS": 12.2,
                        "PRiSM PLUS": 12.2,
                        "Splash PLUS": 12.2,
                        "UNiVERSE PLUS": 12.2
                    },
                    "releaseDate": "2021-08-20"
                }
            ],
            "searchAcronyms": [
                "see you again"
            ]
        },
        {
            "songId": "約束",
            "category": "niconico＆ボーカロイド",
            "title": "約束",
            "artist": "はるまきごはん",
            "bpm": 136,
            "imageName": "a834a781db40ccc3ef6e719083926121bd04f447c5de917e2f2eebba237093c6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 95,
                        "hold": 9,
                        "slide": 2,
                        "touch": 5,
                        "break": 1,
                        "total": 112
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11272,
                    "releaseDate": "2021-08-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 23,
                        "slide": 27,
                        "touch": 8,
                        "break": 4,
                        "total": 231
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11272,
                    "releaseDate": "2021-08-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 168,
                        "hold": 60,
                        "slide": 33,
                        "touch": 27,
                        "break": 4,
                        "total": 292
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11272,
                    "releaseDate": "2021-08-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 366,
                        "hold": 44,
                        "slide": 92,
                        "touch": 30,
                        "break": 16,
                        "total": 548
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11272,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12,
                        "Splash PLUS": 12
                    },
                    "releaseDate": "2021-08-20"
                }
            ],
            "searchAcronyms": [
                "约定",
                "约束"
            ]
        },
        {
            "songId": "トラフィック・ジャム",
            "category": "niconico＆ボーカロイド",
            "title": "トラフィック・ジャム",
            "artist": "煮ル果実",
            "bpm": 130,
            "imageName": "3fe0a655cef9d2291c092fb532a3bc8b2c20d6badb1d336143fa0fbfd0576049",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 92,
                        "hold": 13,
                        "slide": 4,
                        "touch": 16,
                        "break": 2,
                        "total": 127
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11273,
                    "releaseDate": "2021-08-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 206,
                        "hold": 20,
                        "slide": 16,
                        "touch": 31,
                        "break": 4,
                        "total": 277
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11273,
                    "releaseDate": "2021-08-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 124,
                        "slide": 27,
                        "touch": 45,
                        "break": 16,
                        "total": 479
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11273,
                    "releaseDate": "2021-08-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 496,
                        "hold": 174,
                        "slide": 104,
                        "touch": 92,
                        "break": 30,
                        "total": 896
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11273,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8
                    },
                    "releaseDate": "2021-08-20"
                }
            ],
            "searchAcronyms": [
                "jam",
                "traffic jam",
                "Traffic Jam",
                "trafficjam",
                "交通堵塞",
                "交通阻塞",
                "堵车",
                "煮儿果实",
                "黄埔",
                "黄歌",
                "黄谱"
            ]
        },
        {
            "songId": "アルティメットセンパイ",
            "category": "niconico＆ボーカロイド",
            "title": "アルティメットセンパイ",
            "artist": "ピノキオピー",
            "bpm": 145,
            "imageName": "e8b0d5a4ee85e9d8978353bfa21dfaad7936b19950a5dde94748b5716b92beb0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 11,
                        "slide": 2,
                        "touch": 11,
                        "break": 1,
                        "total": 134
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11274,
                    "releaseDate": "2021-08-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 236,
                        "hold": 34,
                        "slide": 9,
                        "touch": 32,
                        "break": 13,
                        "total": 324
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11274,
                    "releaseDate": "2021-08-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "畳返し",
                    "noteCounts": {
                        "tap": 274,
                        "hold": 54,
                        "slide": 38,
                        "touch": 33,
                        "break": 25,
                        "total": 424
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11274,
                    "releaseDate": "2021-08-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 523,
                        "hold": 45,
                        "slide": 95,
                        "touch": 46,
                        "break": 34,
                        "total": 743
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11274,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13.1,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2021-08-20"
                }
            ],
            "searchAcronyms": [
                "先辈",
                "小黄毛",
                "究极先辈",
                "究极前辈"
            ]
        },
        {
            "songId": "BOUNCE & DANCE",
            "category": "オンゲキ＆CHUNITHM",
            "title": "BOUNCE & DANCE",
            "artist": "IOSYS TRAX",
            "bpm": 135,
            "imageName": "156b62d749f4b1123882704235c0fa2e0063b80a0648c10b8416ed2118b7bd2b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 164,
                        "hold": 10,
                        "slide": 7,
                        "touch": 6,
                        "break": 2,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11246,
                    "releaseDate": "2021-09-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 304,
                        "hold": 32,
                        "slide": 11,
                        "touch": 20,
                        "break": 3,
                        "total": 370
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11246,
                    "releaseDate": "2021-09-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 463,
                        "hold": 105,
                        "slide": 41,
                        "touch": 24,
                        "break": 10,
                        "total": 643
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11246,
                    "releaseDate": "2021-09-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "シチミッピー",
                    "noteCounts": {
                        "tap": 711,
                        "hold": 114,
                        "slide": 76,
                        "touch": 71,
                        "break": 27,
                        "total": 999
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11246,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "Splash PLUS": 13.7,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2021-09-03"
                }
            ],
            "searchAcronyms": [
                "bounce &amp; dance",
                "bounce dance",
                "又蹦又跳",
                "小星",
                "小白兔",
                "弹力舞",
                "弹舞",
                "弹跳",
                "脚臭"
            ]
        },
        {
            "songId": "Kiss Me Kiss",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Kiss Me Kiss",
            "artist": "曲：大畑拓也／歌：bitter flavor [桜井 春菜(CV：近藤 玲奈)、早乙女 彩華(CV：中島 唯)]",
            "bpm": 140,
            "imageName": "3fa048da174a355814b85f79a4dd4df00eb5eaf447ddfe92ae8f122923ac7d67",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 97,
                        "hold": 15,
                        "slide": 7,
                        "touch": 4,
                        "break": 2,
                        "total": 125
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11247,
                    "releaseDate": "2021-09-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 283,
                        "hold": 12,
                        "slide": 21,
                        "touch": 8,
                        "break": 4,
                        "total": 328
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11247,
                    "releaseDate": "2021-09-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 106,
                        "slide": 37,
                        "touch": 41,
                        "break": 8,
                        "total": 484
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11247,
                    "releaseDate": "2021-09-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 522,
                        "hold": 80,
                        "slide": 77,
                        "touch": 27,
                        "break": 13,
                        "total": 719
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11247,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2021-09-30"
                }
            ],
            "searchAcronyms": [
                "kiss",
                "kissmeass",
                "qwq",
                "亲我亲"
            ]
        },
        {
            "songId": "MEGATON BLAST",
            "category": "オンゲキ＆CHUNITHM",
            "title": "MEGATON BLAST",
            "artist": "BlackY vs. Yooh",
            "bpm": 194,
            "imageName": "7242c25b5ee7af0748ed7ee0c5b4346591ae9e01a350a6ae899fde71755c024a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 5,
                        "slide": 12,
                        "touch": 6,
                        "break": 6,
                        "total": 266
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11248,
                    "releaseDate": "2021-09-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 737,
                        "hold": 10,
                        "slide": 7,
                        "touch": 35,
                        "break": 25,
                        "total": 814
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11248,
                    "releaseDate": "2021-09-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 654,
                        "hold": 117,
                        "slide": 82,
                        "touch": 26,
                        "break": 77,
                        "total": 956
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11248,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash PLUS": 12.9
                    },
                    "releaseDate": "2021-09-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "The ALiEN vs. Phoenix",
                    "noteCounts": {
                        "tap": 864,
                        "hold": 141,
                        "slide": 60,
                        "touch": 110,
                        "break": 63,
                        "total": 1238
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11248,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "Splash PLUS": 14.3,
                        "UNiVERSE": 14.3,
                        "UNiVERSE PLUS": 14.3
                    },
                    "releaseDate": "2021-09-03"
                }
            ],
            "searchAcronyms": [
                "mb",
                "m属性大爆发",
                "华尔兹2",
                "威震天爆炸",
                "早濑优香",
                "朝比奈真冬",
                "核爆",
                "百万吨爆",
                "百万吨爆炸"
            ]
        },
        {
            "songId": "Splash Dance!!",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Splash Dance!!",
            "artist": "曲：Q-MHz／歌：オンゲキシューターズ",
            "bpm": 155,
            "imageName": "456bfcaea4d27d26101e110999ac21afb4f8c224d5a6866926d1923a79c7d863",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 16,
                        "slide": 6,
                        "touch": 16,
                        "break": 7,
                        "total": 182
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11249,
                    "releaseDate": "2021-09-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 222,
                        "hold": 36,
                        "slide": 23,
                        "touch": 38,
                        "break": 28,
                        "total": 347
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11249,
                    "releaseDate": "2021-09-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 420,
                        "hold": 41,
                        "slide": 49,
                        "touch": 48,
                        "break": 54,
                        "total": 612
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11249,
                    "releaseDate": "2021-09-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 784,
                        "hold": 24,
                        "slide": 105,
                        "touch": 39,
                        "break": 40,
                        "total": 992
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11249,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash PLUS": 13.4,
                        "UNiVERSE": 13.4,
                        "UNiVERSE PLUS": 13.4
                    },
                    "releaseDate": "2021-09-03"
                }
            ],
            "searchAcronyms": [
                "splash dance",
                "喷射舞",
                "泳装2",
                "爽舞"
            ]
        },
        {
            "songId": "宿星審判",
            "category": "オンゲキ＆CHUNITHM",
            "title": "宿星審判",
            "artist": "suzu",
            "bpm": 189,
            "imageName": "2de78b437312cee6fce9e393b0e9546a074a199e8fe8ce545fd8ac86f7c58219",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 120,
                        "hold": 20,
                        "slide": 5,
                        "touch": 23,
                        "break": 6,
                        "total": 174
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "Splash PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11294,
                    "releaseDate": "2021-07-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 304,
                        "hold": 11,
                        "slide": 26,
                        "touch": 36,
                        "break": 14,
                        "total": 391
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "Splash PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11294,
                    "releaseDate": "2021-07-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 517,
                        "hold": 65,
                        "slide": 50,
                        "touch": 34,
                        "break": 21,
                        "total": 687
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "Splash PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11294,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.2,
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "PRiSM PLUS": 12.2,
                        "UNiVERSE": 12.2,
                        "UNiVERSE PLUS": 12.2
                    },
                    "releaseDate": "2021-07-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 738,
                        "hold": 103,
                        "slide": 77,
                        "touch": 110,
                        "break": 46,
                        "total": 1074
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "Splash PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11294,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "UNiVERSE": 14.4,
                        "UNiVERSE PLUS": 14.4
                    },
                    "releaseDate": "2021-07-30"
                }
            ],
            "searchAcronyms": [
                "Shukusei",
                "Shukusei Shinpan",
                "Syukusei Shinpan",
                "大慈树王",
                "审判",
                "宿星",
                "宿星审判",
                "星怒审判",
                "纳西妲"
            ]
        },
        {
            "songId": "脳天直撃",
            "category": "オンゲキ＆CHUNITHM",
            "title": "脳天直撃",
            "artist": "黒沢ダイスケ VS 穴山大輔",
            "bpm": 145,
            "imageName": "d9abaedc304301e85982f575c55593724090f2046fb3a3527a502039b5cef755",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 20,
                        "slide": 9,
                        "touch": 54,
                        "break": 2,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11295,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 355,
                        "hold": 44,
                        "slide": 23,
                        "touch": 34,
                        "break": 13,
                        "total": 469
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11295,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 659,
                        "hold": 60,
                        "slide": 35,
                        "touch": 27,
                        "break": 9,
                        "total": 790
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11295,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "小鳥遊さん vs 華火職人",
                    "noteCounts": {
                        "tap": 1021,
                        "hold": 69,
                        "slide": 46,
                        "touch": 125,
                        "break": 35,
                        "total": 1296
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11295,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.6,
                        "BUDDiES PLUS": 14.6,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL": 14.6,
                        "FESTiVAL PLUS": 14.6,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6,
                        "UNiVERSE": 14.5,
                        "UNiVERSE PLUS": 14.6
                    },
                    "releaseDate": "2021-09-16"
                }
            ],
            "searchAcronyms": [
                "egg",
                "Nouten",
                "Nouten Chokugeki",
                "ongeki egg",
                "你的核酸阳的卧槽",
                "卧槽脑天直击",
                "头部受到打击",
                "老天直击",
                "脑天",
                "脑天直击",
                "脑天直寄",
                "脑瘫直击",
                "脑瘫至极",
                "说的道理"
            ]
        },
        {
            "songId": "とびだせ！TO THE COSMIC!!",
            "category": "maimai",
            "title": "とびだせ！TO THE COSMIC!!",
            "artist": "t+pazolite feat. しゃま(CV:種﨑 敦美) & みるく(CV:伊藤 あすか)",
            "bpm": 185,
            "imageName": "3500f9e9fa5c22d454db2d46df26e815ec4fb9b1079f9815ffb83c4c2ad4b686",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 159,
                        "hold": 10,
                        "slide": 2,
                        "touch": 22,
                        "break": 3,
                        "total": 196
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11296,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 397,
                        "hold": 15,
                        "slide": 23,
                        "touch": 16,
                        "break": 6,
                        "total": 457
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11296,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 489,
                        "hold": 51,
                        "slide": 68,
                        "touch": 22,
                        "break": 100,
                        "total": 730
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11296,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 705,
                        "hold": 29,
                        "slide": 161,
                        "touch": 7,
                        "break": 45,
                        "total": 947
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11296,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "UNiVERSE": 13.5,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2021-09-16"
                }
            ],
            "searchAcronyms": [
                "to the cosmic",
                "tobidase",
                "tobidase to the cosmic",
                "tpz银趴",
                "uni",
                "universe主题曲",
                "uni主题曲",
                "とびだせ",
                "初等数学",
                "压缩tpz",
                "去宇宙",
                "宇宙牛奶",
                "新牛奶",
                "牛奶3",
                "缝合怪",
                "舞萌2023主题曲",
                "起飞"
            ]
        },
        {
            "songId": "噛み係",
            "category": "maimai",
            "title": "噛み係",
            "artist": "さつき が てんこもり feat.96猫",
            "bpm": 148,
            "imageName": "735fc7b478b1d42a7d3251d6f99d95842c07ca249dfb427ecfce5cbc61965b0d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 88,
                        "hold": 16,
                        "slide": 4,
                        "touch": 30,
                        "break": 8,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11297,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 30,
                        "slide": 16,
                        "touch": 20,
                        "break": 12,
                        "total": 292
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11297,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 132,
                        "slide": 51,
                        "touch": 25,
                        "break": 50,
                        "total": 516
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11297,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 10.8
                    },
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 517,
                        "hold": 112,
                        "slide": 83,
                        "touch": 18,
                        "break": 34,
                        "total": 764
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11297,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM PLUS": 13.5,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.3
                    },
                    "releaseDate": "2021-09-16"
                }
            ],
            "searchAcronyms": [
                "96猫",
                "咬个针先",
                "咬系",
                "啮",
                "啮系",
                "噛係",
                "大教堂",
                "神灵附体",
                "齿系"
            ]
        },
        {
            "songId": "トリアージ",
            "category": "maimai",
            "title": "トリアージ",
            "artist": "niki feat.noire",
            "bpm": 180,
            "imageName": "609ff27c2e2b738f4fb48889aaa7735bf27f645f8a8b3c8e2f0cf3310d283a6b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 74,
                        "hold": 23,
                        "slide": 4,
                        "touch": 19,
                        "break": 2,
                        "total": 122
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11298,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 18,
                        "slide": 27,
                        "touch": 7,
                        "break": 6,
                        "total": 290
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11298,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 303,
                        "hold": 71,
                        "slide": 39,
                        "touch": 24,
                        "break": 22,
                        "total": 459
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11298,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 10
                    },
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 461,
                        "hold": 19,
                        "slide": 128,
                        "touch": 20,
                        "break": 9,
                        "total": 637
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11298,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.3,
                        "UNiVERSE": 13.1,
                        "UNiVERSE PLUS": 13.1
                    },
                    "releaseDate": "2021-09-16"
                }
            ],
            "searchAcronyms": [
                "triage",
                "分诊",
                "碑谷",
                "纪念碑谷"
            ]
        },
        {
            "songId": "NAGAREBOSHI☆ROCKET",
            "category": "maimai",
            "title": "NAGAREBOSHI☆ROCKET",
            "artist": "梅干茶漬け",
            "bpm": 216,
            "imageName": "b80fc2a93fafd0af5bd2d34b1177ee9fa857ebf29d10f9a0c717157238485115",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 15,
                        "slide": 4,
                        "touch": 22,
                        "break": 2,
                        "total": 200
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11299,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 22,
                        "slide": 9,
                        "touch": 24,
                        "break": 13,
                        "total": 363
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11299,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 388,
                        "hold": 54,
                        "slide": 38,
                        "touch": 34,
                        "break": 39,
                        "total": 553
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11299,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "FESTiVAL": 12,
                        "PRiSM PLUS": 12,
                        "UNiVERSE": 12
                    },
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "SHICHIMI☆CAT",
                    "noteCounts": {
                        "tap": 516,
                        "hold": 63,
                        "slide": 104,
                        "touch": 102,
                        "break": 36,
                        "total": 821
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11299,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 14.2,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "UNiVERSE": 14.2,
                        "UNiVERSE PLUS": 14.2
                    },
                    "releaseDate": "2021-09-16"
                }
            ],
            "searchAcronyms": [
                "Nagareboshi",
                "像素猫猫",
                "梅干茶渍",
                "流星火箭",
                "火箭猫",
                "火箭猫猫",
                "火箭福瑞",
                "福瑞火箭",
                "那旮热博士"
            ]
        },
        {
            "songId": "テレキャスタービーボーイ",
            "category": "niconico＆ボーカロイド",
            "title": "テレキャスタービーボーイ",
            "artist": "すりぃ",
            "bpm": 182,
            "imageName": "71f747d891d6a3996ccaad808929c2c171d4400d2051524a7bbfd735c7579f4e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 87,
                        "hold": 6,
                        "slide": 2,
                        "touch": 4,
                        "break": 2,
                        "total": 101
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11325,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 18,
                        "slide": 4,
                        "touch": 12,
                        "break": 15,
                        "total": 286
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11325,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 50,
                        "slide": 41,
                        "touch": 14,
                        "break": 19,
                        "total": 404
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11325,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 49,
                        "slide": 77,
                        "touch": 24,
                        "break": 10,
                        "total": 562
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11325,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 11.8
                    },
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 486,
                        "hold": 52,
                        "slide": 64,
                        "touch": 31,
                        "break": 13,
                        "total": 646
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11325,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2021-09-15"
                }
            ],
            "searchAcronyms": [
                "bboy",
                "pop子",
                "tbb",
                "telecaster b boy",
                "telecaster b-boy",
                "Telecaster b-boy",
                "Telecaster B-Boy",
                "Telecaster Bboy",
                "合体",
                "我爱你",
                "比心",
                "电吉他b男",
                "电吉他说唱男孩",
                "电视广播员蜜蜂男孩"
            ]
        },
        {
            "songId": "デッドマンズバラッド",
            "category": "niconico＆ボーカロイド",
            "title": "デッドマンズバラッド",
            "artist": "cosMo＠暴走P",
            "bpm": 300,
            "imageName": "0b9d1d28767d8cec362444f2441367bba8f04af1955c7dea86f130a8f5ffbee9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 15,
                        "slide": 3,
                        "touch": 4,
                        "break": 4,
                        "total": 212
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11328,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 363,
                        "hold": 36,
                        "slide": 26,
                        "touch": 22,
                        "break": 20,
                        "total": 467
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11328,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 635,
                        "hold": 38,
                        "slide": 51,
                        "touch": 51,
                        "break": 43,
                        "total": 818
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11328,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE": 12.5
                    },
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 718,
                        "hold": 230,
                        "slide": 97,
                        "touch": 97,
                        "break": 66,
                        "total": 1208
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11328,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14.2,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "UNiVERSE": 14.2,
                        "UNiVERSE PLUS": 14.2
                    },
                    "releaseDate": "2021-09-16"
                }
            ],
            "searchAcronyms": [
                "BPM300",
                "deadman's ballad",
                "东雪莲姐妹",
                "亡者情歌",
                "僵尸",
                "僵尸初音",
                "僵尸妹",
                "僵尸娘",
                "呜哇呜哇",
                "恋尸癖",
                "散华礼弥",
                "死人的叙事诗",
                "死人的歌谣"
            ]
        },
        {
            "songId": "イヤホンロマンス",
            "category": "東方Project",
            "title": "イヤホンロマンス",
            "artist": "COOL&CREATE × 宝鐘マリン",
            "bpm": 132,
            "imageName": "a25d4e1269976618e3947f5aff3fb002f7949a804ecbbcb892ef4f2a435feb51",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 96,
                        "hold": 20,
                        "slide": 6,
                        "touch": 2,
                        "break": 3,
                        "total": 127
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11329,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 193,
                        "hold": 21,
                        "slide": 28,
                        "touch": 21,
                        "break": 5,
                        "total": 268
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11329,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 321,
                        "hold": 59,
                        "slide": 36,
                        "touch": 7,
                        "break": 23,
                        "total": 446
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11329,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 9.5
                    },
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "ものくろっく",
                    "noteCounts": {
                        "tap": 547,
                        "hold": 107,
                        "slide": 46,
                        "touch": 37,
                        "break": 22,
                        "total": 759
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11329,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "PRiSM PLUS": 13.1,
                        "UNiVERSE": 12.7
                    },
                    "releaseDate": "2021-09-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "竹",
            "category": "ゲーム＆バラエティ",
            "title": "竹",
            "artist": "立秋 feat.ちょこ",
            "bpm": 150,
            "imageName": "bf917dca342a26c89b0170691937bb26edbbed3f719b243a0ce0fa894ddb4912",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 124,
                        "hold": 25,
                        "slide": 4,
                        "touch": 16,
                        "break": 2,
                        "total": 171
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11330,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 346,
                        "hold": 27,
                        "slide": 8,
                        "touch": 20,
                        "break": 28,
                        "total": 429
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11330,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 395,
                        "hold": 52,
                        "slide": 64,
                        "touch": 61,
                        "break": 27,
                        "total": 599
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11330,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12,
                        "UNiVERSE": 11.8
                    },
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 592,
                        "hold": 168,
                        "slide": 77,
                        "touch": 79,
                        "break": 55,
                        "total": 971
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11330,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14.2,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 14.2
                    },
                    "releaseDate": "2021-09-16"
                }
            ],
            "searchAcronyms": [
                "↑↓",
                "🎍",
                "Bamboo",
                "ta↓ke↑",
                "take",
                "Take"
            ]
        },
        {
            "songId": "スーパーシンメトリー",
            "category": "ゲーム＆バラエティ",
            "title": "スーパーシンメトリー",
            "artist": "Sta feat. b",
            "bpm": 210,
            "imageName": "1872af4d1e374da66ec1d704f8d4389eac5604bad934171a16926d8ab8c7586b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 246,
                        "hold": 10,
                        "slide": 1,
                        "touch": 6,
                        "break": 4,
                        "total": 267
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11331,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 33,
                        "slide": 14,
                        "touch": 38,
                        "break": 10,
                        "total": 446
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11331,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 434,
                        "hold": 85,
                        "slide": 59,
                        "touch": 78,
                        "break": 17,
                        "total": 673
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11331,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "FESTiVAL": 12,
                        "FESTiVAL PLUS": 12,
                        "PRiSM PLUS": 12,
                        "UNiVERSE": 12,
                        "UNiVERSE PLUS": 12
                    },
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 753,
                        "hold": 46,
                        "slide": 131,
                        "touch": 76,
                        "break": 20,
                        "total": 1026
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11331,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2021-09-16"
                }
            ],
            "searchAcronyms": [
                "对称性",
                "超对称",
                "超对称性"
            ]
        },
        {
            "songId": "グッバイ宣言",
            "category": "niconico＆ボーカロイド",
            "title": "グッバイ宣言",
            "artist": "Chinozo",
            "bpm": 170,
            "imageName": "81df7dc9efcdc89df717491b698ebdf7666ea12ab045e379f165e5930ced886c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 98,
                        "hold": 12,
                        "slide": 4,
                        "touch": 5,
                        "break": 4,
                        "total": 123
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11353,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 12,
                        "slide": 12,
                        "touch": 5,
                        "break": 4,
                        "total": 328
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11353,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 384,
                        "hold": 81,
                        "slide": 22,
                        "touch": 21,
                        "break": 11,
                        "total": 519
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11353,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 473,
                        "hold": 58,
                        "slide": 135,
                        "touch": 7,
                        "break": 10,
                        "total": 683
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11353,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE": 12.5,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2021-09-16"
                }
            ],
            "searchAcronyms": [
                "✌️👌",
                "886宣言",
                "Goodbye Sengen",
                "one,two",
                "再见宣言",
                "卡手宣言",
                "扭手宣言",
                "袜子"
            ]
        },
        {
            "songId": "Lia=Fail",
            "category": "maimai",
            "title": "Lia=Fail",
            "artist": "Team Grimoire",
            "bpm": 186,
            "imageName": "a54027bec4f1041b6c7c19e99de2fe9cc3d467ee359279e68e6385205fe63f69",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 181,
                        "hold": 12,
                        "slide": 2,
                        "touch": 8,
                        "break": 7,
                        "total": 210
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11364,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 389,
                        "hold": 19,
                        "slide": 16,
                        "touch": 25,
                        "break": 9,
                        "total": 458
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11364,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 514,
                        "hold": 51,
                        "slide": 67,
                        "touch": 38,
                        "break": 27,
                        "total": 697
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11364,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE": 12.8
                    },
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "-ZONE-Phoenix",
                    "noteCounts": {
                        "tap": 827,
                        "hold": 47,
                        "slide": 118,
                        "touch": 20,
                        "break": 4,
                        "total": 1016
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11364,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "FESTiVAL": 14.7,
                        "FESTiVAL PLUS": 14.7,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7,
                        "UNiVERSE": 14.8,
                        "UNiVERSE PLUS": 14.7
                    },
                    "releaseDate": "2021-09-16"
                }
            ],
            "searchAcronyms": [
                "l=f",
                "L=F",
                "liafail",
                "剑3",
                "命运之石",
                "圣剑3",
                "圣剑三",
                "生煎3",
                "生煎三",
                "福瑞3"
            ]
        },
        {
            "songId": "廻廻奇譚",
            "category": "POPS＆アニメ",
            "title": "廻廻奇譚",
            "artist": "Eve TVアニメ「呪術廻戦」第1クールオープニングテーマ",
            "bpm": 185,
            "imageName": "4c8daa25a2e35816294d267fe03d6d3bd7633ccdb17aa80ac5e6119dc5595c33",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 150,
                        "hold": 6,
                        "slide": 12,
                        "touch": 6,
                        "break": 1,
                        "total": 175
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11369,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 301,
                        "hold": 26,
                        "slide": 19,
                        "touch": 22,
                        "break": 6,
                        "total": 374
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11369,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 466,
                        "hold": 75,
                        "slide": 41,
                        "touch": 4,
                        "break": 2,
                        "total": 588
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11369,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 519,
                        "hold": 63,
                        "slide": 118,
                        "touch": 11,
                        "break": 10,
                        "total": 721
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11369,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 11.8
                    },
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 631,
                        "hold": 21,
                        "slide": 122,
                        "touch": 45,
                        "break": 20,
                        "total": 839
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11369,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.5,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.3
                    },
                    "releaseDate": "2021-09-15"
                }
            ],
            "searchAcronyms": [
                "🎳",
                "Kaikai kitan",
                "保龄球",
                "医微医不写术了",
                "咒术回战",
                "咒术回战主题曲",
                "回回奇谈",
                "回回奇谭",
                "奇谭",
                "廻廻奇谭",
                "灰灰鸡蛋",
                "轮回奇谭"
            ]
        },
        {
            "songId": "Southern Cross",
            "category": "ゲーム＆バラエティ",
            "title": "Southern Cross",
            "artist": "403",
            "bpm": 171,
            "imageName": "9c4249a607dfd1864a298cac573c8d93154bf572761642d49c24d0883faa96d6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 130,
                        "hold": 10,
                        "slide": 6,
                        "touch": 27,
                        "break": 4,
                        "total": 177
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11333,
                    "releaseDate": "2021-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 18,
                        "slide": 20,
                        "touch": 23,
                        "break": 10,
                        "total": 361
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11333,
                    "releaseDate": "2021-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 353,
                        "hold": 46,
                        "slide": 78,
                        "touch": 26,
                        "break": 84,
                        "total": 587
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11333,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 10.7
                    },
                    "releaseDate": "2021-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 702,
                        "hold": 49,
                        "slide": 92,
                        "touch": 55,
                        "break": 37,
                        "total": 935
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11333,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2021-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 1103,
                        "hold": 20,
                        "slide": 24,
                        "touch": 15,
                        "break": 32,
                        "total": 1194
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11333,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2021-09-21"
                }
            ],
            "searchAcronyms": [
                "🌟",
                "1+1",
                "403",
                "一加一",
                "全是交互",
                "南十字",
                "南十字星",
                "南方十字",
                "和我贫瘠，星星我给你划了",
                "噩梦之城",
                "守护南十字星",
                "我炫一加一别人炫我星",
                "打个交先",
                "打交",
                "打交神曲",
                "打点计时器",
                "星星保卫战",
                "麦当劳1+1"
            ]
        },
        {
            "songId": "アンビバレンス",
            "category": "maimai",
            "title": "アンビバレンス",
            "artist": "すりぃ×相沢",
            "bpm": 187,
            "imageName": "9c5f25f41c1a8ea31109b58dd31b537e7e6aea0e4daa08d282841ca767515afc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 163,
                        "hold": 14,
                        "slide": 5,
                        "touch": 18,
                        "break": 2,
                        "total": 202
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11365,
                    "releaseDate": "2021-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 15,
                        "slide": 34,
                        "touch": 41,
                        "break": 7,
                        "total": 372
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11365,
                    "releaseDate": "2021-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 439,
                        "hold": 77,
                        "slide": 41,
                        "touch": 26,
                        "break": 20,
                        "total": 603
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11365,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 10.7
                    },
                    "releaseDate": "2021-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 564,
                        "hold": 50,
                        "slide": 203,
                        "touch": 51,
                        "break": 16,
                        "total": 884
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11365,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2021-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 676,
                        "hold": 47,
                        "slide": 184,
                        "touch": 14,
                        "break": 35,
                        "total": 956
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7
                    },
                    "releaseDate": "2025-11-19"
                }
            ],
            "searchAcronyms": [
                "ambivalence",
                "Ambivalence",
                "二律背反",
                "矛盾心理",
                "穿心",
                "言叶5"
            ]
        },
        {
            "songId": "Upshift",
            "category": "ゲーム＆バラエティ",
            "title": "Upshift",
            "artist": "s-don as Iriss-Frantzz",
            "bpm": 155,
            "imageName": "fce150611b2b0d9fe21744d21398f362ac1e29430168b99adb142189ce6687d6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 110,
                        "hold": 7,
                        "slide": 4,
                        "touch": 15,
                        "break": 5,
                        "total": 141
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11334,
                    "releaseDate": "2021-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 286,
                        "hold": 6,
                        "slide": 18,
                        "touch": 24,
                        "break": 10,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11334,
                    "releaseDate": "2021-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 419,
                        "hold": 68,
                        "slide": 65,
                        "touch": 21,
                        "break": 13,
                        "total": 586
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11334,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 11
                    },
                    "releaseDate": "2021-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "Safata.Hz",
                    "noteCounts": {
                        "tap": 656,
                        "hold": 39,
                        "slide": 110,
                        "touch": 15,
                        "break": 44,
                        "total": 864
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11334,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2021-10-01"
                }
            ],
            "searchAcronyms": [
                "CHAPTER 2",
                "upshit",
                "Upshit",
                "上蹲",
                "在屎上",
                "大写锁定"
            ]
        },
        {
            "songId": "MOBILYS",
            "category": "ゲーム＆バラエティ",
            "title": "MOBILYS",
            "artist": "Dachs",
            "bpm": 144,
            "imageName": "fd7a7e7eccea32a5758a995228f2cf02438bfdf7627d5dddff49a0802508142d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 112,
                        "hold": 15,
                        "slide": 4,
                        "touch": 20,
                        "break": 5,
                        "total": 156
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11335,
                    "releaseDate": "2021-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 217,
                        "hold": 26,
                        "slide": 17,
                        "touch": 21,
                        "break": 5,
                        "total": 286
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11335,
                    "releaseDate": "2021-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 274,
                        "hold": 51,
                        "slide": 63,
                        "touch": 12,
                        "break": 30,
                        "total": 430
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11335,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 10
                    },
                    "releaseDate": "2021-10-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 434,
                        "hold": 49,
                        "slide": 88,
                        "touch": 122,
                        "break": 17,
                        "total": 710
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11335,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.1,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2021-10-01"
                }
            ],
            "searchAcronyms": [
                "💡",
                "困锁的灯",
                "抹原逼留一手",
                "摸比利",
                "橘子怪兽二",
                "灯灯灯灯",
                "灯球",
                "灯笼",
                "电灯泡"
            ]
        },
        {
            "songId": "ドラゴンエネルギー",
            "category": "POPS＆アニメ",
            "title": "ドラゴンエネルギー",
            "artist": "オーイシマサヨシ×加藤純一",
            "bpm": 148,
            "imageName": "1e810b66dc10ed831b5bd445b5ecb7ce6629a05766e2892befe80a1f69a52911",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 79,
                        "hold": 12,
                        "slide": 7,
                        "touch": 4,
                        "break": 6,
                        "total": 108
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11336,
                    "releaseDate": "2021-10-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 228,
                        "hold": 24,
                        "slide": 20,
                        "touch": 19,
                        "break": 6,
                        "total": 297
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11336,
                    "releaseDate": "2021-10-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 37,
                        "slide": 21,
                        "touch": 57,
                        "break": 34,
                        "total": 493
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11336,
                    "releaseDate": "2021-10-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 517,
                        "hold": 71,
                        "slide": 96,
                        "touch": 31,
                        "break": 13,
                        "total": 728
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11336,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2021-10-15"
                }
            ],
            "searchAcronyms": [
                "dragon energy",
                "hero",
                "冰火人2",
                "披萨歌",
                "薛之谦",
                "龙能量"
            ]
        },
        {
            "songId": "セカイはまだ始まってすらいない",
            "category": "niconico＆ボーカロイド",
            "title": "セカイはまだ始まってすらいない",
            "artist": "ピノキオピー / 初音ミク / ワンダーランズ×ショウタイム「プロジェクトセカイ カラフルステージ！ feat. 初音ミク」",
            "bpm": 138,
            "imageName": "cc5b3e9c7d0d2b9e312288f9b507dadba52c8062cefeb8d472083339484123eb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 83,
                        "hold": 4,
                        "slide": 3,
                        "touch": 6,
                        "break": 4,
                        "total": 100
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11337,
                    "releaseDate": "2021-10-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 202,
                        "hold": 8,
                        "slide": 20,
                        "touch": 8,
                        "break": 18,
                        "total": 256
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11337,
                    "releaseDate": "2021-10-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 268,
                        "hold": 21,
                        "slide": 26,
                        "touch": 11,
                        "break": 52,
                        "total": 378
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11337,
                    "releaseDate": "2021-10-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 48,
                        "slide": 76,
                        "touch": 48,
                        "break": 20,
                        "total": 536
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11337,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2021-10-15"
                }
            ],
            "searchAcronyms": [
                "Sekai hasn't even started yet"
            ]
        },
        {
            "songId": "アイドル新鋭隊",
            "category": "niconico＆ボーカロイド",
            "title": "アイドル新鋭隊",
            "artist": "Mitchie M / 初音ミク / MORE MORE JUMP！「プロジェクトセカイ カラフルステージ！ feat. 初音ミク」",
            "bpm": 176,
            "imageName": "819e85c0dc37707f697da18c335ff5258bf8638414ee5d54901613d1e73aaf91",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 83,
                        "hold": 5,
                        "slide": 3,
                        "touch": 6,
                        "break": 3,
                        "total": 100
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11371,
                    "releaseDate": "2021-10-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 198,
                        "hold": 16,
                        "slide": 18,
                        "touch": 9,
                        "break": 12,
                        "total": 253
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11371,
                    "releaseDate": "2021-10-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 41,
                        "slide": 36,
                        "touch": 24,
                        "break": 8,
                        "total": 371
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11371,
                    "releaseDate": "2021-10-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.1,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 51,
                        "slide": 127,
                        "touch": 7,
                        "break": 47,
                        "total": 508
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11371,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.1,
                        "CiRCLE PLUS": 12.1,
                        "PRiSM PLUS": 12.1,
                        "UNiVERSE": 12.2,
                        "UNiVERSE PLUS": 12.2
                    },
                    "releaseDate": "2021-10-15"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "needLe",
            "category": "niconico＆ボーカロイド",
            "title": "needLe",
            "artist": "DECO*27 / 初音ミク / Leo/need「プロジェクトセカイ カラフルステージ！ feat. 初音ミク」",
            "bpm": 190,
            "imageName": "6b9c44a9f0ec144ea287bd2eb1bf07e20e79c4b41b32a823f614f271ff4434a1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 73,
                        "hold": 10,
                        "slide": 3,
                        "touch": 9,
                        "break": 1,
                        "total": 96
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11372,
                    "releaseDate": "2021-10-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 236,
                        "hold": 12,
                        "slide": 14,
                        "touch": 15,
                        "break": 4,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11372,
                    "releaseDate": "2021-10-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 42,
                        "slide": 22,
                        "touch": 29,
                        "break": 14,
                        "total": 425
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11372,
                    "releaseDate": "2021-10-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 434,
                        "hold": 39,
                        "slide": 92,
                        "touch": 20,
                        "break": 7,
                        "total": 592
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11372,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2021-10-15"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "BLACK SWAN",
            "category": "maimai",
            "title": "BLACK SWAN",
            "artist": "ぺのれり",
            "bpm": 201,
            "imageName": "e5504fd9ea2267b2cf0aab09e448ef57450e9eb9d53b2ff0e1aecbf36fd147dd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 9,
                        "slide": 4,
                        "touch": 14,
                        "break": 4,
                        "total": 227
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11302,
                    "releaseDate": "2021-10-29"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 33,
                        "slide": 16,
                        "touch": 27,
                        "break": 14,
                        "total": 354
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11302,
                    "releaseDate": "2021-10-29"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 480,
                        "hold": 70,
                        "slide": 58,
                        "touch": 25,
                        "break": 6,
                        "total": 639
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11302,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2021-10-29"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "The ALiEN",
                    "noteCounts": {
                        "tap": 711,
                        "hold": 57,
                        "slide": 84,
                        "touch": 57,
                        "break": 57,
                        "total": 966
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11302,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.6,
                        "BUDDiES PLUS": 14.6,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL": 14.6,
                        "FESTiVAL PLUS": 14.6,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6,
                        "UNiVERSE": 14.6,
                        "UNiVERSE PLUS": 14.6
                    },
                    "releaseDate": "2021-10-29"
                }
            ],
            "searchAcronyms": [
                "七岁小孩都能鸟",
                "右手2顺时针一圈左手6划到2双手再顺推到6",
                "周黑鸭",
                "甘雨",
                "黑丝袜",
                "黑天鹅",
                "黑色丝袜",
                "黑蒜"
            ]
        },
        {
            "songId": "星詠みとデスペラード",
            "category": "maimai",
            "title": "星詠みとデスペラード",
            "artist": "しょご/野村渉悟",
            "bpm": 182,
            "imageName": "ed8138a80a7ef034539482ffbf15d3c0455898974bbfc723a3483a89986aa09a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 9,
                        "slide": 8,
                        "touch": 17,
                        "break": 1,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11303,
                    "releaseDate": "2021-10-29"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 16,
                        "slide": 32,
                        "touch": 17,
                        "break": 5,
                        "total": 254
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11303,
                    "releaseDate": "2021-10-29"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 366,
                        "hold": 72,
                        "slide": 38,
                        "touch": 22,
                        "break": 8,
                        "total": 506
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11303,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 11.8
                    },
                    "releaseDate": "2021-10-29"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 620,
                        "hold": 70,
                        "slide": 60,
                        "touch": 69,
                        "break": 13,
                        "total": 832
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11303,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 14,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 14
                    },
                    "releaseDate": "2021-10-29"
                }
            ],
            "searchAcronyms": [
                "星之咏唱者与亡命之徒",
                "星咏",
                "星诵"
            ]
        },
        {
            "songId": "Technicians High",
            "category": "maimai",
            "title": "Technicians High",
            "artist": "HiTECH NINJA",
            "bpm": 165,
            "imageName": "414efc22ecc4eb1f83f98c99a39afc090da7da914874716064247caadb44a320",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 9,
                        "slide": 4,
                        "touch": 7,
                        "break": 6,
                        "total": 195
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11020,
                    "releaseDate": "2019-08-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 224,
                        "hold": 20,
                        "slide": 22,
                        "touch": 25,
                        "break": 17,
                        "total": 308
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11020,
                    "releaseDate": "2019-08-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 363,
                        "hold": 69,
                        "slide": 33,
                        "touch": 44,
                        "break": 44,
                        "total": 553
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11020,
                    "releaseDate": "2019-08-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 668,
                        "hold": 13,
                        "slide": 25,
                        "touch": 147,
                        "break": 17,
                        "total": 870
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11020,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.4,
                        "Splash": 13.4,
                        "Splash PLUS": 13.4,
                        "UNiVERSE": 13.4,
                        "UNiVERSE PLUS": 13.4,
                        "maimaiでらっくす PLUS": 13.4
                    },
                    "releaseDate": "2019-08-09"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 101,
                        "hold": 11,
                        "slide": 11,
                        "touch": null,
                        "break": 2,
                        "total": 125
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 1020,
                    "releaseDate": "2021-11-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 326,
                        "hold": 22,
                        "slide": 14,
                        "touch": null,
                        "break": 14,
                        "total": 376
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 1020,
                    "releaseDate": "2021-11-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 390,
                        "hold": 86,
                        "slide": 58,
                        "touch": null,
                        "break": 24,
                        "total": 558
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 1020,
                    "releaseDate": "2021-11-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 642,
                        "hold": 48,
                        "slide": 86,
                        "touch": null,
                        "break": 8,
                        "total": 784
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 1020,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2021-11-11"
                }
            ],
            "searchAcronyms": [
                "dx科技高",
                "标准科技高",
                "科技",
                "科技很高",
                "科技高",
                "蓝的盆",
                "高科技"
            ]
        },
        {
            "songId": "Sweets Time",
            "category": "東方Project",
            "title": "Sweets Time",
            "artist": "SYNC.ART'S feat. 3L",
            "bpm": 150,
            "imageName": "2dc83ad1c1f814ef56347a456c261d74c4878596d5824cfd21e96c4e1fc28e0a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 121,
                        "hold": 4,
                        "slide": 4,
                        "touch": 8,
                        "break": 2,
                        "total": 139
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11340,
                    "releaseDate": "2021-11-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 28,
                        "slide": 16,
                        "touch": 24,
                        "break": 14,
                        "total": 359
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11340,
                    "releaseDate": "2021-11-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 138,
                        "slide": 52,
                        "touch": 18,
                        "break": 10,
                        "total": 360
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11340,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 10
                    },
                    "releaseDate": "2021-11-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 430,
                        "hold": 0,
                        "slide": 218,
                        "touch": 3,
                        "break": 7,
                        "total": 658
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11340,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM": 13,
                        "PRiSM PLUS": 13.1,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2021-11-12"
                }
            ],
            "searchAcronyms": [
                "小幸隐",
                "甜蜜时光",
                "芙兰数星星",
                "迪士尼乐园"
            ]
        },
        {
            "songId": "紅星ミゼラブル～廃憶編",
            "category": "東方Project",
            "title": "紅星ミゼラブル～廃憶編",
            "artist": "東京アクティブNEETs",
            "bpm": 160,
            "imageName": "d11981f6b1bdbf6b084454331f5be7b92c4407f06e51c80537dc929ea803fd07",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 115,
                        "hold": 6,
                        "slide": 5,
                        "touch": 8,
                        "break": 5,
                        "total": 139
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11341,
                    "releaseDate": "2021-11-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 18,
                        "slide": 25,
                        "touch": 27,
                        "break": 6,
                        "total": 307
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11341,
                    "releaseDate": "2021-11-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 366,
                        "hold": 77,
                        "slide": 39,
                        "touch": 19,
                        "break": 21,
                        "total": 522
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11341,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 10
                    },
                    "releaseDate": "2021-11-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Redarrow",
                    "noteCounts": {
                        "tap": 568,
                        "hold": 54,
                        "slide": 72,
                        "touch": 123,
                        "break": 20,
                        "total": 837
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11341,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2021-11-12"
                }
            ],
            "searchAcronyms": [
                "红星",
                "蕾米吹zun号",
                "蕾米吹喇叭",
                "蕾米吹小号",
                "蕾米莉亚吹喇叭",
                "蕾米莉亚吹小号",
                "蕾米莉亚吹滴答"
            ]
        },
        {
            "songId": "幻想に咲いた花",
            "category": "東方Project",
            "title": "幻想に咲いた花",
            "artist": "岸田教団&THE明星ロケッツ×草野華余子「東方ダンマクカグラ」",
            "bpm": 186,
            "imageName": "d770fe8118ef6d2bd0883b54a9736c8d95ecd59d2b330050f9c3985c7c92c952",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 9,
                        "slide": 6,
                        "touch": 11,
                        "break": 2,
                        "total": 131
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11342,
                    "releaseDate": "2021-11-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 30,
                        "slide": 20,
                        "touch": 17,
                        "break": 7,
                        "total": 325
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11342,
                    "releaseDate": "2021-11-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 360,
                        "hold": 50,
                        "slide": 33,
                        "touch": 21,
                        "break": 18,
                        "total": 482
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11342,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 9.7
                    },
                    "releaseDate": "2021-11-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "アミノハバキリ",
                    "noteCounts": {
                        "tap": 522,
                        "hold": 59,
                        "slide": 105,
                        "touch": 31,
                        "break": 20,
                        "total": 737
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11342,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "BUDDiES PLUS": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.1,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2021-11-12"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 568,
                        "hold": 27,
                        "slide": 159,
                        "touch": 44,
                        "break": 21,
                        "total": 819
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11342,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2024-10-10"
                }
            ],
            "searchAcronyms": [
                "幻想之花",
                "幻想咲花",
                "幻想花",
                "弹幕神乐"
            ]
        },
        {
            "songId": "マツヨイナイトバグ",
            "category": "東方Project",
            "title": "マツヨイナイトバグ",
            "artist": "COOL&CREATE feat.ビートまりおとまろん「東方ダンマクカグラ」",
            "bpm": 190,
            "imageName": "48b230be9dd9b5cbafa31e5fa94ed7f1fbdb3dc37245bc0a6665d943fb290d95",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 119,
                        "hold": 13,
                        "slide": 6,
                        "touch": 14,
                        "break": 7,
                        "total": 159
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11343,
                    "releaseDate": "2021-11-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 31,
                        "slide": 9,
                        "touch": 40,
                        "break": 10,
                        "total": 375
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11343,
                    "releaseDate": "2021-11-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 444,
                        "hold": 97,
                        "slide": 56,
                        "touch": 9,
                        "break": 17,
                        "total": 623
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11343,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 10.7
                    },
                    "releaseDate": "2021-11-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 732,
                        "hold": 23,
                        "slide": 115,
                        "touch": 23,
                        "break": 89,
                        "total": 982
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11343,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2021-11-12"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 671,
                        "hold": 45,
                        "slide": 115,
                        "touch": 132,
                        "break": 164,
                        "total": 1127
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11343,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3
                    },
                    "releaseDate": "2024-10-10"
                }
            ],
            "searchAcronyms": [
                "matsuyoi",
                "Matsuyoi Nightbug",
                "nightbug",
                "Nightbug",
                "东方绿毛虫",
                "待宵的萤火虫",
                "绿头发",
                "绿毛虫",
                "绿毛龟",
                "绿色夜光虫",
                "绿色女人",
                "绿色苍蝇",
                "苍蝇妹",
                "莉格露",
                "萤火虫",
                "蠢虫"
            ]
        },
        {
            "songId": "ポッピンキャンディ☆フィーバー！",
            "category": "niconico＆ボーカロイド",
            "title": "ポッピンキャンディ☆フィーバー！",
            "artist": "キノシタ",
            "bpm": 190,
            "imageName": "dd37a76915169838db62d58c8eab3fcca2995cc25fe022e19e3e3cebf6bb26d4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 121,
                        "hold": 9,
                        "slide": 6,
                        "touch": 8,
                        "break": 4,
                        "total": 148
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11344,
                    "releaseDate": "2021-11-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 25,
                        "slide": 18,
                        "touch": 18,
                        "break": 44,
                        "total": 395
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11344,
                    "releaseDate": "2021-11-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 450,
                        "hold": 45,
                        "slide": 40,
                        "touch": 35,
                        "break": 29,
                        "total": 599
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11344,
                    "releaseDate": "2021-11-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 551,
                        "hold": 75,
                        "slide": 87,
                        "touch": 116,
                        "break": 43,
                        "total": 872
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11344,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2021-11-26"
                }
            ],
            "searchAcronyms": [
                "poppin candy fever",
                "poppin' candy fever",
                "女同3",
                "怨！",
                "流行糖果发烧了",
                "流行糖果热"
            ]
        },
        {
            "songId": "どぅーまいべすと！",
            "category": "niconico＆ボーカロイド",
            "title": "どぅーまいべすと！",
            "artist": "キノシタ",
            "bpm": 128,
            "imageName": "7dbfcdbc8b72ede0edd43fea326c82d157294fe65af2483d2d939dd83834dd81",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 70,
                        "hold": 3,
                        "slide": 3,
                        "touch": 15,
                        "break": 1,
                        "total": 92
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11345,
                    "releaseDate": "2021-11-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 17,
                        "slide": 14,
                        "touch": 7,
                        "break": 6,
                        "total": 232
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11345,
                    "releaseDate": "2021-11-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 379,
                        "hold": 68,
                        "slide": 9,
                        "touch": 12,
                        "break": 9,
                        "total": 477
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11345,
                    "releaseDate": "2021-11-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 506,
                        "hold": 60,
                        "slide": 39,
                        "touch": 31,
                        "break": 35,
                        "total": 671
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11345,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM PLUS": 12.4,
                        "UNiVERSE": 12.4,
                        "UNiVERSE PLUS": 12.4
                    },
                    "releaseDate": "2021-11-26"
                }
            ],
            "searchAcronyms": [
                "do mai best",
                "do my best",
                "独立宣言",
                "音街宣言"
            ]
        },
        {
            "songId": "Round Round Spinning Around",
            "category": "maimai",
            "title": "Round Round Spinning Around",
            "artist": "Nhato",
            "bpm": 175,
            "imageName": "a998af4d4f7f1514db238b13ad9f3cf3ff2c15586f6c3a2d0097ac58f41dbf28",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 131,
                        "hold": 9,
                        "slide": 6,
                        "touch": 5,
                        "break": 4,
                        "total": 155
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11304,
                    "releaseDate": "2021-12-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 346,
                        "hold": 14,
                        "slide": 20,
                        "touch": 11,
                        "break": 14,
                        "total": 405
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11304,
                    "releaseDate": "2021-12-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 427,
                        "hold": 37,
                        "slide": 47,
                        "touch": 10,
                        "break": 10,
                        "total": 531
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11304,
                    "releaseDate": "2021-12-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "すきやき奉行",
                    "noteCounts": {
                        "tap": 588,
                        "hold": 78,
                        "slide": 101,
                        "touch": 46,
                        "break": 8,
                        "total": 821
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11304,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2021-12-10"
                }
            ],
            "searchAcronyms": [
                "rrsa",
                "大鸟转转转",
                "滨州转转转",
                "绕着旋转",
                "转圈圈",
                "转转",
                "转转转转",
                "魔爪吊带袜美少女"
            ]
        },
        {
            "songId": "Alcyone",
            "category": "maimai",
            "title": "Alcyone",
            "artist": "PRASTIK DANCEFLOOR",
            "bpm": 176,
            "imageName": "c6a90df6ab49d2d9c03777cad95d64e07361d8ff408466642b16e0974261f9c6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 119,
                        "hold": 15,
                        "slide": 8,
                        "touch": 10,
                        "break": 4,
                        "total": 156
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11305,
                    "releaseDate": "2021-12-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 279,
                        "hold": 37,
                        "slide": 24,
                        "touch": 27,
                        "break": 12,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11305,
                    "releaseDate": "2021-12-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 421,
                        "hold": 90,
                        "slide": 63,
                        "touch": 40,
                        "break": 21,
                        "total": 635
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11305,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12,
                        "UNiVERSE": 12
                    },
                    "releaseDate": "2021-12-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 644,
                        "hold": 78,
                        "slide": 94,
                        "touch": 53,
                        "break": 16,
                        "total": 885
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11305,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 14,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "UNiVERSE": 14,
                        "UNiVERSE PLUS": 14
                    },
                    "releaseDate": "2021-12-10"
                }
            ],
            "searchAcronyms": [
                "alc",
                "凯尔希"
            ]
        },
        {
            "songId": "Raven Emperor",
            "category": "maimai",
            "title": "Raven Emperor",
            "artist": "Kobaryo",
            "bpm": 205,
            "imageName": "9808a875f51681af62fd3685fe151641fae4720dd8cd4bfe71470f51ee53260f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 14,
                        "slide": 6,
                        "touch": 6,
                        "break": 2,
                        "total": 185
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11306,
                    "releaseDate": "2021-12-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 24,
                        "slide": 15,
                        "touch": 19,
                        "break": 14,
                        "total": 414
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11306,
                    "releaseDate": "2021-12-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 395,
                        "hold": 65,
                        "slide": 69,
                        "touch": 48,
                        "break": 38,
                        "total": 615
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11306,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12,
                        "UNiVERSE": 12
                    },
                    "releaseDate": "2021-12-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 614,
                        "hold": 78,
                        "slide": 115,
                        "touch": 24,
                        "break": 57,
                        "total": 888
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11306,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "UNiVERSE": 14.4,
                        "UNiVERSE PLUS": 14.5
                    },
                    "releaseDate": "2021-12-10"
                }
            ],
            "searchAcronyms": [
                "erwaqaqaqa",
                "休息段不要看那里挑战",
                "大奶子眼镜妹",
                "妹妹发把狙",
                "渡鸦皇帝",
                "瑞文皇帝",
                "虚低逼",
                "锐雯皇帝",
                "鸦皇"
            ]
        },
        {
            "songId": "Yorugao",
            "category": "maimai",
            "title": "Yorugao",
            "artist": "An & Ryunosuke Kudo",
            "bpm": 182,
            "imageName": "b956d53d3c0f34fb42573505cd8ca962fa882e395473080f2f095d5c8c8ea765",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 19,
                        "slide": 7,
                        "touch": 14,
                        "break": 3,
                        "total": 168
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11307,
                    "releaseDate": "2021-12-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 309,
                        "hold": 18,
                        "slide": 23,
                        "touch": 13,
                        "break": 6,
                        "total": 369
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11307,
                    "releaseDate": "2021-12-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 428,
                        "hold": 91,
                        "slide": 52,
                        "touch": 21,
                        "break": 16,
                        "total": 608
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11307,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "FESTiVAL": 12.2,
                        "PRiSM PLUS": 12.2,
                        "UNiVERSE": 12.2
                    },
                    "releaseDate": "2021-12-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "Jack & Licorice Gunjyo",
                    "noteCounts": {
                        "tap": 712,
                        "hold": 76,
                        "slide": 102,
                        "touch": 59,
                        "break": 5,
                        "total": 954
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11307,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.6,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL": 14.6,
                        "FESTiVAL PLUS": 14.6,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6,
                        "UNiVERSE": 14.6,
                        "UNiVERSE PLUS": 14.6
                    },
                    "releaseDate": "2021-12-10"
                }
            ],
            "searchAcronyms": [
                "夜颜",
                "月光花",
                "有乳膏",
                "油乳膏",
                "牙膏",
                "牛肉干",
                "犹如高",
                "紫黑"
            ]
        },
        {
            "songId": "U&iVERSE -銀河鸞翔-",
            "category": "maimai",
            "title": "U&iVERSE -銀河鸞翔-",
            "artist": "Kai VS 大国奏音 VS 水野健治",
            "bpm": 140,
            "imageName": "bac06802ab44b23ac597298651ef3551f026564a65c6acc855cc5f24174ec9bc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 164,
                        "hold": 22,
                        "slide": 7,
                        "touch": 17,
                        "break": 2,
                        "total": 212
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11300,
                    "releaseDate": "2021-12-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 347,
                        "hold": 32,
                        "slide": 12,
                        "touch": 28,
                        "break": 4,
                        "total": 423
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11300,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 9
                    },
                    "releaseDate": "2021-12-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.1,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 522,
                        "hold": 83,
                        "slide": 38,
                        "touch": 61,
                        "break": 12,
                        "total": 716
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11300,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.1,
                        "CiRCLE PLUS": 12.1,
                        "FESTiVAL": 12.1,
                        "FESTiVAL PLUS": 12.1,
                        "PRiSM PLUS": 12.1,
                        "UNiVERSE": 12,
                        "UNiVERSE PLUS": 12
                    },
                    "releaseDate": "2021-12-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 659,
                        "hold": 29,
                        "slide": 101,
                        "touch": 126,
                        "break": 100,
                        "total": 1015
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11300,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.4,
                        "FESTiVAL PLUS": 14.4,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "UNiVERSE": 14.4,
                        "UNiVERSE PLUS": 14.4
                    },
                    "releaseDate": "2021-12-16"
                }
            ],
            "searchAcronyms": [
                "😫",
                "3d白猫",
                "kop3rd预选曲",
                "U&amp;iVERSE -銀河鸞翔-",
                "u&i",
                "u&iverse",
                "universe",
                "金典有机奶",
                "金牛奶",
                "银河",
                "银河乱翔",
                "银河卵翔",
                "银河护卫队",
                "银河拉翔",
                "银河翱翔",
                "银河飞翔",
                "银河鸟屎",
                "银河鸾翔",
                "银河鸞翔"
            ]
        },
        {
            "songId": "失敗作少女",
            "category": "niconico＆ボーカロイド",
            "title": "失敗作少女",
            "artist": "かいりきベア・MARETU feat.初音ミク",
            "bpm": 235,
            "imageName": "03529a524484f9c729d6adf1fd94e2c789d8c1e662fab204d429660a1458961b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 87,
                        "hold": 15,
                        "slide": 4,
                        "touch": 21,
                        "break": 1,
                        "total": 128
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11349,
                    "releaseDate": "2021-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 202,
                        "hold": 27,
                        "slide": 36,
                        "touch": 27,
                        "break": 3,
                        "total": 295
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11349,
                    "releaseDate": "2021-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 84,
                        "slide": 41,
                        "touch": 36,
                        "break": 17,
                        "total": 450
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11349,
                    "releaseDate": "2021-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 525,
                        "hold": 80,
                        "slide": 79,
                        "touch": 81,
                        "break": 30,
                        "total": 795
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11349,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.1,
                        "UNiVERSE": 12.8
                    },
                    "releaseDate": "2021-12-24"
                }
            ],
            "searchAcronyms": [
                "Failure Girl",
                "失败作",
                "失败作小子",
                "失败作少女",
                "失败作老子",
                "失败做少女",
                "她",
                "我",
                "我肯定"
            ]
        },
        {
            "songId": "悪魔の踊り方",
            "category": "niconico＆ボーカロイド",
            "title": "悪魔の踊り方",
            "artist": "キタニタツヤ",
            "bpm": 106,
            "imageName": "9027d3d2d6d03ef1f8e2855aafd99f1fc0deaac6c261a47809d40bf7ecb91343",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 89,
                        "hold": 11,
                        "slide": 4,
                        "touch": 7,
                        "break": 2,
                        "total": 113
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11350,
                    "releaseDate": "2021-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 21,
                        "slide": 10,
                        "touch": 24,
                        "break": 7,
                        "total": 246
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11350,
                    "releaseDate": "2021-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 374,
                        "hold": 27,
                        "slide": 32,
                        "touch": 29,
                        "break": 19,
                        "total": 481
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11350,
                    "releaseDate": "2021-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 489,
                        "hold": 64,
                        "slide": 85,
                        "touch": 27,
                        "break": 11,
                        "total": 676
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11350,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2021-12-24"
                }
            ],
            "searchAcronyms": [
                "Devil's Manner",
                "The Devil's Manners",
                "恶魔",
                "恶魔的写谱方法",
                "恶魔的舞蹈方式",
                "恶魔跳舞",
                "恶魔踊"
            ]
        },
        {
            "songId": "ノイローゼ",
            "category": "niconico＆ボーカロイド",
            "title": "ノイローゼ",
            "artist": "蜂屋ななし",
            "bpm": 200,
            "imageName": "4cd9f503a213246d98c6ea26e7da5e271a862b68160a60b635aaf6e578986132",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 94,
                        "hold": 14,
                        "slide": 6,
                        "touch": 21,
                        "break": 1,
                        "total": 136
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11351,
                    "releaseDate": "2021-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 314,
                        "hold": 37,
                        "slide": 19,
                        "touch": 23,
                        "break": 8,
                        "total": 401
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11351,
                    "releaseDate": "2021-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 512,
                        "hold": 73,
                        "slide": 47,
                        "touch": 17,
                        "break": 6,
                        "total": 655
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11351,
                    "releaseDate": "2021-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 600,
                        "hold": 73,
                        "slide": 149,
                        "touch": 56,
                        "break": 9,
                        "total": 887
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11351,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE": 12.9
                    },
                    "releaseDate": "2021-12-24"
                }
            ],
            "searchAcronyms": [
                "Neurose",
                "神经官能症",
                "神经病",
                "神经症",
                "神经质",
                "米津玄师"
            ]
        },
        {
            "songId": "響け！CHIREI MY WAY!",
            "category": "東方Project",
            "title": "響け！CHIREI MY WAY!",
            "artist": "森羅万象",
            "bpm": 181,
            "imageName": "e7a8233cd18733ed4296e5841ca3d9b8e3dca869b3da2b05040ae8b7ab81b1e7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 42,
                        "hold": 20,
                        "slide": 5,
                        "touch": 13,
                        "break": 3,
                        "total": 83
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11362,
                    "releaseDate": "2022-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 15,
                        "slide": 23,
                        "touch": 14,
                        "break": 16,
                        "total": 258
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11362,
                    "releaseDate": "2022-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 46,
                        "slide": 17,
                        "touch": 12,
                        "break": 35,
                        "total": 416
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11362,
                    "releaseDate": "2022-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 32,
                        "slide": 101,
                        "touch": 39,
                        "break": 36,
                        "total": 552
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11362,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2022-01-06"
                }
            ],
            "searchAcronyms": [
                "响",
                "地灵殿偶像"
            ]
        },
        {
            "songId": "神々が恋した幻想郷",
            "category": "東方Project",
            "title": "神々が恋した幻想郷",
            "artist": "Unlucky Morpheus",
            "bpm": 155,
            "imageName": "c717245dff86937284935051b531adff6876466fb562c796cb7aadffa9c0ac50",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 97,
                        "hold": 12,
                        "slide": 3,
                        "touch": 7,
                        "break": 4,
                        "total": 123
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11363,
                    "releaseDate": "2022-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 17,
                        "slide": 16,
                        "touch": 15,
                        "break": 13,
                        "total": 356
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11363,
                    "releaseDate": "2022-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 340,
                        "hold": 69,
                        "slide": 47,
                        "touch": 18,
                        "break": 19,
                        "total": 493
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11363,
                    "releaseDate": "2022-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 753,
                        "hold": 42,
                        "slide": 55,
                        "touch": 23,
                        "break": 38,
                        "total": 911
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11363,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5,
                        "UNiVERSE": 13.3,
                        "UNiVERSE PLUS": 13.3
                    },
                    "releaseDate": "2022-01-06"
                }
            ],
            "searchAcronyms": [
                "Eastern Cross",
                "testify",
                "东十字",
                "东十字星",
                "东方南十字",
                "众神眷恋的十字星",
                "众神眷恋的幻想乡",
                "小南十字",
                "幻想乡",
                "神仙稀罕俺们屯",
                "神恋",
                "神眷",
                "神都得意俺们屯",
                "终神眷恋的南十字",
                "青春版白南十字星"
            ]
        },
        {
            "songId": "Destr0yer",
            "category": "ゲーム＆バラエティ",
            "title": "Destr0yer",
            "artist": "削除 feat. Nikki Simmons",
            "bpm": 90,
            "imageName": "039d7dd5b8db61bbee5896526ac06faa004772fd06ae489304ca71b71ae3f44a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 78,
                        "hold": 18,
                        "slide": 1,
                        "touch": 16,
                        "break": 3,
                        "total": 116
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11051,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 29,
                        "slide": 9,
                        "touch": 35,
                        "break": 9,
                        "total": 271
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11051,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 36,
                        "slide": 37,
                        "touch": 80,
                        "break": 2,
                        "total": 440
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11051,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 53,
                        "slide": 66,
                        "touch": 114,
                        "break": 5,
                        "total": 602
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11051,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "Splash": 12.9,
                        "Splash PLUS": 12.9,
                        "UNiVERSE": 12.9,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 112,
                        "hold": 32,
                        "slide": 13,
                        "touch": null,
                        "break": 6,
                        "total": 163
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 1051,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 313,
                        "hold": 12,
                        "slide": 38,
                        "touch": null,
                        "break": 11,
                        "total": 374
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 1051,
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 416,
                        "hold": 69,
                        "slide": 42,
                        "touch": null,
                        "break": 10,
                        "total": 537
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 1051,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12,
                        "UNiVERSE": 12
                    },
                    "releaseDate": "2019-07-11"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 744,
                        "hold": 53,
                        "slide": 84,
                        "touch": null,
                        "break": 16,
                        "total": 897
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 1051,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2,
                        "UNiVERSE": 14,
                        "UNiVERSE PLUS": 14
                    },
                    "releaseDate": "2019-07-11"
                }
            ],
            "searchAcronyms": [
                "----------☀️◻",
                "d0",
                "D0",
                "destroyer",
                "Destroyer",
                "别急10",
                "削除",
                "削除光线",
                "削除射线",
                "射精方块头",
                "方块头",
                "标d0",
                "毁灭者",
                "消除男",
                "驱逐舰"
            ]
        },
        {
            "songId": "ぱくぱく☆がーる",
            "category": "オンゲキ＆CHUNITHM",
            "title": "ぱくぱく☆がーる",
            "artist": "曲：齋藤大／歌：珠洲島 有栖(CV：長縄 まりあ)",
            "bpm": 121,
            "imageName": "0180b97ba055593c48c6c25e2b56f9b1219a55faf0171b9cf6e803fc6af15fa4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 134,
                        "hold": 17,
                        "slide": 4,
                        "touch": 30,
                        "break": 31,
                        "total": 216
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11312,
                    "releaseDate": "2022-01-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 25,
                        "slide": 16,
                        "touch": 50,
                        "break": 11,
                        "total": 331
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11312,
                    "releaseDate": "2022-01-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 370,
                        "hold": 81,
                        "slide": 53,
                        "touch": 70,
                        "break": 50,
                        "total": 624
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11312,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 10.2
                    },
                    "releaseDate": "2022-01-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Redarrow",
                    "noteCounts": {
                        "tap": 613,
                        "hold": 80,
                        "slide": 66,
                        "touch": 164,
                        "break": 75,
                        "total": 998
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11312,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "BUDDiES PLUS": 13.1,
                        "CiRCLE": 13.2,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM": 13.1,
                        "PRiSM PLUS": 13.2,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2022-01-14"
                }
            ],
            "searchAcronyms": [
                "pac pac girl",
                "Pakupaku",
                "Pakupaku Girl",
                "哦那卡素一大",
                "我他妈吃吃吃",
                "我那个贼大",
                "报菜名",
                "江江",
                "江江下锅",
                "江江报菜名",
                "江江炫饭",
                "肚子饿了",
                "郭达抱蔡明"
            ]
        },
        {
            "songId": "No Limit RED Force",
            "category": "オンゲキ＆CHUNITHM",
            "title": "No Limit RED Force",
            "artist": "曲：本多友紀（Arte Refact）／歌：オンゲキシューターズ",
            "bpm": 146,
            "imageName": "ed0f1379122fa5f1c8ce9642ece8d474c4df638c4471b8334012781026d5b7d5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 112,
                        "hold": 9,
                        "slide": 3,
                        "touch": 8,
                        "break": 6,
                        "total": 138
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11313,
                    "releaseDate": "2022-01-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 238,
                        "hold": 15,
                        "slide": 29,
                        "touch": 9,
                        "break": 11,
                        "total": 302
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11313,
                    "releaseDate": "2022-01-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 332,
                        "hold": 40,
                        "slide": 43,
                        "touch": 26,
                        "break": 41,
                        "total": 482
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11313,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 9.7
                    },
                    "releaseDate": "2022-01-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 475,
                        "hold": 46,
                        "slide": 81,
                        "touch": 40,
                        "break": 48,
                        "total": 690
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11313,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2022-01-14"
                }
            ],
            "searchAcronyms": [
                "无尽的赤红之力",
                "无限红",
                "无限红力",
                "红色电音极地大冲击"
            ]
        },
        {
            "songId": "LiftOff",
            "category": "オンゲキ＆CHUNITHM",
            "title": "LiftOff",
            "artist": "MAYA AKAI",
            "bpm": 137,
            "imageName": "3b57623b46909acc86602d131f716ce89f8c008cdfd26bed18826e51467a8845",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 91,
                        "hold": 29,
                        "slide": 9,
                        "touch": 16,
                        "break": 1,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11314,
                    "releaseDate": "2022-01-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 11,
                        "slide": 16,
                        "touch": 9,
                        "break": 10,
                        "total": 388
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11314,
                    "releaseDate": "2022-01-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 376,
                        "hold": 67,
                        "slide": 52,
                        "touch": 113,
                        "break": 11,
                        "total": 619
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11314,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 11.7
                    },
                    "releaseDate": "2022-01-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 605,
                        "hold": 48,
                        "slide": 78,
                        "touch": 23,
                        "break": 13,
                        "total": 767
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11314,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2022-01-14"
                }
            ],
            "searchAcronyms": [
                "东云纺坐电梯",
                "关电梯",
                "刑具",
                "发射",
                "妙脆角",
                "抬棺",
                "火箭",
                "起飞",
                "长角女孩"
            ]
        },
        {
            "songId": "Falsum Atlantis.",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Falsum Atlantis.",
            "artist": "kanone",
            "bpm": 160,
            "imageName": "cb129ca3b7051d4289839528f4005012ad1de565ed68baa7641508c15a627062",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 16,
                        "slide": 6,
                        "touch": 9,
                        "break": 3,
                        "total": 191
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11315,
                    "releaseDate": "2022-01-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 28,
                        "slide": 29,
                        "touch": 22,
                        "break": 18,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11315,
                    "releaseDate": "2022-01-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 530,
                        "hold": 50,
                        "slide": 54,
                        "touch": 34,
                        "break": 4,
                        "total": 672
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11315,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.6,
                        "UNiVERSE": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2022-01-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 685,
                        "hold": 116,
                        "slide": 53,
                        "touch": 94,
                        "break": 29,
                        "total": 977
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11315,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "UNiVERSE": 14.4,
                        "UNiVERSE PLUS": 14.4
                    },
                    "releaseDate": "2022-01-14"
                }
            ],
            "searchAcronyms": [
                "fa",
                "falsum",
                "亚特兰蒂斯",
                "刹那",
                "江江,我是刹那",
                "皇城刹那"
            ]
        },
        {
            "songId": "なだめスかし Negotiation（TVsize）",
            "category": "POPS＆アニメ",
            "title": "なだめスかし Negotiation（TVsize）",
            "artist": "鹿乃と宇崎ちゃん",
            "bpm": 150,
            "imageName": "97dd2ced82b8408e8e559976d6f6848e941d27e4627df389483ed36ec23b6071",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 72,
                        "hold": 11,
                        "slide": 3,
                        "touch": 8,
                        "break": 1,
                        "total": 95
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11356,
                    "releaseDate": "2022-01-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 16,
                        "slide": 8,
                        "touch": 15,
                        "break": 5,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11356,
                    "releaseDate": "2022-01-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 221,
                        "hold": 49,
                        "slide": 15,
                        "touch": 19,
                        "break": 8,
                        "total": 312
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11356,
                    "releaseDate": "2022-01-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 393,
                        "hold": 30,
                        "slide": 56,
                        "touch": 27,
                        "break": 16,
                        "total": 522
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11356,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2022-01-28"
                }
            ],
            "searchAcronyms": [
                "Negotiation",
                "sugoi dekai"
            ]
        },
        {
            "songId": "インドア系ならトラックメイカー",
            "category": "POPS＆アニメ",
            "title": "インドア系ならトラックメイカー",
            "artist": "Yunomi & nicamoq",
            "bpm": 128,
            "imageName": "b0de196b2e5d7fe4025da4833c4d4647ad2eb348c4de3151c1b49910b799501a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 81,
                        "hold": 6,
                        "slide": 7,
                        "touch": 15,
                        "break": 6,
                        "total": 115
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11358,
                    "releaseDate": "2022-01-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 17,
                        "slide": 5,
                        "touch": 53,
                        "break": 20,
                        "total": 284
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11358,
                    "releaseDate": "2022-01-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 184,
                        "slide": 33,
                        "touch": 57,
                        "break": 8,
                        "total": 439
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11358,
                    "releaseDate": "2022-01-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "一ノ瀬 リズ",
                    "noteCounts": {
                        "tap": 507,
                        "hold": 47,
                        "slide": 78,
                        "touch": 68,
                        "break": 3,
                        "total": 703
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11358,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2022-01-28"
                }
            ],
            "searchAcronyms": [
                "Indoor kei nara Trackmaker",
                "nichan",
                "Trackmaker",
                "内向都是作曲家",
                "室内系",
                "室内系的track maker",
                "室内系的trackmaker",
                "室内轨道制造商",
                "小姐姐",
                "我不玩舞萌DX"
            ]
        },
        {
            "songId": "ヒステリックナイトガール",
            "category": "ゲーム＆バラエティ",
            "title": "ヒステリックナイトガール",
            "artist": "PSYQUI",
            "bpm": 126,
            "imageName": "ae2c9b69f3da168db00889e2402fe220a04ba81efc995856e72b8ffd5683170e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 121,
                        "hold": 1,
                        "slide": 6,
                        "touch": 12,
                        "break": 1,
                        "total": 141
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11373,
                    "releaseDate": "2022-01-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 12,
                        "slide": 9,
                        "touch": 7,
                        "break": 11,
                        "total": 273
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11373,
                    "releaseDate": "2022-01-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 301,
                        "hold": 52,
                        "slide": 87,
                        "touch": 5,
                        "break": 18,
                        "total": 463
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11373,
                    "releaseDate": "2022-01-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 504,
                        "hold": 35,
                        "slide": 127,
                        "touch": 7,
                        "break": 22,
                        "total": 695
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11373,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE": 12.8
                    },
                    "releaseDate": "2022-01-28"
                }
            ],
            "searchAcronyms": [
                "啊啊啊啊！",
                "夜晚歇斯底里女孩",
                "歇斯底里",
                "歇斯底里夜女郎",
                "歇斯底里夜晚女孩",
                "歇斯底里女孩",
                "眼保健操",
                "竭斯底里"
            ]
        },
        {
            "songId": "ヨミビトシラズ",
            "category": "maimai",
            "title": "ヨミビトシラズ",
            "artist": "Limonène (サノカモメ+月島春果)",
            "bpm": 188,
            "imageName": "11e5b7df66aa5b162f073333896cf141b031947777293f9048d66753dfaaf175",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 5,
                        "slide": 11,
                        "touch": 17,
                        "break": 1,
                        "total": 210
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11308,
                    "releaseDate": "2022-02-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 249,
                        "hold": 15,
                        "slide": 26,
                        "touch": 32,
                        "break": 3,
                        "total": 325
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11308,
                    "releaseDate": "2022-02-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 533,
                        "hold": 37,
                        "slide": 42,
                        "touch": 35,
                        "break": 5,
                        "total": 652
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11308,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2022-02-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 751,
                        "hold": 50,
                        "slide": 80,
                        "touch": 36,
                        "break": 4,
                        "total": 921
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11308,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2022-02-10"
                }
            ],
            "searchAcronyms": [
                "东雪莲",
                "东雪莲打伞",
                "佚名",
                "作者不详",
                "冬雪莲",
                "咏人不知",
                "哇嘎得路哟",
                "我不知道",
                "東雪莲",
                "東雪蓮",
                "罕见",
                "蓝屏"
            ]
        },
        {
            "songId": "前衛的Landscape",
            "category": "maimai",
            "title": "前衛的Landscape",
            "artist": "HiTECH NINJA feat. RANASOL",
            "bpm": 153,
            "imageName": "5ba16f0773239c0717f23e1fb863cf3c96616af72661ebdbe537c6ea27438435",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 123,
                        "hold": 8,
                        "slide": 4,
                        "touch": 11,
                        "break": 3,
                        "total": 149
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11309,
                    "releaseDate": "2022-02-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 17,
                        "slide": 14,
                        "touch": 9,
                        "break": 6,
                        "total": 300
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11309,
                    "releaseDate": "2022-02-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 46,
                        "slide": 53,
                        "touch": 21,
                        "break": 17,
                        "total": 455
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11309,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 11.4
                    },
                    "releaseDate": "2022-02-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 566,
                        "hold": 33,
                        "slide": 107,
                        "touch": 38,
                        "break": 11,
                        "total": 755
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11309,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2022-02-10"
                }
            ],
            "searchAcronyms": [
                "亲爱滴小妹妹",
                "前卫",
                "前卫的landepen",
                "前卫的landscape",
                "前卫的小妹妹",
                "提纳里",
                "给我玩舞萌dx"
            ]
        },
        {
            "songId": "Trick tear",
            "category": "maimai",
            "title": "Trick tear",
            "artist": "しーけー",
            "bpm": 222,
            "imageName": "70b83fc113aa3f30894a0febc529995fa56f63e493f93ad0055bd1efb3bb787e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 166,
                        "hold": 13,
                        "slide": 3,
                        "touch": 23,
                        "break": 6,
                        "total": 211
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11310,
                    "releaseDate": "2022-02-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 324,
                        "hold": 28,
                        "slide": 15,
                        "touch": 31,
                        "break": 24,
                        "total": 422
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11310,
                    "releaseDate": "2022-02-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 361,
                        "hold": 94,
                        "slide": 58,
                        "touch": 45,
                        "break": 51,
                        "total": 609
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11310,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2022-02-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 518,
                        "hold": 75,
                        "slide": 116,
                        "touch": 90,
                        "break": 41,
                        "total": 840
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11310,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.4,
                        "FESTiVAL PLUS": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "UNiVERSE": 14.4,
                        "UNiVERSE PLUS": 14.4
                    },
                    "releaseDate": "2022-02-10"
                }
            ],
            "searchAcronyms": [
                "tt",
                "TT",
                "吹个提尔",
                "吹个替儿",
                "欺骗泪",
                "诈泪",
                "诡泪"
            ]
        },
        {
            "songId": "躯樹の墓守",
            "category": "maimai",
            "title": "躯樹の墓守",
            "artist": "隣の庭は青い(庭師+Aoi)",
            "bpm": 211,
            "imageName": "cfccaaead0eb345bdf04e6f38736544b1b2e923a9838c72a297c1720429e059c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 16,
                        "slide": 6,
                        "touch": 10,
                        "break": 6,
                        "total": 252
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11311,
                    "releaseDate": "2022-02-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 404,
                        "hold": 24,
                        "slide": 26,
                        "touch": 10,
                        "break": 7,
                        "total": 471
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11311,
                    "releaseDate": "2022-02-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 523,
                        "hold": 71,
                        "slide": 58,
                        "touch": 59,
                        "break": 10,
                        "total": 721
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11311,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2022-02-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.9,
                    "noteDesigner": "超七味星人",
                    "noteCounts": {
                        "tap": 761,
                        "hold": 80,
                        "slide": 116,
                        "touch": 24,
                        "break": 57,
                        "total": 1038
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11311,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.9,
                        "BUDDiES PLUS": 14.9,
                        "CiRCLE": 14.9,
                        "CiRCLE PLUS": 14.9,
                        "FESTiVAL": 14.9,
                        "FESTiVAL PLUS": 14.9,
                        "PRiSM": 14.9,
                        "PRiSM PLUS": 14.9,
                        "UNiVERSE": 14.9,
                        "UNiVERSE PLUS": 14.9
                    },
                    "releaseDate": "2022-02-10"
                }
            ],
            "searchAcronyms": [
                "🌳",
                "3030",
                "Gravekeeper",
                "Gravekeeper of the Dead Tree",
                "hakamori",
                "kohaD鸟",
                "nmsl",
                "为你守墓",
                "去世的母亲",
                "墓守",
                "大树守卫",
                "守墓人",
                "小红帽",
                "木手",
                "树",
                "欧内的墓手",
                "欧内的守",
                "母兽",
                "江东の铁壁",
                "界徐盛の笑",
                "趋势的木琴",
                "躯世的木琴",
                "躯势の墓亲",
                "躯势の墓琴",
                "躯势的墓琴",
                "躯树的墓守",
                "铃芽之旅",
                "铃芽之旅2",
                "雪墓",
                "驱鼠的母兽",
                "鸟墓守了"
            ]
        },
        {
            "songId": "春嵐",
            "category": "niconico＆ボーカロイド",
            "title": "春嵐",
            "artist": "john",
            "bpm": 140,
            "imageName": "da4afc21aac928285710a128231eb225ac2a6372d247dcc60c81860f50558435",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 99,
                        "hold": 3,
                        "slide": 2,
                        "touch": 8,
                        "break": 4,
                        "total": 116
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11354,
                    "releaseDate": "2022-02-25"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 13,
                        "slide": 4,
                        "touch": 19,
                        "break": 12,
                        "total": 257
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11354,
                    "releaseDate": "2022-02-25"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 83,
                        "slide": 56,
                        "touch": 43,
                        "break": 22,
                        "total": 433
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11354,
                    "releaseDate": "2022-02-25"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 522,
                        "hold": 48,
                        "slide": 81,
                        "touch": 13,
                        "break": 4,
                        "total": 668
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11354,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2022-02-25"
                }
            ],
            "searchAcronyms": [
                "三人日山风",
                "春岚",
                "春风",
                "蓝色妖姬"
            ]
        },
        {
            "songId": "ラグトレイン",
            "category": "niconico＆ボーカロイド",
            "title": "ラグトレイン",
            "artist": "稲葉曇",
            "bpm": 147,
            "imageName": "563698fbc4f01aa986477d56e3a5cbb2a6830ec1377c371bc7d1834615171f34",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 16,
                        "slide": 4,
                        "touch": 9,
                        "break": 3,
                        "total": 137
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11355,
                    "releaseDate": "2022-02-25"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 249,
                        "hold": 22,
                        "slide": 14,
                        "touch": 16,
                        "break": 6,
                        "total": 307
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11355,
                    "releaseDate": "2022-02-25"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 438,
                        "hold": 64,
                        "slide": 19,
                        "touch": 5,
                        "break": 10,
                        "total": 536
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11355,
                    "releaseDate": "2022-02-25"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 551,
                        "hold": 84,
                        "slide": 96,
                        "touch": 30,
                        "break": 11,
                        "total": 772
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11355,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "UNiVERSE": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2022-02-25"
                }
            ],
            "searchAcronyms": [
                "15列车",
                "lag train",
                "lagtrain",
                "Lagtrain",
                "你好了吗",
                "列车",
                "啥绝赞",
                "少女终末旅行",
                "延误列车",
                "延迟列车",
                "打地鼠",
                "电车迟到",
                "黑白卡通女孩上下蹦跶"
            ]
        },
        {
            "songId": "アカツキアライヴァル",
            "category": "niconico＆ボーカロイド",
            "title": "アカツキアライヴァル",
            "artist": "Last Note.",
            "bpm": 125,
            "imageName": "7aa766dce28d28fbd9c3135d422bc423b28e6c0afaf787a6503fe88334572570",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 106,
                        "hold": 4,
                        "slide": 3,
                        "touch": 9,
                        "break": 4,
                        "total": 126
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11359,
                    "releaseDate": "2022-02-25"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 198,
                        "hold": 30,
                        "slide": 22,
                        "touch": 23,
                        "break": 7,
                        "total": 280
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11359,
                    "releaseDate": "2022-02-25"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 429,
                        "hold": 28,
                        "slide": 53,
                        "touch": 7,
                        "break": 5,
                        "total": 522
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11359,
                    "releaseDate": "2022-02-25"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 577,
                        "hold": 68,
                        "slide": 61,
                        "touch": 73,
                        "break": 7,
                        "total": 786
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11359,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2022-02-25"
                }
            ],
            "searchAcronyms": [
                "Akatsuki Arrival",
                "Daybreak Arrival",
                "女同8",
                "拂晓",
                "拂晓已至",
                "拂晓抵达",
                "鱼葱"
            ]
        },
        {
            "songId": "リモコン",
            "category": "niconico＆ボーカロイド",
            "title": "リモコン",
            "artist": "じーざす（ワンダフル☆オポチュニティ！）",
            "bpm": 165,
            "imageName": "cb7539727a9692f4ff136e31dd489e629c8a3d21de098724434a5221eecfdef7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 16,
                        "slide": 3,
                        "touch": 8,
                        "break": 6,
                        "total": 138
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11360,
                    "releaseDate": "2022-02-25"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 242,
                        "hold": 19,
                        "slide": 11,
                        "touch": 52,
                        "break": 18,
                        "total": 342
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11360,
                    "releaseDate": "2022-02-25"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 408,
                        "hold": 83,
                        "slide": 13,
                        "touch": 13,
                        "break": 36,
                        "total": 553
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11360,
                    "releaseDate": "2022-02-25"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 513,
                        "hold": 95,
                        "slide": 106,
                        "touch": 84,
                        "break": 30,
                        "total": 828
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11360,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2022-02-25"
                }
            ],
            "searchAcronyms": [
                "Remocon",
                "Remote Control",
                "switch",
                "双子转转转",
                "遥控器"
            ]
        },
        {
            "songId": "on the rocks",
            "category": "niconico＆ボーカロイド",
            "title": "on the rocks",
            "artist": "OSTER project",
            "bpm": 150,
            "imageName": "4efbb6a789b8c9c883efb1ef9b8a95a264c7b6edd0559db41513df3b84256f8d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 70,
                        "hold": 13,
                        "slide": 2,
                        "touch": 7,
                        "break": 2,
                        "total": 94
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11361,
                    "releaseDate": "2022-02-25"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 20,
                        "slide": 14,
                        "touch": 26,
                        "break": 2,
                        "total": 259
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11361,
                    "releaseDate": "2022-02-25"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 49,
                        "slide": 21,
                        "touch": 10,
                        "break": 10,
                        "total": 420
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11361,
                    "releaseDate": "2022-02-25"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 549,
                        "hold": 17,
                        "slide": 76,
                        "touch": 27,
                        "break": 3,
                        "total": 672
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11361,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2022-02-25"
                }
            ],
            "searchAcronyms": [
                "otr",
                "冰酒",
                "在石头上"
            ]
        },
        {
            "songId": "GIGANTØMAKHIA",
            "category": "maimai",
            "title": "GIGANTØMAKHIA",
            "artist": "BlackYooh vs. siromaru",
            "bpm": 190,
            "imageName": "52bbefcc74a8add49ea60516c3ee3e6212190c90c6401c6f64476a36d9f5387e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 243,
                        "hold": 14,
                        "slide": 4,
                        "touch": 11,
                        "break": 6,
                        "total": 278
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11374,
                    "releaseDate": "2022-03-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 367,
                        "hold": 10,
                        "slide": 24,
                        "touch": 20,
                        "break": 14,
                        "total": 435
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11374,
                    "releaseDate": "2022-03-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 441,
                        "hold": 63,
                        "slide": 62,
                        "touch": 43,
                        "break": 13,
                        "total": 622
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11374,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2022-03-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "KOP3rd with 翡翠マナ",
                    "noteCounts": {
                        "tap": 883,
                        "hold": 37,
                        "slide": 98,
                        "touch": 31,
                        "break": 100,
                        "total": 1149
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11374,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "FESTiVAL": 14.7,
                        "FESTiVAL PLUS": 14.7,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7,
                        "UNiVERSE": 14.8,
                        "UNiVERSE PLUS": 14.8
                    },
                    "releaseDate": "2022-03-03"
                }
            ],
            "searchAcronyms": [
                "gigantomakhia",
                "kop3",
                "yoshiki转圈",
                "yoskip",
                "刀客塔拿书",
                "博士读书",
                "巨人之战",
                "老头环",
                "艾尔登法环"
            ]
        },
        {
            "songId": "We Are Us",
            "category": "オンゲキ＆CHUNITHM",
            "title": "We Are Us",
            "artist": "舞ヶ原シンセ研究会",
            "bpm": 145,
            "imageName": "9d9c90b13a4f07f108213eef81ccd29fe9badce1fc9041b5ef448670cbebe6b8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 101,
                        "hold": 10,
                        "slide": 3,
                        "touch": 22,
                        "break": 2,
                        "total": 138
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11316,
                    "releaseDate": "2022-03-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 28,
                        "slide": 14,
                        "touch": 33,
                        "break": 3,
                        "total": 247
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11316,
                    "releaseDate": "2022-03-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 73,
                        "slide": 22,
                        "touch": 14,
                        "break": 11,
                        "total": 413
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11316,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 10
                    },
                    "releaseDate": "2022-03-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 649,
                        "hold": 15,
                        "slide": 80,
                        "touch": 61,
                        "break": 28,
                        "total": 833
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11316,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2022-03-11"
                }
            ],
            "searchAcronyms": [
                "wau",
                "我们是我们",
                "我们是美国"
            ]
        },
        {
            "songId": "Limits",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Limits",
            "artist": "舞ヶ原シンセ研究会",
            "bpm": 140,
            "imageName": "8562861b4aaab1b503f4ee422d3bb02ba4282bdf87bb674b42faa33a717fc1a4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 22,
                        "slide": 6,
                        "touch": 20,
                        "break": 1,
                        "total": 184
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11317,
                    "releaseDate": "2022-03-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 243,
                        "hold": 15,
                        "slide": 26,
                        "touch": 24,
                        "break": 6,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11317,
                    "releaseDate": "2022-03-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 321,
                        "hold": 53,
                        "slide": 59,
                        "touch": 29,
                        "break": 14,
                        "total": 476
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11317,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 10.5
                    },
                    "releaseDate": "2022-03-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "ロシアンブラック",
                    "noteCounts": {
                        "tap": 455,
                        "hold": 108,
                        "slide": 144,
                        "touch": 59,
                        "break": 20,
                        "total": 786
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11317,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.6,
                        "CiRCLE": 13.5,
                        "FESTiVAL": 13.6,
                        "FESTiVAL PLUS": 13.6,
                        "PRiSM PLUS": 13.5,
                        "UNiVERSE": 13.7,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2022-03-11"
                }
            ],
            "searchAcronyms": [
                "极限",
                "限制"
            ]
        },
        {
            "songId": "スピカの天秤",
            "category": "オンゲキ＆CHUNITHM",
            "title": "スピカの天秤",
            "artist": "Acotto",
            "bpm": 252,
            "imageName": "1d56b7818aa2efc495b1757c9e19133ab2ae5b4e936786cfeebbf729dabef79e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 149,
                        "hold": 35,
                        "slide": 8,
                        "touch": 14,
                        "break": 2,
                        "total": 208
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11318,
                    "releaseDate": "2022-03-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 291,
                        "hold": 29,
                        "slide": 34,
                        "touch": 17,
                        "break": 7,
                        "total": 378
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11318,
                    "releaseDate": "2022-03-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 574,
                        "hold": 50,
                        "slide": 23,
                        "touch": 89,
                        "break": 11,
                        "total": 747
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11318,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.1,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM": 13.1,
                        "PRiSM PLUS": 13.1,
                        "UNiVERSE": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2022-03-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 768,
                        "hold": 62,
                        "slide": 87,
                        "touch": 61,
                        "break": 33,
                        "total": 1011
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11318,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.4,
                        "FESTiVAL PLUS": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "UNiVERSE": 14.5,
                        "UNiVERSE PLUS": 14.5
                    },
                    "releaseDate": "2022-03-11"
                }
            ],
            "searchAcronyms": [
                "ac电棍",
                "Scales of Spica",
                "Spica no Tenbin",
                "Spica's Libra",
                "Spica's Scales",
                "交流电电棍",
                "傻逼慢扫键",
                "天平",
                "天秤",
                "心灵终结",
                "绝望泪",
                "这个需要你自己衡量",
                "黑化希望泪"
            ]
        },
        {
            "songId": "ハードコア・シンドローム",
            "category": "オンゲキ＆CHUNITHM",
            "title": "ハードコア・シンドローム",
            "artist": "t+pazolite (HARDCORE TANO*C) feat.TANO*C ALL STARS",
            "bpm": 180,
            "imageName": "c8500bbd109efb2e070d8636e73493b744d81671fa27c268aec883e70f158b83",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 22,
                        "slide": 4,
                        "touch": 22,
                        "break": 15,
                        "total": 232
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11319,
                    "releaseDate": "2022-03-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 296,
                        "hold": 25,
                        "slide": 14,
                        "touch": 31,
                        "break": 9,
                        "total": 375
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11319,
                    "releaseDate": "2022-03-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 455,
                        "hold": 122,
                        "slide": 60,
                        "touch": 51,
                        "break": 41,
                        "total": 729
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11319,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2022-03-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 735,
                        "hold": 52,
                        "slide": 86,
                        "touch": 184,
                        "break": 39,
                        "total": 1096
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11319,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2022-03-11"
                }
            ],
            "searchAcronyms": [
                "hardcore",
                "hardcore syndrome",
                "Hardcore Syndrome",
                "tanoc全明星",
                "友人对战",
                "双人蹦迪",
                "哈德口",
                "哈的口",
                "哈的扣",
                "哈的扣大",
                "哈皮和tpz开音趴",
                "哈皮打交",
                "打交",
                "打交第一名",
                "打架第二名",
                "打胶",
                "梅西哥打交",
                "硬核",
                "硬核综合征",
                "硬核综合症",
                "罚站",
                "舞立方",
                "音趴"
            ]
        },
        {
            "songId": "Halcyon",
            "category": "ゲーム＆バラエティ",
            "title": "Halcyon",
            "artist": "xi",
            "bpm": 191,
            "imageName": "6545b0299e65ee70636dea0bbbe83d65c587221dfca6712f177926154b264fcb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 16,
                        "slide": 2,
                        "touch": 26,
                        "break": 4,
                        "total": 153
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11085,
                    "releaseDate": "2019-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 304,
                        "hold": 34,
                        "slide": 14,
                        "touch": 47,
                        "break": 8,
                        "total": 407
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11085,
                    "releaseDate": "2019-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "うさぎランドリー",
                    "noteCounts": {
                        "tap": 419,
                        "hold": 54,
                        "slide": 63,
                        "touch": 61,
                        "break": 37,
                        "total": 634
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11085,
                    "releaseDate": "2019-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 700,
                        "hold": 53,
                        "slide": 83,
                        "touch": 154,
                        "break": 17,
                        "total": 1007
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11085,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.6,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.6,
                        "FESTiVAL PLUS": 13.6,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5,
                        "Splash": 13.6,
                        "Splash PLUS": 13.6,
                        "UNiVERSE": 13.6,
                        "UNiVERSE PLUS": 13.6,
                        "maimaiでらっくす PLUS": 13.7
                    },
                    "releaseDate": "2019-07-19"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 12,
                        "slide": 4,
                        "touch": null,
                        "break": 12,
                        "total": 242
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 1085,
                    "releaseDate": "2022-03-23"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 382,
                        "hold": 30,
                        "slide": 18,
                        "touch": null,
                        "break": 16,
                        "total": 446
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 1085,
                    "releaseDate": "2022-03-23"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 559,
                        "hold": 73,
                        "slide": 65,
                        "touch": null,
                        "break": 23,
                        "total": 720
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 1085,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2022-03-23"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "ロシアンブラック",
                    "noteCounts": {
                        "tap": 849,
                        "hold": 66,
                        "slide": 116,
                        "touch": null,
                        "break": 49,
                        "total": 1080
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 1085,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "UNiVERSE PLUS": 14.3
                    },
                    "releaseDate": "2022-03-23"
                }
            ],
            "searchAcronyms": [
                "🐔",
                "dx翡翠鸡",
                "sd🐔",
                "标准翡翠鸡",
                "标翡翠鸡",
                "翡翠鸟",
                "翡翠鸡",
                "翡鸡杯",
                "脆皮鸡"
            ]
        },
        {
            "songId": "ミルキースター・シューティングスター",
            "category": "maimai",
            "title": "ミルキースター・シューティングスター",
            "artist": "烏屋茶房 feat. 利香",
            "bpm": 184,
            "imageName": "ba88677d04a8ef69427882900b0616f85003b1ab0d0f23fe160c9eb39bcdfe81",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 85,
                        "hold": 28,
                        "slide": 6,
                        "touch": 23,
                        "break": 2,
                        "total": 144
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11375,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 294,
                        "hold": 24,
                        "slide": 24,
                        "touch": 29,
                        "break": 10,
                        "total": 381
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11375,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.7,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 472,
                        "hold": 56,
                        "slide": 34,
                        "touch": 20,
                        "break": 50,
                        "total": 632
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11375,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 10.7
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 479,
                        "hold": 41,
                        "slide": 145,
                        "touch": 68,
                        "break": 38,
                        "total": 771
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11375,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2022-03-24"
                }
            ],
            "searchAcronyms": [
                "milky star",
                "uni+主题曲",
                "乳液狂飙",
                "星代主题曲",
                "牛奶4",
                "牛奶流星",
                "银河星"
            ]
        },
        {
            "songId": "ｉｓｏｐｈｏｔｅ",
            "category": "maimai",
            "title": "ｉｓｏｐｈｏｔｅ",
            "artist": "パソコン音楽クラブ feat.ぷにぷに電機",
            "bpm": 160,
            "imageName": "b64567055100accc63891b674f1f5d765e9e9baf257e40b6d0662a08bb11d72e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 126,
                        "hold": 19,
                        "slide": 4,
                        "touch": 6,
                        "break": 3,
                        "total": 158
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11376,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 26,
                        "slide": 20,
                        "touch": 26,
                        "break": 4,
                        "total": 276
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11376,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 80,
                        "slide": 72,
                        "touch": 14,
                        "break": 1,
                        "total": 447
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11376,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 10
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 545,
                        "hold": 59,
                        "slide": 100,
                        "touch": 37,
                        "break": 1,
                        "total": 742
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11376,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2022-03-24"
                }
            ],
            "searchAcronyms": [
                "iso",
                "isophote",
                "op",
                "vrchat",
                "一个绝赞",
                "全角英文",
                "女同10",
                "姛",
                "打字带空格",
                "琪芽",
                "等照度线",
                "说话带空格"
            ]
        },
        {
            "songId": "パラマウント☆ショータイム！！",
            "category": "maimai",
            "title": "パラマウント☆ショータイム！！",
            "artist": "翡乃イスカ",
            "bpm": 222,
            "imageName": "b848c5bfefa12ae69f7f3228864d98810c05b87c99c8eeb2ca6de9521a51647b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 170,
                        "hold": 18,
                        "slide": 2,
                        "touch": 8,
                        "break": 9,
                        "total": 207
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11377,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 324,
                        "hold": 26,
                        "slide": 16,
                        "touch": 22,
                        "break": 18,
                        "total": 406
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11377,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.7,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 522,
                        "hold": 77,
                        "slide": 34,
                        "touch": 22,
                        "break": 18,
                        "total": 673
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11377,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 11.7
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 630,
                        "hold": 105,
                        "slide": 78,
                        "touch": 106,
                        "break": 27,
                        "total": 946
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11377,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2022-03-24"
                }
            ],
            "searchAcronyms": [
                "paramount showtime",
                "showtime",
                "兔子",
                "兔子魔术师",
                "小兔子",
                "至高的表演时间",
                "魔术兔"
            ]
        },
        {
            "songId": "Strive against fate",
            "category": "maimai",
            "title": "Strive against fate",
            "artist": "Noah",
            "bpm": 209,
            "imageName": "4bdcc9a5748f22c22339484d623579d3a00b50623fb8858cde3ff3b576b0f449",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 8,
                        "slide": 4,
                        "touch": 18,
                        "break": 9,
                        "total": 253
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11378,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 43,
                        "slide": 21,
                        "touch": 25,
                        "break": 8,
                        "total": 374
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11378,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 592,
                        "hold": 53,
                        "slide": 45,
                        "touch": 53,
                        "break": 15,
                        "total": 758
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11378,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "Redarrow",
                    "noteCounts": {
                        "tap": 805,
                        "hold": 62,
                        "slide": 107,
                        "touch": 57,
                        "break": 40,
                        "total": 1071
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11378,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5
                    },
                    "releaseDate": "2022-03-24"
                }
            ],
            "searchAcronyms": [
                "fate",
                "saf",
                "对抗命运",
                "抗争命运",
                "抗命",
                "电风扇"
            ]
        },
        {
            "songId": "sølips",
            "category": "maimai",
            "title": "sølips",
            "artist": "rintaro soma",
            "bpm": 199,
            "imageName": "ab96a53a18484da4921aaff847cabde82c8692d7c5f0c0986f50635a15194649",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 171,
                        "hold": 17,
                        "slide": 10,
                        "touch": 25,
                        "break": 5,
                        "total": 228
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11379,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 310,
                        "hold": 31,
                        "slide": 23,
                        "touch": 8,
                        "break": 9,
                        "total": 381
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11379,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 508,
                        "hold": 52,
                        "slide": 72,
                        "touch": 84,
                        "break": 17,
                        "total": 733
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11379,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.9,
                    "noteDesigner": "7.3GHz -Før The Legends-",
                    "noteCounts": {
                        "tap": 600,
                        "hold": 100,
                        "slide": 120,
                        "touch": 80,
                        "break": 73,
                        "total": 973
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11379,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.9,
                        "BUDDiES PLUS": 14.9,
                        "CiRCLE": 14.9,
                        "CiRCLE PLUS": 14.9,
                        "FESTiVAL": 14.9,
                        "FESTiVAL PLUS": 14.9,
                        "PRiSM": 14.9,
                        "PRiSM PLUS": 14.9,
                        "UNiVERSE PLUS": 14.9
                    },
                    "releaseDate": "2022-03-24"
                }
            ],
            "searchAcronyms": [
                "🔒",
                "$100lips",
                "100块",
                "100块钱",
                "ø",
                "sleeps",
                "solips",
                "s属性大爆发",
                "そそ!そそそ!",
                "一百块",
                "一百块钱",
                "唯我论",
                "嗦",
                "嗦🍐",
                "嗦嗦，嗦嗦嗦！",
                "嗦蓝盆斯",
                "妈妈生的",
                "我是颠佬",
                "所以嘴唇",
                "现在的孩子",
                "癫佬",
                "空集",
                "索",
                "索利普斯",
                "零元购",
                "黑客帝国"
            ]
        },
        {
            "songId": "Good bye, Merry-Go-Round.",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Good bye, Merry-Go-Round.",
            "artist": "Yooh",
            "bpm": 185,
            "imageName": "4215613aad4f3b3cf565719eed2cbc2fd8217480d7a24ac810c86874bb2cceef",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 16,
                        "slide": 4,
                        "touch": 19,
                        "break": 13,
                        "total": 240
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11398,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 12,
                        "slide": 15,
                        "touch": 23,
                        "break": 11,
                        "total": 354
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11398,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 480,
                        "hold": 71,
                        "slide": 32,
                        "touch": 11,
                        "break": 28,
                        "total": 622
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11398,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "あまくちジンジャー",
                    "noteCounts": {
                        "tap": 574,
                        "hold": 96,
                        "slide": 120,
                        "touch": 62,
                        "break": 18,
                        "total": 870
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11398,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.1,
                        "BUDDiES PLUS": 14.1,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 14.1,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "UNiVERSE PLUS": 14.1
                    },
                    "releaseDate": "2022-03-24"
                }
            ],
            "searchAcronyms": [
                "🐎",
                "🐴",
                "🔁🌲🐴",
                "Good bye, Mother-Not-Found.",
                "Goodbye,mother-not-found",
                "merry go round",
                "mygo",
                "再见，旋转木马",
                "再见，死妈玩意",
                "再见你妈转个圈",
                "再见找不到妈",
                "再见找不到妈妈",
                "再见旋转木马",
                "再见没找到你妈",
                "妈妈去哪了",
                "我没意见",
                "旋转mua",
                "旋转你妈",
                "旋转古神",
                "旋转墓妈",
                "旋转木妈",
                "旋转木琴",
                "旋转木马",
                "日向千夏",
                "杩",
                "狗比美国人",
                "白人掐腰",
                "给你妈塞墓地里疯狂旋转",
                "阿尼亚",
                "阿尼娅",
                "龙图"
            ]
        },
        {
            "songId": "ヴァンパイア",
            "category": "niconico＆ボーカロイド",
            "title": "ヴァンパイア",
            "artist": "DECO*27",
            "bpm": 164,
            "imageName": "0a9939aa70a5828eaa805bd946fd5d0c36f1be4d697a931848231bb3c1039ac8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 11,
                        "slide": 3,
                        "touch": 8,
                        "break": 10,
                        "total": 174
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11410,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 265,
                        "hold": 20,
                        "slide": 4,
                        "touch": 25,
                        "break": 16,
                        "total": 330
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11410,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10.2,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 463,
                        "hold": 35,
                        "slide": 16,
                        "touch": 40,
                        "break": 28,
                        "total": 582
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11410,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 10.2
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.7,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 439,
                        "hold": 80,
                        "slide": 86,
                        "touch": 15,
                        "break": 13,
                        "total": 633
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11410,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 11.7
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 555,
                        "hold": 53,
                        "slide": 95,
                        "touch": 22,
                        "break": 24,
                        "total": 749
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11410,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "UNiVERSE PLUS": 13.4
                    },
                    "releaseDate": "2022-03-23"
                }
            ],
            "searchAcronyms": [
                "nichan",
                "Vamiper voca",
                "vampire",
                "Vampire",
                "Vampire DECO27",
                "Vampire vocaloid",
                "做核酸",
                "吸血鬼",
                "核酸检测",
                "棒棒鸭",
                "玩牌儿",
                "玩牌呀"
            ]
        },
        {
            "songId": "エンヴィーベイビー",
            "category": "niconico＆ボーカロイド",
            "title": "エンヴィーベイビー",
            "artist": "Kanaria",
            "bpm": 171,
            "imageName": "7272cec538d705398f57dda21554d7d5834f43b0246d502b4e88831effca54b3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 107,
                        "hold": 16,
                        "slide": 4,
                        "touch": 12,
                        "break": 2,
                        "total": 141
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11411,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 12,
                        "slide": 10,
                        "touch": 19,
                        "break": 6,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11411,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.7,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 363,
                        "hold": 81,
                        "slide": 31,
                        "touch": 53,
                        "break": 40,
                        "total": 568
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11411,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 9.7
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 517,
                        "hold": 64,
                        "slide": 93,
                        "touch": 73,
                        "break": 29,
                        "total": 776
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11411,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2022-03-24"
                }
            ],
            "searchAcronyms": [
                "envy",
                "envy baby",
                "Envy Baby",
                "envybaby",
                "剔牙",
                "嫉妒宝贝",
                "打牌",
                "拼多多"
            ]
        },
        {
            "songId": "初音天地開闢神話",
            "category": "niconico＆ボーカロイド",
            "title": "初音天地開闢神話",
            "artist": "cosMo＠暴走P",
            "bpm": 240,
            "imageName": "f3ec8f3e5dba903cedf845d5dffc42b3187f645446c3f662d0dfabec0304bc66",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 11,
                        "slide": 2,
                        "touch": 25,
                        "break": 8,
                        "total": 232
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11412,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 394,
                        "hold": 41,
                        "slide": 19,
                        "touch": 7,
                        "break": 5,
                        "total": 466
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11412,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 429,
                        "hold": 112,
                        "slide": 48,
                        "touch": 66,
                        "break": 17,
                        "total": 672
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11412,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 11
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 769,
                        "hold": 34,
                        "slide": 134,
                        "touch": 23,
                        "break": 39,
                        "total": 999
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11412,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2022-03-24"
                }
            ],
            "searchAcronyms": [
                "Hatsune Creation Myth",
                "Hatsune Tenchikaibyaku Shinwa",
                "初音天地开辟神话",
                "初音开天辟地",
                "初音未来开天辟地",
                "初音未来开辟神话",
                "初音未来日天日地",
                "初音未来毁天灭地",
                "初音毁天灭地神话",
                "天地开辟",
                "开天辟地",
                "开辟",
                "开辟天地",
                "毁天灭地",
                "消失2",
                "盘古",
                "盘古开天辟地",
                "神话"
            ]
        },
        {
            "songId": "Armageddon",
            "category": "東方Project",
            "title": "Armageddon",
            "artist": "LeaF",
            "bpm": 210,
            "imageName": "c4a5373e5bf651cd9e397f337ad1d2b4a07bbca0313335077407d2b1b1ca6e83",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 19,
                        "slide": 4,
                        "touch": 16,
                        "break": 13,
                        "total": 193
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11413,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 363,
                        "hold": 6,
                        "slide": 21,
                        "touch": 24,
                        "break": 13,
                        "total": 427
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11413,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 578,
                        "hold": 109,
                        "slide": 49,
                        "touch": 59,
                        "break": 10,
                        "total": 805
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11413,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 666,
                        "hold": 119,
                        "slide": 77,
                        "touch": 105,
                        "break": 26,
                        "total": 993
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11413,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "UNiVERSE PLUS": 14
                    },
                    "releaseDate": "2022-03-24"
                }
            ],
            "searchAcronyms": [
                "⑥",
                "arma",
                "世界末日",
                "太阳信仰",
                "妈了个蛋",
                "灵乌路空",
                "灵知的太阳信仰",
                "阿妈个蛋",
                "阿妈咯噔",
                "阿空"
            ]
        },
        {
            "songId": "Dreadnought",
            "category": "ゲーム＆バラエティ",
            "title": "Dreadnought",
            "artist": "Mastermind(xi+nora2r)",
            "bpm": 192,
            "imageName": "595b4736e72dbabc95b89af24b857cea99bcdf20b1105553c918fafaf60ced06",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 9,
                        "slide": 3,
                        "touch": 12,
                        "break": 8,
                        "total": 183
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11415,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 325,
                        "hold": 14,
                        "slide": 15,
                        "touch": 30,
                        "break": 12,
                        "total": 396
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11415,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 507,
                        "hold": 45,
                        "slide": 49,
                        "touch": 6,
                        "break": 54,
                        "total": 661
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11415,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 640,
                        "hold": 118,
                        "slide": 74,
                        "touch": 66,
                        "break": 34,
                        "total": 932
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11415,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2022-03-24"
                }
            ],
            "searchAcronyms": [
                "🔦",
                "大喷菇",
                "巧脆卷",
                "手电筒",
                "无畏号",
                "无畏号战舰",
                "无畏舰",
                "望远镜",
                "死亡手电筒"
            ]
        },
        {
            "songId": "8-EM",
            "category": "オンゲキ＆CHUNITHM",
            "title": "8-EM",
            "artist": "Sampling Masters AYA",
            "bpm": 168,
            "imageName": "69c47423f29adba2de9568c14c7dec8dd6e9426c0c7c50167bd8dd1e5f435524",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 163,
                        "hold": 7,
                        "slide": 8,
                        "touch": 10,
                        "break": 5,
                        "total": 193
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "UNiVERSE"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11443,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 9,
                        "slide": 13,
                        "touch": 42,
                        "break": 6,
                        "total": 392
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "UNiVERSE"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11443,
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 468,
                        "hold": 103,
                        "slide": 66,
                        "touch": 56,
                        "break": 7,
                        "total": 700
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "UNiVERSE"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11443,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.6,
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.6,
                        "UNiVERSE": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2022-03-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "小鳥遊チミ",
                    "noteCounts": {
                        "tap": 585,
                        "hold": 51,
                        "slide": 84,
                        "touch": 73,
                        "break": 31,
                        "total": 824
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "UNiVERSE"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11443,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "UNiVERSE": 13.8,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2022-03-24"
                }
            ],
            "searchAcronyms": [
                "8em",
                "8EM",
                "atm",
                "ATM",
                "EIGHT-EM",
                "大大大",
                "很酷，不说话",
                "涩图"
            ]
        },
        {
            "songId": "若い力",
            "category": "ゲーム＆バラエティ",
            "title": "若い力",
            "artist": "作詞：セガ社員、作曲：若草恵、歌：135",
            "bpm": 114,
            "imageName": "27254170d8811952baa1626557c101607b61bf526dcaf06491b71b0c416d315d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 55,
                        "hold": 18,
                        "slide": 8,
                        "touch": 6,
                        "break": 10,
                        "total": 97
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11444,
                    "releaseDate": "2022-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 72,
                        "hold": 8,
                        "slide": 14,
                        "touch": 21,
                        "break": 4,
                        "total": 119
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11444,
                    "releaseDate": "2022-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 129,
                        "hold": 32,
                        "slide": 23,
                        "touch": 64,
                        "break": 2,
                        "total": 250
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11444,
                    "releaseDate": "2022-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "作譜：翠楼屋",
                    "noteCounts": {
                        "tap": 298,
                        "hold": 15,
                        "slide": 51,
                        "touch": 56,
                        "break": 62,
                        "total": 482
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11444,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2022-04-01"
                }
            ],
            "searchAcronyms": [
                "sbga",
                "SBGA",
                "sbga社歌",
                "sega",
                "sega大楼",
                "SEGA社歌",
                "世嘉",
                "世嘉社歌",
                "傻逼世嘉",
                "年轻的力量",
                "本社",
                "社歌",
                "若之力",
                "若以力",
                "若力"
            ]
        },
        {
            "songId": "遺伝子レベル∞スパイラル",
            "category": "maimai",
            "title": "遺伝子レベル∞スパイラル",
            "artist": "NAOKI feat.小坂りゆ",
            "bpm": 164,
            "imageName": "ff0fe2a8556cfe1667ee8f46897601681df2381b0b96f39ffd0e0ff00a7c23f7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 18,
                        "slide": 3,
                        "touch": 8,
                        "break": 8,
                        "total": 226
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11445,
                    "releaseDate": "2022-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 22,
                        "slide": 17,
                        "touch": 22,
                        "break": 6,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11445,
                    "releaseDate": "2022-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 245,
                        "hold": 79,
                        "slide": 43,
                        "touch": 29,
                        "break": 9,
                        "total": 405
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11445,
                    "releaseDate": "2022-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 656,
                        "hold": 37,
                        "slide": 85,
                        "touch": 34,
                        "break": 20,
                        "total": 832
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11445,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2022-04-01"
                }
            ],
            "searchAcronyms": [
                "星球大战",
                "遗伝子",
                "遗传",
                "遗传基因 Level ♾️ Spiral",
                "遗传子"
            ]
        },
        {
            "songId": "otorii INNOVATED -[i]3-",
            "category": "オンゲキ＆CHUNITHM",
            "title": "otorii INNOVATED -[i]3-",
            "artist": "NAOKI underground",
            "bpm": 210,
            "imageName": "5c8013230cc9233adc95f112da9f4381085898dc33034ce9dca8b01d081581ff",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 6,
                        "slide": 4,
                        "touch": 31,
                        "break": 8,
                        "total": 249
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11446,
                    "releaseDate": "2022-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 289,
                        "hold": 21,
                        "slide": 15,
                        "touch": 52,
                        "break": 7,
                        "total": 384
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11446,
                    "releaseDate": "2022-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 503,
                        "hold": 58,
                        "slide": 55,
                        "touch": 60,
                        "break": 41,
                        "total": 717
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11446,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2022-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "Hz-R.Arrow",
                    "noteCounts": {
                        "tap": 869,
                        "hold": 20,
                        "slide": 128,
                        "touch": 17,
                        "break": 41,
                        "total": 1075
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11446,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5,
                        "UNiVERSE PLUS": 14.5
                    },
                    "releaseDate": "2022-04-01"
                }
            ],
            "searchAcronyms": [
                "⚡🐻",
                "i3",
                "otorii",
                "otorii innovated",
                "前列腺",
                "大鸟居",
                "天地人间完全放电",
                "杨永信",
                "永江衣玖",
                "熊二",
                "电你前列腺",
                "电你牛子",
                "电刑",
                "电所有人前列腺",
                "电熊",
                "红色电音极地大冲击",
                "紫色滴蜡熊",
                "闪电熊",
                "雷熊",
                "雷电将军"
            ]
        },
        {
            "songId": "enchanted love",
            "category": "ゲーム＆バラエティ",
            "title": "enchanted love",
            "artist": "linear ring",
            "bpm": 95,
            "imageName": "f013d7de2376d2ab3fc50ac6da7a0634a405719b794d0aa09de97fc853031846",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 89,
                        "hold": 7,
                        "slide": 5,
                        "touch": 13,
                        "break": 1,
                        "total": 115
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11418,
                    "releaseDate": "2022-04-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 16,
                        "slide": 12,
                        "touch": 32,
                        "break": 4,
                        "total": 221
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11418,
                    "releaseDate": "2022-04-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.8,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 104,
                        "slide": 47,
                        "touch": 14,
                        "break": 4,
                        "total": 374
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11418,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 11.8
                    },
                    "releaseDate": "2022-04-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 31,
                        "slide": 88,
                        "touch": 96,
                        "break": 4,
                        "total": 576
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11418,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2022-04-08"
                }
            ],
            "searchAcronyms": [
                "🐸",
                "别急17",
                "小青蛙",
                "迷人的爱",
                "醉心之爱",
                "附魔爱",
                "附魔的爱",
                "青蛙",
                "青蛙王子"
            ]
        },
        {
            "songId": "Caterpillar Song",
            "category": "ゲーム＆バラエティ",
            "title": "Caterpillar Song",
            "artist": "Bitplane feat. 葉月ゆら",
            "bpm": 90,
            "imageName": "d1944b55f17189daecb8705cc4658824c9d14b4780565659a67eafe69535a651",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 62,
                        "hold": 11,
                        "slide": 4,
                        "touch": 20,
                        "break": 1,
                        "total": 98
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11419,
                    "releaseDate": "2022-04-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 216,
                        "hold": 10,
                        "slide": 13,
                        "touch": 28,
                        "break": 2,
                        "total": 269
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11419,
                    "releaseDate": "2022-04-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 87,
                        "slide": 2,
                        "touch": 5,
                        "break": 2,
                        "total": 336
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11419,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12,
                        "UNiVERSE PLUS": 12
                    },
                    "releaseDate": "2022-04-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "チェシャ猫とハートのジャック",
                    "noteCounts": {
                        "tap": 309,
                        "hold": 31,
                        "slide": 94,
                        "touch": 46,
                        "break": 1,
                        "total": 481
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11419,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2022-04-08"
                }
            ],
            "searchAcronyms": [
                "🐛",
                "便秘一笔画",
                "别急15",
                "女菩萨念经",
                "毛毛虫",
                "毛毛虫之歌",
                "肯德基"
            ]
        },
        {
            "songId": "　",
            "category": "POPS＆アニメ",
            "title": "　",
            "artist": "x0o0x_",
            "bpm": 130,
            "imageName": "577544f0f2dc0f385f067b83abd178eb48e497e958bb9ba88d9a5fb14726e02e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 100,
                        "hold": 8,
                        "slide": 8,
                        "touch": 16,
                        "break": 1,
                        "total": 133
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11422,
                    "releaseDate": "2022-04-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 174,
                        "hold": 24,
                        "slide": 10,
                        "touch": 15,
                        "break": 7,
                        "total": 230
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11422,
                    "releaseDate": "2022-04-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 185,
                        "hold": 44,
                        "slide": 59,
                        "touch": 59,
                        "break": 10,
                        "total": 357
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11422,
                    "releaseDate": "2022-04-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 382,
                        "hold": 38,
                        "slide": 135,
                        "touch": 44,
                        "break": 6,
                        "total": 605
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11422,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2022-04-15"
                }
            ],
            "searchAcronyms": [
                "‎‎",
                "/ / // / /",
                "\\0",
                "null",
                "ㅤ",
                "六个绝赞全落",
                "六斜杠",
                "口口",
                "如月清秋",
                "如月车站",
                "如有",
                "无名歌",
                "无题",
                "没名字",
                "没名字的歌",
                "没有名字",
                "白音",
                "空格",
                "空白",
                "金条",
                "黑暗剑22"
            ]
        },
        {
            "songId": "BLUE ZONE",
            "category": "ゲーム＆バラエティ",
            "title": "BLUE ZONE",
            "artist": "Tatsh x NAOKI",
            "bpm": 168,
            "imageName": "79445040703621f31dba23e6042178f599c77083d127cebb197c7d84eb18d9e7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 13,
                        "slide": 3,
                        "touch": 7,
                        "break": 3,
                        "total": 172
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11423,
                    "releaseDate": "2022-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 24,
                        "slide": 18,
                        "touch": 14,
                        "break": 18,
                        "total": 404
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11423,
                    "releaseDate": "2022-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 369,
                        "hold": 67,
                        "slide": 48,
                        "touch": 10,
                        "break": 21,
                        "total": 515
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11423,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 11.5
                    },
                    "releaseDate": "2022-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 654,
                        "hold": 25,
                        "slide": 71,
                        "touch": 50,
                        "break": 88,
                        "total": 888
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11423,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.1,
                        "BUDDiES PLUS": 14.1,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 14.1,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "UNiVERSE PLUS": 14.1
                    },
                    "releaseDate": "2022-04-28"
                }
            ],
            "searchAcronyms": [
                "蓝区",
                "蓝界",
                "蓝的区",
                "蓝的盆",
                "蓝的车",
                "蓝粽",
                "蓝车"
            ]
        },
        {
            "songId": "デーモンベット",
            "category": "maimai",
            "title": "デーモンベット",
            "artist": "ちいたな feat.flower",
            "bpm": 107,
            "imageName": "82641474fb536aebca06f76b89ff699161f933dd88500ac1b0a5f87283fcd524",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 114,
                        "hold": 10,
                        "slide": 4,
                        "touch": 18,
                        "break": 3,
                        "total": 149
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11381,
                    "releaseDate": "2022-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 259,
                        "hold": 19,
                        "slide": 13,
                        "touch": 37,
                        "break": 8,
                        "total": 336
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11381,
                    "releaseDate": "2022-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 399,
                        "hold": 35,
                        "slide": 20,
                        "touch": 14,
                        "break": 50,
                        "total": 518
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11381,
                    "releaseDate": "2022-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 484,
                        "hold": 36,
                        "slide": 110,
                        "touch": 23,
                        "break": 13,
                        "total": 666
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11381,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "UNiVERSE PLUS": 13.1
                    },
                    "releaseDate": "2022-04-28"
                }
            ],
            "searchAcronyms": [
                "daemon bet",
                "恶魔赌博",
                "恶魔赌局",
                "恶魔赌约",
                "男同"
            ]
        },
        {
            "songId": "パーフェクション",
            "category": "maimai",
            "title": "パーフェクション",
            "artist": "柊マグネタイト",
            "bpm": 190,
            "imageName": "f5ab0852437e07f5bafb0ce544291ef5adfd2e85d3a2bf2ab8b7d522f7f91e52",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 88,
                        "hold": 22,
                        "slide": 3,
                        "touch": 28,
                        "break": 2,
                        "total": 143
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11380,
                    "releaseDate": "2022-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 12,
                        "slide": 21,
                        "touch": 39,
                        "break": 9,
                        "total": 386
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11380,
                    "releaseDate": "2022-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 480,
                        "hold": 84,
                        "slide": 35,
                        "touch": 17,
                        "break": 12,
                        "total": 628
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11380,
                    "releaseDate": "2022-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 560,
                        "hold": 58,
                        "slide": 118,
                        "touch": 69,
                        "break": 33,
                        "total": 838
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11380,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "UNiVERSE PLUS": 13.5
                    },
                    "releaseDate": "2022-04-28"
                }
            ],
            "searchAcronyms": [
                "perfection",
                "完美",
                "完美物质"
            ]
        },
        {
            "songId": "サンバランド",
            "category": "ゲーム＆バラエティ",
            "title": "サンバランド",
            "artist": "SAMBA MASTER 佐藤",
            "bpm": 132,
            "imageName": "8de6a15223ae97a2ec65653794c5b6f37dc7e8066b8c7b09962c79daa42410dd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 88,
                        "hold": 6,
                        "slide": 4,
                        "touch": 6,
                        "break": 8,
                        "total": 112
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11081,
                    "releaseDate": "2020-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 36,
                        "slide": 3,
                        "touch": 12,
                        "break": 10,
                        "total": 294
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11081,
                    "releaseDate": "2020-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 378,
                        "hold": 51,
                        "slide": 42,
                        "touch": 12,
                        "break": 19,
                        "total": 502
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11081,
                    "releaseDate": "2020-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 526,
                        "hold": 88,
                        "slide": 41,
                        "touch": 24,
                        "break": 21,
                        "total": 700
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす",
                    "internalId": 11081,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8,
                        "Splash PLUS": 12.8,
                        "UNiVERSE": 12.8,
                        "maimaiでらっくす PLUS": 12.8
                    },
                    "releaseDate": "2020-01-10"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 140,
                        "hold": 5,
                        "slide": 4,
                        "touch": null,
                        "break": 11,
                        "total": 160
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 1081,
                    "releaseDate": "2022-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 23,
                        "slide": 8,
                        "touch": null,
                        "break": 12,
                        "total": 275
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 1081,
                    "releaseDate": "2022-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 365,
                        "hold": 74,
                        "slide": 33,
                        "touch": null,
                        "break": 16,
                        "total": 488
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 1081,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 11
                    },
                    "releaseDate": "2022-05-12"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 392,
                        "hold": 6,
                        "slide": 201,
                        "touch": null,
                        "break": 38,
                        "total": 637
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 1081,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2022-05-12"
                }
            ],
            "searchAcronyms": [
                "仰卧起坐",
                "佐藤",
                "标准仰卧起坐",
                "标准桑巴",
                "桑巴",
                "面具男"
            ]
        },
        {
            "songId": "Love's Theme of BADASS ～バッド・アス 愛のテーマ～",
            "category": "ゲーム＆バラエティ",
            "title": "Love's Theme of BADASS ～バッド・アス 愛のテーマ～",
            "artist": "Hommarju",
            "bpm": 202,
            "imageName": "4e342767a7e8d71ad856ea1dec834b3e9ed4e8addb0eb5eb635b08b310a13075",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 13,
                        "slide": 6,
                        "touch": 15,
                        "break": 5,
                        "total": 279
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11429,
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 348,
                        "hold": 21,
                        "slide": 12,
                        "touch": 34,
                        "break": 40,
                        "total": 455
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11429,
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 499,
                        "hold": 27,
                        "slide": 125,
                        "touch": 38,
                        "break": 55,
                        "total": 744
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11429,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 467,
                        "hold": 155,
                        "slide": 180,
                        "touch": 79,
                        "break": 153,
                        "total": 1034
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11429,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.1,
                        "BUDDiES PLUS": 14.1,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 14.1,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "UNiVERSE PLUS": 14.1
                    },
                    "releaseDate": "2022-05-13"
                }
            ],
            "searchAcronyms": [
                "badass",
                "Badass",
                "BADASS",
                "不良尻尾",
                "八大蒜",
                "右肩の爹",
                "右肩之爹",
                "右肩毁灭者",
                "右肩的爹",
                "右臂康复训练",
                "右臂毁灭者",
                "哥布林骑摩托",
                "坏尻",
                "坏屁股",
                "坏腚",
                "恶尻",
                "扒大蒜",
                "打篮球",
                "拔大葱",
                "拔大蒜",
                "烂尻",
                "烂屁股",
                "烂皮炎",
                "爱的主题坏屁股",
                "马达加斯加",
                "麒麟臂"
            ]
        },
        {
            "songId": "BANG!",
            "category": "ゲーム＆バラエティ",
            "title": "BANG!",
            "artist": "Shoichiro Hirata feat.Sana",
            "bpm": 128,
            "imageName": "b87308ecc52f2e189175347d7dfb59c118f54c9ecb5f2727daccedce4898a347",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 80,
                        "hold": 10,
                        "slide": 6,
                        "touch": 12,
                        "break": 1,
                        "total": 109
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11428,
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 13,
                        "slide": 12,
                        "touch": 38,
                        "break": 4,
                        "total": 209
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11428,
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 329,
                        "hold": 29,
                        "slide": 35,
                        "touch": 44,
                        "break": 16,
                        "total": 453
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11428,
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "Techno Kitchen",
                    "noteCounts": {
                        "tap": 410,
                        "hold": 42,
                        "slide": 85,
                        "touch": 30,
                        "break": 37,
                        "total": 604
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11428,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "BUDDiES PLUS": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2022-05-13"
                }
            ],
            "searchAcronyms": [
                "bang",
                "棒",
                "邦",
                "钢管"
            ]
        },
        {
            "songId": "Define",
            "category": "ゲーム＆バラエティ",
            "title": "Define",
            "artist": "Zekk",
            "bpm": 175,
            "imageName": "7966cf9b0faa5d491c0fe2e48d651e4ba02f040a638547e55b3ff9012b3da193",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 113,
                        "hold": 5,
                        "slide": 7,
                        "touch": 13,
                        "break": 3,
                        "total": 141
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11427,
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 244,
                        "hold": 12,
                        "slide": 21,
                        "touch": 34,
                        "break": 5,
                        "total": 316
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11427,
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.2,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 316,
                        "hold": 88,
                        "slide": 47,
                        "touch": 47,
                        "break": 10,
                        "total": 508
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11427,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 11.2
                    },
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 461,
                        "hold": 36,
                        "slide": 137,
                        "touch": 4,
                        "break": 11,
                        "total": 649
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11427,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.6,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2022-05-13"
                }
            ],
            "searchAcronyms": [
                "定义"
            ]
        },
        {
            "songId": "Mjölnir",
            "category": "ゲーム＆バラエティ",
            "title": "Mjölnir",
            "artist": "xi",
            "bpm": 222,
            "imageName": "f6ac558d0e2ae1793829f8157fe0d415022118a861d629e7ac12d5734292681c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 9,
                        "slide": 6,
                        "touch": 9,
                        "break": 8,
                        "total": 263
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11426,
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 399,
                        "hold": 51,
                        "slide": 16,
                        "touch": 44,
                        "break": 14,
                        "total": 524
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11426,
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 513,
                        "hold": 90,
                        "slide": 54,
                        "touch": 82,
                        "break": 25,
                        "total": 764
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11426,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 834,
                        "hold": 207,
                        "slide": 93,
                        "touch": 76,
                        "break": 31,
                        "total": 1241
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11426,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.2,
                        "FESTiVAL PLUS": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4,
                        "UNiVERSE PLUS": 14.2
                    },
                    "releaseDate": "2022-05-13"
                }
            ],
            "searchAcronyms": [
                "🎹💨",
                "mjo",
                "mjolnir",
                "mjr",
                "冒烟钢琴",
                "喵喵槌",
                "喵喵锤",
                "打火机",
                "摸你鸡儿",
                "摸脚尼尔",
                "激光雨",
                "炸琴",
                "砸钢琴",
                "管子海",
                "翠楼屋拉屎",
                "翠楼屋撸管",
                "翠楼屋撸管冒烟",
                "翠楼屋炸钢琴",
                "翠楼屋的管",
                "翠翠薯条",
                "脆脆薯条",
                "薯条",
                "钢琴",
                "钢琴冒烟",
                "钢琴抽大烟",
                "钢管舞",
                "雷神之锤",
                "麻将"
            ]
        },
        {
            "songId": "First Dance",
            "category": "ゲーム＆バラエティ",
            "title": "First Dance",
            "artist": "削除",
            "bpm": 174,
            "imageName": "d2e7f9c17c4e75c361cb0b7cffffb4301b08c505ea40406e869b5dd9ec9feaba",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 193,
                        "hold": 14,
                        "slide": 13,
                        "touch": 4,
                        "break": 9,
                        "total": 233
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11425,
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 302,
                        "hold": 22,
                        "slide": 17,
                        "touch": 26,
                        "break": 4,
                        "total": 371
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11425,
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.1,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 362,
                        "hold": 102,
                        "slide": 62,
                        "touch": 20,
                        "break": 56,
                        "total": 602
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11425,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.1,
                        "CiRCLE PLUS": 12.1,
                        "PRiSM PLUS": 12.1,
                        "UNiVERSE PLUS": 12
                    },
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 637,
                        "hold": 76,
                        "slide": 122,
                        "touch": 71,
                        "break": 28,
                        "total": 934
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11425,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2022-05-13"
                }
            ],
            "searchAcronyms": [
                "1！5！",
                "15",
                "fd",
                "一！舞！",
                "一曲成名",
                "一舞",
                "出生之舞",
                "初舞",
                "第一舞"
            ]
        },
        {
            "songId": "Estahv",
            "category": "ゲーム＆バラエティ",
            "title": "Estahv",
            "artist": "Feryquitous",
            "bpm": 191,
            "imageName": "4b8b4180b5f37c76a2bd18cdfcee626c2ca28f65f7efe99278adcc2c7b5ba758",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 136,
                        "hold": 15,
                        "slide": 3,
                        "touch": 16,
                        "break": 3,
                        "total": 173
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11424,
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 164,
                        "hold": 14,
                        "slide": 29,
                        "touch": 22,
                        "break": 2,
                        "total": 231
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11424,
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 55,
                        "slide": 38,
                        "touch": 53,
                        "break": 6,
                        "total": 442
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11424,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 11.7
                    },
                    "releaseDate": "2022-05-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 434,
                        "hold": 46,
                        "slide": 119,
                        "touch": 6,
                        "break": 27,
                        "total": 632
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11424,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2022-05-13"
                }
            ],
            "searchAcronyms": [
                "Arcahv精神续作",
                "六戒",
                "白戒",
                "真寻",
                "谢丝塔"
            ]
        },
        {
            "songId": "HECATONCHEIR",
            "category": "maimai",
            "title": "HECATONCHEIR",
            "artist": "Yuta Imai",
            "bpm": 155,
            "imageName": "a0387ebdea91588f18c1ea37a6143c766ae3ac49c80dabcf8bda2590648e07e0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 213,
                        "hold": 9,
                        "slide": 8,
                        "touch": 21,
                        "break": 13,
                        "total": 264
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11382,
                    "releaseDate": "2022-05-27"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 329,
                        "hold": 10,
                        "slide": 22,
                        "touch": 33,
                        "break": 16,
                        "total": 410
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11382,
                    "releaseDate": "2022-05-27"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 544,
                        "hold": 51,
                        "slide": 24,
                        "touch": 67,
                        "break": 21,
                        "total": 707
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11382,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2022-05-27"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 643,
                        "hold": 77,
                        "slide": 133,
                        "touch": 94,
                        "break": 100,
                        "total": 1047
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11382,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.1,
                        "BUDDiES PLUS": 14.1,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 14,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1,
                        "UNiVERSE PLUS": 14
                    },
                    "releaseDate": "2022-05-27"
                }
            ],
            "searchAcronyms": [
                "他猫上椅子",
                "很潮通气儿",
                "百手巨人",
                "百臂巨人"
            ]
        },
        {
            "songId": "Irresistible",
            "category": "maimai",
            "title": "Irresistible",
            "artist": "MK",
            "bpm": 157,
            "imageName": "1539ba0cbb17a5a0afdf551c4f5fc8167160ffb3d247e39444b38ce9b18d26a2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 112,
                        "hold": 10,
                        "slide": 7,
                        "touch": 8,
                        "break": 2,
                        "total": 139
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11383,
                    "releaseDate": "2022-05-27"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 244,
                        "hold": 28,
                        "slide": 13,
                        "touch": 20,
                        "break": 3,
                        "total": 308
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11383,
                    "releaseDate": "2022-05-27"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 41,
                        "slide": 42,
                        "touch": 5,
                        "break": 22,
                        "total": 454
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11383,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 11
                    },
                    "releaseDate": "2022-05-27"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 593,
                        "hold": 25,
                        "slide": 81,
                        "touch": 56,
                        "break": 27,
                        "total": 782
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11383,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2022-05-27"
                }
            ],
            "searchAcronyms": [
                "不可阻挡",
                "可莉"
            ]
        },
        {
            "songId": "HAGAKIRI",
            "category": "maimai",
            "title": "HAGAKIRI",
            "artist": "Masayoshi Iimori",
            "bpm": 172,
            "imageName": "d9c1803eb1a7ff0e947a327306d3e29486ba51782055f92e1720b6c763b016fc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 6,
                        "slide": 4,
                        "touch": 15,
                        "break": 11,
                        "total": 211
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11384,
                    "releaseDate": "2022-05-27"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 18,
                        "slide": 17,
                        "touch": 32,
                        "break": 10,
                        "total": 341
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11384,
                    "releaseDate": "2022-05-27"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 398,
                        "hold": 52,
                        "slide": 15,
                        "touch": 42,
                        "break": 40,
                        "total": 547
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11384,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2022-05-27"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 464,
                        "hold": 71,
                        "slide": 59,
                        "touch": 97,
                        "break": 42,
                        "total": 733
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11384,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2022-05-27"
                }
            ],
            "searchAcronyms": [
                "hgkr",
                "光圈科技",
                "八云紫拿着乾坤圈",
                "憋憋",
                "橘花"
            ]
        },
        {
            "songId": "N3V3R G3T OV3R",
            "category": "maimai",
            "title": "N3V3R G3T OV3R",
            "artist": "C-Show",
            "bpm": 128,
            "imageName": "4ad18e055dba18cd77eb4920f360604ccdde5b2f2c964b69162de7fa3b0baa97",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 116,
                        "hold": 18,
                        "slide": 6,
                        "touch": 0,
                        "break": 6,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11385,
                    "releaseDate": "2022-05-27"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 36,
                        "slide": 13,
                        "touch": 25,
                        "break": 24,
                        "total": 297
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11385,
                    "releaseDate": "2022-05-27"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 84,
                        "slide": 31,
                        "touch": 77,
                        "break": 7,
                        "total": 484
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11385,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12,
                        "UNiVERSE PLUS": 12
                    },
                    "releaseDate": "2022-05-27"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 528,
                        "hold": 31,
                        "slide": 91,
                        "touch": 66,
                        "break": 33,
                        "total": 749
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11385,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3
                    },
                    "releaseDate": "2022-05-27"
                }
            ],
            "searchAcronyms": [
                "3333",
                "3炸",
                "n3",
                "never get over",
                "ngo",
                "NGO",
                "双枪老太婆",
                "四个三",
                "永不结束",
                "永远不过"
            ]
        },
        {
            "songId": "春を告げる",
            "category": "POPS＆アニメ",
            "title": "春を告げる",
            "artist": "yama",
            "bpm": 120,
            "imageName": "99d4a33591ee72f5739a5db2b112748fe6547a78f9a02a77225f12a49d829718",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 70,
                        "hold": 14,
                        "slide": 3,
                        "touch": 8,
                        "break": 3,
                        "total": 98
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11346,
                    "releaseDate": "2022-06-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 192,
                        "hold": 9,
                        "slide": 13,
                        "touch": 24,
                        "break": 6,
                        "total": 244
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11346,
                    "releaseDate": "2022-06-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 331,
                        "hold": 44,
                        "slide": 10,
                        "touch": 6,
                        "break": 6,
                        "total": 397
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11346,
                    "releaseDate": "2022-06-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 531,
                        "hold": 69,
                        "slide": 33,
                        "touch": 34,
                        "break": 8,
                        "total": 675
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11346,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2022-06-10"
                }
            ],
            "searchAcronyms": [
                "🛌",
                "cogito睡觉",
                "宣告春天",
                "春告",
                "春天的宣告",
                "睡了"
            ]
        },
        {
            "songId": "Princess♂",
            "category": "POPS＆アニメ",
            "title": "Princess♂",
            "artist": "TOPHAMHAT-KYO",
            "bpm": 92,
            "imageName": "5ac7bcdc0d3dee508f8cc580aed72004feac86f0a581542a83e619da29b118a1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 77,
                        "hold": 11,
                        "slide": 2,
                        "touch": 8,
                        "break": 2,
                        "total": 100
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11432,
                    "releaseDate": "2022-06-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 29,
                        "slide": 9,
                        "touch": 28,
                        "break": 5,
                        "total": 276
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11432,
                    "releaseDate": "2022-06-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 332,
                        "hold": 51,
                        "slide": 19,
                        "touch": 2,
                        "break": 22,
                        "total": 426
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11432,
                    "releaseDate": "2022-06-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 509,
                        "hold": 55,
                        "slide": 74,
                        "touch": 15,
                        "break": 10,
                        "total": 663
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11432,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2022-06-10"
                }
            ],
            "searchAcronyms": [
                "👸",
                "mtf",
                "Princess",
                "公主",
                "公猪",
                "别急16",
                "男公主",
                "男娘2"
            ]
        },
        {
            "songId": "ヒトガタ",
            "category": "POPS＆アニメ",
            "title": "ヒトガタ",
            "artist": "HIMEHINA",
            "bpm": 150,
            "imageName": "6608ba9e4388bdaa82f6816bff33cc263777c7a53faeddf4d8f42731daa8b842",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 107,
                        "hold": 8,
                        "slide": 6,
                        "touch": 8,
                        "break": 2,
                        "total": 131
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11433,
                    "releaseDate": "2022-06-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 259,
                        "hold": 19,
                        "slide": 16,
                        "touch": 28,
                        "break": 7,
                        "total": 329
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11433,
                    "releaseDate": "2022-06-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 380,
                        "hold": 80,
                        "slide": 39,
                        "touch": 35,
                        "break": 16,
                        "total": 550
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11433,
                    "releaseDate": "2022-06-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 530,
                        "hold": 82,
                        "slide": 134,
                        "touch": 19,
                        "break": 34,
                        "total": 799
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11433,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "UNiVERSE PLUS": 13.4
                    },
                    "releaseDate": "2022-06-10"
                }
            ],
            "searchAcronyms": [
                "himehina",
                "hitogata",
                "两个女人跳舞",
                "人型",
                "人形",
                "匕卜力夕",
                "女人跳舞男人打",
                "管人跳舞"
            ]
        },
        {
            "songId": "Swift Swing",
            "category": "maimai",
            "title": "Swift Swing",
            "artist": "Laur",
            "bpm": 150,
            "imageName": "623e24aea4cc64001e2417b9f43adde6aa3097be89a871509e55249702efeb80",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 18,
                        "slide": 6,
                        "touch": 24,
                        "break": 5,
                        "total": 156
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11386,
                    "releaseDate": "2022-06-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 36,
                        "slide": 20,
                        "touch": 41,
                        "break": 9,
                        "total": 320
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11386,
                    "releaseDate": "2022-06-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 304,
                        "hold": 99,
                        "slide": 50,
                        "touch": 112,
                        "break": 10,
                        "total": 575
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11386,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2022-06-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "はっぴー星人",
                    "noteCounts": {
                        "tap": 572,
                        "hold": 64,
                        "slide": 78,
                        "touch": 117,
                        "break": 42,
                        "total": 873
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11386,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3,
                        "UNiVERSE PLUS": 14.3
                    },
                    "releaseDate": "2022-06-24"
                }
            ],
            "searchAcronyms": [
                "ss2",
                "他们是经理",
                "我要出勤",
                "海澜之家",
                "滴蜡熊热舞",
                "滴蜡熊爱跳舞",
                "白铜寺骗百合咲出钱去海澜之家买衣服",
                "荡秋千",
                "谁问你了",
                "迪拉熊跳舞"
            ]
        },
        {
            "songId": "星空パーティーチューン",
            "category": "maimai",
            "title": "星空パーティーチューン",
            "artist": "OSTER project feat. そらこ",
            "bpm": 230,
            "imageName": "917e04919ba3fb330947a539ebc2ecea89fe3cadc949b36703e87b231314249e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 133,
                        "hold": 13,
                        "slide": 5,
                        "touch": 17,
                        "break": 2,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11387,
                    "releaseDate": "2022-06-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 389,
                        "hold": 44,
                        "slide": 25,
                        "touch": 8,
                        "break": 18,
                        "total": 484
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11387,
                    "releaseDate": "2022-06-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 462,
                        "hold": 83,
                        "slide": 32,
                        "touch": 32,
                        "break": 9,
                        "total": 618
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11387,
                    "releaseDate": "2022-06-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 691,
                        "hold": 64,
                        "slide": 74,
                        "touch": 93,
                        "break": 17,
                        "total": 939
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11387,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2022-06-24"
                }
            ],
            "searchAcronyms": [
                "party tune",
                "奶子很大",
                "新海天",
                "星空",
                "星空party tune",
                "星空叙爱曲"
            ]
        },
        {
            "songId": "チューリングの跡",
            "category": "maimai",
            "title": "チューリングの跡",
            "artist": "Frums",
            "bpm": 180,
            "imageName": "9c5fdab71b0c6b3f056ecbcbc48cd17f44daee52d982d0adf406a64cbbca2716",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 13,
                        "slide": 10,
                        "touch": 6,
                        "break": 4,
                        "total": 161
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11388,
                    "releaseDate": "2022-06-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 16,
                        "slide": 24,
                        "touch": 14,
                        "break": 8,
                        "total": 337
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11388,
                    "releaseDate": "2022-06-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 419,
                        "hold": 87,
                        "slide": 8,
                        "touch": 22,
                        "break": 3,
                        "total": 539
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11388,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5,
                        "UNiVERSE PLUS": 13.5
                    },
                    "releaseDate": "2022-06-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 616,
                        "hold": 86,
                        "slide": 1,
                        "touch": 228,
                        "break": 25,
                        "total": 956
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11388,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "FESTiVAL": 14.6,
                        "FESTiVAL PLUS": 14.7,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8,
                        "UNiVERSE PLUS": 14.6
                    },
                    "releaseDate": "2022-06-24"
                }
            ],
            "searchAcronyms": [
                "🎷",
                "🧯",
                "100号拍肚皮",
                "Credits2",
                "jazz for your soul",
                "jazz for your Soul",
                "Jazz for your Soul",
                "regulus吹萨克斯",
                "Remnants of Turing",
                "Trace of Turing",
                "Traces of Turing",
                "Turing",
                "turing trace",
                "Turing's Remnants",
                "Turing's Trace",
                "Turing's Traces",
                "信用2",
                "和白法院做",
                "图灵",
                "图灵之寄",
                "图灵之迹",
                "图灵轨迹",
                "大奶子吹萨克斯",
                "好jbの帅",
                "好jbの帥",
                "寄",
                "日本字跡",
                "灭火器",
                "白法院吹灭火器",
                "白法院吹萨克斯",
                "萨克斯",
                "迹"
            ]
        },
        {
            "songId": "Sage",
            "category": "maimai",
            "title": "Sage",
            "artist": "かめりあ",
            "bpm": 145,
            "imageName": "00e952a6be2d44a35828287fc402f316ec7c0af5046e857cf1f3b23025332417",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 17,
                        "slide": 7,
                        "touch": 0,
                        "break": 4,
                        "total": 237
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11389,
                    "releaseDate": "2022-06-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 319,
                        "hold": 6,
                        "slide": 29,
                        "touch": 8,
                        "break": 4,
                        "total": 366
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11389,
                    "releaseDate": "2022-06-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 462,
                        "hold": 64,
                        "slide": 53,
                        "touch": 21,
                        "break": 41,
                        "total": 641
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11389,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2022-06-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 714,
                        "hold": 71,
                        "slide": 37,
                        "touch": 174,
                        "break": 16,
                        "total": 1012
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11389,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.6,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.7,
                        "FESTiVAL PLUS": 14.6,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5
                    },
                    "releaseDate": "2022-06-24"
                }
            ],
            "searchAcronyms": [
                "sabe",
                "sega",
                "世嘉",
                "啥歌",
                "圣人",
                "萨格",
                "贤者",
                "陕西神医魏莹玲",
                "雅迪电动车",
                "鼠尾草"
            ]
        },
        {
            "songId": "Spring of Dreams",
            "category": "東方Project",
            "title": "Spring of Dreams",
            "artist": "3L (NJK Record)",
            "bpm": 153,
            "imageName": "8fe18807369f4a5ff5fc59f36e88e3629442a9be03f4d7217d810719534f6098",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 129,
                        "hold": 8,
                        "slide": 3,
                        "touch": 8,
                        "break": 3,
                        "total": 151
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11434,
                    "releaseDate": "2022-07-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 14,
                        "slide": 3,
                        "touch": 42,
                        "break": 12,
                        "total": 301
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11434,
                    "releaseDate": "2022-07-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 74,
                        "slide": 23,
                        "touch": 20,
                        "break": 12,
                        "total": 451
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11434,
                    "releaseDate": "2022-07-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "アミノハバキリ",
                    "noteCounts": {
                        "tap": 553,
                        "hold": 77,
                        "slide": 48,
                        "touch": 49,
                        "break": 20,
                        "total": 747
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11434,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2022-07-01"
                }
            ],
            "searchAcronyms": [
                "娜兹玲",
                "小老鼠",
                "春梦",
                "莉莉白"
            ]
        },
        {
            "songId": "大輪の魂 (feat. AO, 司芭扶)",
            "category": "東方Project",
            "title": "大輪の魂 (feat. AO, 司芭扶)",
            "artist": "魂音泉",
            "bpm": 137,
            "imageName": "f75b8a200fbd7a28e3276b63c4e86a8976beae86a9c5195483fd28fa217dd0ba",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 98,
                        "hold": 7,
                        "slide": 8,
                        "touch": 6,
                        "break": 4,
                        "total": 123
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11435,
                    "releaseDate": "2022-07-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 10,
                        "slide": 17,
                        "touch": 26,
                        "break": 6,
                        "total": 288
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11435,
                    "releaseDate": "2022-07-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 332,
                        "hold": 39,
                        "slide": 30,
                        "touch": 10,
                        "break": 18,
                        "total": 429
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11435,
                    "releaseDate": "2022-07-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 550,
                        "hold": 52,
                        "slide": 103,
                        "touch": 42,
                        "break": 19,
                        "total": 766
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11435,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM PLUS": 13.3,
                        "UNiVERSE PLUS": 13.4
                    },
                    "releaseDate": "2022-07-01"
                }
            ],
            "searchAcronyms": [
                "大海底谭",
                "大轮",
                "大轮之魂",
                "大轮的魂",
                "大轮魂"
            ]
        },
        {
            "songId": "紅に染まる恋の花",
            "category": "東方Project",
            "title": "紅に染まる恋の花",
            "artist": "幽閉サテライト(Produce:嵯峨飛鳥 Arranged:Iceon)",
            "bpm": 140,
            "imageName": "3e42792fac5046200a9f4f84e563fae95bd511593dd87d1b35be6093ae7d7600",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 80,
                        "hold": 9,
                        "slide": 4,
                        "touch": 22,
                        "break": 1,
                        "total": 116
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11436,
                    "releaseDate": "2022-07-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 21,
                        "slide": 7,
                        "touch": 32,
                        "break": 2,
                        "total": 302
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11436,
                    "releaseDate": "2022-07-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 53,
                        "slide": 24,
                        "touch": 14,
                        "break": 4,
                        "total": 444
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11436,
                    "releaseDate": "2022-07-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 472,
                        "hold": 14,
                        "slide": 129,
                        "touch": 36,
                        "break": 10,
                        "total": 661
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11436,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL": 12.5,
                        "PRiSM PLUS": 12.5,
                        "UNiVERSE PLUS": 12.5
                    },
                    "releaseDate": "2022-07-01"
                }
            ],
            "searchAcronyms": [
                "染红的恋之花",
                "秋姐妹",
                "红染恋花"
            ]
        },
        {
            "songId": "三妖精SAY YA!!!",
            "category": "東方Project",
            "title": "三妖精SAY YA!!!",
            "artist": "森羅万象",
            "bpm": 150,
            "imageName": "98d337773b4fc825168c34df7c4116f26c71067db81077ecc3a44c05a14865c0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 6,
                        "slide": 7,
                        "touch": 21,
                        "break": 3,
                        "total": 142
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11437,
                    "releaseDate": "2022-07-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 8,
                        "slide": 14,
                        "touch": 20,
                        "break": 1,
                        "total": 333
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11437,
                    "releaseDate": "2022-07-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 366,
                        "hold": 52,
                        "slide": 31,
                        "touch": 33,
                        "break": 11,
                        "total": 493
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11437,
                    "releaseDate": "2022-07-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 481,
                        "hold": 86,
                        "slide": 140,
                        "touch": 72,
                        "break": 23,
                        "total": 802
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11437,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3,
                        "UNiVERSE PLUS": 13.3
                    },
                    "releaseDate": "2022-07-01"
                }
            ],
            "searchAcronyms": [
                "sanyousei",
                "三妖精",
                "三小只",
                "三月精",
                "三笨蛋",
                "三铸币",
                "三铸币 KAI DA!!!",
                "我们三"
            ]
        },
        {
            "songId": "OTOGEMA",
            "category": "maimai",
            "title": "OTOGEMA",
            "artist": "ビートまりお",
            "bpm": 145,
            "imageName": "e238de3ed1b16ac668dcfc00e3c9850b82aefb7e69345204c488ba3075b33d3b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 153,
                        "hold": 9,
                        "slide": 4,
                        "touch": 20,
                        "break": 6,
                        "total": 192
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "UNiVERSE"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11390,
                    "releaseDate": "2022-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 24,
                        "slide": 5,
                        "touch": 7,
                        "break": 20,
                        "total": 307
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "UNiVERSE"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11390,
                    "releaseDate": "2022-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 33,
                        "slide": 56,
                        "touch": 37,
                        "break": 10,
                        "total": 538
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "UNiVERSE"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11390,
                    "releaseDate": "2022-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "Jack & はっぴー vs からめる & ぐるん",
                    "noteCounts": {
                        "tap": 672,
                        "hold": 15,
                        "slide": 112,
                        "touch": 30,
                        "break": 48,
                        "total": 877
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "UNiVERSE"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11390,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6,
                        "UNiVERSE PLUS": 13.8
                    },
                    "releaseDate": "2022-07-11"
                }
            ],
            "searchAcronyms": [
                "10周年",
                "otto",
                "ottogame",
                "ottogema",
                "otto个妈",
                "OTTO个妈",
                "otto给妈",
                "otto给马",
                "十周年",
                "哦偷个妈",
                "我偷个妈",
                "狗打碟",
                "电棍",
                "电棍个妈",
                "电棍送母",
                "音游人",
                "音游玩家"
            ]
        },
        {
            "songId": "WiPE OUT MEMORIES",
            "category": "maimai",
            "title": "WiPE OUT MEMORIES",
            "artist": "t+pazolite",
            "bpm": 210,
            "imageName": "a2e06a1173804eb3b13d1c96e73460e94164e53240796f636b3d6095fb0f5845",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 228,
                        "hold": 9,
                        "slide": 6,
                        "touch": 13,
                        "break": 11,
                        "total": 267
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11391,
                    "releaseDate": "2022-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 376,
                        "hold": 18,
                        "slide": 14,
                        "touch": 30,
                        "break": 20,
                        "total": 458
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11391,
                    "releaseDate": "2022-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 533,
                        "hold": 29,
                        "slide": 64,
                        "touch": 49,
                        "break": 42,
                        "total": 717
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11391,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2022-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "maimai Fumen All-Stars",
                    "noteCounts": {
                        "tap": 741,
                        "hold": 102,
                        "slide": 98,
                        "touch": 76,
                        "break": 88,
                        "total": 1105
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11391,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "FESTiVAL": 14.7,
                        "FESTiVAL PLUS": 14.7,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8
                    },
                    "releaseDate": "2022-07-11"
                }
            ],
            "searchAcronyms": [
                "10周年",
                "maimai机台",
                "wipe",
                "wipeout",
                "wom",
                "WOM",
                "十周年",
                "吴丽芳",
                "抹去记忆",
                "洗衣机",
                "消逝的回忆",
                "缝合怪",
                "舞立方",
                "超级缝合怪"
            ]
        },
        {
            "songId": "Reach For The Stars (Re-Colors)",
            "category": "ゲーム＆バラエティ",
            "title": "Reach For The Stars (Re-Colors)",
            "artist": "大谷智哉「ソニックカラーズ アルティメット」",
            "bpm": 203,
            "imageName": "9ef0d84217c90c7fe01ed8dee9e54dc2ca3eaeba1e0438732e7cf2b7ececccee",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 193,
                        "hold": 11,
                        "slide": 4,
                        "touch": 24,
                        "break": 2,
                        "total": 234
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11438,
                    "releaseDate": "2022-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 13,
                        "slide": 28,
                        "touch": 24,
                        "break": 12,
                        "total": 395
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11438,
                    "releaseDate": "2022-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11.5,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 463,
                        "hold": 59,
                        "slide": 66,
                        "touch": 36,
                        "break": 10,
                        "total": 634
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11438,
                    "multiverInternalLevelValue": {
                        "UNiVERSE PLUS": 11.5
                    },
                    "releaseDate": "2022-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 852,
                        "hold": 45,
                        "slide": 49,
                        "touch": 37,
                        "break": 32,
                        "total": 1015
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11438,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2022-07-11"
                }
            ],
            "searchAcronyms": [
                "dx追星",
                "彩追星",
                "新追星",
                "索尼克缤纷色彩终极版",
                "追星2",
                "追星Remix"
            ]
        },
        {
            "songId": "コスモポップファンクラブ",
            "category": "オンゲキ＆CHUNITHM",
            "title": "コスモポップファンクラブ",
            "artist": "ナユタン星人",
            "bpm": 189,
            "imageName": "ffa8aea93b97be3388d5df9bae820bb0e15c4f65a20beca8662c3ad0de1ac72f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 132,
                        "hold": 10,
                        "slide": 4,
                        "touch": 5,
                        "break": 13,
                        "total": 164
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "UNiVERSE"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11401,
                    "releaseDate": "2022-07-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 21,
                        "slide": 9,
                        "touch": 26,
                        "break": 22,
                        "total": 266
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "UNiVERSE"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11401,
                    "releaseDate": "2022-07-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.7,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 358,
                        "hold": 86,
                        "slide": 37,
                        "touch": 111,
                        "break": 15,
                        "total": 607
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "UNiVERSE"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11401,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 10.7
                    },
                    "releaseDate": "2022-07-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 621,
                        "hold": 54,
                        "slide": 66,
                        "touch": 132,
                        "break": 30,
                        "total": 903
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "UNiVERSE"
                        }
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11401,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 13.2,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13.2,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2022-07-22"
                }
            ],
            "searchAcronyms": [
                "Cosmo Pop Fan Club",
                "cosmo pop funclub",
                "cpfc",
                "吧啦吧吧吧",
                "宇宙流行乐俱乐部",
                "小魔仙",
                "巴啦啦",
                "巴啦啦小魔仙"
            ]
        },
        {
            "songId": "ツクヨミステップ",
            "category": "オンゲキ＆CHUNITHM",
            "title": "ツクヨミステップ",
            "artist": "ユリイ・カノン feat.nameless",
            "bpm": 172,
            "imageName": "1a8805d3f47fb60241498cd773f44cb422f4cb115fdc6b7957475c8e15d5378e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 173,
                        "hold": 7,
                        "slide": 7,
                        "touch": 4,
                        "break": 3,
                        "total": 194
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11399,
                    "releaseDate": "2022-07-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 15,
                        "slide": 10,
                        "touch": 12,
                        "break": 11,
                        "total": 385
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11399,
                    "releaseDate": "2022-07-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 500,
                        "hold": 65,
                        "slide": 50,
                        "touch": 8,
                        "break": 14,
                        "total": 637
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11399,
                    "releaseDate": "2022-07-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 711,
                        "hold": 70,
                        "slide": 66,
                        "touch": 49,
                        "break": 24,
                        "total": 920
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11399,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2022-07-22"
                }
            ],
            "searchAcronyms": [
                "Tsukuyomi Step",
                "嗒嗒啦嗒啦嗒嗒",
                "女人拿水枪",
                "戴帽女人滋水枪",
                "月读",
                "月读舞步",
                "水枪",
                "水枪姐"
            ]
        },
        {
            "songId": "folern",
            "category": "オンゲキ＆CHUNITHM",
            "title": "folern",
            "artist": "ぬゆり",
            "bpm": 200,
            "imageName": "300e7986b3930da702a25f8267fbb0a14a5c843da109ab55749e7dd76d04d860",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 160,
                        "hold": 10,
                        "slide": 4,
                        "touch": 27,
                        "break": 3,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11400,
                    "releaseDate": "2022-07-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 25,
                        "slide": 20,
                        "touch": 8,
                        "break": 6,
                        "total": 381
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11400,
                    "releaseDate": "2022-07-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 485,
                        "hold": 56,
                        "slide": 42,
                        "touch": 69,
                        "break": 15,
                        "total": 667
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11400,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "FESTiVAL": 12.2,
                        "PRiSM PLUS": 12.2,
                        "UNiVERSE PLUS": 12.2
                    },
                    "releaseDate": "2022-07-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 789,
                        "hold": 77,
                        "slide": 55,
                        "touch": 28,
                        "break": 30,
                        "total": 979
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11400,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2022-07-22"
                }
            ],
            "searchAcronyms": [
                "买了否冷",
                "佛冷",
                "北冰洋",
                "大鸣大放",
                "我要抓走你的妈妈",
                "服了",
                "水陈",
                "给我玩中二节奏",
                "迪希雅"
            ]
        },
        {
            "songId": "Metamorphosism",
            "category": "maimai",
            "title": "Metamorphosism",
            "artist": "削除",
            "bpm": 144,
            "imageName": "e0ba440cc5576114c908ef379e21f9a43dc136cbafbaf91e998340d5d42eb2a7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 211,
                        "hold": 16,
                        "slide": 9,
                        "touch": 9,
                        "break": 7,
                        "total": 252
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11392,
                    "releaseDate": "2022-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 38,
                        "slide": 21,
                        "touch": 29,
                        "break": 4,
                        "total": 324
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11392,
                    "releaseDate": "2022-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 244,
                        "hold": 132,
                        "slide": 62,
                        "touch": 76,
                        "break": 11,
                        "total": 525
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11392,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8,
                        "UNiVERSE PLUS": 12.8
                    },
                    "releaseDate": "2022-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 680,
                        "hold": 60,
                        "slide": 127,
                        "touch": 71,
                        "break": 16,
                        "total": 954
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11392,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "FESTiVAL": 14.6,
                        "FESTiVAL PLUS": 14.6,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7,
                        "UNiVERSE PLUS": 14.6
                    },
                    "releaseDate": "2022-08-05"
                }
            ],
            "searchAcronyms": [
                "meta",
                "削除发病",
                "削除拉矢",
                "削除鬼叫",
                "变形",
                "变态",
                "变态主义",
                "变质",
                "哇袄",
                "少爷发癫",
                "消除鬼叫",
                "质变"
            ]
        },
        {
            "songId": "白花の天使",
            "category": "maimai",
            "title": "白花の天使",
            "artist": "Yu-dachi",
            "bpm": 200,
            "imageName": "729eda740b6e8de44c03d2a45b737e753d47783b7ef9de0890d7e20e1f7f33a4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 165,
                        "hold": 13,
                        "slide": 10,
                        "touch": 16,
                        "break": 2,
                        "total": 206
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11393,
                    "releaseDate": "2022-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 358,
                        "hold": 16,
                        "slide": 19,
                        "touch": 12,
                        "break": 3,
                        "total": 408
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11393,
                    "releaseDate": "2022-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 530,
                        "hold": 89,
                        "slide": 52,
                        "touch": 18,
                        "break": 11,
                        "total": 700
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11393,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12,
                        "UNiVERSE PLUS": 12
                    },
                    "releaseDate": "2022-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 591,
                        "hold": 84,
                        "slide": 84,
                        "touch": 72,
                        "break": 15,
                        "total": 846
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11393,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2022-08-05"
                }
            ],
            "searchAcronyms": [
                "东雪莲2",
                "冬雪の莲莲",
                "白花",
                "白花天使",
                "白花的天使"
            ]
        },
        {
            "songId": "World's end loneliness",
            "category": "maimai",
            "title": "World's end loneliness",
            "artist": "打打だいず",
            "bpm": 205,
            "imageName": "3d991cd7ae8acd4b4a6144d797637f381ab5bd7fe185f78ec6561e56360a7aa7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 281,
                        "hold": 26,
                        "slide": 8,
                        "touch": 35,
                        "break": 9,
                        "total": 359
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11394,
                    "releaseDate": "2022-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 398,
                        "hold": 16,
                        "slide": 25,
                        "touch": 21,
                        "break": 12,
                        "total": 472
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11394,
                    "releaseDate": "2022-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 520,
                        "hold": 64,
                        "slide": 57,
                        "touch": 56,
                        "break": 24,
                        "total": 721
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11394,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2022-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.9,
                    "noteDesigner": "翡翠マナ",
                    "noteCounts": {
                        "tap": 856,
                        "hold": 88,
                        "slide": 96,
                        "touch": 94,
                        "break": 100,
                        "total": 1234
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11394,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.9,
                        "BUDDiES PLUS": 14.9,
                        "CiRCLE": 14.9,
                        "CiRCLE PLUS": 14.9,
                        "FESTiVAL": 14.9,
                        "FESTiVAL PLUS": 14.9,
                        "PRiSM": 14.9,
                        "PRiSM PLUS": 14.9,
                        "UNiVERSE PLUS": 14.9
                    },
                    "releaseDate": "2022-08-05"
                }
            ],
            "searchAcronyms": [
                "wel",
                "世孤",
                "世末孤独",
                "世終孤独",
                "世终",
                "世终孤独",
                "世翠孤独",
                "噩梦",
                "奥尔菲斯",
                "孤独终老",
                "寡",
                "寡王",
                "我饿了",
                "林尼"
            ]
        },
        {
            "songId": "Jouez Avec Moi?",
            "category": "maimai",
            "title": "Jouez Avec Moi?",
            "artist": "Retropolitaliens (Ms.+駄々子)",
            "bpm": 162,
            "imageName": "76a01f271d724d4549616901b533b6485e4563ae72bfd25879fa9497aa298d3c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 123,
                        "hold": 16,
                        "slide": 8,
                        "touch": 17,
                        "break": 2,
                        "total": 166
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11395,
                    "releaseDate": "2022-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 248,
                        "hold": 16,
                        "slide": 18,
                        "touch": 21,
                        "break": 9,
                        "total": 312
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11395,
                    "releaseDate": "2022-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 420,
                        "hold": 39,
                        "slide": 67,
                        "touch": 31,
                        "break": 9,
                        "total": 566
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11395,
                    "releaseDate": "2022-08-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 637,
                        "hold": 70,
                        "slide": 86,
                        "touch": 73,
                        "break": 40,
                        "total": 906
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11395,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2022-08-05"
                }
            ],
            "searchAcronyms": [
                "jam",
                "moi",
                "和我拼机吗",
                "和我玩",
                "来玩",
                "跟我玩",
                "问号",
                "陪我玩"
            ]
        },
        {
            "songId": "ジャンキーナイトタウンオーケストラ",
            "category": "niconico＆ボーカロイド",
            "title": "ジャンキーナイトタウンオーケストラ",
            "artist": "すりぃ",
            "bpm": 145,
            "imageName": "de8e6a1c7e55ef80b368fc3a50414e648de76b86a33efc757bf3fa702a69d830",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 122,
                        "hold": 8,
                        "slide": 8,
                        "touch": 17,
                        "break": 4,
                        "total": 159
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11439,
                    "releaseDate": "2022-08-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 195,
                        "hold": 21,
                        "slide": 25,
                        "touch": 14,
                        "break": 6,
                        "total": 261
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11439,
                    "releaseDate": "2022-08-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 85,
                        "slide": 31,
                        "touch": 44,
                        "break": 6,
                        "total": 523
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11439,
                    "releaseDate": "2022-08-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 619,
                        "hold": 58,
                        "slide": 77,
                        "touch": 29,
                        "break": 35,
                        "total": 818
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11439,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2022-08-19"
                }
            ],
            "searchAcronyms": [
                "🤫",
                "junky night town orchestra",
                "Junky Night Town Orchestra",
                "玛奇玛",
                "瘾者之夜",
                "瘾者之夜城镇乐队"
            ]
        },
        {
            "songId": "終焉逃避行",
            "category": "niconico＆ボーカロイド",
            "title": "終焉逃避行",
            "artist": "柊マグネタイト",
            "bpm": 147,
            "imageName": "1e0e2a4a4a363eb008c1ca7a67aeb9f20066c56ec2fa5033fe8972fbc9ee6eaa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 12,
                        "slide": 3,
                        "touch": 5,
                        "break": 1,
                        "total": 175
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11441,
                    "releaseDate": "2022-08-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 211,
                        "hold": 13,
                        "slide": 18,
                        "touch": 13,
                        "break": 7,
                        "total": 262
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11441,
                    "releaseDate": "2022-08-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 371,
                        "hold": 48,
                        "slide": 53,
                        "touch": 8,
                        "break": 9,
                        "total": 489
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11441,
                    "releaseDate": "2022-08-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 539,
                        "hold": 79,
                        "slide": 99,
                        "touch": 20,
                        "break": 46,
                        "total": 783
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11441,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9,
                        "UNiVERSE PLUS": 12.9
                    },
                    "releaseDate": "2022-08-19"
                }
            ],
            "searchAcronyms": [
                "提桶跑路",
                "终焉",
                "终焉逃避行"
            ]
        },
        {
            "songId": "エゴロック",
            "category": "niconico＆ボーカロイド",
            "title": "エゴロック",
            "artist": "すりぃ",
            "bpm": 225,
            "imageName": "1b3250130cf25fcb09a43b6620aa8c8cf2fa4a15a7fd604230083a5187d2c450",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 150,
                        "hold": 8,
                        "slide": 2,
                        "touch": 7,
                        "break": 3,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11447,
                    "releaseDate": "2022-08-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 28,
                        "slide": 3,
                        "touch": 13,
                        "break": 4,
                        "total": 271
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11447,
                    "releaseDate": "2022-08-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10.5,
                    "noteDesigner": "畳返し",
                    "noteCounts": {
                        "tap": 367,
                        "hold": 30,
                        "slide": 18,
                        "touch": 27,
                        "break": 24,
                        "total": 466
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11447,
                    "releaseDate": "2022-08-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 425,
                        "hold": 48,
                        "slide": 127,
                        "touch": 21,
                        "break": 69,
                        "total": 690
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11447,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2022-08-19"
                }
            ],
            "searchAcronyms": [
                "ego rock",
                "egorock",
                "自我摇滚",
                "自由摇滚"
            ]
        },
        {
            "songId": "ただ選択があった",
            "category": "niconico＆ボーカロイド",
            "title": "ただ選択があった",
            "artist": "フロクロ",
            "bpm": 140,
            "imageName": "03593912c076390e97a06668057c7fcc876659b923775f4f78bd85bbd6bbadfb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 85,
                        "hold": 10,
                        "slide": 4,
                        "touch": 8,
                        "break": 1,
                        "total": 108
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11448,
                    "releaseDate": "2022-08-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 183,
                        "hold": 14,
                        "slide": 9,
                        "touch": 28,
                        "break": 4,
                        "total": 238
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11448,
                    "releaseDate": "2022-08-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "畳返し",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 57,
                        "slide": 18,
                        "touch": 85,
                        "break": 8,
                        "total": 409
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11448,
                    "releaseDate": "2022-08-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 260,
                        "hold": 45,
                        "slide": 11,
                        "touch": 145,
                        "break": 5,
                        "total": 466
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11448,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7,
                        "UNiVERSE PLUS": 12.7
                    },
                    "releaseDate": "2022-08-19"
                }
            ],
            "searchAcronyms": [
                "jubeat",
                "仅仅做出选择而已",
                "只是在不断选择",
                "打地鼠",
                "答题卡",
                "选择"
            ]
        },
        {
            "songId": "パズルリボン",
            "category": "オンゲキ＆CHUNITHM",
            "title": "パズルリボン",
            "artist": "すりぃ feat.りょーくん",
            "bpm": 215,
            "imageName": "40eb3264579d40f4fc5f5a71d0442b690a6234617f49b3e92a72b9537aaa6ead",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 211,
                        "hold": 8,
                        "slide": 4,
                        "touch": 6,
                        "break": 6,
                        "total": 235
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11449,
                    "releaseDate": "2022-08-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 38,
                        "slide": 9,
                        "touch": 14,
                        "break": 3,
                        "total": 311
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11449,
                    "releaseDate": "2022-08-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 93,
                        "slide": 50,
                        "touch": 16,
                        "break": 8,
                        "total": 569
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11449,
                    "releaseDate": "2022-08-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 576,
                        "hold": 71,
                        "slide": 138,
                        "touch": 16,
                        "break": 34,
                        "total": 835
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11449,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2022-08-19"
                }
            ],
            "searchAcronyms": [
                "puzzle ribbon",
                "Puzzle Ribbon",
                "东云彰人",
                "拼图丝带",
                "游乐王子",
                "红发男"
            ]
        },
        {
            "songId": "撩乱乙女†無双劇",
            "category": "オンゲキ＆CHUNITHM",
            "title": "撩乱乙女†無双劇",
            "artist": "曲：Haggy Rock & 佐藤厚仁／歌：⊿TRiEDGE [高瀬 梨緒(CV：久保 ユリカ)、結城 莉玖(CV：朝日奈 丸佳)、藍原 椿(CV：橋本 ちなみ)]",
            "bpm": 165,
            "imageName": "01f5b997c1a2fb8726ca2fc18555530de79d110b4ae23d5b8f1770e90a82a6c6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 159,
                        "hold": 3,
                        "slide": 4,
                        "touch": 23,
                        "break": 7,
                        "total": 196
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11402,
                    "releaseDate": "2022-09-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 252,
                        "hold": 13,
                        "slide": 14,
                        "touch": 28,
                        "break": 2,
                        "total": 309
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11402,
                    "releaseDate": "2022-09-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 495,
                        "hold": 58,
                        "slide": 54,
                        "touch": 8,
                        "break": 80,
                        "total": 695
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11402,
                    "releaseDate": "2022-09-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Redarrow",
                    "noteCounts": {
                        "tap": 533,
                        "hold": 63,
                        "slide": 127,
                        "touch": 32,
                        "break": 108,
                        "total": 863
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11402,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4,
                        "UNiVERSE PLUS": 13.4
                    },
                    "releaseDate": "2022-09-02"
                }
            ],
            "searchAcronyms": [
                "TRiEDGE",
                "女同3p",
                "撩乱",
                "撩乱乙女",
                "撩乱乙女无双剧",
                "无双剧",
                "缭乱乙女"
            ]
        },
        {
            "songId": "See The Light",
            "category": "オンゲキ＆CHUNITHM",
            "title": "See The Light",
            "artist": "anubasu-anubasu",
            "bpm": 150,
            "imageName": "42e99e822b2ad401d8b7007e43e7191c3e955c844c73395ed610f7ef00a277c2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 132,
                        "hold": 4,
                        "slide": 4,
                        "touch": 8,
                        "break": 3,
                        "total": 151
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11404,
                    "releaseDate": "2022-09-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 24,
                        "slide": 10,
                        "touch": 24,
                        "break": 2,
                        "total": 256
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11404,
                    "releaseDate": "2022-09-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 389,
                        "hold": 40,
                        "slide": 12,
                        "touch": 14,
                        "break": 55,
                        "total": 510
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11404,
                    "releaseDate": "2022-09-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 541,
                        "hold": 24,
                        "slide": 42,
                        "touch": 134,
                        "break": 55,
                        "total": 796
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11404,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.7,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2022-09-02"
                }
            ],
            "searchAcronyms": [
                "stl",
                "喜之郎",
                "屎都濑",
                "看光",
                "看见光",
                "金坷垃"
            ]
        },
        {
            "songId": "エータ・ベータ・イータ",
            "category": "オンゲキ＆CHUNITHM",
            "title": "エータ・ベータ・イータ",
            "artist": "ルゼ",
            "bpm": 186,
            "imageName": "4aff8b8f7c1b17804e954601c952f07a3e001f0170259d6dfe3a5cf6e85453d0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 13,
                        "slide": 4,
                        "touch": 24,
                        "break": 5,
                        "total": 309
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11405,
                    "releaseDate": "2022-09-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 314,
                        "hold": 28,
                        "slide": 22,
                        "touch": 20,
                        "break": 7,
                        "total": 391
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11405,
                    "releaseDate": "2022-09-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 494,
                        "hold": 78,
                        "slide": 39,
                        "touch": 20,
                        "break": 23,
                        "total": 654
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11405,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.4,
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL": 12.4,
                        "FESTiVAL PLUS": 12.4,
                        "PRiSM PLUS": 12.4,
                        "UNiVERSE PLUS": 12.4
                    },
                    "releaseDate": "2022-09-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "チャン@DP皆伝",
                    "noteCounts": {
                        "tap": 857,
                        "hold": 29,
                        "slide": 29,
                        "touch": 66,
                        "break": 73,
                        "total": 1054
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11405,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.1,
                        "BUDDiES PLUS": 14.1,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 14.2,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1
                    },
                    "releaseDate": "2022-09-02"
                }
            ],
            "searchAcronyms": [
                "ebe",
                "EBE",
                "Eta Beta Eater",
                "Eta Beta Eta",
                "eta beta ita",
                "Eta Beta Ita",
                "hbh",
                "hera2",
                "η·β·ι",
                "二次元hera",
                "儿也号纵连居士",
                "夕夕夕",
                "工一夕",
                "工一夕·八一夕·人一夕",
                "工一夕八一夕人一夕",
                "工一夕点八一夕点人一夕",
                "椿椿的键纵",
                "纵连女",
                "纵连居士",
                "蓝原椿",
                "蓝原椿骂人",
                "赫拉2",
                "赫拉二"
            ]
        },
        {
            "songId": "Transcend Lights",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Transcend Lights",
            "artist": "曲：小高光太郎／歌：オンゲキシューターズ",
            "bpm": 70,
            "imageName": "9e7a9c706a68f7a2e548f81a68b972138b43fcab72c7743fe063e4d4013f6d03",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 126,
                        "hold": 5,
                        "slide": 6,
                        "touch": 14,
                        "break": 4,
                        "total": 155
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11451,
                    "releaseDate": "2022-09-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 19,
                        "slide": 2,
                        "touch": 9,
                        "break": 4,
                        "total": 285
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11451,
                    "releaseDate": "2022-09-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 40,
                        "slide": 55,
                        "touch": 14,
                        "break": 17,
                        "total": 366
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11451,
                    "releaseDate": "2022-09-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 442,
                        "hold": 8,
                        "slide": 119,
                        "touch": 25,
                        "break": 15,
                        "total": 609
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE PLUS",
                    "internalId": 11451,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5,
                        "UNiVERSE PLUS": 13.7
                    },
                    "releaseDate": "2022-09-02"
                }
            ],
            "searchAcronyms": [
                "114514",
                "bright主题曲",
                "tl",
                "九月的雨",
                "别急19",
                "加速同调",
                "压力马斯内",
                "好啊，来吧",
                "封面全是老婆",
                "急急急",
                "我知道你很急但你先别急",
                "正在拆弹",
                "美瞳广告",
                "超越光",
                "音击妹妹",
                "音击的武士",
                "音击的雨"
            ]
        },
        {
            "songId": "ホシシズク",
            "category": "maimai",
            "title": "ホシシズク",
            "artist": "森羅万象",
            "bpm": 182,
            "imageName": "c63d80d56cb56ff12a9c36eacec7c88866c2c3fadd71861543116397a4631d49",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 165,
                        "hold": 16,
                        "slide": 4,
                        "touch": 8,
                        "break": 4,
                        "total": 197
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11452,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 18,
                        "slide": 15,
                        "touch": 18,
                        "break": 12,
                        "total": 412
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11452,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 500,
                        "hold": 41,
                        "slide": 24,
                        "touch": 81,
                        "break": 21,
                        "total": 667
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11452,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "隅田川星人",
                    "noteCounts": {
                        "tap": 578,
                        "hold": 35,
                        "slide": 125,
                        "touch": 65,
                        "break": 64,
                        "total": 867
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11452,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 12.9,
                        "PRiSM": 13.1,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": [
                "fes主题曲",
                "三小只2",
                "三小只过节",
                "星雨",
                "繁星点点"
            ]
        },
        {
            "songId": "Rainbow Rush Story",
            "category": "maimai",
            "title": "Rainbow Rush Story",
            "artist": "いるかアイス feat.ちょこ",
            "bpm": 200,
            "imageName": "f5011ffe7eb33301769b6a5a9f8e11b988ca17ddfb91b05378d8c5f90d810f5b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 10,
                        "slide": 7,
                        "touch": 8,
                        "break": 3,
                        "total": 173
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11453,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 303,
                        "hold": 23,
                        "slide": 12,
                        "touch": 9,
                        "break": 15,
                        "total": 362
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11453,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 18,
                        "slide": 34,
                        "touch": 42,
                        "break": 24,
                        "total": 474
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11453,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 629,
                        "hold": 38,
                        "slide": 111,
                        "touch": 64,
                        "break": 62,
                        "total": 904
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11453,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": [
                "rrs",
                "彩虹冲刺故事",
                "彩虹冲故事"
            ]
        },
        {
            "songId": "Tricolor⁂circuS",
            "category": "maimai",
            "title": "Tricolor⁂circuS",
            "artist": "ああ…翡翠茶漬け…",
            "bpm": 180,
            "imageName": "821e1c28b75374ae619564017b8d94099ebf7d91f54421c9667b289b89ed02f6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 14,
                        "slide": 3,
                        "touch": 18,
                        "break": 4,
                        "total": 164
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11454,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 219,
                        "hold": 27,
                        "slide": 12,
                        "touch": 33,
                        "break": 7,
                        "total": 298
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11454,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 355,
                        "hold": 54,
                        "slide": 31,
                        "touch": 37,
                        "break": 9,
                        "total": 486
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11454,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "ネコトリサーカス団",
                    "noteCounts": {
                        "tap": 624,
                        "hold": 68,
                        "slide": 66,
                        "touch": 111,
                        "break": 55,
                        "total": 924
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11454,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": [
                "Tricolor circuS",
                "三个出生",
                "三只福瑞过节",
                "三色马戏团",
                "福瑞三小只",
                "福瑞过节"
            ]
        },
        {
            "songId": "[X]",
            "category": "maimai",
            "title": "[X]",
            "artist": "Blacklolita",
            "bpm": 162,
            "imageName": "c5abf5c7c5a6f683f43f7b599826bd60ff3d718e215f8ea96ba9373c6ac6ceb7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 134,
                        "hold": 12,
                        "slide": 9,
                        "touch": 20,
                        "break": 26,
                        "total": 201
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11455,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 48,
                        "slide": 18,
                        "touch": 23,
                        "break": 8,
                        "total": 364
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11455,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 444,
                        "hold": 68,
                        "slide": 54,
                        "touch": 57,
                        "break": 10,
                        "total": 633
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11455,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "FESTiVAL": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 628,
                        "hold": 62,
                        "slide": 109,
                        "touch": 111,
                        "break": 89,
                        "total": 999
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11455,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 14,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": [
                "&#91;X&#93;",
                "∞",
                "X",
                "叉",
                "推特",
                "无穷大",
                "无限",
                "艾克斯",
                "高斯函数"
            ]
        },
        {
            "songId": "分解収束テイル",
            "category": "maimai",
            "title": "分解収束テイル",
            "artist": "un:c・konoco×cosMo＠暴走P",
            "bpm": 186,
            "imageName": "fac652d2740b0b94ac39c93410324277a6467f637e1f87d1801bccd307053161",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 115,
                        "hold": 15,
                        "slide": 8,
                        "touch": 21,
                        "break": 6,
                        "total": 165
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11456,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 300,
                        "hold": 46,
                        "slide": 9,
                        "touch": 23,
                        "break": 16,
                        "total": 394
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11456,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 485,
                        "hold": 52,
                        "slide": 40,
                        "touch": 64,
                        "break": 28,
                        "total": 669
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11456,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 11
                    },
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "ロシアンブラック",
                    "noteCounts": {
                        "tap": 644,
                        "hold": 66,
                        "slide": 111,
                        "touch": 173,
                        "break": 62,
                        "total": 1056
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11456,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": [
                "分解收束"
            ]
        },
        {
            "songId": "蜘蛛の糸",
            "category": "オンゲキ＆CHUNITHM",
            "title": "蜘蛛の糸",
            "artist": "きくお×cosMo＠暴走P feat.影縫英",
            "bpm": 180,
            "imageName": "3b0db48212e6690748900b9d4b3ec8e9af6f84995602ec6e4b4df307860bc42c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 173,
                        "hold": 14,
                        "slide": 9,
                        "touch": 20,
                        "break": 8,
                        "total": 224
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11471,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 274,
                        "hold": 27,
                        "slide": 9,
                        "touch": 46,
                        "break": 8,
                        "total": 364
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11471,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 447,
                        "hold": 92,
                        "slide": 26,
                        "touch": 38,
                        "break": 95,
                        "total": 698
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11471,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "小鳥遊さん×アミノハバキリ",
                    "noteCounts": {
                        "tap": 829,
                        "hold": 67,
                        "slide": 28,
                        "touch": 93,
                        "break": 35,
                        "total": 1052
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11471,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL": 14,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": [
                "🕸️",
                "spider's thread",
                "spider’s thread",
                "Spider's Web",
                "Spiderweb",
                "滴嘟丝",
                "蜘蛛丝",
                "蜘蛛的丝"
            ]
        },
        {
            "songId": "Don't Fight The Music",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Don't Fight The Music",
            "artist": "黒魔",
            "bpm": 195,
            "imageName": "43e274dd8f15a897ab59067b6b738233b8897e0b8d56b4d94cd4f81c9924d656",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 183,
                        "hold": 24,
                        "slide": 10,
                        "touch": 4,
                        "break": 4,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11472,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 42,
                        "slide": 18,
                        "touch": 29,
                        "break": 16,
                        "total": 410
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11472,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 545,
                        "hold": 112,
                        "slide": 58,
                        "touch": 19,
                        "break": 17,
                        "total": 751
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11472,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "翠楼屋 vs あまくちジンジャー",
                    "noteCounts": {
                        "tap": 690,
                        "hold": 41,
                        "slide": 73,
                        "touch": 137,
                        "break": 148,
                        "total": 1089
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11472,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.1,
                        "BUDDiES PLUS": 14.1,
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "FESTiVAL": 14.2,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": [
                "dftm",
                "donfai",
                "knd",
                "不要打歌",
                "你不许玩了",
                "别打歌",
                "别打音游",
                "刹那",
                "憋打歌"
            ]
        },
        {
            "songId": "アニマル",
            "category": "niconico＆ボーカロイド",
            "title": "アニマル",
            "artist": "DECO*27",
            "bpm": 188,
            "imageName": "ee4eebd3212cfc68ec993cec990f01ad8f4aabb535f96ea5cc1134923d14ae12",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 22,
                        "slide": 4,
                        "touch": 20,
                        "break": 2,
                        "total": 173
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11481,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 371,
                        "hold": 24,
                        "slide": 9,
                        "touch": 20,
                        "break": 10,
                        "total": 434
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11481,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.8,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 473,
                        "hold": 72,
                        "slide": 8,
                        "touch": 42,
                        "break": 83,
                        "total": 678
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11481,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 10.8
                    },
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "Redarrow",
                    "noteCounts": {
                        "tap": 564,
                        "hold": 53,
                        "slide": 103,
                        "touch": 139,
                        "break": 82,
                        "total": 941
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11481,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": [
                "animal",
                "Animal",
                "动物",
                "杀杀杀",
                "猫葱"
            ]
        },
        {
            "songId": "ジレンマ",
            "category": "niconico＆ボーカロイド",
            "title": "ジレンマ",
            "artist": "DECO*27",
            "bpm": 188,
            "imageName": "a8b42a07c6de23aa1745c06c343d206ab454bd37c14af803e666d22ad5aaebc3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 129,
                        "hold": 12,
                        "slide": 6,
                        "touch": 11,
                        "break": 3,
                        "total": 161
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11482,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 16,
                        "slide": 18,
                        "touch": 23,
                        "break": 15,
                        "total": 410
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11482,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10.2,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 446,
                        "hold": 43,
                        "slide": 27,
                        "touch": 45,
                        "break": 50,
                        "total": 611
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11482,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 10.2
                    },
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 623,
                        "hold": 78,
                        "slide": 80,
                        "touch": 66,
                        "break": 27,
                        "total": 874
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11482,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": [
                "dilemma",
                "异瞳",
                "异色瞳",
                "白葱",
                "赤瞳",
                "进退两难",
                "邦邦邦"
            ]
        },
        {
            "songId": "踊",
            "category": "POPS＆アニメ",
            "title": "踊",
            "artist": "Ado",
            "bpm": 128,
            "imageName": "b4b2015b16d7bdfde4a6cf5f74d105057e4ef09af873a2901d2eacc118a4ce12",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 91,
                        "hold": 9,
                        "slide": 4,
                        "touch": 24,
                        "break": 9,
                        "total": 137
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11483,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 24,
                        "slide": 12,
                        "touch": 29,
                        "break": 11,
                        "total": 315
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11483,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 34,
                        "slide": 63,
                        "touch": 27,
                        "break": 18,
                        "total": 479
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11483,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 8.5
                    },
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11.5,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 468,
                        "hold": 58,
                        "slide": 78,
                        "touch": 70,
                        "break": 33,
                        "total": 707
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11483,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 11.5
                    },
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "あまくちジンジャー",
                    "noteCounts": {
                        "tap": 536,
                        "hold": 42,
                        "slide": 71,
                        "touch": 113,
                        "break": 81,
                        "total": 843
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11483,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": [
                "ko",
                "odo",
                "哦哇哇哦哇哦",
                "桶",
                "红眼果蝇",
                "耶耶耶耶耶耶",
                "起舞",
                "跳舞",
                "长舌妇"
            ]
        },
        {
            "songId": "フォニイ",
            "category": "niconico＆ボーカロイド",
            "title": "フォニイ",
            "artist": "ツミキ　feat.音楽的同位体　可不（KAFU）",
            "bpm": 170,
            "imageName": "9a2d320632a5a21ce028fd725455f5a18addcd580a98c21b1fe7db9dc06b6ef6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 78,
                        "hold": 16,
                        "slide": 6,
                        "touch": 15,
                        "break": 6,
                        "total": 121
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11485,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 242,
                        "hold": 23,
                        "slide": 11,
                        "touch": 21,
                        "break": 6,
                        "total": 303
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11485,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.8,
                    "noteDesigner": "畳返し",
                    "noteCounts": {
                        "tap": 370,
                        "hold": 53,
                        "slide": 9,
                        "touch": 64,
                        "break": 24,
                        "total": 520
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11485,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 9.8
                    },
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11.5,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 434,
                        "hold": 43,
                        "slide": 89,
                        "touch": 30,
                        "break": 26,
                        "total": 622
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11485,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 11.5
                    },
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 501,
                        "hold": 46,
                        "slide": 119,
                        "touch": 44,
                        "break": 43,
                        "total": 753
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11485,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": [
                "7才二亻",
                "phony",
                "Phony",
                "伪物",
                "凤梨",
                "噗泥",
                "扶你"
            ]
        },
        {
            "songId": "ヴィラン",
            "category": "niconico＆ボーカロイド",
            "title": "ヴィラン",
            "artist": "flower・てにをは",
            "bpm": 102,
            "imageName": "a23ce9e2ad74fee404248979c666af721d1e88b43472dc02d152907360de7aa1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 71,
                        "hold": 5,
                        "slide": 4,
                        "touch": 8,
                        "break": 2,
                        "total": 90
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11486,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 173,
                        "hold": 24,
                        "slide": 5,
                        "touch": 24,
                        "break": 7,
                        "total": 233
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11486,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 270,
                        "hold": 63,
                        "slide": 20,
                        "touch": 17,
                        "break": 7,
                        "total": 377
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11486,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 9.2
                    },
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.8,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 398,
                        "hold": 44,
                        "slide": 67,
                        "touch": 48,
                        "break": 15,
                        "total": 572
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11486,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 11.8
                    },
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 431,
                        "hold": 33,
                        "slide": 55,
                        "touch": 111,
                        "break": 49,
                        "total": 679
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11486,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": [
                "villain",
                "villan",
                "反派",
                "反派角色",
                "恶者",
                "碧浪",
                "糜烂"
            ]
        },
        {
            "songId": "EYE",
            "category": "niconico＆ボーカロイド",
            "title": "EYE",
            "artist": "Kanaria",
            "bpm": 137,
            "imageName": "fcf739a25ce997fb47d9e9a655fda8fd26fa7ee190b66dfaeeefcc89767205b6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 71,
                        "hold": 6,
                        "slide": 4,
                        "touch": 8,
                        "break": 20,
                        "total": 109
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11487,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 12,
                        "slide": 22,
                        "touch": 26,
                        "break": 8,
                        "total": 335
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11487,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 386,
                        "hold": 57,
                        "slide": 22,
                        "touch": 3,
                        "break": 13,
                        "total": 481
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11487,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 9
                    },
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "サファ太 vs 翠楼屋",
                    "noteCounts": {
                        "tap": 448,
                        "hold": 41,
                        "slide": 69,
                        "touch": 151,
                        "break": 86,
                        "total": 795
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11487,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": [
                "👀",
                "眼睛"
            ]
        },
        {
            "songId": "スカーレット警察のゲットーパトロール24時",
            "category": "東方Project",
            "title": "スカーレット警察のゲットーパトロール24時",
            "artist": "七条レタスグループ",
            "bpm": 160,
            "imageName": "56f3f92e3231292d7e859d721153fc365bd42a1955c142945ef813eeb58145d9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 88,
                        "hold": 9,
                        "slide": 8,
                        "touch": 10,
                        "break": 2,
                        "total": 117
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11488,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 17,
                        "slide": 12,
                        "touch": 18,
                        "break": 16,
                        "total": 252
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11488,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 51,
                        "slide": 28,
                        "touch": 18,
                        "break": 38,
                        "total": 307
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11488,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 519,
                        "hold": 31,
                        "slide": 77,
                        "touch": 49,
                        "break": 35,
                        "total": 711
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11488,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": [
                "👮",
                "24时",
                "24时警察",
                "funky",
                "Funky",
                "Ghetto Patrol",
                "Scarlet Police",
                "Scarlet Police on Ghetto Patrol",
                "东方警察",
                "东方警察24时",
                "宝宝巴士",
                "斯卡蕾特",
                "斯卡蕾特警察",
                "斯卡雷特警察",
                "琪露诺跳舞",
                "警察",
                "警察24时"
            ]
        },
        {
            "songId": "田中",
            "category": "ゲーム＆バラエティ",
            "title": "田中",
            "artist": "立秋 feat.ちょこ",
            "bpm": 186,
            "imageName": "cf170e8dfbeccce0f373c874a7b3bc5910444e501a4350f67f8462c3efc212d2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 139,
                        "hold": 29,
                        "slide": 6,
                        "touch": 7,
                        "break": 5,
                        "total": 186
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11489,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 24,
                        "slide": 7,
                        "touch": 34,
                        "break": 10,
                        "total": 359
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11489,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.1,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 464,
                        "hold": 74,
                        "slide": 28,
                        "touch": 81,
                        "break": 14,
                        "total": 661
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11489,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.1,
                        "CiRCLE PLUS": 12.1,
                        "FESTiVAL": 12,
                        "PRiSM PLUS": 12.1
                    },
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 571,
                        "hold": 85,
                        "slide": 80,
                        "touch": 110,
                        "break": 46,
                        "total": 892
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11489,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": [
                "tanaka",
                "Tanaka"
            ]
        },
        {
            "songId": "mystique as iris",
            "category": "maimai",
            "title": "mystique as iris",
            "artist": "かねこちはる",
            "bpm": 172,
            "imageName": "b3faaa0cf8d4a736db0ab61a9d1f1bf3d8766be97748ddfcdf6d5eed372d0d22",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 22,
                        "slide": 4,
                        "touch": 6,
                        "break": 1,
                        "total": 260
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11457,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 374,
                        "hold": 38,
                        "slide": 6,
                        "touch": 38,
                        "break": 7,
                        "total": 463
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11457,
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 441,
                        "hold": 118,
                        "slide": 58,
                        "touch": 54,
                        "break": 71,
                        "total": 742
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11457,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2022-09-15"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "red phoenix",
                    "noteCounts": {
                        "tap": 829,
                        "hold": 88,
                        "slide": 75,
                        "touch": 113,
                        "break": 62,
                        "total": 1167
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11457,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.6,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL": 14.7,
                        "FESTiVAL PLUS": 14.6,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6
                    },
                    "releaseDate": "2022-09-15"
                }
            ],
            "searchAcronyms": [
                "iris",
                "mai",
                "像鸢尾花一样神秘",
                "坐椅子",
                "如虹膜般神秘",
                "虹膜",
                "鸢尾花"
            ]
        },
        {
            "songId": "Random",
            "category": "ゲーム＆バラエティ",
            "title": "Random",
            "artist": "Sobrem × Silentroom",
            "bpm": 132,
            "imageName": "85934548f5be736a246e636dae674f8a6d8f48d74ce558e60319ed004b9456d8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 131,
                        "hold": 17,
                        "slide": 12,
                        "touch": 5,
                        "break": 5,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11490,
                    "releaseDate": "2022-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 13,
                        "slide": 7,
                        "touch": 16,
                        "break": 8,
                        "total": 262
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11490,
                    "releaseDate": "2022-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 302,
                        "hold": 98,
                        "slide": 29,
                        "touch": 30,
                        "break": 19,
                        "total": 478
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11490,
                    "releaseDate": "2022-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 417,
                        "hold": 119,
                        "slide": 57,
                        "touch": 147,
                        "break": 46,
                        "total": 786
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11490,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.5,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2022-09-22"
                }
            ],
            "searchAcronyms": [
                "随机"
            ]
        },
        {
            "songId": "Luminaria",
            "category": "ゲーム＆バラエティ",
            "title": "Luminaria",
            "artist": "Lime",
            "bpm": 227,
            "imageName": "a74aea5c617a89cf764d725e48c6d65b262dda3ea4c25808d641a04dbd39c8fd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 143,
                        "hold": 6,
                        "slide": 8,
                        "touch": 42,
                        "break": 7,
                        "total": 206
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11491,
                    "releaseDate": "2022-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 18,
                        "slide": 4,
                        "touch": 42,
                        "break": 7,
                        "total": 353
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11491,
                    "releaseDate": "2022-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 481,
                        "hold": 55,
                        "slide": 17,
                        "touch": 63,
                        "break": 75,
                        "total": 691
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11491,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "FESTiVAL": 12.2,
                        "PRiSM PLUS": 12.2
                    },
                    "releaseDate": "2022-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 640,
                        "hold": 46,
                        "slide": 83,
                        "touch": 18,
                        "break": 45,
                        "total": 832
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11491,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14
                    },
                    "releaseDate": "2022-09-22"
                }
            ],
            "searchAcronyms": [
                "没有bga的亚军曲",
                "流明",
                "海晶灯",
                "露米娅"
            ]
        },
        {
            "songId": "群青讃歌",
            "category": "niconico＆ボーカロイド",
            "title": "群青讃歌",
            "artist": "Eve / 初音ミク、星乃一歌、花里みのり、小豆沢こはね、天馬司、宵崎奏「プロジェクトセカイ カラフルステージ！ feat. 初音ミク」",
            "bpm": 168,
            "imageName": "d23fd6249a26090e75954046d496fac1ce11aa172374a162ff09fd5292e20553",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 58,
                        "hold": 6,
                        "slide": 2,
                        "touch": 4,
                        "break": 1,
                        "total": 71
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11492,
                    "releaseDate": "2022-10-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 17,
                        "slide": 6,
                        "touch": 13,
                        "break": 2,
                        "total": 210
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11492,
                    "releaseDate": "2022-10-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 29,
                        "slide": 17,
                        "touch": 7,
                        "break": 10,
                        "total": 335
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11492,
                    "releaseDate": "2022-10-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 26,
                        "slide": 65,
                        "touch": 21,
                        "break": 17,
                        "total": 385
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11492,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.4,
                        "BUDDiES PLUS": 12.4,
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "FESTiVAL": 12.4,
                        "FESTiVAL PLUS": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2022-10-07"
                }
            ],
            "searchAcronyms": [
                "Gunjo Sanka"
            ]
        },
        {
            "songId": "セカイ",
            "category": "niconico＆ボーカロイド",
            "title": "セカイ",
            "artist": "DECO*27 × 堀江晶太(kemu) / 初音ミク、星乃一歌、天馬司、宵崎奏「プロジェクトセカイ カラフルステージ！ feat. 初音ミク」",
            "bpm": 133,
            "imageName": "ada848fa355ec49a72079890927895b5aea8abdb0209b47a1d31545bcc3e3aed",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 82,
                        "hold": 4,
                        "slide": 4,
                        "touch": 8,
                        "break": 4,
                        "total": 102
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11493,
                    "releaseDate": "2022-10-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 170,
                        "hold": 10,
                        "slide": 6,
                        "touch": 21,
                        "break": 4,
                        "total": 211
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11493,
                    "releaseDate": "2022-10-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 39,
                        "slide": 33,
                        "touch": 16,
                        "break": 18,
                        "total": 360
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11493,
                    "releaseDate": "2022-10-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "うさぎランドリー",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 41,
                        "slide": 34,
                        "touch": 46,
                        "break": 30,
                        "total": 553
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11493,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2022-10-07"
                }
            ],
            "searchAcronyms": [
                "Sekai"
            ]
        },
        {
            "songId": "ワーワーワールド",
            "category": "niconico＆ボーカロイド",
            "title": "ワーワーワールド",
            "artist": "Giga & Mitchie M / 初音ミク、花里みのり、小豆沢こはね「プロジェクトセカイ カラフルステージ！ feat. 初音ミク」",
            "bpm": 160,
            "imageName": "1b5f76bcac271d0d31145dc625903d2e756cbb519611f571f5b46ad770944dcc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 100,
                        "hold": 4,
                        "slide": 4,
                        "touch": 8,
                        "break": 6,
                        "total": 122
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11494,
                    "releaseDate": "2022-10-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 18,
                        "slide": 6,
                        "touch": 27,
                        "break": 12,
                        "total": 239
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11494,
                    "releaseDate": "2022-10-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 281,
                        "hold": 35,
                        "slide": 28,
                        "touch": 19,
                        "break": 8,
                        "total": 371
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11494,
                    "releaseDate": "2022-10-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 382,
                        "hold": 45,
                        "slide": 74,
                        "touch": 35,
                        "break": 22,
                        "total": 558
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11494,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2022-10-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Catch Me If You Can",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Catch Me If You Can",
            "artist": "曲：TAKU INOUE／歌：早乙女 彩華(CV：中島 唯)",
            "bpm": 130,
            "imageName": "d483ed772306a5d80fe9e2485bf9ceaf95fa55f46a8e2d3f9ef9ba34640ed2b1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 225,
                        "hold": 16,
                        "slide": 2,
                        "touch": 17,
                        "break": 4,
                        "total": 264
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11473,
                    "releaseDate": "2022-10-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 19,
                        "slide": 6,
                        "touch": 55,
                        "break": 5,
                        "total": 325
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11473,
                    "releaseDate": "2022-10-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 366,
                        "hold": 83,
                        "slide": 53,
                        "touch": 17,
                        "break": 20,
                        "total": 539
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11473,
                    "releaseDate": "2022-10-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "ものくろっく",
                    "noteCounts": {
                        "tap": 476,
                        "hold": 101,
                        "slide": 72,
                        "touch": 151,
                        "break": 40,
                        "total": 840
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11473,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2022-10-21"
                }
            ],
            "searchAcronyms": [
                "你抓不住我",
                "你抓不住我，我是绝赞",
                "兔女郎",
                "就你还想来抓我嗷",
                "抓我",
                "抓我如果你可以",
                "早乙女彩华",
                "有种就抓我",
                "有种抓住我",
                "来抓我呀",
                "来抓我呀小熊熊",
                "猫鼠游戏",
                "露娜"
            ]
        },
        {
            "songId": "MAGNETAR GIRL",
            "category": "オンゲキ＆CHUNITHM",
            "title": "MAGNETAR GIRL",
            "artist": "Yu-dachi",
            "bpm": 170,
            "imageName": "ec2daa7ce9456586306b7104263b786bdcda32903daee14e4c8c32f47024a4ba",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 160,
                        "hold": 16,
                        "slide": 5,
                        "touch": 17,
                        "break": 11,
                        "total": 209
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11474,
                    "releaseDate": "2022-10-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 320,
                        "hold": 23,
                        "slide": 9,
                        "touch": 39,
                        "break": 3,
                        "total": 394
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11474,
                    "releaseDate": "2022-10-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 350,
                        "hold": 49,
                        "slide": 51,
                        "touch": 31,
                        "break": 37,
                        "total": 518
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11474,
                    "releaseDate": "2022-10-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "たかなっぴー",
                    "noteCounts": {
                        "tap": 626,
                        "hold": 73,
                        "slide": 71,
                        "touch": 128,
                        "break": 33,
                        "total": 931
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11474,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2022-10-21"
                }
            ],
            "searchAcronyms": [
                "mg",
                "柚子",
                "磁星女孩",
                "磁铁女孩"
            ]
        },
        {
            "songId": "SUPER AMBULANCE",
            "category": "オンゲキ＆CHUNITHM",
            "title": "SUPER AMBULANCE",
            "artist": "AJURIKA",
            "bpm": 200,
            "imageName": "dc0d6733393a2701699b7ab61af373f361a12ed5e819d96385214dfc461685f9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 13,
                        "slide": 8,
                        "touch": 16,
                        "break": 2,
                        "total": 238
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11475,
                    "releaseDate": "2022-10-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 366,
                        "hold": 25,
                        "slide": 12,
                        "touch": 21,
                        "break": 9,
                        "total": 433
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11475,
                    "releaseDate": "2022-10-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 448,
                        "hold": 66,
                        "slide": 57,
                        "touch": 64,
                        "break": 13,
                        "total": 648
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11475,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "FESTiVAL": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2022-10-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "翠楼屋 vs あまくちジンジャー",
                    "noteCounts": {
                        "tap": 626,
                        "hold": 73,
                        "slide": 112,
                        "touch": 94,
                        "break": 125,
                        "total": 1030
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11475,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3
                    },
                    "releaseDate": "2022-10-21"
                }
            ],
            "searchAcronyms": [
                "🚑",
                "俺不能死",
                "千夏开大",
                "我创死你",
                "救护车",
                "日向千夏",
                "禁止单刷纪念日",
                "超级小千夏",
                "超级救护车",
                "超级梅西哥"
            ]
        },
        {
            "songId": "銀のめぐり",
            "category": "東方Project",
            "title": "銀のめぐり",
            "artist": "SYNC.ART'S feat. 3L",
            "bpm": 170,
            "imageName": "5c18bfa5428b0156669eb005ea3dfd972bb49a9077a905cec19ba76129199ecb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 115,
                        "hold": 10,
                        "slide": 6,
                        "touch": 8,
                        "break": 3,
                        "total": 142
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11495,
                    "releaseDate": "2022-10-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 16,
                        "slide": 16,
                        "touch": 26,
                        "break": 2,
                        "total": 316
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11495,
                    "releaseDate": "2022-10-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "うさぎランドリー",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 57,
                        "slide": 30,
                        "touch": 7,
                        "break": 37,
                        "total": 475
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11495,
                    "releaseDate": "2022-10-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 427,
                        "hold": 37,
                        "slide": 96,
                        "touch": 51,
                        "break": 42,
                        "total": 653
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11495,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2022-10-21"
                }
            ],
            "searchAcronyms": [
                "古明地觉",
                "银",
                "银的循环",
                "银的轮回"
            ]
        },
        {
            "songId": "Destiny Runner",
            "category": "東方Project",
            "title": "Destiny Runner",
            "artist": "さわわ",
            "bpm": 190,
            "imageName": "bb6b48bd8c4aa8a8dde402fb22f600a679069672e32573a638fc1cf51391dd3d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 2,
                        "slide": 7,
                        "touch": 24,
                        "break": 6,
                        "total": 223
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11496,
                    "releaseDate": "2022-10-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 23,
                        "slide": 8,
                        "touch": 26,
                        "break": 6,
                        "total": 400
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11496,
                    "releaseDate": "2022-10-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 548,
                        "hold": 51,
                        "slide": 17,
                        "touch": 25,
                        "break": 26,
                        "total": 667
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11496,
                    "releaseDate": "2022-10-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 762,
                        "hold": 61,
                        "slide": 74,
                        "touch": 36,
                        "break": 52,
                        "total": 985
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11496,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2022-10-21"
                }
            ],
            "searchAcronyms": [
                "dr",
                "命运奔跑者",
                "命运跑者",
                "蕾米莉亚"
            ]
        },
        {
            "songId": "モンダイナイトリッパー！",
            "category": "POPS＆アニメ",
            "title": "モンダイナイトリッパー！",
            "artist": "名取さな",
            "bpm": 180,
            "imageName": "f4c5752ebfafc8ef3f13946e400bfbbdeee488056584252a4e3150106e1b4a81",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 18,
                        "slide": 6,
                        "touch": 5,
                        "break": 6,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11498,
                    "releaseDate": "2022-11-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 18,
                        "slide": 9,
                        "touch": 19,
                        "break": 3,
                        "total": 334
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11498,
                    "releaseDate": "2022-11-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 408,
                        "hold": 66,
                        "slide": 15,
                        "touch": 15,
                        "break": 27,
                        "total": 531
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11498,
                    "releaseDate": "2022-11-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "アマリリスせんせえ with ぴちネコせんせえ",
                    "noteCounts": {
                        "tap": 536,
                        "hold": 54,
                        "slide": 72,
                        "touch": 121,
                        "break": 56,
                        "total": 839
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11498,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6
                    },
                    "releaseDate": "2022-11-04"
                }
            ],
            "searchAcronyms": [
                "Mondainai Tripper",
                "Tripper",
                "モンダイナイトリッパー",
                "名取纱那",
                "没问题",
                "没问题Tripper",
                "萌呆奶"
            ]
        },
        {
            "songId": "マーシャル・マキシマイザー",
            "category": "niconico＆ボーカロイド",
            "title": "マーシャル・マキシマイザー",
            "artist": "柊マグネタイト　feat.音楽的同位体　可不（KAFU）",
            "bpm": 190,
            "imageName": "f32ef7103af05ba58537b7253a9a2d4093b108ce60593bd56bd331aead4eb00a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 150,
                        "hold": 15,
                        "slide": 7,
                        "touch": 14,
                        "break": 4,
                        "total": 190
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11499,
                    "releaseDate": "2022-11-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 300,
                        "hold": 22,
                        "slide": 8,
                        "touch": 34,
                        "break": 4,
                        "total": 368
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11499,
                    "releaseDate": "2022-11-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 416,
                        "hold": 76,
                        "slide": 24,
                        "touch": 37,
                        "break": 28,
                        "total": 581
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11499,
                    "releaseDate": "2022-11-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 580,
                        "hold": 62,
                        "slide": 139,
                        "touch": 54,
                        "break": 32,
                        "total": 867
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11499,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2022-11-04"
                }
            ],
            "searchAcronyms": [
                "Marshall Maximizer",
                "maximizer",
                "mm",
                "最大化",
                "最大化者",
                "凯南开大化",
                "可不戴耳机",
                "马修麦泽",
                "马歇尔",
                "马歇尔最大化器"
            ]
        },
        {
            "songId": "秋の未確認生物",
            "category": "niconico＆ボーカロイド",
            "title": "秋の未確認生物",
            "artist": "子牛 feat.音街ウナ",
            "bpm": 185,
            "imageName": "763331b710e197518d9ec3211f8293de9858c48aea98f6d60ecadee8902ed450",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 170,
                        "hold": 15,
                        "slide": 8,
                        "touch": 4,
                        "break": 7,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11500,
                    "releaseDate": "2022-11-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 18,
                        "slide": 12,
                        "touch": 29,
                        "break": 30,
                        "total": 364
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11500,
                    "releaseDate": "2022-11-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 457,
                        "hold": 51,
                        "slide": 45,
                        "touch": 35,
                        "break": 21,
                        "total": 609
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11500,
                    "releaseDate": "2022-11-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 638,
                        "hold": 23,
                        "slide": 101,
                        "touch": 34,
                        "break": 103,
                        "total": 899
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11500,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2022-11-04"
                }
            ],
            "searchAcronyms": [
                "未确认生物",
                "生物",
                "秋的未确认生物"
            ]
        },
        {
            "songId": "Rising on the horizon",
            "category": "maimai",
            "title": "Rising on the horizon",
            "artist": "TAG",
            "bpm": 200,
            "imageName": "ce1aad3c87f1a9a7ff1c5f00c2bb9ec6ed1f2aa07aa503959bc1e8c6176ebbc5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 174,
                        "hold": 7,
                        "slide": 10,
                        "touch": 25,
                        "break": 15,
                        "total": 231
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11458,
                    "releaseDate": "2022-11-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 20,
                        "slide": 6,
                        "touch": 27,
                        "break": 16,
                        "total": 331
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11458,
                    "releaseDate": "2022-11-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 467,
                        "hold": 52,
                        "slide": 50,
                        "touch": 66,
                        "break": 21,
                        "total": 656
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11458,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2022-11-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 719,
                        "hold": 39,
                        "slide": 43,
                        "touch": 63,
                        "break": 82,
                        "total": 946
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11458,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.4,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4
                    },
                    "releaseDate": "2022-11-10"
                }
            ],
            "searchAcronyms": [
                "kop4th预选曲",
                "roth",
                "地平线",
                "玛丽萨默斯"
            ]
        },
        {
            "songId": "You Mean the World to Me",
            "category": "maimai",
            "title": "You Mean the World to Me",
            "artist": "Mameyudoufu feat. Shully",
            "bpm": 180,
            "imageName": "4f61b7b742ae2273b1ae03e53de727a33c92cfcded23e71f1e1afcfff3629da9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 117,
                        "hold": 12,
                        "slide": 6,
                        "touch": 21,
                        "break": 4,
                        "total": 160
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11459,
                    "releaseDate": "2022-11-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 268,
                        "hold": 24,
                        "slide": 14,
                        "touch": 26,
                        "break": 4,
                        "total": 336
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11459,
                    "releaseDate": "2022-11-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 69,
                        "slide": 57,
                        "touch": 69,
                        "break": 36,
                        "total": 523
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11459,
                    "releaseDate": "2022-11-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 491,
                        "hold": 64,
                        "slide": 61,
                        "touch": 58,
                        "break": 10,
                        "total": 684
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11459,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.7,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2022-11-18"
                }
            ],
            "searchAcronyms": [
                "你意味世界对我",
                "你是我的世嘉",
                "你是我的世界",
                "你是我的全世界",
                "凯尔希2",
                "我的世界"
            ]
        },
        {
            "songId": "Neon Kingdom",
            "category": "maimai",
            "title": "Neon Kingdom",
            "artist": "litmus*",
            "bpm": 130,
            "imageName": "fb4199b14b30a883ee322c7aaf665434948e5f029b9a9d01a4de4103996f5c9c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 11,
                        "slide": 4,
                        "touch": 14,
                        "break": 5,
                        "total": 180
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11460,
                    "releaseDate": "2022-11-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 11,
                        "slide": 12,
                        "touch": 26,
                        "break": 14,
                        "total": 317
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11460,
                    "releaseDate": "2022-11-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 326,
                        "hold": 83,
                        "slide": 54,
                        "touch": 23,
                        "break": 14,
                        "total": 500
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11460,
                    "releaseDate": "2022-11-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 468,
                        "hold": 146,
                        "slide": 41,
                        "touch": 19,
                        "break": 43,
                        "total": 717
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11460,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2022-11-18"
                }
            ],
            "searchAcronyms": [
                "nk",
                "炒菜",
                "霓虹国度",
                "霓虹城",
                "霓虹王国"
            ]
        },
        {
            "songId": "#狂った民族２ PRAVARGYAZOOQA",
            "category": "maimai",
            "title": "#狂った民族２ PRAVARGYAZOOQA",
            "artist": "DJ Raisei",
            "bpm": 170,
            "imageName": "49ca54d97c6ab8775a109ae0fe0a684fc9f562c3bdf1cfe2dbbbee16a45637ef",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 10,
                        "slide": 10,
                        "touch": 8,
                        "break": 44,
                        "total": 244
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11461,
                    "releaseDate": "2022-11-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 291,
                        "hold": 22,
                        "slide": 10,
                        "touch": 26,
                        "break": 6,
                        "total": 355
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11461,
                    "releaseDate": "2022-11-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 166,
                        "hold": 46,
                        "slide": 12,
                        "touch": 28,
                        "break": 250,
                        "total": 502
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11461,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2022-11-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 750,
                        "hold": 40,
                        "slide": 98,
                        "touch": 22,
                        "break": 53,
                        "total": 963
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11461,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL": 14.4,
                        "FESTiVAL PLUS": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4
                    },
                    "releaseDate": "2022-11-18"
                }
            ],
            "searchAcronyms": [
                "250个绝赞",
                "最炫民族风",
                "最狂民族风",
                "汉堡",
                "汉堡包",
                "狂什么民族",
                "狂民族",
                "狂民族2",
                "疯狂的民族2",
                "红谱250绝赞"
            ]
        },
        {
            "songId": "VSpook!",
            "category": "maimai",
            "title": "VSpook!",
            "artist": "s-don",
            "bpm": 155,
            "imageName": "935bacbf2bdb863b80bb9d09fe238ddcabca732d4c1f059edac5658c8eb1af45",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 10,
                        "slide": 5,
                        "touch": 8,
                        "break": 19,
                        "total": 256
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11462,
                    "releaseDate": "2022-11-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 18,
                        "slide": 3,
                        "touch": 19,
                        "break": 26,
                        "total": 402
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11462,
                    "releaseDate": "2022-11-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 530,
                        "hold": 118,
                        "slide": 83,
                        "touch": 62,
                        "break": 11,
                        "total": 804
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11462,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2022-11-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "Redarrow VS 翠楼屋",
                    "noteCounts": {
                        "tap": 730,
                        "hold": 47,
                        "slide": 120,
                        "touch": 42,
                        "break": 156,
                        "total": 1095
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11462,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.4,
                        "FESTiVAL PLUS": 14.4,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3
                    },
                    "releaseDate": "2022-11-18"
                }
            ],
            "searchAcronyms": [
                "🐖",
                "🐷",
                "debi",
                "VSpook",
                "vspork",
                "大战猪肉",
                "对决猪肉",
                "对战熟猪排",
                "对战猪肉",
                "打扑克",
                "猪",
                "猪肉",
                "脸书",
                "黑姬3"
            ]
        },
        {
            "songId": "VIIIbit Explorer",
            "category": "maimai",
            "title": "VIIIbit Explorer",
            "artist": "Lime",
            "bpm": 188,
            "imageName": "2b1920f465b6732e3b6bc08e709e032ca330f06dfb6d1642a931dde271954067",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 225,
                        "hold": 8,
                        "slide": 4,
                        "touch": 9,
                        "break": 9,
                        "total": 255
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11235,
                    "releaseDate": "2021-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 20,
                        "slide": 14,
                        "touch": 29,
                        "break": 10,
                        "total": 424
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11235,
                    "releaseDate": "2021-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 606,
                        "hold": 75,
                        "slide": 72,
                        "touch": 46,
                        "break": 26,
                        "total": 825
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11235,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13,
                        "Splash PLUS": 13,
                        "UNiVERSE": 13,
                        "UNiVERSE PLUS": 13
                    },
                    "releaseDate": "2021-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "-ZONE- SaFaRi",
                    "noteCounts": {
                        "tap": 738,
                        "hold": 28,
                        "slide": 75,
                        "touch": 70,
                        "break": 88,
                        "total": 999
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash PLUS",
                    "internalId": 11235,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "FESTiVAL": 14.7,
                        "FESTiVAL PLUS": 14.7,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7,
                        "Splash PLUS": 14.8,
                        "UNiVERSE": 14.8,
                        "UNiVERSE PLUS": 14.7
                    },
                    "releaseDate": "2021-07-21"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 195,
                        "hold": 16,
                        "slide": 4,
                        "touch": null,
                        "break": 12,
                        "total": 227
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 1235,
                    "releaseDate": "2021-07-21"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 332,
                        "hold": 12,
                        "slide": 11,
                        "touch": null,
                        "break": 28,
                        "total": 383
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 1235,
                    "releaseDate": "2021-07-21"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 472,
                        "hold": 67,
                        "slide": 72,
                        "touch": null,
                        "break": 45,
                        "total": 656
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 1235,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2021-07-21"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 831,
                        "hold": 59,
                        "slide": 122,
                        "touch": null,
                        "break": 99,
                        "total": 1111
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 1235,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5
                    },
                    "releaseDate": "2021-07-21"
                }
            ],
            "searchAcronyms": [
                "5*8-30/2+3bit",
                "8bit",
                "8bit explorer",
                "8bit浏览器",
                "8比特",
                "8比特浏览器",
                "byte",
                "dx八比特",
                "viiibit",
                "vlllbit explorer",
                "八位探索者",
                "八比特",
                "八比特浏览器",
                "八比特管理器",
                "大手子",
                "巴比特",
                "标8bit",
                "标准8bit",
                "标准八比特",
                "标准浏览器",
                "浏览器",
                "海葵姐"
            ]
        },
        {
            "songId": "Dive into the ZONe",
            "category": "POPS＆アニメ",
            "title": "Dive into the ZONe",
            "artist": "ぞん子",
            "bpm": 160,
            "imageName": "3e663a28a87b7603a9a59cde9b513b77ee491e4d8b0229138b5e4e52f735d08e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 115,
                        "hold": 19,
                        "slide": 4,
                        "touch": 7,
                        "break": 8,
                        "total": 153
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11501,
                    "releaseDate": "2022-12-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 281,
                        "hold": 13,
                        "slide": 6,
                        "touch": 29,
                        "break": 20,
                        "total": 349
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11501,
                    "releaseDate": "2022-12-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 367,
                        "hold": 39,
                        "slide": 18,
                        "touch": 14,
                        "break": 55,
                        "total": 493
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11501,
                    "releaseDate": "2022-12-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "小鳥遊さん",
                    "noteCounts": {
                        "tap": 542,
                        "hold": 54,
                        "slide": 88,
                        "touch": 17,
                        "break": 50,
                        "total": 751
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11501,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2022-12-02"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "エナドリおいしいソング",
            "category": "ゲーム＆バラエティ",
            "title": "エナドリおいしいソング",
            "artist": "冥堂院・アレクサンドル・ヴィクトリア・リヒテンシュタイン・聖斗 feat.TINOP",
            "bpm": 140,
            "imageName": "3319046005c6aa1d1073bd714d19a8f341716ba6b4f63aa4c05faa8f6d294abc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 15,
                        "slide": 4,
                        "touch": 12,
                        "break": 7,
                        "total": 175
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11502,
                    "releaseDate": "2022-12-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 19,
                        "slide": 6,
                        "touch": 30,
                        "break": 8,
                        "total": 343
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11502,
                    "releaseDate": "2022-12-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 372,
                        "hold": 60,
                        "slide": 33,
                        "touch": 5,
                        "break": 39,
                        "total": 509
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11502,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2022-12-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 510,
                        "hold": 23,
                        "slide": 90,
                        "touch": 8,
                        "break": 46,
                        "total": 677
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11502,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 14,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2022-12-02"
                }
            ],
            "searchAcronyms": [
                "drink with me",
                "斐济杯",
                "易拉罐",
                "能量饮料",
                "能量饮料歌",
                "能量饮料真好喝"
            ]
        },
        {
            "songId": "RIFFRAIN",
            "category": "maimai",
            "title": "RIFFRAIN",
            "artist": "夏代孝明",
            "bpm": 122,
            "imageName": "2fc5627ae40e5ca3b9475b4d97777fd5fe02e25c58dbf4ac6c756fe34a5b7aa4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 108,
                        "hold": 13,
                        "slide": 4,
                        "touch": 15,
                        "break": 3,
                        "total": 143
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11463,
                    "releaseDate": "2022-12-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 10,
                        "slide": 10,
                        "touch": 14,
                        "break": 8,
                        "total": 298
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11463,
                    "releaseDate": "2022-12-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "畳返し",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 45,
                        "slide": 8,
                        "touch": 21,
                        "break": 14,
                        "total": 383
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11463,
                    "releaseDate": "2022-12-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 385,
                        "hold": 36,
                        "slide": 89,
                        "touch": 80,
                        "break": 21,
                        "total": 611
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11463,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2022-12-16"
                }
            ],
            "searchAcronyms": [
                "达令达令"
            ]
        },
        {
            "songId": "Falling",
            "category": "maimai",
            "title": "Falling",
            "artist": "シノ feat.しほ",
            "bpm": 122,
            "imageName": "bbd18b96d22cb867e8232baed6313663f8c1b9c40429d6ab9885d7ced8ea9d7b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 136,
                        "hold": 14,
                        "slide": 4,
                        "touch": 6,
                        "break": 3,
                        "total": 163
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11464,
                    "releaseDate": "2022-12-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 11,
                        "slide": 6,
                        "touch": 26,
                        "break": 5,
                        "total": 304
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11464,
                    "releaseDate": "2022-12-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 366,
                        "hold": 27,
                        "slide": 34,
                        "touch": 17,
                        "break": 9,
                        "total": 453
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11464,
                    "releaseDate": "2022-12-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 436,
                        "hold": 38,
                        "slide": 98,
                        "touch": 29,
                        "break": 33,
                        "total": 634
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11464,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2022-12-16"
                }
            ],
            "searchAcronyms": [
                "跳楼"
            ]
        },
        {
            "songId": "ピリオドサイン",
            "category": "maimai",
            "title": "ピリオドサイン",
            "artist": "Ponchi♪ feat.はぁち",
            "bpm": 195,
            "imageName": "6fd7823cf154d68dd2c9e64f4c8b4a2826343785ad8f450c4ad3ae1412db3447",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 15,
                        "slide": 4,
                        "touch": 25,
                        "break": 1,
                        "total": 154
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11465,
                    "releaseDate": "2022-12-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 252,
                        "hold": 29,
                        "slide": 20,
                        "touch": 22,
                        "break": 14,
                        "total": 337
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11465,
                    "releaseDate": "2022-12-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 355,
                        "hold": 59,
                        "slide": 41,
                        "touch": 24,
                        "break": 21,
                        "total": 500
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11465,
                    "releaseDate": "2022-12-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 546,
                        "hold": 52,
                        "slide": 70,
                        "touch": 25,
                        "break": 31,
                        "total": 724
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11465,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.6,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2022-12-16"
                }
            ],
            "searchAcronyms": [
                "period sign",
                "ps",
                "休止符",
                "周期符号",
                "终点2"
            ]
        },
        {
            "songId": "群青シグナル",
            "category": "maimai",
            "title": "群青シグナル",
            "artist": "テヅカ feat. 獅子神レオナ",
            "bpm": 206,
            "imageName": "34b8ab0063d93d42004348113e0a9e0f1298050bcf3bf3d649c791221401068d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 21,
                        "slide": 9,
                        "touch": 14,
                        "break": 4,
                        "total": 236
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11466,
                    "releaseDate": "2022-12-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 369,
                        "hold": 18,
                        "slide": 10,
                        "touch": 26,
                        "break": 20,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11466,
                    "releaseDate": "2022-12-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 491,
                        "hold": 70,
                        "slide": 48,
                        "touch": 4,
                        "break": 39,
                        "total": 652
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11466,
                    "releaseDate": "2022-12-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "ものくろっく",
                    "noteCounts": {
                        "tap": 719,
                        "hold": 62,
                        "slide": 114,
                        "touch": 51,
                        "break": 32,
                        "total": 978
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11466,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2022-12-16"
                }
            ],
            "searchAcronyms": [
                "gunjo signal",
                "gunjou signal",
                "ultramarine signal",
                "体育生2",
                "群青",
                "群青2",
                "群青信号",
                "群青讯号"
            ]
        },
        {
            "songId": "Baddest",
            "category": "POPS＆アニメ",
            "title": "Baddest",
            "artist": "樋口楓",
            "bpm": 215,
            "imageName": "6a2fbebe00d3e80a5f58d842dee924e0d26222e774fc8c9bdec2e4a8b01de9ec",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 13,
                        "slide": 6,
                        "touch": 19,
                        "break": 4,
                        "total": 239
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11503,
                    "releaseDate": "2022-12-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 24,
                        "slide": 12,
                        "touch": 16,
                        "break": 10,
                        "total": 357
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11503,
                    "releaseDate": "2022-12-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 65,
                        "slide": 39,
                        "touch": 60,
                        "break": 63,
                        "total": 583
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11503,
                    "releaseDate": "2022-12-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 738,
                        "hold": 57,
                        "slide": 134,
                        "touch": 35,
                        "break": 66,
                        "total": 1030
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11503,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2022-12-23"
                }
            ],
            "searchAcronyms": [
                "最坏",
                "十六圈",
                "十六块钱",
                "带恶人",
                "德龙",
                "德龙鬼叫",
                "樋口枫",
                "樋口枫大旋风",
                "樋口枫的大逼圈",
                "疯狗转圈"
            ]
        },
        {
            "songId": "ばかみたい【Taxi Driver Edition】",
            "category": "ゲーム＆バラエティ",
            "title": "ばかみたい【Taxi Driver Edition】",
            "artist": "桐生一馬(黒田崇矢)",
            "bpm": 74,
            "imageName": "11133e6e289c4e8fdfb70ed98d38b03e6f639518aad4edc9a4485ba030c52773",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 64,
                        "hold": 9,
                        "slide": 4,
                        "touch": 6,
                        "break": 4,
                        "total": 87
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11504,
                    "releaseDate": "2022-12-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 173,
                        "hold": 17,
                        "slide": 9,
                        "touch": 8,
                        "break": 6,
                        "total": 213
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11504,
                    "releaseDate": "2022-12-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 153,
                        "hold": 28,
                        "slide": 14,
                        "touch": 13,
                        "break": 7,
                        "total": 215
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11504,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "FESTiVAL": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2022-12-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Redarrow",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 33,
                        "slide": 37,
                        "touch": 1,
                        "break": 35,
                        "total": 278
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11504,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2022-12-23"
                }
            ],
            "searchAcronyms": [
                "🐶",
                "🥃",
                "baka mitai",
                "bakamitai",
                "damedane",
                "oceancat",
                "一个touch",
                "像个傻瓜",
                "像笨蛋一样",
                "八嘎米袋",
                "出租车驾驶者",
                "别急20",
                "如龙5",
                "如龙的雨",
                "我",
                "打mai打mai",
                "打咩打捏",
                "打没打mai",
                "打没打捏",
                "海猫",
                "海猫络合物",
                "玛恩纳",
                "笨蛋",
                "铃木太一"
            ]
        },
        {
            "songId": "れっつ！みらくる☆はーどこあっ！",
            "category": "ゲーム＆バラエティ",
            "title": "れっつ！みらくる☆はーどこあっ！",
            "artist": "Laur feat.みしゃも",
            "bpm": 185,
            "imageName": "5e312ee8cac19b1df69fbe1e6cdebabb4f3b9446a891fd61f229aef9db3acbf9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 161,
                        "hold": 21,
                        "slide": 9,
                        "touch": 19,
                        "break": 11,
                        "total": 221
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11505,
                    "releaseDate": "2022-12-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 45,
                        "slide": 5,
                        "touch": 28,
                        "break": 21,
                        "total": 421
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11505,
                    "releaseDate": "2022-12-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 347,
                        "hold": 68,
                        "slide": 45,
                        "touch": 46,
                        "break": 119,
                        "total": 625
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11505,
                    "releaseDate": "2022-12-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 613,
                        "hold": 92,
                        "slide": 126,
                        "touch": 152,
                        "break": 110,
                        "total": 1093
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11505,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2022-12-23"
                }
            ],
            "searchAcronyms": [
                "hardcore2",
                "laur撒狗粮",
                "let's miracle☆hardcore",
                "wifecore",
                "老二和他的老婆",
                "雌小鬼"
            ]
        },
        {
            "songId": "Blank Paper (Prod. TEMPLIME)",
            "category": "POPS＆アニメ",
            "title": "Blank Paper (Prod. TEMPLIME)",
            "artist": "日高零奈・東雲和音・茅野ふたば「電音部」",
            "bpm": 133,
            "imageName": "569981f14403eb5fc3c14bd29c30bc90b9c615ae6642eab6d1e6a33636406a22",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 87,
                        "hold": 10,
                        "slide": 8,
                        "touch": 8,
                        "break": 3,
                        "total": 116
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11506,
                    "releaseDate": "2023-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 220,
                        "hold": 12,
                        "slide": 10,
                        "touch": 25,
                        "break": 2,
                        "total": 269
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11506,
                    "releaseDate": "2023-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 58,
                        "slide": 30,
                        "touch": 17,
                        "break": 18,
                        "total": 385
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11506,
                    "releaseDate": "2023-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 630,
                        "hold": 33,
                        "slide": 98,
                        "touch": 4,
                        "break": 36,
                        "total": 801
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11506,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2023-01-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "In my world (Prod. KOTONOHOUSE)",
            "category": "POPS＆アニメ",
            "title": "In my world (Prod. KOTONOHOUSE)",
            "artist": "鳳凰火凛・瀬戸海月・大賀ルキア「電音部」",
            "bpm": 160,
            "imageName": "b8af86e15d35b99d9efee5023c239c67cc0d4587bfe7398f882d3fabf90c8019",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 99,
                        "hold": 11,
                        "slide": 4,
                        "touch": 19,
                        "break": 2,
                        "total": 135
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11507,
                    "releaseDate": "2023-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 235,
                        "hold": 20,
                        "slide": 18,
                        "touch": 28,
                        "break": 5,
                        "total": 306
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11507,
                    "releaseDate": "2023-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 310,
                        "hold": 52,
                        "slide": 38,
                        "touch": 5,
                        "break": 24,
                        "total": 429
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11507,
                    "releaseDate": "2023-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 530,
                        "hold": 37,
                        "slide": 110,
                        "touch": 52,
                        "break": 14,
                        "total": 743
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11507,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2023-01-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "アイム・マイヒーロー",
            "category": "ゲーム＆バラエティ",
            "title": "アイム・マイヒーロー",
            "artist": "Ino(chronoize) feat. 柳瀬マサキ",
            "bpm": 138,
            "imageName": "beda7d4fc78465873ff13fd2660a9f32ac7f65888f10cb1a7f4bb7a2ef41a644",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 85,
                        "hold": 8,
                        "slide": 3,
                        "touch": 18,
                        "break": 5,
                        "total": 119
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11508,
                    "releaseDate": "2023-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 15,
                        "slide": 8,
                        "touch": 28,
                        "break": 2,
                        "total": 284
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11508,
                    "releaseDate": "2023-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 39,
                        "slide": 34,
                        "touch": 14,
                        "break": 20,
                        "total": 374
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11508,
                    "releaseDate": "2023-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 631,
                        "hold": 28,
                        "slide": 58,
                        "touch": 43,
                        "break": 15,
                        "total": 775
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11508,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2023-01-06"
                }
            ],
            "searchAcronyms": [
                "I am my hero",
                "我是自己的英雄",
                "马云"
            ]
        },
        {
            "songId": "NightTheater",
            "category": "ゲーム＆バラエティ",
            "title": "NightTheater",
            "artist": "わかどり",
            "bpm": 151,
            "imageName": "d03dc84ccfc6e4b6d7e94e4726c983b7f7c566f4a2e65785f2406593999e7a91",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 108,
                        "hold": 10,
                        "slide": 4,
                        "touch": 8,
                        "break": 8,
                        "total": 138
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11509,
                    "releaseDate": "2023-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 26,
                        "slide": 8,
                        "touch": 12,
                        "break": 14,
                        "total": 342
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11509,
                    "releaseDate": "2023-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 41,
                        "slide": 42,
                        "touch": 11,
                        "break": 45,
                        "total": 541
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11509,
                    "releaseDate": "2023-01-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "はぴネコ(はっぴー&ぴちネコ)",
                    "noteCounts": {
                        "tap": 570,
                        "hold": 43,
                        "slide": 54,
                        "touch": 95,
                        "break": 61,
                        "total": 823
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11509,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2023-01-06"
                }
            ],
            "searchAcronyms": [
                "Night Theater",
                "nt",
                "夜剧场",
                "夜剧院"
            ]
        },
        {
            "songId": "Ghost Dance",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Ghost Dance",
            "artist": "亜沙 feat.くろくも",
            "bpm": 154,
            "imageName": "79cfbb351c52f0502b3e173778b90d726f5f94477312cfca13d59293c79ec071",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 134,
                        "hold": 12,
                        "slide": 6,
                        "touch": 10,
                        "break": 4,
                        "total": 166
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11477,
                    "releaseDate": "2023-01-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 308,
                        "hold": 11,
                        "slide": 6,
                        "touch": 29,
                        "break": 32,
                        "total": 386
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11477,
                    "releaseDate": "2023-01-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 347,
                        "hold": 55,
                        "slide": 74,
                        "touch": 26,
                        "break": 20,
                        "total": 522
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11477,
                    "releaseDate": "2023-01-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 662,
                        "hold": 71,
                        "slide": 80,
                        "touch": 18,
                        "break": 28,
                        "total": 859
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11477,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2023-01-20"
                }
            ],
            "searchAcronyms": [
                "gd",
                "幽灵跳舞",
                "贵物",
                "鬼舞",
                "魂5"
            ]
        },
        {
            "songId": "電光石火",
            "category": "オンゲキ＆CHUNITHM",
            "title": "電光石火",
            "artist": "HiTECH NINJA",
            "bpm": 165,
            "imageName": "232416388033cec9f28cdd9cc4f94965593dcf809f54241555edf5e5a8859a23",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 160,
                        "hold": 12,
                        "slide": 6,
                        "touch": 9,
                        "break": 8,
                        "total": 195
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11478,
                    "releaseDate": "2023-01-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 350,
                        "hold": 27,
                        "slide": 4,
                        "touch": 26,
                        "break": 17,
                        "total": 424
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11478,
                    "releaseDate": "2023-01-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 540,
                        "hold": 54,
                        "slide": 44,
                        "touch": 29,
                        "break": 24,
                        "total": 691
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11478,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-01-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "あまくちヘルツ",
                    "noteCounts": {
                        "tap": 809,
                        "hold": 72,
                        "slide": 99,
                        "touch": 17,
                        "break": 50,
                        "total": 1047
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11478,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.4,
                        "FESTiVAL PLUS": 14.4,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3
                    },
                    "releaseDate": "2023-01-20"
                }
            ],
            "searchAcronyms": [
                "🤨",
                "Denko Sekka",
                "Quick Attack",
                "俄洛伊",
                "大电老师",
                "妖艳魔男2",
                "电光火石",
                "电光石火",
                "穿着很少布的大只佬"
            ]
        },
        {
            "songId": "Hainuwele",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Hainuwele",
            "artist": "ETIA.",
            "bpm": 175,
            "imageName": "0e482d3fe98d45755363a909270688f5e2ebd96ae780fd2861531958fb42d6ed",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 201,
                        "hold": 13,
                        "slide": 4,
                        "touch": 6,
                        "break": 15,
                        "total": 239
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11479,
                    "releaseDate": "2023-01-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 348,
                        "hold": 28,
                        "slide": 12,
                        "touch": 26,
                        "break": 8,
                        "total": 422
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11479,
                    "releaseDate": "2023-01-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 501,
                        "hold": 82,
                        "slide": 42,
                        "touch": 32,
                        "break": 17,
                        "total": 674
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11479,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2023-01-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "サファ太 vs 翠楼屋",
                    "noteCounts": {
                        "tap": 809,
                        "hold": 58,
                        "slide": 70,
                        "touch": 16,
                        "break": 77,
                        "total": 1030
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11479,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.4,
                        "FESTiVAL PLUS": 14.4,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3
                    },
                    "releaseDate": "2023-01-20"
                }
            ],
            "searchAcronyms": [
                "华为",
                "华为完了",
                "孩奴",
                "海奴韦莱",
                "海牛",
                "海牛喂了"
            ]
        },
        {
            "songId": "ピュグマリオンの咒文",
            "category": "オンゲキ＆CHUNITHM",
            "title": "ピュグマリオンの咒文",
            "artist": "アリスシャッハと魔法の楽団",
            "bpm": 190,
            "imageName": "41e8f8de8a058b339d4bd2b30c6eacb74a01148a9ec2ca31f8c35dbe3fb0c7dd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 148,
                        "hold": 13,
                        "slide": 4,
                        "touch": 7,
                        "break": 7,
                        "total": 179
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11525,
                    "releaseDate": "2023-01-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 45,
                        "slide": 8,
                        "touch": 24,
                        "break": 8,
                        "total": 308
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11525,
                    "releaseDate": "2023-01-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 329,
                        "hold": 82,
                        "slide": 15,
                        "touch": 38,
                        "break": 55,
                        "total": 519
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11525,
                    "releaseDate": "2023-01-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はぴネコ(はっぴー&ぴちネコ)",
                    "noteCounts": {
                        "tap": 430,
                        "hold": 90,
                        "slide": 105,
                        "touch": 143,
                        "break": 76,
                        "total": 844
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11525,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-01-20"
                }
            ],
            "searchAcronyms": [
                "Hex of Pygmalion",
                "pygmalion",
                "Pygmalion's Spell",
                "咒文",
                "小魔女咒文",
                "皮格马利翁的咒文",
                "皱纹"
            ]
        },
        {
            "songId": "Beat Opera op.1",
            "category": "maimai",
            "title": "Beat Opera op.1",
            "artist": "bermei.inazawa",
            "bpm": 145,
            "imageName": "81405753b85e6f51166098fe7392d833e4f6b31e7e4471ad204be46961b82972",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 123,
                        "hold": 11,
                        "slide": 5,
                        "touch": 10,
                        "break": 7,
                        "total": 156
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11467,
                    "releaseDate": "2023-02-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 228,
                        "hold": 30,
                        "slide": 10,
                        "touch": 32,
                        "break": 3,
                        "total": 303
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11467,
                    "releaseDate": "2023-02-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 309,
                        "hold": 97,
                        "slide": 53,
                        "touch": 35,
                        "break": 6,
                        "total": 500
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11467,
                    "releaseDate": "2023-02-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 535,
                        "hold": 87,
                        "slide": 75,
                        "touch": 47,
                        "break": 19,
                        "total": 763
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11467,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL": 13.9,
                        "FESTiVAL PLUS": 13.9,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14
                    },
                    "releaseDate": "2023-02-03"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "星見草",
            "category": "maimai",
            "title": "星見草",
            "artist": "秋田 真典",
            "bpm": 164,
            "imageName": "d4477d93521cf3682c5142319d1019149b6a06d5d8993bf7ae01b564de278d77",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 134,
                        "hold": 13,
                        "slide": 9,
                        "touch": 25,
                        "break": 7,
                        "total": 188
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11468,
                    "releaseDate": "2023-02-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 31,
                        "slide": 6,
                        "touch": 30,
                        "break": 6,
                        "total": 350
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11468,
                    "releaseDate": "2023-02-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 385,
                        "hold": 45,
                        "slide": 40,
                        "touch": 22,
                        "break": 28,
                        "total": 520
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11468,
                    "releaseDate": "2023-02-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Redarrow",
                    "noteCounts": {
                        "tap": 638,
                        "hold": 43,
                        "slide": 104,
                        "touch": 0,
                        "break": 32,
                        "total": 817
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11468,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-02-03"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "\"411Ψ892\"",
            "category": "maimai",
            "title": "\"411Ψ892\"",
            "artist": "Tanchiky",
            "bpm": 184,
            "imageName": "890070403457183caf1a5ef11fe54142ee7a6760507c23241445099eb9672fc7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 179,
                        "hold": 15,
                        "slide": 4,
                        "touch": 21,
                        "break": 8,
                        "total": 227
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11469,
                    "releaseDate": "2023-02-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 298,
                        "hold": 31,
                        "slide": 12,
                        "touch": 31,
                        "break": 10,
                        "total": 382
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11469,
                    "releaseDate": "2023-02-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 416,
                        "hold": 53,
                        "slide": 52,
                        "touch": 25,
                        "break": 85,
                        "total": 631
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11469,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2023-02-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "サファ太 vs じゃこレモン",
                    "noteCounts": {
                        "tap": 664,
                        "hold": 53,
                        "slide": 86,
                        "touch": 39,
                        "break": 103,
                        "total": 945
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11469,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL": 14.4,
                        "FESTiVAL PLUS": 14.4,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3
                    },
                    "releaseDate": "2023-02-03"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "康莊大道",
            "category": "maimai",
            "title": "康莊大道",
            "artist": "Spiegel vs Yukino",
            "bpm": 208,
            "imageName": "6c771f150d74292148ccc4487dba1036d6343fa86748f347e0b7931eda1fb660",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 9,
                        "slide": 9,
                        "touch": 17,
                        "break": 4,
                        "total": 262
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11470,
                    "releaseDate": "2023-02-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 20,
                        "slide": 30,
                        "touch": 17,
                        "break": 4,
                        "total": 409
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11470,
                    "releaseDate": "2023-02-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 509,
                        "hold": 78,
                        "slide": 51,
                        "touch": 55,
                        "break": 42,
                        "total": 735
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11470,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2023-02-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "ボコ太",
                    "noteCounts": {
                        "tap": 782,
                        "hold": 46,
                        "slide": 47,
                        "touch": 140,
                        "break": 114,
                        "total": 1129
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11470,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "FESTiVAL": 14.7,
                        "FESTiVAL PLUS": 14.7,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7
                    },
                    "releaseDate": "2023-02-03"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "キュートなカノジョ",
            "category": "niconico＆ボーカロイド",
            "title": "キュートなカノジョ",
            "artist": "syudou　feat.音楽的同位体　可不（KAFU）",
            "bpm": 160,
            "imageName": "c66809f5326e3fe6171975130e178c8a47bf81da42fb42b4e14f19beb7214a23",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 107,
                        "hold": 13,
                        "slide": 6,
                        "touch": 17,
                        "break": 5,
                        "total": 148
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11510,
                    "releaseDate": "2023-02-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 21,
                        "slide": 10,
                        "touch": 25,
                        "break": 11,
                        "total": 279
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11510,
                    "releaseDate": "2023-02-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.8,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 341,
                        "hold": 34,
                        "slide": 27,
                        "touch": 26,
                        "break": 18,
                        "total": 446
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11510,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 9.8
                    },
                    "releaseDate": "2023-02-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 468,
                        "hold": 47,
                        "slide": 106,
                        "touch": 11,
                        "break": 48,
                        "total": 680
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11510,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-02-17"
                }
            ],
            "searchAcronyms": [
                "Cute na Kanojo"
            ]
        },
        {
            "songId": "へべれけジャンキー",
            "category": "niconico＆ボーカロイド",
            "title": "へべれけジャンキー",
            "artist": "syudou",
            "bpm": 104,
            "imageName": "844403325530ba4b8c60cb84e83d49befd6dbd6128736cb580185b673f98eb1c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 107,
                        "hold": 5,
                        "slide": 4,
                        "touch": 6,
                        "break": 10,
                        "total": 132
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11511,
                    "releaseDate": "2023-02-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 15,
                        "slide": 4,
                        "touch": 15,
                        "break": 22,
                        "total": 268
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11511,
                    "releaseDate": "2023-02-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.7,
                    "noteDesigner": "畳返し",
                    "noteCounts": {
                        "tap": 310,
                        "hold": 50,
                        "slide": 12,
                        "touch": 33,
                        "break": 16,
                        "total": 421
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11511,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 9.7
                    },
                    "releaseDate": "2023-02-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 515,
                        "hold": 64,
                        "slide": 45,
                        "touch": 71,
                        "break": 40,
                        "total": 735
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11511,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2023-02-17"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "きゅうくらりん",
            "category": "niconico＆ボーカロイド",
            "title": "きゅうくらりん",
            "artist": "いよわ",
            "bpm": 220,
            "imageName": "b89bb0c6b2e597c18de48278dad7a1dfe64eb48093ff5f3898a474eaa5a8adba",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 147,
                        "hold": 15,
                        "slide": 2,
                        "touch": 14,
                        "break": 7,
                        "total": 185
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11512,
                    "releaseDate": "2023-02-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 245,
                        "hold": 38,
                        "slide": 8,
                        "touch": 29,
                        "break": 4,
                        "total": 324
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11512,
                    "releaseDate": "2023-02-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 445,
                        "hold": 101,
                        "slide": 27,
                        "touch": 7,
                        "break": 50,
                        "total": 630
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11512,
                    "releaseDate": "2023-02-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 484,
                        "hold": 196,
                        "slide": 114,
                        "touch": 17,
                        "break": 48,
                        "total": 859
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11512,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-02-17"
                }
            ],
            "searchAcronyms": [
                "Kyuukurarin"
            ]
        },
        {
            "songId": "回る空うさぎ",
            "category": "niconico＆ボーカロイド",
            "title": "回る空うさぎ",
            "artist": "Orangestar",
            "bpm": 120,
            "imageName": "aebb1dc58101071287947c220d5db922f72d8d0f9659ffe72be0f32c8f44c0fa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 9,
                        "slide": 2,
                        "touch": 13,
                        "break": 2,
                        "total": 129
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11513,
                    "releaseDate": "2023-02-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 14,
                        "slide": 16,
                        "touch": 14,
                        "break": 7,
                        "total": 256
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11513,
                    "releaseDate": "2023-02-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 217,
                        "hold": 35,
                        "slide": 25,
                        "touch": 11,
                        "break": 10,
                        "total": 298
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11513,
                    "multiverInternalLevelValue": {
                        "FESTiVAL": 8.2
                    },
                    "releaseDate": "2023-02-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 415,
                        "hold": 27,
                        "slide": 47,
                        "touch": 9,
                        "break": 28,
                        "total": 526
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11513,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "FESTiVAL": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2023-02-17"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Lost Desire",
            "category": "ゲーム＆バラエティ",
            "title": "Lost Desire",
            "artist": "Powerless feat. Sennzai",
            "bpm": 170,
            "imageName": "8ec2bc12d85fd16b502c068352919709a0b2fc6a47a822010ea245b888a655f6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 140,
                        "hold": 15,
                        "slide": 11,
                        "touch": 21,
                        "break": 4,
                        "total": 191
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11514,
                    "releaseDate": "2023-03-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 21,
                        "slide": 22,
                        "touch": 22,
                        "break": 26,
                        "total": 384
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11514,
                    "releaseDate": "2023-03-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 372,
                        "hold": 69,
                        "slide": 49,
                        "touch": 7,
                        "break": 77,
                        "total": 574
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11514,
                    "releaseDate": "2023-03-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 648,
                        "hold": 75,
                        "slide": 93,
                        "touch": 8,
                        "break": 102,
                        "total": 926
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11514,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-03-02"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Aegleseeker",
            "category": "ゲーム＆バラエティ",
            "title": "Aegleseeker",
            "artist": "Silentroom vs Frums",
            "bpm": 234,
            "imageName": "0fee1f54c5613514d93e215e37a737be3fffb1e47fd04bbd4ca562595eddc4e3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 19,
                        "slide": 4,
                        "touch": 31,
                        "break": 7,
                        "total": 245
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11516,
                    "releaseDate": "2023-03-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 312,
                        "hold": 17,
                        "slide": 18,
                        "touch": 23,
                        "break": 20,
                        "total": 390
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11516,
                    "releaseDate": "2023-03-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 480,
                        "hold": 88,
                        "slide": 41,
                        "touch": 35,
                        "break": 21,
                        "total": 665
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11516,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-03-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "サファ太 vs 翠楼屋",
                    "noteCounts": {
                        "tap": 754,
                        "hold": 87,
                        "slide": 49,
                        "touch": 114,
                        "break": 80,
                        "total": 1084
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11516,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.5,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5
                    },
                    "releaseDate": "2023-03-02"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "最強STRONGER",
            "category": "ゲーム＆バラエティ",
            "title": "最強STRONGER",
            "artist": "REDALiCE vs USAO",
            "bpm": 205,
            "imageName": "e346593c2015e71c3bc9ed03946c0cae997d16903f5cec626903344f931fd5aa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 201,
                        "hold": 24,
                        "slide": 8,
                        "touch": 18,
                        "break": 27,
                        "total": 278
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11517,
                    "releaseDate": "2023-03-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 30,
                        "slide": 13,
                        "touch": 26,
                        "break": 20,
                        "total": 426
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11517,
                    "releaseDate": "2023-03-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 540,
                        "hold": 120,
                        "slide": 71,
                        "touch": 28,
                        "break": 30,
                        "total": 789
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11517,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-03-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "チャン@DP皆伝 vs シチミヘルツ",
                    "noteCounts": {
                        "tap": 725,
                        "hold": 66,
                        "slide": 152,
                        "touch": 46,
                        "break": 80,
                        "total": 1069
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11517,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.6,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "FESTiVAL": 14.6,
                        "FESTiVAL PLUS": 14.6,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5
                    },
                    "releaseDate": "2023-03-02"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ViRTUS",
            "category": "maimai",
            "title": "ViRTUS",
            "artist": "Hiro",
            "bpm": 225,
            "imageName": "5737b4ed2d71b1060410769bb4894d7397c25820bcbb6f6fb6ef795e63e99381",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 10,
                        "slide": 12,
                        "touch": 14,
                        "break": 5,
                        "total": 270
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11523,
                    "releaseDate": "2023-03-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 347,
                        "hold": 24,
                        "slide": 15,
                        "touch": 24,
                        "break": 16,
                        "total": 426
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11523,
                    "releaseDate": "2023-03-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 487,
                        "hold": 89,
                        "slide": 38,
                        "touch": 63,
                        "break": 36,
                        "total": 713
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11523,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2023-03-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "jacK on Phoenix & -ZONE- SaFaRi",
                    "noteCounts": {
                        "tap": 774,
                        "hold": 39,
                        "slide": 136,
                        "touch": 49,
                        "break": 65,
                        "total": 1063
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11523,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.6,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL": 14.7,
                        "FESTiVAL PLUS": 14.7,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6
                    },
                    "releaseDate": "2023-03-02"
                }
            ],
            "searchAcronyms": [
                "kop4",
                "op",
                "yoskip",
                "噔噔噔噔噔噔",
                "抽水马桶2",
                "本草纲目",
                "水神2",
                "水神二",
                "辣妹子",
                "辣妹子辣"
            ]
        },
        {
            "songId": "Alice's Suitcase",
            "category": "ゲーム＆バラエティ",
            "title": "Alice's Suitcase",
            "artist": "Endorfin.",
            "bpm": 190,
            "imageName": "116e4a0f6e4a3578cc0b794cd65c762c3f7c24e77a7b1fd160d8e610ddc06513",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 19,
                        "slide": 6,
                        "touch": 20,
                        "break": 4,
                        "total": 174
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11524,
                    "releaseDate": "2023-03-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 47,
                        "slide": 14,
                        "touch": 24,
                        "break": 18,
                        "total": 350
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11524,
                    "releaseDate": "2023-03-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "PG-NAKAGAWA",
                    "noteCounts": {
                        "tap": 331,
                        "hold": 78,
                        "slide": 38,
                        "touch": 12,
                        "break": 18,
                        "total": 477
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11524,
                    "releaseDate": "2023-03-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack vs あまくちジンジャー",
                    "noteCounts": {
                        "tap": 516,
                        "hold": 67,
                        "slide": 97,
                        "touch": 79,
                        "break": 27,
                        "total": 786
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11524,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-03-02"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ボッカデラベリタ",
            "category": "niconico＆ボーカロイド",
            "title": "ボッカデラベリタ",
            "artist": "柊キライ",
            "bpm": 170,
            "imageName": "f3130dc5fb156ba44c58abbc2f5838ce060816159fcd39aee2f022c562285c75",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 134,
                        "hold": 14,
                        "slide": 6,
                        "touch": 8,
                        "break": 5,
                        "total": 167
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11518,
                    "releaseDate": "2023-03-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 24,
                        "slide": 12,
                        "touch": 23,
                        "break": 13,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11518,
                    "releaseDate": "2023-03-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 354,
                        "hold": 62,
                        "slide": 35,
                        "touch": 19,
                        "break": 69,
                        "total": 539
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11518,
                    "releaseDate": "2023-03-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Redarrow",
                    "noteCounts": {
                        "tap": 597,
                        "hold": 61,
                        "slide": 93,
                        "touch": 16,
                        "break": 29,
                        "total": 796
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11518,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.1,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.1,
                        "FESTiVAL PLUS": 13.1,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2023-03-10"
                }
            ],
            "searchAcronyms": [
                "Bocca Della Verita"
            ]
        },
        {
            "songId": "『んっあっあっ。』",
            "category": "niconico＆ボーカロイド",
            "title": "『んっあっあっ。』",
            "artist": "SLAVE.V-V-R",
            "bpm": 123,
            "imageName": "b105a15b545d1e7b9421f1a9136bd0322a643e42704ba2d2a34bff46ac5e5711",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 11,
                        "slide": 4,
                        "touch": 6,
                        "break": 10,
                        "total": 159
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11519,
                    "releaseDate": "2023-03-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 26,
                        "slide": 10,
                        "touch": 28,
                        "break": 19,
                        "total": 279
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11519,
                    "releaseDate": "2023-03-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 307,
                        "hold": 121,
                        "slide": 17,
                        "touch": 11,
                        "break": 28,
                        "total": 484
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11519,
                    "releaseDate": "2023-03-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 436,
                        "hold": 64,
                        "slide": 82,
                        "touch": 221,
                        "break": 94,
                        "total": 897
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11519,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-03-10"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "独りんぼエンヴィー",
            "category": "niconico＆ボーカロイド",
            "title": "独りんぼエンヴィー",
            "artist": "koyori（電ポルP）",
            "bpm": 132,
            "imageName": "34afed676e399dd34641fc2baade275331f81c25114076e0943195ceaa78d2e7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 80,
                        "hold": 10,
                        "slide": 5,
                        "touch": 20,
                        "break": 3,
                        "total": 118
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11520,
                    "releaseDate": "2023-03-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 22,
                        "slide": 6,
                        "touch": 29,
                        "break": 10,
                        "total": 299
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11520,
                    "releaseDate": "2023-03-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 257,
                        "hold": 76,
                        "slide": 24,
                        "touch": 14,
                        "break": 8,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11520,
                    "releaseDate": "2023-03-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "メロンポップ",
                    "noteCounts": {
                        "tap": 390,
                        "hold": 72,
                        "slide": 80,
                        "touch": 39,
                        "break": 25,
                        "total": 606
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11520,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2023-03-10"
                }
            ],
            "searchAcronyms": [
                "Hitorinbo Envy"
            ]
        },
        {
            "songId": "ロータスイーター",
            "category": "niconico＆ボーカロイド",
            "title": "ロータスイーター",
            "artist": "青栗鼠",
            "bpm": 142,
            "imageName": "f8b780e7aee6da5f54cb0c729e0dd5ed7e134d7720c80a1d5ff182406437f567",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 74,
                        "hold": 18,
                        "slide": 4,
                        "touch": 20,
                        "break": 4,
                        "total": 120
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11521,
                    "releaseDate": "2023-03-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 24,
                        "slide": 15,
                        "touch": 24,
                        "break": 23,
                        "total": 318
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11521,
                    "releaseDate": "2023-03-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 367,
                        "hold": 57,
                        "slide": 22,
                        "touch": 0,
                        "break": 33,
                        "total": 479
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11521,
                    "releaseDate": "2023-03-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 553,
                        "hold": 79,
                        "slide": 111,
                        "touch": 56,
                        "break": 7,
                        "total": 806
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL",
                    "internalId": 11521,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2023-03-10"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Trrricksters!!",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Trrricksters!!",
            "artist": "s-don vs. 翡乃イスカ",
            "bpm": 155,
            "imageName": "af5aa2985ef533cc430c6ed4ca9f0fd040dfb4f53650684b65b12c8f56e4fba1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 208,
                        "hold": 14,
                        "slide": 6,
                        "touch": 10,
                        "break": 12,
                        "total": 250
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11549,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 295,
                        "hold": 20,
                        "slide": 12,
                        "touch": 31,
                        "break": 11,
                        "total": 369
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11549,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 483,
                        "hold": 82,
                        "slide": 68,
                        "touch": 73,
                        "break": 69,
                        "total": 775
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11549,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "サファ太 vs -ZONE- SaFaRi",
                    "noteCounts": {
                        "tap": 737,
                        "hold": 108,
                        "slide": 60,
                        "touch": 80,
                        "break": 168,
                        "total": 1153
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11549,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL PLUS": 14.5,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3
                    },
                    "releaseDate": "2023-03-23"
                }
            ],
            "searchAcronyms": [
                "Trickster",
                "Tricksters",
                "Trricksters",
                "Trrrricksters"
            ]
        },
        {
            "songId": "トノサマビーム",
            "category": "maimai",
            "title": "トノサマビーム",
            "artist": "ぼっちぼろまる",
            "bpm": 170,
            "imageName": "b1689ee8dbf309838e82b5bc6ddfa79444f5d30b9bc433ca1f41c7e240216bc7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 144,
                        "hold": 15,
                        "slide": 3,
                        "touch": 7,
                        "break": 5,
                        "total": 174
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11526,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 265,
                        "hold": 19,
                        "slide": 10,
                        "touch": 29,
                        "break": 18,
                        "total": 341
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11526,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 479,
                        "hold": 61,
                        "slide": 16,
                        "touch": 4,
                        "break": 19,
                        "total": 579
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11526,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 522,
                        "hold": 25,
                        "slide": 115,
                        "touch": 141,
                        "break": 66,
                        "total": 869
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11526,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-03-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "enchanted wanderer",
            "category": "maimai",
            "title": "enchanted wanderer",
            "artist": "linear ring",
            "bpm": 102,
            "imageName": "6f33754270f509444b12cfd35a0c2dc9f65c5e4d4ca139d9a892ad23d61debb6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 130,
                        "hold": 15,
                        "slide": 4,
                        "touch": 8,
                        "break": 3,
                        "total": 160
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11527,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 17,
                        "slide": 10,
                        "touch": 22,
                        "break": 6,
                        "total": 286
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11527,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 136,
                        "slide": 51,
                        "touch": 56,
                        "break": 15,
                        "total": 446
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11527,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12,
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "FESTiVAL PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 62,
                        "slide": 107,
                        "touch": 113,
                        "break": 27,
                        "total": 594
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11527,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-03-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Comet Panto Men!",
            "category": "maimai",
            "title": "Comet Panto Men!",
            "artist": "MYUKKE.",
            "bpm": 170,
            "imageName": "3c8ce29fbf6af030ed10d0e1a3eef81b76832b8dc9516f28f2df55d7a6bb9196",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 178,
                        "hold": 13,
                        "slide": 6,
                        "touch": 7,
                        "break": 6,
                        "total": 210
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11528,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 332,
                        "hold": 12,
                        "slide": 6,
                        "touch": 17,
                        "break": 12,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11528,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 461,
                        "hold": 55,
                        "slide": 34,
                        "touch": 19,
                        "break": 59,
                        "total": 628
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11528,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "FESTiVAL PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 629,
                        "hold": 71,
                        "slide": 95,
                        "touch": 85,
                        "break": 32,
                        "total": 912
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11528,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL PLUS": 14,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2023-03-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ツムギボシ",
            "category": "maimai",
            "title": "ツムギボシ",
            "artist": "大国奏音 feat.timao",
            "bpm": 190,
            "imageName": "399205e2297d6ee6753f0e1ac8e7f15891f4eb93158c9ca4a9d851f963ac102e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 181,
                        "hold": 24,
                        "slide": 10,
                        "touch": 15,
                        "break": 5,
                        "total": 235
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11529,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 42,
                        "slide": 18,
                        "touch": 25,
                        "break": 19,
                        "total": 376
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11529,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 425,
                        "hold": 72,
                        "slide": 38,
                        "touch": 68,
                        "break": 23,
                        "total": 626
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11529,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 686,
                        "hold": 64,
                        "slide": 142,
                        "touch": 38,
                        "break": 62,
                        "total": 992
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11529,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.1,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL PLUS": 14.1,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2023-03-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "FLUFFY FLASH",
            "category": "オンゲキ＆CHUNITHM",
            "title": "FLUFFY FLASH",
            "artist": "Kobaryo",
            "bpm": 252,
            "imageName": "c7d904ebcd1c2c78a3e33bf177889712fc33c39ce5719ddedd1aef23bcbd518c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 12,
                        "slide": 9,
                        "touch": 15,
                        "break": 8,
                        "total": 228
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11550,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 33,
                        "slide": 16,
                        "touch": 35,
                        "break": 6,
                        "total": 408
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11550,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 463,
                        "hold": 103,
                        "slide": 39,
                        "touch": 34,
                        "break": 20,
                        "total": 659
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11550,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 646,
                        "hold": 102,
                        "slide": 111,
                        "touch": 104,
                        "break": 25,
                        "total": 988
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11550,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "FESTiVAL PLUS": 14.3,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4
                    },
                    "releaseDate": "2023-03-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ヒバリ",
            "category": "POPS＆アニメ",
            "title": "ヒバリ",
            "artist": "HIMEHINA",
            "bpm": 140,
            "imageName": "186fa137876da3b0b7e0e9c2524b16069f19d6c35fe380e7d47e9b00d5caeccd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 75,
                        "hold": 9,
                        "slide": 5,
                        "touch": 13,
                        "break": 1,
                        "total": 103
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11555,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 164,
                        "hold": 19,
                        "slide": 6,
                        "touch": 22,
                        "break": 9,
                        "total": 220
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11555,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 299,
                        "hold": 52,
                        "slide": 20,
                        "touch": 10,
                        "break": 17,
                        "total": 398
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11555,
                    "multiverInternalLevelValue": {
                        "FESTiVAL PLUS": 10.7
                    },
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 469,
                        "hold": 59,
                        "slide": 41,
                        "touch": 52,
                        "break": 28,
                        "total": 649
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11555,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2023-03-23"
                }
            ],
            "searchAcronyms": [
                "Hibari"
            ]
        },
        {
            "songId": "Hello, Hologram",
            "category": "POPS＆アニメ",
            "title": "Hello, Hologram",
            "artist": "HIMEHINA",
            "bpm": 161,
            "imageName": "1044d48b3ad95e9faa0ff661ff77dd22836cbb77bf56cd17b5cb7fda6107353c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 8,
                        "slide": 6,
                        "touch": 10,
                        "break": 2,
                        "total": 212
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11556,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 27,
                        "slide": 6,
                        "touch": 15,
                        "break": 7,
                        "total": 335
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11556,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 382,
                        "hold": 83,
                        "slide": 37,
                        "touch": 16,
                        "break": 32,
                        "total": 550
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11556,
                    "multiverInternalLevelValue": {
                        "FESTiVAL PLUS": 10.5
                    },
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "ものくろっく",
                    "noteCounts": {
                        "tap": 570,
                        "hold": 88,
                        "slide": 73,
                        "touch": 66,
                        "break": 100,
                        "total": 897
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11556,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-03-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "不機嫌なスリーカード",
            "category": "POPS＆アニメ",
            "title": "不機嫌なスリーカード",
            "artist": "HIMEHINA",
            "bpm": 195,
            "imageName": "e690d97cc16966431ce4e4b84c07074fbf1358565381f785112fa14ee24c3f85",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 91,
                        "hold": 9,
                        "slide": 2,
                        "touch": 7,
                        "break": 3,
                        "total": 112
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11557,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 244,
                        "hold": 23,
                        "slide": 10,
                        "touch": 25,
                        "break": 12,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11557,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10.5,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 302,
                        "hold": 77,
                        "slide": 11,
                        "touch": 6,
                        "break": 35,
                        "total": 431
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11557,
                    "multiverInternalLevelValue": {
                        "FESTiVAL PLUS": 10.5
                    },
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 441,
                        "hold": 27,
                        "slide": 41,
                        "touch": 13,
                        "break": 37,
                        "total": 559
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11557,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2023-03-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "神っぽいな",
            "category": "niconico＆ボーカロイド",
            "title": "神っぽいな",
            "artist": "ピノキオピー",
            "bpm": 142,
            "imageName": "4cafcae7e8a5ef15f0e92e3a9293de3687792cc88bdb03e283d3b8fc758e89b9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 72,
                        "hold": 11,
                        "slide": 4,
                        "touch": 7,
                        "break": 1,
                        "total": 95
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11558,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 13,
                        "slide": 5,
                        "touch": 28,
                        "break": 10,
                        "total": 228
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11558,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "畳返し",
                    "noteCounts": {
                        "tap": 236,
                        "hold": 52,
                        "slide": 15,
                        "touch": 8,
                        "break": 13,
                        "total": 324
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11558,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.7,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 363,
                        "hold": 34,
                        "slide": 54,
                        "touch": 23,
                        "break": 12,
                        "total": 486
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11558,
                    "multiverInternalLevelValue": {
                        "FESTiVAL PLUS": 11.7
                    },
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 442,
                        "hold": 39,
                        "slide": 48,
                        "touch": 9,
                        "break": 25,
                        "total": 563
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11558,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2023-03-22"
                }
            ],
            "searchAcronyms": [
                "God-ish",
                "像神一样"
            ]
        },
        {
            "songId": "魔法少女とチョコレゐト",
            "category": "niconico＆ボーカロイド",
            "title": "魔法少女とチョコレゐト",
            "artist": "ピノキオピー",
            "bpm": 150,
            "imageName": "f7b25f2cce4262d07e50ea6fd20dadb5e8a1a41a96bbce192f0693dc8629d88c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 122,
                        "hold": 15,
                        "slide": 8,
                        "touch": 8,
                        "break": 5,
                        "total": 158
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11559,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 187,
                        "hold": 29,
                        "slide": 10,
                        "touch": 32,
                        "break": 34,
                        "total": 292
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11559,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 255,
                        "hold": 55,
                        "slide": 29,
                        "touch": 10,
                        "break": 21,
                        "total": 370
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11559,
                    "multiverInternalLevelValue": {
                        "FESTiVAL PLUS": 9.5
                    },
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "Redarrow",
                    "noteCounts": {
                        "tap": 385,
                        "hold": 80,
                        "slide": 86,
                        "touch": 42,
                        "break": 27,
                        "total": 620
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11559,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2023-03-23"
                }
            ],
            "searchAcronyms": [
                "Magical Girl and Chocolate",
                "mahou shoujo to chocolate"
            ]
        },
        {
            "songId": "阿修羅ちゃん",
            "category": "POPS＆アニメ",
            "title": "阿修羅ちゃん",
            "artist": "Ado",
            "bpm": 156,
            "imageName": "2f39bb5291deefb1368757d49eea7a55b5d22f01315577ebbfac973e41c018ad",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 111,
                        "hold": 10,
                        "slide": 3,
                        "touch": 12,
                        "break": 6,
                        "total": 142
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11560,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 16,
                        "slide": 8,
                        "touch": 26,
                        "break": 8,
                        "total": 290
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11560,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 343,
                        "hold": 25,
                        "slide": 32,
                        "touch": 50,
                        "break": 36,
                        "total": 486
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11560,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 498,
                        "hold": 10,
                        "slide": 116,
                        "touch": 18,
                        "break": 69,
                        "total": 711
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11560,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2023-03-23"
                }
            ],
            "searchAcronyms": [
                "Ashura-chan"
            ]
        },
        {
            "songId": "おとせサンダー",
            "category": "POPS＆アニメ",
            "title": "おとせサンダー",
            "artist": "ぼっちぼろまる",
            "bpm": 177,
            "imageName": "687ffb400c1eae297e0db484c3e7f3ff72af4d9b973fb96e05a809f609d5896f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 115,
                        "hold": 9,
                        "slide": 4,
                        "touch": 20,
                        "break": 1,
                        "total": 149
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11561,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 15,
                        "slide": 11,
                        "touch": 15,
                        "break": 7,
                        "total": 340
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11561,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 426,
                        "hold": 54,
                        "slide": 27,
                        "touch": 17,
                        "break": 44,
                        "total": 568
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11561,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11.5,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 441,
                        "hold": 50,
                        "slide": 116,
                        "touch": 78,
                        "break": 42,
                        "total": 727
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11561,
                    "multiverInternalLevelValue": {
                        "FESTiVAL PLUS": 11.5
                    },
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 754,
                        "hold": 29,
                        "slide": 120,
                        "touch": 44,
                        "break": 29,
                        "total": 976
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11561,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-03-22"
                }
            ],
            "searchAcronyms": [
                "Otose Thunder",
                "Thunder Shoot"
            ]
        },
        {
            "songId": "ロウワー",
            "category": "niconico＆ボーカロイド",
            "title": "ロウワー",
            "artist": "ぬゆり",
            "bpm": 132,
            "imageName": "e3c7240c7d75cd0b5e9b9b35c8b228f019365e8970eed9aecb4cc3697a347c17",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 87,
                        "hold": 10,
                        "slide": 4,
                        "touch": 8,
                        "break": 4,
                        "total": 113
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11562,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 180,
                        "hold": 33,
                        "slide": 6,
                        "touch": 20,
                        "break": 10,
                        "total": 249
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11562,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.8,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 283,
                        "hold": 33,
                        "slide": 29,
                        "touch": 25,
                        "break": 14,
                        "total": 384
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11562,
                    "multiverInternalLevelValue": {
                        "FESTiVAL PLUS": 8.8
                    },
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11.5,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 366,
                        "hold": 73,
                        "slide": 68,
                        "touch": 44,
                        "break": 22,
                        "total": 573
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11562,
                    "multiverInternalLevelValue": {
                        "FESTiVAL PLUS": 11.5
                    },
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 535,
                        "hold": 66,
                        "slide": 99,
                        "touch": 33,
                        "break": 26,
                        "total": 759
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11562,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2023-03-22"
                }
            ],
            "searchAcronyms": [
                "Lower"
            ]
        },
        {
            "songId": "キャットラビング",
            "category": "niconico＆ボーカロイド",
            "title": "キャットラビング",
            "artist": "香椎モイミ",
            "bpm": 163,
            "imageName": "8d0a2ef8e25fd948d721fd91973c64c93fe4064ce9cd4ad5cfc478c561099393",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 78,
                        "hold": 10,
                        "slide": 9,
                        "touch": 16,
                        "break": 2,
                        "total": 115
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11563,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 185,
                        "hold": 20,
                        "slide": 12,
                        "touch": 26,
                        "break": 14,
                        "total": 257
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11563,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.8,
                    "noteDesigner": "畳返し",
                    "noteCounts": {
                        "tap": 244,
                        "hold": 62,
                        "slide": 18,
                        "touch": 32,
                        "break": 12,
                        "total": 368
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11563,
                    "multiverInternalLevelValue": {
                        "FESTiVAL PLUS": 8.8
                    },
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 399,
                        "hold": 38,
                        "slide": 54,
                        "touch": 106,
                        "break": 28,
                        "total": 625
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11563,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-03-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "リスペク風神",
            "category": "東方Project",
            "title": "リスペク風神",
            "artist": "ビートまりおとまろん",
            "bpm": 135,
            "imageName": "5d78c4f3b6dcd2e853dbb1905a1bfe20c9f5390b9d437ef832fc1b4c111569d2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 98,
                        "hold": 10,
                        "slide": 4,
                        "touch": 22,
                        "break": 8,
                        "total": 142
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11564,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 24,
                        "slide": 12,
                        "touch": 24,
                        "break": 11,
                        "total": 283
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11564,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 377,
                        "hold": 42,
                        "slide": 74,
                        "touch": 21,
                        "break": 36,
                        "total": 550
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11564,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 611,
                        "hold": 45,
                        "slide": 59,
                        "touch": 87,
                        "break": 53,
                        "total": 855
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11564,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-03-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Let you DIVE!",
            "category": "ゲーム＆バラエティ",
            "title": "Let you DIVE!",
            "artist": "HARDCORE TANO*C & エリザベス（CV:大西沙織）",
            "bpm": 185,
            "imageName": "5547b1d67631c0ec6f509eb431d5154b880e80ff8af1e51a87a8336da51118f0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 106,
                        "hold": 5,
                        "slide": 10,
                        "touch": 14,
                        "break": 1,
                        "total": 136
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11565,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 220,
                        "hold": 28,
                        "slide": 12,
                        "touch": 56,
                        "break": 8,
                        "total": 324
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11565,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 405,
                        "hold": 46,
                        "slide": 16,
                        "touch": 23,
                        "break": 32,
                        "total": 522
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11565,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 391,
                        "hold": 53,
                        "slide": 67,
                        "touch": 46,
                        "break": 39,
                        "total": 596
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11565,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-03-23"
                }
            ],
            "searchAcronyms": [
                "lyd",
                "wacca",
                "让你死",
                "让你潜",
                "让你潜水",
                "让你落",
                "遗体捐赠"
            ]
        },
        {
            "songId": "Knight Rider",
            "category": "ゲーム＆バラエティ",
            "title": "Knight Rider",
            "artist": "USAO",
            "bpm": 200,
            "imageName": "e02839c8d1e3c0f446d6d0e8f1adbf2190d095fe871abfd32878e0ac7d2ca6aa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 207,
                        "hold": 10,
                        "slide": 4,
                        "touch": 8,
                        "break": 3,
                        "total": 232
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11566,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 373,
                        "hold": 4,
                        "slide": 10,
                        "touch": 28,
                        "break": 6,
                        "total": 421
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11566,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11.2,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 378,
                        "hold": 94,
                        "slide": 55,
                        "touch": 17,
                        "break": 29,
                        "total": 573
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11566,
                    "multiverInternalLevelValue": {
                        "FESTiVAL PLUS": 11.2
                    },
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 569,
                        "hold": 38,
                        "slide": 175,
                        "touch": 59,
                        "break": 35,
                        "total": 876
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11566,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-03-23"
                }
            ],
            "searchAcronyms": [
                "kr",
                "山奥金曲",
                "骑士骑士",
                "骑骑",
                "骑骑士士"
            ]
        },
        {
            "songId": "INTERNET OVERDOSE",
            "category": "POPS＆アニメ",
            "title": "INTERNET OVERDOSE",
            "artist": "Aiobahn feat. KOTOKO",
            "bpm": 163,
            "imageName": "f4a9ee1fb86ae5819de2943e9ae1bbc113ad207df21e8f077b2a74c0ab87ec8e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 133,
                        "hold": 16,
                        "slide": 6,
                        "touch": 12,
                        "break": 4,
                        "total": 171
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11568,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 35,
                        "slide": 6,
                        "touch": 29,
                        "break": 13,
                        "total": 356
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11568,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 328,
                        "hold": 78,
                        "slide": 36,
                        "touch": 61,
                        "break": 35,
                        "total": 538
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11568,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 517,
                        "hold": 78,
                        "slide": 109,
                        "touch": 13,
                        "break": 105,
                        "total": 822
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL"
                        }
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11568,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2023-03-23"
                }
            ],
            "searchAcronyms": [
                "daisuke",
                "io",
                "kotoko",
                "od",
                "overdose",
                "主播女孩",
                "主播女孩重度依赖",
                "升天",
                "叉烧老婆",
                "地雷女",
                "地雷妹",
                "小天使请安",
                "当代互联网小天使",
                "我有快乐症",
                "我有抑郁症",
                "我有神经病",
                "朝天椒",
                "浴霸",
                "玉玉症",
                "网络过量",
                "超天酱"
            ]
        },
        {
            "songId": "VeRForTe αRtE:VEiN",
            "category": "maimai",
            "title": "VeRForTe αRtE:VEiN",
            "artist": "orangentle",
            "bpm": 190,
            "imageName": "4f14bfe18abbf6497522fb5f1de3374ef8397a0f5bb2597c0d41399287439754",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 173,
                        "hold": 15,
                        "slide": 8,
                        "touch": 26,
                        "break": 5,
                        "total": 227
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11530,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 42,
                        "slide": 18,
                        "touch": 14,
                        "break": 33,
                        "total": 374
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11530,
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 395,
                        "hold": 47,
                        "slide": 66,
                        "touch": 61,
                        "break": 85,
                        "total": 654
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11530,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2023-03-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "翡翠マナ -Memoir-",
                    "noteCounts": {
                        "tap": 774,
                        "hold": 69,
                        "slide": 64,
                        "touch": 72,
                        "break": 85,
                        "total": 1064
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11530,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "FESTiVAL PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8
                    },
                    "releaseDate": "2023-03-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "魂のルフラン",
            "category": "POPS＆アニメ",
            "title": "魂のルフラン",
            "artist": "高橋洋子 [covered by 光吉猛修]",
            "bpm": 130,
            "imageName": "6fcfe1c1ed07e0d6fc8309a5af26d855647bb28747d6d04fc6af36aac920cbaf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 76,
                        "hold": 6,
                        "slide": 2,
                        "touch": 20,
                        "break": 3,
                        "total": 107
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11569,
                    "releaseDate": "2023-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 17,
                        "slide": 4,
                        "touch": 22,
                        "break": 10,
                        "total": 207
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11569,
                    "releaseDate": "2023-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 29,
                        "slide": 48,
                        "touch": 6,
                        "break": 28,
                        "total": 299
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11569,
                    "releaseDate": "2023-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 317,
                        "hold": 21,
                        "slide": 92,
                        "touch": 11,
                        "break": 27,
                        "total": 468
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11569,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2023-04-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Shooting Shower～DANCE TIME(シンディ)～",
            "category": "ゲーム＆バラエティ",
            "title": "Shooting Shower～DANCE TIME(シンディ)～",
            "artist": "Sammy Sound Team",
            "bpm": 149,
            "imageName": "90aacef2aa61ad397b26aa98827554c77a8f512b1800a5815a321d3e385c5a97",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 110,
                        "hold": 10,
                        "slide": 4,
                        "touch": 8,
                        "break": 14,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11570,
                    "releaseDate": "2023-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 17,
                        "slide": 4,
                        "touch": 21,
                        "break": 8,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11570,
                    "releaseDate": "2023-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 40,
                        "slide": 30,
                        "touch": 12,
                        "break": 25,
                        "total": 312
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11570,
                    "releaseDate": "2023-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "DANCE TIME(サファ太)",
                    "noteCounts": {
                        "tap": 389,
                        "hold": 27,
                        "slide": 77,
                        "touch": 19,
                        "break": 40,
                        "total": 552
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11570,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2023-04-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Lights of Muse",
            "category": "ゲーム＆バラエティ",
            "title": "Lights of Muse",
            "artist": "Ayatsugu_Otowa",
            "bpm": 180,
            "imageName": "9f6d1012aecd421f94c938a20b15d640cf9612d101af4cbe2b4794e6e6af708c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 99,
                        "hold": 10,
                        "slide": 4,
                        "touch": 7,
                        "break": 6,
                        "total": 126
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11571,
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 12,
                        "slide": 10,
                        "touch": 22,
                        "break": 10,
                        "total": 283
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11571,
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "きょむりん",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 64,
                        "slide": 23,
                        "touch": 12,
                        "break": 19,
                        "total": 460
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11571,
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 498,
                        "hold": 25,
                        "slide": 91,
                        "touch": 7,
                        "break": 31,
                        "total": 652
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11571,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2023-04-14"
                }
            ],
            "searchAcronyms": [
                "lom",
                "你醒啦，快起来打交",
                "喵斯之光",
                "喵斯光",
                "布若",
                "暮色的光"
            ]
        },
        {
            "songId": "tape/stop/night",
            "category": "ゲーム＆バラエティ",
            "title": "tape/stop/night",
            "artist": "Sugar & Co.",
            "bpm": 115,
            "imageName": "2840938edc4ff3f4fb15b3f0fe56e5be1fb3a4ed7c8257a6d92070e5328e1a42",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 101,
                        "hold": 10,
                        "slide": 8,
                        "touch": 8,
                        "break": 6,
                        "total": 133
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11572,
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 182,
                        "hold": 16,
                        "slide": 12,
                        "touch": 27,
                        "break": 5,
                        "total": 242
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11572,
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 50,
                        "slide": 46,
                        "touch": 50,
                        "break": 16,
                        "total": 416
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11572,
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 15,
                        "slide": 163,
                        "touch": 14,
                        "break": 14,
                        "total": 563
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11572,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-04-14"
                }
            ],
            "searchAcronyms": [
                "tape stop night",
                "tsn",
                "中国弱虫",
                "中国强虫",
                "中国虫",
                "中文歌",
                "君の中國语本当上手",
                "国产弱虫",
                "强虫",
                "暮色电台",
                "磁带暂停夜晚",
                "磁带机",
                "磁带机黑胶",
                "秘密星期五",
                "被踩:夹子歌"
            ]
        },
        {
            "songId": "Final Step!",
            "category": "ゲーム＆バラエティ",
            "title": "Final Step!",
            "artist": "Lime",
            "bpm": 180,
            "imageName": "f8c3dc9d08bdee30157ad424d156573ecf374358ba59ed7c046301b3fef77815",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 11,
                        "slide": 5,
                        "touch": 14,
                        "break": 5,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11573,
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 23,
                        "slide": 16,
                        "touch": 53,
                        "break": 2,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11573,
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 422,
                        "hold": 68,
                        "slide": 51,
                        "touch": 16,
                        "break": 19,
                        "total": 576
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11573,
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 617,
                        "hold": 40,
                        "slide": 95,
                        "touch": 40,
                        "break": 67,
                        "total": 859
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11573,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-04-14"
                }
            ],
            "searchAcronyms": [
                "fs",
                "FS",
                "最后一步"
            ]
        },
        {
            "songId": "The 90's Decision",
            "category": "ゲーム＆バラエティ",
            "title": "The 90's Decision",
            "artist": "MYUKKE.",
            "bpm": 128,
            "imageName": "c9a32145ffbc57c8356314533689fcf080839b992cb28f9024f83dc87cc630aa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 133,
                        "hold": 10,
                        "slide": 4,
                        "touch": 9,
                        "break": 4,
                        "total": 160
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11574,
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 11,
                        "slide": 12,
                        "touch": 13,
                        "break": 4,
                        "total": 291
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11574,
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 73,
                        "slide": 42,
                        "touch": 22,
                        "break": 52,
                        "total": 526
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11574,
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 490,
                        "hold": 58,
                        "slide": 69,
                        "touch": 12,
                        "break": 65,
                        "total": 694
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11574,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2023-04-14"
                }
            ],
            "searchAcronyms": [
                "90s",
                "90秒"
            ]
        },
        {
            "songId": "僕の和風本当上手",
            "category": "ゲーム＆バラエティ",
            "title": "僕の和風本当上手",
            "artist": "ボス",
            "bpm": 120,
            "imageName": "74c8525b9d8c0278875c913338e4f7c4ec2174f9451ea3aca7ad479ffe10b15a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 14,
                        "slide": 4,
                        "touch": 21,
                        "break": 3,
                        "total": 211
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11575,
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 24,
                        "slide": 10,
                        "touch": 28,
                        "break": 6,
                        "total": 404
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11575,
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 477,
                        "hold": 57,
                        "slide": 46,
                        "touch": 45,
                        "break": 25,
                        "total": 650
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11575,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "FESTiVAL PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "僕の檸檬本当上手",
                    "noteCounts": {
                        "tap": 1007,
                        "hold": 23,
                        "slide": 73,
                        "touch": 11,
                        "break": 59,
                        "total": 1173
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11575,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL PLUS": 14,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14
                    },
                    "releaseDate": "2023-04-14"
                }
            ],
            "searchAcronyms": [
                "bokuno和风本当上手",
                "上手",
                "僕の唢呐把人送走",
                "僕の日本语本当上手",
                "君日本语本当上手",
                "和风",
                "和风本当上手",
                "唢呐",
                "我的和风非常厉害",
                "本当上手",
                "现在开始打交"
            ]
        },
        {
            "songId": "Cthugha",
            "category": "ゲーム＆バラエティ",
            "title": "Cthugha",
            "artist": "USAO",
            "bpm": 213,
            "imageName": "470282e7ffb75c309d3ccf64987437d1856cafaefadf6f11402569c2a6b955cb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 16,
                        "slide": 4,
                        "touch": 8,
                        "break": 13,
                        "total": 273
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11576,
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 384,
                        "hold": 20,
                        "slide": 17,
                        "touch": 32,
                        "break": 20,
                        "total": 473
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11576,
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 538,
                        "hold": 80,
                        "slide": 49,
                        "touch": 20,
                        "break": 72,
                        "total": 759
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11576,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "BUDDiES PLUS": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2023-04-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 809,
                        "hold": 100,
                        "slide": 128,
                        "touch": 50,
                        "break": 81,
                        "total": 1168
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11576,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL PLUS": 14.3,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2
                    },
                    "releaseDate": "2023-04-14"
                }
            ],
            "searchAcronyms": [
                "🎃",
                "克图格亚",
                "南瓜头",
                "古神",
                "大火球",
                "清华",
                "火烧兔头",
                "火球",
                "火神2",
                "炎头",
                "赛图格亚"
            ]
        },
        {
            "songId": "ヱデン",
            "category": "maimai",
            "title": "ヱデン",
            "artist": "koyori（電ポルP）",
            "bpm": 137,
            "imageName": "4477873931977be49098771ec6753e068f0afe3c52c87ed8795ff87ea8c0d773",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 111,
                        "hold": 18,
                        "slide": 4,
                        "touch": 10,
                        "break": 5,
                        "total": 148
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11532,
                    "releaseDate": "2023-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 19,
                        "slide": 10,
                        "touch": 25,
                        "break": 8,
                        "total": 292
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11532,
                    "releaseDate": "2023-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 46,
                        "slide": 42,
                        "touch": 13,
                        "break": 18,
                        "total": 461
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11532,
                    "releaseDate": "2023-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 474,
                        "hold": 52,
                        "slide": 91,
                        "touch": 21,
                        "break": 17,
                        "total": 655
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11532,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-04-28"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "にゃーにゃー冒険譚",
            "category": "maimai",
            "title": "にゃーにゃー冒険譚",
            "artist": "黒魔",
            "bpm": 188,
            "imageName": "b0aa06700c8f8afe6a4604f005d75a20de94dce22cbd82cbef5d183f8076f745",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 20,
                        "slide": 7,
                        "touch": 21,
                        "break": 2,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11533,
                    "releaseDate": "2023-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 308,
                        "hold": 40,
                        "slide": 17,
                        "touch": 24,
                        "break": 14,
                        "total": 403
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11533,
                    "releaseDate": "2023-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 482,
                        "hold": 44,
                        "slide": 22,
                        "touch": 24,
                        "break": 69,
                        "total": 641
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11533,
                    "releaseDate": "2023-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 802,
                        "hold": 49,
                        "slide": 82,
                        "touch": 68,
                        "break": 84,
                        "total": 1085
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11533,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-04-28"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "BULK UP (GAME EXCLUSIVE EDIT)",
            "category": "ゲーム＆バラエティ",
            "title": "BULK UP (GAME EXCLUSIVE EDIT)",
            "artist": "USAO & Yuta Imai",
            "bpm": 200,
            "imageName": "8fc67a95ea09b58cabdfdc1476cca942c00915b10d6ada5e82a85fdff4e4bbf8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 14,
                        "slide": 6,
                        "touch": 20,
                        "break": 8,
                        "total": 202
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11594,
                    "releaseDate": "2023-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 16,
                        "slide": 20,
                        "touch": 14,
                        "break": 9,
                        "total": 397
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11594,
                    "releaseDate": "2023-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 403,
                        "hold": 74,
                        "slide": 64,
                        "touch": 60,
                        "break": 43,
                        "total": 644
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11594,
                    "releaseDate": "2023-04-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 508,
                        "hold": 84,
                        "slide": 96,
                        "touch": 79,
                        "break": 177,
                        "total": 944
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11594,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "FESTiVAL PLUS": 14.1,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2
                    },
                    "releaseDate": "2023-04-28"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "コンティニュー！ feat. 藍月なくる",
            "category": "ゲーム＆バラエティ",
            "title": "コンティニュー！ feat. 藍月なくる",
            "artist": "lapix",
            "bpm": 170,
            "imageName": "56876612c1521d91889416e3fce690866a939e0ce29afb40fbdfe916a6879a2f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 167,
                        "hold": 12,
                        "slide": 6,
                        "touch": 19,
                        "break": 7,
                        "total": 211
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11584,
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 249,
                        "hold": 33,
                        "slide": 11,
                        "touch": 27,
                        "break": 4,
                        "total": 324
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11584,
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 401,
                        "hold": 49,
                        "slide": 21,
                        "touch": 27,
                        "break": 55,
                        "total": 553
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11584,
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 606,
                        "hold": 60,
                        "slide": 80,
                        "touch": 80,
                        "break": 71,
                        "total": 897
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11584,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6
                    },
                    "releaseDate": "2023-05-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Sunday Night feat Kanata.N",
            "category": "ゲーム＆バラエティ",
            "title": "Sunday Night feat Kanata.N",
            "artist": "Mameyudoufu",
            "bpm": 143,
            "imageName": "9d83a0f4b2f2358a6ef3469c0fe724468d36e8c905572e1ac7f6d9121d7e08e8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 102,
                        "hold": 12,
                        "slide": 4,
                        "touch": 26,
                        "break": 8,
                        "total": 152
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11585,
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 207,
                        "hold": 14,
                        "slide": 17,
                        "touch": 25,
                        "break": 7,
                        "total": 270
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11585,
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 260,
                        "hold": 112,
                        "slide": 28,
                        "touch": 22,
                        "break": 27,
                        "total": 449
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11585,
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "ものくろっく",
                    "noteCounts": {
                        "tap": 431,
                        "hold": 59,
                        "slide": 57,
                        "touch": 30,
                        "break": 33,
                        "total": 610
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11585,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2023-05-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "PERSONA feat. PANXI",
            "category": "ゲーム＆バラエティ",
            "title": "PERSONA feat. PANXI",
            "artist": "rejection",
            "bpm": 175,
            "imageName": "d88263d5cbb02f90f6e2552b59c266eb8b241e1e2ac9ee04debe106b6c6fa80a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 156,
                        "hold": 12,
                        "slide": 4,
                        "touch": 8,
                        "break": 6,
                        "total": 186
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11586,
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 26,
                        "slide": 10,
                        "touch": 27,
                        "break": 8,
                        "total": 325
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11586,
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 314,
                        "hold": 94,
                        "slide": 63,
                        "touch": 14,
                        "break": 17,
                        "total": 502
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11586,
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 532,
                        "hold": 58,
                        "slide": 104,
                        "touch": 11,
                        "break": 28,
                        "total": 733
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11586,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2023-05-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Halfway(>∀<)",
            "category": "ゲーム＆バラエティ",
            "title": "Halfway(>∀<)",
            "artist": "Blacklolita",
            "bpm": 175,
            "imageName": "be00fb5aed6ee36d4e63ddfdd55932c44ba7dc672541ccc5f10fbe208c495525",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 8,
                        "slide": 6,
                        "touch": 8,
                        "break": 16,
                        "total": 232
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11587,
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 314,
                        "hold": 19,
                        "slide": 14,
                        "touch": 22,
                        "break": 6,
                        "total": 375
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11587,
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 347,
                        "hold": 124,
                        "slide": 51,
                        "touch": 26,
                        "break": 12,
                        "total": 560
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11587,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "FESTiVAL PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 602,
                        "hold": 73,
                        "slide": 101,
                        "touch": 72,
                        "break": 52,
                        "total": 900
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11587,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-05-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Complex Mind",
            "category": "ゲーム＆バラエティ",
            "title": "Complex Mind",
            "artist": "YUKIYANAGI",
            "bpm": 175,
            "imageName": "5ee036ca303c856f828b3c9850a96efd2d87a4c6d10fcc21606db2f9becb1054",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 159,
                        "hold": 9,
                        "slide": 4,
                        "touch": 30,
                        "break": 8,
                        "total": 210
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11588,
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 296,
                        "hold": 17,
                        "slide": 16,
                        "touch": 27,
                        "break": 4,
                        "total": 360
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11588,
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 415,
                        "hold": 101,
                        "slide": 37,
                        "touch": 27,
                        "break": 9,
                        "total": 589
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11588,
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 684,
                        "hold": 39,
                        "slide": 63,
                        "touch": 28,
                        "break": 68,
                        "total": 882
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11588,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-05-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "DROPS feat. Such",
            "category": "ゲーム＆バラエティ",
            "title": "DROPS feat. Such",
            "artist": "Zekk & poplavor",
            "bpm": 120,
            "imageName": "6d3a5c503040dffd25d15458a59b9aa1a040cb3c1c62c3f6210536e21059ac66",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 10,
                        "slide": 4,
                        "touch": 8,
                        "break": 8,
                        "total": 165
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11589,
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 12,
                        "slide": 9,
                        "touch": 13,
                        "break": 10,
                        "total": 275
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11589,
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 361,
                        "hold": 68,
                        "slide": 45,
                        "touch": 27,
                        "break": 10,
                        "total": 511
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11589,
                    "releaseDate": "2023-05-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 473,
                        "hold": 57,
                        "slide": 77,
                        "touch": 21,
                        "break": 20,
                        "total": 648
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11589,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2023-05-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "インターネットサバイバー",
            "category": "東方Project",
            "title": "インターネットサバイバー",
            "artist": "あやぽんず＊ feat.ビートまりお × まろん",
            "bpm": 172,
            "imageName": "9d546f8a65ef6e18174ed61ba9d47982eaa1423897e687a5ce3176af675c4f13",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 118,
                        "hold": 12,
                        "slide": 3,
                        "touch": 6,
                        "break": 7,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11583,
                    "releaseDate": "2023-05-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 235,
                        "hold": 21,
                        "slide": 11,
                        "touch": 24,
                        "break": 8,
                        "total": 299
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11583,
                    "releaseDate": "2023-05-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 88,
                        "slide": 50,
                        "touch": 12,
                        "break": 24,
                        "total": 519
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11583,
                    "releaseDate": "2023-05-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 472,
                        "hold": 50,
                        "slide": 76,
                        "touch": 44,
                        "break": 122,
                        "total": 764
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11583,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "FESTiVAL PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2023-05-26"
                }
            ],
            "searchAcronyms": [
                "Internet Survivor"
            ]
        },
        {
            "songId": "花となれ",
            "category": "niconico＆ボーカロイド",
            "title": "花となれ",
            "artist": "雄之助　feat.音楽的同位体　可不（KAFU）",
            "bpm": 130,
            "imageName": "13c8c22fa535bd9df6f733a686811755bb3827ac4373ca7d769a785d1d40f0ed",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 79,
                        "hold": 9,
                        "slide": 4,
                        "touch": 7,
                        "break": 3,
                        "total": 102
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11592,
                    "releaseDate": "2023-05-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 178,
                        "hold": 14,
                        "slide": 4,
                        "touch": 13,
                        "break": 4,
                        "total": 213
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11592,
                    "releaseDate": "2023-05-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 32,
                        "slide": 25,
                        "touch": 2,
                        "break": 9,
                        "total": 277
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11592,
                    "releaseDate": "2023-05-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 21,
                        "slide": 82,
                        "touch": 62,
                        "break": 20,
                        "total": 313
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11592,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.2,
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "FESTiVAL PLUS": 12.2,
                        "PRiSM PLUS": 12.2
                    },
                    "releaseDate": "2023-05-26"
                }
            ],
            "searchAcronyms": [
                "Hana to Nare"
            ]
        },
        {
            "songId": "私のドッペルゲンガー",
            "category": "niconico＆ボーカロイド",
            "title": "私のドッペルゲンガー",
            "artist": "DIVELA　feat.音楽的同位体　可不（KAFU）",
            "bpm": 190,
            "imageName": "0f12ee61aca8a327499d15022af735944feb41daf70bb45bf52142e5a0015db9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 168,
                        "hold": 11,
                        "slide": 4,
                        "touch": 7,
                        "break": 4,
                        "total": 194
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11593,
                    "releaseDate": "2023-05-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 259,
                        "hold": 41,
                        "slide": 9,
                        "touch": 15,
                        "break": 6,
                        "total": 330
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11593,
                    "releaseDate": "2023-05-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 38,
                        "slide": 55,
                        "touch": 32,
                        "break": 43,
                        "total": 519
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11593,
                    "releaseDate": "2023-05-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 418,
                        "hold": 51,
                        "slide": 108,
                        "touch": 22,
                        "break": 64,
                        "total": 663
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11593,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2023-05-26"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "つるぺったん",
            "category": "東方Project",
            "title": "つるぺったん",
            "artist": "Silver Forest",
            "bpm": 180,
            "imageName": "05ddaae2ef13394f2a596bd7a76db15726f248879bf01c0170682d9fe8bf6024",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 9,
                        "slide": 8,
                        "touch": 13,
                        "break": 4,
                        "total": 188
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11603,
                    "releaseDate": "2023-06-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 18,
                        "slide": 12,
                        "touch": 15,
                        "break": 6,
                        "total": 336
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11603,
                    "releaseDate": "2023-06-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 300,
                        "hold": 132,
                        "slide": 40,
                        "touch": 19,
                        "break": 20,
                        "total": 511
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11603,
                    "releaseDate": "2023-06-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 374,
                        "hold": 98,
                        "slide": 106,
                        "touch": 54,
                        "break": 34,
                        "total": 666
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11603,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2023-06-08"
                }
            ],
            "searchAcronyms": [
                "Tsuru Pettan"
            ]
        },
        {
            "songId": "『ウソテイ』 ～一回戦せりなvsしろなvsなずな～",
            "category": "オンゲキ＆CHUNITHM",
            "title": "『ウソテイ』 ～一回戦せりなvsしろなvsなずな～",
            "artist": "イロドリミドリ「CHUNITHM」",
            "bpm": 190,
            "imageName": "885c1c0454ee97b587dc1c8e23e27ceb645e36cc68e8d389d19d8124363ac9d2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 9,
                        "slide": 4,
                        "touch": 15,
                        "break": 17,
                        "total": 220
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11604,
                    "releaseDate": "2023-06-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 283,
                        "hold": 33,
                        "slide": 13,
                        "touch": 23,
                        "break": 8,
                        "total": 360
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11604,
                    "releaseDate": "2023-06-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 135,
                        "slide": 15,
                        "touch": 28,
                        "break": 42,
                        "total": 558
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11604,
                    "releaseDate": "2023-06-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 628,
                        "hold": 52,
                        "slide": 133,
                        "touch": 15,
                        "break": 65,
                        "total": 893
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11604,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-06-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Bad Apple!! feat.nomico ～五十嵐 撫子 Ver.～",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Bad Apple!! feat.nomico ～五十嵐 撫子 Ver.～",
            "artist": "Masayoshi Minoshima [covered by 五十嵐 撫子(CV:花井 美春)]",
            "bpm": 141,
            "imageName": "efb9b8a29916b9fd36c081ba9b6be13e7a804658e37c078dff2d70812e54614c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 8,
                        "slide": 3,
                        "touch": 8,
                        "break": 6,
                        "total": 171
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11605,
                    "releaseDate": "2023-06-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 244,
                        "hold": 12,
                        "slide": 13,
                        "touch": 27,
                        "break": 8,
                        "total": 304
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11605,
                    "releaseDate": "2023-06-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 35,
                        "slide": 14,
                        "touch": 37,
                        "break": 20,
                        "total": 508
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11605,
                    "releaseDate": "2023-06-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 631,
                        "hold": 44,
                        "slide": 82,
                        "touch": 39,
                        "break": 27,
                        "total": 823
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11605,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2023-06-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Snow Colored Score",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Snow Colored Score",
            "artist": "イロドリミドリ「CHUNITHM」",
            "bpm": 164,
            "imageName": "d9669fc4d42266dea113d7cbce86bc259c7feeb7a69a51c9ba964953be427455",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 124,
                        "hold": 13,
                        "slide": 7,
                        "touch": 7,
                        "break": 7,
                        "total": 158
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11606,
                    "releaseDate": "2023-06-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 22,
                        "slide": 17,
                        "touch": 23,
                        "break": 14,
                        "total": 356
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11606,
                    "releaseDate": "2023-06-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 434,
                        "hold": 65,
                        "slide": 39,
                        "touch": 10,
                        "break": 14,
                        "total": 562
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11606,
                    "releaseDate": "2023-06-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 436,
                        "hold": 53,
                        "slide": 102,
                        "touch": 70,
                        "break": 53,
                        "total": 714
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11606,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2023-06-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "アンバークロニクル",
            "category": "maimai",
            "title": "アンバークロニクル",
            "artist": "しーけー feat.ricono",
            "bpm": 192,
            "imageName": "4b14725bdb015736863618fc14019a4fe752d8c8a5b93e3add29ff5b2e5d7239",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 9,
                        "slide": 4,
                        "touch": 22,
                        "break": 5,
                        "total": 236
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11538,
                    "releaseDate": "2023-06-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 327,
                        "hold": 35,
                        "slide": 10,
                        "touch": 19,
                        "break": 6,
                        "total": 397
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11538,
                    "releaseDate": "2023-06-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 477,
                        "hold": 26,
                        "slide": 61,
                        "touch": 24,
                        "break": 23,
                        "total": 611
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11538,
                    "releaseDate": "2023-06-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 563,
                        "hold": 50,
                        "slide": 161,
                        "touch": 41,
                        "break": 14,
                        "total": 829
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11538,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2023-06-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "リフヴェイン",
            "category": "maimai",
            "title": "リフヴェイン",
            "artist": "青栗鼠 feat.sekai",
            "bpm": 148,
            "imageName": "21b28c9973a25650fcba253b2e5a601d7e51a4eaa9d039e2bdb4dcc263c7f947",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 122,
                        "hold": 10,
                        "slide": 3,
                        "touch": 8,
                        "break": 7,
                        "total": 150
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11539,
                    "releaseDate": "2023-06-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 206,
                        "hold": 24,
                        "slide": 8,
                        "touch": 26,
                        "break": 6,
                        "total": 270
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11539,
                    "releaseDate": "2023-06-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 58,
                        "slide": 35,
                        "touch": 22,
                        "break": 50,
                        "total": 383
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11539,
                    "releaseDate": "2023-06-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 407,
                        "hold": 69,
                        "slide": 82,
                        "touch": 54,
                        "break": 31,
                        "total": 643
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11539,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6
                    },
                    "releaseDate": "2023-06-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Kairos",
            "category": "maimai",
            "title": "Kairos",
            "artist": "ARForest feat.nayuta",
            "bpm": 200,
            "imageName": "83ba2b49290d78463a6ad720081f30f579aaa7f1f1e59fd78d1044fd5f9e1b03",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 121,
                        "hold": 11,
                        "slide": 4,
                        "touch": 16,
                        "break": 4,
                        "total": 156
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11540,
                    "releaseDate": "2023-06-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 30,
                        "slide": 6,
                        "touch": 16,
                        "break": 6,
                        "total": 320
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11540,
                    "releaseDate": "2023-06-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 60,
                        "slide": 27,
                        "touch": 23,
                        "break": 21,
                        "total": 418
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11540,
                    "releaseDate": "2023-06-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 430,
                        "hold": 64,
                        "slide": 55,
                        "touch": 25,
                        "break": 17,
                        "total": 591
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11540,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2023-06-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "宵の鳥",
            "category": "maimai",
            "title": "宵の鳥",
            "artist": "n.k feat.影縫英",
            "bpm": 145,
            "imageName": "895b85dddbb9e4b5a85e9b087307b445dde9e812bfb7bea87584e9c7965d0630",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 143,
                        "hold": 11,
                        "slide": 9,
                        "touch": 14,
                        "break": 3,
                        "total": 180
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11541,
                    "releaseDate": "2023-06-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 300,
                        "hold": 12,
                        "slide": 4,
                        "touch": 26,
                        "break": 4,
                        "total": 346
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11541,
                    "releaseDate": "2023-06-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 271,
                        "hold": 38,
                        "slide": 33,
                        "touch": 31,
                        "break": 20,
                        "total": 393
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11541,
                    "releaseDate": "2023-06-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 548,
                        "hold": 50,
                        "slide": 79,
                        "touch": 43,
                        "break": 26,
                        "total": 746
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11541,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6
                    },
                    "releaseDate": "2023-06-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ここからはじまるプロローグ。 (Kanon Remix)",
            "category": "maimai",
            "title": "ここからはじまるプロローグ。 (Kanon Remix)",
            "artist": "ああああ／大国奏音",
            "bpm": 190,
            "imageName": "6f9682b899c066102c5c5b85c0f3bd9f01204f12db9d19d924d75124b6a79035",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 178,
                        "hold": 20,
                        "slide": 4,
                        "touch": 11,
                        "break": 6,
                        "total": 219
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11542,
                    "releaseDate": "2023-07-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 266,
                        "hold": 43,
                        "slide": 8,
                        "touch": 27,
                        "break": 3,
                        "total": 347
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11542,
                    "releaseDate": "2023-07-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 461,
                        "hold": 46,
                        "slide": 43,
                        "touch": 13,
                        "break": 30,
                        "total": 593
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11542,
                    "releaseDate": "2023-07-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 695,
                        "hold": 105,
                        "slide": 71,
                        "touch": 39,
                        "break": 23,
                        "total": 933
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11542,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-07-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "モ°ルモ°ル (MZK Skippin' Remix)",
            "category": "maimai",
            "title": "モ°ルモ°ル (MZK Skippin' Remix)",
            "artist": "sasakure.UK／水野健治",
            "bpm": 136,
            "imageName": "42d4556d1a14fb018dae026fe3d7695dc968af790290497d4d80f18370392f00",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 123,
                        "hold": 11,
                        "slide": 6,
                        "touch": 8,
                        "break": 6,
                        "total": 154
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11543,
                    "releaseDate": "2023-07-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 211,
                        "hold": 21,
                        "slide": 10,
                        "touch": 21,
                        "break": 2,
                        "total": 265
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11543,
                    "releaseDate": "2023-07-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 224,
                        "hold": 103,
                        "slide": 26,
                        "touch": 18,
                        "break": 56,
                        "total": 427
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11543,
                    "releaseDate": "2023-07-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 506,
                        "hold": 47,
                        "slide": 36,
                        "touch": 70,
                        "break": 37,
                        "total": 696
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11543,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-07-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "VERTeX (rintaro soma deconstructed remix)",
            "category": "maimai",
            "title": "VERTeX (rintaro soma deconstructed remix)",
            "artist": "Hiro／rintaro soma",
            "bpm": 158,
            "imageName": "6a94ba75b3aa0ef8028147d852abdbe8cb58e2b850cf6edfe2e3d08070deae59",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 5,
                        "slide": 4,
                        "touch": 17,
                        "break": 10,
                        "total": 236
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11544,
                    "releaseDate": "2023-07-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 255,
                        "hold": 42,
                        "slide": 6,
                        "touch": 27,
                        "break": 4,
                        "total": 334
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11544,
                    "releaseDate": "2023-07-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 436,
                        "hold": 56,
                        "slide": 42,
                        "touch": 47,
                        "break": 37,
                        "total": 618
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11544,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-07-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "rintaro soma",
                    "noteCounts": {
                        "tap": 659,
                        "hold": 32,
                        "slide": 89,
                        "touch": 85,
                        "break": 71,
                        "total": 936
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11544,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.6,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL PLUS": 14.7,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6
                    },
                    "releaseDate": "2023-07-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "あつすぎの歌",
            "category": "POPS＆アニメ",
            "title": "あつすぎの歌",
            "artist": "からめる",
            "bpm": 180,
            "imageName": "d092a2dc73c551444ed4f7a21e14ab429c2206eda607a8a4f2a806fef4182456",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 9,
                        "slide": 4,
                        "touch": 6,
                        "break": 39,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11590,
                    "releaseDate": "2023-07-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 261,
                        "hold": 30,
                        "slide": 8,
                        "touch": 10,
                        "break": 6,
                        "total": 315
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11590,
                    "releaseDate": "2023-07-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 269,
                        "hold": 47,
                        "slide": 29,
                        "touch": 9,
                        "break": 164,
                        "total": 518
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11590,
                    "releaseDate": "2023-07-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 53,
                        "slide": 83,
                        "touch": 83,
                        "break": 242,
                        "total": 806
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11590,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-07-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ULTRA SYNERGY MATRIX",
            "category": "ゲーム＆バラエティ",
            "title": "ULTRA SYNERGY MATRIX",
            "artist": "Tanchiky",
            "bpm": 160,
            "imageName": "afbe179a68cfacf36cdb587490a663448c93cef27de4729c6be12c238a97a057",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 174,
                        "hold": 6,
                        "slide": 4,
                        "touch": 8,
                        "break": 21,
                        "total": 213
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11591,
                    "releaseDate": "2023-07-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 260,
                        "hold": 32,
                        "slide": 6,
                        "touch": 29,
                        "break": 6,
                        "total": 333
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11591,
                    "releaseDate": "2023-07-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 44,
                        "slide": 51,
                        "touch": 54,
                        "break": 34,
                        "total": 519
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11591,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12,
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "FESTiVAL PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2023-07-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 657,
                        "hold": 24,
                        "slide": 64,
                        "touch": 61,
                        "break": 100,
                        "total": 906
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11591,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL PLUS": 14,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14
                    },
                    "releaseDate": "2023-07-07"
                }
            ],
            "searchAcronyms": [
                "USM",
                "我来出勤了"
            ]
        },
        {
            "songId": "はんぶんこ",
            "category": "POPS＆アニメ",
            "title": "はんぶんこ",
            "artist": "三枝明那",
            "bpm": 124,
            "imageName": "c6c67b5c18de82e56bda42a91de09c771672e246ce7fc08d3260a025a18476f9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 99,
                        "hold": 9,
                        "slide": 6,
                        "touch": 6,
                        "break": 5,
                        "total": 125
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11577,
                    "releaseDate": "2023-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 25,
                        "slide": 6,
                        "touch": 13,
                        "break": 5,
                        "total": 246
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11577,
                    "releaseDate": "2023-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 192,
                        "hold": 21,
                        "slide": 38,
                        "touch": 20,
                        "break": 10,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11577,
                    "releaseDate": "2023-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 15,
                        "slide": 77,
                        "touch": 28,
                        "break": 60,
                        "total": 377
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11577,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2023-07-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Vallista",
            "category": "ゲーム＆バラエティ",
            "title": "Vallista",
            "artist": "削除",
            "bpm": 180,
            "imageName": "3b89dcd2e43116e22599d84e414904b830c0f4f06349744b612d1ce3d1987cc9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 104,
                        "hold": 10,
                        "slide": 7,
                        "touch": 28,
                        "break": 5,
                        "total": 154
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11596,
                    "releaseDate": "2023-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 21,
                        "slide": 6,
                        "touch": 28,
                        "break": 6,
                        "total": 343
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11596,
                    "releaseDate": "2023-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 50,
                        "slide": 54,
                        "touch": 5,
                        "break": 57,
                        "total": 517
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11596,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "BUDDiES PLUS": 12.6,
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2023-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 607,
                        "hold": 25,
                        "slide": 41,
                        "touch": 53,
                        "break": 39,
                        "total": 765
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11596,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.1,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "FESTiVAL PLUS": 14.1,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14
                    },
                    "releaseDate": "2023-07-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "テオ",
            "category": "niconico＆ボーカロイド",
            "title": "テオ",
            "artist": "Omoi",
            "bpm": 185,
            "imageName": "5350d3fc2bf7ad80de582c32bdad663201dfc667ff42ecb34c4e0e8d8886d0e1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 10,
                        "slide": 6,
                        "touch": 8,
                        "break": 8,
                        "total": 232
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11598,
                    "releaseDate": "2023-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 294,
                        "hold": 23,
                        "slide": 11,
                        "touch": 15,
                        "break": 21,
                        "total": 364
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11598,
                    "releaseDate": "2023-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "きょむりん",
                    "noteCounts": {
                        "tap": 361,
                        "hold": 85,
                        "slide": 64,
                        "touch": 37,
                        "break": 35,
                        "total": 582
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11598,
                    "releaseDate": "2023-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 657,
                        "hold": 54,
                        "slide": 96,
                        "touch": 49,
                        "break": 109,
                        "total": 965
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11598,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2023-07-21"
                }
            ],
            "searchAcronyms": [
                "Teo"
            ]
        },
        {
            "songId": "MAGENTA POTION",
            "category": "ゲーム＆バラエティ",
            "title": "MAGENTA POTION",
            "artist": "EmoCosine",
            "bpm": 150,
            "imageName": "d04a44dcd14181db74d25e60effce0ee67d38a6647bdfbf2dee98d387be3eeeb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 94,
                        "hold": 16,
                        "slide": 6,
                        "touch": 21,
                        "break": 4,
                        "total": 141
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11607,
                    "releaseDate": "2023-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 26,
                        "slide": 7,
                        "touch": 49,
                        "break": 10,
                        "total": 268
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11607,
                    "releaseDate": "2023-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 260,
                        "hold": 135,
                        "slide": 15,
                        "touch": 45,
                        "break": 31,
                        "total": 486
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11607,
                    "releaseDate": "2023-07-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 651,
                        "hold": 46,
                        "slide": 82,
                        "touch": 20,
                        "break": 19,
                        "total": 818
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11607,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-07-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "隠密あんみつDX",
            "category": "maimai",
            "title": "隠密あんみつDX",
            "artist": "カルロス袴田 feat. 日南めい, 古川由彩",
            "bpm": 155,
            "imageName": "85590470f648d76ecb10b687903fb0f2c8d270717bd9876e15cdff5cf555a3ad",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 147,
                        "hold": 11,
                        "slide": 4,
                        "touch": 7,
                        "break": 11,
                        "total": 180
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11545,
                    "releaseDate": "2023-08-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 12,
                        "slide": 6,
                        "touch": 33,
                        "break": 10,
                        "total": 328
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11545,
                    "releaseDate": "2023-08-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 54,
                        "slide": 38,
                        "touch": 19,
                        "break": 76,
                        "total": 531
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11545,
                    "releaseDate": "2023-08-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 581,
                        "hold": 31,
                        "slide": 117,
                        "touch": 54,
                        "break": 49,
                        "total": 832
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11545,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "FESTiVAL PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2023-08-04"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "地球",
            "category": "maimai",
            "title": "地球",
            "artist": "立秋 feat.ちょこ",
            "bpm": 79,
            "imageName": "5333d75c3243a610e6c15cf9361e996326ec71e6e61a40c42d019d258498972d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 156,
                        "hold": 10,
                        "slide": 6,
                        "touch": 11,
                        "break": 10,
                        "total": 193
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11546,
                    "releaseDate": "2023-08-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 26,
                        "slide": 4,
                        "touch": 13,
                        "break": 10,
                        "total": 398
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11546,
                    "releaseDate": "2023-08-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 379,
                        "hold": 43,
                        "slide": 24,
                        "touch": 24,
                        "break": 97,
                        "total": 567
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11546,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-08-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 600,
                        "hold": 48,
                        "slide": 147,
                        "touch": 45,
                        "break": 50,
                        "total": 890
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11546,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "FESTiVAL PLUS": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3
                    },
                    "releaseDate": "2023-08-04"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Churros Parlor",
            "category": "maimai",
            "title": "Churros Parlor",
            "artist": "ピエロ☆マン",
            "bpm": 190,
            "imageName": "5cab9d666136605527f17f82e940a0713f67a32e872fd603653a90be5d28bc3b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 150,
                        "hold": 11,
                        "slide": 8,
                        "touch": 8,
                        "break": 17,
                        "total": 194
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11547,
                    "releaseDate": "2023-08-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 22,
                        "slide": 9,
                        "touch": 29,
                        "break": 6,
                        "total": 348
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11547,
                    "releaseDate": "2023-08-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 431,
                        "hold": 100,
                        "slide": 26,
                        "touch": 91,
                        "break": 78,
                        "total": 726
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11547,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2023-08-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 540,
                        "hold": 107,
                        "slide": 54,
                        "touch": 126,
                        "break": 142,
                        "total": 969
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11547,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-08-04"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "超熊猫的周遊記（ワンダーパンダートラベラー）",
            "category": "maimai",
            "title": "超熊猫的周遊記（ワンダーパンダートラベラー）",
            "artist": "FANTAGIRAFF",
            "bpm": 121,
            "imageName": "7212cf5730803a09e1c24c6ed0fc6569ba60bbda024dfeab314f5c12dbcbbfc9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 171,
                        "hold": 13,
                        "slide": 4,
                        "touch": 16,
                        "break": 6,
                        "total": 210
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11548,
                    "releaseDate": "2023-08-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 20,
                        "slide": 8,
                        "touch": 24,
                        "break": 9,
                        "total": 319
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11548,
                    "releaseDate": "2023-08-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 416,
                        "hold": 62,
                        "slide": 62,
                        "touch": 32,
                        "break": 51,
                        "total": 623
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11548,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2023-08-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 735,
                        "hold": 63,
                        "slide": 100,
                        "touch": 55,
                        "break": 88,
                        "total": 1041
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11548,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL PLUS": 14.8,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6
                    },
                    "releaseDate": "2023-08-04"
                }
            ],
            "searchAcronyms": [
                "wonder panda",
                "wonder panda traveler",
                "wonder panda traveller"
            ]
        },
        {
            "songId": "まにまに",
            "category": "niconico＆ボーカロイド",
            "title": "まにまに",
            "artist": "r-906",
            "bpm": 174,
            "imageName": "a1ecfd49a830816e3f36b3350222504e390b16a7ec51253ee6bb7237d58a4d60",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 14,
                        "slide": 7,
                        "touch": 15,
                        "break": 11,
                        "total": 182
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11599,
                    "releaseDate": "2023-08-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 288,
                        "hold": 30,
                        "slide": 6,
                        "touch": 16,
                        "break": 6,
                        "total": 346
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11599,
                    "releaseDate": "2023-08-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 371,
                        "hold": 52,
                        "slide": 18,
                        "touch": 25,
                        "break": 60,
                        "total": 526
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11599,
                    "releaseDate": "2023-08-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 501,
                        "hold": 49,
                        "slide": 116,
                        "touch": 37,
                        "break": 24,
                        "total": 727
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11599,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "FESTiVAL PLUS": 12.8,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2023-08-18"
                }
            ],
            "searchAcronyms": [
                "manimani"
            ]
        },
        {
            "songId": "感情ディシーブ",
            "category": "niconico＆ボーカロイド",
            "title": "感情ディシーブ",
            "artist": "ろーある",
            "bpm": 175,
            "imageName": "cd40737bc47977f8814767bf93eef5abfee2178943b00394fe21c2f5991a9730",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 113,
                        "hold": 15,
                        "slide": 6,
                        "touch": 7,
                        "break": 3,
                        "total": 144
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11600,
                    "releaseDate": "2023-08-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 27,
                        "slide": 8,
                        "touch": 50,
                        "break": 2,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11600,
                    "releaseDate": "2023-08-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 55,
                        "slide": 19,
                        "touch": 22,
                        "break": 63,
                        "total": 474
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11600,
                    "releaseDate": "2023-08-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 475,
                        "hold": 57,
                        "slide": 73,
                        "touch": 47,
                        "break": 42,
                        "total": 694
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11600,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2023-08-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ド屑",
            "category": "niconico＆ボーカロイド",
            "title": "ド屑",
            "artist": "なきそ",
            "bpm": 115,
            "imageName": "d835efc72ce2e33fecd2edc3c9421fff3c5c2e9559ca31983b383ac32c4c20bc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 77,
                        "hold": 16,
                        "slide": 4,
                        "touch": 15,
                        "break": 12,
                        "total": 124
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11601,
                    "releaseDate": "2023-08-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 198,
                        "hold": 14,
                        "slide": 8,
                        "touch": 14,
                        "break": 4,
                        "total": 238
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11601,
                    "releaseDate": "2023-08-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 82,
                        "hold": 60,
                        "slide": 19,
                        "touch": 51,
                        "break": 12,
                        "total": 224
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11601,
                    "releaseDate": "2023-08-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 390,
                        "hold": 42,
                        "slide": 114,
                        "touch": 33,
                        "break": 33,
                        "total": 612
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11601,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2023-08-18"
                }
            ],
            "searchAcronyms": [
                "dokuzu"
            ]
        },
        {
            "songId": "絶対敵対メチャキライヤー",
            "category": "niconico＆ボーカロイド",
            "title": "絶対敵対メチャキライヤー",
            "artist": "メドミア",
            "bpm": 190,
            "imageName": "5b3270309d4b4fdf0847a4a5c75ad111e5ccc08cc95ddfd2cb97cd82219bdd90",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 10,
                        "slide": 8,
                        "touch": 8,
                        "break": 9,
                        "total": 163
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11602,
                    "releaseDate": "2023-08-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 27,
                        "slide": 10,
                        "touch": 60,
                        "break": 10,
                        "total": 306
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11602,
                    "releaseDate": "2023-08-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 49,
                        "slide": 15,
                        "touch": 24,
                        "break": 29,
                        "total": 473
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11602,
                    "releaseDate": "2023-08-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 431,
                        "hold": 74,
                        "slide": 127,
                        "touch": 34,
                        "break": 69,
                        "total": 735
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11602,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "FESTiVAL PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2023-08-18"
                }
            ],
            "searchAcronyms": [
                "Absolute Hostility, I Hate You So Much!",
                "Unfriendly Hater",
                "Zettai Tekitai Mecha Kirai yaa"
            ]
        },
        {
            "songId": "STARRED HEART",
            "category": "オンゲキ＆CHUNITHM",
            "title": "STARRED HEART",
            "artist": "曲：広川恵一 (MONACA)／歌：オンゲキシューターズ",
            "bpm": 140,
            "imageName": "e63fdfd7d6236b853cf16ab5ef97fe648d608bd1aca532e28ac20a2980ba95e7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 112,
                        "hold": 12,
                        "slide": 4,
                        "touch": 12,
                        "break": 10,
                        "total": 150
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11551,
                    "releaseDate": "2023-09-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 14,
                        "slide": 9,
                        "touch": 20,
                        "break": 4,
                        "total": 233
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11551,
                    "releaseDate": "2023-09-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 217,
                        "hold": 19,
                        "slide": 87,
                        "touch": 41,
                        "break": 15,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11551,
                    "releaseDate": "2023-09-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 299,
                        "hold": 19,
                        "slide": 109,
                        "touch": 20,
                        "break": 35,
                        "total": 482
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11551,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "BUDDiES PLUS": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2023-09-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Y.Y.Y.計画!!!!",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Y.Y.Y.計画!!!!",
            "artist": "曲：烏屋茶房／歌：R.B.P. [九條 楓(CV：佳村 はるか)、逢坂 茜(CV：大空 直美)、珠洲島 有栖(CV：長縄 まりあ)]",
            "bpm": 186,
            "imageName": "6928a87d47ab733382360ff486501cc5b588dca91bd39739c162b3cc80c61c7c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 171,
                        "hold": 12,
                        "slide": 7,
                        "touch": 8,
                        "break": 20,
                        "total": 218
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11552,
                    "releaseDate": "2023-09-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 19,
                        "slide": 9,
                        "touch": 28,
                        "break": 6,
                        "total": 392
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11552,
                    "releaseDate": "2023-09-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 464,
                        "hold": 42,
                        "slide": 36,
                        "touch": 35,
                        "break": 49,
                        "total": 626
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11552,
                    "releaseDate": "2023-09-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 529,
                        "hold": 41,
                        "slide": 108,
                        "touch": 111,
                        "break": 158,
                        "total": 947
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11552,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "FESTiVAL PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2023-09-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Last Kingdom",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Last Kingdom",
            "artist": "USAO",
            "bpm": 150,
            "imageName": "5bb41078ff7013e2f546d623b16a198d33b53fbb1911aa612342ce4bcb584b14",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 13,
                        "slide": 6,
                        "touch": 15,
                        "break": 15,
                        "total": 206
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11553,
                    "releaseDate": "2023-09-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 261,
                        "hold": 21,
                        "slide": 8,
                        "touch": 29,
                        "break": 8,
                        "total": 327
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11553,
                    "releaseDate": "2023-09-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 452,
                        "hold": 74,
                        "slide": 37,
                        "touch": 9,
                        "break": 60,
                        "total": 632
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11553,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "FESTiVAL PLUS": 12.5,
                        "PRiSM": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2023-09-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 562,
                        "hold": 98,
                        "slide": 64,
                        "touch": 53,
                        "break": 74,
                        "total": 851
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11553,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-09-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "LAMIA",
            "category": "オンゲキ＆CHUNITHM",
            "title": "LAMIA",
            "artist": "BlackY",
            "bpm": 199,
            "imageName": "88c0e851ff75ea8e94e0bdae0997c54d40876e5614de60768a808a0af590ca9d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 17,
                        "slide": 7,
                        "touch": 21,
                        "break": 7,
                        "total": 264
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11554,
                    "releaseDate": "2023-09-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 34,
                        "slide": 4,
                        "touch": 16,
                        "break": 3,
                        "total": 363
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11554,
                    "releaseDate": "2023-09-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 483,
                        "hold": 64,
                        "slide": 33,
                        "touch": 35,
                        "break": 144,
                        "total": 759
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11554,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "FESTiVAL PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2023-09-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "譜面ボーイズからの挑戦状",
                    "noteCounts": {
                        "tap": 712,
                        "hold": 65,
                        "slide": 67,
                        "touch": 56,
                        "break": 99,
                        "total": 999
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "FESTiVAL PLUS",
                    "internalId": 11554,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "FESTiVAL PLUS": 14.7,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7
                    },
                    "releaseDate": "2023-09-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "PUPA",
            "category": "ゲーム＆バラエティ",
            "title": "PUPA",
            "artist": "モリモリあつし",
            "bpm": 202,
            "imageName": "86696efc4ff72afa3c9c1805b3f079c79ccfe8875f0b0be8dc8398361bc782f5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 177,
                        "hold": 16,
                        "slide": 4,
                        "touch": 14,
                        "break": 10,
                        "total": 221
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11578,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 253,
                        "hold": 28,
                        "slide": 11,
                        "touch": 27,
                        "break": 6,
                        "total": 325
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11578,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 457,
                        "hold": 61,
                        "slide": 52,
                        "touch": 43,
                        "break": 53,
                        "total": 666
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11578,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 714,
                        "hold": 75,
                        "slide": 76,
                        "touch": 26,
                        "break": 73,
                        "total": 964
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11578,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.5,
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4
                    },
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "解けないように",
            "category": "東方Project",
            "title": "解けないように",
            "artist": "KIHOW from MYTH & ROID",
            "bpm": 112,
            "imageName": "599126e74f2ded2e5a5d54db0241ff586dc030cb8da65ad87e6c43c676884ae7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 140,
                        "hold": 14,
                        "slide": 3,
                        "touch": 7,
                        "break": 5,
                        "total": 169
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11580,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 235,
                        "hold": 29,
                        "slide": 3,
                        "touch": 27,
                        "break": 5,
                        "total": 299
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11580,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.8,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 37,
                        "slide": 22,
                        "touch": 20,
                        "break": 41,
                        "total": 392
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11580,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 9.8
                    },
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 479,
                        "hold": 30,
                        "slide": 69,
                        "touch": 28,
                        "break": 22,
                        "total": 628
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11580,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "NOIZY BOUNCE",
            "category": "maimai",
            "title": "NOIZY BOUNCE",
            "artist": "八王子P feat. ななひら・まめこ",
            "bpm": 150,
            "imageName": "d11e96982d4aff03360ca3056861bed6193880f0cc250a61c3d5f2e4ffe98f65",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 85,
                        "hold": 11,
                        "slide": 4,
                        "touch": 26,
                        "break": 10,
                        "total": 136
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11608,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 14,
                        "slide": 11,
                        "touch": 24,
                        "break": 7,
                        "total": 293
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11608,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 207,
                        "hold": 109,
                        "slide": 12,
                        "touch": 32,
                        "break": 59,
                        "total": 419
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11608,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー & サファ太",
                    "noteCounts": {
                        "tap": 556,
                        "hold": 49,
                        "slide": 67,
                        "touch": 3,
                        "break": 33,
                        "total": 708
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11608,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "サンバディ！",
            "category": "maimai",
            "title": "サンバディ！",
            "artist": "水野健治 feat.光吉猛修",
            "bpm": 136,
            "imageName": "137a8bcc05be07d995c108b39b153ffa6ca3130c0245ac7a34236a01bad08694",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 9,
                        "slide": 2,
                        "touch": 12,
                        "break": 5,
                        "total": 185
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11609,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 24,
                        "slide": 12,
                        "touch": 13,
                        "break": 8,
                        "total": 307
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11609,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 19,
                        "slide": 31,
                        "touch": 31,
                        "break": 50,
                        "total": 442
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11609,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 586,
                        "hold": 35,
                        "slide": 103,
                        "touch": 33,
                        "break": 32,
                        "total": 789
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11609,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Horoscope Express",
            "category": "maimai",
            "title": "Horoscope Express",
            "artist": "pan",
            "bpm": 236,
            "imageName": "289fa9c3ac8a729771addfc84b771cca1ce00b8b5cddab4ab8149a732d99f45c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 140,
                        "hold": 14,
                        "slide": 5,
                        "touch": 21,
                        "break": 1,
                        "total": 181
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11610,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 296,
                        "hold": 25,
                        "slide": 8,
                        "touch": 14,
                        "break": 4,
                        "total": 347
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11610,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 411,
                        "hold": 71,
                        "slide": 36,
                        "touch": 27,
                        "break": 14,
                        "total": 559
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11610,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "あまくちジンジャー",
                    "noteCounts": {
                        "tap": 506,
                        "hold": 79,
                        "slide": 81,
                        "touch": 76,
                        "break": 30,
                        "total": 772
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11610,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14
                    },
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Party☆People☆Princess",
            "category": "maimai",
            "title": "Party☆People☆Princess",
            "artist": "Sound Artz",
            "bpm": 152,
            "imageName": "1088552807a82bf43dc346953569ec5d0a871099ee244000b78638b897535dd5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 12,
                        "slide": 4,
                        "touch": 12,
                        "break": 9,
                        "total": 221
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11611,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 252,
                        "hold": 13,
                        "slide": 8,
                        "touch": 27,
                        "break": 8,
                        "total": 308
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11611,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 91,
                        "slide": 50,
                        "touch": 52,
                        "break": 49,
                        "total": 587
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11611,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 11.9
                    },
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "鳩ホルダー & Luxizhel",
                    "noteCounts": {
                        "tap": 590,
                        "hold": 69,
                        "slide": 80,
                        "touch": 74,
                        "break": 72,
                        "total": 885
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11611,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3
                    },
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "SQUAD-Phvntom-",
            "category": "オンゲキ＆CHUNITHM",
            "title": "SQUAD-Phvntom-",
            "artist": "Getty vs DJ DiA",
            "bpm": 200,
            "imageName": "93acdffee0e7cae26c689bff1b7d184e3a1839bd112449af6691f3434a18f99a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 167,
                        "hold": 11,
                        "slide": 4,
                        "touch": 20,
                        "break": 6,
                        "total": 208
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11624,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 22,
                        "slide": 12,
                        "touch": 26,
                        "break": 5,
                        "total": 349
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11624,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 545,
                        "hold": 59,
                        "slide": 47,
                        "touch": 23,
                        "break": 43,
                        "total": 717
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11624,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "Ruby",
                    "noteCounts": {
                        "tap": 708,
                        "hold": 51,
                        "slide": 88,
                        "touch": 77,
                        "break": 140,
                        "total": 1064
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11624,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3
                    },
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "GEOMETRIC DANCE",
            "category": "オンゲキ＆CHUNITHM",
            "title": "GEOMETRIC DANCE",
            "artist": "山本真央樹",
            "bpm": 150,
            "imageName": "de53928e8405414348490adbe7a3a2a975c814036c0d72c04d348c5bb3d4a3aa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 14,
                        "slide": 8,
                        "touch": 12,
                        "break": 6,
                        "total": 197
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11625,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 42,
                        "slide": 5,
                        "touch": 26,
                        "break": 5,
                        "total": 311
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11625,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 564,
                        "hold": 46,
                        "slide": 51,
                        "touch": 39,
                        "break": 41,
                        "total": 741
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11625,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 873,
                        "hold": 36,
                        "slide": 43,
                        "touch": 92,
                        "break": 23,
                        "total": 1067
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11625,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4
                    },
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "熱異常",
            "category": "niconico＆ボーカロイド",
            "title": "熱異常",
            "artist": "いよわ",
            "bpm": 183,
            "imageName": "19236c346533442f4fd0124a5b57e4418716dfda3e9062d647518092c19711e6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 129,
                        "hold": 13,
                        "slide": 6,
                        "touch": 32,
                        "break": 6,
                        "total": 186
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11629,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 310,
                        "hold": 27,
                        "slide": 6,
                        "touch": 13,
                        "break": 4,
                        "total": 360
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11629,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 413,
                        "hold": 53,
                        "slide": 7,
                        "touch": 14,
                        "break": 51,
                        "total": 538
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11629,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.1,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 441,
                        "hold": 125,
                        "slide": 74,
                        "touch": 40,
                        "break": 23,
                        "total": 703
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11629,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 11.8,
                        "CiRCLE": 12.1,
                        "CiRCLE PLUS": 12.1,
                        "PRiSM PLUS": 12.1
                    },
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 693,
                        "hold": 19,
                        "slide": 137,
                        "touch": 113,
                        "break": 34,
                        "total": 996
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11629,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2023-09-13"
                }
            ],
            "searchAcronyms": [
                "Heat Abnormal",
                "netsu ijou"
            ]
        },
        {
            "songId": "1000年生きてる",
            "category": "niconico＆ボーカロイド",
            "title": "1000年生きてる",
            "artist": "いよわ",
            "bpm": 100,
            "imageName": "f894a3eced16bb956c38290809108099f93a703d134ec93e15893b1482abd9bf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 119,
                        "hold": 14,
                        "slide": 4,
                        "touch": 16,
                        "break": 3,
                        "total": 156
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11630,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 22,
                        "slide": 4,
                        "touch": 15,
                        "break": 5,
                        "total": 302
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11630,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 271,
                        "hold": 31,
                        "slide": 10,
                        "touch": 50,
                        "break": 25,
                        "total": 387
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11630,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 9
                    },
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 404,
                        "hold": 46,
                        "slide": 96,
                        "touch": 38,
                        "break": 17,
                        "total": 601
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11630,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": [
                "1000nen ikiteru Living Millenium",
                "Living for a millenium"
            ]
        },
        {
            "songId": "IMAWANOKIWA",
            "category": "niconico＆ボーカロイド",
            "title": "IMAWANOKIWA",
            "artist": "いよわ",
            "bpm": 178,
            "imageName": "a3651741a512cb7e383b2899fa7fb95fcfb6ba58809dbb825c1618dd78a583d7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 124,
                        "hold": 12,
                        "slide": 6,
                        "touch": 15,
                        "break": 4,
                        "total": 161
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11631,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 30,
                        "slide": 12,
                        "touch": 14,
                        "break": 2,
                        "total": 335
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11631,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 385,
                        "hold": 58,
                        "slide": 44,
                        "touch": 14,
                        "break": 41,
                        "total": 542
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11631,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 608,
                        "hold": 158,
                        "slide": 70,
                        "touch": 21,
                        "break": 28,
                        "total": 885
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11631,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Play merrily NEO",
            "category": "ゲーム＆バラエティ",
            "title": "Play merrily NEO",
            "artist": "Shohei Tsuchiya (ZUNTATA) feat. Aimee B",
            "bpm": 180,
            "imageName": "d5f644336cebb90f25d94bafb720dfaa7a0f49a63a47c9ff8af125a308659c95",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 120,
                        "hold": 8,
                        "slide": 4,
                        "touch": 13,
                        "break": 4,
                        "total": 149
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11632,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 12,
                        "slide": 6,
                        "touch": 29,
                        "break": 4,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11632,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "ミニミライト",
                    "noteCounts": {
                        "tap": 432,
                        "hold": 30,
                        "slide": 22,
                        "touch": 8,
                        "break": 20,
                        "total": 512
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11632,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 524,
                        "hold": 25,
                        "slide": 73,
                        "touch": 71,
                        "break": 46,
                        "total": 739
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11632,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "OMAKENO Stroke",
            "category": "ゲーム＆バラエティ",
            "title": "OMAKENO Stroke",
            "artist": "t+pazolite",
            "bpm": 240,
            "imageName": "5631939fd9e47752accc3f278a32747a4e9a8d37e52f7bec44a46c0931d2590d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 147,
                        "hold": 10,
                        "slide": 4,
                        "touch": 22,
                        "break": 6,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11633,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 27,
                        "slide": 6,
                        "touch": 14,
                        "break": 10,
                        "total": 339
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11633,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.9,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 76,
                        "slide": 24,
                        "touch": 10,
                        "break": 17,
                        "total": 476
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11633,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 11.9
                    },
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 516,
                        "hold": 35,
                        "slide": 88,
                        "touch": 57,
                        "break": 33,
                        "total": 729
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11633,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "青春コンプレックス",
            "category": "POPS＆アニメ",
            "title": "青春コンプレックス",
            "artist": "結束バンド",
            "bpm": 190,
            "imageName": "e68b336baa20bd425ffe945ac67b35c44c602acad676fcf09f728c257af93c01",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 143,
                        "hold": 13,
                        "slide": 6,
                        "touch": 13,
                        "break": 7,
                        "total": 182
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11634,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 12,
                        "slide": 14,
                        "touch": 16,
                        "break": 5,
                        "total": 325
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11634,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 414,
                        "hold": 76,
                        "slide": 84,
                        "touch": 25,
                        "break": 27,
                        "total": 626
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11634,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 10
                    },
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.8,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 532,
                        "hold": 49,
                        "slide": 121,
                        "touch": 23,
                        "break": 98,
                        "total": 823
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11634,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 11.8
                    },
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 708,
                        "hold": 45,
                        "slide": 119,
                        "touch": 35,
                        "break": 54,
                        "total": 961
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11634,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-09-13"
                }
            ],
            "searchAcronyms": [
                "seishun complex"
            ]
        },
        {
            "songId": "さくゆいたいそう",
            "category": "POPS＆アニメ",
            "title": "さくゆいたいそう",
            "artist": "さくゆい",
            "bpm": 160,
            "imageName": "009e97266453da8b43416770817b61056d8edca9ddee4d26819bfbf59a7fc502",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 124,
                        "hold": 16,
                        "slide": 6,
                        "touch": 14,
                        "break": 3,
                        "total": 163
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11636,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 269,
                        "hold": 24,
                        "slide": 2,
                        "touch": 26,
                        "break": 14,
                        "total": 335
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11636,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "佑",
                    "noteCounts": {
                        "tap": 421,
                        "hold": 50,
                        "slide": 29,
                        "touch": 15,
                        "break": 23,
                        "total": 538
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11636,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "メロンポップ",
                    "noteCounts": {
                        "tap": 381,
                        "hold": 129,
                        "slide": 69,
                        "touch": 41,
                        "break": 61,
                        "total": 681
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11636,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": [
                "sakuyui taisou"
            ]
        },
        {
            "songId": "バグ",
            "category": "niconico＆ボーカロイド",
            "title": "バグ",
            "artist": "かいりきベア",
            "bpm": 186,
            "imageName": "bc3de6138414088ef1c82f9c9d231cda5b2a9c42741569ab7454670e453cc1ca",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 17,
                        "slide": 7,
                        "touch": 8,
                        "break": 11,
                        "total": 188
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11637,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 50,
                        "slide": 6,
                        "touch": 24,
                        "break": 8,
                        "total": 366
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11637,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10.2,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 413,
                        "hold": 80,
                        "slide": 36,
                        "touch": 19,
                        "break": 70,
                        "total": 618
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11637,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 10.2
                    },
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.8,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 389,
                        "hold": 134,
                        "slide": 107,
                        "touch": 28,
                        "break": 55,
                        "total": 713
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11637,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 11.8
                    },
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 705,
                        "hold": 71,
                        "slide": 101,
                        "touch": 23,
                        "break": 89,
                        "total": 989
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11637,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-09-13"
                }
            ],
            "searchAcronyms": [
                "Bug"
            ]
        },
        {
            "songId": "アルカンシエル",
            "category": "ゲーム＆バラエティ",
            "title": "アルカンシエル",
            "artist": "Yamajet",
            "bpm": 176,
            "imageName": "9022d83ae601efb49371ce125812ae85c6d9f9ee9b3d17edae09e8e12fa62362",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 148,
                        "hold": 18,
                        "slide": 5,
                        "touch": 12,
                        "break": 3,
                        "total": 186
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11664,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 32,
                        "slide": 6,
                        "touch": 26,
                        "break": 6,
                        "total": 321
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11664,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 394,
                        "hold": 57,
                        "slide": 39,
                        "touch": 18,
                        "break": 29,
                        "total": 537
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11664,
                    "releaseDate": "2023-09-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 488,
                        "hold": 51,
                        "slide": 56,
                        "touch": 31,
                        "break": 44,
                        "total": 670
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11664,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[協]Love You",
            "category": "宴会場",
            "title": "[協]Love You",
            "artist": "Q;indivi [cover]",
            "bpm": null,
            "imageName": "96141297a26510f6cd1f1eaac1cda7f6be8180c8aa6b633c5b0816603ea1e138",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【協】",
                    "level": "12?",
                    "internalLevelValue": 12,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100018,
                    "version": "BUDDiES",
                    "comment": "リア充専用譜面だよ！リア充向けだってば！",
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[協]恋愛裁判",
            "category": "宴会場",
            "title": "[協]恋愛裁判",
            "artist": "40mP",
            "bpm": null,
            "imageName": "1c571d729acf820e3e8cd0b8d933fe39446f30f1dda075b54b4f8f06b10ba994",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【協】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100508,
                    "version": "BUDDiES",
                    "comment": "リア充向け譜面　～爆発しろ～",
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[協]Hand in Hand",
            "category": "宴会場",
            "title": "[協]Hand in Hand",
            "artist": "livetune",
            "bpm": null,
            "imageName": "44d678f9502dae022c55a853ab90f0f5ccd8e8c0083a37347c2208fc71845a29",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【協】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100524,
                    "version": "BUDDiES",
                    "comment": "Hand in Hand in Hand in Hand",
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[協]疾走あんさんぶる",
            "category": "宴会場",
            "title": "[協]疾走あんさんぶる",
            "artist": "ビートまりお（COOL&CREATE）",
            "bpm": null,
            "imageName": "7d8fec9fc105277e51093c9bb905e494508630466965c87fee74df08b4c2d961",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【協】",
                    "level": "14?",
                    "internalLevelValue": 14,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100700,
                    "version": "BUDDiES",
                    "comment": "なりきれ！プリズムリバー三姉妹",
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[協]ラグトレイン",
            "category": "宴会場",
            "title": "[協]ラグトレイン",
            "artist": "稲葉曇",
            "bpm": null,
            "imageName": "563698fbc4f01aa986477d56e3a5cbb2a6830ec1377c371bc7d1834615171f34",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【協】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111355,
                    "version": "BUDDiES",
                    "comment": "＼みんなでラグトレイン再現チャレンジ／",
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[奏]アカツキアライヴァル",
            "category": "宴会場",
            "title": "[奏]アカツキアライヴァル",
            "artist": "Last Note.",
            "bpm": null,
            "imageName": "7aa766dce28d28fbd9c3135d422bc423b28e6c0afaf787a6503fe88334572570",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【奏】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111359,
                    "version": "BUDDiES",
                    "comment": "ライバル譜面",
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[協]青春コンプレックス（ヒーロー級）",
            "category": "宴会場",
            "title": "[協]青春コンプレックス",
            "artist": "結束バンド",
            "bpm": null,
            "imageName": "e68b336baa20bd425ffe945ac67b35c44c602acad676fcf09f728c257af93c01",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【協】",
                    "level": "14+?",
                    "internalLevelValue": 14.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "BUDDiES",
                    "comment": "バンドメンバーを集めて挑め！（ヒーロー級）",
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[協]青春コンプレックス（入門編）",
            "category": "宴会場",
            "title": "[協]青春コンプレックス",
            "artist": "結束バンド",
            "bpm": null,
            "imageName": "e68b336baa20bd425ffe945ac67b35c44c602acad676fcf09f728c257af93c01",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【協】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 121634,
                    "version": "BUDDiES",
                    "comment": "バンドメンバーを集めて楽しもう！（入門編）",
                    "releaseDate": "2023-09-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Mystic Parade",
            "category": "maimai",
            "title": "Mystic Parade",
            "artist": "ひとしずく×やま△ feat.悠佑＆ないこ（いれいす）",
            "bpm": 133,
            "imageName": "53c1f2d02e73896e4684801ff180a3da7952d47c5a88376716e086a1c5428f29",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 125,
                        "hold": 13,
                        "slide": 6,
                        "touch": 13,
                        "break": 8,
                        "total": 165
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11613,
                    "releaseDate": "2023-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 242,
                        "hold": 18,
                        "slide": 8,
                        "touch": 27,
                        "break": 10,
                        "total": 305
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11613,
                    "releaseDate": "2023-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 429,
                        "hold": 44,
                        "slide": 44,
                        "touch": 15,
                        "break": 50,
                        "total": 582
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11613,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 10
                    },
                    "releaseDate": "2023-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 681,
                        "hold": 46,
                        "slide": 82,
                        "touch": 24,
                        "break": 63,
                        "total": 896
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11613,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2023-09-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Cry Cry Cry",
            "category": "maimai",
            "title": "Cry Cry Cry",
            "artist": "FLG4 feat.Flower",
            "bpm": 123,
            "imageName": "29beb683044b1b49cb7289f2374d3bc18e067e68d1ea27325092d624ead48103",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 93,
                        "hold": 10,
                        "slide": 7,
                        "touch": 18,
                        "break": 7,
                        "total": 135
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11614,
                    "releaseDate": "2023-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 12,
                        "slide": 14,
                        "touch": 27,
                        "break": 8,
                        "total": 293
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11614,
                    "releaseDate": "2023-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 242,
                        "hold": 88,
                        "slide": 32,
                        "touch": 38,
                        "break": 32,
                        "total": 432
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11614,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 9.8
                    },
                    "releaseDate": "2023-09-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 523,
                        "hold": 57,
                        "slide": 68,
                        "touch": 42,
                        "break": 16,
                        "total": 706
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11614,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-09-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ノンブレス・オブリージュ",
            "category": "niconico＆ボーカロイド",
            "title": "ノンブレス・オブリージュ",
            "artist": "ピノキオピー",
            "bpm": 148,
            "imageName": "a08979e0952e03d7124c6a66066cc0d0a9e51a0689dce3a8eb6663714c1b7c23",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 9,
                        "slide": 4,
                        "touch": 16,
                        "break": 3,
                        "total": 141
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11597,
                    "releaseDate": "2023-10-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 11,
                        "slide": 8,
                        "touch": 25,
                        "break": 8,
                        "total": 279
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11597,
                    "releaseDate": "2023-10-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 38,
                        "slide": 26,
                        "touch": 25,
                        "break": 15,
                        "total": 345
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11597,
                    "releaseDate": "2023-10-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 102,
                        "hold": 281,
                        "slide": 39,
                        "touch": 15,
                        "break": 28,
                        "total": 465
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11597,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2023-10-06"
                }
            ],
            "searchAcronyms": [
                "Nonbreath",
                "Nonbreath oblige"
            ]
        },
        {
            "songId": "Latent Kingdom",
            "category": "maimai",
            "title": "Latent Kingdom",
            "artist": "Laur vs 大国奏音",
            "bpm": 201,
            "imageName": "20198bad2d04ce29266fa1bb6c8fdc3e24c272c6c67cf7242936987f05a7c21f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 18,
                        "slide": 9,
                        "touch": 29,
                        "break": 8,
                        "total": 269
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11612,
                    "releaseDate": "2023-10-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 377,
                        "hold": 30,
                        "slide": 12,
                        "touch": 17,
                        "break": 4,
                        "total": 440
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11612,
                    "releaseDate": "2023-10-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 530,
                        "hold": 99,
                        "slide": 39,
                        "touch": 46,
                        "break": 68,
                        "total": 782
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11612,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-10-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.9,
                    "noteDesigner": "Safata.GHz",
                    "noteCounts": {
                        "tap": 984,
                        "hold": 45,
                        "slide": 124,
                        "touch": 64,
                        "break": 154,
                        "total": 1371
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11612,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.9,
                        "CiRCLE": 14.9,
                        "CiRCLE PLUS": 14.9,
                        "PRiSM": 14.9,
                        "PRiSM PLUS": 14.9
                    },
                    "releaseDate": "2023-10-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "星界ちゃんと可不ちゃんのおつかい合騒曲",
            "category": "niconico＆ボーカロイド",
            "title": "星界ちゃんと可不ちゃんのおつかい合騒曲",
            "artist": "南ノ南",
            "bpm": 220,
            "imageName": "9538d6320c853768cbd14eb03f9850f949d44bfcca15037fecf67c340aaf13f5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 189,
                        "hold": 16,
                        "slide": 6,
                        "touch": 23,
                        "break": 5,
                        "total": 239
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11638,
                    "releaseDate": "2023-10-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 314,
                        "hold": 23,
                        "slide": 6,
                        "touch": 16,
                        "break": 10,
                        "total": 369
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11638,
                    "releaseDate": "2023-10-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 475,
                        "hold": 58,
                        "slide": 80,
                        "touch": 43,
                        "break": 51,
                        "total": 707
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11638,
                    "releaseDate": "2023-10-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 616,
                        "hold": 75,
                        "slide": 224,
                        "touch": 62,
                        "break": 68,
                        "total": 1045
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11638,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-10-06"
                }
            ],
            "searchAcronyms": [
                "Sekai chan",
                "Sekai-Chan and Kafu-Chan's Otsukai Gassoukyoku",
                "sekaseka"
            ]
        },
        {
            "songId": "Burn My Soul",
            "category": "POPS＆アニメ",
            "title": "Burn My Soul",
            "artist": "She is Legend",
            "bpm": 180,
            "imageName": "5b3ba83577d4d6ab72e546d8a1a4217d82814e977b0d1ae4c83389bd4d8152e1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 14,
                        "slide": 4,
                        "touch": 14,
                        "break": 2,
                        "total": 218
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11639,
                    "releaseDate": "2023-10-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 294,
                        "hold": 23,
                        "slide": 9,
                        "touch": 30,
                        "break": 10,
                        "total": 366
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11639,
                    "releaseDate": "2023-10-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 440,
                        "hold": 42,
                        "slide": 47,
                        "touch": 25,
                        "break": 29,
                        "total": 583
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11639,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 10.5
                    },
                    "releaseDate": "2023-10-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 569,
                        "hold": 16,
                        "slide": 144,
                        "touch": 20,
                        "break": 58,
                        "total": 807
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11639,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-10-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[宴]Oshama Scramble!",
            "category": "宴会場",
            "title": "[宴]Oshama Scramble!",
            "artist": "t+pazolite",
            "bpm": null,
            "imageName": "bc7cd87b2a854f63049f834d7ecd9733724424188dc1dae53b33234c70d585b1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【宴】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100363,
                    "version": "BUDDiES",
                    "comment": "Let's Party Night !",
                    "releaseDate": "2023-10-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ぽわわん劇場",
            "category": "maimai",
            "title": "ぽわわん劇場",
            "artist": "ぽわわん劇場",
            "bpm": 190,
            "imageName": "2df628bd88ee529082c9c4bd802270e4c62c461b4ffa8f750f924363fe301fca",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 13,
                        "slide": 8,
                        "touch": 17,
                        "break": 5,
                        "total": 219
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11615,
                    "releaseDate": "2023-10-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 314,
                        "hold": 16,
                        "slide": 16,
                        "touch": 29,
                        "break": 6,
                        "total": 381
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11615,
                    "releaseDate": "2023-10-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 461,
                        "hold": 45,
                        "slide": 65,
                        "touch": 27,
                        "break": 19,
                        "total": 617
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11615,
                    "releaseDate": "2023-10-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 498,
                        "hold": 86,
                        "slide": 112,
                        "touch": 58,
                        "break": 46,
                        "total": 800
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11615,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2023-10-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "my flow",
            "category": "maimai",
            "title": "my flow",
            "artist": "crayvxn",
            "bpm": 157,
            "imageName": "96a17595f6f0797b4fe081e6b5665032a090e656d6d18ee9809402c873405809",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 123,
                        "hold": 15,
                        "slide": 6,
                        "touch": 6,
                        "break": 6,
                        "total": 156
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11616,
                    "releaseDate": "2023-10-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 6,
                        "slide": 10,
                        "touch": 24,
                        "break": 8,
                        "total": 304
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11616,
                    "releaseDate": "2023-10-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 323,
                        "hold": 43,
                        "slide": 62,
                        "touch": 28,
                        "break": 37,
                        "total": 493
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11616,
                    "releaseDate": "2023-10-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 443,
                        "hold": 62,
                        "slide": 58,
                        "touch": 59,
                        "break": 61,
                        "total": 683
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11616,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-10-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "POWER OF UNITY",
            "category": "maimai",
            "title": "POWER OF UNITY",
            "artist": "Zekk",
            "bpm": 190,
            "imageName": "ecc16e5da7753f2e8bd880b933ced1fb5de8fd63b9505d0dc85b4abe80230528",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 213,
                        "hold": 15,
                        "slide": 3,
                        "touch": 6,
                        "break": 5,
                        "total": 242
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11617,
                    "releaseDate": "2023-10-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 326,
                        "hold": 18,
                        "slide": 4,
                        "touch": 29,
                        "break": 8,
                        "total": 385
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11617,
                    "releaseDate": "2023-10-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 434,
                        "hold": 35,
                        "slide": 32,
                        "touch": 17,
                        "break": 45,
                        "total": 563
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11617,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12,
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2023-10-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 651,
                        "hold": 15,
                        "slide": 93,
                        "touch": 74,
                        "break": 80,
                        "total": 913
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11617,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-10-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Energizing Flame",
            "category": "maimai",
            "title": "Energizing Flame",
            "artist": "Artifact vs. Dualcast",
            "bpm": 201,
            "imageName": "30f00531c0c63e9d480d4e7264219a4e1e6b076cc9beeed717bd7f8af2f7871d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 213,
                        "hold": 11,
                        "slide": 12,
                        "touch": 7,
                        "break": 15,
                        "total": 258
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11618,
                    "releaseDate": "2023-10-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 20,
                        "slide": 15,
                        "touch": 22,
                        "break": 13,
                        "total": 388
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11618,
                    "releaseDate": "2023-10-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 469,
                        "hold": 103,
                        "slide": 53,
                        "touch": 55,
                        "break": 66,
                        "total": 746
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11618,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-10-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 666,
                        "hold": 36,
                        "slide": 104,
                        "touch": 59,
                        "break": 101,
                        "total": 966
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11618,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4
                    },
                    "releaseDate": "2023-10-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "KHYMΞXΛ",
            "category": "maimai",
            "title": "KHYMΞXΛ",
            "artist": "のらねこさい feat.ricono",
            "bpm": 220,
            "imageName": "696d2325eef6f5f6bdd7005898830424c1fcda46f83b085f0233ec2622fafc39",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 246,
                        "hold": 13,
                        "slide": 4,
                        "touch": 7,
                        "break": 12,
                        "total": 282
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11619,
                    "releaseDate": "2023-11-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 21,
                        "slide": 12,
                        "touch": 22,
                        "break": 8,
                        "total": 405
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11619,
                    "releaseDate": "2023-11-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 73,
                        "slide": 21,
                        "touch": 24,
                        "break": 91,
                        "total": 611
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11619,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2023-11-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "鳩サファzhel",
                    "noteCounts": {
                        "tap": 672,
                        "hold": 84,
                        "slide": 56,
                        "touch": 19,
                        "break": 150,
                        "total": 981
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "FESTiVAL PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11619,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7
                    },
                    "releaseDate": "2023-11-02"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "with U",
            "category": "ゲーム＆バラエティ",
            "title": "with U",
            "artist": "t+pazolite & Massive New Krew feat. リリィ(CV:青木志貴)",
            "bpm": 155,
            "imageName": "0fc5776cb8f7db1ca36ee9957801eed389c10cedadedb444fb51cf6b0dec176c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 164,
                        "hold": 11,
                        "slide": 8,
                        "touch": 14,
                        "break": 20,
                        "total": 217
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11640,
                    "releaseDate": "2023-11-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 228,
                        "hold": 23,
                        "slide": 8,
                        "touch": 30,
                        "break": 6,
                        "total": 295
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11640,
                    "releaseDate": "2023-11-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 481,
                        "hold": 41,
                        "slide": 19,
                        "touch": 43,
                        "break": 33,
                        "total": 617
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11640,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12,
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2023-11-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 445,
                        "hold": 162,
                        "slide": 86,
                        "touch": 60,
                        "break": 44,
                        "total": 797
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11640,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2023-11-10"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Love Kills U",
            "category": "ゲーム＆バラエティ",
            "title": "Love Kills U",
            "artist": "EmoCosine",
            "bpm": 160,
            "imageName": "25c70abc6d47dec9b07c4f47c254f9a5b858f4e298c9f49bffcf56ffa50e2e23",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 102,
                        "hold": 24,
                        "slide": 4,
                        "touch": 16,
                        "break": 14,
                        "total": 160
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11641,
                    "releaseDate": "2023-11-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 20,
                        "slide": 8,
                        "touch": 28,
                        "break": 6,
                        "total": 338
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11641,
                    "releaseDate": "2023-11-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 396,
                        "hold": 54,
                        "slide": 34,
                        "touch": 10,
                        "break": 19,
                        "total": 513
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11641,
                    "releaseDate": "2023-11-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 469,
                        "hold": 63,
                        "slide": 42,
                        "touch": 72,
                        "break": 130,
                        "total": 776
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11641,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2023-11-10"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "DANGEROOOOUS JUNGLE",
            "category": "ゲーム＆バラエティ",
            "title": "DANGEROOOOUS JUNGLE",
            "artist": "Laur",
            "bpm": 160,
            "imageName": "6bd4931bf63dd5723b492a8c8d57d88b4a92bf39abaf19c5c4e5f61a983c87f8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 124,
                        "hold": 14,
                        "slide": 8,
                        "touch": 32,
                        "break": 15,
                        "total": 193
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11642,
                    "releaseDate": "2023-11-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 23,
                        "slide": 6,
                        "touch": 27,
                        "break": 10,
                        "total": 328
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11642,
                    "releaseDate": "2023-11-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 363,
                        "hold": 66,
                        "slide": 49,
                        "touch": 13,
                        "break": 62,
                        "total": 553
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11642,
                    "releaseDate": "2023-11-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 711,
                        "hold": 56,
                        "slide": 96,
                        "touch": 72,
                        "break": 57,
                        "total": 992
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11642,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-11-10"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "天使光輪",
            "category": "ゲーム＆バラエティ",
            "title": "天使光輪",
            "artist": "REDALiCE & cosMo＠暴走P",
            "bpm": 203,
            "imageName": "01ce1f97b33ffd7b1e3e692cb0bb4893f60e52e046d03870978845deac268a2b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 242,
                        "hold": 14,
                        "slide": 7,
                        "touch": 21,
                        "break": 24,
                        "total": 308
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11643,
                    "releaseDate": "2023-11-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 372,
                        "hold": 16,
                        "slide": 8,
                        "touch": 16,
                        "break": 6,
                        "total": 418
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11643,
                    "releaseDate": "2023-11-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 453,
                        "hold": 79,
                        "slide": 61,
                        "touch": 15,
                        "break": 87,
                        "total": 695
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11643,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2023-11-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 749,
                        "hold": 57,
                        "slide": 116,
                        "touch": 67,
                        "break": 75,
                        "total": 1064
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11643,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.4,
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4
                    },
                    "releaseDate": "2023-11-10"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "I’m Here (feat. Merry Kirk-Holmes)",
            "category": "ゲーム＆バラエティ",
            "title": "I’m Here (feat. Merry Kirk-Holmes)",
            "artist": "大谷智哉「ソニックフロンティア」",
            "bpm": 187,
            "imageName": "cf773337fa56248fcd3cf33b3a8cd3ff651404e31fe0398dade7aee4dbe98332",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 132,
                        "hold": 12,
                        "slide": 8,
                        "touch": 16,
                        "break": 3,
                        "total": 171
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11567,
                    "releaseDate": "2023-11-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 22,
                        "slide": 12,
                        "touch": 14,
                        "break": 4,
                        "total": 316
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11567,
                    "releaseDate": "2023-11-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 359,
                        "hold": 78,
                        "slide": 34,
                        "touch": 22,
                        "break": 38,
                        "total": 531
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11567,
                    "releaseDate": "2023-11-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 538,
                        "hold": 32,
                        "slide": 118,
                        "touch": 12,
                        "break": 41,
                        "total": 741
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11567,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2023-11-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "story",
            "category": "POPS＆アニメ",
            "title": "story",
            "artist": "前島麻由",
            "bpm": 220,
            "imageName": "1f75b9e9d4ac42af8aa21dc22b33a1ab3986624a58d893aad387e538599c4433",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 73,
                        "hold": 12,
                        "slide": 2,
                        "touch": 7,
                        "break": 1,
                        "total": 95
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11644,
                    "releaseDate": "2023-11-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 174,
                        "hold": 20,
                        "slide": 6,
                        "touch": 14,
                        "break": 4,
                        "total": 218
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11644,
                    "releaseDate": "2023-11-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 34,
                        "slide": 44,
                        "touch": 9,
                        "break": 27,
                        "total": 372
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11644,
                    "releaseDate": "2023-11-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "PG-NAKAGAWA",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 19,
                        "slide": 66,
                        "touch": 30,
                        "break": 24,
                        "total": 491
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11644,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.2,
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "PRiSM PLUS": 12.2
                    },
                    "releaseDate": "2023-11-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "トンデモワンダーズ",
            "category": "niconico＆ボーカロイド",
            "title": "トンデモワンダーズ",
            "artist": "sasakure.UK",
            "bpm": 172,
            "imageName": "f9e5374049dbcc9cc14b2c45606e8c9a720113c8561cc8954a6649c21c596e64",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 133,
                        "hold": 3,
                        "slide": 6,
                        "touch": 21,
                        "break": 4,
                        "total": 167
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11645,
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 17,
                        "slide": 6,
                        "touch": 22,
                        "break": 10,
                        "total": 296
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11645,
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "みぞれヤナギ",
                    "noteCounts": {
                        "tap": 321,
                        "hold": 76,
                        "slide": 16,
                        "touch": 24,
                        "break": 20,
                        "total": 457
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11645,
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 518,
                        "hold": 91,
                        "slide": 88,
                        "touch": 41,
                        "break": 46,
                        "total": 784
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11645,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.6,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6
                    },
                    "releaseDate": "2023-12-09"
                }
            ],
            "searchAcronyms": [
                "TONDEMO-WONDERS",
                "TONDEMO-WONDERZ"
            ]
        },
        {
            "songId": "PinqPiq (xovevox Remix)",
            "category": "オンゲキ＆CHUNITHM",
            "title": "PinqPiq (xovevox Remix)",
            "artist": "owl＊tree Remixed by sasakure.UK",
            "bpm": 150,
            "imageName": "5aa8ceb4041290af64eab8918ca409d189032193ce5c9187bceebd4fbd7e92f0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 152,
                        "hold": 11,
                        "slide": 10,
                        "touch": 16,
                        "break": 4,
                        "total": 193
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11668,
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 19,
                        "slide": 8,
                        "touch": 28,
                        "break": 6,
                        "total": 336
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11668,
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 411,
                        "hold": 70,
                        "slide": 53,
                        "touch": 10,
                        "break": 34,
                        "total": 578
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11668,
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 726,
                        "hold": 132,
                        "slide": 41,
                        "touch": 17,
                        "break": 24,
                        "total": 940
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11668,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-12-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "神威",
            "category": "ゲーム＆バラエティ",
            "title": "神威",
            "artist": "TJ.hangneil",
            "bpm": 210,
            "imageName": "f2eaa316c80547d921e1caa7150824d2a4385c9ff2867c9fa239b918f369b0d2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 12,
                        "slide": 4,
                        "touch": 9,
                        "break": 11,
                        "total": 342
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11646,
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 362,
                        "hold": 26,
                        "slide": 8,
                        "touch": 14,
                        "break": 6,
                        "total": 416
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11646,
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 571,
                        "hold": 160,
                        "slide": 25,
                        "touch": 58,
                        "break": 28,
                        "total": 842
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11646,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 883,
                        "hold": 93,
                        "slide": 94,
                        "touch": 155,
                        "break": 38,
                        "total": 1263
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11646,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.6,
                        "BUDDiES PLUS": 14.6,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6
                    },
                    "releaseDate": "2023-12-09"
                }
            ],
            "searchAcronyms": [
                "KAMUI"
            ]
        },
        {
            "songId": "ozma",
            "category": "ゲーム＆バラエティ",
            "title": "ozma",
            "artist": "TJ.hangneil",
            "bpm": 220,
            "imageName": "09d7f5f785dda38aa642d4ca8a47413cdda4cc6973aa0fbdc1183e370a0ed09e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 202,
                        "hold": 17,
                        "slide": 8,
                        "touch": 30,
                        "break": 1,
                        "total": 258
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11647,
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 376,
                        "hold": 19,
                        "slide": 6,
                        "touch": 20,
                        "break": 4,
                        "total": 425
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11647,
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 413,
                        "hold": 89,
                        "slide": 46,
                        "touch": 55,
                        "break": 20,
                        "total": 623
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11647,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 482,
                        "hold": 131,
                        "slide": 80,
                        "touch": 61,
                        "break": 38,
                        "total": 792
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11647,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2023-12-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "月面基地",
            "category": "ゲーム＆バラエティ",
            "title": "月面基地",
            "artist": "sasakure.UK",
            "bpm": 180,
            "imageName": "9cd4b5c988b104afc7221f9d1c349eb2e8ce443e006cd90c087955ccdb74f75e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 213,
                        "hold": 8,
                        "slide": 8,
                        "touch": 8,
                        "break": 10,
                        "total": 247
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11648,
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 36,
                        "slide": 16,
                        "touch": 30,
                        "break": 2,
                        "total": 348
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11648,
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 113,
                        "slide": 56,
                        "touch": 53,
                        "break": 3,
                        "total": 367
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11648,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 677,
                        "hold": 66,
                        "slide": 50,
                        "touch": 85,
                        "break": 22,
                        "total": 900
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11648,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-12-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Apollo",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Apollo",
            "artist": "TJ.hangneil",
            "bpm": 339,
            "imageName": "6f210e5048637b3c4b72368abdf83cd7cf79f03dcadeb66ec168d3b3d296cef1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 268,
                        "hold": 11,
                        "slide": 9,
                        "touch": 19,
                        "break": 10,
                        "total": 317
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11661,
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 29,
                        "slide": 6,
                        "touch": 29,
                        "break": 6,
                        "total": 400
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11661,
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 718,
                        "hold": 64,
                        "slide": 42,
                        "touch": 17,
                        "break": 19,
                        "total": 860
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11661,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "EL DiABLO",
                    "noteCounts": {
                        "tap": 866,
                        "hold": 113,
                        "slide": 90,
                        "touch": 53,
                        "break": 89,
                        "total": 1211
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11661,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.7,
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7
                    },
                    "releaseDate": "2023-12-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "raputa",
            "category": "maimai",
            "title": "raputa",
            "artist": "sasakure.UK × TJ.hangneil",
            "bpm": 339,
            "imageName": "7a1e5ffd34a526f8fe79f16e7435fc57da813aa53f0b5d773e34fce202122651",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 14,
                        "slide": 12,
                        "touch": 26,
                        "break": 10,
                        "total": 339
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11662,
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 30,
                        "slide": 12,
                        "touch": 30,
                        "break": 1,
                        "total": 424
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11662,
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "佑",
                    "noteCounts": {
                        "tap": 612,
                        "hold": 89,
                        "slide": 33,
                        "touch": 91,
                        "break": 63,
                        "total": 888
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11662,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.7,
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-12-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.9,
                    "noteDesigner": "project_raputa",
                    "noteCounts": {
                        "tap": 992,
                        "hold": 116,
                        "slide": 102,
                        "touch": 29,
                        "break": 77,
                        "total": 1316
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11662,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.9,
                        "BUDDiES PLUS": 14.9,
                        "CiRCLE": 14.9,
                        "CiRCLE PLUS": 14.9,
                        "PRiSM": 14.9,
                        "PRiSM PLUS": 14.9
                    },
                    "releaseDate": "2023-12-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "フェイクフェイス・フェイルセイフ",
            "category": "maimai",
            "title": "フェイクフェイス・フェイルセイフ",
            "artist": "カラスヤサボウ feat. もるでお",
            "bpm": 202,
            "imageName": "a2a06d7c0d4ecfbdd06d518fd67fb0fe9ab6c97cfa3874c40ff7c30d8afaf770",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 156,
                        "hold": 16,
                        "slide": 10,
                        "touch": 12,
                        "break": 11,
                        "total": 205
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11620,
                    "releaseDate": "2023-12-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 35,
                        "slide": 5,
                        "touch": 13,
                        "break": 9,
                        "total": 335
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11620,
                    "releaseDate": "2023-12-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "きょむりん",
                    "noteCounts": {
                        "tap": 426,
                        "hold": 65,
                        "slide": 83,
                        "touch": 24,
                        "break": 56,
                        "total": 654
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11620,
                    "releaseDate": "2023-12-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 640,
                        "hold": 35,
                        "slide": 108,
                        "touch": 64,
                        "break": 36,
                        "total": 883
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11620,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2023-12-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ふらふらふら、",
            "category": "maimai",
            "title": "ふらふらふら、",
            "artist": "アオワイファイ feat.犀羅",
            "bpm": 125,
            "imageName": "bd8802f2a38fa2add97de3ebc4990b1777995cdc7c87ca9addcb24dd77f64e33",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 116,
                        "hold": 16,
                        "slide": 4,
                        "touch": 12,
                        "break": 8,
                        "total": 156
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11621,
                    "releaseDate": "2023-12-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 14,
                        "slide": 12,
                        "touch": 14,
                        "break": 10,
                        "total": 325
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11621,
                    "releaseDate": "2023-12-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 354,
                        "hold": 43,
                        "slide": 42,
                        "touch": 10,
                        "break": 19,
                        "total": 468
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11621,
                    "releaseDate": "2023-12-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 625,
                        "hold": 17,
                        "slide": 114,
                        "touch": 29,
                        "break": 20,
                        "total": 805
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11621,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2023-12-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "シックスプラン",
            "category": "maimai",
            "title": "シックスプラン",
            "artist": "針原翼（はりーP）feat. はく",
            "bpm": 120,
            "imageName": "a665d5c6848e3f008647340b6bb87270795845609a803a919494f2d74da19630",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 97,
                        "hold": 13,
                        "slide": 6,
                        "touch": 15,
                        "break": 5,
                        "total": 136
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11622,
                    "releaseDate": "2023-12-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 10,
                        "slide": 11,
                        "touch": 27,
                        "break": 5,
                        "total": 258
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11622,
                    "releaseDate": "2023-12-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 52,
                        "slide": 22,
                        "touch": 18,
                        "break": 19,
                        "total": 375
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11622,
                    "releaseDate": "2023-12-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 447,
                        "hold": 28,
                        "slide": 92,
                        "touch": 29,
                        "break": 36,
                        "total": 632
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11622,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2023-12-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "フタタビ",
            "category": "maimai",
            "title": "フタタビ",
            "artist": "KAZE Lab",
            "bpm": 136,
            "imageName": "2273fbf6a95bceee310bf34b1b0080e599403a622c854fe3402a1b06c7f2ae01",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 110,
                        "hold": 12,
                        "slide": 4,
                        "touch": 9,
                        "break": 4,
                        "total": 139
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11623,
                    "releaseDate": "2023-12-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 211,
                        "hold": 21,
                        "slide": 7,
                        "touch": 30,
                        "break": 8,
                        "total": 277
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11623,
                    "releaseDate": "2023-12-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 35,
                        "slide": 59,
                        "touch": 30,
                        "break": 20,
                        "total": 450
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11623,
                    "releaseDate": "2023-12-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 573,
                        "hold": 24,
                        "slide": 97,
                        "touch": 11,
                        "break": 27,
                        "total": 732
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11623,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.4,
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2023-12-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[蛸]チルノのパーフェクトさんすう教室",
            "category": "宴会場",
            "title": "[蛸]チルノのパーフェクトさんすう教室",
            "artist": "ARM＋夕野ヨシミ(IOSYS)feat. miko",
            "bpm": null,
            "imageName": "d76db1f6abc2d604ebb0139eda2e78582c59eb30de85eac0295b29fdaf8def9f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【蛸】",
                    "level": "12+?",
                    "internalLevelValue": 12.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100199,
                    "version": "BUDDiES",
                    "comment": "パーフェクトホールド教室",
                    "releaseDate": "2023-12-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[星]しゅわスパ大作戦☆",
            "category": "宴会場",
            "title": "[星]しゅわスパ大作戦☆",
            "artist": "SOUND HOLIC feat. Nana Takahashi",
            "bpm": null,
            "imageName": "d93a14827483d85307c067519383d23aaca5c2efd544dd0486d485ae52609299",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【星】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100206,
                    "version": "BUDDiES",
                    "comment": "☆TAP大作戦☆",
                    "releaseDate": "2023-12-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[宴]セガサターン起動音[H.][Remix]",
            "category": "宴会場",
            "title": "[宴]セガサターン起動音[H.][Remix]",
            "artist": "Hiro",
            "bpm": null,
            "imageName": "6b2e3ec675ea2e40be0eda7605df74079b548cfaa68964e2727756f49426f2c0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【宴】",
                    "level": "13+?",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100220,
                    "version": "BUDDiES",
                    "comment": "回転タップ検定起動音",
                    "releaseDate": "2023-12-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[は]Garakuta Doll Play",
            "category": "宴会場",
            "title": "[は]Garakuta Doll Play",
            "artist": "t+pazolite",
            "bpm": null,
            "imageName": "2fd925d0bc0256851e1c4c80354c792af803f98e057c95972873b5dd352b6a8f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【は】",
                    "level": "14?",
                    "internalLevelValue": 14,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100227,
                    "version": "BUDDiES",
                    "comment": "はっぴーの若干ストイック気味版",
                    "releaseDate": "2023-12-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[宴]CYCLES",
            "category": "宴会場",
            "title": "[宴]CYCLES",
            "artist": "Masayoshi Minoshima feat. 綾倉盟",
            "bpm": null,
            "imageName": "7ef3e95cf5ded39ef44c85433c98452ae592fe49e58fe716756493adb1a2f9cb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【宴】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100230,
                    "version": "BUDDiES",
                    "comment": "いつもより多く回っております",
                    "releaseDate": "2023-12-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[狂]タカハせ！名人マン",
            "category": "宴会場",
            "title": "[狂]タカハせ！名人マン",
            "artist": "ビートまりお + ARM feat. 高橋名人",
            "bpm": null,
            "imageName": "7f2bea0c2b68b18f6574712137af566081777a16371cd7ae2de3240912d48ed7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【狂】",
                    "level": "14+?",
                    "internalLevelValue": 14.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100327,
                    "version": "BUDDiES",
                    "comment": "名人マンよくばりセット",
                    "releaseDate": "2023-12-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[蔵]Glorious Crown",
            "category": "宴会場",
            "title": "[蔵]Glorious Crown",
            "artist": "xi",
            "bpm": null,
            "imageName": "86732af137675c3d9cb03d1f28434cd35acbfaa50b3bb91fb3e7ad1e2ce76dbc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【蔵】",
                    "level": "14+?",
                    "internalLevelValue": 14.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100456,
                    "version": "BUDDiES",
                    "comment": "チャンさんの初稿シリーズ～王～",
                    "releaseDate": "2023-12-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[覚]東京リアルワールド",
            "category": "宴会場",
            "title": "[覚]東京リアルワールド",
            "artist": "out of service",
            "bpm": null,
            "imageName": "e4b6e1ffcd5cee99aee5862ac11b23dca12a022d931a10ec100b93804af3123a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【覚】",
                    "level": "12?",
                    "internalLevelValue": 12,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100517,
                    "version": "BUDDiES",
                    "comment": "なぞる順番を覚えるゲーム(初級編)",
                    "releaseDate": "2023-12-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[疑]DETARAME ROCK&ROLL THEORY",
            "category": "宴会場",
            "title": "[疑]DETARAME ROCK&ROLL THEORY",
            "artist": "箱部 なる(CV:M・A・O)",
            "bpm": null,
            "imageName": "04508ef78d4330becb15d7ec4bf4d3d54fad1cd32a9f42ce983337f398f84b30",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【疑】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100548,
                    "version": "BUDDiES",
                    "comment": "スライドの発射タイミング 速度がデタラメ",
                    "releaseDate": "2023-12-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "RAD DOGS",
            "category": "niconico＆ボーカロイド",
            "title": "RAD DOGS",
            "artist": "八王子P / 初音ミク / Vivid BAD SQUAD「プロジェクトセカイ カラフルステージ！ feat. 初音ミク」",
            "bpm": 140,
            "imageName": "15e89ff7086150bd13708ea6150a5f264e5ac1c7918f596ab852b0f3f2a0f7c7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 113,
                        "hold": 11,
                        "slide": 4,
                        "touch": 14,
                        "break": 6,
                        "total": 148
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11665,
                    "releaseDate": "2024-01-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 193,
                        "hold": 13,
                        "slide": 10,
                        "touch": 27,
                        "break": 6,
                        "total": 249
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11665,
                    "releaseDate": "2024-01-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 58,
                        "slide": 29,
                        "touch": 7,
                        "break": 30,
                        "total": 404
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11665,
                    "releaseDate": "2024-01-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 505,
                        "hold": 37,
                        "slide": 93,
                        "touch": 16,
                        "break": 13,
                        "total": 664
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11665,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2024-01-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "アイディスマイル",
            "category": "niconico＆ボーカロイド",
            "title": "アイディスマイル",
            "artist": "とあ / MEIKO / 25時、ナイトコードで。「プロジェクトセカイ カラフルステージ！ feat. 初音ミク」",
            "bpm": 171,
            "imageName": "f20101217f714194d9973b603c07a13b4dcf7d39648842d20d334a546c3e3f55",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 105,
                        "hold": 11,
                        "slide": 4,
                        "touch": 13,
                        "break": 3,
                        "total": 136
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11666,
                    "releaseDate": "2024-01-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 24,
                        "slide": 4,
                        "touch": 41,
                        "break": 6,
                        "total": 302
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11666,
                    "releaseDate": "2024-01-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 217,
                        "hold": 38,
                        "slide": 30,
                        "touch": 22,
                        "break": 11,
                        "total": 318
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11666,
                    "releaseDate": "2024-01-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "りんご Full Set",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 75,
                        "slide": 68,
                        "touch": 67,
                        "break": 18,
                        "total": 510
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11666,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2024-01-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "にっこり^^調査隊のテーマ",
            "category": "niconico＆ボーカロイド",
            "title": "にっこり^^調査隊のテーマ",
            "artist": "ワンダフル☆オポチュニティ！ / 初音ミク / ワンダーランズ×ショウタイム「プロジェクトセカイ カラフルステージ！ feat. 初音ミク」",
            "bpm": 180,
            "imageName": "7cb366f1bc007173af960303405073154a2aaa134527ddbba54ed8a289b4e53a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 131,
                        "hold": 11,
                        "slide": 4,
                        "touch": 7,
                        "break": 8,
                        "total": 161
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11667,
                    "releaseDate": "2024-01-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 222,
                        "hold": 32,
                        "slide": 6,
                        "touch": 24,
                        "break": 6,
                        "total": 290
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11667,
                    "releaseDate": "2024-01-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 354,
                        "hold": 46,
                        "slide": 29,
                        "touch": 9,
                        "break": 50,
                        "total": 488
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11667,
                    "releaseDate": "2024-01-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 110,
                        "slide": 109,
                        "touch": 67,
                        "break": 78,
                        "total": 709
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11667,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2024-01-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ずんだもんの朝食　〜目覚ましずんラップ〜",
            "category": "niconico＆ボーカロイド",
            "title": "ずんだもんの朝食　〜目覚ましずんラップ〜",
            "artist": "ひらうみ",
            "bpm": 260,
            "imageName": "585e5bfd86f6823e371d7077a3308137f9daaae70b23587fb55b054e5da9b7f7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 131,
                        "hold": 12,
                        "slide": 4,
                        "touch": 7,
                        "break": 5,
                        "total": 159
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11650,
                    "releaseDate": "2024-01-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 245,
                        "hold": 22,
                        "slide": 4,
                        "touch": 50,
                        "break": 14,
                        "total": 335
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11650,
                    "releaseDate": "2024-01-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 430,
                        "hold": 36,
                        "slide": 11,
                        "touch": 20,
                        "break": 14,
                        "total": 511
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11650,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 10.8
                    },
                    "releaseDate": "2024-01-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "ずんだポップ",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 87,
                        "slide": 70,
                        "touch": 219,
                        "break": 16,
                        "total": 729
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11650,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "PRiSM": 13.1,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2024-01-26"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "あなたは世界の終わりにずんだを食べるのだ",
            "category": "niconico＆ボーカロイド",
            "title": "あなたは世界の終わりにずんだを食べるのだ",
            "artist": "なみぐる",
            "bpm": 140,
            "imageName": "aa4f74e41932b4f956759633d1549fa6a523552512d49000e87d695d488b8ef1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 99,
                        "hold": 13,
                        "slide": 4,
                        "touch": 19,
                        "break": 2,
                        "total": 137
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11651,
                    "releaseDate": "2024-01-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 16,
                        "slide": 6,
                        "touch": 28,
                        "break": 6,
                        "total": 274
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11651,
                    "releaseDate": "2024-01-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 32,
                        "slide": 25,
                        "touch": 2,
                        "break": 38,
                        "total": 408
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11651,
                    "releaseDate": "2024-01-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 385,
                        "hold": 84,
                        "slide": 90,
                        "touch": 40,
                        "break": 20,
                        "total": 619
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11651,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2024-01-26"
                }
            ],
            "searchAcronyms": [
                "Anata wa Sekai no Owari ni Zunda o Taberu no da",
                "You will eat Zunda at the end of the world"
            ]
        },
        {
            "songId": "HUMANBORG",
            "category": "POPS＆アニメ",
            "title": "HUMANBORG",
            "artist": "SARUKANI",
            "bpm": 189,
            "imageName": "df9216ba4f5891ef6e22439ea6c10403e0f094f60dcc5a633287ea3e95f7f0fc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 17,
                        "slide": 8,
                        "touch": 21,
                        "break": 4,
                        "total": 219
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11652,
                    "releaseDate": "2024-01-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 32,
                        "slide": 9,
                        "touch": 29,
                        "break": 2,
                        "total": 359
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11652,
                    "releaseDate": "2024-01-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 387,
                        "hold": 124,
                        "slide": 68,
                        "touch": 3,
                        "break": 32,
                        "total": 614
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11652,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12,
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2024-01-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 651,
                        "hold": 159,
                        "slide": 1,
                        "touch": 186,
                        "break": 30,
                        "total": 1027
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11652,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2024-01-26"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ULTRA POWER",
            "category": "POPS＆アニメ",
            "title": "ULTRA POWER",
            "artist": "SARUKANI",
            "bpm": 142,
            "imageName": "415a4a5ce2dc484567d87c25e1513a52cdaf90fdbd0d3c33ad0c6e9d558894b6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 139,
                        "hold": 15,
                        "slide": 4,
                        "touch": 7,
                        "break": 16,
                        "total": 181
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11653,
                    "releaseDate": "2024-01-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 225,
                        "hold": 19,
                        "slide": 6,
                        "touch": 30,
                        "break": 10,
                        "total": 290
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11653,
                    "releaseDate": "2024-01-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 24,
                        "slide": 43,
                        "touch": 59,
                        "break": 47,
                        "total": 508
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11653,
                    "releaseDate": "2024-01-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 485,
                        "hold": 118,
                        "slide": 65,
                        "touch": 44,
                        "break": 68,
                        "total": 780
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11653,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.5,
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2024-01-26"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "The Great Banquet",
            "category": "maimai",
            "title": "The Great Banquet",
            "artist": "Iris",
            "bpm": 170,
            "imageName": "4354fc3099928a1b30cbce2a0bf4bfc73631de47d05c6f1164de5421e26dd37e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 15,
                        "slide": 7,
                        "touch": 11,
                        "break": 8,
                        "total": 246
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11534,
                    "releaseDate": "2024-02-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 29,
                        "slide": 2,
                        "touch": 28,
                        "break": 6,
                        "total": 371
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11534,
                    "releaseDate": "2024-02-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 75,
                        "slide": 50,
                        "touch": 12,
                        "break": 43,
                        "total": 518
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11534,
                    "releaseDate": "2024-02-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 715,
                        "hold": 52,
                        "slide": 131,
                        "touch": 10,
                        "break": 45,
                        "total": 953
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11534,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.1,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14
                    },
                    "releaseDate": "2024-02-02"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Redemption",
            "category": "maimai",
            "title": "Redemption",
            "artist": "XinG、10lulu",
            "bpm": 175,
            "imageName": "4d6061278a091301ecb92efb4c19f1467d9a4b40de554575064c1313d9685d3c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 132,
                        "hold": 9,
                        "slide": 10,
                        "touch": 24,
                        "break": 6,
                        "total": 181
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11535,
                    "releaseDate": "2024-02-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 244,
                        "hold": 29,
                        "slide": 9,
                        "touch": 30,
                        "break": 10,
                        "total": 322
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11535,
                    "releaseDate": "2024-02-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 320,
                        "hold": 50,
                        "slide": 48,
                        "touch": 26,
                        "break": 15,
                        "total": 459
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11535,
                    "releaseDate": "2024-02-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 686,
                        "hold": 6,
                        "slide": 49,
                        "touch": 36,
                        "break": 36,
                        "total": 813
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11535,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "CiRCLE": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2024-02-02"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Ether Second",
            "category": "maimai",
            "title": "Ether Second",
            "artist": "Akira Complex",
            "bpm": 150,
            "imageName": "2707888eb33ce6db6f29361a89ff465524e7e63902ba0821ee0c61838fe0ee09",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 22,
                        "slide": 4,
                        "touch": 8,
                        "break": 6,
                        "total": 178
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11536,
                    "releaseDate": "2024-02-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 242,
                        "hold": 18,
                        "slide": 6,
                        "touch": 30,
                        "break": 4,
                        "total": 300
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11536,
                    "releaseDate": "2024-02-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 82,
                        "slide": 55,
                        "touch": 42,
                        "break": 3,
                        "total": 519
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11536,
                    "releaseDate": "2024-02-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 636,
                        "hold": 75,
                        "slide": 59,
                        "touch": 24,
                        "break": 61,
                        "total": 855
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11536,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2024-02-02"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Straight into the lights",
            "category": "maimai",
            "title": "Straight into the lights",
            "artist": "Cosmograph",
            "bpm": 90,
            "imageName": "8fc940a2fcffd56224e372b2a57888e84ca295c43609dad8a185b14227caf2a8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 158,
                        "hold": 30,
                        "slide": 4,
                        "touch": 19,
                        "break": 9,
                        "total": 220
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11537,
                    "releaseDate": "2024-02-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 286,
                        "hold": 27,
                        "slide": 7,
                        "touch": 22,
                        "break": 6,
                        "total": 348
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11537,
                    "releaseDate": "2024-02-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 310,
                        "hold": 81,
                        "slide": 40,
                        "touch": 40,
                        "break": 51,
                        "total": 522
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11537,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2024-02-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 777,
                        "hold": 62,
                        "slide": 87,
                        "touch": 121,
                        "break": 64,
                        "total": 1111
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11537,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8
                    },
                    "releaseDate": "2024-02-02"
                }
            ],
            "searchAcronyms": [
                "中出光",
                "直入光"
            ]
        },
        {
            "songId": "渦状銀河のシンフォニエッタ",
            "category": "maimai",
            "title": "渦状銀河のシンフォニエッタ",
            "artist": "山本真央樹",
            "bpm": 238,
            "imageName": "1cf8ab2e8f094a454cd5c69c9ff6d2ef7e99770b0be8148158b3982450401396",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 101,
                        "hold": 15,
                        "slide": 7,
                        "touch": 18,
                        "break": 10,
                        "total": 151
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11103,
                    "releaseDate": "2020-08-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 39,
                        "slide": 30,
                        "touch": 56,
                        "break": 13,
                        "total": 385
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11103,
                    "releaseDate": "2020-08-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "華火職人",
                    "noteCounts": {
                        "tap": 385,
                        "hold": 78,
                        "slide": 46,
                        "touch": 9,
                        "break": 40,
                        "total": 558
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11103,
                    "releaseDate": "2020-08-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 801,
                        "hold": 87,
                        "slide": 66,
                        "touch": 238,
                        "break": 22,
                        "total": 1214
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "maimaiでらっくす PLUS",
                    "internalId": 11103,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.6,
                        "BUDDiES PLUS": 14.6,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "FESTiVAL": 14.6,
                        "FESTiVAL PLUS": 14.6,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6,
                        "Splash": 14.6,
                        "Splash PLUS": 14.6,
                        "UNiVERSE": 14.6,
                        "UNiVERSE PLUS": 14.6,
                        "maimaiでらっくす PLUS": 14.6
                    },
                    "releaseDate": "2020-08-07"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 183,
                        "hold": 25,
                        "slide": 8,
                        "touch": null,
                        "break": 11,
                        "total": 227
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 1103,
                    "releaseDate": "2024-02-15"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 321,
                        "hold": 34,
                        "slide": 10,
                        "touch": null,
                        "break": 14,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 1103,
                    "releaseDate": "2024-02-15"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 464,
                        "hold": 67,
                        "slide": 47,
                        "touch": null,
                        "break": 46,
                        "total": 624
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 1103,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2024-02-15"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 680,
                        "hold": 71,
                        "slide": 159,
                        "touch": null,
                        "break": 21,
                        "total": 931
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 1103,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.3,
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3
                    },
                    "releaseDate": "2024-02-15"
                }
            ],
            "searchAcronyms": [
                "🚽",
                "抽水马桶",
                "涡状伊岛",
                "涡状台风",
                "涡状银河",
                "涡状银河的小交响曲",
                "涡状马桶",
                "漩涡马桶",
                "银河",
                "马桶"
            ]
        },
        {
            "songId": "ジェヘナ",
            "category": "niconico＆ボーカロイド",
            "title": "ジェヘナ",
            "artist": "wotaku",
            "bpm": 128,
            "imageName": "dfbce1f2050046e0ac47872ce5d911e77b30e987b828150225c187c3dfa5272c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 79,
                        "hold": 15,
                        "slide": 4,
                        "touch": 12,
                        "break": 5,
                        "total": 115
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11654,
                    "releaseDate": "2024-02-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 236,
                        "hold": 20,
                        "slide": 6,
                        "touch": 28,
                        "break": 6,
                        "total": 296
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11654,
                    "releaseDate": "2024-02-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 313,
                        "hold": 70,
                        "slide": 44,
                        "touch": 8,
                        "break": 10,
                        "total": 445
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11654,
                    "releaseDate": "2024-02-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 635,
                        "hold": 54,
                        "slide": 65,
                        "touch": 18,
                        "break": 41,
                        "total": 813
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11654,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.3,
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2024-02-16"
                }
            ],
            "searchAcronyms": [
                "Gehenna"
            ]
        },
        {
            "songId": "ツギハギスタッカート",
            "category": "niconico＆ボーカロイド",
            "title": "ツギハギスタッカート",
            "artist": "とあ",
            "bpm": 139,
            "imageName": "13c1e24f58a49d0ee3655da022554a74c57a6b66a45618d2a0868dc7369ab8d4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 89,
                        "hold": 7,
                        "slide": 5,
                        "touch": 14,
                        "break": 1,
                        "total": 116
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11655,
                    "releaseDate": "2024-02-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 228,
                        "hold": 24,
                        "slide": 6,
                        "touch": 25,
                        "break": 2,
                        "total": 285
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11655,
                    "releaseDate": "2024-02-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "りんご Full Set",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 75,
                        "slide": 37,
                        "touch": 14,
                        "break": 12,
                        "total": 425
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11655,
                    "releaseDate": "2024-02-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 49,
                        "slide": 67,
                        "touch": 101,
                        "break": 7,
                        "total": 599
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11655,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2024-02-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "HANIPAGANDA",
            "category": "東方Project",
            "title": "HANIPAGANDA",
            "artist": "暁Records",
            "bpm": 181,
            "imageName": "8ed763dfe0fff00c8bfb7834363731f91408ef7e445a07a798b952aa8638fbd1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 9,
                        "slide": 8,
                        "touch": 20,
                        "break": 5,
                        "total": 183
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11656,
                    "releaseDate": "2024-02-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 246,
                        "hold": 28,
                        "slide": 6,
                        "touch": 28,
                        "break": 4,
                        "total": 312
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11656,
                    "releaseDate": "2024-02-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 353,
                        "hold": 63,
                        "slide": 30,
                        "touch": 30,
                        "break": 32,
                        "total": 508
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11656,
                    "releaseDate": "2024-02-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 557,
                        "hold": 85,
                        "slide": 92,
                        "touch": 26,
                        "break": 82,
                        "total": 842
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11656,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.6,
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6
                    },
                    "releaseDate": "2024-02-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Rush-Hour",
            "category": "ゲーム＆バラエティ",
            "title": "Rush-Hour",
            "artist": "litmus*",
            "bpm": 224,
            "imageName": "87754d363b458fd6cf6f4a2b4d95fcb0e25e2f498df10bd8ac0eb88317eb6eb6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 23,
                        "slide": 4,
                        "touch": 16,
                        "break": 2,
                        "total": 187
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11657,
                    "releaseDate": "2024-02-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 31,
                        "slide": 6,
                        "touch": 12,
                        "break": 6,
                        "total": 360
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11657,
                    "releaseDate": "2024-02-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 392,
                        "hold": 48,
                        "slide": 37,
                        "touch": 56,
                        "break": 58,
                        "total": 591
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11657,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.5,
                        "BUDDiES PLUS": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2024-02-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 578,
                        "hold": 83,
                        "slide": 106,
                        "touch": 95,
                        "break": 32,
                        "total": 894
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11657,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2024-02-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Ring",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Ring",
            "artist": "R Sound Design feat.向日葵",
            "bpm": 132,
            "imageName": "b4a44e4d72bdc3e33bc19659133d29c5e09d8c8c95e781bf133e9a0b5192d808",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 13,
                        "slide": 4,
                        "touch": 6,
                        "break": 3,
                        "total": 161
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11626,
                    "releaseDate": "2024-02-29"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 202,
                        "hold": 28,
                        "slide": 6,
                        "touch": 16,
                        "break": 8,
                        "total": 260
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11626,
                    "releaseDate": "2024-02-29"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 299,
                        "hold": 65,
                        "slide": 47,
                        "touch": 12,
                        "break": 7,
                        "total": 430
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11626,
                    "releaseDate": "2024-02-29"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 501,
                        "hold": 39,
                        "slide": 77,
                        "touch": 24,
                        "break": 14,
                        "total": 655
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11626,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2024-02-29"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "インパアフェクシオン・ホワイトガアル",
            "category": "オンゲキ＆CHUNITHM",
            "title": "インパアフェクシオン・ホワイトガアル",
            "artist": "ツミキ feat.月乃",
            "bpm": 207,
            "imageName": "58263f6b1c1ab1d05fcda9fe153a2b1d8cf311497109d83b8fda079596056bf4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 165,
                        "hold": 20,
                        "slide": 8,
                        "touch": 11,
                        "break": 5,
                        "total": 209
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11627,
                    "releaseDate": "2024-02-29"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 36,
                        "slide": 4,
                        "touch": 19,
                        "break": 6,
                        "total": 417
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11627,
                    "releaseDate": "2024-02-29"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 457,
                        "hold": 82,
                        "slide": 39,
                        "touch": 19,
                        "break": 62,
                        "total": 659
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11627,
                    "releaseDate": "2024-02-29"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "ミニミライト",
                    "noteCounts": {
                        "tap": 818,
                        "hold": 39,
                        "slide": 172,
                        "touch": 11,
                        "break": 27,
                        "total": 1067
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11627,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.2,
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2
                    },
                    "releaseDate": "2024-02-29"
                }
            ],
            "searchAcronyms": [
                "Imperfection White Girl"
            ]
        },
        {
            "songId": "WE'RE BACK!!",
            "category": "オンゲキ＆CHUNITHM",
            "title": "WE'RE BACK!!",
            "artist": "Zekk",
            "bpm": 185,
            "imageName": "3d0fc531eaad9db6f8d8f5977a3ec2b0119b9f41297ca764363a5976b52595fa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 158,
                        "hold": 14,
                        "slide": 6,
                        "touch": 16,
                        "break": 14,
                        "total": 208
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11628,
                    "releaseDate": "2024-02-29"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 16,
                        "slide": 6,
                        "touch": 28,
                        "break": 8,
                        "total": 364
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11628,
                    "releaseDate": "2024-02-29"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 489,
                        "hold": 47,
                        "slide": 56,
                        "touch": 26,
                        "break": 30,
                        "total": 648
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11628,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.2,
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "PRiSM PLUS": 12.2
                    },
                    "releaseDate": "2024-02-29"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 730,
                        "hold": 78,
                        "slide": 89,
                        "touch": 32,
                        "break": 32,
                        "total": 961
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11628,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14,
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14
                    },
                    "releaseDate": "2024-02-29"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "系ぎて",
            "category": "maimai",
            "title": "系ぎて",
            "artist": "rintaro soma",
            "bpm": 88,
            "imageName": "3a914643f53b41ab5b3f0be0bb501b895a52660f8c78f8317a87a7669efc7930",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 26,
                        "slide": 8,
                        "touch": 14,
                        "break": 14,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11663,
                    "releaseDate": "2024-02-29"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 474,
                        "hold": 28,
                        "slide": 4,
                        "touch": 25,
                        "break": 8,
                        "total": 539
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11663,
                    "releaseDate": "2024-02-29"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 525,
                        "hold": 43,
                        "slide": 82,
                        "touch": 53,
                        "break": 39,
                        "total": 742
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11663,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.8,
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2024-02-29"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "maimai TEAM DX",
                    "noteCounts": {
                        "tap": 862,
                        "hold": 59,
                        "slide": 73,
                        "touch": 118,
                        "break": 88,
                        "total": 1200
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11663,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 14.8,
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7
                    },
                    "releaseDate": "2024-02-29"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "15",
                    "internalLevelValue": 15,
                    "noteDesigner": "BEYOND THE MEMORIES",
                    "noteCounts": {
                        "tap": 1100,
                        "hold": 40,
                        "slide": 70,
                        "touch": 90,
                        "break": 100,
                        "total": 1400
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11663,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 15,
                        "BUDDiES PLUS": 15,
                        "CiRCLE": 15,
                        "CiRCLE PLUS": 15,
                        "PRiSM": 15,
                        "PRiSM PLUS": 15
                    },
                    "releaseDate": "2024-02-29"
                }
            ],
            "searchAcronyms": [
                "6a",
                "6A景区",
                "byd回忆",
                "kop5",
                "kop5th决胜曲",
                "ysk泡温泉",
                "つなぎて",
                "一线牵",
                "俩舞神越级",
                "手牵手",
                "捆绑",
                "携手",
                "携手前进",
                "携手向前",
                "束缚",
                "牵手手",
                "牵绊",
                "白丝",
                "系",
                "系小鬼",
                "系日本字",
                "连结"
            ]
        },
        {
            "songId": "[耐]Space Harrier Main Theme [Reborn]",
            "category": "宴会場",
            "title": "[耐]Space Harrier Main Theme [Reborn]",
            "artist": "佐野 信義「スペースハリアー」",
            "bpm": null,
            "imageName": "efbffc987a0fa536acb35e1d5f5e1081e861933a87f7ebac68edbd471fbb2266",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【耐】",
                    "level": "14+?",
                    "internalLevelValue": 14.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 110114,
                    "version": "BUDDiES",
                    "comment": "HOLDがSQUILLAに！？",
                    "releaseDate": "2024-02-29"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[回]回る空うさぎ",
            "category": "宴会場",
            "title": "[回]回る空うさぎ",
            "artist": "Orangestar",
            "bpm": null,
            "imageName": "aebb1dc58101071287947c220d5db922f72d8d0f9659ffe72be0f32c8f44c0fa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【回】",
                    "level": "11?",
                    "internalLevelValue": 11,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111513,
                    "version": "BUDDiES",
                    "comment": "くるくる回る、お星さま。",
                    "releaseDate": "2024-02-29"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "QUEEN",
            "category": "niconico＆ボーカロイド",
            "title": "QUEEN",
            "artist": "Kanaria",
            "bpm": 170,
            "imageName": "6d580c1181a105351545170ac1ad2c24c66b45b61cec74d2c40c11085b56d448",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 134,
                        "hold": 7,
                        "slide": 4,
                        "touch": 16,
                        "break": 8,
                        "total": 169
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11658,
                    "releaseDate": "2024-03-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 37,
                        "slide": 4,
                        "touch": 41,
                        "break": 4,
                        "total": 289
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11658,
                    "releaseDate": "2024-03-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 410,
                        "hold": 33,
                        "slide": 32,
                        "touch": 16,
                        "break": 19,
                        "total": 510
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11658,
                    "releaseDate": "2024-03-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 555,
                        "hold": 59,
                        "slide": 116,
                        "touch": 35,
                        "break": 12,
                        "total": 777
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11658,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2024-03-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "天使の翼。",
            "category": "niconico＆ボーカロイド",
            "title": "天使の翼。",
            "artist": "A4。",
            "bpm": 125,
            "imageName": "7e6131aabba4b7e53ebedaf2cfb01b13cfa42316f1520318821be94679dd580f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 117,
                        "hold": 10,
                        "slide": 6,
                        "touch": 8,
                        "break": 5,
                        "total": 146
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11659,
                    "releaseDate": "2024-03-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 201,
                        "hold": 15,
                        "slide": 6,
                        "touch": 8,
                        "break": 8,
                        "total": 238
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11659,
                    "releaseDate": "2024-03-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 252,
                        "hold": 49,
                        "slide": 45,
                        "touch": 18,
                        "break": 40,
                        "total": 404
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11659,
                    "releaseDate": "2024-03-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 517,
                        "hold": 23,
                        "slide": 87,
                        "touch": 20,
                        "break": 56,
                        "total": 703
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11659,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2024-03-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "さよならプリンセス",
            "category": "niconico＆ボーカロイド",
            "title": "さよならプリンセス",
            "artist": "Kai",
            "bpm": 195,
            "imageName": "c87c29f338c535601f4266d593fbe3296482acaa644397153b1016a8465e63a1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 15,
                        "slide": 4,
                        "touch": 16,
                        "break": 4,
                        "total": 167
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11660,
                    "releaseDate": "2024-03-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 248,
                        "hold": 13,
                        "slide": 8,
                        "touch": 46,
                        "break": 3,
                        "total": 318
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11660,
                    "releaseDate": "2024-03-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 418,
                        "hold": 55,
                        "slide": 23,
                        "touch": 40,
                        "break": 36,
                        "total": 572
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11660,
                    "releaseDate": "2024-03-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 496,
                        "hold": 61,
                        "slide": 89,
                        "touch": 14,
                        "break": 45,
                        "total": 705
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES",
                    "internalId": 11660,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM": 13.1,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2024-03-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "エスオーエス",
            "category": "maimai",
            "title": "エスオーエス",
            "artist": "カロンズベカラズ",
            "bpm": 196,
            "imageName": "d2f4ba6d3e2ef4aec49e90fdd91333692d6ee2382810738df1bf1149b3e0f6b4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 170,
                        "hold": 14,
                        "slide": 8,
                        "touch": 8,
                        "break": 8,
                        "total": 208
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11669,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 22,
                        "slide": 4,
                        "touch": 24,
                        "break": 8,
                        "total": 402
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11669,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 496,
                        "hold": 40,
                        "slide": 49,
                        "touch": 23,
                        "break": 89,
                        "total": 697
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11669,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 659,
                        "hold": 21,
                        "slide": 188,
                        "touch": 67,
                        "break": 47,
                        "total": 982
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11669,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6
                    },
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "のじゃロリック",
            "category": "maimai",
            "title": "のじゃロリック",
            "artist": "なみぐる feat.ちょこ 桃寝ちのい",
            "bpm": 160,
            "imageName": "65470e7943ecd88fc0f4e12171cce476c85fcdb75614944b594c7c96bc4180ad",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 10,
                        "slide": 8,
                        "touch": 8,
                        "break": 6,
                        "total": 169
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11670,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 7,
                        "slide": 10,
                        "touch": 48,
                        "break": 12,
                        "total": 339
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11670,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 387,
                        "hold": 50,
                        "slide": 42,
                        "touch": 16,
                        "break": 36,
                        "total": 531
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11670,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 549,
                        "hold": 50,
                        "slide": 79,
                        "touch": 22,
                        "break": 68,
                        "total": 768
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11670,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Edelweiss",
            "category": "maimai",
            "title": "Edelweiss",
            "artist": "やどりぎ",
            "bpm": 252,
            "imageName": "f9ec6668254af83d230cda1b6fbdd5329a8fe102d25c6137161b3ca9113c9168",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 20,
                        "slide": 5,
                        "touch": 30,
                        "break": 3,
                        "total": 203
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11671,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 243,
                        "hold": 19,
                        "slide": 9,
                        "touch": 21,
                        "break": 2,
                        "total": 294
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11671,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 425,
                        "hold": 50,
                        "slide": 28,
                        "touch": 41,
                        "break": 7,
                        "total": 551
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11671,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 578,
                        "hold": 68,
                        "slide": 84,
                        "touch": 89,
                        "break": 22,
                        "total": 841
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11671,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "QuiQ",
            "category": "maimai",
            "title": "QuiQ",
            "artist": "owl＊tree feat.nie＊tree",
            "bpm": 120,
            "imageName": "b4e32dd9cb151865862e28ca3aed40ce01475534a27e03ad26d4b0e1f961bca1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 222,
                        "hold": 13,
                        "slide": 4,
                        "touch": 6,
                        "break": 6,
                        "total": 251
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11672,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 339,
                        "hold": 24,
                        "slide": 18,
                        "touch": 16,
                        "break": 9,
                        "total": 406
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11672,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 549,
                        "hold": 100,
                        "slide": 41,
                        "touch": 28,
                        "break": 22,
                        "total": 740
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11672,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 880,
                        "hold": 26,
                        "slide": 119,
                        "touch": 27,
                        "break": 56,
                        "total": 1108
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11672,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4
                    },
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Λzure Vixen",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Λzure Vixen",
            "artist": "かめりあ",
            "bpm": 163,
            "imageName": "3e7484824e1478afb450cd32b215334a8346da28fb8642abe588cc0ce4840dbc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 15,
                        "slide": 8,
                        "touch": 14,
                        "break": 8,
                        "total": 284
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11686,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 22,
                        "slide": 6,
                        "touch": 28,
                        "break": 6,
                        "total": 400
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11686,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 535,
                        "hold": 63,
                        "slide": 58,
                        "touch": 29,
                        "break": 54,
                        "total": 739
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11686,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "BELiZHEL",
                    "noteCounts": {
                        "tap": 1039,
                        "hold": 58,
                        "slide": 87,
                        "touch": 39,
                        "break": 66,
                        "total": 1289
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES"
                        }
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11686,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.6
                    },
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": [
                "azure vixen"
            ]
        },
        {
            "songId": "MarbleBlue.",
            "category": "オンゲキ＆CHUNITHM",
            "title": "MarbleBlue.",
            "artist": "MisoilePunch♪",
            "bpm": 198,
            "imageName": "96672e7b9b68fa8ca5adad28255d095b2632842040ed3b2283ad044b5216ffa9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 187,
                        "hold": 21,
                        "slide": 4,
                        "touch": 33,
                        "break": 3,
                        "total": 248
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11687,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 25,
                        "slide": 6,
                        "touch": 14,
                        "break": 8,
                        "total": 397
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11687,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 475,
                        "hold": 62,
                        "slide": 63,
                        "touch": 52,
                        "break": 31,
                        "total": 683
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11687,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "Twinrook & Safari",
                    "noteCounts": {
                        "tap": 796,
                        "hold": 73,
                        "slide": 79,
                        "touch": 56,
                        "break": 58,
                        "total": 1062
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11687,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5
                    },
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "INTERNET YAMERO",
            "category": "POPS＆アニメ",
            "title": "INTERNET YAMERO",
            "artist": "Aiobahn feat. KOTOKO",
            "bpm": 185,
            "imageName": "c82bc12ab9200d5fe70c0fe2f8ace6ad8a09d982007d699365ad33251416bfdd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 171,
                        "hold": 19,
                        "slide": 6,
                        "touch": 20,
                        "break": 6,
                        "total": 222
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11692,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 303,
                        "hold": 42,
                        "slide": 10,
                        "touch": 21,
                        "break": 13,
                        "total": 389
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11692,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 426,
                        "hold": 135,
                        "slide": 18,
                        "touch": 76,
                        "break": 44,
                        "total": 699
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11692,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.9,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 489,
                        "hold": 79,
                        "slide": 91,
                        "touch": 48,
                        "break": 40,
                        "total": 747
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11692,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 11.9
                    },
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 560,
                        "hold": 55,
                        "slide": 127,
                        "touch": 133,
                        "break": 200,
                        "total": 1075
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11692,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2024-03-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "過去を喰らう",
            "category": "POPS＆アニメ",
            "title": "過去を喰らう",
            "artist": "花譜",
            "bpm": 187,
            "imageName": "9eedb8d59d9b91de7bfbd715689831375e782b838cdb9a4444c4783eaf1c9218",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 17,
                        "slide": 8,
                        "touch": 14,
                        "break": 6,
                        "total": 190
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11693,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 319,
                        "hold": 20,
                        "slide": 3,
                        "touch": 13,
                        "break": 8,
                        "total": 363
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11693,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 366,
                        "hold": 47,
                        "slide": 32,
                        "touch": 33,
                        "break": 28,
                        "total": 506
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11693,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 596,
                        "hold": 43,
                        "slide": 108,
                        "touch": 0,
                        "break": 22,
                        "total": 769
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11693,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM": 12.9,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "強風オールバック",
            "category": "niconico＆ボーカロイド",
            "title": "強風オールバック",
            "artist": "ゆこぴ",
            "bpm": 135,
            "imageName": "733780c613dd07ab2becddc29ede923038d8343f141775893f7a3558b28afd7d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 10,
                        "slide": 2,
                        "touch": 24,
                        "break": 4,
                        "total": 149
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11694,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 224,
                        "hold": 15,
                        "slide": 11,
                        "touch": 10,
                        "break": 6,
                        "total": 266
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11694,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 406,
                        "hold": 35,
                        "slide": 15,
                        "touch": 42,
                        "break": 10,
                        "total": 508
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11694,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "鳩ホルぴー",
                    "noteCounts": {
                        "tap": 363,
                        "hold": 38,
                        "slide": 98,
                        "touch": 50,
                        "break": 31,
                        "total": 580
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11694,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.6,
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": [
                "Kyoufuu All Back"
            ]
        },
        {
            "songId": "寝起きヤシの木",
            "category": "niconico＆ボーカロイド",
            "title": "寝起きヤシの木",
            "artist": "ゆこぴ",
            "bpm": 160,
            "imageName": "f1f9f6d36b18b1976aada326fcba25b9fd32307c3615e34bdd655221a06c6cd6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 115,
                        "hold": 10,
                        "slide": 4,
                        "touch": 8,
                        "break": 2,
                        "total": 139
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11695,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 161,
                        "hold": 23,
                        "slide": 3,
                        "touch": 27,
                        "break": 4,
                        "total": 218
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11695,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 42,
                        "slide": 22,
                        "touch": 28,
                        "break": 25,
                        "total": 389
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11695,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Luxiいぬ",
                    "noteCounts": {
                        "tap": 439,
                        "hold": 5,
                        "slide": 97,
                        "touch": 65,
                        "break": 17,
                        "total": 623
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11695,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": [
                "Neoki Yashinoki",
                "Waking Yashinoki"
            ]
        },
        {
            "songId": "アイドル",
            "category": "POPS＆アニメ",
            "title": "アイドル",
            "artist": "YOASOBI",
            "bpm": 166,
            "imageName": "02abca439349e6ce15375a09f0f3c369ef594f5bc3d2d172544bc94c3e78c1ce",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 14,
                        "slide": 4,
                        "touch": 9,
                        "break": 7,
                        "total": 175
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11696,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 10,
                        "slide": 16,
                        "touch": 17,
                        "break": 10,
                        "total": 282
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11696,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 333,
                        "hold": 66,
                        "slide": 24,
                        "touch": 46,
                        "break": 44,
                        "total": 513
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11696,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11.4,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 425,
                        "hold": 44,
                        "slide": 100,
                        "touch": 11,
                        "break": 49,
                        "total": 629
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11696,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 11.4
                    },
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 503,
                        "hold": 39,
                        "slide": 101,
                        "touch": 44,
                        "break": 110,
                        "total": 797
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11696,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2024-03-20"
                }
            ],
            "searchAcronyms": [
                "idol"
            ]
        },
        {
            "songId": "ラビットホール",
            "category": "niconico＆ボーカロイド",
            "title": "ラビットホール",
            "artist": "DECO*27",
            "bpm": 173,
            "imageName": "7e6dbae884fa635981f6ff548378aeaf6286fb1ac2efee1582fce7a0f1fadcf2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 164,
                        "hold": 18,
                        "slide": 8,
                        "touch": 8,
                        "break": 1,
                        "total": 199
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11697,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 60,
                        "slide": 12,
                        "touch": 27,
                        "break": 12,
                        "total": 334
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11697,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 401,
                        "hold": 64,
                        "slide": 44,
                        "touch": 29,
                        "break": 16,
                        "total": 554
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11697,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.8,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 452,
                        "hold": 73,
                        "slide": 129,
                        "touch": 38,
                        "break": 21,
                        "total": 713
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11697,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 11.8
                    },
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Luxizhel & Jack",
                    "noteCounts": {
                        "tap": 662,
                        "hold": 49,
                        "slide": 158,
                        "touch": 28,
                        "break": 25,
                        "total": 922
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11697,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2024-03-20"
                }
            ],
            "searchAcronyms": [
                "rabbit hole"
            ]
        },
        {
            "songId": "酔いどれ知らず",
            "category": "niconico＆ボーカロイド",
            "title": "酔いどれ知らず",
            "artist": "Kanaria",
            "bpm": 115,
            "imageName": "3ceb7449c8e102c13a54ba39872be5be1efe3cbb41db5dfc23d8e42df0788ae6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 95,
                        "hold": 16,
                        "slide": 4,
                        "touch": 12,
                        "break": 4,
                        "total": 131
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11698,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 180,
                        "hold": 20,
                        "slide": 8,
                        "touch": 11,
                        "break": 6,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11698,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 32,
                        "slide": 28,
                        "touch": 12,
                        "break": 8,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11698,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 373,
                        "hold": 41,
                        "slide": 72,
                        "touch": 18,
                        "break": 9,
                        "total": 513
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11698,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 11.6
                    },
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 497,
                        "hold": 56,
                        "slide": 100,
                        "touch": 12,
                        "break": 35,
                        "total": 700
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11698,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2024-03-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Freak Out Hr.",
            "category": "niconico＆ボーカロイド",
            "title": "Freak Out Hr.",
            "artist": "雄之助 feat. POPY & ROSE",
            "bpm": 180,
            "imageName": "7647a846fb4813cda00d8fb527fd8d87282ca80fd2b43e54204505b7422629d7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 9,
                        "slide": 4,
                        "touch": 16,
                        "break": 2,
                        "total": 173
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11700,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 24,
                        "slide": 6,
                        "touch": 28,
                        "break": 3,
                        "total": 334
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11700,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 474,
                        "hold": 60,
                        "slide": 34,
                        "touch": 10,
                        "break": 6,
                        "total": 584
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11700,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 641,
                        "hold": 42,
                        "slide": 175,
                        "touch": 20,
                        "break": 25,
                        "total": 903
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11700,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "さよならヒストリー",
            "category": "東方Project",
            "title": "さよならヒストリー",
            "artist": "森羅万象",
            "bpm": 180,
            "imageName": "15b5fdafa7686a07eb24eaa2c8bd7f7b6cf0d56bdbf967e07740762d363e833a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 131,
                        "hold": 17,
                        "slide": 4,
                        "touch": 15,
                        "break": 9,
                        "total": 176
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11701,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 34,
                        "slide": 5,
                        "touch": 14,
                        "break": 12,
                        "total": 358
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11701,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 392,
                        "hold": 72,
                        "slide": 51,
                        "touch": 24,
                        "break": 24,
                        "total": 563
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11701,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 511,
                        "hold": 48,
                        "slide": 121,
                        "touch": 16,
                        "break": 64,
                        "total": 760
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11701,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.1,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "New York Back Raise",
            "category": "ゲーム＆バラエティ",
            "title": "New York Back Raise",
            "artist": "saaa + kei_iwata + stuv + わかどり",
            "bpm": 160,
            "imageName": "365232eb26c581f09fe67893f0d1282d35f60a235dd1f698708e6f5159a5a16c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 12,
                        "slide": 8,
                        "touch": 8,
                        "break": 4,
                        "total": 178
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11702,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 19,
                        "slide": 8,
                        "touch": 29,
                        "break": 2,
                        "total": 376
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11702,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 128,
                        "slide": 67,
                        "touch": 92,
                        "break": 32,
                        "total": 656
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11702,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 608,
                        "hold": 93,
                        "slide": 78,
                        "touch": 53,
                        "break": 46,
                        "total": 878
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11702,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "匿名M",
            "category": "niconico＆ボーカロイド",
            "title": "匿名M",
            "artist": "ピノキオピー",
            "bpm": 140,
            "imageName": "7e3280891240d7f72f15eb03be289b21869044b3b38788ee16c71f5a0a22315f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 131,
                        "hold": 13,
                        "slide": 4,
                        "touch": 16,
                        "break": 3,
                        "total": 167
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11714,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 228,
                        "hold": 19,
                        "slide": 14,
                        "touch": 26,
                        "break": 12,
                        "total": 299
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11714,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 313,
                        "hold": 48,
                        "slide": 58,
                        "touch": 24,
                        "break": 32,
                        "total": 475
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11714,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 453,
                        "hold": 62,
                        "slide": 83,
                        "touch": 36,
                        "break": 19,
                        "total": 653
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11714,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": [
                "Anonymous M tokumei m"
            ]
        },
        {
            "songId": "壱雫空",
            "category": "POPS＆アニメ",
            "title": "壱雫空",
            "artist": "MyGO!!!!!",
            "bpm": 204,
            "imageName": "ce3f61736bb249549836b7cb834af1ad4827b46ea2e4ea7c81c924b14a2c4fd6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 101,
                        "hold": 9,
                        "slide": 4,
                        "touch": 13,
                        "break": 1,
                        "total": 128
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11734,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 208,
                        "hold": 10,
                        "slide": 4,
                        "touch": 13,
                        "break": 4,
                        "total": 239
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11734,
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 358,
                        "hold": 30,
                        "slide": 30,
                        "touch": 18,
                        "break": 7,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11734,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 11
                    },
                    "releaseDate": "2024-03-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 502,
                        "hold": 11,
                        "slide": 92,
                        "touch": 11,
                        "break": 18,
                        "total": 634
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11734,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": [
                "Hitoshizuku"
            ]
        },
        {
            "songId": "[J]Garakuta Doll Play",
            "category": "宴会場",
            "title": "[J]Garakuta Doll Play",
            "artist": "t+pazolite",
            "bpm": null,
            "imageName": "2fd925d0bc0256851e1c4c80354c792af803f98e057c95972873b5dd352b6a8f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【J】",
                    "level": "14?",
                    "internalLevelValue": 14,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 110227,
                    "version": "BUDDiES PLUS",
                    "comment": "Jackの現代風アレンジ版",
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[奏]チュルリラ・チュルリラ・ダッダッダ！",
            "category": "宴会場",
            "title": "[奏]チュルリラ・チュルリラ・ダッダッダ！",
            "artist": "和田たけあき(くらげP)",
            "bpm": null,
            "imageName": "5aa1833eff0b847b073299b5a07cf2ba18d942949ef42fbe58980cbbae95160b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【奏】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 110553,
                    "version": "BUDDiES PLUS",
                    "comment": "生き残るのはどっちだッ？？？",
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[協]エイリアンエイリアン",
            "category": "宴会場",
            "title": "[協]エイリアンエイリアン",
            "artist": "ナユタン星人",
            "bpm": null,
            "imageName": "bf5347b1525625b4bbaae20bd9c4d6f8a86904e4b00b22859209fccfe446eb4d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【協】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 110647,
                    "version": "BUDDiES PLUS",
                    "comment": "中央で踊るダンサー、急募。",
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[疑]ロキ",
            "category": "宴会場",
            "title": "[疑]ロキ",
            "artist": "みきとP",
            "bpm": null,
            "imageName": "f1dd2a0b18a6df05e73307ce49369cc327ce4415e9186d108cab1200e509b9a0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【疑】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 110793,
                    "version": "BUDDiES PLUS",
                    "comment": "デタラメのロックンロール",
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[奏]テレキャスタービーボーイ",
            "category": "宴会場",
            "title": "[奏]テレキャスタービーボーイ",
            "artist": "すりぃ",
            "bpm": null,
            "imageName": "71f747d891d6a3996ccaad808929c2c171d4400d2051524a7bbfd735c7579f4e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【奏】",
                    "level": "12+?",
                    "internalLevelValue": 12.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111325,
                    "version": "BUDDiES PLUS",
                    "comment": "誰か一緒に舞わないか？",
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[息]ノンブレス・オブリージュ",
            "category": "宴会場",
            "title": "[息]ノンブレス・オブリージュ",
            "artist": "ピノキオピー",
            "bpm": null,
            "imageName": "a08979e0952e03d7124c6a66066cc0d0a9e51a0689dce3a8eb6663714c1b7c23",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【息】",
                    "level": "13+?",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111597,
                    "version": "BUDDiES PLUS",
                    "comment": "息が詰まる息が詰まる息が詰まる息が詰まる",
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[r]Garakuta Doll Play",
            "category": "宴会場",
            "title": "[r]Garakuta Doll Play",
            "artist": "t+pazolite",
            "bpm": null,
            "imageName": "2fd925d0bc0256851e1c4c80354c792af803f98e057c95972873b5dd352b6a8f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【r】",
                    "level": "14?",
                    "internalLevelValue": 14,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 120227,
                    "version": "BUDDiES PLUS",
                    "comment": "rioNのスライド筋マシマシ版",
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[玉]Garakuta Doll Play",
            "category": "宴会場",
            "title": "[玉]Garakuta Doll Play",
            "artist": "t+pazolite",
            "bpm": null,
            "imageName": "2fd925d0bc0256851e1c4c80354c792af803f98e057c95972873b5dd352b6a8f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【玉】",
                    "level": "14+?",
                    "internalLevelValue": 14.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 130227,
                    "version": "BUDDiES PLUS",
                    "comment": "玉子豆腐のチュウニリスペクト版",
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[某]Garakuta Doll Play",
            "category": "宴会場",
            "title": "[某]Garakuta Doll Play",
            "artist": "t+pazolite",
            "bpm": null,
            "imageName": "2fd925d0bc0256851e1c4c80354c792af803f98e057c95972873b5dd352b6a8f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【某】",
                    "level": "14+?",
                    "internalLevelValue": 14.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 140227,
                    "version": "BUDDiES PLUS",
                    "comment": "パリピS氏のやべーやつ版",
                    "releaseDate": "2024-03-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "DUAL ROZES",
            "category": "ゲーム＆バラエティ",
            "title": "DUAL ROZES",
            "artist": "SOUND HOLIC Vs. Eurobeat Union feat. Nana Takahashi",
            "bpm": 160,
            "imageName": "043914e9a7aa9ac188f337716bfe8375f962d8c30202d7ac30bba87498671a70",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 149,
                        "hold": 12,
                        "slide": 4,
                        "touch": 15,
                        "break": 5,
                        "total": 185
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11704,
                    "releaseDate": "2024-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 16,
                        "slide": 7,
                        "touch": 40,
                        "break": 5,
                        "total": 308
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11704,
                    "releaseDate": "2024-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 66,
                        "slide": 30,
                        "touch": 9,
                        "break": 18,
                        "total": 401
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11704,
                    "releaseDate": "2024-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 596,
                        "hold": 43,
                        "slide": 79,
                        "touch": 21,
                        "break": 86,
                        "total": 825
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11704,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.6
                    },
                    "releaseDate": "2024-04-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "MUSIC PЯAYER",
            "category": "オンゲキ＆CHUNITHM",
            "title": "MUSIC PЯAYER",
            "artist": "A-One",
            "bpm": 168,
            "imageName": "1614d60171023ea752df9e51d2ccc19d0661685dd223b62575350217f6c40a7f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 183,
                        "hold": 14,
                        "slide": 4,
                        "touch": 8,
                        "break": 12,
                        "total": 221
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11733,
                    "releaseDate": "2024-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 332,
                        "hold": 8,
                        "slide": 6,
                        "touch": 16,
                        "break": 10,
                        "total": 372
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11733,
                    "releaseDate": "2024-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 468,
                        "hold": 39,
                        "slide": 43,
                        "touch": 12,
                        "break": 69,
                        "total": 631
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11733,
                    "releaseDate": "2024-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 720,
                        "hold": 20,
                        "slide": 138,
                        "touch": 24,
                        "break": 78,
                        "total": 980
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11733,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.7,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2024-04-01"
                }
            ],
            "searchAcronyms": [
                "MUSIC PRAYER"
            ]
        },
        {
            "songId": "IF:U",
            "category": "maimai",
            "title": "IF:U",
            "artist": "MisoilePunch♪",
            "bpm": 190,
            "imageName": "6da005ce86c14aa6ea4faf94d9ebdf472b6730642c23535b1abc1934584f9f8c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 14,
                        "slide": 8,
                        "touch": 8,
                        "break": 7,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11673,
                    "releaseDate": "2024-04-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 20,
                        "slide": 10,
                        "touch": 17,
                        "break": 4,
                        "total": 327
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11673,
                    "releaseDate": "2024-04-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 404,
                        "hold": 63,
                        "slide": 46,
                        "touch": 62,
                        "break": 41,
                        "total": 616
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11673,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2024-04-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "The Dove",
                    "noteCounts": {
                        "tap": 670,
                        "hold": 32,
                        "slide": 76,
                        "touch": 97,
                        "break": 74,
                        "total": 949
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11673,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 14.7,
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.6
                    },
                    "releaseDate": "2024-04-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "VOLT",
            "category": "ゲーム＆バラエティ",
            "title": "VOLT",
            "artist": "aran",
            "bpm": 174,
            "imageName": "c228c5805aa0cc231ebda867ed8d50f2c9f06bc6cfc828023a50b19005e6cf3d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 10,
                        "slide": 4,
                        "touch": 8,
                        "break": 7,
                        "total": 166
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11705,
                    "releaseDate": "2024-04-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 5,
                        "slide": 10,
                        "touch": 23,
                        "break": 4,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11705,
                    "releaseDate": "2024-04-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 328,
                        "hold": 48,
                        "slide": 26,
                        "touch": 3,
                        "break": 39,
                        "total": 444
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11705,
                    "releaseDate": "2024-04-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 461,
                        "hold": 29,
                        "slide": 77,
                        "touch": 52,
                        "break": 33,
                        "total": 652
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11705,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2024-04-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "tiny tales continue",
            "category": "ゲーム＆バラエティ",
            "title": "tiny tales continue",
            "artist": "黒魔",
            "bpm": 188,
            "imageName": "1b0dc447ff76635c828abc5400f99deadea3f6255b4ef33cd4f79ca6d104156b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 165,
                        "hold": 11,
                        "slide": 6,
                        "touch": 8,
                        "break": 8,
                        "total": 198
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11706,
                    "releaseDate": "2024-04-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 16,
                        "slide": 10,
                        "touch": 30,
                        "break": 4,
                        "total": 338
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11706,
                    "releaseDate": "2024-04-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 366,
                        "hold": 61,
                        "slide": 38,
                        "touch": 11,
                        "break": 22,
                        "total": 498
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11706,
                    "releaseDate": "2024-04-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "サファ太&ぴちネコ",
                    "noteCounts": {
                        "tap": 528,
                        "hold": 96,
                        "slide": 80,
                        "touch": 62,
                        "break": 52,
                        "total": 818
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11706,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2024-04-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ouroboros -twin stroke of the end-",
            "category": "ゲーム＆バラエティ",
            "title": "ouroboros -twin stroke of the end-",
            "artist": "Cranky VS MASAKI",
            "bpm": 188,
            "imageName": "56c3985a2419725fa81cc6464d8d66642c6d9af7539b951ef05643153feaef71",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 15,
                        "slide": 8,
                        "touch": 18,
                        "break": 8,
                        "total": 272
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11707,
                    "releaseDate": "2024-04-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 391,
                        "hold": 22,
                        "slide": 8,
                        "touch": 16,
                        "break": 6,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11707,
                    "releaseDate": "2024-04-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 510,
                        "hold": 72,
                        "slide": 74,
                        "touch": 30,
                        "break": 31,
                        "total": 717
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11707,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2024-04-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 917,
                        "hold": 82,
                        "slide": 68,
                        "touch": 116,
                        "break": 74,
                        "total": 1257
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11707,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 14.4,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.5
                    },
                    "releaseDate": "2024-04-12"
                }
            ],
            "searchAcronyms": [
                "ouroboros"
            ]
        },
        {
            "songId": "カーニバルハッピー",
            "category": "niconico＆ボーカロイド",
            "title": "カーニバルハッピー",
            "artist": "かいりきベア",
            "bpm": 208,
            "imageName": "be30d4bf774b23a20f8d7391f7698fdf2cefcf93681a9facad19bdd6d7f6bf09",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 182,
                        "hold": 12,
                        "slide": 7,
                        "touch": 5,
                        "break": 14,
                        "total": 220
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11708,
                    "releaseDate": "2024-04-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 10,
                        "slide": 15,
                        "touch": 31,
                        "break": 10,
                        "total": 371
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11708,
                    "releaseDate": "2024-04-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 595,
                        "hold": 88,
                        "slide": 28,
                        "touch": 13,
                        "break": 26,
                        "total": 750
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11708,
                    "releaseDate": "2024-04-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 697,
                        "hold": 79,
                        "slide": 125,
                        "touch": 122,
                        "break": 26,
                        "total": 1049
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11708,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2024-04-26"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "つづみぐさ",
            "category": "niconico＆ボーカロイド",
            "title": "つづみぐさ",
            "artist": "いよわ",
            "bpm": 170,
            "imageName": "2a14d8022516c52299a20b24e166cbf30e29fb227472242ea1bac5d5d3eb33cf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 103,
                        "hold": 16,
                        "slide": 7,
                        "touch": 21,
                        "break": 5,
                        "total": 152
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11709,
                    "releaseDate": "2024-04-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 24,
                        "slide": 9,
                        "touch": 28,
                        "break": 2,
                        "total": 303
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11709,
                    "releaseDate": "2024-04-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 82,
                        "slide": 37,
                        "touch": 28,
                        "break": 15,
                        "total": 480
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11709,
                    "releaseDate": "2024-04-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 487,
                        "hold": 61,
                        "slide": 126,
                        "touch": 90,
                        "break": 17,
                        "total": 781
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11709,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2024-04-26"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "サイバーサンダーサイダー",
            "category": "niconico＆ボーカロイド",
            "title": "サイバーサンダーサイダー",
            "artist": "EZFG",
            "bpm": 145,
            "imageName": "1a9ff29600994ed525c9095d0f90d09e891fab86fc997a09fe73f36c5e9027c0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 12,
                        "slide": 4,
                        "touch": 7,
                        "break": 7,
                        "total": 184
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11710,
                    "releaseDate": "2024-04-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 185,
                        "hold": 16,
                        "slide": 10,
                        "touch": 26,
                        "break": 6,
                        "total": 243
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11710,
                    "releaseDate": "2024-04-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 116,
                        "slide": 30,
                        "touch": 23,
                        "break": 20,
                        "total": 466
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11710,
                    "releaseDate": "2024-04-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "みぞれヤナギ&サファ太",
                    "noteCounts": {
                        "tap": 502,
                        "hold": 70,
                        "slide": 55,
                        "touch": 50,
                        "break": 93,
                        "total": 770
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11710,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2024-04-26"
                }
            ],
            "searchAcronyms": [
                "Cyber Thunder Cider"
            ]
        },
        {
            "songId": "おくすり飲んで寝よう",
            "category": "niconico＆ボーカロイド",
            "title": "おくすり飲んで寝よう",
            "artist": "もちうつね",
            "bpm": 130,
            "imageName": "8dbcefb63da171377ffb9330334e08e79a92f6bdff4c9d7aabf04aa7bd5efc04",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 14,
                        "slide": 3,
                        "touch": 9,
                        "break": 4,
                        "total": 158
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11711,
                    "releaseDate": "2024-04-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 16,
                        "slide": 6,
                        "touch": 34,
                        "break": 2,
                        "total": 321
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11711,
                    "releaseDate": "2024-04-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 54,
                        "slide": 42,
                        "touch": 17,
                        "break": 9,
                        "total": 437
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11711,
                    "releaseDate": "2024-04-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 547,
                        "hold": 69,
                        "slide": 98,
                        "touch": 17,
                        "break": 12,
                        "total": 743
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11711,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2024-04-26"
                }
            ],
            "searchAcronyms": [
                "Okusuri nonde neyo"
            ]
        },
        {
            "songId": "Cider P@rty",
            "category": "maimai",
            "title": "Cider P@rty",
            "artist": "Ryo Fukuda",
            "bpm": 180,
            "imageName": "4b8b6f6139b177e8d3fa7cf7446de4bc449401d4a794afbf70857214326a1b34",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 192,
                        "hold": 9,
                        "slide": 4,
                        "touch": 11,
                        "break": 7,
                        "total": 223
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11674,
                    "releaseDate": "2024-05-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 300,
                        "hold": 14,
                        "slide": 10,
                        "touch": 30,
                        "break": 6,
                        "total": 360
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11674,
                    "releaseDate": "2024-05-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "きょむりん",
                    "noteCounts": {
                        "tap": 439,
                        "hold": 39,
                        "slide": 52,
                        "touch": 45,
                        "break": 42,
                        "total": 617
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11674,
                    "releaseDate": "2024-05-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 584,
                        "hold": 75,
                        "slide": 126,
                        "touch": 27,
                        "break": 14,
                        "total": 826
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11674,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2024-05-10"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "勦滅",
            "category": "maimai",
            "title": "勦滅",
            "artist": "siqlo",
            "bpm": 150,
            "imageName": "6455d86ab7e1ff9ac193b79c6b793295c7179c1f41e4bd77480db291bd00345d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 10,
                        "slide": 7,
                        "touch": 15,
                        "break": 8,
                        "total": 230
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11675,
                    "releaseDate": "2024-05-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 329,
                        "hold": 22,
                        "slide": 8,
                        "touch": 14,
                        "break": 4,
                        "total": 377
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11675,
                    "releaseDate": "2024-05-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 376,
                        "hold": 116,
                        "slide": 45,
                        "touch": 32,
                        "break": 12,
                        "total": 581
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11675,
                    "releaseDate": "2024-05-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 773,
                        "hold": 73,
                        "slide": 59,
                        "touch": 77,
                        "break": 48,
                        "total": 1030
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11675,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2
                    },
                    "releaseDate": "2024-05-10"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Lunatic Vibes",
            "category": "maimai",
            "title": "Lunatic Vibes",
            "artist": "K-forest",
            "bpm": 185,
            "imageName": "c4c2a77c66fe531962def38cc8d048a3b6ad5fd15bf366d061573ca72e3e5954",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 12,
                        "slide": 3,
                        "touch": 8,
                        "break": 8,
                        "total": 265
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11676,
                    "releaseDate": "2024-05-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 329,
                        "hold": 24,
                        "slide": 4,
                        "touch": 28,
                        "break": 8,
                        "total": 393
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11676,
                    "releaseDate": "2024-05-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 384,
                        "hold": 81,
                        "slide": 49,
                        "touch": 6,
                        "break": 75,
                        "total": 595
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11676,
                    "releaseDate": "2024-05-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 672,
                        "hold": 76,
                        "slide": 113,
                        "touch": 55,
                        "break": 38,
                        "total": 954
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11676,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2024-05-10"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Bloody Trail",
            "category": "maimai",
            "title": "Bloody Trail",
            "artist": "Hommarju",
            "bpm": 195,
            "imageName": "12dc1af5558a87267fdb57387c884f8e84ff9e971dc74c3ea8991e8d390dd248",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 226,
                        "hold": 13,
                        "slide": 8,
                        "touch": 14,
                        "break": 14,
                        "total": 275
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11677,
                    "releaseDate": "2024-05-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 379,
                        "hold": 16,
                        "slide": 6,
                        "touch": 31,
                        "break": 8,
                        "total": 440
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11677,
                    "releaseDate": "2024-05-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 533,
                        "hold": 127,
                        "slide": 53,
                        "touch": 21,
                        "break": 41,
                        "total": 775
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11677,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.8,
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2024-05-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 882,
                        "hold": 129,
                        "slide": 42,
                        "touch": 3,
                        "break": 100,
                        "total": 1156
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11677,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5
                    },
                    "releaseDate": "2024-05-10"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "新人類",
            "category": "niconico＆ボーカロイド",
            "title": "新人類",
            "artist": "まらしぃ×じん×堀江晶太(kemu) feat.鏡音リン",
            "bpm": 144,
            "imageName": "3c04f2c442ccfd1ae6da1347a1c6e1c725df7bb14fdee146a7d018cf9fa6d4da",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 16,
                        "slide": 4,
                        "touch": 6,
                        "break": 9,
                        "total": 181
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11699,
                    "releaseDate": "2024-05-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 18,
                        "slide": 6,
                        "touch": 28,
                        "break": 8,
                        "total": 310
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11699,
                    "releaseDate": "2024-05-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 371,
                        "hold": 101,
                        "slide": 34,
                        "touch": 74,
                        "break": 32,
                        "total": 612
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11699,
                    "releaseDate": "2024-05-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 896,
                        "hold": 24,
                        "slide": 106,
                        "touch": 4,
                        "break": 26,
                        "total": 1056
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11699,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.6
                    },
                    "releaseDate": "2024-05-24"
                }
            ],
            "searchAcronyms": [
                "New Human Race",
                "Shinjinrui"
            ]
        },
        {
            "songId": "バラバラ〜仮初レインボーローズ〜",
            "category": "POPS＆アニメ",
            "title": "バラバラ〜仮初レインボーローズ〜",
            "artist": "花畑チャイカ＆椎名唯華",
            "bpm": 135,
            "imageName": "ff97407845c7b43e36f7a7e68955f04a4747f81e6c76d6db0d2d5a5d78901f9b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 75,
                        "hold": 14,
                        "slide": 2,
                        "touch": 5,
                        "break": 3,
                        "total": 99
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11712,
                    "releaseDate": "2024-05-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 156,
                        "hold": 17,
                        "slide": 4,
                        "touch": 15,
                        "break": 4,
                        "total": 196
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11712,
                    "releaseDate": "2024-05-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 327,
                        "hold": 21,
                        "slide": 22,
                        "touch": 5,
                        "break": 22,
                        "total": 397
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11712,
                    "releaseDate": "2024-05-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 286,
                        "hold": 33,
                        "slide": 80,
                        "touch": 16,
                        "break": 46,
                        "total": 461
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11712,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.7,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2024-05-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ライアーダンサー",
            "category": "niconico＆ボーカロイド",
            "title": "ライアーダンサー",
            "artist": "マサラダ",
            "bpm": 170,
            "imageName": "84d7f264d0cb789bb59974afb4ddf8a8bbfc3353bf3698310e9cc05255b1afd2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 156,
                        "hold": 18,
                        "slide": 4,
                        "touch": 19,
                        "break": 5,
                        "total": 202
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11715,
                    "releaseDate": "2024-05-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 326,
                        "hold": 18,
                        "slide": 12,
                        "touch": 19,
                        "break": 10,
                        "total": 385
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11715,
                    "releaseDate": "2024-05-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 436,
                        "hold": 67,
                        "slide": 28,
                        "touch": 4,
                        "break": 54,
                        "total": 589
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11715,
                    "releaseDate": "2024-05-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 658,
                        "hold": 52,
                        "slide": 148,
                        "touch": 37,
                        "break": 45,
                        "total": 940
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11715,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2024-05-24"
                }
            ],
            "searchAcronyms": [
                "Liar Dancer"
            ]
        },
        {
            "songId": "バカ通信",
            "category": "niconico＆ボーカロイド",
            "title": "バカ通信",
            "artist": "isonosuke",
            "bpm": 240,
            "imageName": "378b4a939f728c5cc41bbb0d16ff36640508dcec69c3f6ef9c3fd5e94a3e5d9f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 193,
                        "hold": 22,
                        "slide": 5,
                        "touch": 8,
                        "break": 7,
                        "total": 235
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11716,
                    "releaseDate": "2024-05-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 317,
                        "hold": 22,
                        "slide": 8,
                        "touch": 27,
                        "break": 5,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11716,
                    "releaseDate": "2024-05-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 519,
                        "hold": 26,
                        "slide": 57,
                        "touch": 30,
                        "break": 16,
                        "total": 648
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11716,
                    "releaseDate": "2024-05-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 586,
                        "hold": 105,
                        "slide": 142,
                        "touch": 89,
                        "break": 75,
                        "total": 997
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11716,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.6
                    },
                    "releaseDate": "2024-05-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ザムザ",
            "category": "niconico＆ボーカロイド",
            "title": "ザムザ",
            "artist": "てにをは",
            "bpm": 121,
            "imageName": "eb512fa9dfe5ab3f086f324a41c3138c0454c89f7daee5e9e905518120753731",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 85,
                        "hold": 12,
                        "slide": 4,
                        "touch": 4,
                        "break": 6,
                        "total": 111
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11735,
                    "releaseDate": "2024-05-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 19,
                        "slide": 4,
                        "touch": 30,
                        "break": 10,
                        "total": 238
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11735,
                    "releaseDate": "2024-05-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "まぐランド",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 32,
                        "slide": 36,
                        "touch": 13,
                        "break": 28,
                        "total": 359
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11735,
                    "releaseDate": "2024-05-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Jack&アマリリス",
                    "noteCounts": {
                        "tap": 442,
                        "hold": 68,
                        "slide": 53,
                        "touch": 41,
                        "break": 30,
                        "total": 634
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11735,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2024-05-24"
                }
            ],
            "searchAcronyms": [
                "samsa",
                "zamuza",
                "zamza"
            ]
        },
        {
            "songId": "[宴]Oshama Scramble! (Cranky Remix)",
            "category": "宴会場",
            "title": "[宴]Oshama Scramble! (Cranky Remix)",
            "artist": "Cranky",
            "bpm": null,
            "imageName": "13ed9007a46719079f1052d8e6fb767f74b7e563df7060305328d5a52f88c8f1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【宴】",
                    "level": "14+?",
                    "internalLevelValue": 14.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100998,
                    "version": "BUDDiES PLUS",
                    "comment": "ぼくらのかんがえたさいきょうのまいまい",
                    "releaseDate": "2024-05-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[奏]さくゆいたいそう",
            "category": "宴会場",
            "title": "[奏]さくゆいたいそう",
            "artist": "さくゆい",
            "bpm": null,
            "imageName": "009e97266453da8b43416770817b61056d8edca9ddee4d26819bfbf59a7fc502",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【奏】",
                    "level": "12+?",
                    "internalLevelValue": 12.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111636,
                    "version": "BUDDiES PLUS",
                    "comment": "2人合わせてさくゆいたいそう",
                    "releaseDate": "2024-05-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "LOSTPHANTASIA",
            "category": "東方Project",
            "title": "LOSTPHANTASIA",
            "artist": "岸田教団&THE明星ロケッツ×草野華余子",
            "bpm": 133,
            "imageName": "cf8e6cd603dfd15394384f4499adc6f7f188b49fa30e1b9b213be1e640263b39",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 107,
                        "hold": 13,
                        "slide": 4,
                        "touch": 6,
                        "break": 3,
                        "total": 133
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11717,
                    "releaseDate": "2024-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 182,
                        "hold": 18,
                        "slide": 10,
                        "touch": 21,
                        "break": 4,
                        "total": 235
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11717,
                    "releaseDate": "2024-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 206,
                        "hold": 58,
                        "slide": 25,
                        "touch": 19,
                        "break": 21,
                        "total": 329
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11717,
                    "releaseDate": "2024-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 362,
                        "hold": 61,
                        "slide": 68,
                        "touch": 25,
                        "break": 33,
                        "total": 549
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11717,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.7,
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2024-06-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Bad Apple!! feat.nomico (Tetsuya Komuro Remix)",
            "category": "東方Project",
            "title": "Bad Apple!! feat.nomico (Tetsuya Komuro Remix)",
            "artist": "Masayoshi Minoshima Remixed by 小室哲哉",
            "bpm": 135,
            "imageName": "0feb94bb76cc0ea45078b2872f1ce5c3ac754b9b65624ca9b8946f40272df229",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 107,
                        "hold": 9,
                        "slide": 3,
                        "touch": 7,
                        "break": 6,
                        "total": 132
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11718,
                    "releaseDate": "2024-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 166,
                        "hold": 14,
                        "slide": 8,
                        "touch": 27,
                        "break": 8,
                        "total": 223
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11718,
                    "releaseDate": "2024-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 31,
                        "slide": 31,
                        "touch": 17,
                        "break": 15,
                        "total": 399
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11718,
                    "releaseDate": "2024-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 360,
                        "hold": 67,
                        "slide": 88,
                        "touch": 77,
                        "break": 17,
                        "total": 609
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11718,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.1,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2024-06-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Re:Unknown X",
            "category": "東方Project",
            "title": "Re:Unknown X",
            "artist": "まらしぃ",
            "bpm": 190,
            "imageName": "52a02b60219e3a6982df8f2894e89d6cc8515123455acdabac6540db0fdf14cd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 208,
                        "hold": 14,
                        "slide": 8,
                        "touch": 23,
                        "break": 4,
                        "total": 257
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11720,
                    "releaseDate": "2024-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 22,
                        "slide": 12,
                        "touch": 25,
                        "break": 12,
                        "total": 393
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11720,
                    "releaseDate": "2024-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 505,
                        "hold": 30,
                        "slide": 36,
                        "touch": 29,
                        "break": 49,
                        "total": 649
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11720,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2024-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "アミノハバキリ",
                    "noteCounts": {
                        "tap": 983,
                        "hold": 76,
                        "slide": 50,
                        "touch": 59,
                        "break": 21,
                        "total": 1189
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11720,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 14.6,
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "PRiSM": 14.6,
                        "PRiSM PLUS": 14.7
                    },
                    "releaseDate": "2024-06-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "INFiNiTE ENERZY -Overdoze-",
            "category": "ゲーム＆バラエティ",
            "title": "INFiNiTE ENERZY -Overdoze-",
            "artist": "Reku Mochizuki",
            "bpm": 180,
            "imageName": "b0ad5234f21e76e672125d323317ebbc53a58ac3c08c6c6d7992c3edadae4ad6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 201,
                        "hold": 11,
                        "slide": 4,
                        "touch": 14,
                        "break": 7,
                        "total": 237
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11721,
                    "releaseDate": "2024-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 10,
                        "slide": 4,
                        "touch": 46,
                        "break": 4,
                        "total": 336
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11721,
                    "releaseDate": "2024-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 514,
                        "hold": 8,
                        "slide": 66,
                        "touch": 22,
                        "break": 49,
                        "total": 659
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11721,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2024-06-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "Jack vs サファ太",
                    "noteCounts": {
                        "tap": 692,
                        "hold": 40,
                        "slide": 51,
                        "touch": 4,
                        "break": 62,
                        "total": 849
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11721,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14
                    },
                    "releaseDate": "2024-06-07"
                }
            ],
            "searchAcronyms": [
                "infinite energy",
                "infinite enerzy"
            ]
        },
        {
            "songId": "[協]三妖精SAY YA!!!",
            "category": "宴会場",
            "title": "[協]三妖精SAY YA!!!",
            "artist": "森羅万象",
            "bpm": null,
            "imageName": "98d337773b4fc825168c34df7c4116f26c71067db81077ecc3a44c05a14865c0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【協】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111437,
                    "version": "BUDDiES PLUS",
                    "comment": "君たちが三妖精だ！！！",
                    "releaseDate": "2024-06-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[覚]スカーレット警察のゲットーパトロール24時",
            "category": "宴会場",
            "title": "[覚]スカーレット警察のゲットーパトロール24時",
            "artist": "七条レタスグループ",
            "bpm": null,
            "imageName": "56f3f92e3231292d7e859d721153fc365bd42a1955c142945ef813eeb58145d9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【覚】",
                    "level": "12?",
                    "internalLevelValue": 12,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111488,
                    "version": "BUDDiES PLUS",
                    "comment": "隣を見てなぞる順番を覚えるゲーム（初級）",
                    "releaseDate": "2024-06-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "RE:INCARNATED DRAGNER",
            "category": "maimai",
            "title": "RE:INCARNATED DRAGNER",
            "artist": "黒沢ダイスケ × 小寺可南子",
            "bpm": 188,
            "imageName": "170f85816c04d1df9048c154c7bc054f75bfb99d502d4ebd45fbc81a783b0949",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 201,
                        "hold": 17,
                        "slide": 4,
                        "touch": 19,
                        "break": 7,
                        "total": 248
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11678,
                    "releaseDate": "2024-06-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 25,
                        "slide": 6,
                        "touch": 30,
                        "break": 8,
                        "total": 407
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11678,
                    "releaseDate": "2024-06-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 566,
                        "hold": 51,
                        "slide": 43,
                        "touch": 10,
                        "break": 24,
                        "total": 694
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11678,
                    "releaseDate": "2024-06-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 714,
                        "hold": 55,
                        "slide": 127,
                        "touch": 57,
                        "break": 96,
                        "total": 1049
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11678,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.9,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2024-06-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Beginning together!",
            "category": "maimai",
            "title": "Beginning together!",
            "artist": "高瀬一矢 feat. R.I.N.A",
            "bpm": 142,
            "imageName": "645273e5700073f20f0bfcf47f288f5ca089f32b58bfcafcab6ca37a13ef7538",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 20,
                        "slide": 4,
                        "touch": 4,
                        "break": 6,
                        "total": 172
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11679,
                    "releaseDate": "2024-06-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 14,
                        "slide": 4,
                        "touch": 17,
                        "break": 4,
                        "total": 311
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11679,
                    "releaseDate": "2024-06-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 43,
                        "slide": 33,
                        "touch": 20,
                        "break": 20,
                        "total": 472
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11679,
                    "releaseDate": "2024-06-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 531,
                        "hold": 87,
                        "slide": 62,
                        "touch": 37,
                        "break": 73,
                        "total": 790
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11679,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2024-06-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Shining Ray ～僕らの絆～",
            "category": "maimai",
            "title": "Shining Ray ～僕らの絆～",
            "artist": "伊藤和馬(Arte Refact) feat.konoco",
            "bpm": 180,
            "imageName": "da0b992e0534931899f2a329ac29420626aa0d6949bb28495764e8e412508842",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 13,
                        "slide": 9,
                        "touch": 12,
                        "break": 4,
                        "total": 214
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11680,
                    "releaseDate": "2024-06-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 279,
                        "hold": 20,
                        "slide": 6,
                        "touch": 28,
                        "break": 5,
                        "total": 338
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11680,
                    "releaseDate": "2024-06-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 383,
                        "hold": 69,
                        "slide": 32,
                        "touch": 26,
                        "break": 24,
                        "total": 534
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11680,
                    "releaseDate": "2024-06-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 587,
                        "hold": 44,
                        "slide": 101,
                        "touch": 14,
                        "break": 49,
                        "total": 795
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11680,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.3,
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2024-06-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "DEVOTION",
            "category": "maimai",
            "title": "DEVOTION",
            "artist": "AJURIKA feat.SAK.",
            "bpm": 167,
            "imageName": "b0da73f2716997cb4e994642c19bd3164755d888654a8b254a19615921fd7e57",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 11,
                        "slide": 6,
                        "touch": 15,
                        "break": 14,
                        "total": 218
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11681,
                    "releaseDate": "2024-06-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 16,
                        "slide": 6,
                        "touch": 30,
                        "break": 8,
                        "total": 366
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11681,
                    "releaseDate": "2024-06-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 408,
                        "hold": 71,
                        "slide": 55,
                        "touch": 30,
                        "break": 56,
                        "total": 620
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11681,
                    "releaseDate": "2024-06-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "LuxiHertz",
                    "noteCounts": {
                        "tap": 761,
                        "hold": 60,
                        "slide": 102,
                        "touch": 6,
                        "break": 52,
                        "total": 981
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11681,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 14.3,
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3,
                        "PRiSM": 14.3,
                        "PRiSM PLUS": 14.3
                    },
                    "releaseDate": "2024-06-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Make Up Your World feat. キョンシーのCiちゃん & らっぷびと",
            "category": "ゲーム＆バラエティ",
            "title": "Make Up Your World feat. キョンシーのCiちゃん & らっぷびと",
            "artist": "t+pazolite & Srav3R",
            "bpm": 180,
            "imageName": "1db485de3eba435bf24c57d12671cd29ce7586df91f7d2acfec526124bf1b0c1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 187,
                        "hold": 20,
                        "slide": 4,
                        "touch": 12,
                        "break": 9,
                        "total": 232
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11722,
                    "releaseDate": "2024-07-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 16,
                        "slide": 6,
                        "touch": 45,
                        "break": 2,
                        "total": 404
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11722,
                    "releaseDate": "2024-07-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 480,
                        "hold": 57,
                        "slide": 30,
                        "touch": 10,
                        "break": 30,
                        "total": 607
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11722,
                    "releaseDate": "2024-07-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 494,
                        "hold": 39,
                        "slide": 111,
                        "touch": 59,
                        "break": 72,
                        "total": 775
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11722,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.4,
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2024-07-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "BOOM! BOOM!! BOOM!!!",
            "category": "ゲーム＆バラエティ",
            "title": "BOOM! BOOM!! BOOM!!!",
            "artist": "P*Light",
            "bpm": 170,
            "imageName": "b9f3c159f603fe3fc2fc6fb8e925ba8ca2a7faa26d178d234c28b58f03440e40",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 139,
                        "hold": 14,
                        "slide": 4,
                        "touch": 9,
                        "break": 10,
                        "total": 176
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11723,
                    "releaseDate": "2024-07-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 213,
                        "hold": 21,
                        "slide": 8,
                        "touch": 27,
                        "break": 6,
                        "total": 275
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11723,
                    "releaseDate": "2024-07-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 308,
                        "hold": 45,
                        "slide": 25,
                        "touch": 21,
                        "break": 49,
                        "total": 448
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11723,
                    "releaseDate": "2024-07-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "ミニミライト",
                    "noteCounts": {
                        "tap": 600,
                        "hold": 57,
                        "slide": 103,
                        "touch": 14,
                        "break": 17,
                        "total": 791
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11723,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6
                    },
                    "releaseDate": "2024-07-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Everybody Say HARDCORE TANO*C",
            "category": "ゲーム＆バラエティ",
            "title": "Everybody Say HARDCORE TANO*C",
            "artist": "DJ Noriken",
            "bpm": 170,
            "imageName": "095f1e8c02cbd805be86e60207bcafa02bfe056505d3a009d0825565ee12a9dd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 9,
                        "slide": 8,
                        "touch": 6,
                        "break": 10,
                        "total": 245
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11724,
                    "releaseDate": "2024-07-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 334,
                        "hold": 23,
                        "slide": 5,
                        "touch": 14,
                        "break": 16,
                        "total": 392
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11724,
                    "releaseDate": "2024-07-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 384,
                        "hold": 24,
                        "slide": 40,
                        "touch": 25,
                        "break": 90,
                        "total": 563
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11724,
                    "releaseDate": "2024-07-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 644,
                        "hold": 55,
                        "slide": 102,
                        "touch": 54,
                        "break": 66,
                        "total": 921
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11724,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.6
                    },
                    "releaseDate": "2024-07-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ミラクルポップ☆アドベンチャー!!!!!",
            "category": "ゲーム＆バラエティ",
            "title": "ミラクルポップ☆アドベンチャー!!!!!",
            "artist": "DJ Genki",
            "bpm": 180,
            "imageName": "a74785a8a686d6e675f00bf2aaf5d6cd2b66796d76fd1db5d903bf159ad542bf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 219,
                        "hold": 16,
                        "slide": 6,
                        "touch": 6,
                        "break": 9,
                        "total": 256
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11725,
                    "releaseDate": "2024-07-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 331,
                        "hold": 19,
                        "slide": 11,
                        "touch": 37,
                        "break": 5,
                        "total": 403
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11725,
                    "releaseDate": "2024-07-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 514,
                        "hold": 85,
                        "slide": 40,
                        "touch": 15,
                        "break": 58,
                        "total": 712
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11725,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2024-07-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 742,
                        "hold": 62,
                        "slide": 134,
                        "touch": 12,
                        "break": 60,
                        "total": 1010
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11725,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 14.2,
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2
                    },
                    "releaseDate": "2024-07-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Trust",
            "category": "ゲーム＆バラエティ",
            "title": "Trust",
            "artist": "Massive New Krew feat. 光吉猛修",
            "bpm": 155,
            "imageName": "108ec7a7557fc0fbf6e518863d4367664142801e8e101cc1ab1bfaf080517c86",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 12,
                        "slide": 8,
                        "touch": 8,
                        "break": 8,
                        "total": 177
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11726,
                    "releaseDate": "2024-07-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 21,
                        "slide": 7,
                        "touch": 29,
                        "break": 3,
                        "total": 322
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11726,
                    "releaseDate": "2024-07-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 358,
                        "hold": 81,
                        "slide": 59,
                        "touch": 24,
                        "break": 29,
                        "total": 551
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11726,
                    "releaseDate": "2024-07-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 573,
                        "hold": 36,
                        "slide": 95,
                        "touch": 24,
                        "break": 55,
                        "total": 783
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11726,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.6,
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6
                    },
                    "releaseDate": "2024-07-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "QUATTUORUX",
            "category": "ゲーム＆バラエティ",
            "title": "QUATTUORUX",
            "artist": "打打だいず Vs. Tanchiky Vs. からめる",
            "bpm": 220,
            "imageName": "1ab93c49701ea96c9546a018f680bdcf48e79f31f82a062227121ca6e42fe8ac",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 12,
                        "slide": 6,
                        "touch": 36,
                        "break": 32,
                        "total": 316
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11713,
                    "releaseDate": "2024-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 343,
                        "hold": 31,
                        "slide": 17,
                        "touch": 31,
                        "break": 16,
                        "total": 438
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11713,
                    "releaseDate": "2024-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 512,
                        "hold": 79,
                        "slide": 77,
                        "touch": 71,
                        "break": 61,
                        "total": 800
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11713,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2024-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "サファ太 Vs. Safari Vs. さふぁた",
                    "noteCounts": {
                        "tap": 584,
                        "hold": 68,
                        "slide": 104,
                        "touch": 66,
                        "break": 300,
                        "total": 1122
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11713,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5
                    },
                    "releaseDate": "2024-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "華の集落、秋のお届け",
            "category": "maimai",
            "title": "華の集落、秋のお届け",
            "artist": "Umiai",
            "bpm": 165,
            "imageName": "61dbda9e3bcd41e335fea2f6cc9e7b3a005a0ba452be2e9d9adb4fd72b03238b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 117,
                        "hold": 18,
                        "slide": 6,
                        "touch": 9,
                        "break": 5,
                        "total": 155
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11301,
                    "releaseDate": "2021-10-29"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 13,
                        "slide": 28,
                        "touch": 20,
                        "break": 8,
                        "total": 332
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11301,
                    "releaseDate": "2021-10-29"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "翠楼屋",
                    "noteCounts": {
                        "tap": 425,
                        "hold": 70,
                        "slide": 42,
                        "touch": 16,
                        "break": 14,
                        "total": 567
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11301,
                    "multiverInternalLevelValue": {
                        "UNiVERSE": 11.8
                    },
                    "releaseDate": "2021-10-29"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "あまくちジンジャー",
                    "noteCounts": {
                        "tap": 530,
                        "hold": 36,
                        "slide": 67,
                        "touch": 246,
                        "break": 11,
                        "total": 890
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11301,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.9,
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "FESTiVAL": 13.8,
                        "FESTiVAL PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9,
                        "UNiVERSE": 13.9,
                        "UNiVERSE PLUS": 13.9
                    },
                    "releaseDate": "2021-10-29"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 20,
                        "slide": 11,
                        "touch": null,
                        "break": 11,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 1301,
                    "releaseDate": "2024-07-18"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 244,
                        "hold": 40,
                        "slide": 21,
                        "touch": null,
                        "break": 9,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 1301,
                    "releaseDate": "2024-07-18"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 459,
                        "hold": 67,
                        "slide": 60,
                        "touch": null,
                        "break": 25,
                        "total": 611
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 1301,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2024-07-18"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 673,
                        "hold": 60,
                        "slide": 77,
                        "touch": null,
                        "break": 26,
                        "total": 836
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 1301,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.9,
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2024-07-18"
                }
            ],
            "searchAcronyms": [
                "touch当星星",
                "华之集落",
                "华之集落，致以秋意",
                "华的集落",
                "华秋",
                "华落",
                "华集",
                "华集落",
                "滑稽",
                "花村",
                "菲谢尔"
            ]
        },
        {
            "songId": "ラヴィ",
            "category": "niconico＆ボーカロイド",
            "title": "ラヴィ",
            "artist": "すりぃ",
            "bpm": 183,
            "imageName": "c37da0a498a7aeedea50b69d3d672400d6b42ec982cd804c98938f696da6a084",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 8,
                        "slide": 8,
                        "touch": 9,
                        "break": 5,
                        "total": 202
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11727,
                    "releaseDate": "2024-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 314,
                        "hold": 24,
                        "slide": 8,
                        "touch": 16,
                        "break": 10,
                        "total": 372
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11727,
                    "releaseDate": "2024-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 403,
                        "hold": 45,
                        "slide": 59,
                        "touch": 30,
                        "break": 33,
                        "total": 570
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11727,
                    "releaseDate": "2024-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 609,
                        "hold": 73,
                        "slide": 94,
                        "touch": 69,
                        "break": 46,
                        "total": 891
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11727,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2024-07-19"
                }
            ],
            "searchAcronyms": [
                "lavie"
            ]
        },
        {
            "songId": "スティールユー",
            "category": "niconico＆ボーカロイド",
            "title": "スティールユー",
            "artist": "Omoi",
            "bpm": 190,
            "imageName": "f4a82d3695deaf11e8ba246b06a606fa1ac42956aca7ee634a923ad9d7282d39",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 22,
                        "slide": 8,
                        "touch": 8,
                        "break": 2,
                        "total": 202
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11728,
                    "releaseDate": "2024-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 9,
                        "slide": 6,
                        "touch": 28,
                        "break": 6,
                        "total": 398
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11728,
                    "releaseDate": "2024-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 539,
                        "hold": 75,
                        "slide": 52,
                        "touch": 15,
                        "break": 6,
                        "total": 687
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11728,
                    "releaseDate": "2024-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 731,
                        "hold": 28,
                        "slide": 152,
                        "touch": 59,
                        "break": 31,
                        "total": 1001
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11728,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "PRiSM": 13.1,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2024-07-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "オシオキGIMMICK!!",
            "category": "niconico＆ボーカロイド",
            "title": "オシオキGIMMICK!!",
            "artist": "Junky",
            "bpm": 176,
            "imageName": "3f030c91aa1867ee3bd3bf9fc69884fb53ec90050849b419432299eac3cf5bde",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 192,
                        "hold": 12,
                        "slide": 4,
                        "touch": 11,
                        "break": 2,
                        "total": 221
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11729,
                    "releaseDate": "2024-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 22,
                        "slide": 6,
                        "touch": 28,
                        "break": 2,
                        "total": 376
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11729,
                    "releaseDate": "2024-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 480,
                        "hold": 49,
                        "slide": 41,
                        "touch": 15,
                        "break": 41,
                        "total": 626
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11729,
                    "releaseDate": "2024-07-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 568,
                        "hold": 32,
                        "slide": 153,
                        "touch": 50,
                        "break": 29,
                        "total": 832
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11729,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.9,
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2024-07-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Geranium",
            "category": "maimai",
            "title": "Geranium",
            "artist": "Osanzi feat.藍月なくる",
            "bpm": 150,
            "imageName": "09e16a855d903bc36c0bed6aa0b58a5e0e8030e3d7d71079de9a7df8f5a9e333",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 11,
                        "slide": 8,
                        "touch": 13,
                        "break": 11,
                        "total": 237
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11682,
                    "releaseDate": "2024-08-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 286,
                        "hold": 16,
                        "slide": 6,
                        "touch": 30,
                        "break": 4,
                        "total": 342
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11682,
                    "releaseDate": "2024-08-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 417,
                        "hold": 66,
                        "slide": 63,
                        "touch": 19,
                        "break": 6,
                        "total": 571
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11682,
                    "releaseDate": "2024-08-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー & サファ太",
                    "noteCounts": {
                        "tap": 506,
                        "hold": 81,
                        "slide": 106,
                        "touch": 60,
                        "break": 31,
                        "total": 784
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11682,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2024-08-02"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "The Cursed Doll",
            "category": "maimai",
            "title": "The Cursed Doll",
            "artist": "清風明月（Drop×葉月ゆら）",
            "bpm": 131,
            "imageName": "8d58aeddd7db64964619ca481ec2cef032f42e91f051303fd29f190981b8e4be",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 10,
                        "slide": 5,
                        "touch": 10,
                        "break": 5,
                        "total": 205
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11683,
                    "releaseDate": "2024-08-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 13,
                        "slide": 7,
                        "touch": 27,
                        "break": 4,
                        "total": 284
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11683,
                    "releaseDate": "2024-08-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 288,
                        "hold": 44,
                        "slide": 50,
                        "touch": 34,
                        "break": 27,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11683,
                    "releaseDate": "2024-08-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 509,
                        "hold": 61,
                        "slide": 79,
                        "touch": 61,
                        "break": 51,
                        "total": 761
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11683,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2024-08-02"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "RondeauX of RagnaroQ",
            "category": "maimai",
            "title": "RondeauX of RagnaroQ",
            "artist": "Morrigan feat.Lily and 結城碧",
            "bpm": 185,
            "imageName": "cecb5261911395d9646d803345f477e3cfb483b03ef19f56fac3dc3260bf8571",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 15,
                        "slide": 4,
                        "touch": 6,
                        "break": 10,
                        "total": 269
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11684,
                    "releaseDate": "2024-08-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 383,
                        "hold": 10,
                        "slide": 13,
                        "touch": 28,
                        "break": 4,
                        "total": 438
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11684,
                    "releaseDate": "2024-08-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 487,
                        "hold": 49,
                        "slide": 57,
                        "touch": 32,
                        "break": 56,
                        "total": 681
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11684,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12.5,
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2024-08-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "R-blacX of JacQ",
                    "noteCounts": {
                        "tap": 831,
                        "hold": 60,
                        "slide": 97,
                        "touch": 40,
                        "break": 88,
                        "total": 1116
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11684,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 14.5,
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "PRiSM": 14.5,
                        "PRiSM PLUS": 14.5
                    },
                    "releaseDate": "2024-08-02"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ℝ∈Χ LUNATiCA",
            "category": "maimai",
            "title": "ℝ∈Χ LUNATiCA",
            "artist": "Kai",
            "bpm": 230,
            "imageName": "a59296db213734ea0a3377bea2cb0e249fadd135fa48f9e0c458be2e901b421a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 17,
                        "slide": 8,
                        "touch": 30,
                        "break": 12,
                        "total": 298
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11685,
                    "releaseDate": "2024-08-02"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 403,
                        "hold": 26,
                        "slide": 16,
                        "touch": 0,
                        "break": 6,
                        "total": 451
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11685,
                    "releaseDate": "2024-08-02"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 552,
                        "hold": 86,
                        "slide": 41,
                        "touch": 25,
                        "break": 9,
                        "total": 713
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11685,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2024-08-02"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "BELiZHEL",
                    "noteCounts": {
                        "tap": 826,
                        "hold": 49,
                        "slide": 123,
                        "touch": 29,
                        "break": 76,
                        "total": 1103
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11685,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 14.8,
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8
                    },
                    "releaseDate": "2024-08-02"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[奏]ヒトガタ",
            "category": "宴会場",
            "title": "[奏]ヒトガタ",
            "artist": "HIMEHINA",
            "bpm": null,
            "imageName": "6608ba9e4388bdaa82f6816bff33cc263777c7a53faeddf4d8f42731daa8b842",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【奏】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111433,
                    "version": "BUDDiES PLUS",
                    "comment": "ココロを叫べ!",
                    "releaseDate": "2024-08-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[両]はんぶんこ",
            "category": "宴会場",
            "title": "[両]はんぶんこ",
            "artist": "三枝明那",
            "bpm": null,
            "imageName": "c6c67b5c18de82e56bda42a91de09c771672e246ce7fc08d3260a025a18476f9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【両】",
                    "level": "12?",
                    "internalLevelValue": 12,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111577,
                    "version": "BUDDiES PLUS",
                    "comment": "もう一人じゃないから",
                    "releaseDate": "2024-08-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "偉大なる悪魔は実は大天使パトラちゃん様なのだ！",
            "category": "POPS＆アニメ",
            "title": "偉大なる悪魔は実は大天使パトラちゃん様なのだ！",
            "artist": "周防パトラ",
            "bpm": 195,
            "imageName": "fb91e783b73a67d5213d30713b854585f976ff3255233c91ca7a98ba839ddf0a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 155,
                        "hold": 18,
                        "slide": 6,
                        "touch": 26,
                        "break": 6,
                        "total": 211
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11730,
                    "releaseDate": "2024-08-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 303,
                        "hold": 26,
                        "slide": 7,
                        "touch": 50,
                        "break": 2,
                        "total": 388
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11730,
                    "releaseDate": "2024-08-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 414,
                        "hold": 75,
                        "slide": 42,
                        "touch": 20,
                        "break": 25,
                        "total": 576
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11730,
                    "releaseDate": "2024-08-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 583,
                        "hold": 129,
                        "slide": 122,
                        "touch": 39,
                        "break": 62,
                        "total": 935
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11730,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2024-08-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "シュガーホリック",
            "category": "POPS＆アニメ",
            "title": "シュガーホリック",
            "artist": "周防パトラ",
            "bpm": 170,
            "imageName": "67447a336d600d94216d3d450e8e80d2a04211cddb6755599c70341fcecd6ef2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 22,
                        "slide": 4,
                        "touch": 22,
                        "break": 4,
                        "total": 180
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11731,
                    "releaseDate": "2024-08-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 299,
                        "hold": 27,
                        "slide": 5,
                        "touch": 21,
                        "break": 2,
                        "total": 354
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11731,
                    "releaseDate": "2024-08-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 51,
                        "slide": 32,
                        "touch": 18,
                        "break": 29,
                        "total": 505
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11731,
                    "releaseDate": "2024-08-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 524,
                        "hold": 58,
                        "slide": 86,
                        "touch": 30,
                        "break": 24,
                        "total": 722
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11731,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.1,
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "PRiSM": 13.1,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2024-08-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "まっすぐ→→→ストリーム！",
            "category": "オンゲキ＆CHUNITHM",
            "title": "まっすぐ→→→ストリーム！",
            "artist": "曲：本多友紀（Arte Refact）／歌：日向 千夏(CV：岡咲 美保)",
            "bpm": 184,
            "imageName": "025f3542946baa2bb4e61e2270fd7f933d605c0321300748b2a6ff1e11a70c71",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 178,
                        "hold": 11,
                        "slide": 8,
                        "touch": 23,
                        "break": 12,
                        "total": 232
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11688,
                    "releaseDate": "2024-08-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 15,
                        "slide": 14,
                        "touch": 35,
                        "break": 18,
                        "total": 400
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11688,
                    "releaseDate": "2024-08-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 415,
                        "hold": 63,
                        "slide": 29,
                        "touch": 23,
                        "break": 70,
                        "total": 600
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11688,
                    "releaseDate": "2024-08-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 626,
                        "hold": 45,
                        "slide": 140,
                        "touch": 49,
                        "break": 100,
                        "total": 960
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11688,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.5,
                        "CiRCLE": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2024-08-30"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "最っ高のエンタメだ!!",
            "category": "オンゲキ＆CHUNITHM",
            "title": "最っ高のエンタメだ!!",
            "artist": "曲：本田正樹(Dream Monster)／歌：7EVENDAYS⇔HOLIDAYS [井之原 小星(CV：ももの はるな)、柏木 咲姫(CV：石見 舞菜香)]",
            "bpm": 276,
            "imageName": "f0026f5f8aaee4f8e6f0b2e50b3a53a9873ede21b6165f8e9eadbe4417719f38",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 15,
                        "slide": 8,
                        "touch": 9,
                        "break": 4,
                        "total": 259
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11689,
                    "releaseDate": "2024-08-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 22,
                        "slide": 8,
                        "touch": 12,
                        "break": 8,
                        "total": 304
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11689,
                    "releaseDate": "2024-08-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 489,
                        "hold": 72,
                        "slide": 59,
                        "touch": 11,
                        "break": 25,
                        "total": 656
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11689,
                    "releaseDate": "2024-08-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 573,
                        "hold": 55,
                        "slide": 120,
                        "touch": 92,
                        "break": 102,
                        "total": 942
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11689,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.7,
                        "CiRCLE": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2024-08-30"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Baqeela",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Baqeela",
            "artist": "owl＊tree",
            "bpm": 130,
            "imageName": "3550a72d87899eb9d76c928147865378525d60af827e80e5a873253cf8bb90ec",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 158,
                        "hold": 12,
                        "slide": 6,
                        "touch": 15,
                        "break": 4,
                        "total": 195
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11690,
                    "releaseDate": "2024-08-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 23,
                        "slide": 12,
                        "touch": 28,
                        "break": 3,
                        "total": 299
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11690,
                    "releaseDate": "2024-08-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 487,
                        "hold": 41,
                        "slide": 32,
                        "touch": 28,
                        "break": 32,
                        "total": 620
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11690,
                    "releaseDate": "2024-08-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "りんご Full Set",
                    "noteCounts": {
                        "tap": 673,
                        "hold": 50,
                        "slide": 75,
                        "touch": 140,
                        "break": 44,
                        "total": 982
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11690,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 13.8,
                        "CiRCLE": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2024-08-30"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Ai C",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Ai C",
            "artist": "Feryquitous",
            "bpm": 191,
            "imageName": "e9edc8f10a5c853b7f484fd052080330e0bd75421166dd76629b755d40bcb729",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 16,
                        "slide": 8,
                        "touch": 8,
                        "break": 10,
                        "total": 228
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11691,
                    "releaseDate": "2024-08-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 21,
                        "slide": 6,
                        "touch": 28,
                        "break": 6,
                        "total": 336
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11691,
                    "releaseDate": "2024-08-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 34,
                        "slide": 55,
                        "touch": 30,
                        "break": 11,
                        "total": 532
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11691,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 12,
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2024-08-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "メロンポップ",
                    "noteCounts": {
                        "tap": 670,
                        "hold": 50,
                        "slide": 84,
                        "touch": 32,
                        "break": 33,
                        "total": 869
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "BUDDiES PLUS",
                    "internalId": 11691,
                    "multiverInternalLevelValue": {
                        "BUDDiES PLUS": 14,
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14
                    },
                    "releaseDate": "2024-08-30"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "パラドクスイヴ",
            "category": "maimai",
            "title": "パラドクスイヴ",
            "artist": "Teary Planet",
            "bpm": 180,
            "imageName": "499cae0991bdafd23c0e80fc42b15029b98799b5cd427429246a50b9970a2446",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 148,
                        "hold": 20,
                        "slide": 4,
                        "touch": 8,
                        "break": 3,
                        "total": 183
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11737,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 269,
                        "hold": 20,
                        "slide": 9,
                        "touch": 25,
                        "break": 2,
                        "total": 325
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11737,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 350,
                        "hold": 58,
                        "slide": 48,
                        "touch": 12,
                        "break": 32,
                        "total": 500
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11737,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "あまくちジンジャー",
                    "noteCounts": {
                        "tap": 441,
                        "hold": 89,
                        "slide": 83,
                        "touch": 72,
                        "break": 33,
                        "total": 718
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11737,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "YKWTD",
            "category": "maimai",
            "title": "YKWTD",
            "artist": "r-906",
            "bpm": 174,
            "imageName": "9558f7a700d0ea7ffdd4aa0cc4b6a0ae1b32c42cf2f32b977c2a64f113089784",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 15,
                        "slide": 4,
                        "touch": 6,
                        "break": 6,
                        "total": 243
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11738,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 296,
                        "hold": 4,
                        "slide": 16,
                        "touch": 25,
                        "break": 4,
                        "total": 345
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11738,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 50,
                        "slide": 66,
                        "touch": 35,
                        "break": 19,
                        "total": 521
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11738,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 544,
                        "hold": 16,
                        "slide": 142,
                        "touch": 124,
                        "break": 19,
                        "total": 845
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11738,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "184億回のマルチトニック",
            "category": "maimai",
            "title": "184億回のマルチトニック",
            "artist": "Pizuya's Cell feat.中村さん",
            "bpm": 184,
            "imageName": "9d58639383e9231f86b9847dff6950f11e15f1db836e102d7a453043e95100b4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 14,
                        "slide": 6,
                        "touch": 8,
                        "break": 8,
                        "total": 277
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11739,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 323,
                        "hold": 24,
                        "slide": 10,
                        "touch": 33,
                        "break": 1,
                        "total": 391
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11739,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 490,
                        "hold": 54,
                        "slide": 62,
                        "touch": 14,
                        "break": 38,
                        "total": 658
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11739,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 886,
                        "hold": 31,
                        "slide": 116,
                        "touch": 73,
                        "break": 38,
                        "total": 1144
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11739,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14,
                        "PRiSM": 14.1,
                        "PRiSM PLUS": 14.1
                    },
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Elemental Ethnic",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Elemental Ethnic",
            "artist": "Yooh",
            "bpm": 163,
            "imageName": "916c2100a78681336fb078803e39cb7b834e9aad43261efdca5c9f7eed5039e2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 8,
                        "slide": 4,
                        "touch": 20,
                        "break": 12,
                        "total": 306
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11754,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 328,
                        "hold": 22,
                        "slide": 5,
                        "touch": 30,
                        "break": 5,
                        "total": 390
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11754,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 557,
                        "hold": 37,
                        "slide": 46,
                        "touch": 28,
                        "break": 33,
                        "total": 701
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11754,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "サファ太 ＆ 鳩ホルダー",
                    "noteCounts": {
                        "tap": 836,
                        "hold": 64,
                        "slide": 89,
                        "touch": 23,
                        "break": 70,
                        "total": 1082
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11754,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14.2,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14
                    },
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "美夜月鏡",
            "category": "オンゲキ＆CHUNITHM",
            "title": "美夜月鏡",
            "artist": "かゆき",
            "bpm": 164,
            "imageName": "9efb2808b7f4a8d94cd588b739ca21bc5771e7488928befc46fd70aa058e5567",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 207,
                        "hold": 8,
                        "slide": 11,
                        "touch": 9,
                        "break": 5,
                        "total": 240
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11755,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 31,
                        "slide": 14,
                        "touch": 13,
                        "break": 9,
                        "total": 331
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11755,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 412,
                        "hold": 92,
                        "slide": 42,
                        "touch": 11,
                        "break": 8,
                        "total": 565
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11755,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "PRiSM": 12.2,
                        "PRiSM PLUS": 12.2
                    },
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 676,
                        "hold": 102,
                        "slide": 82,
                        "touch": 116,
                        "break": 35,
                        "total": 1011
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11755,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.1,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2
                    },
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "勇者",
            "category": "POPS＆アニメ",
            "title": "勇者",
            "artist": "YOASOBI",
            "bpm": 104,
            "imageName": "246c998cad5e7a1c3ab7458ad1089e2ddf34d6f9ec1d8fda4323989a13bd33f0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 73,
                        "hold": 4,
                        "slide": 4,
                        "touch": 8,
                        "break": 5,
                        "total": 94
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11760,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 110,
                        "hold": 10,
                        "slide": 6,
                        "touch": 14,
                        "break": 13,
                        "total": 153
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11760,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "まぐランド",
                    "noteCounts": {
                        "tap": 217,
                        "hold": 15,
                        "slide": 18,
                        "touch": 5,
                        "break": 16,
                        "total": 271
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11760,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.7,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 289,
                        "hold": 44,
                        "slide": 38,
                        "touch": 8,
                        "break": 17,
                        "total": 396
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11760,
                    "multiverInternalLevelValue": {
                        "PRiSM": 11.7
                    },
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 369,
                        "hold": 17,
                        "slide": 52,
                        "touch": 44,
                        "break": 35,
                        "total": 517
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11760,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2024-09-11"
                }
            ],
            "searchAcronyms": [
                "yuusha  hero"
            ]
        },
        {
            "songId": "病み垢ステロイド",
            "category": "niconico＆ボーカロイド",
            "title": "病み垢ステロイド",
            "artist": "かいりきベア",
            "bpm": 203,
            "imageName": "0703cc12b9f4d6b89961a170a1b5ad895b487e2d700c107978b4941b0e6c000b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 18,
                        "slide": 6,
                        "touch": 22,
                        "break": 5,
                        "total": 250
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11761,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 35,
                        "slide": 8,
                        "touch": 26,
                        "break": 2,
                        "total": 364
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11761,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 409,
                        "hold": 70,
                        "slide": 19,
                        "touch": 23,
                        "break": 106,
                        "total": 627
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11761,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 458,
                        "hold": 79,
                        "slide": 171,
                        "touch": 168,
                        "break": 35,
                        "total": 911
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11761,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ダーリンダンス",
            "category": "niconico＆ボーカロイド",
            "title": "ダーリンダンス",
            "artist": "かいりきベア",
            "bpm": 153,
            "imageName": "6a705833403a19ad74a9d77114712d3aaee8d063b371ecd71dd38c822dc3cf84",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 9,
                        "slide": 6,
                        "touch": 6,
                        "break": 9,
                        "total": 192
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11763,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 16,
                        "slide": 7,
                        "touch": 13,
                        "break": 5,
                        "total": 303
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11763,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 362,
                        "hold": 81,
                        "slide": 53,
                        "touch": 24,
                        "break": 31,
                        "total": 551
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11763,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.8,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 523,
                        "hold": 67,
                        "slide": 71,
                        "touch": 15,
                        "break": 33,
                        "total": 709
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11763,
                    "multiverInternalLevelValue": {
                        "PRiSM": 11.8
                    },
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 670,
                        "hold": 85,
                        "slide": 77,
                        "touch": 8,
                        "break": 64,
                        "total": 904
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11763,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2024-09-11"
                }
            ],
            "searchAcronyms": [
                "Darling Dance"
            ]
        },
        {
            "songId": "唱",
            "category": "POPS＆アニメ",
            "title": "唱",
            "artist": "Ado",
            "bpm": 132,
            "imageName": "b7f14674b8a0d2da02aec0c25af24abb1b3def062463c045b6bd46c354806a17",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 104,
                        "hold": 12,
                        "slide": 6,
                        "touch": 6,
                        "break": 10,
                        "total": 138
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11764,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 199,
                        "hold": 16,
                        "slide": 6,
                        "touch": 13,
                        "break": 5,
                        "total": 239
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11764,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 56,
                        "slide": 16,
                        "touch": 2,
                        "break": 51,
                        "total": 431
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11764,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.8,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 69,
                        "slide": 84,
                        "touch": 51,
                        "break": 38,
                        "total": 577
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11764,
                    "multiverInternalLevelValue": {
                        "PRiSM": 11.8
                    },
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 466,
                        "hold": 53,
                        "slide": 91,
                        "touch": 146,
                        "break": 55,
                        "total": 811
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11764,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2024-09-11"
                }
            ],
            "searchAcronyms": [
                "show"
            ]
        },
        {
            "songId": "愛包ダンスホール",
            "category": "POPS＆アニメ",
            "title": "愛包ダンスホール",
            "artist": "HIMEHINA",
            "bpm": 141,
            "imageName": "70b6b7e7c3a013ba1393702eec9834ae1852966c480dab9b7a7e647c5824b1ab",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 13,
                        "slide": 4,
                        "touch": 4,
                        "break": 10,
                        "total": 182
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11765,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 16,
                        "slide": 9,
                        "touch": 14,
                        "break": 1,
                        "total": 315
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11765,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 394,
                        "hold": 45,
                        "slide": 21,
                        "touch": 20,
                        "break": 34,
                        "total": 514
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11765,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 598,
                        "hold": 65,
                        "slide": 75,
                        "touch": 46,
                        "break": 55,
                        "total": 839
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11765,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "PRiSM": 13.1,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": [
                "heart pie dancehall aipai dancehall"
            ]
        },
        {
            "songId": "マツケンサンバⅡ",
            "category": "POPS＆アニメ",
            "title": "マツケンサンバⅡ",
            "artist": "松平健 [covered by 光吉猛修]",
            "bpm": 133,
            "imageName": "79efa833262eeedb6d7f529acd70175c6b8ec55e42b5a8aa4c9bbbdc5104b318",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 140,
                        "hold": 17,
                        "slide": 6,
                        "touch": 11,
                        "break": 10,
                        "total": 184
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11766,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 201,
                        "hold": 28,
                        "slide": 8,
                        "touch": 26,
                        "break": 8,
                        "total": 271
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11766,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 266,
                        "hold": 38,
                        "slide": 48,
                        "touch": 28,
                        "break": 50,
                        "total": 430
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11766,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 407,
                        "hold": 39,
                        "slide": 98,
                        "touch": 30,
                        "break": 63,
                        "total": 637
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11766,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": [
                "matsuken samba",
                "matsuken samba ii"
            ]
        },
        {
            "songId": "デビルじゃないもん",
            "category": "niconico＆ボーカロイド",
            "title": "デビルじゃないもん",
            "artist": "DECO*27, ピノキオピー",
            "bpm": 154,
            "imageName": "7e7cc9f39a8aae620baafa0b48bedca5ba9779b8bb10b861607ac801567e3c7b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 171,
                        "hold": 11,
                        "slide": 2,
                        "touch": 6,
                        "break": 16,
                        "total": 206
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11767,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 14,
                        "slide": 9,
                        "touch": 13,
                        "break": 5,
                        "total": 319
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11767,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 376,
                        "hold": 25,
                        "slide": 32,
                        "touch": 22,
                        "break": 32,
                        "total": 487
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11767,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 578,
                        "hold": 27,
                        "slide": 97,
                        "touch": 38,
                        "break": 32,
                        "total": 772
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11767,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": [
                "devil jya naimon",
                "not a devil"
            ]
        },
        {
            "songId": "ずんだパーリナイ",
            "category": "niconico＆ボーカロイド",
            "title": "ずんだパーリナイ",
            "artist": "なみぐる feat.ずんだもん",
            "bpm": 150,
            "imageName": "6b89af91d7d80da6e079ed56c9b3922cf50ada6862e2ecdfdf472edbd40f91a4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 159,
                        "hold": 12,
                        "slide": 6,
                        "touch": 10,
                        "break": 8,
                        "total": 195
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11769,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 286,
                        "hold": 16,
                        "slide": 10,
                        "touch": 14,
                        "break": 4,
                        "total": 330
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11769,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 355,
                        "hold": 88,
                        "slide": 23,
                        "touch": 20,
                        "break": 54,
                        "total": 540
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11769,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 520,
                        "hold": 114,
                        "slide": 92,
                        "touch": 162,
                        "break": 110,
                        "total": 998
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11769,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": [
                "zunda party night"
            ]
        },
        {
            "songId": "Ultimate taste",
            "category": "東方Project",
            "title": "Ultimate taste",
            "artist": "ぱらどっと",
            "bpm": 200,
            "imageName": "6234a6b63bdc987c38d87f9a99821fc1dc95e33d9ac5c1baa5fc4673f7803636",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 192,
                        "hold": 11,
                        "slide": 8,
                        "touch": 25,
                        "break": 12,
                        "total": 248
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11770,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 289,
                        "hold": 19,
                        "slide": 10,
                        "touch": 43,
                        "break": 3,
                        "total": 364
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11770,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 443,
                        "hold": 51,
                        "slide": 45,
                        "touch": 22,
                        "break": 34,
                        "total": 595
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11770,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 671,
                        "hold": 57,
                        "slide": 110,
                        "touch": 22,
                        "break": 52,
                        "total": 912
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11770,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Chronomia",
            "category": "ゲーム＆バラエティ",
            "title": "Chronomia",
            "artist": "Lime",
            "bpm": 227,
            "imageName": "be6e11e7e56d11720798287b3d4e7d5add7da656acd802174e1c9bd77032496b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 14,
                        "slide": 7,
                        "touch": 14,
                        "break": 5,
                        "total": 270
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11771,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 18,
                        "slide": 11,
                        "touch": 27,
                        "break": 5,
                        "total": 406
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11771,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 437,
                        "hold": 49,
                        "slide": 75,
                        "touch": 28,
                        "break": 53,
                        "total": 642
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11771,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "サファ太 respects for 小鳥遊さん",
                    "noteCounts": {
                        "tap": 617,
                        "hold": 72,
                        "slide": 128,
                        "touch": 28,
                        "break": 77,
                        "total": 922
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11771,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2
                    },
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "リアライズ",
            "category": "niconico＆ボーカロイド",
            "title": "リアライズ",
            "artist": "柊マグネタイト",
            "bpm": 150,
            "imageName": "440f89f419710cb8b5922d4b8d128fb5448744f7c59ca0add7136a25b4a55227",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 20,
                        "slide": 4,
                        "touch": 12,
                        "break": 4,
                        "total": 175
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11805,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 20,
                        "slide": 9,
                        "touch": 25,
                        "break": 2,
                        "total": 353
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11805,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 374,
                        "hold": 70,
                        "slide": 44,
                        "touch": 9,
                        "break": 21,
                        "total": 518
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11805,
                    "multiverInternalLevelValue": {
                        "PRiSM": 10
                    },
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 632,
                        "hold": 53,
                        "slide": 87,
                        "touch": 37,
                        "break": 27,
                        "total": 836
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11805,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": [
                "realise",
                "realize"
            ]
        },
        {
            "songId": "[回]ダブルラリアット",
            "category": "宴会場",
            "title": "[回]ダブルラリアット",
            "artist": "アゴアニキ",
            "bpm": null,
            "imageName": "7d0c91c09383d4edc9a9af1c9a5f4247ce7121879a3b10230d92f73f22c7776d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【回】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 110281,
                    "version": "PRiSM",
                    "comment": "今から振り回しますので離れていてください",
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[習]ウミユリ海底譚",
            "category": "宴会場",
            "title": "[習]ウミユリ海底譚",
            "artist": "n-buna",
            "bpm": null,
            "imageName": "e05e2a6fc30cd26f1b87310732062c03fdcc3900808695594d4b7d1c625c7315",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【習】",
                    "level": "12+?",
                    "internalLevelValue": 12.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 110417,
                    "version": "PRiSM",
                    "comment": "ウミユリ練習譚",
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[奏]洗脳",
            "category": "宴会場",
            "title": "[奏]洗脳",
            "artist": "ゆりん・柿チョコ×Neru",
            "bpm": null,
            "imageName": "42a34325108104e045ba061d4d478a16d1a8cdc6ba77ed89bd679d4ca6e19af5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【奏】",
                    "level": "12+?",
                    "internalLevelValue": 12.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 110532,
                    "version": "PRiSM",
                    "comment": "知ってた？元祖デュエット譜面",
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[協]太陽系デスコ",
            "category": "宴会場",
            "title": "[協]太陽系デスコ",
            "artist": "ナユタン星人",
            "bpm": null,
            "imageName": "5c741b9b7103837cf5c2917c3523195f9f0b9ff22a81e981b154b49645a99063",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【協】",
                    "level": "11+?",
                    "internalLevelValue": 11.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111069,
                    "version": "PRiSM",
                    "comment": "一緒にデスコ",
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[奏]アンビバレンス",
            "category": "宴会場",
            "title": "[奏]アンビバレンス",
            "artist": "すりぃ×相沢",
            "bpm": null,
            "imageName": "9c5f25f41c1a8ea31109b58dd31b537e7e6aea0e4daa08d282841ca767515afc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【奏】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111365,
                    "version": "PRiSM",
                    "comment": "アンビバレンスな私なの",
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "果ての空、僕らが見た光。",
            "category": "maimai",
            "title": "果ての空、僕らが見た光。",
            "artist": "TAKU1175 ft.駄々子",
            "bpm": 178,
            "imageName": "1275bb73fb80851e8cd8705bbc27b98b6ebe77927ddbf7fe5a760679ba02b847",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 194,
                        "hold": 17,
                        "slide": 4,
                        "touch": 8,
                        "break": 4,
                        "total": 227
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11740,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 308,
                        "hold": 16,
                        "slide": 7,
                        "touch": 26,
                        "break": 1,
                        "total": 358
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11740,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 59,
                        "slide": 34,
                        "touch": 27,
                        "break": 44,
                        "total": 499
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11740,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 590,
                        "hold": 49,
                        "slide": 103,
                        "touch": 50,
                        "break": 28,
                        "total": 820
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11740,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.6,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2024-09-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "人マニア",
            "category": "niconico＆ボーカロイド",
            "title": "人マニア",
            "artist": "原口沙輔 feat.重音テト",
            "bpm": 150,
            "imageName": "a12463905c6a1154f56d89c0acda045f7f3fc77ff063e35413ec616ce74b4585",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 128,
                        "hold": 13,
                        "slide": 4,
                        "touch": 6,
                        "break": 6,
                        "total": 157
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11772,
                    "releaseDate": "2024-09-27"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 192,
                        "hold": 18,
                        "slide": 8,
                        "touch": 22,
                        "break": 4,
                        "total": 244
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11772,
                    "releaseDate": "2024-09-27"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "きょむりん",
                    "noteCounts": {
                        "tap": 213,
                        "hold": 49,
                        "slide": 26,
                        "touch": 80,
                        "break": 52,
                        "total": 420
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11772,
                    "releaseDate": "2024-09-27"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 422,
                        "hold": 26,
                        "slide": 95,
                        "touch": 168,
                        "break": 72,
                        "total": 783
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11772,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2024-09-27"
                }
            ],
            "searchAcronyms": [
                "hitomania"
            ]
        },
        {
            "songId": "イガク",
            "category": "niconico＆ボーカロイド",
            "title": "イガク",
            "artist": "原口沙輔 feat.重音テト",
            "bpm": 170,
            "imageName": "a5c0a49ce221ee05202eb05d7cde29fcd909ff310a514b1201e62645714c97c4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 110,
                        "hold": 12,
                        "slide": 6,
                        "touch": 19,
                        "break": 4,
                        "total": 151
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11784,
                    "releaseDate": "2024-09-27"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 13,
                        "slide": 7,
                        "touch": 30,
                        "break": 6,
                        "total": 286
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11784,
                    "releaseDate": "2024-09-27"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 279,
                        "hold": 26,
                        "slide": 32,
                        "touch": 45,
                        "break": 138,
                        "total": 520
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11784,
                    "releaseDate": "2024-09-27"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 398,
                        "hold": 75,
                        "slide": 140,
                        "touch": 125,
                        "break": 55,
                        "total": 793
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11784,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2024-09-27"
                }
            ],
            "searchAcronyms": [
                "igaku"
            ]
        },
        {
            "songId": "Cryptarithm",
            "category": "maimai",
            "title": "Cryptarithm",
            "artist": "削除",
            "bpm": 175,
            "imageName": "ebf06f89afe89c21bde2f539772dcebdfdd1e8f99652cf42a3621205b8442848",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 19,
                        "slide": 7,
                        "touch": 8,
                        "break": 8,
                        "total": 283
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11741,
                    "releaseDate": "2024-10-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 326,
                        "hold": 14,
                        "slide": 15,
                        "touch": 25,
                        "break": 9,
                        "total": 389
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11741,
                    "releaseDate": "2024-10-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 553,
                        "hold": 39,
                        "slide": 67,
                        "touch": 13,
                        "break": 31,
                        "total": 703
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11741,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2024-10-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "Safazhel",
                    "noteCounts": {
                        "tap": 683,
                        "hold": 114,
                        "slide": 99,
                        "touch": 41,
                        "break": 58,
                        "total": 995
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11741,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.6,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7
                    },
                    "releaseDate": "2024-10-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "メイトなやつら（FEAT. 天開司, 佐藤ホームズ, あっくん大魔王 & 歌衣メイカ）",
            "category": "POPS＆アニメ",
            "title": "メイトなやつら（FEAT. 天開司, 佐藤ホームズ, あっくん大魔王 & 歌衣メイカ）",
            "artist": "MonsterZ MATE",
            "bpm": 160,
            "imageName": "c6bce7f504f2f7855b277e568942716c1ea0a6571e315591ca143650970308a0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 130,
                        "hold": 13,
                        "slide": 4,
                        "touch": 6,
                        "break": 8,
                        "total": 161
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11774,
                    "releaseDate": "2024-10-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 241,
                        "hold": 14,
                        "slide": 8,
                        "touch": 26,
                        "break": 4,
                        "total": 293
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11774,
                    "releaseDate": "2024-10-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 310,
                        "hold": 30,
                        "slide": 50,
                        "touch": 19,
                        "break": 38,
                        "total": 447
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11774,
                    "releaseDate": "2024-10-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 510,
                        "hold": 58,
                        "slide": 91,
                        "touch": 9,
                        "break": 29,
                        "total": 697
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11774,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2024-10-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ゆけむり魂温泉 II",
            "category": "東方Project",
            "title": "ゆけむり魂温泉 II",
            "artist": "魂音泉",
            "bpm": 140,
            "imageName": "30e9e864d987b15e381e4eab26c44062faab353ece688618947e45d8a5ed6055",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 15,
                        "slide": 6,
                        "touch": 6,
                        "break": 6,
                        "total": 217
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11776,
                    "releaseDate": "2024-10-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 269,
                        "hold": 16,
                        "slide": 10,
                        "touch": 16,
                        "break": 7,
                        "total": 318
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11776,
                    "releaseDate": "2024-10-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 368,
                        "hold": 20,
                        "slide": 49,
                        "touch": 9,
                        "break": 45,
                        "total": 491
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11776,
                    "releaseDate": "2024-10-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "7.3Hz+Jack",
                    "noteCounts": {
                        "tap": 682,
                        "hold": 55,
                        "slide": 74,
                        "touch": 26,
                        "break": 68,
                        "total": 905
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11776,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.6,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2024-10-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "人間が大好きなこわれた妖怪の唄",
            "category": "東方Project",
            "title": "人間が大好きなこわれた妖怪の唄",
            "artist": "ビートまりお",
            "bpm": 55,
            "imageName": "552c65be844e13cc0c6df3c2b131a41095d464a9e66ec4205da394b7fa84b53d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 167,
                        "hold": 12,
                        "slide": 4,
                        "touch": 7,
                        "break": 4,
                        "total": 194
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11777,
                    "releaseDate": "2024-10-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 13,
                        "slide": 8,
                        "touch": 16,
                        "break": 1,
                        "total": 278
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11777,
                    "releaseDate": "2024-10-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 300,
                        "hold": 50,
                        "slide": 11,
                        "touch": 29,
                        "break": 18,
                        "total": 408
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11777,
                    "releaseDate": "2024-10-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 11,
                        "slide": 91,
                        "touch": 11,
                        "break": 26,
                        "total": 481
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11777,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2024-10-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Ourania",
            "category": "maimai",
            "title": "Ourania",
            "artist": "satella feat.藍月なくる",
            "bpm": 204,
            "imageName": "7e12fbd301916a6ebcc44a86c49ff60d5c17a6b28eac4aa7aa2391038c9887be",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 168,
                        "hold": 13,
                        "slide": 6,
                        "touch": 11,
                        "break": 6,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11742,
                    "releaseDate": "2024-10-25"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 20,
                        "slide": 10,
                        "touch": 16,
                        "break": 5,
                        "total": 327
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11742,
                    "releaseDate": "2024-10-25"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 61,
                        "slide": 48,
                        "touch": 25,
                        "break": 12,
                        "total": 457
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11742,
                    "releaseDate": "2024-10-25"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "みぞれヤナギ＆Jack",
                    "noteCounts": {
                        "tap": 453,
                        "hold": 64,
                        "slide": 77,
                        "touch": 43,
                        "break": 27,
                        "total": 664
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11742,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2024-10-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "天蓋",
            "category": "maimai",
            "title": "天蓋",
            "artist": "花徒めと（Metomate）",
            "bpm": 178,
            "imageName": "e995b4befac63d328d7eb7f9c4a43065a5f33171f82dd5de26b335daf58bc574",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 13,
                        "slide": 4,
                        "touch": 20,
                        "break": 4,
                        "total": 213
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11743,
                    "releaseDate": "2024-10-25"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 309,
                        "hold": 18,
                        "slide": 11,
                        "touch": 14,
                        "break": 1,
                        "total": 353
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11743,
                    "releaseDate": "2024-10-25"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "みぞれヤナギ",
                    "noteCounts": {
                        "tap": 298,
                        "hold": 82,
                        "slide": 43,
                        "touch": 21,
                        "break": 24,
                        "total": 468
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11743,
                    "releaseDate": "2024-10-25"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "あまくちジンジャー",
                    "noteCounts": {
                        "tap": 523,
                        "hold": 49,
                        "slide": 66,
                        "touch": 71,
                        "break": 24,
                        "total": 733
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11743,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.9,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2024-10-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Deicide",
            "category": "maimai",
            "title": "Deicide",
            "artist": "void (Mournfinale) feat. 古泉葉月",
            "bpm": 163,
            "imageName": "850ad6477888162d5857434899a3453e625943a7f92e54eb8febc08af4dfbe75",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 178,
                        "hold": 14,
                        "slide": 6,
                        "touch": 8,
                        "break": 7,
                        "total": 213
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11744,
                    "releaseDate": "2024-10-25"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 20,
                        "slide": 9,
                        "touch": 11,
                        "break": 2,
                        "total": 384
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11744,
                    "releaseDate": "2024-10-25"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 347,
                        "hold": 71,
                        "slide": 56,
                        "touch": 45,
                        "break": 34,
                        "total": 553
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11744,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2024-10-25"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 591,
                        "hold": 71,
                        "slide": 78,
                        "touch": 35,
                        "break": 99,
                        "total": 874
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11744,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4
                    },
                    "releaseDate": "2024-10-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "氷滅の135小節",
            "category": "maimai",
            "title": "氷滅の135小節",
            "artist": "大国奏音",
            "bpm": 205,
            "imageName": "b3611ad947539aecf46eb5501f773cd79bd6a0ee89089db38795cf861d3ff7c2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 19,
                        "slide": 11,
                        "touch": 21,
                        "break": 9,
                        "total": 365
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11745,
                    "releaseDate": "2024-10-25"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 456,
                        "hold": 18,
                        "slide": 9,
                        "touch": 16,
                        "break": 5,
                        "total": 504
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11745,
                    "releaseDate": "2024-10-25"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 480,
                        "hold": 50,
                        "slide": 67,
                        "touch": 33,
                        "break": 110,
                        "total": 740
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11745,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2024-10-25"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "BELiZHEL vs 7.3GHz",
                    "noteCounts": {
                        "tap": 802,
                        "hold": 33,
                        "slide": 130,
                        "touch": 25,
                        "break": 135,
                        "total": 1125
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11745,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8
                    },
                    "releaseDate": "2024-10-25"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Divide et impera!",
            "category": "maimai",
            "title": "Divide et impera!",
            "artist": "BlackY a.k.a. WAiKURO survive",
            "bpm": 166,
            "imageName": "7f9d02831f34403b1fb95fd405586fa4c6311962fe30c3cf0488563cc3c9a267",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 9,
                        "slide": 11,
                        "touch": 18,
                        "break": 14,
                        "total": 308
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11746,
                    "releaseDate": "2024-10-31"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 341,
                        "hold": 11,
                        "slide": 16,
                        "touch": 11,
                        "break": 5,
                        "total": 384
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11746,
                    "releaseDate": "2024-10-31"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 475,
                        "hold": 57,
                        "slide": 62,
                        "touch": 38,
                        "break": 109,
                        "total": 741
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11746,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2024-10-31"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "The Dove",
                    "noteCounts": {
                        "tap": 859,
                        "hold": 102,
                        "slide": 95,
                        "touch": 69,
                        "break": 100,
                        "total": 1225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "BUDDiES PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11746,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "PRiSM": 14.8,
                        "PRiSM PLUS": 14.8
                    },
                    "releaseDate": "2024-10-31"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "シリウスの輝きのように",
            "category": "POPS＆アニメ",
            "title": "シリウスの輝きのように",
            "artist": "鳳 ここな(CV.石見舞菜香)、静香(CV.長谷川育美)、カトリナ・グリーベル(CV.天城サリー)、新妻八恵(CV.長縄まりあ)、柳場ぱんだ(CV.大空直美)、流石知冴(CV.佐々木李子)",
            "bpm": 158,
            "imageName": "836c70e8ac55f9c9b9319aaa341536655aaf4ab4c0e069879a69f937d09ea5d3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 15,
                        "slide": 2,
                        "touch": 6,
                        "break": 3,
                        "total": 153
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11778,
                    "releaseDate": "2024-11-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 12,
                        "slide": 11,
                        "touch": 35,
                        "break": 1,
                        "total": 286
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11778,
                    "releaseDate": "2024-11-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "まぐランド",
                    "noteCounts": {
                        "tap": 331,
                        "hold": 31,
                        "slide": 13,
                        "touch": 30,
                        "break": 11,
                        "total": 416
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11778,
                    "releaseDate": "2024-11-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 55,
                        "slide": 78,
                        "touch": 32,
                        "break": 29,
                        "total": 478
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11778,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2024-11-08"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 656,
                        "hold": 10,
                        "slide": 99,
                        "touch": 4,
                        "break": 46,
                        "total": 815
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11778,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "PRiSM": 14,
                        "PRiSM PLUS": 14
                    },
                    "releaseDate": "2024-11-08"
                }
            ],
            "searchAcronyms": [
                "Sirius no Kagayaki no you ni"
            ]
        },
        {
            "songId": "プラネタリウム・レヴュー",
            "category": "POPS＆アニメ",
            "title": "プラネタリウム・レヴュー",
            "artist": "千寿 暦(CV.鳥部万里子)、ラモーナ・ウォルフ(CV.田中美海)、王 雪(CV.花井美春)、リリヤ・クルトベイ(CV.安齋由香里)、与那国緋花里(CV.下地紫野)",
            "bpm": 170,
            "imageName": "e8e69fcc77e1a919ee245efb428a0d6f4dae6cb1902158c2464a0679ff25e2c0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 75,
                        "hold": 6,
                        "slide": 4,
                        "touch": 14,
                        "break": 3,
                        "total": 102
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11779,
                    "releaseDate": "2024-11-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 14,
                        "slide": 6,
                        "touch": 11,
                        "break": 4,
                        "total": 231
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11779,
                    "releaseDate": "2024-11-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 34,
                        "slide": 27,
                        "touch": 0,
                        "break": 28,
                        "total": 356
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11779,
                    "releaseDate": "2024-11-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 255,
                        "hold": 33,
                        "slide": 82,
                        "touch": 3,
                        "break": 15,
                        "total": 388
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11779,
                    "releaseDate": "2024-11-08"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 425,
                        "hold": 24,
                        "slide": 62,
                        "touch": 15,
                        "break": 48,
                        "total": 574
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11779,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.6,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2024-11-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "演劇",
            "category": "niconico＆ボーカロイド",
            "title": "演劇",
            "artist": "ナノウ",
            "bpm": 176,
            "imageName": "7baabce63bf7620edb0b8514139efe993777d9fa87fa9228ba09d7254d233bf9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 124,
                        "hold": 15,
                        "slide": 4,
                        "touch": 29,
                        "break": 3,
                        "total": 175
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11780,
                    "releaseDate": "2024-11-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 14,
                        "slide": 8,
                        "touch": 13,
                        "break": 3,
                        "total": 256
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11780,
                    "releaseDate": "2024-11-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 304,
                        "hold": 36,
                        "slide": 38,
                        "touch": 31,
                        "break": 17,
                        "total": 426
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11780,
                    "releaseDate": "2024-11-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 408,
                        "hold": 34,
                        "slide": 90,
                        "touch": 35,
                        "break": 20,
                        "total": 587
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11780,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2024-11-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "無間嫉妬劇場『666』",
            "category": "東方Project",
            "title": "無間嫉妬劇場『666』",
            "artist": "森羅万象",
            "bpm": 108,
            "imageName": "5cd198dc32249a126fe2ae783c053d27e9dabba66283d952f499ae2f2e044239",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 116,
                        "hold": 11,
                        "slide": 8,
                        "touch": 6,
                        "break": 6,
                        "total": 147
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11781,
                    "releaseDate": "2024-11-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 18,
                        "slide": 5,
                        "touch": 11,
                        "break": 2,
                        "total": 300
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11781,
                    "releaseDate": "2024-11-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 331,
                        "hold": 26,
                        "slide": 42,
                        "touch": 11,
                        "break": 37,
                        "total": 447
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11781,
                    "releaseDate": "2024-11-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 476,
                        "hold": 57,
                        "slide": 80,
                        "touch": 21,
                        "break": 32,
                        "total": 666
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11781,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2024-11-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "転生林檎",
            "category": "niconico＆ボーカロイド",
            "title": "転生林檎",
            "artist": "ピノキオピー",
            "bpm": 145,
            "imageName": "282a8ea04fda28ebd6021a21fd7562efa54f6e0880c06d6037574df09616487d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 120,
                        "hold": 16,
                        "slide": 4,
                        "touch": 8,
                        "break": 6,
                        "total": 154
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11773,
                    "releaseDate": "2024-11-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 18,
                        "slide": 6,
                        "touch": 26,
                        "break": 3,
                        "total": 320
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11773,
                    "releaseDate": "2024-11-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 51,
                        "slide": 77,
                        "touch": 34,
                        "break": 14,
                        "total": 473
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11773,
                    "releaseDate": "2024-11-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "きょむりん",
                    "noteCounts": {
                        "tap": 467,
                        "hold": 15,
                        "slide": 123,
                        "touch": 22,
                        "break": 31,
                        "total": 658
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11773,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM": 13.1,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2024-11-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "夢現妄想世界",
            "category": "POPS＆アニメ",
            "title": "夢現妄想世界",
            "artist": "夢限大みゅーたいぷ",
            "bpm": 195,
            "imageName": "9bec84b0b94ac3363a1f79c1ab6465aca1d44059d5ff267e6edca6bf51d459dc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 16,
                        "slide": 8,
                        "touch": 19,
                        "break": 8,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11782,
                    "releaseDate": "2024-11-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 20,
                        "slide": 14,
                        "touch": 26,
                        "break": 6,
                        "total": 402
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11782,
                    "releaseDate": "2024-11-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 427,
                        "hold": 81,
                        "slide": 25,
                        "touch": 51,
                        "break": 38,
                        "total": 622
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11782,
                    "releaseDate": "2024-11-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 628,
                        "hold": 46,
                        "slide": 195,
                        "touch": 16,
                        "break": 57,
                        "total": 942
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11782,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2024-11-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "snooze",
            "category": "niconico＆ボーカロイド",
            "title": "snooze",
            "artist": "wotaku feat.SHIKI",
            "bpm": 150,
            "imageName": "ae06cf858b1c770a0879bcad10c2c94f07c4f22a7d5b09807f7c6312a50d101e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 182,
                        "hold": 13,
                        "slide": 4,
                        "touch": 6,
                        "break": 11,
                        "total": 216
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11783,
                    "releaseDate": "2024-11-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 293,
                        "hold": 12,
                        "slide": 10,
                        "touch": 26,
                        "break": 4,
                        "total": 345
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11783,
                    "releaseDate": "2024-11-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 407,
                        "hold": 46,
                        "slide": 62,
                        "touch": 45,
                        "break": 56,
                        "total": 616
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11783,
                    "releaseDate": "2024-11-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 572,
                        "hold": 100,
                        "slide": 104,
                        "touch": 23,
                        "break": 69,
                        "total": 868
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11783,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2024-11-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "てらてら",
            "category": "niconico＆ボーカロイド",
            "title": "てらてら",
            "artist": "和田たけあき",
            "bpm": 190,
            "imageName": "bb66c410b3fe2d01181687f270cacabd0c6f6066e81a1578285716af3e302f08",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 11,
                        "slide": 6,
                        "touch": 7,
                        "break": 6,
                        "total": 181
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11785,
                    "releaseDate": "2024-11-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 328,
                        "hold": 18,
                        "slide": 6,
                        "touch": 26,
                        "break": 5,
                        "total": 383
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11785,
                    "releaseDate": "2024-11-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 382,
                        "hold": 41,
                        "slide": 33,
                        "touch": 14,
                        "break": 58,
                        "total": 528
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11785,
                    "releaseDate": "2024-11-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 575,
                        "hold": 23,
                        "slide": 92,
                        "touch": 37,
                        "break": 52,
                        "total": 779
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11785,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "PRiSM": 13.1,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2024-11-22"
                }
            ],
            "searchAcronyms": [
                "TeraTera"
            ]
        },
        {
            "songId": "[奏]マイオドレ！舞舞タイム",
            "category": "宴会場",
            "title": "[奏]マイオドレ！舞舞タイム",
            "artist": "キノシタ feat. そらみこ (ホロライブ ときのそら＆さくらみこ)",
            "bpm": null,
            "imageName": "06a7753fdbd27301899e0b1f1c9c51d83d91f38c8531312fa80ba0bef1b4b0dd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【奏】",
                    "level": "12+?",
                    "internalLevelValue": 12.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111156,
                    "version": "PRiSM",
                    "comment": "一緒に！舞舞タイム！",
                    "releaseDate": "2024-11-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[蛸]不機嫌なスリーカード",
            "category": "宴会場",
            "title": "[蛸]不機嫌なスリーカード",
            "artist": "HIMEHINA",
            "bpm": null,
            "imageName": "e690d97cc16966431ce4e4b84c07074fbf1358565381f785112fa14ee24c3f85",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【蛸】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111557,
                    "version": "PRiSM",
                    "comment": "秘密を握った　真実を　魅せてあげる",
                    "releaseDate": "2024-11-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "HYP3RTRIBE",
            "category": "ゲーム＆バラエティ",
            "title": "HYP3RTRIBE",
            "artist": "sky_delta vs KO3 vs Tanchiky",
            "bpm": 190,
            "imageName": "340ad836422a46ffe8450f6a4e9a3bf4bd02ef9b8e469e106f9f60754da11c41",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 236,
                        "hold": 18,
                        "slide": 4,
                        "touch": 18,
                        "break": 7,
                        "total": 283
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11790,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 362,
                        "hold": 16,
                        "slide": 6,
                        "touch": 26,
                        "break": 5,
                        "total": 415
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11790,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 401,
                        "hold": 119,
                        "slide": 52,
                        "touch": 18,
                        "break": 18,
                        "total": 608
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11790,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 673,
                        "hold": 73,
                        "slide": 76,
                        "touch": 54,
                        "break": 60,
                        "total": 936
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11790,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.1,
                        "PRiSM": 14.2,
                        "PRiSM PLUS": 14.2
                    },
                    "releaseDate": "2024-12-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "エイプリルスター",
            "category": "niconico＆ボーカロイド",
            "title": "エイプリルスター",
            "artist": "OSTER project",
            "bpm": 185,
            "imageName": "c7e22c08c82288ab7862aedbc56183266a7ecabdd21c0045284f6d26c579c077",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 213,
                        "hold": 13,
                        "slide": 3,
                        "touch": 6,
                        "break": 6,
                        "total": 241
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11793,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 310,
                        "hold": 25,
                        "slide": 12,
                        "touch": 13,
                        "break": 3,
                        "total": 363
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11793,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 433,
                        "hold": 44,
                        "slide": 48,
                        "touch": 4,
                        "break": 45,
                        "total": 574
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11793,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 649,
                        "hold": 64,
                        "slide": 98,
                        "touch": 9,
                        "break": 32,
                        "total": 852
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11793,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2024-12-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "オーバーライド",
            "category": "niconico＆ボーカロイド",
            "title": "オーバーライド",
            "artist": "吉田夜世",
            "bpm": 204,
            "imageName": "70343d76b9ed300451ce228f921a1afde73215dca23cdba6489ac7d56cfeb2a9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 219,
                        "hold": 9,
                        "slide": 4,
                        "touch": 8,
                        "break": 6,
                        "total": 246
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11794,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 17,
                        "slide": 8,
                        "touch": 26,
                        "break": 5,
                        "total": 400
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11794,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 385,
                        "hold": 94,
                        "slide": 30,
                        "touch": 9,
                        "break": 53,
                        "total": 571
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11794,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 638,
                        "hold": 39,
                        "slide": 155,
                        "touch": 9,
                        "break": 38,
                        "total": 879
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11794,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2024-12-06"
                }
            ],
            "searchAcronyms": [
                "override"
            ]
        },
        {
            "songId": "右に曲ガール",
            "category": "niconico＆ボーカロイド",
            "title": "右に曲ガール",
            "artist": "はるふり",
            "bpm": 175,
            "imageName": "c6f75a496b3233c2bbffea33b4fcc4dc10386e9f37386f295b59933ad15f40ab",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 142,
                        "hold": 11,
                        "slide": 4,
                        "touch": 6,
                        "break": 7,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11795,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 11,
                        "slide": 6,
                        "touch": 28,
                        "break": 4,
                        "total": 331
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11795,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 461,
                        "hold": 47,
                        "slide": 15,
                        "touch": 16,
                        "break": 12,
                        "total": 551
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11795,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 438,
                        "hold": 62,
                        "slide": 110,
                        "touch": 29,
                        "break": 28,
                        "total": 667
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11795,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2024-12-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ウルトラトレーラー",
            "category": "niconico＆ボーカロイド",
            "title": "ウルトラトレーラー",
            "artist": "マサラダ",
            "bpm": 155,
            "imageName": "77f5f78a3acebd261eff2a8ced3b7ef913866a8f14b4a1decc6a134b9eed0f8d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 13,
                        "slide": 4,
                        "touch": 7,
                        "break": 5,
                        "total": 241
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11796,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 368,
                        "hold": 14,
                        "slide": 8,
                        "touch": 15,
                        "break": 3,
                        "total": 408
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11796,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 387,
                        "hold": 65,
                        "slide": 42,
                        "touch": 56,
                        "break": 86,
                        "total": 636
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11796,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 676,
                        "hold": 18,
                        "slide": 140,
                        "touch": 113,
                        "break": 80,
                        "total": 1027
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11796,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2024-12-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "バベル",
            "category": "niconico＆ボーカロイド",
            "title": "バベル",
            "artist": "いよわ feat.重音テト",
            "bpm": 225,
            "imageName": "b82bcf910e8dc751273300cdae332dea14513b8ce4f85e3234bcc8f20ef9c882",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 174,
                        "hold": 14,
                        "slide": 8,
                        "touch": 16,
                        "break": 7,
                        "total": 219
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11797,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 302,
                        "hold": 20,
                        "slide": 4,
                        "touch": 24,
                        "break": 3,
                        "total": 353
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11797,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 62,
                        "slide": 43,
                        "touch": 18,
                        "break": 14,
                        "total": 488
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11797,
                    "releaseDate": "2024-12-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 511,
                        "hold": 68,
                        "slide": 127,
                        "touch": 39,
                        "break": 37,
                        "total": 782
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11797,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2024-12-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[嘘]ライアーダンサー",
            "category": "宴会場",
            "title": "[嘘]ライアーダンサー",
            "artist": "マサラダ",
            "bpm": null,
            "imageName": "84d7f264d0cb789bb59974afb4ddf8a8bbfc3353bf3698310e9cc05255b1afd2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【嘘】",
                    "level": "12+?",
                    "internalLevelValue": 12.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111715,
                    "version": "PRiSM",
                    "comment": "嘘に踊れ",
                    "releaseDate": "2024-12-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[X]人マニア",
            "category": "宴会場",
            "title": "[X]人マニア",
            "artist": "原口沙輔 feat.重音テト",
            "bpm": null,
            "imageName": "a12463905c6a1154f56d89c0acda045f7f3fc77ff063e35413ec616ce74b4585",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【X】",
                    "level": "14?",
                    "internalLevelValue": 14,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111772,
                    "version": "PRiSM",
                    "comment": "人（の初見姿観察推奨）マニア",
                    "releaseDate": "2024-12-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "On your mark (104期 Ver.)",
            "category": "POPS＆アニメ",
            "title": "On your mark (104期 Ver.)",
            "artist": "蓮ノ空女学院スクールアイドルクラブ",
            "bpm": 154,
            "imageName": "afa2b0b775f90c0793cc3da7f38ffd7b30c343a2a90e68e15778d5b982b5fc54",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 131,
                        "hold": 17,
                        "slide": 4,
                        "touch": 8,
                        "break": 5,
                        "total": 165
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11791,
                    "releaseDate": "2024-12-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 268,
                        "hold": 16,
                        "slide": 10,
                        "touch": 26,
                        "break": 2,
                        "total": 322
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11791,
                    "releaseDate": "2024-12-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "まぐランド",
                    "noteCounts": {
                        "tap": 350,
                        "hold": 54,
                        "slide": 27,
                        "touch": 27,
                        "break": 20,
                        "total": 478
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11791,
                    "releaseDate": "2024-12-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 433,
                        "hold": 64,
                        "slide": 75,
                        "touch": 36,
                        "break": 34,
                        "total": 642
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11791,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2024-12-12"
                }
            ],
            "searchAcronyms": [
                "on your mark"
            ]
        },
        {
            "songId": "地獄",
            "category": "maimai",
            "title": "地獄",
            "artist": "164 feat.ELISA・小林太郎",
            "bpm": 190,
            "imageName": "94f4045c94161294764ff971f5dc9103baa19cbdb1b2affa3929d7e108a5daaa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 154,
                        "hold": 16,
                        "slide": 4,
                        "touch": 8,
                        "break": 4,
                        "total": 186
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11747,
                    "releaseDate": "2024-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 269,
                        "hold": 16,
                        "slide": 6,
                        "touch": 17,
                        "break": 5,
                        "total": 313
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11747,
                    "releaseDate": "2024-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 343,
                        "hold": 43,
                        "slide": 45,
                        "touch": 23,
                        "break": 23,
                        "total": 477
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11747,
                    "releaseDate": "2024-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 489,
                        "hold": 53,
                        "slide": 80,
                        "touch": 62,
                        "break": 22,
                        "total": 706
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11747,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "PRiSM": 13.6,
                        "PRiSM PLUS": 13.6
                    },
                    "releaseDate": "2024-12-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "シスターシスター",
            "category": "maimai",
            "title": "シスターシスター",
            "artist": "せきこみごはん",
            "bpm": 150,
            "imageName": "8da4d1ad8924370645ec6d48a609efeb91aa53c25f63205f0c0202519c7eaee3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 17,
                        "slide": 4,
                        "touch": 16,
                        "break": 3,
                        "total": 185
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11748,
                    "releaseDate": "2024-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 291,
                        "hold": 32,
                        "slide": 10,
                        "touch": 14,
                        "break": 5,
                        "total": 352
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11748,
                    "releaseDate": "2024-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 63,
                        "slide": 44,
                        "touch": 69,
                        "break": 38,
                        "total": 496
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11748,
                    "releaseDate": "2024-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 422,
                        "hold": 58,
                        "slide": 107,
                        "touch": 64,
                        "break": 95,
                        "total": 746
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11748,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2024-12-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "有明/Ariake",
            "category": "maimai",
            "title": "有明/Ariake",
            "artist": "SIINCA",
            "bpm": 190,
            "imageName": "a70c124f528230613aee0e5963c0b1d2c214da5a0022d25cc9080fb01a048a43",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 15,
                        "slide": 8,
                        "touch": 27,
                        "break": 6,
                        "total": 256
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11749,
                    "releaseDate": "2024-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 354,
                        "hold": 17,
                        "slide": 8,
                        "touch": 36,
                        "break": 2,
                        "total": 417
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11749,
                    "releaseDate": "2024-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 86,
                        "slide": 45,
                        "touch": 56,
                        "break": 24,
                        "total": 586
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11749,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2024-12-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "BLaCK rOSE dIsEASe pATiENT",
                    "noteCounts": {
                        "tap": 570,
                        "hold": 98,
                        "slide": 82,
                        "touch": 132,
                        "break": 63,
                        "total": 945
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11749,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4
                    },
                    "releaseDate": "2024-12-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[爆]Love's Theme of BADASS ～バッド・アス 愛のテーマ～",
            "category": "宴会場",
            "title": "[爆]Love's Theme of BADASS ～バッド・アス 愛のテーマ～",
            "artist": "Hommarju",
            "bpm": null,
            "imageName": "4e342767a7e8d71ad856ea1dec834b3e9ed4e8addb0eb5eb635b08b310a13075",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【爆】",
                    "level": "14?",
                    "internalLevelValue": 14,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111429,
                    "version": "PRiSM",
                    "comment": "爆発は好きか！？",
                    "releaseDate": "2024-12-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "はげしこの夜 -Psylent Crazy Night-",
            "category": "ゲーム＆バラエティ",
            "title": "はげしこの夜 -Psylent Crazy Night-",
            "artist": "aran & Kobaryo",
            "bpm": 135,
            "imageName": "e0314db2aee688eabad7c43a1858263b63abec2fe4f5a1d10adba0342e58da7f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 143,
                        "hold": 12,
                        "slide": 6,
                        "touch": 14,
                        "break": 6,
                        "total": 181
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11792,
                    "releaseDate": "2024-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 16,
                        "slide": 10,
                        "touch": 26,
                        "break": 4,
                        "total": 328
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11792,
                    "releaseDate": "2024-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 424,
                        "hold": 39,
                        "slide": 44,
                        "touch": 16,
                        "break": 56,
                        "total": 579
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11792,
                    "releaseDate": "2024-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 583,
                        "hold": 51,
                        "slide": 75,
                        "touch": 19,
                        "break": 30,
                        "total": 758
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11792,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2024-12-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Empire of Winter",
            "category": "ゲーム＆バラエティ",
            "title": "Empire of Winter",
            "artist": "Street",
            "bpm": 175,
            "imageName": "f2770220310acf596d73220f97b7a10cb26986893b5669d28286f0a65c626a77",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 140,
                        "hold": 14,
                        "slide": 4,
                        "touch": 20,
                        "break": 2,
                        "total": 180
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11786,
                    "releaseDate": "2025-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 12,
                        "slide": 10,
                        "touch": 27,
                        "break": 4,
                        "total": 300
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11786,
                    "releaseDate": "2025-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 67,
                        "slide": 53,
                        "touch": 16,
                        "break": 13,
                        "total": 416
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11786,
                    "releaseDate": "2025-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 527,
                        "hold": 48,
                        "slide": 101,
                        "touch": 37,
                        "break": 24,
                        "total": 737
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11786,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2025-01-10"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "迷える音色は恋の唄",
            "category": "ゲーム＆バラエティ",
            "title": "迷える音色は恋の唄",
            "artist": "からとP⍺ոchii少年 feat.はるの",
            "bpm": 165,
            "imageName": "ce371152d125cef0bdb8aff716e1544efa21980f63b670ce5c16802d057c7f68",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 9,
                        "slide": 4,
                        "touch": 7,
                        "break": 13,
                        "total": 184
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11787,
                    "releaseDate": "2025-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 12,
                        "slide": 4,
                        "touch": 29,
                        "break": 4,
                        "total": 326
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11787,
                    "releaseDate": "2025-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 346,
                        "hold": 35,
                        "slide": 61,
                        "touch": 49,
                        "break": 34,
                        "total": 525
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11787,
                    "releaseDate": "2025-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 667,
                        "hold": 28,
                        "slide": 88,
                        "touch": 10,
                        "break": 40,
                        "total": 833
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11787,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2025-01-10"
                }
            ],
            "searchAcronyms": [
                "A Wandering Melody of Love"
            ]
        },
        {
            "songId": "Löschen",
            "category": "ゲーム＆バラエティ",
            "title": "Löschen",
            "artist": "BlackY feat. Risa Yuzuki",
            "bpm": 181,
            "imageName": "a394e0bbccac0c5c578240e205103168617ca75483b1cda3a95a3574cbc839d3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 207,
                        "hold": 16,
                        "slide": 4,
                        "touch": 8,
                        "break": 5,
                        "total": 240
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11788,
                    "releaseDate": "2025-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 358,
                        "hold": 12,
                        "slide": 6,
                        "touch": 16,
                        "break": 4,
                        "total": 396
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11788,
                    "releaseDate": "2025-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 419,
                        "hold": 46,
                        "slide": 45,
                        "touch": 15,
                        "break": 29,
                        "total": 554
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11788,
                    "releaseDate": "2025-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 698,
                        "hold": 51,
                        "slide": 78,
                        "touch": 68,
                        "break": 69,
                        "total": 964
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11788,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2025-01-10"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Abstruse Dilemma",
            "category": "ゲーム＆バラエティ",
            "title": "Abstruse Dilemma",
            "artist": "Ashrount vs. 打打だいず",
            "bpm": 216,
            "imageName": "ad5bb7bbd4447e06cbab16471271489fd1c4a35891191ea8fa7d749b287f0401",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 243,
                        "hold": 30,
                        "slide": 5,
                        "touch": 15,
                        "break": 7,
                        "total": 300
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11789,
                    "releaseDate": "2025-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 467,
                        "hold": 17,
                        "slide": 10,
                        "touch": 15,
                        "break": 4,
                        "total": 513
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11789,
                    "releaseDate": "2025-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 449,
                        "hold": 85,
                        "slide": 43,
                        "touch": 32,
                        "break": 40,
                        "total": 649
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11789,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4,
                        "PRiSM": 12.4,
                        "PRiSM PLUS": 12.4
                    },
                    "releaseDate": "2025-01-10"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 704,
                        "hold": 44,
                        "slide": 121,
                        "touch": 87,
                        "break": 92,
                        "total": 1048
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11789,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.5,
                        "PRiSM": 14.4,
                        "PRiSM PLUS": 14.4
                    },
                    "releaseDate": "2025-01-10"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "モンスターカミング",
            "category": "POPS＆アニメ",
            "title": "モンスターカミング",
            "artist": "おめがシスターズ",
            "bpm": 210,
            "imageName": "3a877886084a17e059943d136f688f5ca73a86edfc52bfaa4c3b3ab2c574b5a2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 13,
                        "slide": 8,
                        "touch": 15,
                        "break": 8,
                        "total": 185
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11775,
                    "releaseDate": "2025-01-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 316,
                        "hold": 24,
                        "slide": 13,
                        "touch": 18,
                        "break": 4,
                        "total": 375
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11775,
                    "releaseDate": "2025-01-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 341,
                        "hold": 62,
                        "slide": 19,
                        "touch": 11,
                        "break": 52,
                        "total": 485
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11775,
                    "releaseDate": "2025-01-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 392,
                        "hold": 49,
                        "slide": 103,
                        "touch": 49,
                        "break": 64,
                        "total": 657
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11775,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2025-01-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ワールドワイドワンダー",
            "category": "niconico＆ボーカロイド",
            "title": "ワールドワイドワンダー",
            "artist": "TOKOTOKO（西沢さんP）",
            "bpm": 142,
            "imageName": "f54f17a6383413c17db77c583f0eea8b80911d5df3e130ba9dad22550aea9fcc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 123,
                        "hold": 17,
                        "slide": 4,
                        "touch": 4,
                        "break": 5,
                        "total": 153
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11802,
                    "releaseDate": "2025-01-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 268,
                        "hold": 6,
                        "slide": 7,
                        "touch": 26,
                        "break": 4,
                        "total": 311
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11802,
                    "releaseDate": "2025-01-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 63,
                        "slide": 47,
                        "touch": 12,
                        "break": 17,
                        "total": 488
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11802,
                    "releaseDate": "2025-01-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "きょむりん",
                    "noteCounts": {
                        "tap": 522,
                        "hold": 88,
                        "slide": 64,
                        "touch": 18,
                        "break": 68,
                        "total": 760
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11802,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2025-01-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "MORNINGLOOM",
            "category": "ゲーム＆バラエティ",
            "title": "MORNINGLOOM",
            "artist": "saaa",
            "bpm": 102,
            "imageName": "0f7523bad2ef4924fa35f0fbd69fc2069d166e825b33181a8cf662aab98051f9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 15,
                        "slide": 2,
                        "touch": 9,
                        "break": 2,
                        "total": 237
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11803,
                    "releaseDate": "2025-01-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 22,
                        "slide": 6,
                        "touch": 24,
                        "break": 6,
                        "total": 388
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11803,
                    "releaseDate": "2025-01-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 388,
                        "hold": 50,
                        "slide": 36,
                        "touch": 26,
                        "break": 24,
                        "total": 524
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11803,
                    "releaseDate": "2025-01-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 418,
                        "hold": 78,
                        "slide": 77,
                        "touch": 60,
                        "break": 83,
                        "total": 716
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11803,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2025-01-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "How To Make 音ゲ～曲！",
            "category": "ゲーム＆バラエティ",
            "title": "How To Make 音ゲ～曲！",
            "artist": "F Rabbeat feat.マスタード",
            "bpm": 185,
            "imageName": "cbfcc8b5448d16a4afe41070f1232e4153901f8b2fd3814ed1d16f5a76b985a6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 206,
                        "hold": 25,
                        "slide": 4,
                        "touch": 7,
                        "break": 10,
                        "total": 252
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11804,
                    "releaseDate": "2025-01-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 341,
                        "hold": 16,
                        "slide": 7,
                        "touch": 28,
                        "break": 3,
                        "total": 395
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11804,
                    "releaseDate": "2025-01-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 100,
                        "slide": 79,
                        "touch": 23,
                        "break": 180,
                        "total": 649
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11804,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2025-01-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 589,
                        "hold": 54,
                        "slide": 72,
                        "touch": 76,
                        "break": 63,
                        "total": 854
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11804,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2025-01-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Resolution",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Resolution",
            "artist": "曲：ANCHOR／歌：皇城 セツナ(CV：八巻 アンナ)",
            "bpm": 190,
            "imageName": "dc94fded7370918d161737c4409799d7985f5f8de05ffb27fe543c89dd3fd8f7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 255,
                        "hold": 12,
                        "slide": 8,
                        "touch": 8,
                        "break": 9,
                        "total": 292
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11756,
                    "releaseDate": "2025-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 377,
                        "hold": 14,
                        "slide": 6,
                        "touch": 24,
                        "break": 2,
                        "total": 423
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11756,
                    "releaseDate": "2025-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 461,
                        "hold": 52,
                        "slide": 43,
                        "touch": 19,
                        "break": 54,
                        "total": 629
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11756,
                    "releaseDate": "2025-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "りんご Full Set",
                    "noteCounts": {
                        "tap": 634,
                        "hold": 65,
                        "slide": 110,
                        "touch": 64,
                        "break": 29,
                        "total": 902
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11756,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2025-02-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "いちげき！のテーマ",
            "category": "オンゲキ＆CHUNITHM",
            "title": "いちげき！のテーマ",
            "artist": "曲：ヒゲドライバー／歌：いちげきしゅーたーず！",
            "bpm": 175,
            "imageName": "e9fa111755b86a61eb6a041f8aad0c53ace9e25d76c77dcc6b3fe74a41708edf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 13,
                        "slide": 4,
                        "touch": 8,
                        "break": 14,
                        "total": 270
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11757,
                    "releaseDate": "2025-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 343,
                        "hold": 20,
                        "slide": 11,
                        "touch": 15,
                        "break": 12,
                        "total": 401
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11757,
                    "releaseDate": "2025-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 434,
                        "hold": 64,
                        "slide": 53,
                        "touch": 20,
                        "break": 66,
                        "total": 637
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11757,
                    "releaseDate": "2025-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "ロシェ@ペンギン と はっぴー",
                    "noteCounts": {
                        "tap": 615,
                        "hold": 64,
                        "slide": 118,
                        "touch": 114,
                        "break": 99,
                        "total": 1010
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11757,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.4,
                        "PRiSM": 13.4,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2025-02-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Radiance",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Radiance",
            "artist": "Nhato",
            "bpm": 155,
            "imageName": "15a47255d4ac413f79a525ede1244f859a74ee51d71848c6dc9c7d252ae56e30",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 170,
                        "hold": 13,
                        "slide": 7,
                        "touch": 8,
                        "break": 7,
                        "total": 205
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11758,
                    "releaseDate": "2025-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 19,
                        "slide": 4,
                        "touch": 21,
                        "break": 3,
                        "total": 320
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11758,
                    "releaseDate": "2025-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 386,
                        "hold": 77,
                        "slide": 28,
                        "touch": 16,
                        "break": 7,
                        "total": 514
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11758,
                    "releaseDate": "2025-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 584,
                        "hold": 81,
                        "slide": 55,
                        "touch": 47,
                        "break": 58,
                        "total": 825
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11758,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "PRiSM": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2025-02-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "R'N'R Monsta",
            "category": "オンゲキ＆CHUNITHM",
            "title": "R'N'R Monsta",
            "artist": "Lite Show Magic",
            "bpm": 220,
            "imageName": "60485d04fe1ae4166db772b8ef6836668af9d390c746f1b34abbf7b6a4de175f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 183,
                        "hold": 24,
                        "slide": 8,
                        "touch": 15,
                        "break": 9,
                        "total": 239
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11759,
                    "releaseDate": "2025-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 18,
                        "slide": 12,
                        "touch": 28,
                        "break": 3,
                        "total": 397
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11759,
                    "releaseDate": "2025-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 451,
                        "hold": 36,
                        "slide": 35,
                        "touch": 26,
                        "break": 36,
                        "total": 584
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11759,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2025-02-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "メロンポップ vs Luxizhel",
                    "noteCounts": {
                        "tap": 626,
                        "hold": 22,
                        "slide": 87,
                        "touch": 22,
                        "break": 48,
                        "total": 805
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11759,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "PRiSM PLUS": 14.1
                    },
                    "releaseDate": "2025-02-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[星]ほしぞらスペクタクル",
            "category": "宴会場",
            "title": "[星]ほしぞらスペクタクル",
            "artist": "奏音",
            "bpm": null,
            "imageName": "0aad1815e3ded98572b433a214f2189c844bf9224ee6a384f7fd9d44f32b1012",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【星】",
                    "level": "14?",
                    "internalLevelValue": 14,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111234,
                    "version": "PRiSM",
                    "comment": "ほしだけスペクタクル",
                    "releaseDate": "2025-02-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[片]神々が恋した幻想郷",
            "category": "宴会場",
            "title": "[片]神々が恋した幻想郷",
            "artist": "Unlucky Morpheus",
            "bpm": null,
            "imageName": "c717245dff86937284935051b531adff6876466fb562c796cb7aadffa9c0ac50",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【片】",
                    "level": "14?",
                    "internalLevelValue": 14,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111363,
                    "version": "PRiSM",
                    "comment": "神々が恋したトリル郷",
                    "releaseDate": "2025-02-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "お願い！コンコンお稲荷さま",
            "category": "ゲーム＆バラエティ",
            "title": "お願い！コンコンお稲荷さま",
            "artist": "ARM×狐夢想 feat. ななひら",
            "bpm": 175,
            "imageName": "72198c7643a18b3957bf77a46e8069235475de81e5af1f708699b88c684e0b90",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 181,
                        "hold": 29,
                        "slide": 4,
                        "touch": 16,
                        "break": 10,
                        "total": 240
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11798,
                    "releaseDate": "2025-02-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 326,
                        "hold": 24,
                        "slide": 10,
                        "touch": 15,
                        "break": 6,
                        "total": 381
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11798,
                    "releaseDate": "2025-02-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 63,
                        "slide": 47,
                        "touch": 40,
                        "break": 76,
                        "total": 488
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11798,
                    "releaseDate": "2025-02-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 444,
                        "hold": 52,
                        "slide": 133,
                        "touch": 57,
                        "break": 144,
                        "total": 830
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11798,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2025-02-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "いっぱい食べる君が好きだよ",
            "category": "ゲーム＆バラエティ",
            "title": "いっぱい食べる君が好きだよ",
            "artist": "ななひら",
            "bpm": 224,
            "imageName": "a10abf04b8975cd640b6b5218137c09c64fb1d64c97e75d9bcd9ffe013251067",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 15,
                        "slide": 4,
                        "touch": 8,
                        "break": 3,
                        "total": 235
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11799,
                    "releaseDate": "2025-02-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 347,
                        "hold": 12,
                        "slide": 6,
                        "touch": 43,
                        "break": 2,
                        "total": 410
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11799,
                    "releaseDate": "2025-02-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 434,
                        "hold": 76,
                        "slide": 38,
                        "touch": 39,
                        "break": 32,
                        "total": 619
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11799,
                    "releaseDate": "2025-02-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 549,
                        "hold": 52,
                        "slide": 90,
                        "touch": 54,
                        "break": 53,
                        "total": 798
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11799,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2025-02-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ピポピポ -People People- feat. ななひら",
            "category": "ゲーム＆バラエティ",
            "title": "ピポピポ -People People- feat. ななひら",
            "artist": "Neko Hacker",
            "bpm": 230,
            "imageName": "ff4a13d313aed35911ae2f7608233cc75430bf12c4b3c9d819e117351edb635e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 201,
                        "hold": 18,
                        "slide": 7,
                        "touch": 16,
                        "break": 1,
                        "total": 243
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11800,
                    "releaseDate": "2025-02-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 376,
                        "hold": 31,
                        "slide": 4,
                        "touch": 24,
                        "break": 5,
                        "total": 440
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11800,
                    "releaseDate": "2025-02-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 495,
                        "hold": 69,
                        "slide": 33,
                        "touch": 6,
                        "break": 40,
                        "total": 643
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11800,
                    "releaseDate": "2025-02-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 530,
                        "hold": 142,
                        "slide": 100,
                        "touch": 88,
                        "break": 170,
                        "total": 1030
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11800,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2025-02-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Flashback",
            "category": "maimai",
            "title": "Flashback",
            "artist": "RiraN",
            "bpm": 160,
            "imageName": "acc92d51780a20ab55927e358d7f4c63536d2bc40b7f6a8347032f09dd6d5f6d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 14,
                        "slide": 4,
                        "touch": 8,
                        "break": 8,
                        "total": 209
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11750,
                    "releaseDate": "2025-02-27"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 20,
                        "slide": 6,
                        "touch": 29,
                        "break": 5,
                        "total": 323
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11750,
                    "releaseDate": "2025-02-27"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 49,
                        "slide": 45,
                        "touch": 35,
                        "break": 110,
                        "total": 515
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11750,
                    "releaseDate": "2025-02-27"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 599,
                        "hold": 44,
                        "slide": 79,
                        "touch": 59,
                        "break": 32,
                        "total": 813
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11750,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2025-02-27"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Colorfull:Encounter",
            "category": "maimai",
            "title": "Colorfull:Encounter",
            "artist": "Reku Mochizuki",
            "bpm": 185,
            "imageName": "93cf633b227bbb2c1b9366b2708f50c3aeadd7ed8c4b9a34e5ef4cdd25773b43",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 14,
                        "slide": 4,
                        "touch": 24,
                        "break": 9,
                        "total": 202
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11751,
                    "releaseDate": "2025-02-27"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 18,
                        "slide": 9,
                        "touch": 26,
                        "break": 5,
                        "total": 305
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11751,
                    "releaseDate": "2025-02-27"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 433,
                        "hold": 36,
                        "slide": 39,
                        "touch": 9,
                        "break": 9,
                        "total": 526
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11751,
                    "releaseDate": "2025-02-27"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 533,
                        "hold": 53,
                        "slide": 86,
                        "touch": 30,
                        "break": 23,
                        "total": 725
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11751,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.9,
                        "PRiSM": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2025-02-27"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "雨露霜雪",
            "category": "maimai",
            "title": "雨露霜雪",
            "artist": "かねこちはる vs t+pazolite",
            "bpm": 250,
            "imageName": "5c64b0d4e8582058ba116c03f19eb8797f919daed107fceb5c4fb1fcf426302e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 281,
                        "hold": 12,
                        "slide": 6,
                        "touch": 27,
                        "break": 11,
                        "total": 337
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11752,
                    "releaseDate": "2025-02-27"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 479,
                        "hold": 24,
                        "slide": 10,
                        "touch": 14,
                        "break": 5,
                        "total": 532
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11752,
                    "releaseDate": "2025-02-27"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 705,
                        "hold": 54,
                        "slide": 42,
                        "touch": 48,
                        "break": 66,
                        "total": 915
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11752,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2025-02-27"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "サファ太 vs Luxizhel",
                    "noteCounts": {
                        "tap": 744,
                        "hold": 95,
                        "slide": 102,
                        "touch": 124,
                        "break": 146,
                        "total": 1211
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11752,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.6,
                        "PRiSM": 14.7,
                        "PRiSM PLUS": 14.7
                    },
                    "releaseDate": "2025-02-27"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "宙天",
            "category": "maimai",
            "title": "宙天",
            "artist": "t+pazolite vs かねこちはる",
            "bpm": 125,
            "imageName": "8210d983a3fb31ce543248857a382d89df7db570caf68fdde3c6706d39ec9277",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 16,
                        "slide": 6,
                        "touch": 13,
                        "break": 22,
                        "total": 320
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11753,
                    "releaseDate": "2025-02-27"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 416,
                        "hold": 17,
                        "slide": 11,
                        "touch": 26,
                        "break": 8,
                        "total": 478
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11753,
                    "releaseDate": "2025-02-27"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 397,
                        "hold": 84,
                        "slide": 43,
                        "touch": 107,
                        "break": 29,
                        "total": 660
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11753,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5,
                        "PRiSM": 13.5,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2025-02-27"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.9,
                    "noteDesigner": "BELiZHEL vs  Safari",
                    "noteCounts": {
                        "tap": 725,
                        "hold": 55,
                        "slide": 89,
                        "touch": 82,
                        "break": 107,
                        "total": 1058
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11753,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.9,
                        "CiRCLE PLUS": 14.9,
                        "PRiSM": 14.9,
                        "PRiSM PLUS": 14.9
                    },
                    "releaseDate": "2025-02-27"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Fraq",
            "category": "maimai",
            "title": "Fraq",
            "artist": "owl＊tree feat. べんざ",
            "bpm": 221,
            "imageName": "c5e05f0d999f057ee3d335431d3168a8991750c820370c44432fa1dc9c42b7e6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 171,
                        "hold": 19,
                        "slide": 6,
                        "touch": 24,
                        "break": 9,
                        "total": 229
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11806,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 358,
                        "hold": 26,
                        "slide": 8,
                        "touch": 28,
                        "break": 7,
                        "total": 427
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11806,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 466,
                        "hold": 90,
                        "slide": 31,
                        "touch": 55,
                        "break": 35,
                        "total": 677
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11806,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "PRiSM PLUS": 12.2
                    },
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 521,
                        "hold": 83,
                        "slide": 110,
                        "touch": 26,
                        "break": 66,
                        "total": 806
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11806,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ウタヒメナイトストーム",
            "category": "maimai",
            "title": "ウタヒメナイトストーム",
            "artist": "yowanecity feat.Eye",
            "bpm": 164,
            "imageName": "66c9aa47b034e3b7942bacaaf1f0c2a5c27ef73114989f55f9e0687b43870e97",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 18,
                        "slide": 4,
                        "touch": 8,
                        "break": 3,
                        "total": 190
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11807,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 260,
                        "hold": 12,
                        "slide": 12,
                        "touch": 26,
                        "break": 3,
                        "total": 313
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11807,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 406,
                        "hold": 46,
                        "slide": 55,
                        "touch": 16,
                        "break": 29,
                        "total": 552
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11807,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 631,
                        "hold": 43,
                        "slide": 142,
                        "touch": 14,
                        "break": 26,
                        "total": 856
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11807,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Feel The Luv",
            "category": "maimai",
            "title": "Feel The Luv",
            "artist": "EmoCosine",
            "bpm": 155,
            "imageName": "696469997791890500b4cb86ffce8c8b6471f5d234f50ae201a4e57f498f9fa8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 170,
                        "hold": 9,
                        "slide": 8,
                        "touch": 14,
                        "break": 10,
                        "total": 211
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11808,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 300,
                        "hold": 18,
                        "slide": 4,
                        "touch": 26,
                        "break": 4,
                        "total": 352
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11808,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 413,
                        "hold": 86,
                        "slide": 48,
                        "touch": 11,
                        "break": 36,
                        "total": 594
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11808,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 611,
                        "hold": 42,
                        "slide": 90,
                        "touch": 127,
                        "break": 57,
                        "total": 927
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11808,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Supersonic Generation",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Supersonic Generation",
            "artist": "Massive New Krew",
            "bpm": 155,
            "imageName": "6b0d5a9978831eeb4fb16ed342ac12740ccba94894326e7e47433f62dcc0867e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 140,
                        "hold": 11,
                        "slide": 4,
                        "touch": 6,
                        "break": 10,
                        "total": 171
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "PRiSM"
                        }
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11822,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 22,
                        "slide": 7,
                        "touch": 28,
                        "break": 3,
                        "total": 311
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "PRiSM"
                        }
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11822,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.7,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 341,
                        "hold": 59,
                        "slide": 32,
                        "touch": 31,
                        "break": 40,
                        "total": 503
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "PRiSM"
                        }
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11822,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 11.7,
                        "PRiSM PLUS": 11.7
                    },
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 567,
                        "hold": 12,
                        "slide": 91,
                        "touch": 70,
                        "break": 75,
                        "total": 815
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "PRiSM"
                        }
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11822,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Zitronectar",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Zitronectar",
            "artist": "Reku Mochizuki",
            "bpm": 222,
            "imageName": "0f9e0998c092ba2a68cd3fc221b2dae6022527ac68948f4afcf079b63bf6d88c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 168,
                        "hold": 8,
                        "slide": 8,
                        "touch": 9,
                        "break": 5,
                        "total": 198
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11823,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 300,
                        "hold": 14,
                        "slide": 6,
                        "touch": 16,
                        "break": 4,
                        "total": 340
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11823,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 64,
                        "slide": 55,
                        "touch": 31,
                        "break": 39,
                        "total": 546
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11823,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 469,
                        "hold": 51,
                        "slide": 106,
                        "touch": 29,
                        "break": 87,
                        "total": 742
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11823,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.4,
                        "PRiSM PLUS": 14.3
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "きゅびずむ",
            "category": "POPS＆アニメ",
            "title": "きゅびずむ",
            "artist": "超てんちゃん",
            "bpm": 185,
            "imageName": "3522ffb259bf5e72fcca638754ce5d6472ee7d1bda6f3a54e50a7fb98faf27c1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 134,
                        "hold": 14,
                        "slide": 4,
                        "touch": 12,
                        "break": 8,
                        "total": 172
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11831,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 308,
                        "hold": 18,
                        "slide": 9,
                        "touch": 29,
                        "break": 5,
                        "total": 369
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11831,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 53,
                        "slide": 33,
                        "touch": 19,
                        "break": 49,
                        "total": 469
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11831,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 445,
                        "hold": 68,
                        "slide": 87,
                        "touch": 65,
                        "break": 73,
                        "total": 738
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11831,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": [
                "cubism"
            ]
        },
        {
            "songId": "きゅびびびびずむ",
            "category": "POPS＆アニメ",
            "title": "きゅびびびびずむ",
            "artist": "超てんちゃん",
            "bpm": 185,
            "imageName": "8c0013d320645f580f991355b2076d5902a960d46248dae68ddeee84ee04e7a8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 221,
                        "hold": 15,
                        "slide": 15,
                        "touch": 13,
                        "break": 14,
                        "total": 278
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11832,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 404,
                        "hold": 18,
                        "slide": 13,
                        "touch": 14,
                        "break": 14,
                        "total": 463
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11832,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 323,
                        "hold": 129,
                        "slide": 41,
                        "touch": 49,
                        "break": 124,
                        "total": 666
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11832,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "サぴぴぴぴちネファ太太太太コ",
                    "noteCounts": {
                        "tap": 424,
                        "hold": 98,
                        "slide": 103,
                        "touch": 121,
                        "break": 248,
                        "total": 994
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11832,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": [
                "cubibibibism"
            ]
        },
        {
            "songId": "ゆりかご",
            "category": "niconico＆ボーカロイド",
            "title": "ゆりかご",
            "artist": "歌：可不／作詞・作曲：MIMI",
            "bpm": 120,
            "imageName": "916cc6c89c2901f65a0721601bf96b9b6499835a4809219dfab7c9664c5bc05d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 86,
                        "hold": 9,
                        "slide": 6,
                        "touch": 13,
                        "break": 2,
                        "total": 116
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11833,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 153,
                        "hold": 21,
                        "slide": 8,
                        "touch": 28,
                        "break": 5,
                        "total": 215
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11833,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 255,
                        "hold": 34,
                        "slide": 20,
                        "touch": 24,
                        "break": 10,
                        "total": 343
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11833,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 457,
                        "hold": 38,
                        "slide": 88,
                        "touch": 58,
                        "break": 13,
                        "total": 654
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11833,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": [
                "cradle",
                "yurikago"
            ]
        },
        {
            "songId": "月光",
            "category": "niconico＆ボーカロイド",
            "title": "月光",
            "artist": "歌：V.I.P／作詞・作曲：廉",
            "bpm": 195,
            "imageName": "8afef61d14795b657b49abfa93592be68a556bebe1be579842bd997c96b5245a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 16,
                        "slide": 6,
                        "touch": 8,
                        "break": 5,
                        "total": 211
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11834,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 350,
                        "hold": 16,
                        "slide": 5,
                        "touch": 24,
                        "break": 3,
                        "total": 398
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11834,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 514,
                        "hold": 44,
                        "slide": 44,
                        "touch": 12,
                        "break": 27,
                        "total": 641
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11834,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 550,
                        "hold": 54,
                        "slide": 137,
                        "touch": 10,
                        "break": 69,
                        "total": 820
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11834,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": [
                "gekkou",
                "moonlight"
            ]
        },
        {
            "songId": "はいよろこんで",
            "category": "POPS＆アニメ",
            "title": "はいよろこんで",
            "artist": "こっちのけんと",
            "bpm": 147,
            "imageName": "aea435f0b0580ebdf210c5b824804023993f56c94b40b9d0b226ee40c4703ef5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 155,
                        "hold": 17,
                        "slide": 4,
                        "touch": 9,
                        "break": 8,
                        "total": 193
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11835,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 20,
                        "slide": 6,
                        "touch": 13,
                        "break": 2,
                        "total": 346
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11835,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 37,
                        "slide": 56,
                        "touch": 34,
                        "break": 22,
                        "total": 506
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11835,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "緑川 犬三郎",
                    "noteCounts": {
                        "tap": 401,
                        "hold": 81,
                        "slide": 105,
                        "touch": 16,
                        "break": 46,
                        "total": 649
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11835,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 11.6,
                        "PRiSM PLUS": 11.6
                    },
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 588,
                        "hold": 78,
                        "slide": 95,
                        "touch": 37,
                        "break": 40,
                        "total": 838
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11835,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": [
                "hai yorokonde"
            ]
        },
        {
            "songId": "ビビデバ",
            "category": "POPS＆アニメ",
            "title": "ビビデバ",
            "artist": "星街すいせい（ホロライブ）",
            "bpm": 120,
            "imageName": "900eb4d67d3ed6d1980058fd1211f25f0822f23a8e25f2ce257b742ee7f0e03a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 143,
                        "hold": 13,
                        "slide": 6,
                        "touch": 7,
                        "break": 4,
                        "total": 173
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11836,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 14,
                        "slide": 7,
                        "touch": 13,
                        "break": 5,
                        "total": 316
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11836,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 312,
                        "hold": 89,
                        "slide": 32,
                        "touch": 15,
                        "break": 32,
                        "total": 480
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11836,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.8,
                    "noteDesigner": "緑川 犬三郎",
                    "noteCounts": {
                        "tap": 500,
                        "hold": 66,
                        "slide": 82,
                        "touch": 5,
                        "break": 15,
                        "total": 668
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11836,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 11.8,
                        "PRiSM PLUS": 11.8
                    },
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 616,
                        "hold": 40,
                        "slide": 107,
                        "touch": 44,
                        "break": 18,
                        "total": 825
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11836,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": [
                "bibbidiba",
                "bibideba",
                "bibidiba"
            ]
        },
        {
            "songId": "シカ色デイズ",
            "category": "POPS＆アニメ",
            "title": "シカ色デイズ",
            "artist": "シカ部 [鹿乃子のこ (CV.潘めぐみ)、虎視虎子 (CV.藤田 咲)、虎視餡子 (CV.田辺留依)、馬車芽めめ (CV.和泉風花)]",
            "bpm": 183,
            "imageName": "9d3fda98e5bc7c5091ea4ff033fbd8dc2d663c19be82f9fff4a3beae872864c7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 99,
                        "hold": 7,
                        "slide": 4,
                        "touch": 6,
                        "break": 6,
                        "total": 122
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11837,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 182,
                        "hold": 12,
                        "slide": 4,
                        "touch": 28,
                        "break": 4,
                        "total": 230
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11837,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 281,
                        "hold": 34,
                        "slide": 22,
                        "touch": 31,
                        "break": 20,
                        "total": 388
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11837,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 24,
                        "slide": 113,
                        "touch": 52,
                        "break": 31,
                        "total": 495
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11837,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "メズマライザー",
            "category": "niconico＆ボーカロイド",
            "title": "メズマライザー",
            "artist": "サツキ feat.初音ミク・重音テト",
            "bpm": 185,
            "imageName": "44c55b94a4f2b8c101ebf8c96f906c1cc5cc8b273012306793676d8b9a3e37b8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 22,
                        "slide": 7,
                        "touch": 6,
                        "break": 7,
                        "total": 217
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11838,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 357,
                        "hold": 22,
                        "slide": 13,
                        "touch": 15,
                        "break": 5,
                        "total": 412
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11838,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 379,
                        "hold": 44,
                        "slide": 56,
                        "touch": 29,
                        "break": 16,
                        "total": 524
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11838,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.9,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 428,
                        "hold": 70,
                        "slide": 127,
                        "touch": 40,
                        "break": 10,
                        "total": 675
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11838,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 11.9,
                        "PRiSM PLUS": 11.9
                    },
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 613,
                        "hold": 38,
                        "slide": 83,
                        "touch": 111,
                        "break": 155,
                        "total": 1000
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11838,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": [
                "mesmerizer"
            ]
        },
        {
            "songId": "ももいろの鍵",
            "category": "niconico＆ボーカロイド",
            "title": "ももいろの鍵",
            "artist": "いよわ",
            "bpm": 165,
            "imageName": "ac0b0c66fdc5741bd10e7b280ade2d82cc76d7921f8d473e3ccaf6e733368570",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 10,
                        "slide": 4,
                        "touch": 17,
                        "break": 8,
                        "total": 174
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11839,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 14,
                        "slide": 11,
                        "touch": 28,
                        "break": 3,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11839,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 45,
                        "slide": 22,
                        "touch": 13,
                        "break": 11,
                        "total": 396
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11839,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 395,
                        "hold": 90,
                        "slide": 89,
                        "touch": 36,
                        "break": 30,
                        "total": 640
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11839,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7,
                        "PRiSM PLUS": 12.7
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": [
                "Momoiro no Kagi",
                "The Peachy Key"
            ]
        },
        {
            "songId": "のだ",
            "category": "niconico＆ボーカロイド",
            "title": "のだ",
            "artist": "大漠波新",
            "bpm": 142,
            "imageName": "bc926b0a548176ba855196aff940a3dad615c8b2d7bec485d4e9f1ce96ed7923",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 158,
                        "hold": 15,
                        "slide": 4,
                        "touch": 8,
                        "break": 6,
                        "total": 191
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11840,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 240,
                        "hold": 13,
                        "slide": 15,
                        "touch": 26,
                        "break": 6,
                        "total": 300
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11840,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 62,
                        "slide": 41,
                        "touch": 11,
                        "break": 56,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11840,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Luxizhel＆はっぴー",
                    "noteCounts": {
                        "tap": 526,
                        "hold": 34,
                        "slide": 141,
                        "touch": 74,
                        "break": 55,
                        "total": 830
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11840,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Idoratrize World",
            "category": "東方Project",
            "title": "Idoratrize World",
            "artist": "A-One",
            "bpm": 170,
            "imageName": "1a1f82ebcaa6501ef1d8e1fd121a9527b4e3c043a8093684c86e66f72a1119ca",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 149,
                        "hold": 11,
                        "slide": 4,
                        "touch": 7,
                        "break": 8,
                        "total": 179
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11841,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 16,
                        "slide": 14,
                        "touch": 28,
                        "break": 2,
                        "total": 342
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11841,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 354,
                        "hold": 51,
                        "slide": 56,
                        "touch": 27,
                        "break": 37,
                        "total": 525
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11841,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 487,
                        "hold": 51,
                        "slide": 130,
                        "touch": 41,
                        "break": 52,
                        "total": 761
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11841,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Synthesis.",
            "category": "ゲーム＆バラエティ",
            "title": "Synthesis.",
            "artist": "tn-shi",
            "bpm": 180,
            "imageName": "f7a4ccd98b2f0fa921fd081d6d43cfa09038274c3452e99ed51b070d14409d72",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 18,
                        "slide": 10,
                        "touch": 22,
                        "break": 5,
                        "total": 273
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11842,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 417,
                        "hold": 16,
                        "slide": 12,
                        "touch": 29,
                        "break": 3,
                        "total": 477
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11842,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 400,
                        "hold": 128,
                        "slide": 65,
                        "touch": 32,
                        "break": 20,
                        "total": 645
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11842,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 738,
                        "hold": 84,
                        "slide": 72,
                        "touch": 127,
                        "break": 82,
                        "total": 1103
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11842,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "PRiSM PLUS": 14.1
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[甘]スイートマジック",
            "category": "宴会場",
            "title": "[甘]スイートマジック",
            "artist": "ろん×Junky",
            "bpm": null,
            "imageName": "31f2fe5a9d47549648e15d46435abc418c450e0af529f70ed4127ed2eae7616d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【甘】",
                    "level": "12?",
                    "internalLevelValue": 12,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 110121,
                    "version": "PRiSM PLUS",
                    "comment": "そんな「甘い魔法」",
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[回]ハム太郎とっとこうた",
            "category": "宴会場",
            "title": "[回]ハム太郎とっとこうた",
            "artist": "ハムちゃんず [covered by 光吉猛修]",
            "bpm": null,
            "imageName": "06f4e2a34d6d59cffcb7bcaa6f07fdc51a76648f908e00594f6356f17b9b135c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【回】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111113,
                    "version": "PRiSM PLUS",
                    "comment": "まわると　うれしいね",
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[即]チューリングの跡",
            "category": "宴会場",
            "title": "[即]チューリングの跡",
            "artist": "Frums",
            "bpm": null,
            "imageName": "9c5fdab71b0c6b3f056ecbcbc48cd17f44daee52d982d0adf406a64cbbca2716",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【即】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111388,
                    "version": "PRiSM PLUS",
                    "comment": "実際はBPM360らしいので…",
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[匿]匿名M",
            "category": "宴会場",
            "title": "[匿]匿名M",
            "artist": "ピノキオピー",
            "bpm": null,
            "imageName": "7e3280891240d7f72f15eb03be289b21869044b3b38788ee16c71f5a0a22315f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【匿】",
                    "level": "13+?",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111714,
                    "version": "PRiSM PLUS",
                    "comment": "本日はインタビューよろしくお願いいたします",
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[助]メズマライザー",
            "category": "宴会場",
            "title": "[助]メズマライザー",
            "artist": "サツキ feat.初音ミク・重音テト",
            "bpm": null,
            "imageName": "44c55b94a4f2b8c101ebf8c96f906c1cc5cc8b273012306793676d8b9a3e37b8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【助】",
                    "level": "13+?",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111838,
                    "version": "PRiSM PLUS",
                    "comment": "誰か、助けてね(^^♪",
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Åntinomiε",
            "category": "maimai",
            "title": "Åntinomiε",
            "artist": "ああ…翡翠茶漬け…",
            "bpm": 242,
            "imageName": "ae0bacd24852a9c6d705dfe0e8aae2460b2f58616e04b54c35f4a24b4e5bae57",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 18,
                        "slide": 8,
                        "touch": 26,
                        "break": 2,
                        "total": 308
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11809,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 433,
                        "hold": 21,
                        "slide": 14,
                        "touch": 24,
                        "break": 2,
                        "total": 494
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11809,
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 471,
                        "hold": 87,
                        "slide": 58,
                        "touch": 19,
                        "break": 53,
                        "total": 688
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11809,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2025-03-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "SAFARI☆CAT",
                    "noteCounts": {
                        "tap": 631,
                        "hold": 98,
                        "slide": 114,
                        "touch": 72,
                        "break": 124,
                        "total": 1039
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11809,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6,
                        "PRiSM PLUS": 14.6
                    },
                    "releaseDate": "2025-03-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "もういいよ",
            "category": "POPS＆アニメ",
            "title": "もういいよ",
            "artist": "こっちのけんと",
            "bpm": 147,
            "imageName": "6667be743d76cf7f44b3d64920b6463b8f8af15f4a8c81a02cf2bce29b163711",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 124,
                        "hold": 15,
                        "slide": 4,
                        "touch": 13,
                        "break": 8,
                        "total": 164
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11843,
                    "releaseDate": "2025-03-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 265,
                        "hold": 18,
                        "slide": 6,
                        "touch": 22,
                        "break": 5,
                        "total": 316
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11843,
                    "releaseDate": "2025-03-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 358,
                        "hold": 119,
                        "slide": 38,
                        "touch": 16,
                        "break": 15,
                        "total": 546
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11843,
                    "releaseDate": "2025-03-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 526,
                        "hold": 65,
                        "slide": 107,
                        "touch": 70,
                        "break": 38,
                        "total": 806
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11843,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2025-03-28"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "モエチャッカファイア",
            "category": "POPS＆アニメ",
            "title": "モエチャッカファイア",
            "artist": "弌誠「ゲーム『ゼンレスゾーンゼロ』エレン・ジョー 同人イメージソング」",
            "bpm": 163,
            "imageName": "acd6fac4b9d6cfd302cd300492403c202fbf153208638ba115c4eb9731702dc3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 164,
                        "hold": 11,
                        "slide": 6,
                        "touch": 6,
                        "break": 11,
                        "total": 198
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11844,
                    "releaseDate": "2025-03-28"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 17,
                        "slide": 16,
                        "touch": 26,
                        "break": 6,
                        "total": 332
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11844,
                    "releaseDate": "2025-03-28"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 393,
                        "hold": 22,
                        "slide": 45,
                        "touch": 29,
                        "break": 36,
                        "total": 525
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11844,
                    "releaseDate": "2025-03-28"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 675,
                        "hold": 54,
                        "slide": 131,
                        "touch": 70,
                        "break": 54,
                        "total": 984
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11844,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.9,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2025-03-28"
                }
            ],
            "searchAcronyms": [
                "moe chaka fire",
                "MoeChakkaFire"
            ]
        },
        {
            "songId": "マヌルネコのうた",
            "category": "POPS＆アニメ",
            "title": "マヌルネコのうた",
            "artist": "小田朋美",
            "bpm": 137,
            "imageName": "4a96546c17849f78191f5179a1457e741458d9efc83a5fbb0094fdfb1a71abb3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 116,
                        "hold": 8,
                        "slide": 6,
                        "touch": 9,
                        "break": 5,
                        "total": 144
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11845,
                    "releaseDate": "2025-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 14,
                        "slide": 7,
                        "touch": 28,
                        "break": 5,
                        "total": 244
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11845,
                    "releaseDate": "2025-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 54,
                        "slide": 33,
                        "touch": 32,
                        "break": 21,
                        "total": 398
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11845,
                    "releaseDate": "2025-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 8,
                        "slide": 153,
                        "touch": 5,
                        "break": 15,
                        "total": 503
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11845,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2025-04-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "スナネコのうた",
            "category": "POPS＆アニメ",
            "title": "スナネコのうた",
            "artist": "ぷにぷに電機",
            "bpm": 92,
            "imageName": "a8db886143caf646c97ebc13b1c8ed88202e0e8aa61035cdf955ebc115553e6b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 98,
                        "hold": 2,
                        "slide": 4,
                        "touch": 8,
                        "break": 5,
                        "total": 117
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11846,
                    "releaseDate": "2025-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 159,
                        "hold": 12,
                        "slide": 4,
                        "touch": 13,
                        "break": 4,
                        "total": 192
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11846,
                    "releaseDate": "2025-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 38,
                        "slide": 16,
                        "touch": 17,
                        "break": 14,
                        "total": 261
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11846,
                    "releaseDate": "2025-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 34,
                        "slide": 58,
                        "touch": 118,
                        "break": 76,
                        "total": 566
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "level": "13",
                            "levelValue": 13
                        }
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11846,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM PLUS": 13.4
                    },
                    "releaseDate": "2025-04-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[幸]犬日和。(はっぴー歌唱Ver)",
            "category": "宴会場",
            "title": "[幸]犬日和。(はっぴー歌唱Ver)",
            "artist": "こうのさんとはっぴーちゃん/Hiroの犯行",
            "bpm": null,
            "imageName": "e089d171e667a0c8f8f45a256278ed5c350694d6613ecda6fc50c82637c356f7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【幸】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 100851,
                    "version": "PRiSM PLUS",
                    "comment": "HOLDだけでがんばろうとした。",
                    "releaseDate": "2025-04-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ATLAS RUSH",
            "category": "maimai",
            "title": "ATLAS RUSH",
            "artist": "kanone",
            "bpm": 156,
            "imageName": "d4f9ada0ddcb184121765cb9c9161b7ab8cf6dffdbb2189029b71b1a94dcccaa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 193,
                        "hold": 13,
                        "slide": 6,
                        "touch": 14,
                        "break": 10,
                        "total": 236
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11810,
                    "releaseDate": "2025-04-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 304,
                        "hold": 23,
                        "slide": 7,
                        "touch": 21,
                        "break": 13,
                        "total": 368
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11810,
                    "releaseDate": "2025-04-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 403,
                        "hold": 61,
                        "slide": 48,
                        "touch": 21,
                        "break": 59,
                        "total": 592
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11810,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2025-04-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "BELiZHEL",
                    "noteCounts": {
                        "tap": 763,
                        "hold": 42,
                        "slide": 103,
                        "touch": 28,
                        "break": 109,
                        "total": 1045
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11810,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7,
                        "PRiSM PLUS": 14.7
                    },
                    "releaseDate": "2025-04-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "M@GICAL☆CURE! LOVE ♥ SHOT!",
            "category": "niconico＆ボーカロイド",
            "title": "M@GICAL☆CURE! LOVE ♥ SHOT!",
            "artist": "SAWTOWNE",
            "bpm": 192,
            "imageName": "f9028397884cc704fe579bc97a801560dfabc6d39177e3bab2e4a71f274c2435",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 15,
                        "slide": 4,
                        "touch": 14,
                        "break": 13,
                        "total": 232
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11847,
                    "releaseDate": "2025-04-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 343,
                        "hold": 18,
                        "slide": 11,
                        "touch": 28,
                        "break": 5,
                        "total": 405
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11847,
                    "releaseDate": "2025-04-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 453,
                        "hold": 50,
                        "slide": 44,
                        "touch": 41,
                        "break": 35,
                        "total": 623
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11847,
                    "releaseDate": "2025-04-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 666,
                        "hold": 65,
                        "slide": 139,
                        "touch": 47,
                        "break": 30,
                        "total": 947
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11847,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.6,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2025-04-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Overjoy ★ OVERDOSE!!",
            "category": "ゲーム＆バラエティ",
            "title": "Overjoy ★ OVERDOSE!!",
            "artist": "Luna Fozer (BilliumMoto, 黒皇帝, Sobrem feat. vally.exe)",
            "bpm": 143,
            "imageName": "35f7753bd0fd0f35e5209f4f7cd6e4aece12473f33001419fb894f1aee69c62b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 166,
                        "hold": 13,
                        "slide": 4,
                        "touch": 6,
                        "break": 7,
                        "total": 196
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11848,
                    "releaseDate": "2025-04-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 313,
                        "hold": 13,
                        "slide": 6,
                        "touch": 26,
                        "break": 4,
                        "total": 362
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11848,
                    "releaseDate": "2025-04-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 372,
                        "hold": 72,
                        "slide": 51,
                        "touch": 20,
                        "break": 54,
                        "total": 569
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11848,
                    "releaseDate": "2025-04-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 827,
                        "hold": 50,
                        "slide": 98,
                        "touch": 40,
                        "break": 59,
                        "total": 1074
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11848,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.2,
                        "PRiSM PLUS": 14.1
                    },
                    "releaseDate": "2025-04-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "DATAERR0R",
            "category": "ゲーム＆バラエティ",
            "title": "DATAERR0R",
            "artist": "Cosmograph",
            "bpm": 180,
            "imageName": "da7fc29cf52c4f6b70cba978ed232d1710a0b578050036158b5626cdd1df6b88",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 160,
                        "hold": 13,
                        "slide": 4,
                        "touch": 14,
                        "break": 5,
                        "total": 196
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11849,
                    "releaseDate": "2025-04-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 289,
                        "hold": 18,
                        "slide": 10,
                        "touch": 26,
                        "break": 3,
                        "total": 346
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11849,
                    "releaseDate": "2025-04-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 216,
                        "hold": 62,
                        "slide": 28,
                        "touch": 25,
                        "break": 62,
                        "total": 393
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11849,
                    "releaseDate": "2025-04-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 518,
                        "hold": 60,
                        "slide": 74,
                        "touch": 7,
                        "break": 46,
                        "total": 705
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11849,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "PRiSM PLUS": 14
                    },
                    "releaseDate": "2025-04-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "あいたい星人",
            "category": "niconico＆ボーカロイド",
            "title": "あいたい星人",
            "artist": "DECO*27",
            "bpm": 150,
            "imageName": "51b35a04bba98253edc7c63bc26a996196b871384f2f7eb58fbcdb0a0e3930d1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 11,
                        "slide": 4,
                        "touch": 8,
                        "break": 9,
                        "total": 207
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11850,
                    "releaseDate": "2025-04-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 18,
                        "slide": 13,
                        "touch": 11,
                        "break": 4,
                        "total": 330
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11850,
                    "releaseDate": "2025-04-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 379,
                        "hold": 76,
                        "slide": 50,
                        "touch": 17,
                        "break": 7,
                        "total": 529
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11850,
                    "releaseDate": "2025-04-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 519,
                        "hold": 62,
                        "slide": 103,
                        "touch": 11,
                        "break": 57,
                        "total": 752
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11850,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2025-04-24"
                }
            ],
            "searchAcronyms": [
                "Aitai Seijin",
                "Aitai-lians"
            ]
        },
        {
            "songId": "ハオ",
            "category": "niconico＆ボーカロイド",
            "title": "ハオ",
            "artist": "DECO*27",
            "bpm": 176,
            "imageName": "db93e27724efbe5df1a8fc3e8d5035c9a7e2815d21af7869e476742ec7c90822",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 155,
                        "hold": 11,
                        "slide": 4,
                        "touch": 7,
                        "break": 13,
                        "total": 190
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11851,
                    "releaseDate": "2025-04-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 288,
                        "hold": 14,
                        "slide": 7,
                        "touch": 27,
                        "break": 8,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11851,
                    "releaseDate": "2025-04-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 392,
                        "hold": 27,
                        "slide": 21,
                        "touch": 24,
                        "break": 38,
                        "total": 502
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "level": "10",
                            "levelValue": 10
                        }
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11851,
                    "releaseDate": "2025-04-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 442,
                        "hold": 28,
                        "slide": 136,
                        "touch": 76,
                        "break": 70,
                        "total": 752
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11851,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2025-04-24"
                }
            ],
            "searchAcronyms": [
                "hao"
            ]
        },
        {
            "songId": "概して過誤",
            "category": "maimai",
            "title": "概して過誤",
            "artist": "isonosuke feat.知声",
            "bpm": 170,
            "imageName": "91021b395a15c6d44001bca38135cfdbb49f0eac568c642a2fe819e1942f23d1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 181,
                        "hold": 13,
                        "slide": 5,
                        "touch": 17,
                        "break": 8,
                        "total": 224
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11811,
                    "releaseDate": "2025-05-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 306,
                        "hold": 16,
                        "slide": 14,
                        "touch": 29,
                        "break": 6,
                        "total": 371
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11811,
                    "releaseDate": "2025-05-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 318,
                        "hold": 69,
                        "slide": 43,
                        "touch": 18,
                        "break": 56,
                        "total": 504
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11811,
                    "releaseDate": "2025-05-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 608,
                        "hold": 52,
                        "slide": 78,
                        "touch": 19,
                        "break": 43,
                        "total": 800
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11811,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2025-05-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Unfinished Epic",
            "category": "maimai",
            "title": "Unfinished Epic",
            "artist": "SLAVE.V-V-R feat.Sor△",
            "bpm": 185,
            "imageName": "4bc8243a82de1100a3bd2dc1a077d0735a084fbd9c9ea6ef9f064ca788fdcfaa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 11,
                        "slide": 4,
                        "touch": 8,
                        "break": 8,
                        "total": 278
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11812,
                    "releaseDate": "2025-05-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 405,
                        "hold": 14,
                        "slide": 12,
                        "touch": 20,
                        "break": 6,
                        "total": 457
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11812,
                    "releaseDate": "2025-05-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 427,
                        "hold": 63,
                        "slide": 77,
                        "touch": 38,
                        "break": 50,
                        "total": 655
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11812,
                    "releaseDate": "2025-05-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 584,
                        "hold": 46,
                        "slide": 126,
                        "touch": 71,
                        "break": 76,
                        "total": 903
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11812,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2025-05-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "忙シー日",
            "category": "maimai",
            "title": "忙シー日",
            "artist": "原口沙輔, 式部めぐり",
            "bpm": 150,
            "imageName": "2b0ebffa60a03d90bbde07e2b580ce23597b5ec4ff8eafb168936f4cf195a00b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 139,
                        "hold": 12,
                        "slide": 7,
                        "touch": 8,
                        "break": 28,
                        "total": 194
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11813,
                    "releaseDate": "2025-05-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 298,
                        "hold": 16,
                        "slide": 14,
                        "touch": 26,
                        "break": 2,
                        "total": 356
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11813,
                    "releaseDate": "2025-05-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 112,
                        "slide": 47,
                        "touch": 13,
                        "break": 77,
                        "total": 529
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11813,
                    "releaseDate": "2025-05-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 683,
                        "hold": 36,
                        "slide": 140,
                        "touch": 49,
                        "break": 54,
                        "total": 962
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11813,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "PRiSM PLUS": 14.2
                    },
                    "releaseDate": "2025-05-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "好きな惣菜発表ドラゴン",
            "category": "niconico＆ボーカロイド",
            "title": "好きな惣菜発表ドラゴン",
            "artist": "ンバヂ",
            "bpm": 160,
            "imageName": "83dd218ce1138c8276764ece2a6353c55d6fb1e1542893a2c396d5df260022ed",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 131,
                        "hold": 11,
                        "slide": 6,
                        "touch": 6,
                        "break": 10,
                        "total": 164
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11852,
                    "releaseDate": "2025-05-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 247,
                        "hold": 12,
                        "slide": 9,
                        "touch": 28,
                        "break": 6,
                        "total": 302
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11852,
                    "releaseDate": "2025-05-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 250,
                        "hold": 39,
                        "slide": 22,
                        "touch": 0,
                        "break": 43,
                        "total": 354
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11852,
                    "releaseDate": "2025-05-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 294,
                        "hold": 63,
                        "slide": 55,
                        "touch": 28,
                        "break": 50,
                        "total": 490
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11852,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2025-05-09"
                }
            ],
            "searchAcronyms": [
                "Favorite-Daily-Dish-Announcing Dragon",
                "Suki na Souzai Happyou Doragon"
            ]
        },
        {
            "songId": "[好]好きな惣菜発表ドラゴン",
            "category": "宴会場",
            "title": "[好]好きな惣菜発表ドラゴン",
            "artist": "ンバヂ",
            "bpm": null,
            "imageName": "83dd218ce1138c8276764ece2a6353c55d6fb1e1542893a2c396d5df260022ed",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【好】",
                    "level": "14?",
                    "internalLevelValue": 14,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111852,
                    "version": "PRiSM PLUS",
                    "comment": "好きな譜面発表Luxizhel",
                    "releaseDate": "2025-05-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[譜]好きな惣菜発表ドラゴン",
            "category": "宴会場",
            "title": "[譜]好きな惣菜発表ドラゴン",
            "artist": "ンバヂ",
            "bpm": null,
            "imageName": "83dd218ce1138c8276764ece2a6353c55d6fb1e1542893a2c396d5df260022ed",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【譜】",
                    "level": "14?",
                    "internalLevelValue": 14,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 121852,
                    "version": "PRiSM PLUS",
                    "comment": "好きな譜面発表サファ太",
                    "releaseDate": "2025-05-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[面]好きな惣菜発表ドラゴン",
            "category": "宴会場",
            "title": "[面]好きな惣菜発表ドラゴン",
            "artist": "ンバヂ",
            "bpm": null,
            "imageName": "83dd218ce1138c8276764ece2a6353c55d6fb1e1542893a2c396d5df260022ed",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【面】",
                    "level": "14?",
                    "internalLevelValue": 14,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 131852,
                    "version": "PRiSM PLUS",
                    "comment": "好きな譜面発表鳩ホルダー",
                    "releaseDate": "2025-05-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[発]好きな惣菜発表ドラゴン",
            "category": "宴会場",
            "title": "[発]好きな惣菜発表ドラゴン",
            "artist": "ンバヂ",
            "bpm": null,
            "imageName": "83dd218ce1138c8276764ece2a6353c55d6fb1e1542893a2c396d5df260022ed",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【発】",
                    "level": "13+?",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 141852,
                    "version": "PRiSM PLUS",
                    "comment": "好きな譜面発表メロンポップ",
                    "releaseDate": "2025-05-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[表]好きな惣菜発表ドラゴン",
            "category": "宴会場",
            "title": "[表]好きな惣菜発表ドラゴン",
            "artist": "ンバヂ",
            "bpm": null,
            "imageName": "83dd218ce1138c8276764ece2a6353c55d6fb1e1542893a2c396d5df260022ed",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【表】",
                    "level": "13+?",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 151852,
                    "version": "PRiSM PLUS",
                    "comment": "好きな譜面発表きょむりん",
                    "releaseDate": "2025-05-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[龍]好きな惣菜発表ドラゴン",
            "category": "宴会場",
            "title": "[龍]好きな惣菜発表ドラゴン",
            "artist": "ンバヂ",
            "bpm": null,
            "imageName": "83dd218ce1138c8276764ece2a6353c55d6fb1e1542893a2c396d5df260022ed",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【龍】",
                    "level": "13+?",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 161852,
                    "version": "PRiSM PLUS",
                    "comment": "好きな譜面発表アマリリス",
                    "releaseDate": "2025-05-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "FLΛME/FRΦST",
            "category": "maimai",
            "title": "FLΛME/FRΦST",
            "artist": "FANTAGIRAFF",
            "bpm": 174,
            "imageName": "b60816b3e4323a60d1651dfb31e7b4ac58781c6526abb1341b9039462858e009",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 12,
                        "slide": 6,
                        "touch": 8,
                        "break": 14,
                        "total": 243
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11814,
                    "releaseDate": "2025-05-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 20,
                        "slide": 10,
                        "touch": 28,
                        "break": 3,
                        "total": 358
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11814,
                    "releaseDate": "2025-05-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 424,
                        "hold": 31,
                        "slide": 63,
                        "touch": 19,
                        "break": 62,
                        "total": 599
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11814,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2025-05-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "SΛFΛRI/RΦCHER",
                    "noteCounts": {
                        "tap": 687,
                        "hold": 46,
                        "slide": 73,
                        "touch": 118,
                        "break": 122,
                        "total": 1046
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11814,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8,
                        "PRiSM PLUS": 14.8
                    },
                    "releaseDate": "2025-05-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Help me, ERINNNNNN!!",
            "category": "東方Project",
            "title": "Help me, ERINNNNNN!!",
            "artist": "ビートまりお",
            "bpm": 185,
            "imageName": "a3f1074023bf576cbf63d6436f0e31291371508816d06580ddfce96bbff92726",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 11,
                        "slide": 6,
                        "touch": 6,
                        "break": 7,
                        "total": 220
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11853,
                    "releaseDate": "2025-05-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 12,
                        "slide": 8,
                        "touch": 42,
                        "break": 2,
                        "total": 361
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11853,
                    "releaseDate": "2025-05-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 471,
                        "hold": 48,
                        "slide": 41,
                        "touch": 8,
                        "break": 13,
                        "total": 581
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11853,
                    "releaseDate": "2025-05-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 619,
                        "hold": 48,
                        "slide": 62,
                        "touch": 100,
                        "break": 85,
                        "total": 914
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11853,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2025-05-21"
                }
            ],
            "searchAcronyms": [
                "Help Me ERIN"
            ]
        },
        {
            "songId": "超最終鬼畜妹フランドール・S",
            "category": "東方Project",
            "title": "超最終鬼畜妹フランドール・S",
            "artist": "ビートまりお×まろん",
            "bpm": 210,
            "imageName": "61baff18a353052253ee138f667c83e4072e8baff78980b51483c7dc87d21666",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 11,
                        "slide": 4,
                        "touch": 12,
                        "break": 13,
                        "total": 237
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11854,
                    "releaseDate": "2025-05-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 331,
                        "hold": 14,
                        "slide": 11,
                        "touch": 26,
                        "break": 2,
                        "total": 384
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11854,
                    "releaseDate": "2025-05-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 394,
                        "hold": 76,
                        "slide": 60,
                        "touch": 56,
                        "break": 46,
                        "total": 632
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11854,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.6,
                        "CiRCLE PLUS": 12.6,
                        "PRiSM PLUS": 12.6
                    },
                    "releaseDate": "2025-05-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 584,
                        "hold": 53,
                        "slide": 88,
                        "touch": 51,
                        "break": 64,
                        "total": 840
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11854,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2025-05-21"
                }
            ],
            "searchAcronyms": [
                "Chou saishuu kichiku imouto Flandre S"
            ]
        },
        {
            "songId": "Destined Marionette",
            "category": "ゲーム＆バラエティ",
            "title": "Destined Marionette",
            "artist": "ビートまりお",
            "bpm": 186,
            "imageName": "ac5252d5b23964f6ff0cc99edddb29c4951c4fe52ed5d135acc9e1c73e83d428",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 18,
                        "slide": 3,
                        "touch": 8,
                        "break": 9,
                        "total": 228
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11855,
                    "releaseDate": "2025-05-21"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 379,
                        "hold": 20,
                        "slide": 5,
                        "touch": 28,
                        "break": 5,
                        "total": 437
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11855,
                    "releaseDate": "2025-05-21"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 473,
                        "hold": 41,
                        "slide": 51,
                        "touch": 17,
                        "break": 40,
                        "total": 622
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11855,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2025-05-21"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 660,
                        "hold": 81,
                        "slide": 111,
                        "touch": 50,
                        "break": 121,
                        "total": 1023
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11855,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.3,
                        "PRiSM PLUS": 14.2
                    },
                    "releaseDate": "2025-05-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[協]Ultimate taste",
            "category": "宴会場",
            "title": "[協]Ultimate taste",
            "artist": "ぱらどっと",
            "bpm": null,
            "imageName": "6234a6b63bdc987c38d87f9a99821fc1dc95e33d9ac5c1baa5fc4673f7803636",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【協】",
                    "level": "13+?",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111770,
                    "version": "PRiSM PLUS",
                    "comment": "みんなでFull Flavor!",
                    "releaseDate": "2025-05-21"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "MYTH Re：LEASE",
            "category": "ゲーム＆バラエティ",
            "title": "MYTH Re：LEASE",
            "artist": "打打だいず Vs. Tanchiky Vs. uma Vs. モリモリあつし",
            "bpm": 202,
            "imageName": "c472a0d48e94478e9c1b1ca5b4a98a99d1a400fa8780fe463c7961b1310971f2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 221,
                        "hold": 25,
                        "slide": 8,
                        "touch": 12,
                        "break": 9,
                        "total": 275
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11860,
                    "releaseDate": "2025-05-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 27,
                        "slide": 10,
                        "touch": 45,
                        "break": 2,
                        "total": 421
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11860,
                    "releaseDate": "2025-05-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 553,
                        "hold": 45,
                        "slide": 61,
                        "touch": 25,
                        "break": 78,
                        "total": 762
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11860,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2025-05-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "サファ太 Vs. Safari Vs. Saf Vs. モリモリさふぁた",
                    "noteCounts": {
                        "tap": 627,
                        "hold": 63,
                        "slide": 57,
                        "touch": 64,
                        "break": 300,
                        "total": 1111
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11860,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5,
                        "PRiSM PLUS": 14.5
                    },
                    "releaseDate": "2025-05-30"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "クーネル・エンゲイザー",
            "category": "niconico＆ボーカロイド",
            "title": "クーネル・エンゲイザー",
            "artist": "電ǂ鯨",
            "bpm": 170,
            "imageName": "e64a1ccc2092804a2ff73c172babdff5dd5de99168eca3c6c65f2430b1be0c60",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 183,
                        "hold": 10,
                        "slide": 4,
                        "touch": 8,
                        "break": 5,
                        "total": 210
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11871,
                    "releaseDate": "2025-06-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 310,
                        "hold": 14,
                        "slide": 8,
                        "touch": 14,
                        "break": 4,
                        "total": 350
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11871,
                    "releaseDate": "2025-06-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 303,
                        "hold": 75,
                        "slide": 33,
                        "touch": 18,
                        "break": 52,
                        "total": 481
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11871,
                    "releaseDate": "2025-06-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 390,
                        "hold": 49,
                        "slide": 130,
                        "touch": 32,
                        "break": 43,
                        "total": 644
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11871,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2025-06-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ゼロトーキング",
            "category": "niconico＆ボーカロイド",
            "title": "ゼロトーキング",
            "artist": "はるまきごはん",
            "bpm": 133,
            "imageName": "ee0022a39edd895a8dc6a0e86a291eea07d8b18203db176ca1efa88a1f943978",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 10,
                        "slide": 4,
                        "touch": 14,
                        "break": 1,
                        "total": 167
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11872,
                    "releaseDate": "2025-06-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 14,
                        "slide": 11,
                        "touch": 28,
                        "break": 3,
                        "total": 265
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11872,
                    "releaseDate": "2025-06-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 53,
                        "slide": 27,
                        "touch": 29,
                        "break": 10,
                        "total": 383
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11872,
                    "releaseDate": "2025-06-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 461,
                        "hold": 69,
                        "slide": 69,
                        "touch": 57,
                        "break": 22,
                        "total": 678
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11872,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2025-06-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "抜錨",
            "category": "niconico＆ボーカロイド",
            "title": "抜錨",
            "artist": "ナナホシ管弦楽団",
            "bpm": 140,
            "imageName": "73339154ad0105f2ccca273d6330350eee3c255c0051459e867ead4a5a7835a4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 158,
                        "hold": 10,
                        "slide": 5,
                        "touch": 14,
                        "break": 6,
                        "total": 193
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11873,
                    "releaseDate": "2025-06-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 14,
                        "slide": 7,
                        "touch": 13,
                        "break": 6,
                        "total": 322
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11873,
                    "releaseDate": "2025-06-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 425,
                        "hold": 60,
                        "slide": 43,
                        "touch": 2,
                        "break": 34,
                        "total": 564
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11873,
                    "releaseDate": "2025-06-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 554,
                        "hold": 42,
                        "slide": 106,
                        "touch": 23,
                        "break": 40,
                        "total": 765
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11873,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2025-06-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[覚]Hainuwele",
            "category": "宴会場",
            "title": "[覚]Hainuwele",
            "artist": "ETIA.",
            "bpm": null,
            "imageName": "0e482d3fe98d45755363a909270688f5e2ebd96ae780fd2861531958fb42d6ed",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【覚】",
                    "level": "13+?",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111479,
                    "version": "PRiSM PLUS",
                    "comment": "maimai でらっくす版覚譜面もほしかった",
                    "releaseDate": "2025-06-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[逆]WE'RE BACK!!",
            "category": "宴会場",
            "title": "[逆]WE'RE BACK!!",
            "artist": "Zekk",
            "bpm": null,
            "imageName": "3d0fc531eaad9db6f8d8f5977a3ec2b0119b9f41297ca764363a5976b52595fa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【逆】",
                    "level": "12+?",
                    "internalLevelValue": 12.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "internalId": 111628,
                    "version": "PRiSM PLUS",
                    "comment": "SLIDE BACK!!",
                    "releaseDate": "2025-06-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "なんかノイズにきこえる",
            "category": "オンゲキ＆CHUNITHM",
            "title": "なんかノイズにきこえる",
            "artist": "HaNaMiNa feat.Hana",
            "bpm": 158,
            "imageName": "7c378534fb419e378c4b9248d4d38e2d89a2133d50107ec3bbb53c26ed1b9094",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 210,
                        "hold": 9,
                        "slide": 4,
                        "touch": 6,
                        "break": 7,
                        "total": 236
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11824,
                    "releaseDate": "2025-06-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 316,
                        "hold": 16,
                        "slide": 10,
                        "touch": 26,
                        "break": 3,
                        "total": 371
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11824,
                    "releaseDate": "2025-06-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 416,
                        "hold": 39,
                        "slide": 47,
                        "touch": 6,
                        "break": 36,
                        "total": 544
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11824,
                    "releaseDate": "2025-06-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 661,
                        "hold": 37,
                        "slide": 135,
                        "touch": 11,
                        "break": 49,
                        "total": 893
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11824,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2025-06-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "うぇいびー",
            "category": "POPS＆アニメ",
            "title": "うぇいびー",
            "artist": "三枝明那",
            "bpm": 200,
            "imageName": "aaa6baeaded1935f3ab401e4b0ab90a9144042c7fea1c0aee11df13df0539ea0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 9,
                        "slide": 5,
                        "touch": 6,
                        "break": 8,
                        "total": 214
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11867,
                    "releaseDate": "2025-06-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 355,
                        "hold": 10,
                        "slide": 16,
                        "touch": 13,
                        "break": 6,
                        "total": 400
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11867,
                    "releaseDate": "2025-06-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 370,
                        "hold": 72,
                        "slide": 37,
                        "touch": 29,
                        "break": 37,
                        "total": 545
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11867,
                    "releaseDate": "2025-06-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 580,
                        "hold": 44,
                        "slide": 133,
                        "touch": 35,
                        "break": 47,
                        "total": 839
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11867,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2025-06-20"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "三枝明那とはっぴー",
                    "noteCounts": {
                        "tap": 629,
                        "hold": 48,
                        "slide": 176,
                        "touch": 23,
                        "break": 59,
                        "total": 935
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11867,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2025-06-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "RED",
            "category": "POPS＆アニメ",
            "title": "RED",
            "artist": "三枝明那",
            "bpm": 168,
            "imageName": "af3201ddf95d6676cbc66cf679016aabd78430ab463ac612baa360d589d9f8c9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 136,
                        "hold": 11,
                        "slide": 6,
                        "touch": 8,
                        "break": 3,
                        "total": 164
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11868,
                    "releaseDate": "2025-06-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 253,
                        "hold": 12,
                        "slide": 12,
                        "touch": 28,
                        "break": 3,
                        "total": 308
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11868,
                    "releaseDate": "2025-06-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 317,
                        "hold": 31,
                        "slide": 27,
                        "touch": 16,
                        "break": 8,
                        "total": 399
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11868,
                    "releaseDate": "2025-06-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 385,
                        "hold": 36,
                        "slide": 60,
                        "touch": 65,
                        "break": 57,
                        "total": 603
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11868,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2025-06-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ホラフキパペット",
            "category": "POPS＆アニメ",
            "title": "ホラフキパペット",
            "artist": "七次元生徒会！",
            "bpm": 205,
            "imageName": "2c7f47189b8bc71de07b8b68fc25b3a173ad3031c9fece4f25794c26216ea73d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 191,
                        "hold": 12,
                        "slide": 8,
                        "touch": 7,
                        "break": 6,
                        "total": 224
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11869,
                    "releaseDate": "2025-06-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 302,
                        "hold": 16,
                        "slide": 6,
                        "touch": 13,
                        "break": 4,
                        "total": 341
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11869,
                    "releaseDate": "2025-06-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 390,
                        "hold": 49,
                        "slide": 28,
                        "touch": 26,
                        "break": 37,
                        "total": 530
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11869,
                    "releaseDate": "2025-06-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "メロンホップ",
                    "noteCounts": {
                        "tap": 457,
                        "hold": 54,
                        "slide": 126,
                        "touch": 80,
                        "break": 39,
                        "total": 756
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11869,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6,
                        "PRiSM PLUS": 13.6
                    },
                    "releaseDate": "2025-06-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "BlackFlagBreaker!!",
            "category": "POPS＆アニメ",
            "title": "BlackFlagBreaker!!",
            "artist": "社築 × sasakure.UK",
            "bpm": 163,
            "imageName": "802e292413d17600cdfd93cb448b14da2403fd17d704d38589eed6085aaf12df",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 9,
                        "slide": 5,
                        "touch": 6,
                        "break": 8,
                        "total": 214
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11870,
                    "releaseDate": "2025-06-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 12,
                        "slide": 15,
                        "touch": 26,
                        "break": 2,
                        "total": 404
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11870,
                    "releaseDate": "2025-06-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 406,
                        "hold": 50,
                        "slide": 49,
                        "touch": 41,
                        "break": 42,
                        "total": 588
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11870,
                    "releaseDate": "2025-06-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 693,
                        "hold": 112,
                        "slide": 124,
                        "touch": 27,
                        "break": 42,
                        "total": 998
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11870,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.9,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2025-06-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "JIGOKU STATION CENTRAL GATE",
            "category": "オンゲキ＆CHUNITHM",
            "title": "JIGOKU STATION CENTRAL GATE",
            "artist": "鬱P feat.000",
            "bpm": 160,
            "imageName": "0e1d403a77ae281717e38a943763d5d770eec74b7152c0d7b58dcef7487257e7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 9,
                        "slide": 4,
                        "touch": 6,
                        "break": 4,
                        "total": 250
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11825,
                    "releaseDate": "2025-06-27"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 326,
                        "hold": 14,
                        "slide": 12,
                        "touch": 26,
                        "break": 12,
                        "total": 390
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11825,
                    "releaseDate": "2025-06-27"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 447,
                        "hold": 59,
                        "slide": 72,
                        "touch": 6,
                        "break": 40,
                        "total": 624
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11825,
                    "releaseDate": "2025-06-27"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 725,
                        "hold": 72,
                        "slide": 110,
                        "touch": 56,
                        "break": 55,
                        "total": 1018
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "level": "13+",
                            "levelValue": 13.6
                        }
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11825,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 14,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2025-06-27"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "㋰責任集合体",
            "category": "niconico＆ボーカロイド",
            "title": "㋰責任集合体",
            "artist": "マサラダ",
            "bpm": 135,
            "imageName": "994f16b997988b4c0b22c39412646787f5192e99a0e56fe4915c6f759a6d13eb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 186,
                        "hold": 8,
                        "slide": 4,
                        "touch": 15,
                        "break": 13,
                        "total": 226
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11862,
                    "releaseDate": "2025-06-27"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 14,
                        "slide": 7,
                        "touch": 11,
                        "break": 10,
                        "total": 380
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11862,
                    "releaseDate": "2025-06-27"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 389,
                        "hold": 78,
                        "slide": 28,
                        "touch": 0,
                        "break": 49,
                        "total": 544
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11862,
                    "releaseDate": "2025-06-27"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 664,
                        "hold": 59,
                        "slide": 113,
                        "touch": 57,
                        "break": 86,
                        "total": 979
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11862,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.4,
                        "PRiSM PLUS": 13.5
                    },
                    "releaseDate": "2025-06-27"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "三日月ステップ 2023",
            "category": "niconico＆ボーカロイド",
            "title": "三日月ステップ 2023",
            "artist": "r-906",
            "bpm": 167,
            "imageName": "34a57b074052d8006f8c64a3eff87d09d330bfab810d7c20b09de62508c10e4d",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 185,
                        "hold": 9,
                        "slide": 4,
                        "touch": 6,
                        "break": 9,
                        "total": 213
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11863,
                    "releaseDate": "2025-06-27"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 16,
                        "slide": 8,
                        "touch": 26,
                        "break": 5,
                        "total": 400
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11863,
                    "releaseDate": "2025-06-27"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 428,
                        "hold": 39,
                        "slide": 54,
                        "touch": 23,
                        "break": 15,
                        "total": 559
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11863,
                    "releaseDate": "2025-06-27"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 489,
                        "hold": 56,
                        "slide": 110,
                        "touch": 27,
                        "break": 40,
                        "total": 722
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11863,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2025-06-27"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Lover's Trick",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Lover's Trick",
            "artist": "litmus*",
            "bpm": 130,
            "imageName": "b34900d74e1ccfffa0c4b39fc546761d6dc6e0f9d95c7a04cd3e7671314e7780",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 12,
                        "slide": 6,
                        "touch": 13,
                        "break": 2,
                        "total": 171
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11826,
                    "releaseDate": "2025-07-04"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 16,
                        "slide": 5,
                        "touch": 21,
                        "break": 7,
                        "total": 261
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11826,
                    "releaseDate": "2025-07-04"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 245,
                        "hold": 82,
                        "slide": 46,
                        "touch": 35,
                        "break": 34,
                        "total": 442
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11826,
                    "releaseDate": "2025-07-04"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 520,
                        "hold": 88,
                        "slide": 37,
                        "touch": 85,
                        "break": 18,
                        "total": 748
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "internalId": 11826,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2025-07-04"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "IMBRUED:FLUX",
            "category": "maimai",
            "title": "IMBRUED:FLUX",
            "artist": "qfeileadh feat.のあ",
            "bpm": 176,
            "imageName": "b7130ac980a8504595202603808b4c277b8d9f91e419eeb96dbbeb716a1d7ae1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 177,
                        "hold": 8,
                        "slide": 10,
                        "touch": 9,
                        "break": 4,
                        "total": 208
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 302,
                        "hold": 10,
                        "slide": 11,
                        "touch": 14,
                        "break": 4,
                        "total": 341
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 377,
                        "hold": 66,
                        "slide": 39,
                        "touch": 53,
                        "break": 43,
                        "total": 578
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "きょむりん vs Luxizhel",
                    "noteCounts": {
                        "tap": 661,
                        "hold": 60,
                        "slide": 101,
                        "touch": 82,
                        "break": 39,
                        "total": 943
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1,
                        "PRiSM PLUS": 14.1
                    },
                    "releaseDate": "2025-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "砂の函",
            "category": "maimai",
            "title": "砂の函",
            "artist": "Nego_tiator",
            "bpm": 180,
            "imageName": "9bb21016c0ce87ea4fa1e05a5f3b978d29b6e6cf2c148bb992834a610a7a7caf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 171,
                        "hold": 10,
                        "slide": 4,
                        "touch": 26,
                        "break": 2,
                        "total": 213
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 30,
                        "slide": 8,
                        "touch": 6,
                        "break": 2,
                        "total": 283
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 106,
                        "slide": 63,
                        "touch": 20,
                        "break": 40,
                        "total": 505
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 512,
                        "hold": 56,
                        "slide": 75,
                        "touch": 60,
                        "break": 78,
                        "total": 781
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "PRiSM PLUS": 14
                    },
                    "releaseDate": "2025-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Amereistr",
            "category": "maimai",
            "title": "Amereistr",
            "artist": "rN",
            "bpm": 147,
            "imageName": "4ad3acf63b3c4c2555c52d9cc2aa9d760a809db51148454b20b95b3ada10d07c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 13,
                        "slide": 4,
                        "touch": 8,
                        "break": 5,
                        "total": 261
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 366,
                        "hold": 18,
                        "slide": 10,
                        "touch": 34,
                        "break": 8,
                        "total": 436
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 122,
                        "hold": 53,
                        "slide": 12,
                        "touch": 31,
                        "break": 45,
                        "total": 263
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5
                    },
                    "releaseDate": "2025-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 466,
                        "hold": 102,
                        "slide": 31,
                        "touch": 67,
                        "break": 72,
                        "total": 738
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2025-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "サウンドプレイヤー",
            "category": "オンゲキ＆CHUNITHM",
            "title": "サウンドプレイヤー",
            "artist": "tilt-six feat.バル",
            "bpm": 143,
            "imageName": "e6e72dc6fab73056dc0a246494bded6c9281a8361e0a03217d861f4360952fb2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 170,
                        "hold": 11,
                        "slide": 4,
                        "touch": 7,
                        "break": 6,
                        "total": 198
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 261,
                        "hold": 13,
                        "slide": 9,
                        "touch": 27,
                        "break": 4,
                        "total": 314
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 380,
                        "hold": 65,
                        "slide": 44,
                        "touch": 8,
                        "break": 22,
                        "total": 519
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 551,
                        "hold": 73,
                        "slide": 73,
                        "touch": 107,
                        "break": 33,
                        "total": 837
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2025-07-11"
                }
            ],
            "searchAcronyms": [
                "Sound Player",
                "Sound Prayer"
            ]
        },
        {
            "songId": "World's end BLACKBOX",
            "category": "maimai",
            "title": "World's end BLACKBOX",
            "artist": "打打だいず",
            "bpm": 205,
            "imageName": "40c242e209232ade9754eadb1bcbdc7a0315cb8dd6ba01a62915ece87bf4bff2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 350,
                        "hold": 27,
                        "slide": 8,
                        "touch": 25,
                        "break": 6,
                        "total": 416
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 576,
                        "hold": 20,
                        "slide": 14,
                        "touch": 22,
                        "break": 8,
                        "total": 640
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 671,
                        "hold": 34,
                        "slide": 54,
                        "touch": 70,
                        "break": 50,
                        "total": 879
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2025-07-11"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.9,
                    "noteDesigner": "7sRef -DOVE-",
                    "noteCounts": {
                        "tap": 831,
                        "hold": 137,
                        "slide": 116,
                        "touch": 115,
                        "break": 123,
                        "total": 1322
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.9,
                        "CiRCLE PLUS": 14.9,
                        "PRiSM PLUS": 14.9
                    },
                    "releaseDate": "2025-07-11"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "プリズム△▽リズム",
            "category": "maimai",
            "title": "プリズム△▽リズム",
            "artist": "Shoichiro Hirata feat.Sana",
            "bpm": 155,
            "imageName": "4a0a2d8dd700e942a21b79030c814a4d4e09f46c5478ae7701cc6b4531a1aad8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 165,
                        "hold": 13,
                        "slide": 8,
                        "touch": 8,
                        "break": 6,
                        "total": 200
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11736,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 18,
                        "slide": 12,
                        "touch": 18,
                        "break": 2,
                        "total": 313
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11736,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 45,
                        "slide": 49,
                        "touch": 6,
                        "break": 52,
                        "total": 490
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11736,
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "みそかつ侍",
                    "noteCounts": {
                        "tap": 450,
                        "hold": 47,
                        "slide": 121,
                        "touch": 81,
                        "break": 74,
                        "total": 773
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM",
                    "internalId": 11736,
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2024-09-12"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 187,
                        "hold": 18,
                        "slide": 7,
                        "touch": null,
                        "break": 1,
                        "total": 213
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-12"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 249,
                        "hold": 16,
                        "slide": 15,
                        "touch": null,
                        "break": 4,
                        "total": 284
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-12"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 30,
                        "slide": 30,
                        "touch": null,
                        "break": 10,
                        "total": 419
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-12"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "譜面-100号",
                    "noteCounts": {
                        "tap": 498,
                        "hold": 57,
                        "slide": 113,
                        "touch": null,
                        "break": 13,
                        "total": 681
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "PRiSM PLUS": 13.2
                    },
                    "releaseDate": "2025-07-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "AFTER PANDORA",
            "category": "maimai",
            "title": "AFTER PANDORA",
            "artist": "削除",
            "bpm": 85,
            "imageName": "9dacc0e909e896cf30d5037da8752ed5ec37ff04389c1f4122189f01ba6c6b89",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 165,
                        "hold": 6,
                        "slide": 8,
                        "touch": null,
                        "break": 4,
                        "total": 183
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-13"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 11,
                        "slide": 6,
                        "touch": null,
                        "break": 6,
                        "total": 298
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-13"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 255,
                        "hold": 44,
                        "slide": 29,
                        "touch": null,
                        "break": 5,
                        "total": 333
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2025-07-13"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 429,
                        "hold": 21,
                        "slide": 102,
                        "touch": null,
                        "break": 25,
                        "total": 577
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2,
                        "PRiSM PLUS": 14.2
                    },
                    "releaseDate": "2025-07-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Xaleid◆scopiX",
            "category": "maimai",
            "title": "Xaleid◆scopiX",
            "artist": "xi",
            "bpm": 180,
            "imageName": "e84a9114bdc2482c819aa18ab8e1114ba007ee207a3c53405fd3f41a063faaef",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 517,
                        "hold": 26,
                        "slide": 12,
                        "touch": 36,
                        "break": 9,
                        "total": 600
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 865,
                        "hold": 51,
                        "slide": 20,
                        "touch": 60,
                        "break": 4,
                        "total": 1000
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 1017,
                        "hold": 103,
                        "slide": 90,
                        "touch": 75,
                        "break": 72,
                        "total": 1357
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "PRiSM PLUS": 13.7
                    },
                    "releaseDate": "2025-07-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.9,
                    "noteDesigner": "KALEIDXSCOPE",
                    "noteCounts": {
                        "tap": 1556,
                        "hold": 143,
                        "slide": 168,
                        "touch": 93,
                        "break": 221,
                        "total": 2181
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.9,
                        "CiRCLE PLUS": 14.9,
                        "PRiSM PLUS": 14.9
                    },
                    "releaseDate": "2025-07-13"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "15",
                    "internalLevelValue": 15,
                    "noteDesigner": "Xaleid◆scopiX",
                    "noteCounts": {
                        "tap": 1590,
                        "hold": 173,
                        "slide": 103,
                        "touch": 134,
                        "break": 222,
                        "total": 2222
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 15,
                        "CiRCLE PLUS": 15,
                        "PRiSM PLUS": 15
                    },
                    "releaseDate": "2025-07-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Ref:rain (for 7th Heaven)",
            "category": "maimai",
            "title": "Ref:rain (for 7th Heaven)",
            "artist": "カモメサノエレクトリックオーケストラ include Limonène",
            "bpm": 188,
            "imageName": "abcf8d06013f6ff6a1d1ffb70ddf42eae1a223cd9117c245e2f1e74ceb254541",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 279,
                        "hold": 28,
                        "slide": 14,
                        "touch": 32,
                        "break": 3,
                        "total": 356
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 523,
                        "hold": 20,
                        "slide": 19,
                        "touch": 31,
                        "break": 28,
                        "total": 621
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "きょむりん & Luxizhel",
                    "noteCounts": {
                        "tap": 712,
                        "hold": 58,
                        "slide": 69,
                        "touch": 96,
                        "break": 56,
                        "total": 991
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5,
                        "PRiSM PLUS": 12.5
                    },
                    "releaseDate": "2025-07-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "Jack + Soma",
                    "noteCounts": {
                        "tap": 777,
                        "hold": 107,
                        "slide": 147,
                        "touch": 147,
                        "break": 47,
                        "total": 1225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14,
                        "PRiSM PLUS": 14
                    },
                    "releaseDate": "2025-07-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "crazy (about you)",
            "category": "オンゲキ＆CHUNITHM",
            "title": "crazy (about you)",
            "artist": "kamome sano",
            "bpm": 145,
            "imageName": "f8d6864f29345942bdecc58cfbf065647e9caf6292d9390881edbd437f288d86",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 147,
                        "hold": 14,
                        "slide": 3,
                        "touch": 8,
                        "break": 4,
                        "total": 176
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 225,
                        "hold": 10,
                        "slide": 10,
                        "touch": 26,
                        "break": 3,
                        "total": 274
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 268,
                        "hold": 32,
                        "slide": 40,
                        "touch": 27,
                        "break": 42,
                        "total": 409
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 494,
                        "hold": 75,
                        "slide": 52,
                        "touch": 89,
                        "break": 33,
                        "total": 743
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2025-07-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Drivessover",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Drivessover",
            "artist": "Taishi",
            "bpm": 182,
            "imageName": "129cce4ccb097407424f08be82728743fab46fdbfd75359a1b1977023acbf24f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 9,
                        "slide": 4,
                        "touch": 7,
                        "break": 6,
                        "total": 216
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 319,
                        "hold": 18,
                        "slide": 6,
                        "touch": 30,
                        "break": 3,
                        "total": 376
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 64,
                        "slide": 55,
                        "touch": 28,
                        "break": 16,
                        "total": 565
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2,
                        "PRiSM PLUS": 12.2
                    },
                    "releaseDate": "2025-07-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 512,
                        "hold": 91,
                        "slide": 97,
                        "touch": 43,
                        "break": 43,
                        "total": 786
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.6,
                        "PRiSM PLUS": 13.6
                    },
                    "releaseDate": "2025-07-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Tidal Wave",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Tidal Wave",
            "artist": "D-Cee",
            "bpm": 175,
            "imageName": "06de80a42ae3a27a7525bf765cd21715b0a76a1db6c99ccd0219a0dda0542a06",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 173,
                        "hold": 10,
                        "slide": 4,
                        "touch": 20,
                        "break": 5,
                        "total": 212
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 12,
                        "slide": 13,
                        "touch": 21,
                        "break": 6,
                        "total": 315
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-07-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.3,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 44,
                        "slide": 34,
                        "touch": 17,
                        "break": 16,
                        "total": 453
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.3,
                        "CiRCLE PLUS": 12.3,
                        "PRiSM PLUS": 12.3
                    },
                    "releaseDate": "2025-07-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "あまくちジンジャー",
                    "noteCounts": {
                        "tap": 426,
                        "hold": 30,
                        "slide": 111,
                        "touch": 25,
                        "break": 16,
                        "total": 608
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2025-07-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "∀",
            "category": "ゲーム＆バラエティ",
            "title": "∀",
            "artist": "ああああ",
            "bpm": 245,
            "imageName": "bd1879bba2e422957f40d68435756e357a1d236e3ff08d87391f448c1f162290",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 195,
                        "hold": 17,
                        "slide": 4,
                        "touch": 8,
                        "break": 1,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 8,
                        "slide": 9,
                        "touch": 9,
                        "break": 2,
                        "total": 363
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 378,
                        "hold": 42,
                        "slide": 30,
                        "touch": 9,
                        "break": 29,
                        "total": 488
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 474,
                        "hold": 61,
                        "slide": 56,
                        "touch": 49,
                        "break": 30,
                        "total": 670
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.3,
                        "PRiSM PLUS": 14.2
                    },
                    "releaseDate": "2025-08-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Pixel Galaxy",
            "category": "ゲーム＆バラエティ",
            "title": "Pixel Galaxy",
            "artist": "Snail's House",
            "bpm": 150,
            "imageName": "5885edffe017170cdeae1c4d24bf5855cb7a024199edc9455c6ff83c59f157e3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 130,
                        "hold": 10,
                        "slide": 8,
                        "touch": 13,
                        "break": 6,
                        "total": 167
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 13,
                        "slide": 12,
                        "touch": 21,
                        "break": 3,
                        "total": 334
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 301,
                        "hold": 70,
                        "slide": 30,
                        "touch": 31,
                        "break": 59,
                        "total": 491
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 523,
                        "hold": 49,
                        "slide": 76,
                        "touch": 13,
                        "break": 60,
                        "total": 721
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1,
                        "PRiSM PLUS": 13.1
                    },
                    "releaseDate": "2025-08-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "MIRA",
            "category": "niconico＆ボーカロイド",
            "title": "MIRA",
            "artist": "Kanaria",
            "bpm": 148,
            "imageName": "8af73ca81e2c0aaeafee1ab206d04d5dc1d60615e509035c08e0b02d7cc045e8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 118,
                        "hold": 10,
                        "slide": 4,
                        "touch": 18,
                        "break": 2,
                        "total": 152
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 248,
                        "hold": 12,
                        "slide": 8,
                        "touch": 11,
                        "break": 3,
                        "total": 282
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 236,
                        "hold": 43,
                        "slide": 39,
                        "touch": 8,
                        "break": 8,
                        "total": 334
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 40,
                        "slide": 49,
                        "touch": 87,
                        "break": 53,
                        "total": 540
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2025-08-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "空回りライブラリ",
            "category": "niconico＆ボーカロイド",
            "title": "空回りライブラリ",
            "artist": "雪乃イト",
            "bpm": 130,
            "imageName": "33dd097d3acda0d089da1daf4744a0c8f0b52f9696b2f292a57c8bf7ab1d2ce1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 152,
                        "hold": 9,
                        "slide": 4,
                        "touch": 9,
                        "break": 6,
                        "total": 180
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 16,
                        "slide": 4,
                        "touch": 11,
                        "break": 4,
                        "total": 302
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 32,
                        "slide": 37,
                        "touch": 13,
                        "break": 39,
                        "total": 418
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 484,
                        "hold": 55,
                        "slide": 87,
                        "touch": 17,
                        "break": 24,
                        "total": 667
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8,
                        "PRiSM PLUS": 12.8
                    },
                    "releaseDate": "2025-08-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "お呪い",
            "category": "niconico＆ボーカロイド",
            "title": "お呪い",
            "artist": "なきそ",
            "bpm": 115,
            "imageName": "143a2361541b73c6a3a47e062e14ab97e6e18131960e5736368752094d0592b3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 92,
                        "hold": 7,
                        "slide": 6,
                        "touch": 8,
                        "break": 5,
                        "total": 118
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 8,
                        "slide": 6,
                        "touch": 6,
                        "break": 3,
                        "total": 228
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "きょむりん",
                    "noteCounts": {
                        "tap": 210,
                        "hold": 78,
                        "slide": 10,
                        "touch": 18,
                        "break": 21,
                        "total": 337
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 382,
                        "hold": 16,
                        "slide": 73,
                        "touch": 39,
                        "break": 39,
                        "total": 549
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2025-08-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ありきたりな恋の歌",
            "category": "niconico＆ボーカロイド",
            "title": "ありきたりな恋の歌",
            "artist": "GYARI",
            "bpm": 180,
            "imageName": "801629d887b1578e07a3cb0688bbbe92d50945e7fab1bb4580d852d14c314b1c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 208,
                        "hold": 8,
                        "slide": 4,
                        "touch": 18,
                        "break": 6,
                        "total": 244
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 343,
                        "hold": 19,
                        "slide": 9,
                        "touch": 12,
                        "break": 4,
                        "total": 387
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 411,
                        "hold": 89,
                        "slide": 25,
                        "touch": 28,
                        "break": 24,
                        "total": 577
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 503,
                        "hold": 53,
                        "slide": 122,
                        "touch": 136,
                        "break": 117,
                        "total": 931
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.7,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2025-08-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[協]Seyana. ～何でも言うことを聞いてくれるアカネチャン～",
            "category": "宴会場",
            "title": "[協]Seyana. ～何でも言うことを聞いてくれるアカネチャン～",
            "artist": "GYARI",
            "bpm": null,
            "imageName": "99a40805904616f17fcd478ca8b0195af5629229c54b01bc8617d344e7dbde29",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【協】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "PRiSM PLUS",
                    "comment": "さらに言うことを聞いてくれるアカネチャン",
                    "releaseDate": "2025-08-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[耐]星界ちゃんと可不ちゃんのおつかい合騒曲",
            "category": "宴会場",
            "title": "[耐]星界ちゃんと可不ちゃんのおつかい合騒曲",
            "artist": "南ノ南",
            "bpm": null,
            "imageName": "9538d6320c853768cbd14eb03f9850f949d44bfcca15037fecf67c340aaf13f5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【耐】",
                    "level": "14?",
                    "internalLevelValue": 14,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "PRiSM PLUS",
                    "comment": "せかせかせかせかせかせかせかせかせかせか",
                    "releaseDate": "2025-08-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[騒]ありきたりな恋の歌",
            "category": "宴会場",
            "title": "[騒]ありきたりな恋の歌",
            "artist": "GYARI",
            "bpm": null,
            "imageName": "801629d887b1578e07a3cb0688bbbe92d50945e7fab1bb4580d852d14c314b1c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【騒】",
                    "level": "13+?",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "PRiSM PLUS",
                    "comment": "花隈の歌は可愛いし小春六花はマジでうるさい",
                    "releaseDate": "2025-08-22"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "少女レイ",
            "category": "niconico＆ボーカロイド",
            "title": "少女レイ",
            "artist": "みきとP",
            "bpm": 150,
            "imageName": "7b2cecac0681a0c1e3747e5318e6bbb5acd8a1309782e6deeacc8092ba539051",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 163,
                        "hold": 11,
                        "slide": 4,
                        "touch": 15,
                        "break": 6,
                        "total": 199
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 296,
                        "hold": 12,
                        "slide": 7,
                        "touch": 27,
                        "break": 4,
                        "total": 346
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 324,
                        "hold": 33,
                        "slide": 62,
                        "touch": 13,
                        "break": 11,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 417,
                        "hold": 47,
                        "slide": 104,
                        "touch": 23,
                        "break": 31,
                        "total": 622
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9,
                        "PRiSM PLUS": 12.9
                    },
                    "releaseDate": "2025-08-22"
                }
            ],
            "searchAcronyms": [
                "shoujo rei shoujo ray"
            ]
        },
        {
            "songId": "少女A",
            "category": "niconico＆ボーカロイド",
            "title": "少女A",
            "artist": "椎名もた",
            "bpm": 130,
            "imageName": "92d2d7c1ae4ea9e7a9786b2a32bdcd0375d47604de209ce99d9ebb2b782ce6ef",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 126,
                        "hold": 9,
                        "slide": 4,
                        "touch": 14,
                        "break": 6,
                        "total": 159
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 238,
                        "hold": 12,
                        "slide": 12,
                        "touch": 14,
                        "break": 4,
                        "total": 280
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 287,
                        "hold": 120,
                        "slide": 39,
                        "touch": 8,
                        "break": 12,
                        "total": 466
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 686,
                        "hold": 29,
                        "slide": 91,
                        "touch": 15,
                        "break": 21,
                        "total": 842
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2025-08-22"
                }
            ],
            "searchAcronyms": [
                "shoujo A"
            ]
        },
        {
            "songId": "帝国少女",
            "category": "niconico＆ボーカロイド",
            "title": "帝国少女",
            "artist": "R Sound Design",
            "bpm": 118,
            "imageName": "d52ae514f768b7c210dc50ebde5c05d26a3d6fbada7fa1b8be766740c842f223",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 114,
                        "hold": 10,
                        "slide": 4,
                        "touch": 9,
                        "break": 4,
                        "total": 141
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 195,
                        "hold": 15,
                        "slide": 8,
                        "touch": 27,
                        "break": 6,
                        "total": 251
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 283,
                        "hold": 63,
                        "slide": 26,
                        "touch": 14,
                        "break": 3,
                        "total": 389
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-08-22"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "カマボコホルダー",
                    "noteCounts": {
                        "tap": 506,
                        "hold": 28,
                        "slide": 93,
                        "touch": 49,
                        "break": 21,
                        "total": 697
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3,
                        "PRiSM PLUS": 13.3
                    },
                    "releaseDate": "2025-08-22"
                }
            ],
            "searchAcronyms": [
                "Imperial Girl"
            ]
        },
        {
            "songId": "NO ONE YES MAN",
            "category": "ゲーム＆バラエティ",
            "title": "NO ONE YES MAN",
            "artist": "MYUKKE.",
            "bpm": 170,
            "imageName": "d4ca0dffc2dd08e0c8c836bd003b1515e8d281c1c2bb1bc1852d4db2af38d888",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 150,
                        "hold": 11,
                        "slide": 8,
                        "touch": 6,
                        "break": 5,
                        "total": 180
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-09-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 260,
                        "hold": 14,
                        "slide": 7,
                        "touch": 28,
                        "break": 1,
                        "total": 310
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-09-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 365,
                        "hold": 45,
                        "slide": 60,
                        "touch": 11,
                        "break": 40,
                        "total": 521
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12,
                        "PRiSM PLUS": 12
                    },
                    "releaseDate": "2025-09-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "鳩ホルダー＆Luxizhel",
                    "noteCounts": {
                        "tap": 515,
                        "hold": 73,
                        "slide": 81,
                        "touch": 92,
                        "break": 66,
                        "total": 827
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9,
                        "PRiSM PLUS": 13.9
                    },
                    "releaseDate": "2025-09-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Leave All Behind",
            "category": "ゲーム＆バラエティ",
            "title": "Leave All Behind",
            "artist": "rider",
            "bpm": 150,
            "imageName": "a38fb01e205e28b1f6fafd0e03bbe631370fc8001d8d88135eca8b1697275c2f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 11,
                        "slide": 4,
                        "touch": 13,
                        "break": 5,
                        "total": 160
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-09-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 15,
                        "slide": 8,
                        "touch": 28,
                        "break": 4,
                        "total": 269
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-09-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 46,
                        "slide": 38,
                        "touch": 26,
                        "break": 38,
                        "total": 433
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-09-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 501,
                        "hold": 39,
                        "slide": 48,
                        "touch": 60,
                        "break": 36,
                        "total": 684
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2025-09-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Retribution ～ Cycle of Redemption ～",
            "category": "ゲーム＆バラエティ",
            "title": "Retribution ～ Cycle of Redemption ～",
            "artist": "Ardolf vs. Daily天利 (原曲： nm-y & Kry.exe)",
            "bpm": 112,
            "imageName": "c4e123cc5c9b91846170a9a9827aaed3ca1b7789a75d23301a0dec22a6b5ac9a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 6,
                        "slide": 8,
                        "touch": 17,
                        "break": 5,
                        "total": 372
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-09-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 341,
                        "hold": 28,
                        "slide": 6,
                        "touch": 49,
                        "break": 5,
                        "total": 429
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-09-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 640,
                        "hold": 57,
                        "slide": 36,
                        "touch": 40,
                        "break": 29,
                        "total": 802
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13
                    },
                    "releaseDate": "2025-09-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 726,
                        "hold": 100,
                        "slide": 93,
                        "touch": 64,
                        "break": 105,
                        "total": 1088
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4,
                        "PRiSM PLUS": 14.4
                    },
                    "releaseDate": "2025-09-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Luminescence",
            "category": "ゲーム＆バラエティ",
            "title": "Luminescence",
            "artist": "米虾Fomiki & 初云CLoudie",
            "bpm": 184,
            "imageName": "52edbb1dba0fa4cfac98729301400f25821c1c9c77833a6a7396a87a92a4ffaa",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 22,
                        "slide": 4,
                        "touch": 7,
                        "break": 5,
                        "total": 241
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-09-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 316,
                        "hold": 20,
                        "slide": 16,
                        "touch": 26,
                        "break": 2,
                        "total": 380
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-09-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 332,
                        "hold": 78,
                        "slide": 61,
                        "touch": 46,
                        "break": 61,
                        "total": 578
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "releaseDate": "2025-09-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 599,
                        "hold": 40,
                        "slide": 72,
                        "touch": 129,
                        "break": 42,
                        "total": 882
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "PRiSM PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8,
                        "PRiSM PLUS": 13.8
                    },
                    "releaseDate": "2025-09-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "CiRCLE CAMPAiGN",
            "category": "maimai",
            "title": "CiRCLE CAMPAiGN",
            "artist": "サツキ feat.天音かなた",
            "bpm": 182,
            "imageName": "85f67b84beb77324942974947eb8046bcda4565358e8f3fc4feb0fc8f4ab2230",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 9,
                        "slide": 8,
                        "touch": 6,
                        "break": 8,
                        "total": 254
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 18,
                        "slide": 15,
                        "touch": 28,
                        "break": 7,
                        "total": 405
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 418,
                        "hold": 65,
                        "slide": 54,
                        "touch": 19,
                        "break": 63,
                        "total": 619
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 661,
                        "hold": 40,
                        "slide": 188,
                        "touch": 37,
                        "break": 39,
                        "total": 965
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7
                    },
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Magical Paradox",
            "category": "maimai",
            "title": "Magical Paradox",
            "artist": "Mr.Asyu",
            "bpm": 192,
            "imageName": "fba5dfc95e8f5b68fcaa28fa4a06feef00dd69af56dc132559c600bbc56cac5b",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 227,
                        "hold": 30,
                        "slide": 4,
                        "touch": 15,
                        "break": 3,
                        "total": 279
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 319,
                        "hold": 16,
                        "slide": 13,
                        "touch": 46,
                        "break": 6,
                        "total": 400
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 365,
                        "hold": 84,
                        "slide": 68,
                        "touch": 47,
                        "break": 22,
                        "total": 586
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 737,
                        "hold": 82,
                        "slide": 102,
                        "touch": 45,
                        "break": 86,
                        "total": 1052
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8
                    },
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "殿ッ！？ご乱心！？",
            "category": "maimai",
            "title": "殿ッ！？ご乱心！？",
            "artist": "Shu feat. 天羽しろっぷ",
            "bpm": 200,
            "imageName": "bbf90ce8b107ff06f415e7777acf4252defb8ba9acfda83e323ee44c0ccba27d",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 14,
                        "slide": 6,
                        "touch": 13,
                        "break": 12,
                        "total": 303
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 25,
                        "slide": 12,
                        "touch": 30,
                        "break": 14,
                        "total": 345
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 434,
                        "hold": 62,
                        "slide": 53,
                        "touch": 15,
                        "break": 69,
                        "total": 633
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7
                    },
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 498,
                        "hold": 81,
                        "slide": 98,
                        "touch": 96,
                        "break": 112,
                        "total": 885
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2
                    },
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "イーヴィルガール",
            "category": "オンゲキ＆CHUNITHM",
            "title": "イーヴィルガール",
            "artist": "Fushi feat.吉乃",
            "bpm": 180,
            "imageName": "5e26a1a82894dc68e5760604cf07219fe1fdd79ece2d2c80d3b084cc9938a615",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 15,
                        "slide": 4,
                        "touch": 6,
                        "break": 6,
                        "total": 227
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 18,
                        "slide": 8,
                        "touch": 28,
                        "break": 5,
                        "total": 404
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 438,
                        "hold": 99,
                        "slide": 62,
                        "touch": 18,
                        "break": 25,
                        "total": 642
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Luxizhel & 鳩ホルダー",
                    "noteCounts": {
                        "tap": 782,
                        "hold": 128,
                        "slide": 78,
                        "touch": 65,
                        "break": 67,
                        "total": 1120
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8
                    },
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": [
                "evil girl"
            ]
        },
        {
            "songId": "Dazzle hop",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Dazzle hop",
            "artist": "Sampling Masters MEGA",
            "bpm": 220,
            "imageName": "33e39db8ab16b3a9ce78b2de5bcbebe1ddbfffaa0b3a618cb06313a78d624d3c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 5,
                        "slide": 11,
                        "touch": 14,
                        "break": 14,
                        "total": 273
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 389,
                        "hold": 12,
                        "slide": 19,
                        "touch": 24,
                        "break": 6,
                        "total": 450
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 470,
                        "hold": 98,
                        "slide": 79,
                        "touch": 12,
                        "break": 75,
                        "total": 734
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8
                    },
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 593,
                        "hold": 58,
                        "slide": 111,
                        "touch": 78,
                        "break": 13,
                        "total": 853
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2
                    },
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Unwelcome School",
            "category": "ゲーム＆バラエティ",
            "title": "Unwelcome School",
            "artist": "Mitsukiyo「ブルーアーカイブ -Blue Archive-」",
            "bpm": 180,
            "imageName": "23ab67b13ca0aa29ec167dda513c02b0cf98de21cd8c8776f9acdda3dec89c01",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 9,
                        "slide": 4,
                        "touch": 10,
                        "break": 9,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 12,
                        "slide": 6,
                        "touch": 28,
                        "break": 7,
                        "total": 311
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 326,
                        "hold": 76,
                        "slide": 48,
                        "touch": 16,
                        "break": 13,
                        "total": 479
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 566,
                        "hold": 29,
                        "slide": 95,
                        "touch": 33,
                        "break": 22,
                        "total": 745
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2
                    },
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": 706,
                        "hold": 17,
                        "slide": 152,
                        "touch": 37,
                        "break": 48,
                        "total": 960
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14,
                        "CiRCLE PLUS": 14.1
                    },
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "彩りキャンバス",
            "category": "ゲーム＆バラエティ",
            "title": "彩りキャンバス",
            "artist": "SUGAR RUSH「ブルーアーカイブ -Blue Archive-」",
            "bpm": 180,
            "imageName": "0f4c6d4515f0c1cb06334701d18aad30451d6e5cede2066461eaad1b5febc044",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 88,
                        "hold": 13,
                        "slide": 2,
                        "touch": 6,
                        "break": 3,
                        "total": 112
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 16,
                        "slide": 8,
                        "touch": 11,
                        "break": 4,
                        "total": 208
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 235,
                        "hold": 28,
                        "slide": 30,
                        "touch": 20,
                        "break": 15,
                        "total": 328
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 333,
                        "hold": 28,
                        "slide": 56,
                        "touch": 22,
                        "break": 27,
                        "total": 466
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13
                    },
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": [
                "Irodori Canvas"
            ]
        },
        {
            "songId": "死ぬな！",
            "category": "POPS＆アニメ",
            "title": "死ぬな！",
            "artist": "こっちのけんと",
            "bpm": 220,
            "imageName": "89c65b1e906650b2cc902e7926098440cd6e0139ba691901deaf530073069487",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 19,
                        "slide": 4,
                        "touch": 19,
                        "break": 6,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 296,
                        "hold": 11,
                        "slide": 7,
                        "touch": 13,
                        "break": 4,
                        "total": 331
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 269,
                        "hold": 48,
                        "slide": 43,
                        "touch": 0,
                        "break": 15,
                        "total": 375
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 457,
                        "hold": 32,
                        "slide": 64,
                        "touch": 58,
                        "break": 30,
                        "total": 641
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3
                    },
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "どんぐりGAME",
            "category": "POPS＆アニメ",
            "title": "どんぐりGAME",
            "artist": "こっちのけんと",
            "bpm": 130,
            "imageName": "179913407b1db857cce906358ede88589c2f95da5c3d10fdc9ac24c516fd424b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 134,
                        "hold": 13,
                        "slide": 4,
                        "touch": 10,
                        "break": 5,
                        "total": 166
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 207,
                        "hold": 19,
                        "slide": 7,
                        "touch": 28,
                        "break": 14,
                        "total": 275
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 91,
                        "slide": 33,
                        "touch": 39,
                        "break": 20,
                        "total": 420
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 326,
                        "hold": 13,
                        "slide": 189,
                        "touch": 57,
                        "break": 23,
                        "total": 608
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6
                    },
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "君だったから",
            "category": "POPS＆アニメ",
            "title": "君だったから",
            "artist": "中野家の五つ子",
            "bpm": 125,
            "imageName": "345c5490bec6a3f614ca6c6eded0492a317acf720f89fc86fda0a6f9c1d3c98a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 132,
                        "hold": 8,
                        "slide": 5,
                        "touch": 8,
                        "break": 4,
                        "total": 157
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 219,
                        "hold": 8,
                        "slide": 8,
                        "touch": 28,
                        "break": 4,
                        "total": 267
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 300,
                        "hold": 43,
                        "slide": 27,
                        "touch": 19,
                        "break": 25,
                        "total": 414
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 316,
                        "hold": 34,
                        "slide": 76,
                        "touch": 40,
                        "break": 67,
                        "total": 533
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8
                    },
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Overdose",
            "category": "POPS＆アニメ",
            "title": "Overdose",
            "artist": "なとり",
            "bpm": 118,
            "imageName": "50ce0572b198290311ffecdcc6556f08b4ada72d2a4df3f9884bde65f38b64c4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 84,
                        "hold": 10,
                        "slide": 3,
                        "touch": 4,
                        "break": 2,
                        "total": 103
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 181,
                        "hold": 8,
                        "slide": 4,
                        "touch": 11,
                        "break": 5,
                        "total": 209
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 12,
                        "slide": 32,
                        "touch": 12,
                        "break": 14,
                        "total": 284
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 336,
                        "hold": 23,
                        "slide": 88,
                        "touch": 6,
                        "break": 15,
                        "total": 468
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13
                    },
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Bring it on",
            "category": "POPS＆アニメ",
            "title": "Bring it on",
            "artist": "ROF-MAO",
            "bpm": 143,
            "imageName": "c9fb3cad5e5b66d617fe7bc382cc0f8c9445ed8d329c3401d52e34ad3e0751d1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 10,
                        "slide": 6,
                        "touch": 10,
                        "break": 7,
                        "total": 174
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": null
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 10,
                        "slide": 10,
                        "touch": 28,
                        "break": 6,
                        "total": 287
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": null
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 281,
                        "hold": 31,
                        "slide": 40,
                        "touch": 29,
                        "break": 56,
                        "total": 437
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": null
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 572,
                        "hold": 84,
                        "slide": 87,
                        "touch": 59,
                        "break": 22,
                        "total": 824
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4
                    },
                    "releaseDate": null
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "モニタリング",
            "category": "niconico＆ボーカロイド",
            "title": "モニタリング",
            "artist": "DECO*27",
            "bpm": 132,
            "imageName": "ea7e0de192e20fbb4a9207884a97e046c9ebace52df9697c885661c89fc36616",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 123,
                        "hold": 11,
                        "slide": 4,
                        "touch": 8,
                        "break": 7,
                        "total": 153
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": null
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 202,
                        "hold": 8,
                        "slide": 9,
                        "touch": 26,
                        "break": 3,
                        "total": 248
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": null
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 49,
                        "slide": 60,
                        "touch": 17,
                        "break": 17,
                        "total": 473
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": null
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.8,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 26,
                        "slide": 97,
                        "touch": 19,
                        "break": 11,
                        "total": 497
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 11.8,
                        "CiRCLE PLUS": 11.8
                    },
                    "releaseDate": null
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 439,
                        "hold": 43,
                        "slide": 102,
                        "touch": 31,
                        "break": 31,
                        "total": 646
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4
                    },
                    "releaseDate": null
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "テトリス",
            "category": "niconico＆ボーカロイド",
            "title": "テトリス",
            "artist": "柊マグネタイト",
            "bpm": 170,
            "imageName": "c9d69620376431713e871dc5f95ec50b6789ae3cc13477fec791b1687eb290fb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 218,
                        "hold": 7,
                        "slide": 4,
                        "touch": 9,
                        "break": 8,
                        "total": 246
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 320,
                        "hold": 19,
                        "slide": 8,
                        "touch": 24,
                        "break": 8,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 346,
                        "hold": 65,
                        "slide": 60,
                        "touch": 26,
                        "break": 64,
                        "total": 561
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 545,
                        "hold": 20,
                        "slide": 142,
                        "touch": 13,
                        "break": 21,
                        "total": 741
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12,
                        "CiRCLE PLUS": 12
                    },
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 618,
                        "hold": 38,
                        "slide": 171,
                        "touch": 55,
                        "break": 59,
                        "total": 941
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7
                    },
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": [
                "Tetoris"
            ]
        },
        {
            "songId": "有頂天ドリーマーズ",
            "category": "東方Project",
            "title": "有頂天ドリーマーズ",
            "artist": "森羅万象",
            "bpm": 188,
            "imageName": "cf0caeae364d3bd62e0671b6de6b20f740c4fdd1815122fcf998c3edcbef3950",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 13,
                        "slide": 4,
                        "touch": 7,
                        "break": 4,
                        "total": 163
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": null
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 14,
                        "slide": 7,
                        "touch": 13,
                        "break": 6,
                        "total": 302
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": null
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 56,
                        "slide": 21,
                        "touch": 17,
                        "break": 22,
                        "total": 446
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": null
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 481,
                        "hold": 37,
                        "slide": 74,
                        "touch": 18,
                        "break": 35,
                        "total": 645
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1
                    },
                    "releaseDate": null
                }
            ],
            "searchAcronyms": [
                "uchouten dreamers"
            ]
        },
        {
            "songId": "Eureka",
            "category": "ゲーム＆バラエティ",
            "title": "Eureka",
            "artist": "sasakure.UK × ArmyTom (w/z Bitplane)",
            "bpm": 150,
            "imageName": "33832437003a23ab5716fc195a83e37b9ab92ca678681efefa7850d13a4e8207",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 10,
                        "slide": 5,
                        "touch": 6,
                        "break": 4,
                        "total": 197
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 262,
                        "hold": 28,
                        "slide": 8,
                        "touch": 24,
                        "break": 6,
                        "total": 328
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 294,
                        "hold": 88,
                        "slide": 46,
                        "touch": 23,
                        "break": 24,
                        "total": 475
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "Luxizhel vs サファ太",
                    "noteCounts": {
                        "tap": 629,
                        "hold": 112,
                        "slide": 72,
                        "touch": 60,
                        "break": 34,
                        "total": 907
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1
                    },
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ニルヴの心臓",
            "category": "ゲーム＆バラエティ",
            "title": "ニルヴの心臓",
            "artist": "TJ.hangneil + Atomic Sphere feat.Annabel",
            "bpm": 256,
            "imageName": "eadb93dc8c53a902eb02e10e83c581b38407cc85e29b872089bdabffbf729468",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 8,
                        "slide": 12,
                        "touch": 9,
                        "break": 4,
                        "total": 311
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 340,
                        "hold": 15,
                        "slide": 8,
                        "touch": 28,
                        "break": 3,
                        "total": 394
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 506,
                        "hold": 97,
                        "slide": 18,
                        "touch": 43,
                        "break": 9,
                        "total": 673
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7
                    },
                    "releaseDate": "2025-09-18"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 585,
                        "hold": 111,
                        "slide": 72,
                        "touch": 33,
                        "break": 79,
                        "total": 880
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3
                    },
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": [
                "nirv",
                "the tower of nirv",
                "tower of nirv"
            ]
        },
        {
            "songId": "サイエンス",
            "category": "niconico＆ボーカロイド",
            "title": "サイエンス",
            "artist": "MIMI",
            "bpm": 188,
            "imageName": "514e56928b99bb14e29cb096e006d75982d6d4aa9e39486feaf2593a7deb03b7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 162,
                        "hold": 13,
                        "slide": 8,
                        "touch": 8,
                        "break": 4,
                        "total": 195
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": null
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 356,
                        "hold": 12,
                        "slide": 6,
                        "touch": 26,
                        "break": 4,
                        "total": 404
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": null
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 359,
                        "hold": 72,
                        "slide": 47,
                        "touch": 42,
                        "break": 12,
                        "total": 532
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": null
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 530,
                        "hold": 61,
                        "slide": 93,
                        "touch": 32,
                        "break": 34,
                        "total": 750
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13
                    },
                    "releaseDate": null
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[蛸]時空を超えて久しぶり！",
            "category": "宴会場",
            "title": "[蛸]時空を超えて久しぶり！",
            "artist": "アルル(CV 園崎未恵)「ぷよぷよ」",
            "bpm": null,
            "imageName": "c33c06b1a4364ba020541962dce358aae3036d8b865aeb40c9ec1b18e849112c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【蛸】",
                    "level": "12+?",
                    "internalLevelValue": 12.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE",
                    "comment": "つなげたりして消すぷよ（令和最新版）",
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[餡]隠密あんみつDX",
            "category": "宴会場",
            "title": "[餡]隠密あんみつDX",
            "artist": "カルロス袴田 feat. 日南めい, 古川由彩",
            "bpm": null,
            "imageName": "85590470f648d76ecb10b687903fb0f2c8d270717bd9876e15cdff5cf555a3ad",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【餡】",
                    "level": "12+?",
                    "internalLevelValue": 12.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE",
                    "comment": "いい感じに同時押しするといい感じになる！",
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[奏]のじゃロリック",
            "category": "宴会場",
            "title": "[奏]のじゃロリック",
            "artist": "なみぐる feat.ちょこ 桃寝ちのい",
            "bpm": null,
            "imageName": "65470e7943ecd88fc0f4e12171cce476c85fcdb75614944b594c7c96bc4180ad",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【奏】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE",
                    "comment": "のじゃロリックがはじまるぞ",
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[音]ラビットホール",
            "category": "宴会場",
            "title": "[音]ラビットホール",
            "artist": "DECO*27",
            "bpm": null,
            "imageName": "7e6dbae884fa635981f6ff548378aeaf6286fb1ac2efee1582fce7a0f1fadcf2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【音】",
                    "level": "13+?",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE",
                    "comment": "～音取りほぼMAXバージョン～",
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[耐]死ぬな！",
            "category": "宴会場",
            "title": "[耐]死ぬな！",
            "artist": "こっちのけんと",
            "bpm": null,
            "imageName": "89c65b1e906650b2cc902e7926098440cd6e0139ba691901deaf530073069487",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【耐】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE",
                    "comment": "命はひとつ",
                    "releaseDate": "2025-09-18"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "エンジェル ドリーム",
            "category": "ゲーム＆バラエティ",
            "title": "エンジェル ドリーム",
            "artist": "「太鼓の達人」より",
            "bpm": 180,
            "imageName": "41c17afa35c90a7717a16b30e34f7c56bb33ea882e4544047c38477eb62a30bf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 174,
                        "hold": 18,
                        "slide": 4,
                        "touch": 18,
                        "break": 4,
                        "total": 218
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 309,
                        "hold": 19,
                        "slide": 12,
                        "touch": 7,
                        "break": 8,
                        "total": 355
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 407,
                        "hold": 44,
                        "slide": 48,
                        "touch": 21,
                        "break": 19,
                        "total": 539
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 592,
                        "hold": 56,
                        "slide": 101,
                        "touch": 24,
                        "break": 61,
                        "total": 834
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.6
                    },
                    "releaseDate": "2025-09-26"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Hurtling Boys",
            "category": "ゲーム＆バラエティ",
            "title": "Hurtling Boys",
            "artist": "さだきち「太鼓の達人」より",
            "bpm": 195,
            "imageName": "0d1a286ec9890decfb0e293c4accf0ab1b38f95cf651b8aeac91259126ae94ec",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 201,
                        "hold": 9,
                        "slide": 4,
                        "touch": 10,
                        "break": 9,
                        "total": 233
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-26"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 314,
                        "hold": 12,
                        "slide": 6,
                        "touch": 24,
                        "break": 4,
                        "total": 360
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-09-26"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 376,
                        "hold": 92,
                        "slide": 79,
                        "touch": 3,
                        "break": 59,
                        "total": 609
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8
                    },
                    "releaseDate": "2025-09-26"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "鳩ホルダー",
                    "noteCounts": {
                        "tap": 694,
                        "hold": 76,
                        "slide": 92,
                        "touch": 38,
                        "break": 31,
                        "total": 931
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5
                    },
                    "releaseDate": "2025-09-26"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "しゅ～しん？変身☆ハカイシンzzZ",
            "category": "niconico＆ボーカロイド",
            "title": "しゅ～しん？変身☆ハカイシンzzZ",
            "artist": "YOFUKASHi Sound Team feat.編井うも",
            "bpm": 180,
            "imageName": "f9dbd4b8f4509aadbbf0a645840186b284fd56fed211d1b6943636a547998e01",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 180,
                        "hold": 14,
                        "slide": 4,
                        "touch": 16,
                        "break": 7,
                        "total": 221
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 26,
                        "slide": 12,
                        "touch": 18,
                        "break": 4,
                        "total": 365
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 366,
                        "hold": 87,
                        "slide": 46,
                        "touch": 38,
                        "break": 71,
                        "total": 608
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 524,
                        "hold": 56,
                        "slide": 92,
                        "touch": 105,
                        "break": 126,
                        "total": 903
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8
                    },
                    "releaseDate": "2025-10-03"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "命テステス",
            "category": "niconico＆ボーカロイド",
            "title": "命テステス",
            "artist": "ぱりぱりさらうどん",
            "bpm": 240,
            "imageName": "a27b6ce6a58a0c33c18aefa5d1053ebedf7fa38d8bede82521daad0f2303fdc0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 138,
                        "hold": 13,
                        "slide": 4,
                        "touch": 12,
                        "break": 2,
                        "total": 169
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 10,
                        "slide": 12,
                        "touch": 16,
                        "break": 2,
                        "total": 324
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 242,
                        "hold": 89,
                        "slide": 46,
                        "touch": 19,
                        "break": 17,
                        "total": 413
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 289,
                        "hold": 33,
                        "slide": 108,
                        "touch": 71,
                        "break": 8,
                        "total": 509
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6
                    },
                    "releaseDate": "2025-10-03"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "拝啓、最高の思い出たち",
            "category": "niconico＆ボーカロイド",
            "title": "拝啓、最高の思い出たち",
            "artist": "ヤレギノ",
            "bpm": 124,
            "imageName": "abc465389781c16b68adcd3bac4fedc8b3654d976d2ab84da521bb64a8bc07f3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 137,
                        "hold": 11,
                        "slide": 6,
                        "touch": 12,
                        "break": 4,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 195,
                        "hold": 10,
                        "slide": 6,
                        "touch": 26,
                        "break": 7,
                        "total": 244
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 278,
                        "hold": 46,
                        "slide": 16,
                        "touch": 18,
                        "break": 19,
                        "total": 377
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 528,
                        "hold": 48,
                        "slide": 75,
                        "touch": 38,
                        "break": 28,
                        "total": 717
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13
                    },
                    "releaseDate": "2025-10-03"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "おべんきょうたいむ",
            "category": "niconico＆ボーカロイド",
            "title": "おべんきょうたいむ",
            "artist": "litmus*",
            "bpm": 165,
            "imageName": "41da9bd03d97c80d29187ece38ed8df20cc67b4ea2800a684390e508214530d5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 211,
                        "hold": 13,
                        "slide": 7,
                        "touch": 13,
                        "break": 8,
                        "total": 252
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 312,
                        "hold": 16,
                        "slide": 6,
                        "touch": 26,
                        "break": 8,
                        "total": 368
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 410,
                        "hold": 103,
                        "slide": 56,
                        "touch": 19,
                        "break": 65,
                        "total": 653
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4
                    },
                    "releaseDate": "2025-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 626,
                        "hold": 96,
                        "slide": 127,
                        "touch": 66,
                        "break": 91,
                        "total": 1006
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1
                    },
                    "releaseDate": "2025-10-03"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "るろうらんる",
            "category": "niconico＆ボーカロイド",
            "title": "るろうらんる",
            "artist": "ちから",
            "bpm": 156,
            "imageName": "4e7586c6a57269e20e92176da21c203dafc923fc8a4598b8b830538e9ba3c0ba",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 169,
                        "hold": 13,
                        "slide": 4,
                        "touch": 7,
                        "break": 9,
                        "total": 202
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 251,
                        "hold": 8,
                        "slide": 7,
                        "touch": 26,
                        "break": 8,
                        "total": 300
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 476,
                        "hold": 49,
                        "slide": 35,
                        "touch": 16,
                        "break": 17,
                        "total": 593
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "るしえる",
                    "noteCounts": {
                        "tap": 699,
                        "hold": 114,
                        "slide": 60,
                        "touch": 45,
                        "break": 30,
                        "total": 948
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.3,
                        "CiRCLE PLUS": 14.3
                    },
                    "releaseDate": "2025-10-03"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "廃墟にいますキャンペーン",
            "category": "maimai",
            "title": "廃墟にいますキャンペーン",
            "artist": "吉田夜世 feat.ちっく。",
            "bpm": 215,
            "imageName": "73b0669cbc9f19f070567cf5c7e82a000dd1740e016389b02d450da364ed0672",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 235,
                        "hold": 18,
                        "slide": 3,
                        "touch": 8,
                        "break": 6,
                        "total": 270
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 326,
                        "hold": 19,
                        "slide": 8,
                        "touch": 46,
                        "break": 8,
                        "total": 407
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 415,
                        "hold": 51,
                        "slide": 52,
                        "touch": 35,
                        "break": 30,
                        "total": 583
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 606,
                        "hold": 53,
                        "slide": 153,
                        "touch": 34,
                        "break": 33,
                        "total": 879
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9
                    },
                    "releaseDate": "2025-10-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Customized Justice",
            "category": "maimai",
            "title": "Customized Justice",
            "artist": "Kobaryo",
            "bpm": 292,
            "imageName": "55cf02e1f0d8ec2e9ace372ec4393e7bf171409850717c57c4d9bfa253732ca3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 266,
                        "hold": 18,
                        "slide": 6,
                        "touch": 11,
                        "break": 7,
                        "total": 308
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 352,
                        "hold": 13,
                        "slide": 16,
                        "touch": 32,
                        "break": 8,
                        "total": 421
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 571,
                        "hold": 52,
                        "slide": 33,
                        "touch": 22,
                        "break": 25,
                        "total": 703
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13
                    },
                    "releaseDate": "2025-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "サファ太 vs じゃこレモン",
                    "noteCounts": {
                        "tap": 758,
                        "hold": 93,
                        "slide": 62,
                        "touch": 71,
                        "break": 92,
                        "total": 1076
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8
                    },
                    "releaseDate": "2025-10-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "はじまりの未来",
            "category": "niconico＆ボーカロイド",
            "title": "はじまりの未来",
            "artist": "40mP × sasakure.UK / 初音ミク「劇場版プロジェクトセカイ　壊れたセカイと歌えないミク」",
            "bpm": 156,
            "imageName": "2fa76cbe8ff01b6ef36592a8832d959bfcd5785e9865ce13b0375bfcfbb227bb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 102,
                        "hold": 17,
                        "slide": 5,
                        "touch": 7,
                        "break": 3,
                        "total": 134
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 224,
                        "hold": 18,
                        "slide": 8,
                        "touch": 26,
                        "break": 4,
                        "total": 280
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 332,
                        "hold": 39,
                        "slide": 27,
                        "touch": 8,
                        "break": 27,
                        "total": 433
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 50,
                        "slide": 62,
                        "touch": 121,
                        "break": 55,
                        "total": 623
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13
                    },
                    "releaseDate": "2025-10-16"
                }
            ],
            "searchAcronyms": [
                "hajimari no mirai"
            ]
        },
        {
            "songId": "Worlders",
            "category": "niconico＆ボーカロイド",
            "title": "Worlders",
            "artist": "じん / バーチャル・シンガー、Leo/need、MORE MORE JUMP！、Vivid BAD SQUAD、ワンダーランズ×ショウタイム、25時、ナイトコードで。「劇場版プロジェクトセカイ　壊れたセカイと歌えないミク」",
            "bpm": 137,
            "imageName": "fb8006c007625f79cd07f74b31891b1405113a47dd3f3875f39e7b2c75ab7c67",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 106,
                        "hold": 9,
                        "slide": 4,
                        "touch": 17,
                        "break": 4,
                        "total": 140
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 181,
                        "hold": 16,
                        "slide": 6,
                        "touch": 32,
                        "break": 5,
                        "total": 240
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 285,
                        "hold": 34,
                        "slide": 35,
                        "touch": 5,
                        "break": 25,
                        "total": 384
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 382,
                        "hold": 17,
                        "slide": 74,
                        "touch": 3,
                        "break": 56,
                        "total": 532
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8
                    },
                    "releaseDate": "2025-10-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[藍]絶え間なく藍色",
            "category": "宴会場",
            "title": "[藍]絶え間なく藍色",
            "artist": "獅子志司",
            "bpm": null,
            "imageName": "a373ff59ac6cbfe60f50f37ecb90d2b60adc90b8c6c3036f90ff888fde5fb369",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【藍】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE",
                    "comment": "絶え間なく青色",
                    "releaseDate": "2025-10-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[音]snooze",
            "category": "宴会場",
            "title": "[音]snooze",
            "artist": "wotaku feat.SHIKI",
            "bpm": null,
            "imageName": "ae06cf858b1c770a0879bcad10c2c94f07c4f22a7d5b09807f7c6312a50d101e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【音】",
                    "level": "13+?",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE",
                    "comment": "～音取りほぼMAXバージョン～",
                    "releaseDate": "2025-10-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "False Amber (from the Black Bazaar, Or by A Kervan Trader from the Lands Afar, Or Buried Beneath the Shifting Sands That Lead Everywhere but Nowhere)",
            "category": "maimai",
            "title": "False Amber (from the Black Bazaar, Or by A Kervan Trader from the Lands Afar, Or Buried Beneath the Shifting Sands That Lead Everywhere but Nowhere)",
            "artist": "かめりあ",
            "bpm": 132,
            "imageName": "1ead33086c0eff4af90de97530951984666c5224a91c0289857b982dc24a0e49",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 180,
                        "hold": 16,
                        "slide": 10,
                        "touch": 6,
                        "break": 3,
                        "total": 215
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "PRiSM PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 392,
                        "hold": 12,
                        "slide": 10,
                        "touch": 12,
                        "break": 2,
                        "total": 428
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "PRiSM PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 655,
                        "hold": 70,
                        "slide": 22,
                        "touch": 34,
                        "break": 27,
                        "total": 808
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "PRiSM PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2
                    },
                    "releaseDate": "2025-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.8,
                    "noteDesigner": "Safari",
                    "noteCounts": {
                        "tap": 823,
                        "hold": 72,
                        "slide": 37,
                        "touch": 110,
                        "break": 150,
                        "total": 1192
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "PRiSM PLUS"
                        }
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.8,
                        "CiRCLE PLUS": 14.8
                    },
                    "releaseDate": "2025-10-30"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ヒアソビ",
            "category": "niconico＆ボーカロイド",
            "title": "ヒアソビ",
            "artist": "かめりあ",
            "bpm": 134,
            "imageName": "47f1e7f5a4eb2f52d0c721c4b7167a08e2e6be1a68573580025da41ea0e51986",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 10,
                        "slide": 5,
                        "touch": 23,
                        "break": 4,
                        "total": 218
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 273,
                        "hold": 14,
                        "slide": 8,
                        "touch": 24,
                        "break": 5,
                        "total": 324
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 332,
                        "hold": 101,
                        "slide": 35,
                        "touch": 26,
                        "break": 25,
                        "total": 519
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-10-30"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 605,
                        "hold": 85,
                        "slide": 99,
                        "touch": 29,
                        "break": 106,
                        "total": 924
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7
                    },
                    "releaseDate": "2025-10-30"
                }
            ],
            "searchAcronyms": [
                "Hiasobi",
                "Play With Fire"
            ]
        },
        {
            "songId": "真空都市",
            "category": "maimai",
            "title": "真空都市",
            "artist": "ナナツカゼ",
            "bpm": 185,
            "imageName": "383fcfe5a2d387135f685d2023294fb7eee5db810a32f58329919f3ea8700409",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 223,
                        "hold": 12,
                        "slide": 5,
                        "touch": 7,
                        "break": 3,
                        "total": 250
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 335,
                        "hold": 16,
                        "slide": 11,
                        "touch": 48,
                        "break": 7,
                        "total": 417
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 392,
                        "hold": 77,
                        "slide": 35,
                        "touch": 36,
                        "break": 14,
                        "total": 554
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 592,
                        "hold": 27,
                        "slide": 66,
                        "touch": 38,
                        "break": 29,
                        "total": 752
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4
                    },
                    "releaseDate": "2025-11-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Eternal Return",
            "category": "maimai",
            "title": "Eternal Return",
            "artist": "Tatsunoshin & Aira Arere",
            "bpm": 180,
            "imageName": "ec13b44bc2babef86c8764a6cf9c772b7ccc273cd8b331bd42ebfc4356aef808",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 17,
                        "slide": 4,
                        "touch": 6,
                        "break": 6,
                        "total": 230
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 289,
                        "hold": 16,
                        "slide": 12,
                        "touch": 24,
                        "break": 4,
                        "total": 345
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 363,
                        "hold": 103,
                        "slide": 43,
                        "touch": 44,
                        "break": 8,
                        "total": 561
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 624,
                        "hold": 56,
                        "slide": 112,
                        "touch": 77,
                        "break": 28,
                        "total": 897
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8
                    },
                    "releaseDate": "2025-11-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ぱぱぱらビーチ",
            "category": "maimai",
            "title": "ぱぱぱらビーチ",
            "artist": "ぱぱぱらビーチ",
            "bpm": 160,
            "imageName": "0ce5d5a84b6a42e9264fdb39192a8a93102004a95acfeb203fc1b9d37163c6b0",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 205,
                        "hold": 10,
                        "slide": 4,
                        "touch": 11,
                        "break": 5,
                        "total": 235
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 14,
                        "slide": 8,
                        "touch": 11,
                        "break": 6,
                        "total": 350
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 394,
                        "hold": 37,
                        "slide": 62,
                        "touch": 11,
                        "break": 49,
                        "total": 553
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 626,
                        "hold": 21,
                        "slide": 87,
                        "touch": 41,
                        "break": 56,
                        "total": 831
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6
                    },
                    "releaseDate": "2025-11-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Get U ♭ack",
            "category": "maimai",
            "title": "Get U ♭ack",
            "artist": "Ryo Fukuda",
            "bpm": 205,
            "imageName": "58089e92c4abfc669ecdcde85bb1fb23f1471016fd96ff0130e1f87357c99ec4",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 198,
                        "hold": 13,
                        "slide": 8,
                        "touch": 16,
                        "break": 10,
                        "total": 245
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-07"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 339,
                        "hold": 11,
                        "slide": 6,
                        "touch": 30,
                        "break": 6,
                        "total": 392
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-07"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "きょむりん",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 60,
                        "slide": 56,
                        "touch": 15,
                        "break": 55,
                        "total": 588
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9
                    },
                    "releaseDate": "2025-11-07"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 693,
                        "hold": 74,
                        "slide": 83,
                        "touch": 62,
                        "break": 87,
                        "total": 999
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "level": "14",
                            "levelValue": 14
                        }
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.6
                    },
                    "releaseDate": "2025-11-07"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "電光刹歌",
            "category": "niconico＆ボーカロイド",
            "title": "電光刹歌",
            "artist": "かめりあ",
            "bpm": 207,
            "imageName": "912549a9b627974e41863249dab38011de5afbdd1bd70cd649f59fe17e8bfdec",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 174,
                        "hold": 15,
                        "slide": 10,
                        "touch": 6,
                        "break": 2,
                        "total": 207
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 317,
                        "hold": 19,
                        "slide": 8,
                        "touch": 12,
                        "break": 5,
                        "total": 361
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 451,
                        "hold": 48,
                        "slide": 26,
                        "touch": 35,
                        "break": 47,
                        "total": 607
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 602,
                        "hold": 16,
                        "slide": 132,
                        "touch": 25,
                        "break": 53,
                        "total": 828
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8
                    },
                    "releaseDate": "2025-11-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ウィーアーピコピコハンマーズ!!!!",
            "category": "niconico＆ボーカロイド",
            "title": "ウィーアーピコピコハンマーズ!!!!",
            "artist": "cosMo＠暴走P",
            "bpm": 202,
            "imageName": "0b176ef055a3418dbf47c75f6aed9796cb91c5324b6dd473b4ff545251c3ac50",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 14,
                        "slide": 6,
                        "touch": 8,
                        "break": 12,
                        "total": 271
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 368,
                        "hold": 21,
                        "slide": 4,
                        "touch": 25,
                        "break": 11,
                        "total": 429
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 444,
                        "hold": 34,
                        "slide": 24,
                        "touch": 34,
                        "break": 44,
                        "total": 580
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 692,
                        "hold": 76,
                        "slide": 119,
                        "touch": 22,
                        "break": 129,
                        "total": 1038
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9
                    },
                    "releaseDate": "2025-11-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ジェットブラック",
            "category": "niconico＆ボーカロイド",
            "title": "ジェットブラック",
            "artist": "雄之助",
            "bpm": 170,
            "imageName": "3cd4ae51b9ef370c7fa990d51953b431c4b7d2875a798152dd93f5e05e476cb5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 180,
                        "hold": 12,
                        "slide": 10,
                        "touch": 6,
                        "break": 4,
                        "total": 212
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 323,
                        "hold": 18,
                        "slide": 6,
                        "touch": 26,
                        "break": 6,
                        "total": 379
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 417,
                        "hold": 56,
                        "slide": 40,
                        "touch": 21,
                        "break": 7,
                        "total": 541
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 548,
                        "hold": 65,
                        "slide": 113,
                        "touch": 30,
                        "break": 52,
                        "total": 808
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2
                    },
                    "releaseDate": "2025-11-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "トレジャーガーデン",
            "category": "niconico＆ボーカロイド",
            "title": "トレジャーガーデン",
            "artist": "Ponchi♪",
            "bpm": 268,
            "imageName": "16b803eb28f734d1492ec9ca807b280c5b0a03bb0b37a93d5f731699e2e01255",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 237,
                        "hold": 18,
                        "slide": 7,
                        "touch": 13,
                        "break": 6,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 373,
                        "hold": 29,
                        "slide": 8,
                        "touch": 26,
                        "break": 8,
                        "total": 444
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 434,
                        "hold": 52,
                        "slide": 42,
                        "touch": 30,
                        "break": 34,
                        "total": 592
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 697,
                        "hold": 80,
                        "slide": 113,
                        "touch": 53,
                        "break": 108,
                        "total": 1051
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8
                    },
                    "releaseDate": "2025-11-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "最愛人生ランナー",
            "category": "niconico＆ボーカロイド",
            "title": "最愛人生ランナー",
            "artist": "かいりきベア",
            "bpm": 180,
            "imageName": "8f850f13e23678e08f5e0d4011f25bce8094bb5968c4749bac8756404036b518",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 216,
                        "hold": 22,
                        "slide": 5,
                        "touch": 8,
                        "break": 7,
                        "total": 258
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 338,
                        "hold": 26,
                        "slide": 8,
                        "touch": 22,
                        "break": 8,
                        "total": 402
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 496,
                        "hold": 99,
                        "slide": 62,
                        "touch": 9,
                        "break": 70,
                        "total": 736
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-11-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 735,
                        "hold": 61,
                        "slide": 151,
                        "touch": 44,
                        "break": 63,
                        "total": 1054
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.8
                    },
                    "releaseDate": "2025-11-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "僕は空気が嫁ない",
            "category": "niconico＆ボーカロイド",
            "title": "僕は空気が嫁ない",
            "artist": "cosMo＠暴走P",
            "bpm": 192,
            "imageName": "8512a4150d41345bac054dcf79da26bcf010ef73bd5f09a52ced1820f28eaafb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 70,
                        "hold": 3,
                        "slide": 2,
                        "touch": 12,
                        "break": 2,
                        "total": 89
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11327,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 238,
                        "hold": 20,
                        "slide": 15,
                        "touch": 15,
                        "break": 3,
                        "total": 291
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11327,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 307,
                        "hold": 53,
                        "slide": 23,
                        "touch": 19,
                        "break": 31,
                        "total": 433
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11327,
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 516,
                        "hold": 33,
                        "slide": 140,
                        "touch": 29,
                        "break": 1,
                        "total": 719
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "UNiVERSE",
                    "internalId": 11327,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13.2,
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2,
                        "FESTiVAL": 13.2,
                        "FESTiVAL PLUS": 13.2,
                        "PRiSM PLUS": 13.2,
                        "UNiVERSE": 13.2,
                        "UNiVERSE PLUS": 13.2
                    },
                    "releaseDate": "2021-09-16"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 144,
                        "hold": 10,
                        "slide": 4,
                        "touch": null,
                        "break": 3,
                        "total": 161
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 272,
                        "hold": 15,
                        "slide": 8,
                        "touch": null,
                        "break": 5,
                        "total": 300
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 374,
                        "hold": 52,
                        "slide": 46,
                        "touch": null,
                        "break": 10,
                        "total": 482
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-04"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 581,
                        "hold": 19,
                        "slide": 135,
                        "touch": null,
                        "break": 35,
                        "total": 770
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.5
                    },
                    "releaseDate": "2025-12-04"
                }
            ],
            "searchAcronyms": [
                "1绝赞",
                "ky宣言",
                "一个绝赞",
                "我不会察言观色",
                "我不嫁给空气",
                "空气",
                "空气嫁",
                "绝赞落"
            ]
        },
        {
            "songId": "ラストピースに祝福と栄光を",
            "category": "オンゲキ＆CHUNITHM",
            "title": "ラストピースに祝福と栄光を",
            "artist": "cosMo＠暴走P",
            "bpm": 280,
            "imageName": "d39c7d636539e2489565a7f18b3eb7c985ef56fea9045017e1256eed1bbce28f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 312,
                        "hold": 8,
                        "slide": 6,
                        "touch": 28,
                        "break": 9,
                        "total": 363
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 426,
                        "hold": 25,
                        "slide": 13,
                        "touch": 40,
                        "break": 20,
                        "total": 524
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 539,
                        "hold": 80,
                        "slide": 53,
                        "touch": 55,
                        "break": 44,
                        "total": 771
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9
                    },
                    "releaseDate": "2025-12-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "せめんともり",
                    "noteCounts": {
                        "tap": 960,
                        "hold": 43,
                        "slide": 118,
                        "touch": 179,
                        "break": 99,
                        "total": 1399
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6
                    },
                    "releaseDate": "2025-12-05"
                }
            ],
            "searchAcronyms": [
                "Last Piece"
            ]
        },
        {
            "songId": "初音ミクの暴走",
            "category": "niconico＆ボーカロイド",
            "title": "初音ミクの暴走",
            "artist": "cosMo＠暴走P",
            "bpm": 310,
            "imageName": "974a80aaf1edd76b49ec3e5ab208ae9fd19fa6d6b6276062b938c9d23c2923ba",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 280,
                        "hold": 12,
                        "slide": 4,
                        "touch": 9,
                        "break": 7,
                        "total": 312
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 339,
                        "hold": 14,
                        "slide": 10,
                        "touch": 38,
                        "break": 7,
                        "total": 408
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 678,
                        "hold": 39,
                        "slide": 52,
                        "touch": 20,
                        "break": 27,
                        "total": 816
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.7,
                        "CiRCLE PLUS": 12.7
                    },
                    "releaseDate": "2025-12-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 671,
                        "hold": 159,
                        "slide": 75,
                        "touch": 65,
                        "break": 121,
                        "total": 1091
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9
                    },
                    "releaseDate": "2025-12-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Let's ミクササイズ！！",
            "category": "niconico＆ボーカロイド",
            "title": "Let's ミクササイズ！！",
            "artist": "cosMo＠暴走P「Fit Boxing feat. 初音ミク -ミクといっしょにエクササイズ-」",
            "bpm": 239,
            "imageName": "ce882a1f0f7daf69ed69377b0e831459afa9ca46a810871076355efccf0efc04",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 244,
                        "hold": 17,
                        "slide": 8,
                        "touch": 14,
                        "break": 4,
                        "total": 287
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 372,
                        "hold": 16,
                        "slide": 13,
                        "touch": 27,
                        "break": 10,
                        "total": 438
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 657,
                        "hold": 70,
                        "slide": 27,
                        "touch": 19,
                        "break": 97,
                        "total": 870
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4
                    },
                    "releaseDate": "2025-12-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 817,
                        "hold": 69,
                        "slide": 142,
                        "touch": 21,
                        "break": 62,
                        "total": 1111
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8
                    },
                    "releaseDate": "2025-12-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ミクマリ",
            "category": "maimai",
            "title": "ミクマリ",
            "artist": "テヅカ",
            "bpm": 174,
            "imageName": "49a0f6c6bc20c9565051e90d023452c03a0ec4f517dd0cad63096b173f8792d9",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 171,
                        "hold": 11,
                        "slide": 9,
                        "touch": 8,
                        "break": 9,
                        "total": 208
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 16,
                        "slide": 12,
                        "touch": 24,
                        "break": 4,
                        "total": 371
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 74,
                        "slide": 53,
                        "touch": 31,
                        "break": 16,
                        "total": 464
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.5,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 549,
                        "hold": 59,
                        "slide": 67,
                        "touch": 73,
                        "break": 29,
                        "total": 777
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.5,
                        "CiRCLE PLUS": 13.5
                    },
                    "releaseDate": "2025-12-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "雲外蒼電 -Dreaming Voltage-",
            "category": "maimai",
            "title": "雲外蒼電 -Dreaming Voltage-",
            "artist": "adaptor vs DRIVE.",
            "bpm": 160,
            "imageName": "b1fb06f9dff35eaeb7896c98afa607cdab20050d36a78e2cb38f3dea21f767e7",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 13,
                        "slide": 5,
                        "touch": 14,
                        "break": 7,
                        "total": 223
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 275,
                        "hold": 14,
                        "slide": 9,
                        "touch": 27,
                        "break": 6,
                        "total": 331
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.2,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 392,
                        "hold": 46,
                        "slide": 56,
                        "touch": 16,
                        "break": 87,
                        "total": 597
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.2,
                        "CiRCLE PLUS": 12.2
                    },
                    "releaseDate": "2025-12-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 584,
                        "hold": 53,
                        "slide": 96,
                        "touch": 72,
                        "break": 71,
                        "total": 876
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9
                    },
                    "releaseDate": "2025-12-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "鬼女紅妖",
            "category": "maimai",
            "title": "鬼女紅妖",
            "artist": "Earliri",
            "bpm": 165,
            "imageName": "ad9737d3fd62b76ebdae69b93e3ce6bc5798c3562d98abb6eafd409f62410b0b",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 209,
                        "hold": 13,
                        "slide": 4,
                        "touch": 9,
                        "break": 6,
                        "total": 241
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 14,
                        "slide": 12,
                        "touch": 26,
                        "break": 4,
                        "total": 338
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 378,
                        "hold": 95,
                        "slide": 33,
                        "touch": 9,
                        "break": 16,
                        "total": 531
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 690,
                        "hold": 53,
                        "slide": 73,
                        "touch": 15,
                        "break": 103,
                        "total": 934
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1
                    },
                    "releaseDate": "2025-12-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "華天月兎",
            "category": "maimai",
            "title": "華天月兎",
            "artist": "satella feat.Risa Yuzuki",
            "bpm": 184,
            "imageName": "b59a36fc60cb860b193bffd6a3f6d9de3ca7db8d10ed463a75a36a92c568c0ee",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 193,
                        "hold": 10,
                        "slide": 9,
                        "touch": 27,
                        "break": 10,
                        "total": 249
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-12"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 320,
                        "hold": 10,
                        "slide": 13,
                        "touch": 41,
                        "break": 6,
                        "total": 390
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-12"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.5,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 366,
                        "hold": 35,
                        "slide": 54,
                        "touch": 78,
                        "break": 14,
                        "total": 547
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.5,
                        "CiRCLE PLUS": 12.5
                    },
                    "releaseDate": "2025-12-12"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 593,
                        "hold": 55,
                        "slide": 100,
                        "touch": 126,
                        "break": 14,
                        "total": 888
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.4,
                        "CiRCLE PLUS": 14.4
                    },
                    "releaseDate": "2025-12-12"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "スノーマン (Rerec)",
            "category": "niconico＆ボーカロイド",
            "title": "スノーマン (Rerec)",
            "artist": "halyosy",
            "bpm": 127,
            "imageName": "af350450b1d30c36e70ffc324a7f36da8cac5e5a2c2e81087688e92a55b1c3ec",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 144,
                        "hold": 10,
                        "slide": 4,
                        "touch": 8,
                        "break": 10,
                        "total": 176
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 18,
                        "slide": 7,
                        "touch": 30,
                        "break": 10,
                        "total": 265
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 353,
                        "hold": 59,
                        "slide": 24,
                        "touch": 17,
                        "break": 27,
                        "total": 480
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 503,
                        "hold": 86,
                        "slide": 69,
                        "touch": 36,
                        "break": 31,
                        "total": 725
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.1,
                        "CiRCLE PLUS": 13.1
                    },
                    "releaseDate": "2025-12-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "JINGLE DEATH",
            "category": "ゲーム＆バラエティ",
            "title": "JINGLE DEATH",
            "artist": "DJ Myosuke & Gram",
            "bpm": 222,
            "imageName": "5ce83f4f6d8d73983036fd9e40cacd44c31815bdd19b6c05de03d8e767aef6c3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 12,
                        "slide": 8,
                        "touch": 12,
                        "break": 4,
                        "total": 208
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 372,
                        "hold": 18,
                        "slide": 7,
                        "touch": 13,
                        "break": 8,
                        "total": 418
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 402,
                        "hold": 52,
                        "slide": 47,
                        "touch": 21,
                        "break": 26,
                        "total": 548
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.4,
                        "CiRCLE PLUS": 12.4
                    },
                    "releaseDate": "2025-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 563,
                        "hold": 46,
                        "slide": 103,
                        "touch": 92,
                        "break": 55,
                        "total": 859
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.1,
                        "CiRCLE PLUS": 14.1
                    },
                    "releaseDate": "2025-12-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ヤミナベ!!!!",
            "category": "niconico＆ボーカロイド",
            "title": "ヤミナベ!!!!",
            "artist": "cosMo＠暴走P",
            "bpm": 264,
            "imageName": "881a04259aeff8e0d6efcbfd50e75eee365140a225f2bc22d306258fe16986f5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 253,
                        "hold": 15,
                        "slide": 4,
                        "touch": 13,
                        "break": 14,
                        "total": 299
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 322,
                        "hold": 10,
                        "slide": 12,
                        "touch": 20,
                        "break": 8,
                        "total": 372
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2025-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 542,
                        "hold": 39,
                        "slide": 36,
                        "touch": 25,
                        "break": 10,
                        "total": 652
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 12.6
                    },
                    "releaseDate": "2025-12-24"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 661,
                        "hold": 121,
                        "slide": 80,
                        "touch": 44,
                        "break": 100,
                        "total": 1006
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.5,
                        "CiRCLE PLUS": 14.5
                    },
                    "releaseDate": "2025-12-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[一]もうみんなしねばいいのに",
            "category": "宴会場",
            "title": "[一]もうみんなしねばいいのに",
            "artist": "谷屋楽",
            "bpm": null,
            "imageName": "d4bfa83449c0580240e3bc4bd59b7c31b086a4665d4171dc005b98200c822fa8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【一】",
                    "level": "14+?",
                    "internalLevelValue": 14.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE",
                    "comment": "どいつもこいつもリア充しやがって！",
                    "releaseDate": "2025-12-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[充]エンジェル ドリーム",
            "category": "宴会場",
            "title": "[充]エンジェル ドリーム",
            "artist": "「太鼓の達人」より",
            "bpm": null,
            "imageName": "41c17afa35c90a7717a16b30e34f7c56bb33ea882e4544047c38477eb62a30bf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【充】",
                    "level": "11?",
                    "internalLevelValue": 11,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE",
                    "comment": "目と目を合わせて舞を分け合おう",
                    "releaseDate": "2025-12-24"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "み　む　かｩ　わ　ナ　イ　ス　ト　ラ　イ",
            "category": "niconico＆ボーカロイド",
            "title": "み　む　かｩ　わ　ナ　イ　ス　ト　ラ　イ",
            "artist": "ぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬぬ",
            "bpm": 126,
            "imageName": "9ed4cf307b6b51287ea3e8f2f1a39611a099b02e568612358ff5b8e83b7ab67f",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 6,
                        "slide": 4,
                        "touch": 19,
                        "break": 20,
                        "total": 184
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 264,
                        "hold": 16,
                        "slide": 10,
                        "touch": 18,
                        "break": 22,
                        "total": 330
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 340,
                        "hold": 96,
                        "slide": 25,
                        "touch": 31,
                        "break": 115,
                        "total": 607
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 414,
                        "hold": 127,
                        "slide": 86,
                        "touch": 178,
                        "break": 123,
                        "total": 928
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7
                    },
                    "releaseDate": "2026-01-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "化けの花",
            "category": "niconico＆ボーカロイド",
            "title": "化けの花",
            "artist": "なきそ",
            "bpm": 180,
            "imageName": "806f1365a1545d43dea49cc0b71f71f152f1ab2178a0e14ddb45b916bb9733a8",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 11,
                        "slide": 4,
                        "touch": 19,
                        "break": 4,
                        "total": 173
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 235,
                        "hold": 15,
                        "slide": 10,
                        "touch": 25,
                        "break": 3,
                        "total": 288
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 349,
                        "hold": 38,
                        "slide": 52,
                        "touch": 30,
                        "break": 16,
                        "total": 485
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 484,
                        "hold": 59,
                        "slide": 87,
                        "touch": 64,
                        "break": 48,
                        "total": 742
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.4,
                        "CiRCLE PLUS": 13.4
                    },
                    "releaseDate": "2026-01-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "うい麦畑でつかまえて",
            "category": "POPS＆アニメ",
            "title": "うい麦畑でつかまえて",
            "artist": "しぐれうい",
            "bpm": 168,
            "imageName": "315c2f4ef69b30f79f3e94276eea18f4f9dcb600bf1918a4c8d623a6d3069889",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 187,
                        "hold": 19,
                        "slide": 5,
                        "touch": 8,
                        "break": 5,
                        "total": 224
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 309,
                        "hold": 16,
                        "slide": 11,
                        "touch": 26,
                        "break": 15,
                        "total": 377
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "おそろっちーぬ",
                    "noteCounts": {
                        "tap": 398,
                        "hold": 46,
                        "slide": 52,
                        "touch": 22,
                        "break": 84,
                        "total": 602
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 653,
                        "hold": 56,
                        "slide": 127,
                        "touch": 59,
                        "break": 74,
                        "total": 969
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2
                    },
                    "releaseDate": "2026-01-09"
                }
            ],
            "searchAcronyms": [
                "Ui mugibatake de tsukamaete"
            ]
        },
        {
            "songId": "勝手に生きましょ",
            "category": "POPS＆アニメ",
            "title": "勝手に生きましょ",
            "artist": "しぐれうい",
            "bpm": 176,
            "imageName": "8f646c2dae16dfa1f2ce797ccafce3b0d151b4ce0293dc874e66aedf61a6f7bc",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 179,
                        "hold": 22,
                        "slide": 5,
                        "touch": 10,
                        "break": 6,
                        "total": 222
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 333,
                        "hold": 20,
                        "slide": 15,
                        "touch": 28,
                        "break": 5,
                        "total": 401
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 342,
                        "hold": 68,
                        "slide": 38,
                        "touch": 40,
                        "break": 30,
                        "total": 518
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 545,
                        "hold": 42,
                        "slide": 86,
                        "touch": 58,
                        "break": 18,
                        "total": 749
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13
                    },
                    "releaseDate": "2026-01-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "アイアイ傘",
            "category": "niconico＆ボーカロイド",
            "title": "アイアイ傘",
            "artist": "ハム feat. 雨衣",
            "bpm": 116,
            "imageName": "7f1e94161551e3863a590428813241950678cf838e9aac8be0fa6005d0fc8967",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 135,
                        "hold": 9,
                        "slide": 4,
                        "touch": 5,
                        "break": 5,
                        "total": 158
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-09"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 230,
                        "hold": 8,
                        "slide": 7,
                        "touch": 13,
                        "break": 11,
                        "total": 269
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-09"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 296,
                        "hold": 50,
                        "slide": 26,
                        "touch": 23,
                        "break": 22,
                        "total": 417
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-09"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "きょむりん & はっぴー",
                    "noteCounts": {
                        "tap": 373,
                        "hold": 12,
                        "slide": 173,
                        "touch": 15,
                        "break": 14,
                        "total": 587
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9
                    },
                    "releaseDate": "2026-01-09"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "INTJINTPENTJENTPINFJENFJINFPENFPISTJISFJESTJESFJESTPISTPISFPESFP",
            "category": "POPS＆アニメ",
            "title": "INTJINTPENTJENTPINFJENFJINFPENFPISTJISFJESTJESFJESTPISTPISFPESFP",
            "artist": "3markets[ ]",
            "bpm": 150,
            "imageName": "f13031c7d0390a23079c0b0344a272caa9dbb965d74a4d7edddcc9ae9bfee985",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 185,
                        "hold": 13,
                        "slide": 6,
                        "touch": 11,
                        "break": 5,
                        "total": 220
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-16"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 302,
                        "hold": 20,
                        "slide": 9,
                        "touch": 26,
                        "break": 8,
                        "total": 365
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-16"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 334,
                        "hold": 94,
                        "slide": 41,
                        "touch": 6,
                        "break": 21,
                        "total": 496
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-16"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー(INFP)",
                    "noteCounts": {
                        "tap": 659,
                        "hold": 61,
                        "slide": 176,
                        "touch": 4,
                        "break": 26,
                        "total": 926
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3
                    },
                    "releaseDate": "2026-01-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[鏡]MIRROR of MAGIC",
            "category": "宴会場",
            "title": "[鏡]MIRROR of MAGIC",
            "artist": "Shoichiro Hirata feat.SUIMI",
            "bpm": null,
            "imageName": "0500229a1fba056cab4d4a872b4ac8f734812e3ebc2b3c5a978c9502dff579d6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【鏡】",
                    "level": "12?",
                    "internalLevelValue": 12,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE",
                    "comment": "MIRROR of ADVANCED(↻)",
                    "releaseDate": "2026-01-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[邪]アマノジャクリバース feat. ｙｔｒ",
            "category": "宴会場",
            "title": "[邪]アマノジャクリバース feat. ｙｔｒ",
            "artist": "魂音泉",
            "bpm": null,
            "imageName": "45df78b7be097196fb6dbb1c1d44b0af8ef95b2c029efd63df27ac1dafc82018",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【邪】",
                    "level": "13+?",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE",
                    "comment": "ぜたっ作を面譜なルワジイ",
                    "releaseDate": "2026-01-16"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Paranoia",
            "category": "東方Project",
            "title": "Paranoia",
            "artist": "DiGiTAL WiNG feat. 花たん",
            "bpm": 150,
            "imageName": "13ee9951f5fe8c7a02dbaa81b853396515bc7a51aec675123cd0e09f58c3eca9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 175,
                        "hold": 6,
                        "slide": 2,
                        "touch": 14,
                        "break": 14,
                        "total": 211
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11200,
                    "multiverInternalLevelValue": {
                        "Splash": 4
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 254,
                        "hold": 26,
                        "slide": 12,
                        "touch": 25,
                        "break": 12,
                        "total": 329
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11200,
                    "multiverInternalLevelValue": {
                        "Splash": 7
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 337,
                        "hold": 38,
                        "slide": 46,
                        "touch": 33,
                        "break": 27,
                        "total": 481
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11200,
                    "multiverInternalLevelValue": {
                        "Splash": 9.5
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "某S氏",
                    "noteCounts": {
                        "tap": 554,
                        "hold": 42,
                        "slide": 88,
                        "touch": 54,
                        "break": 30,
                        "total": 768
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "Splash",
                    "internalId": 11200,
                    "multiverInternalLevelValue": {
                        "BUDDiES": 13,
                        "CiRCLE": 13,
                        "CiRCLE PLUS": 13,
                        "PRiSM PLUS": 13,
                        "Splash": 12.7,
                        "Splash PLUS": 12.7,
                        "UNiVERSE": 12.7
                    },
                    "releaseDate": "2020-09-17"
                },
                {
                    "type": "std",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 12,
                        "slide": 4,
                        "touch": null,
                        "break": 13,
                        "total": 170
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-22"
                },
                {
                    "type": "std",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 246,
                        "hold": 18,
                        "slide": 6,
                        "touch": null,
                        "break": 14,
                        "total": 284
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-22"
                },
                {
                    "type": "std",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 331,
                        "hold": 59,
                        "slide": 22,
                        "touch": null,
                        "break": 35,
                        "total": 447
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-22"
                },
                {
                    "type": "std",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 579,
                        "hold": 33,
                        "slide": 118,
                        "touch": null,
                        "break": 88,
                        "total": 818
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.6
                    },
                    "releaseDate": "2026-01-22"
                }
            ],
            "searchAcronyms": [
                "妄想症",
                "金色灵梦"
            ]
        },
        {
            "songId": "Restricted Access",
            "category": "ゲーム＆バラエティ",
            "title": "Restricted Access",
            "artist": "Knighthood",
            "bpm": 185,
            "imageName": "6bfff68d914008f6169de274c17616ef9ff2a85adfc8c81c125efb4a9912bbb3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 172,
                        "hold": 15,
                        "slide": 4,
                        "touch": 20,
                        "break": 6,
                        "total": 217
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 312,
                        "hold": 13,
                        "slide": 11,
                        "touch": 45,
                        "break": 8,
                        "total": 389
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 309,
                        "hold": 58,
                        "slide": 38,
                        "touch": 72,
                        "break": 58,
                        "total": 535
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 556,
                        "hold": 68,
                        "slide": 98,
                        "touch": 165,
                        "break": 33,
                        "total": 920
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8
                    },
                    "releaseDate": "2026-01-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "胡蝶乃舞",
            "category": "ゲーム＆バラエティ",
            "title": "胡蝶乃舞",
            "artist": "Srav3R",
            "bpm": 180,
            "imageName": "a396d313f20b4a7209a13e0198c4635f09980840ee577970d1bef8223ae3491c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 177,
                        "hold": 10,
                        "slide": 4,
                        "touch": 8,
                        "break": 7,
                        "total": 206
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 266,
                        "hold": 17,
                        "slide": 6,
                        "touch": 23,
                        "break": 6,
                        "total": 318
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 65,
                        "slide": 61,
                        "touch": 17,
                        "break": 38,
                        "total": 526
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 632,
                        "hold": 45,
                        "slide": 97,
                        "touch": 20,
                        "break": 38,
                        "total": 832
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.9,
                        "CiRCLE PLUS": 13.9
                    },
                    "releaseDate": "2026-01-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "零號車輛",
            "category": "ゲーム＆バラエティ",
            "title": "零號車輛",
            "artist": "seatrus",
            "bpm": 240,
            "imageName": "395fbb6716c46636e562d9b9ef00841c39b14658c8e3dbd087a96febf731fcba",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 15,
                        "slide": 8,
                        "touch": 7,
                        "break": 10,
                        "total": 303
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 354,
                        "hold": 17,
                        "slide": 13,
                        "touch": 16,
                        "break": 10,
                        "total": 410
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 460,
                        "hold": 63,
                        "slide": 34,
                        "touch": 38,
                        "break": 61,
                        "total": 656
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8
                    },
                    "releaseDate": "2026-01-23"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 836,
                        "hold": 83,
                        "slide": 92,
                        "touch": 72,
                        "break": 60,
                        "total": 1143
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": true
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.6,
                        "CiRCLE PLUS": 14.6
                    },
                    "releaseDate": "2026-01-23"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "スローグロー",
            "category": "maimai",
            "title": "スローグロー",
            "artist": "nayuta",
            "bpm": 180,
            "imageName": "3457faca05095949f17a1ee55033a9e0cac004eecd22601ec17b493ebdf7e436",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 161,
                        "hold": 15,
                        "slide": 8,
                        "touch": 15,
                        "break": 4,
                        "total": 203
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 256,
                        "hold": 26,
                        "slide": 10,
                        "touch": 13,
                        "break": 8,
                        "total": 313
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 424,
                        "hold": 35,
                        "slide": 28,
                        "touch": 33,
                        "break": 17,
                        "total": 537
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 487,
                        "hold": 32,
                        "slide": 60,
                        "touch": 100,
                        "break": 31,
                        "total": 710
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3
                    },
                    "releaseDate": "2026-02-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ECHO,",
            "category": "maimai",
            "title": "ECHO,",
            "artist": "棗いつき",
            "bpm": 193,
            "imageName": "37a0076ef4629d674842b28c9cc58f4c0c679e5c98da15e9b9959fe8e4bbf1d7",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 214,
                        "hold": 12,
                        "slide": 8,
                        "touch": 9,
                        "break": 5,
                        "total": 248
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 320,
                        "hold": 20,
                        "slide": 15,
                        "touch": 15,
                        "break": 4,
                        "total": 374
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 447,
                        "hold": 56,
                        "slide": 59,
                        "touch": 2,
                        "break": 17,
                        "total": 581
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 608,
                        "hold": 27,
                        "slide": 135,
                        "touch": 24,
                        "break": 45,
                        "total": 839
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.7,
                        "CiRCLE PLUS": 13.7
                    },
                    "releaseDate": "2026-02-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Phase: Theatre",
            "category": "maimai",
            "title": "Phase: Theatre",
            "artist": "藍月なくる",
            "bpm": 195,
            "imageName": "a62918a7cc1de3acdcf8beca1028fd3158698de8b4ec0bdb8be068300d2ec051",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 181,
                        "hold": 25,
                        "slide": 7,
                        "touch": 16,
                        "break": 3,
                        "total": 232
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 351,
                        "hold": 19,
                        "slide": 11,
                        "touch": 13,
                        "break": 4,
                        "total": 398
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 400,
                        "hold": 79,
                        "slide": 57,
                        "touch": 22,
                        "break": 62,
                        "total": 620
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 681,
                        "hold": 56,
                        "slide": 112,
                        "touch": 48,
                        "break": 68,
                        "total": 965
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8
                    },
                    "releaseDate": "2026-02-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Sky Trails",
            "category": "maimai",
            "title": "Sky Trails",
            "artist": "La prière",
            "bpm": 171,
            "imageName": "62f55591b921a168db75481c1ba79af0784a3f74ca541b3aafb7ac4181d11f6f",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 234,
                        "hold": 20,
                        "slide": 10,
                        "touch": 9,
                        "break": 8,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-06"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 364,
                        "hold": 11,
                        "slide": 16,
                        "touch": 13,
                        "break": 6,
                        "total": 410
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-06"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 454,
                        "hold": 48,
                        "slide": 72,
                        "touch": 28,
                        "break": 74,
                        "total": 676
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8
                    },
                    "releaseDate": "2026-02-06"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "Luxizhel+カマボコ君+はっぴー",
                    "noteCounts": {
                        "tap": 651,
                        "hold": 65,
                        "slide": 165,
                        "touch": 150,
                        "break": 21,
                        "total": 1052
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.7,
                        "CiRCLE PLUS": 14.7
                    },
                    "releaseDate": "2026-02-06"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ラプラスショコラ",
            "category": "niconico＆ボーカロイド",
            "title": "ラプラスショコラ",
            "artist": "Kai",
            "bpm": 130,
            "imageName": "1969e08ef7d2b3e648131cd1164a6b03cc5bfb455ec3391bef1a80605725c2c9",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 130,
                        "hold": 11,
                        "slide": 6,
                        "touch": 7,
                        "break": 4,
                        "total": 158
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-13"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 211,
                        "hold": 18,
                        "slide": 8,
                        "touch": 11,
                        "break": 6,
                        "total": 254
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-13"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 37,
                        "slide": 54,
                        "touch": 16,
                        "break": 20,
                        "total": 403
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-13"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 488,
                        "hold": 42,
                        "slide": 135,
                        "touch": 9,
                        "break": 17,
                        "total": 691
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.9,
                        "CiRCLE PLUS": 12.9
                    },
                    "releaseDate": "2026-02-13"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "恋の氷結おてんば湯けむりチルノ温泉",
            "category": "東方Project",
            "title": "恋の氷結おてんば湯けむりチルノ温泉",
            "artist": "uno×夕野ヨシミ feat. miko",
            "bpm": 188,
            "imageName": "1a6396421dcb22f018e02b429382cd2e4218d22c79bce18849960c5da1117708",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 109,
                        "hold": 9,
                        "slide": 6,
                        "touch": 13,
                        "break": 3,
                        "total": 140
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 216,
                        "hold": 12,
                        "slide": 5,
                        "touch": 7,
                        "break": 2,
                        "total": 242
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 243,
                        "hold": 43,
                        "slide": 43,
                        "touch": 18,
                        "break": 18,
                        "total": 365
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 411,
                        "hold": 58,
                        "slide": 73,
                        "touch": 44,
                        "break": 34,
                        "total": 620
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3
                    },
                    "releaseDate": "2026-02-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "イタ電はやめて！ ぼくらのスカーレット・コール",
            "category": "東方Project",
            "title": "イタ電はやめて！ ぼくらのスカーレット・コール",
            "artist": "七条レタスグループ",
            "bpm": 112,
            "imageName": "457a18322173d292140207e2c4253a2d7e69976e77db27628563867d46f5de23",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "1",
                    "internalLevelValue": 1,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 92,
                        "hold": 13,
                        "slide": 4,
                        "touch": 11,
                        "break": 5,
                        "total": 125
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 184,
                        "hold": 14,
                        "slide": 6,
                        "touch": 26,
                        "break": 8,
                        "total": 238
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 217,
                        "hold": 42,
                        "slide": 37,
                        "touch": 10,
                        "break": 49,
                        "total": 355
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 297,
                        "hold": 15,
                        "slide": 54,
                        "touch": 744,
                        "break": 29,
                        "total": 1139
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8
                    },
                    "releaseDate": "2026-02-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "むしみこうにゃーのハッピッピー",
            "category": "東方Project",
            "title": "むしみこうにゃーのハッピッピー",
            "artist": "ARM×狐夢想 feat. miko×山本椛",
            "bpm": 225,
            "imageName": "83c8b17a67bb6a2b30ca8d4652e1ee9bafac942bbac09d5ecbb3500eae766492",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 139,
                        "hold": 14,
                        "slide": 4,
                        "touch": 9,
                        "break": 6,
                        "total": 172
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 17,
                        "slide": 8,
                        "touch": 11,
                        "break": 6,
                        "total": 281
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 75,
                        "slide": 16,
                        "touch": 10,
                        "break": 95,
                        "total": 511
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-02-20"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "じゃこレモン",
                    "noteCounts": {
                        "tap": 474,
                        "hold": 38,
                        "slide": 130,
                        "touch": 31,
                        "break": 56,
                        "total": 729
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.6,
                        "CiRCLE PLUS": 13.6
                    },
                    "releaseDate": "2026-02-20"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "7 Wonders",
            "category": "maimai",
            "title": "7 Wonders",
            "artist": "削除",
            "bpm": 168,
            "imageName": "2c309f067ecc26ec73586a2bbbefdc0373380c79a6c7bceaada31d588374feae",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 200,
                        "hold": 25,
                        "slide": 6,
                        "touch": 11,
                        "break": 20,
                        "total": 262
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-03-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 298,
                        "hold": 25,
                        "slide": 13,
                        "touch": 18,
                        "break": 2,
                        "total": 356
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-03-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 478,
                        "hold": 89,
                        "slide": 51,
                        "touch": 20,
                        "break": 65,
                        "total": 703
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 12.8,
                        "CiRCLE PLUS": 12.8
                    },
                    "releaseDate": "2026-03-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.9,
                    "noteDesigner": "KOP7th -FiNAL BATTLE- by 7.3GHz",
                    "noteCounts": {
                        "tap": 977,
                        "hold": 77,
                        "slide": 77,
                        "touch": 77,
                        "break": 77,
                        "total": 1285
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.9,
                        "CiRCLE PLUS": 14.9
                    },
                    "releaseDate": "2026-03-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "WakeUP MakeUP FEVER!",
            "category": "オンゲキ＆CHUNITHM",
            "title": "WakeUP MakeUP FEVER!",
            "artist": "曲：アオワイファイ／歌：オンゲキシューターズ",
            "bpm": 126,
            "imageName": "c6907b0483b2bc0c34bce2138991086ce96be427f893137ca7fe040658149177",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 136,
                        "hold": 17,
                        "slide": 2,
                        "touch": 8,
                        "break": 4,
                        "total": 167
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-03-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 236,
                        "hold": 12,
                        "slide": 10,
                        "touch": 26,
                        "break": 10,
                        "total": 294
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-03-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 363,
                        "hold": 30,
                        "slide": 40,
                        "touch": 27,
                        "break": 41,
                        "total": 501
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-03-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 549,
                        "hold": 73,
                        "slide": 96,
                        "touch": 96,
                        "break": 73,
                        "total": 887
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.3,
                        "CiRCLE PLUS": 13.3
                    },
                    "releaseDate": "2026-03-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "give it up to you",
            "category": "オンゲキ＆CHUNITHM",
            "title": "give it up to you",
            "artist": "曲：中土智博／歌：bitter flavor [桜井 春菜(CV：近藤 玲奈)、早乙女 彩華(CV：中島 唯)]",
            "bpm": 174,
            "imageName": "e602ec5e5622f586661f63509a9beb6c10bc87e242bcb2857ae7d17382be272a",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 167,
                        "hold": 9,
                        "slide": 4,
                        "touch": 6,
                        "break": 3,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-03-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 248,
                        "hold": 12,
                        "slide": 6,
                        "touch": 24,
                        "break": 4,
                        "total": 294
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-03-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 290,
                        "hold": 58,
                        "slide": 31,
                        "touch": 23,
                        "break": 31,
                        "total": 433
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-03-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "せめんともり",
                    "noteCounts": {
                        "tap": 454,
                        "hold": 37,
                        "slide": 88,
                        "touch": 31,
                        "break": 24,
                        "total": 634
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.2,
                        "CiRCLE PLUS": 13.2
                    },
                    "releaseDate": "2026-03-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ICEBURN",
            "category": "オンゲキ＆CHUNITHM",
            "title": "ICEBURN",
            "artist": "Srav3R",
            "bpm": 190,
            "imageName": "fdc849a509cdfe9ac2877dd897b326c0a2cd4b6cf52d8c567e4abedf43aecce3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 182,
                        "hold": 12,
                        "slide": 10,
                        "touch": 8,
                        "break": 4,
                        "total": 216
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-03-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 363,
                        "hold": 15,
                        "slide": 10,
                        "touch": 10,
                        "break": 4,
                        "total": 402
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-03-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 345,
                        "hold": 59,
                        "slide": 46,
                        "touch": 16,
                        "break": 81,
                        "total": 547
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-03-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 603,
                        "hold": 43,
                        "slide": 125,
                        "touch": 76,
                        "break": 28,
                        "total": 875
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 13.8,
                        "CiRCLE PLUS": 13.8
                    },
                    "releaseDate": "2026-03-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Daredevil Glaive",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Daredevil Glaive",
            "artist": "Artifact",
            "bpm": 185,
            "imageName": "664870085a9a831cd92dd5cf26853bc80e70992e530db559187422db671b6889",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 203,
                        "hold": 11,
                        "slide": 6,
                        "touch": 20,
                        "break": 9,
                        "total": 249
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-03-05"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 320,
                        "hold": 14,
                        "slide": 7,
                        "touch": 24,
                        "break": 10,
                        "total": 375
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-03-05"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 371,
                        "hold": 72,
                        "slide": 70,
                        "touch": 48,
                        "break": 31,
                        "total": 592
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "releaseDate": "2026-03-05"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.2,
                    "noteDesigner": "サファ太 & メロンポップ",
                    "noteCounts": {
                        "tap": 690,
                        "hold": 69,
                        "slide": 68,
                        "touch": 78,
                        "break": 99,
                        "total": 1004
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE",
                    "multiverInternalLevelValue": {
                        "CiRCLE": 14.2,
                        "CiRCLE PLUS": 14.2
                    },
                    "releaseDate": "2026-03-05"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "KNØCK ØUT!!",
            "category": "maimai",
            "title": "KNØCK ØUT!!",
            "artist": "DIVELA feat.ラングドシャ",
            "bpm": 200,
            "imageName": "8c571ebeca56955fac0226f9d907c769e7248653dd63e7d9c20ebcd1904fa31b",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 182,
                        "hold": 10,
                        "slide": 5,
                        "touch": 8,
                        "break": 7,
                        "total": 212
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 296,
                        "hold": 13,
                        "slide": 6,
                        "touch": 10,
                        "break": 4,
                        "total": 329
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 424,
                        "hold": 30,
                        "slide": 36,
                        "touch": 38,
                        "break": 26,
                        "total": 554
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 550,
                        "hold": 39,
                        "slide": 109,
                        "touch": 99,
                        "break": 77,
                        "total": 874
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 13.8
                    },
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Aides",
            "category": "maimai",
            "title": "Aides",
            "artist": "tokiwa×むﾄ",
            "bpm": 200,
            "imageName": "26956ef2313d5d611a5b3dca4c78ee092645ca35aea1178bf9d75c0796ccef4a",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 185,
                        "hold": 14,
                        "slide": 4,
                        "touch": 8,
                        "break": 6,
                        "total": 217
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 292,
                        "hold": 22,
                        "slide": 14,
                        "touch": 24,
                        "break": 3,
                        "total": 355
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 399,
                        "hold": 73,
                        "slide": 35,
                        "touch": 13,
                        "break": 52,
                        "total": 572
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 556,
                        "hold": 56,
                        "slide": 122,
                        "touch": 33,
                        "break": 26,
                        "total": 793
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 13.8
                    },
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Treasure Chest Expedition",
            "category": "maimai",
            "title": "Treasure Chest Expedition",
            "artist": "7mai",
            "bpm": 200,
            "imageName": "033cdaecf2c99521d67d9464396b349b9a76451eb0f2ad5c8012e9d56aaf95d1",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 13,
                        "slide": 4,
                        "touch": 17,
                        "break": 2,
                        "total": 233
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 355,
                        "hold": 3,
                        "slide": 8,
                        "touch": 10,
                        "break": 5,
                        "total": 381
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 467,
                        "hold": 56,
                        "slide": 37,
                        "touch": 28,
                        "break": 28,
                        "total": 616
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "せめんともり",
                    "noteCounts": {
                        "tap": 645,
                        "hold": 41,
                        "slide": 79,
                        "touch": 12,
                        "break": 55,
                        "total": 832
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 13.7
                    },
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ソテリア",
            "category": "maimai",
            "title": "ソテリア",
            "artist": "Rafutsuri feat.桜あおい",
            "bpm": 160,
            "imageName": "d16e86da63013ae76b1c0e06b499b7a75f00f2e2439ac1b1b670357d98689c8b",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 190,
                        "hold": 11,
                        "slide": 6,
                        "touch": 9,
                        "break": 3,
                        "total": 219
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 277,
                        "hold": 24,
                        "slide": 10,
                        "touch": 24,
                        "break": 8,
                        "total": 343
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 363,
                        "hold": 80,
                        "slide": 81,
                        "touch": 19,
                        "break": 36,
                        "total": 579
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 12
                    },
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.1,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 569,
                        "hold": 43,
                        "slide": 135,
                        "touch": 61,
                        "break": 82,
                        "total": 890
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 14.1
                    },
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "TECHNOPOLIS 2085",
            "category": "オンゲキ＆CHUNITHM",
            "title": "TECHNOPOLIS 2085",
            "artist": "PRASTIK DANCEFLOOR",
            "bpm": 134,
            "imageName": "2bdedf907d00f9e47700ea07f6363581429813be65d92fb48f67022c80b73bd3",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 167,
                        "hold": 16,
                        "slide": 3,
                        "touch": 7,
                        "break": 5,
                        "total": 198
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 197,
                        "hold": 15,
                        "slide": 8,
                        "touch": 27,
                        "break": 6,
                        "total": 253
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 311,
                        "hold": 41,
                        "slide": 63,
                        "touch": 10,
                        "break": 35,
                        "total": 460
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.8,
                    "noteDesigner": "シチミヘルツ",
                    "noteCounts": {
                        "tap": 398,
                        "hold": 136,
                        "slide": 51,
                        "touch": 119,
                        "break": 46,
                        "total": 750
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 13.8
                    },
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Galaxy Blaster",
            "category": "オンゲキ＆CHUNITHM",
            "title": "Galaxy Blaster",
            "artist": "ああああ",
            "bpm": 208,
            "imageName": "93d8b4c72a3e31d6a4e8fed965ad10adb11d6c1109c65fdf91c1f22ba46c715a",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 239,
                        "hold": 8,
                        "slide": 4,
                        "touch": 8,
                        "break": 9,
                        "total": 268
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "CiRCLE"
                        }
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 328,
                        "hold": 13,
                        "slide": 10,
                        "touch": 10,
                        "break": 8,
                        "total": 369
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "CiRCLE"
                        }
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 413,
                        "hold": 75,
                        "slide": 50,
                        "touch": 26,
                        "break": 7,
                        "total": 571
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "CiRCLE"
                        }
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 606,
                        "hold": 84,
                        "slide": 97,
                        "touch": 45,
                        "break": 106,
                        "total": 938
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "CiRCLE"
                        }
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 14.3
                    },
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "BOW AND ARROW （アニメ・オープニングver.）",
            "category": "POPS＆アニメ",
            "title": "BOW AND ARROW （アニメ・オープニングver.）",
            "artist": "米津玄師",
            "bpm": 180,
            "imageName": "c2797c73ba272177e492624d381022c6e23ffaf4302fb0182f9d88638436fff7",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 89,
                        "hold": 3,
                        "slide": 5,
                        "touch": 8,
                        "break": 6,
                        "total": 111
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 181,
                        "hold": 14,
                        "slide": 5,
                        "touch": 11,
                        "break": 5,
                        "total": 216
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 243,
                        "hold": 28,
                        "slide": 20,
                        "touch": 21,
                        "break": 16,
                        "total": 328
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.8,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 315,
                        "hold": 31,
                        "slide": 68,
                        "touch": 5,
                        "break": 9,
                        "total": 428
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 11.8
                    },
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 284,
                        "hold": 35,
                        "slide": 64,
                        "touch": 44,
                        "break": 37,
                        "total": 464
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "無敵的ハピネス！(SOS団5人Ver.)",
            "category": "POPS＆アニメ",
            "title": "無敵的ハピネス！(SOS団5人Ver.)",
            "artist": "涼宮ハルヒ(CV.平野綾),長門有希(CV.茅原実里),朝比奈みくる(CV.後藤邑子)、キョン(CV.杉田智和)、古泉一樹(CV.小野大輔)",
            "bpm": 185,
            "imageName": "cdc66217ac97b6c3c8aa38f9df5f448dbe54e2176f28b645a232bfc7de1b8ab1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 148,
                        "hold": 11,
                        "slide": 9,
                        "touch": 8,
                        "break": 3,
                        "total": 179
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 288,
                        "hold": 10,
                        "slide": 12,
                        "touch": 22,
                        "break": 6,
                        "total": 338
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "せめんともり",
                    "noteCounts": {
                        "tap": 395,
                        "hold": 43,
                        "slide": 23,
                        "touch": 24,
                        "break": 73,
                        "total": 558
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "きょむりん",
                    "noteCounts": {
                        "tap": 466,
                        "hold": 50,
                        "slide": 103,
                        "touch": 111,
                        "break": 57,
                        "total": 787
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Chasing destiny",
            "category": "POPS＆アニメ",
            "title": "Chasing destiny",
            "artist": "涼宮ハルヒ(CV.平野綾)",
            "bpm": 186,
            "imageName": "70fe5a6dfad42583c289f9b5b4e0a89ae752642f22e845bd7cae176f184c7b71",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 212,
                        "hold": 14,
                        "slide": 5,
                        "touch": 21,
                        "break": 2,
                        "total": 254
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 368,
                        "hold": 16,
                        "slide": 10,
                        "touch": 19,
                        "break": 4,
                        "total": 417
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 506,
                        "hold": 57,
                        "slide": 54,
                        "touch": 16,
                        "break": 12,
                        "total": 645
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 645,
                        "hold": 23,
                        "slide": 140,
                        "touch": 38,
                        "break": 42,
                        "total": 888
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 13.7
                    },
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Colorful Starting Line",
            "category": "POPS＆アニメ",
            "title": "Colorful Starting Line",
            "artist": "涼宮ハルヒ(CV.平野綾)",
            "bpm": 162,
            "imageName": "7fef6b477579ca509d9d249e194f4070759a070aa4c8f4beba740af69f863134",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 183,
                        "hold": 10,
                        "slide": 6,
                        "touch": 14,
                        "break": 2,
                        "total": 215
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 305,
                        "hold": 18,
                        "slide": 13,
                        "touch": 24,
                        "break": 4,
                        "total": 364
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 418,
                        "hold": 69,
                        "slide": 50,
                        "touch": 15,
                        "break": 45,
                        "total": 597
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": "せめんともり & カマボコ君",
                    "noteCounts": {
                        "tap": 645,
                        "hold": 23,
                        "slide": 140,
                        "touch": 38,
                        "break": 42,
                        "total": 888
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 13
                    },
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "愛♡スクリ～ム！",
            "category": "POPS＆アニメ",
            "title": "愛♡スクリ～ム！",
            "artist": "AiScReam[黒澤ルビィ(CV.降幡 愛)、上原歩夢(CV.大西亜玖璃)、若菜四季(CV.大熊和奏)]",
            "bpm": 132,
            "imageName": "3a3a668d1965015a49425df32c35d6af6c294e62b2faf620e5e35d60651bf8a6",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 141,
                        "hold": 8,
                        "slide": 4,
                        "touch": 9,
                        "break": 6,
                        "total": 168
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 252,
                        "hold": 20,
                        "slide": 7,
                        "touch": 17,
                        "break": 11,
                        "total": 307
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9",
                    "internalLevelValue": 9,
                    "noteDesigner": "まぐランド",
                    "noteCounts": {
                        "tap": 279,
                        "hold": 42,
                        "slide": 37,
                        "touch": 22,
                        "break": 24,
                        "total": 404
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11",
                    "internalLevelValue": 11.5,
                    "noteDesigner": "緑風 犬三郎",
                    "noteCounts": {
                        "tap": 328,
                        "hold": 36,
                        "slide": 86,
                        "touch": 47,
                        "break": 43,
                        "total": 540
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 11.5
                    },
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "ぴちネコ",
                    "noteCounts": {
                        "tap": 418,
                        "hold": 38,
                        "slide": 114,
                        "touch": 108,
                        "break": 74,
                        "total": 752
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "テレパシ",
            "category": "niconico＆ボーカロイド",
            "title": "テレパシ",
            "artist": "DECO*27",
            "bpm": 205,
            "imageName": "17f661d3477792b7bd974247e9df4afa467bbebad62597603f11e49407962c6c",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 196,
                        "hold": 12,
                        "slide": 4,
                        "touch": 14,
                        "break": 3,
                        "total": 229
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 344,
                        "hold": 17,
                        "slide": 12,
                        "touch": 13,
                        "break": 10,
                        "total": 396
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 430,
                        "hold": 64,
                        "slide": 26,
                        "touch": 26,
                        "break": 43,
                        "total": 589
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 550,
                        "hold": 51,
                        "slide": 182,
                        "touch": 80,
                        "break": 30,
                        "total": 893
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 13.3
                    },
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ダイダイダイダイダイキライ",
            "category": "niconico＆ボーカロイド",
            "title": "ダイダイダイダイダイキライ",
            "artist": "雨良 Amala",
            "bpm": 130,
            "imageName": "559635fe21755d15de310b1331aab30faefe539633786af1e1f3023d164d6450",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 176,
                        "hold": 10,
                        "slide": 4,
                        "touch": 8,
                        "break": 7,
                        "total": 205
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 232,
                        "hold": 15,
                        "slide": 7,
                        "touch": 24,
                        "break": 10,
                        "total": 288
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 393,
                        "hold": 73,
                        "slide": 40,
                        "touch": 8,
                        "break": 29,
                        "total": 543
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "11+",
                    "internalLevelValue": 11.8,
                    "noteDesigner": "緑風　犬三郎",
                    "noteCounts": {
                        "tap": 399,
                        "hold": 84,
                        "slide": 89,
                        "touch": 31,
                        "break": 31,
                        "total": 634
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 11.8
                    },
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "remaster",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 489,
                        "hold": 76,
                        "slide": 93,
                        "touch": 101,
                        "break": 93,
                        "total": 852
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 13.6
                    },
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "オペラ！スペースオペラ！",
            "category": "niconico＆ボーカロイド",
            "title": "オペラ！スペースオペラ！",
            "artist": "ナユタン星人",
            "bpm": 198,
            "imageName": "be165e30ff7f13e1dc9ea878528dc540afc936786bde01a7b6a69141428857a1",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 259,
                        "hold": 10,
                        "slide": 4,
                        "touch": 8,
                        "break": 3,
                        "total": 284
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 339,
                        "hold": 7,
                        "slide": 6,
                        "touch": 28,
                        "break": 16,
                        "total": 396
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 481,
                        "hold": 57,
                        "slide": 38,
                        "touch": 38,
                        "break": 55,
                        "total": 669
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 679,
                        "hold": 46,
                        "slide": 149,
                        "touch": 27,
                        "break": 82,
                        "total": 983
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 13.3
                    },
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "T氏の話を信じるな",
            "category": "niconico＆ボーカロイド",
            "title": "T氏の話を信じるな",
            "artist": "ピノキオピー",
            "bpm": 143,
            "imageName": "5f9d79b2b96bf559a5c8ccc6b410f761a73d89e9900c6165c2d1e02d8c023497",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 192,
                        "hold": 13,
                        "slide": 4,
                        "touch": 11,
                        "break": 5,
                        "total": 225
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 267,
                        "hold": 16,
                        "slide": 9,
                        "touch": 22,
                        "break": 18,
                        "total": 332
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 373,
                        "hold": 56,
                        "slide": 50,
                        "touch": 19,
                        "break": 33,
                        "total": 531
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 650,
                        "hold": 41,
                        "slide": 109,
                        "touch": 67,
                        "break": 58,
                        "total": 925
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 13.2
                    },
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "超ナイト・オブ・ナイツ",
            "category": "東方Project",
            "title": "超ナイト・オブ・ナイツ",
            "artist": "ビートまりお×まろん",
            "bpm": 193,
            "imageName": "2b760bfa884190e9a991fac9e626d4ad4f882f33624421a7f7a2e7397bf1dcdf",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 193,
                        "hold": 9,
                        "slide": 9,
                        "touch": 8,
                        "break": 10,
                        "total": 229
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 265,
                        "hold": 18,
                        "slide": 9,
                        "touch": 22,
                        "break": 11,
                        "total": 325
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "せめんともり",
                    "noteCounts": {
                        "tap": 424,
                        "hold": 71,
                        "slide": 36,
                        "touch": 35,
                        "break": 25,
                        "total": 591
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 727,
                        "hold": 32,
                        "slide": 60,
                        "touch": 56,
                        "break": 93,
                        "total": 968
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 14
                    },
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "浮世絵横丁",
            "category": "ゲーム＆バラエティ",
            "title": "浮世絵横丁",
            "artist": "魔界都市ニイガタ（黄泉路テヂーモ×dawn-system×かゆき）",
            "bpm": 192,
            "imageName": "7e896309f893871a45d3e9e02633f14802e4d173170fd3be4f54be66543c11ec",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 157,
                        "hold": 14,
                        "slide": 5,
                        "touch": 5,
                        "break": 3,
                        "total": 184
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 14,
                        "slide": 10,
                        "touch": 24,
                        "break": 4,
                        "total": 315
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 360,
                        "hold": 76,
                        "slide": 42,
                        "touch": 6,
                        "break": 49,
                        "total": 533
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.9,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 655,
                        "hold": 56,
                        "slide": 76,
                        "touch": 44,
                        "break": 11,
                        "total": 842
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 13.9
                    },
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "AiAe",
            "category": "ゲーム＆バラエティ",
            "title": "AiAe",
            "artist": "DJ'TEKINA//SOMETHING a.k.a ゆよゆっぺ",
            "bpm": 180,
            "imageName": "1a4741add589b6738cd70303ffb2c25227ddc8fa4dc92f8248c0bea87a4e0dd2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 233,
                        "hold": 17,
                        "slide": 6,
                        "touch": 13,
                        "break": 8,
                        "total": 277
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 319,
                        "hold": 15,
                        "slide": 7,
                        "touch": 31,
                        "break": 3,
                        "total": 375
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12.4,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 388,
                        "hold": 43,
                        "slide": 65,
                        "touch": 51,
                        "break": 66,
                        "total": 613
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 12.4
                    },
                    "releaseDate": "2026-03-19"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.4,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 749,
                        "hold": 43,
                        "slide": 124,
                        "touch": 66,
                        "break": 67,
                        "total": 1049
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "multiverInternalLevelValue": {
                        "CiRCLE PLUS": 14.4
                    },
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[習]からくりピエロ",
            "category": "宴会場",
            "title": "[習]からくりピエロ",
            "artist": "40mP",
            "bpm": null,
            "imageName": "a48fd5796466b29761c12fc7990d4d5684d523c474194f21154c9a6eca57abcd",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【習】",
                    "level": "11?",
                    "internalLevelValue": 11,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE PLUS",
                    "comment": "片手でなぞる　それが答えでしょ",
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[奏]クレイジークレイジーダンサーズ",
            "category": "宴会場",
            "title": "[奏]クレイジークレイジーダンサーズ",
            "artist": "ビートまりお＋あまね（COOL&CREATE）",
            "bpm": null,
            "imageName": "0e533966d5248330c0d83a2a722e3c77e3eb44d607428fe2fe1bb53cadaad9d5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage2p",
                    "difficulty": "【奏】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE PLUS",
                    "comment": "舞 踊れ SAD-NO 踊れ",
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[破]テレパシ",
            "category": "宴会場",
            "title": "[破]テレパシ",
            "artist": "DECO*27",
            "bpm": null,
            "imageName": "731c6ff26ea57028cc3a015d22e130bbe5e13fcee2433f2bfa92b17673770aa5",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【破】",
                    "level": "14?",
                    "internalLevelValue": 14,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE PLUS",
                    "comment": "ミクの波形って可愛いんですよ",
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[音]On your mark (104期 Ver.)",
            "category": "宴会場",
            "title": "[音]On your mark (104期 Ver.)",
            "artist": "蓮ノ空女学院スクールアイドルクラブ",
            "bpm": null,
            "imageName": "afa2b0b775f90c0793cc3da7f38ffd7b30c343a2a90e68e15778d5b982b5fc54",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【音】",
                    "level": "13+?",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE PLUS",
                    "comment": "～音取りほぼMAXバージョン～",
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[音]テトリス",
            "category": "宴会場",
            "title": "[音]テトリス",
            "artist": "柊マグネタイト",
            "bpm": null,
            "imageName": "c9d69620376431713e871dc5f95ec50b6789ae3cc13477fec791b1687eb290fb",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【音】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE PLUS",
                    "comment": "～音取りほぼMAXバージョン～",
                    "releaseDate": "2026-03-19"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "キミは“見ていたね”？",
            "category": "オンゲキ＆CHUNITHM",
            "title": "キミは“見ていたね”？",
            "artist": "曲：篠崎あやと、橘亮祐／歌：結城 莉玖(CV：朝日奈 丸佳)、東雲 つむぎ(CV：和泉 風花)",
            "bpm": 168,
            "imageName": "dafe0e9cc3304c23d55826820480ee0957745dacd1ad0cda05d4a9efc02b73a4",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 146,
                        "hold": 14,
                        "slide": 5,
                        "touch": 14,
                        "break": 10,
                        "total": 189
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 298,
                        "hold": 13,
                        "slide": 8,
                        "touch": 19,
                        "break": 6,
                        "total": 344
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 326,
                        "hold": 86,
                        "slide": 42,
                        "touch": 0,
                        "break": 17,
                        "total": 471
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 56,
                        "slide": 84,
                        "touch": 63,
                        "break": 77,
                        "total": 655
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[宴]Wonderland Wars　オープニング (BASIC)",
            "category": "宴会場",
            "title": "[宴]Wonderland Wars　オープニング",
            "artist": "「童話」は、全て「戦記」だった",
            "bpm": null,
            "imageName": "9a252b03fa5e55aec2f7bebf4ea284435c87765b95d3ee4f7c4cd2bc3bd43da2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【宴】",
                    "level": "10?",
                    "internalLevelValue": 10,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE PLUS",
                    "comment": "BASIC（当時は宴という枠が無かった）",
                    "releaseDate": "2026-04-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[宴]Wonderland Wars　オープニング (ADVANCED)",
            "category": "宴会場",
            "title": "[宴]Wonderland Wars　オープニング",
            "artist": "「童話」は、全て「戦記」だった",
            "bpm": null,
            "imageName": "9a252b03fa5e55aec2f7bebf4ea284435c87765b95d3ee4f7c4cd2bc3bd43da2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【宴】",
                    "level": "11?",
                    "internalLevelValue": 11,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE PLUS",
                    "comment": "BASIC（当時は宴という枠が無かった）",
                    "releaseDate": "2026-04-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[宴]Wonderland Wars　オープニング (EXPERT)",
            "category": "宴会場",
            "title": "[宴]Wonderland Wars　オープニング",
            "artist": "「童話」は、全て「戦記」だった",
            "bpm": null,
            "imageName": "9a252b03fa5e55aec2f7bebf4ea284435c87765b95d3ee4f7c4cd2bc3bd43da2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【宴】",
                    "level": "12?",
                    "internalLevelValue": 12,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE PLUS",
                    "comment": "BASIC（当時は宴という枠が無かった）",
                    "releaseDate": "2026-04-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[宴]Wonderland Wars　オープニング (MASTER)",
            "category": "宴会場",
            "title": "[宴]Wonderland Wars　オープニング",
            "artist": "「童話」は、全て「戦記」だった",
            "bpm": null,
            "imageName": "9a252b03fa5e55aec2f7bebf4ea284435c87765b95d3ee4f7c4cd2bc3bd43da2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【宴】",
                    "level": "13?",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE PLUS",
                    "comment": "BASIC（当時は宴という枠が無かった）",
                    "releaseDate": "2026-04-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[宴]Wonderland Wars　オープニング (Re:MASTER)",
            "category": "宴会場",
            "title": "[宴]Wonderland Wars　オープニング",
            "artist": "「童話」は、全て「戦記」だった",
            "bpm": null,
            "imageName": "9a252b03fa5e55aec2f7bebf4ea284435c87765b95d3ee4f7c4cd2bc3bd43da2",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【宴】",
                    "level": "14?",
                    "internalLevelValue": 14,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE PLUS",
                    "comment": "BASIC（当時は宴という枠が無かった）",
                    "releaseDate": "2026-04-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "奇々解体",
            "category": "ゲーム＆バラエティ",
            "title": "奇々解体",
            "artist": "MURASAKI feat.かたたかんな",
            "bpm": 148,
            "imageName": "17681fc49959bbef9fed523051eddc7dd3a1af149f6ccf9dcd8a91ad87547a88",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 130,
                        "hold": 10,
                        "slide": 4,
                        "touch": 11,
                        "break": 7,
                        "total": 162
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 231,
                        "hold": 10,
                        "slide": 10,
                        "touch": 10,
                        "break": 10,
                        "total": 271
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "廻屋渉",
                    "noteCounts": {
                        "tap": 255,
                        "hold": 42,
                        "slide": 46,
                        "touch": 26,
                        "break": 29,
                        "total": 398
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "廻屋渉",
                    "noteCounts": {
                        "tap": 404,
                        "hold": 40,
                        "slide": 118,
                        "touch": 35,
                        "break": 47,
                        "total": 644
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Break The Speakers",
            "category": "maimai",
            "title": "Break The Speakers",
            "artist": "DJ Myosuke",
            "bpm": 185,
            "imageName": "350e28f3f178daa6738b4c9d7d15612537dbb8cad43d9b0e33311943c88dc9d7",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 238,
                        "hold": 3,
                        "slide": 6,
                        "touch": 14,
                        "break": 14,
                        "total": 275
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "CiRCLE"
                        }
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 374,
                        "hold": 13,
                        "slide": 6,
                        "touch": 8,
                        "break": 42,
                        "total": 443
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "CiRCLE"
                        }
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.6,
                    "noteDesigner": "ロシェ@ペンギン",
                    "noteCounts": {
                        "tap": 313,
                        "hold": 84,
                        "slide": 89,
                        "touch": 107,
                        "break": 112,
                        "total": 705
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "CiRCLE"
                        }
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "BELiZHEL",
                    "noteCounts": {
                        "tap": 685,
                        "hold": 96,
                        "slide": 131,
                        "touch": 72,
                        "break": 112,
                        "total": 1096
                    },
                    "regions": {
                        "jp": true,
                        "intl": true,
                        "usa": true,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {
                            "version": "CiRCLE"
                        }
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-03"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "雑魚",
            "category": "niconico＆ボーカロイド",
            "title": "雑魚",
            "artist": "柊マグネタイト",
            "bpm": 135,
            "imageName": "13cb19e34b7d623125aab0a8d4689b64a750fcbb8fc9c1614ec799dd738ea7e3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 126,
                        "hold": 10,
                        "slide": 5,
                        "touch": 6,
                        "break": 10,
                        "total": 157
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 226,
                        "hold": 11,
                        "slide": 6,
                        "touch": 27,
                        "break": 6,
                        "total": 276
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 206,
                        "hold": 88,
                        "slide": 17,
                        "touch": 49,
                        "break": 59,
                        "total": 419
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.1,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 516,
                        "hold": 45,
                        "slide": 147,
                        "touch": 26,
                        "break": 31,
                        "total": 765
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-03"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "お返事まだカナ？おじさん構文！",
            "category": "niconico＆ボーカロイド",
            "title": "お返事まだカナ？おじさん構文！",
            "artist": "吉本おじさん",
            "bpm": 225,
            "imageName": "28bcd3ea1d046a2bfba0e7d1dedfb417501747c596a4162f83b259f60d77a449",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 171,
                        "hold": 10,
                        "slide": 4,
                        "touch": 12,
                        "break": 6,
                        "total": 203
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7+",
                    "internalLevelValue": 7.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 276,
                        "hold": 10,
                        "slide": 6,
                        "touch": 13,
                        "break": 10,
                        "total": 315
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 411,
                        "hold": 70,
                        "slide": 18,
                        "touch": 30,
                        "break": 19,
                        "total": 548
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 469,
                        "hold": 90,
                        "slide": 100,
                        "touch": 93,
                        "break": 41,
                        "total": 793
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-03"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ZEUS",
            "category": "ゲーム＆バラエティ",
            "title": "ZEUS",
            "artist": "DÉ DÉ MOUSE & KAJI",
            "bpm": 180,
            "imageName": "2940ee4c7c9a92d5abf1b14db35c38b803fec59378c423d720d694e41cc68985",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 281,
                        "hold": 8,
                        "slide": 8,
                        "touch": 6,
                        "break": 18,
                        "total": 321
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-03"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 388,
                        "hold": 11,
                        "slide": 14,
                        "touch": 24,
                        "break": 4,
                        "total": 441
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-03"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.8,
                    "noteDesigner": "せめんともり",
                    "noteCounts": {
                        "tap": 541,
                        "hold": 65,
                        "slide": 99,
                        "touch": 6,
                        "break": 23,
                        "total": 734
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-03"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 831,
                        "hold": 86,
                        "slide": 111,
                        "touch": 63,
                        "break": 147,
                        "total": 1238
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-03"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Nine Point Eight",
            "category": "ゲーム＆バラエティ",
            "title": "Nine Point Eight",
            "artist": "Mili",
            "bpm": 164,
            "imageName": "2465b7a20b162fc695dc9d6ec04d49e4d816d543d8886126ed7bcfb19bfa0de3",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 136,
                        "hold": 11,
                        "slide": 4,
                        "touch": 20,
                        "break": 6,
                        "total": 177
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 258,
                        "hold": 18,
                        "slide": 14,
                        "touch": 13,
                        "break": 8,
                        "total": 311
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "9+",
                    "internalLevelValue": 9.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 361,
                        "hold": 43,
                        "slide": 36,
                        "touch": 35,
                        "break": 10,
                        "total": 485
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 555,
                        "hold": 51,
                        "slide": 95,
                        "touch": 16,
                        "break": 23,
                        "total": 740
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-17"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Myosotis",
            "category": "ゲーム＆バラエティ",
            "title": "Myosotis",
            "artist": "M2U / Arranger : M2U & NICODE / Vocal : Guriri & Lucy",
            "bpm": 160,
            "imageName": "e007c34273910447fdc05cde58a4aed1d17896c822bb2d3af9ac5f5ad1b4c6f0",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 151,
                        "hold": 12,
                        "slide": 9,
                        "touch": 14,
                        "break": 6,
                        "total": 192
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8+",
                    "internalLevelValue": 8.6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 323,
                        "hold": 18,
                        "slide": 7,
                        "touch": 19,
                        "break": 10,
                        "total": 377
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12",
                    "internalLevelValue": 12,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 437,
                        "hold": 51,
                        "slide": 45,
                        "touch": 12,
                        "break": 32,
                        "total": 577
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.5,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 683,
                        "hold": 65,
                        "slide": 74,
                        "touch": 113,
                        "break": 64,
                        "total": 999
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-17"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "ANiMA",
            "category": "ゲーム＆バラエティ",
            "title": "ANiMA",
            "artist": "xi",
            "bpm": 183,
            "imageName": "a0563e1ff57abad91cc93c2efd4ec849d94fdb957e9b463ab87de8f48cc16b3a",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 167,
                        "hold": 9,
                        "slide": 4,
                        "touch": 15,
                        "break": 9,
                        "total": 204
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-17"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 282,
                        "hold": 6,
                        "slide": 7,
                        "touch": 24,
                        "break": 10,
                        "total": 329
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-17"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "12+",
                    "internalLevelValue": 12.9,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 549,
                        "hold": 10,
                        "slide": 33,
                        "touch": 5,
                        "break": 32,
                        "total": 629
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-17"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14+",
                    "internalLevelValue": 14.7,
                    "noteDesigner": "Safazhel",
                    "noteCounts": {
                        "tap": 622,
                        "hold": 47,
                        "slide": 67,
                        "touch": 97,
                        "break": 111,
                        "total": 944
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-04-17"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Operation☆DOTABATA!",
            "category": "ゲーム＆バラエティ",
            "title": "Operation☆DOTABATA!",
            "artist": "Mitsukiyo「ブルーアーカイブ -Blue Archive-」",
            "bpm": 140,
            "imageName": "ee55e950f47a57481c9a4759dfbd51d6a620b52a87b4c61f2b7a91a8b2e1a284",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 129,
                        "hold": 11,
                        "slide": 4,
                        "touch": 11,
                        "break": 7,
                        "total": 162
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 201,
                        "hold": 12,
                        "slide": 6,
                        "touch": 11,
                        "break": 8,
                        "total": 238
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 266,
                        "hold": 36,
                        "slide": 29,
                        "touch": 40,
                        "break": 57,
                        "total": 428
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.4,
                    "noteDesigner": "アマリリス",
                    "noteCounts": {
                        "tap": 475,
                        "hold": 53,
                        "slide": 61,
                        "touch": 18,
                        "break": 97,
                        "total": 704
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "RE Aoharu",
            "category": "ゲーム＆バラエティ",
            "title": "RE Aoharu",
            "artist": "Nor「ブルーアーカイブ -Blue Archive-」",
            "bpm": 180,
            "imageName": "f1a13c30bdcfaf2a110d19cf036875ad16d14bb4157c1f5d0f47522a6ba7e883",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 160,
                        "hold": 13,
                        "slide": 4,
                        "touch": 6,
                        "break": 3,
                        "total": 186
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 253,
                        "hold": 10,
                        "slide": 14,
                        "touch": 22,
                        "break": 6,
                        "total": 305
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "せめんともり",
                    "noteCounts": {
                        "tap": 405,
                        "hold": 40,
                        "slide": 44,
                        "touch": 5,
                        "break": 43,
                        "total": 537
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.7,
                    "noteDesigner": "はっぴー",
                    "noteCounts": {
                        "tap": 534,
                        "hold": 16,
                        "slide": 112,
                        "touch": 29,
                        "break": 41,
                        "total": 732
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "Usagi Flap",
            "category": "ゲーム＆バラエティ",
            "title": "Usagi Flap",
            "artist": "Nor「ブルーアーカイブ -Blue Archive-」",
            "bpm": 170,
            "imageName": "4070328cdd7a9af16e5ac7c98a3bb57eab5335a7575d9a31f630cfb15ed8780e",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 123,
                        "hold": 13,
                        "slide": 4,
                        "touch": 19,
                        "break": 2,
                        "total": 161
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-01"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 220,
                        "hold": 20,
                        "slide": 6,
                        "touch": 24,
                        "break": 4,
                        "total": 274
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-01"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 302,
                        "hold": 60,
                        "slide": 29,
                        "touch": 27,
                        "break": 9,
                        "total": 427
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-01"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.2,
                    "noteDesigner": "カマボコ君",
                    "noteCounts": {
                        "tap": 430,
                        "hold": 80,
                        "slide": 91,
                        "touch": 60,
                        "break": 8,
                        "total": 669
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-01"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "オールマスター",
            "category": "maimai",
            "title": "オールマスター",
            "artist": "大漠波新 feat.ヲタみん",
            "bpm": 150,
            "imageName": "b2a215092f8580fd8b1d85245f0e9b22ff0b6eef42989cad1a77f2d71c7c4f75",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "4",
                    "internalLevelValue": 4,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 127,
                        "hold": 16,
                        "slide": 8,
                        "touch": 6,
                        "break": 8,
                        "total": 165
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 263,
                        "hold": 12,
                        "slide": 11,
                        "touch": 11,
                        "break": 18,
                        "total": 315
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11",
                    "internalLevelValue": 11,
                    "noteDesigner": "せめんともり",
                    "noteCounts": {
                        "tap": 340,
                        "hold": 65,
                        "slide": 42,
                        "touch": 5,
                        "break": 88,
                        "total": 540
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 603,
                        "hold": 59,
                        "slide": 96,
                        "touch": 68,
                        "break": 31,
                        "total": 857
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "STRAY",
            "category": "maimai",
            "title": "STRAY",
            "artist": "umigame",
            "bpm": 130,
            "imageName": "c13e4f00d799192dcade7fd028822f43d766653f1cd70b04143affa402f62d8d",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 145,
                        "hold": 9,
                        "slide": 4,
                        "touch": 15,
                        "break": 4,
                        "total": 177
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 229,
                        "hold": 16,
                        "slide": 6,
                        "touch": 13,
                        "break": 3,
                        "total": 267
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": "Luxizhel",
                    "noteCounts": {
                        "tap": 330,
                        "hold": 49,
                        "slide": 34,
                        "touch": 20,
                        "break": 15,
                        "total": 448
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13.3,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 487,
                        "hold": 59,
                        "slide": 73,
                        "touch": 22,
                        "break": 46,
                        "total": 687
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "クロノイデア",
            "category": "maimai",
            "title": "クロノイデア",
            "artist": "iDEN LiLY feat.X-Fenriey",
            "bpm": 190,
            "imageName": "766a3d226224e0be0c6c4e03684d1540608586a3bef8e476904a9e7018b6ee3f",
            "isNew": false,
            "isLocked": true,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "5",
                    "internalLevelValue": 5,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 178,
                        "hold": 17,
                        "slide": 8,
                        "touch": 28,
                        "break": 8,
                        "total": 239
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-08"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "8",
                    "internalLevelValue": 8,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 340,
                        "hold": 18,
                        "slide": 8,
                        "touch": 16,
                        "break": 6,
                        "total": 388
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-08"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "11+",
                    "internalLevelValue": 11.6,
                    "noteDesigner": "サファ太",
                    "noteCounts": {
                        "tap": 403,
                        "hold": 79,
                        "slide": 41,
                        "touch": 25,
                        "break": 46,
                        "total": 594
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-08"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "14",
                    "internalLevelValue": 14.3,
                    "noteDesigner": "Jack",
                    "noteCounts": {
                        "tap": 714,
                        "hold": 50,
                        "slide": 138,
                        "touch": 32,
                        "break": 82,
                        "total": 1016
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-08"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "キスキツネ",
            "category": "POPS＆アニメ",
            "title": "キスキツネ",
            "artist": "HIMEHINA",
            "bpm": null,
            "imageName": "3411e61509c17e518a0999c90d7e18ce66ebeb18d20b8d19951d8b9d0eded299",
            "isNew": true,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 96,
                        "hold": 11,
                        "slide": 4,
                        "touch": 8,
                        "break": 2,
                        "total": 121
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 180,
                        "hold": 15,
                        "slide": 8,
                        "touch": 29,
                        "break": 8,
                        "total": 240
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": 278,
                        "hold": 47,
                        "slide": 31,
                        "touch": 5,
                        "break": 40,
                        "total": 401
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13+",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": 508,
                        "hold": 103,
                        "slide": 78,
                        "touch": 15,
                        "break": 62,
                        "total": 766
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "WWW",
            "category": "POPS＆アニメ",
            "title": "WWW",
            "artist": "HIMEHINA",
            "bpm": null,
            "imageName": "2d070018eebd26c7078e72411022912dff843315f727310f48769b0f74ca98a2",
            "isNew": true,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "2",
                    "internalLevelValue": 2,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 90,
                        "hold": 8,
                        "slide": 3,
                        "touch": 6,
                        "break": 3,
                        "total": 110
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "6",
                    "internalLevelValue": 6,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 193,
                        "hold": 4,
                        "slide": 6,
                        "touch": 11,
                        "break": 6,
                        "total": 220
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10+",
                    "internalLevelValue": 10.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": 206,
                        "hold": 43,
                        "slide": 23,
                        "touch": 16,
                        "break": 34,
                        "total": 322
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": 402,
                        "hold": 24,
                        "slide": 65,
                        "touch": 10,
                        "break": 41,
                        "total": 542
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "うたかたよいかないで",
            "category": "POPS＆アニメ",
            "title": "うたかたよいかないで",
            "artist": "HIMEHINA",
            "bpm": null,
            "imageName": "cf170e57331a7da631134f4ff5248fb36cac2b0685aa685add3ed65bfb21c61c",
            "isNew": true,
            "isLocked": false,
            "sheets": [
                {
                    "type": "dx",
                    "difficulty": "basic",
                    "level": "3",
                    "internalLevelValue": 3,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 188,
                        "hold": 13,
                        "slide": 6,
                        "touch": 14,
                        "break": 5,
                        "total": 226
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "advanced",
                    "level": "7",
                    "internalLevelValue": 7,
                    "noteDesigner": "-",
                    "noteCounts": {
                        "tap": 375,
                        "hold": 18,
                        "slide": 11,
                        "touch": 25,
                        "break": 10,
                        "total": 439
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "expert",
                    "level": "10",
                    "internalLevelValue": 10,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": 479,
                        "hold": 52,
                        "slide": 36,
                        "touch": 13,
                        "break": 34,
                        "total": 614
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-14"
                },
                {
                    "type": "dx",
                    "difficulty": "master",
                    "level": "13",
                    "internalLevelValue": 13,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": 548,
                        "hold": 39,
                        "slide": 118,
                        "touch": 72,
                        "break": 97,
                        "total": 874
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": false,
                    "version": "CiRCLE PLUS",
                    "releaseDate": "2026-05-14"
                }
            ],
            "searchAcronyms": []
        },
        {
            "songId": "[音]愛包ダンスホール",
            "category": "宴会場",
            "title": "[音]愛包ダンスホール",
            "artist": "HIMEHINA",
            "bpm": null,
            "imageName": "70b6b7e7c3a013ba1393702eec9834ae1852966c480dab9b7a7e647c5824b1ab",
            "isNew": false,
            "isLocked": false,
            "sheets": [
                {
                    "type": "utage",
                    "difficulty": "【音】",
                    "level": "13+?",
                    "internalLevelValue": 13.6,
                    "noteDesigner": null,
                    "noteCounts": {
                        "tap": null,
                        "hold": null,
                        "slide": null,
                        "touch": null,
                        "break": null,
                        "total": null
                    },
                    "regions": {
                        "jp": true,
                        "intl": false,
                        "usa": false,
                        "cn": false
                    },
                    "regionOverrides": {
                        "intl": {}
                    },
                    "isSpecial": true,
                    "version": "CiRCLE PLUS",
                    "comment": "～音取りほぼMAXバージョン～",
                    "releaseDate": "2026-05-14"
                }
            ],
            "searchAcronyms": []
        }
    ],
    "categories": [
        {
            "category": "POPS＆アニメ"
        },
        {
            "category": "niconico＆ボーカロイド"
        },
        {
            "category": "東方Project"
        },
        {
            "category": "ゲーム＆バラエティ"
        },
        {
            "category": "maimai"
        },
        {
            "category": "オンゲキ＆CHUNITHM"
        },
        {
            "category": "宴会場"
        }
    ],
    "versions": [
        {
            "version": "maimai",
            "abbr": "maimai (真)",
            "releaseDate": "2012-07-11"
        },
        {
            "version": "maimai PLUS",
            "abbr": "maimai+ (真)",
            "releaseDate": "2012-12-13"
        },
        {
            "version": "GreeN",
            "abbr": "GreeN (超)",
            "releaseDate": "2013-07-11"
        },
        {
            "version": "GreeN PLUS",
            "abbr": "GreeN+ (檄)",
            "releaseDate": "2014-02-26"
        },
        {
            "version": "ORANGE",
            "abbr": "ORANGE (橙)",
            "releaseDate": "2014-09-18"
        },
        {
            "version": "ORANGE PLUS",
            "abbr": "ORANGE+ (暁)",
            "releaseDate": "2015-03-19"
        },
        {
            "version": "PiNK",
            "abbr": "PiNK (桃)",
            "releaseDate": "2015-12-09"
        },
        {
            "version": "PiNK PLUS",
            "abbr": "PiNK+ (櫻)",
            "releaseDate": "2016-06-30"
        },
        {
            "version": "MURASAKi",
            "abbr": "MURASAKi (紫)",
            "releaseDate": "2016-12-15"
        },
        {
            "version": "MURASAKi PLUS",
            "abbr": "MURASAKi+ (菫)",
            "releaseDate": "2017-06-22"
        },
        {
            "version": "MiLK",
            "abbr": "MiLK (白)",
            "releaseDate": "2017-12-14"
        },
        {
            "version": "MiLK PLUS",
            "abbr": "MiLK+ (雪)",
            "releaseDate": "2018-06-21"
        },
        {
            "version": "FiNALE",
            "abbr": "FiNALE (輝)",
            "releaseDate": "2018-12-13"
        },
        {
            "version": "maimaiでらっくす",
            "abbr": "でらっくす (熊)",
            "releaseDate": "2019-07-11"
        },
        {
            "version": "maimaiでらっくす PLUS",
            "abbr": "でらっくす+ (華)",
            "releaseDate": "2020-01-23"
        },
        {
            "version": "Splash",
            "abbr": "Splash (爽)",
            "releaseDate": "2020-09-17"
        },
        {
            "version": "Splash PLUS",
            "abbr": "Splash+ (煌)",
            "releaseDate": "2021-03-18"
        },
        {
            "version": "UNiVERSE",
            "abbr": "UNiVERSE (宙)",
            "releaseDate": "2021-09-16"
        },
        {
            "version": "UNiVERSE PLUS",
            "abbr": "UNiVERSE+ (星)",
            "releaseDate": "2022-03-24"
        },
        {
            "version": "FESTiVAL",
            "abbr": "FESTiVAL (祭)",
            "releaseDate": "2022-09-15"
        },
        {
            "version": "FESTiVAL PLUS",
            "abbr": "FESTiVAL+ (祝)",
            "releaseDate": "2023-03-23"
        },
        {
            "version": "BUDDiES",
            "abbr": "BUDDiES (双)",
            "releaseDate": "2023-09-14"
        },
        {
            "version": "BUDDiES PLUS",
            "abbr": "BUDDiES+ (宴)",
            "releaseDate": "2024-03-21"
        },
        {
            "version": "PRiSM",
            "abbr": "PRiSM (鏡)",
            "releaseDate": "2024-09-12"
        },
        {
            "version": "PRiSM PLUS",
            "abbr": "PRiSM+ (彩)",
            "releaseDate": "2025-03-13"
        },
        {
            "version": "CiRCLE",
            "abbr": "CiRCLE (丸)",
            "releaseDate": "2025-09-18"
        },
        {
            "version": "CiRCLE PLUS",
            "abbr": "CiRCLE+",
            "releaseDate": "2026-03-19"
        }
    ],
    "types": [
        {
            "type": "dx",
            "name": "DX（でらっくす）",
            "abbr": "DX",
            "iconUrl": "type-dx.png",
            "iconHeight": 22
        },
        {
            "type": "std",
            "name": "STD（スタンダード）",
            "abbr": "STD",
            "iconUrl": "type-std.png",
            "iconHeight": 22
        },
        {
            "type": "utage",
            "name": "宴（宴会場）",
            "abbr": "宴"
        }
    ],
    "difficulties": [
        {
            "difficulty": "basic",
            "name": "BASIC",
            "color": "#22bb5b"
        },
        {
            "difficulty": "advanced",
            "name": "ADVANCED",
            "color": "#fb9c2d"
        },
        {
            "difficulty": "expert",
            "name": "EXPERT",
            "color": "#f64861"
        },
        {
            "difficulty": "master",
            "name": "MASTER",
            "color": "#9e45e2"
        },
        {
            "difficulty": "remaster",
            "name": "Re:MASTER",
            "color": "#ba67f8"
        }
    ],
    "regions": [
        {
            "region": "jp",
            "name": "日本版"
        },
        {
            "region": "intl",
            "name": "海外版 (International ver.)"
        },
        {
            "region": "usa",
            "name": "アメリカ海外版 (USA International ver.)"
        },
        {
            "region": "cn",
            "name": "中国版 (舞萌DX)"
        }
    ],
    "updateTime": "2026-05-15T01:25:22.845Z"
}